/*! For license information please see app.js.LICENSE.txt */ ! function (t) {
    "use strict";
    var e = {};

    function i(n) {
        if (e[n]) return e[n].exports;
        var l = e[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return t[n].call(l.exports, l, l.exports, i), l.l = !0, l.exports
    }
    i.m = t, i.c = e, i.d = function (t, e, n) {
        i.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
        })
    }, i.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, i.t = function (t, e) {
        if (1 & e && (t = i(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (i.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
            for (var l in t) i.d(n, l, function (e) {
                return t[e]
            }.bind(null, l));
        return n
    }, i.n = function (t) {
        var e = t && t.__esModule ? function () {
            return t.default
        } : function () {
            return t
        };
        return i.d(e, "a", e), e
    }, i.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, i.p = "", i(i.s = 267)
}([function (t, e, i) {
    var n = i(29)("wks"),
        l = i(25),
        r = i(2).Symbol,
        a = "function" == typeof r;
    (t.exports = function (t) {
        return n[t] || (n[t] = a && r[t] || (a ? r : l)("Symbol." + t))
    }).store = n
}, function (t, e, i) {
    (function (e) {
        var i = function (t) {
            return t && t.Math == Math && t
        };
        t.exports = i("object" == typeof globalThis && globalThis) || i("object" == typeof window && window) || i("object" == typeof self && self) || i("object" == typeof e && e) || function () {
            return this
        }() || Function("return this")()
    }).call(this, i(8))
}, function (t, e) {
    var i = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = i)
}, function (t, e) {
    t.exports = function (t) {
        try {
            return !!t()
        } catch (t) {
            return !0
        }
    }
}, function (t, e) {
    t.exports = function (t) {
        try {
            return !!t()
        } catch (t) {
            return !0
        }
    }
}, function (t, e) {
    t.exports = function (t) {
        function e(t) {
            "undefined" != typeof console && (console.error || console.log)("[Script Loader]", t)
        }
        try {
            "undefined" != typeof execScript && "undefined" != typeof attachEvent && "undefined" == typeof addEventListener ? execScript(t) : "undefined" != typeof eval ? eval.call(null, t) : e("EvalError: No eval function available")
        } catch (t) {
            e(t)
        }
    }
}, function (t, e, i) {
    var n = i(2),
        l = i(17),
        r = i(10),
        a = i(19),
        o = i(41),
        s = function (t, e, i) {
            var c, u, h, d, f = t & s.F,
                p = t & s.G,
                g = t & s.S,
                m = t & s.P,
                v = t & s.B,
                y = p ? n : g ? n[e] || (n[e] = {}) : (n[e] || {}).prototype,
                b = p ? l : l[e] || (l[e] = {}),
                x = b.prototype || (b.prototype = {});
            for (c in p && (i = e), i) h = ((u = !f && y && void 0 !== y[c]) ? y : i)[c], d = v && u ? o(h, n) : m && "function" == typeof h ? o(Function.call, h) : h, y && a(y, c, h, t & s.U), b[c] != h && r(b, c, d), m && x[c] != h && (x[c] = h)
        };
    n.core = l, s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s
}, function (t, e, i) {
    var n = i(11);
    t.exports = function (t) {
        if (!n(t)) throw TypeError(t + " is not an object!");
        return t
    }
}, function (t, e) {
    var i;
    i = function () {
        return this
    }();
    try {
        i = i || new Function("return this")()
    } catch (t) {
        "object" == typeof window && (i = window)
    }
    t.exports = i
}, function (t, e, i) {
    var n = i(1),
        l = i(70),
        r = i(15),
        a = i(72),
        o = i(108),
        s = i(158),
        c = l("wks"),
        u = n.Symbol,
        h = s ? u : u && u.withoutSetter || a;
    t.exports = function (t) {
        return r(c, t) && (o || "string" == typeof c[t]) || (o && r(u, t) ? c[t] = u[t] : c[t] = h("Symbol." + t)), c[t]
    }
}, function (t, e, i) {
    var n = i(18),
        l = i(28);
    t.exports = i(12) ? function (t, e, i) {
        return n.f(t, e, l(1, i))
    } : function (t, e, i) {
        return t[e] = i, t
    }
}, function (t, e) {
    t.exports = function (t) {
        return "object" == typeof t ? null !== t : "function" == typeof t
    }
}, function (t, e, i) {
    t.exports = !i(3)((function () {
        return 7 != Object.defineProperty({}, "a", {
            get: function () {
                return 7
            }
        }).a
    }))
}, function (t, e) {
    var i = {}.toString;
    t.exports = function (t) {
        return i.call(t).slice(8, -1)
    }
}, function (t, e) {
    t.exports = function (t) {
        return "object" == typeof t ? null !== t : "function" == typeof t
    }
}, function (t, e, i) {
    var n = i(35),
        l = {}.hasOwnProperty;
    t.exports = Object.hasOwn || function (t, e) {
        return l.call(n(t), e)
    }
}, function (t, e, i) {
    var n = i(14);
    t.exports = function (t) {
        if (!n(t)) throw TypeError(String(t) + " is not an object");
        return t
    }
}, function (t, e) {
    var i = t.exports = {
        version: "2.6.12"
    };
    "number" == typeof __e && (__e = i)
}, function (t, e, i) {
    var n = i(7),
        l = i(47),
        r = i(40),
        a = Object.defineProperty;
    e.f = i(12) ? Object.defineProperty : function (t, e, i) {
        if (n(t), e = r(e, !0), n(i), l) try {
            return a(t, e, i)
        } catch (t) {}
        if ("get" in i || "set" in i) throw TypeError("Accessors not supported!");
        return "value" in i && (t[e] = i.value), t
    }
}, function (t, e, i) {
    var n = i(2),
        l = i(10),
        r = i(20),
        a = i(25)("src"),
        o = i(63),
        s = "toString",
        c = ("" + o).split(s);
    i(17).inspectSource = function (t) {
        return o.call(t)
    }, (t.exports = function (t, e, i, o) {
        var s = "function" == typeof i;
        s && (r(i, "name") || l(i, "name", e)), t[e] !== i && (s && (r(i, a) || l(i, a, t[e] ? "" + t[e] : c.join(String(e)))), t === n ? t[e] = i : o ? t[e] ? t[e] = i : l(t, e, i) : (delete t[e], l(t, e, i)))
    })(Function.prototype, s, (function () {
        return "function" == typeof this && this[a] || o.call(this)
    }))
}, function (t, e) {
    var i = {}.hasOwnProperty;
    t.exports = function (t, e) {
        return i.call(t, e)
    }
}, function (t, e) {
    var i = Math.ceil,
        n = Math.floor;
    t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? n : i)(t)
    }
}, function (t, e, i) {
    var n = i(21),
        l = Math.min;
    t.exports = function (t) {
        return t > 0 ? l(n(t), 9007199254740991) : 0
    }
}, function (t, e) {
    t.exports = function (t) {
        if (null == t) throw TypeError("Can't call method on  " + t);
        return t
    }
}, function (t, e, i) {
    var n = i(30),
        l = i(31),
        r = i(66);
    t.exports = n ? function (t, e, i) {
        return l.f(t, e, r(1, i))
    } : function (t, e, i) {
        return t[e] = i, t
    }
}, function (t, e) {
    var i = 0,
        n = Math.random();
    t.exports = function (t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++i + n).toString(36))
    }
}, function (t, e, i) {
    var n = i(23);
    t.exports = function (t) {
        return Object(n(t))
    }
}, function (t, e, i) {
    var n = i(1),
        l = i(95).f,
        r = i(24),
        a = i(36),
        o = i(67),
        s = i(149),
        c = i(104);
    t.exports = function (t, e) {
        var i, u, h, d, f, p = t.target,
            g = t.global,
            m = t.stat;
        if (i = g ? n : m ? n[p] || o(p, {}) : (n[p] || {}).prototype)
            for (u in e) {
                if (d = e[u], h = t.noTargetGet ? (f = l(i, u)) && f.value : i[u], !c(g ? u : p + (m ? "." : "#") + u, t.forced) && void 0 !== h) {
                    if (typeof d == typeof h) continue;
                    s(d, h)
                }(t.sham || h && h.sham) && r(d, "sham", !0), a(i, u, d, t)
            }
    }
}, function (t, e) {
    t.exports = function (t, e) {
        return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: e
        }
    }
}, function (t, e, i) {
    var n = i(17),
        l = i(2),
        r = "__core-js_shared__",
        a = l[r] || (l[r] = {});
    (t.exports = function (t, e) {
        return a[t] || (a[t] = void 0 !== e ? e : {})
    })("versions", []).push({
        version: n.version,
        mode: i(33) ? "pure" : "global",
        copyright: "Â© 2020 Denis Pushkarev (zloirock.ru)"
    })
}, function (t, e, i) {
    var n = i(4);
    t.exports = !n((function () {
        return 7 != Object.defineProperty({}, 1, {
            get: function () {
                return 7
            }
        })[1]
    }))
}, function (t, e, i) {
    var n = i(30),
        l = i(98),
        r = i(16),
        a = i(97),
        o = Object.defineProperty;
    e.f = n ? o : function (t, e, i) {
        if (r(t), e = a(e, !0), r(i), l) try {
            return o(t, e, i)
        } catch (t) {}
        if ("get" in i || "set" in i) throw TypeError("Accessors not supported");
        return "value" in i && (t[e] = i.value), t
    }
}, , function (t, e) {
    t.exports = !1
}, function (t, e) {
    t.exports = function (t) {
        if (null == t) throw TypeError("Can't call method on " + t);
        return t
    }
}, function (t, e, i) {
    var n = i(34);
    t.exports = function (t) {
        return Object(n(t))
    }
}, function (t, e, i) {
    var n = i(1),
        l = i(24),
        r = i(15),
        a = i(67),
        o = i(100),
        s = i(43),
        c = s.get,
        u = s.enforce,
        h = String(String).split("String");
    (t.exports = function (t, e, i, o) {
        var s, c = !!o && !!o.unsafe,
            d = !!o && !!o.enumerable,
            f = !!o && !!o.noTargetGet;
        "function" == typeof i && ("string" != typeof e || r(i, "name") || l(i, "name", e), (s = u(i)).source || (s.source = h.join("string" == typeof e ? e : ""))), t !== n ? (c ? !f && t[e] && (d = !0) : delete t[e], d ? t[e] = i : l(t, e, i)) : d ? t[e] = i : a(e, i)
    })(Function.prototype, "toString", (function () {
        return "function" == typeof this && c(this).source || o(this)
    }))
}, function (t, e, i) {
    var n = i(55),
        l = Math.min;
    t.exports = function (t) {
        return t > 0 ? l(n(t), 9007199254740991) : 0
    }
}, function (t, e, i) {
    "use strict";
    var n, l, r = i(82),
        a = RegExp.prototype.exec,
        o = String.prototype.replace,
        s = a,
        c = (n = /a/, l = /b*/g, a.call(n, "a"), a.call(l, "a"), 0 !== n.lastIndex || 0 !== l.lastIndex),
        u = void 0 !== /()??/.exec("")[1];
    (c || u) && (s = function (t) {
        var e, i, n, l, s = this;
        return u && (i = new RegExp("^" + s.source + "$(?!\\s)", r.call(s))), c && (e = s.lastIndex), n = a.call(s, t), c && n && (s.lastIndex = s.global ? n.index + n[0].length : e), u && n && n.length > 1 && o.call(n[0], i, (function () {
            for (l = 1; l < arguments.length - 2; l++) void 0 === arguments[l] && (n[l] = void 0)
        })), n
    }), t.exports = s
}, , function (t, e, i) {
    var n = i(11);
    t.exports = function (t, e) {
        if (!n(t)) return t;
        var i, l;
        if (e && "function" == typeof (i = t.toString) && !n(l = i.call(t))) return l;
        if ("function" == typeof (i = t.valueOf) && !n(l = i.call(t))) return l;
        if (!e && "function" == typeof (i = t.toString) && !n(l = i.call(t))) return l;
        throw TypeError("Can't convert object to primitive value")
    }
}, function (t, e, i) {
    var n = i(49);
    t.exports = function (t, e, i) {
        if (n(t), void 0 === e) return t;
        switch (i) {
            case 1:
                return function (i) {
                    return t.call(e, i)
                };
            case 2:
                return function (i, n) {
                    return t.call(e, i, n)
                };
            case 3:
                return function (i, n, l) {
                    return t.call(e, i, n, l)
                }
        }
        return function () {
            return t.apply(e, arguments)
        }
    }
}, function (t, e) {
    var i = {}.toString;
    t.exports = function (t) {
        return i.call(t).slice(8, -1)
    }
}, function (t, e, i) {
    var n, l, r, a = i(101),
        o = i(1),
        s = i(14),
        c = i(24),
        u = i(15),
        h = i(68),
        d = i(69),
        f = i(54),
        p = "Object already initialized",
        g = o.WeakMap;
    if (a || h.state) {
        var m = h.state || (h.state = new g),
            v = m.get,
            y = m.has,
            b = m.set;
        n = function (t, e) {
            if (y.call(m, t)) throw new TypeError(p);
            return e.facade = t, b.call(m, t, e), e
        }, l = function (t) {
            return v.call(m, t) || {}
        }, r = function (t) {
            return y.call(m, t)
        }
    } else {
        var x = d("state");
        f[x] = !0, n = function (t, e) {
            if (u(t, x)) throw new TypeError(p);
            return e.facade = t, c(t, x, e), e
        }, l = function (t) {
            return u(t, x) ? t[x] : {}
        }, r = function (t) {
            return u(t, x)
        }
    }
    t.exports = {
        set: n,
        get: l,
        has: r,
        enforce: function (t) {
            return r(t) ? l(t) : n(t, {})
        },
        getterFor: function (t) {
            return function (e) {
                var i;
                if (!s(e) || (i = l(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
                return i
            }
        }
    }
}, function (t, e) {
    t.exports = {}
}, function (t, e, i) {
    var n = i(13),
        l = i(0)("toStringTag"),
        r = "Arguments" == n(function () {
            return arguments
        }());
    t.exports = function (t) {
        var e, i, a;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (i = function (t, e) {
            try {
                return t[e]
            } catch (t) {}
        }(e = Object(t), l)) ? i : r ? n(e) : "Object" == (a = n(e)) && "function" == typeof e.callee ? "Arguments" : a
    }
}, , function (t, e, i) {
    t.exports = !i(12) && !i(3)((function () {
        return 7 != Object.defineProperty(i(48)("div"), "a", {
            get: function () {
                return 7
            }
        }).a
    }))
}, function (t, e, i) {
    var n = i(11),
        l = i(2).document,
        r = n(l) && n(l.createElement);
    t.exports = function (t) {
        return r ? l.createElement(t) : {}
    }
}, function (t, e) {
    t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t
    }
}, function (t, e, i) {
    var n = i(2).document;
    t.exports = n && n.documentElement
}, function (t, e, i) {
    var n = i(21),
        l = Math.max,
        r = Math.min;
    t.exports = function (t, e) {
        return (t = n(t)) < 0 ? l(t + e, 0) : r(t, e)
    }
}, function (t, e, i) {
    var n = i(53),
        l = i(34);
    t.exports = function (t) {
        return n(l(t))
    }
}, function (t, e, i) {
    var n = i(4),
        l = i(42),
        r = "".split;
    t.exports = n((function () {
        return !Object("z").propertyIsEnumerable(0)
    })) ? function (t) {
        return "String" == l(t) ? r.call(t, "") : Object(t)
    } : Object
}, function (t, e) {
    t.exports = {}
}, function (t, e) {
    var i = Math.ceil,
        n = Math.floor;
    t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? n : i)(t)
    }
}, function (t, e, i) {
    "use strict";
    var n = i(57)(!0);
    t.exports = function (t, e, i) {
        return e + (i ? n(t, e).length : 1)
    }
}, function (t, e, i) {
    var n = i(21),
        l = i(23);
    t.exports = function (t) {
        return function (e, i) {
            var r, a, o = String(l(e)),
                s = n(i),
                c = o.length;
            return s < 0 || s >= c ? t ? "" : void 0 : (r = o.charCodeAt(s)) < 55296 || r > 56319 || s + 1 === c || (a = o.charCodeAt(s + 1)) < 56320 || a > 57343 ? t ? o.charAt(s) : r : t ? o.slice(s, s + 2) : a - 56320 + (r - 55296 << 10) + 65536
        }
    }
}, function (t, e, i) {
    "use strict";
    var n = i(45),
        l = RegExp.prototype.exec;
    t.exports = function (t, e) {
        var i = t.exec;
        if ("function" == typeof i) {
            var r = i.call(t, e);
            if ("object" != typeof r) throw new TypeError("RegExp exec method returned something other than an Object or null");
            return r
        }
        if ("RegExp" !== n(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
        return l.call(t, e)
    }
}, function (t, e, i) {
    "use strict";
    i(83);
    var n = i(19),
        l = i(10),
        r = i(3),
        a = i(23),
        o = i(0),
        s = i(38),
        c = o("species"),
        u = !r((function () {
            var t = /./;
            return t.exec = function () {
                var t = [];
                return t.groups = {
                    a: "7"
                }, t
            }, "7" !== "".replace(t, "$<a>")
        })),
        h = function () {
            var t = /(?:)/,
                e = t.exec;
            t.exec = function () {
                return e.apply(this, arguments)
            };
            var i = "ab".split(t);
            return 2 === i.length && "a" === i[0] && "b" === i[1]
        }();
    t.exports = function (t, e, i) {
        var d = o(t),
            f = !r((function () {
                var e = {};
                return e[d] = function () {
                    return 7
                }, 7 != "" [t](e)
            })),
            p = f ? !r((function () {
                var e = !1,
                    i = /a/;
                return i.exec = function () {
                    return e = !0, null
                }, "split" === t && (i.constructor = {}, i.constructor[c] = function () {
                    return i
                }), i[d](""), !e
            })) : void 0;
        if (!f || !p || "replace" === t && !u || "split" === t && !h) {
            var g = /./ [d],
                m = i(a, d, "" [t], (function (t, e, i, n, l) {
                    return e.exec === s ? f && !l ? {
                        done: !0,
                        value: g.call(e, i, n)
                    } : {
                        done: !0,
                        value: t.call(i, e, n)
                    } : {
                        done: !1
                    }
                })),
                v = m[0],
                y = m[1];
            n(String.prototype, t, v), l(RegExp.prototype, d, 2 == e ? function (t, e) {
                return y.call(t, this, e)
            } : function (t) {
                return y.call(t, this)
            })
        }
    }
}, , function (t, e) {
    var i = !("undefined" == typeof window || !window.document || !window.document.createElement);
    t.exports = i
}, function (t, e, i) {
    "use strict";
    var n = i(6),
        l = i(50),
        r = i(13),
        a = i(51),
        o = i(22),
        s = [].slice;
    n(n.P + n.F * i(3)((function () {
        l && s.call(l)
    })), "Array", {
        slice: function (t, e) {
            var i = o(this.length),
                n = r(this);
            if (e = void 0 === e ? i : e, "Array" == n) return s.call(this, t, e);
            for (var l = a(t, i), c = a(e, i), u = o(c - l), h = new Array(u), d = 0; d < u; d++) h[d] = "String" == n ? this.charAt(l + d) : this[l + d];
            return h
        }
    })
}, function (t, e, i) {
    t.exports = i(29)("native-function-to-string", Function.toString)
}, function (t, e, i) {
    var n = i(13);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
        return "String" == n(t) ? t.split("") : Object(t)
    }
}, function (t, e, i) {
    var n = i(13);
    t.exports = Array.isArray || function (t) {
        return "Array" == n(t)
    }
}, function (t, e) {
    t.exports = function (t, e) {
        return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: e
        }
    }
}, function (t, e, i) {
    var n = i(1),
        l = i(24);
    t.exports = function (t, e) {
        try {
            l(n, t, e)
        } catch (i) {
            n[t] = e
        }
        return e
    }
}, function (t, e, i) {
    var n = i(1),
        l = i(67),
        r = "__core-js_shared__",
        a = n[r] || l(r, {});
    t.exports = a
}, function (t, e, i) {
    var n = i(70),
        l = i(72),
        r = n("keys");
    t.exports = function (t) {
        return r[t] || (r[t] = l(t))
    }
}, function (t, e, i) {
    var n = i(71),
        l = i(68);
    (t.exports = function (t, e) {
        return l[t] || (l[t] = void 0 !== e ? e : {})
    })("versions", []).push({
        version: "3.14.0",
        mode: n ? "pure" : "global",
        copyright: "Â© 2021 Denis Pushkarev (zloirock.ru)"
    })
}, function (t, e) {
    t.exports = !1
}, function (t, e) {
    var i = 0,
        n = Math.random();
    t.exports = function (t) {
        return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++i + n).toString(36)
    }
}, function (t, e, i) {
    var n = i(151),
        l = i(1),
        r = function (t) {
            return "function" == typeof t ? t : void 0
        };
    t.exports = function (t, e) {
        return arguments.length < 2 ? r(n[t]) || r(l[t]) : n[t] && n[t][e] || l[t] && l[t][e]
    }
}, function (t, e) {
    t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]
}, function (t, e, i) {
    var n = i(106),
        l = i(53),
        r = i(35),
        a = i(37),
        o = i(155),
        s = [].push,
        c = function (t) {
            var e = 1 == t,
                i = 2 == t,
                c = 3 == t,
                u = 4 == t,
                h = 6 == t,
                d = 7 == t,
                f = 5 == t || h;
            return function (p, g, m, v) {
                for (var y, b, x = r(p), w = l(x), _ = n(g, m, 3), k = a(w.length), S = 0, A = v || o, M = e ? A(p, k) : i || d ? A(p, 0) : void 0; k > S; S++)
                    if ((f || S in w) && (b = _(y = w[S], S, x), t))
                        if (e) M[S] = b;
                        else if (b) switch (t) {
                    case 3:
                        return !0;
                    case 5:
                        return y;
                    case 6:
                        return S;
                    case 2:
                        s.call(M, y)
                } else switch (t) {
                    case 4:
                        return !1;
                    case 7:
                        s.call(M, y)
                }
                return h ? -1 : c || u ? u : M
            }
        };
    t.exports = {
        forEach: c(0),
        map: c(1),
        filter: c(2),
        some: c(3),
        every: c(4),
        find: c(5),
        findIndex: c(6),
        filterOut: c(7)
    }
}, function (t, e, i) {
    var n, l, r = i(1),
        a = i(157),
        o = r.process,
        s = o && o.versions,
        c = s && s.v8;
    c ? l = (n = c.split("."))[0] < 4 ? 1 : n[0] + n[1] : a && (!(n = a.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = a.match(/Chrome\/(\d+)/)) && (l = n[1]), t.exports = l && +l
}, function (t, e, i) {
    var n = i(31).f,
        l = i(15),
        r = i(9)("toStringTag");
    t.exports = function (t, e, i) {
        t && !l(t = i ? t : t.prototype, r) && n(t, r, {
            configurable: !0,
            value: e
        })
    }
}, function (t, e, i) {
    var n = {};
    n[i(9)("toStringTag")] = "z", t.exports = "[object z]" === String(n)
}, function (t, e, i) {
    var n = i(54),
        l = i(14),
        r = i(15),
        a = i(31).f,
        o = i(72),
        s = i(177),
        c = o("meta"),
        u = 0,
        h = Object.isExtensible || function () {
            return !0
        },
        d = function (t) {
            a(t, c, {
                value: {
                    objectID: "O" + ++u,
                    weakData: {}
                }
            })
        },
        f = t.exports = {
            REQUIRED: !1,
            fastKey: function (t, e) {
                if (!l(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
                if (!r(t, c)) {
                    if (!h(t)) return "F";
                    if (!e) return "E";
                    d(t)
                }
                return t[c].objectID
            },
            getWeakData: function (t, e) {
                if (!r(t, c)) {
                    if (!h(t)) return !0;
                    if (!e) return !1;
                    d(t)
                }
                return t[c].weakData
            },
            onFreeze: function (t) {
                return s && f.REQUIRED && h(t) && !r(t, c) && d(t), t
            }
        };
    n[c] = !0
}, function (t, e, i) {
    "use strict";
    var n, l, r = i(190),
        a = i(191),
        o = i(70),
        s = RegExp.prototype.exec,
        c = o("native-string-replace", String.prototype.replace),
        u = s,
        h = (n = /a/, l = /b*/g, s.call(n, "a"), s.call(l, "a"), 0 !== n.lastIndex || 0 !== l.lastIndex),
        d = a.UNSUPPORTED_Y || a.BROKEN_CARET,
        f = void 0 !== /()??/.exec("")[1];
    (h || f || d) && (u = function (t) {
        var e, i, n, l, a = this,
            o = d && a.sticky,
            u = r.call(a),
            p = a.source,
            g = 0,
            m = t;
        return o && (-1 === (u = u.replace("y", "")).indexOf("g") && (u += "g"), m = String(t).slice(a.lastIndex), a.lastIndex > 0 && (!a.multiline || a.multiline && "\n" !== t[a.lastIndex - 1]) && (p = "(?: " + p + ")", m = " " + m, g++), i = new RegExp("^(?:" + p + ")", u)), f && (i = new RegExp("^" + p + "$(?!\\s)", u)), h && (e = a.lastIndex), n = s.call(o ? i : a, m), o ? n ? (n.input = n.input.slice(g), n[0] = n[0].slice(g), n.index = a.lastIndex, a.lastIndex += n[0].length) : a.lastIndex = 0 : h && n && (a.lastIndex = a.global ? n.index + n[0].length : e), f && n && n.length > 1 && c.call(n[0], i, (function () {
            for (l = 1; l < arguments.length - 2; l++) void 0 === arguments[l] && (n[l] = void 0)
        })), n
    }), t.exports = u
}, function (t, e, i) {
    var n = i(11),
        l = i(13),
        r = i(0)("match");
    t.exports = function (t) {
        var e;
        return n(t) && (void 0 !== (e = t[r]) ? !!e : "RegExp" == l(t))
    }
}, function (t, e, i) {
    "use strict";
    var n = i(7);
    t.exports = function () {
        var t = n(this),
            e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e
    }
}, function (t, e, i) {
    "use strict";
    var n = i(38);
    i(6)({
        target: "RegExp",
        proto: !0,
        forced: n !== /./.exec
    }, {
        exec: n
    })
}, function (t, e, i) {
    "use strict";
    var n = i(7),
        l = i(26),
        r = i(22),
        a = i(21),
        o = i(56),
        s = i(58),
        c = Math.max,
        u = Math.min,
        h = Math.floor,
        d = /\$([$&`']|\d\d?|<[^>]*>)/g,
        f = /\$([$&`']|\d\d?)/g;
    i(59)("replace", 2, (function (t, e, i, p) {
        return [function (n, l) {
            var r = t(this),
                a = null == n ? void 0 : n[e];
            return void 0 !== a ? a.call(n, r, l) : i.call(String(r), n, l)
        }, function (t, e) {
            var l = p(i, t, this, e);
            if (l.done) return l.value;
            var h = n(t),
                d = String(this),
                f = "function" == typeof e;
            f || (e = String(e));
            var m = h.global;
            if (m) {
                var v = h.unicode;
                h.lastIndex = 0
            }
            for (var y = [];;) {
                var b = s(h, d);
                if (null === b) break;
                if (y.push(b), !m) break;
                "" === String(b[0]) && (h.lastIndex = o(d, r(h.lastIndex), v))
            }
            for (var x, w = "", _ = 0, k = 0; k < y.length; k++) {
                b = y[k];
                for (var S = String(b[0]), A = c(u(a(b.index), d.length), 0), M = [], C = 1; C < b.length; C++) M.push(void 0 === (x = b[C]) ? x : String(x));
                var E = b.groups;
                if (f) {
                    var O = [S].concat(M, A, d);
                    void 0 !== E && O.push(E);
                    var T = String(e.apply(void 0, O))
                } else T = g(S, d, A, M, E, e);
                A >= _ && (w += d.slice(_, A) + T, _ = A + S.length)
            }
            return w + d.slice(_)
        }];

        function g(t, e, n, r, a, o) {
            var s = n + t.length,
                c = r.length,
                u = f;
            return void 0 !== a && (a = l(a), u = d), i.call(o, u, (function (i, l) {
                var o;
                switch (l.charAt(0)) {
                    case "$":
                        return "$";
                    case "&":
                        return t;
                    case "`":
                        return e.slice(0, n);
                    case "'":
                        return e.slice(s);
                    case "<":
                        o = a[l.slice(1, -1)];
                        break;
                    default:
                        var u = +l;
                        if (0 === u) return i;
                        if (u > c) {
                            var d = h(u / 10);
                            return 0 === d ? i : d <= c ? void 0 === r[d - 1] ? l.charAt(1) : r[d - 1] + l.charAt(1) : i
                        }
                        o = r[u - 1]
                }
                return void 0 === o ? "" : o
            }))
        }
    }))
}, function (t, e) {
    var i, n, l = t.exports = {};

    function r() {
        throw new Error("setTimeout has not been defined")
    }

    function a() {
        throw new Error("clearTimeout has not been defined")
    }

    function o(t) {
        if (i === setTimeout) return setTimeout(t, 0);
        if ((i === r || !i) && setTimeout) return i = setTimeout, setTimeout(t, 0);
        try {
            return i(t, 0)
        } catch (e) {
            try {
                return i.call(null, t, 0)
            } catch (e) {
                return i.call(this, t, 0)
            }
        }
    }! function () {
        try {
            i = "function" == typeof setTimeout ? setTimeout : r
        } catch (t) {
            i = r
        }
        try {
            n = "function" == typeof clearTimeout ? clearTimeout : a
        } catch (t) {
            n = a
        }
    }();
    var s, c = [],
        u = !1,
        h = -1;

    function d() {
        u && s && (u = !1, s.length ? c = s.concat(c) : h = -1, c.length && f())
    }

    function f() {
        if (!u) {
            var t = o(d);
            u = !0;
            for (var e = c.length; e;) {
                for (s = c, c = []; ++h < e;) s && s[h].run();
                h = -1, e = c.length
            }
            s = null, u = !1,
                function (t) {
                    if (n === clearTimeout) return clearTimeout(t);
                    if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);
                    try {
                        n(t)
                    } catch (e) {
                        try {
                            return n.call(null, t)
                        } catch (e) {
                            return n.call(this, t)
                        }
                    }
                }(t)
        }
    }

    function p(t, e) {
        this.fun = t, this.array = e
    }

    function g() {}
    l.nextTick = function (t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1)
            for (var i = 1; i < arguments.length; i++) e[i - 1] = arguments[i];
        c.push(new p(t, e)), 1 !== c.length || u || o(f)
    }, p.prototype.run = function () {
        this.fun.apply(null, this.array)
    }, l.title = "browser", l.browser = !0, l.env = {}, l.argv = [], l.version = "", l.versions = {}, l.on = g, l.addListener = g, l.once = g, l.off = g, l.removeListener = g, l.removeAllListeners = g, l.emit = g, l.prependListener = g, l.prependOnceListener = g, l.listeners = function (t) {
        return []
    }, l.binding = function (t) {
        throw new Error("process.binding is not supported")
    }, l.cwd = function () {
        return "/"
    }, l.chdir = function (t) {
        throw new Error("process.chdir is not supported")
    }, l.umask = function () {
        return 0
    }
}, function (t, e) {
    t.exports = function (t) {
        return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
            enumerable: !0,
            get: function () {
                return t.l
            }
        }), Object.defineProperty(t, "id", {
            enumerable: !0,
            get: function () {
                return t.i
            }
        }), t.webpackPolyfill = 1), t
    }
}, , , , function (t, e, i) {
    (function (e) {
        var i = "Expected a function",
            n = /^\s+|\s+$/g,
            l = /^[-+]0x[0-9a-f]+$/i,
            r = /^0b[01]+$/i,
            a = /^0o[0-7]+$/i,
            o = parseInt,
            s = "object" == typeof e && e && e.Object === Object && e,
            c = "object" == typeof self && self && self.Object === Object && self,
            u = s || c || Function("return this")(),
            h = Object.prototype.toString,
            d = Math.max,
            f = Math.min,
            p = function () {
                return u.Date.now()
            };

        function g(t, e, n) {
            var l, r, a, o, s, c, u = 0,
                h = !1,
                g = !1,
                y = !0;
            if ("function" != typeof t) throw new TypeError(i);

            function b(e) {
                var i = l,
                    n = r;
                return l = r = void 0, u = e, o = t.apply(n, i)
            }

            function x(t) {
                return u = t, s = setTimeout(_, e), h ? b(t) : o
            }

            function w(t) {
                var i = t - c;
                return void 0 === c || i >= e || i < 0 || g && t - u >= a
            }

            function _() {
                var t = p();
                if (w(t)) return k(t);
                s = setTimeout(_, function (t) {
                    var i = e - (t - c);
                    return g ? f(i, a - (t - u)) : i
                }(t))
            }

            function k(t) {
                return s = void 0, y && l ? b(t) : (l = r = void 0, o)
            }

            function S() {
                var t = p(),
                    i = w(t);
                if (l = arguments, r = this, c = t, i) {
                    if (void 0 === s) return x(c);
                    if (g) return s = setTimeout(_, e), b(c)
                }
                return void 0 === s && (s = setTimeout(_, e)), o
            }
            return e = v(e) || 0, m(n) && (h = !!n.leading, a = (g = "maxWait" in n) ? d(v(n.maxWait) || 0, e) : a, y = "trailing" in n ? !!n.trailing : y), S.cancel = function () {
                void 0 !== s && clearTimeout(s), u = 0, l = c = r = s = void 0
            }, S.flush = function () {
                return void 0 === s ? o : k(p())
            }, S
        }

        function m(t) {
            var e = typeof t;
            return !!t && ("object" == e || "function" == e)
        }

        function v(t) {
            if ("number" == typeof t) return t;
            if (function (t) {
                    return "symbol" == typeof t || function (t) {
                        return !!t && "object" == typeof t
                    }(t) && "[object Symbol]" == h.call(t)
                }(t)) return NaN;
            if (m(t)) {
                var e = "function" == typeof t.valueOf ? t.valueOf() : t;
                t = m(e) ? e + "" : e
            }
            if ("string" != typeof t) return 0 === t ? t : +t;
            t = t.replace(n, "");
            var i = r.test(t);
            return i || a.test(t) ? o(t.slice(2), i ? 2 : 8) : l.test(t) ? NaN : +t
        }
        t.exports = function (t, e, n) {
            var l = !0,
                r = !0;
            if ("function" != typeof t) throw new TypeError(i);
            return m(n) && (l = "leading" in n ? !!n.leading : l, r = "trailing" in n ? !!n.trailing : r), g(t, e, {
                leading: l,
                maxWait: e,
                trailing: r
            })
        }
    }).call(this, i(8))
}, function (t, e, i) {
    (function (e) {
        var i = /^\s+|\s+$/g,
            n = /^[-+]0x[0-9a-f]+$/i,
            l = /^0b[01]+$/i,
            r = /^0o[0-7]+$/i,
            a = parseInt,
            o = "object" == typeof e && e && e.Object === Object && e,
            s = "object" == typeof self && self && self.Object === Object && self,
            c = o || s || Function("return this")(),
            u = Object.prototype.toString,
            h = Math.max,
            d = Math.min,
            f = function () {
                return c.Date.now()
            };

        function p(t) {
            var e = typeof t;
            return !!t && ("object" == e || "function" == e)
        }

        function g(t) {
            if ("number" == typeof t) return t;
            if (function (t) {
                    return "symbol" == typeof t || function (t) {
                        return !!t && "object" == typeof t
                    }(t) && "[object Symbol]" == u.call(t)
                }(t)) return NaN;
            if (p(t)) {
                var e = "function" == typeof t.valueOf ? t.valueOf() : t;
                t = p(e) ? e + "" : e
            }
            if ("string" != typeof t) return 0 === t ? t : +t;
            t = t.replace(i, "");
            var o = l.test(t);
            return o || r.test(t) ? a(t.slice(2), o ? 2 : 8) : n.test(t) ? NaN : +t
        }
        t.exports = function (t, e, i) {
            var n, l, r, a, o, s, c = 0,
                u = !1,
                m = !1,
                v = !0;
            if ("function" != typeof t) throw new TypeError("Expected a function");

            function y(e) {
                var i = n,
                    r = l;
                return n = l = void 0, c = e, a = t.apply(r, i)
            }

            function b(t) {
                return c = t, o = setTimeout(w, e), u ? y(t) : a
            }

            function x(t) {
                var i = t - s;
                return void 0 === s || i >= e || i < 0 || m && t - c >= r
            }

            function w() {
                var t = f();
                if (x(t)) return _(t);
                o = setTimeout(w, function (t) {
                    var i = e - (t - s);
                    return m ? d(i, r - (t - c)) : i
                }(t))
            }

            function _(t) {
                return o = void 0, v && n ? y(t) : (n = l = void 0, a)
            }

            function k() {
                var t = f(),
                    i = x(t);
                if (n = arguments, l = this, s = t, i) {
                    if (void 0 === o) return b(s);
                    if (m) return o = setTimeout(w, e), y(s)
                }
                return void 0 === o && (o = setTimeout(w, e)), a
            }
            return e = g(e) || 0, p(i) && (u = !!i.leading, r = (m = "maxWait" in i) ? h(g(i.maxWait) || 0, e) : r, v = "trailing" in i ? !!i.trailing : v), k.cancel = function () {
                void 0 !== o && clearTimeout(o), c = 0, n = s = l = o = void 0
            }, k.flush = function () {
                return void 0 === o ? a : _(f())
            }, k
        }
    }).call(this, i(8))
}, function (t, e, i) {
    var n;
    "undefined" != typeof self && self, n = function () {
        return function (t) {
            var e = {};

            function i(n) {
                if (e[n]) return e[n].exports;
                var l = e[n] = {
                    i: n,
                    l: !1,
                    exports: {}
                };
                return t[n].call(l.exports, l, l.exports, i), l.l = !0, l.exports
            }
            return i.m = t, i.c = e, i.d = function (t, e, n) {
                i.o(t, e) || Object.defineProperty(t, e, {
                    configurable: !1,
                    enumerable: !0,
                    get: n
                })
            }, i.r = function (t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                })
            }, i.n = function (t) {
                var e = t && t.__esModule ? function () {
                    return t.default
                } : function () {
                    return t
                };
                return i.d(e, "a", e), e
            }, i.o = function (t, e) {
                return Object.prototype.hasOwnProperty.call(t, e)
            }, i.p = "", i(i.s = 0)
        }({
            "./dist/icons.json": function (t) {
                t.exports = {
                    activity: '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>',
                    airplay: '<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon>',
                    "alert-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
                    "alert-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
                    "alert-triangle": '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>',
                    "align-center": '<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>',
                    "align-justify": '<line x1="21" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="3" y2="18"></line>',
                    "align-left": '<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>',
                    "align-right": '<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>',
                    anchor: '<circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path>',
                    aperture: '<circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>',
                    archive: '<polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line>',
                    "arrow-down-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="8" x2="12" y2="16"></line>',
                    "arrow-down-left": '<line x1="17" y1="7" x2="7" y2="17"></line><polyline points="17 17 7 17 7 7"></polyline>',
                    "arrow-down-right": '<line x1="7" y1="7" x2="17" y2="17"></line><polyline points="17 7 17 17 7 17"></polyline>',
                    "arrow-down": '<line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline>',
                    "arrow-left-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 8 8 12 12 16"></polyline><line x1="16" y1="12" x2="8" y2="12"></line>',
                    "arrow-left": '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>',
                    "arrow-right-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line>',
                    "arrow-right": '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>',
                    "arrow-up-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line>',
                    "arrow-up-left": '<line x1="17" y1="17" x2="7" y2="7"></line><polyline points="7 17 7 7 17 7"></polyline>',
                    "arrow-up-right": '<line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline>',
                    "arrow-up": '<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>',
                    "at-sign": '<circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>',
                    award: '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>',
                    "bar-chart-2": '<line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line>',
                    "bar-chart": '<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>',
                    "battery-charging": '<path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline>',
                    battery: '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>',
                    "bell-off": '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    bell: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>',
                    bluetooth: '<polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>',
                    bold: '<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>',
                    "book-open": '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>',
                    book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>',
                    bookmark: '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>',
                    box: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                    briefcase: '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>',
                    calendar: '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>',
                    "camera-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"></path>',
                    camera: '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle>',
                    cast: '<path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2.01" y2="20"></line>',
                    "check-circle": '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>',
                    "check-square": '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>',
                    check: '<polyline points="20 6 9 17 4 12"></polyline>',
                    "chevron-down": '<polyline points="6 9 12 15 18 9"></polyline>',
                    "chevron-left": '<polyline points="15 18 9 12 15 6"></polyline>',
                    "chevron-right": '<polyline points="9 18 15 12 9 6"></polyline>',
                    "chevron-up": '<polyline points="18 15 12 9 6 15"></polyline>',
                    "chevrons-down": '<polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline>',
                    "chevrons-left": '<polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>',
                    "chevrons-right": '<polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>',
                    "chevrons-up": '<polyline points="17 11 12 6 7 11"></polyline><polyline points="17 18 12 13 7 18"></polyline>',
                    chrome: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>',
                    circle: '<circle cx="12" cy="12" r="10"></circle>',
                    clipboard: '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>',
                    clock: '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>',
                    "cloud-drizzle": '<line x1="8" y1="19" x2="8" y2="21"></line><line x1="8" y1="13" x2="8" y2="15"></line><line x1="16" y1="19" x2="16" y2="21"></line><line x1="16" y1="13" x2="16" y2="15"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="12" y1="15" x2="12" y2="17"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
                    "cloud-lightning": '<path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline points="13 11 9 17 15 17 11 23"></polyline>',
                    "cloud-off": '<path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    "cloud-rain": '<line x1="16" y1="13" x2="16" y2="21"></line><line x1="8" y1="13" x2="8" y2="21"></line><line x1="12" y1="15" x2="12" y2="23"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
                    "cloud-snow": '<path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="8" y1="20" x2="8.01" y2="20"></line><line x1="12" y1="18" x2="12.01" y2="18"></line><line x1="12" y1="22" x2="12.01" y2="22"></line><line x1="16" y1="16" x2="16.01" y2="16"></line><line x1="16" y1="20" x2="16.01" y2="20"></line>',
                    cloud: '<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>',
                    code: '<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>',
                    codepen: '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>',
                    codesandbox: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                    coffee: '<path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line>',
                    columns: '<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>',
                    command: '<path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>',
                    compass: '<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>',
                    copy: '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>',
                    "corner-down-left": '<polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path>',
                    "corner-down-right": '<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>',
                    "corner-left-down": '<polyline points="14 15 9 20 4 15"></polyline><path d="M20 4h-7a4 4 0 0 0-4 4v12"></path>',
                    "corner-left-up": '<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>',
                    "corner-right-down": '<polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>',
                    "corner-right-up": '<polyline points="10 9 15 4 20 9"></polyline><path d="M4 20h7a4 4 0 0 0 4-4V4"></path>',
                    "corner-up-left": '<polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>',
                    "corner-up-right": '<polyline points="15 14 20 9 15 4"></polyline><path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>',
                    cpu: '<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line>',
                    "credit-card": '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>',
                    crop: '<path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>',
                    crosshair: '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>',
                    database: '<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>',
                    delete: '<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line>',
                    disc: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>',
                    "divide-circle": '<line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line><circle cx="12" cy="12" r="10"></circle>',
                    "divide-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line>',
                    divide: '<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>',
                    "dollar-sign": '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>',
                    "download-cloud": '<polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>',
                    download: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>',
                    dribbble: '<circle cx="12" cy="12" r="10"></circle><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>',
                    droplet: '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>',
                    "edit-2": '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>',
                    "edit-3": '<path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>',
                    edit: '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>',
                    "external-link": '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>',
                    "eye-off": '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
                    facebook: '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>',
                    "fast-forward": '<polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon>',
                    feather: '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>',
                    figma: '<path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"></path><path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"></path><path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"></path><path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"></path><path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"></path>',
                    "file-minus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="9" y1="15" x2="15" y2="15"></line>',
                    "file-plus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line>',
                    "file-text": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>',
                    file: '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>',
                    film: '<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line>',
                    filter: '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>',
                    flag: '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>',
                    "folder-minus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="9" y1="14" x2="15" y2="14"></line>',
                    "folder-plus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line>',
                    folder: '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>',
                    framer: '<path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>',
                    handshake: '<path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z"/>',
                    frown: '<circle cx="12" cy="12" r="10"></circle><path d="M16 16s-1.5-2-4-2-4 2-4 2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                    gift: '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>',
                    "git-branch": '<line x1="6" y1="3" x2="6" y2="15"></line><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path>',
                    "git-commit": '<circle cx="12" cy="12" r="4"></circle><line x1="1.05" y1="12" x2="7" y2="12"></line><line x1="17.01" y1="12" x2="22.96" y2="12"></line>',
                    "git-merge": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M6 21V9a9 9 0 0 0 9 9"></path>',
                    "git-pull-request": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M13 6h3a2 2 0 0 1 2 2v7"></path><line x1="6" y1="9" x2="6" y2="21"></line>',
                    github: '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>',
                    gitlab: '<path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>',
                    globe: '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>',
                    grid: '<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>',
                    "hard-drive": '<line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line>',
                    hash: '<line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line>',
                    headphones: '<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>',
                    heart: '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
                    "help-circle": '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>',
                    hexagon: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>',
                    home: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>',
                    image: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>',
                    inbox: '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>',
                    info: '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
                    instagram: '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>',
                    italic: '<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>',
                    key: '<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>',
                    layers: '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>',
                    layout: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line>',
                    "life-buoy": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line><line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>',
                    "link-2": '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path><line x1="8" y1="12" x2="16" y2="12"></line>',
                    link: '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>',
                    linkedin: '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>',
                    list: '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>',
                    loader: '<line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>',
                    lock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>',
                    "log-in": '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>',
                    "log-out": '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>',
                    mail: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>',
                    "map-pin": '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>',
                    map: '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line>',
                    "maximize-2": '<polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
                    maximize: '<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>',
                    meh: '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                    menu: '<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>',
                    "message-circle": '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>',
                    "message-square": '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>',
                    "mic-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
                    mic: '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
                    "minimize-2": '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
                    minimize: '<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>',
                    "minus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line>',
                    "minus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>',
                    minus: '<line x1="5" y1="12" x2="19" y2="12"></line>',
                    monitor: '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>',
                    moon: '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>',
                    "more-horizontal": '<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>',
                    "more-vertical": '<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>',
                    "mouse-pointer": '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="M13 13l6 6"></path>',
                    move: '<polyline points="5 9 2 12 5 15"></polyline><polyline points="9 5 12 2 15 5"></polyline><polyline points="15 19 12 22 9 19"></polyline><polyline points="19 9 22 12 19 15"></polyline><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line>',
                    music: '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>',
                    "navigation-2": '<polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>',
                    navigation: '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>',
                    octagon: '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>',
                    package: '<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                    paperclip: '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>',
                    "pause-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line>',
                    pause: '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>',
                    "pen-tool": '<path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle>',
                    percent: '<line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>',
                    "phone-call": '<path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "phone-forwarded": '<polyline points="19 1 23 5 19 9"></polyline><line x1="15" y1="5" x2="23" y2="5"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "phone-incoming": '<polyline points="16 2 16 8 22 8"></polyline><line x1="23" y1="1" x2="16" y2="8"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "phone-missed": '<line x1="23" y1="1" x2="17" y2="7"></line><line x1="17" y1="1" x2="23" y2="7"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "phone-off": '<path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line>',
                    "phone-outgoing": '<polyline points="23 7 23 1 17 1"></polyline><line x1="16" y1="8" x2="23" y2="1"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    phone: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "pie-chart": '<path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>',
                    "play-circle": '<circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon>',
                    play: '<polygon points="5 3 19 12 5 21 5 3"></polygon>',
                    "plus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
                    "plus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
                    plus: '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>',
                    pocket: '<path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path><polyline points="8 10 12 14 16 10"></polyline>',
                    power: '<path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line>',
                    printer: '<polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect>',
                    radio: '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>',
                    "refresh-ccw": '<polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>',
                    "refresh-cw": '<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>',
                    repeat: '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>',
                    rewind: '<polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>',
                    "rotate-ccw": '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>',
                    "rotate-cw": '<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>',
                    rss: '<path d="M4 11a9 9 0 0 1 9 9"></path><path d="M4 4a16 16 0 0 1 16 16"></path><circle cx="5" cy="19" r="1"></circle>',
                    save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>',
                    scissors: '<circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>',
                    search: '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>',
                    send: '<line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>',
                    server: '<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line>',
                    settings: '<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>',
                    "share-2": '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>',
                    share: '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line>',
                    "shield-off": '<path d="M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"></path><path d="M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>',
                    "shopping-bag": '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>',
                    "shopping-cart": '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
                    shuffle: '<polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>',
                    sidebar: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line>',
                    "skip-back": '<polygon points="19 20 9 12 19 4 19 20"></polygon><line x1="5" y1="19" x2="5" y2="5"></line>',
                    "skip-forward": '<polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line>',
                    slack: '<path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>',
                    slash: '<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>',
                    sliders: '<line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line>',
                    smartphone: '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
                    smile: '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                    speaker: '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><circle cx="12" cy="14" r="4"></circle><line x1="12" y1="6" x2="12.01" y2="6"></line>',
                    square: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
                    star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>',
                    "stop-circle": '<circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6"></rect>',
                    sun: '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>',
                    sunrise: '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>',
                    sunset: '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>',
                    tablet: '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
                    tag: '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>',
                    target: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>',
                    terminal: '<polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line>',
                    thermometer: '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>',
                    "thumbs-down": '<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>',
                    "thumbs-up": '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>',
                    "toggle-left": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>',
                    "toggle-right": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>',
                    tool: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>',
                    "trash-2": '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>',
                    trash: '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>',
                    trello: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><rect x="7" y="7" width="3" height="9"></rect><rect x="14" y="7" width="3" height="5"></rect>',
                    "trending-down": '<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline>',
                    "trending-up": '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>',
                    triangle: '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>',
                    truck: '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>',
                    tv: '<rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline>',
                    twitch: '<path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"></path>',
                    twitter: '<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>',
                    type: '<polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line>',
                    umbrella: '<path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"></path>',
                    underline: '<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>',
                    unlock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path>',
                    "upload-cloud": '<polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline>',
                    upload: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>',
                    "user-check": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline>',
                    "user-minus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line>',
                    "user-plus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>',
                    "user-x": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line>',
                    user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>',
                    users: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
                    "video-off": '<path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    video: '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>',
                    voicemail: '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>',
                    "volume-1": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
                    "volume-2": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
                    "volume-x": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>',
                    volume: '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>',
                    watch: '<circle cx="12" cy="12" r="7"></circle><polyline points="12 9 12 12 13.5 13.5"></polyline><path d="M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"></path>',
                    "wifi-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path><path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
                    wifi: '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
                    wind: '<path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path>',
                    "x-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
                    "x-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
                    "x-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line>',
                    x: '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
                    youtube: '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>',
                    "zap-off": '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>',
                    zap: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>',
                    "zoom-in": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
                    "zoom-out": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line>'
                }
            },
            "./node_modules/classnames/dedupe.js": function (t, e, i) {
                var n;
                ! function () {
                    "use strict";
                    var i = function () {
                        function t() {}

                        function e(t, e) {
                            for (var i = e.length, n = 0; n < i; ++n) l(t, e[n])
                        }
                        t.prototype = Object.create(null);
                        var i = {}.hasOwnProperty,
                            n = /\s+/;

                        function l(t, l) {
                            if (l) {
                                var r = typeof l;
                                "string" === r ? function (t, e) {
                                    for (var i = e.split(n), l = i.length, r = 0; r < l; ++r) t[i[r]] = !0
                                }(t, l) : Array.isArray(l) ? e(t, l) : "object" === r ? function (t, e) {
                                    for (var n in e) i.call(e, n) && (t[n] = !!e[n])
                                }(t, l) : "number" === r && function (t, e) {
                                    t[e] = !0
                                }(t, l)
                            }
                        }
                        return function () {
                            for (var i = arguments.length, n = Array(i), l = 0; l < i; l++) n[l] = arguments[l];
                            var r = new t;
                            e(r, n);
                            var a = [];
                            for (var o in r) r[o] && a.push(o);
                            return a.join(" ")
                        }
                    }();
                    void 0 !== t && t.exports ? t.exports = i : void 0 === (n = function () {
                        return i
                    }.apply(e, [])) || (t.exports = n)
                }()
            },
            "./node_modules/core-js/es/array/from.js": function (t, e, i) {
                i("./node_modules/core-js/modules/es.string.iterator.js"), i("./node_modules/core-js/modules/es.array.from.js");
                var n = i("./node_modules/core-js/internals/path.js");
                t.exports = n.Array.from
            },
            "./node_modules/core-js/internals/a-function.js": function (t, e) {
                t.exports = function (t) {
                    if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
                    return t
                }
            },
            "./node_modules/core-js/internals/an-object.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/is-object.js");
                t.exports = function (t) {
                    if (!n(t)) throw TypeError(String(t) + " is not an object");
                    return t
                }
            },
            "./node_modules/core-js/internals/array-from.js": function (t, e, i) {
                "use strict";
                var n = i("./node_modules/core-js/internals/bind-context.js"),
                    l = i("./node_modules/core-js/internals/to-object.js"),
                    r = i("./node_modules/core-js/internals/call-with-safe-iteration-closing.js"),
                    a = i("./node_modules/core-js/internals/is-array-iterator-method.js"),
                    o = i("./node_modules/core-js/internals/to-length.js"),
                    s = i("./node_modules/core-js/internals/create-property.js"),
                    c = i("./node_modules/core-js/internals/get-iterator-method.js");
                t.exports = function (t) {
                    var e, i, u, h, d = l(t),
                        f = "function" == typeof this ? this : Array,
                        p = arguments.length,
                        g = p > 1 ? arguments[1] : void 0,
                        m = void 0 !== g,
                        v = 0,
                        y = c(d);
                    if (m && (g = n(g, p > 2 ? arguments[2] : void 0, 2)), null == y || f == Array && a(y))
                        for (i = new f(e = o(d.length)); e > v; v++) s(i, v, m ? g(d[v], v) : d[v]);
                    else
                        for (h = y.call(d), i = new f; !(u = h.next()).done; v++) s(i, v, m ? r(h, g, [u.value, v], !0) : u.value);
                    return i.length = v, i
                }
            },
            "./node_modules/core-js/internals/array-includes.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/to-indexed-object.js"),
                    l = i("./node_modules/core-js/internals/to-length.js"),
                    r = i("./node_modules/core-js/internals/to-absolute-index.js");
                t.exports = function (t) {
                    return function (e, i, a) {
                        var o, s = n(e),
                            c = l(s.length),
                            u = r(a, c);
                        if (t && i != i) {
                            for (; c > u;)
                                if ((o = s[u++]) != o) return !0
                        } else
                            for (; c > u; u++)
                                if ((t || u in s) && s[u] === i) return t || u || 0;
                        return !t && -1
                    }
                }
            },
            "./node_modules/core-js/internals/bind-context.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/a-function.js");
                t.exports = function (t, e, i) {
                    if (n(t), void 0 === e) return t;
                    switch (i) {
                        case 0:
                            return function () {
                                return t.call(e)
                            };
                        case 1:
                            return function (i) {
                                return t.call(e, i)
                            };
                        case 2:
                            return function (i, n) {
                                return t.call(e, i, n)
                            };
                        case 3:
                            return function (i, n, l) {
                                return t.call(e, i, n, l)
                            }
                    }
                    return function () {
                        return t.apply(e, arguments)
                    }
                }
            },
            "./node_modules/core-js/internals/call-with-safe-iteration-closing.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/an-object.js");
                t.exports = function (t, e, i, l) {
                    try {
                        return l ? e(n(i)[0], i[1]) : e(i)
                    } catch (e) {
                        var r = t.return;
                        throw void 0 !== r && n(r.call(t)), e
                    }
                }
            },
            "./node_modules/core-js/internals/check-correctness-of-iteration.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/well-known-symbol.js")("iterator"),
                    l = !1;
                try {
                    var r = 0,
                        a = {
                            next: function () {
                                return {
                                    done: !!r++
                                }
                            },
                            return: function () {
                                l = !0
                            }
                        };
                    a[n] = function () {
                        return this
                    }, Array.from(a, (function () {
                        throw 2
                    }))
                } catch (t) {}
                t.exports = function (t, e) {
                    if (!e && !l) return !1;
                    var i = !1;
                    try {
                        var r = {};
                        r[n] = function () {
                            return {
                                next: function () {
                                    return {
                                        done: i = !0
                                    }
                                }
                            }
                        }, t(r)
                    } catch (t) {}
                    return i
                }
            },
            "./node_modules/core-js/internals/classof-raw.js": function (t, e) {
                var i = {}.toString;
                t.exports = function (t) {
                    return i.call(t).slice(8, -1)
                }
            },
            "./node_modules/core-js/internals/classof.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/classof-raw.js"),
                    l = i("./node_modules/core-js/internals/well-known-symbol.js")("toStringTag"),
                    r = "Arguments" == n(function () {
                        return arguments
                    }());
                t.exports = function (t) {
                    var e, i, a;
                    return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (i = function (t, e) {
                        try {
                            return t[e]
                        } catch (t) {}
                    }(e = Object(t), l)) ? i : r ? n(e) : "Object" == (a = n(e)) && "function" == typeof e.callee ? "Arguments" : a
                }
            },
            "./node_modules/core-js/internals/copy-constructor-properties.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/has.js"),
                    l = i("./node_modules/core-js/internals/own-keys.js"),
                    r = i("./node_modules/core-js/internals/object-get-own-property-descriptor.js"),
                    a = i("./node_modules/core-js/internals/object-define-property.js");
                t.exports = function (t, e) {
                    for (var i = l(e), o = a.f, s = r.f, c = 0; c < i.length; c++) {
                        var u = i[c];
                        n(t, u) || o(t, u, s(e, u))
                    }
                }
            },
            "./node_modules/core-js/internals/correct-prototype-getter.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/fails.js");
                t.exports = !n((function () {
                    function t() {}
                    return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype
                }))
            },
            "./node_modules/core-js/internals/create-iterator-constructor.js": function (t, e, i) {
                "use strict";
                var n = i("./node_modules/core-js/internals/iterators-core.js").IteratorPrototype,
                    l = i("./node_modules/core-js/internals/object-create.js"),
                    r = i("./node_modules/core-js/internals/create-property-descriptor.js"),
                    a = i("./node_modules/core-js/internals/set-to-string-tag.js"),
                    o = i("./node_modules/core-js/internals/iterators.js"),
                    s = function () {
                        return this
                    };
                t.exports = function (t, e, i) {
                    var c = e + " Iterator";
                    return t.prototype = l(n, {
                        next: r(1, i)
                    }), a(t, c, !1, !0), o[c] = s, t
                }
            },
            "./node_modules/core-js/internals/create-property-descriptor.js": function (t, e) {
                t.exports = function (t, e) {
                    return {
                        enumerable: !(1 & t),
                        configurable: !(2 & t),
                        writable: !(4 & t),
                        value: e
                    }
                }
            },
            "./node_modules/core-js/internals/create-property.js": function (t, e, i) {
                "use strict";
                var n = i("./node_modules/core-js/internals/to-primitive.js"),
                    l = i("./node_modules/core-js/internals/object-define-property.js"),
                    r = i("./node_modules/core-js/internals/create-property-descriptor.js");
                t.exports = function (t, e, i) {
                    var a = n(e);
                    a in t ? l.f(t, a, r(0, i)) : t[a] = i
                }
            },
            "./node_modules/core-js/internals/define-iterator.js": function (t, e, i) {
                "use strict";
                var n = i("./node_modules/core-js/internals/export.js"),
                    l = i("./node_modules/core-js/internals/create-iterator-constructor.js"),
                    r = i("./node_modules/core-js/internals/object-get-prototype-of.js"),
                    a = i("./node_modules/core-js/internals/object-set-prototype-of.js"),
                    o = i("./node_modules/core-js/internals/set-to-string-tag.js"),
                    s = i("./node_modules/core-js/internals/hide.js"),
                    c = i("./node_modules/core-js/internals/redefine.js"),
                    u = i("./node_modules/core-js/internals/well-known-symbol.js"),
                    h = i("./node_modules/core-js/internals/is-pure.js"),
                    d = i("./node_modules/core-js/internals/iterators.js"),
                    f = i("./node_modules/core-js/internals/iterators-core.js"),
                    p = f.IteratorPrototype,
                    g = f.BUGGY_SAFARI_ITERATORS,
                    m = u("iterator"),
                    v = "keys",
                    y = "values",
                    b = "entries",
                    x = function () {
                        return this
                    };
                t.exports = function (t, e, i, u, f, w, _) {
                    l(i, e, u);
                    var k, S, A, M = function (t) {
                            if (t === f && P) return P;
                            if (!g && t in O) return O[t];
                            switch (t) {
                                case v:
                                case y:
                                case b:
                                    return function () {
                                        return new i(this, t)
                                    }
                            }
                            return function () {
                                return new i(this)
                            }
                        },
                        C = e + " Iterator",
                        E = !1,
                        O = t.prototype,
                        T = O[m] || O["@@iterator"] || f && O[f],
                        P = !g && T || M(f),
                        L = "Array" == e && O.entries || T;
                    if (L && (k = r(L.call(new t)), p !== Object.prototype && k.next && (h || r(k) === p || (a ? a(k, p) : "function" != typeof k[m] && s(k, m, x)), o(k, C, !0, !0), h && (d[C] = x))), f == y && T && T.name !== y && (E = !0, P = function () {
                            return T.call(this)
                        }), h && !_ || O[m] === P || s(O, m, P), d[e] = P, f)
                        if (S = {
                                values: M(y),
                                keys: w ? P : M(v),
                                entries: M(b)
                            }, _)
                            for (A in S)(g || E || !(A in O)) && c(O, A, S[A]);
                        else n({
                            target: e,
                            proto: !0,
                            forced: g || E
                        }, S);
                    return S
                }
            },
            "./node_modules/core-js/internals/descriptors.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/fails.js");
                t.exports = !n((function () {
                    return 7 != Object.defineProperty({}, "a", {
                        get: function () {
                            return 7
                        }
                    }).a
                }))
            },
            "./node_modules/core-js/internals/document-create-element.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/global.js"),
                    l = i("./node_modules/core-js/internals/is-object.js"),
                    r = n.document,
                    a = l(r) && l(r.createElement);
                t.exports = function (t) {
                    return a ? r.createElement(t) : {}
                }
            },
            "./node_modules/core-js/internals/enum-bug-keys.js": function (t, e) {
                t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]
            },
            "./node_modules/core-js/internals/export.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/global.js"),
                    l = i("./node_modules/core-js/internals/object-get-own-property-descriptor.js").f,
                    r = i("./node_modules/core-js/internals/hide.js"),
                    a = i("./node_modules/core-js/internals/redefine.js"),
                    o = i("./node_modules/core-js/internals/set-global.js"),
                    s = i("./node_modules/core-js/internals/copy-constructor-properties.js"),
                    c = i("./node_modules/core-js/internals/is-forced.js");
                t.exports = function (t, e) {
                    var i, u, h, d, f, p = t.target,
                        g = t.global,
                        m = t.stat;
                    if (i = g ? n : m ? n[p] || o(p, {}) : (n[p] || {}).prototype)
                        for (u in e) {
                            if (d = e[u], h = t.noTargetGet ? (f = l(i, u)) && f.value : i[u], !c(g ? u : p + (m ? "." : "#") + u, t.forced) && void 0 !== h) {
                                if (typeof d == typeof h) continue;
                                s(d, h)
                            }(t.sham || h && h.sham) && r(d, "sham", !0), a(i, u, d, t)
                        }
                }
            },
            "./node_modules/core-js/internals/fails.js": function (t, e) {
                t.exports = function (t) {
                    try {
                        return !!t()
                    } catch (t) {
                        return !0
                    }
                }
            },
            "./node_modules/core-js/internals/function-to-string.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/shared.js");
                t.exports = n("native-function-to-string", Function.toString)
            },
            "./node_modules/core-js/internals/get-iterator-method.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/classof.js"),
                    l = i("./node_modules/core-js/internals/iterators.js"),
                    r = i("./node_modules/core-js/internals/well-known-symbol.js")("iterator");
                t.exports = function (t) {
                    if (null != t) return t[r] || t["@@iterator"] || l[n(t)]
                }
            },
            "./node_modules/core-js/internals/global.js": function (t, e, i) {
                (function (e) {
                    var i = "object",
                        n = function (t) {
                            return t && t.Math == Math && t
                        };
                    t.exports = n(typeof globalThis == i && globalThis) || n(typeof window == i && window) || n(typeof self == i && self) || n(typeof e == i && e) || Function("return this")()
                }).call(this, i("./node_modules/webpack/buildin/global.js"))
            },
            "./node_modules/core-js/internals/has.js": function (t, e) {
                var i = {}.hasOwnProperty;
                t.exports = function (t, e) {
                    return i.call(t, e)
                }
            },
            "./node_modules/core-js/internals/hidden-keys.js": function (t, e) {
                t.exports = {}
            },
            "./node_modules/core-js/internals/hide.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/descriptors.js"),
                    l = i("./node_modules/core-js/internals/object-define-property.js"),
                    r = i("./node_modules/core-js/internals/create-property-descriptor.js");
                t.exports = n ? function (t, e, i) {
                    return l.f(t, e, r(1, i))
                } : function (t, e, i) {
                    return t[e] = i, t
                }
            },
            "./node_modules/core-js/internals/html.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/global.js").document;
                t.exports = n && n.documentElement
            },
            "./node_modules/core-js/internals/ie8-dom-define.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/descriptors.js"),
                    l = i("./node_modules/core-js/internals/fails.js"),
                    r = i("./node_modules/core-js/internals/document-create-element.js");
                t.exports = !n && !l((function () {
                    return 7 != Object.defineProperty(r("div"), "a", {
                        get: function () {
                            return 7
                        }
                    }).a
                }))
            },
            "./node_modules/core-js/internals/indexed-object.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/fails.js"),
                    l = i("./node_modules/core-js/internals/classof-raw.js"),
                    r = "".split;
                t.exports = n((function () {
                    return !Object("z").propertyIsEnumerable(0)
                })) ? function (t) {
                    return "String" == l(t) ? r.call(t, "") : Object(t)
                } : Object
            },
            "./node_modules/core-js/internals/internal-state.js": function (t, e, i) {
                var n, l, r, a = i("./node_modules/core-js/internals/native-weak-map.js"),
                    o = i("./node_modules/core-js/internals/global.js"),
                    s = i("./node_modules/core-js/internals/is-object.js"),
                    c = i("./node_modules/core-js/internals/hide.js"),
                    u = i("./node_modules/core-js/internals/has.js"),
                    h = i("./node_modules/core-js/internals/shared-key.js"),
                    d = i("./node_modules/core-js/internals/hidden-keys.js"),
                    f = o.WeakMap;
                if (a) {
                    var p = new f,
                        g = p.get,
                        m = p.has,
                        v = p.set;
                    n = function (t, e) {
                        return v.call(p, t, e), e
                    }, l = function (t) {
                        return g.call(p, t) || {}
                    }, r = function (t) {
                        return m.call(p, t)
                    }
                } else {
                    var y = h("state");
                    d[y] = !0, n = function (t, e) {
                        return c(t, y, e), e
                    }, l = function (t) {
                        return u(t, y) ? t[y] : {}
                    }, r = function (t) {
                        return u(t, y)
                    }
                }
                t.exports = {
                    set: n,
                    get: l,
                    has: r,
                    enforce: function (t) {
                        return r(t) ? l(t) : n(t, {})
                    },
                    getterFor: function (t) {
                        return function (e) {
                            var i;
                            if (!s(e) || (i = l(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
                            return i
                        }
                    }
                }
            },
            "./node_modules/core-js/internals/is-array-iterator-method.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/well-known-symbol.js"),
                    l = i("./node_modules/core-js/internals/iterators.js"),
                    r = n("iterator"),
                    a = Array.prototype;
                t.exports = function (t) {
                    return void 0 !== t && (l.Array === t || a[r] === t)
                }
            },
            "./node_modules/core-js/internals/is-forced.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/fails.js"),
                    l = /#|\.prototype\./,
                    r = function (t, e) {
                        var i = o[a(t)];
                        return i == c || i != s && ("function" == typeof e ? n(e) : !!e)
                    },
                    a = r.normalize = function (t) {
                        return String(t).replace(l, ".").toLowerCase()
                    },
                    o = r.data = {},
                    s = r.NATIVE = "N",
                    c = r.POLYFILL = "P";
                t.exports = r
            },
            "./node_modules/core-js/internals/is-object.js": function (t, e) {
                t.exports = function (t) {
                    return "object" == typeof t ? null !== t : "function" == typeof t
                }
            },
            "./node_modules/core-js/internals/is-pure.js": function (t, e) {
                t.exports = !1
            },
            "./node_modules/core-js/internals/iterators-core.js": function (t, e, i) {
                "use strict";
                var n, l, r, a = i("./node_modules/core-js/internals/object-get-prototype-of.js"),
                    o = i("./node_modules/core-js/internals/hide.js"),
                    s = i("./node_modules/core-js/internals/has.js"),
                    c = i("./node_modules/core-js/internals/well-known-symbol.js"),
                    u = i("./node_modules/core-js/internals/is-pure.js"),
                    h = c("iterator"),
                    d = !1;
                [].keys && ("next" in (r = [].keys()) ? (l = a(a(r))) !== Object.prototype && (n = l) : d = !0), null == n && (n = {}), u || s(n, h) || o(n, h, (function () {
                    return this
                })), t.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: d
                }
            },
            "./node_modules/core-js/internals/iterators.js": function (t, e) {
                t.exports = {}
            },
            "./node_modules/core-js/internals/native-symbol.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/fails.js");
                t.exports = !!Object.getOwnPropertySymbols && !n((function () {
                    return !String(Symbol())
                }))
            },
            "./node_modules/core-js/internals/native-weak-map.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/global.js"),
                    l = i("./node_modules/core-js/internals/function-to-string.js"),
                    r = n.WeakMap;
                t.exports = "function" == typeof r && /native code/.test(l.call(r))
            },
            "./node_modules/core-js/internals/object-create.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/an-object.js"),
                    l = i("./node_modules/core-js/internals/object-define-properties.js"),
                    r = i("./node_modules/core-js/internals/enum-bug-keys.js"),
                    a = i("./node_modules/core-js/internals/hidden-keys.js"),
                    o = i("./node_modules/core-js/internals/html.js"),
                    s = i("./node_modules/core-js/internals/document-create-element.js"),
                    c = i("./node_modules/core-js/internals/shared-key.js")("IE_PROTO"),
                    u = function () {},
                    h = function () {
                        var t, e = s("iframe"),
                            i = r.length;
                        for (e.style.display = "none", o.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), h = t.F; i--;) delete h.prototype[r[i]];
                        return h()
                    };
                t.exports = Object.create || function (t, e) {
                    var i;
                    return null !== t ? (u.prototype = n(t), i = new u, u.prototype = null, i[c] = t) : i = h(), void 0 === e ? i : l(i, e)
                }, a[c] = !0
            },
            "./node_modules/core-js/internals/object-define-properties.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/descriptors.js"),
                    l = i("./node_modules/core-js/internals/object-define-property.js"),
                    r = i("./node_modules/core-js/internals/an-object.js"),
                    a = i("./node_modules/core-js/internals/object-keys.js");
                t.exports = n ? Object.defineProperties : function (t, e) {
                    r(t);
                    for (var i, n = a(e), o = n.length, s = 0; o > s;) l.f(t, i = n[s++], e[i]);
                    return t
                }
            },
            "./node_modules/core-js/internals/object-define-property.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/descriptors.js"),
                    l = i("./node_modules/core-js/internals/ie8-dom-define.js"),
                    r = i("./node_modules/core-js/internals/an-object.js"),
                    a = i("./node_modules/core-js/internals/to-primitive.js"),
                    o = Object.defineProperty;
                e.f = n ? o : function (t, e, i) {
                    if (r(t), e = a(e, !0), r(i), l) try {
                        return o(t, e, i)
                    } catch (t) {}
                    if ("get" in i || "set" in i) throw TypeError("Accessors not supported");
                    return "value" in i && (t[e] = i.value), t
                }
            },
            "./node_modules/core-js/internals/object-get-own-property-descriptor.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/descriptors.js"),
                    l = i("./node_modules/core-js/internals/object-property-is-enumerable.js"),
                    r = i("./node_modules/core-js/internals/create-property-descriptor.js"),
                    a = i("./node_modules/core-js/internals/to-indexed-object.js"),
                    o = i("./node_modules/core-js/internals/to-primitive.js"),
                    s = i("./node_modules/core-js/internals/has.js"),
                    c = i("./node_modules/core-js/internals/ie8-dom-define.js"),
                    u = Object.getOwnPropertyDescriptor;
                e.f = n ? u : function (t, e) {
                    if (t = a(t), e = o(e, !0), c) try {
                        return u(t, e)
                    } catch (t) {}
                    if (s(t, e)) return r(!l.f.call(t, e), t[e])
                }
            },
            "./node_modules/core-js/internals/object-get-own-property-names.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/object-keys-internal.js"),
                    l = i("./node_modules/core-js/internals/enum-bug-keys.js").concat("length", "prototype");
                e.f = Object.getOwnPropertyNames || function (t) {
                    return n(t, l)
                }
            },
            "./node_modules/core-js/internals/object-get-own-property-symbols.js": function (t, e) {
                e.f = Object.getOwnPropertySymbols
            },
            "./node_modules/core-js/internals/object-get-prototype-of.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/has.js"),
                    l = i("./node_modules/core-js/internals/to-object.js"),
                    r = i("./node_modules/core-js/internals/shared-key.js"),
                    a = i("./node_modules/core-js/internals/correct-prototype-getter.js"),
                    o = r("IE_PROTO"),
                    s = Object.prototype;
                t.exports = a ? Object.getPrototypeOf : function (t) {
                    return t = l(t), n(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? s : null
                }
            },
            "./node_modules/core-js/internals/object-keys-internal.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/has.js"),
                    l = i("./node_modules/core-js/internals/to-indexed-object.js"),
                    r = i("./node_modules/core-js/internals/array-includes.js"),
                    a = i("./node_modules/core-js/internals/hidden-keys.js"),
                    o = r(!1);
                t.exports = function (t, e) {
                    var i, r = l(t),
                        s = 0,
                        c = [];
                    for (i in r) !n(a, i) && n(r, i) && c.push(i);
                    for (; e.length > s;) n(r, i = e[s++]) && (~o(c, i) || c.push(i));
                    return c
                }
            },
            "./node_modules/core-js/internals/object-keys.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/object-keys-internal.js"),
                    l = i("./node_modules/core-js/internals/enum-bug-keys.js");
                t.exports = Object.keys || function (t) {
                    return n(t, l)
                }
            },
            "./node_modules/core-js/internals/object-property-is-enumerable.js": function (t, e, i) {
                "use strict";
                var n = {}.propertyIsEnumerable,
                    l = Object.getOwnPropertyDescriptor,
                    r = l && !n.call({
                        1: 2
                    }, 1);
                e.f = r ? function (t) {
                    var e = l(this, t);
                    return !!e && e.enumerable
                } : n
            },
            "./node_modules/core-js/internals/object-set-prototype-of.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/validate-set-prototype-of-arguments.js");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
                    var t, e = !1,
                        i = {};
                    try {
                        (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(i, []), e = i instanceof Array
                    } catch (t) {}
                    return function (i, l) {
                        return n(i, l), e ? t.call(i, l) : i.__proto__ = l, i
                    }
                }() : void 0)
            },
            "./node_modules/core-js/internals/own-keys.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/global.js"),
                    l = i("./node_modules/core-js/internals/object-get-own-property-names.js"),
                    r = i("./node_modules/core-js/internals/object-get-own-property-symbols.js"),
                    a = i("./node_modules/core-js/internals/an-object.js"),
                    o = n.Reflect;
                t.exports = o && o.ownKeys || function (t) {
                    var e = l.f(a(t)),
                        i = r.f;
                    return i ? e.concat(i(t)) : e
                }
            },
            "./node_modules/core-js/internals/path.js": function (t, e, i) {
                t.exports = i("./node_modules/core-js/internals/global.js")
            },
            "./node_modules/core-js/internals/redefine.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/global.js"),
                    l = i("./node_modules/core-js/internals/shared.js"),
                    r = i("./node_modules/core-js/internals/hide.js"),
                    a = i("./node_modules/core-js/internals/has.js"),
                    o = i("./node_modules/core-js/internals/set-global.js"),
                    s = i("./node_modules/core-js/internals/function-to-string.js"),
                    c = i("./node_modules/core-js/internals/internal-state.js"),
                    u = c.get,
                    h = c.enforce,
                    d = String(s).split("toString");
                l("inspectSource", (function (t) {
                    return s.call(t)
                })), (t.exports = function (t, e, i, l) {
                    var s = !!l && !!l.unsafe,
                        c = !!l && !!l.enumerable,
                        u = !!l && !!l.noTargetGet;
                    "function" == typeof i && ("string" != typeof e || a(i, "name") || r(i, "name", e), h(i).source = d.join("string" == typeof e ? e : "")), t !== n ? (s ? !u && t[e] && (c = !0) : delete t[e], c ? t[e] = i : r(t, e, i)) : c ? t[e] = i : o(e, i)
                })(Function.prototype, "toString", (function () {
                    return "function" == typeof this && u(this).source || s.call(this)
                }))
            },
            "./node_modules/core-js/internals/require-object-coercible.js": function (t, e) {
                t.exports = function (t) {
                    if (null == t) throw TypeError("Can't call method on " + t);
                    return t
                }
            },
            "./node_modules/core-js/internals/set-global.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/global.js"),
                    l = i("./node_modules/core-js/internals/hide.js");
                t.exports = function (t, e) {
                    try {
                        l(n, t, e)
                    } catch (i) {
                        n[t] = e
                    }
                    return e
                }
            },
            "./node_modules/core-js/internals/set-to-string-tag.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/object-define-property.js").f,
                    l = i("./node_modules/core-js/internals/has.js"),
                    r = i("./node_modules/core-js/internals/well-known-symbol.js")("toStringTag");
                t.exports = function (t, e, i) {
                    t && !l(t = i ? t : t.prototype, r) && n(t, r, {
                        configurable: !0,
                        value: e
                    })
                }
            },
            "./node_modules/core-js/internals/shared-key.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/shared.js"),
                    l = i("./node_modules/core-js/internals/uid.js"),
                    r = n("keys");
                t.exports = function (t) {
                    return r[t] || (r[t] = l(t))
                }
            },
            "./node_modules/core-js/internals/shared.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/global.js"),
                    l = i("./node_modules/core-js/internals/set-global.js"),
                    r = i("./node_modules/core-js/internals/is-pure.js"),
                    a = "__core-js_shared__",
                    o = n[a] || l(a, {});
                (t.exports = function (t, e) {
                    return o[t] || (o[t] = void 0 !== e ? e : {})
                })("versions", []).push({
                    version: "3.1.3",
                    mode: r ? "pure" : "global",
                    copyright: "Â© 2019 Denis Pushkarev (zloirock.ru)"
                })
            },
            "./node_modules/core-js/internals/string-at.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/to-integer.js"),
                    l = i("./node_modules/core-js/internals/require-object-coercible.js");
                t.exports = function (t, e, i) {
                    var r, a, o = String(l(t)),
                        s = n(e),
                        c = o.length;
                    return s < 0 || s >= c ? i ? "" : void 0 : (r = o.charCodeAt(s)) < 55296 || r > 56319 || s + 1 === c || (a = o.charCodeAt(s + 1)) < 56320 || a > 57343 ? i ? o.charAt(s) : r : i ? o.slice(s, s + 2) : a - 56320 + (r - 55296 << 10) + 65536
                }
            },
            "./node_modules/core-js/internals/to-absolute-index.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/to-integer.js"),
                    l = Math.max,
                    r = Math.min;
                t.exports = function (t, e) {
                    var i = n(t);
                    return i < 0 ? l(i + e, 0) : r(i, e)
                }
            },
            "./node_modules/core-js/internals/to-indexed-object.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/indexed-object.js"),
                    l = i("./node_modules/core-js/internals/require-object-coercible.js");
                t.exports = function (t) {
                    return n(l(t))
                }
            },
            "./node_modules/core-js/internals/to-integer.js": function (t, e) {
                var i = Math.ceil,
                    n = Math.floor;
                t.exports = function (t) {
                    return isNaN(t = +t) ? 0 : (t > 0 ? n : i)(t)
                }
            },
            "./node_modules/core-js/internals/to-length.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/to-integer.js"),
                    l = Math.min;
                t.exports = function (t) {
                    return t > 0 ? l(n(t), 9007199254740991) : 0
                }
            },
            "./node_modules/core-js/internals/to-object.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/require-object-coercible.js");
                t.exports = function (t) {
                    return Object(n(t))
                }
            },
            "./node_modules/core-js/internals/to-primitive.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/is-object.js");
                t.exports = function (t, e) {
                    if (!n(t)) return t;
                    var i, l;
                    if (e && "function" == typeof (i = t.toString) && !n(l = i.call(t))) return l;
                    if ("function" == typeof (i = t.valueOf) && !n(l = i.call(t))) return l;
                    if (!e && "function" == typeof (i = t.toString) && !n(l = i.call(t))) return l;
                    throw TypeError("Can't convert object to primitive value")
                }
            },
            "./node_modules/core-js/internals/uid.js": function (t, e) {
                var i = 0,
                    n = Math.random();
                t.exports = function (t) {
                    return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++i + n).toString(36))
                }
            },
            "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/is-object.js"),
                    l = i("./node_modules/core-js/internals/an-object.js");
                t.exports = function (t, e) {
                    if (l(t), !n(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype")
                }
            },
            "./node_modules/core-js/internals/well-known-symbol.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/global.js"),
                    l = i("./node_modules/core-js/internals/shared.js"),
                    r = i("./node_modules/core-js/internals/uid.js"),
                    a = i("./node_modules/core-js/internals/native-symbol.js"),
                    o = n.Symbol,
                    s = l("wks");
                t.exports = function (t) {
                    return s[t] || (s[t] = a && o[t] || (a ? o : r)("Symbol." + t))
                }
            },
            "./node_modules/core-js/modules/es.array.from.js": function (t, e, i) {
                var n = i("./node_modules/core-js/internals/export.js"),
                    l = i("./node_modules/core-js/internals/array-from.js");
                n({
                    target: "Array",
                    stat: !0,
                    forced: !i("./node_modules/core-js/internals/check-correctness-of-iteration.js")((function (t) {
                        Array.from(t)
                    }))
                }, {
                    from: l
                })
            },
            "./node_modules/core-js/modules/es.string.iterator.js": function (t, e, i) {
                "use strict";
                var n = i("./node_modules/core-js/internals/string-at.js"),
                    l = i("./node_modules/core-js/internals/internal-state.js"),
                    r = i("./node_modules/core-js/internals/define-iterator.js"),
                    a = "String Iterator",
                    o = l.set,
                    s = l.getterFor(a);
                r(String, "String", (function (t) {
                    o(this, {
                        type: a,
                        string: String(t),
                        index: 0
                    })
                }), (function () {
                    var t, e = s(this),
                        i = e.string,
                        l = e.index;
                    return l >= i.length ? {
                        value: void 0,
                        done: !0
                    } : (t = n(i, l, !0), e.index += t.length, {
                        value: t,
                        done: !1
                    })
                }))
            },
            "./node_modules/webpack/buildin/global.js": function (t, e) {
                var i;
                i = function () {
                    return this
                }();
                try {
                    i = i || Function("return this")() || (0, eval)("this")
                } catch (t) {
                    "object" == typeof window && (i = window)
                }
                t.exports = i
            },
            "./src/default-attrs.json": function (t) {
                t.exports = {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: 24,
                    height: 24,
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": 2,
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }
            },
            "./src/icon.js": function (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var n = Object.assign || function (t) {
                        for (var e = 1; e < arguments.length; e++) {
                            var i = arguments[e];
                            for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
                        }
                        return t
                    },
                    l = function () {
                        function t(t, e) {
                            for (var i = 0; i < e.length; i++) {
                                var n = e[i];
                                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                            }
                        }
                        return function (e, i, n) {
                            return i && t(e.prototype, i), n && t(e, n), e
                        }
                    }(),
                    r = o(i("./node_modules/classnames/dedupe.js")),
                    a = o(i("./src/default-attrs.json"));

                function o(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    }
                }

                function s(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                }
                var c = function () {
                    function t(e, i) {
                        var l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                        s(this, t), this.name = e, this.contents = i, this.tags = l, this.attrs = n({}, a.default, {
                            class: "feather feather-" + e
                        })
                    }
                    return l(t, [{
                        key: "toSvg",
                        value: function () {
                            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                                e = n({}, this.attrs, t, {
                                    class: (0, r.default)(this.attrs.class, t.class)
                                });
                            return "<svg " + u(e) + ">" + this.contents + "</svg>"
                        }
                    }, {
                        key: "toString",
                        value: function () {
                            return this.contents
                        }
                    }]), t
                }();

                function u(t) {
                    return Object.keys(t).map((function (e) {
                        return e + '="' + t[e] + '"'
                    })).join(" ")
                }
                e.default = c
            },
            "./src/icons.js": function (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var n = a(i("./src/icon.js")),
                    l = a(i("./dist/icons.json")),
                    r = a(i("./src/tags.json"));

                function a(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    }
                }
                e.default = Object.keys(l.default).map((function (t) {
                    return new n.default(t, l.default[t], r.default[t])
                })).reduce((function (t, e) {
                    return t[e.name] = e, t
                }), {})
            },
            "./src/index.js": function (t, e, i) {
                "use strict";
                var n = a(i("./src/icons.js")),
                    l = a(i("./src/to-svg.js")),
                    r = a(i("./src/replace.js"));

                function a(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    }
                }
                t.exports = {
                    icons: n.default,
                    toSvg: l.default,
                    replace: r.default
                }
            },
            "./src/replace.js": function (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var n = Object.assign || function (t) {
                        for (var e = 1; e < arguments.length; e++) {
                            var i = arguments[e];
                            for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
                        }
                        return t
                    },
                    l = a(i("./node_modules/classnames/dedupe.js")),
                    r = a(i("./src/icons.js"));

                function a(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    }
                }

                function o(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                        i = s(t),
                        a = i["data-feather"];
                    delete i["data-feather"];
                    var o = r.default[a].toSvg(n({}, e, i, {
                            class: (0, l.default)(e.class, i.class)
                        })),
                        c = (new DOMParser).parseFromString(o, "image/svg+xml"),
                        u = c.querySelector("svg");
                    t.parentNode.replaceChild(u, t)
                }

                function s(t) {
                    return Array.from(t.attributes).reduce((function (t, e) {
                        return t[e.name] = e.value, t
                    }), {})
                }
                e.default = function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    if ("undefined" == typeof document) throw new Error("`feather.replace()` only works in a browser environment.");
                    var e = document.querySelectorAll("[data-feather]");
                    Array.from(e).forEach((function (e) {
                        return o(e, t)
                    }))
                }
            },
            "./src/tags.json": function (t) {
                t.exports = {
                    activity: ["pulse", "health", "action", "motion"],
                    airplay: ["stream", "cast", "mirroring"],
                    "alert-circle": ["warning", "alert", "danger"],
                    "alert-octagon": ["warning", "alert", "danger"],
                    "alert-triangle": ["warning", "alert", "danger"],
                    "align-center": ["text alignment", "center"],
                    "align-justify": ["text alignment", "justified"],
                    "align-left": ["text alignment", "left"],
                    "align-right": ["text alignment", "right"],
                    anchor: [],
                    archive: ["index", "box"],
                    "at-sign": ["mention", "at", "email", "message"],
                    award: ["achievement", "badge"],
                    aperture: ["camera", "photo"],
                    "bar-chart": ["statistics", "diagram", "graph"],
                    "bar-chart-2": ["statistics", "diagram", "graph"],
                    battery: ["power", "electricity"],
                    "battery-charging": ["power", "electricity"],
                    bell: ["alarm", "notification", "sound"],
                    "bell-off": ["alarm", "notification", "silent"],
                    bluetooth: ["wireless"],
                    "book-open": ["read", "library"],
                    book: ["read", "dictionary", "booklet", "magazine", "library"],
                    bookmark: ["read", "clip", "marker", "tag"],
                    box: ["cube"],
                    briefcase: ["work", "bag", "baggage", "folder"],
                    calendar: ["date"],
                    camera: ["photo"],
                    cast: ["chromecast", "airplay"],
                    circle: ["off", "zero", "record"],
                    clipboard: ["copy"],
                    clock: ["time", "watch", "alarm"],
                    "cloud-drizzle": ["weather", "shower"],
                    "cloud-lightning": ["weather", "bolt"],
                    "cloud-rain": ["weather"],
                    "cloud-snow": ["weather", "blizzard"],
                    cloud: ["weather"],
                    codepen: ["logo"],
                    codesandbox: ["logo"],
                    code: ["source", "programming"],
                    coffee: ["drink", "cup", "mug", "tea", "cafe", "hot", "beverage"],
                    columns: ["layout"],
                    command: ["keyboard", "cmd", "terminal", "prompt"],
                    compass: ["navigation", "safari", "travel", "direction"],
                    copy: ["clone", "duplicate"],
                    "corner-down-left": ["arrow", "return"],
                    "corner-down-right": ["arrow"],
                    "corner-left-down": ["arrow"],
                    "corner-left-up": ["arrow"],
                    "corner-right-down": ["arrow"],
                    "corner-right-up": ["arrow"],
                    "corner-up-left": ["arrow"],
                    "corner-up-right": ["arrow"],
                    cpu: ["processor", "technology"],
                    "credit-card": ["purchase", "payment", "cc"],
                    crop: ["photo", "image"],
                    crosshair: ["aim", "target"],
                    database: ["storage", "memory"],
                    delete: ["remove"],
                    disc: ["album", "cd", "dvd", "music"],
                    "dollar-sign": ["currency", "money", "payment"],
                    droplet: ["water"],
                    edit: ["pencil", "change"],
                    "edit-2": ["pencil", "change"],
                    "edit-3": ["pencil", "change"],
                    eye: ["view", "watch"],
                    "eye-off": ["view", "watch", "hide", "hidden"],
                    "external-link": ["outbound"],
                    facebook: ["logo", "social"],
                    "fast-forward": ["music"],
                    figma: ["logo", "design", "tool"],
                    "file-minus": ["delete", "remove", "erase"],
                    "file-plus": ["add", "create", "new"],
                    "file-text": ["data", "txt", "pdf"],
                    film: ["movie", "video"],
                    filter: ["funnel", "hopper"],
                    flag: ["report"],
                    "folder-minus": ["directory"],
                    "folder-plus": ["directory"],
                    folder: ["directory"],
                    framer: ["logo", "design", "tool"],
                    frown: ["emoji", "face", "bad", "sad", "emotion"],
                    gift: ["present", "box", "birthday", "party"],
                    "git-branch": ["code", "version control"],
                    "git-commit": ["code", "version control"],
                    "git-merge": ["code", "version control"],
                    "git-pull-request": ["code", "version control"],
                    github: ["logo", "version control"],
                    gitlab: ["logo", "version control"],
                    globe: ["world", "browser", "language", "translate"],
                    "hard-drive": ["computer", "server", "memory", "data"],
                    hash: ["hashtag", "number", "pound"],
                    headphones: ["music", "audio", "sound"],
                    heart: ["like", "love", "emotion"],
                    "help-circle": ["question mark"],
                    hexagon: ["shape", "node.js", "logo"],
                    home: ["house", "living"],
                    image: ["picture"],
                    inbox: ["email"],
                    instagram: ["logo", "camera"],
                    key: ["password", "login", "authentication", "secure"],
                    layers: ["stack"],
                    layout: ["window", "webpage"],
                    "life-bouy": ["help", "life ring", "support"],
                    link: ["chain", "url"],
                    "link-2": ["chain", "url"],
                    linkedin: ["logo", "social media"],
                    list: ["options"],
                    lock: ["security", "password", "secure"],
                    "log-in": ["sign in", "arrow", "enter"],
                    "log-out": ["sign out", "arrow", "exit"],
                    mail: ["email", "message"],
                    "map-pin": ["location", "navigation", "travel", "marker"],
                    map: ["location", "navigation", "travel"],
                    maximize: ["fullscreen"],
                    "maximize-2": ["fullscreen", "arrows", "expand"],
                    meh: ["emoji", "face", "neutral", "emotion"],
                    menu: ["bars", "navigation", "hamburger"],
                    "message-circle": ["comment", "chat"],
                    "message-square": ["comment", "chat"],
                    "mic-off": ["record", "sound", "mute"],
                    mic: ["record", "sound", "listen"],
                    minimize: ["exit fullscreen", "close"],
                    "minimize-2": ["exit fullscreen", "arrows", "close"],
                    minus: ["subtract"],
                    monitor: ["tv", "screen", "display"],
                    moon: ["dark", "night"],
                    "more-horizontal": ["ellipsis"],
                    "more-vertical": ["ellipsis"],
                    "mouse-pointer": ["arrow", "cursor"],
                    move: ["arrows"],
                    music: ["note"],
                    navigation: ["location", "travel"],
                    "navigation-2": ["location", "travel"],
                    octagon: ["stop"],
                    package: ["box", "container"],
                    paperclip: ["attachment"],
                    pause: ["music", "stop"],
                    "pause-circle": ["music", "audio", "stop"],
                    "pen-tool": ["vector", "drawing"],
                    percent: ["discount"],
                    "phone-call": ["ring"],
                    "phone-forwarded": ["call"],
                    "phone-incoming": ["call"],
                    "phone-missed": ["call"],
                    "phone-off": ["call", "mute"],
                    "phone-outgoing": ["call"],
                    phone: ["call"],
                    play: ["music", "start"],
                    "pie-chart": ["statistics", "diagram"],
                    "play-circle": ["music", "start"],
                    plus: ["add", "new"],
                    "plus-circle": ["add", "new"],
                    "plus-square": ["add", "new"],
                    pocket: ["logo", "save"],
                    power: ["on", "off"],
                    printer: ["fax", "office", "device"],
                    radio: ["signal"],
                    "refresh-cw": ["synchronise", "arrows"],
                    "refresh-ccw": ["arrows"],
                    repeat: ["loop", "arrows"],
                    rewind: ["music"],
                    "rotate-ccw": ["arrow"],
                    "rotate-cw": ["arrow"],
                    rss: ["feed", "subscribe"],
                    save: ["floppy disk"],
                    scissors: ["cut"],
                    search: ["find", "magnifier", "magnifying glass"],
                    send: ["message", "mail", "email", "paper airplane", "paper aeroplane"],
                    settings: ["cog", "edit", "gear", "preferences"],
                    "share-2": ["network", "connections"],
                    shield: ["security", "secure"],
                    "shield-off": ["security", "insecure"],
                    "shopping-bag": ["ecommerce", "cart", "purchase", "store"],
                    "shopping-cart": ["ecommerce", "cart", "purchase", "store"],
                    shuffle: ["music"],
                    "skip-back": ["music"],
                    "skip-forward": ["music"],
                    slack: ["logo"],
                    slash: ["ban", "no"],
                    sliders: ["settings", "controls"],
                    smartphone: ["cellphone", "device"],
                    smile: ["emoji", "face", "happy", "good", "emotion"],
                    speaker: ["audio", "music"],
                    star: ["bookmark", "favorite", "like"],
                    "stop-circle": ["media", "music"],
                    sun: ["brightness", "weather", "light"],
                    sunrise: ["weather", "time", "morning", "day"],
                    sunset: ["weather", "time", "evening", "night"],
                    tablet: ["device"],
                    tag: ["label"],
                    target: ["logo", "bullseye"],
                    terminal: ["code", "command line", "prompt"],
                    thermometer: ["temperature", "celsius", "fahrenheit", "weather"],
                    "thumbs-down": ["dislike", "bad", "emotion"],
                    "thumbs-up": ["like", "good", "emotion"],
                    "toggle-left": ["on", "off", "switch"],
                    "toggle-right": ["on", "off", "switch"],
                    tool: ["settings", "spanner"],
                    trash: ["garbage", "delete", "remove", "bin"],
                    "trash-2": ["garbage", "delete", "remove", "bin"],
                    triangle: ["delta"],
                    truck: ["delivery", "van", "shipping", "transport", "lorry"],
                    tv: ["television", "stream"],
                    twitch: ["logo"],
                    twitter: ["logo", "social"],
                    type: ["text"],
                    umbrella: ["rain", "weather"],
                    unlock: ["security"],
                    "user-check": ["followed", "subscribed"],
                    "user-minus": ["delete", "remove", "unfollow", "unsubscribe"],
                    "user-plus": ["new", "add", "create", "follow", "subscribe"],
                    "user-x": ["delete", "remove", "unfollow", "unsubscribe", "unavailable"],
                    user: ["person", "account"],
                    users: ["group"],
                    "video-off": ["camera", "movie", "film"],
                    video: ["camera", "movie", "film"],
                    voicemail: ["phone"],
                    volume: ["music", "sound", "mute"],
                    "volume-1": ["music", "sound"],
                    "volume-2": ["music", "sound"],
                    "volume-x": ["music", "sound", "mute"],
                    watch: ["clock", "time"],
                    "wifi-off": ["disabled"],
                    wifi: ["connection", "signal", "wireless"],
                    wind: ["weather", "air"],
                    "x-circle": ["cancel", "close", "delete", "remove", "times", "clear"],
                    "x-octagon": ["delete", "stop", "alert", "warning", "times", "clear"],
                    "x-square": ["cancel", "close", "delete", "remove", "times", "clear"],
                    x: ["cancel", "close", "delete", "remove", "times", "clear"],
                    youtube: ["logo", "video", "play"],
                    "zap-off": ["flash", "camera", "lightning"],
                    zap: ["flash", "camera", "lightning"],
                    "zoom-in": ["magnifying glass"],
                    "zoom-out": ["magnifying glass"]
                }
            },
            "./src/to-svg.js": function (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var n, l = i("./src/icons.js"),
                    r = (n = l) && n.__esModule ? n : {
                        default: n
                    };
                e.default = function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (console.warn("feather.toSvg() is deprecated. Please use feather.icons[name].toSvg() instead."), !t) throw new Error("The required `key` (icon name) parameter is missing.");
                    if (!r.default[t]) throw new Error("No icon matching '" + t + "'. See the complete list of icons at https://feathericons.com");
                    return r.default[t].toSvg(e)
                }
            },
            0: function (t, e, i) {
                i("./node_modules/core-js/es/array/from.js"), t.exports = i("./src/index.js")
            }
        })
    }, t.exports = n()
}, function (t, e, i) {
    t.exports = function (t) {
        "use strict";

        function e(t, e) {
            return t(e = {
                exports: {}
            }, e.exports), e.exports
        }

        function i(t) {
            return t && t.default || t
        }
        t = t && t.hasOwnProperty("default") ? t.default : t;
        var n = {
                aliceblue: [240, 248, 255],
                antiquewhite: [250, 235, 215],
                aqua: [0, 255, 255],
                aquamarine: [127, 255, 212],
                azure: [240, 255, 255],
                beige: [245, 245, 220],
                bisque: [255, 228, 196],
                black: [0, 0, 0],
                blanchedalmond: [255, 235, 205],
                blue: [0, 0, 255],
                blueviolet: [138, 43, 226],
                brown: [165, 42, 42],
                burlywood: [222, 184, 135],
                cadetblue: [95, 158, 160],
                chartreuse: [127, 255, 0],
                chocolate: [210, 105, 30],
                coral: [255, 127, 80],
                cornflowerblue: [100, 149, 237],
                cornsilk: [255, 248, 220],
                crimson: [220, 20, 60],
                cyan: [0, 255, 255],
                darkblue: [0, 0, 139],
                darkcyan: [0, 139, 139],
                darkgoldenrod: [184, 134, 11],
                darkgray: [169, 169, 169],
                darkgreen: [0, 100, 0],
                darkgrey: [169, 169, 169],
                darkkhaki: [189, 183, 107],
                darkmagenta: [139, 0, 139],
                darkolivegreen: [85, 107, 47],
                darkorange: [255, 140, 0],
                darkorchid: [153, 50, 204],
                darkred: [139, 0, 0],
                darksalmon: [233, 150, 122],
                darkseagreen: [143, 188, 143],
                darkslateblue: [72, 61, 139],
                darkslategray: [47, 79, 79],
                darkslategrey: [47, 79, 79],
                darkturquoise: [0, 206, 209],
                darkviolet: [148, 0, 211],
                deeppink: [255, 20, 147],
                deepskyblue: [0, 191, 255],
                dimgray: [105, 105, 105],
                dimgrey: [105, 105, 105],
                dodgerblue: [30, 144, 255],
                firebrick: [178, 34, 34],
                floralwhite: [255, 250, 240],
                forestgreen: [34, 139, 34],
                fuchsia: [255, 0, 255],
                gainsboro: [220, 220, 220],
                ghostwhite: [248, 248, 255],
                gold: [255, 215, 0],
                goldenrod: [218, 165, 32],
                gray: [128, 128, 128],
                green: [0, 128, 0],
                greenyellow: [173, 255, 47],
                grey: [128, 128, 128],
                honeydew: [240, 255, 240],
                hotpink: [255, 105, 180],
                indianred: [205, 92, 92],
                indigo: [75, 0, 130],
                ivory: [255, 255, 240],
                khaki: [240, 230, 140],
                lavender: [230, 230, 250],
                lavenderblush: [255, 240, 245],
                lawngreen: [124, 252, 0],
                lemonchiffon: [255, 250, 205],
                lightblue: [173, 216, 230],
                lightcoral: [240, 128, 128],
                lightcyan: [224, 255, 255],
                lightgoldenrodyellow: [250, 250, 210],
                lightgray: [211, 211, 211],
                lightgreen: [144, 238, 144],
                lightgrey: [211, 211, 211],
                lightpink: [255, 182, 193],
                lightsalmon: [255, 160, 122],
                lightseagreen: [32, 178, 170],
                lightskyblue: [135, 206, 250],
                lightslategray: [119, 136, 153],
                lightslategrey: [119, 136, 153],
                lightsteelblue: [176, 196, 222],
                lightyellow: [255, 255, 224],
                lime: [0, 255, 0],
                limegreen: [50, 205, 50],
                linen: [250, 240, 230],
                magenta: [255, 0, 255],
                maroon: [128, 0, 0],
                mediumaquamarine: [102, 205, 170],
                mediumblue: [0, 0, 205],
                mediumorchid: [186, 85, 211],
                mediumpurple: [147, 112, 219],
                mediumseagreen: [60, 179, 113],
                mediumslateblue: [123, 104, 238],
                mediumspringgreen: [0, 250, 154],
                mediumturquoise: [72, 209, 204],
                mediumvioletred: [199, 21, 133],
                midnightblue: [25, 25, 112],
                mintcream: [245, 255, 250],
                mistyrose: [255, 228, 225],
                moccasin: [255, 228, 181],
                navajowhite: [255, 222, 173],
                navy: [0, 0, 128],
                oldlace: [253, 245, 230],
                olive: [128, 128, 0],
                olivedrab: [107, 142, 35],
                orange: [255, 165, 0],
                orangered: [255, 69, 0],
                orchid: [218, 112, 214],
                palegoldenrod: [238, 232, 170],
                palegreen: [152, 251, 152],
                paleturquoise: [175, 238, 238],
                palevioletred: [219, 112, 147],
                papayawhip: [255, 239, 213],
                peachpuff: [255, 218, 185],
                peru: [205, 133, 63],
                pink: [255, 192, 203],
                plum: [221, 160, 221],
                powderblue: [176, 224, 230],
                purple: [128, 0, 128],
                rebeccapurple: [102, 51, 153],
                red: [255, 0, 0],
                rosybrown: [188, 143, 143],
                royalblue: [65, 105, 225],
                saddlebrown: [139, 69, 19],
                salmon: [250, 128, 114],
                sandybrown: [244, 164, 96],
                seagreen: [46, 139, 87],
                seashell: [255, 245, 238],
                sienna: [160, 82, 45],
                silver: [192, 192, 192],
                skyblue: [135, 206, 235],
                slateblue: [106, 90, 205],
                slategray: [112, 128, 144],
                slategrey: [112, 128, 144],
                snow: [255, 250, 250],
                springgreen: [0, 255, 127],
                steelblue: [70, 130, 180],
                tan: [210, 180, 140],
                teal: [0, 128, 128],
                thistle: [216, 191, 216],
                tomato: [255, 99, 71],
                turquoise: [64, 224, 208],
                violet: [238, 130, 238],
                wheat: [245, 222, 179],
                white: [255, 255, 255],
                whitesmoke: [245, 245, 245],
                yellow: [255, 255, 0],
                yellowgreen: [154, 205, 50]
            },
            l = e((function (t) {
                var e = {};
                for (var i in n) n.hasOwnProperty(i) && (e[n[i]] = i);
                var l = t.exports = {
                    rgb: {
                        channels: 3,
                        labels: "rgb"
                    },
                    hsl: {
                        channels: 3,
                        labels: "hsl"
                    },
                    hsv: {
                        channels: 3,
                        labels: "hsv"
                    },
                    hwb: {
                        channels: 3,
                        labels: "hwb"
                    },
                    cmyk: {
                        channels: 4,
                        labels: "cmyk"
                    },
                    xyz: {
                        channels: 3,
                        labels: "xyz"
                    },
                    lab: {
                        channels: 3,
                        labels: "lab"
                    },
                    lch: {
                        channels: 3,
                        labels: "lch"
                    },
                    hex: {
                        channels: 1,
                        labels: ["hex"]
                    },
                    keyword: {
                        channels: 1,
                        labels: ["keyword"]
                    },
                    ansi16: {
                        channels: 1,
                        labels: ["ansi16"]
                    },
                    ansi256: {
                        channels: 1,
                        labels: ["ansi256"]
                    },
                    hcg: {
                        channels: 3,
                        labels: ["h", "c", "g"]
                    },
                    apple: {
                        channels: 3,
                        labels: ["r16", "g16", "b16"]
                    },
                    gray: {
                        channels: 1,
                        labels: ["gray"]
                    }
                };
                for (var r in l)
                    if (l.hasOwnProperty(r)) {
                        if (!("channels" in l[r])) throw new Error("missing channels property: " + r);
                        if (!("labels" in l[r])) throw new Error("missing channel labels property: " + r);
                        if (l[r].labels.length !== l[r].channels) throw new Error("channel and label counts mismatch: " + r);
                        var a = l[r].channels,
                            o = l[r].labels;
                        delete l[r].channels, delete l[r].labels, Object.defineProperty(l[r], "channels", {
                            value: a
                        }), Object.defineProperty(l[r], "labels", {
                            value: o
                        })
                    }

                function s(t, e) {
                    return Math.pow(t[0] - e[0], 2) + Math.pow(t[1] - e[1], 2) + Math.pow(t[2] - e[2], 2)
                }
                l.rgb.hsl = function (t) {
                    var e, i, n = t[0] / 255,
                        l = t[1] / 255,
                        r = t[2] / 255,
                        a = Math.min(n, l, r),
                        o = Math.max(n, l, r),
                        s = o - a;
                    return o === a ? e = 0 : n === o ? e = (l - r) / s : l === o ? e = 2 + (r - n) / s : r === o && (e = 4 + (n - l) / s), (e = Math.min(60 * e, 360)) < 0 && (e += 360), i = (a + o) / 2, [e, 100 * (o === a ? 0 : i <= .5 ? s / (o + a) : s / (2 - o - a)), 100 * i]
                }, l.rgb.hsv = function (t) {
                    var e, i, n, l, r, a = t[0] / 255,
                        o = t[1] / 255,
                        s = t[2] / 255,
                        c = Math.max(a, o, s),
                        u = c - Math.min(a, o, s),
                        h = function (t) {
                            return (c - t) / 6 / u + .5
                        };
                    return 0 === u ? l = r = 0 : (r = u / c, e = h(a), i = h(o), n = h(s), a === c ? l = n - i : o === c ? l = 1 / 3 + e - n : s === c && (l = 2 / 3 + i - e), l < 0 ? l += 1 : l > 1 && (l -= 1)), [360 * l, 100 * r, 100 * c]
                }, l.rgb.hwb = function (t) {
                    var e = t[0],
                        i = t[1],
                        n = t[2];
                    return [l.rgb.hsl(t)[0], 1 / 255 * Math.min(e, Math.min(i, n)) * 100, 100 * (n = 1 - 1 / 255 * Math.max(e, Math.max(i, n)))]
                }, l.rgb.cmyk = function (t) {
                    var e, i = t[0] / 255,
                        n = t[1] / 255,
                        l = t[2] / 255;
                    return [100 * ((1 - i - (e = Math.min(1 - i, 1 - n, 1 - l))) / (1 - e) || 0), 100 * ((1 - n - e) / (1 - e) || 0), 100 * ((1 - l - e) / (1 - e) || 0), 100 * e]
                }, l.rgb.keyword = function (t) {
                    var i = e[t];
                    if (i) return i;
                    var l, r = 1 / 0;
                    for (var a in n)
                        if (n.hasOwnProperty(a)) {
                            var o = s(t, n[a]);
                            o < r && (r = o, l = a)
                        } return l
                }, l.keyword.rgb = function (t) {
                    return n[t]
                }, l.rgb.xyz = function (t) {
                    var e = t[0] / 255,
                        i = t[1] / 255,
                        n = t[2] / 255;
                    return [100 * (.4124 * (e = e > .04045 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92) + .3576 * (i = i > .04045 ? Math.pow((i + .055) / 1.055, 2.4) : i / 12.92) + .1805 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92)), 100 * (.2126 * e + .7152 * i + .0722 * n), 100 * (.0193 * e + .1192 * i + .9505 * n)]
                }, l.rgb.lab = function (t) {
                    var e = l.rgb.xyz(t),
                        i = e[0],
                        n = e[1],
                        r = e[2];
                    return n /= 100, r /= 108.883, i = (i /= 95.047) > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116, [116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16, 500 * (i - n), 200 * (n - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))]
                }, l.hsl.rgb = function (t) {
                    var e, i, n, l, r, a = t[0] / 360,
                        o = t[1] / 100,
                        s = t[2] / 100;
                    if (0 === o) return [r = 255 * s, r, r];
                    e = 2 * s - (i = s < .5 ? s * (1 + o) : s + o - s * o), l = [0, 0, 0];
                    for (var c = 0; c < 3; c++)(n = a + 1 / 3 * -(c - 1)) < 0 && n++, n > 1 && n--, r = 6 * n < 1 ? e + 6 * (i - e) * n : 2 * n < 1 ? i : 3 * n < 2 ? e + (i - e) * (2 / 3 - n) * 6 : e, l[c] = 255 * r;
                    return l
                }, l.hsl.hsv = function (t) {
                    var e = t[0],
                        i = t[1] / 100,
                        n = t[2] / 100,
                        l = i,
                        r = Math.max(n, .01);
                    return i *= (n *= 2) <= 1 ? n : 2 - n, l *= r <= 1 ? r : 2 - r, [e, 100 * (0 === n ? 2 * l / (r + l) : 2 * i / (n + i)), (n + i) / 2 * 100]
                }, l.hsv.rgb = function (t) {
                    var e = t[0] / 60,
                        i = t[1] / 100,
                        n = t[2] / 100,
                        l = Math.floor(e) % 6,
                        r = e - Math.floor(e),
                        a = 255 * n * (1 - i),
                        o = 255 * n * (1 - i * r),
                        s = 255 * n * (1 - i * (1 - r));
                    switch (n *= 255, l) {
                        case 0:
                            return [n, s, a];
                        case 1:
                            return [o, n, a];
                        case 2:
                            return [a, n, s];
                        case 3:
                            return [a, o, n];
                        case 4:
                            return [s, a, n];
                        case 5:
                            return [n, a, o]
                    }
                }, l.hsv.hsl = function (t) {
                    var e, i, n, l = t[0],
                        r = t[1] / 100,
                        a = t[2] / 100,
                        o = Math.max(a, .01);
                    return n = (2 - r) * a, i = r * o, [l, 100 * (i = (i /= (e = (2 - r) * o) <= 1 ? e : 2 - e) || 0), 100 * (n /= 2)]
                }, l.hwb.rgb = function (t) {
                    var e, i, n, l, r, a, o, s = t[0] / 360,
                        c = t[1] / 100,
                        u = t[2] / 100,
                        h = c + u;
                    switch (h > 1 && (c /= h, u /= h), n = 6 * s - (e = Math.floor(6 * s)), 0 != (1 & e) && (n = 1 - n), l = c + n * ((i = 1 - u) - c), e) {
                        default:
                        case 6:
                        case 0:
                            r = i, a = l, o = c;
                            break;
                        case 1:
                            r = l, a = i, o = c;
                            break;
                        case 2:
                            r = c, a = i, o = l;
                            break;
                        case 3:
                            r = c, a = l, o = i;
                            break;
                        case 4:
                            r = l, a = c, o = i;
                            break;
                        case 5:
                            r = i, a = c, o = l
                    }
                    return [255 * r, 255 * a, 255 * o]
                }, l.cmyk.rgb = function (t) {
                    var e = t[0] / 100,
                        i = t[1] / 100,
                        n = t[2] / 100,
                        l = t[3] / 100;
                    return [255 * (1 - Math.min(1, e * (1 - l) + l)), 255 * (1 - Math.min(1, i * (1 - l) + l)), 255 * (1 - Math.min(1, n * (1 - l) + l))]
                }, l.xyz.rgb = function (t) {
                    var e, i, n, l = t[0] / 100,
                        r = t[1] / 100,
                        a = t[2] / 100;
                    return i = -.9689 * l + 1.8758 * r + .0415 * a, n = .0557 * l + -.204 * r + 1.057 * a, e = (e = 3.2406 * l + -1.5372 * r + -.4986 * a) > .0031308 ? 1.055 * Math.pow(e, 1 / 2.4) - .055 : 12.92 * e, i = i > .0031308 ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : 12.92 * i, n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, [255 * (e = Math.min(Math.max(0, e), 1)), 255 * (i = Math.min(Math.max(0, i), 1)), 255 * (n = Math.min(Math.max(0, n), 1))]
                }, l.xyz.lab = function (t) {
                    var e = t[0],
                        i = t[1],
                        n = t[2];
                    return i /= 100, n /= 108.883, e = (e /= 95.047) > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, [116 * (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116) - 16, 500 * (e - i), 200 * (i - (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116))]
                }, l.lab.xyz = function (t) {
                    var e, i, n, l = t[0];
                    e = t[1] / 500 + (i = (l + 16) / 116), n = i - t[2] / 200;
                    var r = Math.pow(i, 3),
                        a = Math.pow(e, 3),
                        o = Math.pow(n, 3);
                    return i = r > .008856 ? r : (i - 16 / 116) / 7.787, e = a > .008856 ? a : (e - 16 / 116) / 7.787, n = o > .008856 ? o : (n - 16 / 116) / 7.787, [e *= 95.047, i *= 100, n *= 108.883]
                }, l.lab.lch = function (t) {
                    var e, i = t[0],
                        n = t[1],
                        l = t[2];
                    return (e = 360 * Math.atan2(l, n) / 2 / Math.PI) < 0 && (e += 360), [i, Math.sqrt(n * n + l * l), e]
                }, l.lch.lab = function (t) {
                    var e, i = t[0],
                        n = t[1];
                    return e = t[2] / 360 * 2 * Math.PI, [i, n * Math.cos(e), n * Math.sin(e)]
                }, l.rgb.ansi16 = function (t) {
                    var e = t[0],
                        i = t[1],
                        n = t[2],
                        r = 1 in arguments ? arguments[1] : l.rgb.hsv(t)[2];
                    if (0 === (r = Math.round(r / 50))) return 30;
                    var a = 30 + (Math.round(n / 255) << 2 | Math.round(i / 255) << 1 | Math.round(e / 255));
                    return 2 === r && (a += 60), a
                }, l.hsv.ansi16 = function (t) {
                    return l.rgb.ansi16(l.hsv.rgb(t), t[2])
                }, l.rgb.ansi256 = function (t) {
                    var e = t[0],
                        i = t[1],
                        n = t[2];
                    return e === i && i === n ? e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(i / 255 * 5) + Math.round(n / 255 * 5)
                }, l.ansi16.rgb = function (t) {
                    var e = t % 10;
                    if (0 === e || 7 === e) return t > 50 && (e += 3.5), [e = e / 10.5 * 255, e, e];
                    var i = .5 * (1 + ~~(t > 50));
                    return [(1 & e) * i * 255, (e >> 1 & 1) * i * 255, (e >> 2 & 1) * i * 255]
                }, l.ansi256.rgb = function (t) {
                    if (t >= 232) {
                        var e = 10 * (t - 232) + 8;
                        return [e, e, e]
                    }
                    var i;
                    return t -= 16, [Math.floor(t / 36) / 5 * 255, Math.floor((i = t % 36) / 6) / 5 * 255, i % 6 / 5 * 255]
                }, l.rgb.hex = function (t) {
                    var e = (((255 & Math.round(t[0])) << 16) + ((255 & Math.round(t[1])) << 8) + (255 & Math.round(t[2]))).toString(16).toUpperCase();
                    return "000000".substring(e.length) + e
                }, l.hex.rgb = function (t) {
                    var e = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
                    if (!e) return [0, 0, 0];
                    var i = e[0];
                    3 === e[0].length && (i = i.split("").map((function (t) {
                        return t + t
                    })).join(""));
                    var n = parseInt(i, 16);
                    return [n >> 16 & 255, n >> 8 & 255, 255 & n]
                }, l.rgb.hcg = function (t) {
                    var e, i = t[0] / 255,
                        n = t[1] / 255,
                        l = t[2] / 255,
                        r = Math.max(Math.max(i, n), l),
                        a = Math.min(Math.min(i, n), l),
                        o = r - a;
                    return e = o <= 0 ? 0 : r === i ? (n - l) / o % 6 : r === n ? 2 + (l - i) / o : 4 + (i - n) / o + 4, e /= 6, [360 * (e %= 1), 100 * o, 100 * (o < 1 ? a / (1 - o) : 0)]
                }, l.hsl.hcg = function (t) {
                    var e = t[1] / 100,
                        i = t[2] / 100,
                        n = 1,
                        l = 0;
                    return (n = i < .5 ? 2 * e * i : 2 * e * (1 - i)) < 1 && (l = (i - .5 * n) / (1 - n)), [t[0], 100 * n, 100 * l]
                }, l.hsv.hcg = function (t) {
                    var e = t[1] / 100,
                        i = t[2] / 100,
                        n = e * i,
                        l = 0;
                    return n < 1 && (l = (i - n) / (1 - n)), [t[0], 100 * n, 100 * l]
                }, l.hcg.rgb = function (t) {
                    var e = t[0] / 360,
                        i = t[1] / 100,
                        n = t[2] / 100;
                    if (0 === i) return [255 * n, 255 * n, 255 * n];
                    var l = [0, 0, 0],
                        r = e % 1 * 6,
                        a = r % 1,
                        o = 1 - a,
                        s = 0;
                    switch (Math.floor(r)) {
                        case 0:
                            l[0] = 1, l[1] = a, l[2] = 0;
                            break;
                        case 1:
                            l[0] = o, l[1] = 1, l[2] = 0;
                            break;
                        case 2:
                            l[0] = 0, l[1] = 1, l[2] = a;
                            break;
                        case 3:
                            l[0] = 0, l[1] = o, l[2] = 1;
                            break;
                        case 4:
                            l[0] = a, l[1] = 0, l[2] = 1;
                            break;
                        default:
                            l[0] = 1, l[1] = 0, l[2] = o
                    }
                    return s = (1 - i) * n, [255 * (i * l[0] + s), 255 * (i * l[1] + s), 255 * (i * l[2] + s)]
                }, l.hcg.hsv = function (t) {
                    var e = t[1] / 100,
                        i = e + t[2] / 100 * (1 - e),
                        n = 0;
                    return i > 0 && (n = e / i), [t[0], 100 * n, 100 * i]
                }, l.hcg.hsl = function (t) {
                    var e = t[1] / 100,
                        i = t[2] / 100 * (1 - e) + .5 * e,
                        n = 0;
                    return i > 0 && i < .5 ? n = e / (2 * i) : i >= .5 && i < 1 && (n = e / (2 * (1 - i))), [t[0], 100 * n, 100 * i]
                }, l.hcg.hwb = function (t) {
                    var e = t[1] / 100,
                        i = e + t[2] / 100 * (1 - e);
                    return [t[0], 100 * (i - e), 100 * (1 - i)]
                }, l.hwb.hcg = function (t) {
                    var e = t[1] / 100,
                        i = 1 - t[2] / 100,
                        n = i - e,
                        l = 0;
                    return n < 1 && (l = (i - n) / (1 - n)), [t[0], 100 * n, 100 * l]
                }, l.apple.rgb = function (t) {
                    return [t[0] / 65535 * 255, t[1] / 65535 * 255, t[2] / 65535 * 255]
                }, l.rgb.apple = function (t) {
                    return [t[0] / 255 * 65535, t[1] / 255 * 65535, t[2] / 255 * 65535]
                }, l.gray.rgb = function (t) {
                    return [t[0] / 100 * 255, t[0] / 100 * 255, t[0] / 100 * 255]
                }, l.gray.hsl = l.gray.hsv = function (t) {
                    return [0, 0, t[0]]
                }, l.gray.hwb = function (t) {
                    return [0, 100, t[0]]
                }, l.gray.cmyk = function (t) {
                    return [0, 0, 0, t[0]]
                }, l.gray.lab = function (t) {
                    return [t[0], 0, 0]
                }, l.gray.hex = function (t) {
                    var e = 255 & Math.round(t[0] / 100 * 255),
                        i = ((e << 16) + (e << 8) + e).toString(16).toUpperCase();
                    return "000000".substring(i.length) + i
                }, l.rgb.gray = function (t) {
                    return [(t[0] + t[1] + t[2]) / 3 / 255 * 100]
                }
            }));

        function r() {
            for (var t = {}, e = Object.keys(l), i = e.length, n = 0; n < i; n++) t[e[n]] = {
                distance: -1,
                parent: null
            };
            return t
        }

        function a(t) {
            var e = r(),
                i = [t];
            for (e[t].distance = 0; i.length;)
                for (var n = i.pop(), a = Object.keys(l[n]), o = a.length, s = 0; s < o; s++) {
                    var c = a[s],
                        u = e[c]; - 1 === u.distance && (u.distance = e[n].distance + 1, u.parent = n, i.unshift(c))
                }
            return e
        }

        function o(t, e) {
            return function (i) {
                return e(t(i))
            }
        }

        function s(t, e) {
            for (var i = [e[t].parent, t], n = l[e[t].parent][t], r = e[t].parent; e[r].parent;) i.unshift(e[r].parent), n = o(l[e[r].parent][r], n), r = e[r].parent;
            return n.conversion = i, n
        }
        l.rgb, l.hsl, l.hsv, l.hwb, l.cmyk, l.xyz, l.lab, l.lch, l.hex, l.keyword, l.ansi16, l.ansi256, l.hcg, l.apple, l.gray;
        var c = function (t) {
                for (var e = a(t), i = {}, n = Object.keys(e), l = n.length, r = 0; r < l; r++) {
                    var o = n[r];
                    null !== e[o].parent && (i[o] = s(o, e))
                }
                return i
            },
            u = {};

        function h(t) {
            var e = function (e) {
                return null == e ? e : (arguments.length > 1 && (e = Array.prototype.slice.call(arguments)), t(e))
            };
            return "conversion" in t && (e.conversion = t.conversion), e
        }

        function d(t) {
            var e = function (e) {
                if (null == e) return e;
                arguments.length > 1 && (e = Array.prototype.slice.call(arguments));
                var i = t(e);
                if ("object" == typeof i)
                    for (var n = i.length, l = 0; l < n; l++) i[l] = Math.round(i[l]);
                return i
            };
            return "conversion" in t && (e.conversion = t.conversion), e
        }
        Object.keys(l).forEach((function (t) {
            u[t] = {}, Object.defineProperty(u[t], "channels", {
                value: l[t].channels
            }), Object.defineProperty(u[t], "labels", {
                value: l[t].labels
            });
            var e = c(t);
            Object.keys(e).forEach((function (i) {
                var n = e[i];
                u[t][i] = d(n), u[t][i].raw = h(n)
            }))
        }));
        var f = u,
            p = {
                aliceblue: [240, 248, 255],
                antiquewhite: [250, 235, 215],
                aqua: [0, 255, 255],
                aquamarine: [127, 255, 212],
                azure: [240, 255, 255],
                beige: [245, 245, 220],
                bisque: [255, 228, 196],
                black: [0, 0, 0],
                blanchedalmond: [255, 235, 205],
                blue: [0, 0, 255],
                blueviolet: [138, 43, 226],
                brown: [165, 42, 42],
                burlywood: [222, 184, 135],
                cadetblue: [95, 158, 160],
                chartreuse: [127, 255, 0],
                chocolate: [210, 105, 30],
                coral: [255, 127, 80],
                cornflowerblue: [100, 149, 237],
                cornsilk: [255, 248, 220],
                crimson: [220, 20, 60],
                cyan: [0, 255, 255],
                darkblue: [0, 0, 139],
                darkcyan: [0, 139, 139],
                darkgoldenrod: [184, 134, 11],
                darkgray: [169, 169, 169],
                darkgreen: [0, 100, 0],
                darkgrey: [169, 169, 169],
                darkkhaki: [189, 183, 107],
                darkmagenta: [139, 0, 139],
                darkolivegreen: [85, 107, 47],
                darkorange: [255, 140, 0],
                darkorchid: [153, 50, 204],
                darkred: [139, 0, 0],
                darksalmon: [233, 150, 122],
                darkseagreen: [143, 188, 143],
                darkslateblue: [72, 61, 139],
                darkslategray: [47, 79, 79],
                darkslategrey: [47, 79, 79],
                darkturquoise: [0, 206, 209],
                darkviolet: [148, 0, 211],
                deeppink: [255, 20, 147],
                deepskyblue: [0, 191, 255],
                dimgray: [105, 105, 105],
                dimgrey: [105, 105, 105],
                dodgerblue: [30, 144, 255],
                firebrick: [178, 34, 34],
                floralwhite: [255, 250, 240],
                forestgreen: [34, 139, 34],
                fuchsia: [255, 0, 255],
                gainsboro: [220, 220, 220],
                ghostwhite: [248, 248, 255],
                gold: [255, 215, 0],
                goldenrod: [218, 165, 32],
                gray: [128, 128, 128],
                green: [0, 128, 0],
                greenyellow: [173, 255, 47],
                grey: [128, 128, 128],
                honeydew: [240, 255, 240],
                hotpink: [255, 105, 180],
                indianred: [205, 92, 92],
                indigo: [75, 0, 130],
                ivory: [255, 255, 240],
                khaki: [240, 230, 140],
                lavender: [230, 230, 250],
                lavenderblush: [255, 240, 245],
                lawngreen: [124, 252, 0],
                lemonchiffon: [255, 250, 205],
                lightblue: [173, 216, 230],
                lightcoral: [240, 128, 128],
                lightcyan: [224, 255, 255],
                lightgoldenrodyellow: [250, 250, 210],
                lightgray: [211, 211, 211],
                lightgreen: [144, 238, 144],
                lightgrey: [211, 211, 211],
                lightpink: [255, 182, 193],
                lightsalmon: [255, 160, 122],
                lightseagreen: [32, 178, 170],
                lightskyblue: [135, 206, 250],
                lightslategray: [119, 136, 153],
                lightslategrey: [119, 136, 153],
                lightsteelblue: [176, 196, 222],
                lightyellow: [255, 255, 224],
                lime: [0, 255, 0],
                limegreen: [50, 205, 50],
                linen: [250, 240, 230],
                magenta: [255, 0, 255],
                maroon: [128, 0, 0],
                mediumaquamarine: [102, 205, 170],
                mediumblue: [0, 0, 205],
                mediumorchid: [186, 85, 211],
                mediumpurple: [147, 112, 219],
                mediumseagreen: [60, 179, 113],
                mediumslateblue: [123, 104, 238],
                mediumspringgreen: [0, 250, 154],
                mediumturquoise: [72, 209, 204],
                mediumvioletred: [199, 21, 133],
                midnightblue: [25, 25, 112],
                mintcream: [245, 255, 250],
                mistyrose: [255, 228, 225],
                moccasin: [255, 228, 181],
                navajowhite: [255, 222, 173],
                navy: [0, 0, 128],
                oldlace: [253, 245, 230],
                olive: [128, 128, 0],
                olivedrab: [107, 142, 35],
                orange: [255, 165, 0],
                orangered: [255, 69, 0],
                orchid: [218, 112, 214],
                palegoldenrod: [238, 232, 170],
                palegreen: [152, 251, 152],
                paleturquoise: [175, 238, 238],
                palevioletred: [219, 112, 147],
                papayawhip: [255, 239, 213],
                peachpuff: [255, 218, 185],
                peru: [205, 133, 63],
                pink: [255, 192, 203],
                plum: [221, 160, 221],
                powderblue: [176, 224, 230],
                purple: [128, 0, 128],
                rebeccapurple: [102, 51, 153],
                red: [255, 0, 0],
                rosybrown: [188, 143, 143],
                royalblue: [65, 105, 225],
                saddlebrown: [139, 69, 19],
                salmon: [250, 128, 114],
                sandybrown: [244, 164, 96],
                seagreen: [46, 139, 87],
                seashell: [255, 245, 238],
                sienna: [160, 82, 45],
                silver: [192, 192, 192],
                skyblue: [135, 206, 235],
                slateblue: [106, 90, 205],
                slategray: [112, 128, 144],
                slategrey: [112, 128, 144],
                snow: [255, 250, 250],
                springgreen: [0, 255, 127],
                steelblue: [70, 130, 180],
                tan: [210, 180, 140],
                teal: [0, 128, 128],
                thistle: [216, 191, 216],
                tomato: [255, 99, 71],
                turquoise: [64, 224, 208],
                violet: [238, 130, 238],
                wheat: [245, 222, 179],
                white: [255, 255, 255],
                whitesmoke: [245, 245, 245],
                yellow: [255, 255, 0],
                yellowgreen: [154, 205, 50]
            },
            g = {
                getRgba: m,
                getHsla: v,
                getRgb: b,
                getHsl: x,
                getHwb: y,
                getAlpha: w,
                hexString: _,
                rgbString: k,
                rgbaString: S,
                percentString: A,
                percentaString: M,
                hslString: C,
                hslaString: E,
                hwbString: O,
                keyword: T
            };

        function m(t) {
            if (t) {
                var e = /^#([a-fA-F0-9]{3,4})$/i,
                    i = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
                    n = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
                    l = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
                    r = /(\w+)/,
                    a = [0, 0, 0],
                    o = 1,
                    s = t.match(e),
                    c = "";
                if (s) {
                    c = (s = s[1])[3];
                    for (var u = 0; u < a.length; u++) a[u] = parseInt(s[u] + s[u], 16);
                    c && (o = Math.round(parseInt(c + c, 16) / 255 * 100) / 100)
                } else if (s = t.match(i)) {
                    for (c = s[2], s = s[1], u = 0; u < a.length; u++) a[u] = parseInt(s.slice(2 * u, 2 * u + 2), 16);
                    c && (o = Math.round(parseInt(c, 16) / 255 * 100) / 100)
                } else if (s = t.match(n)) {
                    for (u = 0; u < a.length; u++) a[u] = parseInt(s[u + 1]);
                    o = parseFloat(s[4])
                } else if (s = t.match(l)) {
                    for (u = 0; u < a.length; u++) a[u] = Math.round(2.55 * parseFloat(s[u + 1]));
                    o = parseFloat(s[4])
                } else if (s = t.match(r)) {
                    if ("transparent" == s[1]) return [0, 0, 0, 0];
                    if (!(a = p[s[1]])) return
                }
                for (u = 0; u < a.length; u++) a[u] = P(a[u], 0, 255);
                return o = o || 0 == o ? P(o, 0, 1) : 1, a[3] = o, a
            }
        }

        function v(t) {
            if (t) {
                var e = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,
                    i = t.match(e);
                if (i) {
                    var n = parseFloat(i[4]);
                    return [P(parseInt(i[1]), 0, 360), P(parseFloat(i[2]), 0, 100), P(parseFloat(i[3]), 0, 100), P(isNaN(n) ? 1 : n, 0, 1)]
                }
            }
        }

        function y(t) {
            if (t) {
                var e = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,
                    i = t.match(e);
                if (i) {
                    var n = parseFloat(i[4]);
                    return [P(parseInt(i[1]), 0, 360), P(parseFloat(i[2]), 0, 100), P(parseFloat(i[3]), 0, 100), P(isNaN(n) ? 1 : n, 0, 1)]
                }
            }
        }

        function b(t) {
            var e = m(t);
            return e && e.slice(0, 3)
        }

        function x(t) {
            var e = v(t);
            return e && e.slice(0, 3)
        }

        function w(t) {
            var e = m(t);
            return e || (e = v(t)) || (e = y(t)) ? e[3] : void 0
        }

        function _(t, e) {
            return e = void 0 !== e && 3 === t.length ? e : t[3], "#" + L(t[0]) + L(t[1]) + L(t[2]) + (e >= 0 && e < 1 ? L(Math.round(255 * e)) : "")
        }

        function k(t, e) {
            return e < 1 || t[3] && t[3] < 1 ? S(t, e) : "rgb(" + t[0] + ", " + t[1] + ", " + t[2] + ")"
        }

        function S(t, e) {
            return void 0 === e && (e = void 0 !== t[3] ? t[3] : 1), "rgba(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + e + ")"
        }

        function A(t, e) {
            return e < 1 || t[3] && t[3] < 1 ? M(t, e) : "rgb(" + Math.round(t[0] / 255 * 100) + "%, " + Math.round(t[1] / 255 * 100) + "%, " + Math.round(t[2] / 255 * 100) + "%)"
        }

        function M(t, e) {
            return "rgba(" + Math.round(t[0] / 255 * 100) + "%, " + Math.round(t[1] / 255 * 100) + "%, " + Math.round(t[2] / 255 * 100) + "%, " + (e || t[3] || 1) + ")"
        }

        function C(t, e) {
            return e < 1 || t[3] && t[3] < 1 ? E(t, e) : "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)"
        }

        function E(t, e) {
            return void 0 === e && (e = void 0 !== t[3] ? t[3] : 1), "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + e + ")"
        }

        function O(t, e) {
            return void 0 === e && (e = void 0 !== t[3] ? t[3] : 1), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + (void 0 !== e && 1 !== e ? ", " + e : "") + ")"
        }

        function T(t) {
            return D[t.slice(0, 3)]
        }

        function P(t, e, i) {
            return Math.min(Math.max(e, t), i)
        }

        function L(t) {
            var e = t.toString(16).toUpperCase();
            return e.length < 2 ? "0" + e : e
        }
        var D = {};
        for (var I in p) D[p[I]] = I;
        var j = function (t) {
            return t instanceof j ? t : this instanceof j ? (this.valid = !1, this.values = {
                rgb: [0, 0, 0],
                hsl: [0, 0, 0],
                hsv: [0, 0, 0],
                hwb: [0, 0, 0],
                cmyk: [0, 0, 0, 0],
                alpha: 1
            }, void("string" == typeof t ? (e = g.getRgba(t)) ? this.setValues("rgb", e) : (e = g.getHsla(t)) ? this.setValues("hsl", e) : (e = g.getHwb(t)) && this.setValues("hwb", e) : "object" == typeof t && (void 0 !== (e = t).r || void 0 !== e.red ? this.setValues("rgb", e) : void 0 !== e.l || void 0 !== e.lightness ? this.setValues("hsl", e) : void 0 !== e.v || void 0 !== e.value ? this.setValues("hsv", e) : void 0 !== e.w || void 0 !== e.whiteness ? this.setValues("hwb", e) : void 0 === e.c && void 0 === e.cyan || this.setValues("cmyk", e)))) : new j(t);
            var e
        };
        j.prototype = {
            isValid: function () {
                return this.valid
            },
            rgb: function () {
                return this.setSpace("rgb", arguments)
            },
            hsl: function () {
                return this.setSpace("hsl", arguments)
            },
            hsv: function () {
                return this.setSpace("hsv", arguments)
            },
            hwb: function () {
                return this.setSpace("hwb", arguments)
            },
            cmyk: function () {
                return this.setSpace("cmyk", arguments)
            },
            rgbArray: function () {
                return this.values.rgb
            },
            hslArray: function () {
                return this.values.hsl
            },
            hsvArray: function () {
                return this.values.hsv
            },
            hwbArray: function () {
                var t = this.values;
                return 1 !== t.alpha ? t.hwb.concat([t.alpha]) : t.hwb
            },
            cmykArray: function () {
                return this.values.cmyk
            },
            rgbaArray: function () {
                var t = this.values;
                return t.rgb.concat([t.alpha])
            },
            hslaArray: function () {
                var t = this.values;
                return t.hsl.concat([t.alpha])
            },
            alpha: function (t) {
                return void 0 === t ? this.values.alpha : (this.setValues("alpha", t), this)
            },
            red: function (t) {
                return this.setChannel("rgb", 0, t)
            },
            green: function (t) {
                return this.setChannel("rgb", 1, t)
            },
            blue: function (t) {
                return this.setChannel("rgb", 2, t)
            },
            hue: function (t) {
                return t && (t = (t %= 360) < 0 ? 360 + t : t), this.setChannel("hsl", 0, t)
            },
            saturation: function (t) {
                return this.setChannel("hsl", 1, t)
            },
            lightness: function (t) {
                return this.setChannel("hsl", 2, t)
            },
            saturationv: function (t) {
                return this.setChannel("hsv", 1, t)
            },
            whiteness: function (t) {
                return this.setChannel("hwb", 1, t)
            },
            blackness: function (t) {
                return this.setChannel("hwb", 2, t)
            },
            value: function (t) {
                return this.setChannel("hsv", 2, t)
            },
            cyan: function (t) {
                return this.setChannel("cmyk", 0, t)
            },
            magenta: function (t) {
                return this.setChannel("cmyk", 1, t)
            },
            yellow: function (t) {
                return this.setChannel("cmyk", 2, t)
            },
            black: function (t) {
                return this.setChannel("cmyk", 3, t)
            },
            hexString: function () {
                return g.hexString(this.values.rgb)
            },
            rgbString: function () {
                return g.rgbString(this.values.rgb, this.values.alpha)
            },
            rgbaString: function () {
                return g.rgbaString(this.values.rgb, this.values.alpha)
            },
            percentString: function () {
                return g.percentString(this.values.rgb, this.values.alpha)
            },
            hslString: function () {
                return g.hslString(this.values.hsl, this.values.alpha)
            },
            hslaString: function () {
                return g.hslaString(this.values.hsl, this.values.alpha)
            },
            hwbString: function () {
                return g.hwbString(this.values.hwb, this.values.alpha)
            },
            keyword: function () {
                return g.keyword(this.values.rgb, this.values.alpha)
            },
            rgbNumber: function () {
                var t = this.values.rgb;
                return t[0] << 16 | t[1] << 8 | t[2]
            },
            luminosity: function () {
                for (var t = this.values.rgb, e = [], i = 0; i < t.length; i++) {
                    var n = t[i] / 255;
                    e[i] = n <= .03928 ? n / 12.92 : Math.pow((n + .055) / 1.055, 2.4)
                }
                return .2126 * e[0] + .7152 * e[1] + .0722 * e[2]
            },
            contrast: function (t) {
                var e = this.luminosity(),
                    i = t.luminosity();
                return e > i ? (e + .05) / (i + .05) : (i + .05) / (e + .05)
            },
            level: function (t) {
                var e = this.contrast(t);
                return e >= 7.1 ? "AAA" : e >= 4.5 ? "AA" : ""
            },
            dark: function () {
                var t = this.values.rgb;
                return (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3 < 128
            },
            light: function () {
                return !this.dark()
            },
            negate: function () {
                for (var t = [], e = 0; e < 3; e++) t[e] = 255 - this.values.rgb[e];
                return this.setValues("rgb", t), this
            },
            lighten: function (t) {
                var e = this.values.hsl;
                return e[2] += e[2] * t, this.setValues("hsl", e), this
            },
            darken: function (t) {
                var e = this.values.hsl;
                return e[2] -= e[2] * t, this.setValues("hsl", e), this
            },
            saturate: function (t) {
                var e = this.values.hsl;
                return e[1] += e[1] * t, this.setValues("hsl", e), this
            },
            desaturate: function (t) {
                var e = this.values.hsl;
                return e[1] -= e[1] * t, this.setValues("hsl", e), this
            },
            whiten: function (t) {
                var e = this.values.hwb;
                return e[1] += e[1] * t, this.setValues("hwb", e), this
            },
            blacken: function (t) {
                var e = this.values.hwb;
                return e[2] += e[2] * t, this.setValues("hwb", e), this
            },
            greyscale: function () {
                var t = this.values.rgb,
                    e = .3 * t[0] + .59 * t[1] + .11 * t[2];
                return this.setValues("rgb", [e, e, e]), this
            },
            clearer: function (t) {
                var e = this.values.alpha;
                return this.setValues("alpha", e - e * t), this
            },
            opaquer: function (t) {
                var e = this.values.alpha;
                return this.setValues("alpha", e + e * t), this
            },
            rotate: function (t) {
                var e = this.values.hsl,
                    i = (e[0] + t) % 360;
                return e[0] = i < 0 ? 360 + i : i, this.setValues("hsl", e), this
            },
            mix: function (t, e) {
                var i = this,
                    n = t,
                    l = void 0 === e ? .5 : e,
                    r = 2 * l - 1,
                    a = i.alpha() - n.alpha(),
                    o = ((r * a == -1 ? r : (r + a) / (1 + r * a)) + 1) / 2,
                    s = 1 - o;
                return this.rgb(o * i.red() + s * n.red(), o * i.green() + s * n.green(), o * i.blue() + s * n.blue()).alpha(i.alpha() * l + n.alpha() * (1 - l))
            },
            toJSON: function () {
                return this.rgb()
            },
            clone: function () {
                var t, e, i = new j,
                    n = this.values,
                    l = i.values;
                for (var r in n) n.hasOwnProperty(r) && (t = n[r], "[object Array]" === (e = {}.toString.call(t)) ? l[r] = t.slice(0) : "[object Number]" === e ? l[r] = t : console.error("unexpected color value:", t));
                return i
            }
        }, j.prototype.spaces = {
            rgb: ["red", "green", "blue"],
            hsl: ["hue", "saturation", "lightness"],
            hsv: ["hue", "saturation", "value"],
            hwb: ["hue", "whiteness", "blackness"],
            cmyk: ["cyan", "magenta", "yellow", "black"]
        }, j.prototype.maxes = {
            rgb: [255, 255, 255],
            hsl: [360, 100, 100],
            hsv: [360, 100, 100],
            hwb: [360, 100, 100],
            cmyk: [100, 100, 100, 100]
        }, j.prototype.getValues = function (t) {
            for (var e = this.values, i = {}, n = 0; n < t.length; n++) i[t.charAt(n)] = e[t][n];
            return 1 !== e.alpha && (i.a = e.alpha), i
        }, j.prototype.setValues = function (t, e) {
            var i, n, l = this.values,
                r = this.spaces,
                a = this.maxes,
                o = 1;
            if (this.valid = !0, "alpha" === t) o = e;
            else if (e.length) l[t] = e.slice(0, t.length), o = e[t.length];
            else if (void 0 !== e[t.charAt(0)]) {
                for (i = 0; i < t.length; i++) l[t][i] = e[t.charAt(i)];
                o = e.a
            } else if (void 0 !== e[r[t][0]]) {
                var s = r[t];
                for (i = 0; i < t.length; i++) l[t][i] = e[s[i]];
                o = e.alpha
            }
            if (l.alpha = Math.max(0, Math.min(1, void 0 === o ? l.alpha : o)), "alpha" === t) return !1;
            for (i = 0; i < t.length; i++) n = Math.max(0, Math.min(a[t][i], l[t][i])), l[t][i] = Math.round(n);
            for (var c in r) c !== t && (l[c] = f[t][c](l[t]));
            return !0
        }, j.prototype.setSpace = function (t, e) {
            var i = e[0];
            return void 0 === i ? this.getValues(t) : ("number" == typeof i && (i = Array.prototype.slice.call(e)), this.setValues(t, i), this)
        }, j.prototype.setChannel = function (t, e, i) {
            var n = this.values[t];
            return void 0 === i ? n[e] : (i === n[e] || (n[e] = i, this.setValues(t, n)), this)
        }, "undefined" != typeof window && (window.Color = j);
        var N = j;

        function R(t) {
            return -1 === ["__proto__", "prototype", "constructor"].indexOf(t)
        }
        var F, z = {
                noop: function () {},
                uid: (F = 0, function () {
                    return F++
                }),
                isNullOrUndef: function (t) {
                    return null == t
                },
                isArray: function (t) {
                    if (Array.isArray && Array.isArray(t)) return !0;
                    var e = Object.prototype.toString.call(t);
                    return "[object" === e.substr(0, 7) && "Array]" === e.substr(-6)
                },
                isObject: function (t) {
                    return null !== t && "[object Object]" === Object.prototype.toString.call(t)
                },
                isFinite: function (t) {
                    return ("number" == typeof t || t instanceof Number) && isFinite(t)
                },
                valueOrDefault: function (t, e) {
                    return void 0 === t ? e : t
                },
                valueAtIndexOrDefault: function (t, e, i) {
                    return z.valueOrDefault(z.isArray(t) ? t[e] : t, i)
                },
                callback: function (t, e, i) {
                    if (t && "function" == typeof t.call) return t.apply(i, e)
                },
                each: function (t, e, i, n) {
                    var l, r, a;
                    if (z.isArray(t))
                        if (r = t.length, n)
                            for (l = r - 1; l >= 0; l--) e.call(i, t[l], l);
                        else
                            for (l = 0; l < r; l++) e.call(i, t[l], l);
                    else if (z.isObject(t))
                        for (r = (a = Object.keys(t)).length, l = 0; l < r; l++) e.call(i, t[a[l]], a[l])
                },
                arrayEquals: function (t, e) {
                    var i, n, l, r;
                    if (!t || !e || t.length !== e.length) return !1;
                    for (i = 0, n = t.length; i < n; ++i)
                        if (l = t[i], r = e[i], l instanceof Array && r instanceof Array) {
                            if (!z.arrayEquals(l, r)) return !1
                        } else if (l !== r) return !1;
                    return !0
                },
                clone: function (t) {
                    if (z.isArray(t)) return t.map(z.clone);
                    if (z.isObject(t)) {
                        for (var e = Object.create(t), i = Object.keys(t), n = i.length, l = 0; l < n; ++l) e[i[l]] = z.clone(t[i[l]]);
                        return e
                    }
                    return t
                },
                _merger: function (t, e, i, n) {
                    if (R(t)) {
                        var l = e[t],
                            r = i[t];
                        z.isObject(l) && z.isObject(r) ? z.merge(l, r, n) : e[t] = z.clone(r)
                    }
                },
                _mergerIf: function (t, e, i) {
                    if (R(t)) {
                        var n = e[t],
                            l = i[t];
                        z.isObject(n) && z.isObject(l) ? z.mergeIf(n, l) : e.hasOwnProperty(t) || (e[t] = z.clone(l))
                    }
                },
                merge: function (t, e, i) {
                    var n, l, r, a, o, s = z.isArray(e) ? e : [e],
                        c = s.length;
                    if (!z.isObject(t)) return t;
                    for (n = (i = i || {}).merger || z._merger, l = 0; l < c; ++l)
                        if (e = s[l], z.isObject(e))
                            for (o = 0, a = (r = Object.keys(e)).length; o < a; ++o) n(r[o], t, e, i);
                    return t
                },
                mergeIf: function (t, e) {
                    return z.merge(t, e, {
                        merger: z._mergerIf
                    })
                },
                extend: Object.assign || function (t) {
                    return z.merge(t, [].slice.call(arguments, 1), {
                        merger: function (t, e, i) {
                            e[t] = i[t]
                        }
                    })
                },
                inherits: function (t) {
                    var e = this,
                        i = t && t.hasOwnProperty("constructor") ? t.constructor : function () {
                            return e.apply(this, arguments)
                        },
                        n = function () {
                            this.constructor = i
                        };
                    return n.prototype = e.prototype, i.prototype = new n, i.extend = z.inherits, t && z.extend(i.prototype, t), i.__super__ = e.prototype, i
                },
                _deprecated: function (t, e, i, n) {
                    void 0 !== e && console.warn(t + ': "' + i + '" is deprecated. Please use "' + n + '" instead')
                }
            },
            H = z;
        z.callCallback = z.callback, z.indexOf = function (t, e, i) {
            return Array.prototype.indexOf.call(t, e, i)
        }, z.getValueOrDefault = z.valueOrDefault, z.getValueAtIndexOrDefault = z.valueAtIndexOrDefault;
        var B = {
                linear: function (t) {
                    return t
                },
                easeInQuad: function (t) {
                    return t * t
                },
                easeOutQuad: function (t) {
                    return -t * (t - 2)
                },
                easeInOutQuad: function (t) {
                    return (t /= .5) < 1 ? .5 * t * t : -.5 * (--t * (t - 2) - 1)
                },
                easeInCubic: function (t) {
                    return t * t * t
                },
                easeOutCubic: function (t) {
                    return (t -= 1) * t * t + 1
                },
                easeInOutCubic: function (t) {
                    return (t /= .5) < 1 ? .5 * t * t * t : .5 * ((t -= 2) * t * t + 2)
                },
                easeInQuart: function (t) {
                    return t * t * t * t
                },
                easeOutQuart: function (t) {
                    return -((t -= 1) * t * t * t - 1)
                },
                easeInOutQuart: function (t) {
                    return (t /= .5) < 1 ? .5 * t * t * t * t : -.5 * ((t -= 2) * t * t * t - 2)
                },
                easeInQuint: function (t) {
                    return t * t * t * t * t
                },
                easeOutQuint: function (t) {
                    return (t -= 1) * t * t * t * t + 1
                },
                easeInOutQuint: function (t) {
                    return (t /= .5) < 1 ? .5 * t * t * t * t * t : .5 * ((t -= 2) * t * t * t * t + 2)
                },
                easeInSine: function (t) {
                    return 1 - Math.cos(t * (Math.PI / 2))
                },
                easeOutSine: function (t) {
                    return Math.sin(t * (Math.PI / 2))
                },
                easeInOutSine: function (t) {
                    return -.5 * (Math.cos(Math.PI * t) - 1)
                },
                easeInExpo: function (t) {
                    return 0 === t ? 0 : Math.pow(2, 10 * (t - 1))
                },
                easeOutExpo: function (t) {
                    return 1 === t ? 1 : 1 - Math.pow(2, -10 * t)
                },
                easeInOutExpo: function (t) {
                    return 0 === t ? 0 : 1 === t ? 1 : (t /= .5) < 1 ? .5 * Math.pow(2, 10 * (t - 1)) : .5 * (2 - Math.pow(2, -10 * --t))
                },
                easeInCirc: function (t) {
                    return t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1)
                },
                easeOutCirc: function (t) {
                    return Math.sqrt(1 - (t -= 1) * t)
                },
                easeInOutCirc: function (t) {
                    return (t /= .5) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1)
                },
                easeInElastic: function (t) {
                    var e = 1.70158,
                        i = 0,
                        n = 1;
                    return 0 === t ? 0 : 1 === t ? 1 : (i || (i = .3), n < 1 ? (n = 1, e = i / 4) : e = i / (2 * Math.PI) * Math.asin(1 / n), -n * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / i))
                },
                easeOutElastic: function (t) {
                    var e = 1.70158,
                        i = 0,
                        n = 1;
                    return 0 === t ? 0 : 1 === t ? 1 : (i || (i = .3), n < 1 ? (n = 1, e = i / 4) : e = i / (2 * Math.PI) * Math.asin(1 / n), n * Math.pow(2, -10 * t) * Math.sin((t - e) * (2 * Math.PI) / i) + 1)
                },
                easeInOutElastic: function (t) {
                    var e = 1.70158,
                        i = 0,
                        n = 1;
                    return 0 === t ? 0 : 2 == (t /= .5) ? 1 : (i || (i = .45), n < 1 ? (n = 1, e = i / 4) : e = i / (2 * Math.PI) * Math.asin(1 / n), t < 1 ? n * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / i) * -.5 : n * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / i) * .5 + 1)
                },
                easeInBack: function (t) {
                    var e = 1.70158;
                    return t * t * ((e + 1) * t - e)
                },
                easeOutBack: function (t) {
                    var e = 1.70158;
                    return (t -= 1) * t * ((e + 1) * t + e) + 1
                },
                easeInOutBack: function (t) {
                    var e = 1.70158;
                    return (t /= .5) < 1 ? t * t * ((1 + (e *= 1.525)) * t - e) * .5 : .5 * ((t -= 2) * t * ((1 + (e *= 1.525)) * t + e) + 2)
                },
                easeInBounce: function (t) {
                    return 1 - B.easeOutBounce(1 - t)
                },
                easeOutBounce: function (t) {
                    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375
                },
                easeInOutBounce: function (t) {
                    return t < .5 ? .5 * B.easeInBounce(2 * t) : .5 * B.easeOutBounce(2 * t - 1) + .5
                }
            },
            Y = {
                effects: B
            };
        H.easingEffects = B;
        var W = Math.PI,
            V = W / 180,
            X = 2 * W,
            q = W / 2,
            Z = W / 4,
            G = 2 * W / 3,
            U = {
                clear: function (t) {
                    t.ctx.clearRect(0, 0, t.width, t.height)
                },
                roundedRect: function (t, e, i, n, l, r) {
                    if (r) {
                        var a = Math.min(r, l / 2, n / 2),
                            o = e + a,
                            s = i + a,
                            c = e + n - a,
                            u = i + l - a;
                        t.moveTo(e, s), o < c && s < u ? (t.arc(o, s, a, -W, -q), t.arc(c, s, a, -q, 0), t.arc(c, u, a, 0, q), t.arc(o, u, a, q, W)) : o < c ? (t.moveTo(o, i), t.arc(c, s, a, -q, q), t.arc(o, s, a, q, W + q)) : s < u ? (t.arc(o, s, a, -W, 0), t.arc(o, u, a, 0, W)) : t.arc(o, s, a, -W, W), t.closePath(), t.moveTo(e, i)
                    } else t.rect(e, i, n, l)
                },
                drawPoint: function (t, e, i, n, l, r) {
                    var a, o, s, c, u, h = (r || 0) * V;
                    if (e && "object" == typeof e && ("[object HTMLImageElement]" === (a = e.toString()) || "[object HTMLCanvasElement]" === a)) return t.save(), t.translate(n, l), t.rotate(h), t.drawImage(e, -e.width / 2, -e.height / 2, e.width, e.height), void t.restore();
                    if (!(isNaN(i) || i <= 0)) {
                        switch (t.beginPath(), e) {
                            default:
                                t.arc(n, l, i, 0, X), t.closePath();
                                break;
                            case "triangle":
                                t.moveTo(n + Math.sin(h) * i, l - Math.cos(h) * i), h += G, t.lineTo(n + Math.sin(h) * i, l - Math.cos(h) * i), h += G, t.lineTo(n + Math.sin(h) * i, l - Math.cos(h) * i), t.closePath();
                                break;
                            case "rectRounded":
                                c = i - (u = .516 * i), o = Math.cos(h + Z) * c, s = Math.sin(h + Z) * c, t.arc(n - o, l - s, u, h - W, h - q), t.arc(n + s, l - o, u, h - q, h), t.arc(n + o, l + s, u, h, h + q), t.arc(n - s, l + o, u, h + q, h + W), t.closePath();
                                break;
                            case "rect":
                                if (!r) {
                                    c = Math.SQRT1_2 * i, t.rect(n - c, l - c, 2 * c, 2 * c);
                                    break
                                }
                                h += Z;
                            case "rectRot":
                                o = Math.cos(h) * i, s = Math.sin(h) * i, t.moveTo(n - o, l - s), t.lineTo(n + s, l - o), t.lineTo(n + o, l + s), t.lineTo(n - s, l + o), t.closePath();
                                break;
                            case "crossRot":
                                h += Z;
                            case "cross":
                                o = Math.cos(h) * i, s = Math.sin(h) * i, t.moveTo(n - o, l - s), t.lineTo(n + o, l + s), t.moveTo(n + s, l - o), t.lineTo(n - s, l + o);
                                break;
                            case "star":
                                o = Math.cos(h) * i, s = Math.sin(h) * i, t.moveTo(n - o, l - s), t.lineTo(n + o, l + s), t.moveTo(n + s, l - o), t.lineTo(n - s, l + o), h += Z, o = Math.cos(h) * i, s = Math.sin(h) * i, t.moveTo(n - o, l - s), t.lineTo(n + o, l + s), t.moveTo(n + s, l - o), t.lineTo(n - s, l + o);
                                break;
                            case "line":
                                o = Math.cos(h) * i, s = Math.sin(h) * i, t.moveTo(n - o, l - s), t.lineTo(n + o, l + s);
                                break;
                            case "dash":
                                t.moveTo(n, l), t.lineTo(n + Math.cos(h) * i, l + Math.sin(h) * i)
                        }
                        t.fill(), t.stroke()
                    }
                },
                _isPointInArea: function (t, e) {
                    var i = 1e-6;
                    return t.x > e.left - i && t.x < e.right + i && t.y > e.top - i && t.y < e.bottom + i
                },
                clipArea: function (t, e) {
                    t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip()
                },
                unclipArea: function (t) {
                    t.restore()
                },
                lineTo: function (t, e, i, n) {
                    var l = i.steppedLine;
                    if (l) {
                        if ("middle" === l) {
                            var r = (e.x + i.x) / 2;
                            t.lineTo(r, n ? i.y : e.y), t.lineTo(r, n ? e.y : i.y)
                        } else "after" === l && !n || "after" !== l && n ? t.lineTo(e.x, i.y) : t.lineTo(i.x, e.y);
                        t.lineTo(i.x, i.y)
                    } else i.tension ? t.bezierCurveTo(n ? e.controlPointPreviousX : e.controlPointNextX, n ? e.controlPointPreviousY : e.controlPointNextY, n ? i.controlPointNextX : i.controlPointPreviousX, n ? i.controlPointNextY : i.controlPointPreviousY, i.x, i.y) : t.lineTo(i.x, i.y)
                }
            },
            K = U;
        H.clear = U.clear, H.drawRoundedRectangle = function (t) {
            t.beginPath(), U.roundedRect.apply(U, arguments)
        };
        var $ = {
            _set: function (t, e) {
                return H.merge(this[t] || (this[t] = {}), e)
            }
        };
        $._set("global", {
            defaultColor: "rgba(0,0,0,0.1)",
            defaultFontColor: "#666",
            defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            defaultFontSize: 12,
            defaultFontStyle: "normal",
            defaultLineHeight: 1.2,
            showLines: !0
        });
        var Q = $,
            J = H.valueOrDefault;

        function tt(t) {
            return !t || H.isNullOrUndef(t.size) || H.isNullOrUndef(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family
        }
        var et = {
                toLineHeight: function (t, e) {
                    var i = ("" + t).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
                    if (!i || "normal" === i[1]) return 1.2 * e;
                    switch (t = +i[2], i[3]) {
                        case "px":
                            return t;
                        case "%":
                            t /= 100
                    }
                    return e * t
                },
                toPadding: function (t) {
                    var e, i, n, l;
                    return H.isObject(t) ? (e = +t.top || 0, i = +t.right || 0, n = +t.bottom || 0, l = +t.left || 0) : e = i = n = l = +t || 0, {
                        top: e,
                        right: i,
                        bottom: n,
                        left: l,
                        height: e + n,
                        width: l + i
                    }
                },
                _parseFont: function (t) {
                    var e = Q.global,
                        i = J(t.fontSize, e.defaultFontSize),
                        n = {
                            family: J(t.fontFamily, e.defaultFontFamily),
                            lineHeight: H.options.toLineHeight(J(t.lineHeight, e.defaultLineHeight), i),
                            size: i,
                            style: J(t.fontStyle, e.defaultFontStyle),
                            weight: null,
                            string: ""
                        };
                    return n.string = tt(n), n
                },
                resolve: function (t, e, i, n) {
                    var l, r, a, o = !0;
                    for (l = 0, r = t.length; l < r; ++l)
                        if (void 0 !== (a = t[l]) && (void 0 !== e && "function" == typeof a && (a = a(e), o = !1), void 0 !== i && H.isArray(a) && (a = a[i], o = !1), void 0 !== a)) return n && !o && (n.cacheable = !1), a
                }
            },
            it = {
                _factorize: function (t) {
                    var e, i = [],
                        n = Math.sqrt(t);
                    for (e = 1; e < n; e++) t % e == 0 && (i.push(e), i.push(t / e));
                    return n === (0 | n) && i.push(n), i.sort((function (t, e) {
                        return t - e
                    })).pop(), i
                },
                log10: Math.log10 || function (t) {
                    var e = Math.log(t) * Math.LOG10E,
                        i = Math.round(e);
                    return t === Math.pow(10, i) ? i : e
                }
            },
            nt = it;
        H.log10 = it.log10;
        var lt = function (t, e) {
                return {
                    x: function (i) {
                        return t + t + e - i
                    },
                    setWidth: function (t) {
                        e = t
                    },
                    textAlign: function (t) {
                        return "center" === t ? t : "right" === t ? "left" : "right"
                    },
                    xPlus: function (t, e) {
                        return t - e
                    },
                    leftForLtr: function (t, e) {
                        return t - e
                    }
                }
            },
            rt = function () {
                return {
                    x: function (t) {
                        return t
                    },
                    setWidth: function (t) {},
                    textAlign: function (t) {
                        return t
                    },
                    xPlus: function (t, e) {
                        return t + e
                    },
                    leftForLtr: function (t, e) {
                        return t
                    }
                }
            },
            at = H,
            ot = Y,
            st = K,
            ct = et,
            ut = nt,
            ht = {
                getRtlAdapter: function (t, e, i) {
                    return t ? lt(e, i) : rt()
                },
                overrideTextDirection: function (t, e) {
                    var i, n;
                    "ltr" !== e && "rtl" !== e || (n = [(i = t.canvas.style).getPropertyValue("direction"), i.getPropertyPriority("direction")], i.setProperty("direction", e, "important"), t.prevTextDirection = n)
                },
                restoreTextDirection: function (t) {
                    var e = t.prevTextDirection;
                    void 0 !== e && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]))
                }
            };

        function dt(t, e, i, n) {
            var l, r, a, o, s, c, u, h, d, f = Object.keys(i);
            for (l = 0, r = f.length; l < r; ++l)
                if (c = i[a = f[l]], e.hasOwnProperty(a) || (e[a] = c), (o = e[a]) !== c && "_" !== a[0]) {
                    if (t.hasOwnProperty(a) || (t[a] = o), (u = typeof c) == typeof (s = t[a]))
                        if ("string" === u) {
                            if ((h = N(s)).valid && (d = N(c)).valid) {
                                e[a] = d.mix(h, n).rgbString();
                                continue
                            }
                        } else if (at.isFinite(s) && at.isFinite(c)) {
                        e[a] = s + (c - s) * n;
                        continue
                    }
                    e[a] = c
                }
        }
        at.easing = ot, at.canvas = st, at.options = ct, at.math = ut, at.rtl = ht;
        var ft = function (t) {
            at.extend(this, t), this.initialize.apply(this, arguments)
        };
        at.extend(ft.prototype, {
            _type: void 0,
            initialize: function () {
                this.hidden = !1
            },
            pivot: function () {
                var t = this;
                return t._view || (t._view = at.extend({}, t._model)), t._start = {}, t
            },
            transition: function (t) {
                var e = this,
                    i = e._model,
                    n = e._start,
                    l = e._view;
                return i && 1 !== t ? (l || (l = e._view = {}), n || (n = e._start = {}), dt(n, l, i, t), e) : (e._view = at.extend({}, i), e._start = null, e)
            },
            tooltipPosition: function () {
                return {
                    x: this._model.x,
                    y: this._model.y
                }
            },
            hasValue: function () {
                return at.isNumber(this._model.x) && at.isNumber(this._model.y)
            }
        }), ft.extend = at.inherits;
        var pt = ft,
            gt = pt.extend({
                chart: null,
                currentStep: 0,
                numSteps: 60,
                easing: "",
                render: null,
                onAnimationProgress: null,
                onAnimationComplete: null
            }),
            mt = gt;
        Object.defineProperty(gt.prototype, "animationObject", {
            get: function () {
                return this
            }
        }), Object.defineProperty(gt.prototype, "chartInstance", {
            get: function () {
                return this.chart
            },
            set: function (t) {
                this.chart = t
            }
        }), Q._set("global", {
            animation: {
                duration: 1e3,
                easing: "easeOutQuart",
                onProgress: at.noop,
                onComplete: at.noop
            }
        });
        var vt = {
                animations: [],
                request: null,
                addAnimation: function (t, e, i, n) {
                    var l, r, a = this.animations;
                    for (e.chart = t, e.startTime = Date.now(), e.duration = i, n || (t.animating = !0), l = 0, r = a.length; l < r; ++l)
                        if (a[l].chart === t) return void(a[l] = e);
                    a.push(e), 1 === a.length && this.requestAnimationFrame()
                },
                cancelAnimation: function (t) {
                    var e = at.findIndex(this.animations, (function (e) {
                        return e.chart === t
                    })); - 1 !== e && (this.animations.splice(e, 1), t.animating = !1)
                },
                requestAnimationFrame: function () {
                    var t = this;
                    null === t.request && (t.request = at.requestAnimFrame.call(window, (function () {
                        t.request = null, t.startDigest()
                    })))
                },
                startDigest: function () {
                    var t = this;
                    t.advance(), t.animations.length > 0 && t.requestAnimationFrame()
                },
                advance: function () {
                    for (var t, e, i, n, l = this.animations, r = 0; r < l.length;) e = (t = l[r]).chart, i = t.numSteps, n = Math.floor((Date.now() - t.startTime) / t.duration * i) + 1, t.currentStep = Math.min(n, i), at.callback(t.render, [e, t], e), at.callback(t.onAnimationProgress, [t], e), t.currentStep >= i ? (at.callback(t.onAnimationComplete, [t], e), e.animating = !1, l.splice(r, 1)) : ++r
                }
            },
            yt = at.options.resolve,
            bt = ["push", "pop", "shift", "splice", "unshift"];

        function xt(t, e) {
            t._chartjs ? t._chartjs.listeners.push(e) : (Object.defineProperty(t, "_chartjs", {
                configurable: !0,
                enumerable: !1,
                value: {
                    listeners: [e]
                }
            }), bt.forEach((function (e) {
                var i = "onData" + e.charAt(0).toUpperCase() + e.slice(1),
                    n = t[e];
                Object.defineProperty(t, e, {
                    configurable: !0,
                    enumerable: !1,
                    value: function () {
                        var e = Array.prototype.slice.call(arguments),
                            l = n.apply(this, e);
                        return at.each(t._chartjs.listeners, (function (t) {
                            "function" == typeof t[i] && t[i].apply(t, e)
                        })), l
                    }
                })
            })))
        }

        function wt(t, e) {
            var i = t._chartjs;
            if (i) {
                var n = i.listeners,
                    l = n.indexOf(e); - 1 !== l && n.splice(l, 1), n.length > 0 || (bt.forEach((function (e) {
                    delete t[e]
                })), delete t._chartjs)
            }
        }
        var _t = function (t, e) {
            this.initialize(t, e)
        };
        at.extend(_t.prototype, {
            datasetElementType: null,
            dataElementType: null,
            _datasetElementOptions: ["backgroundColor", "borderCapStyle", "borderColor", "borderDash", "borderDashOffset", "borderJoinStyle", "borderWidth"],
            _dataElementOptions: ["backgroundColor", "borderColor", "borderWidth", "pointStyle"],
            initialize: function (t, e) {
                var i = this;
                i.chart = t, i.index = e, i.linkScales(), i.addElements(), i._type = i.getMeta().type
            },
            updateIndex: function (t) {
                this.index = t
            },
            linkScales: function () {
                var t = this,
                    e = t.getMeta(),
                    i = t.chart,
                    n = i.scales,
                    l = t.getDataset(),
                    r = i.options.scales;
                null !== e.xAxisID && e.xAxisID in n && !l.xAxisID || (e.xAxisID = l.xAxisID || r.xAxes[0].id), null !== e.yAxisID && e.yAxisID in n && !l.yAxisID || (e.yAxisID = l.yAxisID || r.yAxes[0].id)
            },
            getDataset: function () {
                return this.chart.data.datasets[this.index]
            },
            getMeta: function () {
                return this.chart.getDatasetMeta(this.index)
            },
            getScaleForId: function (t) {
                return this.chart.scales[t]
            },
            _getValueScaleId: function () {
                return this.getMeta().yAxisID
            },
            _getIndexScaleId: function () {
                return this.getMeta().xAxisID
            },
            _getValueScale: function () {
                return this.getScaleForId(this._getValueScaleId())
            },
            _getIndexScale: function () {
                return this.getScaleForId(this._getIndexScaleId())
            },
            reset: function () {
                this._update(!0)
            },
            destroy: function () {
                this._data && wt(this._data, this)
            },
            createMetaDataset: function () {
                var t = this,
                    e = t.datasetElementType;
                return e && new e({
                    _chart: t.chart,
                    _datasetIndex: t.index
                })
            },
            createMetaData: function (t) {
                var e = this,
                    i = e.dataElementType;
                return i && new i({
                    _chart: e.chart,
                    _datasetIndex: e.index,
                    _index: t
                })
            },
            addElements: function () {
                var t, e, i = this,
                    n = i.getMeta(),
                    l = i.getDataset().data || [],
                    r = n.data;
                for (t = 0, e = l.length; t < e; ++t) r[t] = r[t] || i.createMetaData(t);
                n.dataset = n.dataset || i.createMetaDataset()
            },
            addElementAndReset: function (t) {
                var e = this.createMetaData(t);
                this.getMeta().data.splice(t, 0, e), this.updateElement(e, t, !0)
            },
            buildOrUpdateElements: function () {
                var t = this,
                    e = t.getDataset(),
                    i = e.data || (e.data = []);
                t._data !== i && (t._data && wt(t._data, t), i && Object.isExtensible(i) && xt(i, t), t._data = i), t.resyncElements()
            },
            _configure: function () {
                var t = this;
                t._config = at.merge(Object.create(null), [t.chart.options.datasets[t._type], t.getDataset()], {
                    merger: function (t, e, i) {
                        "_meta" !== t && "data" !== t && at._merger(t, e, i)
                    }
                })
            },
            _update: function (t) {
                var e = this;
                e._configure(), e._cachedDataOpts = null, e.update(t)
            },
            update: at.noop,
            transition: function (t) {
                for (var e = this.getMeta(), i = e.data || [], n = i.length, l = 0; l < n; ++l) i[l].transition(t);
                e.dataset && e.dataset.transition(t)
            },
            draw: function () {
                var t = this.getMeta(),
                    e = t.data || [],
                    i = e.length,
                    n = 0;
                for (t.dataset && t.dataset.draw(); n < i; ++n) e[n].draw()
            },
            getStyle: function (t) {
                var e, i = this,
                    n = i.getMeta(),
                    l = n.dataset;
                return i._configure(), l && void 0 === t ? e = i._resolveDatasetElementOptions(l || {}) : (t = t || 0, e = i._resolveDataElementOptions(n.data[t] || {}, t)), !1 !== e.fill && null !== e.fill || (e.backgroundColor = e.borderColor), e
            },
            _resolveDatasetElementOptions: function (t, e) {
                var i, n, l, r, a = this,
                    o = a.chart,
                    s = a._config,
                    c = t.custom || {},
                    u = o.options.elements[a.datasetElementType.prototype._type] || {},
                    h = a._datasetElementOptions,
                    d = {},
                    f = {
                        chart: o,
                        dataset: a.getDataset(),
                        datasetIndex: a.index,
                        hover: e
                    };
                for (i = 0, n = h.length; i < n; ++i) l = h[i], r = e ? "hover" + l.charAt(0).toUpperCase() + l.slice(1) : l, d[l] = yt([c[r], s[r], u[r]], f);
                return d
            },
            _resolveDataElementOptions: function (t, e) {
                var i = this,
                    n = t && t.custom,
                    l = i._cachedDataOpts;
                if (l && !n) return l;
                var r, a, o, s, c = i.chart,
                    u = i._config,
                    h = c.options.elements[i.dataElementType.prototype._type] || {},
                    d = i._dataElementOptions,
                    f = {},
                    p = {
                        chart: c,
                        dataIndex: e,
                        dataset: i.getDataset(),
                        datasetIndex: i.index
                    },
                    g = {
                        cacheable: !n
                    };
                if (n = n || {}, at.isArray(d))
                    for (a = 0, o = d.length; a < o; ++a) f[s = d[a]] = yt([n[s], u[s], h[s]], p, e, g);
                else
                    for (a = 0, o = (r = Object.keys(d)).length; a < o; ++a) f[s = r[a]] = yt([n[s], u[d[s]], u[s], h[s]], p, e, g);
                return g.cacheable && (i._cachedDataOpts = Object.freeze(f)), f
            },
            removeHoverStyle: function (t) {
                at.merge(t._model, t.$previousStyle || {}), delete t.$previousStyle
            },
            setHoverStyle: function (t) {
                var e = this.chart.data.datasets[t._datasetIndex],
                    i = t._index,
                    n = t.custom || {},
                    l = t._model,
                    r = at.getHoverColor;
                t.$previousStyle = {
                    backgroundColor: l.backgroundColor,
                    borderColor: l.borderColor,
                    borderWidth: l.borderWidth
                }, l.backgroundColor = yt([n.hoverBackgroundColor, e.hoverBackgroundColor, r(l.backgroundColor)], void 0, i), l.borderColor = yt([n.hoverBorderColor, e.hoverBorderColor, r(l.borderColor)], void 0, i), l.borderWidth = yt([n.hoverBorderWidth, e.hoverBorderWidth, l.borderWidth], void 0, i)
            },
            _removeDatasetHoverStyle: function () {
                var t = this.getMeta().dataset;
                t && this.removeHoverStyle(t)
            },
            _setDatasetHoverStyle: function () {
                var t, e, i, n, l, r, a = this.getMeta().dataset,
                    o = {};
                if (a) {
                    for (r = a._model, l = this._resolveDatasetElementOptions(a, !0), t = 0, e = (n = Object.keys(l)).length; t < e; ++t) o[i = n[t]] = r[i], r[i] = l[i];
                    a.$previousStyle = o
                }
            },
            resyncElements: function () {
                var t = this,
                    e = t.getMeta(),
                    i = t.getDataset().data,
                    n = e.data.length,
                    l = i.length;
                l < n ? e.data.splice(l, n - l) : l > n && t.insertElements(n, l - n)
            },
            insertElements: function (t, e) {
                for (var i = 0; i < e; ++i) this.addElementAndReset(t + i)
            },
            onDataPush: function () {
                var t = arguments.length;
                this.insertElements(this.getDataset().data.length - t, t)
            },
            onDataPop: function () {
                this.getMeta().data.pop()
            },
            onDataShift: function () {
                this.getMeta().data.shift()
            },
            onDataSplice: function (t, e) {
                this.getMeta().data.splice(t, e), this.insertElements(t, arguments.length - 2)
            },
            onDataUnshift: function () {
                this.insertElements(0, arguments.length)
            }
        }), _t.extend = at.inherits;
        var kt = _t,
            St = 2 * Math.PI;

        function At(t, e) {
            var i = e.startAngle,
                n = e.endAngle,
                l = e.pixelMargin,
                r = l / e.outerRadius,
                a = e.x,
                o = e.y;
            t.beginPath(), t.arc(a, o, e.outerRadius, i - r, n + r), e.innerRadius > l ? (r = l / e.innerRadius, t.arc(a, o, e.innerRadius - l, n + r, i - r, !0)) : t.arc(a, o, l, n + Math.PI / 2, i - Math.PI / 2), t.closePath(), t.clip()
        }

        function Mt(t, e, i, n) {
            var l, r = i.endAngle;
            for (n && (i.endAngle = i.startAngle + St, At(t, i), i.endAngle = r, i.endAngle === i.startAngle && i.fullCircles && (i.endAngle += St, i.fullCircles--)), t.beginPath(), t.arc(i.x, i.y, i.innerRadius, i.startAngle + St, i.startAngle, !0), l = 0; l < i.fullCircles; ++l) t.stroke();
            for (t.beginPath(), t.arc(i.x, i.y, e.outerRadius, i.startAngle, i.startAngle + St), l = 0; l < i.fullCircles; ++l) t.stroke()
        }

        function Ct(t, e, i) {
            var n = "inner" === e.borderAlign;
            n ? (t.lineWidth = 2 * e.borderWidth, t.lineJoin = "round") : (t.lineWidth = e.borderWidth, t.lineJoin = "bevel"), i.fullCircles && Mt(t, e, i, n), n && At(t, i), t.beginPath(), t.arc(i.x, i.y, e.outerRadius, i.startAngle, i.endAngle), t.arc(i.x, i.y, i.innerRadius, i.endAngle, i.startAngle, !0), t.closePath(), t.stroke()
        }
        Q._set("global", {
            elements: {
                arc: {
                    backgroundColor: Q.global.defaultColor,
                    borderColor: "#fff",
                    borderWidth: 2,
                    borderAlign: "center"
                }
            }
        });
        var Et = pt.extend({
                _type: "arc",
                inLabelRange: function (t) {
                    var e = this._view;
                    return !!e && Math.pow(t - e.x, 2) < Math.pow(e.radius + e.hoverRadius, 2)
                },
                inRange: function (t, e) {
                    var i = this._view;
                    if (i) {
                        for (var n = at.getAngleFromPoint(i, {
                                x: t,
                                y: e
                            }), l = n.angle, r = n.distance, a = i.startAngle, o = i.endAngle; o < a;) o += St;
                        for (; l > o;) l -= St;
                        for (; l < a;) l += St;
                        var s = l >= a && l <= o,
                            c = r >= i.innerRadius && r <= i.outerRadius;
                        return s && c
                    }
                    return !1
                },
                getCenterPoint: function () {
                    var t = this._view,
                        e = (t.startAngle + t.endAngle) / 2,
                        i = (t.innerRadius + t.outerRadius) / 2;
                    return {
                        x: t.x + Math.cos(e) * i,
                        y: t.y + Math.sin(e) * i
                    }
                },
                getArea: function () {
                    var t = this._view;
                    return Math.PI * ((t.endAngle - t.startAngle) / (2 * Math.PI)) * (Math.pow(t.outerRadius, 2) - Math.pow(t.innerRadius, 2))
                },
                tooltipPosition: function () {
                    var t = this._view,
                        e = t.startAngle + (t.endAngle - t.startAngle) / 2,
                        i = (t.outerRadius - t.innerRadius) / 2 + t.innerRadius;
                    return {
                        x: t.x + Math.cos(e) * i,
                        y: t.y + Math.sin(e) * i
                    }
                },
                draw: function () {
                    var t, e = this._chart.ctx,
                        i = this._view,
                        n = "inner" === i.borderAlign ? .33 : 0,
                        l = {
                            x: i.x,
                            y: i.y,
                            innerRadius: i.innerRadius,
                            outerRadius: Math.max(i.outerRadius - n, 0),
                            pixelMargin: n,
                            startAngle: i.startAngle,
                            endAngle: i.endAngle,
                            fullCircles: Math.floor(i.circumference / St)
                        };
                    if (e.save(), e.fillStyle = i.backgroundColor, e.strokeStyle = i.borderColor, l.fullCircles) {
                        for (l.endAngle = l.startAngle + St, e.beginPath(), e.arc(l.x, l.y, l.outerRadius, l.startAngle, l.endAngle), e.arc(l.x, l.y, l.innerRadius, l.endAngle, l.startAngle, !0), e.closePath(), t = 0; t < l.fullCircles; ++t) e.fill();
                        l.endAngle = l.startAngle + i.circumference % St
                    }
                    e.beginPath(), e.arc(l.x, l.y, l.outerRadius, l.startAngle, l.endAngle), e.arc(l.x, l.y, l.innerRadius, l.endAngle, l.startAngle, !0), e.closePath(), e.fill(), i.borderWidth && Ct(e, i, l), e.restore()
                }
            }),
            Ot = at.valueOrDefault,
            Tt = Q.global.defaultColor;
        Q._set("global", {
            elements: {
                line: {
                    tension: .4,
                    backgroundColor: Tt,
                    borderWidth: 3,
                    borderColor: Tt,
                    borderCapStyle: "butt",
                    borderDash: [],
                    borderDashOffset: 0,
                    borderJoinStyle: "miter",
                    capBezierPoints: !0,
                    fill: !0
                }
            }
        });
        var Pt = pt.extend({
                _type: "line",
                draw: function () {
                    var t, e, i, n = this,
                        l = n._view,
                        r = n._chart.ctx,
                        a = l.spanGaps,
                        o = n._children.slice(),
                        s = Q.global,
                        c = s.elements.line,
                        u = -1,
                        h = n._loop;
                    if (o.length) {
                        if (n._loop) {
                            for (t = 0; t < o.length; ++t)
                                if (e = at.previousItem(o, t), !o[t]._view.skip && e._view.skip) {
                                    o = o.slice(t).concat(o.slice(0, t)), h = a;
                                    break
                                } h && o.push(o[0])
                        }
                        for (r.save(), r.lineCap = l.borderCapStyle || c.borderCapStyle, r.setLineDash && r.setLineDash(l.borderDash || c.borderDash), r.lineDashOffset = Ot(l.borderDashOffset, c.borderDashOffset), r.lineJoin = l.borderJoinStyle || c.borderJoinStyle, r.lineWidth = Ot(l.borderWidth, c.borderWidth), r.strokeStyle = l.borderColor || s.defaultColor, r.beginPath(), (i = o[0]._view).skip || (r.moveTo(i.x, i.y), u = 0), t = 1; t < o.length; ++t) i = o[t]._view, e = -1 === u ? at.previousItem(o, t) : o[u], i.skip || (u !== t - 1 && !a || -1 === u ? r.moveTo(i.x, i.y) : at.canvas.lineTo(r, e._view, i), u = t);
                        h && r.closePath(), r.stroke(), r.restore()
                    }
                }
            }),
            Lt = at.valueOrDefault,
            Dt = Q.global.defaultColor;

        function It(t) {
            var e = this._view;
            return !!e && Math.abs(t - e.x) < e.radius + e.hitRadius
        }

        function jt(t) {
            var e = this._view;
            return !!e && Math.abs(t - e.y) < e.radius + e.hitRadius
        }
        Q._set("global", {
            elements: {
                point: {
                    radius: 3,
                    pointStyle: "circle",
                    backgroundColor: Dt,
                    borderColor: Dt,
                    borderWidth: 1,
                    hitRadius: 1,
                    hoverRadius: 4,
                    hoverBorderWidth: 1
                }
            }
        });
        var Nt = pt.extend({
                _type: "point",
                inRange: function (t, e) {
                    var i = this._view;
                    return !!i && Math.pow(t - i.x, 2) + Math.pow(e - i.y, 2) < Math.pow(i.hitRadius + i.radius, 2)
                },
                inLabelRange: It,
                inXRange: It,
                inYRange: jt,
                getCenterPoint: function () {
                    var t = this._view;
                    return {
                        x: t.x,
                        y: t.y
                    }
                },
                getArea: function () {
                    return Math.PI * Math.pow(this._view.radius, 2)
                },
                tooltipPosition: function () {
                    var t = this._view;
                    return {
                        x: t.x,
                        y: t.y,
                        padding: t.radius + t.borderWidth
                    }
                },
                draw: function (t) {
                    var e = this._view,
                        i = this._chart.ctx,
                        n = e.pointStyle,
                        l = e.rotation,
                        r = e.radius,
                        a = e.x,
                        o = e.y,
                        s = Q.global,
                        c = s.defaultColor;
                    e.skip || (void 0 === t || at.canvas._isPointInArea(e, t)) && (i.strokeStyle = e.borderColor || c, i.lineWidth = Lt(e.borderWidth, s.elements.point.borderWidth), i.fillStyle = e.backgroundColor || c, at.canvas.drawPoint(i, n, r, a, o, l))
                }
            }),
            Rt = Q.global.defaultColor;

        function Ft(t) {
            return t && void 0 !== t.width
        }

        function zt(t) {
            var e, i, n, l, r;
            return Ft(t) ? (r = t.width / 2, e = t.x - r, i = t.x + r, n = Math.min(t.y, t.base), l = Math.max(t.y, t.base)) : (r = t.height / 2, e = Math.min(t.x, t.base), i = Math.max(t.x, t.base), n = t.y - r, l = t.y + r), {
                left: e,
                top: n,
                right: i,
                bottom: l
            }
        }

        function Ht(t, e, i) {
            return t === e ? i : t === i ? e : t
        }

        function Bt(t) {
            var e = t.borderSkipped,
                i = {};
            return e ? (t.horizontal ? t.base > t.x && (e = Ht(e, "left", "right")) : t.base < t.y && (e = Ht(e, "bottom", "top")), i[e] = !0, i) : i
        }

        function Yt(t, e, i) {
            var n, l, r, a, o = t.borderWidth,
                s = Bt(t);
            return at.isObject(o) ? (n = +o.top || 0, l = +o.right || 0, r = +o.bottom || 0, a = +o.left || 0) : n = l = r = a = +o || 0, {
                t: s.top || n < 0 ? 0 : n > i ? i : n,
                r: s.right || l < 0 ? 0 : l > e ? e : l,
                b: s.bottom || r < 0 ? 0 : r > i ? i : r,
                l: s.left || a < 0 ? 0 : a > e ? e : a
            }
        }

        function Wt(t) {
            var e = zt(t),
                i = e.right - e.left,
                n = e.bottom - e.top,
                l = Yt(t, i / 2, n / 2);
            return {
                outer: {
                    x: e.left,
                    y: e.top,
                    w: i,
                    h: n
                },
                inner: {
                    x: e.left + l.l,
                    y: e.top + l.t,
                    w: i - l.l - l.r,
                    h: n - l.t - l.b
                }
            }
        }

        function Vt(t, e, i) {
            var n = null === e,
                l = null === i,
                r = !(!t || n && l) && zt(t);
            return r && (n || e >= r.left && e <= r.right) && (l || i >= r.top && i <= r.bottom)
        }
        Q._set("global", {
            elements: {
                rectangle: {
                    backgroundColor: Rt,
                    borderColor: Rt,
                    borderSkipped: "bottom",
                    borderWidth: 0
                }
            }
        });
        var Xt = pt.extend({
                _type: "rectangle",
                draw: function () {
                    var t = this._chart.ctx,
                        e = this._view,
                        i = Wt(e),
                        n = i.outer,
                        l = i.inner;
                    t.fillStyle = e.backgroundColor, t.fillRect(n.x, n.y, n.w, n.h), n.w === l.w && n.h === l.h || (t.save(), t.beginPath(), t.rect(n.x, n.y, n.w, n.h), t.clip(), t.fillStyle = e.borderColor, t.rect(l.x, l.y, l.w, l.h), t.fill("evenodd"), t.restore())
                },
                height: function () {
                    var t = this._view;
                    return t.base - t.y
                },
                inRange: function (t, e) {
                    return Vt(this._view, t, e)
                },
                inLabelRange: function (t, e) {
                    var i = this._view;
                    return Ft(i) ? Vt(i, t, null) : Vt(i, null, e)
                },
                inXRange: function (t) {
                    return Vt(this._view, t, null)
                },
                inYRange: function (t) {
                    return Vt(this._view, null, t)
                },
                getCenterPoint: function () {
                    var t, e, i = this._view;
                    return Ft(i) ? (t = i.x, e = (i.y + i.base) / 2) : (t = (i.x + i.base) / 2, e = i.y), {
                        x: t,
                        y: e
                    }
                },
                getArea: function () {
                    var t = this._view;
                    return Ft(t) ? t.width * Math.abs(t.y - t.base) : t.height * Math.abs(t.x - t.base)
                },
                tooltipPosition: function () {
                    var t = this._view;
                    return {
                        x: t.x,
                        y: t.y
                    }
                }
            }),
            qt = {},
            Zt = Et,
            Gt = Pt,
            Ut = Nt,
            Kt = Xt;
        qt.Arc = Zt, qt.Line = Gt, qt.Point = Ut, qt.Rectangle = Kt;
        var $t = at._deprecated,
            Qt = at.valueOrDefault;

        function Jt(t, e) {
            var i, n, l, r, a = t._length;
            for (l = 1, r = e.length; l < r; ++l) a = Math.min(a, Math.abs(e[l] - e[l - 1]));
            for (l = 0, r = t.getTicks().length; l < r; ++l) n = t.getPixelForTick(l), a = l > 0 ? Math.min(a, Math.abs(n - i)) : a, i = n;
            return a
        }

        function te(t, e, i) {
            var n, l, r = i.barThickness,
                a = e.stackCount,
                o = e.pixels[t],
                s = at.isNullOrUndef(r) ? Jt(e.scale, e.pixels) : -1;
            return at.isNullOrUndef(r) ? (n = s * i.categoryPercentage, l = i.barPercentage) : (n = r * a, l = 1), {
                chunk: n / a,
                ratio: l,
                start: o - n / 2
            }
        }

        function ee(t, e, i) {
            var n, l = e.pixels,
                r = l[t],
                a = t > 0 ? l[t - 1] : null,
                o = t < l.length - 1 ? l[t + 1] : null,
                s = i.categoryPercentage;
            return null === a && (a = r - (null === o ? e.end - e.start : o - r)), null === o && (o = r + r - a), n = r - (r - Math.min(a, o)) / 2 * s, {
                chunk: Math.abs(o - a) / 2 * s / e.stackCount,
                ratio: i.barPercentage,
                start: n
            }
        }
        Q._set("bar", {
            hover: {
                mode: "label"
            },
            scales: {
                xAxes: [{
                    type: "category",
                    offset: !0,
                    gridLines: {
                        offsetGridLines: !0
                    }
                }],
                yAxes: [{
                    type: "linear"
                }]
            }
        }), Q._set("global", {
            datasets: {
                bar: {
                    categoryPercentage: .8,
                    barPercentage: .9
                }
            }
        });
        var ie = kt.extend({
                dataElementType: qt.Rectangle,
                _dataElementOptions: ["backgroundColor", "borderColor", "borderSkipped", "borderWidth", "barPercentage", "barThickness", "categoryPercentage", "maxBarThickness", "minBarLength"],
                initialize: function () {
                    var t, e, i = this;
                    kt.prototype.initialize.apply(i, arguments), (t = i.getMeta()).stack = i.getDataset().stack, t.bar = !0, e = i._getIndexScale().options, $t("bar chart", e.barPercentage, "scales.[x/y]Axes.barPercentage", "dataset.barPercentage"), $t("bar chart", e.barThickness, "scales.[x/y]Axes.barThickness", "dataset.barThickness"), $t("bar chart", e.categoryPercentage, "scales.[x/y]Axes.categoryPercentage", "dataset.categoryPercentage"), $t("bar chart", i._getValueScale().options.minBarLength, "scales.[x/y]Axes.minBarLength", "dataset.minBarLength"), $t("bar chart", e.maxBarThickness, "scales.[x/y]Axes.maxBarThickness", "dataset.maxBarThickness")
                },
                update: function (t) {
                    var e, i, n = this,
                        l = n.getMeta().data;
                    for (n._ruler = n.getRuler(), e = 0, i = l.length; e < i; ++e) n.updateElement(l[e], e, t)
                },
                updateElement: function (t, e, i) {
                    var n = this,
                        l = n.getMeta(),
                        r = n.getDataset(),
                        a = n._resolveDataElementOptions(t, e);
                    t._xScale = n.getScaleForId(l.xAxisID), t._yScale = n.getScaleForId(l.yAxisID), t._datasetIndex = n.index, t._index = e, t._model = {
                        backgroundColor: a.backgroundColor,
                        borderColor: a.borderColor,
                        borderSkipped: a.borderSkipped,
                        borderWidth: a.borderWidth,
                        datasetLabel: r.label,
                        label: n.chart.data.labels[e]
                    }, at.isArray(r.data[e]) && (t._model.borderSkipped = null), n._updateElementGeometry(t, e, i, a), t.pivot()
                },
                _updateElementGeometry: function (t, e, i, n) {
                    var l = this,
                        r = t._model,
                        a = l._getValueScale(),
                        o = a.getBasePixel(),
                        s = a.isHorizontal(),
                        c = l._ruler || l.getRuler(),
                        u = l.calculateBarValuePixels(l.index, e, n),
                        h = l.calculateBarIndexPixels(l.index, e, c, n);
                    r.horizontal = s, r.base = i ? o : u.base, r.x = s ? i ? o : u.head : h.center, r.y = s ? h.center : i ? o : u.head, r.height = s ? h.size : void 0, r.width = s ? void 0 : h.size
                },
                _getStacks: function (t) {
                    var e, i, n = this,
                        l = n._getIndexScale(),
                        r = l._getMatchingVisibleMetas(n._type),
                        a = l.options.stacked,
                        o = r.length,
                        s = [];
                    for (e = 0; e < o && (i = r[e], (!1 === a || -1 === s.indexOf(i.stack) || void 0 === a && void 0 === i.stack) && s.push(i.stack), i.index !== t); ++e);
                    return s
                },
                getStackCount: function () {
                    return this._getStacks().length
                },
                getStackIndex: function (t, e) {
                    var i = this._getStacks(t),
                        n = void 0 !== e ? i.indexOf(e) : -1;
                    return -1 === n ? i.length - 1 : n
                },
                getRuler: function () {
                    var t, e, i = this,
                        n = i._getIndexScale(),
                        l = [];
                    for (t = 0, e = i.getMeta().data.length; t < e; ++t) l.push(n.getPixelForValue(null, t, i.index));
                    return {
                        pixels: l,
                        start: n._startPixel,
                        end: n._endPixel,
                        stackCount: i.getStackCount(),
                        scale: n
                    }
                },
                calculateBarValuePixels: function (t, e, i) {
                    var n, l, r, a, o, s, c, u = this,
                        h = u.chart,
                        d = u._getValueScale(),
                        f = d.isHorizontal(),
                        p = h.data.datasets,
                        g = d._getMatchingVisibleMetas(u._type),
                        m = d._parseValue(p[t].data[e]),
                        v = i.minBarLength,
                        y = d.options.stacked,
                        b = u.getMeta().stack,
                        x = void 0 === m.start ? 0 : m.max >= 0 && m.min >= 0 ? m.min : m.max,
                        w = void 0 === m.start ? m.end : m.max >= 0 && m.min >= 0 ? m.max - m.min : m.min - m.max,
                        _ = g.length;
                    if (y || void 0 === y && void 0 !== b)
                        for (n = 0; n < _ && (l = g[n]).index !== t; ++n) l.stack === b && (r = void 0 === (c = d._parseValue(p[l.index].data[e])).start ? c.end : c.min >= 0 && c.max >= 0 ? c.max : c.min, (m.min < 0 && r < 0 || m.max >= 0 && r > 0) && (x += r));
                    return a = d.getPixelForValue(x), s = (o = d.getPixelForValue(x + w)) - a, void 0 !== v && Math.abs(s) < v && (s = v, o = w >= 0 && !f || w < 0 && f ? a - v : a + v), {
                        size: s,
                        base: a,
                        head: o,
                        center: o + s / 2
                    }
                },
                calculateBarIndexPixels: function (t, e, i, n) {
                    var l = this,
                        r = "flex" === n.barThickness ? ee(e, i, n) : te(e, i, n),
                        a = l.getStackIndex(t, l.getMeta().stack),
                        o = r.start + r.chunk * a + r.chunk / 2,
                        s = Math.min(Qt(n.maxBarThickness, 1 / 0), r.chunk * r.ratio);
                    return {
                        base: o - s / 2,
                        head: o + s / 2,
                        center: o,
                        size: s
                    }
                },
                draw: function () {
                    var t = this,
                        e = t.chart,
                        i = t._getValueScale(),
                        n = t.getMeta().data,
                        l = t.getDataset(),
                        r = n.length,
                        a = 0;
                    for (at.canvas.clipArea(e.ctx, e.chartArea); a < r; ++a) {
                        var o = i._parseValue(l.data[a]);
                        isNaN(o.min) || isNaN(o.max) || n[a].draw()
                    }
                    at.canvas.unclipArea(e.ctx)
                },
                _resolveDataElementOptions: function () {
                    var t = this,
                        e = at.extend({}, kt.prototype._resolveDataElementOptions.apply(t, arguments)),
                        i = t._getIndexScale().options,
                        n = t._getValueScale().options;
                    return e.barPercentage = Qt(i.barPercentage, e.barPercentage), e.barThickness = Qt(i.barThickness, e.barThickness), e.categoryPercentage = Qt(i.categoryPercentage, e.categoryPercentage), e.maxBarThickness = Qt(i.maxBarThickness, e.maxBarThickness), e.minBarLength = Qt(n.minBarLength, e.minBarLength), e
                }
            }),
            ne = at.valueOrDefault,
            le = at.options.resolve;
        Q._set("bubble", {
            hover: {
                mode: "single"
            },
            scales: {
                xAxes: [{
                    type: "linear",
                    position: "bottom",
                    id: "x-axis-0"
                }],
                yAxes: [{
                    type: "linear",
                    position: "left",
                    id: "y-axis-0"
                }]
            },
            tooltips: {
                callbacks: {
                    title: function () {
                        return ""
                    },
                    label: function (t, e) {
                        var i = e.datasets[t.datasetIndex].label || "",
                            n = e.datasets[t.datasetIndex].data[t.index];
                        return i + ": (" + t.xLabel + ", " + t.yLabel + ", " + n.r + ")"
                    }
                }
            }
        });
        var re = kt.extend({
                dataElementType: qt.Point,
                _dataElementOptions: ["backgroundColor", "borderColor", "borderWidth", "hoverBackgroundColor", "hoverBorderColor", "hoverBorderWidth", "hoverRadius", "hitRadius", "pointStyle", "rotation"],
                update: function (t) {
                    var e = this,
                        i = e.getMeta().data;
                    at.each(i, (function (i, n) {
                        e.updateElement(i, n, t)
                    }))
                },
                updateElement: function (t, e, i) {
                    var n = this,
                        l = n.getMeta(),
                        r = t.custom || {},
                        a = n.getScaleForId(l.xAxisID),
                        o = n.getScaleForId(l.yAxisID),
                        s = n._resolveDataElementOptions(t, e),
                        c = n.getDataset().data[e],
                        u = n.index,
                        h = i ? a.getPixelForDecimal(.5) : a.getPixelForValue("object" == typeof c ? c : NaN, e, u),
                        d = i ? o.getBasePixel() : o.getPixelForValue(c, e, u);
                    t._xScale = a, t._yScale = o, t._options = s, t._datasetIndex = u, t._index = e, t._model = {
                        backgroundColor: s.backgroundColor,
                        borderColor: s.borderColor,
                        borderWidth: s.borderWidth,
                        hitRadius: s.hitRadius,
                        pointStyle: s.pointStyle,
                        rotation: s.rotation,
                        radius: i ? 0 : s.radius,
                        skip: r.skip || isNaN(h) || isNaN(d),
                        x: h,
                        y: d
                    }, t.pivot()
                },
                setHoverStyle: function (t) {
                    var e = t._model,
                        i = t._options,
                        n = at.getHoverColor;
                    t.$previousStyle = {
                        backgroundColor: e.backgroundColor,
                        borderColor: e.borderColor,
                        borderWidth: e.borderWidth,
                        radius: e.radius
                    }, e.backgroundColor = ne(i.hoverBackgroundColor, n(i.backgroundColor)), e.borderColor = ne(i.hoverBorderColor, n(i.borderColor)), e.borderWidth = ne(i.hoverBorderWidth, i.borderWidth), e.radius = i.radius + i.hoverRadius
                },
                _resolveDataElementOptions: function (t, e) {
                    var i = this,
                        n = i.chart,
                        l = i.getDataset(),
                        r = t.custom || {},
                        a = l.data[e] || {},
                        o = kt.prototype._resolveDataElementOptions.apply(i, arguments),
                        s = {
                            chart: n,
                            dataIndex: e,
                            dataset: l,
                            datasetIndex: i.index
                        };
                    return i._cachedDataOpts === o && (o = at.extend({}, o)), o.radius = le([r.radius, a.r, i._config.radius, n.options.elements.point.radius], s, e), o
                }
            }),
            ae = at.valueOrDefault,
            oe = Math.PI,
            se = 2 * oe,
            ce = oe / 2;
        Q._set("doughnut", {
            animation: {
                animateRotate: !0,
                animateScale: !1
            },
            hover: {
                mode: "single"
            },
            legendCallback: function (t) {
                var e, i, n, l = document.createElement("ul"),
                    r = t.data,
                    a = r.datasets,
                    o = r.labels;
                if (l.setAttribute("class", t.id + "-legend"), a.length)
                    for (e = 0, i = a[0].data.length; e < i; ++e)(n = l.appendChild(document.createElement("li"))).appendChild(document.createElement("span")).style.backgroundColor = a[0].backgroundColor[e], o[e] && n.appendChild(document.createTextNode(o[e]));
                return l.outerHTML
            },
            legend: {
                labels: {
                    generateLabels: function (t) {
                        var e = t.data;
                        return e.labels.length && e.datasets.length ? e.labels.map((function (i, n) {
                            var l = t.getDatasetMeta(0),
                                r = l.controller.getStyle(n);
                            return {
                                text: i,
                                fillStyle: r.backgroundColor,
                                strokeStyle: r.borderColor,
                                lineWidth: r.borderWidth,
                                hidden: isNaN(e.datasets[0].data[n]) || l.data[n].hidden,
                                index: n
                            }
                        })) : []
                    }
                },
                onClick: function (t, e) {
                    var i, n, l, r = e.index,
                        a = this.chart;
                    for (i = 0, n = (a.data.datasets || []).length; i < n; ++i)(l = a.getDatasetMeta(i)).data[r] && (l.data[r].hidden = !l.data[r].hidden);
                    a.update()
                }
            },
            cutoutPercentage: 50,
            rotation: -ce,
            circumference: se,
            tooltips: {
                callbacks: {
                    title: function () {
                        return ""
                    },
                    label: function (t, e) {
                        var i = e.labels[t.index],
                            n = ": " + e.datasets[t.datasetIndex].data[t.index];
                        return at.isArray(i) ? (i = i.slice())[0] += n : i += n, i
                    }
                }
            }
        });
        var ue = kt.extend({
            dataElementType: qt.Arc,
            linkScales: at.noop,
            _dataElementOptions: ["backgroundColor", "borderColor", "borderWidth", "borderAlign", "hoverBackgroundColor", "hoverBorderColor", "hoverBorderWidth"],
            getRingIndex: function (t) {
                for (var e = 0, i = 0; i < t; ++i) this.chart.isDatasetVisible(i) && ++e;
                return e
            },
            update: function (t) {
                var e, i, n, l, r = this,
                    a = r.chart,
                    o = a.chartArea,
                    s = a.options,
                    c = 1,
                    u = 1,
                    h = 0,
                    d = 0,
                    f = r.getMeta(),
                    p = f.data,
                    g = s.cutoutPercentage / 100 || 0,
                    m = s.circumference,
                    v = r._getRingWeight(r.index);
                if (m < se) {
                    var y = s.rotation % se,
                        b = (y += y >= oe ? -se : y < -oe ? se : 0) + m,
                        x = Math.cos(y),
                        w = Math.sin(y),
                        _ = Math.cos(b),
                        k = Math.sin(b),
                        S = y <= 0 && b >= 0 || b >= se,
                        A = y <= ce && b >= ce || b >= se + ce,
                        M = y <= -ce && b >= -ce || b >= oe + ce,
                        C = y === -oe || b >= oe ? -1 : Math.min(x, x * g, _, _ * g),
                        E = M ? -1 : Math.min(w, w * g, k, k * g),
                        O = S ? 1 : Math.max(x, x * g, _, _ * g),
                        T = A ? 1 : Math.max(w, w * g, k, k * g);
                    c = (O - C) / 2, u = (T - E) / 2, h = -(O + C) / 2, d = -(T + E) / 2
                }
                for (n = 0, l = p.length; n < l; ++n) p[n]._options = r._resolveDataElementOptions(p[n], n);
                for (a.borderWidth = r.getMaxBorderWidth(), e = (o.right - o.left - a.borderWidth) / c, i = (o.bottom - o.top - a.borderWidth) / u, a.outerRadius = Math.max(Math.min(e, i) / 2, 0), a.innerRadius = Math.max(a.outerRadius * g, 0), a.radiusLength = (a.outerRadius - a.innerRadius) / (r._getVisibleDatasetWeightTotal() || 1), a.offsetX = h * a.outerRadius, a.offsetY = d * a.outerRadius, f.total = r.calculateTotal(), r.outerRadius = a.outerRadius - a.radiusLength * r._getRingWeightOffset(r.index), r.innerRadius = Math.max(r.outerRadius - a.radiusLength * v, 0), n = 0, l = p.length; n < l; ++n) r.updateElement(p[n], n, t)
            },
            updateElement: function (t, e, i) {
                var n = this,
                    l = n.chart,
                    r = l.chartArea,
                    a = l.options,
                    o = a.animation,
                    s = (r.left + r.right) / 2,
                    c = (r.top + r.bottom) / 2,
                    u = a.rotation,
                    h = a.rotation,
                    d = n.getDataset(),
                    f = i && o.animateRotate || t.hidden ? 0 : n.calculateCircumference(d.data[e]) * (a.circumference / se),
                    p = i && o.animateScale ? 0 : n.innerRadius,
                    g = i && o.animateScale ? 0 : n.outerRadius,
                    m = t._options || {};
                at.extend(t, {
                    _datasetIndex: n.index,
                    _index: e,
                    _model: {
                        backgroundColor: m.backgroundColor,
                        borderColor: m.borderColor,
                        borderWidth: m.borderWidth,
                        borderAlign: m.borderAlign,
                        x: s + l.offsetX,
                        y: c + l.offsetY,
                        startAngle: u,
                        endAngle: h,
                        circumference: f,
                        outerRadius: g,
                        innerRadius: p,
                        label: at.valueAtIndexOrDefault(d.label, e, l.data.labels[e])
                    }
                });
                var v = t._model;
                i && o.animateRotate || (v.startAngle = 0 === e ? a.rotation : n.getMeta().data[e - 1]._model.endAngle, v.endAngle = v.startAngle + v.circumference), t.pivot()
            },
            calculateTotal: function () {
                var t, e = this.getDataset(),
                    i = this.getMeta(),
                    n = 0;
                return at.each(i.data, (function (i, l) {
                    t = e.data[l], isNaN(t) || i.hidden || (n += Math.abs(t))
                })), n
            },
            calculateCircumference: function (t) {
                var e = this.getMeta().total;
                return e > 0 && !isNaN(t) ? se * (Math.abs(t) / e) : 0
            },
            getMaxBorderWidth: function (t) {
                var e, i, n, l, r, a, o, s, c = this,
                    u = 0,
                    h = c.chart;
                if (!t)
                    for (e = 0, i = h.data.datasets.length; e < i; ++e)
                        if (h.isDatasetVisible(e)) {
                            t = (n = h.getDatasetMeta(e)).data, e !== c.index && (r = n.controller);
                            break
                        } if (!t) return 0;
                for (e = 0, i = t.length; e < i; ++e) l = t[e], r ? (r._configure(), a = r._resolveDataElementOptions(l, e)) : a = l._options, "inner" !== a.borderAlign && (o = a.borderWidth, u = (s = a.hoverBorderWidth) > (u = o > u ? o : u) ? s : u);
                return u
            },
            setHoverStyle: function (t) {
                var e = t._model,
                    i = t._options,
                    n = at.getHoverColor;
                t.$previousStyle = {
                    backgroundColor: e.backgroundColor,
                    borderColor: e.borderColor,
                    borderWidth: e.borderWidth
                }, e.backgroundColor = ae(i.hoverBackgroundColor, n(i.backgroundColor)), e.borderColor = ae(i.hoverBorderColor, n(i.borderColor)), e.borderWidth = ae(i.hoverBorderWidth, i.borderWidth)
            },
            _getRingWeightOffset: function (t) {
                for (var e = 0, i = 0; i < t; ++i) this.chart.isDatasetVisible(i) && (e += this._getRingWeight(i));
                return e
            },
            _getRingWeight: function (t) {
                return Math.max(ae(this.chart.data.datasets[t].weight, 1), 0)
            },
            _getVisibleDatasetWeightTotal: function () {
                return this._getRingWeightOffset(this.chart.data.datasets.length)
            }
        });
        Q._set("horizontalBar", {
            hover: {
                mode: "index",
                axis: "y"
            },
            scales: {
                xAxes: [{
                    type: "linear",
                    position: "bottom"
                }],
                yAxes: [{
                    type: "category",
                    position: "left",
                    offset: !0,
                    gridLines: {
                        offsetGridLines: !0
                    }
                }]
            },
            elements: {
                rectangle: {
                    borderSkipped: "left"
                }
            },
            tooltips: {
                mode: "index",
                axis: "y"
            }
        }), Q._set("global", {
            datasets: {
                horizontalBar: {
                    categoryPercentage: .8,
                    barPercentage: .9
                }
            }
        });
        var he = ie.extend({
                _getValueScaleId: function () {
                    return this.getMeta().xAxisID
                },
                _getIndexScaleId: function () {
                    return this.getMeta().yAxisID
                }
            }),
            de = at.valueOrDefault,
            fe = at.options.resolve,
            pe = at.canvas._isPointInArea;

        function ge(t, e) {
            var i = t && t.options.ticks || {},
                n = i.reverse,
                l = void 0 === i.min ? e : 0,
                r = void 0 === i.max ? e : 0;
            return {
                start: n ? r : l,
                end: n ? l : r
            }
        }

        function me(t, e, i) {
            var n = i / 2,
                l = ge(t, n),
                r = ge(e, n);
            return {
                top: r.end,
                right: l.end,
                bottom: r.start,
                left: l.start
            }
        }

        function ve(t) {
            var e, i, n, l;
            return at.isObject(t) ? (e = t.top, i = t.right, n = t.bottom, l = t.left) : e = i = n = l = t, {
                top: e,
                right: i,
                bottom: n,
                left: l
            }
        }
        Q._set("line", {
            showLines: !0,
            spanGaps: !1,
            hover: {
                mode: "label"
            },
            scales: {
                xAxes: [{
                    type: "category",
                    id: "x-axis-0"
                }],
                yAxes: [{
                    type: "linear",
                    id: "y-axis-0"
                }]
            }
        });
        var ye = kt.extend({
                datasetElementType: qt.Line,
                dataElementType: qt.Point,
                _datasetElementOptions: ["backgroundColor", "borderCapStyle", "borderColor", "borderDash", "borderDashOffset", "borderJoinStyle", "borderWidth", "cubicInterpolationMode", "fill"],
                _dataElementOptions: {
                    backgroundColor: "pointBackgroundColor",
                    borderColor: "pointBorderColor",
                    borderWidth: "pointBorderWidth",
                    hitRadius: "pointHitRadius",
                    hoverBackgroundColor: "pointHoverBackgroundColor",
                    hoverBorderColor: "pointHoverBorderColor",
                    hoverBorderWidth: "pointHoverBorderWidth",
                    hoverRadius: "pointHoverRadius",
                    pointStyle: "pointStyle",
                    radius: "pointRadius",
                    rotation: "pointRotation"
                },
                update: function (t) {
                    var e, i, n = this,
                        l = n.getMeta(),
                        r = l.dataset,
                        a = l.data || [],
                        o = n.chart.options,
                        s = n._config,
                        c = n._showLine = de(s.showLine, o.showLines);
                    for (n._xScale = n.getScaleForId(l.xAxisID), n._yScale = n.getScaleForId(l.yAxisID), c && (void 0 !== s.tension && void 0 === s.lineTension && (s.lineTension = s.tension), r._scale = n._yScale, r._datasetIndex = n.index, r._children = a, r._model = n._resolveDatasetElementOptions(r), r.pivot()), e = 0, i = a.length; e < i; ++e) n.updateElement(a[e], e, t);
                    for (c && 0 !== r._model.tension && n.updateBezierControlPoints(), e = 0, i = a.length; e < i; ++e) a[e].pivot()
                },
                updateElement: function (t, e, i) {
                    var n, l, r = this,
                        a = r.getMeta(),
                        o = t.custom || {},
                        s = r.getDataset(),
                        c = r.index,
                        u = s.data[e],
                        h = r._xScale,
                        d = r._yScale,
                        f = a.dataset._model,
                        p = r._resolveDataElementOptions(t, e);
                    n = h.getPixelForValue("object" == typeof u ? u : NaN, e, c), l = i ? d.getBasePixel() : r.calculatePointY(u, e, c), t._xScale = h, t._yScale = d, t._options = p, t._datasetIndex = c, t._index = e, t._model = {
                        x: n,
                        y: l,
                        skip: o.skip || isNaN(n) || isNaN(l),
                        radius: p.radius,
                        pointStyle: p.pointStyle,
                        rotation: p.rotation,
                        backgroundColor: p.backgroundColor,
                        borderColor: p.borderColor,
                        borderWidth: p.borderWidth,
                        tension: de(o.tension, f ? f.tension : 0),
                        steppedLine: !!f && f.steppedLine,
                        hitRadius: p.hitRadius
                    }
                },
                _resolveDatasetElementOptions: function (t) {
                    var e = this,
                        i = e._config,
                        n = t.custom || {},
                        l = e.chart.options,
                        r = l.elements.line,
                        a = kt.prototype._resolveDatasetElementOptions.apply(e, arguments);
                    return a.spanGaps = de(i.spanGaps, l.spanGaps), a.tension = de(i.lineTension, r.tension), a.steppedLine = fe([n.steppedLine, i.steppedLine, r.stepped]), a.clip = ve(de(i.clip, me(e._xScale, e._yScale, a.borderWidth))), a
                },
                calculatePointY: function (t, e, i) {
                    var n, l, r, a, o, s, c, u = this,
                        h = u.chart,
                        d = u._yScale,
                        f = 0,
                        p = 0;
                    if (d.options.stacked) {
                        for (o = +d.getRightValue(t), c = (s = h._getSortedVisibleDatasetMetas()).length, n = 0; n < c && (r = s[n]).index !== i; ++n) l = h.data.datasets[r.index], "line" === r.type && r.yAxisID === d.id && ((a = +d.getRightValue(l.data[e])) < 0 ? p += a || 0 : f += a || 0);
                        return o < 0 ? d.getPixelForValue(p + o) : d.getPixelForValue(f + o)
                    }
                    return d.getPixelForValue(t)
                },
                updateBezierControlPoints: function () {
                    var t, e, i, n, l = this,
                        r = l.chart,
                        a = l.getMeta(),
                        o = a.dataset._model,
                        s = r.chartArea,
                        c = a.data || [];

                    function u(t, e, i) {
                        return Math.max(Math.min(t, i), e)
                    }
                    if (o.spanGaps && (c = c.filter((function (t) {
                            return !t._model.skip
                        }))), "monotone" === o.cubicInterpolationMode) at.splineCurveMonotone(c);
                    else
                        for (t = 0, e = c.length; t < e; ++t) i = c[t]._model, n = at.splineCurve(at.previousItem(c, t)._model, i, at.nextItem(c, t)._model, o.tension), i.controlPointPreviousX = n.previous.x, i.controlPointPreviousY = n.previous.y, i.controlPointNextX = n.next.x, i.controlPointNextY = n.next.y;
                    if (r.options.elements.line.capBezierPoints)
                        for (t = 0, e = c.length; t < e; ++t) i = c[t]._model, pe(i, s) && (t > 0 && pe(c[t - 1]._model, s) && (i.controlPointPreviousX = u(i.controlPointPreviousX, s.left, s.right), i.controlPointPreviousY = u(i.controlPointPreviousY, s.top, s.bottom)), t < c.length - 1 && pe(c[t + 1]._model, s) && (i.controlPointNextX = u(i.controlPointNextX, s.left, s.right), i.controlPointNextY = u(i.controlPointNextY, s.top, s.bottom)))
                },
                draw: function () {
                    var t, e = this,
                        i = e.chart,
                        n = e.getMeta(),
                        l = n.data || [],
                        r = i.chartArea,
                        a = i.canvas,
                        o = 0,
                        s = l.length;
                    for (e._showLine && (t = n.dataset._model.clip, at.canvas.clipArea(i.ctx, {
                            left: !1 === t.left ? 0 : r.left - t.left,
                            right: !1 === t.right ? a.width : r.right + t.right,
                            top: !1 === t.top ? 0 : r.top - t.top,
                            bottom: !1 === t.bottom ? a.height : r.bottom + t.bottom
                        }), n.dataset.draw(), at.canvas.unclipArea(i.ctx)); o < s; ++o) l[o].draw(r)
                },
                setHoverStyle: function (t) {
                    var e = t._model,
                        i = t._options,
                        n = at.getHoverColor;
                    t.$previousStyle = {
                        backgroundColor: e.backgroundColor,
                        borderColor: e.borderColor,
                        borderWidth: e.borderWidth,
                        radius: e.radius
                    }, e.backgroundColor = de(i.hoverBackgroundColor, n(i.backgroundColor)), e.borderColor = de(i.hoverBorderColor, n(i.borderColor)), e.borderWidth = de(i.hoverBorderWidth, i.borderWidth), e.radius = de(i.hoverRadius, i.radius)
                }
            }),
            be = at.options.resolve;
        Q._set("polarArea", {
            scale: {
                type: "radialLinear",
                angleLines: {
                    display: !1
                },
                gridLines: {
                    circular: !0
                },
                pointLabels: {
                    display: !1
                },
                ticks: {
                    beginAtZero: !0
                }
            },
            animation: {
                animateRotate: !0,
                animateScale: !0
            },
            startAngle: -.5 * Math.PI,
            legendCallback: function (t) {
                var e, i, n, l = document.createElement("ul"),
                    r = t.data,
                    a = r.datasets,
                    o = r.labels;
                if (l.setAttribute("class", t.id + "-legend"), a.length)
                    for (e = 0, i = a[0].data.length; e < i; ++e)(n = l.appendChild(document.createElement("li"))).appendChild(document.createElement("span")).style.backgroundColor = a[0].backgroundColor[e], o[e] && n.appendChild(document.createTextNode(o[e]));
                return l.outerHTML
            },
            legend: {
                labels: {
                    generateLabels: function (t) {
                        var e = t.data;
                        return e.labels.length && e.datasets.length ? e.labels.map((function (i, n) {
                            var l = t.getDatasetMeta(0),
                                r = l.controller.getStyle(n);
                            return {
                                text: i,
                                fillStyle: r.backgroundColor,
                                strokeStyle: r.borderColor,
                                lineWidth: r.borderWidth,
                                hidden: isNaN(e.datasets[0].data[n]) || l.data[n].hidden,
                                index: n
                            }
                        })) : []
                    }
                },
                onClick: function (t, e) {
                    var i, n, l, r = e.index,
                        a = this.chart;
                    for (i = 0, n = (a.data.datasets || []).length; i < n; ++i)(l = a.getDatasetMeta(i)).data[r].hidden = !l.data[r].hidden;
                    a.update()
                }
            },
            tooltips: {
                callbacks: {
                    title: function () {
                        return ""
                    },
                    label: function (t, e) {
                        return e.labels[t.index] + ": " + t.yLabel
                    }
                }
            }
        });
        var xe = kt.extend({
            dataElementType: qt.Arc,
            linkScales: at.noop,
            _dataElementOptions: ["backgroundColor", "borderColor", "borderWidth", "borderAlign", "hoverBackgroundColor", "hoverBorderColor", "hoverBorderWidth"],
            _getIndexScaleId: function () {
                return this.chart.scale.id
            },
            _getValueScaleId: function () {
                return this.chart.scale.id
            },
            update: function (t) {
                var e, i, n, l = this,
                    r = l.getDataset(),
                    a = l.getMeta(),
                    o = l.chart.options.startAngle || 0,
                    s = l._starts = [],
                    c = l._angles = [],
                    u = a.data;
                for (l._updateRadius(), a.count = l.countVisibleElements(), e = 0, i = r.data.length; e < i; e++) s[e] = o, n = l._computeAngle(e), c[e] = n, o += n;
                for (e = 0, i = u.length; e < i; ++e) u[e]._options = l._resolveDataElementOptions(u[e], e), l.updateElement(u[e], e, t)
            },
            _updateRadius: function () {
                var t = this,
                    e = t.chart,
                    i = e.chartArea,
                    n = e.options,
                    l = Math.min(i.right - i.left, i.bottom - i.top);
                e.outerRadius = Math.max(l / 2, 0), e.innerRadius = Math.max(n.cutoutPercentage ? e.outerRadius / 100 * n.cutoutPercentage : 1, 0), e.radiusLength = (e.outerRadius - e.innerRadius) / e.getVisibleDatasetCount(), t.outerRadius = e.outerRadius - e.radiusLength * t.index, t.innerRadius = t.outerRadius - e.radiusLength
            },
            updateElement: function (t, e, i) {
                var n = this,
                    l = n.chart,
                    r = n.getDataset(),
                    a = l.options,
                    o = a.animation,
                    s = l.scale,
                    c = l.data.labels,
                    u = s.xCenter,
                    h = s.yCenter,
                    d = a.startAngle,
                    f = t.hidden ? 0 : s.getDistanceFromCenterForValue(r.data[e]),
                    p = n._starts[e],
                    g = p + (t.hidden ? 0 : n._angles[e]),
                    m = o.animateScale ? 0 : s.getDistanceFromCenterForValue(r.data[e]),
                    v = t._options || {};
                at.extend(t, {
                    _datasetIndex: n.index,
                    _index: e,
                    _scale: s,
                    _model: {
                        backgroundColor: v.backgroundColor,
                        borderColor: v.borderColor,
                        borderWidth: v.borderWidth,
                        borderAlign: v.borderAlign,
                        x: u,
                        y: h,
                        innerRadius: 0,
                        outerRadius: i ? m : f,
                        startAngle: i && o.animateRotate ? d : p,
                        endAngle: i && o.animateRotate ? d : g,
                        label: at.valueAtIndexOrDefault(c, e, c[e])
                    }
                }), t.pivot()
            },
            countVisibleElements: function () {
                var t = this.getDataset(),
                    e = this.getMeta(),
                    i = 0;
                return at.each(e.data, (function (e, n) {
                    isNaN(t.data[n]) || e.hidden || i++
                })), i
            },
            setHoverStyle: function (t) {
                var e = t._model,
                    i = t._options,
                    n = at.getHoverColor,
                    l = at.valueOrDefault;
                t.$previousStyle = {
                    backgroundColor: e.backgroundColor,
                    borderColor: e.borderColor,
                    borderWidth: e.borderWidth
                }, e.backgroundColor = l(i.hoverBackgroundColor, n(i.backgroundColor)), e.borderColor = l(i.hoverBorderColor, n(i.borderColor)), e.borderWidth = l(i.hoverBorderWidth, i.borderWidth)
            },
            _computeAngle: function (t) {
                var e = this,
                    i = this.getMeta().count,
                    n = e.getDataset(),
                    l = e.getMeta();
                if (isNaN(n.data[t]) || l.data[t].hidden) return 0;
                var r = {
                    chart: e.chart,
                    dataIndex: t,
                    dataset: n,
                    datasetIndex: e.index
                };
                return be([e.chart.options.elements.arc.angle, 2 * Math.PI / i], r, t)
            }
        });
        Q._set("pie", at.clone(Q.doughnut)), Q._set("pie", {
            cutoutPercentage: 0
        });
        var we = ue,
            _e = at.valueOrDefault;
        Q._set("radar", {
            spanGaps: !1,
            scale: {
                type: "radialLinear"
            },
            elements: {
                line: {
                    fill: "start",
                    tension: 0
                }
            }
        });
        var ke = kt.extend({
            datasetElementType: qt.Line,
            dataElementType: qt.Point,
            linkScales: at.noop,
            _datasetElementOptions: ["backgroundColor", "borderWidth", "borderColor", "borderCapStyle", "borderDash", "borderDashOffset", "borderJoinStyle", "fill"],
            _dataElementOptions: {
                backgroundColor: "pointBackgroundColor",
                borderColor: "pointBorderColor",
                borderWidth: "pointBorderWidth",
                hitRadius: "pointHitRadius",
                hoverBackgroundColor: "pointHoverBackgroundColor",
                hoverBorderColor: "pointHoverBorderColor",
                hoverBorderWidth: "pointHoverBorderWidth",
                hoverRadius: "pointHoverRadius",
                pointStyle: "pointStyle",
                radius: "pointRadius",
                rotation: "pointRotation"
            },
            _getIndexScaleId: function () {
                return this.chart.scale.id
            },
            _getValueScaleId: function () {
                return this.chart.scale.id
            },
            update: function (t) {
                var e, i, n = this,
                    l = n.getMeta(),
                    r = l.dataset,
                    a = l.data || [],
                    o = n.chart.scale,
                    s = n._config;
                for (void 0 !== s.tension && void 0 === s.lineTension && (s.lineTension = s.tension), r._scale = o, r._datasetIndex = n.index, r._children = a, r._loop = !0, r._model = n._resolveDatasetElementOptions(r), r.pivot(), e = 0, i = a.length; e < i; ++e) n.updateElement(a[e], e, t);
                for (n.updateBezierControlPoints(), e = 0, i = a.length; e < i; ++e) a[e].pivot()
            },
            updateElement: function (t, e, i) {
                var n = this,
                    l = t.custom || {},
                    r = n.getDataset(),
                    a = n.chart.scale,
                    o = a.getPointPositionForValue(e, r.data[e]),
                    s = n._resolveDataElementOptions(t, e),
                    c = n.getMeta().dataset._model,
                    u = i ? a.xCenter : o.x,
                    h = i ? a.yCenter : o.y;
                t._scale = a, t._options = s, t._datasetIndex = n.index, t._index = e, t._model = {
                    x: u,
                    y: h,
                    skip: l.skip || isNaN(u) || isNaN(h),
                    radius: s.radius,
                    pointStyle: s.pointStyle,
                    rotation: s.rotation,
                    backgroundColor: s.backgroundColor,
                    borderColor: s.borderColor,
                    borderWidth: s.borderWidth,
                    tension: _e(l.tension, c ? c.tension : 0),
                    hitRadius: s.hitRadius
                }
            },
            _resolveDatasetElementOptions: function () {
                var t = this,
                    e = t._config,
                    i = t.chart.options,
                    n = kt.prototype._resolveDatasetElementOptions.apply(t, arguments);
                return n.spanGaps = _e(e.spanGaps, i.spanGaps), n.tension = _e(e.lineTension, i.elements.line.tension), n
            },
            updateBezierControlPoints: function () {
                var t, e, i, n, l = this,
                    r = l.getMeta(),
                    a = l.chart.chartArea,
                    o = r.data || [];

                function s(t, e, i) {
                    return Math.max(Math.min(t, i), e)
                }
                for (r.dataset._model.spanGaps && (o = o.filter((function (t) {
                        return !t._model.skip
                    }))), t = 0, e = o.length; t < e; ++t) i = o[t]._model, n = at.splineCurve(at.previousItem(o, t, !0)._model, i, at.nextItem(o, t, !0)._model, i.tension), i.controlPointPreviousX = s(n.previous.x, a.left, a.right), i.controlPointPreviousY = s(n.previous.y, a.top, a.bottom), i.controlPointNextX = s(n.next.x, a.left, a.right), i.controlPointNextY = s(n.next.y, a.top, a.bottom)
            },
            setHoverStyle: function (t) {
                var e = t._model,
                    i = t._options,
                    n = at.getHoverColor;
                t.$previousStyle = {
                    backgroundColor: e.backgroundColor,
                    borderColor: e.borderColor,
                    borderWidth: e.borderWidth,
                    radius: e.radius
                }, e.backgroundColor = _e(i.hoverBackgroundColor, n(i.backgroundColor)), e.borderColor = _e(i.hoverBorderColor, n(i.borderColor)), e.borderWidth = _e(i.hoverBorderWidth, i.borderWidth), e.radius = _e(i.hoverRadius, i.radius)
            }
        });
        Q._set("scatter", {
            hover: {
                mode: "single"
            },
            scales: {
                xAxes: [{
                    id: "x-axis-1",
                    type: "linear",
                    position: "bottom"
                }],
                yAxes: [{
                    id: "y-axis-1",
                    type: "linear",
                    position: "left"
                }]
            },
            tooltips: {
                callbacks: {
                    title: function () {
                        return ""
                    },
                    label: function (t) {
                        return "(" + t.xLabel + ", " + t.yLabel + ")"
                    }
                }
            }
        }), Q._set("global", {
            datasets: {
                scatter: {
                    showLine: !1
                }
            }
        });
        var Se = {
            bar: ie,
            bubble: re,
            doughnut: ue,
            horizontalBar: he,
            line: ye,
            polarArea: xe,
            pie: we,
            radar: ke,
            scatter: ye
        };

        function Ae(t, e) {
            return t.native ? {
                x: t.x,
                y: t.y
            } : at.getRelativePosition(t, e)
        }

        function Me(t, e) {
            var i, n, l, r, a, o, s = t._getSortedVisibleDatasetMetas();
            for (n = 0, r = s.length; n < r; ++n)
                for (l = 0, a = (i = s[n].data).length; l < a; ++l)(o = i[l])._view.skip || e(o)
        }

        function Ce(t, e) {
            var i = [];
            return Me(t, (function (t) {
                t.inRange(e.x, e.y) && i.push(t)
            })), i
        }

        function Ee(t, e, i, n) {
            var l = Number.POSITIVE_INFINITY,
                r = [];
            return Me(t, (function (t) {
                if (!i || t.inRange(e.x, e.y)) {
                    var a = t.getCenterPoint(),
                        o = n(e, a);
                    o < l ? (r = [t], l = o) : o === l && r.push(t)
                }
            })), r
        }

        function Oe(t) {
            var e = -1 !== t.indexOf("x"),
                i = -1 !== t.indexOf("y");
            return function (t, n) {
                var l = e ? Math.abs(t.x - n.x) : 0,
                    r = i ? Math.abs(t.y - n.y) : 0;
                return Math.sqrt(Math.pow(l, 2) + Math.pow(r, 2))
            }
        }

        function Te(t, e, i) {
            var n = Ae(e, t);
            i.axis = i.axis || "x";
            var l = Oe(i.axis),
                r = i.intersect ? Ce(t, n) : Ee(t, n, !1, l),
                a = [];
            return r.length ? (t._getSortedVisibleDatasetMetas().forEach((function (t) {
                var e = t.data[r[0]._index];
                e && !e._view.skip && a.push(e)
            })), a) : []
        }
        var Pe = {
                modes: {
                    single: function (t, e) {
                        var i = Ae(e, t),
                            n = [];
                        return Me(t, (function (t) {
                            if (t.inRange(i.x, i.y)) return n.push(t), n
                        })), n.slice(0, 1)
                    },
                    label: Te,
                    index: Te,
                    dataset: function (t, e, i) {
                        var n = Ae(e, t);
                        i.axis = i.axis || "xy";
                        var l = Oe(i.axis),
                            r = i.intersect ? Ce(t, n) : Ee(t, n, !1, l);
                        return r.length > 0 && (r = t.getDatasetMeta(r[0]._datasetIndex).data), r
                    },
                    "x-axis": function (t, e) {
                        return Te(t, e, {
                            intersect: !1
                        })
                    },
                    point: function (t, e) {
                        return Ce(t, Ae(e, t))
                    },
                    nearest: function (t, e, i) {
                        var n = Ae(e, t);
                        i.axis = i.axis || "xy";
                        var l = Oe(i.axis);
                        return Ee(t, n, i.intersect, l)
                    },
                    x: function (t, e, i) {
                        var n = Ae(e, t),
                            l = [],
                            r = !1;
                        return Me(t, (function (t) {
                            t.inXRange(n.x) && l.push(t), t.inRange(n.x, n.y) && (r = !0)
                        })), i.intersect && !r && (l = []), l
                    },
                    y: function (t, e, i) {
                        var n = Ae(e, t),
                            l = [],
                            r = !1;
                        return Me(t, (function (t) {
                            t.inYRange(n.y) && l.push(t), t.inRange(n.x, n.y) && (r = !0)
                        })), i.intersect && !r && (l = []), l
                    }
                }
            },
            Le = at.extend;

        function De(t, e) {
            return at.where(t, (function (t) {
                return t.pos === e
            }))
        }

        function Ie(t, e) {
            return t.sort((function (t, i) {
                var n = e ? i : t,
                    l = e ? t : i;
                return n.weight === l.weight ? n.index - l.index : n.weight - l.weight
            }))
        }

        function je(t) {
            var e, i, n, l = [];
            for (e = 0, i = (t || []).length; e < i; ++e) n = t[e], l.push({
                index: e,
                box: n,
                pos: n.position,
                horizontal: n.isHorizontal(),
                weight: n.weight
            });
            return l
        }

        function Ne(t, e) {
            var i, n, l;
            for (i = 0, n = t.length; i < n; ++i)(l = t[i]).width = l.horizontal ? l.box.fullWidth && e.availableWidth : e.vBoxMaxWidth, l.height = l.horizontal && e.hBoxMaxHeight
        }

        function Re(t) {
            var e = je(t),
                i = Ie(De(e, "left"), !0),
                n = Ie(De(e, "right")),
                l = Ie(De(e, "top"), !0),
                r = Ie(De(e, "bottom"));
            return {
                leftAndTop: i.concat(l),
                rightAndBottom: n.concat(r),
                chartArea: De(e, "chartArea"),
                vertical: i.concat(n),
                horizontal: l.concat(r)
            }
        }

        function Fe(t, e, i, n) {
            return Math.max(t[i], e[i]) + Math.max(t[n], e[n])
        }

        function ze(t, e, i) {
            var n, l, r = i.box,
                a = t.maxPadding;
            if (i.size && (t[i.pos] -= i.size), i.size = i.horizontal ? r.height : r.width, t[i.pos] += i.size, r.getPadding) {
                var o = r.getPadding();
                a.top = Math.max(a.top, o.top), a.left = Math.max(a.left, o.left), a.bottom = Math.max(a.bottom, o.bottom), a.right = Math.max(a.right, o.right)
            }
            if (n = e.outerWidth - Fe(a, t, "left", "right"), l = e.outerHeight - Fe(a, t, "top", "bottom"), n !== t.w || l !== t.h) {
                t.w = n, t.h = l;
                var s = i.horizontal ? [n, t.w] : [l, t.h];
                return !(s[0] === s[1] || isNaN(s[0]) && isNaN(s[1]))
            }
        }

        function He(t) {
            var e = t.maxPadding;

            function i(i) {
                var n = Math.max(e[i] - t[i], 0);
                return t[i] += n, n
            }
            t.y += i("top"), t.x += i("left"), i("right"), i("bottom")
        }

        function Be(t, e) {
            var i = e.maxPadding;

            function n(t) {
                var n = {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                };
                return t.forEach((function (t) {
                    n[t] = Math.max(e[t], i[t])
                })), n
            }
            return n(t ? ["left", "right"] : ["top", "bottom"])
        }

        function Ye(t, e, i) {
            var n, l, r, a, o, s, c = [];
            for (n = 0, l = t.length; n < l; ++n)(a = (r = t[n]).box).update(r.width || e.w, r.height || e.h, Be(r.horizontal, e)), ze(e, i, r) && (s = !0, c.length && (o = !0)), a.fullWidth || c.push(r);
            return o && Ye(c, e, i) || s
        }

        function We(t, e, i) {
            var n, l, r, a, o = i.padding,
                s = e.x,
                c = e.y;
            for (n = 0, l = t.length; n < l; ++n) a = (r = t[n]).box, r.horizontal ? (a.left = a.fullWidth ? o.left : e.left, a.right = a.fullWidth ? i.outerWidth - o.right : e.left + e.w, a.top = c, a.bottom = c + a.height, a.width = a.right - a.left, c = a.bottom) : (a.left = s, a.right = s + a.width, a.top = e.top, a.bottom = e.top + e.h, a.height = a.bottom - a.top, s = a.right);
            e.x = s, e.y = c
        }
        Q._set("global", {
            layout: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        });
        var Ve = {
                defaults: {},
                addBox: function (t, e) {
                    t.boxes || (t.boxes = []), e.fullWidth = e.fullWidth || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function () {
                        return [{
                            z: 0,
                            draw: function () {
                                e.draw.apply(e, arguments)
                            }
                        }]
                    }, t.boxes.push(e)
                },
                removeBox: function (t, e) {
                    var i = t.boxes ? t.boxes.indexOf(e) : -1; - 1 !== i && t.boxes.splice(i, 1)
                },
                configure: function (t, e, i) {
                    for (var n, l = ["fullWidth", "position", "weight"], r = l.length, a = 0; a < r; ++a) n = l[a], i.hasOwnProperty(n) && (e[n] = i[n])
                },
                update: function (t, e, i) {
                    if (t) {
                        var n = t.options.layout || {},
                            l = at.options.toPadding(n.padding),
                            r = e - l.width,
                            a = i - l.height,
                            o = Re(t.boxes),
                            s = o.vertical,
                            c = o.horizontal,
                            u = Object.freeze({
                                outerWidth: e,
                                outerHeight: i,
                                padding: l,
                                availableWidth: r,
                                vBoxMaxWidth: r / 2 / s.length,
                                hBoxMaxHeight: a / 2
                            }),
                            h = Le({
                                maxPadding: Le({}, l),
                                w: r,
                                h: a,
                                x: l.left,
                                y: l.top
                            }, l);
                        Ne(s.concat(c), u), Ye(s, h, u), Ye(c, h, u) && Ye(s, h, u), He(h), We(o.leftAndTop, h, u), h.x += h.w, h.y += h.h, We(o.rightAndBottom, h, u), t.chartArea = {
                            left: h.left,
                            top: h.top,
                            right: h.left + h.w,
                            bottom: h.top + h.h
                        }, at.each(o.chartArea, (function (e) {
                            var i = e.box;
                            Le(i, t.chartArea), i.update(h.w, h.h)
                        }))
                    }
                }
            },
            Xe = {
                acquireContext: function (t) {
                    return t && t.canvas && (t = t.canvas), t && t.getContext("2d") || null
                }
            },
            qe = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n",
            Ze = i(Object.freeze({
                __proto__: null,
                default: qe
            })),
            Ge = "$chartjs",
            Ue = "chartjs-",
            Ke = Ue + "size-monitor",
            $e = Ue + "render-monitor",
            Qe = Ue + "render-animation",
            Je = ["animationstart", "webkitAnimationStart"],
            ti = {
                touchstart: "mousedown",
                touchmove: "mousemove",
                touchend: "mouseup",
                pointerenter: "mouseenter",
                pointerdown: "mousedown",
                pointermove: "mousemove",
                pointerup: "mouseup",
                pointerleave: "mouseout",
                pointerout: "mouseout"
            };

        function ei(t, e) {
            var i = at.getStyle(t, e),
                n = i && i.match(/^(\d+)(\.\d+)?px$/);
            return n ? Number(n[1]) : void 0
        }

        function ii(t, e) {
            var i = t.style,
                n = t.getAttribute("height"),
                l = t.getAttribute("width");
            if (t[Ge] = {
                    initial: {
                        height: n,
                        width: l,
                        style: {
                            display: i.display,
                            height: i.height,
                            width: i.width
                        }
                    }
                }, i.display = i.display || "block", null === l || "" === l) {
                var r = ei(t, "width");
                void 0 !== r && (t.width = r)
            }
            if (null === n || "" === n)
                if ("" === t.style.height) t.height = t.width / (e.options.aspectRatio || 2);
                else {
                    var a = ei(t, "height");
                    void 0 !== r && (t.height = a)
                } return t
        }
        var ni = !! function () {
            var t = !1;
            try {
                var e = Object.defineProperty({}, "passive", {
                    get: function () {
                        t = !0
                    }
                });
                window.addEventListener("e", null, e)
            } catch (t) {}
            return t
        }() && {
            passive: !0
        };

        function li(t, e, i) {
            t.addEventListener(e, i, ni)
        }

        function ri(t, e, i) {
            t.removeEventListener(e, i, ni)
        }

        function ai(t, e, i, n, l) {
            return {
                type: t,
                chart: e,
                native: l || null,
                x: void 0 !== i ? i : null,
                y: void 0 !== n ? n : null
            }
        }

        function oi(t, e) {
            var i = ti[t.type] || t.type,
                n = at.getRelativePosition(t, e);
            return ai(i, e, n.x, n.y, t)
        }

        function si(t, e) {
            var i = !1,
                n = [];
            return function () {
                n = Array.prototype.slice.call(arguments), e = e || this, i || (i = !0, at.requestAnimFrame.call(window, (function () {
                    i = !1, t.apply(e, n)
                })))
            }
        }

        function ci(t) {
            var e = document.createElement("div");
            return e.className = t || "", e
        }

        function ui(t) {
            var e = 1e6,
                i = ci(Ke),
                n = ci(Ke + "-expand"),
                l = ci(Ke + "-shrink");
            n.appendChild(ci()), l.appendChild(ci()), i.appendChild(n), i.appendChild(l), i._reset = function () {
                n.scrollLeft = e, n.scrollTop = e, l.scrollLeft = e, l.scrollTop = e
            };
            var r = function () {
                i._reset(), t()
            };
            return li(n, "scroll", r.bind(n, "expand")), li(l, "scroll", r.bind(l, "shrink")), i
        }

        function hi(t, e) {
            var i = t[Ge] || (t[Ge] = {}),
                n = i.renderProxy = function (t) {
                    t.animationName === Qe && e()
                };
            at.each(Je, (function (e) {
                li(t, e, n)
            })), i.reflow = !!t.offsetParent, t.classList.add($e)
        }

        function di(t) {
            var e = t[Ge] || {},
                i = e.renderProxy;
            i && (at.each(Je, (function (e) {
                ri(t, e, i)
            })), delete e.renderProxy), t.classList.remove($e)
        }

        function fi(t, e, i) {
            var n = t[Ge] || (t[Ge] = {}),
                l = n.resizer = ui(si((function () {
                    if (n.resizer) {
                        var l = i.options.maintainAspectRatio && t.parentNode,
                            r = l ? l.clientWidth : 0;
                        e(ai("resize", i)), l && l.clientWidth < r && i.canvas && e(ai("resize", i))
                    }
                })));
            hi(t, (function () {
                if (n.resizer) {
                    var e = t.parentNode;
                    e && e !== l.parentNode && e.insertBefore(l, e.firstChild), l._reset()
                }
            }))
        }

        function pi(t) {
            var e = t[Ge] || {},
                i = e.resizer;
            delete e.resizer, di(t), i && i.parentNode && i.parentNode.removeChild(i)
        }

        function gi(t, e) {
            var i = t[Ge] || (t[Ge] = {});
            if (!i.containsStyles) {
                i.containsStyles = !0, e = "/* Chart.js */\n" + e;
                var n = document.createElement("style");
                n.setAttribute("type", "text/css"), n.appendChild(document.createTextNode(e)), t.appendChild(n)
            }
        }
        var mi = {
            disableCSSInjection: !1,
            _enabled: "undefined" != typeof window && "undefined" != typeof document,
            _ensureLoaded: function (t) {
                if (!this.disableCSSInjection) {
                    var e = t.getRootNode ? t.getRootNode() : document;
                    gi(e.host ? e : document.head, Ze)
                }
            },
            acquireContext: function (t, e) {
                "string" == typeof t ? t = document.getElementById(t) : t.length && (t = t[0]), t && t.canvas && (t = t.canvas);
                var i = t && t.getContext && t.getContext("2d");
                return i && i.canvas === t ? (this._ensureLoaded(t), ii(t, e), i) : null
            },
            releaseContext: function (t) {
                var e = t.canvas;
                if (e[Ge]) {
                    var i = e[Ge].initial;
                    ["height", "width"].forEach((function (t) {
                        var n = i[t];
                        at.isNullOrUndef(n) ? e.removeAttribute(t) : e.setAttribute(t, n)
                    })), at.each(i.style || {}, (function (t, i) {
                        e.style[i] = t
                    })), e.width = e.width, delete e[Ge]
                }
            },
            addEventListener: function (t, e, i) {
                var n = t.canvas;
                if ("resize" !== e) {
                    var l = i[Ge] || (i[Ge] = {});
                    li(n, e, (l.proxies || (l.proxies = {}))[t.id + "_" + e] = function (e) {
                        i(oi(e, t))
                    })
                } else fi(n, i, t)
            },
            removeEventListener: function (t, e, i) {
                var n = t.canvas;
                if ("resize" !== e) {
                    var l = ((i[Ge] || {}).proxies || {})[t.id + "_" + e];
                    l && ri(n, e, l)
                } else pi(n)
            }
        };
        at.addEvent = li, at.removeEvent = ri;
        var vi = mi._enabled ? mi : Xe,
            yi = at.extend({
                initialize: function () {},
                acquireContext: function () {},
                releaseContext: function () {},
                addEventListener: function () {},
                removeEventListener: function () {}
            }, vi);
        Q._set("global", {
            plugins: {}
        });
        var bi = {
                _plugins: [],
                _cacheId: 0,
                register: function (t) {
                    var e = this._plugins;
                    [].concat(t).forEach((function (t) {
                        -1 === e.indexOf(t) && e.push(t)
                    })), this._cacheId++
                },
                unregister: function (t) {
                    var e = this._plugins;
                    [].concat(t).forEach((function (t) {
                        var i = e.indexOf(t); - 1 !== i && e.splice(i, 1)
                    })), this._cacheId++
                },
                clear: function () {
                    this._plugins = [], this._cacheId++
                },
                count: function () {
                    return this._plugins.length
                },
                getAll: function () {
                    return this._plugins
                },
                notify: function (t, e, i) {
                    var n, l, r, a, o, s = this.descriptors(t),
                        c = s.length;
                    for (n = 0; n < c; ++n)
                        if ("function" == typeof (o = (r = (l = s[n]).plugin)[e]) && ((a = [t].concat(i || [])).push(l.options), !1 === o.apply(r, a))) return !1;
                    return !0
                },
                descriptors: function (t) {
                    var e = t.$plugins || (t.$plugins = {});
                    if (e.id === this._cacheId) return e.descriptors;
                    var i = [],
                        n = [],
                        l = t && t.config || {},
                        r = l.options && l.options.plugins || {};
                    return this._plugins.concat(l.plugins || []).forEach((function (t) {
                        if (-1 === i.indexOf(t)) {
                            var e = t.id,
                                l = r[e];
                            !1 !== l && (!0 === l && (l = at.clone(Q.global.plugins[e])), i.push(t), n.push({
                                plugin: t,
                                options: l || {}
                            }))
                        }
                    })), e.descriptors = n, e.id = this._cacheId, n
                },
                _invalidate: function (t) {
                    delete t.$plugins
                }
            },
            xi = {
                constructors: {},
                defaults: {},
                registerScaleType: function (t, e, i) {
                    this.constructors[t] = e, this.defaults[t] = at.clone(i)
                },
                getScaleConstructor: function (t) {
                    return this.constructors.hasOwnProperty(t) ? this.constructors[t] : void 0
                },
                getScaleDefaults: function (t) {
                    return this.defaults.hasOwnProperty(t) ? at.merge(Object.create(null), [Q.scale, this.defaults[t]]) : {}
                },
                updateScaleDefaults: function (t, e) {
                    var i = this;
                    i.defaults.hasOwnProperty(t) && (i.defaults[t] = at.extend(i.defaults[t], e))
                },
                addScalesToLayout: function (t) {
                    at.each(t.scales, (function (e) {
                        e.fullWidth = e.options.fullWidth, e.position = e.options.position, e.weight = e.options.weight, Ve.addBox(t, e)
                    }))
                }
            },
            wi = at.valueOrDefault,
            _i = at.rtl.getRtlAdapter;
        Q._set("global", {
            tooltips: {
                enabled: !0,
                custom: null,
                mode: "nearest",
                position: "average",
                intersect: !0,
                backgroundColor: "rgba(0,0,0,0.8)",
                titleFontStyle: "bold",
                titleSpacing: 2,
                titleMarginBottom: 6,
                titleFontColor: "#fff",
                titleAlign: "left",
                bodySpacing: 2,
                bodyFontColor: "#fff",
                bodyAlign: "left",
                footerFontStyle: "bold",
                footerSpacing: 2,
                footerMarginTop: 6,
                footerFontColor: "#fff",
                footerAlign: "left",
                yPadding: 6,
                xPadding: 6,
                caretPadding: 2,
                caretSize: 5,
                cornerRadius: 6,
                multiKeyBackground: "#fff",
                displayColors: !0,
                borderColor: "rgba(0,0,0,0)",
                borderWidth: 0,
                callbacks: {
                    beforeTitle: at.noop,
                    title: function (t, e) {
                        var i = "",
                            n = e.labels,
                            l = n ? n.length : 0;
                        if (t.length > 0) {
                            var r = t[0];
                            r.label ? i = r.label : r.xLabel ? i = r.xLabel : l > 0 && r.index < l && (i = n[r.index])
                        }
                        return i
                    },
                    afterTitle: at.noop,
                    beforeBody: at.noop,
                    beforeLabel: at.noop,
                    label: function (t, e) {
                        var i = e.datasets[t.datasetIndex].label || "";
                        return i && (i += ": "), at.isNullOrUndef(t.value) ? i += t.yLabel : i += t.value, i
                    },
                    labelColor: function (t, e) {
                        var i = e.getDatasetMeta(t.datasetIndex).data[t.index]._view;
                        return {
                            borderColor: i.borderColor,
                            backgroundColor: i.backgroundColor
                        }
                    },
                    labelTextColor: function () {
                        return this._options.bodyFontColor
                    },
                    afterLabel: at.noop,
                    afterBody: at.noop,
                    beforeFooter: at.noop,
                    footer: at.noop,
                    afterFooter: at.noop
                }
            }
        });
        var ki = {
            average: function (t) {
                if (!t.length) return !1;
                var e, i, n = 0,
                    l = 0,
                    r = 0;
                for (e = 0, i = t.length; e < i; ++e) {
                    var a = t[e];
                    if (a && a.hasValue()) {
                        var o = a.tooltipPosition();
                        n += o.x, l += o.y, ++r
                    }
                }
                return {
                    x: n / r,
                    y: l / r
                }
            },
            nearest: function (t, e) {
                var i, n, l, r = e.x,
                    a = e.y,
                    o = Number.POSITIVE_INFINITY;
                for (i = 0, n = t.length; i < n; ++i) {
                    var s = t[i];
                    if (s && s.hasValue()) {
                        var c = s.getCenterPoint(),
                            u = at.distanceBetweenPoints(e, c);
                        u < o && (o = u, l = s)
                    }
                }
                if (l) {
                    var h = l.tooltipPosition();
                    r = h.x, a = h.y
                }
                return {
                    x: r,
                    y: a
                }
            }
        };

        function Si(t, e) {
            return e && (at.isArray(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t
        }

        function Ai(t) {
            return ("string" == typeof t || t instanceof String) && t.indexOf("\n") > -1 ? t.split("\n") : t
        }

        function Mi(t) {
            var e = t._xScale,
                i = t._yScale || t._scale,
                n = t._index,
                l = t._datasetIndex,
                r = t._chart.getDatasetMeta(l).controller,
                a = r._getIndexScale(),
                o = r._getValueScale();
            return {
                xLabel: e ? e.getLabelForIndex(n, l) : "",
                yLabel: i ? i.getLabelForIndex(n, l) : "",
                label: a ? "" + a.getLabelForIndex(n, l) : "",
                value: o ? "" + o.getLabelForIndex(n, l) : "",
                index: n,
                datasetIndex: l,
                x: t._model.x,
                y: t._model.y
            }
        }

        function Ci(t) {
            var e = Q.global;
            return {
                xPadding: t.xPadding,
                yPadding: t.yPadding,
                xAlign: t.xAlign,
                yAlign: t.yAlign,
                rtl: t.rtl,
                textDirection: t.textDirection,
                bodyFontColor: t.bodyFontColor,
                _bodyFontFamily: wi(t.bodyFontFamily, e.defaultFontFamily),
                _bodyFontStyle: wi(t.bodyFontStyle, e.defaultFontStyle),
                _bodyAlign: t.bodyAlign,
                bodyFontSize: wi(t.bodyFontSize, e.defaultFontSize),
                bodySpacing: t.bodySpacing,
                titleFontColor: t.titleFontColor,
                _titleFontFamily: wi(t.titleFontFamily, e.defaultFontFamily),
                _titleFontStyle: wi(t.titleFontStyle, e.defaultFontStyle),
                titleFontSize: wi(t.titleFontSize, e.defaultFontSize),
                _titleAlign: t.titleAlign,
                titleSpacing: t.titleSpacing,
                titleMarginBottom: t.titleMarginBottom,
                footerFontColor: t.footerFontColor,
                _footerFontFamily: wi(t.footerFontFamily, e.defaultFontFamily),
                _footerFontStyle: wi(t.footerFontStyle, e.defaultFontStyle),
                footerFontSize: wi(t.footerFontSize, e.defaultFontSize),
                _footerAlign: t.footerAlign,
                footerSpacing: t.footerSpacing,
                footerMarginTop: t.footerMarginTop,
                caretSize: t.caretSize,
                cornerRadius: t.cornerRadius,
                backgroundColor: t.backgroundColor,
                opacity: 0,
                legendColorBackground: t.multiKeyBackground,
                displayColors: t.displayColors,
                borderColor: t.borderColor,
                borderWidth: t.borderWidth
            }
        }

        function Ei(t, e) {
            var i = t._chart.ctx,
                n = 2 * e.yPadding,
                l = 0,
                r = e.body,
                a = r.reduce((function (t, e) {
                    return t + e.before.length + e.lines.length + e.after.length
                }), 0);
            a += e.beforeBody.length + e.afterBody.length;
            var o = e.title.length,
                s = e.footer.length,
                c = e.titleFontSize,
                u = e.bodyFontSize,
                h = e.footerFontSize;
            n += o * c, n += o ? (o - 1) * e.titleSpacing : 0, n += o ? e.titleMarginBottom : 0, n += a * u, n += a ? (a - 1) * e.bodySpacing : 0, n += s ? e.footerMarginTop : 0, n += s * h, n += s ? (s - 1) * e.footerSpacing : 0;
            var d = 0,
                f = function (t) {
                    l = Math.max(l, i.measureText(t).width + d)
                };
            return i.font = at.fontString(c, e._titleFontStyle, e._titleFontFamily), at.each(e.title, f), i.font = at.fontString(u, e._bodyFontStyle, e._bodyFontFamily), at.each(e.beforeBody.concat(e.afterBody), f), d = e.displayColors ? u + 2 : 0, at.each(r, (function (t) {
                at.each(t.before, f), at.each(t.lines, f), at.each(t.after, f)
            })), d = 0, i.font = at.fontString(h, e._footerFontStyle, e._footerFontFamily), at.each(e.footer, f), {
                width: l += 2 * e.xPadding,
                height: n
            }
        }

        function Oi(t, e) {
            var i, n, l, r, a, o = t._model,
                s = t._chart,
                c = t._chart.chartArea,
                u = "center",
                h = "center";
            o.y < e.height ? h = "top" : o.y > s.height - e.height && (h = "bottom");
            var d = (c.left + c.right) / 2,
                f = (c.top + c.bottom) / 2;
            "center" === h ? (i = function (t) {
                return t <= d
            }, n = function (t) {
                return t > d
            }) : (i = function (t) {
                return t <= e.width / 2
            }, n = function (t) {
                return t >= s.width - e.width / 2
            }), l = function (t) {
                return t + e.width + o.caretSize + o.caretPadding > s.width
            }, r = function (t) {
                return t - e.width - o.caretSize - o.caretPadding < 0
            }, a = function (t) {
                return t <= f ? "top" : "bottom"
            }, i(o.x) ? (u = "left", l(o.x) && (u = "center", h = a(o.y))) : n(o.x) && (u = "right", r(o.x) && (u = "center", h = a(o.y)));
            var p = t._options;
            return {
                xAlign: p.xAlign ? p.xAlign : u,
                yAlign: p.yAlign ? p.yAlign : h
            }
        }

        function Ti(t, e, i, n) {
            var l = t.x,
                r = t.y,
                a = t.caretSize,
                o = t.caretPadding,
                s = t.cornerRadius,
                c = i.xAlign,
                u = i.yAlign,
                h = a + o,
                d = s + o;
            return "right" === c ? l -= e.width : "center" === c && ((l -= e.width / 2) + e.width > n.width && (l = n.width - e.width), l < 0 && (l = 0)), "top" === u ? r += h : r -= "bottom" === u ? e.height + h : e.height / 2, "center" === u ? "left" === c ? l += h : "right" === c && (l -= h) : "left" === c ? l -= d : "right" === c && (l += d), {
                x: l,
                y: r
            }
        }

        function Pi(t, e) {
            return "center" === e ? t.x + t.width / 2 : "right" === e ? t.x + t.width - t.xPadding : t.x + t.xPadding
        }

        function Li(t) {
            return Si([], Ai(t))
        }
        var Di = pt.extend({
                initialize: function () {
                    this._model = Ci(this._options), this._lastActive = []
                },
                getTitle: function () {
                    var t = this,
                        e = t._options.callbacks,
                        i = e.beforeTitle.apply(t, arguments),
                        n = e.title.apply(t, arguments),
                        l = e.afterTitle.apply(t, arguments),
                        r = [];
                    return r = Si(r, Ai(i)), r = Si(r, Ai(n)), r = Si(r, Ai(l))
                },
                getBeforeBody: function () {
                    return Li(this._options.callbacks.beforeBody.apply(this, arguments))
                },
                getBody: function (t, e) {
                    var i = this,
                        n = i._options.callbacks,
                        l = [];
                    return at.each(t, (function (t) {
                        var r = {
                            before: [],
                            lines: [],
                            after: []
                        };
                        Si(r.before, Ai(n.beforeLabel.call(i, t, e))), Si(r.lines, n.label.call(i, t, e)), Si(r.after, Ai(n.afterLabel.call(i, t, e))), l.push(r)
                    })), l
                },
                getAfterBody: function () {
                    return Li(this._options.callbacks.afterBody.apply(this, arguments))
                },
                getFooter: function () {
                    var t = this,
                        e = t._options.callbacks,
                        i = e.beforeFooter.apply(t, arguments),
                        n = e.footer.apply(t, arguments),
                        l = e.afterFooter.apply(t, arguments),
                        r = [];
                    return r = Si(r, Ai(i)), r = Si(r, Ai(n)), r = Si(r, Ai(l))
                },
                update: function (t) {
                    var e, i, n = this,
                        l = n._options,
                        r = n._model,
                        a = n._model = Ci(l),
                        o = n._active,
                        s = n._data,
                        c = {
                            xAlign: r.xAlign,
                            yAlign: r.yAlign
                        },
                        u = {
                            x: r.x,
                            y: r.y
                        },
                        h = {
                            width: r.width,
                            height: r.height
                        },
                        d = {
                            x: r.caretX,
                            y: r.caretY
                        };
                    if (o.length) {
                        a.opacity = 1;
                        var f = [],
                            p = [];
                        d = ki[l.position].call(n, o, n._eventPosition);
                        var g = [];
                        for (e = 0, i = o.length; e < i; ++e) g.push(Mi(o[e]));
                        l.filter && (g = g.filter((function (t) {
                            return l.filter(t, s)
                        }))), l.itemSort && (g = g.sort((function (t, e) {
                            return l.itemSort(t, e, s)
                        }))), at.each(g, (function (t) {
                            f.push(l.callbacks.labelColor.call(n, t, n._chart)), p.push(l.callbacks.labelTextColor.call(n, t, n._chart))
                        })), a.title = n.getTitle(g, s), a.beforeBody = n.getBeforeBody(g, s), a.body = n.getBody(g, s), a.afterBody = n.getAfterBody(g, s), a.footer = n.getFooter(g, s), a.x = d.x, a.y = d.y, a.caretPadding = l.caretPadding, a.labelColors = f, a.labelTextColors = p, a.dataPoints = g, u = Ti(a, h = Ei(this, a), c = Oi(this, h), n._chart)
                    } else a.opacity = 0;
                    return a.xAlign = c.xAlign, a.yAlign = c.yAlign, a.x = u.x, a.y = u.y, a.width = h.width, a.height = h.height, a.caretX = d.x, a.caretY = d.y, n._model = a, t && l.custom && l.custom.call(n, a), n
                },
                drawCaret: function (t, e) {
                    var i = this._chart.ctx,
                        n = this._view,
                        l = this.getCaretPosition(t, e, n);
                    i.lineTo(l.x1, l.y1), i.lineTo(l.x2, l.y2), i.lineTo(l.x3, l.y3)
                },
                getCaretPosition: function (t, e, i) {
                    var n, l, r, a, o, s, c = i.caretSize,
                        u = i.cornerRadius,
                        h = i.xAlign,
                        d = i.yAlign,
                        f = t.x,
                        p = t.y,
                        g = e.width,
                        m = e.height;
                    if ("center" === d) o = p + m / 2, "left" === h ? (l = (n = f) - c, r = n, a = o + c, s = o - c) : (l = (n = f + g) + c, r = n, a = o - c, s = o + c);
                    else if ("left" === h ? (n = (l = f + u + c) - c, r = l + c) : "right" === h ? (n = (l = f + g - u - c) - c, r = l + c) : (n = (l = i.caretX) - c, r = l + c), "top" === d) o = (a = p) - c, s = a;
                    else {
                        o = (a = p + m) + c, s = a;
                        var v = r;
                        r = n, n = v
                    }
                    return {
                        x1: n,
                        x2: l,
                        x3: r,
                        y1: a,
                        y2: o,
                        y3: s
                    }
                },
                drawTitle: function (t, e, i) {
                    var n, l, r, a = e.title,
                        o = a.length;
                    if (o) {
                        var s = _i(e.rtl, e.x, e.width);
                        for (t.x = Pi(e, e._titleAlign), i.textAlign = s.textAlign(e._titleAlign), i.textBaseline = "middle", n = e.titleFontSize, l = e.titleSpacing, i.fillStyle = e.titleFontColor, i.font = at.fontString(n, e._titleFontStyle, e._titleFontFamily), r = 0; r < o; ++r) i.fillText(a[r], s.x(t.x), t.y + n / 2), t.y += n + l, r + 1 === o && (t.y += e.titleMarginBottom - l)
                    }
                },
                drawBody: function (t, e, i) {
                    var n, l, r, a, o, s, c, u, h = e.bodyFontSize,
                        d = e.bodySpacing,
                        f = e._bodyAlign,
                        p = e.body,
                        g = e.displayColors,
                        m = 0,
                        v = g ? Pi(e, "left") : 0,
                        y = _i(e.rtl, e.x, e.width),
                        b = function (e) {
                            i.fillText(e, y.x(t.x + m), t.y + h / 2), t.y += h + d
                        },
                        x = y.textAlign(f);
                    for (i.textAlign = f, i.textBaseline = "middle", i.font = at.fontString(h, e._bodyFontStyle, e._bodyFontFamily), t.x = Pi(e, x), i.fillStyle = e.bodyFontColor, at.each(e.beforeBody, b), m = g && "right" !== x ? "center" === f ? h / 2 + 1 : h + 2 : 0, o = 0, c = p.length; o < c; ++o) {
                        for (n = p[o], l = e.labelTextColors[o], r = e.labelColors[o], i.fillStyle = l, at.each(n.before, b), s = 0, u = (a = n.lines).length; s < u; ++s) {
                            if (g) {
                                var w = y.x(v);
                                i.fillStyle = e.legendColorBackground, i.fillRect(y.leftForLtr(w, h), t.y, h, h), i.lineWidth = 1, i.strokeStyle = r.borderColor, i.strokeRect(y.leftForLtr(w, h), t.y, h, h), i.fillStyle = r.backgroundColor, i.fillRect(y.leftForLtr(y.xPlus(w, 1), h - 2), t.y + 1, h - 2, h - 2), i.fillStyle = l
                            }
                            b(a[s])
                        }
                        at.each(n.after, b)
                    }
                    m = 0, at.each(e.afterBody, b), t.y -= d
                },
                drawFooter: function (t, e, i) {
                    var n, l, r = e.footer,
                        a = r.length;
                    if (a) {
                        var o = _i(e.rtl, e.x, e.width);
                        for (t.x = Pi(e, e._footerAlign), t.y += e.footerMarginTop, i.textAlign = o.textAlign(e._footerAlign), i.textBaseline = "middle", n = e.footerFontSize, i.fillStyle = e.footerFontColor, i.font = at.fontString(n, e._footerFontStyle, e._footerFontFamily), l = 0; l < a; ++l) i.fillText(r[l], o.x(t.x), t.y + n / 2), t.y += n + e.footerSpacing
                    }
                },
                drawBackground: function (t, e, i, n) {
                    i.fillStyle = e.backgroundColor, i.strokeStyle = e.borderColor, i.lineWidth = e.borderWidth;
                    var l = e.xAlign,
                        r = e.yAlign,
                        a = t.x,
                        o = t.y,
                        s = n.width,
                        c = n.height,
                        u = e.cornerRadius;
                    i.beginPath(), i.moveTo(a + u, o), "top" === r && this.drawCaret(t, n), i.lineTo(a + s - u, o), i.quadraticCurveTo(a + s, o, a + s, o + u), "center" === r && "right" === l && this.drawCaret(t, n), i.lineTo(a + s, o + c - u), i.quadraticCurveTo(a + s, o + c, a + s - u, o + c), "bottom" === r && this.drawCaret(t, n), i.lineTo(a + u, o + c), i.quadraticCurveTo(a, o + c, a, o + c - u), "center" === r && "left" === l && this.drawCaret(t, n), i.lineTo(a, o + u), i.quadraticCurveTo(a, o, a + u, o), i.closePath(), i.fill(), e.borderWidth > 0 && i.stroke()
                },
                draw: function () {
                    var t = this._chart.ctx,
                        e = this._view;
                    if (0 !== e.opacity) {
                        var i = {
                                width: e.width,
                                height: e.height
                            },
                            n = {
                                x: e.x,
                                y: e.y
                            },
                            l = Math.abs(e.opacity < .001) ? 0 : e.opacity,
                            r = e.title.length || e.beforeBody.length || e.body.length || e.afterBody.length || e.footer.length;
                        this._options.enabled && r && (t.save(), t.globalAlpha = l, this.drawBackground(n, e, t, i), n.y += e.yPadding, at.rtl.overrideTextDirection(t, e.textDirection), this.drawTitle(n, e, t), this.drawBody(n, e, t), this.drawFooter(n, e, t), at.rtl.restoreTextDirection(t, e.textDirection), t.restore())
                    }
                },
                handleEvent: function (t) {
                    var e = this,
                        i = e._options,
                        n = !1;
                    return e._lastActive = e._lastActive || [], "mouseout" === t.type ? e._active = [] : (e._active = e._chart.getElementsAtEventForMode(t, i.mode, i), i.reverse && e._active.reverse()), (n = !at.arrayEquals(e._active, e._lastActive)) && (e._lastActive = e._active, (i.enabled || i.custom) && (e._eventPosition = {
                        x: t.x,
                        y: t.y
                    }, e.update(!0), e.pivot())), n
                }
            }),
            Ii = ki,
            ji = Di;
        ji.positioners = Ii;
        var Ni = at.valueOrDefault;

        function Ri() {
            return at.merge(Object.create(null), [].slice.call(arguments), {
                merger: function (t, e, i, n) {
                    if ("xAxes" === t || "yAxes" === t) {
                        var l, r, a, o = i[t].length;
                        for (e[t] || (e[t] = []), l = 0; l < o; ++l) a = i[t][l], r = Ni(a.type, "xAxes" === t ? "category" : "linear"), l >= e[t].length && e[t].push({}), !e[t][l].type || a.type && a.type !== e[t][l].type ? at.merge(e[t][l], [xi.getScaleDefaults(r), a]) : at.merge(e[t][l], a)
                    } else at._merger(t, e, i, n)
                }
            })
        }

        function Fi() {
            return at.merge(Object.create(null), [].slice.call(arguments), {
                merger: function (t, e, i, n) {
                    var l = e[t] || Object.create(null),
                        r = i[t];
                    "scales" === t ? e[t] = Ri(l, r) : "scale" === t ? e[t] = at.merge(l, [xi.getScaleDefaults(r.type), r]) : at._merger(t, e, i, n)
                }
            })
        }

        function zi(t) {
            var e = (t = t || Object.create(null)).data = t.data || {};
            return e.datasets = e.datasets || [], e.labels = e.labels || [], t.options = Fi(Q.global, Q[t.type], t.options || {}), t
        }

        function Hi(t) {
            var e = t.options;
            at.each(t.scales, (function (e) {
                Ve.removeBox(t, e)
            })), e = Fi(Q.global, Q[t.config.type], e), t.options = t.config.options = e, t.ensureScalesHaveIDs(), t.buildOrUpdateScales(), t.tooltip._options = e.tooltips, t.tooltip.initialize()
        }

        function Bi(t, e, i) {
            var n, l = function (t) {
                return t.id === n
            };
            do {
                n = e + i++
            } while (at.findIndex(t, l) >= 0);
            return n
        }

        function Yi(t) {
            return "top" === t || "bottom" === t
        }

        function Wi(t, e) {
            return function (i, n) {
                return i[t] === n[t] ? i[e] - n[e] : i[t] - n[t]
            }
        }
        Q._set("global", {
            elements: {},
            events: ["mousemove", "mouseout", "click", "touchstart", "touchmove"],
            hover: {
                onHover: null,
                mode: "nearest",
                intersect: !0,
                animationDuration: 400
            },
            onClick: null,
            maintainAspectRatio: !0,
            responsive: !0,
            responsiveAnimationDuration: 0
        });
        var Vi = function (t, e) {
            return this.construct(t, e), this
        };
        at.extend(Vi.prototype, {
            construct: function (t, e) {
                var i = this;
                e = zi(e);
                var n = yi.acquireContext(t, e),
                    l = n && n.canvas,
                    r = l && l.height,
                    a = l && l.width;
                i.id = at.uid(), i.ctx = n, i.canvas = l, i.config = e, i.width = a, i.height = r, i.aspectRatio = r ? a / r : null, i.options = e.options, i._bufferedRender = !1, i._layers = [], i.chart = i, i.controller = i, Vi.instances[i.id] = i, Object.defineProperty(i, "data", {
                    get: function () {
                        return i.config.data
                    },
                    set: function (t) {
                        i.config.data = t
                    }
                }), n && l ? (i.initialize(), i.update()) : console.error("Failed to create chart: can't acquire context from the given item")
            },
            initialize: function () {
                var t = this;
                return bi.notify(t, "beforeInit"), at.retinaScale(t, t.options.devicePixelRatio), t.bindEvents(), t.options.responsive && t.resize(!0), t.initToolTip(), bi.notify(t, "afterInit"), t
            },
            clear: function () {
                return at.canvas.clear(this), this
            },
            stop: function () {
                return vt.cancelAnimation(this), this
            },
            resize: function (t) {
                var e = this,
                    i = e.options,
                    n = e.canvas,
                    l = i.maintainAspectRatio && e.aspectRatio || null,
                    r = Math.max(0, Math.floor(at.getMaximumWidth(n))),
                    a = Math.max(0, Math.floor(l ? r / l : at.getMaximumHeight(n)));
                if ((e.width !== r || e.height !== a) && (n.width = e.width = r, n.height = e.height = a, n.style.width = r + "px", n.style.height = a + "px", at.retinaScale(e, i.devicePixelRatio), !t)) {
                    var o = {
                        width: r,
                        height: a
                    };
                    bi.notify(e, "resize", [o]), i.onResize && i.onResize(e, o), e.stop(), e.update({
                        duration: i.responsiveAnimationDuration
                    })
                }
            },
            ensureScalesHaveIDs: function () {
                var t = this.options,
                    e = t.scales || {},
                    i = t.scale;
                at.each(e.xAxes, (function (t, i) {
                    t.id || (t.id = Bi(e.xAxes, "x-axis-", i))
                })), at.each(e.yAxes, (function (t, i) {
                    t.id || (t.id = Bi(e.yAxes, "y-axis-", i))
                })), i && (i.id = i.id || "scale")
            },
            buildOrUpdateScales: function () {
                var t = this,
                    e = t.options,
                    i = t.scales || {},
                    n = [],
                    l = Object.keys(i).reduce((function (t, e) {
                        return t[e] = !1, t
                    }), {});
                e.scales && (n = n.concat((e.scales.xAxes || []).map((function (t) {
                    return {
                        options: t,
                        dtype: "category",
                        dposition: "bottom"
                    }
                })), (e.scales.yAxes || []).map((function (t) {
                    return {
                        options: t,
                        dtype: "linear",
                        dposition: "left"
                    }
                })))), e.scale && n.push({
                    options: e.scale,
                    dtype: "radialLinear",
                    isDefault: !0,
                    dposition: "chartArea"
                }), at.each(n, (function (e) {
                    var n = e.options,
                        r = n.id,
                        a = Ni(n.type, e.dtype);
                    Yi(n.position) !== Yi(e.dposition) && (n.position = e.dposition), l[r] = !0;
                    var o = null;
                    if (r in i && i[r].type === a)(o = i[r]).options = n, o.ctx = t.ctx, o.chart = t;
                    else {
                        var s = xi.getScaleConstructor(a);
                        if (!s) return;
                        o = new s({
                            id: r,
                            type: a,
                            options: n,
                            ctx: t.ctx,
                            chart: t
                        }), i[o.id] = o
                    }
                    o.mergeTicksOptions(), e.isDefault && (t.scale = o)
                })), at.each(l, (function (t, e) {
                    t || delete i[e]
                })), t.scales = i, xi.addScalesToLayout(this)
            },
            buildOrUpdateControllers: function () {
                var t, e, i = this,
                    n = [],
                    l = i.data.datasets;
                for (t = 0, e = l.length; t < e; t++) {
                    var r = l[t],
                        a = i.getDatasetMeta(t),
                        o = r.type || i.config.type;
                    if (a.type && a.type !== o && (i.destroyDatasetMeta(t), a = i.getDatasetMeta(t)), a.type = o, a.order = r.order || 0, a.index = t, a.controller) a.controller.updateIndex(t), a.controller.linkScales();
                    else {
                        var s = Se[a.type];
                        if (void 0 === s) throw new Error('"' + a.type + '" is not a chart type.');
                        a.controller = new s(i, t), n.push(a.controller)
                    }
                }
                return n
            },
            resetElements: function () {
                var t = this;
                at.each(t.data.datasets, (function (e, i) {
                    t.getDatasetMeta(i).controller.reset()
                }), t)
            },
            reset: function () {
                this.resetElements(), this.tooltip.initialize()
            },
            update: function (t) {
                var e, i, n = this;
                if (t && "object" == typeof t || (t = {
                        duration: t,
                        lazy: arguments[1]
                    }), Hi(n), bi._invalidate(n), !1 !== bi.notify(n, "beforeUpdate")) {
                    n.tooltip._data = n.data;
                    var l = n.buildOrUpdateControllers();
                    for (e = 0, i = n.data.datasets.length; e < i; e++) n.getDatasetMeta(e).controller.buildOrUpdateElements();
                    n.updateLayout(), n.options.animation && n.options.animation.duration && at.each(l, (function (t) {
                        t.reset()
                    })), n.updateDatasets(), n.tooltip.initialize(), n.lastActive = [], bi.notify(n, "afterUpdate"), n._layers.sort(Wi("z", "_idx")), n._bufferedRender ? n._bufferedRequest = {
                        duration: t.duration,
                        easing: t.easing,
                        lazy: t.lazy
                    } : n.render(t)
                }
            },
            updateLayout: function () {
                var t = this;
                !1 !== bi.notify(t, "beforeLayout") && (Ve.update(this, this.width, this.height), t._layers = [], at.each(t.boxes, (function (e) {
                    e._configure && e._configure(), t._layers.push.apply(t._layers, e._layers())
                }), t), t._layers.forEach((function (t, e) {
                    t._idx = e
                })), bi.notify(t, "afterScaleUpdate"), bi.notify(t, "afterLayout"))
            },
            updateDatasets: function () {
                var t = this;
                if (!1 !== bi.notify(t, "beforeDatasetsUpdate")) {
                    for (var e = 0, i = t.data.datasets.length; e < i; ++e) t.updateDataset(e);
                    bi.notify(t, "afterDatasetsUpdate")
                }
            },
            updateDataset: function (t) {
                var e = this,
                    i = e.getDatasetMeta(t),
                    n = {
                        meta: i,
                        index: t
                    };
                !1 !== bi.notify(e, "beforeDatasetUpdate", [n]) && (i.controller._update(), bi.notify(e, "afterDatasetUpdate", [n]))
            },
            render: function (t) {
                var e = this;
                t && "object" == typeof t || (t = {
                    duration: t,
                    lazy: arguments[1]
                });
                var i = e.options.animation,
                    n = Ni(t.duration, i && i.duration),
                    l = t.lazy;
                if (!1 !== bi.notify(e, "beforeRender")) {
                    var r = function (t) {
                        bi.notify(e, "afterRender"), at.callback(i && i.onComplete, [t], e)
                    };
                    if (i && n) {
                        var a = new mt({
                            numSteps: n / 16.66,
                            easing: t.easing || i.easing,
                            render: function (t, e) {
                                var i = at.easing.effects[e.easing],
                                    n = e.currentStep,
                                    l = n / e.numSteps;
                                t.draw(i(l), l, n)
                            },
                            onAnimationProgress: i.onProgress,
                            onAnimationComplete: r
                        });
                        vt.addAnimation(e, a, n, l)
                    } else e.draw(), r(new mt({
                        numSteps: 0,
                        chart: e
                    }));
                    return e
                }
            },
            draw: function (t) {
                var e, i, n = this;
                if (n.clear(), at.isNullOrUndef(t) && (t = 1), n.transition(t), !(n.width <= 0 || n.height <= 0) && !1 !== bi.notify(n, "beforeDraw", [t])) {
                    for (i = n._layers, e = 0; e < i.length && i[e].z <= 0; ++e) i[e].draw(n.chartArea);
                    for (n.drawDatasets(t); e < i.length; ++e) i[e].draw(n.chartArea);
                    n._drawTooltip(t), bi.notify(n, "afterDraw", [t])
                }
            },
            transition: function (t) {
                for (var e = this, i = 0, n = (e.data.datasets || []).length; i < n; ++i) e.isDatasetVisible(i) && e.getDatasetMeta(i).controller.transition(t);
                e.tooltip.transition(t)
            },
            _getSortedDatasetMetas: function (t) {
                var e, i, n = this,
                    l = [];
                for (e = 0, i = (n.data.datasets || []).length; e < i; ++e) t && !n.isDatasetVisible(e) || l.push(n.getDatasetMeta(e));
                return l.sort(Wi("order", "index")), l
            },
            _getSortedVisibleDatasetMetas: function () {
                return this._getSortedDatasetMetas(!0)
            },
            drawDatasets: function (t) {
                var e, i, n = this;
                if (!1 !== bi.notify(n, "beforeDatasetsDraw", [t])) {
                    for (i = (e = n._getSortedVisibleDatasetMetas()).length - 1; i >= 0; --i) n.drawDataset(e[i], t);
                    bi.notify(n, "afterDatasetsDraw", [t])
                }
            },
            drawDataset: function (t, e) {
                var i = this,
                    n = {
                        meta: t,
                        index: t.index,
                        easingValue: e
                    };
                !1 !== bi.notify(i, "beforeDatasetDraw", [n]) && (t.controller.draw(e), bi.notify(i, "afterDatasetDraw", [n]))
            },
            _drawTooltip: function (t) {
                var e = this,
                    i = e.tooltip,
                    n = {
                        tooltip: i,
                        easingValue: t
                    };
                !1 !== bi.notify(e, "beforeTooltipDraw", [n]) && (i.draw(), bi.notify(e, "afterTooltipDraw", [n]))
            },
            getElementAtEvent: function (t) {
                return Pe.modes.single(this, t)
            },
            getElementsAtEvent: function (t) {
                return Pe.modes.label(this, t, {
                    intersect: !0
                })
            },
            getElementsAtXAxis: function (t) {
                return Pe.modes["x-axis"](this, t, {
                    intersect: !0
                })
            },
            getElementsAtEventForMode: function (t, e, i) {
                var n = Pe.modes[e];
                return "function" == typeof n ? n(this, t, i) : []
            },
            getDatasetAtEvent: function (t) {
                return Pe.modes.dataset(this, t, {
                    intersect: !0
                })
            },
            getDatasetMeta: function (t) {
                var e = this,
                    i = e.data.datasets[t];
                i._meta || (i._meta = {});
                var n = i._meta[e.id];
                return n || (n = i._meta[e.id] = {
                    type: null,
                    data: [],
                    dataset: null,
                    controller: null,
                    hidden: null,
                    xAxisID: null,
                    yAxisID: null,
                    order: i.order || 0,
                    index: t
                }), n
            },
            getVisibleDatasetCount: function () {
                for (var t = 0, e = 0, i = this.data.datasets.length; e < i; ++e) this.isDatasetVisible(e) && t++;
                return t
            },
            isDatasetVisible: function (t) {
                var e = this.getDatasetMeta(t);
                return "boolean" == typeof e.hidden ? !e.hidden : !this.data.datasets[t].hidden
            },
            generateLegend: function () {
                return this.options.legendCallback(this)
            },
            destroyDatasetMeta: function (t) {
                var e = this.id,
                    i = this.data.datasets[t],
                    n = i._meta && i._meta[e];
                n && (n.controller.destroy(), delete i._meta[e])
            },
            destroy: function () {
                var t, e, i = this,
                    n = i.canvas;
                for (i.stop(), t = 0, e = i.data.datasets.length; t < e; ++t) i.destroyDatasetMeta(t);
                n && (i.unbindEvents(), at.canvas.clear(i), yi.releaseContext(i.ctx), i.canvas = null, i.ctx = null), bi.notify(i, "destroy"), delete Vi.instances[i.id]
            },
            toBase64Image: function () {
                return this.canvas.toDataURL.apply(this.canvas, arguments)
            },
            initToolTip: function () {
                var t = this;
                t.tooltip = new ji({
                    _chart: t,
                    _chartInstance: t,
                    _data: t.data,
                    _options: t.options.tooltips
                }, t)
            },
            bindEvents: function () {
                var t = this,
                    e = t._listeners = {},
                    i = function () {
                        t.eventHandler.apply(t, arguments)
                    };
                at.each(t.options.events, (function (n) {
                    yi.addEventListener(t, n, i), e[n] = i
                })), t.options.responsive && (i = function () {
                    t.resize()
                }, yi.addEventListener(t, "resize", i), e.resize = i)
            },
            unbindEvents: function () {
                var t = this,
                    e = t._listeners;
                e && (delete t._listeners, at.each(e, (function (e, i) {
                    yi.removeEventListener(t, i, e)
                })))
            },
            updateHoverStyle: function (t, e, i) {
                var n, l, r, a = i ? "set" : "remove";
                for (l = 0, r = t.length; l < r; ++l)(n = t[l]) && this.getDatasetMeta(n._datasetIndex).controller[a + "HoverStyle"](n);
                "dataset" === e && this.getDatasetMeta(t[0]._datasetIndex).controller["_" + a + "DatasetHoverStyle"]()
            },
            eventHandler: function (t) {
                var e = this,
                    i = e.tooltip;
                if (!1 !== bi.notify(e, "beforeEvent", [t])) {
                    e._bufferedRender = !0, e._bufferedRequest = null;
                    var n = e.handleEvent(t);
                    i && (n = i._start ? i.handleEvent(t) : n | i.handleEvent(t)), bi.notify(e, "afterEvent", [t]);
                    var l = e._bufferedRequest;
                    return l ? e.render(l) : n && !e.animating && (e.stop(), e.render({
                        duration: e.options.hover.animationDuration,
                        lazy: !0
                    })), e._bufferedRender = !1, e._bufferedRequest = null, e
                }
            },
            handleEvent: function (t) {
                var e = this,
                    i = e.options || {},
                    n = i.hover,
                    l = !1;
                return e.lastActive = e.lastActive || [], "mouseout" === t.type ? e.active = [] : e.active = e.getElementsAtEventForMode(t, n.mode, n), at.callback(i.onHover || i.hover.onHover, [t.native, e.active], e), "mouseup" !== t.type && "click" !== t.type || i.onClick && i.onClick.call(e, t.native, e.active), e.lastActive.length && e.updateHoverStyle(e.lastActive, n.mode, !1), e.active.length && n.mode && e.updateHoverStyle(e.active, n.mode, !0), l = !at.arrayEquals(e.active, e.lastActive), e.lastActive = e.active, l
            }
        }), Vi.instances = {};
        var Xi = Vi;
        Vi.Controller = Vi, Vi.types = {}, at.configMerge = Fi, at.scaleMerge = Ri;
        var qi = function () {
            function t(t, e, i) {
                var n;
                return "string" == typeof t ? (n = parseInt(t, 10), -1 !== t.indexOf("%") && (n = n / 100 * e.parentNode[i])) : n = t, n
            }

            function e(t) {
                return null != t && "none" !== t
            }

            function i(i, n, l) {
                var r = document.defaultView,
                    a = at._getParentNode(i),
                    o = r.getComputedStyle(i)[n],
                    s = r.getComputedStyle(a)[n],
                    c = e(o),
                    u = e(s),
                    h = Number.POSITIVE_INFINITY;
                return c || u ? Math.min(c ? t(o, i, l) : h, u ? t(s, a, l) : h) : "none"
            }
            at.where = function (t, e) {
                if (at.isArray(t) && Array.prototype.filter) return t.filter(e);
                var i = [];
                return at.each(t, (function (t) {
                    e(t) && i.push(t)
                })), i
            }, at.findIndex = Array.prototype.findIndex ? function (t, e, i) {
                return t.findIndex(e, i)
            } : function (t, e, i) {
                i = void 0 === i ? t : i;
                for (var n = 0, l = t.length; n < l; ++n)
                    if (e.call(i, t[n], n, t)) return n;
                return -1
            }, at.findNextWhere = function (t, e, i) {
                at.isNullOrUndef(i) && (i = -1);
                for (var n = i + 1; n < t.length; n++) {
                    var l = t[n];
                    if (e(l)) return l
                }
            }, at.findPreviousWhere = function (t, e, i) {
                at.isNullOrUndef(i) && (i = t.length);
                for (var n = i - 1; n >= 0; n--) {
                    var l = t[n];
                    if (e(l)) return l
                }
            }, at.isNumber = function (t) {
                return !isNaN(parseFloat(t)) && isFinite(t)
            }, at.almostEquals = function (t, e, i) {
                return Math.abs(t - e) < i
            }, at.almostWhole = function (t, e) {
                var i = Math.round(t);
                return i - e <= t && i + e >= t
            }, at.max = function (t) {
                return t.reduce((function (t, e) {
                    return isNaN(e) ? t : Math.max(t, e)
                }), Number.NEGATIVE_INFINITY)
            }, at.min = function (t) {
                return t.reduce((function (t, e) {
                    return isNaN(e) ? t : Math.min(t, e)
                }), Number.POSITIVE_INFINITY)
            }, at.sign = Math.sign ? function (t) {
                return Math.sign(t)
            } : function (t) {
                return 0 == (t = +t) || isNaN(t) ? t : t > 0 ? 1 : -1
            }, at.toRadians = function (t) {
                return t * (Math.PI / 180)
            }, at.toDegrees = function (t) {
                return t * (180 / Math.PI)
            }, at._decimalPlaces = function (t) {
                if (at.isFinite(t)) {
                    for (var e = 1, i = 0; Math.round(t * e) / e !== t;) e *= 10, i++;
                    return i
                }
            }, at.getAngleFromPoint = function (t, e) {
                var i = e.x - t.x,
                    n = e.y - t.y,
                    l = Math.sqrt(i * i + n * n),
                    r = Math.atan2(n, i);
                return r < -.5 * Math.PI && (r += 2 * Math.PI), {
                    angle: r,
                    distance: l
                }
            }, at.distanceBetweenPoints = function (t, e) {
                return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))
            }, at.aliasPixel = function (t) {
                return t % 2 == 0 ? 0 : .5
            }, at._alignPixel = function (t, e, i) {
                var n = t.currentDevicePixelRatio,
                    l = i / 2;
                return Math.round((e - l) * n) / n + l
            }, at.splineCurve = function (t, e, i, n) {
                var l = t.skip ? e : t,
                    r = e,
                    a = i.skip ? e : i,
                    o = Math.sqrt(Math.pow(r.x - l.x, 2) + Math.pow(r.y - l.y, 2)),
                    s = Math.sqrt(Math.pow(a.x - r.x, 2) + Math.pow(a.y - r.y, 2)),
                    c = o / (o + s),
                    u = s / (o + s),
                    h = n * (c = isNaN(c) ? 0 : c),
                    d = n * (u = isNaN(u) ? 0 : u);
                return {
                    previous: {
                        x: r.x - h * (a.x - l.x),
                        y: r.y - h * (a.y - l.y)
                    },
                    next: {
                        x: r.x + d * (a.x - l.x),
                        y: r.y + d * (a.y - l.y)
                    }
                }
            }, at.EPSILON = Number.EPSILON || 1e-14, at.splineCurveMonotone = function (t) {
                var e, i, n, l, r, a, o, s, c, u = (t || []).map((function (t) {
                        return {
                            model: t._model,
                            deltaK: 0,
                            mK: 0
                        }
                    })),
                    h = u.length;
                for (e = 0; e < h; ++e)
                    if (!(n = u[e]).model.skip) {
                        if (i = e > 0 ? u[e - 1] : null, (l = e < h - 1 ? u[e + 1] : null) && !l.model.skip) {
                            var d = l.model.x - n.model.x;
                            n.deltaK = 0 !== d ? (l.model.y - n.model.y) / d : 0
                        }!i || i.model.skip ? n.mK = n.deltaK : !l || l.model.skip ? n.mK = i.deltaK : this.sign(i.deltaK) !== this.sign(n.deltaK) ? n.mK = 0 : n.mK = (i.deltaK + n.deltaK) / 2
                    } for (e = 0; e < h - 1; ++e) n = u[e], l = u[e + 1], n.model.skip || l.model.skip || (at.almostEquals(n.deltaK, 0, this.EPSILON) ? n.mK = l.mK = 0 : (r = n.mK / n.deltaK, a = l.mK / n.deltaK, (s = Math.pow(r, 2) + Math.pow(a, 2)) <= 9 || (o = 3 / Math.sqrt(s), n.mK = r * o * n.deltaK, l.mK = a * o * n.deltaK)));
                for (e = 0; e < h; ++e)(n = u[e]).model.skip || (i = e > 0 ? u[e - 1] : null, l = e < h - 1 ? u[e + 1] : null, i && !i.model.skip && (c = (n.model.x - i.model.x) / 3, n.model.controlPointPreviousX = n.model.x - c, n.model.controlPointPreviousY = n.model.y - c * n.mK), l && !l.model.skip && (c = (l.model.x - n.model.x) / 3, n.model.controlPointNextX = n.model.x + c, n.model.controlPointNextY = n.model.y + c * n.mK))
            }, at.nextItem = function (t, e, i) {
                return i ? e >= t.length - 1 ? t[0] : t[e + 1] : e >= t.length - 1 ? t[t.length - 1] : t[e + 1]
            }, at.previousItem = function (t, e, i) {
                return i ? e <= 0 ? t[t.length - 1] : t[e - 1] : e <= 0 ? t[0] : t[e - 1]
            }, at.niceNum = function (t, e) {
                var i = Math.floor(at.log10(t)),
                    n = t / Math.pow(10, i);
                return (e ? n < 1.5 ? 1 : n < 3 ? 2 : n < 7 ? 5 : 10 : n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * Math.pow(10, i)
            }, at.requestAnimFrame = "undefined" == typeof window ? function (t) {
                t()
            } : window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (t) {
                return window.setTimeout(t, 1e3 / 60)
            }, at.getRelativePosition = function (t, e) {
                var i, n, l = t.originalEvent || t,
                    r = t.target || t.srcElement,
                    a = r.getBoundingClientRect(),
                    o = l.touches;
                o && o.length > 0 ? (i = o[0].clientX, n = o[0].clientY) : (i = l.clientX, n = l.clientY);
                var s = parseFloat(at.getStyle(r, "padding-left")),
                    c = parseFloat(at.getStyle(r, "padding-top")),
                    u = parseFloat(at.getStyle(r, "padding-right")),
                    h = parseFloat(at.getStyle(r, "padding-bottom")),
                    d = a.right - a.left - s - u,
                    f = a.bottom - a.top - c - h;
                return {
                    x: i = Math.round((i - a.left - s) / d * r.width / e.currentDevicePixelRatio),
                    y: n = Math.round((n - a.top - c) / f * r.height / e.currentDevicePixelRatio)
                }
            }, at.getConstraintWidth = function (t) {
                return i(t, "max-width", "clientWidth")
            }, at.getConstraintHeight = function (t) {
                return i(t, "max-height", "clientHeight")
            }, at._calculatePadding = function (t, e, i) {
                return (e = at.getStyle(t, e)).indexOf("%") > -1 ? i * parseInt(e, 10) / 100 : parseInt(e, 10)
            }, at._getParentNode = function (t) {
                var e = t.parentNode;
                return e && "[object ShadowRoot]" === e.toString() && (e = e.host), e
            }, at.getMaximumWidth = function (t) {
                var e = at._getParentNode(t);
                if (!e) return t.clientWidth;
                var i = e.clientWidth,
                    n = i - at._calculatePadding(e, "padding-left", i) - at._calculatePadding(e, "padding-right", i),
                    l = at.getConstraintWidth(t);
                return isNaN(l) ? n : Math.min(n, l)
            }, at.getMaximumHeight = function (t) {
                var e = at._getParentNode(t);
                if (!e) return t.clientHeight;
                var i = e.clientHeight,
                    n = i - at._calculatePadding(e, "padding-top", i) - at._calculatePadding(e, "padding-bottom", i),
                    l = at.getConstraintHeight(t);
                return isNaN(l) ? n : Math.min(n, l)
            }, at.getStyle = function (t, e) {
                return t.currentStyle ? t.currentStyle[e] : document.defaultView.getComputedStyle(t, null).getPropertyValue(e)
            }, at.retinaScale = function (t, e) {
                var i = t.currentDevicePixelRatio = e || "undefined" != typeof window && window.devicePixelRatio || 1;
                if (1 !== i) {
                    var n = t.canvas,
                        l = t.height,
                        r = t.width;
                    n.height = l * i, n.width = r * i, t.ctx.scale(i, i), n.style.height || n.style.width || (n.style.height = l + "px", n.style.width = r + "px")
                }
            }, at.fontString = function (t, e, i) {
                return e + " " + t + "px " + i
            }, at.longestText = function (t, e, i, n) {
                var l = (n = n || {}).data = n.data || {},
                    r = n.garbageCollect = n.garbageCollect || [];
                n.font !== e && (l = n.data = {}, r = n.garbageCollect = [], n.font = e), t.font = e;
                var a, o, s, c, u, h = 0,
                    d = i.length;
                for (a = 0; a < d; a++)
                    if (null != (c = i[a]) && !0 !== at.isArray(c)) h = at.measureText(t, l, r, h, c);
                    else if (at.isArray(c))
                    for (o = 0, s = c.length; o < s; o++) null == (u = c[o]) || at.isArray(u) || (h = at.measureText(t, l, r, h, u));
                var f = r.length / 2;
                if (f > i.length) {
                    for (a = 0; a < f; a++) delete l[r[a]];
                    r.splice(0, f)
                }
                return h
            }, at.measureText = function (t, e, i, n, l) {
                var r = e[l];
                return r || (r = e[l] = t.measureText(l).width, i.push(l)), r > n && (n = r), n
            }, at.numberOfLabelLines = function (t) {
                var e = 1;
                return at.each(t, (function (t) {
                    at.isArray(t) && t.length > e && (e = t.length)
                })), e
            }, at.color = N ? function (t) {
                return t instanceof CanvasGradient && (t = Q.global.defaultColor), N(t)
            } : function (t) {
                return console.error("Color.js not found!"), t
            }, at.getHoverColor = function (t) {
                return t instanceof CanvasPattern || t instanceof CanvasGradient ? t : at.color(t).saturate(.5).darken(.1).rgbString()
            }
        };

        function Zi() {
            throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.")
        }

        function Gi(t) {
            this.options = t || {}
        }
        at.extend(Gi.prototype, {
            formats: Zi,
            parse: Zi,
            format: Zi,
            add: Zi,
            diff: Zi,
            startOf: Zi,
            endOf: Zi,
            _create: function (t) {
                return t
            }
        }), Gi.override = function (t) {
            at.extend(Gi.prototype, t)
        };
        var Ui = {
                _date: Gi
            },
            Ki = {
                formatters: {
                    values: function (t) {
                        return at.isArray(t) ? t : "" + t
                    },
                    linear: function (t, e, i) {
                        var n = i.length > 3 ? i[2] - i[1] : i[1] - i[0];
                        Math.abs(n) > 1 && t !== Math.floor(t) && (n = t - Math.floor(t));
                        var l = at.log10(Math.abs(n)),
                            r = "";
                        if (0 !== t)
                            if (Math.max(Math.abs(i[0]), Math.abs(i[i.length - 1])) < 1e-4) {
                                var a = at.log10(Math.abs(t)),
                                    o = Math.floor(a) - Math.floor(l);
                                o = Math.max(Math.min(o, 20), 0), r = t.toExponential(o)
                            } else {
                                var s = -1 * Math.floor(l);
                                s = Math.max(Math.min(s, 20), 0), r = t.toFixed(s)
                            }
                        else r = "0";
                        return r
                    },
                    logarithmic: function (t, e, i) {
                        var n = t / Math.pow(10, Math.floor(at.log10(t)));
                        return 0 === t ? "0" : 1 === n || 2 === n || 5 === n || 0 === e || e === i.length - 1 ? t.toExponential() : ""
                    }
                }
            },
            $i = at.isArray,
            Qi = at.isNullOrUndef,
            Ji = at.valueOrDefault,
            tn = at.valueAtIndexOrDefault;

        function en(t, e) {
            for (var i = [], n = t.length / e, l = 0, r = t.length; l < r; l += n) i.push(t[Math.floor(l)]);
            return i
        }

        function nn(t, e, i) {
            var n, l = t.getTicks().length,
                r = Math.min(e, l - 1),
                a = t.getPixelForTick(r),
                o = t._startPixel,
                s = t._endPixel,
                c = 1e-6;
            if (!(i && (n = 1 === l ? Math.max(a - o, s - a) : 0 === e ? (t.getPixelForTick(1) - a) / 2 : (a - t.getPixelForTick(r - 1)) / 2, (a += r < e ? n : -n) < o - c || a > s + c))) return a
        }

        function ln(t, e) {
            at.each(t, (function (t) {
                var i, n = t.gc,
                    l = n.length / 2;
                if (l > e) {
                    for (i = 0; i < l; ++i) delete t.data[n[i]];
                    n.splice(0, l)
                }
            }))
        }

        function rn(t, e, i, n) {
            var l, r, a, o, s, c, u, h, d, f, p, g, m, v = i.length,
                y = [],
                b = [],
                x = [],
                w = 0,
                _ = 0;
            for (l = 0; l < v; ++l) {
                if (o = i[l].label, s = i[l].major ? e.major : e.minor, t.font = c = s.string, u = n[c] = n[c] || {
                        data: {},
                        gc: []
                    }, h = s.lineHeight, d = f = 0, Qi(o) || $i(o)) {
                    if ($i(o))
                        for (r = 0, a = o.length; r < a; ++r) p = o[r], Qi(p) || $i(p) || (d = at.measureText(t, u.data, u.gc, d, p), f += h)
                } else d = at.measureText(t, u.data, u.gc, d, o), f = h;
                y.push(d), b.push(f), x.push(h / 2), w = Math.max(d, w), _ = Math.max(f, _)
            }

            function k(t) {
                return {
                    width: y[t] || 0,
                    height: b[t] || 0,
                    offset: x[t] || 0
                }
            }
            return ln(n, v), g = y.indexOf(w), m = b.indexOf(_), {
                first: k(0),
                last: k(v - 1),
                widest: k(g),
                highest: k(m)
            }
        }

        function an(t) {
            return t.drawTicks ? t.tickMarkLength : 0
        }

        function on(t) {
            var e, i;
            return t.display ? (e = at.options._parseFont(t), i = at.options.toPadding(t.padding), e.lineHeight + i.height) : 0
        }

        function sn(t, e) {
            return at.extend(at.options._parseFont({
                fontFamily: Ji(e.fontFamily, t.fontFamily),
                fontSize: Ji(e.fontSize, t.fontSize),
                fontStyle: Ji(e.fontStyle, t.fontStyle),
                lineHeight: Ji(e.lineHeight, t.lineHeight)
            }), {
                color: at.options.resolve([e.fontColor, t.fontColor, Q.global.defaultFontColor])
            })
        }

        function cn(t) {
            var e = sn(t, t.minor);
            return {
                minor: e,
                major: t.major.enabled ? sn(t, t.major) : e
            }
        }

        function un(t) {
            var e, i, n, l = [];
            for (i = 0, n = t.length; i < n; ++i) void 0 !== (e = t[i])._index && l.push(e);
            return l
        }

        function hn(t) {
            var e, i, n = t.length;
            if (n < 2) return !1;
            for (i = t[0], e = 1; e < n; ++e)
                if (t[e] - t[e - 1] !== i) return !1;
            return i
        }

        function dn(t, e, i, n) {
            var l, r, a, o, s = hn(t),
                c = (e.length - 1) / n;
            if (!s) return Math.max(c, 1);
            for (a = 0, o = (l = at.math._factorize(s)).length - 1; a < o; a++)
                if ((r = l[a]) > c) return r;
            return Math.max(c, 1)
        }

        function fn(t) {
            var e, i, n = [];
            for (e = 0, i = t.length; e < i; e++) t[e].major && n.push(e);
            return n
        }

        function pn(t, e, i) {
            var n, l, r = 0,
                a = e[0];
            for (i = Math.ceil(i), n = 0; n < t.length; n++) l = t[n], n === a ? (l._index = n, a = e[++r * i]) : delete l.label
        }

        function gn(t, e, i, n) {
            var l, r, a, o, s = Ji(i, 0),
                c = Math.min(Ji(n, t.length), t.length),
                u = 0;
            for (e = Math.ceil(e), n && (e = (l = n - i) / Math.floor(l / e)), o = s; o < 0;) u++, o = Math.round(s + u * e);
            for (r = Math.max(s, 0); r < c; r++) a = t[r], r === o ? (a._index = r, u++, o = Math.round(s + u * e)) : delete a.label
        }
        Q._set("scale", {
            display: !0,
            position: "left",
            offset: !1,
            gridLines: {
                display: !0,
                color: "rgba(0,0,0,0.1)",
                lineWidth: 1,
                drawBorder: !0,
                drawOnChartArea: !0,
                drawTicks: !0,
                tickMarkLength: 10,
                zeroLineWidth: 1,
                zeroLineColor: "rgba(0,0,0,0.25)",
                zeroLineBorderDash: [],
                zeroLineBorderDashOffset: 0,
                offsetGridLines: !1,
                borderDash: [],
                borderDashOffset: 0
            },
            scaleLabel: {
                display: !1,
                labelString: "",
                padding: {
                    top: 4,
                    bottom: 4
                }
            },
            ticks: {
                beginAtZero: !1,
                minRotation: 0,
                maxRotation: 50,
                mirror: !1,
                padding: 0,
                reverse: !1,
                display: !0,
                autoSkip: !0,
                autoSkipPadding: 0,
                labelOffset: 0,
                callback: Ki.formatters.values,
                minor: {},
                major: {}
            }
        });
        var mn = pt.extend({
            zeroLineIndex: 0,
            getPadding: function () {
                var t = this;
                return {
                    left: t.paddingLeft || 0,
                    top: t.paddingTop || 0,
                    right: t.paddingRight || 0,
                    bottom: t.paddingBottom || 0
                }
            },
            getTicks: function () {
                return this._ticks
            },
            _getLabels: function () {
                var t = this.chart.data;
                return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || []
            },
            mergeTicksOptions: function () {},
            beforeUpdate: function () {
                at.callback(this.options.beforeUpdate, [this])
            },
            update: function (t, e, i) {
                var n, l, r, a, o, s = this,
                    c = s.options.ticks,
                    u = c.sampleSize;
                if (s.beforeUpdate(), s.maxWidth = t, s.maxHeight = e, s.margins = at.extend({
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }, i), s._ticks = null, s.ticks = null, s._labelSizes = null, s._maxLabelLines = 0, s.longestLabelWidth = 0, s.longestTextCache = s.longestTextCache || {}, s._gridLineItems = null, s._labelItems = null, s.beforeSetDimensions(), s.setDimensions(), s.afterSetDimensions(), s.beforeDataLimits(), s.determineDataLimits(), s.afterDataLimits(), s.beforeBuildTicks(), a = s.buildTicks() || [], (!(a = s.afterBuildTicks(a) || a) || !a.length) && s.ticks)
                    for (a = [], n = 0, l = s.ticks.length; n < l; ++n) a.push({
                        value: s.ticks[n],
                        major: !1
                    });
                return s._ticks = a, o = u < a.length, r = s._convertTicksToLabels(o ? en(a, u) : a), s._configure(), s.beforeCalculateTickRotation(), s.calculateTickRotation(), s.afterCalculateTickRotation(), s.beforeFit(), s.fit(), s.afterFit(), s._ticksToDraw = c.display && (c.autoSkip || "auto" === c.source) ? s._autoSkip(a) : a, o && (r = s._convertTicksToLabels(s._ticksToDraw)), s.ticks = r, s.afterUpdate(), s.minSize
            },
            _configure: function () {
                var t, e, i = this,
                    n = i.options.ticks.reverse;
                i.isHorizontal() ? (t = i.left, e = i.right) : (t = i.top, e = i.bottom, n = !n), i._startPixel = t, i._endPixel = e, i._reversePixels = n, i._length = e - t
            },
            afterUpdate: function () {
                at.callback(this.options.afterUpdate, [this])
            },
            beforeSetDimensions: function () {
                at.callback(this.options.beforeSetDimensions, [this])
            },
            setDimensions: function () {
                var t = this;
                t.isHorizontal() ? (t.width = t.maxWidth, t.left = 0, t.right = t.width) : (t.height = t.maxHeight, t.top = 0, t.bottom = t.height), t.paddingLeft = 0, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0
            },
            afterSetDimensions: function () {
                at.callback(this.options.afterSetDimensions, [this])
            },
            beforeDataLimits: function () {
                at.callback(this.options.beforeDataLimits, [this])
            },
            determineDataLimits: at.noop,
            afterDataLimits: function () {
                at.callback(this.options.afterDataLimits, [this])
            },
            beforeBuildTicks: function () {
                at.callback(this.options.beforeBuildTicks, [this])
            },
            buildTicks: at.noop,
            afterBuildTicks: function (t) {
                var e = this;
                return $i(t) && t.length ? at.callback(e.options.afterBuildTicks, [e, t]) : (e.ticks = at.callback(e.options.afterBuildTicks, [e, e.ticks]) || e.ticks, t)
            },
            beforeTickToLabelConversion: function () {
                at.callback(this.options.beforeTickToLabelConversion, [this])
            },
            convertTicksToLabels: function () {
                var t = this,
                    e = t.options.ticks;
                t.ticks = t.ticks.map(e.userCallback || e.callback, this)
            },
            afterTickToLabelConversion: function () {
                at.callback(this.options.afterTickToLabelConversion, [this])
            },
            beforeCalculateTickRotation: function () {
                at.callback(this.options.beforeCalculateTickRotation, [this])
            },
            calculateTickRotation: function () {
                var t, e, i, n, l, r, a, o = this,
                    s = o.options,
                    c = s.ticks,
                    u = o.getTicks().length,
                    h = c.minRotation || 0,
                    d = c.maxRotation,
                    f = h;
                !o._isVisible() || !c.display || h >= d || u <= 1 || !o.isHorizontal() ? o.labelRotation = h : (e = (t = o._getLabelSizes()).widest.width, i = t.highest.height - t.highest.offset, n = Math.min(o.maxWidth, o.chart.width - e), e + 6 > (l = s.offset ? o.maxWidth / u : n / (u - 1)) && (l = n / (u - (s.offset ? .5 : 1)), r = o.maxHeight - an(s.gridLines) - c.padding - on(s.scaleLabel), a = Math.sqrt(e * e + i * i), f = at.toDegrees(Math.min(Math.asin(Math.min((t.highest.height + 6) / l, 1)), Math.asin(Math.min(r / a, 1)) - Math.asin(i / a))), f = Math.max(h, Math.min(d, f))), o.labelRotation = f)
            },
            afterCalculateTickRotation: function () {
                at.callback(this.options.afterCalculateTickRotation, [this])
            },
            beforeFit: function () {
                at.callback(this.options.beforeFit, [this])
            },
            fit: function () {
                var t = this,
                    e = t.minSize = {
                        width: 0,
                        height: 0
                    },
                    i = t.chart,
                    n = t.options,
                    l = n.ticks,
                    r = n.scaleLabel,
                    a = n.gridLines,
                    o = t._isVisible(),
                    s = "bottom" === n.position,
                    c = t.isHorizontal();
                if (c ? e.width = t.maxWidth : o && (e.width = an(a) + on(r)), c ? o && (e.height = an(a) + on(r)) : e.height = t.maxHeight, l.display && o) {
                    var u = cn(l),
                        h = t._getLabelSizes(),
                        d = h.first,
                        f = h.last,
                        p = h.widest,
                        g = h.highest,
                        m = .4 * u.minor.lineHeight,
                        v = l.padding;
                    if (c) {
                        var y = 0 !== t.labelRotation,
                            b = at.toRadians(t.labelRotation),
                            x = Math.cos(b),
                            w = Math.sin(b),
                            _ = w * p.width + x * (g.height - (y ? g.offset : 0)) + (y ? 0 : m);
                        e.height = Math.min(t.maxHeight, e.height + _ + v);
                        var k, S, A = t.getPixelForTick(0) - t.left,
                            M = t.right - t.getPixelForTick(t.getTicks().length - 1);
                        y ? (k = s ? x * d.width + w * d.offset : w * (d.height - d.offset), S = s ? w * (f.height - f.offset) : x * f.width + w * f.offset) : (k = d.width / 2, S = f.width / 2), t.paddingLeft = Math.max((k - A) * t.width / (t.width - A), 0) + 3, t.paddingRight = Math.max((S - M) * t.width / (t.width - M), 0) + 3
                    } else {
                        var C = l.mirror ? 0 : p.width + v + m;
                        e.width = Math.min(t.maxWidth, e.width + C), t.paddingTop = d.height / 2, t.paddingBottom = f.height / 2
                    }
                }
                t.handleMargins(), c ? (t.width = t._length = i.width - t.margins.left - t.margins.right, t.height = e.height) : (t.width = e.width, t.height = t._length = i.height - t.margins.top - t.margins.bottom)
            },
            handleMargins: function () {
                var t = this;
                t.margins && (t.margins.left = Math.max(t.paddingLeft, t.margins.left), t.margins.top = Math.max(t.paddingTop, t.margins.top), t.margins.right = Math.max(t.paddingRight, t.margins.right), t.margins.bottom = Math.max(t.paddingBottom, t.margins.bottom))
            },
            afterFit: function () {
                at.callback(this.options.afterFit, [this])
            },
            isHorizontal: function () {
                var t = this.options.position;
                return "top" === t || "bottom" === t
            },
            isFullWidth: function () {
                return this.options.fullWidth
            },
            getRightValue: function (t) {
                if (Qi(t)) return NaN;
                if (("number" == typeof t || t instanceof Number) && !isFinite(t)) return NaN;
                if (t)
                    if (this.isHorizontal()) {
                        if (void 0 !== t.x) return this.getRightValue(t.x)
                    } else if (void 0 !== t.y) return this.getRightValue(t.y);
                return t
            },
            _convertTicksToLabels: function (t) {
                var e, i, n, l = this;
                for (l.ticks = t.map((function (t) {
                        return t.value
                    })), l.beforeTickToLabelConversion(), e = l.convertTicksToLabels(t) || l.ticks, l.afterTickToLabelConversion(), i = 0, n = t.length; i < n; ++i) t[i].label = e[i];
                return e
            },
            _getLabelSizes: function () {
                var t = this,
                    e = t._labelSizes;
                return e || (t._labelSizes = e = rn(t.ctx, cn(t.options.ticks), t.getTicks(), t.longestTextCache), t.longestLabelWidth = e.widest.width), e
            },
            _parseValue: function (t) {
                var e, i, n, l;
                return $i(t) ? (e = +this.getRightValue(t[0]), i = +this.getRightValue(t[1]), n = Math.min(e, i), l = Math.max(e, i)) : (e = void 0, i = t = +this.getRightValue(t), n = t, l = t), {
                    min: n,
                    max: l,
                    start: e,
                    end: i
                }
            },
            _getScaleLabel: function (t) {
                var e = this._parseValue(t);
                return void 0 !== e.start ? "[" + e.start + ", " + e.end + "]" : +this.getRightValue(t)
            },
            getLabelForIndex: at.noop,
            getPixelForValue: at.noop,
            getValueForPixel: at.noop,
            getPixelForTick: function (t) {
                var e = this,
                    i = e.options.offset,
                    n = e._ticks.length,
                    l = 1 / Math.max(n - (i ? 0 : 1), 1);
                return t < 0 || t > n - 1 ? null : e.getPixelForDecimal(t * l + (i ? l / 2 : 0))
            },
            getPixelForDecimal: function (t) {
                var e = this;
                return e._reversePixels && (t = 1 - t), e._startPixel + t * e._length
            },
            getDecimalForPixel: function (t) {
                var e = (t - this._startPixel) / this._length;
                return this._reversePixels ? 1 - e : e
            },
            getBasePixel: function () {
                return this.getPixelForValue(this.getBaseValue())
            },
            getBaseValue: function () {
                var t = this,
                    e = t.min,
                    i = t.max;
                return t.beginAtZero ? 0 : e < 0 && i < 0 ? i : e > 0 && i > 0 ? e : 0
            },
            _autoSkip: function (t) {
                var e, i, n, l, r = this,
                    a = r.options.ticks,
                    o = r._length,
                    s = a.maxTicksLimit || o / r._tickSize() + 1,
                    c = a.major.enabled ? fn(t) : [],
                    u = c.length,
                    h = c[0],
                    d = c[u - 1];
                if (u > s) return pn(t, c, u / s), un(t);
                if (n = dn(c, t, o, s), u > 0) {
                    for (e = 0, i = u - 1; e < i; e++) gn(t, n, c[e], c[e + 1]);
                    return l = u > 1 ? (d - h) / (u - 1) : null, gn(t, n, at.isNullOrUndef(l) ? 0 : h - l, h), gn(t, n, d, at.isNullOrUndef(l) ? t.length : d + l), un(t)
                }
                return gn(t, n), un(t)
            },
            _tickSize: function () {
                var t = this,
                    e = t.options.ticks,
                    i = at.toRadians(t.labelRotation),
                    n = Math.abs(Math.cos(i)),
                    l = Math.abs(Math.sin(i)),
                    r = t._getLabelSizes(),
                    a = e.autoSkipPadding || 0,
                    o = r ? r.widest.width + a : 0,
                    s = r ? r.highest.height + a : 0;
                return t.isHorizontal() ? s * n > o * l ? o / n : s / l : s * l < o * n ? s / n : o / l
            },
            _isVisible: function () {
                var t, e, i, n = this,
                    l = n.chart,
                    r = n.options.display;
                if ("auto" !== r) return !!r;
                for (t = 0, e = l.data.datasets.length; t < e; ++t)
                    if (l.isDatasetVisible(t) && ((i = l.getDatasetMeta(t)).xAxisID === n.id || i.yAxisID === n.id)) return !0;
                return !1
            },
            _computeGridLineItems: function (t) {
                var e, i, n, l, r, a, o, s, c, u, h, d, f, p, g, m, v, y = this,
                    b = y.chart,
                    x = y.options,
                    w = x.gridLines,
                    _ = x.position,
                    k = w.offsetGridLines,
                    S = y.isHorizontal(),
                    A = y._ticksToDraw,
                    M = A.length + (k ? 1 : 0),
                    C = an(w),
                    E = [],
                    O = w.drawBorder ? tn(w.lineWidth, 0, 0) : 0,
                    T = O / 2,
                    P = at._alignPixel,
                    L = function (t) {
                        return P(b, t, O)
                    };
                for ("top" === _ ? (e = L(y.bottom), o = y.bottom - C, c = e - T, h = L(t.top) + T, f = t.bottom) : "bottom" === _ ? (e = L(y.top), h = t.top, f = L(t.bottom) - T, o = e + T, c = y.top + C) : "left" === _ ? (e = L(y.right), a = y.right - C, s = e - T, u = L(t.left) + T, d = t.right) : (e = L(y.left), u = t.left, d = L(t.right) - T, a = e + T, s = y.left + C), i = 0; i < M; ++i) n = A[i] || {}, Qi(n.label) && i < A.length || (i === y.zeroLineIndex && x.offset === k ? (p = w.zeroLineWidth, g = w.zeroLineColor, m = w.zeroLineBorderDash || [], v = w.zeroLineBorderDashOffset || 0) : (p = tn(w.lineWidth, i, 1), g = tn(w.color, i, "rgba(0,0,0,0.1)"), m = w.borderDash || [], v = w.borderDashOffset || 0), void 0 !== (l = nn(y, n._index || i, k)) && (r = P(b, l, p), S ? a = s = u = d = r : o = c = h = f = r, E.push({
                    tx1: a,
                    ty1: o,
                    tx2: s,
                    ty2: c,
                    x1: u,
                    y1: h,
                    x2: d,
                    y2: f,
                    width: p,
                    color: g,
                    borderDash: m,
                    borderDashOffset: v
                })));
                return E.ticksLength = M, E.borderValue = e, E
            },
            _computeLabelItems: function () {
                var t, e, i, n, l, r, a, o, s, c, u, h, d = this,
                    f = d.options,
                    p = f.ticks,
                    g = f.position,
                    m = p.mirror,
                    v = d.isHorizontal(),
                    y = d._ticksToDraw,
                    b = cn(p),
                    x = p.padding,
                    w = an(f.gridLines),
                    _ = -at.toRadians(d.labelRotation),
                    k = [];
                for ("top" === g ? (r = d.bottom - w - x, a = _ ? "left" : "center") : "bottom" === g ? (r = d.top + w + x, a = _ ? "right" : "center") : "left" === g ? (l = d.right - (m ? 0 : w) - x, a = m ? "left" : "right") : (l = d.left + (m ? 0 : w) + x, a = m ? "right" : "left"), t = 0, e = y.length; t < e; ++t) n = (i = y[t]).label, Qi(n) || (o = d.getPixelForTick(i._index || t) + p.labelOffset, c = (s = i.major ? b.major : b.minor).lineHeight, u = $i(n) ? n.length : 1, v ? (l = o, h = "top" === g ? ((_ ? 1 : .5) - u) * c : (_ ? 0 : .5) * c) : (r = o, h = (1 - u) * c / 2), k.push({
                    x: l,
                    y: r,
                    rotation: _,
                    label: n,
                    font: s,
                    textOffset: h,
                    textAlign: a
                }));
                return k
            },
            _drawGrid: function (t) {
                var e = this,
                    i = e.options.gridLines;
                if (i.display) {
                    var n, l, r, a, o, s = e.ctx,
                        c = e.chart,
                        u = at._alignPixel,
                        h = i.drawBorder ? tn(i.lineWidth, 0, 0) : 0,
                        d = e._gridLineItems || (e._gridLineItems = e._computeGridLineItems(t));
                    for (r = 0, a = d.length; r < a; ++r) n = (o = d[r]).width, l = o.color, n && l && (s.save(), s.lineWidth = n, s.strokeStyle = l, s.setLineDash && (s.setLineDash(o.borderDash), s.lineDashOffset = o.borderDashOffset), s.beginPath(), i.drawTicks && (s.moveTo(o.tx1, o.ty1), s.lineTo(o.tx2, o.ty2)), i.drawOnChartArea && (s.moveTo(o.x1, o.y1), s.lineTo(o.x2, o.y2)), s.stroke(), s.restore());
                    if (h) {
                        var f, p, g, m, v = h,
                            y = tn(i.lineWidth, d.ticksLength - 1, 1),
                            b = d.borderValue;
                        e.isHorizontal() ? (f = u(c, e.left, v) - v / 2, p = u(c, e.right, y) + y / 2, g = m = b) : (g = u(c, e.top, v) - v / 2, m = u(c, e.bottom, y) + y / 2, f = p = b), s.lineWidth = h, s.strokeStyle = tn(i.color, 0), s.beginPath(), s.moveTo(f, g), s.lineTo(p, m), s.stroke()
                    }
                }
            },
            _drawLabels: function () {
                var t = this;
                if (t.options.ticks.display) {
                    var e, i, n, l, r, a, o, s, c = t.ctx,
                        u = t._labelItems || (t._labelItems = t._computeLabelItems());
                    for (e = 0, n = u.length; e < n; ++e) {
                        if (a = (r = u[e]).font, c.save(), c.translate(r.x, r.y), c.rotate(r.rotation), c.font = a.string, c.fillStyle = a.color, c.textBaseline = "middle", c.textAlign = r.textAlign, o = r.label, s = r.textOffset, $i(o))
                            for (i = 0, l = o.length; i < l; ++i) c.fillText("" + o[i], 0, s), s += a.lineHeight;
                        else c.fillText(o, 0, s);
                        c.restore()
                    }
                }
            },
            _drawTitle: function () {
                var t = this,
                    e = t.ctx,
                    i = t.options,
                    n = i.scaleLabel;
                if (n.display) {
                    var l, r, a = Ji(n.fontColor, Q.global.defaultFontColor),
                        o = at.options._parseFont(n),
                        s = at.options.toPadding(n.padding),
                        c = o.lineHeight / 2,
                        u = i.position,
                        h = 0;
                    if (t.isHorizontal()) l = t.left + t.width / 2, r = "bottom" === u ? t.bottom - c - s.bottom : t.top + c + s.top;
                    else {
                        var d = "left" === u;
                        l = d ? t.left + c + s.top : t.right - c - s.top, r = t.top + t.height / 2, h = d ? -.5 * Math.PI : .5 * Math.PI
                    }
                    e.save(), e.translate(l, r), e.rotate(h), e.textAlign = "center", e.textBaseline = "middle", e.fillStyle = a, e.font = o.string, e.fillText(n.labelString, 0, 0), e.restore()
                }
            },
            draw: function (t) {
                var e = this;
                e._isVisible() && (e._drawGrid(t), e._drawTitle(), e._drawLabels())
            },
            _layers: function () {
                var t = this,
                    e = t.options,
                    i = e.ticks && e.ticks.z || 0,
                    n = e.gridLines && e.gridLines.z || 0;
                return t._isVisible() && i !== n && t.draw === t._draw ? [{
                    z: n,
                    draw: function () {
                        t._drawGrid.apply(t, arguments), t._drawTitle.apply(t, arguments)
                    }
                }, {
                    z: i,
                    draw: function () {
                        t._drawLabels.apply(t, arguments)
                    }
                }] : [{
                    z: i,
                    draw: function () {
                        t.draw.apply(t, arguments)
                    }
                }]
            },
            _getMatchingVisibleMetas: function (t) {
                var e = this,
                    i = e.isHorizontal();
                return e.chart._getSortedVisibleDatasetMetas().filter((function (n) {
                    return (!t || n.type === t) && (i ? n.xAxisID === e.id : n.yAxisID === e.id)
                }))
            }
        });
        mn.prototype._draw = mn.prototype.draw;
        var vn = mn,
            yn = at.isNullOrUndef,
            bn = {
                position: "bottom"
            },
            xn = vn.extend({
                determineDataLimits: function () {
                    var t, e = this,
                        i = e._getLabels(),
                        n = e.options.ticks,
                        l = n.min,
                        r = n.max,
                        a = 0,
                        o = i.length - 1;
                    void 0 !== l && (t = i.indexOf(l)) >= 0 && (a = t), void 0 !== r && (t = i.indexOf(r)) >= 0 && (o = t), e.minIndex = a, e.maxIndex = o, e.min = i[a], e.max = i[o]
                },
                buildTicks: function () {
                    var t = this,
                        e = t._getLabels(),
                        i = t.minIndex,
                        n = t.maxIndex;
                    t.ticks = 0 === i && n === e.length - 1 ? e : e.slice(i, n + 1)
                },
                getLabelForIndex: function (t, e) {
                    var i = this,
                        n = i.chart;
                    return n.getDatasetMeta(e).controller._getValueScaleId() === i.id ? i.getRightValue(n.data.datasets[e].data[t]) : i._getLabels()[t]
                },
                _configure: function () {
                    var t = this,
                        e = t.options.offset,
                        i = t.ticks;
                    vn.prototype._configure.call(t), t.isHorizontal() || (t._reversePixels = !t._reversePixels), i && (t._startValue = t.minIndex - (e ? .5 : 0), t._valueRange = Math.max(i.length - (e ? 0 : 1), 1))
                },
                getPixelForValue: function (t, e, i) {
                    var n, l, r, a = this;
                    return yn(e) || yn(i) || (t = a.chart.data.datasets[i].data[e]), yn(t) || (n = a.isHorizontal() ? t.x : t.y), (void 0 !== n || void 0 !== t && isNaN(e)) && (l = a._getLabels(), t = at.valueOrDefault(n, t), e = -1 !== (r = l.indexOf(t)) ? r : e, isNaN(e) && (e = t)), a.getPixelForDecimal((e - a._startValue) / a._valueRange)
                },
                getPixelForTick: function (t) {
                    var e = this.ticks;
                    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t], t + this.minIndex)
                },
                getValueForPixel: function (t) {
                    var e = this,
                        i = Math.round(e._startValue + e.getDecimalForPixel(t) * e._valueRange);
                    return Math.min(Math.max(i, 0), e.ticks.length - 1)
                },
                getBasePixel: function () {
                    return this.bottom
                }
            }),
            wn = bn;
        xn._defaults = wn;
        var _n = at.noop,
            kn = at.isNullOrUndef;

        function Sn(t, e) {
            var i, n, l, r, a = [],
                o = 1e-14,
                s = t.stepSize,
                c = s || 1,
                u = t.maxTicks - 1,
                h = t.min,
                d = t.max,
                f = t.precision,
                p = e.min,
                g = e.max,
                m = at.niceNum((g - p) / u / c) * c;
            if (m < o && kn(h) && kn(d)) return [p, g];
            (r = Math.ceil(g / m) - Math.floor(p / m)) > u && (m = at.niceNum(r * m / u / c) * c), s || kn(f) ? i = Math.pow(10, at._decimalPlaces(m)) : (i = Math.pow(10, f), m = Math.ceil(m * i) / i), n = Math.floor(p / m) * m, l = Math.ceil(g / m) * m, s && (!kn(h) && at.almostWhole(h / m, m / 1e3) && (n = h), !kn(d) && at.almostWhole(d / m, m / 1e3) && (l = d)), r = (l - n) / m, r = at.almostEquals(r, Math.round(r), m / 1e3) ? Math.round(r) : Math.ceil(r), n = Math.round(n * i) / i, l = Math.round(l * i) / i, a.push(kn(h) ? n : h);
            for (var v = 1; v < r; ++v) a.push(Math.round((n + v * m) * i) / i);
            return a.push(kn(d) ? l : d), a
        }
        var An = vn.extend({
                getRightValue: function (t) {
                    return "string" == typeof t ? +t : vn.prototype.getRightValue.call(this, t)
                },
                handleTickRangeOptions: function () {
                    var t = this,
                        e = t.options.ticks;
                    if (e.beginAtZero) {
                        var i = at.sign(t.min),
                            n = at.sign(t.max);
                        i < 0 && n < 0 ? t.max = 0 : i > 0 && n > 0 && (t.min = 0)
                    }
                    var l = void 0 !== e.min || void 0 !== e.suggestedMin,
                        r = void 0 !== e.max || void 0 !== e.suggestedMax;
                    void 0 !== e.min ? t.min = e.min : void 0 !== e.suggestedMin && (null === t.min ? t.min = e.suggestedMin : t.min = Math.min(t.min, e.suggestedMin)), void 0 !== e.max ? t.max = e.max : void 0 !== e.suggestedMax && (null === t.max ? t.max = e.suggestedMax : t.max = Math.max(t.max, e.suggestedMax)), l !== r && t.min >= t.max && (l ? t.max = t.min + 1 : t.min = t.max - 1), t.min === t.max && (t.max++, e.beginAtZero || t.min--)
                },
                getTickLimit: function () {
                    var t, e = this,
                        i = e.options.ticks,
                        n = i.stepSize,
                        l = i.maxTicksLimit;
                    return n ? t = Math.ceil(e.max / n) - Math.floor(e.min / n) + 1 : (t = e._computeTickLimit(), l = l || 11), l && (t = Math.min(l, t)), t
                },
                _computeTickLimit: function () {
                    return Number.POSITIVE_INFINITY
                },
                handleDirectionalChanges: _n,
                buildTicks: function () {
                    var t = this,
                        e = t.options.ticks,
                        i = t.getTickLimit(),
                        n = {
                            maxTicks: i = Math.max(2, i),
                            min: e.min,
                            max: e.max,
                            precision: e.precision,
                            stepSize: at.valueOrDefault(e.fixedStepSize, e.stepSize)
                        },
                        l = t.ticks = Sn(n, t);
                    t.handleDirectionalChanges(), t.max = at.max(l), t.min = at.min(l), e.reverse ? (l.reverse(), t.start = t.max, t.end = t.min) : (t.start = t.min, t.end = t.max)
                },
                convertTicksToLabels: function () {
                    var t = this;
                    t.ticksAsNumbers = t.ticks.slice(), t.zeroLineIndex = t.ticks.indexOf(0), vn.prototype.convertTicksToLabels.call(t)
                },
                _configure: function () {
                    var t, e = this,
                        i = e.getTicks(),
                        n = e.min,
                        l = e.max;
                    vn.prototype._configure.call(e), e.options.offset && i.length && (n -= t = (l - n) / Math.max(i.length - 1, 1) / 2, l += t), e._startValue = n, e._endValue = l, e._valueRange = l - n
                }
            }),
            Mn = {
                position: "left",
                ticks: {
                    callback: Ki.formatters.linear
                }
            },
            Cn = 0,
            En = 1;

        function On(t, e, i) {
            var n = [i.type, void 0 === e && void 0 === i.stack ? i.index : "", i.stack].join(".");
            return void 0 === t[n] && (t[n] = {
                pos: [],
                neg: []
            }), t[n]
        }

        function Tn(t, e, i, n) {
            var l, r, a = t.options,
                o = On(e, a.stacked, i),
                s = o.pos,
                c = o.neg,
                u = n.length;
            for (l = 0; l < u; ++l) r = t._parseValue(n[l]), isNaN(r.min) || isNaN(r.max) || i.data[l].hidden || (s[l] = s[l] || 0, c[l] = c[l] || 0, a.relativePoints ? s[l] = 100 : r.min < 0 || r.max < 0 ? c[l] += r.min : s[l] += r.max)
        }

        function Pn(t, e, i) {
            var n, l, r = i.length;
            for (n = 0; n < r; ++n) l = t._parseValue(i[n]), isNaN(l.min) || isNaN(l.max) || e.data[n].hidden || (t.min = Math.min(t.min, l.min), t.max = Math.max(t.max, l.max))
        }
        var Ln = An.extend({
                determineDataLimits: function () {
                    var t, e, i, n, l = this,
                        r = l.options,
                        a = l.chart.data.datasets,
                        o = l._getMatchingVisibleMetas(),
                        s = r.stacked,
                        c = {},
                        u = o.length;
                    if (l.min = Number.POSITIVE_INFINITY, l.max = Number.NEGATIVE_INFINITY, void 0 === s)
                        for (t = 0; !s && t < u; ++t) s = void 0 !== (e = o[t]).stack;
                    for (t = 0; t < u; ++t) i = a[(e = o[t]).index].data, s ? Tn(l, c, e, i) : Pn(l, e, i);
                    at.each(c, (function (t) {
                        n = t.pos.concat(t.neg), l.min = Math.min(l.min, at.min(n)), l.max = Math.max(l.max, at.max(n))
                    })), l.min = at.isFinite(l.min) && !isNaN(l.min) ? l.min : Cn, l.max = at.isFinite(l.max) && !isNaN(l.max) ? l.max : En, l.handleTickRangeOptions()
                },
                _computeTickLimit: function () {
                    var t, e = this;
                    return e.isHorizontal() ? Math.ceil(e.width / 40) : (t = at.options._parseFont(e.options.ticks), Math.ceil(e.height / t.lineHeight))
                },
                handleDirectionalChanges: function () {
                    this.isHorizontal() || this.ticks.reverse()
                },
                getLabelForIndex: function (t, e) {
                    return this._getScaleLabel(this.chart.data.datasets[e].data[t])
                },
                getPixelForValue: function (t) {
                    var e = this;
                    return e.getPixelForDecimal((+e.getRightValue(t) - e._startValue) / e._valueRange)
                },
                getValueForPixel: function (t) {
                    return this._startValue + this.getDecimalForPixel(t) * this._valueRange
                },
                getPixelForTick: function (t) {
                    var e = this.ticksAsNumbers;
                    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t])
                }
            }),
            Dn = Mn;
        Ln._defaults = Dn;
        var In = at.valueOrDefault,
            jn = at.math.log10;

        function Nn(t, e) {
            var i, n, l = [],
                r = In(t.min, Math.pow(10, Math.floor(jn(e.min)))),
                a = Math.floor(jn(e.max)),
                o = Math.ceil(e.max / Math.pow(10, a));
            0 === r ? (i = Math.floor(jn(e.minNotZero)), n = Math.floor(e.minNotZero / Math.pow(10, i)), l.push(r), r = n * Math.pow(10, i)) : (i = Math.floor(jn(r)), n = Math.floor(r / Math.pow(10, i)));
            var s = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
            do {
                l.push(r), 10 == ++n && (n = 1, s = ++i >= 0 ? 1 : s), r = Math.round(n * Math.pow(10, i) * s) / s
            } while (i < a || i === a && n < o);
            var c = In(t.max, r);
            return l.push(c), l
        }
        var Rn = {
            position: "left",
            ticks: {
                callback: Ki.formatters.logarithmic
            }
        };

        function Fn(t, e) {
            return at.isFinite(t) && t >= 0 ? t : e
        }
        var zn = vn.extend({
                determineDataLimits: function () {
                    var t, e, i, n, l, r, a = this,
                        o = a.options,
                        s = a.chart,
                        c = s.data.datasets,
                        u = a.isHorizontal();

                    function h(t) {
                        return u ? t.xAxisID === a.id : t.yAxisID === a.id
                    }
                    a.min = Number.POSITIVE_INFINITY, a.max = Number.NEGATIVE_INFINITY, a.minNotZero = Number.POSITIVE_INFINITY;
                    var d = o.stacked;
                    if (void 0 === d)
                        for (t = 0; t < c.length; t++)
                            if (e = s.getDatasetMeta(t), s.isDatasetVisible(t) && h(e) && void 0 !== e.stack) {
                                d = !0;
                                break
                            } if (o.stacked || d) {
                        var f = {};
                        for (t = 0; t < c.length; t++) {
                            var p = [(e = s.getDatasetMeta(t)).type, void 0 === o.stacked && void 0 === e.stack ? t : "", e.stack].join(".");
                            if (s.isDatasetVisible(t) && h(e))
                                for (void 0 === f[p] && (f[p] = []), l = 0, r = (n = c[t].data).length; l < r; l++) {
                                    var g = f[p];
                                    i = a._parseValue(n[l]), isNaN(i.min) || isNaN(i.max) || e.data[l].hidden || i.min < 0 || i.max < 0 || (g[l] = g[l] || 0, g[l] += i.max)
                                }
                        }
                        at.each(f, (function (t) {
                            if (t.length > 0) {
                                var e = at.min(t),
                                    i = at.max(t);
                                a.min = Math.min(a.min, e), a.max = Math.max(a.max, i)
                            }
                        }))
                    } else
                        for (t = 0; t < c.length; t++)
                            if (e = s.getDatasetMeta(t), s.isDatasetVisible(t) && h(e))
                                for (l = 0, r = (n = c[t].data).length; l < r; l++) i = a._parseValue(n[l]), isNaN(i.min) || isNaN(i.max) || e.data[l].hidden || i.min < 0 || i.max < 0 || (a.min = Math.min(i.min, a.min), a.max = Math.max(i.max, a.max), 0 !== i.min && (a.minNotZero = Math.min(i.min, a.minNotZero)));
                    a.min = at.isFinite(a.min) ? a.min : null, a.max = at.isFinite(a.max) ? a.max : null, a.minNotZero = at.isFinite(a.minNotZero) ? a.minNotZero : null, this.handleTickRangeOptions()
                },
                handleTickRangeOptions: function () {
                    var t = this,
                        e = t.options.ticks,
                        i = 1,
                        n = 10;
                    t.min = Fn(e.min, t.min), t.max = Fn(e.max, t.max), t.min === t.max && (0 !== t.min && null !== t.min ? (t.min = Math.pow(10, Math.floor(jn(t.min)) - 1), t.max = Math.pow(10, Math.floor(jn(t.max)) + 1)) : (t.min = i, t.max = n)), null === t.min && (t.min = Math.pow(10, Math.floor(jn(t.max)) - 1)), null === t.max && (t.max = 0 !== t.min ? Math.pow(10, Math.floor(jn(t.min)) + 1) : n), null === t.minNotZero && (t.min > 0 ? t.minNotZero = t.min : t.max < 1 ? t.minNotZero = Math.pow(10, Math.floor(jn(t.max))) : t.minNotZero = i)
                },
                buildTicks: function () {
                    var t = this,
                        e = t.options.ticks,
                        i = !t.isHorizontal(),
                        n = {
                            min: Fn(e.min),
                            max: Fn(e.max)
                        },
                        l = t.ticks = Nn(n, t);
                    t.max = at.max(l), t.min = at.min(l), e.reverse ? (i = !i, t.start = t.max, t.end = t.min) : (t.start = t.min, t.end = t.max), i && l.reverse()
                },
                convertTicksToLabels: function () {
                    this.tickValues = this.ticks.slice(), vn.prototype.convertTicksToLabels.call(this)
                },
                getLabelForIndex: function (t, e) {
                    return this._getScaleLabel(this.chart.data.datasets[e].data[t])
                },
                getPixelForTick: function (t) {
                    var e = this.tickValues;
                    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t])
                },
                _getFirstTickValue: function (t) {
                    var e = Math.floor(jn(t));
                    return Math.floor(t / Math.pow(10, e)) * Math.pow(10, e)
                },
                _configure: function () {
                    var t = this,
                        e = t.min,
                        i = 0;
                    vn.prototype._configure.call(t), 0 === e && (e = t._getFirstTickValue(t.minNotZero), i = In(t.options.ticks.fontSize, Q.global.defaultFontSize) / t._length), t._startValue = jn(e), t._valueOffset = i, t._valueRange = (jn(t.max) - jn(e)) / (1 - i)
                },
                getPixelForValue: function (t) {
                    var e = this,
                        i = 0;
                    return (t = +e.getRightValue(t)) > e.min && t > 0 && (i = (jn(t) - e._startValue) / e._valueRange + e._valueOffset), e.getPixelForDecimal(i)
                },
                getValueForPixel: function (t) {
                    var e = this,
                        i = e.getDecimalForPixel(t);
                    return 0 === i && 0 === e.min ? 0 : Math.pow(10, e._startValue + (i - e._valueOffset) * e._valueRange)
                }
            }),
            Hn = Rn;
        zn._defaults = Hn;
        var Bn = at.valueOrDefault,
            Yn = at.valueAtIndexOrDefault,
            Wn = at.options.resolve,
            Vn = {
                display: !0,
                animate: !0,
                position: "chartArea",
                angleLines: {
                    display: !0,
                    color: "rgba(0,0,0,0.1)",
                    lineWidth: 1,
                    borderDash: [],
                    borderDashOffset: 0
                },
                gridLines: {
                    circular: !1
                },
                ticks: {
                    showLabelBackdrop: !0,
                    backdropColor: "rgba(255,255,255,0.75)",
                    backdropPaddingY: 2,
                    backdropPaddingX: 2,
                    callback: Ki.formatters.linear
                },
                pointLabels: {
                    display: !0,
                    fontSize: 10,
                    callback: function (t) {
                        return t
                    }
                }
            };

        function Xn(t) {
            var e = t.ticks;
            return e.display && t.display ? Bn(e.fontSize, Q.global.defaultFontSize) + 2 * e.backdropPaddingY : 0
        }

        function qn(t, e, i) {
            return at.isArray(i) ? {
                w: at.longestText(t, t.font, i),
                h: i.length * e
            } : {
                w: t.measureText(i).width,
                h: e
            }
        }

        function Zn(t, e, i, n, l) {
            return t === n || t === l ? {
                start: e - i / 2,
                end: e + i / 2
            } : t < n || t > l ? {
                start: e - i,
                end: e
            } : {
                start: e,
                end: e + i
            }
        }

        function Gn(t) {
            var e, i, n, l = at.options._parseFont(t.options.pointLabels),
                r = {
                    l: 0,
                    r: t.width,
                    t: 0,
                    b: t.height - t.paddingTop
                },
                a = {};
            t.ctx.font = l.string, t._pointLabelSizes = [];
            var o = t.chart.data.labels.length;
            for (e = 0; e < o; e++) {
                n = t.getPointPosition(e, t.drawingArea + 5), i = qn(t.ctx, l.lineHeight, t.pointLabels[e]), t._pointLabelSizes[e] = i;
                var s = t.getIndexAngle(e),
                    c = at.toDegrees(s) % 360,
                    u = Zn(c, n.x, i.w, 0, 180),
                    h = Zn(c, n.y, i.h, 90, 270);
                u.start < r.l && (r.l = u.start, a.l = s), u.end > r.r && (r.r = u.end, a.r = s), h.start < r.t && (r.t = h.start, a.t = s), h.end > r.b && (r.b = h.end, a.b = s)
            }
            t.setReductions(t.drawingArea, r, a)
        }

        function Un(t) {
            return 0 === t || 180 === t ? "center" : t < 180 ? "left" : "right"
        }

        function Kn(t, e, i, n) {
            var l, r, a = i.y + n / 2;
            if (at.isArray(e))
                for (l = 0, r = e.length; l < r; ++l) t.fillText(e[l], i.x, a), a += n;
            else t.fillText(e, i.x, a)
        }

        function $n(t, e, i) {
            90 === t || 270 === t ? i.y -= e.h / 2 : (t > 270 || t < 90) && (i.y -= e.h)
        }

        function Qn(t) {
            var e = t.ctx,
                i = t.options,
                n = i.pointLabels,
                l = Xn(i),
                r = t.getDistanceFromCenterForValue(i.ticks.reverse ? t.min : t.max),
                a = at.options._parseFont(n);
            e.save(), e.font = a.string, e.textBaseline = "middle";
            for (var o = t.chart.data.labels.length - 1; o >= 0; o--) {
                var s = 0 === o ? l / 2 : 0,
                    c = t.getPointPosition(o, r + s + 5),
                    u = Yn(n.fontColor, o, Q.global.defaultFontColor);
                e.fillStyle = u;
                var h = t.getIndexAngle(o),
                    d = at.toDegrees(h);
                e.textAlign = Un(d), $n(d, t._pointLabelSizes[o], c), Kn(e, t.pointLabels[o], c, a.lineHeight)
            }
            e.restore()
        }

        function Jn(t, e, i, n) {
            var l, r = t.ctx,
                a = e.circular,
                o = t.chart.data.labels.length,
                s = Yn(e.color, n - 1),
                c = Yn(e.lineWidth, n - 1);
            if ((a || o) && s && c) {
                if (r.save(), r.strokeStyle = s, r.lineWidth = c, r.setLineDash && (r.setLineDash(e.borderDash || []), r.lineDashOffset = e.borderDashOffset || 0), r.beginPath(), a) r.arc(t.xCenter, t.yCenter, i, 0, 2 * Math.PI);
                else {
                    l = t.getPointPosition(0, i), r.moveTo(l.x, l.y);
                    for (var u = 1; u < o; u++) l = t.getPointPosition(u, i), r.lineTo(l.x, l.y)
                }
                r.closePath(), r.stroke(), r.restore()
            }
        }

        function tl(t) {
            return at.isNumber(t) ? t : 0
        }
        var el = An.extend({
                setDimensions: function () {
                    var t = this;
                    t.width = t.maxWidth, t.height = t.maxHeight, t.paddingTop = Xn(t.options) / 2, t.xCenter = Math.floor(t.width / 2), t.yCenter = Math.floor((t.height - t.paddingTop) / 2), t.drawingArea = Math.min(t.height - t.paddingTop, t.width) / 2
                },
                determineDataLimits: function () {
                    var t = this,
                        e = t.chart,
                        i = Number.POSITIVE_INFINITY,
                        n = Number.NEGATIVE_INFINITY;
                    at.each(e.data.datasets, (function (l, r) {
                        if (e.isDatasetVisible(r)) {
                            var a = e.getDatasetMeta(r);
                            at.each(l.data, (function (e, l) {
                                var r = +t.getRightValue(e);
                                isNaN(r) || a.data[l].hidden || (i = Math.min(r, i), n = Math.max(r, n))
                            }))
                        }
                    })), t.min = i === Number.POSITIVE_INFINITY ? 0 : i, t.max = n === Number.NEGATIVE_INFINITY ? 0 : n, t.handleTickRangeOptions()
                },
                _computeTickLimit: function () {
                    return Math.ceil(this.drawingArea / Xn(this.options))
                },
                convertTicksToLabels: function () {
                    var t = this;
                    An.prototype.convertTicksToLabels.call(t), t.pointLabels = t.chart.data.labels.map((function () {
                        var e = at.callback(t.options.pointLabels.callback, arguments, t);
                        return e || 0 === e ? e : ""
                    }))
                },
                getLabelForIndex: function (t, e) {
                    return +this.getRightValue(this.chart.data.datasets[e].data[t])
                },
                fit: function () {
                    var t = this,
                        e = t.options;
                    e.display && e.pointLabels.display ? Gn(t) : t.setCenterPoint(0, 0, 0, 0)
                },
                setReductions: function (t, e, i) {
                    var n = this,
                        l = e.l / Math.sin(i.l),
                        r = Math.max(e.r - n.width, 0) / Math.sin(i.r),
                        a = -e.t / Math.cos(i.t),
                        o = -Math.max(e.b - (n.height - n.paddingTop), 0) / Math.cos(i.b);
                    l = tl(l), r = tl(r), a = tl(a), o = tl(o), n.drawingArea = Math.min(Math.floor(t - (l + r) / 2), Math.floor(t - (a + o) / 2)), n.setCenterPoint(l, r, a, o)
                },
                setCenterPoint: function (t, e, i, n) {
                    var l = this,
                        r = l.width - e - l.drawingArea,
                        a = t + l.drawingArea,
                        o = i + l.drawingArea,
                        s = l.height - l.paddingTop - n - l.drawingArea;
                    l.xCenter = Math.floor((a + r) / 2 + l.left), l.yCenter = Math.floor((o + s) / 2 + l.top + l.paddingTop)
                },
                getIndexAngle: function (t) {
                    var e = this.chart,
                        i = (t * (360 / e.data.labels.length) + ((e.options || {}).startAngle || 0)) % 360;
                    return (i < 0 ? i + 360 : i) * Math.PI * 2 / 360
                },
                getDistanceFromCenterForValue: function (t) {
                    var e = this;
                    if (at.isNullOrUndef(t)) return NaN;
                    var i = e.drawingArea / (e.max - e.min);
                    return e.options.ticks.reverse ? (e.max - t) * i : (t - e.min) * i
                },
                getPointPosition: function (t, e) {
                    var i = this,
                        n = i.getIndexAngle(t) - Math.PI / 2;
                    return {
                        x: Math.cos(n) * e + i.xCenter,
                        y: Math.sin(n) * e + i.yCenter
                    }
                },
                getPointPositionForValue: function (t, e) {
                    return this.getPointPosition(t, this.getDistanceFromCenterForValue(e))
                },
                getBasePosition: function (t) {
                    var e = this,
                        i = e.min,
                        n = e.max;
                    return e.getPointPositionForValue(t || 0, e.beginAtZero ? 0 : i < 0 && n < 0 ? n : i > 0 && n > 0 ? i : 0)
                },
                _drawGrid: function () {
                    var t, e, i, n = this,
                        l = n.ctx,
                        r = n.options,
                        a = r.gridLines,
                        o = r.angleLines,
                        s = Bn(o.lineWidth, a.lineWidth),
                        c = Bn(o.color, a.color);
                    if (r.pointLabels.display && Qn(n), a.display && at.each(n.ticks, (function (t, i) {
                            0 !== i && (e = n.getDistanceFromCenterForValue(n.ticksAsNumbers[i]), Jn(n, a, e, i))
                        })), o.display && s && c) {
                        for (l.save(), l.lineWidth = s, l.strokeStyle = c, l.setLineDash && (l.setLineDash(Wn([o.borderDash, a.borderDash, []])), l.lineDashOffset = Wn([o.borderDashOffset, a.borderDashOffset, 0])), t = n.chart.data.labels.length - 1; t >= 0; t--) e = n.getDistanceFromCenterForValue(r.ticks.reverse ? n.min : n.max), i = n.getPointPosition(t, e), l.beginPath(), l.moveTo(n.xCenter, n.yCenter), l.lineTo(i.x, i.y), l.stroke();
                        l.restore()
                    }
                },
                _drawLabels: function () {
                    var t = this,
                        e = t.ctx,
                        i = t.options.ticks;
                    if (i.display) {
                        var n, l, r = t.getIndexAngle(0),
                            a = at.options._parseFont(i),
                            o = Bn(i.fontColor, Q.global.defaultFontColor);
                        e.save(), e.font = a.string, e.translate(t.xCenter, t.yCenter), e.rotate(r), e.textAlign = "center", e.textBaseline = "middle", at.each(t.ticks, (function (r, s) {
                            (0 !== s || i.reverse) && (n = t.getDistanceFromCenterForValue(t.ticksAsNumbers[s]), i.showLabelBackdrop && (l = e.measureText(r).width, e.fillStyle = i.backdropColor, e.fillRect(-l / 2 - i.backdropPaddingX, -n - a.size / 2 - i.backdropPaddingY, l + 2 * i.backdropPaddingX, a.size + 2 * i.backdropPaddingY)), e.fillStyle = o, e.fillText(r, 0, -n))
                        })), e.restore()
                    }
                },
                _drawTitle: at.noop
            }),
            il = Vn;
        el._defaults = il;
        var nl = at._deprecated,
            ll = at.options.resolve,
            rl = at.valueOrDefault,
            al = Number.MIN_SAFE_INTEGER || -9007199254740991,
            ol = Number.MAX_SAFE_INTEGER || 9007199254740991,
            sl = {
                millisecond: {
                    common: !0,
                    size: 1,
                    steps: 1e3
                },
                second: {
                    common: !0,
                    size: 1e3,
                    steps: 60
                },
                minute: {
                    common: !0,
                    size: 6e4,
                    steps: 60
                },
                hour: {
                    common: !0,
                    size: 36e5,
                    steps: 24
                },
                day: {
                    common: !0,
                    size: 864e5,
                    steps: 30
                },
                week: {
                    common: !1,
                    size: 6048e5,
                    steps: 4
                },
                month: {
                    common: !0,
                    size: 2628e6,
                    steps: 12
                },
                quarter: {
                    common: !1,
                    size: 7884e6,
                    steps: 4
                },
                year: {
                    common: !0,
                    size: 3154e7
                }
            },
            cl = Object.keys(sl);

        function ul(t, e) {
            return t - e
        }

        function hl(t) {
            var e, i, n, l = {},
                r = [];
            for (e = 0, i = t.length; e < i; ++e) l[n = t[e]] || (l[n] = !0, r.push(n));
            return r
        }

        function dl(t) {
            return at.valueOrDefault(t.time.min, t.ticks.min)
        }

        function fl(t) {
            return at.valueOrDefault(t.time.max, t.ticks.max)
        }

        function pl(t, e, i, n) {
            if ("linear" === n || !t.length) return [{
                time: e,
                pos: 0
            }, {
                time: i,
                pos: 1
            }];
            var l, r, a, o, s, c = [],
                u = [e];
            for (l = 0, r = t.length; l < r; ++l)(o = t[l]) > e && o < i && u.push(o);
            for (u.push(i), l = 0, r = u.length; l < r; ++l) s = u[l + 1], a = u[l - 1], o = u[l], void 0 !== a && void 0 !== s && Math.round((s + a) / 2) === o || c.push({
                time: o,
                pos: l / (r - 1)
            });
            return c
        }

        function gl(t, e, i) {
            for (var n, l, r, a = 0, o = t.length - 1; a >= 0 && a <= o;) {
                if (l = t[(n = a + o >> 1) - 1] || null, r = t[n], !l) return {
                    lo: null,
                    hi: r
                };
                if (r[e] < i) a = n + 1;
                else {
                    if (!(l[e] > i)) return {
                        lo: l,
                        hi: r
                    };
                    o = n - 1
                }
            }
            return {
                lo: r,
                hi: null
            }
        }

        function ml(t, e, i, n) {
            var l = gl(t, e, i),
                r = l.lo ? l.hi ? l.lo : t[t.length - 2] : t[0],
                a = l.lo ? l.hi ? l.hi : t[t.length - 1] : t[1],
                o = a[e] - r[e],
                s = o ? (i - r[e]) / o : 0,
                c = (a[n] - r[n]) * s;
            return r[n] + c
        }

        function vl(t, e) {
            var i = t._adapter,
                n = t.options.time,
                l = n.parser,
                r = l || n.format,
                a = e;
            return "function" == typeof l && (a = l(a)), at.isFinite(a) || (a = "string" == typeof r ? i.parse(a, r) : i.parse(a)), null !== a ? +a : (l || "function" != typeof r || (a = r(e), at.isFinite(a) || (a = i.parse(a))), a)
        }

        function yl(t, e) {
            if (at.isNullOrUndef(e)) return null;
            var i = t.options.time,
                n = vl(t, t.getRightValue(e));
            return null === n || i.round && (n = +t._adapter.startOf(n, i.round)), n
        }

        function bl(t, e, i, n) {
            var l, r, a, o = cl.length;
            for (l = cl.indexOf(t); l < o - 1; ++l)
                if (a = (r = sl[cl[l]]).steps ? r.steps : ol, r.common && Math.ceil((i - e) / (a * r.size)) <= n) return cl[l];
            return cl[o - 1]
        }

        function xl(t, e, i, n, l) {
            var r, a;
            for (r = cl.length - 1; r >= cl.indexOf(i); r--)
                if (a = cl[r], sl[a].common && t._adapter.diff(l, n, a) >= e - 1) return a;
            return cl[i ? cl.indexOf(i) : 0]
        }

        function wl(t) {
            for (var e = cl.indexOf(t) + 1, i = cl.length; e < i; ++e)
                if (sl[cl[e]].common) return cl[e]
        }

        function _l(t, e, i, n) {
            var l, r = t._adapter,
                a = t.options,
                o = a.time,
                s = o.unit || bl(o.minUnit, e, i, n),
                c = ll([o.stepSize, o.unitStepSize, 1]),
                u = "week" === s && o.isoWeekday,
                h = e,
                d = [];
            if (u && (h = +r.startOf(h, "isoWeek", u)), h = +r.startOf(h, u ? "day" : s), r.diff(i, e, s) > 1e5 * c) throw e + " and " + i + " are too far apart with stepSize of " + c + " " + s;
            for (l = h; l < i; l = +r.add(l, c, s)) d.push(l);
            return l !== i && "ticks" !== a.bounds || d.push(l), d
        }

        function kl(t, e, i, n, l) {
            var r, a, o = 0,
                s = 0;
            return l.offset && e.length && (r = ml(t, "time", e[0], "pos"), o = 1 === e.length ? 1 - r : (ml(t, "time", e[1], "pos") - r) / 2, a = ml(t, "time", e[e.length - 1], "pos"), s = 1 === e.length ? a : (a - ml(t, "time", e[e.length - 2], "pos")) / 2), {
                start: o,
                end: s,
                factor: 1 / (o + 1 + s)
            }
        }

        function Sl(t, e, i, n) {
            var l, r, a = t._adapter,
                o = +a.startOf(e[0].value, n),
                s = e[e.length - 1].value;
            for (l = o; l <= s; l = +a.add(l, 1, n))(r = i[l]) >= 0 && (e[r].major = !0);
            return e
        }

        function Al(t, e, i) {
            var n, l, r = [],
                a = {},
                o = e.length;
            for (n = 0; n < o; ++n) a[l = e[n]] = n, r.push({
                value: l,
                major: !1
            });
            return 0 !== o && i ? Sl(t, r, a, i) : r
        }
        var Ml = {
                position: "bottom",
                distribution: "linear",
                bounds: "data",
                adapters: {},
                time: {
                    parser: !1,
                    unit: !1,
                    round: !1,
                    displayFormat: !1,
                    isoWeekday: !1,
                    minUnit: "millisecond",
                    displayFormats: {}
                },
                ticks: {
                    autoSkip: !1,
                    source: "auto",
                    major: {
                        enabled: !1
                    }
                }
            },
            Cl = vn.extend({
                initialize: function () {
                    this.mergeTicksOptions(), vn.prototype.initialize.call(this)
                },
                update: function () {
                    var t = this,
                        e = t.options,
                        i = e.time || (e.time = {}),
                        n = t._adapter = new Ui._date(e.adapters.date);
                    return nl("time scale", i.format, "time.format", "time.parser"), nl("time scale", i.min, "time.min", "ticks.min"), nl("time scale", i.max, "time.max", "ticks.max"), at.mergeIf(i.displayFormats, n.formats()), vn.prototype.update.apply(t, arguments)
                },
                getRightValue: function (t) {
                    return t && void 0 !== t.t && (t = t.t), vn.prototype.getRightValue.call(this, t)
                },
                determineDataLimits: function () {
                    var t, e, i, n, l, r, a, o = this,
                        s = o.chart,
                        c = o._adapter,
                        u = o.options,
                        h = u.time.unit || "day",
                        d = ol,
                        f = al,
                        p = [],
                        g = [],
                        m = [],
                        v = o._getLabels();
                    for (t = 0, i = v.length; t < i; ++t) m.push(yl(o, v[t]));
                    for (t = 0, i = (s.data.datasets || []).length; t < i; ++t)
                        if (s.isDatasetVisible(t))
                            if (l = s.data.datasets[t].data, at.isObject(l[0]))
                                for (g[t] = [], e = 0, n = l.length; e < n; ++e) r = yl(o, l[e]), p.push(r), g[t][e] = r;
                            else g[t] = m.slice(0), a || (p = p.concat(m), a = !0);
                    else g[t] = [];
                    m.length && (d = Math.min(d, m[0]), f = Math.max(f, m[m.length - 1])), p.length && (p = i > 1 ? hl(p).sort(ul) : p.sort(ul), d = Math.min(d, p[0]), f = Math.max(f, p[p.length - 1])), d = yl(o, dl(u)) || d, f = yl(o, fl(u)) || f, d = d === ol ? +c.startOf(Date.now(), h) : d, f = f === al ? +c.endOf(Date.now(), h) + 1 : f, o.min = Math.min(d, f), o.max = Math.max(d + 1, f), o._table = [], o._timestamps = {
                        data: p,
                        datasets: g,
                        labels: m
                    }
                },
                buildTicks: function () {
                    var t, e, i, n = this,
                        l = n.min,
                        r = n.max,
                        a = n.options,
                        o = a.ticks,
                        s = a.time,
                        c = n._timestamps,
                        u = [],
                        h = n.getLabelCapacity(l),
                        d = o.source,
                        f = a.distribution;
                    for (c = "data" === d || "auto" === d && "series" === f ? c.data : "labels" === d ? c.labels : _l(n, l, r, h), "ticks" === a.bounds && c.length && (l = c[0], r = c[c.length - 1]), l = yl(n, dl(a)) || l, r = yl(n, fl(a)) || r, t = 0, e = c.length; t < e; ++t)(i = c[t]) >= l && i <= r && u.push(i);
                    return n.min = l, n.max = r, n._unit = s.unit || (o.autoSkip ? bl(s.minUnit, n.min, n.max, h) : xl(n, u.length, s.minUnit, n.min, n.max)), n._majorUnit = o.major.enabled && "year" !== n._unit ? wl(n._unit) : void 0, n._table = pl(n._timestamps.data, l, r, f), n._offsets = kl(n._table, u, l, r, a), o.reverse && u.reverse(), Al(n, u, n._majorUnit)
                },
                getLabelForIndex: function (t, e) {
                    var i = this,
                        n = i._adapter,
                        l = i.chart.data,
                        r = i.options.time,
                        a = l.labels && t < l.labels.length ? l.labels[t] : "",
                        o = l.datasets[e].data[t];
                    return at.isObject(o) && (a = i.getRightValue(o)), r.tooltipFormat ? n.format(vl(i, a), r.tooltipFormat) : "string" == typeof a ? a : n.format(vl(i, a), r.displayFormats.datetime)
                },
                tickFormatFunction: function (t, e, i, n) {
                    var l = this,
                        r = l._adapter,
                        a = l.options,
                        o = a.time.displayFormats,
                        s = o[l._unit],
                        c = l._majorUnit,
                        u = o[c],
                        h = i[e],
                        d = a.ticks,
                        f = c && u && h && h.major,
                        p = r.format(t, n || (f ? u : s)),
                        g = f ? d.major : d.minor,
                        m = ll([g.callback, g.userCallback, d.callback, d.userCallback]);
                    return m ? m(p, e, i) : p
                },
                convertTicksToLabels: function (t) {
                    var e, i, n = [];
                    for (e = 0, i = t.length; e < i; ++e) n.push(this.tickFormatFunction(t[e].value, e, t));
                    return n
                },
                getPixelForOffset: function (t) {
                    var e = this,
                        i = e._offsets,
                        n = ml(e._table, "time", t, "pos");
                    return e.getPixelForDecimal((i.start + n) * i.factor)
                },
                getPixelForValue: function (t, e, i) {
                    var n = this,
                        l = null;
                    if (void 0 !== e && void 0 !== i && (l = n._timestamps.datasets[i][e]), null === l && (l = yl(n, t)), null !== l) return n.getPixelForOffset(l)
                },
                getPixelForTick: function (t) {
                    var e = this.getTicks();
                    return t >= 0 && t < e.length ? this.getPixelForOffset(e[t].value) : null
                },
                getValueForPixel: function (t) {
                    var e = this,
                        i = e._offsets,
                        n = e.getDecimalForPixel(t) / i.factor - i.end,
                        l = ml(e._table, "pos", n, "time");
                    return e._adapter._create(l)
                },
                _getLabelSize: function (t) {
                    var e = this,
                        i = e.options.ticks,
                        n = e.ctx.measureText(t).width,
                        l = at.toRadians(e.isHorizontal() ? i.maxRotation : i.minRotation),
                        r = Math.cos(l),
                        a = Math.sin(l),
                        o = rl(i.fontSize, Q.global.defaultFontSize);
                    return {
                        w: n * r + o * a,
                        h: n * a + o * r
                    }
                },
                getLabelWidth: function (t) {
                    return this._getLabelSize(t).w
                },
                getLabelCapacity: function (t) {
                    var e = this,
                        i = e.options.time,
                        n = i.displayFormats,
                        l = n[i.unit] || n.millisecond,
                        r = e.tickFormatFunction(t, 0, Al(e, [t], e._majorUnit), l),
                        a = e._getLabelSize(r),
                        o = Math.floor(e.isHorizontal() ? e.width / a.w : e.height / a.h);
                    return e.options.offset && o--, o > 0 ? o : 1
                }
            }),
            El = Ml;
        Cl._defaults = El;
        var Ol = {
                category: xn,
                linear: Ln,
                logarithmic: zn,
                radialLinear: el,
                time: Cl
            },
            Tl = {
                datetime: "MMM D, YYYY, h:mm:ss a",
                millisecond: "h:mm:ss.SSS a",
                second: "h:mm:ss a",
                minute: "h:mm a",
                hour: "hA",
                day: "MMM D",
                week: "ll",
                month: "MMM YYYY",
                quarter: "[Q]Q - YYYY",
                year: "YYYY"
            };
        Ui._date.override("function" == typeof t ? {
            _id: "moment",
            formats: function () {
                return Tl
            },
            parse: function (e, i) {
                return "string" == typeof e && "string" == typeof i ? e = t(e, i) : e instanceof t || (e = t(e)), e.isValid() ? e.valueOf() : null
            },
            format: function (e, i) {
                return t(e).format(i)
            },
            add: function (e, i, n) {
                return t(e).add(i, n).valueOf()
            },
            diff: function (e, i, n) {
                return t(e).diff(t(i), n)
            },
            startOf: function (e, i, n) {
                return e = t(e), "isoWeek" === i ? e.isoWeekday(n).valueOf() : e.startOf(i).valueOf()
            },
            endOf: function (e, i) {
                return t(e).endOf(i).valueOf()
            },
            _create: function (e) {
                return t(e)
            }
        } : {}), Q._set("global", {
            plugins: {
                filler: {
                    propagate: !0
                }
            }
        });
        var Pl = {
            dataset: function (t) {
                var e = t.fill,
                    i = t.chart,
                    n = i.getDatasetMeta(e),
                    l = n && i.isDatasetVisible(e) && n.dataset._children || [],
                    r = l.length || 0;
                return r ? function (t, e) {
                    return e < r && l[e]._view || null
                } : null
            },
            boundary: function (t) {
                var e = t.boundary,
                    i = e ? e.x : null,
                    n = e ? e.y : null;
                return at.isArray(e) ? function (t, i) {
                    return e[i]
                } : function (t) {
                    return {
                        x: null === i ? t.x : i,
                        y: null === n ? t.y : n
                    }
                }
            }
        };

        function Ll(t, e, i) {
            var n, l = t._model || {},
                r = l.fill;
            if (void 0 === r && (r = !!l.backgroundColor), !1 === r || null === r) return !1;
            if (!0 === r) return "origin";
            if (n = parseFloat(r, 10), isFinite(n) && Math.floor(n) === n) return "-" !== r[0] && "+" !== r[0] || (n = e + n), !(n === e || n < 0 || n >= i) && n;
            switch (r) {
                case "bottom":
                    return "start";
                case "top":
                    return "end";
                case "zero":
                    return "origin";
                case "origin":
                case "start":
                case "end":
                    return r;
                default:
                    return !1
            }
        }

        function Dl(t) {
            var e, i = t.el._model || {},
                n = t.el._scale || {},
                l = t.fill,
                r = null;
            if (isFinite(l)) return null;
            if ("start" === l ? r = void 0 === i.scaleBottom ? n.bottom : i.scaleBottom : "end" === l ? r = void 0 === i.scaleTop ? n.top : i.scaleTop : void 0 !== i.scaleZero ? r = i.scaleZero : n.getBasePixel && (r = n.getBasePixel()), null != r) {
                if (void 0 !== r.x && void 0 !== r.y) return r;
                if (at.isFinite(r)) return {
                    x: (e = n.isHorizontal()) ? r : null,
                    y: e ? null : r
                }
            }
            return null
        }

        function Il(t) {
            var e, i, n, l, r, a = t.el._scale,
                o = a.options,
                s = a.chart.data.labels.length,
                c = t.fill,
                u = [];
            if (!s) return null;
            for (e = o.ticks.reverse ? a.max : a.min, i = o.ticks.reverse ? a.min : a.max, n = a.getPointPositionForValue(0, e), l = 0; l < s; ++l) r = "start" === c || "end" === c ? a.getPointPositionForValue(l, "start" === c ? e : i) : a.getBasePosition(l), o.gridLines.circular && (r.cx = n.x, r.cy = n.y, r.angle = a.getIndexAngle(l) - Math.PI / 2), u.push(r);
            return u
        }

        function jl(t) {
            return (t.el._scale || {}).getPointPositionForValue ? Il(t) : Dl(t)
        }

        function Nl(t, e, i) {
            var n, l = t[e].fill,
                r = [e];
            if (!i) return l;
            for (; !1 !== l && -1 === r.indexOf(l);) {
                if (!isFinite(l)) return l;
                if (!(n = t[l])) return !1;
                if (n.visible) return l;
                r.push(l), l = n.fill
            }
            return !1
        }

        function Rl(t) {
            var e = t.fill,
                i = "dataset";
            return !1 === e ? null : (isFinite(e) || (i = "boundary"), Pl[i](t))
        }

        function Fl(t) {
            return t && !t.skip
        }

        function zl(t, e, i, n, l) {
            var r, a, o, s;
            if (n && l) {
                for (t.moveTo(e[0].x, e[0].y), r = 1; r < n; ++r) at.canvas.lineTo(t, e[r - 1], e[r]);
                if (void 0 === i[0].angle)
                    for (t.lineTo(i[l - 1].x, i[l - 1].y), r = l - 1; r > 0; --r) at.canvas.lineTo(t, i[r], i[r - 1], !0);
                else
                    for (a = i[0].cx, o = i[0].cy, s = Math.sqrt(Math.pow(i[0].x - a, 2) + Math.pow(i[0].y - o, 2)), r = l - 1; r > 0; --r) t.arc(a, o, s, i[r].angle, i[r - 1].angle, !0)
            }
        }

        function Hl(t, e, i, n, l, r) {
            var a, o, s, c, u, h, d, f, p = e.length,
                g = n.spanGaps,
                m = [],
                v = [],
                y = 0,
                b = 0;
            for (t.beginPath(), a = 0, o = p; a < o; ++a) u = i(c = e[s = a % p]._view, s, n), h = Fl(c), d = Fl(u), r && void 0 === f && h && (o = p + (f = a + 1)), h && d ? (y = m.push(c), b = v.push(u)) : y && b && (g ? (h && m.push(c), d && v.push(u)) : (zl(t, m, v, y, b), y = b = 0, m = [], v = []));
            zl(t, m, v, y, b), t.closePath(), t.fillStyle = l, t.fill()
        }
        var Bl = {
                id: "filler",
                afterDatasetsUpdate: function (t, e) {
                    var i, n, l, r, a = (t.data.datasets || []).length,
                        o = e.propagate,
                        s = [];
                    for (n = 0; n < a; ++n) r = null, (l = (i = t.getDatasetMeta(n)).dataset) && l._model && l instanceof qt.Line && (r = {
                        visible: t.isDatasetVisible(n),
                        fill: Ll(l, n, a),
                        chart: t,
                        el: l
                    }), i.$filler = r, s.push(r);
                    for (n = 0; n < a; ++n)(r = s[n]) && (r.fill = Nl(s, n, o), r.boundary = jl(r), r.mapper = Rl(r))
                },
                beforeDatasetsDraw: function (t) {
                    var e, i, n, l, r, a, o, s = t._getSortedVisibleDatasetMetas(),
                        c = t.ctx;
                    for (i = s.length - 1; i >= 0; --i)(e = s[i].$filler) && e.visible && (l = (n = e.el)._view, r = n._children || [], a = e.mapper, o = l.backgroundColor || Q.global.defaultColor, a && o && r.length && (at.canvas.clipArea(c, t.chartArea), Hl(c, r, a, l, o, n._loop), at.canvas.unclipArea(c)))
                }
            },
            Yl = at.rtl.getRtlAdapter,
            Wl = at.noop,
            Vl = at.valueOrDefault;

        function Xl(t, e) {
            return t.usePointStyle && t.boxWidth > e ? e : t.boxWidth
        }
        Q._set("global", {
            legend: {
                display: !0,
                position: "top",
                align: "center",
                fullWidth: !0,
                reverse: !1,
                weight: 1e3,
                onClick: function (t, e) {
                    var i = e.datasetIndex,
                        n = this.chart,
                        l = n.getDatasetMeta(i);
                    l.hidden = null === l.hidden ? !n.data.datasets[i].hidden : null, n.update()
                },
                onHover: null,
                onLeave: null,
                labels: {
                    boxWidth: 40,
                    padding: 10,
                    generateLabels: function (t) {
                        var e = t.data.datasets,
                            i = t.options.legend || {},
                            n = i.labels && i.labels.usePointStyle;
                        return t._getSortedDatasetMetas().map((function (i) {
                            var l = i.controller.getStyle(n ? 0 : void 0);
                            return {
                                text: e[i.index].label,
                                fillStyle: l.backgroundColor,
                                hidden: !t.isDatasetVisible(i.index),
                                lineCap: l.borderCapStyle,
                                lineDash: l.borderDash,
                                lineDashOffset: l.borderDashOffset,
                                lineJoin: l.borderJoinStyle,
                                lineWidth: l.borderWidth,
                                strokeStyle: l.borderColor,
                                pointStyle: l.pointStyle,
                                rotation: l.rotation,
                                datasetIndex: i.index
                            }
                        }), this)
                    }
                }
            },
            legendCallback: function (t) {
                var e, i, n, l = document.createElement("ul"),
                    r = t.data.datasets;
                for (l.setAttribute("class", t.id + "-legend"), e = 0, i = r.length; e < i; e++)(n = l.appendChild(document.createElement("li"))).appendChild(document.createElement("span")).style.backgroundColor = r[e].backgroundColor, r[e].label && n.appendChild(document.createTextNode(r[e].label));
                return l.outerHTML
            }
        });
        var ql = pt.extend({
            initialize: function (t) {
                var e = this;
                at.extend(e, t), e.legendHitBoxes = [], e._hoveredItem = null, e.doughnutMode = !1
            },
            beforeUpdate: Wl,
            update: function (t, e, i) {
                var n = this;
                return n.beforeUpdate(), n.maxWidth = t, n.maxHeight = e, n.margins = i, n.beforeSetDimensions(), n.setDimensions(), n.afterSetDimensions(), n.beforeBuildLabels(), n.buildLabels(), n.afterBuildLabels(), n.beforeFit(), n.fit(), n.afterFit(), n.afterUpdate(), n.minSize
            },
            afterUpdate: Wl,
            beforeSetDimensions: Wl,
            setDimensions: function () {
                var t = this;
                t.isHorizontal() ? (t.width = t.maxWidth, t.left = 0, t.right = t.width) : (t.height = t.maxHeight, t.top = 0, t.bottom = t.height), t.paddingLeft = 0, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0, t.minSize = {
                    width: 0,
                    height: 0
                }
            },
            afterSetDimensions: Wl,
            beforeBuildLabels: Wl,
            buildLabels: function () {
                var t = this,
                    e = t.options.labels || {},
                    i = at.callback(e.generateLabels, [t.chart], t) || [];
                e.filter && (i = i.filter((function (i) {
                    return e.filter(i, t.chart.data)
                }))), t.options.reverse && i.reverse(), t.legendItems = i
            },
            afterBuildLabels: Wl,
            beforeFit: Wl,
            fit: function () {
                var t = this,
                    e = t.options,
                    i = e.labels,
                    n = e.display,
                    l = t.ctx,
                    r = at.options._parseFont(i),
                    a = r.size,
                    o = t.legendHitBoxes = [],
                    s = t.minSize,
                    c = t.isHorizontal();
                if (c ? (s.width = t.maxWidth, s.height = n ? 10 : 0) : (s.width = n ? 10 : 0, s.height = t.maxHeight), n) {
                    if (l.font = r.string, c) {
                        var u = t.lineWidths = [0],
                            h = 0;
                        l.textAlign = "left", l.textBaseline = "middle", at.each(t.legendItems, (function (t, e) {
                            var n = Xl(i, a) + a / 2 + l.measureText(t.text).width;
                            (0 === e || u[u.length - 1] + n + 2 * i.padding > s.width) && (h += a + i.padding, u[u.length - (e > 0 ? 0 : 1)] = 0), o[e] = {
                                left: 0,
                                top: 0,
                                width: n,
                                height: a
                            }, u[u.length - 1] += n + i.padding
                        })), s.height += h
                    } else {
                        var d = i.padding,
                            f = t.columnWidths = [],
                            p = t.columnHeights = [],
                            g = i.padding,
                            m = 0,
                            v = 0;
                        at.each(t.legendItems, (function (t, e) {
                            var n = Xl(i, a) + a / 2 + l.measureText(t.text).width;
                            e > 0 && v + a + 2 * d > s.height && (g += m + i.padding, f.push(m), p.push(v), m = 0, v = 0), m = Math.max(m, n), v += a + d, o[e] = {
                                left: 0,
                                top: 0,
                                width: n,
                                height: a
                            }
                        })), g += m, f.push(m), p.push(v), s.width += g
                    }
                    t.width = s.width, t.height = s.height
                } else t.width = s.width = t.height = s.height = 0
            },
            afterFit: Wl,
            isHorizontal: function () {
                return "top" === this.options.position || "bottom" === this.options.position
            },
            draw: function () {
                var t = this,
                    e = t.options,
                    i = e.labels,
                    n = Q.global,
                    l = n.defaultColor,
                    r = n.elements.line,
                    a = t.height,
                    o = t.columnHeights,
                    s = t.width,
                    c = t.lineWidths;
                if (e.display) {
                    var u, h = Yl(e.rtl, t.left, t.minSize.width),
                        d = t.ctx,
                        f = Vl(i.fontColor, n.defaultFontColor),
                        p = at.options._parseFont(i),
                        g = p.size;
                    d.textAlign = h.textAlign("left"), d.textBaseline = "middle", d.lineWidth = .5, d.strokeStyle = f, d.fillStyle = f, d.font = p.string;
                    var m = Xl(i, g),
                        v = t.legendHitBoxes,
                        y = function (t, e, n) {
                            if (!(isNaN(m) || m <= 0)) {
                                d.save();
                                var a = Vl(n.lineWidth, r.borderWidth);
                                if (d.fillStyle = Vl(n.fillStyle, l), d.lineCap = Vl(n.lineCap, r.borderCapStyle), d.lineDashOffset = Vl(n.lineDashOffset, r.borderDashOffset), d.lineJoin = Vl(n.lineJoin, r.borderJoinStyle), d.lineWidth = a, d.strokeStyle = Vl(n.strokeStyle, l), d.setLineDash && d.setLineDash(Vl(n.lineDash, r.borderDash)), i && i.usePointStyle) {
                                    var o = m * Math.SQRT2 / 2,
                                        s = h.xPlus(t, m / 2),
                                        c = e + g / 2;
                                    at.canvas.drawPoint(d, n.pointStyle, o, s, c, n.rotation)
                                } else d.fillRect(h.leftForLtr(t, m), e, m, g), 0 !== a && d.strokeRect(h.leftForLtr(t, m), e, m, g);
                                d.restore()
                            }
                        },
                        b = function (t, e, i, n) {
                            var l = g / 2,
                                r = h.xPlus(t, m + l),
                                a = e + l;
                            d.fillText(i.text, r, a), i.hidden && (d.beginPath(), d.lineWidth = 2, d.moveTo(r, a), d.lineTo(h.xPlus(r, n), a), d.stroke())
                        },
                        x = function (t, n) {
                            switch (e.align) {
                                case "start":
                                    return i.padding;
                                case "end":
                                    return t - n;
                                default:
                                    return (t - n + i.padding) / 2
                            }
                        },
                        w = t.isHorizontal();
                    u = w ? {
                        x: t.left + x(s, c[0]),
                        y: t.top + i.padding,
                        line: 0
                    } : {
                        x: t.left + i.padding,
                        y: t.top + x(a, o[0]),
                        line: 0
                    }, at.rtl.overrideTextDirection(t.ctx, e.textDirection);
                    var _ = g + i.padding;
                    at.each(t.legendItems, (function (e, n) {
                        var l = d.measureText(e.text).width,
                            r = m + g / 2 + l,
                            f = u.x,
                            p = u.y;
                        h.setWidth(t.minSize.width), w ? n > 0 && f + r + i.padding > t.left + t.minSize.width && (p = u.y += _, u.line++, f = u.x = t.left + x(s, c[u.line])) : n > 0 && p + _ > t.top + t.minSize.height && (f = u.x = f + t.columnWidths[u.line] + i.padding, u.line++, p = u.y = t.top + x(a, o[u.line]));
                        var k = h.x(f);
                        y(k, p, e), v[n].left = h.leftForLtr(k, v[n].width), v[n].top = p, b(k, p, e, l), w ? u.x += r + i.padding : u.y += _
                    })), at.rtl.restoreTextDirection(t.ctx, e.textDirection)
                }
            },
            _getLegendItemAt: function (t, e) {
                var i, n, l, r = this;
                if (t >= r.left && t <= r.right && e >= r.top && e <= r.bottom)
                    for (l = r.legendHitBoxes, i = 0; i < l.length; ++i)
                        if (t >= (n = l[i]).left && t <= n.left + n.width && e >= n.top && e <= n.top + n.height) return r.legendItems[i];
                return null
            },
            handleEvent: function (t) {
                var e, i = this,
                    n = i.options,
                    l = "mouseup" === t.type ? "click" : t.type;
                if ("mousemove" === l) {
                    if (!n.onHover && !n.onLeave) return
                } else {
                    if ("click" !== l) return;
                    if (!n.onClick) return
                }
                e = i._getLegendItemAt(t.x, t.y), "click" === l ? e && n.onClick && n.onClick.call(i, t.native, e) : (n.onLeave && e !== i._hoveredItem && (i._hoveredItem && n.onLeave.call(i, t.native, i._hoveredItem), i._hoveredItem = e), n.onHover && e && n.onHover.call(i, t.native, e))
            }
        });

        function Zl(t, e) {
            var i = new ql({
                ctx: t.ctx,
                options: e,
                chart: t
            });
            Ve.configure(t, i, e), Ve.addBox(t, i), t.legend = i
        }
        var Gl = {
                id: "legend",
                _element: ql,
                beforeInit: function (t) {
                    var e = t.options.legend;
                    e && Zl(t, e)
                },
                beforeUpdate: function (t) {
                    var e = t.options.legend,
                        i = t.legend;
                    e ? (at.mergeIf(e, Q.global.legend), i ? (Ve.configure(t, i, e), i.options = e) : Zl(t, e)) : i && (Ve.removeBox(t, i), delete t.legend)
                },
                afterEvent: function (t, e) {
                    var i = t.legend;
                    i && i.handleEvent(e)
                }
            },
            Ul = at.noop;
        Q._set("global", {
            title: {
                display: !1,
                fontStyle: "bold",
                fullWidth: !0,
                padding: 10,
                position: "top",
                text: "",
                weight: 2e3
            }
        });
        var Kl = pt.extend({
            initialize: function (t) {
                var e = this;
                at.extend(e, t), e.legendHitBoxes = []
            },
            beforeUpdate: Ul,
            update: function (t, e, i) {
                var n = this;
                return n.beforeUpdate(), n.maxWidth = t, n.maxHeight = e, n.margins = i, n.beforeSetDimensions(), n.setDimensions(), n.afterSetDimensions(), n.beforeBuildLabels(), n.buildLabels(), n.afterBuildLabels(), n.beforeFit(), n.fit(), n.afterFit(), n.afterUpdate(), n.minSize
            },
            afterUpdate: Ul,
            beforeSetDimensions: Ul,
            setDimensions: function () {
                var t = this;
                t.isHorizontal() ? (t.width = t.maxWidth, t.left = 0, t.right = t.width) : (t.height = t.maxHeight, t.top = 0, t.bottom = t.height), t.paddingLeft = 0, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0, t.minSize = {
                    width: 0,
                    height: 0
                }
            },
            afterSetDimensions: Ul,
            beforeBuildLabels: Ul,
            buildLabels: Ul,
            afterBuildLabels: Ul,
            beforeFit: Ul,
            fit: function () {
                var t, e = this,
                    i = e.options,
                    n = e.minSize = {},
                    l = e.isHorizontal();
                i.display ? (t = (at.isArray(i.text) ? i.text.length : 1) * at.options._parseFont(i).lineHeight + 2 * i.padding, e.width = n.width = l ? e.maxWidth : t, e.height = n.height = l ? t : e.maxHeight) : e.width = n.width = e.height = n.height = 0
            },
            afterFit: Ul,
            isHorizontal: function () {
                var t = this.options.position;
                return "top" === t || "bottom" === t
            },
            draw: function () {
                var t = this,
                    e = t.ctx,
                    i = t.options;
                if (i.display) {
                    var n, l, r, a = at.options._parseFont(i),
                        o = a.lineHeight,
                        s = o / 2 + i.padding,
                        c = 0,
                        u = t.top,
                        h = t.left,
                        d = t.bottom,
                        f = t.right;
                    e.fillStyle = at.valueOrDefault(i.fontColor, Q.global.defaultFontColor), e.font = a.string, t.isHorizontal() ? (l = h + (f - h) / 2, r = u + s, n = f - h) : (l = "left" === i.position ? h + s : f - s, r = u + (d - u) / 2, n = d - u, c = Math.PI * ("left" === i.position ? -.5 : .5)), e.save(), e.translate(l, r), e.rotate(c), e.textAlign = "center", e.textBaseline = "middle";
                    var p = i.text;
                    if (at.isArray(p))
                        for (var g = 0, m = 0; m < p.length; ++m) e.fillText(p[m], 0, g, n), g += o;
                    else e.fillText(p, 0, 0, n);
                    e.restore()
                }
            }
        });

        function $l(t, e) {
            var i = new Kl({
                ctx: t.ctx,
                options: e,
                chart: t
            });
            Ve.configure(t, i, e), Ve.addBox(t, i), t.titleBlock = i
        }
        var Ql = {},
            Jl = Bl,
            tr = Gl,
            er = {
                id: "title",
                _element: Kl,
                beforeInit: function (t) {
                    var e = t.options.title;
                    e && $l(t, e)
                },
                beforeUpdate: function (t) {
                    var e = t.options.title,
                        i = t.titleBlock;
                    e ? (at.mergeIf(e, Q.global.title), i ? (Ve.configure(t, i, e), i.options = e) : $l(t, e)) : i && (Ve.removeBox(t, i), delete t.titleBlock)
                }
            };
        for (var ir in Ql.filler = Jl, Ql.legend = tr, Ql.title = er, Xi.helpers = at, qi(), Xi._adapters = Ui, Xi.Animation = mt, Xi.animationService = vt, Xi.controllers = Se, Xi.DatasetController = kt, Xi.defaults = Q, Xi.Element = pt, Xi.elements = qt, Xi.Interaction = Pe, Xi.layouts = Ve, Xi.platform = yi, Xi.plugins = bi, Xi.Scale = vn, Xi.scaleService = xi, Xi.Ticks = Ki, Xi.Tooltip = ji, Xi.helpers.each(Ol, (function (t, e) {
                Xi.scaleService.registerScaleType(e, t, t._defaults)
            })), Ql) Ql.hasOwnProperty(ir) && Xi.plugins.register(Ql[ir]);
        Xi.platform.initialize();
        var nr = Xi;
        return "undefined" != typeof window && (window.Chart = Xi), Xi.Chart = Xi, Xi.Legend = Ql.legend._element, Xi.Title = Ql.title._element, Xi.pluginService = Xi.plugins, Xi.PluginBase = Xi.Element.extend({}), Xi.canvasHelpers = Xi.helpers.canvas, Xi.layoutService = Xi.layouts, Xi.LinearScaleBase = An, Xi.helpers.each(["Bar", "Bubble", "Doughnut", "Line", "PolarArea", "Radar", "Scatter"], (function (t) {
            Xi[t] = function (e, i) {
                return new Xi(e, Xi.helpers.merge(i || {}, {
                    type: t.charAt(0).toLowerCase() + t.slice(1)
                }))
            }
        })), nr
    }(function () {
        try {
            return i(208)
        } catch (t) {}
    }())
}, function (t, e, i) {
    t.exports = i(210)
}, function (t, e, i) {
    var n = i(30),
        l = i(96),
        r = i(66),
        a = i(52),
        o = i(97),
        s = i(15),
        c = i(98),
        u = Object.getOwnPropertyDescriptor;
    e.f = n ? u : function (t, e) {
        if (t = a(t), e = o(e, !0), c) try {
            return u(t, e)
        } catch (t) {}
        if (s(t, e)) return r(!l.f.call(t, e), t[e])
    }
}, function (t, e, i) {
    "use strict";
    var n = {}.propertyIsEnumerable,
        l = Object.getOwnPropertyDescriptor,
        r = l && !n.call({
            1: 2
        }, 1);
    e.f = r ? function (t) {
        var e = l(this, t);
        return !!e && e.enumerable
    } : n
}, function (t, e, i) {
    var n = i(14);
    t.exports = function (t, e) {
        if (!n(t)) return t;
        var i, l;
        if (e && "function" == typeof (i = t.toString) && !n(l = i.call(t))) return l;
        if ("function" == typeof (i = t.valueOf) && !n(l = i.call(t))) return l;
        if (!e && "function" == typeof (i = t.toString) && !n(l = i.call(t))) return l;
        throw TypeError("Can't convert object to primitive value")
    }
}, function (t, e, i) {
    var n = i(30),
        l = i(4),
        r = i(99);
    t.exports = !n && !l((function () {
        return 7 != Object.defineProperty(r("div"), "a", {
            get: function () {
                return 7
            }
        }).a
    }))
}, function (t, e, i) {
    var n = i(1),
        l = i(14),
        r = n.document,
        a = l(r) && l(r.createElement);
    t.exports = function (t) {
        return a ? r.createElement(t) : {}
    }
}, function (t, e, i) {
    var n = i(68),
        l = Function.toString;
    "function" != typeof n.inspectSource && (n.inspectSource = function (t) {
        return l.call(t)
    }), t.exports = n.inspectSource
}, function (t, e, i) {
    var n = i(1),
        l = i(100),
        r = n.WeakMap;
    t.exports = "function" == typeof r && /native code/.test(l(r))
}, function (t, e, i) {
    var n = i(15),
        l = i(52),
        r = i(153).indexOf,
        a = i(54);
    t.exports = function (t, e) {
        var i, o = l(t),
            s = 0,
            c = [];
        for (i in o) !n(a, i) && n(o, i) && c.push(i);
        for (; e.length > s;) n(o, i = e[s++]) && (~r(c, i) || c.push(i));
        return c
    }
}, function (t, e) {
    e.f = Object.getOwnPropertySymbols
}, function (t, e, i) {
    var n = i(4),
        l = /#|\.prototype\./,
        r = function (t, e) {
            var i = o[a(t)];
            return i == c || i != s && ("function" == typeof e ? n(e) : !!e)
        },
        a = r.normalize = function (t) {
            return String(t).replace(l, ".").toLowerCase()
        },
        o = r.data = {},
        s = r.NATIVE = "N",
        c = r.POLYFILL = "P";
    t.exports = r
}, function (t, e, i) {
    "use strict";
    var n = i(75).forEach,
        l = i(109)("forEach");
    t.exports = l ? [].forEach : function (t) {
        return n(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
}, function (t, e, i) {
    var n = i(107);
    t.exports = function (t, e, i) {
        if (n(t), void 0 === e) return t;
        switch (i) {
            case 0:
                return function () {
                    return t.call(e)
                };
            case 1:
                return function (i) {
                    return t.call(e, i)
                };
            case 2:
                return function (i, n) {
                    return t.call(e, i, n)
                };
            case 3:
                return function (i, n, l) {
                    return t.call(e, i, n, l)
                }
        }
        return function () {
            return t.apply(e, arguments)
        }
    }
}, function (t, e) {
    t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
        return t
    }
}, function (t, e, i) {
    var n = i(76),
        l = i(4);
    t.exports = !!Object.getOwnPropertySymbols && !l((function () {
        var t = Symbol();
        return !String(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && n && n < 41
    }))
}, function (t, e, i) {
    "use strict";
    var n = i(4);
    t.exports = function (t, e) {
        var i = [][t];
        return !!i && n((function () {
            i.call(null, e || function () {
                throw 1
            }, 1)
        }))
    }
}, function (t, e) {
    t.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    }
}, function (t, e, i) {
    "use strict";
    var n = i(52),
        l = i(162),
        r = i(44),
        a = i(43),
        o = i(114),
        s = "Array Iterator",
        c = a.set,
        u = a.getterFor(s);
    t.exports = o(Array, "Array", (function (t, e) {
        c(this, {
            type: s,
            target: n(t),
            index: 0,
            kind: e
        })
    }), (function () {
        var t = u(this),
            e = t.target,
            i = t.kind,
            n = t.index++;
        return !e || n >= e.length ? (t.target = void 0, {
            value: void 0,
            done: !0
        }) : "keys" == i ? {
            value: n,
            done: !1
        } : "values" == i ? {
            value: e[n],
            done: !1
        } : {
            value: [n, e[n]],
            done: !1
        }
    }), "values"), r.Arguments = r.Array, l("keys"), l("values"), l("entries")
}, function (t, e, i) {
    var n, l = i(16),
        r = i(163),
        a = i(74),
        o = i(54),
        s = i(164),
        c = i(99),
        u = i(69),
        h = u("IE_PROTO"),
        d = function () {},
        f = function (t) {
            return "<script>" + t + "</" + "script>"
        },
        p = function () {
            try {
                n = document.domain && new ActiveXObject("htmlfile")
            } catch (t) {}
            var t, e;
            p = n ? function (t) {
                t.write(f("")), t.close();
                var e = t.parentWindow.Object;
                return t = null, e
            }(n) : ((e = c("iframe")).style.display = "none", s.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write(f("document.F=Object")), t.close(), t.F);
            for (var i = a.length; i--;) delete p.prototype[a[i]];
            return p()
        };
    o[h] = !0, t.exports = Object.create || function (t, e) {
        var i;
        return null !== t ? (d.prototype = l(t), i = new d, d.prototype = null, i[h] = t) : i = p(), void 0 === e ? i : r(i, e)
    }
}, function (t, e, i) {
    var n = i(102),
        l = i(74);
    t.exports = Object.keys || function (t) {
        return n(t, l)
    }
}, function (t, e, i) {
    "use strict";
    var n = i(27),
        l = i(165),
        r = i(116),
        a = i(117),
        o = i(77),
        s = i(24),
        c = i(36),
        u = i(9),
        h = i(71),
        d = i(44),
        f = i(115),
        p = f.IteratorPrototype,
        g = f.BUGGY_SAFARI_ITERATORS,
        m = u("iterator"),
        v = "keys",
        y = "values",
        b = "entries",
        x = function () {
            return this
        };
    t.exports = function (t, e, i, u, f, w, _) {
        l(i, e, u);
        var k, S, A, M = function (t) {
                if (t === f && P) return P;
                if (!g && t in O) return O[t];
                switch (t) {
                    case v:
                    case y:
                    case b:
                        return function () {
                            return new i(this, t)
                        }
                }
                return function () {
                    return new i(this)
                }
            },
            C = e + " Iterator",
            E = !1,
            O = t.prototype,
            T = O[m] || O["@@iterator"] || f && O[f],
            P = !g && T || M(f),
            L = "Array" == e && O.entries || T;
        if (L && (k = r(L.call(new t)), p !== Object.prototype && k.next && (h || r(k) === p || (a ? a(k, p) : "function" != typeof k[m] && s(k, m, x)), o(k, C, !0, !0), h && (d[C] = x))), f == y && T && T.name !== y && (E = !0, P = function () {
                return T.call(this)
            }), h && !_ || O[m] === P || s(O, m, P), d[e] = P, f)
            if (S = {
                    values: M(y),
                    keys: w ? P : M(v),
                    entries: M(b)
                }, _)
                for (A in S)(g || E || !(A in O)) && c(O, A, S[A]);
            else n({
                target: e,
                proto: !0,
                forced: g || E
            }, S);
        return S
    }
}, function (t, e, i) {
    "use strict";
    var n, l, r, a = i(4),
        o = i(116),
        s = i(24),
        c = i(15),
        u = i(9),
        h = i(71),
        d = u("iterator"),
        f = !1;
    [].keys && ("next" in (r = [].keys()) ? (l = o(o(r))) !== Object.prototype && (n = l) : f = !0);
    var p = null == n || a((function () {
        var t = {};
        return n[d].call(t) !== t
    }));
    p && (n = {}), h && !p || c(n, d) || s(n, d, (function () {
        return this
    })), t.exports = {
        IteratorPrototype: n,
        BUGGY_SAFARI_ITERATORS: f
    }
}, function (t, e, i) {
    var n = i(15),
        l = i(35),
        r = i(69),
        a = i(166),
        o = r("IE_PROTO"),
        s = Object.prototype;
    t.exports = a ? Object.getPrototypeOf : function (t) {
        return t = l(t), n(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? s : null
    }
}, function (t, e, i) {
    var n = i(16),
        l = i(167);
    t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
        var t, e = !1,
            i = {};
        try {
            (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(i, []), e = i instanceof Array
        } catch (t) {}
        return function (i, r) {
            return n(i), l(r), e ? t.call(i, r) : i.__proto__ = r, i
        }
    }() : void 0)
}, function (t, e, i) {
    var n = i(78),
        l = i(42),
        r = i(9)("toStringTag"),
        a = "Arguments" == l(function () {
            return arguments
        }());
    t.exports = n ? l : function (t) {
        var e, i, n;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (i = function (t, e) {
            try {
                return t[e]
            } catch (t) {}
        }(e = Object(t), r)) ? i : a ? l(e) : "Object" == (n = l(e)) && "function" == typeof e.callee ? "Arguments" : n
    }
}, function (t, e) {
    t.exports = "\t\n\v\f\r Â áš€â€€â€â€‚â€ƒâ€„â€…â€†â€‡â€ˆâ€‰â€Šâ€¯âŸã€€\u2028\u2029\ufeff"
}, function (t, e, i) {
    var n = i(55),
        l = i(34),
        r = function (t) {
            return function (e, i) {
                var r, a, o = String(l(e)),
                    s = n(i),
                    c = o.length;
                return s < 0 || s >= c ? t ? "" : void 0 : (r = o.charCodeAt(s)) < 55296 || r > 56319 || s + 1 === c || (a = o.charCodeAt(s + 1)) < 56320 || a > 57343 ? t ? o.charAt(s) : r : t ? o.slice(s, s + 2) : a - 56320 + (r - 55296 << 10) + 65536
            }
        };
    t.exports = {
        codeAt: r(!1),
        charAt: r(!0)
    }
}, function (t, e, i) {
    var n = i(36);
    t.exports = function (t, e, i) {
        for (var l in e) n(t, l, e[l], i);
        return t
    }
}, function (t, e, i) {
    var n = i(16),
        l = i(179),
        r = i(37),
        a = i(106),
        o = i(180),
        s = i(181),
        c = function (t, e) {
            this.stopped = t, this.result = e
        };
    t.exports = function (t, e, i) {
        var u, h, d, f, p, g, m, v = i && i.that,
            y = !(!i || !i.AS_ENTRIES),
            b = !(!i || !i.IS_ITERATOR),
            x = !(!i || !i.INTERRUPTED),
            w = a(e, v, 1 + y + x),
            _ = function (t) {
                return u && s(u), new c(!0, t)
            },
            k = function (t) {
                return y ? (n(t), x ? w(t[0], t[1], _) : w(t[0], t[1])) : x ? w(t, _) : w(t)
            };
        if (b) u = t;
        else {
            if ("function" != typeof (h = o(t))) throw TypeError("Target is not iterable");
            if (l(h)) {
                for (d = 0, f = r(t.length); f > d; d++)
                    if ((p = k(t[d])) && p instanceof c) return p;
                return new c(!1)
            }
            u = h.call(t)
        }
        for (g = u.next; !(m = g.call(u)).done;) {
            try {
                p = k(m.value)
            } catch (t) {
                throw s(u), t
            }
            if ("object" == typeof p && p && p instanceof c) return p
        }
        return new c(!1)
    }
}, function (t, e) {
    t.exports = function (t, e, i) {
        if (!(t instanceof e)) throw TypeError("Incorrect " + (i ? i + " " : "") + "invocation");
        return t
    }
}, function (t, e, i) {
    "use strict";
    var n = i(27),
        l = i(80);
    n({
        target: "RegExp",
        proto: !0,
        forced: /./.exec !== l
    }, {
        exec: l
    })
}, function (t, e, i) {
    "use strict";
    i(124);
    var n = i(36),
        l = i(80),
        r = i(4),
        a = i(9),
        o = i(24),
        s = a("species"),
        c = RegExp.prototype,
        u = !r((function () {
            var t = /./;
            return t.exec = function () {
                var t = [];
                return t.groups = {
                    a: "7"
                }, t
            }, "7" !== "".replace(t, "$<a>")
        })),
        h = "$0" === "a".replace(/./, "$0"),
        d = a("replace"),
        f = !!/./ [d] && "" === /./ [d]("a", "$0"),
        p = !r((function () {
            var t = /(?:)/,
                e = t.exec;
            t.exec = function () {
                return e.apply(this, arguments)
            };
            var i = "ab".split(t);
            return 2 !== i.length || "a" !== i[0] || "b" !== i[1]
        }));
    t.exports = function (t, e, i, d) {
        var g = a(t),
            m = !r((function () {
                var e = {};
                return e[g] = function () {
                    return 7
                }, 7 != "" [t](e)
            })),
            v = m && !r((function () {
                var e = !1,
                    i = /a/;
                return "split" === t && ((i = {}).constructor = {}, i.constructor[s] = function () {
                    return i
                }, i.flags = "", i[g] = /./ [g]), i.exec = function () {
                    return e = !0, null
                }, i[g](""), !e
            }));
        if (!m || !v || "replace" === t && (!u || !h || f) || "split" === t && !p) {
            var y = /./ [g],
                b = i(g, "" [t], (function (t, e, i, n, r) {
                    var a = e.exec;
                    return a === l || a === c.exec ? m && !r ? {
                        done: !0,
                        value: y.call(e, i, n)
                    } : {
                        done: !0,
                        value: t.call(i, e, n)
                    } : {
                        done: !1
                    }
                }), {
                    REPLACE_KEEPS_$0: h,
                    REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: f
                }),
                x = b[0],
                w = b[1];
            n(String.prototype, t, x), n(c, g, 2 == e ? function (t, e) {
                return w.call(t, this, e)
            } : function (t) {
                return w.call(t, this)
            })
        }
        d && o(c[g], "sham", !0)
    }
}, function (t, e, i) {
    "use strict";
    var n = i(120).charAt;
    t.exports = function (t, e, i) {
        return e + (i ? n(t, e).length : 1)
    }
}, function (t, e, i) {
    var n = i(42),
        l = i(80);
    t.exports = function (t, e) {
        var i = t.exec;
        if ("function" == typeof i) {
            var r = i.call(t, e);
            if ("object" != typeof r) throw TypeError("RegExp exec method returned something other than an Object or null");
            return r
        }
        if ("RegExp" !== n(t)) throw TypeError("RegExp#exec called on incompatible receiver");
        return l.call(t, e)
    }
}, , , , , , , , , , function (t, e, i) {
    (function (e) {
        var i = "__lodash_hash_undefined__",
            n = "[object Function]",
            l = "[object GeneratorFunction]",
            r = /^\[object .+?Constructor\]$/,
            a = "object" == typeof e && e && e.Object === Object && e,
            o = "object" == typeof self && self && self.Object === Object && self,
            s = a || o || Function("return this")();
        var c, u = Array.prototype,
            h = Function.prototype,
            d = Object.prototype,
            f = s["__core-js_shared__"],
            p = (c = /[^.]+$/.exec(f && f.keys && f.keys.IE_PROTO || "")) ? "Symbol(src)_1." + c : "",
            g = h.toString,
            m = d.hasOwnProperty,
            v = d.toString,
            y = RegExp("^" + g.call(m).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
            b = u.splice,
            x = E(s, "Map"),
            w = E(Object, "create");

        function _(t) {
            var e = -1,
                i = t ? t.length : 0;
            for (this.clear(); ++e < i;) {
                var n = t[e];
                this.set(n[0], n[1])
            }
        }

        function k(t) {
            var e = -1,
                i = t ? t.length : 0;
            for (this.clear(); ++e < i;) {
                var n = t[e];
                this.set(n[0], n[1])
            }
        }

        function S(t) {
            var e = -1,
                i = t ? t.length : 0;
            for (this.clear(); ++e < i;) {
                var n = t[e];
                this.set(n[0], n[1])
            }
        }

        function A(t, e) {
            for (var i, n, l = t.length; l--;)
                if ((i = t[l][0]) === (n = e) || i != i && n != n) return l;
            return -1
        }

        function M(t) {
            return !(!T(t) || (e = t, p && p in e)) && (function (t) {
                var e = T(t) ? v.call(t) : "";
                return e == n || e == l
            }(t) || function (t) {
                var e = !1;
                if (null != t && "function" != typeof t.toString) try {
                    e = !!(t + "")
                } catch (t) {}
                return e
            }(t) ? y : r).test(function (t) {
                if (null != t) {
                    try {
                        return g.call(t)
                    } catch (t) {}
                    try {
                        return t + ""
                    } catch (t) {}
                }
                return ""
            }(t));
            var e
        }

        function C(t, e) {
            var i, n, l = t.__data__;
            return ("string" == (n = typeof (i = e)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== i : null === i) ? l["string" == typeof e ? "string" : "hash"] : l.map
        }

        function E(t, e) {
            var i = function (t, e) {
                return null == t ? void 0 : t[e]
            }(t, e);
            return M(i) ? i : void 0
        }

        function O(t, e) {
            if ("function" != typeof t || e && "function" != typeof e) throw new TypeError("Expected a function");
            var i = function () {
                var n = arguments,
                    l = e ? e.apply(this, n) : n[0],
                    r = i.cache;
                if (r.has(l)) return r.get(l);
                var a = t.apply(this, n);
                return i.cache = r.set(l, a), a
            };
            return i.cache = new(O.Cache || S), i
        }

        function T(t) {
            var e = typeof t;
            return !!t && ("object" == e || "function" == e)
        }
        _.prototype.clear = function () {
            this.__data__ = w ? w(null) : {}
        }, _.prototype.delete = function (t) {
            return this.has(t) && delete this.__data__[t]
        }, _.prototype.get = function (t) {
            var e = this.__data__;
            if (w) {
                var n = e[t];
                return n === i ? void 0 : n
            }
            return m.call(e, t) ? e[t] : void 0
        }, _.prototype.has = function (t) {
            var e = this.__data__;
            return w ? void 0 !== e[t] : m.call(e, t)
        }, _.prototype.set = function (t, e) {
            return this.__data__[t] = w && void 0 === e ? i : e, this
        }, k.prototype.clear = function () {
            this.__data__ = []
        }, k.prototype.delete = function (t) {
            var e = this.__data__,
                i = A(e, t);
            return !(i < 0) && (i == e.length - 1 ? e.pop() : b.call(e, i, 1), !0)
        }, k.prototype.get = function (t) {
            var e = this.__data__,
                i = A(e, t);
            return i < 0 ? void 0 : e[i][1]
        }, k.prototype.has = function (t) {
            return A(this.__data__, t) > -1
        }, k.prototype.set = function (t, e) {
            var i = this.__data__,
                n = A(i, t);
            return n < 0 ? i.push([t, e]) : i[n][1] = e, this
        }, S.prototype.clear = function () {
            this.__data__ = {
                hash: new _,
                map: new(x || k),
                string: new _
            }
        }, S.prototype.delete = function (t) {
            return C(this, t).delete(t)
        }, S.prototype.get = function (t) {
            return C(this, t).get(t)
        }, S.prototype.has = function (t) {
            return C(this, t).has(t)
        }, S.prototype.set = function (t, e) {
            return C(this, t).set(t, e), this
        }, O.Cache = S, t.exports = O
    }).call(this, i(8))
}, function (t, e, i) {
    "use strict";
    (function (t) {
        var i = function () {
                if ("undefined" != typeof Map) return Map;

                function t(t, e) {
                    var i = -1;
                    return t.some((function (t, n) {
                        return t[0] === e && (i = n, !0)
                    })), i
                }
                return function () {
                    function e() {
                        this.__entries__ = []
                    }
                    return Object.defineProperty(e.prototype, "size", {
                        get: function () {
                            return this.__entries__.length
                        },
                        enumerable: !0,
                        configurable: !0
                    }), e.prototype.get = function (e) {
                        var i = t(this.__entries__, e),
                            n = this.__entries__[i];
                        return n && n[1]
                    }, e.prototype.set = function (e, i) {
                        var n = t(this.__entries__, e);
                        ~n ? this.__entries__[n][1] = i : this.__entries__.push([e, i])
                    }, e.prototype.delete = function (e) {
                        var i = this.__entries__,
                            n = t(i, e);
                        ~n && i.splice(n, 1)
                    }, e.prototype.has = function (e) {
                        return !!~t(this.__entries__, e)
                    }, e.prototype.clear = function () {
                        this.__entries__.splice(0)
                    }, e.prototype.forEach = function (t, e) {
                        void 0 === e && (e = null);
                        for (var i = 0, n = this.__entries__; i < n.length; i++) {
                            var l = n[i];
                            t.call(e, l[1], l[0])
                        }
                    }, e
                }()
            }(),
            n = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
            l = void 0 !== t && t.Math === Math ? t : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
            r = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(l) : function (t) {
                return setTimeout((function () {
                    return t(Date.now())
                }), 1e3 / 60)
            };
        var a = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
            o = "undefined" != typeof MutationObserver,
            s = function () {
                function t() {
                    this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (t, e) {
                        var i = !1,
                            n = !1,
                            l = 0;

                        function a() {
                            i && (i = !1, t()), n && s()
                        }

                        function o() {
                            r(a)
                        }

                        function s() {
                            var t = Date.now();
                            if (i) {
                                if (t - l < 2) return;
                                n = !0
                            } else i = !0, n = !1, setTimeout(o, e);
                            l = t
                        }
                        return s
                    }(this.refresh.bind(this), 20)
                }
                return t.prototype.addObserver = function (t) {
                    ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_()
                }, t.prototype.removeObserver = function (t) {
                    var e = this.observers_,
                        i = e.indexOf(t);
                    ~i && e.splice(i, 1), !e.length && this.connected_ && this.disconnect_()
                }, t.prototype.refresh = function () {
                    this.updateObservers_() && this.refresh()
                }, t.prototype.updateObservers_ = function () {
                    var t = this.observers_.filter((function (t) {
                        return t.gatherActive(), t.hasActive()
                    }));
                    return t.forEach((function (t) {
                        return t.broadcastActive()
                    })), t.length > 0
                }, t.prototype.connect_ = function () {
                    n && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), o ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
                        attributes: !0,
                        childList: !0,
                        characterData: !0,
                        subtree: !0
                    })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0)
                }, t.prototype.disconnect_ = function () {
                    n && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1)
                }, t.prototype.onTransitionEnd_ = function (t) {
                    var e = t.propertyName,
                        i = void 0 === e ? "" : e;
                    a.some((function (t) {
                        return !!~i.indexOf(t)
                    })) && this.refresh()
                }, t.getInstance = function () {
                    return this.instance_ || (this.instance_ = new t), this.instance_
                }, t.instance_ = null, t
            }(),
            c = function (t, e) {
                for (var i = 0, n = Object.keys(e); i < n.length; i++) {
                    var l = n[i];
                    Object.defineProperty(t, l, {
                        value: e[l],
                        enumerable: !1,
                        writable: !1,
                        configurable: !0
                    })
                }
                return t
            },
            u = function (t) {
                return t && t.ownerDocument && t.ownerDocument.defaultView || l
            },
            h = v(0, 0, 0, 0);

        function d(t) {
            return parseFloat(t) || 0
        }

        function f(t) {
            for (var e = [], i = 1; i < arguments.length; i++) e[i - 1] = arguments[i];
            return e.reduce((function (e, i) {
                return e + d(t["border-" + i + "-width"])
            }), 0)
        }

        function p(t) {
            var e = t.clientWidth,
                i = t.clientHeight;
            if (!e && !i) return h;
            var n = u(t).getComputedStyle(t),
                l = function (t) {
                    for (var e = {}, i = 0, n = ["top", "right", "bottom", "left"]; i < n.length; i++) {
                        var l = n[i],
                            r = t["padding-" + l];
                        e[l] = d(r)
                    }
                    return e
                }(n),
                r = l.left + l.right,
                a = l.top + l.bottom,
                o = d(n.width),
                s = d(n.height);
            if ("border-box" === n.boxSizing && (Math.round(o + r) !== e && (o -= f(n, "left", "right") + r), Math.round(s + a) !== i && (s -= f(n, "top", "bottom") + a)), ! function (t) {
                    return t === u(t).document.documentElement
                }(t)) {
                var c = Math.round(o + r) - e,
                    p = Math.round(s + a) - i;
                1 !== Math.abs(c) && (o -= c), 1 !== Math.abs(p) && (s -= p)
            }
            return v(l.left, l.top, o, s)
        }
        var g = "undefined" != typeof SVGGraphicsElement ? function (t) {
            return t instanceof u(t).SVGGraphicsElement
        } : function (t) {
            return t instanceof u(t).SVGElement && "function" == typeof t.getBBox
        };

        function m(t) {
            return n ? g(t) ? function (t) {
                var e = t.getBBox();
                return v(0, 0, e.width, e.height)
            }(t) : p(t) : h
        }

        function v(t, e, i, n) {
            return {
                x: t,
                y: e,
                width: i,
                height: n
            }
        }
        var y = function () {
                function t(t) {
                    this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = v(0, 0, 0, 0), this.target = t
                }
                return t.prototype.isActive = function () {
                    var t = m(this.target);
                    return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight
                }, t.prototype.broadcastRect = function () {
                    var t = this.contentRect_;
                    return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t
                }, t
            }(),
            b = function (t, e) {
                var i, n, l, r, a, o, s, u = (n = (i = e).x, l = i.y, r = i.width, a = i.height, o = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, s = Object.create(o.prototype), c(s, {
                    x: n,
                    y: l,
                    width: r,
                    height: a,
                    top: l,
                    right: n + r,
                    bottom: a + l,
                    left: n
                }), s);
                c(this, {
                    target: t,
                    contentRect: u
                })
            },
            x = function () {
                function t(t, e, n) {
                    if (this.activeObservations_ = [], this.observations_ = new i, "function" != typeof t) throw new TypeError("The callback provided as parameter 1 is not a function.");
                    this.callback_ = t, this.controller_ = e, this.callbackCtx_ = n
                }
                return t.prototype.observe = function (t) {
                    if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
                    if ("undefined" != typeof Element && Element instanceof Object) {
                        if (!(t instanceof u(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                        var e = this.observations_;
                        e.has(t) || (e.set(t, new y(t)), this.controller_.addObserver(this), this.controller_.refresh())
                    }
                }, t.prototype.unobserve = function (t) {
                    if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
                    if ("undefined" != typeof Element && Element instanceof Object) {
                        if (!(t instanceof u(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                        var e = this.observations_;
                        e.has(t) && (e.delete(t), e.size || this.controller_.removeObserver(this))
                    }
                }, t.prototype.disconnect = function () {
                    this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this)
                }, t.prototype.gatherActive = function () {
                    var t = this;
                    this.clearActive(), this.observations_.forEach((function (e) {
                        e.isActive() && t.activeObservations_.push(e)
                    }))
                }, t.prototype.broadcastActive = function () {
                    if (this.hasActive()) {
                        var t = this.callbackCtx_,
                            e = this.activeObservations_.map((function (t) {
                                return new b(t.target, t.broadcastRect())
                            }));
                        this.callback_.call(t, e, t), this.clearActive()
                    }
                }, t.prototype.clearActive = function () {
                    this.activeObservations_.splice(0)
                }, t.prototype.hasActive = function () {
                    return this.activeObservations_.length > 0
                }, t
            }(),
            w = "undefined" != typeof WeakMap ? new WeakMap : new i,
            _ = function t(e) {
                if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function.");
                if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
                var i = s.getInstance(),
                    n = new x(e, i, this);
                w.set(this, n)
            };
        ["observe", "unobserve", "disconnect"].forEach((function (t) {
            _.prototype[t] = function () {
                var e;
                return (e = w.get(this))[t].apply(e, arguments)
            }
        }));
        var k = void 0 !== l.ResizeObserver ? l.ResizeObserver : _;
        e.a = k
    }).call(this, i(8))
}, function (t, e, i) {
    "use strict";
    (function (e) {
        var n = i(198),
            l = i(204),
            r = i(207),
            a = document,
            o = a.documentElement;

        function s(t, i, n, r) {
            e.navigator.pointerEnabled ? l[i](t, {
                mouseup: "pointerup",
                mousedown: "pointerdown",
                mousemove: "pointermove"
            } [n], r) : e.navigator.msPointerEnabled ? l[i](t, {
                mouseup: "MSPointerUp",
                mousedown: "MSPointerDown",
                mousemove: "MSPointerMove"
            } [n], r) : (l[i](t, {
                mouseup: "touchend",
                mousedown: "touchstart",
                mousemove: "touchmove"
            } [n], r), l[i](t, n, r))
        }

        function c(t) {
            if (void 0 !== t.touches) return t.touches.length;
            if (void 0 !== t.which && 0 !== t.which) return t.which;
            if (void 0 !== t.buttons) return t.buttons;
            var e = t.button;
            return void 0 !== e ? 1 & e ? 1 : 2 & e ? 3 : 4 & e ? 2 : 0 : void 0
        }

        function u(t) {
            var e = t.getBoundingClientRect();
            return {
                left: e.left + h("scrollLeft", "pageXOffset"),
                top: e.top + h("scrollTop", "pageYOffset")
            }
        }

        function h(t, i) {
            return void 0 !== e[i] ? e[i] : o.clientHeight ? o[t] : a.body[t]
        }

        function d(t, e, i) {
            var n, l = (t = t || {}).className || "";
            return t.className += " gu-hide", n = a.elementFromPoint(e, i), t.className = l, n
        }

        function f() {
            return !1
        }

        function p() {
            return !0
        }

        function g(t) {
            return t.width || t.right - t.left
        }

        function m(t) {
            return t.height || t.bottom - t.top
        }

        function v(t) {
            return t.parentNode === a ? null : t.parentNode
        }

        function y(t) {
            return "INPUT" === t.tagName || "TEXTAREA" === t.tagName || "SELECT" === t.tagName || b(t)
        }

        function b(t) {
            return !!t && ("false" !== t.contentEditable && ("true" === t.contentEditable || b(v(t))))
        }

        function x(t) {
            return t.nextElementSibling || function () {
                var e = t;
                do {
                    e = e.nextSibling
                } while (e && 1 !== e.nodeType);
                return e
            }()
        }

        function w(t, e) {
            var i = function (t) {
                    return t.targetTouches && t.targetTouches.length ? t.targetTouches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t
                }(e),
                n = {
                    pageX: "clientX",
                    pageY: "clientY"
                };
            return t in n && !(t in i) && n[t] in i && (t = n[t]), i[t]
        }
        t.exports = function (t, e) {
            var i, h, b, _, k, S, A, M, C, E, O, T = arguments.length;
            1 === T && !1 === Array.isArray(t) && (e = t, t = []);
            var P, L = null,
                D = e || {};
            void 0 === D.moves && (D.moves = p), void 0 === D.accepts && (D.accepts = p), void 0 === D.invalid && (D.invalid = Z), void 0 === D.containers && (D.containers = t || []), void 0 === D.isContainer && (D.isContainer = f), void 0 === D.copy && (D.copy = !1), void 0 === D.copySortSource && (D.copySortSource = !1), void 0 === D.revertOnSpill && (D.revertOnSpill = !1), void 0 === D.removeOnSpill && (D.removeOnSpill = !1), void 0 === D.direction && (D.direction = "vertical"), void 0 === D.ignoreInputTextSelection && (D.ignoreInputTextSelection = !0), void 0 === D.mirrorContainer && (D.mirrorContainer = a.body);
            var I = n({
                containers: D.containers,
                start: X,
                end: G,
                cancel: J,
                remove: Q,
                destroy: z,
                canMove: V,
                dragging: !1
            });
            return !0 === D.removeOnSpill && I.on("over", lt).on("out", rt), N(), I;

            function j(t) {
                return -1 !== I.containers.indexOf(t) || D.isContainer(t)
            }

            function N(t) {
                var e = t ? "remove" : "add";
                s(o, e, "mousedown", B), s(o, e, "mouseup", K)
            }

            function R(t) {
                s(o, t ? "remove" : "add", "mousemove", Y)
            }

            function F(t) {
                var e = t ? "remove" : "add";
                l[e](o, "selectstart", H), l[e](o, "click", H)
            }

            function z() {
                N(!0), K({})
            }

            function H(t) {
                P && t.preventDefault()
            }

            function B(t) {
                if (S = t.clientX, A = t.clientY, !(1 !== c(t) || t.metaKey || t.ctrlKey)) {
                    var e = t.target,
                        i = W(e);
                    i && (P = i, R(), "mousedown" === t.type && (y(e) ? e.focus() : t.preventDefault()))
                }
            }

            function Y(t) {
                if (P)
                    if (0 !== c(t)) {
                        if (!(void 0 !== t.clientX && Math.abs(t.clientX - S) <= (D.slideFactorX || 0) && void 0 !== t.clientY && Math.abs(t.clientY - A) <= (D.slideFactorY || 0))) {
                            if (D.ignoreInputTextSelection) {
                                var e = w("clientX", t) || 0,
                                    i = w("clientY", t) || 0;
                                if (y(a.elementFromPoint(e, i))) return
                            }
                            var n = P;
                            R(!0), F(), G(), q(n);
                            var l = u(b);
                            _ = w("pageX", t) - l.left, k = w("pageY", t) - l.top, r.add(E || b, "gu-transit"), at(), nt(t)
                        }
                    } else K({})
            }

            function W(t) {
                if (!(I.dragging && i || j(t))) {
                    for (var e = t; v(t) && !1 === j(v(t));) {
                        if (D.invalid(t, e)) return;
                        if (!(t = v(t))) return
                    }
                    var n = v(t);
                    if (n)
                        if (!D.invalid(t, e))
                            if (D.moves(t, n, e, x(t))) return {
                                item: t,
                                source: n
                            }
                }
            }

            function V(t) {
                return !!W(t)
            }

            function X(t) {
                var e = W(t);
                e && q(e)
            }

            function q(t) {
                ut(t.item, t.source) && (E = t.item.cloneNode(!0), I.emit("cloned", E, t.item, "copy")), h = t.source, b = t.item, M = C = x(t.item), I.dragging = !0, I.emit("drag", b, h)
            }

            function Z() {
                return !1
            }

            function G() {
                if (I.dragging) {
                    var t = E || b;
                    $(t, v(t))
                }
            }

            function U() {
                P = !1, R(!0), F(!0)
            }

            function K(t) {
                if (U(), I.dragging) {
                    var e = E || b,
                        n = w("clientX", t) || 0,
                        l = w("clientY", t) || 0,
                        r = it(d(i, n, l), n, l);
                    r && (E && D.copySortSource || !E || r !== h) ? $(e, r) : D.removeOnSpill ? Q() : J()
                }
            }

            function $(t, e) {
                var i = v(t);
                E && D.copySortSource && e === h && i.removeChild(b), et(e) ? I.emit("cancel", t, h, h) : I.emit("drop", t, e, h, C), tt()
            }

            function Q() {
                if (I.dragging) {
                    var t = E || b,
                        e = v(t);
                    e && e.removeChild(t), I.emit(E ? "cancel" : "remove", t, e, h), tt()
                }
            }

            function J(t) {
                if (I.dragging) {
                    var e = arguments.length > 0 ? t : D.revertOnSpill,
                        i = E || b,
                        n = v(i),
                        l = et(n);
                    !1 === l && e && (E ? n && n.removeChild(E) : h.insertBefore(i, M)), l || e ? I.emit("cancel", i, h, h) : I.emit("drop", i, n, h, C), tt()
                }
            }

            function tt() {
                var t = E || b;
                U(), ot(), t && r.rm(t, "gu-transit"), O && clearTimeout(O), I.dragging = !1, L && I.emit("out", t, L, h), I.emit("dragend", t), h = b = E = M = C = O = L = null
            }

            function et(t, e) {
                var n;
                return n = void 0 !== e ? e : i ? C : x(E || b), t === h && n === M
            }

            function it(t, e, i) {
                for (var n = t; n && !l();) n = v(n);
                return n;

                function l() {
                    if (!1 === j(n)) return !1;
                    var l = st(n, t),
                        r = ct(n, l, e, i);
                    return !!et(n, r) || D.accepts(b, n, h, r)
                }
            }

            function nt(t) {
                if (i) {
                    t.preventDefault();
                    var e = w("clientX", t) || 0,
                        n = w("clientY", t) || 0,
                        l = e - _,
                        r = n - k;
                    i.style.left = l + "px", i.style.top = r + "px";
                    var a = E || b,
                        o = d(i, e, n),
                        s = it(o, e, n),
                        c = null !== s && s !== L;
                    (c || null === s) && (L && g("out"), L = s, c && g("over"));
                    var u = v(a);
                    if (s !== h || !E || D.copySortSource) {
                        var f, p = st(s, o);
                        if (null !== p) f = ct(s, p, e, n);
                        else {
                            if (!0 !== D.revertOnSpill || E) return void(E && u && u.removeChild(a));
                            f = M, s = h
                        }(null === f && c || f !== a && f !== x(a)) && (C = f, s.insertBefore(a, f), I.emit("shadow", a, s, h))
                    } else u && u.removeChild(a)
                }

                function g(t) {
                    I.emit(t, a, L, h)
                }
            }

            function lt(t) {
                r.rm(t, "gu-hide")
            }

            function rt(t) {
                I.dragging && r.add(t, "gu-hide")
            }

            function at() {
                if (!i) {
                    var t = b.getBoundingClientRect();
                    (i = b.cloneNode(!0)).style.width = g(t) + "px", i.style.height = m(t) + "px", r.rm(i, "gu-transit"), r.add(i, "gu-mirror"), D.mirrorContainer.appendChild(i), s(o, "add", "mousemove", nt), r.add(D.mirrorContainer, "gu-unselectable"), I.emit("cloned", i, b, "mirror")
                }
            }

            function ot() {
                i && (r.rm(D.mirrorContainer, "gu-unselectable"), s(o, "remove", "mousemove", nt), v(i).removeChild(i), i = null)
            }

            function st(t, e) {
                for (var i = e; i !== t && v(i) !== t;) i = v(i);
                return i === o ? null : i
            }

            function ct(t, e, i, n) {
                var l = "horizontal" === D.direction;
                return e !== t ? function () {
                    var t = e.getBoundingClientRect();
                    if (l) return r(i > t.left + g(t) / 2);
                    return r(n > t.top + m(t) / 2)
                }() : function () {
                    var e, r, a, o = t.children.length;
                    for (e = 0; e < o; e++) {
                        if (r = t.children[e], a = r.getBoundingClientRect(), l && a.left + a.width / 2 > i) return r;
                        if (!l && a.top + a.height / 2 > n) return r
                    }
                    return null
                }();

                function r(t) {
                    return t ? x(e) : e
                }
            }

            function ut(t, e) {
                return "boolean" == typeof D.copy ? D.copy : D.copy(t, e)
            }
        }
    }).call(this, i(8))
}, function (t, e, i) {
    "use strict";
    var n;

    function l(t) {
        return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function r(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function a(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function o(t, e, i) {
        return e && a(t.prototype, e), i && a(t, i), t
    }

    function s(t, e, i) {
        return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = i, t
    }

    function c(t, e) {
        var i = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t);
            e && (n = n.filter((function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable
            }))), i.push.apply(i, n)
        }
        return i
    }

    function u(t) {
        for (var e = 1; e < arguments.length; e++) {
            var i = null != arguments[e] ? arguments[e] : {};
            e % 2 ? c(Object(i), !0).forEach((function (e) {
                s(t, e, i[e])
            })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : c(Object(i)).forEach((function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e))
            }))
        }
        return t
    }

    function h(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: !0,
                configurable: !0
            }
        }), e && f(t, e)
    }

    function d(t) {
        return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function f(t, e) {
        return (f = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    function p(t, e) {
        return !e || "object" != typeof e && "function" != typeof e ? function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }(t) : e
    }

    function g(t) {
        var e = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Date.prototype.toString.call(Reflect.construct(Date, [], (function () {}))), !0
            } catch (t) {
                return !1
            }
        }();
        return function () {
            var i, n = d(t);
            if (e) {
                var l = d(this).constructor;
                i = Reflect.construct(n, arguments, l)
            } else i = n.apply(this, arguments);
            return p(this, i)
        }
    }

    function m(t) {
        return function (t) {
            if (Array.isArray(t)) return v(t)
        }(t) || function (t) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t)
        }(t) || function (t, e) {
            if (t) {
                if ("string" == typeof t) return v(t, e);
                var i = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? v(t, e) : void 0
            }
        }(t) || function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }

    function v(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
        return n
    }
    var y = function () {
            function t() {
                r(this, t)
            }
            return o(t, [{
                key: "shadeRGBColor",
                value: function (t, e) {
                    var i = e.split(","),
                        n = t < 0 ? 0 : 255,
                        l = t < 0 ? -1 * t : t,
                        r = parseInt(i[0].slice(4), 10),
                        a = parseInt(i[1], 10),
                        o = parseInt(i[2], 10);
                    return "rgb(" + (Math.round((n - r) * l) + r) + "," + (Math.round((n - a) * l) + a) + "," + (Math.round((n - o) * l) + o) + ")"
                }
            }, {
                key: "shadeHexColor",
                value: function (t, e) {
                    var i = parseInt(e.slice(1), 16),
                        n = t < 0 ? 0 : 255,
                        l = t < 0 ? -1 * t : t,
                        r = i >> 16,
                        a = i >> 8 & 255,
                        o = 255 & i;
                    return "#" + (16777216 + 65536 * (Math.round((n - r) * l) + r) + 256 * (Math.round((n - a) * l) + a) + (Math.round((n - o) * l) + o)).toString(16).slice(1)
                }
            }, {
                key: "shadeColor",
                value: function (e, i) {
                    return t.isColorHex(i) ? this.shadeHexColor(e, i) : this.shadeRGBColor(e, i)
                }
            }], [{
                key: "bind",
                value: function (t, e) {
                    return function () {
                        return t.apply(e, arguments)
                    }
                }
            }, {
                key: "isObject",
                value: function (t) {
                    return t && "object" === l(t) && !Array.isArray(t) && null != t
                }
            }, {
                key: "listToArray",
                value: function (t) {
                    var e, i = [];
                    for (e = 0; e < t.length; e++) i[e] = t[e];
                    return i
                }
            }, {
                key: "extend",
                value: function (t, e) {
                    var i = this;
                    "function" != typeof Object.assign && (Object.assign = function (t) {
                        if (null == t) throw new TypeError("Cannot convert undefined or null to object");
                        for (var e = Object(t), i = 1; i < arguments.length; i++) {
                            var n = arguments[i];
                            if (null != n)
                                for (var l in n) n.hasOwnProperty(l) && (e[l] = n[l])
                        }
                        return e
                    });
                    var n = Object.assign({}, t);
                    return this.isObject(t) && this.isObject(e) && Object.keys(e).forEach((function (l) {
                        i.isObject(e[l]) && l in t ? n[l] = i.extend(t[l], e[l]) : Object.assign(n, s({}, l, e[l]))
                    })), n
                }
            }, {
                key: "extendArray",
                value: function (e, i) {
                    var n = [];
                    return e.map((function (e) {
                        n.push(t.extend(i, e))
                    })), n
                }
            }, {
                key: "monthMod",
                value: function (t) {
                    return t % 12
                }
            }, {
                key: "clone",
                value: function (t) {
                    if ("[object Array]" === Object.prototype.toString.call(t)) {
                        for (var e = [], i = 0; i < t.length; i++) e[i] = this.clone(t[i]);
                        return e
                    }
                    if ("[object Null]" === Object.prototype.toString.call(t)) return null;
                    if ("[object Date]" === Object.prototype.toString.call(t)) return t;
                    if ("object" === l(t)) {
                        var n = {};
                        for (var r in t) t.hasOwnProperty(r) && (n[r] = this.clone(t[r]));
                        return n
                    }
                    return t
                }
            }, {
                key: "log10",
                value: function (t) {
                    return Math.log(t) / Math.LN10
                }
            }, {
                key: "roundToBase10",
                value: function (t) {
                    return Math.pow(10, Math.floor(Math.log10(t)))
                }
            }, {
                key: "roundToBase",
                value: function (t, e) {
                    return Math.pow(e, Math.floor(Math.log(t) / Math.log(e)))
                }
            }, {
                key: "parseNumber",
                value: function (t) {
                    return null === t ? t : parseFloat(t)
                }
            }, {
                key: "randomId",
                value: function () {
                    return (Math.random() + 1).toString(36).substring(4)
                }
            }, {
                key: "noExponents",
                value: function (t) {
                    var e = String(t).split(/[eE]/);
                    if (1 === e.length) return e[0];
                    var i = "",
                        n = t < 0 ? "-" : "",
                        l = e[0].replace(".", ""),
                        r = Number(e[1]) + 1;
                    if (r < 0) {
                        for (i = n + "0."; r++;) i += "0";
                        return i + l.replace(/^-/, "")
                    }
                    for (r -= l.length; r--;) i += "0";
                    return l + i
                }
            }, {
                key: "getDimensions",
                value: function (t) {
                    var e = getComputedStyle(t, null),
                        i = t.clientHeight,
                        n = t.clientWidth;
                    return i -= parseFloat(e.paddingTop) + parseFloat(e.paddingBottom), [n -= parseFloat(e.paddingLeft) + parseFloat(e.paddingRight), i]
                }
            }, {
                key: "getBoundingClientRect",
                value: function (t) {
                    var e = t.getBoundingClientRect();
                    return {
                        top: e.top,
                        right: e.right,
                        bottom: e.bottom,
                        left: e.left,
                        width: t.clientWidth,
                        height: t.clientHeight,
                        x: e.left,
                        y: e.top
                    }
                }
            }, {
                key: "getLargestStringFromArr",
                value: function (t) {
                    return t.reduce((function (t, e) {
                        return Array.isArray(e) && (e = e.reduce((function (t, e) {
                            return t.length > e.length ? t : e
                        }))), t.length > e.length ? t : e
                    }), 0)
                }
            }, {
                key: "hexToRgba",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "#999999",
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .6;
                    "#" !== t.substring(0, 1) && (t = "#999999");
                    var i = t.replace("#", "");
                    i = i.match(new RegExp("(.{" + i.length / 3 + "})", "g"));
                    for (var n = 0; n < i.length; n++) i[n] = parseInt(1 === i[n].length ? i[n] + i[n] : i[n], 16);
                    return void 0 !== e && i.push(e), "rgba(" + i.join(",") + ")"
                }
            }, {
                key: "getOpacityFromRGBA",
                value: function (t) {
                    return parseFloat(t.replace(/^.*,(.+)\)/, "$1"))
                }
            }, {
                key: "rgb2hex",
                value: function (t) {
                    return (t = t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && 4 === t.length ? "#" + ("0" + parseInt(t[1], 10).toString(16)).slice(-2) + ("0" + parseInt(t[2], 10).toString(16)).slice(-2) + ("0" + parseInt(t[3], 10).toString(16)).slice(-2) : ""
                }
            }, {
                key: "isColorHex",
                value: function (t) {
                    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t)
                }
            }, {
                key: "getPolygonPos",
                value: function (t, e) {
                    for (var i = [], n = 2 * Math.PI / e, l = 0; l < e; l++) {
                        var r = {};
                        r.x = t * Math.sin(l * n), r.y = -t * Math.cos(l * n), i.push(r)
                    }
                    return i
                }
            }, {
                key: "polarToCartesian",
                value: function (t, e, i, n) {
                    var l = (n - 90) * Math.PI / 180;
                    return {
                        x: t + i * Math.cos(l),
                        y: e + i * Math.sin(l)
                    }
                }
            }, {
                key: "escapeString",
                value: function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x",
                        i = t.toString().slice();
                    return i.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, e)
                }
            }, {
                key: "negToZero",
                value: function (t) {
                    return t < 0 ? 0 : t
                }
            }, {
                key: "moveIndexInArray",
                value: function (t, e, i) {
                    if (i >= t.length)
                        for (var n = i - t.length + 1; n--;) t.push(void 0);
                    return t.splice(i, 0, t.splice(e, 1)[0]), t
                }
            }, {
                key: "extractNumber",
                value: function (t) {
                    return parseFloat(t.replace(/[^\d.]*/g, ""))
                }
            }, {
                key: "findAncestor",
                value: function (t, e) {
                    for (;
                        (t = t.parentElement) && !t.classList.contains(e););
                    return t
                }
            }, {
                key: "setELstyles",
                value: function (t, e) {
                    for (var i in e) e.hasOwnProperty(i) && (t.style.key = e[i])
                }
            }, {
                key: "isNumber",
                value: function (t) {
                    return !isNaN(t) && parseFloat(Number(t)) === t && !isNaN(parseInt(t, 10))
                }
            }, {
                key: "isFloat",
                value: function (t) {
                    return Number(t) === t && t % 1 != 0
                }
            }, {
                key: "isSafari",
                value: function () {
                    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
                }
            }, {
                key: "isFirefox",
                value: function () {
                    return navigator.userAgent.toLowerCase().indexOf("firefox") > -1
                }
            }, {
                key: "isIE11",
                value: function () {
                    if (-1 !== window.navigator.userAgent.indexOf("MSIE") || window.navigator.appVersion.indexOf("Trident/") > -1) return !0
                }
            }, {
                key: "isIE",
                value: function () {
                    var t = window.navigator.userAgent,
                        e = t.indexOf("MSIE ");
                    if (e > 0) return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
                    if (t.indexOf("Trident/") > 0) {
                        var i = t.indexOf("rv:");
                        return parseInt(t.substring(i + 3, t.indexOf(".", i)), 10)
                    }
                    var n = t.indexOf("Edge/");
                    return n > 0 && parseInt(t.substring(n + 5, t.indexOf(".", n)), 10)
                }
            }]), t
        }(),
        b = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.setEasingFunctions()
            }
            return o(t, [{
                key: "setEasingFunctions",
                value: function () {
                    var t;
                    if (!this.w.globals.easing) {
                        switch (this.w.config.chart.animations.easing) {
                            case "linear":
                                t = "-";
                                break;
                            case "easein":
                                t = "<";
                                break;
                            case "easeout":
                                t = ">";
                                break;
                            case "easeinout":
                                t = "<>";
                                break;
                            case "swing":
                                t = function (t) {
                                    var e = 1.70158;
                                    return (t -= 1) * t * ((e + 1) * t + e) + 1
                                };
                                break;
                            case "bounce":
                                t = function (t) {
                                    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375
                                };
                                break;
                            case "elastic":
                                t = function (t) {
                                    return t === !!t ? t : Math.pow(2, -10 * t) * Math.sin((t - .075) * (2 * Math.PI) / .3) + 1
                                };
                                break;
                            default:
                                t = "<>"
                        }
                        this.w.globals.easing = t
                    }
                }
            }, {
                key: "animateLine",
                value: function (t, e, i, n) {
                    t.attr(e).animate(n).attr(i)
                }
            }, {
                key: "animateMarker",
                value: function (t, e, i, n, l, r) {
                    e || (e = 0), t.attr({
                        r: e,
                        width: e,
                        height: e
                    }).animate(n, l).attr({
                        r: i,
                        width: i.width,
                        height: i.height
                    }).afterAll((function () {
                        r()
                    }))
                }
            }, {
                key: "animateCircle",
                value: function (t, e, i, n, l) {
                    t.attr({
                        r: e.r,
                        cx: e.cx,
                        cy: e.cy
                    }).animate(n, l).attr({
                        r: i.r,
                        cx: i.cx,
                        cy: i.cy
                    })
                }
            }, {
                key: "animateRect",
                value: function (t, e, i, n, l) {
                    t.attr(e).animate(n).attr(i).afterAll((function () {
                        return l()
                    }))
                }
            }, {
                key: "animatePathsGradually",
                value: function (t) {
                    var e = t.el,
                        i = t.realIndex,
                        n = t.j,
                        l = t.fill,
                        r = t.pathFrom,
                        a = t.pathTo,
                        o = t.speed,
                        s = t.delay,
                        c = this.w,
                        u = 0;
                    c.config.chart.animations.animateGradually.enabled && (u = c.config.chart.animations.animateGradually.delay), c.config.chart.animations.dynamicAnimation.enabled && c.globals.dataChanged && "bar" !== c.config.chart.type && (u = 0), this.morphSVG(e, i, n, "line" !== c.config.chart.type || c.globals.comboCharts ? l : "stroke", r, a, o, s * u)
                }
            }, {
                key: "showDelayedElements",
                value: function () {
                    this.w.globals.delayedElements.forEach((function (t) {
                        t.el.classList.remove("apexcharts-element-hidden")
                    }))
                }
            }, {
                key: "animationCompleted",
                value: function (t) {
                    var e = this.w;
                    e.globals.animationEnded || (e.globals.animationEnded = !0, this.showDelayedElements(), "function" == typeof e.config.chart.events.animationEnd && e.config.chart.events.animationEnd(this.ctx, {
                        el: t,
                        w: e
                    }))
                }
            }, {
                key: "morphSVG",
                value: function (t, e, i, n, l, r, a, o) {
                    var s = this,
                        c = this.w;
                    l || (l = t.attr("pathFrom")), r || (r = t.attr("pathTo"));
                    var u = function (t) {
                        return "radar" === c.config.chart.type && (a = 1), "M 0 ".concat(c.globals.gridHeight)
                    };
                    (!l || l.indexOf("undefined") > -1 || l.indexOf("NaN") > -1) && (l = u()), (!r || r.indexOf("undefined") > -1 || r.indexOf("NaN") > -1) && (r = u()), c.globals.shouldAnimate || (a = 1), t.plot(l).animate(1, c.globals.easing, o).plot(l).animate(a, c.globals.easing, o).plot(r).afterAll((function () {
                        y.isNumber(i) ? i === c.globals.series[c.globals.maxValsInArrayIndex].length - 2 && c.globals.shouldAnimate && s.animationCompleted(t) : "none" !== n && c.globals.shouldAnimate && (!c.globals.comboCharts && e === c.globals.series.length - 1 || c.globals.comboCharts) && s.animationCompleted(t), s.showDelayedElements()
                    }))
                }
            }]), t
        }(),
        x = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "getDefaultFilter",
                value: function (t, e) {
                    var i = this.w;
                    t.unfilter(!0), (new window.SVG.Filter).size("120%", "180%", "-5%", "-40%"), "none" !== i.config.states.normal.filter ? this.applyFilter(t, e, i.config.states.normal.filter.type, i.config.states.normal.filter.value) : i.config.chart.dropShadow.enabled && this.dropShadow(t, i.config.chart.dropShadow, e)
                }
            }, {
                key: "addNormalFilter",
                value: function (t, e) {
                    var i = this.w;
                    i.config.chart.dropShadow.enabled && !t.node.classList.contains("apexcharts-marker") && this.dropShadow(t, i.config.chart.dropShadow, e)
                }
            }, {
                key: "addLightenFilter",
                value: function (t, e, i) {
                    var n = this,
                        l = this.w,
                        r = i.intensity;
                    t.unfilter(!0), new window.SVG.Filter, t.filter((function (t) {
                        var i = l.config.chart.dropShadow;
                        (i.enabled ? n.addShadow(t, e, i) : t).componentTransfer({
                            rgb: {
                                type: "linear",
                                slope: 1.5,
                                intercept: r
                            }
                        })
                    })), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node)
                }
            }, {
                key: "addDarkenFilter",
                value: function (t, e, i) {
                    var n = this,
                        l = this.w,
                        r = i.intensity;
                    t.unfilter(!0), new window.SVG.Filter, t.filter((function (t) {
                        var i = l.config.chart.dropShadow;
                        (i.enabled ? n.addShadow(t, e, i) : t).componentTransfer({
                            rgb: {
                                type: "linear",
                                slope: r
                            }
                        })
                    })), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node)
                }
            }, {
                key: "applyFilter",
                value: function (t, e, i) {
                    var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5;
                    switch (i) {
                        case "none":
                            this.addNormalFilter(t, e);
                            break;
                        case "lighten":
                            this.addLightenFilter(t, e, {
                                intensity: n
                            });
                            break;
                        case "darken":
                            this.addDarkenFilter(t, e, {
                                intensity: n
                            })
                    }
                }
            }, {
                key: "addShadow",
                value: function (t, e, i) {
                    var n = i.blur,
                        l = i.top,
                        r = i.left,
                        a = i.color,
                        o = i.opacity,
                        s = t.flood(Array.isArray(a) ? a[e] : a, o).composite(t.sourceAlpha, "in").offset(r, l).gaussianBlur(n).merge(t.source);
                    return t.blend(t.source, s)
                }
            }, {
                key: "dropShadow",
                value: function (t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                        n = e.top,
                        l = e.left,
                        r = e.blur,
                        a = e.color,
                        o = e.opacity,
                        s = e.noUserSpaceOnUse,
                        c = this.w;
                    return t.unfilter(!0), y.isIE() && "radialBar" === c.config.chart.type || (a = Array.isArray(a) ? a[i] : a, t.filter((function (t) {
                        var e;
                        e = y.isSafari() || y.isFirefox() || y.isIE() ? t.flood(a, o).composite(t.sourceAlpha, "in").offset(l, n).gaussianBlur(r) : t.flood(a, o).composite(t.sourceAlpha, "in").offset(l, n).gaussianBlur(r).merge(t.source), t.blend(t.source, e)
                    })), s || t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node)), t
                }
            }, {
                key: "setSelectionFilter",
                value: function (t, e, i) {
                    var n = this.w;
                    if (void 0 !== n.globals.selectedDataPoints[e] && n.globals.selectedDataPoints[e].indexOf(i) > -1) {
                        t.node.setAttribute("selected", !0);
                        var l = n.config.states.active.filter;
                        "none" !== l && this.applyFilter(t, e, l.type, l.value)
                    }
                }
            }, {
                key: "_scaleFilterSize",
                value: function (t) {
                    ! function (e) {
                        for (var i in e) e.hasOwnProperty(i) && t.setAttribute(i, e[i])
                    }({
                        width: "200%",
                        height: "200%",
                        x: "-50%",
                        y: "-50%"
                    })
                }
            }]), t
        }(),
        w = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "drawLine",
                value: function (t, e, i, n) {
                    var l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "#a8a8a8",
                        r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0,
                        a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null,
                        o = this.w,
                        s = o.globals.dom.Paper.line().attr({
                            x1: t,
                            y1: e,
                            x2: i,
                            y2: n,
                            stroke: l,
                            "stroke-dasharray": r,
                            "stroke-width": a
                        });
                    return s
                }
            }, {
                key: "drawRect",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
                        l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                        r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "#fefefe",
                        a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1,
                        o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null,
                        s = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null,
                        c = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0,
                        u = this.w,
                        h = u.globals.dom.Paper.rect();
                    return h.attr({
                        x: t,
                        y: e,
                        width: i > 0 ? i : 0,
                        height: n > 0 ? n : 0,
                        rx: l,
                        ry: l,
                        opacity: a,
                        "stroke-width": null !== o ? o : 0,
                        stroke: null !== s ? s : "none",
                        "stroke-dasharray": c
                    }), h.node.setAttribute("fill", r), h
                }
            }, {
                key: "drawPolygon",
                value: function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#e1e1e1",
                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
                        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "none",
                        l = this.w,
                        r = l.globals.dom.Paper.polygon(t).attr({
                            fill: n,
                            stroke: e,
                            "stroke-width": i
                        });
                    return r
                }
            }, {
                key: "drawCircle",
                value: function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                        i = this.w;
                    t < 0 && (t = 0);
                    var n = i.globals.dom.Paper.circle(2 * t);
                    return null !== e && n.attr(e), n
                }
            }, {
                key: "drawPath",
                value: function (t) {
                    var e = t.d,
                        i = void 0 === e ? "" : e,
                        n = t.stroke,
                        l = void 0 === n ? "#a8a8a8" : n,
                        r = t.strokeWidth,
                        a = void 0 === r ? 1 : r,
                        o = t.fill,
                        s = t.fillOpacity,
                        c = void 0 === s ? 1 : s,
                        u = t.strokeOpacity,
                        h = void 0 === u ? 1 : u,
                        d = t.classes,
                        f = t.strokeLinecap,
                        p = void 0 === f ? null : f,
                        g = t.strokeDashArray,
                        m = void 0 === g ? 0 : g,
                        v = this.w;
                    return null === p && (p = v.config.stroke.lineCap), (i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = "M 0 ".concat(v.globals.gridHeight)), v.globals.dom.Paper.path(i).attr({
                        fill: o,
                        "fill-opacity": c,
                        stroke: l,
                        "stroke-opacity": h,
                        "stroke-linecap": p,
                        "stroke-width": a,
                        "stroke-dasharray": m,
                        class: d
                    })
                }
            }, {
                key: "group",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                        e = this.w,
                        i = e.globals.dom.Paper.group();
                    return null !== t && i.attr(t), i
                }
            }, {
                key: "move",
                value: function (t, e) {
                    return ["M", t, e].join(" ")
                }
            }, {
                key: "line",
                value: function (t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                        n = null;
                    return null === i ? n = ["L", t, e].join(" ") : "H" === i ? n = ["H", t].join(" ") : "V" === i && (n = ["V", e].join(" ")), n
                }
            }, {
                key: "curve",
                value: function (t, e, i, n, l, r) {
                    return ["C", t, e, i, n, l, r].join(" ")
                }
            }, {
                key: "quadraticCurve",
                value: function (t, e, i, n) {
                    return ["Q", t, e, i, n].join(" ")
                }
            }, {
                key: "arc",
                value: function (t, e, i, n, l, r, a) {
                    var o = arguments.length > 7 && void 0 !== arguments[7] && arguments[7],
                        s = "A";
                    o && (s = "a");
                    var c = [s, t, e, i, n, l, r, a].join(" ");
                    return c
                }
            }, {
                key: "renderPaths",
                value: function (t) {
                    var e, i = t.j,
                        n = t.realIndex,
                        l = t.pathFrom,
                        r = t.pathTo,
                        a = t.stroke,
                        o = t.strokeWidth,
                        s = t.strokeLinecap,
                        c = t.fill,
                        h = t.animationDelay,
                        d = t.initialSpeed,
                        f = t.dataChangeSpeed,
                        p = t.className,
                        g = t.shouldClipToGrid,
                        m = void 0 === g || g,
                        v = t.bindEventsOnPaths,
                        y = void 0 === v || v,
                        w = t.drawShadow,
                        _ = void 0 === w || w,
                        k = this.w,
                        S = new x(this.ctx),
                        A = new b(this.ctx),
                        M = this.w.config.chart.animations.enabled,
                        C = M && this.w.config.chart.animations.dynamicAnimation.enabled,
                        E = !!(M && !k.globals.resized || C && k.globals.dataChanged && k.globals.shouldAnimate);
                    E ? e = l : (e = r, k.globals.animationEnded = !0);
                    var O, T = k.config.stroke.dashArray;
                    O = Array.isArray(T) ? T[n] : k.config.stroke.dashArray;
                    var P = this.drawPath({
                        d: e,
                        stroke: a,
                        strokeWidth: o,
                        fill: c,
                        fillOpacity: 1,
                        classes: p,
                        strokeLinecap: s,
                        strokeDashArray: O
                    });
                    if (P.attr("index", n), m && P.attr({
                            "clip-path": "url(#gridRectMask".concat(k.globals.cuid, ")")
                        }), "none" !== k.config.states.normal.filter.type) S.getDefaultFilter(P, n);
                    else if (k.config.chart.dropShadow.enabled && _ && (!k.config.chart.dropShadow.enabledOnSeries || k.config.chart.dropShadow.enabledOnSeries && -1 !== k.config.chart.dropShadow.enabledOnSeries.indexOf(n))) {
                        var L = k.config.chart.dropShadow;
                        S.dropShadow(P, L, n)
                    }
                    y && (P.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, P)), P.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, P)), P.node.addEventListener("mousedown", this.pathMouseDown.bind(this, P))), P.attr({
                        pathTo: r,
                        pathFrom: l
                    });
                    var D = {
                        el: P,
                        j: i,
                        realIndex: n,
                        pathFrom: l,
                        pathTo: r,
                        fill: c,
                        strokeWidth: o,
                        delay: h
                    };
                    return !M || k.globals.resized || k.globals.dataChanged ? !k.globals.resized && k.globals.dataChanged || A.showDelayedElements() : A.animatePathsGradually(u(u({}, D), {}, {
                        speed: d
                    })), k.globals.dataChanged && C && E && A.animatePathsGradually(u(u({}, D), {}, {
                        speed: f
                    })), P
                }
            }, {
                key: "drawPattern",
                value: function (t, e, i) {
                    var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "#a8a8a8",
                        l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                        r = this.w,
                        a = r.globals.dom.Paper.pattern(e, i, (function (r) {
                            "horizontalLines" === t ? r.line(0, 0, i, 0).stroke({
                                color: n,
                                width: l + 1
                            }) : "verticalLines" === t ? r.line(0, 0, 0, e).stroke({
                                color: n,
                                width: l + 1
                            }) : "slantedLines" === t ? r.line(0, 0, e, i).stroke({
                                color: n,
                                width: l
                            }) : "squares" === t ? r.rect(e, i).fill("none").stroke({
                                color: n,
                                width: l
                            }) : "circles" === t && r.circle(e).fill("none").stroke({
                                color: n,
                                width: l
                            })
                        }));
                    return a
                }
            }, {
                key: "drawGradient",
                value: function (t, e, i, n, l) {
                    var r, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
                        o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null,
                        s = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null,
                        c = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0,
                        u = this.w;
                    e.length < 9 && 0 === e.indexOf("#") && (e = y.hexToRgba(e, n)), i.length < 9 && 0 === i.indexOf("#") && (i = y.hexToRgba(i, l));
                    var h = 0,
                        d = 1,
                        f = 1,
                        p = null;
                    null !== o && (h = void 0 !== o[0] ? o[0] / 100 : 0, d = void 0 !== o[1] ? o[1] / 100 : 1, f = void 0 !== o[2] ? o[2] / 100 : 1, p = void 0 !== o[3] ? o[3] / 100 : null);
                    var g = !("donut" !== u.config.chart.type && "pie" !== u.config.chart.type && "polarArea" !== u.config.chart.type && "bubble" !== u.config.chart.type);
                    if (r = null === s || 0 === s.length ? u.globals.dom.Paper.gradient(g ? "radial" : "linear", (function (t) {
                            t.at(h, e, n), t.at(d, i, l), t.at(f, i, l), null !== p && t.at(p, e, n)
                        })) : u.globals.dom.Paper.gradient(g ? "radial" : "linear", (function (t) {
                            (Array.isArray(s[c]) ? s[c] : s).forEach((function (e) {
                                t.at(e.offset / 100, e.color, e.opacity)
                            }))
                        })), g) {
                        var m = u.globals.gridWidth / 2,
                            v = u.globals.gridHeight / 2;
                        "bubble" !== u.config.chart.type ? r.attr({
                            gradientUnits: "userSpaceOnUse",
                            cx: m,
                            cy: v,
                            r: a
                        }) : r.attr({
                            cx: .5,
                            cy: .5,
                            r: .8,
                            fx: .2,
                            fy: .2
                        })
                    } else "vertical" === t ? r.from(0, 0).to(0, 1) : "diagonal" === t ? r.from(0, 0).to(1, 1) : "horizontal" === t ? r.from(0, 1).to(1, 1) : "diagonal2" === t && r.from(1, 0).to(0, 1);
                    return r
                }
            }, {
                key: "drawText",
                value: function (t) {
                    var e, i = t.x,
                        n = t.y,
                        l = t.text,
                        r = t.textAnchor,
                        a = t.fontSize,
                        o = t.fontFamily,
                        s = t.fontWeight,
                        c = t.foreColor,
                        u = t.opacity,
                        h = t.cssClass,
                        d = void 0 === h ? "" : h,
                        f = t.isPlainText,
                        p = void 0 === f || f,
                        g = this.w;
                    return void 0 === l && (l = ""), r || (r = "start"), c && c.length || (c = g.config.chart.foreColor), o = o || g.config.chart.fontFamily, s = s || "regular", (e = Array.isArray(l) ? g.globals.dom.Paper.text((function (t) {
                        for (var e = 0; e < l.length; e++) 0 === e ? t.tspan(l[e]) : t.tspan(l[e]).newLine()
                    })) : p ? g.globals.dom.Paper.plain(l) : g.globals.dom.Paper.text((function (t) {
                        return t.tspan(l)
                    }))).attr({
                        x: i,
                        y: n,
                        "text-anchor": r,
                        "dominant-baseline": "auto",
                        "font-size": a,
                        "font-family": o,
                        "font-weight": s,
                        fill: c,
                        class: "apexcharts-text " + d
                    }), e.node.style.fontFamily = o, e.node.style.opacity = u, e
                }
            }, {
                key: "drawMarker",
                value: function (t, e, i) {
                    t = t || 0;
                    var n = i.pSize || 0,
                        l = null;
                    if ("square" === i.shape || "rect" === i.shape) {
                        var r = void 0 === i.pRadius ? n / 2 : i.pRadius;
                        null !== e && n || (n = 0, r = 0);
                        var a = 1.2 * n + r,
                            o = this.drawRect(a, a, a, a, r);
                        o.attr({
                            x: t - a / 2,
                            y: e - a / 2,
                            cx: t,
                            cy: e,
                            class: i.class ? i.class : "",
                            fill: i.pointFillColor,
                            "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                            stroke: i.pointStrokeColor,
                            "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                            "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                        }), l = o
                    } else "circle" !== i.shape && i.shape || (y.isNumber(e) || (n = 0, e = 0), l = this.drawCircle(n, {
                        cx: t,
                        cy: e,
                        class: i.class ? i.class : "",
                        stroke: i.pointStrokeColor,
                        fill: i.pointFillColor,
                        "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                        "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                        "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                    }));
                    return l
                }
            }, {
                key: "pathMouseEnter",
                value: function (t, e) {
                    var i = this.w,
                        n = new x(this.ctx),
                        l = parseInt(t.node.getAttribute("index"), 10),
                        r = parseInt(t.node.getAttribute("j"), 10);
                    if ("function" == typeof i.config.chart.events.dataPointMouseEnter && i.config.chart.events.dataPointMouseEnter(e, this.ctx, {
                            seriesIndex: l,
                            dataPointIndex: r,
                            w: i
                        }), this.ctx.events.fireEvent("dataPointMouseEnter", [e, this.ctx, {
                            seriesIndex: l,
                            dataPointIndex: r,
                            w: i
                        }]), ("none" === i.config.states.active.filter.type || "true" !== t.node.getAttribute("selected")) && "none" !== i.config.states.hover.filter.type && "none" !== i.config.states.active.filter.type && !i.globals.isTouchDevice) {
                        var a = i.config.states.hover.filter;
                        n.applyFilter(t, l, a.type, a.value)
                    }
                }
            }, {
                key: "pathMouseLeave",
                value: function (t, e) {
                    var i = this.w,
                        n = new x(this.ctx),
                        l = parseInt(t.node.getAttribute("index"), 10),
                        r = parseInt(t.node.getAttribute("j"), 10);
                    "function" == typeof i.config.chart.events.dataPointMouseLeave && i.config.chart.events.dataPointMouseLeave(e, this.ctx, {
                        seriesIndex: l,
                        dataPointIndex: r,
                        w: i
                    }), this.ctx.events.fireEvent("dataPointMouseLeave", [e, this.ctx, {
                        seriesIndex: l,
                        dataPointIndex: r,
                        w: i
                    }]), "none" !== i.config.states.active.filter.type && "true" === t.node.getAttribute("selected") || "none" !== i.config.states.hover.filter.type && n.getDefaultFilter(t, l)
                }
            }, {
                key: "pathMouseDown",
                value: function (t, e) {
                    var i = this.w,
                        n = new x(this.ctx),
                        l = parseInt(t.node.getAttribute("index"), 10),
                        r = parseInt(t.node.getAttribute("j"), 10),
                        a = "false";
                    if ("true" === t.node.getAttribute("selected")) {
                        if (t.node.setAttribute("selected", "false"), i.globals.selectedDataPoints[l].indexOf(r) > -1) {
                            var o = i.globals.selectedDataPoints[l].indexOf(r);
                            i.globals.selectedDataPoints[l].splice(o, 1)
                        }
                    } else {
                        if (!i.config.states.active.allowMultipleDataPointsSelection && i.globals.selectedDataPoints.length > 0) {
                            i.globals.selectedDataPoints = [];
                            var s = i.globals.dom.Paper.select(".apexcharts-series path").members,
                                c = i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members,
                                u = function (t) {
                                    Array.prototype.forEach.call(t, (function (t) {
                                        t.node.setAttribute("selected", "false"), n.getDefaultFilter(t, l)
                                    }))
                                };
                            u(s), u(c)
                        }
                        t.node.setAttribute("selected", "true"), a = "true", void 0 === i.globals.selectedDataPoints[l] && (i.globals.selectedDataPoints[l] = []), i.globals.selectedDataPoints[l].push(r)
                    }
                    if ("true" === a) {
                        var h = i.config.states.active.filter;
                        "none" !== h && n.applyFilter(t, l, h.type, h.value)
                    } else "none" !== i.config.states.active.filter.type && n.getDefaultFilter(t, l);
                    "function" == typeof i.config.chart.events.dataPointSelection && i.config.chart.events.dataPointSelection(e, this.ctx, {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: l,
                        dataPointIndex: r,
                        w: i
                    }), e && this.ctx.events.fireEvent("dataPointSelection", [e, this.ctx, {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: l,
                        dataPointIndex: r,
                        w: i
                    }])
                }
            }, {
                key: "rotateAroundCenter",
                value: function (t) {
                    var e = t.getBBox();
                    return {
                        x: e.x + e.width / 2,
                        y: e.y + e.height / 2
                    }
                }
            }, {
                key: "getTextRects",
                value: function (t, e, i, n) {
                    var l = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
                        r = this.w,
                        a = this.drawText({
                            x: -200,
                            y: -200,
                            text: t,
                            textAnchor: "start",
                            fontSize: e,
                            fontFamily: i,
                            foreColor: "#fff",
                            opacity: 0
                        });
                    n && a.attr("transform", n), r.globals.dom.Paper.add(a);
                    var o = a.bbox();
                    return l || (o = a.node.getBoundingClientRect()), a.remove(), {
                        width: o.width,
                        height: o.height
                    }
                }
            }, {
                key: "placeTextWithEllipsis",
                value: function (t, e, i) {
                    if ("function" == typeof t.getComputedTextLength && (t.textContent = e, e.length > 0 && t.getComputedTextLength() >= i / 1.1)) {
                        for (var n = e.length - 3; n > 0; n -= 3)
                            if (t.getSubStringLength(0, n) <= i / 1.1) return void(t.textContent = e.substring(0, n) + "...");
                        t.textContent = "."
                    }
                }
            }], [{
                key: "setAttrs",
                value: function (t, e) {
                    for (var i in e) e.hasOwnProperty(i) && t.setAttribute(i, e[i])
                }
            }]), t
        }(),
        _ = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.annoCtx = e
            }
            return o(t, [{
                key: "setOrientations",
                value: function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                        i = this.w;
                    if ("vertical" === t.label.orientation) {
                        var n = null !== e ? e : 0,
                            l = i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(n, "']"));
                        if (null !== l) {
                            var r = l.getBoundingClientRect();
                            l.setAttribute("x", parseFloat(l.getAttribute("x")) - r.height + 4), "top" === t.label.position ? l.setAttribute("y", parseFloat(l.getAttribute("y")) + r.width) : l.setAttribute("y", parseFloat(l.getAttribute("y")) - r.width);
                            var a = this.annoCtx.graphics.rotateAroundCenter(l),
                                o = a.x,
                                s = a.y;
                            l.setAttribute("transform", "rotate(-90 ".concat(o, " ").concat(s, ")"))
                        }
                    }
                }
            }, {
                key: "addBackgroundToAnno",
                value: function (t, e) {
                    var i = this.w;
                    if (!t || !e.label.text || e.label.text && !e.label.text.trim()) return null;
                    var n = i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(),
                        l = t.getBoundingClientRect(),
                        r = e.label.style.padding.left,
                        a = e.label.style.padding.right,
                        o = e.label.style.padding.top,
                        s = e.label.style.padding.bottom;
                    "vertical" === e.label.orientation && (o = e.label.style.padding.left, s = e.label.style.padding.right, r = e.label.style.padding.top, a = e.label.style.padding.bottom);
                    var c = l.left - n.left - r,
                        u = l.top - n.top - o,
                        h = this.annoCtx.graphics.drawRect(c - i.globals.barPadForNumericAxis, u, l.width + r + a, l.height + o + s, e.label.borderRadius, e.label.style.background, 1, e.label.borderWidth, e.label.borderColor, 0);
                    return e.id && h.node.classList.add(e.id), h
                }
            }, {
                key: "annotationsBackground",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = function (i, n, l) {
                            var r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(l, "-annotations .apexcharts-").concat(l, "-annotation-label[rel='").concat(n, "']"));
                            if (r) {
                                var a = r.parentNode,
                                    o = t.addBackgroundToAnno(r, i);
                                o && a.insertBefore(o.node, r)
                            }
                        };
                    e.config.annotations.xaxis.map((function (t, e) {
                        i(t, e, "xaxis")
                    })), e.config.annotations.yaxis.map((function (t, e) {
                        i(t, e, "yaxis")
                    })), e.config.annotations.points.map((function (t, e) {
                        i(t, e, "point")
                    }))
                }
            }, {
                key: "getStringX",
                value: function (t) {
                    var e = this.w,
                        i = t;
                    e.config.xaxis.convertedCatToNumeric && e.globals.categoryLabels.length && (t = e.globals.categoryLabels.indexOf(t) + 1);
                    var n = e.globals.labels.indexOf(t),
                        l = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(" + (n + 1) + ")");
                    return l && (i = parseFloat(l.getAttribute("x"))), i
                }
            }]), t
        }(),
        k = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis
            }
            return o(t, [{
                key: "addXaxisAnnotation",
                value: function (t, e, i) {
                    var n = this.w,
                        l = this.invertAxis ? n.globals.minY : n.globals.minX,
                        r = this.invertAxis ? n.globals.maxY : n.globals.maxX,
                        a = this.invertAxis ? n.globals.yRange[0] : n.globals.xRange,
                        o = (t.x - l) / (a / n.globals.gridWidth);
                    this.annoCtx.inversedReversedAxis && (o = (r - t.x) / (a / n.globals.gridWidth));
                    var s = t.label.text;
                    "category" !== n.config.xaxis.type && !n.config.xaxis.convertedCatToNumeric || this.invertAxis || n.globals.dataFormatXNumeric || (o = this.annoCtx.helpers.getStringX(t.x));
                    var c = t.strokeDashArray;
                    if (y.isNumber(o)) {
                        if (null === t.x2 || void 0 === t.x2) {
                            var u = this.annoCtx.graphics.drawLine(o + t.offsetX, 0 + t.offsetY, o + t.offsetX, n.globals.gridHeight + t.offsetY, t.borderColor, c, t.borderWidth);
                            e.appendChild(u.node), t.id && u.node.classList.add(t.id)
                        } else {
                            var h = (t.x2 - l) / (a / n.globals.gridWidth);
                            if (this.annoCtx.inversedReversedAxis && (h = (r - t.x2) / (a / n.globals.gridWidth)), "category" !== n.config.xaxis.type && !n.config.xaxis.convertedCatToNumeric || this.invertAxis || n.globals.dataFormatXNumeric || (h = this.annoCtx.helpers.getStringX(t.x2)), h < o) {
                                var d = o;
                                o = h, h = d
                            }
                            var f = this.annoCtx.graphics.drawRect(o + t.offsetX, 0 + t.offsetY, h - o, n.globals.gridHeight + t.offsetY, 0, t.fillColor, t.opacity, 1, t.borderColor, c);
                            f.node.classList.add("apexcharts-annotation-rect"), f.attr("clip-path", "url(#gridRectMask".concat(n.globals.cuid, ")")), e.appendChild(f.node), t.id && f.node.classList.add(t.id)
                        }
                        var p = "top" === t.label.position ? 4 : n.globals.gridHeight,
                            g = this.annoCtx.graphics.getTextRects(s, parseFloat(t.label.style.fontSize)),
                            m = this.annoCtx.graphics.drawText({
                                x: o + t.label.offsetX,
                                y: p + t.label.offsetY - ("vertical" === t.label.orientation ? "top" === t.label.position ? g.width / 2 - 12 : -g.width / 2 : 0),
                                text: s,
                                textAnchor: t.label.textAnchor,
                                fontSize: t.label.style.fontSize,
                                fontFamily: t.label.style.fontFamily,
                                fontWeight: t.label.style.fontWeight,
                                foreColor: t.label.style.color,
                                cssClass: "apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                            });
                        m.attr({
                            rel: i
                        }), e.appendChild(m.node), this.annoCtx.helpers.setOrientations(t, i)
                    }
                }
            }, {
                key: "drawXAxisAnnotations",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = this.annoCtx.graphics.group({
                            class: "apexcharts-xaxis-annotations"
                        });
                    return e.config.annotations.xaxis.map((function (e, n) {
                        t.addXaxisAnnotation(e, i.node, n)
                    })), i
                }
            }]), t
        }(),
        S = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "getStackedSeriesTotals",
                value: function () {
                    var t = this.w,
                        e = [];
                    if (0 === t.globals.series.length) return e;
                    for (var i = 0; i < t.globals.series[t.globals.maxValsInArrayIndex].length; i++) {
                        for (var n = 0, l = 0; l < t.globals.series.length; l++) void 0 !== t.globals.series[l][i] && (n += t.globals.series[l][i]);
                        e.push(n)
                    }
                    return t.globals.stackedSeriesTotals = e, e
                }
            }, {
                key: "getSeriesTotalByIndex",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                    return null === t ? this.w.config.series.reduce((function (t, e) {
                        return t + e
                    }), 0) : this.w.globals.series[t].reduce((function (t, e) {
                        return t + e
                    }), 0)
                }
            }, {
                key: "isSeriesNull",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                    return 0 === (null === t ? this.w.config.series.filter((function (t) {
                        return null !== t
                    })) : this.w.config.series[t].data.filter((function (t) {
                        return null !== t
                    }))).length
                }
            }, {
                key: "seriesHaveSameValues",
                value: function (t) {
                    return this.w.globals.series[t].every((function (t, e, i) {
                        return t === i[0]
                    }))
                }
            }, {
                key: "getCategoryLabels",
                value: function (t) {
                    var e = this.w,
                        i = t.slice();
                    return e.config.xaxis.convertedCatToNumeric && (i = t.map((function (t, i) {
                        return e.config.xaxis.labels.formatter(t - e.globals.minX + 1)
                    }))), i
                }
            }, {
                key: "getLargestSeries",
                value: function () {
                    var t = this.w;
                    t.globals.maxValsInArrayIndex = t.globals.series.map((function (t) {
                        return t.length
                    })).indexOf(Math.max.apply(Math, t.globals.series.map((function (t) {
                        return t.length
                    }))))
                }
            }, {
                key: "getLargestMarkerSize",
                value: function () {
                    var t = this.w,
                        e = 0;
                    return t.globals.markers.size.forEach((function (t) {
                        e = Math.max(e, t)
                    })), t.globals.markers.largestSize = e, e
                }
            }, {
                key: "getSeriesTotals",
                value: function () {
                    var t = this.w;
                    t.globals.seriesTotals = t.globals.series.map((function (t, e) {
                        var i = 0;
                        if (Array.isArray(t))
                            for (var n = 0; n < t.length; n++) i += t[n];
                        else i += t;
                        return i
                    }))
                }
            }, {
                key: "getSeriesTotalsXRange",
                value: function (t, e) {
                    var i = this.w;
                    return i.globals.series.map((function (n, l) {
                        for (var r = 0, a = 0; a < n.length; a++) i.globals.seriesX[l][a] > t && i.globals.seriesX[l][a] < e && (r += n[a]);
                        return r
                    }))
                }
            }, {
                key: "getPercentSeries",
                value: function () {
                    var t = this.w;
                    t.globals.seriesPercent = t.globals.series.map((function (e, i) {
                        var n = [];
                        if (Array.isArray(e))
                            for (var l = 0; l < e.length; l++) {
                                var r = t.globals.stackedSeriesTotals[l],
                                    a = 0;
                                r && (a = 100 * e[l] / r), n.push(a)
                            } else {
                                var o = 100 * e / t.globals.seriesTotals.reduce((function (t, e) {
                                    return t + e
                                }), 0);
                                n.push(o)
                            }
                        return n
                    }))
                }
            }, {
                key: "getCalculatedRatios",
                value: function () {
                    var t, e, i, n, l = this.w.globals,
                        r = [],
                        a = 0,
                        o = [],
                        s = .1,
                        c = 0;
                    if (l.yRange = [], l.isMultipleYAxis)
                        for (var u = 0; u < l.minYArr.length; u++) l.yRange.push(Math.abs(l.minYArr[u] - l.maxYArr[u])), o.push(0);
                    else l.yRange.push(Math.abs(l.minY - l.maxY));
                    l.xRange = Math.abs(l.maxX - l.minX), l.zRange = Math.abs(l.maxZ - l.minZ);
                    for (var h = 0; h < l.yRange.length; h++) r.push(l.yRange[h] / l.gridHeight);
                    if (e = l.xRange / l.gridWidth, i = Math.abs(l.initialMaxX - l.initialMinX) / l.gridWidth, t = l.yRange / l.gridWidth, n = l.xRange / l.gridHeight, (a = l.zRange / l.gridHeight * 16) || (a = 1), l.minY !== Number.MIN_VALUE && 0 !== Math.abs(l.minY) && (l.hasNegs = !0), l.isMultipleYAxis) {
                        o = [];
                        for (var d = 0; d < r.length; d++) o.push(-l.minYArr[d] / r[d])
                    } else o.push(-l.minY / r[0]), l.minY !== Number.MIN_VALUE && 0 !== Math.abs(l.minY) && (s = -l.minY / t, c = l.minX / e);
                    return {
                        yRatio: r,
                        invertedYRatio: t,
                        zRatio: a,
                        xRatio: e,
                        initialXRatio: i,
                        invertedXRatio: n,
                        baseLineInvertedY: s,
                        baseLineY: o,
                        baseLineX: c
                    }
                }
            }, {
                key: "getLogSeries",
                value: function (t) {
                    var e = this,
                        i = this.w;
                    return i.globals.seriesLog = t.map((function (t, n) {
                        return i.config.yaxis[n] && i.config.yaxis[n].logarithmic ? t.map((function (t) {
                            return null === t ? null : e.getLogVal(t, n)
                        })) : t
                    })), i.globals.invalidLogScale ? t : i.globals.seriesLog
                }
            }, {
                key: "getLogVal",
                value: function (t, e) {
                    var i = this.w;
                    return (Math.log(t) - Math.log(i.globals.minYArr[e])) / (Math.log(i.globals.maxYArr[e]) - Math.log(i.globals.minYArr[e]))
                }
            }, {
                key: "getLogYRatios",
                value: function (t) {
                    var e = this,
                        i = this.w,
                        n = this.w.globals;
                    return n.yLogRatio = t.slice(), n.logYRange = n.yRange.map((function (t, l) {
                        if (i.config.yaxis[l] && e.w.config.yaxis[l].logarithmic) {
                            var r, a = -Number.MAX_VALUE,
                                o = Number.MIN_VALUE;
                            return n.seriesLog.forEach((function (t, e) {
                                t.forEach((function (t) {
                                    i.config.yaxis[e] && i.config.yaxis[e].logarithmic && (a = Math.max(t, a), o = Math.min(t, o))
                                }))
                            })), r = Math.pow(n.yRange[l], Math.abs(o - a) / n.yRange[l]), n.yLogRatio[l] = r / n.gridHeight, r
                        }
                    })), n.invalidLogScale ? t.slice() : n.yLogRatio
                }
            }], [{
                key: "checkComboSeries",
                value: function (t) {
                    var e = !1,
                        i = 0,
                        n = 0;
                    return t.length && void 0 !== t[0].type && t.forEach((function (t) {
                        "bar" !== t.type && "column" !== t.type && "candlestick" !== t.type && "boxPlot" !== t.type || i++, void 0 !== t.type && n++
                    })), n > 1 && (e = !0), {
                        comboBarCount: i,
                        comboCharts: e
                    }
                }
            }, {
                key: "extendArrayProps",
                value: function (t, e, i) {
                    return e.yaxis && (e = t.extendYAxis(e, i)), e.annotations && (e.annotations.yaxis && (e = t.extendYAxisAnnotations(e)), e.annotations.xaxis && (e = t.extendXAxisAnnotations(e)), e.annotations.points && (e = t.extendPointAnnotations(e))), e
                }
            }]), t
        }(),
        A = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.annoCtx = e
            }
            return o(t, [{
                key: "addYaxisAnnotation",
                value: function (t, e, i) {
                    var n, l = this.w,
                        r = t.strokeDashArray,
                        a = this._getY1Y2("y1", t),
                        o = t.label.text;
                    if (null === t.y2 || void 0 === t.y2) {
                        var s = this.annoCtx.graphics.drawLine(0 + t.offsetX, a + t.offsetY, this._getYAxisAnnotationWidth(t), a + t.offsetY, t.borderColor, r, t.borderWidth);
                        e.appendChild(s.node), t.id && s.node.classList.add(t.id)
                    } else {
                        if ((n = this._getY1Y2("y2", t)) > a) {
                            var c = a;
                            a = n, n = c
                        }
                        var u = this.annoCtx.graphics.drawRect(0 + t.offsetX, n + t.offsetY, this._getYAxisAnnotationWidth(t), a - n, 0, t.fillColor, t.opacity, 1, t.borderColor, r);
                        u.node.classList.add("apexcharts-annotation-rect"), u.attr("clip-path", "url(#gridRectMask".concat(l.globals.cuid, ")")), e.appendChild(u.node), t.id && u.node.classList.add(t.id)
                    }
                    var h = "right" === t.label.position ? l.globals.gridWidth : 0,
                        d = this.annoCtx.graphics.drawText({
                            x: h + t.label.offsetX,
                            y: (n || a) + t.label.offsetY - 3,
                            text: o,
                            textAnchor: t.label.textAnchor,
                            fontSize: t.label.style.fontSize,
                            fontFamily: t.label.style.fontFamily,
                            fontWeight: t.label.style.fontWeight,
                            foreColor: t.label.style.color,
                            cssClass: "apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                        });
                    d.attr({
                        rel: i
                    }), e.appendChild(d.node)
                }
            }, {
                key: "_getY1Y2",
                value: function (t, e) {
                    var i, n = "y1" === t ? e.y : e.y2,
                        l = this.w;
                    if (this.annoCtx.invertAxis) {
                        var r = l.globals.labels.indexOf(n);
                        l.config.xaxis.convertedCatToNumeric && (r = l.globals.categoryLabels.indexOf(n));
                        var a = l.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(" + (r + 1) + ")");
                        a && (i = parseFloat(a.getAttribute("y")))
                    } else {
                        var o;
                        o = l.config.yaxis[e.yAxisIndex].logarithmic ? (n = new S(this.annoCtx.ctx).getLogVal(n, e.yAxisIndex)) / l.globals.yLogRatio[e.yAxisIndex] : (n - l.globals.minYArr[e.yAxisIndex]) / (l.globals.yRange[e.yAxisIndex] / l.globals.gridHeight), i = l.globals.gridHeight - o, l.config.yaxis[e.yAxisIndex] && l.config.yaxis[e.yAxisIndex].reversed && (i = o)
                    }
                    return i
                }
            }, {
                key: "_getYAxisAnnotationWidth",
                value: function (t) {
                    var e = this.w;
                    return e.globals.gridWidth, (t.width.indexOf("%") > -1 ? e.globals.gridWidth * parseInt(t.width, 10) / 100 : parseInt(t.width, 10)) + t.offsetX
                }
            }, {
                key: "drawYAxisAnnotations",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = this.annoCtx.graphics.group({
                            class: "apexcharts-yaxis-annotations"
                        });
                    return e.config.annotations.yaxis.map((function (e, n) {
                        t.addYaxisAnnotation(e, i.node, n)
                    })), i
                }
            }]), t
        }(),
        M = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.annoCtx = e
            }
            return o(t, [{
                key: "addPointAnnotation",
                value: function (t, e, i) {
                    var n = this.w,
                        l = 0,
                        r = 0,
                        a = 0;
                    this.annoCtx.invertAxis && console.warn("Point annotation is not supported in horizontal bar charts.");
                    var o, s = parseFloat(t.y);
                    if ("string" == typeof t.x) {
                        var c = n.globals.labels.indexOf(t.x);
                        n.config.xaxis.convertedCatToNumeric && (c = n.globals.categoryLabels.indexOf(t.x)), l = this.annoCtx.helpers.getStringX(t.x), null === t.y && (s = n.globals.series[t.seriesIndex][c])
                    } else l = (t.x - n.globals.minX) / (n.globals.xRange / n.globals.gridWidth);
                    if (o = n.config.yaxis[t.yAxisIndex].logarithmic ? (s = new S(this.annoCtx.ctx).getLogVal(s, t.yAxisIndex)) / n.globals.yLogRatio[t.yAxisIndex] : (s - n.globals.minYArr[t.yAxisIndex]) / (n.globals.yRange[t.yAxisIndex] / n.globals.gridHeight), r = n.globals.gridHeight - o - parseFloat(t.label.style.fontSize) - t.marker.size, a = n.globals.gridHeight - o, n.config.yaxis[t.yAxisIndex] && n.config.yaxis[t.yAxisIndex].reversed && (r = o + parseFloat(t.label.style.fontSize) + t.marker.size, a = o), y.isNumber(l)) {
                        var u = {
                                pSize: t.marker.size,
                                pointStrokeWidth: t.marker.strokeWidth,
                                pointFillColor: t.marker.fillColor,
                                pointStrokeColor: t.marker.strokeColor,
                                shape: t.marker.shape,
                                pRadius: t.marker.radius,
                                class: "apexcharts-point-annotation-marker ".concat(t.marker.cssClass, " ").concat(t.id ? t.id : "")
                            },
                            h = this.annoCtx.graphics.drawMarker(l + t.marker.offsetX, a + t.marker.offsetY, u);
                        e.appendChild(h.node);
                        var d = t.label.text ? t.label.text : "",
                            f = this.annoCtx.graphics.drawText({
                                x: l + t.label.offsetX,
                                y: r + t.label.offsetY,
                                text: d,
                                textAnchor: t.label.textAnchor,
                                fontSize: t.label.style.fontSize,
                                fontFamily: t.label.style.fontFamily,
                                fontWeight: t.label.style.fontWeight,
                                foreColor: t.label.style.color,
                                cssClass: "apexcharts-point-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                            });
                        if (f.attr({
                                rel: i
                            }), e.appendChild(f.node), t.customSVG.SVG) {
                            var p = this.annoCtx.graphics.group({
                                class: "apexcharts-point-annotations-custom-svg " + t.customSVG.cssClass
                            });
                            p.attr({
                                transform: "translate(".concat(l + t.customSVG.offsetX, ", ").concat(r + t.customSVG.offsetY, ")")
                            }), p.node.innerHTML = t.customSVG.SVG, e.appendChild(p.node)
                        }
                        if (t.image.path) {
                            var g = t.image.width ? t.image.width : 20,
                                m = t.image.height ? t.image.height : 20;
                            this.annoCtx.addImage({
                                x: l + t.image.offsetX - g / 2,
                                y: r + t.image.offsetY - m / 2,
                                width: g,
                                height: m,
                                path: t.image.path,
                                appendTo: ".apexcharts-point-annotations"
                            })
                        }
                    }
                }
            }, {
                key: "drawPointAnnotations",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = this.annoCtx.graphics.group({
                            class: "apexcharts-point-annotations"
                        });
                    return e.config.annotations.points.map((function (e, n) {
                        t.addPointAnnotation(e, i.node, n)
                    })), i
                }
            }]), t
        }(),
        C = {
            name: "en",
            options: {
                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                toolbar: {
                    exportToSVG: "Download SVG",
                    exportToPNG: "Download PNG",
                    exportToCSV: "Download CSV",
                    menu: "Menu",
                    selection: "Selection",
                    selectionZoom: "Selection Zoom",
                    zoomIn: "Zoom In",
                    zoomOut: "Zoom Out",
                    pan: "Panning",
                    reset: "Reset Zoom"
                }
            }
        },
        E = function () {
            function t() {
                r(this, t), this.yAxis = {
                    show: !0,
                    showAlways: !1,
                    showForNullSeries: !0,
                    seriesName: void 0,
                    opposite: !1,
                    reversed: !1,
                    logarithmic: !1,
                    tickAmount: void 0,
                    forceNiceScale: !1,
                    max: void 0,
                    min: void 0,
                    floating: !1,
                    decimalsInFloat: void 0,
                    labels: {
                        show: !0,
                        minWidth: 0,
                        maxWidth: 160,
                        offsetX: 0,
                        offsetY: 0,
                        align: void 0,
                        rotate: 0,
                        padding: 20,
                        style: {
                            colors: [],
                            fontSize: "11px",
                            fontWeight: 400,
                            fontFamily: void 0,
                            cssClass: ""
                        },
                        formatter: void 0
                    },
                    axisBorder: {
                        show: !1,
                        color: "#e0e0e0",
                        width: 1,
                        offsetX: 0,
                        offsetY: 0
                    },
                    axisTicks: {
                        show: !1,
                        color: "#e0e0e0",
                        width: 6,
                        offsetX: 0,
                        offsetY: 0
                    },
                    title: {
                        text: void 0,
                        rotate: -90,
                        offsetY: 0,
                        offsetX: 0,
                        style: {
                            color: void 0,
                            fontSize: "11px",
                            fontWeight: 900,
                            fontFamily: void 0,
                            cssClass: ""
                        }
                    },
                    tooltip: {
                        enabled: !1,
                        offsetX: 0
                    },
                    crosshairs: {
                        show: !0,
                        position: "front",
                        stroke: {
                            color: "#b6b6b6",
                            width: 1,
                            dashArray: 0
                        }
                    }
                }, this.pointAnnotation = {
                    x: 0,
                    y: null,
                    yAxisIndex: 0,
                    seriesIndex: 0,
                    marker: {
                        size: 4,
                        fillColor: "#fff",
                        strokeWidth: 2,
                        strokeColor: "#333",
                        shape: "circle",
                        offsetX: 0,
                        offsetY: 0,
                        radius: 2,
                        cssClass: ""
                    },
                    label: {
                        borderColor: "#c2c2c2",
                        borderWidth: 1,
                        borderRadius: 2,
                        text: void 0,
                        textAnchor: "middle",
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            background: "#fff",
                            color: void 0,
                            fontSize: "11px",
                            fontFamily: void 0,
                            fontWeight: 400,
                            cssClass: "",
                            padding: {
                                left: 5,
                                right: 5,
                                top: 2,
                                bottom: 2
                            }
                        }
                    },
                    customSVG: {
                        SVG: void 0,
                        cssClass: void 0,
                        offsetX: 0,
                        offsetY: 0
                    },
                    image: {
                        path: void 0,
                        width: 20,
                        height: 20,
                        offsetX: 0,
                        offsetY: 0
                    }
                }, this.yAxisAnnotation = {
                    y: 0,
                    y2: null,
                    strokeDashArray: 1,
                    fillColor: "#c2c2c2",
                    borderColor: "#c2c2c2",
                    borderWidth: 1,
                    opacity: .3,
                    offsetX: 0,
                    offsetY: 0,
                    width: "100%",
                    yAxisIndex: 0,
                    label: {
                        borderColor: "#c2c2c2",
                        borderWidth: 1,
                        borderRadius: 2,
                        text: void 0,
                        textAnchor: "end",
                        position: "right",
                        offsetX: 0,
                        offsetY: -3,
                        style: {
                            background: "#fff",
                            color: void 0,
                            fontSize: "11px",
                            fontFamily: void 0,
                            fontWeight: 400,
                            cssClass: "",
                            padding: {
                                left: 5,
                                right: 5,
                                top: 2,
                                bottom: 2
                            }
                        }
                    }
                }, this.xAxisAnnotation = {
                    x: 0,
                    x2: null,
                    strokeDashArray: 1,
                    fillColor: "#c2c2c2",
                    borderColor: "#c2c2c2",
                    borderWidth: 1,
                    opacity: .3,
                    offsetX: 0,
                    offsetY: 0,
                    label: {
                        borderColor: "#c2c2c2",
                        borderWidth: 1,
                        borderRadius: 2,
                        text: void 0,
                        textAnchor: "middle",
                        orientation: "vertical",
                        position: "top",
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            background: "#fff",
                            color: void 0,
                            fontSize: "11px",
                            fontFamily: void 0,
                            fontWeight: 400,
                            cssClass: "",
                            padding: {
                                left: 5,
                                right: 5,
                                top: 2,
                                bottom: 2
                            }
                        }
                    }
                }, this.text = {
                    x: 0,
                    y: 0,
                    text: "",
                    textAnchor: "start",
                    foreColor: void 0,
                    fontSize: "13px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    appendTo: ".apexcharts-annotations",
                    backgroundColor: "transparent",
                    borderColor: "#c2c2c2",
                    borderRadius: 0,
                    borderWidth: 0,
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingTop: 2,
                    paddingBottom: 2
                }
            }
            return o(t, [{
                key: "init",
                value: function () {
                    return {
                        annotations: {
                            position: "front",
                            yaxis: [this.yAxisAnnotation],
                            xaxis: [this.xAxisAnnotation],
                            points: [this.pointAnnotation],
                            texts: [],
                            images: [],
                            shapes: []
                        },
                        chart: {
                            animations: {
                                enabled: !0,
                                easing: "easeinout",
                                speed: 800,
                                animateGradually: {
                                    delay: 150,
                                    enabled: !0
                                },
                                dynamicAnimation: {
                                    enabled: !0,
                                    speed: 350
                                }
                            },
                            background: "transparent",
                            locales: [C],
                            defaultLocale: "en",
                            dropShadow: {
                                enabled: !1,
                                enabledOnSeries: void 0,
                                top: 2,
                                left: 2,
                                blur: 4,
                                color: "#000",
                                opacity: .35
                            },
                            events: {
                                animationEnd: void 0,
                                beforeMount: void 0,
                                mounted: void 0,
                                updated: void 0,
                                click: void 0,
                                mouseMove: void 0,
                                legendClick: void 0,
                                markerClick: void 0,
                                selection: void 0,
                                dataPointSelection: void 0,
                                dataPointMouseEnter: void 0,
                                dataPointMouseLeave: void 0,
                                beforeZoom: void 0,
                                beforeResetZoom: void 0,
                                zoomed: void 0,
                                scrolled: void 0,
                                brushScrolled: void 0
                            },
                            foreColor: "#373d3f",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            height: "auto",
                            parentHeightOffset: 15,
                            redrawOnParentResize: !0,
                            redrawOnWindowResize: !0,
                            id: void 0,
                            group: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            selection: {
                                enabled: !1,
                                type: "x",
                                fill: {
                                    color: "#24292e",
                                    opacity: .1
                                },
                                stroke: {
                                    width: 1,
                                    color: "#24292e",
                                    opacity: .4,
                                    dashArray: 3
                                },
                                xaxis: {
                                    min: void 0,
                                    max: void 0
                                },
                                yaxis: {
                                    min: void 0,
                                    max: void 0
                                }
                            },
                            sparkline: {
                                enabled: !1
                            },
                            brush: {
                                enabled: !1,
                                autoScaleYaxis: !0,
                                target: void 0
                            },
                            stacked: !1,
                            stackType: "normal",
                            toolbar: {
                                show: !0,
                                offsetX: 0,
                                offsetY: 0,
                                tools: {
                                    download: !0,
                                    selection: !0,
                                    zoom: !0,
                                    zoomin: !0,
                                    zoomout: !0,
                                    pan: !0,
                                    reset: !0,
                                    customIcons: []
                                },
                                export: {
                                    csv: {
                                        filename: void 0,
                                        columnDelimiter: ",",
                                        headerCategory: "category",
                                        headerValue: "value",
                                        dateFormatter: function (t) {
                                            return new Date(t).toDateString()
                                        }
                                    },
                                    png: {
                                        filename: void 0
                                    },
                                    svg: {
                                        filename: void 0
                                    }
                                },
                                autoSelected: "zoom"
                            },
                            type: "line",
                            width: "100%",
                            zoom: {
                                enabled: !0,
                                type: "x",
                                autoScaleYaxis: !1,
                                zoomedArea: {
                                    fill: {
                                        color: "#90CAF9",
                                        opacity: .4
                                    },
                                    stroke: {
                                        color: "#0D47A1",
                                        opacity: .4,
                                        width: 1
                                    }
                                }
                            }
                        },
                        plotOptions: {
                            area: {
                                fillTo: "origin"
                            },
                            bar: {
                                horizontal: !1,
                                columnWidth: "70%",
                                barHeight: "70%",
                                distributed: !1,
                                borderRadius: 0,
                                rangeBarOverlap: !0,
                                rangeBarGroupRows: !1,
                                colors: {
                                    ranges: [],
                                    backgroundBarColors: [],
                                    backgroundBarOpacity: 1,
                                    backgroundBarRadius: 0
                                },
                                dataLabels: {
                                    position: "top",
                                    maxItems: 100,
                                    hideOverflowingLabels: !0,
                                    orientation: "horizontal"
                                }
                            },
                            bubble: {
                                minBubbleRadius: void 0,
                                maxBubbleRadius: void 0
                            },
                            candlestick: {
                                colors: {
                                    upward: "#00B746",
                                    downward: "#EF403C"
                                },
                                wick: {
                                    useFillColor: !0
                                }
                            },
                            boxPlot: {
                                colors: {
                                    upper: "#00E396",
                                    lower: "#008FFB"
                                }
                            },
                            heatmap: {
                                radius: 2,
                                enableShades: !0,
                                shadeIntensity: .5,
                                reverseNegativeShade: !1,
                                distributed: !1,
                                useFillColorAsStroke: !1,
                                colorScale: {
                                    inverse: !1,
                                    ranges: [],
                                    min: void 0,
                                    max: void 0
                                }
                            },
                            treemap: {
                                enableShades: !0,
                                shadeIntensity: .5,
                                distributed: !1,
                                reverseNegativeShade: !1,
                                useFillColorAsStroke: !1,
                                colorScale: {
                                    inverse: !1,
                                    ranges: [],
                                    min: void 0,
                                    max: void 0
                                }
                            },
                            radialBar: {
                                inverseOrder: !1,
                                startAngle: 0,
                                endAngle: 360,
                                offsetX: 0,
                                offsetY: 0,
                                hollow: {
                                    margin: 5,
                                    size: "50%",
                                    background: "transparent",
                                    image: void 0,
                                    imageWidth: 150,
                                    imageHeight: 150,
                                    imageOffsetX: 0,
                                    imageOffsetY: 0,
                                    imageClipped: !0,
                                    position: "front",
                                    dropShadow: {
                                        enabled: !1,
                                        top: 0,
                                        left: 0,
                                        blur: 3,
                                        color: "#000",
                                        opacity: .5
                                    }
                                },
                                track: {
                                    show: !0,
                                    startAngle: void 0,
                                    endAngle: void 0,
                                    background: "#f2f2f2",
                                    strokeWidth: "97%",
                                    opacity: 1,
                                    margin: 5,
                                    dropShadow: {
                                        enabled: !1,
                                        top: 0,
                                        left: 0,
                                        blur: 3,
                                        color: "#000",
                                        opacity: .5
                                    }
                                },
                                dataLabels: {
                                    show: !0,
                                    name: {
                                        show: !0,
                                        fontSize: "16px",
                                        fontFamily: void 0,
                                        fontWeight: 600,
                                        color: void 0,
                                        offsetY: 0,
                                        formatter: function (t) {
                                            return t
                                        }
                                    },
                                    value: {
                                        show: !0,
                                        fontSize: "14px",
                                        fontFamily: void 0,
                                        fontWeight: 400,
                                        color: void 0,
                                        offsetY: 16,
                                        formatter: function (t) {
                                            return t + "%"
                                        }
                                    },
                                    total: {
                                        show: !1,
                                        label: "Total",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        fontFamily: void 0,
                                        color: void 0,
                                        formatter: function (t) {
                                            return t.globals.seriesTotals.reduce((function (t, e) {
                                                return t + e
                                            }), 0) / t.globals.series.length + "%"
                                        }
                                    }
                                }
                            },
                            pie: {
                                customScale: 1,
                                offsetX: 0,
                                offsetY: 0,
                                startAngle: 0,
                                endAngle: 360,
                                expandOnClick: !0,
                                dataLabels: {
                                    offset: 0,
                                    minAngleToShowLabel: 10
                                },
                                donut: {
                                    size: "65%",
                                    background: "transparent",
                                    labels: {
                                        show: !1,
                                        name: {
                                            show: !0,
                                            fontSize: "16px",
                                            fontFamily: void 0,
                                            fontWeight: 600,
                                            color: void 0,
                                            offsetY: -10,
                                            formatter: function (t) {
                                                return t
                                            }
                                        },
                                        value: {
                                            show: !0,
                                            fontSize: "20px",
                                            fontFamily: void 0,
                                            fontWeight: 400,
                                            color: void 0,
                                            offsetY: 10,
                                            formatter: function (t) {
                                                return t
                                            }
                                        },
                                        total: {
                                            show: !1,
                                            showAlways: !1,
                                            label: "Total",
                                            fontSize: "16px",
                                            fontWeight: 400,
                                            fontFamily: void 0,
                                            color: void 0,
                                            formatter: function (t) {
                                                return t.globals.seriesTotals.reduce((function (t, e) {
                                                    return t + e
                                                }), 0)
                                            }
                                        }
                                    }
                                }
                            },
                            polarArea: {
                                rings: {
                                    strokeWidth: 1,
                                    strokeColor: "#e8e8e8"
                                },
                                spokes: {
                                    strokeWidth: 1,
                                    connectorColors: "#e8e8e8"
                                }
                            },
                            radar: {
                                size: void 0,
                                offsetX: 0,
                                offsetY: 0,
                                polygons: {
                                    strokeWidth: 1,
                                    strokeColors: "#e8e8e8",
                                    connectorColors: "#e8e8e8",
                                    fill: {
                                        colors: void 0
                                    }
                                }
                            }
                        },
                        colors: void 0,
                        dataLabels: {
                            enabled: !0,
                            enabledOnSeries: void 0,
                            formatter: function (t) {
                                return null !== t ? t : ""
                            },
                            textAnchor: "middle",
                            distributed: !1,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0,
                                fontWeight: 600,
                                colors: void 0
                            },
                            background: {
                                enabled: !0,
                                foreColor: "#fff",
                                borderRadius: 2,
                                padding: 4,
                                opacity: .9,
                                borderWidth: 1,
                                borderColor: "#fff",
                                dropShadow: {
                                    enabled: !1,
                                    top: 1,
                                    left: 1,
                                    blur: 1,
                                    color: "#000",
                                    opacity: .45
                                }
                            },
                            dropShadow: {
                                enabled: !1,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: "#000",
                                opacity: .45
                            }
                        },
                        fill: {
                            type: "solid",
                            colors: void 0,
                            opacity: .85,
                            gradient: {
                                shade: "dark",
                                type: "horizontal",
                                shadeIntensity: .5,
                                gradientToColors: void 0,
                                inverseColors: !0,
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [0, 50, 100],
                                colorStops: []
                            },
                            image: {
                                src: [],
                                width: void 0,
                                height: void 0
                            },
                            pattern: {
                                style: "squares",
                                width: 6,
                                height: 6,
                                strokeWidth: 2
                            }
                        },
                        grid: {
                            show: !0,
                            borderColor: "#e0e0e0",
                            strokeDashArray: 0,
                            position: "back",
                            xaxis: {
                                lines: {
                                    show: !1
                                }
                            },
                            yaxis: {
                                lines: {
                                    show: !0
                                }
                            },
                            row: {
                                colors: void 0,
                                opacity: .5
                            },
                            column: {
                                colors: void 0,
                                opacity: .5
                            },
                            padding: {
                                top: 0,
                                right: 10,
                                bottom: 0,
                                left: 12
                            }
                        },
                        labels: [],
                        legend: {
                            show: !0,
                            showForSingleSeries: !1,
                            showForNullSeries: !0,
                            showForZeroSeries: !0,
                            floating: !1,
                            position: "bottom",
                            horizontalAlign: "center",
                            inverseOrder: !1,
                            fontSize: "12px",
                            fontFamily: void 0,
                            fontWeight: 400,
                            width: void 0,
                            height: void 0,
                            formatter: void 0,
                            tooltipHoverFormatter: void 0,
                            offsetX: -20,
                            offsetY: 4,
                            labels: {
                                colors: void 0,
                                useSeriesColors: !1
                            },
                            markers: {
                                width: 12,
                                height: 12,
                                strokeWidth: 0,
                                fillColors: void 0,
                                strokeColor: "#fff",
                                radius: 12,
                                customHTML: void 0,
                                offsetX: 0,
                                offsetY: 0,
                                onClick: void 0
                            },
                            itemMargin: {
                                horizontal: 5,
                                vertical: 2
                            },
                            onItemClick: {
                                toggleDataSeries: !0
                            },
                            onItemHover: {
                                highlightDataSeries: !0
                            }
                        },
                        markers: {
                            discrete: [],
                            size: 0,
                            colors: void 0,
                            strokeColors: "#fff",
                            strokeWidth: 2,
                            strokeOpacity: .9,
                            strokeDashArray: 0,
                            fillOpacity: 1,
                            shape: "circle",
                            width: 8,
                            height: 8,
                            radius: 2,
                            offsetX: 0,
                            offsetY: 0,
                            onClick: void 0,
                            onDblClick: void 0,
                            showNullDataPoints: !0,
                            hover: {
                                size: void 0,
                                sizeOffset: 3
                            }
                        },
                        noData: {
                            text: void 0,
                            align: "center",
                            verticalAlign: "middle",
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                color: void 0,
                                fontSize: "14px",
                                fontFamily: void 0
                            }
                        },
                        responsive: [],
                        series: void 0,
                        states: {
                            normal: {
                                filter: {
                                    type: "none",
                                    value: 0
                                }
                            },
                            hover: {
                                filter: {
                                    type: "lighten",
                                    value: .1
                                }
                            },
                            active: {
                                allowMultipleDataPointsSelection: !1,
                                filter: {
                                    type: "darken",
                                    value: .5
                                }
                            }
                        },
                        title: {
                            text: void 0,
                            align: "left",
                            margin: 5,
                            offsetX: 0,
                            offsetY: 0,
                            floating: !1,
                            style: {
                                fontSize: "14px",
                                fontWeight: 900,
                                fontFamily: void 0,
                                color: void 0
                            }
                        },
                        subtitle: {
                            text: void 0,
                            align: "left",
                            margin: 5,
                            offsetX: 0,
                            offsetY: 30,
                            floating: !1,
                            style: {
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                color: void 0
                            }
                        },
                        stroke: {
                            show: !0,
                            curve: "smooth",
                            lineCap: "butt",
                            width: 2,
                            colors: void 0,
                            dashArray: 0
                        },
                        tooltip: {
                            enabled: !0,
                            enabledOnSeries: void 0,
                            shared: !0,
                            followCursor: !1,
                            intersect: !1,
                            inverseOrder: !1,
                            custom: void 0,
                            fillSeriesColor: !1,
                            theme: "light",
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0
                            },
                            onDatasetHover: {
                                highlightDataSeries: !1
                            },
                            x: {
                                show: !0,
                                format: "dd MMM",
                                formatter: void 0
                            },
                            y: {
                                formatter: void 0,
                                title: {
                                    formatter: function (t) {
                                        return t ? t + ": " : ""
                                    }
                                }
                            },
                            z: {
                                formatter: void 0,
                                title: "Size: "
                            },
                            marker: {
                                show: !0,
                                fillColors: void 0
                            },
                            items: {
                                display: "flex"
                            },
                            fixed: {
                                enabled: !1,
                                position: "topRight",
                                offsetX: 0,
                                offsetY: 0
                            }
                        },
                        xaxis: {
                            type: "category",
                            categories: [],
                            convertedCatToNumeric: !1,
                            offsetX: 0,
                            offsetY: 0,
                            labels: {
                                show: !0,
                                rotate: -45,
                                rotateAlways: !1,
                                hideOverlappingLabels: !0,
                                trim: !1,
                                minHeight: void 0,
                                maxHeight: 120,
                                showDuplicates: !0,
                                style: {
                                    colors: [],
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    fontFamily: void 0,
                                    cssClass: ""
                                },
                                offsetX: 0,
                                offsetY: 0,
                                format: void 0,
                                formatter: void 0,
                                datetimeUTC: !0,
                                datetimeFormatter: {
                                    year: "yyyy",
                                    month: "MMM 'yy",
                                    day: "dd MMM",
                                    hour: "HH:mm",
                                    minute: "HH:mm:ss",
                                    second: "HH:mm:ss"
                                }
                            },
                            axisBorder: {
                                show: !0,
                                color: "#e0e0e0",
                                width: "100%",
                                height: 1,
                                offsetX: 0,
                                offsetY: 0
                            },
                            axisTicks: {
                                show: !0,
                                color: "#e0e0e0",
                                height: 6,
                                offsetX: 0,
                                offsetY: 0
                            },
                            tickAmount: void 0,
                            tickPlacement: "on",
                            min: void 0,
                            max: void 0,
                            range: void 0,
                            floating: !1,
                            decimalsInFloat: void 0,
                            position: "bottom",
                            title: {
                                text: void 0,
                                offsetX: 0,
                                offsetY: 0,
                                style: {
                                    color: void 0,
                                    fontSize: "12px",
                                    fontWeight: 900,
                                    fontFamily: void 0,
                                    cssClass: ""
                                }
                            },
                            crosshairs: {
                                show: !0,
                                width: 1,
                                position: "back",
                                opacity: .9,
                                stroke: {
                                    color: "#b6b6b6",
                                    width: 1,
                                    dashArray: 3
                                },
                                fill: {
                                    type: "solid",
                                    color: "#B1B9C4",
                                    gradient: {
                                        colorFrom: "#D8E3F0",
                                        colorTo: "#BED1E6",
                                        stops: [0, 100],
                                        opacityFrom: .4,
                                        opacityTo: .5
                                    }
                                },
                                dropShadow: {
                                    enabled: !1,
                                    left: 0,
                                    top: 0,
                                    blur: 1,
                                    opacity: .4
                                }
                            },
                            tooltip: {
                                enabled: !0,
                                offsetY: 0,
                                formatter: void 0,
                                style: {
                                    fontSize: "12px",
                                    fontFamily: void 0
                                }
                            }
                        },
                        yaxis: this.yAxis,
                        theme: {
                            mode: "light",
                            palette: "palette1",
                            monochrome: {
                                enabled: !1,
                                color: "#008FFB",
                                shadeTo: "light",
                                shadeIntensity: .65
                            }
                        }
                    }
                }
            }]), t
        }(),
        O = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.graphics = new w(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new _(this), this.xAxisAnnotations = new k(this), this.yAxisAnnotations = new A(this), this.pointsAnnotations = new M(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints
            }
            return o(t, [{
                key: "drawAxesAnnotations",
                value: function () {
                    var t = this.w;
                    if (t.globals.axisCharts) {
                        for (var e = this.yAxisAnnotations.drawYAxisAnnotations(), i = this.xAxisAnnotations.drawXAxisAnnotations(), n = this.pointsAnnotations.drawPointAnnotations(), l = t.config.chart.animations.enabled, r = [e, i, n], a = [i.node, e.node, n.node], o = 0; o < 3; o++) t.globals.dom.elGraphical.add(r[o]), !l || t.globals.resized || t.globals.dataChanged || "scatter" !== t.config.chart.type && "bubble" !== t.config.chart.type && t.globals.dataPoints > 1 && a[o].classList.add("apexcharts-element-hidden"), t.globals.delayedElements.push({
                            el: a[o],
                            index: 0
                        });
                        this.helpers.annotationsBackground()
                    }
                }
            }, {
                key: "drawImageAnnos",
                value: function () {
                    var t = this;
                    this.w.config.annotations.images.map((function (e, i) {
                        t.addImage(e, i)
                    }))
                }
            }, {
                key: "drawTextAnnos",
                value: function () {
                    var t = this;
                    this.w.config.annotations.texts.map((function (e, i) {
                        t.addText(e, i)
                    }))
                }
            }, {
                key: "addXaxisAnnotation",
                value: function (t, e, i) {
                    this.xAxisAnnotations.addXaxisAnnotation(t, e, i)
                }
            }, {
                key: "addYaxisAnnotation",
                value: function (t, e, i) {
                    this.yAxisAnnotations.addYaxisAnnotation(t, e, i)
                }
            }, {
                key: "addPointAnnotation",
                value: function (t, e, i) {
                    this.pointsAnnotations.addPointAnnotation(t, e, i)
                }
            }, {
                key: "addText",
                value: function (t, e) {
                    var i = t.x,
                        n = t.y,
                        l = t.text,
                        r = t.textAnchor,
                        a = t.foreColor,
                        o = t.fontSize,
                        s = t.fontFamily,
                        c = t.fontWeight,
                        u = t.cssClass,
                        h = t.backgroundColor,
                        d = t.borderWidth,
                        f = t.strokeDashArray,
                        p = t.borderRadius,
                        g = t.borderColor,
                        m = t.appendTo,
                        v = void 0 === m ? ".apexcharts-annotations" : m,
                        y = t.paddingLeft,
                        b = void 0 === y ? 4 : y,
                        x = t.paddingRight,
                        w = void 0 === x ? 4 : x,
                        _ = t.paddingBottom,
                        k = void 0 === _ ? 2 : _,
                        S = t.paddingTop,
                        A = void 0 === S ? 2 : S,
                        M = this.w,
                        C = this.graphics.drawText({
                            x: i,
                            y: n,
                            text: l,
                            textAnchor: r || "start",
                            fontSize: o || "12px",
                            fontWeight: c || "regular",
                            fontFamily: s || M.config.chart.fontFamily,
                            foreColor: a || M.config.chart.foreColor,
                            cssClass: u
                        }),
                        E = M.globals.dom.baseEl.querySelector(v);
                    E && E.appendChild(C.node);
                    var O = C.bbox();
                    if (l) {
                        var T = this.graphics.drawRect(O.x - b, O.y - A, O.width + b + w, O.height + k + A, p, h || "transparent", 1, d, g, f);
                        E.insertBefore(T.node, C.node)
                    }
                }
            }, {
                key: "addImage",
                value: function (t, e) {
                    var i = this.w,
                        n = t.path,
                        l = t.x,
                        r = void 0 === l ? 0 : l,
                        a = t.y,
                        o = void 0 === a ? 0 : a,
                        s = t.width,
                        c = void 0 === s ? 20 : s,
                        u = t.height,
                        h = void 0 === u ? 20 : u,
                        d = t.appendTo,
                        f = void 0 === d ? ".apexcharts-annotations" : d,
                        p = i.globals.dom.Paper.image(n);
                    p.size(c, h).move(r, o);
                    var g = i.globals.dom.baseEl.querySelector(f);
                    g && g.appendChild(p.node)
                }
            }, {
                key: "addXaxisAnnotationExternal",
                value: function (t, e, i) {
                    return this.addAnnotationExternal({
                        params: t,
                        pushToMemory: e,
                        context: i,
                        type: "xaxis",
                        contextMethod: i.addXaxisAnnotation
                    }), i
                }
            }, {
                key: "addYaxisAnnotationExternal",
                value: function (t, e, i) {
                    return this.addAnnotationExternal({
                        params: t,
                        pushToMemory: e,
                        context: i,
                        type: "yaxis",
                        contextMethod: i.addYaxisAnnotation
                    }), i
                }
            }, {
                key: "addPointAnnotationExternal",
                value: function (t, e, i) {
                    return void 0 === this.invertAxis && (this.invertAxis = i.w.globals.isBarHorizontal), this.addAnnotationExternal({
                        params: t,
                        pushToMemory: e,
                        context: i,
                        type: "point",
                        contextMethod: i.addPointAnnotation
                    }), i
                }
            }, {
                key: "addAnnotationExternal",
                value: function (t) {
                    var e = t.params,
                        i = t.pushToMemory,
                        n = t.context,
                        l = t.type,
                        r = t.contextMethod,
                        a = n,
                        o = a.w,
                        s = o.globals.dom.baseEl.querySelector(".apexcharts-".concat(l, "-annotations")),
                        c = s.childNodes.length + 1,
                        u = new E,
                        h = Object.assign({}, "xaxis" === l ? u.xAxisAnnotation : "yaxis" === l ? u.yAxisAnnotation : u.pointAnnotation),
                        d = y.extend(h, e);
                    switch (l) {
                        case "xaxis":
                            this.addXaxisAnnotation(d, s, c);
                            break;
                        case "yaxis":
                            this.addYaxisAnnotation(d, s, c);
                            break;
                        case "point":
                            this.addPointAnnotation(d, s, c)
                    }
                    var f = o.globals.dom.baseEl.querySelector(".apexcharts-".concat(l, "-annotations .apexcharts-").concat(l, "-annotation-label[rel='").concat(c, "']")),
                        p = this.helpers.addBackgroundToAnno(f, d);
                    return p && s.insertBefore(p.node, f), i && o.globals.memory.methodsToExec.push({
                        context: a,
                        id: d.id ? d.id : y.randomId(),
                        method: r,
                        label: "addAnnotation",
                        params: e
                    }), n
                }
            }, {
                key: "clearAnnotations",
                value: function (t) {
                    var e = t.w,
                        i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations");
                    e.globals.memory.methodsToExec.map((function (t, i) {
                        "addText" !== t.label && "addAnnotation" !== t.label || e.globals.memory.methodsToExec.splice(i, 1)
                    })), i = y.listToArray(i), Array.prototype.forEach.call(i, (function (t) {
                        for (; t.firstChild;) t.removeChild(t.firstChild)
                    }))
                }
            }, {
                key: "removeAnnotation",
                value: function (t, e) {
                    var i = t.w,
                        n = i.globals.dom.baseEl.querySelectorAll(".".concat(e));
                    n && (i.globals.memory.methodsToExec.map((function (t, n) {
                        t.id === e && i.globals.memory.methodsToExec.splice(n, 1)
                    })), Array.prototype.forEach.call(n, (function (t) {
                        t.parentElement.removeChild(t)
                    })))
                }
            }]), t
        }(),
        T = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0
            }
            return o(t, [{
                key: "clippedImgArea",
                value: function (t) {
                    var e = this.w,
                        i = e.config,
                        n = parseInt(e.globals.gridWidth, 10),
                        l = parseInt(e.globals.gridHeight, 10),
                        r = n > l ? n : l,
                        a = t.image,
                        o = 0,
                        s = 0;
                    void 0 === t.width && void 0 === t.height ? void 0 !== i.fill.image.width && void 0 !== i.fill.image.height ? (o = i.fill.image.width + 1, s = i.fill.image.height) : (o = r + 1, s = r) : (o = t.width, s = t.height);
                    var c = document.createElementNS(e.globals.SVGNS, "pattern");
                    w.setAttrs(c, {
                        id: t.patternID,
                        patternUnits: t.patternUnits ? t.patternUnits : "userSpaceOnUse",
                        width: o + "px",
                        height: s + "px"
                    });
                    var u = document.createElementNS(e.globals.SVGNS, "image");
                    c.appendChild(u), u.setAttributeNS(window.SVG.xlink, "href", a), w.setAttrs(u, {
                        x: 0,
                        y: 0,
                        preserveAspectRatio: "none",
                        width: o + "px",
                        height: s + "px"
                    }), u.style.opacity = t.opacity, e.globals.dom.elDefs.node.appendChild(c)
                }
            }, {
                key: "getSeriesIndex",
                value: function (t) {
                    var e = this.w;
                    return ("bar" === e.config.chart.type || "rangeBar" === e.config.chart.type) && e.config.plotOptions.bar.distributed || "heatmap" === e.config.chart.type || "treemap" === e.config.chart.type ? this.seriesIndex = t.seriesNumber : this.seriesIndex = t.seriesNumber % e.globals.series.length, this.seriesIndex
                }
            }, {
                key: "fillPath",
                value: function (t) {
                    var e = this.w;
                    this.opts = t;
                    var i, n, l, r = this.w.config;
                    this.seriesIndex = this.getSeriesIndex(t);
                    var a = this.getFillColors()[this.seriesIndex];
                    void 0 !== e.globals.seriesColors[this.seriesIndex] && (a = e.globals.seriesColors[this.seriesIndex]), "function" == typeof a && (a = a({
                        seriesIndex: this.seriesIndex,
                        dataPointIndex: t.dataPointIndex,
                        value: t.value,
                        w: e
                    }));
                    var o = this.getFillType(this.seriesIndex),
                        s = Array.isArray(r.fill.opacity) ? r.fill.opacity[this.seriesIndex] : r.fill.opacity;
                    t.color && (a = t.color);
                    var c = a;
                    if (-1 === a.indexOf("rgb") ? a.length < 9 && (c = y.hexToRgba(a, s)) : a.indexOf("rgba") > -1 && (s = y.getOpacityFromRGBA(a)), t.opacity && (s = t.opacity), "pattern" === o && (n = this.handlePatternFill(n, a, s, c)), "gradient" === o && (l = this.handleGradientFill(a, s, this.seriesIndex)), "image" === o) {
                        var u = r.fill.image.src,
                            h = t.patternID ? t.patternID : "";
                        this.clippedImgArea({
                            opacity: s,
                            image: Array.isArray(u) ? t.seriesNumber < u.length ? u[t.seriesNumber] : u[0] : u,
                            width: t.width ? t.width : void 0,
                            height: t.height ? t.height : void 0,
                            patternUnits: t.patternUnits,
                            patternID: "pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(h)
                        }), i = "url(#pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(h, ")")
                    } else i = "gradient" === o ? l : "pattern" === o ? n : c;
                    return t.solid && (i = c), i
                }
            }, {
                key: "getFillType",
                value: function (t) {
                    var e = this.w;
                    return Array.isArray(e.config.fill.type) ? e.config.fill.type[t] : e.config.fill.type
                }
            }, {
                key: "getFillColors",
                value: function () {
                    var t = this.w,
                        e = t.config,
                        i = this.opts,
                        n = [];
                    return t.globals.comboCharts ? "line" === t.config.series[this.seriesIndex].type ? Array.isArray(t.globals.stroke.colors) ? n = t.globals.stroke.colors : n.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? n = t.globals.fill.colors : n.push(t.globals.fill.colors) : "line" === e.chart.type ? Array.isArray(t.globals.stroke.colors) ? n = t.globals.stroke.colors : n.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? n = t.globals.fill.colors : n.push(t.globals.fill.colors), void 0 !== i.fillColors && (n = [], Array.isArray(i.fillColors) ? n = i.fillColors.slice() : n.push(i.fillColors)), n
                }
            }, {
                key: "handlePatternFill",
                value: function (t, e, i, n) {
                    var l = this.w.config,
                        r = this.opts,
                        a = new w(this.ctx),
                        o = void 0 === l.fill.pattern.strokeWidth ? Array.isArray(l.stroke.width) ? l.stroke.width[this.seriesIndex] : l.stroke.width : Array.isArray(l.fill.pattern.strokeWidth) ? l.fill.pattern.strokeWidth[this.seriesIndex] : l.fill.pattern.strokeWidth,
                        s = e;
                    return Array.isArray(l.fill.pattern.style) ? void 0 !== l.fill.pattern.style[r.seriesNumber] ? a.drawPattern(l.fill.pattern.style[r.seriesNumber], l.fill.pattern.width, l.fill.pattern.height, s, o, i) : n : a.drawPattern(l.fill.pattern.style, l.fill.pattern.width, l.fill.pattern.height, s, o, i)
                }
            }, {
                key: "handleGradientFill",
                value: function (t, e, i) {
                    var n, l = this.w.config,
                        r = this.opts,
                        a = new w(this.ctx),
                        o = new y,
                        s = l.fill.gradient.type,
                        c = t,
                        u = void 0 === l.fill.gradient.opacityFrom ? e : Array.isArray(l.fill.gradient.opacityFrom) ? l.fill.gradient.opacityFrom[i] : l.fill.gradient.opacityFrom;
                    c.indexOf("rgba") > -1 && (u = y.getOpacityFromRGBA(c));
                    var h = void 0 === l.fill.gradient.opacityTo ? e : Array.isArray(l.fill.gradient.opacityTo) ? l.fill.gradient.opacityTo[i] : l.fill.gradient.opacityTo;
                    if (void 0 === l.fill.gradient.gradientToColors || 0 === l.fill.gradient.gradientToColors.length) n = "dark" === l.fill.gradient.shade ? o.shadeColor(-1 * parseFloat(l.fill.gradient.shadeIntensity), t.indexOf("rgb") > -1 ? y.rgb2hex(t) : t) : o.shadeColor(parseFloat(l.fill.gradient.shadeIntensity), t.indexOf("rgb") > -1 ? y.rgb2hex(t) : t);
                    else if (l.fill.gradient.gradientToColors[r.seriesNumber]) {
                        var d = l.fill.gradient.gradientToColors[r.seriesNumber];
                        n = d, d.indexOf("rgba") > -1 && (h = y.getOpacityFromRGBA(d))
                    } else n = t;
                    if (l.fill.gradient.inverseColors) {
                        var f = c;
                        c = n, n = f
                    }
                    return c.indexOf("rgb") > -1 && (c = y.rgb2hex(c)), n.indexOf("rgb") > -1 && (n = y.rgb2hex(n)), a.drawGradient(s, c, n, u, h, r.size, l.fill.gradient.stops, l.fill.gradient.colorStops, i)
                }
            }]), t
        }(),
        P = function () {
            function t(e, i) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "setGlobalMarkerSize",
                value: function () {
                    var t = this.w;
                    if (t.globals.markers.size = Array.isArray(t.config.markers.size) ? t.config.markers.size : [t.config.markers.size], t.globals.markers.size.length > 0) {
                        if (t.globals.markers.size.length < t.globals.series.length + 1)
                            for (var e = 0; e <= t.globals.series.length; e++) void 0 === t.globals.markers.size[e] && t.globals.markers.size.push(t.globals.markers.size[0])
                    } else t.globals.markers.size = t.config.series.map((function (e) {
                        return t.config.markers.size
                    }))
                }
            }, {
                key: "plotChartMarkers",
                value: function (t, e, i, n) {
                    var l, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
                        a = this.w,
                        o = e,
                        s = t,
                        c = null,
                        u = new w(this.ctx);
                    if ((a.globals.markers.size[e] > 0 || r) && (c = u.group({
                            class: r ? "" : "apexcharts-series-markers"
                        })).attr("clip-path", "url(#gridRectMarkerMask".concat(a.globals.cuid, ")")), Array.isArray(s.x))
                        for (var h = 0; h < s.x.length; h++) {
                            var d = i;
                            1 === i && 0 === h && (d = 0), 1 === i && 1 === h && (d = 1);
                            var f = "apexcharts-marker";
                            "line" !== a.config.chart.type && "area" !== a.config.chart.type || a.globals.comboCharts || a.config.tooltip.intersect || (f += " no-pointer-events");
                            var p = Array.isArray(a.config.markers.size) ? a.globals.markers.size[e] > 0 : a.config.markers.size > 0;
                            if (p || r) {
                                y.isNumber(s.y[h]) ? f += " w".concat(y.randomId()) : f = "apexcharts-nullpoint";
                                var g = this.getMarkerConfig(f, e, d);
                                a.config.series[o].data[d] && (a.config.series[o].data[d].fillColor && (g.pointFillColor = a.config.series[o].data[d].fillColor), a.config.series[o].data[d].strokeColor && (g.pointStrokeColor = a.config.series[o].data[d].strokeColor)), n && (g.pSize = n), (l = u.drawMarker(s.x[h], s.y[h], g)).attr("rel", d), l.attr("j", d), l.attr("index", e), l.node.setAttribute("default-marker-size", g.pSize);
                                var m = new x(this.ctx);
                                m.setSelectionFilter(l, e, d), this.addEvents(l), c && c.add(l)
                            } else void 0 === a.globals.pointsArray[e] && (a.globals.pointsArray[e] = []), a.globals.pointsArray[e].push([s.x[h], s.y[h]])
                        }
                    return c
                }
            }, {
                key: "getMarkerConfig",
                value: function (t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                        n = this.w,
                        l = this.getMarkerStyle(e),
                        r = n.globals.markers.size[e],
                        a = n.config.markers;
                    return null !== i && a.discrete.length && a.discrete.map((function (t) {
                        t.seriesIndex === e && t.dataPointIndex === i && (l.pointStrokeColor = t.strokeColor, l.pointFillColor = t.fillColor, r = t.size)
                    })), {
                        pSize: r,
                        pRadius: a.radius,
                        width: Array.isArray(a.width) ? a.width[e] : a.width,
                        height: Array.isArray(a.height) ? a.height[e] : a.height,
                        pointStrokeWidth: Array.isArray(a.strokeWidth) ? a.strokeWidth[e] : a.strokeWidth,
                        pointStrokeColor: l.pointStrokeColor,
                        pointFillColor: l.pointFillColor,
                        shape: Array.isArray(a.shape) ? a.shape[e] : a.shape,
                        class: t,
                        pointStrokeOpacity: Array.isArray(a.strokeOpacity) ? a.strokeOpacity[e] : a.strokeOpacity,
                        pointStrokeDashArray: Array.isArray(a.strokeDashArray) ? a.strokeDashArray[e] : a.strokeDashArray,
                        pointFillOpacity: Array.isArray(a.fillOpacity) ? a.fillOpacity[e] : a.fillOpacity,
                        seriesIndex: e
                    }
                }
            }, {
                key: "addEvents",
                value: function (t) {
                    var e = this.w,
                        i = new w(this.ctx);
                    t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this.ctx, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this.ctx, t)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this.ctx, t)), t.node.addEventListener("click", e.config.markers.onClick), t.node.addEventListener("dblclick", e.config.markers.onDblClick), t.node.addEventListener("touchstart", i.pathMouseDown.bind(this.ctx, t), {
                        passive: !0
                    })
                }
            }, {
                key: "getMarkerStyle",
                value: function (t) {
                    var e = this.w,
                        i = e.globals.markers.colors,
                        n = e.config.markers.strokeColor || e.config.markers.strokeColors;
                    return {
                        pointStrokeColor: Array.isArray(n) ? n[t] : n,
                        pointFillColor: Array.isArray(i) ? i[t] : i
                    }
                }
            }]), t
        }(),
        L = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled
            }
            return o(t, [{
                key: "draw",
                value: function (t, e, i) {
                    var n = this.w,
                        l = new w(this.ctx),
                        r = i.realIndex,
                        a = i.pointsPos,
                        o = i.zRatio,
                        s = i.elParent,
                        c = l.group({
                            class: "apexcharts-series-markers apexcharts-series-".concat(n.config.chart.type)
                        });
                    if (c.attr("clip-path", "url(#gridRectMarkerMask".concat(n.globals.cuid, ")")), Array.isArray(a.x))
                        for (var u = 0; u < a.x.length; u++) {
                            var h = e + 1,
                                d = !0;
                            0 === e && 0 === u && (h = 0), 0 === e && 1 === u && (h = 1);
                            var f = 0,
                                p = n.globals.markers.size[r];
                            if (o !== 1 / 0) {
                                p = n.globals.seriesZ[r][h] / o;
                                var g = n.config.plotOptions.bubble;
                                g.minBubbleRadius && p < g.minBubbleRadius && (p = g.minBubbleRadius), g.maxBubbleRadius && p > g.maxBubbleRadius && (p = g.maxBubbleRadius)
                            }
                            n.config.chart.animations.enabled || (f = p);
                            var m = a.x[u],
                                v = a.y[u];
                            if (f = f || 0, null !== v && void 0 !== n.globals.series[r][h] || (d = !1), d) {
                                var y = this.drawPoint(m, v, f, p, r, h, e);
                                c.add(y)
                            }
                            s.add(c)
                        }
                }
            }, {
                key: "drawPoint",
                value: function (t, e, i, n, l, r, a) {
                    var o, s = this.w,
                        c = l,
                        u = new b(this.ctx),
                        h = new x(this.ctx),
                        d = new T(this.ctx),
                        f = new P(this.ctx),
                        p = new w(this.ctx),
                        g = f.getMarkerConfig("apexcharts-marker", c),
                        m = d.fillPath({
                            seriesNumber: l,
                            dataPointIndex: r,
                            patternUnits: "objectBoundingBox",
                            value: s.globals.series[l][a]
                        });
                    if ("circle" === g.shape ? o = p.drawCircle(i) : "square" !== g.shape && "rect" !== g.shape || (o = p.drawRect(0, 0, g.width - g.pointStrokeWidth / 2, g.height - g.pointStrokeWidth / 2, g.pRadius)), s.config.series[c].data[r] && s.config.series[c].data[r].fillColor && (m = s.config.series[c].data[r].fillColor), o.attr({
                            x: t - g.width / 2 - g.pointStrokeWidth / 2,
                            y: e - g.height / 2 - g.pointStrokeWidth / 2,
                            cx: t,
                            cy: e,
                            fill: m,
                            "fill-opacity": g.pointFillOpacity,
                            stroke: g.pointStrokeColor,
                            r: n,
                            "stroke-width": g.pointStrokeWidth,
                            "stroke-dasharray": g.pointStrokeDashArray,
                            "stroke-opacity": g.pointStrokeOpacity
                        }), s.config.chart.dropShadow.enabled) {
                        var v = s.config.chart.dropShadow;
                        h.dropShadow(o, v, l)
                    }
                    if (!this.initialAnim || s.globals.dataChanged || s.globals.resized) s.globals.animationEnded = !0;
                    else {
                        var y = s.config.chart.animations.speed;
                        u.animateMarker(o, 0, "circle" === g.shape ? n : {
                            width: g.width,
                            height: g.height
                        }, y, s.globals.easing, (function () {
                            window.setTimeout((function () {
                                u.animationCompleted(o)
                            }), 100)
                        }))
                    }
                    if (s.globals.dataChanged && "circle" === g.shape)
                        if (this.dynamicAnim) {
                            var _, k, S, A, M = s.config.chart.animations.dynamicAnimation.speed;
                            null != (A = s.globals.previousPaths[l] && s.globals.previousPaths[l][a]) && (_ = A.x, k = A.y, S = void 0 !== A.r ? A.r : n);
                            for (var C = 0; C < s.globals.collapsedSeries.length; C++) s.globals.collapsedSeries[C].index === l && (M = 1, n = 0);
                            0 === t && 0 === e && (n = 0), u.animateCircle(o, {
                                cx: _,
                                cy: k,
                                r: S
                            }, {
                                cx: t,
                                cy: e,
                                r: n
                            }, M, s.globals.easing)
                        } else o.attr({
                            r: n
                        });
                    return o.attr({
                        rel: r,
                        j: r,
                        index: l,
                        "default-marker-size": n
                    }), h.setSelectionFilter(o, l, r), f.addEvents(o), o.node.classList.add("apexcharts-marker"), o
                }
            }, {
                key: "centerTextInBubble",
                value: function (t) {
                    var e = this.w;
                    return {
                        y: t += parseInt(e.config.dataLabels.style.fontSize, 10) / 4
                    }
                }
            }]), t
        }(),
        D = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "dataLabelsCorrection",
                value: function (t, e, i, n, l, r, a) {
                    var o = this.w,
                        s = !1,
                        c = new w(this.ctx).getTextRects(i, a),
                        u = c.width,
                        h = c.height;
                    e < 0 && (e = 0), e > o.globals.gridHeight + h && (e = o.globals.gridHeight + h / 2), void 0 === o.globals.dataLabelsRects[n] && (o.globals.dataLabelsRects[n] = []), o.globals.dataLabelsRects[n].push({
                        x: t,
                        y: e,
                        width: u,
                        height: h
                    });
                    var d = o.globals.dataLabelsRects[n].length - 2,
                        f = void 0 !== o.globals.lastDrawnDataLabelsIndexes[n] ? o.globals.lastDrawnDataLabelsIndexes[n][o.globals.lastDrawnDataLabelsIndexes[n].length - 1] : 0;
                    if (void 0 !== o.globals.dataLabelsRects[n][d]) {
                        var p = o.globals.dataLabelsRects[n][f];
                        (t > p.x + p.width + 2 || e > p.y + p.height + 2 || t + u < p.x) && (s = !0)
                    }
                    return (0 === l || r) && (s = !0), {
                        x: t,
                        y: e,
                        textRects: c,
                        drawnextLabel: s
                    }
                }
            }, {
                key: "drawDataLabel",
                value: function (t, e, i) {
                    var n = this,
                        l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 2,
                        r = this.w,
                        a = new w(this.ctx),
                        o = r.config.dataLabels,
                        s = 0,
                        c = 0,
                        u = i,
                        h = null;
                    if (!o.enabled || !Array.isArray(t.x)) return h;
                    h = a.group({
                        class: "apexcharts-data-labels"
                    });
                    for (var d = 0; d < t.x.length; d++)
                        if (s = t.x[d] + o.offsetX, c = t.y[d] + o.offsetY + l, !isNaN(s)) {
                            1 === i && 0 === d && (u = 0), 1 === i && 1 === d && (u = 1);
                            var f = r.globals.series[e][u],
                                p = "",
                                g = function (t) {
                                    return r.config.dataLabels.formatter(t, {
                                        ctx: n.ctx,
                                        seriesIndex: e,
                                        dataPointIndex: u,
                                        w: r
                                    })
                                };
                            if ("bubble" === r.config.chart.type) {
                                p = g(f = r.globals.seriesZ[e][u]), c = t.y[d];
                                var m = new L(this.ctx),
                                    v = m.centerTextInBubble(c, e, u);
                                c = v.y
                            } else void 0 !== f && (p = g(f));
                            this.plotDataLabelsText({
                                x: s,
                                y: c,
                                text: p,
                                i: e,
                                j: u,
                                parent: h,
                                offsetCorrection: !0,
                                dataLabelsConfig: r.config.dataLabels
                            })
                        } return h
                }
            }, {
                key: "plotDataLabelsText",
                value: function (t) {
                    var e = this.w,
                        i = new w(this.ctx),
                        n = t.x,
                        l = t.y,
                        r = t.i,
                        a = t.j,
                        o = t.text,
                        s = t.textAnchor,
                        c = t.fontSize,
                        u = t.parent,
                        h = t.dataLabelsConfig,
                        d = t.color,
                        f = t.alwaysDrawDataLabel,
                        p = t.offsetCorrection;
                    if (!(Array.isArray(e.config.dataLabels.enabledOnSeries) && e.config.dataLabels.enabledOnSeries.indexOf(r) < 0)) {
                        var g = {
                            x: n,
                            y: l,
                            drawnextLabel: !0
                        };
                        p && (g = this.dataLabelsCorrection(n, l, o, r, a, f, parseInt(h.style.fontSize, 10))), e.globals.zoomed || (n = g.x, l = g.y), g.textRects && (n < -10 - g.textRects.width || n > e.globals.gridWidth + g.textRects.width + 10) && (o = "");
                        var m = e.globals.dataLabels.style.colors[r];
                        (("bar" === e.config.chart.type || "rangeBar" === e.config.chart.type) && e.config.plotOptions.bar.distributed || e.config.dataLabels.distributed) && (m = e.globals.dataLabels.style.colors[a]), "function" == typeof m && (m = m({
                            series: e.globals.series,
                            seriesIndex: r,
                            dataPointIndex: a,
                            w: e
                        })), d && (m = d);
                        var v = h.offsetX,
                            y = h.offsetY;
                        if ("bar" !== e.config.chart.type && "rangeBar" !== e.config.chart.type || (v = 0, y = 0), g.drawnextLabel) {
                            var b = i.drawText({
                                width: 100,
                                height: parseInt(h.style.fontSize, 10),
                                x: n + v,
                                y: l + y,
                                foreColor: m,
                                textAnchor: s || h.textAnchor,
                                text: o,
                                fontSize: c || h.style.fontSize,
                                fontFamily: h.style.fontFamily,
                                fontWeight: h.style.fontWeight || "normal"
                            });
                            if (b.attr({
                                    class: "apexcharts-datalabel",
                                    cx: n,
                                    cy: l
                                }), h.dropShadow.enabled) {
                                var _ = h.dropShadow;
                                new x(this.ctx).dropShadow(b, _)
                            }
                            u.add(b), void 0 === e.globals.lastDrawnDataLabelsIndexes[r] && (e.globals.lastDrawnDataLabelsIndexes[r] = []), e.globals.lastDrawnDataLabelsIndexes[r].push(a)
                        }
                    }
                }
            }, {
                key: "addBackgroundToDataLabel",
                value: function (t, e) {
                    var i = this.w,
                        n = i.config.dataLabels.background,
                        l = n.padding,
                        r = n.padding / 2,
                        a = e.width,
                        o = e.height,
                        s = new w(this.ctx).drawRect(e.x - l, e.y - r / 2, a + 2 * l, o + r, n.borderRadius, "transparent" === i.config.chart.background ? "#fff" : i.config.chart.background, n.opacity, n.borderWidth, n.borderColor);
                    return n.dropShadow.enabled && new x(this.ctx).dropShadow(s, n.dropShadow), s
                }
            }, {
                key: "dataLabelsBackground",
                value: function () {
                    var t = this.w;
                    if ("bubble" !== t.config.chart.type)
                        for (var e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), i = 0; i < e.length; i++) {
                            var n = e[i],
                                l = n.getBBox(),
                                r = null;
                            if (l.width && l.height && (r = this.addBackgroundToDataLabel(n, l)), r) {
                                n.parentNode.insertBefore(r.node, n);
                                var a = n.getAttribute("fill");
                                !t.config.chart.animations.enabled || t.globals.resized || t.globals.dataChanged ? r.attr({
                                    fill: a
                                }) : r.animate().attr({
                                    fill: a
                                }), n.setAttribute("fill", t.config.dataLabels.background.foreColor)
                            }
                        }
                }
            }, {
                key: "bringForward",
                value: function () {
                    for (var t = this.w, e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), i = t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), n = 0; n < e.length; n++) i && i.insertBefore(e[n], i.nextSibling)
                }
            }]), t
        }(),
        I = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.barCtx = e
            }
            return o(t, [{
                key: "handleBarDataLabels",
                value: function (t) {
                    var e = t.x,
                        i = t.y,
                        n = t.y1,
                        l = t.y2,
                        r = t.i,
                        a = t.j,
                        o = t.realIndex,
                        s = t.series,
                        c = t.barHeight,
                        u = t.barWidth,
                        h = t.barYPosition,
                        d = t.visibleSeries,
                        f = t.renderedPath,
                        p = this.w,
                        g = new w(this.barCtx.ctx),
                        m = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[o] : this.barCtx.strokeWidth,
                        v = e + parseFloat(u * d),
                        y = i + parseFloat(c * d);
                    p.globals.isXNumeric && !p.globals.isBarHorizontal && (v = e + parseFloat(u * (d + 1)), y = i + parseFloat(c * (d + 1)) - m);
                    var b, x = e,
                        _ = i,
                        k = p.config.dataLabels,
                        S = this.barCtx.barOptions.dataLabels;
                    void 0 !== h && this.barCtx.isTimelineBar && (y = h, _ = h);
                    var A = k.offsetX,
                        M = k.offsetY,
                        C = {
                            width: 0,
                            height: 0
                        };
                    if (p.config.dataLabels.enabled) {
                        var E = this.barCtx.series[r][a];
                        C = g.getTextRects(p.globals.yLabelFormatters[0](E), parseFloat(k.style.fontSize))
                    }
                    var O = {
                        x: e,
                        y: i,
                        i: r,
                        j: a,
                        renderedPath: f,
                        bcx: v,
                        bcy: y,
                        barHeight: c,
                        barWidth: u,
                        textRects: C,
                        strokeWidth: m,
                        dataLabelsX: x,
                        dataLabelsY: _,
                        barDataLabelsConfig: S,
                        offX: A,
                        offY: M
                    };
                    return b = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(O) : this.calculateColumnsDataLabelsPosition(O), f.attr({
                        cy: b.bcy,
                        cx: b.bcx,
                        j: a,
                        val: s[r][a],
                        barHeight: c,
                        barWidth: u
                    }), this.drawCalculatedDataLabels({
                        x: b.dataLabelsX,
                        y: b.dataLabelsY,
                        val: this.barCtx.isTimelineBar ? [n, l] : s[r][a],
                        i: o,
                        j: a,
                        barWidth: u,
                        barHeight: c,
                        textRects: C,
                        dataLabelsConfig: k
                    })
                }
            }, {
                key: "calculateColumnsDataLabelsPosition",
                value: function (t) {
                    var e, i = this.w,
                        n = t.i,
                        l = t.j,
                        r = t.y,
                        a = t.bcx,
                        o = t.barWidth,
                        s = t.barHeight,
                        c = t.textRects,
                        u = t.dataLabelsY,
                        h = t.barDataLabelsConfig,
                        d = t.strokeWidth,
                        f = t.offX,
                        p = t.offY;
                    s = Math.abs(s);
                    var g = "vertical" === i.config.plotOptions.bar.dataLabels.orientation;
                    a -= d / 2;
                    var m = i.globals.gridWidth / i.globals.dataPoints;
                    e = i.globals.isXNumeric ? a - o / 2 + f : a - m + o / 2 + f, g && (e = e + c.height / 2 - d / 2 - 2);
                    var v = this.barCtx.series[n][l] < 0,
                        y = r;
                    switch (this.barCtx.isReversed && (y = r - s + (v ? 2 * s : 0), r -= s), h.position) {
                        case "center":
                            u = g ? v ? y + s / 2 + p : y + s / 2 - p : v ? y - s / 2 + c.height / 2 + p : y + s / 2 + c.height / 2 - p;
                            break;
                        case "bottom":
                            u = g ? v ? y + s + p : y + s - p : v ? y - s + c.height + d + p : y + s - c.height / 2 + d - p;
                            break;
                        case "top":
                            u = g ? v ? y + p : y - p : v ? y - c.height / 2 - p : y + c.height + p
                    }
                    return i.config.chart.stacked || (u < 0 ? u = 0 + d : u + c.height / 3 > i.globals.gridHeight && (u = i.globals.gridHeight - d)), {
                        bcx: a,
                        bcy: r,
                        dataLabelsX: e,
                        dataLabelsY: u
                    }
                }
            }, {
                key: "calculateBarsDataLabelsPosition",
                value: function (t) {
                    var e = this.w,
                        i = t.x,
                        n = t.i,
                        l = t.j,
                        r = t.bcy,
                        a = t.barHeight,
                        o = t.barWidth,
                        s = t.textRects,
                        c = t.dataLabelsX,
                        u = t.strokeWidth,
                        h = t.barDataLabelsConfig,
                        d = t.offX,
                        f = t.offY,
                        p = e.globals.gridHeight / e.globals.dataPoints;
                    o = Math.abs(o);
                    var g = r - (this.barCtx.isTimelineBar ? 0 : p) + a / 2 + s.height / 2 + f - 3,
                        m = this.barCtx.series[n][l] < 0,
                        v = i;
                    switch (this.barCtx.isReversed && (v = i + o - (m ? 2 * o : 0), i = e.globals.gridWidth - o), h.position) {
                        case "center":
                            c = m ? v + o / 2 - d : Math.max(s.width / 2, v - o / 2) + d;
                            break;
                        case "bottom":
                            c = m ? v + o - u - Math.round(s.width / 2) - d : v - o + u + Math.round(s.width / 2) + d;
                            break;
                        case "top":
                            c = m ? v - u + Math.round(s.width / 2) - d : v - u - Math.round(s.width / 2) + d
                    }
                    return e.config.chart.stacked || (c < 0 ? c = c + s.width + u : c + s.width / 2 > e.globals.gridWidth && (c = e.globals.gridWidth - s.width - u)), {
                        bcx: i,
                        bcy: r,
                        dataLabelsX: c,
                        dataLabelsY: g
                    }
                }
            }, {
                key: "drawCalculatedDataLabels",
                value: function (t) {
                    var e = t.x,
                        i = t.y,
                        n = t.val,
                        l = t.i,
                        r = t.j,
                        a = t.textRects,
                        o = t.barHeight,
                        s = t.barWidth,
                        c = t.dataLabelsConfig,
                        h = this.w,
                        d = "rotate(0)";
                    "vertical" === h.config.plotOptions.bar.dataLabels.orientation && (d = "rotate(-90, ".concat(e, ", ").concat(i, ")"));
                    var f = new D(this.barCtx.ctx),
                        p = new w(this.barCtx.ctx),
                        g = c.formatter,
                        m = null,
                        v = h.globals.collapsedSeriesIndices.indexOf(l) > -1;
                    if (c.enabled && !v) {
                        m = p.group({
                            class: "apexcharts-data-labels",
                            transform: d
                        });
                        var y = "";
                        void 0 !== n && (y = g(n, {
                            seriesIndex: l,
                            dataPointIndex: r,
                            w: h
                        })), 0 === n && h.config.chart.stacked && (y = "");
                        var b = h.globals.series[l][r] <= 0,
                            x = h.config.plotOptions.bar.dataLabels.position;
                        "vertical" === h.config.plotOptions.bar.dataLabels.orientation && ("top" === x && (c.textAnchor = b ? "end" : "start"), "center" === x && (c.textAnchor = "middle"), "bottom" === x && (c.textAnchor = b ? "end" : "start")), this.barCtx.isTimelineBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && s < p.getTextRects(y, parseFloat(c.style.fontSize)).width && (y = ""), h.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? (s > 0 && a.width / 1.6 > s || s < 0 && a.width / 1.6 < s) && (y = "") : a.height / 1.6 > o && (y = ""));
                        var _ = u({}, c);
                        this.barCtx.isHorizontal && n < 0 && ("start" === c.textAnchor ? _.textAnchor = "end" : "end" === c.textAnchor && (_.textAnchor = "start")), f.plotDataLabelsText({
                            x: e,
                            y: i,
                            text: y,
                            i: l,
                            j: r,
                            parent: m,
                            dataLabelsConfig: _,
                            alwaysDrawDataLabel: !0,
                            offsetCorrection: !0
                        })
                    }
                    return m
                }
            }]), t
        }(),
        j = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive"
            }
            return o(t, [{
                key: "getAllSeriesEls",
                value: function () {
                    return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series")
                }
            }, {
                key: "getSeriesByName",
                value: function (t) {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat(y.escapeString(t), "']"))
                }
            }, {
                key: "isSeriesHidden",
                value: function (t) {
                    var e = this.getSeriesByName(t),
                        i = parseInt(e.getAttribute("data:realIndex"), 10);
                    return {
                        isHidden: e.classList.contains("apexcharts-series-collapsed"),
                        realIndex: i
                    }
                }
            }, {
                key: "addCollapsedClassToSeries",
                value: function (t, e) {
                    var i = this.w;

                    function n(i) {
                        for (var n = 0; n < i.length; n++) i[n].index === e && t.node.classList.add("apexcharts-series-collapsed")
                    }
                    n(i.globals.collapsedSeries), n(i.globals.ancillaryCollapsedSeries)
                }
            }, {
                key: "toggleSeries",
                value: function (t) {
                    var e = this.isSeriesHidden(t);
                    return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, e.isHidden), e.isHidden
                }
            }, {
                key: "showSeries",
                value: function (t) {
                    var e = this.isSeriesHidden(t);
                    e.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !0)
                }
            }, {
                key: "hideSeries",
                value: function (t) {
                    var e = this.isSeriesHidden(t);
                    e.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !1)
                }
            }, {
                key: "resetSeries",
                value: function () {
                    var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                        e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                        i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                        n = this.w,
                        l = y.clone(n.globals.initialSeries);
                    n.globals.previousPaths = [], i ? (n.globals.collapsedSeries = [], n.globals.ancillaryCollapsedSeries = [], n.globals.collapsedSeriesIndices = [], n.globals.ancillaryCollapsedSeriesIndices = []) : l = this.emptyCollapsedSeries(l), n.config.series = l, t && (e && (n.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(l, n.config.chart.animations.dynamicAnimation.enabled))
                }
            }, {
                key: "emptyCollapsedSeries",
                value: function (t) {
                    for (var e = this.w, i = 0; i < t.length; i++) e.globals.collapsedSeriesIndices.indexOf(i) > -1 && (t[i].data = []);
                    return t
                }
            }, {
                key: "toggleSeriesOnHover",
                value: function (t, e) {
                    var i = this.w,
                        n = i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels");
                    if ("mousemove" === t.type) {
                        var l = parseInt(e.getAttribute("rel"), 10) - 1,
                            r = null,
                            a = null;
                        i.globals.axisCharts || "radialBar" === i.config.chart.type ? i.globals.axisCharts ? (r = i.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(l, "']")), a = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(l, "']"))) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(l + 1, "']")) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(l + 1, "'] path"));
                        for (var o = 0; o < n.length; o++) n[o].classList.add(this.legendInactiveClass);
                        null !== r && (i.globals.axisCharts || r.parentNode.classList.remove(this.legendInactiveClass), r.classList.remove(this.legendInactiveClass), null !== a && a.classList.remove(this.legendInactiveClass))
                    } else if ("mouseout" === t.type)
                        for (var s = 0; s < n.length; s++) n[s].classList.remove(this.legendInactiveClass)
                }
            }, {
                key: "highlightRangeInSeries",
                value: function (t, e) {
                    var i = this,
                        n = this.w,
                        l = n.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"),
                        r = function (t) {
                            for (var e = 0; e < l.length; e++) l[e].classList[t](i.legendInactiveClass)
                        };
                    if ("mousemove" === t.type) {
                        var a = parseInt(e.getAttribute("rel"), 10) - 1;
                        r("add"),
                            function (t) {
                                for (var e = 0; e < l.length; e++) {
                                    var n = parseInt(l[e].getAttribute("val"), 10);
                                    n >= t.from && n <= t.to && l[e].classList.remove(i.legendInactiveClass)
                                }
                            }(n.config.plotOptions.heatmap.colorScale.ranges[a])
                    } else "mouseout" === t.type && r("remove")
                }
            }, {
                key: "getActiveConfigSeriesIndex",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "asc",
                        i = this.w,
                        n = 0;
                    if (i.config.series.length > 1)
                        for (var l = i.config.series.map((function (e, n) {
                                var l = !1;
                                return t && (l = "bar" === i.config.series[n].type || "column" === i.config.series[n].type), e.data && e.data.length > 0 && !l ? n : -1
                            })), r = "asc" === e ? 0 : l.length - 1;
                            "asc" === e ? r < l.length : r >= 0;
                            "asc" === e ? r++ : r--)
                            if (-1 !== l[r]) {
                                n = l[r];
                                break
                            } return n
                }
            }, {
                key: "getPreviousPaths",
                value: function () {
                    var t = this.w;

                    function e(e, i, n) {
                        for (var l = e[i].childNodes, r = {
                                type: n,
                                paths: [],
                                realIndex: e[i].getAttribute("data:realIndex")
                            }, a = 0; a < l.length; a++)
                            if (l[a].hasAttribute("pathTo")) {
                                var o = l[a].getAttribute("pathTo");
                                r.paths.push({
                                    d: o
                                })
                            } t.globals.previousPaths.push(r)
                    }
                    t.globals.previousPaths = [], ["line", "area", "bar", "rangebar", "candlestick", "radar"].forEach((function (i) {
                        for (var n, l = (n = i, t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(n, "-series .apexcharts-series"))), r = 0; r < l.length; r++) e(l, r, i)
                    })), this.handlePrevBubbleScatterPaths("bubble"), this.handlePrevBubbleScatterPaths("scatter");
                    var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series"));
                    if (i.length > 0)
                        for (var n = function (e) {
                                for (var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(e, "'] rect")), n = [], l = function (t) {
                                        var e = function (e) {
                                                return i[t].getAttribute(e)
                                            },
                                            l = {
                                                x: parseFloat(e("x")),
                                                y: parseFloat(e("y")),
                                                width: parseFloat(e("width")),
                                                height: parseFloat(e("height"))
                                            };
                                        n.push({
                                            rect: l,
                                            color: i[t].getAttribute("color")
                                        })
                                    }, r = 0; r < i.length; r++) l(r);
                                t.globals.previousPaths.push(n)
                            }, l = 0; l < i.length; l++) n(l);
                    t.globals.axisCharts || (t.globals.previousPaths = t.globals.series)
                }
            }, {
                key: "handlePrevBubbleScatterPaths",
                value: function (t) {
                    var e = this.w,
                        i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series"));
                    if (i.length > 0)
                        for (var n = 0; n < i.length; n++) {
                            for (var l = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series[data\\:realIndex='").concat(n, "'] circle")), r = [], a = 0; a < l.length; a++) r.push({
                                x: l[a].getAttribute("cx"),
                                y: l[a].getAttribute("cy"),
                                r: l[a].getAttribute("r")
                            });
                            e.globals.previousPaths.push(r)
                        }
                }
            }, {
                key: "clearPreviousPaths",
                value: function () {
                    var t = this.w;
                    t.globals.previousPaths = [], t.globals.allSeriesCollapsed = !1
                }
            }, {
                key: "handleNoData",
                value: function () {
                    var t = this.w,
                        e = t.config.noData,
                        i = new w(this.ctx),
                        n = t.globals.svgWidth / 2,
                        l = t.globals.svgHeight / 2,
                        r = "middle";
                    if (t.globals.noData = !0, t.globals.animationEnded = !0, "left" === e.align ? (n = 10, r = "start") : "right" === e.align && (n = t.globals.svgWidth - 10, r = "end"), "top" === e.verticalAlign ? l = 50 : "bottom" === e.verticalAlign && (l = t.globals.svgHeight - 50), n += e.offsetX, l = l + parseInt(e.style.fontSize, 10) + 2 + e.offsetY, void 0 !== e.text && "" !== e.text) {
                        var a = i.drawText({
                            x: n,
                            y: l,
                            text: e.text,
                            textAnchor: r,
                            fontSize: e.style.fontSize,
                            fontFamily: e.style.fontFamily,
                            foreColor: e.style.color,
                            opacity: 1,
                            class: "apexcharts-text-nodata"
                        });
                        t.globals.dom.Paper.add(a)
                    }
                }
            }, {
                key: "setNullSeriesToZeroValues",
                value: function (t) {
                    for (var e = this.w, i = 0; i < t.length; i++)
                        if (0 === t[i].length)
                            for (var n = 0; n < t[e.globals.maxValsInArrayIndex].length; n++) t[i].push(0);
                    return t
                }
            }, {
                key: "hasAllSeriesEqualX",
                value: function () {
                    for (var t = !0, e = this.w, i = this.filteredSeriesX(), n = 0; n < i.length - 1; n++)
                        if (i[n][0] !== i[n + 1][0]) {
                            t = !1;
                            break
                        } return e.globals.allSeriesHasEqualX = t, t
                }
            }, {
                key: "filteredSeriesX",
                value: function () {
                    return this.w.globals.seriesX.map((function (t) {
                        return t.length > 0 ? t : []
                    }))
                }
            }]), t
        }(),
        N = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.barCtx = e
            }
            return o(t, [{
                key: "initVariables",
                value: function (t) {
                    var e = this.w;
                    this.barCtx.series = t, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
                    for (var i = 0; i < t.length; i++)
                        if (t[i].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += t[i].length), e.globals.isXNumeric)
                            for (var n = 0; n < t[i].length; n++) e.globals.seriesX[i][n] > e.globals.minX && e.globals.seriesX[i][n] < e.globals.maxX && this.barCtx.visibleItems++;
                        else this.barCtx.visibleItems = e.globals.dataPoints;
                    0 === this.barCtx.seriesLen && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], this.barCtx.radiusOnSeriesNumber = t.length - 1, e.globals.comboCharts || this.checkZeroSeries({
                        series: t
                    })
                }
            }, {
                key: "initialPositions",
                value: function () {
                    var t, e, i, n, l, r, a, o, s = this.w,
                        c = s.globals.dataPoints;
                    this.barCtx.isTimelineBar && (c = s.globals.labels.length);
                    var u = this.barCtx.seriesLen;
                    if (s.config.plotOptions.bar.rangeBarGroupRows && (u = 1), this.barCtx.isHorizontal) l = (i = s.globals.gridHeight / c) / u, s.globals.isXNumeric && (l = (i = s.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), l = l * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, o = this.barCtx.baseLineInvertedY + s.globals.padHorizontal + (this.barCtx.isReversed ? s.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), e = (i - l * this.barCtx.seriesLen) / 2;
                    else {
                        if (n = s.globals.gridWidth / this.barCtx.visibleItems, s.config.xaxis.convertedCatToNumeric && (n = s.globals.gridWidth / s.globals.dataPoints), r = n / this.barCtx.seriesLen * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, s.globals.isXNumeric) {
                            var h = this.barCtx.xRatio;
                            s.config.xaxis.convertedCatToNumeric && (h = this.barCtx.initialXRatio), s.globals.minXDiff && .5 !== s.globals.minXDiff && s.globals.minXDiff / h > 0 && (n = s.globals.minXDiff / h), (r = n / this.barCtx.seriesLen * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (r = 1)
                        }
                        a = s.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.yaxisIndex] - (this.barCtx.isReversed ? s.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.yaxisIndex] : 0), t = s.globals.padHorizontal + (n - r * this.barCtx.seriesLen) / 2
                    }
                    return {
                        x: t,
                        y: e,
                        yDivision: i,
                        xDivision: n,
                        barHeight: l,
                        barWidth: r,
                        zeroH: a,
                        zeroW: o
                    }
                }
            }, {
                key: "getPathFillColor",
                value: function (t, e, i, n) {
                    var l = this.w,
                        r = new T(this.barCtx.ctx),
                        a = null,
                        o = this.barCtx.barOptions.distributed ? i : e;
                    return this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map((function (n) {
                        t[e][i] >= n.from && t[e][i] <= n.to && (a = n.color)
                    })), l.config.series[e].data[i] && l.config.series[e].data[i].fillColor && (a = l.config.series[e].data[i].fillColor), r.fillPath({
                        seriesNumber: this.barCtx.barOptions.distributed ? o : n,
                        dataPointIndex: i,
                        color: a,
                        value: t[e][i]
                    })
                }
            }, {
                key: "getStrokeWidth",
                value: function (t, e, i) {
                    var n = 0,
                        l = this.w;
                    return void 0 === this.barCtx.series[t][e] || null === this.barCtx.series[t][e] ? this.barCtx.isNullValue = !0 : this.barCtx.isNullValue = !1, l.config.stroke.show && (this.barCtx.isNullValue || (n = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[i] : this.barCtx.strokeWidth)), n
                }
            }, {
                key: "barBackground",
                value: function (t) {
                    var e = t.j,
                        i = t.i,
                        n = t.x1,
                        l = t.x2,
                        r = t.y1,
                        a = t.y2,
                        o = t.elSeries,
                        s = this.w,
                        c = new w(this.barCtx.ctx),
                        u = new j(this.barCtx.ctx).getActiveConfigSeriesIndex();
                    if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && u === i) {
                        e >= this.barCtx.barOptions.colors.backgroundBarColors.length && (e -= this.barCtx.barOptions.colors.backgroundBarColors.length);
                        var h = this.barCtx.barOptions.colors.backgroundBarColors[e],
                            d = c.drawRect(void 0 !== n ? n : 0, void 0 !== r ? r : 0, void 0 !== l ? l : s.globals.gridWidth, void 0 !== a ? a : s.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, h, this.barCtx.barOptions.colors.backgroundBarOpacity);
                        o.add(d), d.node.classList.add("apexcharts-backgroundBar")
                    }
                }
            }, {
                key: "getColumnPaths",
                value: function (t) {
                    var e = t.barWidth,
                        i = t.barXPosition,
                        n = t.yRatio,
                        l = t.y1,
                        r = t.y2,
                        a = t.strokeWidth,
                        o = t.series,
                        s = t.realIndex,
                        c = t.i,
                        u = t.j,
                        h = t.w,
                        d = new w(this.barCtx.ctx);
                    (a = Array.isArray(a) ? a[s] : a) || (a = 0);
                    var f = {
                            barWidth: e,
                            strokeWidth: a,
                            yRatio: n,
                            barXPosition: i,
                            y1: l,
                            y2: r
                        },
                        p = this.getRoundedBars(h, f, o, c, u),
                        g = i,
                        m = i + e,
                        v = d.move(g, l),
                        y = d.move(g, l),
                        b = d.line(m - a, l);
                    return h.globals.previousPaths.length > 0 && (y = this.barCtx.getPreviousPath(s, u, !1)), v = v + d.line(g, p.y2) + p.pathWithRadius + d.line(m - a, p.y2) + b + b + "z", y = y + d.line(g, l) + b + b + b + b + b + d.line(g, l), h.config.chart.stacked && (this.barCtx.yArrj.push(p.y2), this.barCtx.yArrjF.push(Math.abs(l - p.y2)), this.barCtx.yArrjVal.push(this.barCtx.series[c][u])), {
                        pathTo: v,
                        pathFrom: y
                    }
                }
            }, {
                key: "getBarpaths",
                value: function (t) {
                    var e = t.barYPosition,
                        i = t.barHeight,
                        n = t.x1,
                        l = t.x2,
                        r = t.strokeWidth,
                        a = t.series,
                        o = t.realIndex,
                        s = t.i,
                        c = t.j,
                        u = t.w,
                        h = new w(this.barCtx.ctx);
                    (r = Array.isArray(r) ? r[o] : r) || (r = 0);
                    var d = {
                            barHeight: i,
                            strokeWidth: r,
                            barYPosition: e,
                            x2: l,
                            x1: n
                        },
                        f = this.getRoundedBars(u, d, a, s, c),
                        p = h.move(n, e),
                        g = h.move(n, e);
                    u.globals.previousPaths.length > 0 && (g = this.barCtx.getPreviousPath(o, c, !1));
                    var m = e,
                        v = e + i,
                        y = h.line(n, v - r);
                    return p = p + h.line(f.x2, m) + f.pathWithRadius + h.line(f.x2, v - r) + y + y + "z", g = g + h.line(n, m) + y + y + y + y + y + h.line(n, m), u.config.chart.stacked && (this.barCtx.xArrj.push(f.x2), this.barCtx.xArrjF.push(Math.abs(n - f.x2)), this.barCtx.xArrjVal.push(this.barCtx.series[s][c])), {
                        pathTo: p,
                        pathFrom: g
                    }
                }
            }, {
                key: "getRoundedBars",
                value: function (t, e, i, n, l) {
                    var r = new w(this.barCtx.ctx),
                        a = t.config.plotOptions.bar.borderRadius;
                    if (t.config.chart.stacked && i.length > 1 && n !== this.barCtx.radiusOnSeriesNumber && (a = 0), this.barCtx.isHorizontal) {
                        var o = "",
                            s = e.x2;
                        if (Math.abs(e.x1 - e.x2) < a && (a = Math.abs(e.x1 - e.x2)), void 0 !== i[n][l] || null !== i[n][l]) {
                            var c = this.barCtx.isReversed ? i[n][l] > 0 : i[n][l] < 0;
                            c && (a *= -1), s -= a, o = r.quadraticCurve(s + a, e.barYPosition, s + a, e.barYPosition + (c ? -1 * a : a)) + r.line(s + a, e.barYPosition + e.barHeight - e.strokeWidth - (c ? -1 * a : a)) + r.quadraticCurve(s + a, e.barYPosition + e.barHeight - e.strokeWidth, s, e.barYPosition + e.barHeight - e.strokeWidth)
                        }
                        return {
                            pathWithRadius: o,
                            x2: s
                        }
                    }
                    var u = "",
                        h = e.y2;
                    if (Math.abs(e.y1 - e.y2) < a && (a = Math.abs(e.y1 - e.y2)), void 0 !== i[n][l] || null !== i[n][l]) {
                        var d = i[n][l] < 0;
                        d && (a *= -1), h += a, u = r.quadraticCurve(e.barXPosition, h - a, e.barXPosition + (d ? -1 * a : a), h - a) + r.line(e.barXPosition + e.barWidth - e.strokeWidth - (d ? -1 * a : a), h - a) + r.quadraticCurve(e.barXPosition + e.barWidth - e.strokeWidth, h - a, e.barXPosition + e.barWidth - e.strokeWidth, h)
                    }
                    return {
                        pathWithRadius: u,
                        y2: h
                    }
                }
            }, {
                key: "checkZeroSeries",
                value: function (t) {
                    for (var e = t.series, i = this.w, n = 0; n < e.length; n++) {
                        for (var l = 0, r = 0; r < e[i.globals.maxValsInArrayIndex].length; r++) l += e[n][r];
                        0 === l && this.barCtx.zeroSerieses.push(n)
                    }
                    for (var a = e.length - 1; a >= 0; a--) this.barCtx.zeroSerieses.indexOf(a) > -1 && a === this.radiusOnSeriesNumber && (this.barCtx.radiusOnSeriesNumber -= 1);
                    for (var o = e.length - 1; o >= 0; o--) i.globals.collapsedSeriesIndices.indexOf(this.barCtx.radiusOnSeriesNumber) > -1 && (this.barCtx.radiusOnSeriesNumber -= 1)
                }
            }]), t
        }(),
        R = function () {
            function t(e, i) {
                r(this, t), this.ctx = e, this.w = e.w;
                var n = this.w;
                this.barOptions = n.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = n.config.stroke.width, this.isNullValue = !1, this.isTimelineBar = "datetime" === n.config.xaxis.type && n.globals.seriesRangeBarTimeline.length, this.xyRatios = i, null !== this.xyRatios && (this.xRatio = i.xRatio, this.initialXRatio = i.initialXRatio, this.yRatio = i.yRatio, this.invertedXRatio = i.invertedXRatio, this.invertedYRatio = i.invertedYRatio, this.baseLineY = i.baseLineY, this.baseLineInvertedY = i.baseLineInvertedY), this.yaxisIndex = 0, this.seriesLen = 0, this.barHelpers = new N(this)
            }
            return o(t, [{
                key: "draw",
                value: function (t, e) {
                    var i = this.w,
                        n = new w(this.ctx),
                        l = new S(this.ctx, i);
                    t = l.getLogSeries(t), this.series = t, this.yRatio = l.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                    var r = n.group({
                        class: "apexcharts-bar-series apexcharts-plot-series"
                    });
                    i.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering.");
                    for (var a = 0, o = 0; a < t.length; a++, o++) {
                        var s, c, h, d, f = void 0,
                            p = void 0,
                            g = [],
                            m = [],
                            v = i.globals.comboCharts ? e[a] : a,
                            b = n.group({
                                class: "apexcharts-series",
                                rel: a + 1,
                                seriesName: y.escapeString(i.globals.seriesNames[v]),
                                "data:realIndex": v
                            });
                        this.ctx.series.addCollapsedClassToSeries(b, v), t[a].length > 0 && (this.visibleI = this.visibleI + 1);
                        var x = 0,
                            _ = 0;
                        this.yRatio.length > 1 && (this.yaxisIndex = v), this.isReversed = i.config.yaxis[this.yaxisIndex] && i.config.yaxis[this.yaxisIndex].reversed;
                        var k = this.barHelpers.initialPositions();
                        p = k.y, x = k.barHeight, c = k.yDivision, d = k.zeroW, f = k.x, _ = k.barWidth, s = k.xDivision, h = k.zeroH, this.horizontal || m.push(f + _ / 2);
                        for (var A = n.group({
                                class: "apexcharts-datalabels",
                                "data:realIndex": v
                            }), M = 0; M < i.globals.dataPoints; M++) {
                            var C = this.barHelpers.getStrokeWidth(a, M, v),
                                E = null,
                                O = {
                                    indexes: {
                                        i: a,
                                        j: M,
                                        realIndex: v,
                                        bc: o
                                    },
                                    x: f,
                                    y: p,
                                    strokeWidth: C,
                                    elSeries: b
                                };
                            this.isHorizontal ? (E = this.drawBarPaths(u(u({}, O), {}, {
                                barHeight: x,
                                zeroW: d,
                                yDivision: c
                            })), _ = this.series[a][M] / this.invertedYRatio) : (E = this.drawColumnPaths(u(u({}, O), {}, {
                                xDivision: s,
                                barWidth: _,
                                zeroH: h
                            })), x = this.series[a][M] / this.yRatio[this.yaxisIndex]), p = E.y, f = E.x, M > 0 && m.push(f + _ / 2), g.push(p);
                            var T = this.barHelpers.getPathFillColor(t, a, M, v);
                            this.renderSeries({
                                realIndex: v,
                                pathFill: T,
                                j: M,
                                i: a,
                                pathFrom: E.pathFrom,
                                pathTo: E.pathTo,
                                strokeWidth: C,
                                elSeries: b,
                                x: f,
                                y: p,
                                series: t,
                                barHeight: x,
                                barWidth: _,
                                elDataLabelsWrap: A,
                                visibleSeries: this.visibleI,
                                type: "bar"
                            })
                        }
                        i.globals.seriesXvalues[v] = m, i.globals.seriesYvalues[v] = g, r.add(b)
                    }
                    return r
                }
            }, {
                key: "renderSeries",
                value: function (t) {
                    var e = t.realIndex,
                        i = t.pathFill,
                        n = t.lineFill,
                        l = t.j,
                        r = t.i,
                        a = t.pathFrom,
                        o = t.pathTo,
                        s = t.strokeWidth,
                        c = t.elSeries,
                        u = t.x,
                        h = t.y,
                        d = t.y1,
                        f = t.y2,
                        p = t.series,
                        g = t.barHeight,
                        m = t.barWidth,
                        v = t.barYPosition,
                        y = t.elDataLabelsWrap,
                        b = t.visibleSeries,
                        _ = t.type,
                        k = this.w,
                        S = new w(this.ctx);
                    n || (n = this.barOptions.distributed ? k.globals.stroke.colors[l] : k.globals.stroke.colors[e]), k.config.series[r].data[l] && k.config.series[r].data[l].strokeColor && (n = k.config.series[r].data[l].strokeColor), this.isNullValue && (i = "none");
                    var A = l / k.config.chart.animations.animateGradually.delay * (k.config.chart.animations.speed / k.globals.dataPoints) / 2.4,
                        M = S.renderPaths({
                            i: r,
                            j: l,
                            realIndex: e,
                            pathFrom: a,
                            pathTo: o,
                            stroke: n,
                            strokeWidth: s,
                            strokeLineCap: k.config.stroke.lineCap,
                            fill: i,
                            animationDelay: A,
                            initialSpeed: k.config.chart.animations.speed,
                            dataChangeSpeed: k.config.chart.animations.dynamicAnimation.speed,
                            className: "apexcharts-".concat(_, "-area")
                        });
                    M.attr("clip-path", "url(#gridRectMask".concat(k.globals.cuid, ")")), void 0 !== d && void 0 !== f && (M.attr("data-range-y1", d), M.attr("data-range-y2", f)), new x(this.ctx).setSelectionFilter(M, e, l), c.add(M);
                    var C = new I(this).handleBarDataLabels({
                        x: u,
                        y: h,
                        y1: d,
                        y2: f,
                        i: r,
                        j: l,
                        series: p,
                        realIndex: e,
                        barHeight: g,
                        barWidth: m,
                        barYPosition: v,
                        renderedPath: M,
                        visibleSeries: b
                    });
                    return null !== C && y.add(C), c.add(y), c
                }
            }, {
                key: "drawBarPaths",
                value: function (t) {
                    var e = t.indexes,
                        i = t.barHeight,
                        n = t.strokeWidth,
                        l = t.zeroW,
                        r = t.x,
                        a = t.y,
                        o = t.yDivision,
                        s = t.elSeries,
                        c = this.w,
                        u = e.i,
                        h = e.j;
                    c.globals.isXNumeric && (a = (c.globals.seriesX[u][h] - c.globals.minX) / this.invertedXRatio - i);
                    var d = a + i * this.visibleI;
                    r = void 0 === this.series[u][h] || null === this.series[u][h] ? l : l + this.series[u][h] / this.invertedYRatio - 2 * (this.isReversed ? this.series[u][h] / this.invertedYRatio : 0);
                    var f = this.barHelpers.getBarpaths({
                        barYPosition: d,
                        barHeight: i,
                        x1: l,
                        x2: r,
                        strokeWidth: n,
                        series: this.series,
                        realIndex: e.realIndex,
                        i: u,
                        j: h,
                        w: c
                    });
                    return c.globals.isXNumeric || (a += o), this.barHelpers.barBackground({
                        j: h,
                        i: u,
                        y1: d - i * this.visibleI,
                        y2: i * this.seriesLen,
                        elSeries: s
                    }), {
                        pathTo: f.pathTo,
                        pathFrom: f.pathFrom,
                        x: r,
                        y: a,
                        barYPosition: d
                    }
                }
            }, {
                key: "drawColumnPaths",
                value: function (t) {
                    var e = t.indexes,
                        i = t.x,
                        n = t.y,
                        l = t.xDivision,
                        r = t.barWidth,
                        a = t.zeroH,
                        o = t.strokeWidth,
                        s = t.elSeries,
                        c = this.w,
                        u = e.realIndex,
                        h = e.i,
                        d = e.j,
                        f = e.bc;
                    if (c.globals.isXNumeric) {
                        var p = u;
                        c.globals.seriesX[u].length || (p = c.globals.maxValsInArrayIndex), i = (c.globals.seriesX[p][d] - c.globals.minX) / this.xRatio - r * this.seriesLen / 2
                    }
                    var g = i + r * this.visibleI;
                    n = void 0 === this.series[h][d] || null === this.series[h][d] ? a : a - this.series[h][d] / this.yRatio[this.yaxisIndex] + 2 * (this.isReversed ? this.series[h][d] / this.yRatio[this.yaxisIndex] : 0);
                    var m = this.barHelpers.getColumnPaths({
                        barXPosition: g,
                        barWidth: r,
                        y1: a,
                        y2: n,
                        strokeWidth: o,
                        series: this.series,
                        realIndex: e.realIndex,
                        i: h,
                        j: d,
                        w: c
                    });
                    return c.globals.isXNumeric || (i += l), this.barHelpers.barBackground({
                        bc: f,
                        j: d,
                        i: h,
                        x1: g - o / 2 - r * this.visibleI,
                        x2: r * this.seriesLen + o / 2,
                        elSeries: s
                    }), {
                        pathTo: m.pathTo,
                        pathFrom: m.pathFrom,
                        x: i,
                        y: n,
                        barXPosition: g
                    }
                }
            }, {
                key: "getPreviousPath",
                value: function (t, e) {
                    for (var i, n = this.w, l = 0; l < n.globals.previousPaths.length; l++) {
                        var r = n.globals.previousPaths[l];
                        r.paths && r.paths.length > 0 && parseInt(r.realIndex, 10) === parseInt(t, 10) && void 0 !== n.globals.previousPaths[l].paths[e] && (i = n.globals.previousPaths[l].paths[e].d)
                    }
                    return i
                }
            }]), t
        }(),
        F = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.months31 = [1, 3, 5, 7, 8, 10, 12], this.months30 = [2, 4, 6, 9, 11], this.daysCntOfYear = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334]
            }
            return o(t, [{
                key: "isValidDate",
                value: function (t) {
                    return !isNaN(this.parseDate(t))
                }
            }, {
                key: "getTimeStamp",
                value: function (t) {
                    return Date.parse(t) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toISOString().substr(0, 25)).getTime() : new Date(t).getTime() : t
                }
            }, {
                key: "getDate",
                value: function (t) {
                    return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toUTCString()) : new Date(t)
                }
            }, {
                key: "parseDate",
                value: function (t) {
                    var e = Date.parse(t);
                    if (!isNaN(e)) return this.getTimeStamp(t);
                    var i = Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                    return this.getTimeStamp(i)
                }
            }, {
                key: "parseDateWithTimezone",
                value: function (t) {
                    return Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "))
                }
            }, {
                key: "formatDate",
                value: function (t, e) {
                    var i = this.w.globals.locale,
                        n = this.w.config.xaxis.labels.datetimeUTC,
                        l = ["\0"].concat(m(i.months)),
                        r = [""].concat(m(i.shortMonths)),
                        a = [""].concat(m(i.days)),
                        o = [""].concat(m(i.shortDays));

                    function s(t, e) {
                        var i = t + "";
                        for (e = e || 2; i.length < e;) i = "0" + i;
                        return i
                    }
                    var c = n ? t.getUTCFullYear() : t.getFullYear();
                    e = (e = (e = e.replace(/(^|[^\\])yyyy+/g, "$1" + c)).replace(/(^|[^\\])yy/g, "$1" + c.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + c);
                    var u = (n ? t.getUTCMonth() : t.getMonth()) + 1;
                    e = (e = (e = (e = e.replace(/(^|[^\\])MMMM+/g, "$1" + l[0])).replace(/(^|[^\\])MMM/g, "$1" + r[0])).replace(/(^|[^\\])MM/g, "$1" + s(u))).replace(/(^|[^\\])M/g, "$1" + u);
                    var h = n ? t.getUTCDate() : t.getDate();
                    e = (e = (e = (e = e.replace(/(^|[^\\])dddd+/g, "$1" + a[0])).replace(/(^|[^\\])ddd/g, "$1" + o[0])).replace(/(^|[^\\])dd/g, "$1" + s(h))).replace(/(^|[^\\])d/g, "$1" + h);
                    var d = n ? t.getUTCHours() : t.getHours(),
                        f = d > 12 ? d - 12 : 0 === d ? 12 : d;
                    e = (e = (e = (e = e.replace(/(^|[^\\])HH+/g, "$1" + s(d))).replace(/(^|[^\\])H/g, "$1" + d)).replace(/(^|[^\\])hh+/g, "$1" + s(f))).replace(/(^|[^\\])h/g, "$1" + f);
                    var p = n ? t.getUTCMinutes() : t.getMinutes();
                    e = (e = e.replace(/(^|[^\\])mm+/g, "$1" + s(p))).replace(/(^|[^\\])m/g, "$1" + p);
                    var g = n ? t.getUTCSeconds() : t.getSeconds();
                    e = (e = e.replace(/(^|[^\\])ss+/g, "$1" + s(g))).replace(/(^|[^\\])s/g, "$1" + g);
                    var v = n ? t.getUTCMilliseconds() : t.getMilliseconds();
                    e = e.replace(/(^|[^\\])fff+/g, "$1" + s(v, 3)), v = Math.round(v / 10), e = e.replace(/(^|[^\\])ff/g, "$1" + s(v)), v = Math.round(v / 10);
                    var y = d < 12 ? "AM" : "PM";
                    e = (e = (e = e.replace(/(^|[^\\])f/g, "$1" + v)).replace(/(^|[^\\])TT+/g, "$1" + y)).replace(/(^|[^\\])T/g, "$1" + y.charAt(0));
                    var b = y.toLowerCase();
                    e = (e = e.replace(/(^|[^\\])tt+/g, "$1" + b)).replace(/(^|[^\\])t/g, "$1" + b.charAt(0));
                    var x = -t.getTimezoneOffset(),
                        w = n || !x ? "Z" : x > 0 ? "+" : "-";
                    if (!n) {
                        var _ = (x = Math.abs(x)) % 60;
                        w += s(Math.floor(x / 60)) + ":" + s(_)
                    }
                    e = e.replace(/(^|[^\\])K/g, "$1" + w);
                    var k = (n ? t.getUTCDay() : t.getDay()) + 1;
                    return (e = (e = (e = (e = e.replace(new RegExp(a[0], "g"), a[k])).replace(new RegExp(o[0], "g"), o[k])).replace(new RegExp(l[0], "g"), l[u])).replace(new RegExp(r[0], "g"), r[u])).replace(/\\(.)/g, "$1")
                }
            }, {
                key: "getTimeUnitsfromTimestamp",
                value: function (t, e, i) {
                    var n = this.w;
                    void 0 !== n.config.xaxis.min && (t = n.config.xaxis.min), void 0 !== n.config.xaxis.max && (e = n.config.xaxis.max);
                    var l = this.getDate(t),
                        r = this.getDate(e),
                        a = this.formatDate(l, "yyyy MM dd HH mm ss fff").split(" "),
                        o = this.formatDate(r, "yyyy MM dd HH mm ss fff").split(" ");
                    return {
                        minMillisecond: parseInt(a[6], 10),
                        maxMillisecond: parseInt(o[6], 10),
                        minSecond: parseInt(a[5], 10),
                        maxSecond: parseInt(o[5], 10),
                        minMinute: parseInt(a[4], 10),
                        maxMinute: parseInt(o[4], 10),
                        minHour: parseInt(a[3], 10),
                        maxHour: parseInt(o[3], 10),
                        minDate: parseInt(a[2], 10),
                        maxDate: parseInt(o[2], 10),
                        minMonth: parseInt(a[1], 10) - 1,
                        maxMonth: parseInt(o[1], 10) - 1,
                        minYear: parseInt(a[0], 10),
                        maxYear: parseInt(o[0], 10)
                    }
                }
            }, {
                key: "isLeapYear",
                value: function (t) {
                    return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
                }
            }, {
                key: "calculcateLastDaysOfMonth",
                value: function (t, e, i) {
                    return this.determineDaysOfMonths(t, e) - i
                }
            }, {
                key: "determineDaysOfYear",
                value: function (t) {
                    var e = 365;
                    return this.isLeapYear(t) && (e = 366), e
                }
            }, {
                key: "determineRemainingDaysOfYear",
                value: function (t, e, i) {
                    var n = this.daysCntOfYear[e] + i;
                    return e > 1 && this.isLeapYear() && n++, n
                }
            }, {
                key: "determineDaysOfMonths",
                value: function (t, e) {
                    var i = 30;
                    switch (t = y.monthMod(t), !0) {
                        case this.months30.indexOf(t) > -1:
                            2 === t && (i = this.isLeapYear(e) ? 29 : 28);
                            break;
                        case this.months31.indexOf(t) > -1:
                        default:
                            i = 31
                    }
                    return i
                }
            }]), t
        }(),
        z = function (t) {
            h(i, R);
            var e = g(i);

            function i() {
                return r(this, i), e.apply(this, arguments)
            }
            return o(i, [{
                key: "draw",
                value: function (t, e) {
                    var i = this.w,
                        n = new w(this.ctx);
                    this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = t, this.seriesRangeStart = i.globals.seriesRangeStart, this.seriesRangeEnd = i.globals.seriesRangeEnd, this.barHelpers.initVariables(t);
                    for (var l = n.group({
                            class: "apexcharts-rangebar-series apexcharts-plot-series"
                        }), r = 0; r < t.length; r++) {
                        var a, o, s, c = void 0,
                            h = void 0,
                            d = void 0,
                            f = i.globals.comboCharts ? e[r] : r,
                            p = n.group({
                                class: "apexcharts-series",
                                seriesName: y.escapeString(i.globals.seriesNames[f]),
                                rel: r + 1,
                                "data:realIndex": f
                            });
                        t[r].length > 0 && (this.visibleI = this.visibleI + 1);
                        var g = 0,
                            m = 0;
                        this.yRatio.length > 1 && (this.yaxisIndex = f);
                        var v = this.barHelpers.initialPositions();
                        h = v.y, s = v.zeroW, c = v.x, m = v.barWidth, a = v.xDivision, o = v.zeroH;
                        for (var b = n.group({
                                class: "apexcharts-datalabels",
                                "data:realIndex": f
                            }), x = 0; x < i.globals.dataPoints; x++) {
                            var _ = this.barHelpers.getStrokeWidth(r, x, f),
                                k = this.seriesRangeStart[r][x],
                                S = this.seriesRangeEnd[r][x],
                                A = null,
                                M = null,
                                C = {
                                    x: c,
                                    y: h,
                                    strokeWidth: _,
                                    elSeries: p
                                };
                            if (d = v.yDivision, g = v.barHeight, this.isHorizontal) {
                                M = h + g * this.visibleI;
                                var E = this.seriesLen;
                                i.config.plotOptions.bar.rangeBarGroupRows && (E = 1);
                                var O = (d - g * E) / 2;
                                if (void 0 === i.config.series[r].data[x]) break;
                                if (this.isTimelineBar && i.config.series[r].data[x].x) {
                                    var T = this.detectOverlappingBars({
                                        i: r,
                                        j: x,
                                        barYPosition: M,
                                        srty: O,
                                        barHeight: g,
                                        yDivision: d,
                                        initPositions: v
                                    });
                                    g = T.barHeight, M = T.barYPosition
                                }
                                m = (A = this.drawRangeBarPaths(u({
                                    indexes: {
                                        i: r,
                                        j: x,
                                        realIndex: f
                                    },
                                    barHeight: g,
                                    barYPosition: M,
                                    zeroW: s,
                                    yDivision: d,
                                    y1: k,
                                    y2: S
                                }, C))).barWidth
                            } else g = (A = this.drawRangeColumnPaths(u({
                                indexes: {
                                    i: r,
                                    j: x,
                                    realIndex: f
                                },
                                zeroH: o,
                                barWidth: m,
                                xDivision: a
                            }, C))).barHeight;
                            h = A.y, c = A.x;
                            var P = this.barHelpers.getPathFillColor(t, r, x, f),
                                L = i.globals.stroke.colors[f];
                            this.renderSeries({
                                realIndex: f,
                                pathFill: P,
                                lineFill: L,
                                j: x,
                                i: r,
                                x: c,
                                y: h,
                                y1: k,
                                y2: S,
                                pathFrom: A.pathFrom,
                                pathTo: A.pathTo,
                                strokeWidth: _,
                                elSeries: p,
                                series: t,
                                barHeight: g,
                                barYPosition: M,
                                barWidth: m,
                                elDataLabelsWrap: b,
                                visibleSeries: this.visibleI,
                                type: "rangebar"
                            })
                        }
                        l.add(p)
                    }
                    return l
                }
            }, {
                key: "detectOverlappingBars",
                value: function (t) {
                    var e = t.i,
                        i = t.j,
                        n = t.barYPosition,
                        l = t.srty,
                        r = t.barHeight,
                        a = t.yDivision,
                        o = t.initPositions,
                        s = this.w,
                        c = [],
                        u = s.config.series[e].data[i].rangeName,
                        h = s.config.series[e].data[i].x,
                        d = s.globals.labels.indexOf(h),
                        f = s.globals.seriesRangeBarTimeline[e].findIndex((function (t) {
                            return t.x === h && t.overlaps.length > 0
                        }));
                    return n = s.config.plotOptions.bar.rangeBarGroupRows ? l + a * d : l + r * this.visibleI + a * d, f > -1 && !s.config.plotOptions.bar.rangeBarOverlap && (c = s.globals.seriesRangeBarTimeline[e][f].overlaps).indexOf(u) > -1 && (n = (r = o.barHeight / c.length) * this.visibleI + a * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + r * (this.visibleI + c.indexOf(u)) + a * d), {
                        barYPosition: n,
                        barHeight: r
                    }
                }
            }, {
                key: "drawRangeColumnPaths",
                value: function (t) {
                    var e = t.indexes,
                        i = t.x,
                        n = (t.strokeWidth, t.xDivision),
                        l = t.barWidth,
                        r = t.zeroH,
                        a = this.w,
                        o = e.i,
                        s = e.j,
                        c = this.yRatio[this.yaxisIndex],
                        u = e.realIndex,
                        h = this.getRangeValue(u, s),
                        d = Math.min(h.start, h.end),
                        f = Math.max(h.start, h.end);
                    a.globals.isXNumeric && (i = (a.globals.seriesX[o][s] - a.globals.minX) / this.xRatio - l / 2);
                    var p = i + l * this.visibleI;
                    void 0 === this.series[o][s] || null === this.series[o][s] ? d = r : (d = r - d / c, f = r - f / c);
                    var g = Math.abs(f - d),
                        m = this.barHelpers.getColumnPaths({
                            barXPosition: p,
                            barWidth: l,
                            y1: d,
                            y2: f,
                            strokeWidth: this.strokeWidth,
                            series: this.seriesRangeEnd,
                            realIndex: e.realIndex,
                            i: u,
                            j: s,
                            w: a
                        });
                    return a.globals.isXNumeric || (i += n), {
                        pathTo: m.pathTo,
                        pathFrom: m.pathFrom,
                        barHeight: g,
                        x: i,
                        y: f,
                        barXPosition: p
                    }
                }
            }, {
                key: "drawRangeBarPaths",
                value: function (t) {
                    var e = t.indexes,
                        i = t.y,
                        n = t.y1,
                        l = t.y2,
                        r = t.yDivision,
                        a = t.barHeight,
                        o = t.barYPosition,
                        s = t.zeroW,
                        c = this.w,
                        u = s + n / this.invertedYRatio,
                        h = s + l / this.invertedYRatio,
                        d = Math.abs(h - u),
                        f = this.barHelpers.getBarpaths({
                            barYPosition: o,
                            barHeight: a,
                            x1: u,
                            x2: h,
                            strokeWidth: this.strokeWidth,
                            series: this.seriesRangeEnd,
                            i: e.realIndex,
                            realIndex: e.realIndex,
                            j: e.j,
                            w: c
                        });
                    return c.globals.isXNumeric || (i += r), {
                        pathTo: f.pathTo,
                        pathFrom: f.pathFrom,
                        barWidth: d,
                        x: h,
                        y: i
                    }
                }
            }, {
                key: "getRangeValue",
                value: function (t, e) {
                    var i = this.w;
                    return {
                        start: i.globals.seriesRangeStart[t][e],
                        end: i.globals.seriesRangeEnd[t][e]
                    }
                }
            }, {
                key: "getTooltipValues",
                value: function (t) {
                    var e = t.ctx,
                        i = t.seriesIndex,
                        n = t.dataPointIndex,
                        l = t.y1,
                        r = t.y2,
                        a = t.w,
                        o = a.globals.seriesRangeStart[i][n],
                        s = a.globals.seriesRangeEnd[i][n],
                        c = a.globals.labels[n],
                        u = a.config.series[i].name ? a.config.series[i].name : "",
                        h = a.config.tooltip.y.formatter,
                        d = a.config.tooltip.y.title.formatter,
                        f = {
                            w: a,
                            seriesIndex: i,
                            dataPointIndex: n,
                            start: o,
                            end: s
                        };
                    "function" == typeof d && (u = d(u, f)), Number.isFinite(l) && Number.isFinite(r) && (o = l, s = r, a.config.series[i].data[n].x && (c = a.config.series[i].data[n].x + ":"), "function" == typeof h && (c = h(c, f)));
                    var p = "",
                        g = "",
                        m = a.globals.colors[i];
                    if (void 0 === a.config.tooltip.x.formatter)
                        if ("datetime" === a.config.xaxis.type) {
                            var v = new F(e);
                            p = v.formatDate(v.getDate(o), a.config.tooltip.x.format), g = v.formatDate(v.getDate(s), a.config.tooltip.x.format)
                        } else p = o, g = s;
                    else p = a.config.tooltip.x.formatter(o), g = a.config.tooltip.x.formatter(s);
                    return {
                        start: o,
                        end: s,
                        startVal: p,
                        endVal: g,
                        ylabel: c,
                        color: m,
                        seriesName: u
                    }
                }
            }, {
                key: "buildCustomTooltipHTML",
                value: function (t) {
                    return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + t.color + '">' + (t.seriesName || "") + '</span></div><div> <span class="category">' + t.ylabel + ' </span> <span class="value start-value">' + t.start + '</span> <span class="separator">-</span> <span class="value end-value">' + t.end + "</span></div></div>"
                }
            }]), i
        }(),
        H = function () {
            function t(e) {
                r(this, t), this.opts = e
            }
            return o(t, [{
                key: "line",
                value: function () {
                    return {
                        chart: {
                            animations: {
                                easing: "swing"
                            }
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        stroke: {
                            width: 5,
                            curve: "straight"
                        },
                        markers: {
                            size: 0,
                            hover: {
                                sizeOffset: 6
                            }
                        },
                        xaxis: {
                            crosshairs: {
                                width: 1
                            }
                        }
                    }
                }
            }, {
                key: "sparkline",
                value: function (t) {
                    return this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0, y.extend(t, {
                        grid: {
                            show: !1,
                            padding: {
                                left: 0,
                                right: 0,
                                top: 0,
                                bottom: 0
                            }
                        },
                        legend: {
                            show: !1
                        },
                        xaxis: {
                            labels: {
                                show: !1
                            },
                            tooltip: {
                                enabled: !1
                            },
                            axisBorder: {
                                show: !1
                            },
                            axisTicks: {
                                show: !1
                            }
                        },
                        chart: {
                            toolbar: {
                                show: !1
                            },
                            zoom: {
                                enabled: !1
                            }
                        },
                        dataLabels: {
                            enabled: !1
                        }
                    })
                }
            }, {
                key: "bar",
                value: function () {
                    return {
                        chart: {
                            stacked: !1,
                            animations: {
                                easing: "swing"
                            }
                        },
                        plotOptions: {
                            bar: {
                                dataLabels: {
                                    position: "center"
                                }
                            }
                        },
                        dataLabels: {
                            style: {
                                colors: ["#fff"]
                            },
                            background: {
                                enabled: !1
                            }
                        },
                        stroke: {
                            width: 0,
                            lineCap: "round"
                        },
                        fill: {
                            opacity: .85
                        },
                        legend: {
                            markers: {
                                shape: "square",
                                radius: 2,
                                size: 8
                            }
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0
                        },
                        xaxis: {
                            tooltip: {
                                enabled: !1
                            },
                            tickPlacement: "between",
                            crosshairs: {
                                width: "barWidth",
                                position: "back",
                                fill: {
                                    type: "gradient"
                                },
                                dropShadow: {
                                    enabled: !1
                                },
                                stroke: {
                                    width: 0
                                }
                            }
                        }
                    }
                }
            }, {
                key: "candlestick",
                value: function () {
                    var t = this;
                    return {
                        stroke: {
                            width: 1,
                            colors: ["#333"]
                        },
                        fill: {
                            opacity: 1
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        tooltip: {
                            shared: !0,
                            custom: function (e) {
                                var i = e.seriesIndex,
                                    n = e.dataPointIndex,
                                    l = e.w;
                                return t._getBoxTooltip(l, i, n, ["Open", "High", "", "Low", "Close"], "candlestick")
                            }
                        },
                        states: {
                            active: {
                                filter: {
                                    type: "none"
                                }
                            }
                        },
                        xaxis: {
                            crosshairs: {
                                width: 1
                            }
                        }
                    }
                }
            }, {
                key: "boxPlot",
                value: function () {
                    var t = this;
                    return {
                        chart: {
                            animations: {
                                dynamicAnimation: {
                                    enabled: !1
                                }
                            }
                        },
                        stroke: {
                            width: 1,
                            colors: ["#24292e"]
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        tooltip: {
                            shared: !0,
                            custom: function (e) {
                                var i = e.seriesIndex,
                                    n = e.dataPointIndex,
                                    l = e.w;
                                return t._getBoxTooltip(l, i, n, ["Minimum", "Q1", "Median", "Q3", "Maximum"], "boxPlot")
                            }
                        },
                        markers: {
                            size: 5,
                            strokeWidth: 1,
                            strokeColors: "#111"
                        },
                        xaxis: {
                            crosshairs: {
                                width: 1
                            }
                        }
                    }
                }
            }, {
                key: "rangeBar",
                value: function () {
                    return {
                        stroke: {
                            width: 0,
                            lineCap: "square"
                        },
                        plotOptions: {
                            bar: {
                                borderRadius: 0,
                                dataLabels: {
                                    position: "center"
                                }
                            }
                        },
                        dataLabels: {
                            enabled: !1,
                            formatter: function (t, e) {
                                e.ctx;
                                var i = e.seriesIndex,
                                    n = e.dataPointIndex,
                                    l = e.w,
                                    r = l.globals.seriesRangeStart[i][n];
                                return l.globals.seriesRangeEnd[i][n] - r
                            },
                            background: {
                                enabled: !1
                            },
                            style: {
                                colors: ["#fff"]
                            }
                        },
                        tooltip: {
                            shared: !1,
                            followCursor: !0,
                            custom: function (t) {
                                return t.w.config.plotOptions && t.w.config.plotOptions.bar && t.w.config.plotOptions.bar.horizontal ? function (t) {
                                    var e = new z(t.ctx, null),
                                        i = e.getTooltipValues(t),
                                        n = i.color,
                                        l = i.seriesName,
                                        r = i.ylabel,
                                        a = i.startVal,
                                        o = i.endVal;
                                    return e.buildCustomTooltipHTML({
                                        color: n,
                                        seriesName: l,
                                        ylabel: r,
                                        start: a,
                                        end: o
                                    })
                                }(t) : function (t) {
                                    var e = new z(t.ctx, null),
                                        i = e.getTooltipValues(t),
                                        n = i.color,
                                        l = i.seriesName,
                                        r = i.ylabel,
                                        a = i.start,
                                        o = i.end;
                                    return e.buildCustomTooltipHTML({
                                        color: n,
                                        seriesName: l,
                                        ylabel: r,
                                        start: a,
                                        end: o
                                    })
                                }(t)
                            }
                        },
                        xaxis: {
                            tickPlacement: "between",
                            tooltip: {
                                enabled: !1
                            },
                            crosshairs: {
                                stroke: {
                                    width: 0
                                }
                            }
                        }
                    }
                }
            }, {
                key: "area",
                value: function () {
                    return {
                        stroke: {
                            width: 4
                        },
                        fill: {
                            type: "gradient",
                            gradient: {
                                inverseColors: !1,
                                shade: "light",
                                type: "vertical",
                                opacityFrom: .65,
                                opacityTo: .5,
                                stops: [0, 100, 100]
                            }
                        },
                        markers: {
                            size: 0,
                            hover: {
                                sizeOffset: 6
                            }
                        },
                        tooltip: {
                            followCursor: !1
                        }
                    }
                }
            }, {
                key: "brush",
                value: function (t) {
                    return y.extend(t, {
                        chart: {
                            toolbar: {
                                autoSelected: "selection",
                                show: !1
                            },
                            zoom: {
                                enabled: !1
                            }
                        },
                        dataLabels: {
                            enabled: !1
                        },
                        stroke: {
                            width: 1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        xaxis: {
                            tooltip: {
                                enabled: !1
                            }
                        }
                    })
                }
            }, {
                key: "stacked100",
                value: function (t) {
                    t.dataLabels = t.dataLabels || {}, t.dataLabels.formatter = t.dataLabels.formatter || void 0;
                    var e = t.dataLabels.formatter;
                    return t.yaxis.forEach((function (e, i) {
                        t.yaxis[i].min = 0, t.yaxis[i].max = 100
                    })), "bar" === t.chart.type && (t.dataLabels.formatter = e || function (t) {
                        return "number" == typeof t && t ? t.toFixed(0) + "%" : t
                    }), t
                }
            }, {
                key: "convertCatToNumeric",
                value: function (t) {
                    return t.xaxis.convertedCatToNumeric = !0, t
                }
            }, {
                key: "convertCatToNumericXaxis",
                value: function (t, e, i) {
                    t.xaxis.type = "numeric", t.xaxis.labels = t.xaxis.labels || {}, t.xaxis.labels.formatter = t.xaxis.labels.formatter || function (t) {
                        return y.isNumber(t) ? Math.floor(t) : t
                    };
                    var n = t.xaxis.labels.formatter,
                        l = t.xaxis.categories && t.xaxis.categories.length ? t.xaxis.categories : t.labels;
                    return i && i.length && (l = i.map((function (t) {
                        return Array.isArray(t) ? t : String(t)
                    }))), l && l.length && (t.xaxis.labels.formatter = function (t) {
                        return y.isNumber(t) ? n(l[Math.floor(t) - 1]) : n(t)
                    }), t.xaxis.categories = [], t.labels = [], t.xaxis.tickAmount = t.xaxis.tickAmount || "dataPoints", t
                }
            }, {
                key: "bubble",
                value: function () {
                    return {
                        dataLabels: {
                            style: {
                                colors: ["#fff"]
                            }
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0
                        },
                        xaxis: {
                            crosshairs: {
                                width: 0
                            }
                        },
                        fill: {
                            type: "solid",
                            gradient: {
                                shade: "light",
                                inverse: !0,
                                shadeIntensity: .55,
                                opacityFrom: .4,
                                opacityTo: .8
                            }
                        }
                    }
                }
            }, {
                key: "scatter",
                value: function () {
                    return {
                        dataLabels: {
                            enabled: !1
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0
                        },
                        markers: {
                            size: 6,
                            strokeWidth: 1,
                            hover: {
                                sizeOffset: 2
                            }
                        }
                    }
                }
            }, {
                key: "heatmap",
                value: function () {
                    return {
                        chart: {
                            stacked: !1
                        },
                        fill: {
                            opacity: 1
                        },
                        dataLabels: {
                            style: {
                                colors: ["#fff"]
                            }
                        },
                        stroke: {
                            colors: ["#fff"]
                        },
                        tooltip: {
                            followCursor: !0,
                            marker: {
                                show: !1
                            },
                            x: {
                                show: !1
                            }
                        },
                        legend: {
                            position: "top",
                            markers: {
                                shape: "square",
                                size: 10,
                                offsetY: 2
                            }
                        },
                        grid: {
                            padding: {
                                right: 20
                            }
                        }
                    }
                }
            }, {
                key: "treemap",
                value: function () {
                    return {
                        chart: {
                            zoom: {
                                enabled: !1
                            }
                        },
                        dataLabels: {
                            style: {
                                fontSize: 14,
                                fontWeight: 600,
                                colors: ["#fff"]
                            }
                        },
                        stroke: {
                            show: !0,
                            width: 2,
                            colors: ["#fff"]
                        },
                        legend: {
                            show: !1
                        },
                        fill: {
                            gradient: {
                                stops: [0, 100]
                            }
                        },
                        tooltip: {
                            followCursor: !0,
                            x: {
                                show: !1
                            }
                        },
                        grid: {
                            padding: {
                                left: 0,
                                right: 0
                            }
                        },
                        xaxis: {
                            crosshairs: {
                                show: !1
                            },
                            tooltip: {
                                enabled: !1
                            }
                        }
                    }
                }
            }, {
                key: "pie",
                value: function () {
                    return {
                        chart: {
                            toolbar: {
                                show: !1
                            }
                        },
                        plotOptions: {
                            pie: {
                                donut: {
                                    labels: {
                                        show: !1
                                    }
                                }
                            }
                        },
                        dataLabels: {
                            formatter: function (t) {
                                return t.toFixed(1) + "%"
                            },
                            style: {
                                colors: ["#fff"]
                            },
                            background: {
                                enabled: !1
                            },
                            dropShadow: {
                                enabled: !0
                            }
                        },
                        stroke: {
                            colors: ["#fff"]
                        },
                        fill: {
                            opacity: 1,
                            gradient: {
                                shade: "light",
                                stops: [0, 100]
                            }
                        },
                        tooltip: {
                            theme: "dark",
                            fillSeriesColor: !0
                        },
                        legend: {
                            position: "right"
                        }
                    }
                }
            }, {
                key: "donut",
                value: function () {
                    return {
                        chart: {
                            toolbar: {
                                show: !1
                            }
                        },
                        dataLabels: {
                            formatter: function (t) {
                                return t.toFixed(1) + "%"
                            },
                            style: {
                                colors: ["#fff"]
                            },
                            background: {
                                enabled: !1
                            },
                            dropShadow: {
                                enabled: !0
                            }
                        },
                        stroke: {
                            colors: ["#fff"]
                        },
                        fill: {
                            opacity: 1,
                            gradient: {
                                shade: "light",
                                shadeIntensity: .35,
                                stops: [80, 100],
                                opacityFrom: 1,
                                opacityTo: 1
                            }
                        },
                        tooltip: {
                            theme: "dark",
                            fillSeriesColor: !0
                        },
                        legend: {
                            position: "right"
                        }
                    }
                }
            }, {
                key: "polarArea",
                value: function () {
                    return this.opts.yaxis[0].tickAmount = this.opts.yaxis[0].tickAmount ? this.opts.yaxis[0].tickAmount : 6, {
                        chart: {
                            toolbar: {
                                show: !1
                            }
                        },
                        dataLabels: {
                            formatter: function (t) {
                                return t.toFixed(1) + "%"
                            },
                            enabled: !1
                        },
                        stroke: {
                            show: !0,
                            width: 2
                        },
                        fill: {
                            opacity: .7
                        },
                        tooltip: {
                            theme: "dark",
                            fillSeriesColor: !0
                        },
                        legend: {
                            position: "right"
                        }
                    }
                }
            }, {
                key: "radar",
                value: function () {
                    return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, {
                        dataLabels: {
                            enabled: !1,
                            style: {
                                fontSize: "11px"
                            }
                        },
                        stroke: {
                            width: 2
                        },
                        markers: {
                            size: 3,
                            strokeWidth: 1,
                            strokeOpacity: 1
                        },
                        fill: {
                            opacity: .2
                        },
                        tooltip: {
                            shared: !1,
                            intersect: !0,
                            followCursor: !0
                        },
                        grid: {
                            show: !1
                        },
                        xaxis: {
                            labels: {
                                formatter: function (t) {
                                    return t
                                },
                                style: {
                                    colors: ["#a8a8a8"],
                                    fontSize: "11px"
                                }
                            },
                            tooltip: {
                                enabled: !1
                            },
                            crosshairs: {
                                show: !1
                            }
                        }
                    }
                }
            }, {
                key: "radialBar",
                value: function () {
                    return {
                        chart: {
                            animations: {
                                dynamicAnimation: {
                                    enabled: !0,
                                    speed: 800
                                }
                            },
                            toolbar: {
                                show: !1
                            }
                        },
                        fill: {
                            gradient: {
                                shade: "dark",
                                shadeIntensity: .4,
                                inverseColors: !1,
                                type: "diagonal2",
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [70, 98, 100]
                            }
                        },
                        legend: {
                            show: !1,
                            position: "right"
                        },
                        tooltip: {
                            enabled: !1,
                            fillSeriesColor: !0
                        }
                    }
                }
            }, {
                key: "_getBoxTooltip",
                value: function (t, e, i, n, l) {
                    var r = t.globals.seriesCandleO[e][i],
                        a = t.globals.seriesCandleH[e][i],
                        o = t.globals.seriesCandleM[e][i],
                        s = t.globals.seriesCandleL[e][i],
                        c = t.globals.seriesCandleC[e][i];
                    return t.config.series[e].type && t.config.series[e].type !== l ? '<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name ? t.config.series[e].name : "series-" + (e + 1), ": <strong>").concat(t.globals.series[e][i], "</strong>\n        </div>") : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type, '">') + "<div>".concat(n[0], ': <span class="value">') + r + "</span></div>" + "<div>".concat(n[1], ': <span class="value">') + a + "</span></div>" + (o ? "<div>".concat(n[2], ': <span class="value">') + o + "</span></div>" : "") + "<div>".concat(n[3], ': <span class="value">') + s + "</span></div>" + "<div>".concat(n[4], ': <span class="value">') + c + "</span></div></div>"
                }
            }]), t
        }(),
        B = function () {
            function t(e) {
                r(this, t), this.opts = e
            }
            return o(t, [{
                key: "init",
                value: function (t) {
                    var e = t.responsiveOverride,
                        i = this.opts,
                        n = new E,
                        r = new H(i);
                    this.chartType = i.chart.type, "histogram" === this.chartType && (i.chart.type = "bar", i = y.extend({
                        plotOptions: {
                            bar: {
                                columnWidth: "99.99%"
                            }
                        }
                    }, i)), i = this.extendYAxis(i), i = this.extendAnnotations(i);
                    var a = n.init(),
                        o = {};
                    if (i && "object" === l(i)) {
                        var s = {};
                        s = -1 !== ["line", "area", "bar", "candlestick", "boxPlot", "rangeBar", "histogram", "bubble", "scatter", "heatmap", "treemap", "pie", "polarArea", "donut", "radar", "radialBar"].indexOf(i.chart.type) ? r[i.chart.type]() : r.line(), i.chart.brush && i.chart.brush.enabled && (s = r.brush(s)), i.chart.stacked && "100%" === i.chart.stackType && (i = r.stacked100(i)), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(i), i.xaxis = i.xaxis || window.Apex.xaxis || {}, e || (i.xaxis.convertedCatToNumeric = !1), ((i = this.checkForCatToNumericXAxis(this.chartType, s, i)).chart.sparkline && i.chart.sparkline.enabled || window.Apex.chart && window.Apex.chart.sparkline && window.Apex.chart.sparkline.enabled) && (s = r.sparkline(s)), o = y.extend(a, s)
                    }
                    var c = y.extend(o, window.Apex);
                    return a = y.extend(c, i), this.handleUserInputErrors(a)
                }
            }, {
                key: "checkForCatToNumericXAxis",
                value: function (t, e, i) {
                    var n = new H(i),
                        l = "bar" === t && i.plotOptions && i.plotOptions.bar && i.plotOptions.bar.horizontal,
                        r = "pie" === t || "polarArea" === t || "donut" === t || "radar" === t || "radialBar" === t || "heatmap" === t,
                        a = "datetime" !== i.xaxis.type && "numeric" !== i.xaxis.type,
                        o = i.xaxis.tickPlacement ? i.xaxis.tickPlacement : e.xaxis && e.xaxis.tickPlacement;
                    return l || r || !a || "between" === o || (i = n.convertCatToNumeric(i)), i
                }
            }, {
                key: "extendYAxis",
                value: function (t, e) {
                    var i = new E;
                    (void 0 === t.yaxis || !t.yaxis || Array.isArray(t.yaxis) && 0 === t.yaxis.length) && (t.yaxis = {}), t.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (t.yaxis = y.extend(t.yaxis, window.Apex.yaxis)), t.yaxis.constructor !== Array ? t.yaxis = [y.extend(i.yAxis, t.yaxis)] : t.yaxis = y.extendArray(t.yaxis, i.yAxis);
                    var n = !1;
                    t.yaxis.forEach((function (t) {
                        t.logarithmic && (n = !0)
                    }));
                    var l = t.series;
                    return e && !l && (l = e.config.series), n && l.length !== t.yaxis.length && l.length && (t.yaxis = l.map((function (e, n) {
                        if (e.name || (l[n].name = "series-".concat(n + 1)), t.yaxis[n]) return t.yaxis[n].seriesName = l[n].name, t.yaxis[n];
                        var r = y.extend(i.yAxis, t.yaxis[0]);
                        return r.show = !1, r
                    }))), n && l.length > 1 && l.length !== t.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes. Please make sure to equalize both."), t
                }
            }, {
                key: "extendAnnotations",
                value: function (t) {
                    return void 0 === t.annotations && (t.annotations = {}, t.annotations.yaxis = [], t.annotations.xaxis = [], t.annotations.points = []), t = this.extendYAxisAnnotations(t), t = this.extendXAxisAnnotations(t), this.extendPointAnnotations(t)
                }
            }, {
                key: "extendYAxisAnnotations",
                value: function (t) {
                    var e = new E;
                    return t.annotations.yaxis = y.extendArray(void 0 !== t.annotations.yaxis ? t.annotations.yaxis : [], e.yAxisAnnotation), t
                }
            }, {
                key: "extendXAxisAnnotations",
                value: function (t) {
                    var e = new E;
                    return t.annotations.xaxis = y.extendArray(void 0 !== t.annotations.xaxis ? t.annotations.xaxis : [], e.xAxisAnnotation), t
                }
            }, {
                key: "extendPointAnnotations",
                value: function (t) {
                    var e = new E;
                    return t.annotations.points = y.extendArray(void 0 !== t.annotations.points ? t.annotations.points : [], e.pointAnnotation), t
                }
            }, {
                key: "checkForDarkTheme",
                value: function (t) {
                    t.theme && "dark" === t.theme.mode && (t.tooltip || (t.tooltip = {}), "light" !== t.tooltip.theme && (t.tooltip.theme = "dark"), t.chart.foreColor || (t.chart.foreColor = "#f6f7f8"), t.chart.background || (t.chart.background = "#424242"), t.theme.palette || (t.theme.palette = "palette4"))
                }
            }, {
                key: "handleUserInputErrors",
                value: function (t) {
                    var e = t;
                    if (e.tooltip.shared && e.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
                    if ("bar" === e.chart.type && e.plotOptions.bar.horizontal) {
                        if (e.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
                        e.yaxis[0].reversed && (e.yaxis[0].opposite = !0), e.xaxis.tooltip.enabled = !1, e.yaxis[0].tooltip.enabled = !1, e.chart.zoom.enabled = !1
                    }
                    return "bar" !== e.chart.type && "rangeBar" !== e.chart.type || e.tooltip.shared && "barWidth" === e.xaxis.crosshairs.width && e.series.length > 1 && (console.warn('crosshairs.width = "barWidth" is only supported in single series, not in a multi-series barChart.'), e.xaxis.crosshairs.width = "tickWidth"), "candlestick" !== e.chart.type && "boxPlot" !== e.chart.type || e.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(e.chart.type, " chart is not supported.")), e.yaxis[0].reversed = !1), e.chart.group && 0 === e.yaxis[0].labels.minWidth && console.warn("It looks like you have multiple charts in synchronization. You must provide yaxis.labels.minWidth which must be EQUAL for all grouped charts to prevent incorrect behaviour."), Array.isArray(e.stroke.width) && "line" !== e.chart.type && "area" !== e.chart.type && (console.warn("stroke.width option accepts array only for line and area charts. Reverted back to Number"), e.stroke.width = e.stroke.width[0]), e
                }
            }]), t
        }(),
        Y = function () {
            function t() {
                r(this, t)
            }
            return o(t, [{
                key: "initGlobalVars",
                value: function (t) {
                    t.series = [], t.seriesCandleO = [], t.seriesCandleH = [], t.seriesCandleM = [], t.seriesCandleL = [], t.seriesCandleC = [], t.seriesRangeStart = [], t.seriesRangeEnd = [], t.seriesRangeBarTimeline = [], t.seriesPercent = [], t.seriesX = [], t.seriesZ = [], t.seriesNames = [], t.seriesTotals = [], t.seriesLog = [], t.seriesColors = [], t.stackedSeriesTotals = [], t.seriesXvalues = [], t.seriesYvalues = [], t.labels = [], t.categoryLabels = [], t.timescaleLabels = [], t.noLabelsProvided = !1, t.resizeTimer = null, t.selectionResizeTimer = null, t.delayedElements = [], t.pointsArray = [], t.dataLabelsRects = [], t.isXNumeric = !1, t.xaxisLabelsCount = 0, t.skipLastTimelinelabel = !1, t.skipFirstTimelinelabel = !1, t.isDataXYZ = !1, t.isMultiLineX = !1, t.isMultipleYAxis = !1, t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE, t.minYArr = [], t.maxYArr = [], t.maxX = -Number.MAX_VALUE, t.minX = Number.MAX_VALUE, t.initialMaxX = -Number.MAX_VALUE, t.initialMinX = Number.MAX_VALUE, t.maxDate = 0, t.minDate = Number.MAX_VALUE, t.minZ = Number.MAX_VALUE, t.maxZ = -Number.MAX_VALUE, t.minXDiff = Number.MAX_VALUE, t.yAxisScale = [], t.xAxisScale = null, t.xAxisTicksPositions = [], t.yLabelsCoords = [], t.yTitleCoords = [], t.barPadForNumericAxis = 0, t.padHorizontal = 0, t.xRange = 0, t.yRange = [], t.zRange = 0, t.dataPoints = 0, t.xTickAmount = 0
                }
            }, {
                key: "globalVars",
                value: function (t) {
                    return {
                        chartID: null,
                        cuid: null,
                        events: {
                            beforeMount: [],
                            mounted: [],
                            updated: [],
                            clicked: [],
                            selection: [],
                            dataPointSelection: [],
                            zoomed: [],
                            scrolled: []
                        },
                        colors: [],
                        clientX: null,
                        clientY: null,
                        fill: {
                            colors: []
                        },
                        stroke: {
                            colors: []
                        },
                        dataLabels: {
                            style: {
                                colors: []
                            }
                        },
                        radarPolygons: {
                            fill: {
                                colors: []
                            }
                        },
                        markers: {
                            colors: [],
                            size: t.markers.size,
                            largestSize: 0
                        },
                        animationEnded: !1,
                        isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints,
                        isDirty: !1,
                        isExecCalled: !1,
                        initialConfig: null,
                        initialSeries: [],
                        lastXAxis: [],
                        lastYAxis: [],
                        columnSeries: null,
                        labels: [],
                        timescaleLabels: [],
                        noLabelsProvided: !1,
                        allSeriesCollapsed: !1,
                        collapsedSeries: [],
                        collapsedSeriesIndices: [],
                        ancillaryCollapsedSeries: [],
                        ancillaryCollapsedSeriesIndices: [],
                        risingSeries: [],
                        dataFormatXNumeric: !1,
                        capturedSeriesIndex: -1,
                        capturedDataPointIndex: -1,
                        selectedDataPoints: [],
                        goldenPadding: 35,
                        invalidLogScale: !1,
                        ignoreYAxisIndexes: [],
                        yAxisSameScaleIndices: [],
                        maxValsInArrayIndex: 0,
                        radialSize: 0,
                        selection: void 0,
                        zoomEnabled: "zoom" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.zoom && t.chart.zoom.enabled,
                        panEnabled: "pan" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.pan,
                        selectionEnabled: "selection" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.selection,
                        yaxis: null,
                        mousedown: !1,
                        lastClientPosition: {},
                        visibleXRange: void 0,
                        yValueDecimal: 0,
                        total: 0,
                        SVGNS: "http://www.w3.org/2000/svg",
                        svgWidth: 0,
                        svgHeight: 0,
                        noData: !1,
                        locale: {},
                        dom: {},
                        memory: {
                            methodsToExec: []
                        },
                        shouldAnimate: !0,
                        skipLastTimelinelabel: !1,
                        skipFirstTimelinelabel: !1,
                        delayedElements: [],
                        axisCharts: !0,
                        isDataXYZ: !1,
                        resized: !1,
                        resizeTimer: null,
                        comboCharts: !1,
                        dataChanged: !1,
                        previousPaths: [],
                        allSeriesHasEqualX: !0,
                        pointsArray: [],
                        dataLabelsRects: [],
                        lastDrawnDataLabelsIndexes: [],
                        hasNullValues: !1,
                        easing: null,
                        zoomed: !1,
                        gridWidth: 0,
                        gridHeight: 0,
                        rotateXLabels: !1,
                        defaultLabels: !1,
                        xLabelFormatter: void 0,
                        yLabelFormatters: [],
                        xaxisTooltipFormatter: void 0,
                        ttKeyFormatter: void 0,
                        ttVal: void 0,
                        ttZFormatter: void 0,
                        LINE_HEIGHT_RATIO: 1.618,
                        xAxisLabelsHeight: 0,
                        xAxisLabelsWidth: 0,
                        yAxisLabelsWidth: 0,
                        scaleX: 1,
                        scaleY: 1,
                        translateX: 0,
                        translateY: 0,
                        translateYAxisX: [],
                        yAxisWidths: [],
                        translateXAxisY: 0,
                        translateXAxisX: 0,
                        tooltip: null
                    }
                }
            }, {
                key: "init",
                value: function (t) {
                    var e = this.globalVars(t);
                    return this.initGlobalVars(e), e.initialConfig = y.extend({}, t), e.initialSeries = y.clone(t.series), e.lastXAxis = y.clone(e.initialConfig.xaxis), e.lastYAxis = y.clone(e.initialConfig.yaxis), e
                }
            }]), t
        }(),
        W = function () {
            function t(e) {
                r(this, t), this.opts = e
            }
            return o(t, [{
                key: "init",
                value: function () {
                    var t = new B(this.opts).init({
                        responsiveOverride: !1
                    });
                    return {
                        config: t,
                        globals: (new Y).init(t)
                    }
                }
            }]), t
        }(),
        V = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.coreUtils = new S(this.ctx)
            }
            return o(t, [{
                key: "isMultiFormat",
                value: function () {
                    return this.isFormatXY() || this.isFormat2DArray()
                }
            }, {
                key: "isFormatXY",
                value: function () {
                    var t = this.w.config.series.slice(),
                        e = new j(this.ctx);
                    if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && null !== t[this.activeSeriesIndex].data[0] && void 0 !== t[this.activeSeriesIndex].data[0].x && null !== t[this.activeSeriesIndex].data[0]) return !0
                }
            }, {
                key: "isFormat2DArray",
                value: function () {
                    var t = this.w.config.series.slice(),
                        e = new j(this.ctx);
                    if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && void 0 !== t[this.activeSeriesIndex].data[0] && null !== t[this.activeSeriesIndex].data[0] && t[this.activeSeriesIndex].data[0].constructor === Array) return !0
                }
            }, {
                key: "handleFormat2DArray",
                value: function (t, e) {
                    for (var i = this.w.config, n = this.w.globals, l = "boxPlot" === i.chart.type || "boxPlot" === i.series[e].type, r = 0; r < t[e].data.length; r++)
                        if (void 0 !== t[e].data[r][1] && (Array.isArray(t[e].data[r][1]) && 4 === t[e].data[r][1].length && !l ? this.twoDSeries.push(y.parseNumber(t[e].data[r][1][3])) : t[e].data[r].length >= 5 ? this.twoDSeries.push(y.parseNumber(t[e].data[r][4])) : this.twoDSeries.push(y.parseNumber(t[e].data[r][1])), n.dataFormatXNumeric = !0), "datetime" === i.xaxis.type) {
                            var a = new Date(t[e].data[r][0]);
                            a = new Date(a).getTime(), this.twoDSeriesX.push(a)
                        } else this.twoDSeriesX.push(t[e].data[r][0]);
                    for (var o = 0; o < t[e].data.length; o++) void 0 !== t[e].data[o][2] && (this.threeDSeries.push(t[e].data[o][2]), n.isDataXYZ = !0)
                }
            }, {
                key: "handleFormatXY",
                value: function (t, e) {
                    var i = this.w.config,
                        n = this.w.globals,
                        l = new F(this.ctx),
                        r = e;
                    n.collapsedSeriesIndices.indexOf(e) > -1 && (r = this.activeSeriesIndex);
                    for (var a = 0; a < t[e].data.length; a++) void 0 !== t[e].data[a].y && (Array.isArray(t[e].data[a].y) ? this.twoDSeries.push(y.parseNumber(t[e].data[a].y[t[e].data[a].y.length - 1])) : this.twoDSeries.push(y.parseNumber(t[e].data[a].y)));
                    for (var o = 0; o < t[r].data.length; o++) {
                        var s = "string" == typeof t[r].data[o].x,
                            c = Array.isArray(t[r].data[o].x),
                            u = !c && !!l.isValidDate(t[r].data[o].x.toString());
                        if (s || u)
                            if (s || i.xaxis.convertedCatToNumeric) {
                                var h = n.isBarHorizontal && n.isRangeData;
                                "datetime" !== i.xaxis.type || h ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[o].x)) : this.twoDSeriesX.push(l.parseDate(t[r].data[o].x))
                            } else "datetime" === i.xaxis.type ? this.twoDSeriesX.push(l.parseDate(t[r].data[o].x.toString())) : (n.dataFormatXNumeric = !0, n.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(t[r].data[o].x)));
                        else c ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[o].x)) : (n.isXNumeric = !0, n.dataFormatXNumeric = !0, this.twoDSeriesX.push(t[r].data[o].x))
                    }
                    if (t[e].data[0] && void 0 !== t[e].data[0].z) {
                        for (var d = 0; d < t[e].data.length; d++) this.threeDSeries.push(t[e].data[d].z);
                        n.isDataXYZ = !0
                    }
                }
            }, {
                key: "handleRangeData",
                value: function (t, e) {
                    var i = this.w.config,
                        n = this.w.globals,
                        l = {};
                    return this.isFormat2DArray() ? l = this.handleRangeDataFormat("array", t, e) : this.isFormatXY() && (l = this.handleRangeDataFormat("xy", t, e)), n.seriesRangeStart.push(l.start), n.seriesRangeEnd.push(l.end), "datetime" === i.xaxis.type && n.seriesRangeBarTimeline.push(l.rangeUniques), n.seriesRangeBarTimeline.forEach((function (t, e) {
                        t && t.forEach((function (t, e) {
                            t.y.forEach((function (e, i) {
                                for (var n = 0; n < t.y.length; n++)
                                    if (i !== n) {
                                        var l = e.y1,
                                            r = e.y2,
                                            a = t.y[n].y1;
                                        l <= t.y[n].y2 && a <= r && (t.overlaps.indexOf(e.rangeName) < 0 && t.overlaps.push(e.rangeName), t.overlaps.indexOf(t.y[n].rangeName) < 0 && t.overlaps.push(t.y[n].rangeName))
                                    }
                            }))
                        }))
                    })), l
                }
            }, {
                key: "handleCandleStickBoxData",
                value: function (t, e) {
                    var i = this.w.globals,
                        n = {};
                    return this.isFormat2DArray() ? n = this.handleCandleStickBoxDataFormat("array", t, e) : this.isFormatXY() && (n = this.handleCandleStickBoxDataFormat("xy", t, e)), i.seriesCandleO[e] = n.o, i.seriesCandleH[e] = n.h, i.seriesCandleM[e] = n.m, i.seriesCandleL[e] = n.l, i.seriesCandleC[e] = n.c, n
                }
            }, {
                key: "handleRangeDataFormat",
                value: function (t, e, i) {
                    var n = [],
                        l = [],
                        r = e[i].data.filter((function (t, e, i) {
                            return e === i.findIndex((function (e) {
                                return e.x === t.x
                            }))
                        })).map((function (t, e) {
                            return {
                                x: t.x,
                                overlaps: [],
                                y: []
                            }
                        })),
                        a = "Please provide [Start, End] values in valid format. Read more https://apexcharts.com/docs/series/#rangecharts",
                        o = new j(this.ctx).getActiveConfigSeriesIndex();
                    if ("array" === t) {
                        if (2 !== e[o].data[0][1].length) throw new Error(a);
                        for (var s = 0; s < e[i].data.length; s++) n.push(e[i].data[s][1][0]), l.push(e[i].data[s][1][1])
                    } else if ("xy" === t) {
                        if (2 !== e[o].data[0].y.length) throw new Error(a);
                        for (var c = function (t) {
                                var a = y.randomId(),
                                    o = e[i].data[t].x,
                                    s = {
                                        y1: e[i].data[t].y[0],
                                        y2: e[i].data[t].y[1],
                                        rangeName: a
                                    };
                                e[i].data[t].rangeName = a;
                                var c = r.findIndex((function (t) {
                                    return t.x === o
                                }));
                                r[c].y.push(s), n.push(s.y1), l.push(s.y2)
                            }, u = 0; u < e[i].data.length; u++) c(u)
                    }
                    return {
                        start: n,
                        end: l,
                        rangeUniques: r
                    }
                }
            }, {
                key: "handleCandleStickBoxDataFormat",
                value: function (t, e, i) {
                    var n = this.w,
                        l = "boxPlot" === n.config.chart.type || "boxPlot" === n.config.series[i].type,
                        r = [],
                        a = [],
                        o = [],
                        s = [],
                        c = [];
                    if ("array" === t)
                        if (l && 6 === e[i].data[0].length || !l && 5 === e[i].data[0].length)
                            for (var u = 0; u < e[i].data.length; u++) r.push(e[i].data[u][1]), a.push(e[i].data[u][2]), l ? (o.push(e[i].data[u][3]), s.push(e[i].data[u][4]), c.push(e[i].data[u][5])) : (s.push(e[i].data[u][3]), c.push(e[i].data[u][4]));
                        else
                            for (var h = 0; h < e[i].data.length; h++) Array.isArray(e[i].data[h][1]) && (r.push(e[i].data[h][1][0]), a.push(e[i].data[h][1][1]), l ? (o.push(e[i].data[h][1][2]), s.push(e[i].data[h][1][3]), c.push(e[i].data[h][1][4])) : (s.push(e[i].data[h][1][2]), c.push(e[i].data[h][1][3])));
                    else if ("xy" === t)
                        for (var d = 0; d < e[i].data.length; d++) Array.isArray(e[i].data[d].y) && (r.push(e[i].data[d].y[0]), a.push(e[i].data[d].y[1]), l ? (o.push(e[i].data[d].y[2]), s.push(e[i].data[d].y[3]), c.push(e[i].data[d].y[4])) : (s.push(e[i].data[d].y[2]), c.push(e[i].data[d].y[3])));
                    return {
                        o: r,
                        h: a,
                        m: o,
                        l: s,
                        c: c
                    }
                }
            }, {
                key: "parseDataAxisCharts",
                value: function (t) {
                    var e = this,
                        i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.ctx,
                        n = this.w.config,
                        l = this.w.globals,
                        r = new F(i),
                        a = n.labels.length > 0 ? n.labels.slice() : n.xaxis.categories.slice();
                    l.isTimelineBar = "rangeBar" === n.chart.type && "datetime" === n.xaxis.type;
                    for (var o = function () {
                            for (var t = 0; t < a.length; t++)
                                if ("string" == typeof a[t]) {
                                    if (!r.isValidDate(a[t])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
                                    e.twoDSeriesX.push(r.parseDate(a[t]))
                                } else e.twoDSeriesX.push(a[t])
                        }, s = 0; s < t.length; s++) {
                        if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], void 0 === t[s].data) return void console.error("It is a possibility that you may have not included 'data' property in series.");
                        if ("rangeBar" !== n.chart.type && "rangeArea" !== n.chart.type && "rangeBar" !== t[s].type && "rangeArea" !== t[s].type || (l.isRangeData = !0, this.handleRangeData(t, s)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(t, s) : this.isFormatXY() && this.handleFormatXY(t, s), "candlestick" !== n.chart.type && "candlestick" !== t[s].type && "boxPlot" !== n.chart.type && "boxPlot" !== t[s].type || this.handleCandleStickBoxData(t, s), l.series.push(this.twoDSeries), l.labels.push(this.twoDSeriesX), l.seriesX.push(this.twoDSeriesX), s !== this.activeSeriesIndex || this.fallbackToCategory || (l.isXNumeric = !0);
                        else {
                            "datetime" === n.xaxis.type ? (l.isXNumeric = !0, o(), l.seriesX.push(this.twoDSeriesX)) : "numeric" === n.xaxis.type && (l.isXNumeric = !0, a.length > 0 && (this.twoDSeriesX = a, l.seriesX.push(this.twoDSeriesX))), l.labels.push(this.twoDSeriesX);
                            var c = t[s].data.map((function (t) {
                                return y.parseNumber(t)
                            }));
                            l.series.push(c)
                        }
                        l.seriesZ.push(this.threeDSeries), void 0 !== t[s].name ? l.seriesNames.push(t[s].name) : l.seriesNames.push("series-" + parseInt(s + 1, 10)), void 0 !== t[s].color ? l.seriesColors.push(t[s].color) : l.seriesColors.push(void 0)
                    }
                    return this.w
                }
            }, {
                key: "parseDataNonAxisCharts",
                value: function (t) {
                    var e = this.w.globals,
                        i = this.w.config;
                    e.series = t.slice(), e.seriesNames = i.labels.slice();
                    for (var n = 0; n < e.series.length; n++) void 0 === e.seriesNames[n] && e.seriesNames.push("series-" + (n + 1));
                    return this.w
                }
            }, {
                key: "handleExternalLabelsData",
                value: function (t) {
                    var e = this.w.config,
                        i = this.w.globals;
                    e.xaxis.categories.length > 0 ? i.labels = e.xaxis.categories : e.labels.length > 0 ? i.labels = e.labels.slice() : this.fallbackToCategory ? (i.labels = i.labels[0], i.seriesRangeBarTimeline.length && (i.seriesRangeBarTimeline.map((function (t) {
                        t.forEach((function (t) {
                            i.labels.indexOf(t.x) < 0 && t.x && i.labels.push(t.x)
                        }))
                    })), i.labels = i.labels.filter((function (t, e, i) {
                        return i.indexOf(t) === e
                    }))), e.xaxis.convertedCatToNumeric && (new H(e).convertCatToNumericXaxis(e, this.ctx, i.seriesX[0]), this._generateExternalLabels(t))) : this._generateExternalLabels(t)
                }
            }, {
                key: "_generateExternalLabels",
                value: function (t) {
                    var e = this.w.globals,
                        i = this.w.config,
                        n = [];
                    if (e.axisCharts) {
                        if (e.series.length > 0)
                            for (var l = 0; l < e.series[e.maxValsInArrayIndex].length; l++) n.push(l + 1);
                        e.seriesX = [];
                        for (var r = 0; r < t.length; r++) e.seriesX.push(n);
                        e.isXNumeric = !0
                    }
                    if (0 === n.length) {
                        n = e.axisCharts ? [] : e.series.map((function (t, e) {
                            return e + 1
                        }));
                        for (var a = 0; a < t.length; a++) e.seriesX.push(n)
                    }
                    e.labels = n, i.xaxis.convertedCatToNumeric && (e.categoryLabels = n.map((function (t) {
                        return i.xaxis.labels.formatter(t)
                    }))), e.noLabelsProvided = !0
                }
            }, {
                key: "parseData",
                value: function (t) {
                    var e = this.w,
                        i = e.config,
                        n = e.globals;
                    if (this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), n.axisCharts ? this.parseDataAxisCharts(t) : this.parseDataNonAxisCharts(t), this.coreUtils.getLargestSeries(), "bar" === i.chart.type && i.chart.stacked) {
                        var l = new j(this.ctx);
                        n.series = l.setNullSeriesToZeroValues(n.series)
                    }
                    this.coreUtils.getSeriesTotals(), n.axisCharts && this.coreUtils.getStackedSeriesTotals(), this.coreUtils.getPercentSeries(), n.dataFormatXNumeric || n.isXNumeric && ("numeric" !== i.xaxis.type || 0 !== i.labels.length || 0 !== i.xaxis.categories.length) || this.handleExternalLabelsData(t);
                    for (var r = this.coreUtils.getCategoryLabels(n.labels), a = 0; a < r.length; a++)
                        if (Array.isArray(r[a])) {
                            n.isMultiLineX = !0;
                            break
                        }
                }
            }, {
                key: "excludeCollapsedSeriesInYAxis",
                value: function () {
                    var t = this,
                        e = this.w;
                    e.globals.ignoreYAxisIndexes = e.globals.collapsedSeries.map((function (i, n) {
                        if (t.w.globals.isMultipleYAxis && !e.config.chart.stacked) return i.index
                    }))
                }
            }]), t
        }(),
        X = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM"
            }
            return o(t, [{
                key: "xLabelFormat",
                value: function (t, e, i, n) {
                    var l = this.w;
                    if ("datetime" === l.config.xaxis.type && void 0 === l.config.xaxis.labels.formatter && void 0 === l.config.tooltip.x.formatter) {
                        var r = new F(this.ctx);
                        return r.formatDate(r.getDate(e), l.config.tooltip.x.format)
                    }
                    return t(e, i, n)
                }
            }, {
                key: "defaultGeneralFormatter",
                value: function (t) {
                    return Array.isArray(t) ? t.map((function (t) {
                        return t
                    })) : t
                }
            }, {
                key: "defaultYFormatter",
                value: function (t, e, i) {
                    var n = this.w;
                    return y.isNumber(t) && (t = 0 !== n.globals.yValueDecimal ? t.toFixed(void 0 !== e.decimalsInFloat ? e.decimalsInFloat : n.globals.yValueDecimal) : n.globals.maxYArr[i] - n.globals.minYArr[i] < 5 ? t.toFixed(1) : t.toFixed(0)), t
                }
            }, {
                key: "setLabelFormatters",
                value: function () {
                    var t = this,
                        e = this.w;
                    return e.globals.xaxisTooltipFormatter = function (e) {
                        return t.defaultGeneralFormatter(e)
                    }, e.globals.ttKeyFormatter = function (e) {
                        return t.defaultGeneralFormatter(e)
                    }, e.globals.ttZFormatter = function (t) {
                        return t
                    }, e.globals.legendFormatter = function (e) {
                        return t.defaultGeneralFormatter(e)
                    }, void 0 !== e.config.xaxis.labels.formatter ? e.globals.xLabelFormatter = e.config.xaxis.labels.formatter : e.globals.xLabelFormatter = function (t) {
                        if (y.isNumber(t)) {
                            if (!e.config.xaxis.convertedCatToNumeric && "numeric" === e.config.xaxis.type) {
                                if (y.isNumber(e.config.xaxis.decimalsInFloat)) return t.toFixed(e.config.xaxis.decimalsInFloat);
                                var i = e.globals.maxX - e.globals.minX;
                                return i > 0 && i < 100 ? t.toFixed(1) : t.toFixed(0)
                            }
                            return e.globals.isBarHorizontal && e.globals.maxY - e.globals.minYArr < 4 ? t.toFixed(1) : t.toFixed(0)
                        }
                        return t
                    }, "function" == typeof e.config.tooltip.x.formatter ? e.globals.ttKeyFormatter = e.config.tooltip.x.formatter : e.globals.ttKeyFormatter = e.globals.xLabelFormatter, "function" == typeof e.config.xaxis.tooltip.formatter && (e.globals.xaxisTooltipFormatter = e.config.xaxis.tooltip.formatter), (Array.isArray(e.config.tooltip.y) || void 0 !== e.config.tooltip.y.formatter) && (e.globals.ttVal = e.config.tooltip.y), void 0 !== e.config.tooltip.z.formatter && (e.globals.ttZFormatter = e.config.tooltip.z.formatter), void 0 !== e.config.legend.formatter && (e.globals.legendFormatter = e.config.legend.formatter), e.config.yaxis.forEach((function (i, n) {
                        void 0 !== i.labels.formatter ? e.globals.yLabelFormatters[n] = i.labels.formatter : e.globals.yLabelFormatters[n] = function (l) {
                            return e.globals.xyCharts ? Array.isArray(l) ? l.map((function (e) {
                                return t.defaultYFormatter(e, i, n)
                            })) : t.defaultYFormatter(l, i, n) : l
                        }
                    })), e.globals
                }
            }, {
                key: "heatmapLabelFormatters",
                value: function () {
                    var t = this.w;
                    if ("heatmap" === t.config.chart.type) {
                        t.globals.yAxisScale[0].result = t.globals.seriesNames.slice();
                        var e = t.globals.seriesNames.reduce((function (t, e) {
                            return t.length > e.length ? t : e
                        }), 0);
                        t.globals.yAxisScale[0].niceMax = e, t.globals.yAxisScale[0].niceMin = e
                    }
                }
            }]), t
        }(),
        q = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "getLabel",
                value: function (t, e, i, n) {
                    var l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [],
                        r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "12px",
                        a = this.w,
                        o = void 0 === t[n] ? "" : t[n],
                        s = o,
                        c = a.globals.xLabelFormatter,
                        u = a.config.xaxis.labels.formatter,
                        h = !1,
                        d = new X(this.ctx),
                        f = o;
                    s = d.xLabelFormat(c, o, f, {
                        i: n,
                        dateFormatter: new F(this.ctx).formatDate,
                        w: a
                    }), void 0 !== u && (s = u(o, t[n], {
                        i: n,
                        dateFormatter: new F(this.ctx).formatDate,
                        w: a
                    }));
                    var p = function (t) {
                        var i = null;
                        return e.forEach((function (t) {
                            "month" === t.unit ? i = "year" : "day" === t.unit ? i = "month" : "hour" === t.unit ? i = "day" : "minute" === t.unit && (i = "hour")
                        })), i === t
                    };
                    e.length > 0 ? (h = p(e[n].unit), i = e[n].position, s = e[n].value) : "datetime" === a.config.xaxis.type && void 0 === u && (s = ""), void 0 === s && (s = ""), s = Array.isArray(s) ? s : s.toString();
                    var g = new w(this.ctx),
                        m = {};
                    m = a.globals.rotateXLabels ? g.getTextRects(s, parseInt(r, 10), null, "rotate(".concat(a.config.xaxis.labels.rotate, " 0 0)"), !1) : g.getTextRects(s, parseInt(r, 10));
                    var v = !a.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
                    return !Array.isArray(s) && (0 === s.indexOf("NaN") || 0 === s.toLowerCase().indexOf("invalid") || s.toLowerCase().indexOf("infinity") >= 0 || l.indexOf(s) >= 0 && v) && (s = ""), {
                        x: i,
                        text: s,
                        textRect: m,
                        isBold: h
                    }
                }
            }, {
                key: "checkLabelBasedOnTickamount",
                value: function (t, e, i) {
                    var n = this.w,
                        l = n.config.xaxis.tickAmount;
                    return "dataPoints" === l && (l = Math.round(n.globals.gridWidth / 120)), l > i || t % Math.round(i / (l + 1)) == 0 || (e.text = ""), e
                }
            }, {
                key: "checkForOverflowingLabels",
                value: function (t, e, i, n, l) {
                    var r = this.w;
                    if (0 === t && r.globals.skipFirstTimelinelabel && (e.text = ""), t === i - 1 && r.globals.skipLastTimelinelabel && (e.text = ""), r.config.xaxis.labels.hideOverlappingLabels && n.length > 0) {
                        var a = l[l.length - 1];
                        e.x < a.textRect.width / (r.globals.rotateXLabels ? Math.abs(r.config.xaxis.labels.rotate) / 12 : 1.01) + a.x && (e.text = "")
                    }
                    return e
                }
            }, {
                key: "checkForReversedLabels",
                value: function (t, e) {
                    var i = this.w;
                    return i.config.yaxis[t] && i.config.yaxis[t].reversed && e.reverse(), e
                }
            }, {
                key: "isYAxisHidden",
                value: function (t) {
                    var e = this.w,
                        i = new S(this.ctx);
                    return !e.config.yaxis[t].show || !e.config.yaxis[t].showForNullSeries && i.isSeriesNull(t) && -1 === e.globals.collapsedSeriesIndices.indexOf(t)
                }
            }, {
                key: "getYAxisForeColor",
                value: function (t, e) {
                    var i = this.w;
                    return Array.isArray(t) && i.globals.yAxisScale[e] && this.ctx.theme.pushExtraColors(t, i.globals.yAxisScale[e].result.length, !1), t
                }
            }, {
                key: "drawYAxisTicks",
                value: function (t, e, i, n, l, r, a) {
                    var o = this.w,
                        s = new w(this.ctx),
                        c = o.globals.translateY;
                    if (n.show && e > 0) {
                        !0 === o.config.yaxis[l].opposite && (t += n.width);
                        for (var u = e; u >= 0; u--) {
                            var h = c + e / 10 + o.config.yaxis[l].labels.offsetY - 1;
                            o.globals.isBarHorizontal && (h = r * u), "heatmap" === o.config.chart.type && (h += r / 2);
                            var d = s.drawLine(t + i.offsetX - n.width + n.offsetX, h + n.offsetY, t + i.offsetX + n.offsetX, h + n.offsetY, n.color);
                            a.add(d), c += r
                        }
                    }
                }
            }]), t
        }(),
        Z = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "fixSvgStringForIe11",
                value: function (t) {
                    if (!y.isIE11()) return t;
                    var e = 0,
                        i = t.replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/g, (function (t) {
                            return 2 == ++e ? 'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"' : t
                        }));
                    return (i = i.replace(/xmlns:NS\d+=""/g, "")).replace(/NS\d+:(\w+:\w+=")/g, "$1")
                }
            }, {
                key: "getSvgString",
                value: function () {
                    var t = this.w.globals.dom.Paper.svg();
                    return this.fixSvgStringForIe11(t)
                }
            }, {
                key: "cleanup",
                value: function () {
                    var t = this.w,
                        e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"),
                        i = t.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"),
                        n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");
                    Array.prototype.forEach.call(n, (function (t) {
                        t.setAttribute("width", 0)
                    })), e && e[0] && (e[0].setAttribute("x", -500), e[0].setAttribute("x1", -500), e[0].setAttribute("x2", -500)), i && i[0] && (i[0].setAttribute("y", -100), i[0].setAttribute("y1", -100), i[0].setAttribute("y2", -100))
                }
            }, {
                key: "svgUrl",
                value: function () {
                    this.cleanup();
                    var t = this.getSvgString(),
                        e = new Blob([t], {
                            type: "image/svg+xml;charset=utf-8"
                        });
                    return URL.createObjectURL(e)
                }
            }, {
                key: "dataURI",
                value: function () {
                    var t = this;
                    return new Promise((function (e) {
                        var i = t.w;
                        t.cleanup();
                        var n = document.createElement("canvas");
                        n.width = i.globals.svgWidth, n.height = parseInt(i.globals.dom.elWrap.style.height, 10);
                        var l = "transparent" === i.config.chart.background ? "#fff" : i.config.chart.background,
                            r = n.getContext("2d");
                        r.fillStyle = l, r.fillRect(0, 0, n.width, n.height);
                        var a = t.getSvgString();
                        if (window.canvg && y.isIE11()) {
                            var o = window.canvg.Canvg.fromString(r, a, {
                                ignoreClear: !0,
                                ignoreDimensions: !0
                            });
                            o.start();
                            var s = n.msToBlob();
                            o.stop(), e({
                                blob: s
                            })
                        } else {
                            var c = "data:image/svg+xml," + encodeURIComponent(a),
                                u = new Image;
                            u.crossOrigin = "anonymous", u.onload = function () {
                                if (r.drawImage(u, 0, 0), n.msToBlob) {
                                    var t = n.msToBlob();
                                    e({
                                        blob: t
                                    })
                                } else {
                                    var i = n.toDataURL("image/png");
                                    e({
                                        imgURI: i
                                    })
                                }
                            }, u.src = c
                        }
                    }))
                }
            }, {
                key: "exportToSVG",
                value: function () {
                    this.triggerDownload(this.svgUrl(), this.w.config.chart.toolbar.export.svg.filename, ".svg")
                }
            }, {
                key: "exportToPng",
                value: function () {
                    var t = this;
                    this.dataURI().then((function (e) {
                        var i = e.imgURI,
                            n = e.blob;
                        n ? navigator.msSaveOrOpenBlob(n, t.w.globals.chartID + ".png") : t.triggerDownload(i, t.w.config.chart.toolbar.export.png.filename, ".png")
                    }))
                }
            }, {
                key: "exportToCSV",
                value: function (t) {
                    var e = this,
                        i = t.series,
                        n = t.columnDelimiter,
                        l = t.lineDelimiter,
                        r = void 0 === l ? "\n" : l,
                        a = this.w,
                        o = [],
                        s = [],
                        c = "data:text/csv;charset=utf-8,\ufeff",
                        u = new V(this.ctx),
                        h = new q(this.ctx),
                        d = function (t) {
                            var i = "";
                            if (a.globals.axisCharts) {
                                if ("category" === a.config.xaxis.type || a.config.xaxis.convertedCatToNumeric)
                                    if (a.globals.isBarHorizontal) {
                                        var l = a.globals.yLabelFormatters[0],
                                            r = new j(e.ctx).getActiveConfigSeriesIndex();
                                        i = l(a.globals.labels[t], {
                                            seriesIndex: r,
                                            dataPointIndex: t,
                                            w: a
                                        })
                                    } else i = h.getLabel(a.globals.labels, a.globals.timescaleLabels, 0, t).text;
                                "datetime" === a.config.xaxis.type && (a.config.xaxis.categories.length ? i = a.config.xaxis.categories[t] : a.config.labels.length && (i = a.config.labels[t]))
                            } else i = a.config.labels[t];
                            return Array.isArray(i) && (i = i.join(" ")), y.isNumber(i) ? i : i.split(n).join("")
                        };
                    o.push(a.config.chart.toolbar.export.csv.headerCategory), i.map((function (t, e) {
                        var i = t.name ? t.name : "series-".concat(e);
                        a.globals.axisCharts && o.push(i.split(n).join("") ? i.split(n).join("") : "series-".concat(e))
                    })), a.globals.axisCharts || (o.push(a.config.chart.toolbar.export.csv.headerValue), s.push(o.join(n))), i.map((function (t, e) {
                        a.globals.axisCharts ? function (t, e) {
                            if (o.length && 0 === e && s.push(o.join(n)), t.data && t.data.length)
                                for (var l = 0; l < t.data.length; l++) {
                                    o = [];
                                    var r = d(l);
                                    if (r || (u.isFormatXY() ? r = i[e].data[l].x : u.isFormat2DArray() && (r = i[e].data[l] ? i[e].data[l][0] : "")), 0 === e) {
                                        o.push((h = r, "datetime" === a.config.xaxis.type && String(h).length >= 10 ? a.config.chart.toolbar.export.csv.dateFormatter(r) : y.isNumber(r) ? r : r.split(n).join("")));
                                        for (var c = 0; c < a.globals.series.length; c++) o.push(a.globals.series[c][l])
                                    }("candlestick" === a.config.chart.type || t.type && "candlestick" === t.type) && (o.pop(), o.push(a.globals.seriesCandleO[e][l]), o.push(a.globals.seriesCandleH[e][l]), o.push(a.globals.seriesCandleL[e][l]), o.push(a.globals.seriesCandleC[e][l])), ("boxPlot" === a.config.chart.type || t.type && "boxPlot" === t.type) && (o.pop(), o.push(a.globals.seriesCandleO[e][l]), o.push(a.globals.seriesCandleH[e][l]), o.push(a.globals.seriesCandleM[e][l]), o.push(a.globals.seriesCandleL[e][l]), o.push(a.globals.seriesCandleC[e][l])), "rangeBar" === a.config.chart.type && (o.pop(), o.push(a.globals.seriesRangeStart[e][l]), o.push(a.globals.seriesRangeEnd[e][l])), o.length && s.push(o.join(n))
                                }
                            var h
                        }(t, e) : ((o = []).push(a.globals.labels[e].split(n).join("")), o.push(a.globals.series[e]), s.push(o.join(n)))
                    })), c += s.join(r), this.triggerDownload(encodeURI(c), a.config.chart.toolbar.export.csv.filename, ".csv")
                }
            }, {
                key: "triggerDownload",
                value: function (t, e, i) {
                    var n = document.createElement("a");
                    n.href = t, n.download = (e || this.w.globals.chartID) + i, document.body.appendChild(n), n.click(), document.body.removeChild(n)
                }
            }]), t
        }(),
        G = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w;
                var i = this.w;
                this.axesUtils = new q(e), this.xaxisLabels = i.globals.labels.slice(), i.globals.timescaleLabels.length > 0 && !i.globals.isBarHorizontal && (this.xaxisLabels = i.globals.timescaleLabels.slice()), this.drawnLabels = [], this.drawnLabelsRects = [], "top" === i.config.xaxis.position ? this.offY = 0 : this.offY = i.globals.gridHeight + 1, this.offY = this.offY + i.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = "bar" === i.config.chart.type && i.config.plotOptions.bar.horizontal, this.xaxisFontSize = i.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = i.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = i.config.xaxis.labels.style.colors, this.xaxisBorderWidth = i.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = i.config.yaxis[0].axisBorder.width.toString()), this.xaxisBorderWidth.indexOf("%") > -1 ? this.xaxisBorderWidth = i.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = i.config.xaxis.axisBorder.height, this.yaxis = i.config.yaxis[0]
            }
            return o(t, [{
                key: "drawXaxis",
                value: function () {
                    var t, e = this,
                        i = this.w,
                        n = new w(this.ctx),
                        l = n.group({
                            class: "apexcharts-xaxis",
                            transform: "translate(".concat(i.config.xaxis.offsetX, ", ").concat(i.config.xaxis.offsetY, ")")
                        }),
                        r = n.group({
                            class: "apexcharts-xaxis-texts-g",
                            transform: "translate(".concat(i.globals.translateXAxisX, ", ").concat(i.globals.translateXAxisY, ")")
                        });
                    l.add(r);
                    for (var a = i.globals.padHorizontal, o = [], s = 0; s < this.xaxisLabels.length; s++) o.push(this.xaxisLabels[s]);
                    var c = o.length;
                    if (i.globals.isXNumeric) {
                        var u = c > 1 ? c - 1 : c;
                        t = i.globals.gridWidth / u, a = a + t / 2 + i.config.xaxis.labels.offsetX
                    } else t = i.globals.gridWidth / o.length, a = a + t + i.config.xaxis.labels.offsetX;
                    for (var h = function (l) {
                            var s = a - t / 2 + i.config.xaxis.labels.offsetX;
                            0 === l && 1 === c && t / 2 === a && 1 === i.globals.dataPoints && (s = i.globals.gridWidth / 2);
                            var u = e.axesUtils.getLabel(o, i.globals.timescaleLabels, s, l, e.drawnLabels, e.xaxisFontSize),
                                h = 28;
                            if (i.globals.rotateXLabels && (h = 22), (u = void 0 !== i.config.xaxis.tickAmount && "dataPoints" !== i.config.xaxis.tickAmount && "datetime" !== i.config.xaxis.type ? e.axesUtils.checkLabelBasedOnTickamount(l, u, c) : e.axesUtils.checkForOverflowingLabels(l, u, c, e.drawnLabels, e.drawnLabelsRects)).text && i.globals.xaxisLabelsCount++, i.config.xaxis.labels.show) {
                                var d = n.drawText({
                                    x: u.x,
                                    y: e.offY + i.config.xaxis.labels.offsetY + h - ("top" === i.config.xaxis.position ? i.globals.xAxisHeight + i.config.xaxis.axisTicks.height - 2 : 0),
                                    text: u.text,
                                    textAnchor: "middle",
                                    fontWeight: u.isBold ? 600 : i.config.xaxis.labels.style.fontWeight,
                                    fontSize: e.xaxisFontSize,
                                    fontFamily: e.xaxisFontFamily,
                                    foreColor: Array.isArray(e.xaxisForeColors) ? i.config.xaxis.convertedCatToNumeric ? e.xaxisForeColors[i.globals.minX + l - 1] : e.xaxisForeColors[l] : e.xaxisForeColors,
                                    isPlainText: !1,
                                    cssClass: "apexcharts-xaxis-label " + i.config.xaxis.labels.style.cssClass
                                });
                                r.add(d);
                                var f = document.createElementNS(i.globals.SVGNS, "title");
                                f.textContent = Array.isArray(u.text) ? u.text.join(" ") : u.text, d.node.appendChild(f), "" !== u.text && (e.drawnLabels.push(u.text), e.drawnLabelsRects.push(u))
                            }
                            a += t
                        }, d = 0; d <= c - 1; d++) h(d);
                    if (void 0 !== i.config.xaxis.title.text) {
                        var f = n.group({
                                class: "apexcharts-xaxis-title"
                            }),
                            p = n.drawText({
                                x: i.globals.gridWidth / 2 + i.config.xaxis.title.offsetX,
                                y: this.offY + parseFloat(this.xaxisFontSize) + i.globals.xAxisLabelsHeight + i.config.xaxis.title.offsetY,
                                text: i.config.xaxis.title.text,
                                textAnchor: "middle",
                                fontSize: i.config.xaxis.title.style.fontSize,
                                fontFamily: i.config.xaxis.title.style.fontFamily,
                                fontWeight: i.config.xaxis.title.style.fontWeight,
                                foreColor: i.config.xaxis.title.style.color,
                                cssClass: "apexcharts-xaxis-title-text " + i.config.xaxis.title.style.cssClass
                            });
                        f.add(p), l.add(f)
                    }
                    if (i.config.xaxis.axisBorder.show) {
                        var g = i.globals.barPadForNumericAxis,
                            m = n.drawLine(i.globals.padHorizontal + i.config.xaxis.axisBorder.offsetX - g, this.offY, this.xaxisBorderWidth + g, this.offY, i.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
                        l.add(m)
                    }
                    return l
                }
            }, {
                key: "drawXaxisInversed",
                value: function (t) {
                    var e, i, n = this,
                        l = this.w,
                        r = new w(this.ctx),
                        a = l.config.yaxis[0].opposite ? l.globals.translateYAxisX[t] : 0,
                        o = r.group({
                            class: "apexcharts-yaxis apexcharts-xaxis-inversed",
                            rel: t
                        }),
                        s = r.group({
                            class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",
                            transform: "translate(" + a + ", 0)"
                        });
                    o.add(s);
                    var c = [];
                    if (l.config.yaxis[t].show)
                        for (var u = 0; u < this.xaxisLabels.length; u++) c.push(this.xaxisLabels[u]);
                    e = l.globals.gridHeight / c.length, i = -e / 2.2;
                    var h = l.globals.yLabelFormatters[0],
                        d = l.config.yaxis[0].labels;
                    if (d.show)
                        for (var f = function (a) {
                                var o = void 0 === c[a] ? "" : c[a];
                                o = h(o, {
                                    seriesIndex: t,
                                    dataPointIndex: a,
                                    w: l
                                });
                                var u = n.axesUtils.getYAxisForeColor(d.style.colors, t),
                                    f = 0;
                                Array.isArray(o) && (f = o.length / 2 * parseInt(d.style.fontSize, 10));
                                var p = r.drawText({
                                    x: d.offsetX - 15,
                                    y: i + e + d.offsetY - f,
                                    text: o,
                                    textAnchor: n.yaxis.opposite ? "start" : "end",
                                    foreColor: Array.isArray(u) ? u[a] : u,
                                    fontSize: d.style.fontSize,
                                    fontFamily: d.style.fontFamily,
                                    fontWeight: d.style.fontWeight,
                                    isPlainText: !1,
                                    cssClass: "apexcharts-yaxis-label " + d.style.cssClass
                                });
                                s.add(p);
                                var g = document.createElementNS(l.globals.SVGNS, "title");
                                if (g.textContent = o.text, p.node.appendChild(g), 0 !== l.config.yaxis[t].labels.rotate) {
                                    var m = r.rotateAroundCenter(p.node);
                                    p.node.setAttribute("transform", "rotate(".concat(l.config.yaxis[t].labels.rotate, " 0 ").concat(m.y, ")"))
                                }
                                i += e
                            }, p = 0; p <= c.length - 1; p++) f(p);
                    if (void 0 !== l.config.yaxis[0].title.text) {
                        var g = r.group({
                                class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed",
                                transform: "translate(" + a + ", 0)"
                            }),
                            m = r.drawText({
                                x: 0,
                                y: l.globals.gridHeight / 2,
                                text: l.config.yaxis[0].title.text,
                                textAnchor: "middle",
                                foreColor: l.config.yaxis[0].title.style.color,
                                fontSize: l.config.yaxis[0].title.style.fontSize,
                                fontWeight: l.config.yaxis[0].title.style.fontWeight,
                                fontFamily: l.config.yaxis[0].title.style.fontFamily,
                                cssClass: "apexcharts-yaxis-title-text " + l.config.yaxis[0].title.style.cssClass
                            });
                        g.add(m), o.add(g)
                    }
                    var v = 0;
                    this.isCategoryBarHorizontal && l.config.yaxis[0].opposite && (v = l.globals.gridWidth);
                    var y = l.config.xaxis.axisBorder;
                    if (y.show) {
                        var b = r.drawLine(l.globals.padHorizontal + y.offsetX + v, 1 + y.offsetY, l.globals.padHorizontal + y.offsetX + v, l.globals.gridHeight + y.offsetY, y.color, 0);
                        o.add(b)
                    }
                    return l.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(v, c.length, l.config.yaxis[0].axisBorder, l.config.yaxis[0].axisTicks, 0, e, o), o
                }
            }, {
                key: "drawXaxisTicks",
                value: function (t, e) {
                    var i = this.w,
                        n = t;
                    if (!(t < 0 || t - 2 > i.globals.gridWidth)) {
                        var l = this.offY + i.config.xaxis.axisTicks.offsetY,
                            r = l + i.config.xaxis.axisTicks.height;
                        if ("top" === i.config.xaxis.position && (r = l - i.config.xaxis.axisTicks.height), i.config.xaxis.axisTicks.show) {
                            var a = new w(this.ctx).drawLine(t + i.config.xaxis.axisTicks.offsetX, l + i.config.xaxis.offsetY, n + i.config.xaxis.axisTicks.offsetX, r + i.config.xaxis.offsetY, i.config.xaxis.axisTicks.color);
                            e.add(a), a.node.classList.add("apexcharts-xaxis-tick")
                        }
                    }
                }
            }, {
                key: "getXAxisTicksPositions",
                value: function () {
                    var t = this.w,
                        e = [],
                        i = this.xaxisLabels.length,
                        n = t.globals.padHorizontal;
                    if (t.globals.timescaleLabels.length > 0)
                        for (var l = 0; l < i; l++) n = this.xaxisLabels[l].position, e.push(n);
                    else
                        for (var r = i, a = 0; a < r; a++) {
                            var o = r;
                            t.globals.isXNumeric && "bar" !== t.config.chart.type && (o -= 1), n += t.globals.gridWidth / o, e.push(n)
                        }
                    return e
                }
            }, {
                key: "xAxisLabelCorrections",
                value: function () {
                    var t = this.w,
                        e = new w(this.ctx),
                        i = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"),
                        n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text"),
                        l = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"),
                        r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
                    if (t.globals.rotateXLabels || t.config.xaxis.labels.rotateAlways)
                        for (var a = 0; a < n.length; a++) {
                            var o = e.rotateAroundCenter(n[a]);
                            o.y = o.y - 1, o.x = o.x + 1, n[a].setAttribute("transform", "rotate(".concat(t.config.xaxis.labels.rotate, " ").concat(o.x, " ").concat(o.y, ")")), n[a].setAttribute("text-anchor", "end"), i.setAttribute("transform", "translate(0, ".concat(-10, ")"));
                            var s = n[a].childNodes;
                            t.config.xaxis.labels.trim && Array.prototype.forEach.call(s, (function (i) {
                                e.placeTextWithEllipsis(i, i.textContent, t.globals.xAxisLabelsHeight - ("bottom" === t.config.legend.position ? 20 : 10))
                            }))
                        } else ! function () {
                            for (var i = t.globals.gridWidth / (t.globals.labels.length + 1), l = 0; l < n.length; l++) {
                                var r = n[l].childNodes;
                                t.config.xaxis.labels.trim && "datetime" !== t.config.xaxis.type && Array.prototype.forEach.call(r, (function (t) {
                                    e.placeTextWithEllipsis(t, t.textContent, i)
                                }))
                            }
                        }();
                    if (l.length > 0) {
                        var c = l[l.length - 1].getBBox(),
                            u = l[0].getBBox();
                        c.x < -20 && l[l.length - 1].parentNode.removeChild(l[l.length - 1]), u.x + u.width > t.globals.gridWidth && !t.globals.isBarHorizontal && l[0].parentNode.removeChild(l[0]);
                        for (var h = 0; h < r.length; h++) e.placeTextWithEllipsis(r[h], r[h].textContent, t.config.yaxis[0].labels.maxWidth - 2 * parseFloat(t.config.yaxis[0].title.style.fontSize) - 20)
                    }
                }
            }]), t
        }(),
        U = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w;
                var i = this.w;
                this.xaxisLabels = i.globals.labels.slice(), this.axesUtils = new q(e), this.isTimelineBar = "datetime" === i.config.xaxis.type && i.globals.seriesRangeBarTimeline.length, i.globals.timescaleLabels.length > 0 && (this.xaxisLabels = i.globals.timescaleLabels.slice())
            }
            return o(t, [{
                key: "drawGridArea",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                        e = this.w,
                        i = new w(this.ctx);
                    null === t && (t = i.group({
                        class: "apexcharts-grid"
                    }));
                    var n = i.drawLine(e.globals.padHorizontal, 1, e.globals.padHorizontal, e.globals.gridHeight, "transparent"),
                        l = i.drawLine(e.globals.padHorizontal, e.globals.gridHeight, e.globals.gridWidth, e.globals.gridHeight, "transparent");
                    return t.add(l), t.add(n), t
                }
            }, {
                key: "drawGrid",
                value: function () {
                    var t = null;
                    return this.w.globals.axisCharts && (t = this.renderGrid(), this.drawGridArea(t.el)), t
                }
            }, {
                key: "createGridMask",
                value: function () {
                    var t = this.w,
                        e = t.globals,
                        i = new w(this.ctx),
                        n = Array.isArray(t.config.stroke.width) ? 0 : t.config.stroke.width;
                    if (Array.isArray(t.config.stroke.width)) {
                        var l = 0;
                        t.config.stroke.width.forEach((function (t) {
                            l = Math.max(l, t)
                        })), n = l
                    }
                    e.dom.elGridRectMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMask.setAttribute("id", "gridRectMask".concat(e.cuid)), e.dom.elGridRectMarkerMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMarkerMask.setAttribute("id", "gridRectMarkerMask".concat(e.cuid));
                    var r = t.config.chart.type,
                        a = 0,
                        o = 0;
                    ("bar" === r || "rangeBar" === r || "candlestick" === r || "boxPlot" === r || t.globals.comboBarCount > 0) && t.globals.isXNumeric && !t.globals.isBarHorizontal && (a = t.config.grid.padding.left, o = t.config.grid.padding.right, e.barPadForNumericAxis > a && (a = e.barPadForNumericAxis, o = e.barPadForNumericAxis)), e.dom.elGridRect = i.drawRect(-n / 2 - a - 2, -n / 2, e.gridWidth + n + o + a + 4, e.gridHeight + n, 0, "#fff"), new S(this).getLargestMarkerSize();
                    var s = t.globals.markers.largestSize + 1;
                    e.dom.elGridRectMarker = i.drawRect(2 * -s, 2 * -s, e.gridWidth + 4 * s, e.gridHeight + 4 * s, 0, "#fff"), e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node), e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);
                    var c = e.dom.baseEl.querySelector("defs");
                    c.appendChild(e.dom.elGridRectMask), c.appendChild(e.dom.elGridRectMarkerMask)
                }
            }, {
                key: "_drawGridLines",
                value: function (t) {
                    var e = t.i,
                        i = t.x1,
                        n = t.y1,
                        l = t.x2,
                        r = t.y2,
                        a = t.xCount,
                        o = t.parent,
                        s = this.w;
                    0 === e && s.globals.skipFirstTimelinelabel || e === a - 1 && s.globals.skipLastTimelinelabel && !s.config.xaxis.labels.formatter || "radar" === s.config.chart.type || (s.config.grid.xaxis.lines.show && this._drawGridLine({
                        x1: i,
                        y1: n,
                        x2: l,
                        y2: r,
                        parent: o
                    }), new G(this.ctx).drawXaxisTicks(i, this.elg))
                }
            }, {
                key: "_drawGridLine",
                value: function (t) {
                    var e = t.x1,
                        i = t.y1,
                        n = t.x2,
                        l = t.y2,
                        r = t.parent,
                        a = this.w,
                        o = r.node.classList.contains("apexcharts-gridlines-horizontal"),
                        s = a.config.grid.strokeDashArray,
                        c = a.globals.barPadForNumericAxis,
                        u = new w(this).drawLine(e - (o ? c : 0), i, n + (o ? c : 0), l, a.config.grid.borderColor, s);
                    u.node.classList.add("apexcharts-gridline"), r.add(u)
                }
            }, {
                key: "_drawGridBandRect",
                value: function (t) {
                    var e = t.c,
                        i = t.x1,
                        n = t.y1,
                        l = t.x2,
                        r = t.y2,
                        a = t.type,
                        o = this.w,
                        s = new w(this.ctx),
                        c = o.globals.barPadForNumericAxis;
                    if ("column" !== a || "datetime" !== o.config.xaxis.type) {
                        var u = o.config.grid[a].colors[e],
                            h = s.drawRect(i - ("row" === a ? c : 0), n, l + ("row" === a ? 2 * c : 0), r, 0, u, o.config.grid[a].opacity);
                        this.elg.add(h), h.attr("clip-path", "url(#gridRectMask".concat(o.globals.cuid, ")")), h.node.classList.add("apexcharts-grid-".concat(a))
                    }
                }
            }, {
                key: "_drawXYLines",
                value: function (t) {
                    var e = this,
                        i = t.xCount,
                        n = t.tickAmount,
                        l = this.w;
                    if (l.config.grid.xaxis.lines.show || l.config.xaxis.axisTicks.show) {
                        var r, a = l.globals.padHorizontal,
                            o = l.globals.gridHeight;
                        l.globals.timescaleLabels.length ? function (t) {
                            for (var n = t.xC, l = t.x1, r = t.y1, a = t.x2, o = t.y2, s = 0; s < n; s++) l = e.xaxisLabels[s].position, a = e.xaxisLabels[s].position, e._drawGridLines({
                                i: s,
                                x1: l,
                                y1: r,
                                x2: a,
                                y2: o,
                                xCount: i,
                                parent: e.elgridLinesV
                            })
                        }({
                            xC: i,
                            x1: a,
                            y1: 0,
                            x2: r,
                            y2: o
                        }) : (l.globals.isXNumeric && (i = l.globals.xAxisScale.result.length), l.config.xaxis.convertedCatToNumeric && (i = l.globals.xaxisLabelsCount), function (t) {
                            var n = t.xC,
                                r = t.x1,
                                a = t.y1,
                                o = t.x2,
                                s = t.y2;
                            if (void 0 !== l.config.xaxis.tickAmount && "dataPoints" !== l.config.xaxis.tickAmount) l.globals.dom.baseEl.querySelectorAll(".apexcharts-text.apexcharts-xaxis-label tspan:not(:empty)").forEach((function (t, n) {
                                var l = t.getBBox();
                                e._drawGridLines({
                                    i: n,
                                    x1: l.x + l.width / 2,
                                    y1: a,
                                    x2: l.x + l.width / 2,
                                    y2: s,
                                    xCount: i,
                                    parent: e.elgridLinesV
                                })
                            }));
                            else
                                for (var c = 0; c < n + (l.globals.isXNumeric ? 0 : 1); c++) 0 === c && 1 === n && 1 === l.globals.dataPoints && (o = r = l.globals.gridWidth / 2), e._drawGridLines({
                                    i: c,
                                    x1: r,
                                    y1: a,
                                    x2: o,
                                    y2: s,
                                    xCount: i,
                                    parent: e.elgridLinesV
                                }), o = r += l.globals.gridWidth / (l.globals.isXNumeric ? n - 1 : n)
                        }({
                            xC: i,
                            x1: a,
                            y1: 0,
                            x2: r,
                            y2: o
                        }))
                    }
                    if (l.config.grid.yaxis.lines.show) {
                        var s = 0,
                            c = 0,
                            u = l.globals.gridWidth,
                            h = n + 1;
                        this.isTimelineBar && (h = l.globals.labels.length);
                        for (var d = 0; d < h + (this.isTimelineBar ? 1 : 0); d++) this._drawGridLine({
                            x1: 0,
                            y1: s,
                            x2: u,
                            y2: c,
                            parent: this.elgridLinesH
                        }), c = s += l.globals.gridHeight / (this.isTimelineBar ? h : n)
                    }
                }
            }, {
                key: "_drawInvertedXYLines",
                value: function (t) {
                    var e = t.xCount,
                        i = this.w;
                    if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show)
                        for (var n, l = i.globals.padHorizontal, r = i.globals.gridHeight, a = 0; a < e + 1; a++) i.config.grid.xaxis.lines.show && this._drawGridLine({
                            x1: l,
                            y1: 0,
                            x2: n,
                            y2: r,
                            parent: this.elgridLinesV
                        }), new G(this.ctx).drawXaxisTicks(l, this.elg), n = l = l + i.globals.gridWidth / e + .3;
                    if (i.config.grid.yaxis.lines.show)
                        for (var o = 0, s = 0, c = i.globals.gridWidth, u = 0; u < i.globals.dataPoints + 1; u++) this._drawGridLine({
                            x1: 0,
                            y1: o,
                            x2: c,
                            y2: s,
                            parent: this.elgridLinesH
                        }), s = o += i.globals.gridHeight / i.globals.dataPoints
                }
            }, {
                key: "renderGrid",
                value: function () {
                    var t = this.w,
                        e = new w(this.ctx);
                    this.elg = e.group({
                        class: "apexcharts-grid"
                    }), this.elgridLinesH = e.group({
                        class: "apexcharts-gridlines-horizontal"
                    }), this.elgridLinesV = e.group({
                        class: "apexcharts-gridlines-vertical"
                    }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), t.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide());
                    for (var i, n = t.globals.yAxisScale.length ? t.globals.yAxisScale[0].result.length - 1 : 5, l = 0; l < t.globals.series.length && (void 0 !== t.globals.yAxisScale[l] && (n = t.globals.yAxisScale[l].result.length - 1), !(n > 2)); l++);
                    return !t.globals.isBarHorizontal || this.isTimelineBar ? (i = this.xaxisLabels.length, this.isTimelineBar && (n = t.globals.labels.length, t.config.xaxis.tickAmount && t.config.xaxis.labels.formatter && (i = t.config.xaxis.tickAmount)), this._drawXYLines({
                        xCount: i,
                        tickAmount: n
                    })) : (i = n, n = t.globals.xTickAmount, this._drawInvertedXYLines({
                        xCount: i,
                        tickAmount: n
                    })), this.drawGridBands(i, n), {
                        el: this.elg,
                        xAxisTickWidth: t.globals.gridWidth / i
                    }
                }
            }, {
                key: "drawGridBands",
                value: function (t, e) {
                    var i = this.w;
                    if (void 0 !== i.config.grid.row.colors && i.config.grid.row.colors.length > 0)
                        for (var n = 0, l = i.globals.gridHeight / e, r = i.globals.gridWidth, a = 0, o = 0; a < e; a++, o++) o >= i.config.grid.row.colors.length && (o = 0), this._drawGridBandRect({
                            c: o,
                            x1: 0,
                            y1: n,
                            x2: r,
                            y2: l,
                            type: "row"
                        }), n += i.globals.gridHeight / e;
                    if (void 0 !== i.config.grid.column.colors && i.config.grid.column.colors.length > 0)
                        for (var s = i.globals.isBarHorizontal || "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric ? t : t - 1, c = i.globals.padHorizontal, u = i.globals.padHorizontal + i.globals.gridWidth / s, h = i.globals.gridHeight, d = 0, f = 0; d < t; d++, f++) f >= i.config.grid.column.colors.length && (f = 0), this._drawGridBandRect({
                            c: f,
                            x1: c,
                            y1: 0,
                            x2: u,
                            y2: h,
                            type: "column"
                        }), c += i.globals.gridWidth / s
                }
            }]), t
        }(),
        K = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "niceScale",
                value: function (t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10,
                        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
                        l = arguments.length > 4 ? arguments[4] : void 0,
                        r = this.w,
                        a = Math.abs(e - t);
                    if ("dataPoints" === (i = this._adjustTicksForSmallRange(i, n, a)) && (i = r.globals.dataPoints - 1), t === Number.MIN_VALUE && 0 === e || !y.isNumber(t) && !y.isNumber(e) || t === Number.MIN_VALUE && e === -Number.MAX_VALUE) {
                        t = 0, e = i;
                        var o = this.linearScale(t, e, i);
                        return o
                    }
                    t > e ? (console.warn("axis.min cannot be greater than axis.max"), e = t + .1) : t === e && (t = 0 === t ? 0 : t - .5, e = 0 === e ? 2 : e + .5);
                    var s = [];
                    a < 1 && l && ("candlestick" === r.config.chart.type || "candlestick" === r.config.series[n].type || "boxPlot" === r.config.chart.type || "boxPlot" === r.config.series[n].type || r.globals.isRangeData) && (e *= 1.01);
                    var c = i + 1;
                    c < 2 ? c = 2 : c > 2 && (c -= 2);
                    var u = a / c,
                        h = Math.floor(y.log10(u)),
                        d = Math.pow(10, h),
                        f = Math.round(u / d);
                    f < 1 && (f = 1);
                    var p = f * d,
                        g = p * Math.floor(t / p),
                        m = p * Math.ceil(e / p),
                        v = g;
                    if (l && a > 2) {
                        for (; s.push(v), !((v += p) > m););
                        return {
                            result: s,
                            niceMin: s[0],
                            niceMax: s[s.length - 1]
                        }
                    }
                    var b = t;
                    (s = []).push(b);
                    for (var x = Math.abs(e - t) / i, w = 0; w <= i; w++) b += x, s.push(b);
                    return s[s.length - 2] >= e && s.pop(), {
                        result: s,
                        niceMin: s[0],
                        niceMax: s[s.length - 1]
                    }
                }
            }, {
                key: "linearScale",
                value: function (t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10,
                        n = arguments.length > 3 ? arguments[3] : void 0,
                        l = Math.abs(e - t);
                    "dataPoints" === (i = this._adjustTicksForSmallRange(i, n, l)) && (i = this.w.globals.dataPoints - 1);
                    var r = l / i;
                    i === Number.MAX_VALUE && (i = 10, r = 1);
                    for (var a = [], o = t; i >= 0;) a.push(o), o += r, i -= 1;
                    return {
                        result: a,
                        niceMin: a[0],
                        niceMax: a[a.length - 1]
                    }
                }
            }, {
                key: "logarithmicScale",
                value: function (t) {
                    for (var e = [], i = Math.ceil(Math.log10(t)) + 1, n = 0; n < i; n++) e.push(Math.pow(10, n));
                    return {
                        result: e,
                        niceMin: e[0],
                        niceMax: e[e.length - 1]
                    }
                }
            }, {
                key: "_adjustTicksForSmallRange",
                value: function (t, e, i) {
                    var n = t;
                    if (void 0 !== e && this.w.config.yaxis[e].labels.formatter && void 0 === this.w.config.yaxis[e].tickAmount) {
                        var l = this.w.config.yaxis[e].labels.formatter(1);
                        y.isNumber(Number(l)) && !y.isFloat(l) && (n = Math.ceil(i))
                    }
                    return n < t ? n : t
                }
            }, {
                key: "setYScaleForIndex",
                value: function (t, e, i) {
                    var n = this.w.globals,
                        l = this.w.config,
                        r = n.isBarHorizontal ? l.xaxis : l.yaxis[t];
                    void 0 === n.yAxisScale[t] && (n.yAxisScale[t] = []);
                    var a = Math.abs(i - e);
                    if (r.logarithmic && a <= 5 && (n.invalidLogScale = !0), r.logarithmic && a > 5) n.allSeriesCollapsed = !1, n.yAxisScale[t] = this.logarithmicScale(i);
                    else if (i !== -Number.MAX_VALUE && y.isNumber(i))
                        if (n.allSeriesCollapsed = !1, void 0 === r.min && void 0 === r.max || r.forceNiceScale) {
                            var o = void 0 === l.yaxis[t].max && void 0 === l.yaxis[t].min || l.yaxis[t].forceNiceScale;
                            n.yAxisScale[t] = this.niceScale(e, i, r.tickAmount ? r.tickAmount : a < 5 && a > 1 ? a + 1 : 5, t, o)
                        } else n.yAxisScale[t] = this.linearScale(e, i, r.tickAmount, t);
                    else n.yAxisScale[t] = this.linearScale(0, 5, 5)
                }
            }, {
                key: "setXScale",
                value: function (t, e) {
                    var i = this.w,
                        n = i.globals,
                        l = i.config.xaxis,
                        r = Math.abs(e - t);
                    return e !== -Number.MAX_VALUE && y.isNumber(e) ? n.xAxisScale = this.linearScale(t, e, l.tickAmount ? l.tickAmount : r < 5 && r > 1 ? r + 1 : 5, 0) : n.xAxisScale = this.linearScale(0, 5, 5), n.xAxisScale
                }
            }, {
                key: "setMultipleYScales",
                value: function () {
                    var t = this,
                        e = this.w.globals,
                        i = this.w.config,
                        n = e.minYArr.concat([]),
                        l = e.maxYArr.concat([]),
                        r = [];
                    i.yaxis.forEach((function (e, a) {
                        var o = a;
                        i.series.forEach((function (t, i) {
                            t.name === e.seriesName && (o = i, a !== i ? r.push({
                                index: i,
                                similarIndex: a,
                                alreadyExists: !0
                            }) : r.push({
                                index: i
                            }))
                        }));
                        var s = n[o],
                            c = l[o];
                        t.setYScaleForIndex(a, s, c)
                    })), this.sameScaleInMultipleAxes(n, l, r)
                }
            }, {
                key: "sameScaleInMultipleAxes",
                value: function (t, e, i) {
                    var n = this,
                        l = this.w.config,
                        r = this.w.globals,
                        a = [];
                    i.forEach((function (t) {
                        t.alreadyExists && (void 0 === a[t.index] && (a[t.index] = []), a[t.index].push(t.index), a[t.index].push(t.similarIndex))
                    })), r.yAxisSameScaleIndices = a, a.forEach((function (t, e) {
                        a.forEach((function (i, n) {
                            var l, r;
                            e !== n && (l = t, r = i, l.filter((function (t) {
                                return -1 !== r.indexOf(t)
                            }))).length > 0 && (a[e] = a[e].concat(a[n]))
                        }))
                    }));
                    var o = a.map((function (t) {
                        return t.filter((function (e, i) {
                            return t.indexOf(e) === i
                        }))
                    })).map((function (t) {
                        return t.sort()
                    }));
                    a = a.filter((function (t) {
                        return !!t
                    }));
                    var s = o.slice(),
                        c = s.map((function (t) {
                            return JSON.stringify(t)
                        }));
                    s = s.filter((function (t, e) {
                        return c.indexOf(JSON.stringify(t)) === e
                    }));
                    var u = [],
                        h = [];
                    t.forEach((function (t, i) {
                        s.forEach((function (n, l) {
                            n.indexOf(i) > -1 && (void 0 === u[l] && (u[l] = [], h[l] = []), u[l].push({
                                key: i,
                                value: t
                            }), h[l].push({
                                key: i,
                                value: e[i]
                            }))
                        }))
                    }));
                    var d = Array.apply(null, Array(s.length)).map(Number.prototype.valueOf, Number.MIN_VALUE),
                        f = Array.apply(null, Array(s.length)).map(Number.prototype.valueOf, -Number.MAX_VALUE);
                    u.forEach((function (t, e) {
                        t.forEach((function (t, i) {
                            d[e] = Math.min(t.value, d[e])
                        }))
                    })), h.forEach((function (t, e) {
                        t.forEach((function (t, i) {
                            f[e] = Math.max(t.value, f[e])
                        }))
                    })), t.forEach((function (t, e) {
                        h.forEach((function (t, i) {
                            var a = d[i],
                                o = f[i];
                            l.chart.stacked && (o = 0, t.forEach((function (t, e) {
                                t.value !== -Number.MAX_VALUE && (o += t.value), a !== Number.MIN_VALUE && (a += u[i][e].value)
                            }))), t.forEach((function (i, s) {
                                t[s].key === e && (void 0 !== l.yaxis[e].min && (a = "function" == typeof l.yaxis[e].min ? l.yaxis[e].min(r.minY) : l.yaxis[e].min), void 0 !== l.yaxis[e].max && (o = "function" == typeof l.yaxis[e].max ? l.yaxis[e].max(r.maxY) : l.yaxis[e].max), n.setYScaleForIndex(e, a, o))
                            }))
                        }))
                    }))
                }
            }, {
                key: "autoScaleY",
                value: function (t, e, i) {
                    t || (t = this);
                    var n = t.w;
                    if (n.globals.isMultipleYAxis || n.globals.collapsedSeries.length) return console.warn("autoScaleYaxis is not supported in a multi-yaxis chart."), e;
                    var l = n.globals.seriesX[0],
                        r = n.config.chart.stacked;
                    return e.forEach((function (t, a) {
                        for (var o = 0, s = 0; s < l.length; s++)
                            if (l[s] >= i.xaxis.min) {
                                o = s;
                                break
                            } var c, u, h = n.globals.minYArr[a],
                            d = n.globals.maxYArr[a],
                            f = n.globals.stackedSeriesTotals;
                        n.globals.series.forEach((function (a, s) {
                            var p = a[o];
                            r ? (p = f[o], c = u = p, f.forEach((function (t, e) {
                                l[e] <= i.xaxis.max && l[e] >= i.xaxis.min && (t > u && null !== t && (u = t), a[e] < c && null !== a[e] && (c = a[e]))
                            }))) : (c = u = p, a.forEach((function (t, e) {
                                if (l[e] <= i.xaxis.max && l[e] >= i.xaxis.min) {
                                    var r = t,
                                        a = t;
                                    n.globals.series.forEach((function (i, n) {
                                        null !== t && (r = Math.min(i[e], r), a = Math.max(i[e], a))
                                    })), a > u && null !== a && (u = a), r < c && null !== r && (c = r)
                                }
                            }))), void 0 === c && void 0 === u && (c = h, u = d), (u *= u < 0 ? .9 : 1.1) < 0 && u < d && (u = d), (c *= c < 0 ? 1.1 : .9) < 0 && c > h && (c = h), e.length > 1 ? (e[s].min = void 0 === t.min ? c : t.min, e[s].max = void 0 === t.max ? u : t.max) : (e[0].min = void 0 === t.min ? c : t.min, e[0].max = void 0 === t.max ? u : t.max)
                        }))
                    })), e
                }
            }]), t
        }(),
        $ = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.scales = new K(e)
            }
            return o(t, [{
                key: "init",
                value: function () {
                    this.setYRange(), this.setXRange(), this.setZRange()
                }
            }, {
                key: "getMinYMaxY",
                value: function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE,
                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -Number.MAX_VALUE,
                        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
                        l = this.w.config,
                        r = this.w.globals,
                        a = -Number.MAX_VALUE,
                        o = Number.MIN_VALUE;
                    null === n && (n = t + 1);
                    var s = r.series,
                        c = s,
                        u = s;
                    "candlestick" === l.chart.type ? (c = r.seriesCandleL, u = r.seriesCandleH) : "boxPlot" === l.chart.type ? (c = r.seriesCandleO, u = r.seriesCandleC) : r.isRangeData && (c = r.seriesRangeStart, u = r.seriesRangeEnd);
                    for (var h = t; h < n; h++) {
                        r.dataPoints = Math.max(r.dataPoints, s[h].length);
                        for (var d = 0; d < r.series[h].length; d++) {
                            var f = s[h][d];
                            null !== f && y.isNumber(f) ? (void 0 !== u[h][d] && (a = Math.max(a, u[h][d])), void 0 !== c[h][d] && (e = Math.min(e, c[h][d]), i = Math.max(i, c[h][d])), "candlestick" !== this.w.config.chart.type && "boxPlot" !== this.w.config.chart.type || (void 0 !== r.seriesCandleC[h][d] && (a = Math.max(a, r.seriesCandleO[h][d]), a = Math.max(a, r.seriesCandleH[h][d]), a = Math.max(a, r.seriesCandleL[h][d]), a = Math.max(a, r.seriesCandleC[h][d]), "boxPlot" === this.w.config.chart.type && (a = Math.max(a, r.seriesCandleM[h][d]))), !l.series[h].type || "candlestick" === l.series[h].type && "boxPlot" === l.series[h].type || (a = Math.max(a, r.series[h][d]), e = Math.min(e, r.series[h][d])), i = a), y.isFloat(f) && (f = y.noExponents(f), r.yValueDecimal = Math.max(r.yValueDecimal, f.toString().split(".")[1].length)), o > c[h][d] && c[h][d] < 0 && (o = c[h][d])) : r.hasNullValues = !0
                        }
                    }
                    return "rangeBar" === l.chart.type && r.seriesRangeStart.length && r.isBarHorizontal && "datetime" === l.xaxis.type && (o = e), "bar" === l.chart.type && (o < 0 && a < 0 && (a = 0), o === Number.MIN_VALUE && (o = 0)), {
                        minY: o,
                        maxY: a,
                        lowestY: e,
                        highestY: i
                    }
                }
            }, {
                key: "setYRange",
                value: function () {
                    var t = this.w.globals,
                        e = this.w.config;
                    t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE;
                    var i = Number.MAX_VALUE;
                    if (t.isMultipleYAxis)
                        for (var n = 0; n < t.series.length; n++) {
                            var l = this.getMinYMaxY(n, i, null, n + 1);
                            t.minYArr.push(l.minY), t.maxYArr.push(l.maxY), i = l.lowestY
                        }
                    var r = this.getMinYMaxY(0, i, null, t.series.length);
                    if (t.minY = r.minY, t.maxY = r.maxY, i = r.lowestY, e.chart.stacked && this._setStackedMinMax(), ("line" === e.chart.type || "area" === e.chart.type || "candlestick" === e.chart.type || "boxPlot" === e.chart.type || "rangeBar" === e.chart.type && !t.isBarHorizontal) && t.minY === Number.MIN_VALUE && i !== -Number.MAX_VALUE && i !== t.maxY) {
                        var a = t.maxY - i;
                        (i >= 0 && i <= 10 || void 0 !== e.yaxis[0].min || void 0 !== e.yaxis[0].max) && (a = 0), t.minY = i - 5 * a / 100, i > 0 && t.minY < 0 && (t.minY = 0), t.maxY = t.maxY + 5 * a / 100
                    }
                    return e.yaxis.forEach((function (e, i) {
                        void 0 !== e.max && ("number" == typeof e.max ? t.maxYArr[i] = e.max : "function" == typeof e.max && (t.maxYArr[i] = e.max(t.isMultipleYAxis ? t.maxYArr[i] : t.maxY)), t.maxY = t.maxYArr[i]), void 0 !== e.min && ("number" == typeof e.min ? t.minYArr[i] = e.min : "function" == typeof e.min && (t.minYArr[i] = e.min(t.isMultipleYAxis ? t.minYArr[i] === Number.MIN_VALUE ? 0 : t.minYArr[i] : t.minY)), t.minY = t.minYArr[i])
                    })), t.isBarHorizontal && ["min", "max"].forEach((function (i) {
                        void 0 !== e.xaxis[i] && "number" == typeof e.xaxis[i] && ("min" === i ? t.minY = e.xaxis[i] : t.maxY = e.xaxis[i])
                    })), t.isMultipleYAxis ? (this.scales.setMultipleYScales(), t.minY = i, t.yAxisScale.forEach((function (e, i) {
                        t.minYArr[i] = e.niceMin, t.maxYArr[i] = e.niceMax
                    }))) : (this.scales.setYScaleForIndex(0, t.minY, t.maxY), t.minY = t.yAxisScale[0].niceMin, t.maxY = t.yAxisScale[0].niceMax, t.minYArr[0] = t.yAxisScale[0].niceMin, t.maxYArr[0] = t.yAxisScale[0].niceMax), {
                        minY: t.minY,
                        maxY: t.maxY,
                        minYArr: t.minYArr,
                        maxYArr: t.maxYArr,
                        yAxisScale: t.yAxisScale
                    }
                }
            }, {
                key: "setXRange",
                value: function () {
                    var t = this.w.globals,
                        e = this.w.config,
                        i = "numeric" === e.xaxis.type || "datetime" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided || t.noLabelsProvided || t.isXNumeric;
                    if (t.isXNumeric && function () {
                            for (var e = 0; e < t.series.length; e++)
                                if (t.labels[e])
                                    for (var i = 0; i < t.labels[e].length; i++) null !== t.labels[e][i] && y.isNumber(t.labels[e][i]) && (t.maxX = Math.max(t.maxX, t.labels[e][i]), t.initialMaxX = Math.max(t.maxX, t.labels[e][i]), t.minX = Math.min(t.minX, t.labels[e][i]), t.initialMinX = Math.min(t.minX, t.labels[e][i]))
                        }(), t.noLabelsProvided && 0 === e.xaxis.categories.length && (t.maxX = t.labels[t.labels.length - 1], t.initialMaxX = t.labels[t.labels.length - 1], t.minX = 1, t.initialMinX = 1), t.isXNumeric || t.noLabelsProvided || t.dataFormatXNumeric) {
                        var n;
                        if (void 0 === e.xaxis.tickAmount ? (n = Math.round(t.svgWidth / 150), "numeric" === e.xaxis.type && t.dataPoints < 30 && (n = t.dataPoints - 1), n > t.dataPoints && 0 !== t.dataPoints && (n = t.dataPoints - 1)) : "dataPoints" === e.xaxis.tickAmount ? (t.series.length > 1 && (n = t.series[t.maxValsInArrayIndex].length - 1), t.isXNumeric && (n = t.maxX - t.minX - 1)) : n = e.xaxis.tickAmount, t.xTickAmount = n, void 0 !== e.xaxis.max && "number" == typeof e.xaxis.max && (t.maxX = e.xaxis.max), void 0 !== e.xaxis.min && "number" == typeof e.xaxis.min && (t.minX = e.xaxis.min), void 0 !== e.xaxis.range && (t.minX = t.maxX - e.xaxis.range), t.minX !== Number.MAX_VALUE && t.maxX !== -Number.MAX_VALUE)
                            if (e.xaxis.convertedCatToNumeric && !t.dataFormatXNumeric) {
                                for (var l = [], r = t.minX - 1; r < t.maxX; r++) l.push(r + 1);
                                t.xAxisScale = {
                                    result: l,
                                    niceMin: l[0],
                                    niceMax: l[l.length - 1]
                                }
                            } else t.xAxisScale = this.scales.setXScale(t.minX, t.maxX);
                        else t.xAxisScale = this.scales.linearScale(1, n, n), t.noLabelsProvided && t.labels.length > 0 && (t.xAxisScale = this.scales.linearScale(1, t.labels.length, n - 1), t.seriesX = t.labels.slice());
                        i && (t.labels = t.xAxisScale.result.slice())
                    }
                    return t.isBarHorizontal && t.labels.length && (t.xTickAmount = t.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), {
                        minX: t.minX,
                        maxX: t.maxX
                    }
                }
            }, {
                key: "setZRange",
                value: function () {
                    var t = this.w.globals;
                    if (t.isDataXYZ)
                        for (var e = 0; e < t.series.length; e++)
                            if (void 0 !== t.seriesZ[e])
                                for (var i = 0; i < t.seriesZ[e].length; i++) null !== t.seriesZ[e][i] && y.isNumber(t.seriesZ[e][i]) && (t.maxZ = Math.max(t.maxZ, t.seriesZ[e][i]), t.minZ = Math.min(t.minZ, t.seriesZ[e][i]))
                }
            }, {
                key: "_handleSingleDataPoint",
                value: function () {
                    var t = this.w.globals,
                        e = this.w.config;
                    if (t.minX === t.maxX) {
                        var i = new F(this.ctx);
                        if ("datetime" === e.xaxis.type) {
                            var n = i.getDate(t.minX);
                            n.setUTCDate(n.getDate() - 2), t.minX = new Date(n).getTime();
                            var l = i.getDate(t.maxX);
                            l.setUTCDate(l.getDate() + 2), t.maxX = new Date(l).getTime()
                        } else("numeric" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided) && (t.minX = t.minX - 2, t.initialMinX = t.minX, t.maxX = t.maxX + 2, t.initialMaxX = t.maxX)
                    }
                }
            }, {
                key: "_getMinXDiff",
                value: function () {
                    var t = this.w.globals;
                    t.isXNumeric && t.seriesX.forEach((function (e, i) {
                        1 === e.length && e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length - 1]);
                        var n = e.slice();
                        n.sort((function (t, e) {
                            return t - e
                        })), n.forEach((function (e, i) {
                            if (i > 0) {
                                var l = e - n[i - 1];
                                l > 0 && (t.minXDiff = Math.min(l, t.minXDiff))
                            }
                        })), 1 === t.dataPoints && t.minXDiff === Number.MAX_VALUE && (t.minXDiff = .5)
                    }))
                }
            }, {
                key: "_setStackedMinMax",
                value: function () {
                    var t = this.w.globals,
                        e = [],
                        i = [];
                    if (t.series.length)
                        for (var n = 0; n < t.series[t.maxValsInArrayIndex].length; n++)
                            for (var l = 0, r = 0, a = 0; a < t.series.length; a++) null !== t.series[a][n] && y.isNumber(t.series[a][n]) && (t.series[a][n] > 0 ? l = l + parseFloat(t.series[a][n]) + 1e-4 : r += parseFloat(t.series[a][n])), a === t.series.length - 1 && (e.push(l), i.push(r));
                    for (var o = 0; o < e.length; o++) t.maxY = Math.max(t.maxY, e[o]), t.minY = Math.min(t.minY, i[o])
                }
            }]), t
        }(),
        Q = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w;
                var i = this.w;
                this.xaxisFontSize = i.config.xaxis.labels.style.fontSize, this.axisFontFamily = i.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = i.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = "bar" === i.config.chart.type && i.config.plotOptions.bar.horizontal, this.xAxisoffX = 0, "bottom" === i.config.xaxis.position && (this.xAxisoffX = i.globals.gridHeight), this.drawnLabels = [], this.axesUtils = new q(e)
            }
            return o(t, [{
                key: "drawYaxis",
                value: function (t) {
                    var e = this,
                        i = this.w,
                        n = new w(this.ctx),
                        l = i.config.yaxis[t].labels.style,
                        r = l.fontSize,
                        a = l.fontFamily,
                        o = l.fontWeight,
                        s = n.group({
                            class: "apexcharts-yaxis",
                            rel: t,
                            transform: "translate(" + i.globals.translateYAxisX[t] + ", 0)"
                        });
                    if (this.axesUtils.isYAxisHidden(t)) return s;
                    var c = n.group({
                        class: "apexcharts-yaxis-texts-g"
                    });
                    s.add(c);
                    var u = i.globals.yAxisScale[t].result.length - 1,
                        h = i.globals.gridHeight / u,
                        d = i.globals.translateY,
                        f = i.globals.yLabelFormatters[t],
                        p = i.globals.yAxisScale[t].result.slice();
                    p = this.axesUtils.checkForReversedLabels(t, p);
                    var g = "";
                    if (i.config.yaxis[t].labels.show)
                        for (var m = function (s) {
                                var m = p[s];
                                m = f(m, s);
                                var v = i.config.yaxis[t].labels.padding;
                                i.config.yaxis[t].opposite && 0 !== i.config.yaxis.length && (v *= -1);
                                var y = e.axesUtils.getYAxisForeColor(l.colors, t),
                                    b = n.drawText({
                                        x: v,
                                        y: d + u / 10 + i.config.yaxis[t].labels.offsetY + 1,
                                        text: m,
                                        textAnchor: i.config.yaxis[t].opposite ? "start" : "end",
                                        fontSize: r,
                                        fontFamily: a,
                                        fontWeight: o,
                                        foreColor: Array.isArray(y) ? y[s] : y,
                                        isPlainText: !1,
                                        cssClass: "apexcharts-yaxis-label " + l.cssClass
                                    });
                                if (s === u && (g = b), c.add(b), 0 !== i.config.yaxis[t].labels.rotate) {
                                    var x = n.rotateAroundCenter(g.node),
                                        w = n.rotateAroundCenter(b.node);
                                    b.node.setAttribute("transform", "rotate(".concat(i.config.yaxis[t].labels.rotate, " ").concat(x.x, " ").concat(w.y, ")"))
                                }
                                d += h
                            }, v = u; v >= 0; v--) m(v);
                    if (void 0 !== i.config.yaxis[t].title.text) {
                        var y = n.group({
                                class: "apexcharts-yaxis-title"
                            }),
                            b = 0;
                        i.config.yaxis[t].opposite && (b = i.globals.translateYAxisX[t]);
                        var x = n.drawText({
                            x: b,
                            y: i.globals.gridHeight / 2 + i.globals.translateY + i.config.yaxis[t].title.offsetY,
                            text: i.config.yaxis[t].title.text,
                            textAnchor: "end",
                            foreColor: i.config.yaxis[t].title.style.color,
                            fontSize: i.config.yaxis[t].title.style.fontSize,
                            fontWeight: i.config.yaxis[t].title.style.fontWeight,
                            fontFamily: i.config.yaxis[t].title.style.fontFamily,
                            cssClass: "apexcharts-yaxis-title-text " + i.config.yaxis[t].title.style.cssClass
                        });
                        y.add(x), s.add(y)
                    }
                    var _ = i.config.yaxis[t].axisBorder,
                        k = 31 + _.offsetX;
                    if (i.config.yaxis[t].opposite && (k = -31 - _.offsetX), _.show) {
                        var S = n.drawLine(k, i.globals.translateY + _.offsetY - 2, k, i.globals.gridHeight + i.globals.translateY + _.offsetY + 2, _.color, 0, _.width);
                        s.add(S)
                    }
                    return i.config.yaxis[t].axisTicks.show && this.axesUtils.drawYAxisTicks(k, u, _, i.config.yaxis[t].axisTicks, t, h, s), s
                }
            }, {
                key: "drawYaxisInversed",
                value: function (t) {
                    var e = this.w,
                        i = new w(this.ctx),
                        n = i.group({
                            class: "apexcharts-xaxis apexcharts-yaxis-inversed"
                        }),
                        l = i.group({
                            class: "apexcharts-xaxis-texts-g",
                            transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")")
                        });
                    n.add(l);
                    var r = e.globals.yAxisScale[t].result.length - 1,
                        a = e.globals.gridWidth / r + .1,
                        o = a + e.config.xaxis.labels.offsetX,
                        s = e.globals.xLabelFormatter,
                        c = e.globals.yAxisScale[t].result.slice(),
                        u = e.globals.timescaleLabels;
                    u.length > 0 && (this.xaxisLabels = u.slice(), r = (c = u.slice()).length), c = this.axesUtils.checkForReversedLabels(t, c);
                    var h = u.length;
                    if (e.config.xaxis.labels.show)
                        for (var d = h ? 0 : r; h ? d < h : d >= 0; h ? d++ : d--) {
                            var f = c[d];
                            f = s(f, d);
                            var p = e.globals.gridWidth + e.globals.padHorizontal - (o - a + e.config.xaxis.labels.offsetX);
                            if (u.length) {
                                var g = this.axesUtils.getLabel(c, u, p, d, this.drawnLabels, this.xaxisFontSize);
                                p = g.x, f = g.text, this.drawnLabels.push(g.text), 0 === d && e.globals.skipFirstTimelinelabel && (f = ""), d === c.length - 1 && e.globals.skipLastTimelinelabel && (f = "")
                            }
                            var m = i.drawText({
                                x: p,
                                y: this.xAxisoffX + e.config.xaxis.labels.offsetY + 30 - ("top" === e.config.xaxis.position ? e.globals.xAxisHeight + e.config.xaxis.axisTicks.height - 2 : 0),
                                text: f,
                                textAnchor: "middle",
                                foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[t] : this.xaxisForeColors,
                                fontSize: this.xaxisFontSize,
                                fontFamily: this.xaxisFontFamily,
                                fontWeight: e.config.xaxis.labels.style.fontWeight,
                                isPlainText: !1,
                                cssClass: "apexcharts-xaxis-label " + e.config.xaxis.labels.style.cssClass
                            });
                            l.add(m), m.tspan(f);
                            var v = document.createElementNS(e.globals.SVGNS, "title");
                            v.textContent = f, m.node.appendChild(v), o += a
                        }
                    return this.inversedYAxisTitleText(n), this.inversedYAxisBorder(n), n
                }
            }, {
                key: "inversedYAxisBorder",
                value: function (t) {
                    var e = this.w,
                        i = new w(this.ctx),
                        n = e.config.xaxis.axisBorder;
                    if (n.show) {
                        var l = 0;
                        "bar" === e.config.chart.type && e.globals.isXNumeric && (l -= 15);
                        var r = i.drawLine(e.globals.padHorizontal + l + n.offsetX, this.xAxisoffX, e.globals.gridWidth, this.xAxisoffX, n.color, 0, n.height);
                        t.add(r)
                    }
                }
            }, {
                key: "inversedYAxisTitleText",
                value: function (t) {
                    var e = this.w,
                        i = new w(this.ctx);
                    if (void 0 !== e.config.xaxis.title.text) {
                        var n = i.group({
                                class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed"
                            }),
                            l = i.drawText({
                                x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX,
                                y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(e.config.xaxis.title.style.fontSize) + e.config.xaxis.title.offsetY + 20,
                                text: e.config.xaxis.title.text,
                                textAnchor: "middle",
                                fontSize: e.config.xaxis.title.style.fontSize,
                                fontFamily: e.config.xaxis.title.style.fontFamily,
                                fontWeight: e.config.xaxis.title.style.fontWeight,
                                foreColor: e.config.xaxis.title.style.color,
                                cssClass: "apexcharts-xaxis-title-text " + e.config.xaxis.title.style.cssClass
                            });
                        n.add(l), t.add(n)
                    }
                }
            }, {
                key: "yAxisTitleRotate",
                value: function (t, e) {
                    var i = this.w,
                        n = new w(this.ctx),
                        l = {
                            width: 0,
                            height: 0
                        },
                        r = {
                            width: 0,
                            height: 0
                        },
                        a = i.globals.dom.baseEl.querySelector(" .apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-texts-g"));
                    null !== a && (l = a.getBoundingClientRect());
                    var o = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-title text"));
                    if (null !== o && (r = o.getBoundingClientRect()), null !== o) {
                        var s = this.xPaddingForYAxisTitle(t, l, r, e);
                        o.setAttribute("x", s.xPos - (e ? 10 : 0))
                    }
                    if (null !== o) {
                        var c = n.rotateAroundCenter(o);
                        o.setAttribute("transform", "rotate(".concat(e ? -1 * i.config.yaxis[t].title.rotate : i.config.yaxis[t].title.rotate, " ").concat(c.x, " ").concat(c.y, ")"))
                    }
                }
            }, {
                key: "xPaddingForYAxisTitle",
                value: function (t, e, i, n) {
                    var l = this.w,
                        r = 0,
                        a = 0,
                        o = 10;
                    return void 0 === l.config.yaxis[t].title.text || t < 0 ? {
                        xPos: a,
                        padd: 0
                    } : (n ? (a = e.width + l.config.yaxis[t].title.offsetX + i.width / 2 + o / 2, 0 === (r += 1) && (a -= o / 2)) : (a = -1 * e.width + l.config.yaxis[t].title.offsetX + o / 2 + i.width / 2, l.globals.isBarHorizontal && (o = 25, a = -1 * e.width - l.config.yaxis[t].title.offsetX - o)), {
                        xPos: a,
                        padd: o
                    })
                }
            }, {
                key: "setYAxisXPosition",
                value: function (t, e) {
                    var i = this.w,
                        n = 0,
                        l = 0,
                        r = 18,
                        a = 1;
                    i.config.yaxis.length > 1 && (this.multipleYs = !0), i.config.yaxis.map((function (o, s) {
                        var c = i.globals.ignoreYAxisIndexes.indexOf(s) > -1 || !o.show || o.floating || 0 === t[s].width,
                            u = t[s].width + e[s].width;
                        o.opposite ? i.globals.isBarHorizontal ? (l = i.globals.gridWidth + i.globals.translateX - 1, i.globals.translateYAxisX[s] = l - o.labels.offsetX) : (l = i.globals.gridWidth + i.globals.translateX + a, c || (a = a + u + 20), i.globals.translateYAxisX[s] = l - o.labels.offsetX + 20) : (n = i.globals.translateX - r, c || (r = r + u + 20), i.globals.translateYAxisX[s] = n + o.labels.offsetX)
                    }))
                }
            }, {
                key: "setYAxisTextAlignments",
                value: function () {
                    var t = this.w,
                        e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis");
                    (e = y.listToArray(e)).forEach((function (e, i) {
                        var n = t.config.yaxis[i];
                        if (n && void 0 !== n.labels.align) {
                            var l = t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-texts-g")),
                                r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-label"));
                            r = y.listToArray(r);
                            var a = l.getBoundingClientRect();
                            "left" === n.labels.align ? (r.forEach((function (t, e) {
                                t.setAttribute("text-anchor", "start")
                            })), n.opposite || l.setAttribute("transform", "translate(-".concat(a.width, ", 0)"))) : "center" === n.labels.align ? (r.forEach((function (t, e) {
                                t.setAttribute("text-anchor", "middle")
                            })), l.setAttribute("transform", "translate(".concat(a.width / 2 * (n.opposite ? 1 : -1), ", 0)"))) : "right" === n.labels.align && (r.forEach((function (t, e) {
                                t.setAttribute("text-anchor", "end")
                            })), n.opposite && l.setAttribute("transform", "translate(".concat(a.width, ", 0)")))
                        }
                    }))
                }
            }]), t
        }(),
        J = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.documentEvent = y.bind(this.documentEvent, this)
            }
            return o(t, [{
                key: "addEventListener",
                value: function (t, e) {
                    var i = this.w;
                    i.globals.events.hasOwnProperty(t) ? i.globals.events[t].push(e) : i.globals.events[t] = [e]
                }
            }, {
                key: "removeEventListener",
                value: function (t, e) {
                    var i = this.w;
                    if (i.globals.events.hasOwnProperty(t)) {
                        var n = i.globals.events[t].indexOf(e); - 1 !== n && i.globals.events[t].splice(n, 1)
                    }
                }
            }, {
                key: "fireEvent",
                value: function (t, e) {
                    var i = this.w;
                    if (i.globals.events.hasOwnProperty(t)) {
                        e && e.length || (e = []);
                        for (var n = i.globals.events[t], l = n.length, r = 0; r < l; r++) n[r].apply(null, e)
                    }
                }
            }, {
                key: "setupEventHandlers",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = this.ctx,
                        n = e.globals.dom.baseEl.querySelector(e.globals.chartClass);
                    this.ctx.eventList.forEach((function (t) {
                        n.addEventListener(t, (function (t) {
                            var n = Object.assign({}, e, {
                                seriesIndex: e.globals.capturedSeriesIndex,
                                dataPointIndex: e.globals.capturedDataPointIndex
                            });
                            "mousemove" === t.type || "touchmove" === t.type ? "function" == typeof e.config.chart.events.mouseMove && e.config.chart.events.mouseMove(t, i, n) : ("mouseup" === t.type && 1 === t.which || "touchend" === t.type) && ("function" == typeof e.config.chart.events.click && e.config.chart.events.click(t, i, n), i.ctx.events.fireEvent("click", [t, i, n]))
                        }), {
                            capture: !1,
                            passive: !0
                        })
                    })), this.ctx.eventList.forEach((function (i) {
                        e.globals.dom.baseEl.addEventListener(i, t.documentEvent, {
                            passive: !0
                        })
                    })), this.ctx.core.setupBrushHandler()
                }
            }, {
                key: "documentEvent",
                value: function (t) {
                    var e = this.w,
                        i = t.target.className;
                    if ("click" === t.type) {
                        var n = e.globals.dom.baseEl.querySelector(".apexcharts-menu");
                        n && n.classList.contains("apexcharts-menu-open") && "apexcharts-menu-icon" !== i && n.classList.remove("apexcharts-menu-open")
                    }
                    e.globals.clientX = "touchmove" === t.type ? t.touches[0].clientX : t.clientX, e.globals.clientY = "touchmove" === t.type ? t.touches[0].clientY : t.clientY
                }
            }]), t
        }(),
        tt = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "setCurrentLocaleValues",
                value: function (t) {
                    var e = this.w.config.chart.locales;
                    window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (e = this.w.config.chart.locales.concat(window.Apex.chart.locales));
                    var i = e.filter((function (e) {
                        return e.name === t
                    }))[0];
                    if (!i) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
                    var n = y.extend(C, i);
                    this.w.globals.locale = n.options
                }
            }]), t
        }(),
        et = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "drawAxis",
                value: function (t, e) {
                    var i, n, l = this.w.globals,
                        r = this.w.config,
                        a = new G(this.ctx),
                        o = new Q(this.ctx);
                    l.axisCharts && "radar" !== t && (l.isBarHorizontal ? (n = o.drawYaxisInversed(0), i = a.drawXaxisInversed(0), l.dom.elGraphical.add(i), l.dom.elGraphical.add(n)) : (i = a.drawXaxis(), l.dom.elGraphical.add(i), r.yaxis.map((function (t, e) {
                        -1 === l.ignoreYAxisIndexes.indexOf(e) && (n = o.drawYaxis(e), l.dom.Paper.add(n))
                    }))))
                }
            }]), t
        }(),
        it = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "drawXCrosshairs",
                value: function () {
                    var t = this.w,
                        e = new w(this.ctx),
                        i = new x(this.ctx),
                        n = t.config.xaxis.crosshairs.fill.gradient,
                        l = t.config.xaxis.crosshairs.dropShadow,
                        r = t.config.xaxis.crosshairs.fill.type,
                        a = n.colorFrom,
                        o = n.colorTo,
                        s = n.opacityFrom,
                        c = n.opacityTo,
                        u = n.stops,
                        h = l.enabled,
                        d = l.left,
                        f = l.top,
                        p = l.blur,
                        g = l.color,
                        m = l.opacity,
                        v = t.config.xaxis.crosshairs.fill.color;
                    if (t.config.xaxis.crosshairs.show) {
                        "gradient" === r && (v = e.drawGradient("vertical", a, o, s, c, null, u, null));
                        var b = e.drawRect();
                        1 === t.config.xaxis.crosshairs.width && (b = e.drawLine()), b.attr({
                            class: "apexcharts-xcrosshairs",
                            x: 0,
                            y: 0,
                            y2: t.globals.gridHeight,
                            width: y.isNumber(t.config.xaxis.crosshairs.width) ? t.config.xaxis.crosshairs.width : 0,
                            height: t.globals.gridHeight,
                            fill: v,
                            filter: "none",
                            "fill-opacity": t.config.xaxis.crosshairs.opacity,
                            stroke: t.config.xaxis.crosshairs.stroke.color,
                            "stroke-width": t.config.xaxis.crosshairs.stroke.width,
                            "stroke-dasharray": t.config.xaxis.crosshairs.stroke.dashArray
                        }), h && (b = i.dropShadow(b, {
                            left: d,
                            top: f,
                            blur: p,
                            color: g,
                            opacity: m
                        })), t.globals.dom.elGraphical.add(b)
                    }
                }
            }, {
                key: "drawYCrosshairs",
                value: function () {
                    var t = this.w,
                        e = new w(this.ctx),
                        i = t.config.yaxis[0].crosshairs,
                        n = t.globals.barPadForNumericAxis;
                    if (t.config.yaxis[0].crosshairs.show) {
                        var l = e.drawLine(-n, 0, t.globals.gridWidth + n, 0, i.stroke.color, i.stroke.dashArray, i.stroke.width);
                        l.attr({
                            class: "apexcharts-ycrosshairs"
                        }), t.globals.dom.elGraphical.add(l)
                    }
                    var r = e.drawLine(-n, 0, t.globals.gridWidth + n, 0, i.stroke.color, 0, 0);
                    r.attr({
                        class: "apexcharts-ycrosshairs-hidden"
                    }), t.globals.dom.elGraphical.add(r)
                }
            }]), t
        }(),
        nt = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "checkResponsiveConfig",
                value: function (t) {
                    var e = this,
                        i = this.w,
                        n = i.config;
                    if (0 !== n.responsive.length) {
                        var l = n.responsive.slice();
                        l.sort((function (t, e) {
                            return t.breakpoint > e.breakpoint ? 1 : e.breakpoint > t.breakpoint ? -1 : 0
                        })).reverse();
                        var r = new B({}),
                            a = function () {
                                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                                    n = l[0].breakpoint,
                                    a = window.innerWidth > 0 ? window.innerWidth : screen.width;
                                if (a > n) {
                                    var o = S.extendArrayProps(r, i.globals.initialConfig, i);
                                    t = y.extend(o, t), t = y.extend(i.config, t), e.overrideResponsiveOptions(t)
                                } else
                                    for (var s = 0; s < l.length; s++) a < l[s].breakpoint && (t = S.extendArrayProps(r, l[s].options, i), t = y.extend(i.config, t), e.overrideResponsiveOptions(t))
                            };
                        if (t) {
                            var o = S.extendArrayProps(r, t, i);
                            o = y.extend(i.config, o), a(o = y.extend(o, t))
                        } else a({})
                    }
                }
            }, {
                key: "overrideResponsiveOptions",
                value: function (t) {
                    var e = new B(t).init({
                        responsiveOverride: !0
                    });
                    this.w.config = e
                }
            }]), t
        }(),
        lt = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.colors = [], this.w = e.w;
                var i = this.w;
                this.isColorFn = !1, this.isHeatmapDistributed = "treemap" === i.config.chart.type && i.config.plotOptions.treemap.distributed || "heatmap" === i.config.chart.type && i.config.plotOptions.heatmap.distributed, this.isBarDistributed = i.config.plotOptions.bar.distributed && ("bar" === i.config.chart.type || "rangeBar" === i.config.chart.type)
            }
            return o(t, [{
                key: "init",
                value: function () {
                    this.setDefaultColors()
                }
            }, {
                key: "setDefaultColors",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = new y;
                    if (e.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(e.config.theme.mode)), void 0 === e.config.colors ? e.globals.colors = this.predefined() : (e.globals.colors = e.config.colors, Array.isArray(e.config.colors) && e.config.colors.length > 0 && "function" == typeof e.config.colors[0] && (e.globals.colors = e.config.series.map((function (i, n) {
                            var l = e.config.colors[n];
                            return l || (l = e.config.colors[0]), "function" == typeof l ? (t.isColorFn = !0, l({
                                value: e.globals.axisCharts ? e.globals.series[n][0] ? e.globals.series[n][0] : 0 : e.globals.series[n],
                                seriesIndex: n,
                                dataPointIndex: n,
                                w: e
                            })) : l
                        })))), e.globals.seriesColors.map((function (t, i) {
                            t && (e.globals.colors[i] = t)
                        })), e.config.theme.monochrome.enabled) {
                        var n = [],
                            l = e.globals.series.length;
                        (this.isBarDistributed || this.isHeatmapDistributed) && (l = e.globals.series[0].length * e.globals.series.length);
                        for (var r = e.config.theme.monochrome.color, a = 1 / (l / e.config.theme.monochrome.shadeIntensity), o = e.config.theme.monochrome.shadeTo, s = 0, c = 0; c < l; c++) {
                            var u = void 0;
                            "dark" === o ? (u = i.shadeColor(-1 * s, r), s += a) : (u = i.shadeColor(s, r), s += a), n.push(u)
                        }
                        e.globals.colors = n.slice()
                    }
                    var h = e.globals.colors.slice();
                    this.pushExtraColors(e.globals.colors), ["fill", "stroke"].forEach((function (i) {
                        void 0 === e.config[i].colors ? e.globals[i].colors = t.isColorFn ? e.config.colors : h : e.globals[i].colors = e.config[i].colors.slice(), t.pushExtraColors(e.globals[i].colors)
                    })), void 0 === e.config.dataLabels.style.colors ? e.globals.dataLabels.style.colors = h : e.globals.dataLabels.style.colors = e.config.dataLabels.style.colors.slice(), this.pushExtraColors(e.globals.dataLabels.style.colors, 50), void 0 === e.config.plotOptions.radar.polygons.fill.colors ? e.globals.radarPolygons.fill.colors = ["dark" === e.config.theme.mode ? "#424242" : "none"] : e.globals.radarPolygons.fill.colors = e.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(e.globals.radarPolygons.fill.colors, 20), void 0 === e.config.markers.colors ? e.globals.markers.colors = h : e.globals.markers.colors = e.config.markers.colors.slice(), this.pushExtraColors(e.globals.markers.colors)
                }
            }, {
                key: "pushExtraColors",
                value: function (t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                        n = this.w,
                        l = e || n.globals.series.length;
                    if (null === i && (i = this.isBarDistributed || this.isHeatmapDistributed || "heatmap" === n.config.chart.type && n.config.plotOptions.heatmap.colorScale.inverse), i && n.globals.series.length && (l = n.globals.series[n.globals.maxValsInArrayIndex].length * n.globals.series.length), t.length < l)
                        for (var r = l - t.length, a = 0; a < r; a++) t.push(t[a])
                }
            }, {
                key: "updateThemeOptions",
                value: function (t) {
                    t.chart = t.chart || {}, t.tooltip = t.tooltip || {};
                    var e = t.theme.mode || "light",
                        i = t.theme.palette ? t.theme.palette : "dark" === e ? "palette4" : "palette1",
                        n = t.chart.foreColor ? t.chart.foreColor : "dark" === e ? "#f6f7f8" : "#373d3f";
                    return t.tooltip.theme = e, t.chart.foreColor = n, t.theme.palette = i, t
                }
            }, {
                key: "predefined",
                value: function () {
                    switch (this.w.config.theme.palette) {
                        case "palette1":
                            this.colors = ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"];
                            break;
                        case "palette2":
                            this.colors = ["#3f51b5", "#03a9f4", "#4caf50", "#f9ce1d", "#FF9800"];
                            break;
                        case "palette3":
                            this.colors = ["#33b2df", "#546E7A", "#d4526e", "#13d8aa", "#A5978B"];
                            break;
                        case "palette4":
                            this.colors = ["#4ecdc4", "#c7f464", "#81D4FA", "#fd6a6a", "#546E7A"];
                            break;
                        case "palette5":
                            this.colors = ["#2b908f", "#f9a3a4", "#90ee7e", "#fa4443", "#69d2e7"];
                            break;
                        case "palette6":
                            this.colors = ["#449DD1", "#F86624", "#EA3546", "#662E9B", "#C5D86D"];
                            break;
                        case "palette7":
                            this.colors = ["#D7263D", "#1B998B", "#2E294E", "#F46036", "#E2C044"];
                            break;
                        case "palette8":
                            this.colors = ["#662E9B", "#F86624", "#F9C80E", "#EA3546", "#43BCCD"];
                            break;
                        case "palette9":
                            this.colors = ["#5C4742", "#A5978B", "#8D5B4C", "#5A2A27", "#C4BBAF"];
                            break;
                        case "palette10":
                            this.colors = ["#A300D6", "#7D02EB", "#5653FE", "#2983FF", "#00B1F2"];
                            break;
                        default:
                            this.colors = ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"]
                    }
                    return this.colors
                }
            }]), t
        }(),
        rt = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "draw",
                value: function () {
                    this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle")
                }
            }, {
                key: "drawTitleSubtitle",
                value: function (t) {
                    var e = this.w,
                        i = "title" === t ? e.config.title : e.config.subtitle,
                        n = e.globals.svgWidth / 2,
                        l = i.offsetY,
                        r = "middle";
                    if ("left" === i.align ? (n = 10, r = "start") : "right" === i.align && (n = e.globals.svgWidth - 10, r = "end"), n += i.offsetX, l = l + parseInt(i.style.fontSize, 10) + i.margin / 2, void 0 !== i.text) {
                        var a = new w(this.ctx).drawText({
                            x: n,
                            y: l,
                            text: i.text,
                            textAnchor: r,
                            fontSize: i.style.fontSize,
                            fontFamily: i.style.fontFamily,
                            fontWeight: i.style.fontWeight,
                            foreColor: i.style.color,
                            opacity: 1
                        });
                        a.node.setAttribute("class", "apexcharts-".concat(t, "-text")), e.globals.dom.Paper.add(a)
                    }
                }
            }]), t
        }(),
        at = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.dCtx = e
            }
            return o(t, [{
                key: "getTitleSubtitleCoords",
                value: function (t) {
                    var e = this.w,
                        i = 0,
                        n = 0,
                        l = "title" === t ? e.config.title.floating : e.config.subtitle.floating,
                        r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t, "-text"));
                    if (null !== r && !l) {
                        var a = r.getBoundingClientRect();
                        i = a.width, n = e.globals.axisCharts ? a.height + 5 : a.height
                    }
                    return {
                        width: i,
                        height: n
                    }
                }
            }, {
                key: "getLegendsRect",
                value: function () {
                    var t = this.w,
                        e = t.globals.dom.baseEl.querySelector(".apexcharts-legend");
                    t.config.legend.height || "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || (e.style.maxHeight = t.globals.svgHeight / 2 + "px");
                    var i = Object.assign({}, y.getBoundingClientRect(e));
                    return null !== e && !t.config.legend.floating && t.config.legend.show ? this.dCtx.lgRect = {
                        x: i.x,
                        y: i.y,
                        height: i.height,
                        width: 0 === i.height ? 0 : i.width
                    } : this.dCtx.lgRect = {
                        x: 0,
                        y: 0,
                        height: 0,
                        width: 0
                    }, "left" !== t.config.legend.position && "right" !== t.config.legend.position || 1.5 * this.dCtx.lgRect.width > t.globals.svgWidth && (this.dCtx.lgRect.width = t.globals.svgWidth / 1.5), this.dCtx.lgRect
                }
            }, {
                key: "getLargestStringFromMultiArr",
                value: function (t, e) {
                    var i = t;
                    if (this.w.globals.isMultiLineX) {
                        var n = e.map((function (t, e) {
                                return Array.isArray(t) ? t.length : 1
                            })),
                            l = Math.max.apply(Math, m(n));
                        i = e[n.indexOf(l)]
                    }
                    return i
                }
            }]), t
        }(),
        ot = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.dCtx = e
            }
            return o(t, [{
                key: "getxAxisLabelsCoords",
                value: function () {
                    var t, e = this.w,
                        i = e.globals.labels.slice();
                    if (e.config.xaxis.convertedCatToNumeric && 0 === i.length && (i = e.globals.categoryLabels), e.globals.timescaleLabels.length > 0) {
                        var n = this.getxAxisTimeScaleLabelsCoords();
                        t = {
                            width: n.width,
                            height: n.height
                        }, e.globals.rotateXLabels = !1
                    } else {
                        this.dCtx.lgWidthForSideLegends = "left" !== e.config.legend.position && "right" !== e.config.legend.position || e.config.legend.floating ? 0 : this.dCtx.lgRect.width;
                        var l = e.globals.xLabelFormatter,
                            r = y.getLargestStringFromArr(i),
                            a = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, i);
                        e.globals.isBarHorizontal && (a = r = e.globals.yAxisScale[0].result.reduce((function (t, e) {
                            return t.length > e.length ? t : e
                        }), 0));
                        var o = new X(this.dCtx.ctx),
                            s = r;
                        r = o.xLabelFormat(l, r, s, {
                            i: void 0,
                            dateFormatter: new F(this.dCtx.ctx).formatDate,
                            w: e
                        }), a = o.xLabelFormat(l, a, s, {
                            i: void 0,
                            dateFormatter: new F(this.dCtx.ctx).formatDate,
                            w: e
                        }), (e.config.xaxis.convertedCatToNumeric && void 0 === r || "" === String(r).trim()) && (a = r = "1");
                        var c = new w(this.dCtx.ctx),
                            u = c.getTextRects(r, e.config.xaxis.labels.style.fontSize),
                            h = u;
                        if (r !== a && (h = c.getTextRects(a, e.config.xaxis.labels.style.fontSize)), (t = {
                                width: u.width >= h.width ? u.width : h.width,
                                height: u.height >= h.height ? u.height : h.height
                            }).width * i.length > e.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && 0 !== e.config.xaxis.labels.rotate || e.config.xaxis.labels.rotateAlways) {
                            if (!e.globals.isBarHorizontal) {
                                e.globals.rotateXLabels = !0;
                                var d = function (t) {
                                    return c.getTextRects(t, e.config.xaxis.labels.style.fontSize, e.config.xaxis.labels.style.fontFamily, "rotate(".concat(e.config.xaxis.labels.rotate, " 0 0)"), !1)
                                };
                                u = d(r), r !== a && (h = d(a)), t.height = (u.height > h.height ? u.height : h.height) / 1.5, t.width = u.width > h.width ? u.width : h.width
                            }
                        } else e.globals.rotateXLabels = !1
                    }
                    return e.config.xaxis.labels.show || (t = {
                        width: 0,
                        height: 0
                    }), {
                        width: t.width,
                        height: t.height
                    }
                }
            }, {
                key: "getxAxisTitleCoords",
                value: function () {
                    var t = this.w,
                        e = 0,
                        i = 0;
                    if (void 0 !== t.config.xaxis.title.text) {
                        var n = new w(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text, t.config.xaxis.title.style.fontSize);
                        e = n.width, i = n.height
                    }
                    return {
                        width: e,
                        height: i
                    }
                }
            }, {
                key: "getxAxisTimeScaleLabelsCoords",
                value: function () {
                    var t, e = this.w;
                    this.dCtx.timescaleLabels = e.globals.timescaleLabels.slice();
                    var i = this.dCtx.timescaleLabels.map((function (t) {
                            return t.value
                        })),
                        n = i.reduce((function (t, e) {
                            return void 0 === t ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : t.length > e.length ? t : e
                        }), 0);
                    return 1.05 * (t = new w(this.dCtx.ctx).getTextRects(n, e.config.xaxis.labels.style.fontSize)).width * i.length > e.globals.gridWidth && 0 !== e.config.xaxis.labels.rotate && (e.globals.overlappingXLabels = !0), t
                }
            }, {
                key: "additionalPaddingXLabels",
                value: function (t) {
                    var e = this,
                        i = this.w,
                        n = i.globals,
                        l = i.config,
                        r = l.xaxis.type,
                        a = t.width;
                    n.skipLastTimelinelabel = !1, n.skipFirstTimelinelabel = !1;
                    var o = i.config.yaxis[0].opposite && i.globals.isBarHorizontal,
                        s = function (t, o) {
                            (function (t) {
                                return -1 !== n.collapsedSeriesIndices.indexOf(t)
                            })(o) || function (t) {
                                if (e.dCtx.timescaleLabels && e.dCtx.timescaleLabels.length) {
                                    var o = e.dCtx.timescaleLabels[0],
                                        s = e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length - 1].position + a / 1.75 - e.dCtx.yAxisWidthRight,
                                        c = o.position - a / 1.75 + e.dCtx.yAxisWidthLeft,
                                        u = "right" === i.config.legend.position && e.dCtx.lgRect.width > 0 ? e.dCtx.lgRect.width : 0;
                                    s > n.svgWidth - n.translateX - u && (n.skipLastTimelinelabel = !0), c < -(t.show && !t.floating || "bar" !== l.chart.type && "candlestick" !== l.chart.type && "rangeBar" !== l.chart.type && "boxPlot" !== l.chart.type ? 10 : a / 1.75) && (n.skipFirstTimelinelabel = !0)
                                } else "datetime" === r ? e.dCtx.gridPad.right < a && !n.rotateXLabels && (n.skipLastTimelinelabel = !0) : "datetime" !== r && e.dCtx.gridPad.right < a / 2 - e.dCtx.yAxisWidthRight && !n.rotateXLabels && ("between" !== i.config.xaxis.tickPlacement || i.globals.isBarHorizontal) && (e.dCtx.xPadRight = a / 2 + 1)
                            }(t)
                        };
                    l.yaxis.forEach((function (t, i) {
                        o ? (e.dCtx.gridPad.left < a && (e.dCtx.xPadLeft = a / 2 + 1), e.dCtx.xPadRight = a / 2 + 1) : s(t, i)
                    }))
                }
            }]), t
        }(),
        st = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.dCtx = e
            }
            return o(t, [{
                key: "getyAxisLabelsCoords",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = [],
                        n = 10,
                        l = new q(this.dCtx.ctx);
                    return e.config.yaxis.map((function (r, a) {
                        var o = e.globals.yAxisScale[a];
                        if (!l.isYAxisHidden(a) && r.labels.show && o.result.length) {
                            var s = e.globals.yLabelFormatters[a],
                                c = o.niceMin === Number.MIN_VALUE ? 0 : o.niceMin,
                                u = String(c).length > String(o.niceMax).length ? c : o.niceMax,
                                h = s(u, {
                                    seriesIndex: a,
                                    dataPointIndex: -1,
                                    w: e
                                }),
                                d = h;
                            if (void 0 !== h && 0 !== h.length || (h = u), e.globals.isBarHorizontal) {
                                n = 0;
                                var f = e.globals.labels.slice();
                                h = s(h = y.getLargestStringFromArr(f), {
                                    seriesIndex: a,
                                    dataPointIndex: -1,
                                    w: e
                                }), d = t.dCtx.dimHelpers.getLargestStringFromMultiArr(h, f)
                            }
                            var p = new w(t.dCtx.ctx),
                                g = "rotate(".concat(r.labels.rotate, " 0 0)"),
                                m = p.getTextRects(h, r.labels.style.fontSize, r.labels.style.fontFamily, g, !1),
                                v = m;
                            h !== d && (v = p.getTextRects(d, r.labels.style.fontSize, r.labels.style.fontFamily, g, !1)), i.push({
                                width: (v.width > m.width ? v.width : m.width) + n,
                                height: v.height > m.height ? v.height : m.height
                            })
                        } else i.push({
                            width: 0,
                            height: 0
                        })
                    })), i
                }
            }, {
                key: "getyAxisTitleCoords",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = [];
                    return e.config.yaxis.map((function (e, n) {
                        if (e.show && void 0 !== e.title.text) {
                            var l = new w(t.dCtx.ctx),
                                r = "rotate(".concat(e.title.rotate, " 0 0)"),
                                a = l.getTextRects(e.title.text, e.title.style.fontSize, e.title.style.fontFamily, r, !1);
                            i.push({
                                width: a.width,
                                height: a.height
                            })
                        } else i.push({
                            width: 0,
                            height: 0
                        })
                    })), i
                }
            }, {
                key: "getTotalYAxisWidth",
                value: function () {
                    var t = this.w,
                        e = 0,
                        i = 0,
                        n = 0,
                        l = t.globals.yAxisScale.length > 1 ? 10 : 0,
                        r = new q(this.dCtx.ctx),
                        a = function (a, o) {
                            var s = t.config.yaxis[o].floating,
                                c = 0;
                            a.width > 0 && !s ? (c = a.width + l, function (e) {
                                return t.globals.ignoreYAxisIndexes.indexOf(e) > -1
                            }(o) && (c = c - a.width - l)) : c = s || r.isYAxisHidden(o) ? 0 : 5, t.config.yaxis[o].opposite ? n += c : i += c, e += c
                        };
                    return t.globals.yLabelsCoords.map((function (t, e) {
                        a(t, e)
                    })), t.globals.yTitleCoords.map((function (t, e) {
                        a(t, e)
                    })), t.globals.isBarHorizontal && !t.config.yaxis[0].floating && (e = t.globals.yLabelsCoords[0].width + t.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = i, this.dCtx.yAxisWidthRight = n, e
                }
            }]), t
        }(),
        ct = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.dCtx = e
            }
            return o(t, [{
                key: "gridPadForColumnsInNumericAxis",
                value: function (t) {
                    var e = this.w;
                    if (e.globals.noData || e.globals.allSeriesCollapsed) return 0;
                    var i = function (t) {
                            return "bar" === t || "rangeBar" === t || "candlestick" === t || "boxPlot" === t
                        },
                        n = e.config.chart.type,
                        l = 0,
                        r = i(n) ? e.config.series.length : 1;
                    if (e.globals.comboBarCount > 0 && (r = e.globals.comboBarCount), e.globals.collapsedSeries.forEach((function (t) {
                            i(t.type) && (r -= 1)
                        })), e.config.chart.stacked && (r = 1), (i(n) || e.globals.comboBarCount > 0) && e.globals.isXNumeric && !e.globals.isBarHorizontal && r > 0) {
                        var a, o, s = Math.abs(e.globals.initialMaxX - e.globals.initialMinX);
                        s <= 3 && (s = e.globals.dataPoints), a = s / t, e.globals.minXDiff && e.globals.minXDiff / a > 0 && (o = e.globals.minXDiff / a), o > t / 2 && (o /= 2), (l = o / r * parseInt(e.config.plotOptions.bar.columnWidth, 10) / 100) < 1 && (l = 1), l = l / (r > 1 ? 1 : 1.5) + 5, e.globals.barPadForNumericAxis = l
                    }
                    return l
                }
            }, {
                key: "gridPadFortitleSubtitle",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = e.globals,
                        n = this.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 10;
                    ["title", "subtitle"].forEach((function (i) {
                        void 0 !== e.config[i].text ? n += e.config[i].margin : n += t.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 5
                    })), !e.config.legend.show || "bottom" !== e.config.legend.position || e.config.legend.floating || e.globals.axisCharts || (n += 10);
                    var l = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"),
                        r = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
                    i.gridHeight = i.gridHeight - l.height - r.height - n, i.translateY = i.translateY + l.height + r.height + n
                }
            }, {
                key: "setGridXPosForDualYAxis",
                value: function (t, e) {
                    var i = this.w,
                        n = new q(this.dCtx.ctx);
                    i.config.yaxis.map((function (l, r) {
                        -1 !== i.globals.ignoreYAxisIndexes.indexOf(r) || l.floating || n.isYAxisHidden(r) || (l.opposite && (i.globals.translateX = i.globals.translateX - (e[r].width + t[r].width) - parseInt(i.config.yaxis[r].labels.style.fontSize, 10) / 1.2 - 12), i.globals.translateX < 2 && (i.globals.translateX = 2))
                    }))
                }
            }]), t
        }(),
        ut = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new at(this), this.dimYAxis = new st(this), this.dimXAxis = new ot(this), this.dimGrid = new ct(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0
            }
            return o(t, [{
                key: "plotCoords",
                value: function () {
                    var t = this.w.globals;
                    this.lgRect = this.dimHelpers.getLegendsRect(), t.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), t.gridHeight = t.gridHeight - this.gridPad.top - this.gridPad.bottom, t.gridWidth = t.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
                    var e = this.dimGrid.gridPadForColumnsInNumericAxis(t.gridWidth);
                    t.gridWidth = t.gridWidth - 2 * e, t.translateX = t.translateX + this.gridPad.left + this.xPadLeft + (e > 0 ? e + 4 : 0), t.translateY = t.translateY + this.gridPad.top
                }
            }, {
                key: "setDimensionsForAxisCharts",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = e.globals,
                        n = this.dimYAxis.getyAxisLabelsCoords(),
                        l = this.dimYAxis.getyAxisTitleCoords();
                    e.globals.yLabelsCoords = [], e.globals.yTitleCoords = [], e.config.yaxis.map((function (t, i) {
                        e.globals.yLabelsCoords.push({
                            width: n[i].width,
                            index: i
                        }), e.globals.yTitleCoords.push({
                            width: l[i].width,
                            index: i
                        })
                    })), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
                    var r = this.dimXAxis.getxAxisLabelsCoords(),
                        a = this.dimXAxis.getxAxisTitleCoords();
                    this.conditionalChecksForAxisCoords(r, a), i.translateXAxisY = e.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, i.translateXAxisX = e.globals.rotateXLabels && e.globals.isXNumeric && e.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, e.globals.isBarHorizontal && (i.rotateXLabels = !1, i.translateXAxisY = parseInt(e.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), i.translateXAxisY = i.translateXAxisY + e.config.xaxis.labels.offsetY, i.translateXAxisX = i.translateXAxisX + e.config.xaxis.labels.offsetX;
                    var o = this.yAxisWidth,
                        s = this.xAxisHeight;
                    i.xAxisLabelsHeight = this.xAxisHeight - a.height, i.xAxisLabelsWidth = this.xAxisWidth, i.xAxisHeight = this.xAxisHeight;
                    var c = 10;
                    ("radar" === e.config.chart.type || this.isSparkline) && (o = 0, s = i.goldenPadding), this.isSparkline && (this.lgRect = {
                        height: 0,
                        width: 0
                    }), (this.isSparkline || "treemap" === e.config.chart.type) && (o = 0, s = 0, c = 0), this.isSparkline || this.dimXAxis.additionalPaddingXLabels(r);
                    var u = function () {
                        i.translateX = o, i.gridHeight = i.svgHeight - t.lgRect.height - s - (t.isSparkline || "treemap" === e.config.chart.type ? 0 : e.globals.rotateXLabels ? 10 : 15), i.gridWidth = i.svgWidth - o
                    };
                    switch ("top" === e.config.xaxis.position && (c = i.xAxisHeight - e.config.xaxis.axisTicks.height - 5), e.config.legend.position) {
                        case "bottom":
                            i.translateY = c, u();
                            break;
                        case "top":
                            i.translateY = this.lgRect.height + c, u();
                            break;
                        case "left":
                            i.translateY = c, i.translateX = this.lgRect.width + o, i.gridHeight = i.svgHeight - s - 12, i.gridWidth = i.svgWidth - this.lgRect.width - o;
                            break;
                        case "right":
                            i.translateY = c, i.translateX = o, i.gridHeight = i.svgHeight - s - 12, i.gridWidth = i.svgWidth - this.lgRect.width - o - 5;
                            break;
                        default:
                            throw new Error("Legend position not supported")
                    }
                    this.dimGrid.setGridXPosForDualYAxis(l, n), new Q(this.ctx).setYAxisXPosition(n, l)
                }
            }, {
                key: "setDimensionsForNonAxisCharts",
                value: function () {
                    var t = this.w,
                        e = t.globals,
                        i = t.config,
                        n = 0;
                    t.config.legend.show && !t.config.legend.floating && (n = 20);
                    var l = "pie" === i.chart.type || "polarArea" === i.chart.type || "donut" === i.chart.type ? "pie" : "radialBar",
                        r = i.plotOptions[l].offsetY,
                        a = i.plotOptions[l].offsetX;
                    if (!i.legend.show || i.legend.floating) return e.gridHeight = e.svgHeight - i.grid.padding.left + i.grid.padding.right, e.gridWidth = e.gridHeight, e.translateY = r, void(e.translateX = a + (e.svgWidth - e.gridWidth) / 2);
                    switch (i.legend.position) {
                        case "bottom":
                            e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = r - 10, e.translateX = a + (e.svgWidth - e.gridWidth) / 2;
                            break;
                        case "top":
                            e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = this.lgRect.height + r + 10, e.translateX = a + (e.svgWidth - e.gridWidth) / 2;
                            break;
                        case "left":
                            e.gridWidth = e.svgWidth - this.lgRect.width - n, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = a + this.lgRect.width + n;
                            break;
                        case "right":
                            e.gridWidth = e.svgWidth - this.lgRect.width - n - 5, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = a + 10;
                            break;
                        default:
                            throw new Error("Legend position not supported")
                    }
                }
            }, {
                key: "conditionalChecksForAxisCoords",
                value: function (t, e) {
                    var i = this.w;
                    this.xAxisHeight = (t.height + e.height) * (i.globals.isMultiLineX ? 1.2 : i.globals.LINE_HEIGHT_RATIO) + (i.globals.rotateXLabels ? 22 : 10), this.xAxisWidth = t.width, this.xAxisHeight - e.height > i.config.xaxis.labels.maxHeight && (this.xAxisHeight = i.config.xaxis.labels.maxHeight), i.config.xaxis.labels.minHeight && this.xAxisHeight < i.config.xaxis.labels.minHeight && (this.xAxisHeight = i.config.xaxis.labels.minHeight), i.config.xaxis.floating && (this.xAxisHeight = 0);
                    var n = 0,
                        l = 0;
                    i.config.yaxis.forEach((function (t) {
                        n += t.labels.minWidth, l += t.labels.maxWidth
                    })), this.yAxisWidth < n && (this.yAxisWidth = n), this.yAxisWidth > l && (this.yAxisWidth = l)
                }
            }]), t
        }(),
        ht = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.lgCtx = e
            }
            return o(t, [{
                key: "getLegendStyles",
                value: function () {
                    var t = document.createElement("style");
                    t.setAttribute("type", "text/css");
                    var e = document.createTextNode("\t\n    \t\n      .apexcharts-legend {\t\n        display: flex;\t\n        overflow: auto;\t\n        padding: 0 10px;\t\n      }\t\n      .apexcharts-legend.position-bottom, .apexcharts-legend.position-top {\t\n        flex-wrap: wrap\t\n      }\t\n      .apexcharts-legend.position-right, .apexcharts-legend.position-left {\t\n        flex-direction: column;\t\n        bottom: 0;\t\n      }\t\n      .apexcharts-legend.position-bottom.apexcharts-align-left, .apexcharts-legend.position-top.apexcharts-align-left, .apexcharts-legend.position-right, .apexcharts-legend.position-left {\t\n        justify-content: flex-start;\t\n      }\t\n      .apexcharts-legend.position-bottom.apexcharts-align-center, .apexcharts-legend.position-top.apexcharts-align-center {\t\n        justify-content: center;  \t\n      }\t\n      .apexcharts-legend.position-bottom.apexcharts-align-right, .apexcharts-legend.position-top.apexcharts-align-right {\t\n        justify-content: flex-end;\t\n      }\t\n      .apexcharts-legend-series {\t\n        cursor: pointer;\t\n        line-height: normal;\t\n      }\t\n      .apexcharts-legend.position-bottom .apexcharts-legend-series, .apexcharts-legend.position-top .apexcharts-legend-series{\t\n        display: flex;\t\n        align-items: center;\t\n      }\t\n      .apexcharts-legend-text {\t\n        position: relative;\t\n        font-size: 14px;\t\n      }\t\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {\t\n        pointer-events: none;\t\n      }\t\n      .apexcharts-legend-marker {\t\n        position: relative;\t\n        display: inline-block;\t\n        cursor: pointer;\t\n        margin-right: 3px;\t\n        border-style: solid;\n      }\t\n      \t\n      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{\t\n        display: inline-block;\t\n      }\t\n      .apexcharts-legend-series.apexcharts-no-click {\t\n        cursor: auto;\t\n      }\t\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {\t\n        display: none !important;\t\n      }\t\n      .apexcharts-inactive-legend {\t\n        opacity: 0.45;\t\n      }");
                    return t.appendChild(e), t
                }
            }, {
                key: "getLegendBBox",
                value: function () {
                    var t = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(),
                        e = t.width;
                    return {
                        clwh: t.height,
                        clww: e
                    }
                }
            }, {
                key: "appendToForeignObject",
                value: function () {
                    var t = this.w.globals;
                    t.dom.elLegendForeign = document.createElementNS(t.SVGNS, "foreignObject");
                    var e = t.dom.elLegendForeign;
                    e.setAttribute("x", 0), e.setAttribute("y", 0), e.setAttribute("width", t.svgWidth), e.setAttribute("height", t.svgHeight), t.dom.elLegendWrap.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), e.appendChild(t.dom.elLegendWrap), e.appendChild(this.getLegendStyles()), t.dom.Paper.node.insertBefore(e, t.dom.elGraphical.node)
                }
            }, {
                key: "toggleDataSeries",
                value: function (t, e) {
                    var i = this,
                        n = this.w;
                    if (n.globals.axisCharts || "radialBar" === n.config.chart.type) {
                        n.globals.resized = !0;
                        var l = null,
                            r = null;
                        n.globals.risingSeries = [], n.globals.axisCharts ? (l = n.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "']")), r = parseInt(l.getAttribute("data:realIndex"), 10)) : (l = n.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t + 1, "']")), r = parseInt(l.getAttribute("rel"), 10) - 1), e ? [{
                            cs: n.globals.collapsedSeries,
                            csi: n.globals.collapsedSeriesIndices
                        }, {
                            cs: n.globals.ancillaryCollapsedSeries,
                            csi: n.globals.ancillaryCollapsedSeriesIndices
                        }].forEach((function (t) {
                            i.riseCollapsedSeries(t.cs, t.csi, r)
                        })) : this.hideSeries({
                            seriesEl: l,
                            realIndex: r
                        })
                    } else {
                        var a = n.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(t + 1, "'] path")),
                            o = n.config.chart.type;
                        if ("pie" === o || "polarArea" === o || "donut" === o) {
                            var s = n.config.plotOptions.pie.donut.labels;
                            new w(this.lgCtx.ctx).pathMouseDown(a.members[0], null), this.lgCtx.ctx.pie.printDataLabelsInner(a.members[0].node, s)
                        }
                        a.fire("click")
                    }
                }
            }, {
                key: "hideSeries",
                value: function (t) {
                    var e = t.seriesEl,
                        i = t.realIndex,
                        n = this.w,
                        l = y.clone(n.config.series);
                    if (n.globals.axisCharts) {
                        var r = !1;
                        if (n.config.yaxis[i] && n.config.yaxis[i].show && n.config.yaxis[i].showAlways && (r = !0, n.globals.ancillaryCollapsedSeriesIndices.indexOf(i) < 0 && (n.globals.ancillaryCollapsedSeries.push({
                                index: i,
                                data: l[i].data.slice(),
                                type: e.parentNode.className.baseVal.split("-")[1]
                            }), n.globals.ancillaryCollapsedSeriesIndices.push(i))), !r) {
                            n.globals.collapsedSeries.push({
                                index: i,
                                data: l[i].data.slice(),
                                type: e.parentNode.className.baseVal.split("-")[1]
                            }), n.globals.collapsedSeriesIndices.push(i);
                            var a = n.globals.risingSeries.indexOf(i);
                            n.globals.risingSeries.splice(a, 1)
                        }
                    } else n.globals.collapsedSeries.push({
                        index: i,
                        data: l[i]
                    }), n.globals.collapsedSeriesIndices.push(i);
                    for (var o = e.childNodes, s = 0; s < o.length; s++) o[s].classList.contains("apexcharts-series-markers-wrap") && (o[s].classList.contains("apexcharts-hide") ? o[s].classList.remove("apexcharts-hide") : o[s].classList.add("apexcharts-hide"));
                    n.globals.allSeriesCollapsed = n.globals.collapsedSeries.length === n.config.series.length, l = this._getSeriesBasedOnCollapsedState(l), this.lgCtx.ctx.updateHelpers._updateSeries(l, n.config.chart.animations.dynamicAnimation.enabled)
                }
            }, {
                key: "riseCollapsedSeries",
                value: function (t, e, i) {
                    var n = this.w,
                        l = y.clone(n.config.series);
                    if (t.length > 0) {
                        for (var r = 0; r < t.length; r++) t[r].index === i && (n.globals.axisCharts ? (l[i].data = t[r].data.slice(), t.splice(r, 1), e.splice(r, 1), n.globals.risingSeries.push(i)) : (l[i] = t[r].data, t.splice(r, 1), e.splice(r, 1), n.globals.risingSeries.push(i)));
                        l = this._getSeriesBasedOnCollapsedState(l), this.lgCtx.ctx.updateHelpers._updateSeries(l, n.config.chart.animations.dynamicAnimation.enabled)
                    }
                }
            }, {
                key: "_getSeriesBasedOnCollapsedState",
                value: function (t) {
                    var e = this.w;
                    return e.globals.axisCharts ? t.forEach((function (i, n) {
                        e.globals.collapsedSeriesIndices.indexOf(n) > -1 && (t[n].data = [])
                    })) : t.forEach((function (i, n) {
                        e.globals.collapsedSeriesIndices.indexOf(n) > -1 && (t[n] = 0)
                    })), t
                }
            }]), t
        }(),
        dt = function () {
            function t(e, i) {
                r(this, t), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = "bar" === this.w.config.chart.type && this.w.config.plotOptions.bar.distributed && 1 === this.w.config.series.length, this.legendHelpers = new ht(this)
            }
            return o(t, [{
                key: "init",
                value: function () {
                    var t = this.w,
                        e = t.globals,
                        i = t.config;
                    if ((i.legend.showForSingleSeries && 1 === e.series.length || this.isBarsDistributed || e.series.length > 1 || !e.axisCharts) && i.legend.show) {
                        for (; e.dom.elLegendWrap.firstChild;) e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);
                        this.drawLegends(), y.isIE11() ? document.getElementsByTagName("head")[0].appendChild(this.legendHelpers.getLegendStyles()) : this.legendHelpers.appendToForeignObject(), "bottom" === i.legend.position || "top" === i.legend.position ? this.legendAlignHorizontal() : "right" !== i.legend.position && "left" !== i.legend.position || this.legendAlignVertical()
                    }
                }
            }, {
                key: "drawLegends",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = e.config.legend.fontFamily,
                        n = e.globals.seriesNames,
                        l = e.globals.colors.slice();
                    if ("heatmap" === e.config.chart.type) {
                        var r = e.config.plotOptions.heatmap.colorScale.ranges;
                        n = r.map((function (t) {
                            return t.name ? t.name : t.from + " - " + t.to
                        })), l = r.map((function (t) {
                            return t.color
                        }))
                    } else this.isBarsDistributed && (n = e.globals.labels.slice());
                    for (var a = e.globals.legendFormatter, o = e.config.legend.inverseOrder, s = o ? n.length - 1 : 0; o ? s >= 0 : s <= n.length - 1; o ? s-- : s++) {
                        var c = a(n[s], {
                                seriesIndex: s,
                                w: e
                            }),
                            u = !1,
                            h = !1;
                        if (e.globals.collapsedSeries.length > 0)
                            for (var d = 0; d < e.globals.collapsedSeries.length; d++) e.globals.collapsedSeries[d].index === s && (u = !0);
                        if (e.globals.ancillaryCollapsedSeriesIndices.length > 0)
                            for (var f = 0; f < e.globals.ancillaryCollapsedSeriesIndices.length; f++) e.globals.ancillaryCollapsedSeriesIndices[f] === s && (h = !0);
                        var p = document.createElement("span");
                        p.classList.add("apexcharts-legend-marker");
                        var g = e.config.legend.markers.offsetX,
                            m = e.config.legend.markers.offsetY,
                            v = e.config.legend.markers.height,
                            b = e.config.legend.markers.width,
                            x = e.config.legend.markers.strokeWidth,
                            _ = e.config.legend.markers.strokeColor,
                            k = e.config.legend.markers.radius,
                            A = p.style;
                        A.background = l[s], A.color = l[s], A.setProperty("background", l[s], "important"), e.config.legend.markers.fillColors && e.config.legend.markers.fillColors[s] && (A.background = e.config.legend.markers.fillColors[s]), void 0 !== e.globals.seriesColors[s] && (A.background = e.globals.seriesColors[s], A.color = e.globals.seriesColors[s]), A.height = Array.isArray(v) ? parseFloat(v[s]) + "px" : parseFloat(v) + "px", A.width = Array.isArray(b) ? parseFloat(b[s]) + "px" : parseFloat(b) + "px", A.left = Array.isArray(g) ? g[s] : g, A.top = Array.isArray(m) ? m[s] : m, A.borderWidth = Array.isArray(x) ? x[s] : x, A.borderColor = Array.isArray(_) ? _[s] : _, A.borderRadius = Array.isArray(k) ? parseFloat(k[s]) + "px" : parseFloat(k) + "px", e.config.legend.markers.customHTML && (Array.isArray(e.config.legend.markers.customHTML) ? e.config.legend.markers.customHTML[s] && (p.innerHTML = e.config.legend.markers.customHTML[s]()) : p.innerHTML = e.config.legend.markers.customHTML()), w.setAttrs(p, {
                            rel: s + 1,
                            "data:collapsed": u || h
                        }), (u || h) && p.classList.add("apexcharts-inactive-legend");
                        var M = document.createElement("div"),
                            C = document.createElement("span");
                        C.classList.add("apexcharts-legend-text"), C.innerHTML = Array.isArray(c) ? c.join(" ") : c;
                        var E = e.config.legend.labels.useSeriesColors ? e.globals.colors[s] : e.config.legend.labels.colors;
                        E || (E = e.config.chart.foreColor), C.style.color = E, C.style.fontSize = parseFloat(e.config.legend.fontSize) + "px", C.style.fontWeight = e.config.legend.fontWeight, C.style.fontFamily = i || e.config.chart.fontFamily, w.setAttrs(C, {
                            rel: s + 1,
                            i: s,
                            "data:default-text": encodeURIComponent(c),
                            "data:collapsed": u || h
                        }), M.appendChild(p), M.appendChild(C);
                        var O = new S(this.ctx);
                        e.config.legend.showForZeroSeries || 0 === O.getSeriesTotalByIndex(s) && O.seriesHaveSameValues(s) && !O.isSeriesNull(s) && -1 === e.globals.collapsedSeriesIndices.indexOf(s) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(s) && M.classList.add("apexcharts-hidden-zero-series"), e.config.legend.showForNullSeries || O.isSeriesNull(s) && -1 === e.globals.collapsedSeriesIndices.indexOf(s) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(s) && M.classList.add("apexcharts-hidden-null-series"), e.globals.dom.elLegendWrap.appendChild(M), e.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(e.config.legend.horizontalAlign)), e.globals.dom.elLegendWrap.classList.add("position-" + e.config.legend.position), M.classList.add("apexcharts-legend-series"), M.style.margin = "".concat(e.config.legend.itemMargin.vertical, "px ").concat(e.config.legend.itemMargin.horizontal, "px"), e.globals.dom.elLegendWrap.style.width = e.config.legend.width ? e.config.legend.width + "px" : "", e.globals.dom.elLegendWrap.style.height = e.config.legend.height ? e.config.legend.height + "px" : "", w.setAttrs(M, {
                            rel: s + 1,
                            seriesName: y.escapeString(n[s]),
                            "data:collapsed": u || h
                        }), (u || h) && M.classList.add("apexcharts-inactive-legend"), e.config.legend.onItemClick.toggleDataSeries || M.classList.add("apexcharts-no-click")
                    }
                    e.globals.dom.elWrap.addEventListener("click", t.onLegendClick, !0), e.config.legend.onItemHover.highlightDataSeries && (e.globals.dom.elWrap.addEventListener("mousemove", t.onLegendHovered, !0), e.globals.dom.elWrap.addEventListener("mouseout", t.onLegendHovered, !0))
                }
            }, {
                key: "setLegendWrapXY",
                value: function (t, e) {
                    var i = this.w,
                        n = i.globals.dom.baseEl.querySelector(".apexcharts-legend"),
                        l = n.getBoundingClientRect(),
                        r = 0,
                        a = 0;
                    if ("bottom" === i.config.legend.position) a += i.globals.svgHeight - l.height / 2;
                    else if ("top" === i.config.legend.position) {
                        var o = new ut(this.ctx),
                            s = o.dimHelpers.getTitleSubtitleCoords("title").height,
                            c = o.dimHelpers.getTitleSubtitleCoords("subtitle").height;
                        a = a + (s > 0 ? s - 10 : 0) + (c > 0 ? c - 10 : 0)
                    }
                    n.style.position = "absolute", r = r + t + i.config.legend.offsetX, a = a + e + i.config.legend.offsetY, n.style.left = r + "px", n.style.top = a + "px", "bottom" === i.config.legend.position ? (n.style.top = "auto", n.style.bottom = 5 - i.config.legend.offsetY + "px") : "right" === i.config.legend.position && (n.style.left = "auto", n.style.right = 25 + i.config.legend.offsetX + "px"), ["width", "height"].forEach((function (t) {
                        n.style[t] && (n.style[t] = parseInt(i.config.legend[t], 10) + "px")
                    }))
                }
            }, {
                key: "legendAlignHorizontal",
                value: function () {
                    var t = this.w;
                    t.globals.dom.baseEl.querySelector(".apexcharts-legend").style.right = 0;
                    var e = this.legendHelpers.getLegendBBox(),
                        i = new ut(this.ctx),
                        n = i.dimHelpers.getTitleSubtitleCoords("title"),
                        l = i.dimHelpers.getTitleSubtitleCoords("subtitle"),
                        r = 0;
                    "bottom" === t.config.legend.position ? r = -e.clwh / 1.8 : "top" === t.config.legend.position && (r = n.height + l.height + t.config.title.margin + t.config.subtitle.margin - 10), this.setLegendWrapXY(20, r)
                }
            }, {
                key: "legendAlignVertical",
                value: function () {
                    var t = this.w,
                        e = this.legendHelpers.getLegendBBox(),
                        i = 0;
                    "left" === t.config.legend.position && (i = 20), "right" === t.config.legend.position && (i = t.globals.svgWidth - e.clww - 10), this.setLegendWrapXY(i, 20)
                }
            }, {
                key: "onLegendHovered",
                value: function (t) {
                    var e = this.w,
                        i = t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker");
                    if ("heatmap" === e.config.chart.type || this.isBarsDistributed) {
                        if (i) {
                            var n = parseInt(t.target.getAttribute("rel"), 10) - 1;
                            this.ctx.events.fireEvent("legendHover", [this.ctx, n, this.w]), new j(this.ctx).highlightRangeInSeries(t, t.target)
                        }
                    } else !t.target.classList.contains("apexcharts-inactive-legend") && i && new j(this.ctx).toggleSeriesOnHover(t, t.target)
                }
            }, {
                key: "onLegendClick",
                value: function (t) {
                    var e = this.w;
                    if (t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker")) {
                        var i = parseInt(t.target.getAttribute("rel"), 10) - 1,
                            n = "true" === t.target.getAttribute("data:collapsed"),
                            l = this.w.config.chart.events.legendClick;
                        "function" == typeof l && l(this.ctx, i, this.w), this.ctx.events.fireEvent("legendClick", [this.ctx, i, this.w]);
                        var r = this.w.config.legend.markers.onClick;
                        "function" == typeof r && t.target.classList.contains("apexcharts-legend-marker") && (r(this.ctx, i, this.w), this.ctx.events.fireEvent("legendMarkerClick", [this.ctx, i, this.w])), "treemap" !== e.config.chart.type && "heatmap" !== e.config.chart.type && !this.isBarsDistributed && e.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(i, n)
                    }
                }
            }]), t
        }(),
        ft = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w;
                var i = this.w;
                this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = i.globals.minX, this.maxX = i.globals.maxX
            }
            return o(t, [{
                key: "createToolbar",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = function () {
                            return document.createElement("div")
                        },
                        n = i();
                    if (n.setAttribute("class", "apexcharts-toolbar"), n.style.top = e.config.chart.toolbar.offsetY + "px", n.style.right = 3 - e.config.chart.toolbar.offsetX + "px", e.globals.dom.elWrap.appendChild(n), this.elZoom = i(), this.elZoomIn = i(), this.elZoomOut = i(), this.elPan = i(), this.elSelection = i(), this.elZoomReset = i(), this.elMenuIcon = i(), this.elMenu = i(), this.elCustomIcons = [], this.t = e.config.chart.toolbar.tools, Array.isArray(this.t.customIcons))
                        for (var l = 0; l < this.t.customIcons.length; l++) this.elCustomIcons.push(i());
                    var r = [],
                        a = function (i, n, l) {
                            var a = i.toLowerCase();
                            t.t[a] && e.config.chart.zoom.enabled && r.push({
                                el: n,
                                icon: "string" == typeof t.t[a] ? t.t[a] : l,
                                title: t.localeValues[i],
                                class: "apexcharts-".concat(a, "-icon")
                            })
                        };
                    a("zoomIn", this.elZoomIn, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'), a("zoomOut", this.elZoomOut, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');
                    var o = function (i) {
                        t.t[i] && e.config.chart[i].enabled && r.push({
                            el: "zoom" === i ? t.elZoom : t.elSelection,
                            icon: "string" == typeof t.t[i] ? t.t[i] : "zoom" === i ? '<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>' : '<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',
                            title: t.localeValues["zoom" === i ? "selectionZoom" : "selection"],
                            class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-".concat(i, "-icon")
                        })
                    };
                    o("zoom"), o("selection"), this.t.pan && e.config.chart.zoom.enabled && r.push({
                        el: this.elPan,
                        icon: "string" == typeof this.t.pan ? this.t.pan : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',
                        title: this.localeValues.pan,
                        class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-pan-icon"
                    }), a("reset", this.elZoomReset, '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'), this.t.download && r.push({
                        el: this.elMenuIcon,
                        icon: "string" == typeof this.t.download ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',
                        title: this.localeValues.menu,
                        class: "apexcharts-menu-icon"
                    });
                    for (var s = 0; s < this.elCustomIcons.length; s++) r.push({
                        el: this.elCustomIcons[s],
                        icon: this.t.customIcons[s].icon,
                        title: this.t.customIcons[s].title,
                        index: this.t.customIcons[s].index,
                        class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[s].class
                    });
                    r.forEach((function (t, e) {
                        t.index && y.moveIndexInArray(r, e, t.index)
                    }));
                    for (var c = 0; c < r.length; c++) w.setAttrs(r[c].el, {
                        class: r[c].class,
                        title: r[c].title
                    }), r[c].el.innerHTML = r[c].icon, n.appendChild(r[c].el);
                    this._createHamburgerMenu(n), e.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : e.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : e.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners()
                }
            }, {
                key: "_createHamburgerMenu",
                value: function (t) {
                    this.elMenuItems = [], t.appendChild(this.elMenu), w.setAttrs(this.elMenu, {
                        class: "apexcharts-menu"
                    });
                    var e = [{
                        name: "exportSVG",
                        title: this.localeValues.exportToSVG
                    }, {
                        name: "exportPNG",
                        title: this.localeValues.exportToPNG
                    }, {
                        name: "exportCSV",
                        title: this.localeValues.exportToCSV
                    }];
                    this.w.globals.allSeriesHasEqualX || e.splice(2, 1);
                    for (var i = 0; i < e.length; i++) this.elMenuItems.push(document.createElement("div")), this.elMenuItems[i].innerHTML = e[i].title, w.setAttrs(this.elMenuItems[i], {
                        class: "apexcharts-menu-item ".concat(e[i].name),
                        title: e[i].title
                    }), this.elMenu.appendChild(this.elMenuItems[i])
                }
            }, {
                key: "addToolbarEventListeners",
                value: function () {
                    var t = this;
                    this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach((function (e) {
                        e.classList.contains("exportSVG") ? e.addEventListener("click", t.handleDownload.bind(t, "svg")) : e.classList.contains("exportPNG") ? e.addEventListener("click", t.handleDownload.bind(t, "png")) : e.classList.contains("exportCSV") && e.addEventListener("click", t.handleDownload.bind(t, "csv"))
                    }));
                    for (var e = 0; e < this.t.customIcons.length; e++) this.elCustomIcons[e].addEventListener("click", this.t.customIcons[e].click.bind(this, this.ctx, this.ctx.w))
                }
            }, {
                key: "toggleZoomSelection",
                value: function (t) {
                    this.ctx.getSyncedCharts().forEach((function (e) {
                        e.ctx.toolbar.toggleOtherControls();
                        var i = "selection" === t ? e.ctx.toolbar.elSelection : e.ctx.toolbar.elZoom,
                            n = "selection" === t ? "selectionEnabled" : "zoomEnabled";
                        e.w.globals[n] = !e.w.globals[n], i.classList.contains(e.ctx.toolbar.selectedClass) ? i.classList.remove(e.ctx.toolbar.selectedClass) : i.classList.add(e.ctx.toolbar.selectedClass)
                    }))
                }
            }, {
                key: "getToolbarIconsReference",
                value: function () {
                    var t = this.w;
                    this.elZoom || (this.elZoom = t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"))
                }
            }, {
                key: "enableZoomPanFromToolbar",
                value: function (t) {
                    this.toggleOtherControls(), "pan" === t ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
                    var e = "pan" === t ? this.elPan : this.elZoom,
                        i = "pan" === t ? this.elZoom : this.elPan;
                    e && e.classList.add(this.selectedClass), i && i.classList.remove(this.selectedClass)
                }
            }, {
                key: "togglePanning",
                value: function () {
                    this.ctx.getSyncedCharts().forEach((function (t) {
                        t.ctx.toolbar.toggleOtherControls(), t.w.globals.panEnabled = !t.w.globals.panEnabled, t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass) ? t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass) : t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass)
                    }))
                }
            }, {
                key: "toggleOtherControls",
                value: function () {
                    var t = this,
                        e = this.w;
                    e.globals.panEnabled = !1, e.globals.zoomEnabled = !1, e.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [this.elPan, this.elSelection, this.elZoom].forEach((function (e) {
                        e && e.classList.remove(t.selectedClass)
                    }))
                }
            }, {
                key: "handleZoomIn",
                value: function () {
                    var t = this.w;
                    t.globals.isTimelineBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY);
                    var e = (this.minX + this.maxX) / 2,
                        i = (this.minX + e) / 2,
                        n = (this.maxX + e) / 2,
                        l = this._getNewMinXMaxX(i, n);
                    t.globals.disableZoomIn || this.zoomUpdateOptions(l.minX, l.maxX)
                }
            }, {
                key: "handleZoomOut",
                value: function () {
                    var t = this.w;
                    if (t.globals.isTimelineBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY), !("datetime" === t.config.xaxis.type && new Date(this.minX).getUTCFullYear() < 1e3)) {
                        var e = (this.minX + this.maxX) / 2,
                            i = this.minX - (e - this.minX),
                            n = this.maxX - (e - this.maxX),
                            l = this._getNewMinXMaxX(i, n);
                        t.globals.disableZoomOut || this.zoomUpdateOptions(l.minX, l.maxX)
                    }
                }
            }, {
                key: "_getNewMinXMaxX",
                value: function (t, e) {
                    var i = this.w.config.xaxis.convertedCatToNumeric;
                    return {
                        minX: i ? Math.floor(t) : t,
                        maxX: i ? Math.floor(e) : e
                    }
                }
            }, {
                key: "zoomUpdateOptions",
                value: function (t, e) {
                    var i = this.w;
                    if (void 0 !== t || void 0 !== e) {
                        if (!(i.config.xaxis.convertedCatToNumeric && (t < 1 && (t = 1, e = i.globals.dataPoints), e - t < 2))) {
                            var n = {
                                    min: t,
                                    max: e
                                },
                                l = this.getBeforeZoomRange(n);
                            l && (n = l.xaxis);
                            var r = {
                                    xaxis: n
                                },
                                a = y.clone(i.globals.initialConfig.yaxis);
                            i.config.chart.zoom.autoScaleYaxis && (a = new K(this.ctx).autoScaleY(this.ctx, a, {
                                xaxis: n
                            })), i.config.chart.group || (r.yaxis = a), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(r, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(n, a)
                        }
                    } else this.handleZoomReset()
                }
            }, {
                key: "zoomCallback",
                value: function (t, e) {
                    "function" == typeof this.ev.zoomed && this.ev.zoomed(this.ctx, {
                        xaxis: t,
                        yaxis: e
                    })
                }
            }, {
                key: "getBeforeZoomRange",
                value: function (t, e) {
                    var i = null;
                    return "function" == typeof this.ev.beforeZoom && (i = this.ev.beforeZoom(this, {
                        xaxis: t,
                        yaxis: e
                    })), i
                }
            }, {
                key: "toggleMenu",
                value: function () {
                    var t = this;
                    window.setTimeout((function () {
                        t.elMenu.classList.contains("apexcharts-menu-open") ? t.elMenu.classList.remove("apexcharts-menu-open") : t.elMenu.classList.add("apexcharts-menu-open")
                    }), 0)
                }
            }, {
                key: "handleDownload",
                value: function (t) {
                    var e = this.w,
                        i = new Z(this.ctx);
                    switch (t) {
                        case "svg":
                            i.exportToSVG(this.ctx);
                            break;
                        case "png":
                            i.exportToPng(this.ctx);
                            break;
                        case "csv":
                            i.exportToCSV({
                                series: e.config.series,
                                columnDelimiter: e.config.chart.toolbar.export.csv.columnDelimiter
                            })
                    }
                }
            }, {
                key: "handleZoomReset",
                value: function (t) {
                    this.ctx.getSyncedCharts().forEach((function (t) {
                        var e = t.w;
                        if (e.globals.lastXAxis.min = void 0, e.globals.lastXAxis.max = void 0, t.updateHelpers.revertDefaultAxisMinMax(), "function" == typeof e.config.chart.events.beforeResetZoom) {
                            var i = e.config.chart.events.beforeResetZoom(t, e);
                            i && t.updateHelpers.revertDefaultAxisMinMax(i)
                        }
                        "function" == typeof e.config.chart.events.zoomed && t.ctx.toolbar.zoomCallback({
                            min: e.config.xaxis.min,
                            max: e.config.xaxis.max
                        }), e.globals.zoomed = !1;
                        var n = t.ctx.series.emptyCollapsedSeries(y.clone(e.globals.initialSeries));
                        t.updateHelpers._updateSeries(n, e.config.chart.animations.dynamicAnimation.enabled)
                    }))
                }
            }, {
                key: "destroy",
                value: function () {
                    this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null
                }
            }]), t
        }(),
        pt = function (t) {
            h(i, ft);
            var e = g(i);

            function i(t) {
                var n;
                return r(this, i), (n = e.call(this, t)).ctx = t, n.w = t.w, n.dragged = !1, n.graphics = new w(n.ctx), n.eventList = ["mousedown", "mouseleave", "mousemove", "touchstart", "touchmove", "mouseup", "touchend"], n.clientX = 0, n.clientY = 0, n.startX = 0, n.endX = 0, n.dragX = 0, n.startY = 0, n.endY = 0, n.dragY = 0, n.moveDirection = "none", n
            }
            return o(i, [{
                key: "init",
                value: function (t) {
                    var e = this,
                        i = t.xyRatios,
                        n = this.w,
                        l = this;
                    this.xyRatios = i, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = n.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), n.globals.dom.elGraphical.add(this.zoomRect), n.globals.dom.elGraphical.add(this.selectionRect), "x" === n.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                        minX: 0,
                        minY: 0,
                        maxX: n.globals.gridWidth,
                        maxY: n.globals.gridHeight
                    }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : "y" === n.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                        minX: 0,
                        maxX: n.globals.gridWidth
                    }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = n.globals.dom.baseEl.querySelector("".concat(n.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach((function (t) {
                        e.hoverArea.addEventListener(t, l.svgMouseEvents.bind(l, i), {
                            capture: !1,
                            passive: !0
                        })
                    }))
                }
            }, {
                key: "destroy",
                value: function () {
                    this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null
                }
            }, {
                key: "svgMouseEvents",
                value: function (t, e) {
                    var i = this.w,
                        n = this,
                        l = this.ctx.toolbar,
                        r = i.globals.zoomEnabled ? i.config.chart.zoom.type : i.config.chart.selection.type,
                        a = i.config.chart.toolbar.autoSelected;
                    e.shiftKey ? (this.shiftWasPressed = !0, l.enableZoomPanFromToolbar("pan" === a ? "zoom" : "pan")) : this.shiftWasPressed && (l.enableZoomPanFromToolbar(a), this.shiftWasPressed = !1);
                    var o = e.target.classList;
                    if (!(o.contains("apexcharts-selection-rect") || o.contains("apexcharts-legend-marker") || o.contains("apexcharts-legend-text") || e.target.parentNode.classList.contains("apexcharts-toolbar"))) {
                        if (n.clientX = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientX : "touchend" === e.type ? e.changedTouches[0].clientX : e.clientX, n.clientY = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientY : "touchend" === e.type ? e.changedTouches[0].clientY : e.clientY, "mousedown" === e.type && 1 === e.which) {
                            var s = n.gridRect.getBoundingClientRect();
                            n.startX = n.clientX - s.left, n.startY = n.clientY - s.top, n.dragged = !1, n.w.globals.mousedown = !0
                        }
                        if (("mousemove" === e.type && 1 === e.which || "touchmove" === e.type) && (n.dragged = !0, i.globals.panEnabled ? (i.globals.selection = null, n.w.globals.mousedown && n.panDragging({
                                context: n,
                                zoomtype: r,
                                xyRatios: t
                            })) : (n.w.globals.mousedown && i.globals.zoomEnabled || n.w.globals.mousedown && i.globals.selectionEnabled) && (n.selection = n.selectionDrawing({
                                context: n,
                                zoomtype: r
                            }))), "mouseup" === e.type || "touchend" === e.type || "mouseleave" === e.type) {
                            var c = n.gridRect.getBoundingClientRect();
                            n.w.globals.mousedown && (n.endX = n.clientX - c.left, n.endY = n.clientY - c.top, n.dragX = Math.abs(n.endX - n.startX), n.dragY = Math.abs(n.endY - n.startY), (i.globals.zoomEnabled || i.globals.selectionEnabled) && n.selectionDrawn({
                                context: n,
                                zoomtype: r
                            }), i.globals.panEnabled && i.config.xaxis.convertedCatToNumeric && n.delayedPanScrolled()), i.globals.zoomEnabled && n.hideSelectionRect(this.selectionRect), n.dragged = !1, n.w.globals.mousedown = !1
                        }
                        this.makeSelectionRectDraggable()
                    }
                }
            }, {
                key: "makeSelectionRectDraggable",
                value: function () {
                    var t = this.w;
                    if (this.selectionRect) {
                        var e = this.selectionRect.node.getBoundingClientRect();
                        e.width > 0 && e.height > 0 && this.slDraggableRect.selectize({
                            points: "l, r",
                            pointSize: 8,
                            pointType: "rect"
                        }).resize({
                            constraint: {
                                minX: 0,
                                minY: 0,
                                maxX: t.globals.gridWidth,
                                maxY: t.globals.gridHeight
                            }
                        }).on("resizing", this.selectionDragging.bind(this, "resizing"))
                    }
                }
            }, {
                key: "preselectedSelection",
                value: function () {
                    var t = this.w,
                        e = this.xyRatios;
                    if (!t.globals.zoomEnabled)
                        if (void 0 !== t.globals.selection && null !== t.globals.selection) this.drawSelectionRect(t.globals.selection);
                        else if (void 0 !== t.config.chart.selection.xaxis.min && void 0 !== t.config.chart.selection.xaxis.max) {
                        var i = (t.config.chart.selection.xaxis.min - t.globals.minX) / e.xRatio,
                            n = {
                                x: i,
                                y: 0,
                                width: t.globals.gridWidth - (t.globals.maxX - t.config.chart.selection.xaxis.max) / e.xRatio - i,
                                height: t.globals.gridHeight,
                                translateX: 0,
                                translateY: 0,
                                selectionEnabled: !0
                            };
                        this.drawSelectionRect(n), this.makeSelectionRectDraggable(), "function" == typeof t.config.chart.events.selection && t.config.chart.events.selection(this.ctx, {
                            xaxis: {
                                min: t.config.chart.selection.xaxis.min,
                                max: t.config.chart.selection.xaxis.max
                            },
                            yaxis: {}
                        })
                    }
                }
            }, {
                key: "drawSelectionRect",
                value: function (t) {
                    var e = t.x,
                        i = t.y,
                        n = t.width,
                        l = t.height,
                        r = t.translateX,
                        a = void 0 === r ? 0 : r,
                        o = t.translateY,
                        s = void 0 === o ? 0 : o,
                        c = this.w,
                        u = this.zoomRect,
                        h = this.selectionRect;
                    if (this.dragged || null !== c.globals.selection) {
                        var d = {
                            transform: "translate(" + a + ", " + s + ")"
                        };
                        c.globals.zoomEnabled && this.dragged && (n < 0 && (n = 1), u.attr({
                            x: e,
                            y: i,
                            width: n,
                            height: l,
                            fill: c.config.chart.zoom.zoomedArea.fill.color,
                            "fill-opacity": c.config.chart.zoom.zoomedArea.fill.opacity,
                            stroke: c.config.chart.zoom.zoomedArea.stroke.color,
                            "stroke-width": c.config.chart.zoom.zoomedArea.stroke.width,
                            "stroke-opacity": c.config.chart.zoom.zoomedArea.stroke.opacity
                        }), w.setAttrs(u.node, d)), c.globals.selectionEnabled && (h.attr({
                            x: e,
                            y: i,
                            width: n > 0 ? n : 0,
                            height: l > 0 ? l : 0,
                            fill: c.config.chart.selection.fill.color,
                            "fill-opacity": c.config.chart.selection.fill.opacity,
                            stroke: c.config.chart.selection.stroke.color,
                            "stroke-width": c.config.chart.selection.stroke.width,
                            "stroke-dasharray": c.config.chart.selection.stroke.dashArray,
                            "stroke-opacity": c.config.chart.selection.stroke.opacity
                        }), w.setAttrs(h.node, d))
                    }
                }
            }, {
                key: "hideSelectionRect",
                value: function (t) {
                    t && t.attr({
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    })
                }
            }, {
                key: "selectionDrawing",
                value: function (t) {
                    var e, i = t.context,
                        n = t.zoomtype,
                        l = this.w,
                        r = i,
                        a = this.gridRect.getBoundingClientRect(),
                        o = r.startX - 1,
                        s = r.startY,
                        c = !1,
                        u = !1,
                        h = r.clientX - a.left - o,
                        d = r.clientY - a.top - s;
                    return Math.abs(h + o) > l.globals.gridWidth ? h = l.globals.gridWidth - o : r.clientX - a.left < 0 && (h = o), o > r.clientX - a.left && (c = !0, h = Math.abs(h)), s > r.clientY - a.top && (u = !0, d = Math.abs(d)), e = "x" === n ? {
                        x: c ? o - h : o,
                        y: 0,
                        width: h,
                        height: l.globals.gridHeight
                    } : "y" === n ? {
                        x: 0,
                        y: u ? s - d : s,
                        width: l.globals.gridWidth,
                        height: d
                    } : {
                        x: c ? o - h : o,
                        y: u ? s - d : s,
                        width: h,
                        height: d
                    }, r.drawSelectionRect(e), r.selectionDragging("resizing"), e
                }
            }, {
                key: "selectionDragging",
                value: function (t, e) {
                    var i = this,
                        n = this.w,
                        l = this.xyRatios,
                        r = this.selectionRect,
                        a = 0;
                    "resizing" === t && (a = 30);
                    var o = function (t) {
                            return parseFloat(r.node.getAttribute(t))
                        },
                        s = {
                            x: o("x"),
                            y: o("y"),
                            width: o("width"),
                            height: o("height")
                        };
                    n.globals.selection = s, "function" == typeof n.config.chart.events.selection && n.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout((function () {
                        var t = i.gridRect.getBoundingClientRect(),
                            e = r.node.getBoundingClientRect(),
                            a = {
                                xaxis: {
                                    min: n.globals.xAxisScale.niceMin + (e.left - t.left) * l.xRatio,
                                    max: n.globals.xAxisScale.niceMin + (e.right - t.left) * l.xRatio
                                },
                                yaxis: {
                                    min: n.globals.yAxisScale[0].niceMin + (t.bottom - e.bottom) * l.yRatio[0],
                                    max: n.globals.yAxisScale[0].niceMax - (e.top - t.top) * l.yRatio[0]
                                }
                            };
                        n.config.chart.events.selection(i.ctx, a), n.config.chart.brush.enabled && void 0 !== n.config.chart.events.brushScrolled && n.config.chart.events.brushScrolled(i.ctx, a)
                    }), a))
                }
            }, {
                key: "selectionDrawn",
                value: function (t) {
                    var e = t.context,
                        i = t.zoomtype,
                        n = this.w,
                        l = e,
                        r = this.xyRatios,
                        a = this.ctx.toolbar;
                    if (l.startX > l.endX) {
                        var o = l.startX;
                        l.startX = l.endX, l.endX = o
                    }
                    if (l.startY > l.endY) {
                        var s = l.startY;
                        l.startY = l.endY, l.endY = s
                    }
                    var c = void 0,
                        u = void 0;
                    n.globals.isTimelineBar ? (c = n.globals.yAxisScale[0].niceMin + l.startX * r.invertedYRatio, u = n.globals.yAxisScale[0].niceMin + l.endX * r.invertedYRatio) : (c = n.globals.xAxisScale.niceMin + l.startX * r.xRatio, u = n.globals.xAxisScale.niceMin + l.endX * r.xRatio);
                    var h = [],
                        d = [];
                    if (n.config.yaxis.forEach((function (t, e) {
                            h.push(n.globals.yAxisScale[e].niceMax - r.yRatio[e] * l.startY), d.push(n.globals.yAxisScale[e].niceMax - r.yRatio[e] * l.endY)
                        })), l.dragged && (l.dragX > 10 || l.dragY > 10) && c !== u)
                        if (n.globals.zoomEnabled) {
                            var f = y.clone(n.globals.initialConfig.yaxis),
                                p = y.clone(n.globals.initialConfig.xaxis);
                            if (n.globals.zoomed = !0, n.config.xaxis.convertedCatToNumeric && (c = Math.floor(c), u = Math.floor(u), c < 1 && (c = 1, u = n.globals.dataPoints), u - c < 2 && (u = c + 1)), "xy" !== i && "x" !== i || (p = {
                                    min: c,
                                    max: u
                                }), "xy" !== i && "y" !== i || f.forEach((function (t, e) {
                                    f[e].min = d[e], f[e].max = h[e]
                                })), n.config.chart.zoom.autoScaleYaxis) {
                                var g = new K(l.ctx);
                                f = g.autoScaleY(l.ctx, f, {
                                    xaxis: p
                                })
                            }
                            if (a) {
                                var m = a.getBeforeZoomRange(p, f);
                                m && (p = m.xaxis ? m.xaxis : p, f = m.yaxis ? m.yaxis : f)
                            }
                            var v = {
                                xaxis: p
                            };
                            n.config.chart.group || (v.yaxis = f), l.ctx.updateHelpers._updateOptions(v, !1, l.w.config.chart.animations.dynamicAnimation.enabled), "function" == typeof n.config.chart.events.zoomed && a.zoomCallback(p, f)
                        } else if (n.globals.selectionEnabled) {
                        var b, x = null;
                        b = {
                            min: c,
                            max: u
                        }, "xy" !== i && "y" !== i || (x = y.clone(n.config.yaxis)).forEach((function (t, e) {
                            x[e].min = d[e], x[e].max = h[e]
                        })), n.globals.selection = l.selection, "function" == typeof n.config.chart.events.selection && n.config.chart.events.selection(l.ctx, {
                            xaxis: b,
                            yaxis: x
                        })
                    }
                }
            }, {
                key: "panDragging",
                value: function (t) {
                    var e = t.context,
                        i = this.w,
                        n = e;
                    if (void 0 !== i.globals.lastClientPosition.x) {
                        var l = i.globals.lastClientPosition.x - n.clientX,
                            r = i.globals.lastClientPosition.y - n.clientY;
                        Math.abs(l) > Math.abs(r) && l > 0 ? this.moveDirection = "left" : Math.abs(l) > Math.abs(r) && l < 0 ? this.moveDirection = "right" : Math.abs(r) > Math.abs(l) && r > 0 ? this.moveDirection = "up" : Math.abs(r) > Math.abs(l) && r < 0 && (this.moveDirection = "down")
                    }
                    i.globals.lastClientPosition = {
                        x: n.clientX,
                        y: n.clientY
                    };
                    var a = i.globals.isTimelineBar ? i.globals.minY : i.globals.minX,
                        o = i.globals.isTimelineBar ? i.globals.maxY : i.globals.maxX;
                    i.config.xaxis.convertedCatToNumeric || n.panScrolled(a, o)
                }
            }, {
                key: "delayedPanScrolled",
                value: function () {
                    var t = this.w,
                        e = t.globals.minX,
                        i = t.globals.maxX,
                        n = (t.globals.maxX - t.globals.minX) / 2;
                    "left" === this.moveDirection ? (e = t.globals.minX + n, i = t.globals.maxX + n) : "right" === this.moveDirection && (e = t.globals.minX - n, i = t.globals.maxX - n), e = Math.floor(e), i = Math.floor(i), this.updateScrolledChart({
                        xaxis: {
                            min: e,
                            max: i
                        }
                    }, e, i)
                }
            }, {
                key: "panScrolled",
                value: function (t, e) {
                    var i = this.w,
                        n = this.xyRatios,
                        l = y.clone(i.globals.initialConfig.yaxis),
                        r = n.xRatio,
                        a = i.globals.minX,
                        o = i.globals.maxX;
                    i.globals.isTimelineBar && (r = n.invertedYRatio, a = i.globals.minY, o = i.globals.maxY), "left" === this.moveDirection ? (t = a + i.globals.gridWidth / 15 * r, e = o + i.globals.gridWidth / 15 * r) : "right" === this.moveDirection && (t = a - i.globals.gridWidth / 15 * r, e = o - i.globals.gridWidth / 15 * r), i.globals.isTimelineBar || (t < i.globals.initialMinX || e > i.globals.initialMaxX) && (t = a, e = o);
                    var s = {
                        min: t,
                        max: e
                    };
                    i.config.chart.zoom.autoScaleYaxis && (l = new K(this.ctx).autoScaleY(this.ctx, l, {
                        xaxis: s
                    }));
                    var c = {
                        xaxis: {
                            min: t,
                            max: e
                        }
                    };
                    i.config.chart.group || (c.yaxis = l), this.updateScrolledChart(c, t, e)
                }
            }, {
                key: "updateScrolledChart",
                value: function (t, e, i) {
                    var n = this.w;
                    this.ctx.updateHelpers._updateOptions(t, !1, !1), "function" == typeof n.config.chart.events.scrolled && n.config.chart.events.scrolled(this.ctx, {
                        xaxis: {
                            min: e,
                            max: i
                        }
                    })
                }
            }]), i
        }(),
        gt = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx
            }
            return o(t, [{
                key: "getNearestValues",
                value: function (t) {
                    var e = t.hoverArea,
                        i = t.elGrid,
                        n = t.clientX,
                        l = t.clientY,
                        r = this.w,
                        a = r.globals.gridWidth,
                        o = r.globals.gridHeight,
                        s = a / (r.globals.dataPoints - 1),
                        c = o / r.globals.dataPoints,
                        u = i.getBoundingClientRect(),
                        h = this.hasBars();
                    !r.globals.comboCharts && !h || r.config.xaxis.convertedCatToNumeric || (s = a / r.globals.dataPoints);
                    var d = n - u.left - r.globals.barPadForNumericAxis,
                        f = l - u.top;
                    d < 0 || f < 0 || d > r.globals.gridWidth || f > r.globals.gridHeight ? (e.classList.remove("hovering-zoom"), e.classList.remove("hovering-pan")) : r.globals.zoomEnabled ? (e.classList.remove("hovering-pan"), e.classList.add("hovering-zoom")) : r.globals.panEnabled && (e.classList.remove("hovering-zoom"), e.classList.add("hovering-pan"));
                    var p = Math.round(d / s),
                        g = Math.floor(f / c);
                    h && !r.config.xaxis.convertedCatToNumeric && (p = Math.ceil(d / s), p -= 1);
                    for (var m, v = null, b = null, x = [], w = 0; w < r.globals.seriesXvalues.length; w++) x.push([r.globals.seriesXvalues[w][0] - 1e-6].concat(r.globals.seriesXvalues[w]));
                    return x = x.map((function (t) {
                        return t.filter((function (t) {
                            return t
                        }))
                    })), m = r.globals.seriesYvalues.map((function (t) {
                        return t.filter((function (t) {
                            return y.isNumber(t)
                        }))
                    })), r.globals.isXNumeric && (v = (b = this.closestInMultiArray(d, f, x, m)).index, p = b.j, null !== v && (x = r.globals.seriesXvalues[v], p = (b = this.closestInArray(d, x)).index)), r.globals.capturedSeriesIndex = null === v ? -1 : v, (!p || p < 1) && (p = 0), r.globals.capturedDataPointIndex = p, {
                        capturedSeries: v,
                        j: r.globals.isBarHorizontal ? g : p,
                        hoverX: d,
                        hoverY: f
                    }
                }
            }, {
                key: "closestInMultiArray",
                value: function (t, e, i, n) {
                    var l = this.w,
                        r = 0,
                        a = null,
                        o = -1;
                    l.globals.series.length > 1 ? r = this.getFirstActiveXArray(i) : a = 0;
                    var s = n[r][0],
                        c = i[r][0],
                        u = Math.abs(t - c),
                        h = Math.abs(e - s),
                        d = h + u;
                    return n.map((function (l, r) {
                        l.map((function (l, s) {
                            var c = Math.abs(e - n[r][s]),
                                f = Math.abs(t - i[r][s]),
                                p = f + c;
                            p < d && (d = p, u = f, h = c, a = r, o = s)
                        }))
                    })), {
                        index: a,
                        j: o
                    }
                }
            }, {
                key: "getFirstActiveXArray",
                value: function (t) {
                    for (var e = 0, i = t.map((function (t, e) {
                            return t.length > 0 ? e : -1
                        })), n = 0; n < i.length; n++)
                        if (-1 !== i[n]) {
                            e = i[n];
                            break
                        } return e
                }
            }, {
                key: "closestInArray",
                value: function (t, e) {
                    for (var i = e[0], n = null, l = Math.abs(t - i), r = 0; r < e.length; r++) {
                        var a = Math.abs(t - e[r]);
                        a < l && (l = a, n = r)
                    }
                    return {
                        index: n
                    }
                }
            }, {
                key: "isXoverlap",
                value: function (t) {
                    var e = [],
                        i = this.w.globals.seriesX.filter((function (t) {
                            return void 0 !== t[0]
                        }));
                    if (i.length > 0)
                        for (var n = 0; n < i.length - 1; n++) void 0 !== i[n][t] && void 0 !== i[n + 1][t] && i[n][t] !== i[n + 1][t] && e.push("unEqual");
                    return 0 === e.length
                }
            }, {
                key: "isInitialSeriesSameLen",
                value: function () {
                    for (var t = !0, e = this.w.globals.initialSeries, i = 0; i < e.length - 1; i++)
                        if (e[i].data.length !== e[i + 1].data.length) {
                            t = !1;
                            break
                        } return t
                }
            }, {
                key: "getBarsHeight",
                value: function (t) {
                    return m(t).reduce((function (t, e) {
                        return t + e.getBBox().height
                    }), 0)
                }
            }, {
                key: "getElMarkers",
                value: function () {
                    return this.w.globals.dom.baseEl.querySelectorAll(" .apexcharts-series-markers")
                }
            }, {
                key: "getAllMarkers",
                value: function () {
                    var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
                    (t = m(t)).sort((function (t, e) {
                        return Number(e.getAttribute("data:realIndex")) < Number(t.getAttribute("data:realIndex")) ? 0 : -1
                    }));
                    var e = [];
                    return t.forEach((function (t) {
                        e.push(t.querySelector(".apexcharts-marker"))
                    })), e
                }
            }, {
                key: "hasMarkers",
                value: function () {
                    return this.getElMarkers().length > 0
                }
            }, {
                key: "getElBars",
                value: function () {
                    return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series")
                }
            }, {
                key: "hasBars",
                value: function () {
                    return this.getElBars().length > 0
                }
            }, {
                key: "getHoverMarkerSize",
                value: function (t) {
                    var e = this.w,
                        i = e.config.markers.hover.size;
                    return void 0 === i && (i = e.globals.markers.size[t] + e.config.markers.hover.sizeOffset), i
                }
            }, {
                key: "toggleAllTooltipSeriesGroups",
                value: function (t) {
                    var e = this.w,
                        i = this.ttCtx;
                    0 === i.allTooltipSeriesGroups.length && (i.allTooltipSeriesGroups = e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
                    for (var n = i.allTooltipSeriesGroups, l = 0; l < n.length; l++) "enable" === t ? (n[l].classList.add("apexcharts-active"), n[l].style.display = e.config.tooltip.items.display) : (n[l].classList.remove("apexcharts-active"), n[l].style.display = "none")
                }
            }]), t
        }(),
        mt = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new gt(e)
            }
            return o(t, [{
                key: "drawSeriesTexts",
                value: function (t) {
                    var e = t.shared,
                        i = void 0 === e || e,
                        n = t.ttItems,
                        l = t.i,
                        r = void 0 === l ? 0 : l,
                        a = t.j,
                        o = void 0 === a ? null : a,
                        s = t.y1,
                        c = t.y2,
                        u = t.e,
                        h = this.w;
                    void 0 !== h.config.tooltip.custom ? this.handleCustomTooltip({
                        i: r,
                        j: o,
                        y1: s,
                        y2: c,
                        w: h
                    }) : this.toggleActiveInactiveSeries(i);
                    var d = this.getValuesToPrint({
                        i: r,
                        j: o
                    });
                    this.printLabels({
                        i: r,
                        j: o,
                        values: d,
                        ttItems: n,
                        shared: i,
                        e: u
                    });
                    var f = this.ttCtx.getElTooltip();
                    this.ttCtx.tooltipRect.ttWidth = f.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = f.getBoundingClientRect().height
                }
            }, {
                key: "printLabels",
                value: function (t) {
                    var e, i = this,
                        n = t.i,
                        l = t.j,
                        r = t.values,
                        a = t.ttItems,
                        o = t.shared,
                        s = t.e,
                        c = this.w,
                        h = r.xVal,
                        d = r.zVal,
                        f = r.xAxisTTVal,
                        p = "",
                        g = c.globals.colors[n];
                    null !== l && c.config.plotOptions.bar.distributed && (g = c.globals.colors[l]);
                    for (var m = function (t, r) {
                            var m = i.getFormatters(n);
                            p = i.getSeriesName({
                                fn: m.yLbTitleFormatter,
                                index: n,
                                seriesIndex: n,
                                j: l
                            }), "treemap" === c.config.chart.type && (p = m.yLbTitleFormatter(String(c.config.series[n].data[l].x), {
                                series: c.globals.series,
                                seriesIndex: n,
                                dataPointIndex: l,
                                w: c
                            }));
                            var v = c.config.tooltip.inverseOrder ? r : t;
                            if (c.globals.axisCharts) {
                                var y = function (t) {
                                    return m.yLbFormatter(c.globals.series[t][l], {
                                        series: c.globals.series,
                                        seriesIndex: t,
                                        dataPointIndex: l,
                                        w: c
                                    })
                                };
                                o ? (m = i.getFormatters(v), p = i.getSeriesName({
                                    fn: m.yLbTitleFormatter,
                                    index: v,
                                    seriesIndex: n,
                                    j: l
                                }), g = c.globals.colors[v], e = y(v)) : (s && s.target && s.target.getAttribute("fill") && (g = s.target.getAttribute("fill")), e = y(n))
                            }
                            null === l && (e = m.yLbFormatter(c.globals.series[n], u(u({}, c), {}, {
                                seriesIndex: n,
                                dataPointIndex: n
                            }))), i.DOMHandling({
                                i: n,
                                t: v,
                                j: l,
                                ttItems: a,
                                values: {
                                    val: e,
                                    xVal: h,
                                    xAxisTTVal: f,
                                    zVal: d
                                },
                                seriesName: p,
                                shared: o,
                                pColor: g
                            })
                        }, v = 0, y = c.globals.series.length - 1; v < c.globals.series.length; v++, y--) m(v, y)
                }
            }, {
                key: "getFormatters",
                value: function (t) {
                    var e, i = this.w,
                        n = i.globals.yLabelFormatters[t];
                    return void 0 !== i.globals.ttVal ? Array.isArray(i.globals.ttVal) ? (n = i.globals.ttVal[t] && i.globals.ttVal[t].formatter, e = i.globals.ttVal[t] && i.globals.ttVal[t].title && i.globals.ttVal[t].title.formatter) : (n = i.globals.ttVal.formatter, "function" == typeof i.globals.ttVal.title.formatter && (e = i.globals.ttVal.title.formatter)) : e = i.config.tooltip.y.title.formatter, "function" != typeof n && (n = i.globals.yLabelFormatters[0] ? i.globals.yLabelFormatters[0] : function (t) {
                        return t
                    }), "function" != typeof e && (e = function (t) {
                        return t
                    }), {
                        yLbFormatter: n,
                        yLbTitleFormatter: e
                    }
                }
            }, {
                key: "getSeriesName",
                value: function (t) {
                    var e = t.fn,
                        i = t.index,
                        n = t.seriesIndex,
                        l = t.j,
                        r = this.w;
                    return e(String(r.globals.seriesNames[i]), {
                        series: r.globals.series,
                        seriesIndex: n,
                        dataPointIndex: l,
                        w: r
                    })
                }
            }, {
                key: "DOMHandling",
                value: function (t) {
                    t.i;
                    var e = t.t,
                        i = (t.j, t.ttItems),
                        n = t.values,
                        l = t.seriesName,
                        r = t.shared,
                        a = t.pColor,
                        o = this.w,
                        s = this.ttCtx,
                        c = n.val,
                        u = n.xVal,
                        h = n.xAxisTTVal,
                        d = n.zVal,
                        f = null;
                    f = i[e].children, o.config.tooltip.fillSeriesColor && (i[e].style.backgroundColor = a, f[0].style.display = "none"), s.showTooltipTitle && (null === s.tooltipTitle && (s.tooltipTitle = o.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), s.tooltipTitle.innerHTML = u), s.blxaxisTooltip && (s.xaxisTooltipText.innerHTML = "" !== h ? h : u);
                    var p = i[e].querySelector(".apexcharts-tooltip-text-label");
                    p && (p.innerHTML = l || "");
                    var g = i[e].querySelector(".apexcharts-tooltip-text-value");
                    g && (g.innerHTML = void 0 !== c ? c : ""), f[0] && f[0].classList.contains("apexcharts-tooltip-marker") && (o.config.tooltip.marker.fillColors && Array.isArray(o.config.tooltip.marker.fillColors) && (a = o.config.tooltip.marker.fillColors[e]), f[0].style.backgroundColor = a), o.config.tooltip.marker.show || (f[0].style.display = "none"), null !== d && (i[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = o.config.tooltip.z.title, i[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = void 0 !== d ? d : ""), r && f[0] && (null == c || o.globals.collapsedSeriesIndices.indexOf(e) > -1 ? f[0].parentNode.style.display = "none" : f[0].parentNode.style.display = o.config.tooltip.items.display)
                }
            }, {
                key: "toggleActiveInactiveSeries",
                value: function (t) {
                    var e = this.w;
                    if (t) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
                    else {
                        this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
                        var i = e.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group");
                        i && (i.classList.add("apexcharts-active"), i.style.display = e.config.tooltip.items.display)
                    }
                }
            }, {
                key: "getValuesToPrint",
                value: function (t) {
                    var e = t.i,
                        i = t.j,
                        n = this.w,
                        l = this.ctx.series.filteredSeriesX(),
                        r = "",
                        a = "",
                        o = null,
                        s = null,
                        c = {
                            series: n.globals.series,
                            seriesIndex: e,
                            dataPointIndex: i,
                            w: n
                        },
                        u = n.globals.ttZFormatter;
                    null === i ? s = n.globals.series[e] : n.globals.isXNumeric && "treemap" !== n.config.chart.type ? (r = l[e][i], 0 === l[e].length && (r = l[this.tooltipUtil.getFirstActiveXArray(l)][i])) : r = void 0 !== n.globals.labels[i] ? n.globals.labels[i] : "";
                    var h = r;
                    return r = n.globals.isXNumeric && "datetime" === n.config.xaxis.type ? new X(this.ctx).xLabelFormat(n.globals.ttKeyFormatter, h, h, {
                        i: void 0,
                        dateFormatter: new F(this.ctx).formatDate,
                        w: this.w
                    }) : n.globals.isBarHorizontal ? n.globals.yLabelFormatters[0](h, c) : n.globals.xLabelFormatter(h, c), void 0 !== n.config.tooltip.x.formatter && (r = n.globals.ttKeyFormatter(h, c)), n.globals.seriesZ.length > 0 && n.globals.seriesZ[e].length > 0 && (o = u(n.globals.seriesZ[e][i], n)), a = "function" == typeof n.config.xaxis.tooltip.formatter ? n.globals.xaxisTooltipFormatter(h, c) : r, {
                        val: Array.isArray(s) ? s.join(" ") : s,
                        xVal: Array.isArray(r) ? r.join(" ") : r,
                        xAxisTTVal: Array.isArray(a) ? a.join(" ") : a,
                        zVal: o
                    }
                }
            }, {
                key: "handleCustomTooltip",
                value: function (t) {
                    var e = t.i,
                        i = t.j,
                        n = t.y1,
                        l = t.y2,
                        r = t.w,
                        a = this.ttCtx.getElTooltip(),
                        o = r.config.tooltip.custom;
                    Array.isArray(o) && o[e] && (o = o[e]), a.innerHTML = o({
                        ctx: this.ctx,
                        series: r.globals.series,
                        seriesIndex: e,
                        dataPointIndex: i,
                        y1: n,
                        y2: l,
                        w: r
                    })
                }
            }]), t
        }(),
        vt = function () {
            function t(e) {
                r(this, t), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w
            }
            return o(t, [{
                key: "moveXCrosshairs",
                value: function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                        i = this.ttCtx,
                        n = this.w,
                        l = i.getElXCrosshairs(),
                        r = t - i.xcrosshairsWidth / 2,
                        a = n.globals.labels.slice().length;
                    if (null !== e && (r = n.globals.gridWidth / a * e), null !== l && (l.setAttribute("x", r), l.setAttribute("x1", r), l.setAttribute("x2", r), l.setAttribute("y2", n.globals.gridHeight), l.classList.add("apexcharts-active")), r < 0 && (r = 0), r > n.globals.gridWidth && (r = n.globals.gridWidth), i.blxaxisTooltip) {
                        var o = r;
                        "tickWidth" !== n.config.xaxis.crosshairs.width && "barWidth" !== n.config.xaxis.crosshairs.width || (o = r + i.xcrosshairsWidth / 2), this.moveXAxisTooltip(o)
                    }
                }
            }, {
                key: "moveYCrosshairs",
                value: function (t) {
                    var e = this.ttCtx;
                    null !== e.ycrosshairs && w.setAttrs(e.ycrosshairs, {
                        y1: t,
                        y2: t
                    }), null !== e.ycrosshairsHidden && w.setAttrs(e.ycrosshairsHidden, {
                        y1: t,
                        y2: t
                    })
                }
            }, {
                key: "moveXAxisTooltip",
                value: function (t) {
                    var e = this.w,
                        i = this.ttCtx;
                    if (null !== i.xaxisTooltip) {
                        i.xaxisTooltip.classList.add("apexcharts-active");
                        var n, l = i.xaxisOffY + e.config.xaxis.tooltip.offsetY + e.globals.translateY + 1 + e.config.xaxis.offsetY;
                        if (t -= i.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(t)) t += e.globals.translateX, n = new w(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML), i.xaxisTooltipText.style.minWidth = n.width + "px", i.xaxisTooltip.style.left = t + "px", i.xaxisTooltip.style.top = l + "px"
                    }
                }
            }, {
                key: "moveYAxisTooltip",
                value: function (t) {
                    var e = this.w,
                        i = this.ttCtx;
                    null === i.yaxisTTEls && (i.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                    var n = parseInt(i.ycrosshairsHidden.getAttribute("y1"), 10),
                        l = e.globals.translateY + n,
                        r = i.yaxisTTEls[t].getBoundingClientRect().height,
                        a = e.globals.translateYAxisX[t] - 2;
                    e.config.yaxis[t].opposite && (a -= 26), l -= r / 2, -1 === e.globals.ignoreYAxisIndexes.indexOf(t) ? (i.yaxisTTEls[t].classList.add("apexcharts-active"), i.yaxisTTEls[t].style.top = l + "px", i.yaxisTTEls[t].style.left = a + e.config.yaxis[t].tooltip.offsetX + "px") : i.yaxisTTEls[t].classList.remove("apexcharts-active")
                }
            }, {
                key: "moveTooltip",
                value: function (t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                        n = this.w,
                        l = this.ttCtx,
                        r = l.getElTooltip(),
                        a = l.tooltipRect,
                        o = null !== i ? parseFloat(i) : 1,
                        s = parseFloat(t) + o + 5,
                        c = parseFloat(e) + o / 2;
                    if (s > n.globals.gridWidth / 2 && (s = s - a.ttWidth - o - 15), s > n.globals.gridWidth - a.ttWidth - 10 && (s = n.globals.gridWidth - a.ttWidth), s < -20 && (s = -20), n.config.tooltip.followCursor) {
                        var u = l.getElGrid(),
                            h = u.getBoundingClientRect();
                        c = l.e.clientY + n.globals.translateY - h.top - a.ttHeight / 2
                    } else n.globals.isBarHorizontal ? c -= a.ttHeight : (a.ttHeight / 2 + c > n.globals.gridHeight && (c = n.globals.gridHeight - a.ttHeight + n.globals.translateY), c < 0 && (c = 0));
                    isNaN(s) || (s += n.globals.translateX, r.style.left = s + "px", r.style.top = c + "px")
                }
            }, {
                key: "moveMarkers",
                value: function (t, e) {
                    var i = this.w,
                        n = this.ttCtx;
                    if (i.globals.markers.size[t] > 0)
                        for (var l = i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-marker")), r = 0; r < l.length; r++) parseInt(l[r].getAttribute("rel"), 10) === e && (n.marker.resetPointsSize(), n.marker.enlargeCurrentPoint(e, l[r]));
                    else n.marker.resetPointsSize(), this.moveDynamicPointOnHover(e, t)
                }
            }, {
                key: "moveDynamicPointOnHover",
                value: function (t, e) {
                    var i, n, l = this.w,
                        r = this.ttCtx,
                        a = l.globals.pointsArray,
                        o = r.tooltipUtil.getHoverMarkerSize(e),
                        s = l.config.series[e].type;
                    if (!s || "column" !== s && "candlestick" !== s && "boxPlot" !== s) {
                        i = a[e][t][0], n = a[e][t][1] ? a[e][t][1] : 0;
                        var c = l.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers circle"));
                        c && n < l.globals.gridHeight && n > 0 && (c.setAttribute("r", o), c.setAttribute("cx", i), c.setAttribute("cy", n)), this.moveXCrosshairs(i), r.fixedTooltip || this.moveTooltip(i, n, o)
                    }
                }
            }, {
                key: "moveDynamicPointsOnHover",
                value: function (t) {
                    var e, i = this.ttCtx,
                        n = i.w,
                        l = 0,
                        r = 0,
                        a = n.globals.pointsArray;
                    e = new j(this.ctx).getActiveConfigSeriesIndex(!0);
                    var o = i.tooltipUtil.getHoverMarkerSize(e);
                    a[e] && (l = a[e][t][0], r = a[e][t][1]);
                    var s = i.tooltipUtil.getAllMarkers();
                    if (null !== s)
                        for (var c = 0; c < n.globals.series.length; c++) {
                            var u = a[c];
                            if (n.globals.comboCharts && void 0 === u && s.splice(c, 0, null), u && u.length) {
                                var h = a[c][t][1];
                                s[c].setAttribute("cx", l), null !== h && !isNaN(h) && h < n.globals.gridHeight && h > 0 ? (s[c] && s[c].setAttribute("r", o), s[c] && s[c].setAttribute("cy", h)) : s[c] && s[c].setAttribute("r", 0)
                            }
                        }
                    if (this.moveXCrosshairs(l), !i.fixedTooltip) {
                        var d = r || n.globals.gridHeight;
                        this.moveTooltip(l, d, o)
                    }
                }
            }, {
                key: "moveStickyTooltipOverBars",
                value: function (t) {
                    var e = this.w,
                        i = this.ttCtx,
                        n = e.globals.columnSeries ? e.globals.columnSeries.length : e.globals.series.length,
                        l = n >= 2 && n % 2 == 0 ? Math.floor(n / 2) : Math.floor(n / 2) + 1;
                    e.globals.isBarHorizontal && (l = new j(this.ctx).getActiveConfigSeriesIndex(!1, "desc") + 1);
                    var r = e.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(l, "'] path[j='").concat(t, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(l, "'] path[j='").concat(t, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(l, "'] path[j='").concat(t, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(l, "'] path[j='").concat(t, "']")),
                        a = r ? parseFloat(r.getAttribute("cx")) : 0,
                        o = r ? parseFloat(r.getAttribute("cy")) : 0,
                        s = r ? parseFloat(r.getAttribute("barWidth")) : 0,
                        c = r ? parseFloat(r.getAttribute("barHeight")) : 0,
                        u = i.getElGrid().getBoundingClientRect();
                    if (e.globals.isXNumeric ? (a -= n % 2 != 0 ? s / 2 : 0, r && (r.classList.contains("apexcharts-candlestick-area") || r.classList.contains("apexcharts-boxPlot-area")) && e.globals.comboCharts && (a -= s / 2)) : e.globals.isBarHorizontal || (a = i.xAxisTicksPositions[t - 1] + i.dataPointsDividedWidth / 2, isNaN(a) && (a = i.xAxisTicksPositions[t] - i.dataPointsDividedWidth / 2)), e.globals.isBarHorizontal ? o += c / 3 : o = i.e.clientY - u.top - i.tooltipRect.ttHeight / 2, e.globals.isBarHorizontal || this.moveXCrosshairs(a), !i.fixedTooltip) {
                        var h = o || e.globals.gridHeight;
                        this.moveTooltip(a, h)
                    }
                }
            }]), t
        }(),
        yt = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new vt(e)
            }
            return o(t, [{
                key: "drawDynamicPoints",
                value: function () {
                    var t = this.w,
                        e = new w(this.ctx),
                        i = new P(this.ctx),
                        n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                    n = m(n), t.config.chart.stacked && n.sort((function (t, e) {
                        return parseFloat(t.getAttribute("data:realIndex")) - parseFloat(e.getAttribute("data:realIndex"))
                    }));
                    for (var l = 0; l < n.length; l++) {
                        var r = n[l].querySelector(".apexcharts-series-markers-wrap");
                        if (null !== r) {
                            var a = void 0,
                                o = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
                            "line" !== t.config.chart.type && "area" !== t.config.chart.type || t.globals.comboCharts || t.config.tooltip.intersect || (o += " no-pointer-events");
                            var s = i.getMarkerConfig(o, l);
                            (a = e.drawMarker(0, 0, s)).node.setAttribute("default-marker-size", 0);
                            var c = document.createElementNS(t.globals.SVGNS, "g");
                            c.classList.add("apexcharts-series-markers"), c.appendChild(a.node), r.appendChild(c)
                        }
                    }
                }
            }, {
                key: "enlargeCurrentPoint",
                value: function (t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
                        l = this.w;
                    "bubble" !== l.config.chart.type && this.newPointSize(t, e);
                    var r = e.getAttribute("cx"),
                        a = e.getAttribute("cy");
                    if (null !== i && null !== n && (r = i, a = n), this.tooltipPosition.moveXCrosshairs(r), !this.fixedTooltip) {
                        if ("radar" === l.config.chart.type) {
                            var o = this.ttCtx.getElGrid(),
                                s = o.getBoundingClientRect();
                            r = this.ttCtx.e.clientX - s.left
                        }
                        this.tooltipPosition.moveTooltip(r, a, l.config.markers.hover.size)
                    }
                }
            }, {
                key: "enlargePoints",
                value: function (t) {
                    for (var e = this.w, i = this, n = this.ttCtx, l = t, r = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), a = e.config.markers.hover.size, o = 0; o < r.length; o++) {
                        var s = r[o].getAttribute("rel"),
                            c = r[o].getAttribute("index");
                        if (void 0 === a && (a = e.globals.markers.size[c] + e.config.markers.hover.sizeOffset), l === parseInt(s, 10)) {
                            i.newPointSize(l, r[o]);
                            var u = r[o].getAttribute("cx"),
                                h = r[o].getAttribute("cy");
                            i.tooltipPosition.moveXCrosshairs(u), n.fixedTooltip || i.tooltipPosition.moveTooltip(u, h, a)
                        } else i.oldPointSize(r[o])
                    }
                }
            }, {
                key: "newPointSize",
                value: function (t, e) {
                    var i = this.w,
                        n = i.config.markers.hover.size,
                        l = 0 === t ? e.parentNode.firstChild : e.parentNode.lastChild;
                    if ("0" !== l.getAttribute("default-marker-size")) {
                        var r = parseInt(l.getAttribute("index"), 10);
                        void 0 === n && (n = i.globals.markers.size[r] + i.config.markers.hover.sizeOffset), n < 0 && (n = 0), l.setAttribute("r", n)
                    }
                }
            }, {
                key: "oldPointSize",
                value: function (t) {
                    var e = parseFloat(t.getAttribute("default-marker-size"));
                    t.setAttribute("r", e)
                }
            }, {
                key: "resetPointsSize",
                value: function () {
                    for (var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), e = 0; e < t.length; e++) {
                        var i = parseFloat(t[e].getAttribute("default-marker-size"));
                        y.isNumber(i) && i >= 0 ? t[e].setAttribute("r", i) : t[e].setAttribute("r", 0)
                    }
                }
            }]), t
        }(),
        bt = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.ttCtx = e
            }
            return o(t, [{
                key: "getAttr",
                value: function (t, e) {
                    return parseFloat(t.target.getAttribute(e))
                }
            }, {
                key: "handleHeatTreeTooltip",
                value: function (t) {
                    var e = t.e,
                        i = t.opt,
                        n = t.x,
                        l = t.y,
                        r = t.type,
                        a = this.ttCtx,
                        o = this.w;
                    if (e.target.classList.contains("apexcharts-".concat(r, "-rect"))) {
                        var s = this.getAttr(e, "i"),
                            c = this.getAttr(e, "j"),
                            u = this.getAttr(e, "cx"),
                            h = this.getAttr(e, "cy"),
                            d = this.getAttr(e, "width"),
                            f = this.getAttr(e, "height");
                        if (a.tooltipLabels.drawSeriesTexts({
                                ttItems: i.ttItems,
                                i: s,
                                j: c,
                                shared: !1,
                                e: e
                            }), o.globals.capturedSeriesIndex = s, o.globals.capturedDataPointIndex = c, n = u + a.tooltipRect.ttWidth / 2 + d, l = h + a.tooltipRect.ttHeight / 2 - f / 2, a.tooltipPosition.moveXCrosshairs(u + d / 2), n > o.globals.gridWidth / 2 && (n = u - a.tooltipRect.ttWidth / 2 + d), a.w.config.tooltip.followCursor) {
                            var p = o.globals.dom.elWrap.getBoundingClientRect();
                            n = o.globals.clientX - p.left - a.tooltipRect.ttWidth / 2, l = o.globals.clientY - p.top - a.tooltipRect.ttHeight - 5
                        }
                    }
                    return {
                        x: n,
                        y: l
                    }
                }
            }, {
                key: "handleMarkerTooltip",
                value: function (t) {
                    var e, i, n = t.e,
                        l = t.opt,
                        r = t.x,
                        a = t.y,
                        o = this.w,
                        s = this.ttCtx;
                    if (n.target.classList.contains("apexcharts-marker")) {
                        var c = parseInt(l.paths.getAttribute("cx"), 10),
                            u = parseInt(l.paths.getAttribute("cy"), 10),
                            h = parseFloat(l.paths.getAttribute("val"));
                        if (i = parseInt(l.paths.getAttribute("rel"), 10), e = parseInt(l.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, s.intersect) {
                            var d = y.findAncestor(l.paths, "apexcharts-series");
                            d && (e = parseInt(d.getAttribute("data:realIndex"), 10))
                        }
                        if (s.tooltipLabels.drawSeriesTexts({
                                ttItems: l.ttItems,
                                i: e,
                                j: i,
                                shared: !s.showOnIntersect && o.config.tooltip.shared,
                                e: n
                            }), "mouseup" === n.type && s.markerClick(n, e, i), o.globals.capturedSeriesIndex = e, o.globals.capturedDataPointIndex = i, r = c, a = u + o.globals.translateY - 1.4 * s.tooltipRect.ttHeight, s.w.config.tooltip.followCursor) {
                            var f = s.getElGrid().getBoundingClientRect();
                            a = s.e.clientY + o.globals.translateY - f.top
                        }
                        h < 0 && (a = u), s.marker.enlargeCurrentPoint(i, l.paths, r, a)
                    }
                    return {
                        x: r,
                        y: a
                    }
                }
            }, {
                key: "handleBarTooltip",
                value: function (t) {
                    var e, i, n = t.e,
                        l = t.opt,
                        r = this.w,
                        a = this.ttCtx,
                        o = a.getElTooltip(),
                        s = 0,
                        c = 0,
                        u = 0,
                        h = this.getBarTooltipXY({
                            e: n,
                            opt: l
                        });
                    e = h.i;
                    var d = h.barHeight,
                        f = h.j;
                    r.globals.capturedSeriesIndex = e, r.globals.capturedDataPointIndex = f, r.globals.isBarHorizontal && a.tooltipUtil.hasBars() || !r.config.tooltip.shared ? (c = h.x, u = h.y, i = Array.isArray(r.config.stroke.width) ? r.config.stroke.width[e] : r.config.stroke.width, s = c) : r.globals.comboCharts || r.config.tooltip.shared || (s /= 2), isNaN(u) ? u = r.globals.svgHeight - a.tooltipRect.ttHeight : u < 0 && (u = 0);
                    var p = parseInt(l.paths.parentNode.getAttribute("data:realIndex"), 10),
                        g = r.globals.isMultipleYAxis ? r.config.yaxis[p] && r.config.yaxis[p].reversed : r.config.yaxis[0].reversed;
                    if (c + a.tooltipRect.ttWidth > r.globals.gridWidth && !g ? c -= a.tooltipRect.ttWidth : c < 0 && (c = 0), a.w.config.tooltip.followCursor) {
                        var m = a.getElGrid().getBoundingClientRect();
                        u = a.e.clientY - m.top
                    }
                    null === a.tooltip && (a.tooltip = r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), r.config.tooltip.shared || (r.globals.comboBarCount > 0 ? a.tooltipPosition.moveXCrosshairs(s + i / 2) : a.tooltipPosition.moveXCrosshairs(s)), !a.fixedTooltip && (!r.config.tooltip.shared || r.globals.isBarHorizontal && a.tooltipUtil.hasBars()) && (g && (c -= a.tooltipRect.ttWidth) < 0 && (c = 0), o.style.left = c + r.globals.translateX + "px", !g || r.globals.isBarHorizontal && a.tooltipUtil.hasBars() || (u = u + d - 2 * (r.globals.series[e][f] < 0 ? d : 0)), a.tooltipRect.ttHeight + u > r.globals.gridHeight ? (u = r.globals.gridHeight - a.tooltipRect.ttHeight + r.globals.translateY, o.style.top = u + "px") : o.style.top = u + r.globals.translateY - a.tooltipRect.ttHeight / 2 + "px")
                }
            }, {
                key: "getBarTooltipXY",
                value: function (t) {
                    var e = t.e,
                        i = t.opt,
                        n = this.w,
                        l = null,
                        r = this.ttCtx,
                        a = 0,
                        o = 0,
                        s = 0,
                        c = 0,
                        u = 0,
                        h = e.target.classList;
                    if (h.contains("apexcharts-bar-area") || h.contains("apexcharts-candlestick-area") || h.contains("apexcharts-boxPlot-area") || h.contains("apexcharts-rangebar-area")) {
                        var d = e.target,
                            f = d.getBoundingClientRect(),
                            p = i.elGrid.getBoundingClientRect(),
                            g = f.height;
                        u = f.height;
                        var m = f.width,
                            v = parseInt(d.getAttribute("cx"), 10),
                            y = parseInt(d.getAttribute("cy"), 10);
                        c = parseFloat(d.getAttribute("barWidth"));
                        var b = "touchmove" === e.type ? e.touches[0].clientX : e.clientX;
                        l = parseInt(d.getAttribute("j"), 10), a = parseInt(d.parentNode.getAttribute("rel"), 10) - 1;
                        var x = d.getAttribute("data-range-y1"),
                            w = d.getAttribute("data-range-y2");
                        n.globals.comboCharts && (a = parseInt(d.parentNode.getAttribute("data:realIndex"), 10)), r.tooltipLabels.drawSeriesTexts({
                            ttItems: i.ttItems,
                            i: a,
                            j: l,
                            y1: x ? parseInt(x, 10) : null,
                            y2: w ? parseInt(w, 10) : null,
                            shared: !r.showOnIntersect && n.config.tooltip.shared,
                            e: e
                        }), n.config.tooltip.followCursor ? n.globals.isBarHorizontal ? (o = b - p.left + 15, s = y - r.dataPointsDividedHeight + g / 2 - r.tooltipRect.ttHeight / 2) : (o = n.globals.isXNumeric ? v - m / 2 : v - r.dataPointsDividedWidth + m / 2, s = e.clientY - p.top - r.tooltipRect.ttHeight / 2 - 15) : n.globals.isBarHorizontal ? ((o = v) < r.xyRatios.baseLineInvertedY && (o = v - r.tooltipRect.ttWidth), s = y - r.dataPointsDividedHeight + g / 2 - r.tooltipRect.ttHeight / 2) : (o = n.globals.isXNumeric ? v - m / 2 : v - r.dataPointsDividedWidth + m / 2, s = y)
                    }
                    return {
                        x: o,
                        y: s,
                        barHeight: u,
                        barWidth: c,
                        i: a,
                        j: l
                    }
                }
            }]), t
        }(),
        xt = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.ttCtx = e
            }
            return o(t, [{
                key: "drawXaxisTooltip",
                value: function () {
                    var t = this.w,
                        e = this.ttCtx,
                        i = "bottom" === t.config.xaxis.position;
                    e.xaxisOffY = i ? t.globals.gridHeight + 1 : -t.globals.xAxisHeight - t.config.xaxis.axisTicks.height + 3;
                    var n = i ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top",
                        l = t.globals.dom.elWrap;
                    e.blxaxisTooltip && null === t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") && (e.xaxisTooltip = document.createElement("div"), e.xaxisTooltip.setAttribute("class", n + " apexcharts-theme-" + t.config.tooltip.theme), l.appendChild(e.xaxisTooltip), e.xaxisTooltipText = document.createElement("div"), e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), e.xaxisTooltipText.style.fontFamily = t.config.xaxis.tooltip.style.fontFamily || t.config.chart.fontFamily, e.xaxisTooltipText.style.fontSize = t.config.xaxis.tooltip.style.fontSize, e.xaxisTooltip.appendChild(e.xaxisTooltipText))
                }
            }, {
                key: "drawYaxisTooltip",
                value: function () {
                    for (var t = this.w, e = this.ttCtx, i = function (i) {
                            var n = t.config.yaxis[i].opposite || t.config.yaxis[i].crosshairs.opposite;
                            e.yaxisOffX = n ? t.globals.gridWidth + 1 : 1;
                            var l = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i, n ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left");
                            t.globals.yAxisSameScaleIndices.map((function (e, n) {
                                e.map((function (e, n) {
                                    n === i && (l += t.config.yaxis[n].show ? " " : " apexcharts-yaxistooltip-hidden")
                                }))
                            }));
                            var r = t.globals.dom.elWrap;
                            null === t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i)) && (e.yaxisTooltip = document.createElement("div"), e.yaxisTooltip.setAttribute("class", l + " apexcharts-theme-" + t.config.tooltip.theme), r.appendChild(e.yaxisTooltip), 0 === i && (e.yaxisTooltipText = []), e.yaxisTooltipText[i] = document.createElement("div"), e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"), e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]))
                        }, n = 0; n < t.config.yaxis.length; n++) i(n)
                }
            }, {
                key: "setXCrosshairWidth",
                value: function () {
                    var t = this.w,
                        e = this.ttCtx,
                        i = e.getElXCrosshairs();
                    if (e.xcrosshairsWidth = parseInt(t.config.xaxis.crosshairs.width, 10), t.globals.comboCharts) {
                        var n = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                        if (null !== n && "barWidth" === t.config.xaxis.crosshairs.width) {
                            var l = parseFloat(n.getAttribute("barWidth"));
                            e.xcrosshairsWidth = l
                        } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                            var r = t.globals.labels.length;
                            e.xcrosshairsWidth = t.globals.gridWidth / r
                        }
                    } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                        var a = t.globals.labels.length;
                        e.xcrosshairsWidth = t.globals.gridWidth / a
                    } else if ("barWidth" === t.config.xaxis.crosshairs.width) {
                        var o = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                        if (null !== o) {
                            var s = parseFloat(o.getAttribute("barWidth"));
                            e.xcrosshairsWidth = s
                        } else e.xcrosshairsWidth = 1
                    }
                    t.globals.isBarHorizontal && (e.xcrosshairsWidth = 0), null !== i && e.xcrosshairsWidth > 0 && i.setAttribute("width", e.xcrosshairsWidth)
                }
            }, {
                key: "handleYCrosshair",
                value: function () {
                    var t = this.w,
                        e = this.ttCtx;
                    e.ycrosshairs = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), e.ycrosshairsHidden = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden")
                }
            }, {
                key: "drawYaxisTooltipText",
                value: function (t, e, i) {
                    var n = this.ttCtx,
                        l = this.w,
                        r = l.globals.yLabelFormatters[t];
                    if (n.yaxisTooltips[t]) {
                        var a = n.getElGrid().getBoundingClientRect(),
                            o = (e - a.top) * i.yRatio[t],
                            s = l.globals.maxYArr[t] - l.globals.minYArr[t],
                            c = l.globals.minYArr[t] + (s - o);
                        n.tooltipPosition.moveYCrosshairs(e - a.top), n.yaxisTooltipText[t].innerHTML = r(c), n.tooltipPosition.moveYAxisTooltip(t)
                    }
                }
            }]), t
        }(),
        wt = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w;
                var i = this.w;
                this.tConfig = i.config.tooltip, this.tooltipUtil = new gt(this), this.tooltipLabels = new mt(this), this.tooltipPosition = new vt(this), this.marker = new yt(this), this.intersect = new bt(this), this.axesTooltip = new xt(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !i.globals.isBarHorizontal && this.tConfig.shared
            }
            return o(t, [{
                key: "getElTooltip",
                value: function (t) {
                    return t || (t = this), t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip")
                }
            }, {
                key: "getElXCrosshairs",
                value: function () {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs")
                }
            }, {
                key: "getElGrid",
                value: function () {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid")
                }
            }, {
                key: "drawTooltip",
                value: function (t) {
                    var e = this.w;
                    this.xyRatios = t, this.blxaxisTooltip = e.config.xaxis.tooltip.enabled && e.globals.axisCharts, this.yaxisTooltips = e.config.yaxis.map((function (t, i) {
                        return !!(t.show && t.tooltip.enabled && e.globals.axisCharts)
                    })), this.allTooltipSeriesGroups = [], e.globals.axisCharts || (this.showTooltipTitle = !1);
                    var i = document.createElement("div");
                    if (i.classList.add("apexcharts-tooltip"), i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)), e.globals.dom.elWrap.appendChild(i), e.globals.axisCharts) {
                        this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
                        var n = new G(this.ctx);
                        this.xAxisTicksPositions = n.getXAxisTicksPositions()
                    }
                    if (!e.globals.comboCharts && !this.tConfig.intersect && "rangeBar" !== e.config.chart.type || this.tConfig.shared || (this.showOnIntersect = !0), 0 !== e.config.markers.size && 0 !== e.globals.markers.largestSize || this.marker.drawDynamicPoints(this), e.globals.collapsedSeries.length !== e.globals.series.length) {
                        this.dataPointsDividedHeight = e.globals.gridHeight / e.globals.dataPoints, this.dataPointsDividedWidth = e.globals.gridWidth / e.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || e.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, i.appendChild(this.tooltipTitle));
                        var l = e.globals.series.length;
                        (e.globals.xyCharts || e.globals.comboCharts) && this.tConfig.shared && (l = this.showOnIntersect ? 1 : e.globals.series.length), this.legendLabels = e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(l), this.addSVGEvents()
                    }
                }
            }, {
                key: "createTTElements",
                value: function (t) {
                    for (var e = this.w, i = [], n = this.getElTooltip(), l = 0; l < t; l++) {
                        var r = document.createElement("div");
                        r.classList.add("apexcharts-tooltip-series-group"), r.style.order = e.config.tooltip.inverseOrder ? t - l : l + 1, this.tConfig.shared && this.tConfig.enabledOnSeries && Array.isArray(this.tConfig.enabledOnSeries) && this.tConfig.enabledOnSeries.indexOf(l) < 0 && r.classList.add("apexcharts-tooltip-series-group-hidden");
                        var a = document.createElement("span");
                        a.classList.add("apexcharts-tooltip-marker"), a.style.backgroundColor = e.globals.colors[l], r.appendChild(a);
                        var o = document.createElement("div");
                        o.classList.add("apexcharts-tooltip-text"), o.style.fontFamily = this.tConfig.style.fontFamily || e.config.chart.fontFamily, o.style.fontSize = this.tConfig.style.fontSize;
                        var s = document.createElement("div");
                        s.classList.add("apexcharts-tooltip-y-group");
                        var c = document.createElement("span");
                        c.classList.add("apexcharts-tooltip-text-label"), s.appendChild(c);
                        var u = document.createElement("span");
                        u.classList.add("apexcharts-tooltip-text-value"), s.appendChild(u);
                        var h = document.createElement("div");
                        h.classList.add("apexcharts-tooltip-z-group");
                        var d = document.createElement("span");
                        d.classList.add("apexcharts-tooltip-text-z-label"), h.appendChild(d);
                        var f = document.createElement("span");
                        f.classList.add("apexcharts-tooltip-text-z-value"), h.appendChild(f), o.appendChild(s), o.appendChild(h), r.appendChild(o), n.appendChild(r), i.push(r)
                    }
                    return i
                }
            }, {
                key: "addSVGEvents",
                value: function () {
                    var t = this.w,
                        e = t.config.chart.type,
                        i = this.getElTooltip(),
                        n = !("bar" !== e && "candlestick" !== e && "boxPlot" !== e && "rangeBar" !== e),
                        l = "area" === e || "line" === e || "scatter" === e || "bubble" === e || "radar" === e,
                        r = t.globals.dom.Paper.node,
                        a = this.getElGrid();
                    a && (this.seriesBound = a.getBoundingClientRect());
                    var o, s = [],
                        c = [],
                        u = {
                            hoverArea: r,
                            elGrid: a,
                            tooltipEl: i,
                            tooltipY: s,
                            tooltipX: c,
                            ttItems: this.ttItems
                        };
                    if (t.globals.axisCharts && (l ? o = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : n ? o = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : "heatmap" !== e && "treemap" !== e || (o = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), o && o.length))
                        for (var h = 0; h < o.length; h++) s.push(o[h].getAttribute("cy")), c.push(o[h].getAttribute("cx"));
                    if (t.globals.xyCharts && !this.showOnIntersect || t.globals.comboCharts && !this.showOnIntersect || n && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([r], u);
                    else if (n && !t.globals.comboCharts || l && this.showOnIntersect) this.addDatapointEventsListeners(u);
                    else if (!t.globals.axisCharts || "heatmap" === e || "treemap" === e) {
                        var d = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                        this.addPathsEventListeners(d, u)
                    }
                    if (this.showOnIntersect) {
                        var f = t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
                        f.length > 0 && this.addPathsEventListeners(f, u), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(u)
                    }
                }
            }, {
                key: "drawFixedTooltipRect",
                value: function () {
                    var t = this.w,
                        e = this.getElTooltip(),
                        i = e.getBoundingClientRect(),
                        n = i.width + 10,
                        l = i.height + 10,
                        r = this.tConfig.fixed.offsetX,
                        a = this.tConfig.fixed.offsetY,
                        o = this.tConfig.fixed.position.toLowerCase();
                    return o.indexOf("right") > -1 && (r = r + t.globals.svgWidth - n + 10), o.indexOf("bottom") > -1 && (a = a + t.globals.svgHeight - l - 10), e.style.left = r + "px", e.style.top = a + "px", {
                        x: r,
                        y: a,
                        ttWidth: n,
                        ttHeight: l
                    }
                }
            }, {
                key: "addDatapointEventsListeners",
                value: function (t) {
                    var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
                    this.addPathsEventListeners(e, t)
                }
            }, {
                key: "addPathsEventListeners",
                value: function (t, e) {
                    for (var i = this, n = function (n) {
                            var l = {
                                paths: t[n],
                                tooltipEl: e.tooltipEl,
                                tooltipY: e.tooltipY,
                                tooltipX: e.tooltipX,
                                elGrid: e.elGrid,
                                hoverArea: e.hoverArea,
                                ttItems: e.ttItems
                            };
                            ["mousemove", "mouseup", "touchmove", "mouseout", "touchend"].map((function (e) {
                                return t[n].addEventListener(e, i.seriesHover.bind(i, l), {
                                    capture: !1,
                                    passive: !0
                                })
                            }))
                        }, l = 0; l < t.length; l++) n(l)
                }
            }, {
                key: "seriesHover",
                value: function (t, e) {
                    var i = this,
                        n = [],
                        l = this.w;
                    l.config.chart.group && (n = this.ctx.getGroupedCharts()), l.globals.axisCharts && (l.globals.minX === -1 / 0 && l.globals.maxX === 1 / 0 || 0 === l.globals.dataPoints) || (n.length ? n.forEach((function (n) {
                        var l = i.getElTooltip(n),
                            r = {
                                paths: t.paths,
                                tooltipEl: l,
                                tooltipY: t.tooltipY,
                                tooltipX: t.tooltipX,
                                elGrid: t.elGrid,
                                hoverArea: t.hoverArea,
                                ttItems: n.w.globals.tooltip.ttItems
                            };
                        n.w.globals.minX === i.w.globals.minX && n.w.globals.maxX === i.w.globals.maxX && n.w.globals.tooltip.seriesHoverByContext({
                            chartCtx: n,
                            ttCtx: n.w.globals.tooltip,
                            opt: r,
                            e: e
                        })
                    })) : this.seriesHoverByContext({
                        chartCtx: this.ctx,
                        ttCtx: this.w.globals.tooltip,
                        opt: t,
                        e: e
                    }))
                }
            }, {
                key: "seriesHoverByContext",
                value: function (t) {
                    var e = t.chartCtx,
                        i = t.ttCtx,
                        n = t.opt,
                        l = t.e,
                        r = e.w,
                        a = this.getElTooltip();
                    i.tooltipRect = {
                        x: 0,
                        y: 0,
                        ttWidth: a.getBoundingClientRect().width,
                        ttHeight: a.getBoundingClientRect().height
                    }, i.e = l, !i.tooltipUtil.hasBars() || r.globals.comboCharts || i.isBarShared || this.tConfig.onDatasetHover.highlightDataSeries && new j(e).toggleSeriesOnHover(l, l.target.parentNode), i.fixedTooltip && i.drawFixedTooltipRect(), r.globals.axisCharts ? i.axisChartsTooltips({
                        e: l,
                        opt: n,
                        tooltipRect: i.tooltipRect
                    }) : i.nonAxisChartsTooltips({
                        e: l,
                        opt: n,
                        tooltipRect: i.tooltipRect
                    })
                }
            }, {
                key: "axisChartsTooltips",
                value: function (t) {
                    var e, i, n = t.e,
                        l = t.opt,
                        r = this.w,
                        a = l.elGrid.getBoundingClientRect(),
                        o = "touchmove" === n.type ? n.touches[0].clientX : n.clientX,
                        s = "touchmove" === n.type ? n.touches[0].clientY : n.clientY;
                    if (this.clientY = s, this.clientX = o, r.globals.capturedSeriesIndex = -1, r.globals.capturedDataPointIndex = -1, s < a.top || s > a.top + a.height) this.handleMouseOut(l);
                    else {
                        if (Array.isArray(this.tConfig.enabledOnSeries) && !r.config.tooltip.shared) {
                            var c = parseInt(l.paths.getAttribute("index"), 10);
                            if (this.tConfig.enabledOnSeries.indexOf(c) < 0) return void this.handleMouseOut(l)
                        }
                        var u = this.getElTooltip(),
                            h = this.getElXCrosshairs(),
                            d = r.globals.xyCharts || "bar" === r.config.chart.type && !r.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || r.globals.comboCharts && this.tooltipUtil.hasBars();
                        if ("mousemove" === n.type || "touchmove" === n.type || "mouseup" === n.type) {
                            null !== h && h.classList.add("apexcharts-active");
                            var f = this.yaxisTooltips.filter((function (t) {
                                return !0 === t
                            }));
                            if (null !== this.ycrosshairs && f.length && this.ycrosshairs.classList.add("apexcharts-active"), d && !this.showOnIntersect) this.handleStickyTooltip(n, o, s, l);
                            else if ("heatmap" === r.config.chart.type || "treemap" === r.config.chart.type) {
                                var p = this.intersect.handleHeatTreeTooltip({
                                    e: n,
                                    opt: l,
                                    x: e,
                                    y: i,
                                    type: r.config.chart.type
                                });
                                e = p.x, i = p.y, u.style.left = e + "px", u.style.top = i + "px"
                            } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({
                                e: n,
                                opt: l
                            }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({
                                e: n,
                                opt: l,
                                x: e,
                                y: i
                            });
                            if (this.yaxisTooltips.length)
                                for (var g = 0; g < r.config.yaxis.length; g++) this.axesTooltip.drawYaxisTooltipText(g, s, this.xyRatios);
                            l.tooltipEl.classList.add("apexcharts-active")
                        } else "mouseout" !== n.type && "touchend" !== n.type || this.handleMouseOut(l)
                    }
                }
            }, {
                key: "nonAxisChartsTooltips",
                value: function (t) {
                    var e = t.e,
                        i = t.opt,
                        n = t.tooltipRect,
                        l = this.w,
                        r = i.paths.getAttribute("rel"),
                        a = this.getElTooltip(),
                        o = l.globals.dom.elWrap.getBoundingClientRect();
                    if ("mousemove" === e.type || "touchmove" === e.type) {
                        a.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({
                            ttItems: i.ttItems,
                            i: parseInt(r, 10) - 1,
                            shared: !1
                        });
                        var s = l.globals.clientX - o.left - n.ttWidth / 2,
                            c = l.globals.clientY - o.top - n.ttHeight - 10;
                        if (a.style.left = s + "px", a.style.top = c + "px", l.config.legend.tooltipHoverFormatter) {
                            var u = r - 1,
                                h = (0, l.config.legend.tooltipHoverFormatter)(this.legendLabels[u].getAttribute("data:default-text"), {
                                    seriesIndex: u,
                                    dataPointIndex: u,
                                    w: l
                                });
                            this.legendLabels[u].innerHTML = h
                        }
                    } else "mouseout" !== e.type && "touchend" !== e.type || (a.classList.remove("apexcharts-active"), l.config.legend.tooltipHoverFormatter && this.legendLabels.forEach((function (t) {
                        var e = t.getAttribute("data:default-text");
                        t.innerHTML = decodeURIComponent(e)
                    })))
                }
            }, {
                key: "handleStickyTooltip",
                value: function (t, e, i, n) {
                    var l = this.w,
                        r = this.tooltipUtil.getNearestValues({
                            context: this,
                            hoverArea: n.hoverArea,
                            elGrid: n.elGrid,
                            clientX: e,
                            clientY: i
                        }),
                        a = r.j,
                        o = r.capturedSeries;
                    r.hoverX < 0 || r.hoverX > l.globals.gridWidth ? this.handleMouseOut(n) : null !== o ? this.handleStickyCapturedSeries(t, o, n, a) : (this.tooltipUtil.isXoverlap(a) || l.globals.isBarHorizontal) && this.create(t, this, 0, a, n.ttItems)
                }
            }, {
                key: "handleStickyCapturedSeries",
                value: function (t, e, i, n) {
                    var l = this.w;
                    null === l.globals.series[e][n] ? this.handleMouseOut(i) : void 0 !== l.globals.series[e][n] ? this.tConfig.shared && this.tooltipUtil.isXoverlap(n) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(t, this, e, n, i.ttItems) : this.create(t, this, e, n, i.ttItems, !1) : this.tooltipUtil.isXoverlap(n) && this.create(t, this, 0, n, i.ttItems)
                }
            }, {
                key: "deactivateHoverFilter",
                value: function () {
                    for (var t = this.w, e = new w(this.ctx), i = t.globals.dom.Paper.select(".apexcharts-bar-area"), n = 0; n < i.length; n++) e.pathMouseLeave(i[n])
                }
            }, {
                key: "handleMouseOut",
                value: function (t) {
                    var e = this.w,
                        i = this.getElXCrosshairs();
                    if (t.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), "bubble" !== e.config.chart.type && this.marker.resetPointsSize(), null !== i && i.classList.remove("apexcharts-active"), null !== this.ycrosshairs && this.ycrosshairs.classList.remove("apexcharts-active"), this.blxaxisTooltip && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
                        null === this.yaxisTTEls && (this.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                        for (var n = 0; n < this.yaxisTTEls.length; n++) this.yaxisTTEls[n].classList.remove("apexcharts-active")
                    }
                    e.config.legend.tooltipHoverFormatter && this.legendLabels.forEach((function (t) {
                        var e = t.getAttribute("data:default-text");
                        t.innerHTML = decodeURIComponent(e)
                    }))
                }
            }, {
                key: "markerClick",
                value: function (t, e, i) {
                    var n = this.w;
                    "function" == typeof n.config.chart.events.markerClick && n.config.chart.events.markerClick(t, this.ctx, {
                        seriesIndex: e,
                        dataPointIndex: i,
                        w: n
                    }), this.ctx.events.fireEvent("markerClick", [t, this.ctx, {
                        seriesIndex: e,
                        dataPointIndex: i,
                        w: n
                    }])
                }
            }, {
                key: "create",
                value: function (t, e, i, n, l) {
                    var r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
                        a = this.w,
                        o = e;
                    "mouseup" === t.type && this.markerClick(t, i, n), null === r && (r = this.tConfig.shared);
                    var s = this.tooltipUtil.hasMarkers(),
                        c = this.tooltipUtil.getElBars();
                    if (a.config.legend.tooltipHoverFormatter) {
                        var u = a.config.legend.tooltipHoverFormatter,
                            h = Array.from(this.legendLabels);
                        h.forEach((function (t) {
                            var e = t.getAttribute("data:default-text");
                            t.innerHTML = decodeURIComponent(e)
                        }));
                        for (var d = 0; d < h.length; d++) {
                            var f = h[d],
                                p = parseInt(f.getAttribute("i"), 10),
                                g = decodeURIComponent(f.getAttribute("data:default-text")),
                                m = u(g, {
                                    seriesIndex: r ? p : i,
                                    dataPointIndex: n,
                                    w: a
                                });
                            if (r) f.innerHTML = a.globals.collapsedSeriesIndices.indexOf(p) < 0 ? m : g;
                            else if (f.innerHTML = p === i ? m : g, i === p) break
                        }
                    }
                    if (r) {
                        if (o.tooltipLabels.drawSeriesTexts({
                                ttItems: l,
                                i: i,
                                j: n,
                                shared: !this.showOnIntersect && this.tConfig.shared
                            }), s && (a.globals.markers.largestSize > 0 ? o.marker.enlargePoints(n) : o.tooltipPosition.moveDynamicPointsOnHover(n)), this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(c), this.barSeriesHeight > 0)) {
                            var v = new w(this.ctx),
                                y = a.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(n, "']"));
                            this.deactivateHoverFilter(), this.tooltipPosition.moveStickyTooltipOverBars(n);
                            for (var b = 0; b < y.length; b++) v.pathMouseEnter(y[b])
                        }
                    } else o.tooltipLabels.drawSeriesTexts({
                        shared: !1,
                        ttItems: l,
                        i: i,
                        j: n
                    }), this.tooltipUtil.hasBars() && o.tooltipPosition.moveStickyTooltipOverBars(n), s && o.tooltipPosition.moveMarkers(i, n)
                }
            }]), t
        }(),
        _t = function (t) {
            h(i, R);
            var e = g(i);

            function i() {
                return r(this, i), e.apply(this, arguments)
            }
            return o(i, [{
                key: "draw",
                value: function (t, e) {
                    var i = this,
                        n = this.w;
                    this.graphics = new w(this.ctx), this.bar = new R(this.ctx, this.xyRatios);
                    var l = new S(this.ctx, n);
                    t = l.getLogSeries(t), this.yRatio = l.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t), "100%" === n.config.chart.stackType && (t = n.globals.seriesPercent.slice()), this.series = t, this.totalItems = 0, this.prevY = [], this.prevX = [], this.prevYF = [], this.prevXF = [], this.prevYVal = [], this.prevXVal = [], this.xArrj = [], this.xArrjF = [], this.xArrjVal = [], this.yArrj = [], this.yArrjF = [], this.yArrjVal = [];
                    for (var r = 0; r < t.length; r++) t[r].length > 0 && (this.totalItems += t[r].length);
                    for (var a = this.graphics.group({
                            class: "apexcharts-bar-series apexcharts-plot-series"
                        }), o = 0, s = 0, c = function (l, r) {
                            var c = void 0,
                                h = void 0,
                                d = void 0,
                                f = void 0,
                                p = [],
                                g = [],
                                m = n.globals.comboCharts ? e[l] : l;
                            i.yRatio.length > 1 && (i.yaxisIndex = m), i.isReversed = n.config.yaxis[i.yaxisIndex] && n.config.yaxis[i.yaxisIndex].reversed;
                            var v = i.graphics.group({
                                class: "apexcharts-series",
                                seriesName: y.escapeString(n.globals.seriesNames[m]),
                                rel: l + 1,
                                "data:realIndex": m
                            });
                            i.ctx.series.addCollapsedClassToSeries(v, m);
                            var b = i.graphics.group({
                                    class: "apexcharts-datalabels",
                                    "data:realIndex": m
                                }),
                                x = 0,
                                w = 0,
                                _ = i.initialPositions(o, s, c, h, d, f);
                            s = _.y, x = _.barHeight, h = _.yDivision, f = _.zeroW, o = _.x, w = _.barWidth, c = _.xDivision, d = _.zeroH, i.yArrj = [], i.yArrjF = [], i.yArrjVal = [], i.xArrj = [], i.xArrjF = [], i.xArrjVal = [], 1 === i.prevY.length && i.prevY[0].every((function (t) {
                                return isNaN(t)
                            })) && (i.prevY[0] = i.prevY[0].map((function (t) {
                                return d
                            })), i.prevYF[0] = i.prevYF[0].map((function (t) {
                                return 0
                            })));
                            for (var k = 0; k < n.globals.dataPoints; k++) {
                                var S = i.barHelpers.getStrokeWidth(l, k, m),
                                    A = {
                                        indexes: {
                                            i: l,
                                            j: k,
                                            realIndex: m,
                                            bc: r
                                        },
                                        strokeWidth: S,
                                        x: o,
                                        y: s,
                                        elSeries: v
                                    },
                                    M = null;
                                i.isHorizontal ? (M = i.drawStackedBarPaths(u(u({}, A), {}, {
                                    zeroW: f,
                                    barHeight: x,
                                    yDivision: h
                                })), w = i.series[l][k] / i.invertedYRatio) : (M = i.drawStackedColumnPaths(u(u({}, A), {}, {
                                    xDivision: c,
                                    barWidth: w,
                                    zeroH: d
                                })), x = i.series[l][k] / i.yRatio[i.yaxisIndex]), s = M.y, o = M.x, p.push(o), g.push(s);
                                var C = i.barHelpers.getPathFillColor(t, l, k, m);
                                v = i.renderSeries({
                                    realIndex: m,
                                    pathFill: C,
                                    j: k,
                                    i: l,
                                    pathFrom: M.pathFrom,
                                    pathTo: M.pathTo,
                                    strokeWidth: S,
                                    elSeries: v,
                                    x: o,
                                    y: s,
                                    series: t,
                                    barHeight: x,
                                    barWidth: w,
                                    elDataLabelsWrap: b,
                                    type: "bar",
                                    visibleSeries: 0
                                })
                            }
                            n.globals.seriesXvalues[m] = p, n.globals.seriesYvalues[m] = g, i.prevY.push(i.yArrj), i.prevYF.push(i.yArrjF), i.prevYVal.push(i.yArrjVal), i.prevX.push(i.xArrj), i.prevXF.push(i.xArrjF), i.prevXVal.push(i.xArrjVal), a.add(v)
                        }, h = 0, d = 0; h < t.length; h++, d++) c(h, d);
                    return a
                }
            }, {
                key: "initialPositions",
                value: function (t, e, i, n, l, r) {
                    var a, o, s = this.w;
                    return this.isHorizontal ? (a = (a = n = s.globals.gridHeight / s.globals.dataPoints) * parseInt(s.config.plotOptions.bar.barHeight, 10) / 100, r = this.baseLineInvertedY + s.globals.padHorizontal + (this.isReversed ? s.globals.gridWidth : 0) - (this.isReversed ? 2 * this.baseLineInvertedY : 0), e = (n - a) / 2) : (o = i = s.globals.gridWidth / s.globals.dataPoints, o = s.globals.isXNumeric && s.globals.dataPoints > 1 ? (i = s.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : o * parseInt(s.config.plotOptions.bar.columnWidth, 10) / 100, l = this.baseLineY[this.yaxisIndex] + (this.isReversed ? s.globals.gridHeight : 0) - (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), t = s.globals.padHorizontal + (i - o) / 2), {
                        x: t,
                        y: e,
                        yDivision: n,
                        xDivision: i,
                        barHeight: a,
                        barWidth: o,
                        zeroH: l,
                        zeroW: r
                    }
                }
            }, {
                key: "drawStackedBarPaths",
                value: function (t) {
                    for (var e, i = t.indexes, n = t.barHeight, l = t.strokeWidth, r = t.zeroW, a = t.x, o = t.y, s = t.yDivision, c = t.elSeries, u = this.w, h = o, d = i.i, f = i.j, p = 0, g = 0; g < this.prevXF.length; g++) p += this.prevXF[g][f];
                    if (d > 0) {
                        var m = r;
                        this.prevXVal[d - 1][f] < 0 ? m = this.series[d][f] >= 0 ? this.prevX[d - 1][f] + p - 2 * (this.isReversed ? p : 0) : this.prevX[d - 1][f] : this.prevXVal[d - 1][f] >= 0 && (m = this.series[d][f] >= 0 ? this.prevX[d - 1][f] : this.prevX[d - 1][f] - p + 2 * (this.isReversed ? p : 0)), e = m
                    } else e = r;
                    a = null === this.series[d][f] ? e : e + this.series[d][f] / this.invertedYRatio - 2 * (this.isReversed ? this.series[d][f] / this.invertedYRatio : 0);
                    var v = this.barHelpers.getBarpaths({
                        barYPosition: h,
                        barHeight: n,
                        x1: e,
                        x2: a,
                        strokeWidth: l,
                        series: this.series,
                        realIndex: i.realIndex,
                        i: d,
                        j: f,
                        w: u
                    });
                    return this.barHelpers.barBackground({
                        j: f,
                        i: d,
                        y1: h,
                        y2: n,
                        elSeries: c
                    }), o += s, {
                        pathTo: v.pathTo,
                        pathFrom: v.pathFrom,
                        x: a,
                        y: o
                    }
                }
            }, {
                key: "drawStackedColumnPaths",
                value: function (t) {
                    var e = t.indexes,
                        i = t.x,
                        n = t.y,
                        l = t.xDivision,
                        r = t.barWidth,
                        a = t.zeroH,
                        o = (t.strokeWidth, t.elSeries),
                        s = this.w,
                        c = e.i,
                        u = e.j,
                        h = e.bc;
                    if (s.globals.isXNumeric) {
                        var d = s.globals.seriesX[c][u];
                        d || (d = 0), i = (d - s.globals.minX) / this.xRatio - r / 2
                    }
                    for (var f, p = i, g = 0, m = 0; m < this.prevYF.length; m++) g += isNaN(this.prevYF[m][u]) ? 0 : this.prevYF[m][u];
                    if (c > 0 && !s.globals.isXNumeric || c > 0 && s.globals.isXNumeric && s.globals.seriesX[c - 1][u] === s.globals.seriesX[c][u]) {
                        var v, y, b = Math.min(this.yRatio.length + 1, c + 1);
                        if (void 0 !== this.prevY[c - 1])
                            for (var x = 1; x < b; x++)
                                if (!isNaN(this.prevY[c - x][u])) {
                                    y = this.prevY[c - x][u];
                                    break
                                } for (var w = 1; w < b; w++) {
                            if (this.prevYVal[c - w][u] < 0) {
                                v = this.series[c][u] >= 0 ? y - g + 2 * (this.isReversed ? g : 0) : y;
                                break
                            }
                            if (this.prevYVal[c - w][u] >= 0) {
                                v = this.series[c][u] >= 0 ? y : y + g - 2 * (this.isReversed ? g : 0);
                                break
                            }
                        }
                        void 0 === v && (v = s.globals.gridHeight), f = this.prevYF[0].every((function (t) {
                            return 0 === t
                        })) && this.prevYF.slice(1, c).every((function (t) {
                            return t.every((function (t) {
                                return isNaN(t)
                            }))
                        })) ? s.globals.gridHeight - a : v
                    } else f = s.globals.gridHeight - a;
                    n = f - this.series[c][u] / this.yRatio[this.yaxisIndex] + 2 * (this.isReversed ? this.series[c][u] / this.yRatio[this.yaxisIndex] : 0);
                    var _ = this.barHelpers.getColumnPaths({
                        barXPosition: p,
                        barWidth: r,
                        y1: f,
                        y2: n,
                        yRatio: this.yRatio[this.yaxisIndex],
                        strokeWidth: this.strokeWidth,
                        series: this.series,
                        realIndex: e.realIndex,
                        i: c,
                        j: u,
                        w: s
                    });
                    return this.barHelpers.barBackground({
                        bc: h,
                        j: u,
                        i: c,
                        x1: p,
                        x2: r,
                        elSeries: o
                    }), i += l, {
                        pathTo: _.pathTo,
                        pathFrom: _.pathFrom,
                        x: s.globals.isXNumeric ? i - l : i,
                        y: n
                    }
                }
            }]), i
        }(),
        kt = function (t) {
            h(i, R);
            var e = g(i);

            function i() {
                return r(this, i), e.apply(this, arguments)
            }
            return o(i, [{
                key: "draw",
                value: function (t, e) {
                    var i = this,
                        n = this.w,
                        l = new w(this.ctx),
                        r = new T(this.ctx);
                    this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot;
                    var a = new S(this.ctx, n);
                    t = a.getLogSeries(t), this.series = t, this.yRatio = a.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                    for (var o = l.group({
                            class: "apexcharts-".concat(n.config.chart.type, "-series apexcharts-plot-series")
                        }), s = function (a) {
                            i.isBoxPlot = "boxPlot" === n.config.chart.type || "boxPlot" === n.config.series[a].type;
                            var s, c, u, h, d = void 0,
                                f = void 0,
                                p = [],
                                g = [],
                                m = n.globals.comboCharts ? e[a] : a,
                                v = l.group({
                                    class: "apexcharts-series",
                                    seriesName: y.escapeString(n.globals.seriesNames[m]),
                                    rel: a + 1,
                                    "data:realIndex": m
                                });
                            t[a].length > 0 && (i.visibleI = i.visibleI + 1), i.yRatio.length > 1 && (i.yaxisIndex = m);
                            var b = i.barHelpers.initialPositions();
                            f = b.y, u = b.barHeight, d = b.x, h = b.barWidth, s = b.xDivision, c = b.zeroH, g.push(d + h / 2);
                            for (var x = l.group({
                                    class: "apexcharts-datalabels",
                                    "data:realIndex": m
                                }), w = function (e) {
                                    var l = i.barHelpers.getStrokeWidth(a, e, m),
                                        o = i.drawBoxPaths({
                                            indexes: {
                                                i: a,
                                                j: e,
                                                realIndex: m
                                            },
                                            x: d,
                                            y: f,
                                            xDivision: s,
                                            barWidth: h,
                                            zeroH: c,
                                            strokeWidth: l,
                                            elSeries: v
                                        });
                                    f = o.y, d = o.x, e > 0 && g.push(d + h / 2), p.push(f), o.pathTo.forEach((function (s, c) {
                                        var p = !i.isBoxPlot && i.candlestickOptions.wick.useFillColor ? o.color[c] : n.globals.stroke.colors[a],
                                            g = r.fillPath({
                                                seriesNumber: m,
                                                dataPointIndex: e,
                                                color: o.color[c],
                                                value: t[a][e]
                                            });
                                        i.renderSeries({
                                            realIndex: m,
                                            pathFill: g,
                                            lineFill: p,
                                            j: e,
                                            i: a,
                                            pathFrom: o.pathFrom,
                                            pathTo: s,
                                            strokeWidth: l,
                                            elSeries: v,
                                            x: d,
                                            y: f,
                                            series: t,
                                            barHeight: u,
                                            barWidth: h,
                                            elDataLabelsWrap: x,
                                            visibleSeries: i.visibleI,
                                            type: n.config.chart.type
                                        })
                                    }))
                                }, _ = 0; _ < n.globals.dataPoints; _++) w(_);
                            n.globals.seriesXvalues[m] = g, n.globals.seriesYvalues[m] = p, o.add(v)
                        }, c = 0; c < t.length; c++) s(c);
                    return o
                }
            }, {
                key: "drawBoxPaths",
                value: function (t) {
                    var e = t.indexes,
                        i = t.x,
                        n = (t.y, t.xDivision),
                        l = t.barWidth,
                        r = t.zeroH,
                        a = t.strokeWidth,
                        o = this.w,
                        s = new w(this.ctx),
                        c = e.i,
                        u = e.j,
                        h = !0,
                        d = o.config.plotOptions.candlestick.colors.upward,
                        f = o.config.plotOptions.candlestick.colors.downward,
                        p = "";
                    this.isBoxPlot && (p = [this.boxOptions.colors.lower, this.boxOptions.colors.upper]);
                    var g = this.yRatio[this.yaxisIndex],
                        m = e.realIndex,
                        v = this.getOHLCValue(m, u),
                        y = r,
                        b = r;
                    v.o > v.c && (h = !1);
                    var x = Math.min(v.o, v.c),
                        _ = Math.max(v.o, v.c),
                        k = v.m;
                    o.globals.isXNumeric && (i = (o.globals.seriesX[m][u] - o.globals.minX) / this.xRatio - l / 2);
                    var S = i + l * this.visibleI;
                    void 0 === this.series[c][u] || null === this.series[c][u] ? (x = r, _ = r) : (x = r - x / g, _ = r - _ / g, y = r - v.h / g, b = r - v.l / g, k = r - v.m / g);
                    var A = s.move(S, r),
                        M = s.move(S + l / 2, x);
                    return o.globals.previousPaths.length > 0 && (M = this.getPreviousPath(m, u, !0)), A = this.isBoxPlot ? [s.move(S, x) + s.line(S + l / 2, x) + s.line(S + l / 2, y) + s.line(S + l / 4, y) + s.line(S + l - l / 4, y) + s.line(S + l / 2, y) + s.line(S + l / 2, x) + s.line(S + l, x) + s.line(S + l, k) + s.line(S, k) + s.line(S, x + a / 2), s.move(S, k) + s.line(S + l, k) + s.line(S + l, _) + s.line(S + l / 2, _) + s.line(S + l / 2, b) + s.line(S + l - l / 4, b) + s.line(S + l / 4, b) + s.line(S + l / 2, b) + s.line(S + l / 2, _) + s.line(S, _) + s.line(S, k) + "z"] : [s.move(S, _) + s.line(S + l / 2, _) + s.line(S + l / 2, y) + s.line(S + l / 2, _) + s.line(S + l, _) + s.line(S + l, x) + s.line(S + l / 2, x) + s.line(S + l / 2, b) + s.line(S + l / 2, x) + s.line(S, x) + s.line(S, _ - a / 2)], M += s.move(S, x), o.globals.isXNumeric || (i += n), {
                        pathTo: A,
                        pathFrom: M,
                        x: i,
                        y: _,
                        barXPosition: S,
                        color: this.isBoxPlot ? p : h ? [d] : [f]
                    }
                }
            }, {
                key: "getOHLCValue",
                value: function (t, e) {
                    var i = this.w;
                    return {
                        o: this.isBoxPlot ? i.globals.seriesCandleH[t][e] : i.globals.seriesCandleO[t][e],
                        h: this.isBoxPlot ? i.globals.seriesCandleO[t][e] : i.globals.seriesCandleH[t][e],
                        m: i.globals.seriesCandleM[t][e],
                        l: this.isBoxPlot ? i.globals.seriesCandleC[t][e] : i.globals.seriesCandleL[t][e],
                        c: this.isBoxPlot ? i.globals.seriesCandleL[t][e] : i.globals.seriesCandleC[t][e]
                    }
                }
            }]), i
        }(),
        St = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "checkColorRange",
                value: function () {
                    var t = this.w,
                        e = !1,
                        i = t.config.plotOptions[t.config.chart.type];
                    return i.colorScale.ranges.length > 0 && i.colorScale.ranges.map((function (t, i) {
                        t.from <= 0 && (e = !0)
                    })), e
                }
            }, {
                key: "getShadeColor",
                value: function (t, e, i, n) {
                    var l = this.w,
                        r = 1,
                        a = l.config.plotOptions[t].shadeIntensity,
                        o = this.determineColor(t, e, i);
                    l.globals.hasNegs || n ? r = l.config.plotOptions[t].reverseNegativeShade ? o.percent < 0 ? o.percent / 100 * (1.25 * a) : (1 - o.percent / 100) * (1.25 * a) : o.percent <= 0 ? 1 - (1 + o.percent / 100) * a : (1 - o.percent / 100) * a : (r = 1 - o.percent / 100, "treemap" === t && (r = (1 - o.percent / 100) * (1.25 * a)));
                    var s = o.color,
                        c = new y;
                    return l.config.plotOptions[t].enableShades && (s = "dark" === this.w.config.theme.mode ? y.hexToRgba(c.shadeColor(-1 * r, o.color), l.config.fill.opacity) : y.hexToRgba(c.shadeColor(r, o.color), l.config.fill.opacity)), {
                        color: s,
                        colorProps: o
                    }
                }
            }, {
                key: "determineColor",
                value: function (t, e, i) {
                    var n = this.w,
                        l = n.globals.series[e][i],
                        r = n.config.plotOptions[t],
                        a = r.colorScale.inverse ? i : e;
                    n.config.plotOptions[t].distributed && (a = i);
                    var o = n.globals.colors[a],
                        s = null,
                        c = Math.min.apply(Math, m(n.globals.series[e])),
                        u = Math.max.apply(Math, m(n.globals.series[e]));
                    r.distributed || "heatmap" !== t || (c = n.globals.minY, u = n.globals.maxY), void 0 !== r.colorScale.min && (c = r.colorScale.min < n.globals.minY ? r.colorScale.min : n.globals.minY, u = r.colorScale.max > n.globals.maxY ? r.colorScale.max : n.globals.maxY);
                    var h = Math.abs(u) + Math.abs(c),
                        d = 100 * l / (0 === h ? h - 1e-6 : h);
                    return r.colorScale.ranges.length > 0 && r.colorScale.ranges.map((function (t, e) {
                        if (l >= t.from && l <= t.to) {
                            o = t.color, s = t.foreColor ? t.foreColor : null, c = t.from, u = t.to;
                            var i = Math.abs(u) + Math.abs(c);
                            d = 100 * l / (0 === i ? i - 1e-6 : i)
                        }
                    })), {
                        color: o,
                        foreColor: s,
                        percent: d
                    }
                }
            }, {
                key: "calculateDataLabels",
                value: function (t) {
                    var e = t.text,
                        i = t.x,
                        n = t.y,
                        l = t.i,
                        r = t.j,
                        a = t.colorProps,
                        o = t.fontSize,
                        s = this.w.config.dataLabels,
                        c = new w(this.ctx),
                        u = new D(this.ctx),
                        h = null;
                    if (s.enabled) {
                        h = c.group({
                            class: "apexcharts-data-labels"
                        });
                        var d = s.offsetX,
                            f = s.offsetY,
                            p = i + d,
                            g = n + parseFloat(s.style.fontSize) / 3 + f;
                        u.plotDataLabelsText({
                            x: p,
                            y: g,
                            text: e,
                            i: l,
                            j: r,
                            color: a.foreColor,
                            parent: h,
                            fontSize: o,
                            dataLabelsConfig: s
                        })
                    }
                    return h
                }
            }, {
                key: "addListeners",
                value: function (t) {
                    var e = new w(this.ctx);
                    t.node.addEventListener("mouseenter", e.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", e.pathMouseLeave.bind(this, t)), t.node.addEventListener("mousedown", e.pathMouseDown.bind(this, t))
                }
            }]), t
        }(),
        At = function () {
            function t(e, i) {
                r(this, t), this.ctx = e, this.w = e.w, this.xRatio = i.xRatio, this.yRatio = i.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new St(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0
            }
            return o(t, [{
                key: "draw",
                value: function (t) {
                    var e = this.w,
                        i = new w(this.ctx),
                        n = i.group({
                            class: "apexcharts-heatmap"
                        });
                    n.attr("clip-path", "url(#gridRectMask".concat(e.globals.cuid, ")"));
                    var l = e.globals.gridWidth / e.globals.dataPoints,
                        r = e.globals.gridHeight / e.globals.series.length,
                        a = 0,
                        o = !1;
                    this.negRange = this.helpers.checkColorRange();
                    var s = t.slice();
                    e.config.yaxis[0].reversed && (o = !0, s.reverse());
                    for (var c = o ? 0 : s.length - 1; o ? c < s.length : c >= 0; o ? c++ : c--) {
                        var u = i.group({
                            class: "apexcharts-series apexcharts-heatmap-series",
                            seriesName: y.escapeString(e.globals.seriesNames[c]),
                            rel: c + 1,
                            "data:realIndex": c
                        });
                        if (this.ctx.series.addCollapsedClassToSeries(u, c), e.config.chart.dropShadow.enabled) {
                            var h = e.config.chart.dropShadow;
                            new x(this.ctx).dropShadow(u, h, c)
                        }
                        for (var d = 0, f = e.config.plotOptions.heatmap.shadeIntensity, p = 0; p < s[c].length; p++) {
                            var g = this.helpers.getShadeColor(e.config.chart.type, c, p, this.negRange),
                                m = g.color,
                                v = g.colorProps;
                            "image" === e.config.fill.type && (m = new T(this.ctx).fillPath({
                                seriesNumber: c,
                                dataPointIndex: p,
                                opacity: e.globals.hasNegs ? v.percent < 0 ? 1 - (1 + v.percent / 100) : f + v.percent / 100 : v.percent / 100,
                                patternID: y.randomId(),
                                width: e.config.fill.image.width ? e.config.fill.image.width : l,
                                height: e.config.fill.image.height ? e.config.fill.image.height : r
                            }));
                            var b = this.rectRadius,
                                _ = i.drawRect(d, a, l, r, b);
                            if (_.attr({
                                    cx: d,
                                    cy: a
                                }), _.node.classList.add("apexcharts-heatmap-rect"), u.add(_), _.attr({
                                    fill: m,
                                    i: c,
                                    index: c,
                                    j: p,
                                    val: s[c][p],
                                    "stroke-width": this.strokeWidth,
                                    stroke: e.config.plotOptions.heatmap.useFillColorAsStroke ? m : e.globals.stroke.colors[0],
                                    color: m
                                }), this.helpers.addListeners(_), e.config.chart.animations.enabled && !e.globals.dataChanged) {
                                var k = 1;
                                e.globals.resized || (k = e.config.chart.animations.speed), this.animateHeatMap(_, d, a, l, r, k)
                            }
                            if (e.globals.dataChanged) {
                                var S = 1;
                                if (this.dynamicAnim.enabled && e.globals.shouldAnimate) {
                                    S = this.dynamicAnim.speed;
                                    var A = e.globals.previousPaths[c] && e.globals.previousPaths[c][p] && e.globals.previousPaths[c][p].color;
                                    A || (A = "rgba(255, 255, 255, 0)"), this.animateHeatColor(_, y.isColorHex(A) ? A : y.rgb2hex(A), y.isColorHex(m) ? m : y.rgb2hex(m), S)
                                }
                            }
                            var M = (0, e.config.dataLabels.formatter)(e.globals.series[c][p], {
                                    value: e.globals.series[c][p],
                                    seriesIndex: c,
                                    dataPointIndex: p,
                                    w: e
                                }),
                                C = this.helpers.calculateDataLabels({
                                    text: M,
                                    x: d + l / 2,
                                    y: a + r / 2,
                                    i: c,
                                    j: p,
                                    colorProps: v,
                                    series: s
                                });
                            null !== C && u.add(C), d += l
                        }
                        a += r, n.add(u)
                    }
                    var E = e.globals.yAxisScale[0].result.slice();
                    e.config.yaxis[0].reversed ? E.unshift("") : E.push(""), e.globals.yAxisScale[0].result = E;
                    var O = e.globals.gridHeight / e.globals.series.length;
                    return e.config.yaxis[0].labels.offsetY = -O / 2, n
                }
            }, {
                key: "animateHeatMap",
                value: function (t, e, i, n, l, r) {
                    var a = new b(this.ctx);
                    a.animateRect(t, {
                        x: e + n / 2,
                        y: i + l / 2,
                        width: 0,
                        height: 0
                    }, {
                        x: e,
                        y: i,
                        width: n,
                        height: l
                    }, r, (function () {
                        a.animationCompleted(t)
                    }))
                }
            }, {
                key: "animateHeatColor",
                value: function (t, e, i, n) {
                    t.attr({
                        fill: e
                    }).animate(n).attr({
                        fill: i
                    })
                }
            }]), t
        }(),
        Mt = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "drawYAxisTexts",
                value: function (t, e, i, n) {
                    var l = this.w,
                        r = l.config.yaxis[0],
                        a = l.globals.yLabelFormatters[0];
                    return new w(this.ctx).drawText({
                        x: t + r.labels.offsetX,
                        y: e + r.labels.offsetY,
                        text: a(n, i),
                        textAnchor: "middle",
                        fontSize: r.labels.style.fontSize,
                        fontFamily: r.labels.style.fontFamily,
                        foreColor: Array.isArray(r.labels.style.colors) ? r.labels.style.colors[i] : r.labels.style.colors
                    })
                }
            }]), t
        }(),
        Ct = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w;
                var i = this.w;
                this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [0], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = Math.min(i.globals.gridWidth, i.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = i.globals.gridWidth / 2, "radialBar" === i.config.chart.type ? this.fullAngle = 360 : this.fullAngle = Math.abs(i.config.plotOptions.pie.endAngle - i.config.plotOptions.pie.startAngle), this.initialAngle = i.config.plotOptions.pie.startAngle % this.fullAngle, i.globals.radialSize = this.defaultSize / 2.05 - i.config.stroke.width - (i.config.chart.sparkline.enabled ? 0 : i.config.chart.dropShadow.blur), this.donutSize = i.globals.radialSize * parseInt(i.config.plotOptions.pie.donut.size, 10) / 100, this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = []
            }
            return o(t, [{
                key: "draw",
                value: function (t) {
                    var e = this,
                        i = this.w,
                        n = new w(this.ctx);
                    if (this.ret = n.group({
                            class: "apexcharts-pie"
                        }), i.globals.noData) return this.ret;
                    for (var l = 0, r = 0; r < t.length; r++) l += y.negToZero(t[r]);
                    var a = [],
                        o = n.group();
                    0 === l && (l = 1e-5), t.forEach((function (t) {
                        e.maxY = Math.max(e.maxY, t)
                    })), i.config.yaxis[0].max && (this.maxY = i.config.yaxis[0].max), "back" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret);
                    for (var s = 0; s < t.length; s++) {
                        var c = this.fullAngle * y.negToZero(t[s]) / l;
                        a.push(c), "polarArea" === this.chartType ? (a[s] = this.fullAngle / t.length, this.sliceSizes.push(i.globals.radialSize * t[s] / this.maxY)) : this.sliceSizes.push(i.globals.radialSize)
                    }
                    if (i.globals.dataChanged) {
                        for (var u, h = 0, d = 0; d < i.globals.previousPaths.length; d++) h += y.negToZero(i.globals.previousPaths[d]);
                        for (var f = 0; f < i.globals.previousPaths.length; f++) u = this.fullAngle * y.negToZero(i.globals.previousPaths[f]) / h, this.prevSectorAngleArr.push(u)
                    }
                    this.donutSize < 0 && (this.donutSize = 0);
                    var p = i.config.plotOptions.pie.customScale,
                        g = i.globals.gridWidth / 2,
                        m = i.globals.gridHeight / 2,
                        v = g - i.globals.gridWidth / 2 * p,
                        b = m - i.globals.gridHeight / 2 * p;
                    if ("donut" === this.chartType) {
                        var x = n.drawCircle(this.donutSize);
                        x.attr({
                            cx: this.centerX,
                            cy: this.centerY,
                            fill: i.config.plotOptions.pie.donut.background ? i.config.plotOptions.pie.donut.background : "transparent"
                        }), o.add(x)
                    }
                    var _ = this.drawArcs(a, t);
                    if (this.sliceLabels.forEach((function (t) {
                            _.add(t)
                        })), o.attr({
                            transform: "translate(".concat(v, ", ").concat(b, ") scale(").concat(p, ")")
                        }), o.add(_), this.ret.add(o), this.donutDataLabels.show) {
                        var k = this.renderInnerDataLabels(this.donutDataLabels, {
                            hollowSize: this.donutSize,
                            centerX: this.centerX,
                            centerY: this.centerY,
                            opacity: this.donutDataLabels.show,
                            translateX: v,
                            translateY: b
                        });
                        this.ret.add(k)
                    }
                    return "front" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret), this.ret
                }
            }, {
                key: "drawArcs",
                value: function (t, e) {
                    var i = this.w,
                        n = new x(this.ctx),
                        l = new w(this.ctx),
                        r = new T(this.ctx),
                        a = l.group({
                            class: "apexcharts-slices"
                        }),
                        o = this.initialAngle,
                        s = this.initialAngle,
                        c = this.initialAngle,
                        u = this.initialAngle;
                    this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0;
                    for (var h = 0; h < t.length; h++) {
                        var d = l.group({
                            class: "apexcharts-series apexcharts-pie-series",
                            seriesName: y.escapeString(i.globals.seriesNames[h]),
                            rel: h + 1,
                            "data:realIndex": h
                        });
                        a.add(d), s = u, c = (o = c) + t[h], u = s + this.prevSectorAngleArr[h];
                        var f = c < o ? this.fullAngle + c - o : c - o,
                            p = r.fillPath({
                                seriesNumber: h,
                                size: this.sliceSizes[h],
                                value: e[h]
                            }),
                            g = this.getChangedPath(s, u),
                            m = l.drawPath({
                                d: g,
                                stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[h] : this.lineColorArr,
                                strokeWidth: 0,
                                fill: p,
                                fillOpacity: i.config.fill.opacity,
                                classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(h)
                            });
                        if (m.attr({
                                index: 0,
                                j: h
                            }), n.setSelectionFilter(m, 0, h), i.config.chart.dropShadow.enabled) {
                            var v = i.config.chart.dropShadow;
                            n.dropShadow(m, v, h)
                        }
                        this.addListeners(m, this.donutDataLabels), w.setAttrs(m.node, {
                            "data:angle": f,
                            "data:startAngle": o,
                            "data:strokeWidth": this.strokeWidth,
                            "data:value": e[h]
                        });
                        var b = {
                            x: 0,
                            y: 0
                        };
                        "pie" === this.chartType || "polarArea" === this.chartType ? b = y.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize / 1.25 + i.config.plotOptions.pie.dataLabels.offset, (o + f / 2) % this.fullAngle) : "donut" === this.chartType && (b = y.polarToCartesian(this.centerX, this.centerY, (i.globals.radialSize + this.donutSize) / 2 + i.config.plotOptions.pie.dataLabels.offset, (o + f / 2) % this.fullAngle)), d.add(m);
                        var _ = 0;
                        if (!this.initialAnim || i.globals.resized || i.globals.dataChanged ? this.animBeginArr.push(0) : (0 == (_ = f / this.fullAngle * i.config.chart.animations.speed) && (_ = 1), this.animDur = _ + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && i.globals.dataChanged ? this.animatePaths(m, {
                                size: this.sliceSizes[h],
                                endAngle: c,
                                startAngle: o,
                                prevStartAngle: s,
                                prevEndAngle: u,
                                animateStartingPos: !0,
                                i: h,
                                animBeginArr: this.animBeginArr,
                                shouldSetPrevPaths: !0,
                                dur: i.config.chart.animations.dynamicAnimation.speed
                            }) : this.animatePaths(m, {
                                size: this.sliceSizes[h],
                                endAngle: c,
                                startAngle: o,
                                i: h,
                                totalItems: t.length - 1,
                                animBeginArr: this.animBeginArr,
                                dur: _
                            }), i.config.plotOptions.pie.expandOnClick && "polarArea" !== this.chartType && m.click(this.pieClicked.bind(this, h)), void 0 !== i.globals.selectedDataPoints[0] && i.globals.selectedDataPoints[0].indexOf(h) > -1 && this.pieClicked(h), i.config.dataLabels.enabled) {
                            var k = b.x,
                                S = b.y,
                                A = 100 * f / this.fullAngle + "%";
                            if (0 !== f && i.config.plotOptions.pie.dataLabels.minAngleToShowLabel < t[h]) {
                                var M = i.config.dataLabels.formatter;
                                void 0 !== M && (A = M(i.globals.seriesPercent[h][0], {
                                    seriesIndex: h,
                                    w: i
                                }));
                                var C = i.globals.dataLabels.style.colors[h],
                                    E = l.group({
                                        class: "apexcharts-datalabels"
                                    }),
                                    O = l.drawText({
                                        x: k,
                                        y: S,
                                        text: A,
                                        textAnchor: "middle",
                                        fontSize: i.config.dataLabels.style.fontSize,
                                        fontFamily: i.config.dataLabels.style.fontFamily,
                                        fontWeight: i.config.dataLabels.style.fontWeight,
                                        foreColor: C
                                    });
                                if (E.add(O), i.config.dataLabels.dropShadow.enabled) {
                                    var P = i.config.dataLabels.dropShadow;
                                    n.dropShadow(O, P)
                                }
                                O.node.classList.add("apexcharts-pie-label"), i.config.chart.animations.animate && !1 === i.globals.resized && (O.node.classList.add("apexcharts-pie-label-delay"), O.node.style.animationDelay = i.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(E)
                            }
                        }
                    }
                    return a
                }
            }, {
                key: "addListeners",
                value: function (t, e) {
                    var i = new w(this.ctx);
                    t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this, t)), t.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this, t)), this.donutDataLabels.total.showAlways || (t.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, t.node, e)))
                }
            }, {
                key: "animatePaths",
                value: function (t, e) {
                    var i = this.w,
                        n = e.endAngle < e.startAngle ? this.fullAngle + e.endAngle - e.startAngle : e.endAngle - e.startAngle,
                        l = n,
                        r = e.startAngle,
                        a = e.startAngle;
                    void 0 !== e.prevStartAngle && void 0 !== e.prevEndAngle && (r = e.prevEndAngle, l = e.prevEndAngle < e.prevStartAngle ? this.fullAngle + e.prevEndAngle - e.prevStartAngle : e.prevEndAngle - e.prevStartAngle), e.i === i.config.series.length - 1 && (n + a > this.fullAngle ? e.endAngle = e.endAngle - (n + a) : n + a < this.fullAngle && (e.endAngle = e.endAngle + (this.fullAngle - (n + a)))), n === this.fullAngle && (n = this.fullAngle - .01), this.animateArc(t, r, a, n, l, e)
                }
            }, {
                key: "animateArc",
                value: function (t, e, i, n, l, r) {
                    var a, o = this,
                        s = this.w,
                        c = new b(this.ctx),
                        u = r.size;
                    (isNaN(e) || isNaN(l)) && (e = i, l = n, r.dur = 0);
                    var h = n,
                        d = i,
                        f = e < i ? this.fullAngle + e - i : e - i;
                    s.globals.dataChanged && r.shouldSetPrevPaths && r.prevEndAngle && (a = o.getPiePath({
                        me: o,
                        startAngle: r.prevStartAngle,
                        angle: r.prevEndAngle < r.prevStartAngle ? this.fullAngle + r.prevEndAngle - r.prevStartAngle : r.prevEndAngle - r.prevStartAngle,
                        size: u
                    }), t.attr({
                        d: a
                    })), 0 !== r.dur ? t.animate(r.dur, s.globals.easing, r.animBeginArr[r.i]).afterAll((function () {
                        "pie" !== o.chartType && "donut" !== o.chartType && "polarArea" !== o.chartType || this.animate(s.config.chart.animations.dynamicAnimation.speed).attr({
                            "stroke-width": o.strokeWidth
                        }), r.i === s.config.series.length - 1 && c.animationCompleted(t)
                    })).during((function (s) {
                        h = f + (n - f) * s, r.animateStartingPos && (h = l + (n - l) * s, d = e - l + (i - (e - l)) * s), a = o.getPiePath({
                            me: o,
                            startAngle: d,
                            angle: h,
                            size: u
                        }), t.node.setAttribute("data:pathOrig", a), t.attr({
                            d: a
                        })
                    })) : (a = o.getPiePath({
                        me: o,
                        startAngle: d,
                        angle: n,
                        size: u
                    }), r.isTrack || (s.globals.animationEnded = !0), t.node.setAttribute("data:pathOrig", a), t.attr({
                        d: a,
                        "stroke-width": o.strokeWidth
                    }))
                }
            }, {
                key: "pieClicked",
                value: function (t) {
                    var e, i = this.w,
                        n = this,
                        l = n.sliceSizes[t] + (i.config.plotOptions.pie.expandOnClick ? 4 : 0),
                        r = i.globals.dom.Paper.select(".apexcharts-".concat(n.chartType.toLowerCase(), "-slice-").concat(t)).members[0];
                    if ("true" !== r.attr("data:pieClicked")) {
                        var a = i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
                        Array.prototype.forEach.call(a, (function (t) {
                            t.setAttribute("data:pieClicked", "false");
                            var e = t.getAttribute("data:pathOrig");
                            t.setAttribute("d", e)
                        })), r.attr("data:pieClicked", "true");
                        var o = parseInt(r.attr("data:startAngle"), 10),
                            s = parseInt(r.attr("data:angle"), 10);
                        e = n.getPiePath({
                            me: n,
                            startAngle: o,
                            angle: s,
                            size: l
                        }), 360 !== s && r.plot(e)
                    } else {
                        r.attr({
                            "data:pieClicked": "false"
                        }), this.revertDataLabelsInner(r.node, this.donutDataLabels);
                        var c = r.attr("data:pathOrig");
                        r.attr({
                            d: c
                        })
                    }
                }
            }, {
                key: "getChangedPath",
                value: function (t, e) {
                    var i = "";
                    return this.dynamicAnim && this.w.globals.dataChanged && (i = this.getPiePath({
                        me: this,
                        startAngle: t,
                        angle: e - t,
                        size: this.size
                    })), i
                }
            }, {
                key: "getPiePath",
                value: function (t) {
                    var e = t.me,
                        i = t.startAngle,
                        n = t.angle,
                        l = t.size,
                        r = i,
                        a = Math.PI * (r - 90) / 180,
                        o = n + i;
                    Math.ceil(o) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (o = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - .01), Math.ceil(o) > this.fullAngle && (o -= this.fullAngle);
                    var s = Math.PI * (o - 90) / 180,
                        c = e.centerX + l * Math.cos(a),
                        u = e.centerY + l * Math.sin(a),
                        h = e.centerX + l * Math.cos(s),
                        d = e.centerY + l * Math.sin(s),
                        f = y.polarToCartesian(e.centerX, e.centerY, e.donutSize, o),
                        p = y.polarToCartesian(e.centerX, e.centerY, e.donutSize, r),
                        g = n > 180 ? 1 : 0,
                        m = ["M", c, u, "A", l, l, 0, g, 1, h, d];
                    return "donut" === e.chartType ? [].concat(m, ["L", f.x, f.y, "A", e.donutSize, e.donutSize, 0, g, 0, p.x, p.y, "L", c, u, "z"]).join(" ") : "pie" === e.chartType || "polarArea" === e.chartType ? [].concat(m, ["L", e.centerX, e.centerY, "L", c, u]).join(" ") : [].concat(m).join(" ")
                }
            }, {
                key: "drawPolarElements",
                value: function (t) {
                    var e = this.w,
                        i = new K(this.ctx),
                        n = new w(this.ctx),
                        l = new Mt(this.ctx),
                        r = n.group(),
                        a = n.group(),
                        o = i.niceScale(0, Math.ceil(this.maxY), e.config.yaxis[0].tickAmount, 0, !0),
                        s = o.result.reverse(),
                        c = o.result.length;
                    this.maxY = o.niceMax;
                    for (var u = e.globals.radialSize, h = u / (c - 1), d = 0; d < c - 1; d++) {
                        var f = n.drawCircle(u);
                        if (f.attr({
                                cx: this.centerX,
                                cy: this.centerY,
                                fill: "none",
                                "stroke-width": e.config.plotOptions.polarArea.rings.strokeWidth,
                                stroke: e.config.plotOptions.polarArea.rings.strokeColor
                            }), e.config.yaxis[0].show) {
                            var p = l.drawYAxisTexts(this.centerX, this.centerY - u + parseInt(e.config.yaxis[0].labels.style.fontSize, 10) / 2, d, s[d]);
                            a.add(p)
                        }
                        r.add(f), u -= h
                    }
                    this.drawSpokes(t), t.add(r), t.add(a)
                }
            }, {
                key: "renderInnerDataLabels",
                value: function (t, e) {
                    var i = this.w,
                        n = new w(this.ctx),
                        l = n.group({
                            class: "apexcharts-datalabels-group",
                            transform: "translate(".concat(e.translateX ? e.translateX : 0, ", ").concat(e.translateY ? e.translateY : 0, ") scale(").concat(i.config.plotOptions.pie.customScale, ")")
                        }),
                        r = t.total.show;
                    l.node.style.opacity = e.opacity;
                    var a, o, s = e.centerX,
                        c = e.centerY;
                    a = void 0 === t.name.color ? i.globals.colors[0] : t.name.color;
                    var u = t.name.fontSize,
                        h = t.name.fontFamily,
                        d = t.value.fontWeight;
                    o = void 0 === t.value.color ? i.config.chart.foreColor : t.value.color;
                    var f = t.value.formatter,
                        p = "",
                        g = "";
                    if (r ? (a = t.total.color, u = t.total.fontSize, h = t.total.fontFamily, d = t.total.fontWeight, g = t.total.label, p = t.total.formatter(i)) : 1 === i.globals.series.length && (p = f(i.globals.series[0], i), g = i.globals.seriesNames[0]), g && (g = t.name.formatter(g, t.total.show, i)), t.name.show) {
                        var m = n.drawText({
                            x: s,
                            y: c + parseFloat(t.name.offsetY),
                            text: g,
                            textAnchor: "middle",
                            foreColor: a,
                            fontSize: u,
                            fontWeight: d,
                            fontFamily: h
                        });
                        m.node.classList.add("apexcharts-datalabel-label"), l.add(m)
                    }
                    if (t.value.show) {
                        var v = t.name.show ? parseFloat(t.value.offsetY) + 16 : t.value.offsetY,
                            y = n.drawText({
                                x: s,
                                y: c + v,
                                text: p,
                                textAnchor: "middle",
                                foreColor: o,
                                fontWeight: t.value.fontWeight,
                                fontSize: t.value.fontSize,
                                fontFamily: t.value.fontFamily
                            });
                        y.node.classList.add("apexcharts-datalabel-value"), l.add(y)
                    }
                    return l
                }
            }, {
                key: "printInnerLabels",
                value: function (t, e, i, n) {
                    var l, r = this.w;
                    n ? l = void 0 === t.name.color ? r.globals.colors[parseInt(n.parentNode.getAttribute("rel"), 10) - 1] : t.name.color : r.globals.series.length > 1 && t.total.show && (l = t.total.color);
                    var a = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"),
                        o = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
                    i = (0, t.value.formatter)(i, r), n || "function" != typeof t.total.formatter || (i = t.total.formatter(r));
                    var s = e === t.total.label;
                    e = t.name.formatter(e, s, r), null !== a && (a.textContent = e), null !== o && (o.textContent = i), null !== a && (a.style.fill = l)
                }
            }, {
                key: "printDataLabelsInner",
                value: function (t, e) {
                    var i = this.w,
                        n = t.getAttribute("data:value"),
                        l = i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"), 10) - 1];
                    i.globals.series.length > 1 && this.printInnerLabels(e, l, n, t);
                    var r = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
                    null !== r && (r.style.opacity = 1)
                }
            }, {
                key: "drawSpokes",
                value: function (t) {
                    var e = this,
                        i = this.w,
                        n = new w(this.ctx),
                        l = i.config.plotOptions.polarArea.spokes;
                    if (0 !== l.strokeWidth) {
                        for (var r = [], a = 360 / i.globals.series.length, o = 0; o < i.globals.series.length; o++) r.push(y.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize, i.config.plotOptions.pie.startAngle + a * o));
                        r.forEach((function (i, r) {
                            var a = n.drawLine(i.x, i.y, e.centerX, e.centerY, Array.isArray(l.connectorColors) ? l.connectorColors[r] : l.connectorColors);
                            t.add(a)
                        }))
                    }
                }
            }, {
                key: "revertDataLabelsInner",
                value: function (t, e, i) {
                    var n = this,
                        l = this.w,
                        r = l.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group"),
                        a = !1,
                        o = l.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area"),
                        s = function (t) {
                            var i = t.makeSliceOut,
                                l = t.printLabel;
                            Array.prototype.forEach.call(o, (function (t) {
                                "true" === t.getAttribute("data:pieClicked") && (i && (a = !0), l && n.printDataLabelsInner(t, e))
                            }))
                        };
                    if (s({
                            makeSliceOut: !0,
                            printLabel: !1
                        }), e.total.show && l.globals.series.length > 1) a && !e.total.showAlways ? s({
                        makeSliceOut: !1,
                        printLabel: !0
                    }) : this.printInnerLabels(e, e.total.label, e.total.formatter(l));
                    else if (s({
                            makeSliceOut: !1,
                            printLabel: !0
                        }), !a)
                        if (l.globals.selectedDataPoints.length && l.globals.series.length > 1)
                            if (l.globals.selectedDataPoints[0].length > 0) {
                                var c = l.globals.selectedDataPoints[0],
                                    u = l.globals.dom.baseEl.querySelector(".apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(c));
                                this.printDataLabelsInner(u, e)
                            } else r && l.globals.selectedDataPoints.length && 0 === l.globals.selectedDataPoints[0].length && (r.style.opacity = 0);
                    else r && l.globals.series.length > 1 && (r.style.opacity = 0)
                }
            }]), t
        }(),
        Et = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
                var i = this.w;
                this.graphics = new w(this.ctx), this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = i.globals.svgHeight < i.globals.svgWidth ? i.globals.gridHeight + 1.5 * i.globals.goldenPadding : i.globals.gridWidth, this.isLog = i.config.yaxis[0].logarithmic, this.coreUtils = new S(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(i.globals.maxY, 0) : i.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.w.globals.minY, 0) : i.globals.minY, this.polygons = i.config.plotOptions.radar.polygons, this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - i.config.chart.dropShadow.blur, i.config.xaxis.labels.show && (this.size = this.size - i.globals.xAxisLabelsWidth / 1.75), void 0 !== i.config.plotOptions.radar.size && (this.size = i.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = []
            }
            return o(t, [{
                key: "draw",
                value: function (t) {
                    var e = this,
                        i = this.w,
                        n = new T(this.ctx),
                        l = [],
                        r = new D(this.ctx);
                    t.length && (this.dataPointsLen = t[i.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
                    var a = i.globals.gridWidth / 2,
                        o = i.globals.gridHeight / 2,
                        s = a + i.config.plotOptions.radar.offsetX,
                        c = o + i.config.plotOptions.radar.offsetY,
                        h = this.graphics.group({
                            class: "apexcharts-radar-series apexcharts-plot-series",
                            transform: "translate(".concat(s || 0, ", ").concat(c || 0, ")")
                        }),
                        d = [],
                        f = null,
                        p = null;
                    if (this.yaxisLabels = this.graphics.group({
                            class: "apexcharts-yaxis"
                        }), t.forEach((function (t, a) {
                            var o = t.length === i.globals.dataPoints,
                                s = e.graphics.group().attr({
                                    class: "apexcharts-series",
                                    "data:longestSeries": o,
                                    seriesName: y.escapeString(i.globals.seriesNames[a]),
                                    rel: a + 1,
                                    "data:realIndex": a
                                });
                            e.dataRadiusOfPercent[a] = [], e.dataRadius[a] = [], e.angleArr[a] = [], t.forEach((function (t, i) {
                                var n = Math.abs(e.maxValue - e.minValue);
                                t += Math.abs(e.minValue), e.isLog && (t = e.coreUtils.getLogVal(t, 0)), e.dataRadiusOfPercent[a][i] = t / n, e.dataRadius[a][i] = e.dataRadiusOfPercent[a][i] * e.size, e.angleArr[a][i] = i * e.disAngle
                            })), d = e.getDataPointsPos(e.dataRadius[a], e.angleArr[a]);
                            var c = e.createPaths(d, {
                                x: 0,
                                y: 0
                            });
                            f = e.graphics.group({
                                class: "apexcharts-series-markers-wrap apexcharts-element-hidden"
                            }), p = e.graphics.group({
                                class: "apexcharts-datalabels",
                                "data:realIndex": a
                            }), i.globals.delayedElements.push({
                                el: f.node,
                                index: a
                            });
                            var h = {
                                    i: a,
                                    realIndex: a,
                                    animationDelay: a,
                                    initialSpeed: i.config.chart.animations.speed,
                                    dataChangeSpeed: i.config.chart.animations.dynamicAnimation.speed,
                                    className: "apexcharts-radar",
                                    shouldClipToGrid: !1,
                                    bindEventsOnPaths: !1,
                                    stroke: i.globals.stroke.colors[a],
                                    strokeLineCap: i.config.stroke.lineCap
                                },
                                g = null;
                            i.globals.previousPaths.length > 0 && (g = e.getPreviousPath(a));
                            for (var m = 0; m < c.linePathsTo.length; m++) {
                                var v = e.graphics.renderPaths(u(u({}, h), {}, {
                                    pathFrom: null === g ? c.linePathsFrom[m] : g,
                                    pathTo: c.linePathsTo[m],
                                    strokeWidth: Array.isArray(e.strokeWidth) ? e.strokeWidth[a] : e.strokeWidth,
                                    fill: "none",
                                    drawShadow: !1
                                }));
                                s.add(v);
                                var b = n.fillPath({
                                        seriesNumber: a
                                    }),
                                    w = e.graphics.renderPaths(u(u({}, h), {}, {
                                        pathFrom: null === g ? c.areaPathsFrom[m] : g,
                                        pathTo: c.areaPathsTo[m],
                                        strokeWidth: 0,
                                        fill: b,
                                        drawShadow: !1
                                    }));
                                if (i.config.chart.dropShadow.enabled) {
                                    var _ = new x(e.ctx),
                                        k = i.config.chart.dropShadow;
                                    _.dropShadow(w, Object.assign({}, k, {
                                        noUserSpaceOnUse: !0
                                    }), a)
                                }
                                s.add(w)
                            }
                            t.forEach((function (t, n) {
                                var l = new P(e.ctx).getMarkerConfig("apexcharts-marker", a, n),
                                    o = e.graphics.drawMarker(d[n].x, d[n].y, l);
                                o.attr("rel", n), o.attr("j", n), o.attr("index", a), o.node.setAttribute("default-marker-size", l.pSize);
                                var c = e.graphics.group({
                                    class: "apexcharts-series-markers"
                                });
                                c && c.add(o), f.add(c), s.add(f);
                                var h = i.config.dataLabels;
                                if (h.enabled) {
                                    var g = h.formatter(i.globals.series[a][n], {
                                        seriesIndex: a,
                                        dataPointIndex: n,
                                        w: i
                                    });
                                    r.plotDataLabelsText({
                                        x: d[n].x,
                                        y: d[n].y,
                                        text: g,
                                        textAnchor: "middle",
                                        i: a,
                                        j: a,
                                        parent: p,
                                        offsetCorrection: !1,
                                        dataLabelsConfig: u({}, h)
                                    })
                                }
                                s.add(p)
                            })), l.push(s)
                        })), this.drawPolygons({
                            parent: h
                        }), i.config.xaxis.labels.show) {
                        var g = this.drawXAxisTexts();
                        h.add(g)
                    }
                    return l.forEach((function (t) {
                        h.add(t)
                    })), h.add(this.yaxisLabels), h
                }
            }, {
                key: "drawPolygons",
                value: function (t) {
                    for (var e = this, i = this.w, n = t.parent, l = new Mt(this.ctx), r = i.globals.yAxisScale[0].result.reverse(), a = r.length, o = [], s = this.size / (a - 1), c = 0; c < a; c++) o[c] = s * c;
                    o.reverse();
                    var u = [],
                        h = [];
                    o.forEach((function (t, i) {
                        var n = y.getPolygonPos(t, e.dataPointsLen),
                            l = "";
                        n.forEach((function (t, n) {
                            if (0 === i) {
                                var r = e.graphics.drawLine(t.x, t.y, 0, 0, Array.isArray(e.polygons.connectorColors) ? e.polygons.connectorColors[n] : e.polygons.connectorColors);
                                h.push(r)
                            }
                            0 === n && e.yaxisLabelsTextsPos.push({
                                x: t.x,
                                y: t.y
                            }), l += t.x + "," + t.y + " "
                        })), u.push(l)
                    })), u.forEach((function (t, l) {
                        var r = e.polygons.strokeColors,
                            a = e.polygons.strokeWidth,
                            o = e.graphics.drawPolygon(t, Array.isArray(r) ? r[l] : r, Array.isArray(a) ? a[l] : a, i.globals.radarPolygons.fill.colors[l]);
                        n.add(o)
                    })), h.forEach((function (t) {
                        n.add(t)
                    })), i.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach((function (t, i) {
                        var n = l.drawYAxisTexts(t.x, t.y, i, r[i]);
                        e.yaxisLabels.add(n)
                    }))
                }
            }, {
                key: "drawXAxisTexts",
                value: function () {
                    var t = this,
                        e = this.w,
                        i = e.config.xaxis.labels,
                        n = this.graphics.group({
                            class: "apexcharts-xaxis"
                        }),
                        l = y.getPolygonPos(this.size, this.dataPointsLen);
                    return e.globals.labels.forEach((function (r, a) {
                        var o = e.config.xaxis.labels.formatter,
                            s = new D(t.ctx);
                        if (l[a]) {
                            var c = t.getTextPos(l[a], t.size),
                                h = o(r, {
                                    seriesIndex: -1,
                                    dataPointIndex: a,
                                    w: e
                                });
                            s.plotDataLabelsText({
                                x: c.newX,
                                y: c.newY,
                                text: h,
                                textAnchor: c.textAnchor,
                                i: a,
                                j: a,
                                parent: n,
                                color: Array.isArray(i.style.colors) && i.style.colors[a] ? i.style.colors[a] : "#a8a8a8",
                                dataLabelsConfig: u({
                                    textAnchor: c.textAnchor,
                                    dropShadow: {
                                        enabled: !1
                                    }
                                }, i),
                                offsetCorrection: !1
                            })
                        }
                    })), n
                }
            }, {
                key: "createPaths",
                value: function (t, e) {
                    var i = this,
                        n = [],
                        l = [],
                        r = [],
                        a = [];
                    if (t.length) {
                        l = [this.graphics.move(e.x, e.y)], a = [this.graphics.move(e.x, e.y)];
                        var o = this.graphics.move(t[0].x, t[0].y),
                            s = this.graphics.move(t[0].x, t[0].y);
                        t.forEach((function (e, n) {
                            o += i.graphics.line(e.x, e.y), s += i.graphics.line(e.x, e.y), n === t.length - 1 && (o += "Z", s += "Z")
                        })), n.push(o), r.push(s)
                    }
                    return {
                        linePathsFrom: l,
                        linePathsTo: n,
                        areaPathsFrom: a,
                        areaPathsTo: r
                    }
                }
            }, {
                key: "getTextPos",
                value: function (t, e) {
                    var i = "middle",
                        n = t.x,
                        l = t.y;
                    return Math.abs(t.x) >= 10 ? t.x > 0 ? (i = "start", n += 10) : t.x < 0 && (i = "end", n -= 10) : i = "middle", Math.abs(t.y) >= e - 10 && (t.y < 0 ? l -= 10 : t.y > 0 && (l += 10)), {
                        textAnchor: i,
                        newX: n,
                        newY: l
                    }
                }
            }, {
                key: "getPreviousPath",
                value: function (t) {
                    for (var e = this.w, i = null, n = 0; n < e.globals.previousPaths.length; n++) {
                        var l = e.globals.previousPaths[n];
                        l.paths.length > 0 && parseInt(l.realIndex, 10) === parseInt(t, 10) && void 0 !== e.globals.previousPaths[n].paths[0] && (i = e.globals.previousPaths[n].paths[0].d)
                    }
                    return i
                }
            }, {
                key: "getDataPointsPos",
                value: function (t, e) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.dataPointsLen;
                    t = t || [], e = e || [];
                    for (var n = [], l = 0; l < i; l++) {
                        var r = {};
                        r.x = t[l] * Math.sin(e[l]), r.y = -t[l] * Math.cos(e[l]), n.push(r)
                    }
                    return n
                }
            }]), t
        }(),
        Ot = function (t) {
            h(i, Ct);
            var e = g(i);

            function i(t) {
                var n;
                r(this, i), (n = e.call(this, t)).ctx = t, n.w = t.w, n.animBeginArr = [0], n.animDur = 0;
                var l = n.w;
                return n.startAngle = l.config.plotOptions.radialBar.startAngle, n.endAngle = l.config.plotOptions.radialBar.endAngle, n.totalAngle = Math.abs(l.config.plotOptions.radialBar.endAngle - l.config.plotOptions.radialBar.startAngle), n.trackStartAngle = l.config.plotOptions.radialBar.track.startAngle, n.trackEndAngle = l.config.plotOptions.radialBar.track.endAngle, n.radialDataLabels = l.config.plotOptions.radialBar.dataLabels, n.trackStartAngle || (n.trackStartAngle = n.startAngle), n.trackEndAngle || (n.trackEndAngle = n.endAngle), 360 === n.endAngle && (n.endAngle = 359.99), n.margin = parseInt(l.config.plotOptions.radialBar.track.margin, 10), n
            }
            return o(i, [{
                key: "draw",
                value: function (t) {
                    var e = this.w,
                        i = new w(this.ctx),
                        n = i.group({
                            class: "apexcharts-radialbar"
                        });
                    if (e.globals.noData) return n;
                    var l = i.group(),
                        r = this.defaultSize / 2,
                        a = e.globals.gridWidth / 2,
                        o = this.defaultSize / 2.05;
                    e.config.chart.sparkline.enabled || (o = o - e.config.stroke.width - e.config.chart.dropShadow.blur);
                    var s = e.globals.fill.colors;
                    if (e.config.plotOptions.radialBar.track.show) {
                        var c = this.drawTracks({
                            size: o,
                            centerX: a,
                            centerY: r,
                            colorArr: s,
                            series: t
                        });
                        l.add(c)
                    }
                    var u = this.drawArcs({
                            size: o,
                            centerX: a,
                            centerY: r,
                            colorArr: s,
                            series: t
                        }),
                        h = 360;
                    e.config.plotOptions.radialBar.startAngle < 0 && (h = this.totalAngle);
                    var d = (360 - h) / 360;
                    if (e.globals.radialSize = o - o * d, this.radialDataLabels.value.show) {
                        var f = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
                        e.globals.radialSize += f * d
                    }
                    return l.add(u.g), "front" === e.config.plotOptions.radialBar.hollow.position && (u.g.add(u.elHollow), u.dataLabels && u.g.add(u.dataLabels)), n.add(l), n
                }
            }, {
                key: "drawTracks",
                value: function (t) {
                    var e = this.w,
                        i = new w(this.ctx),
                        n = i.group({
                            class: "apexcharts-tracks"
                        }),
                        l = new x(this.ctx),
                        r = new T(this.ctx),
                        a = this.getStrokeWidth(t);
                    t.size = t.size - a / 2;
                    for (var o = 0; o < t.series.length; o++) {
                        var s = i.group({
                            class: "apexcharts-radialbar-track apexcharts-track"
                        });
                        n.add(s), s.attr({
                            rel: o + 1
                        }), t.size = t.size - a - this.margin;
                        var c = e.config.plotOptions.radialBar.track,
                            u = r.fillPath({
                                seriesNumber: 0,
                                size: t.size,
                                fillColors: Array.isArray(c.background) ? c.background[o] : c.background,
                                solid: !0
                            }),
                            h = this.trackStartAngle,
                            d = this.trackEndAngle;
                        Math.abs(d) + Math.abs(h) >= 360 && (d = 360 - Math.abs(this.startAngle) - .1);
                        var f = i.drawPath({
                            d: "",
                            stroke: u,
                            strokeWidth: a * parseInt(c.strokeWidth, 10) / 100,
                            fill: "none",
                            strokeOpacity: c.opacity,
                            classes: "apexcharts-radialbar-area"
                        });
                        if (c.dropShadow.enabled) {
                            var p = c.dropShadow;
                            l.dropShadow(f, p)
                        }
                        s.add(f), f.attr("id", "apexcharts-radialbarTrack-" + o), this.animatePaths(f, {
                            centerX: t.centerX,
                            centerY: t.centerY,
                            endAngle: d,
                            startAngle: h,
                            size: t.size,
                            i: o,
                            totalItems: 2,
                            animBeginArr: 0,
                            dur: 0,
                            isTrack: !0,
                            easing: e.globals.easing
                        })
                    }
                    return n
                }
            }, {
                key: "drawArcs",
                value: function (t) {
                    var e = this.w,
                        i = new w(this.ctx),
                        n = new T(this.ctx),
                        l = new x(this.ctx),
                        r = i.group(),
                        a = this.getStrokeWidth(t);
                    t.size = t.size - a / 2;
                    var o = e.config.plotOptions.radialBar.hollow.background,
                        s = t.size - a * t.series.length - this.margin * t.series.length - a * parseInt(e.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2,
                        c = s - e.config.plotOptions.radialBar.hollow.margin;
                    void 0 !== e.config.plotOptions.radialBar.hollow.image && (o = this.drawHollowImage(t, r, s, o));
                    var u = this.drawHollow({
                        size: c,
                        centerX: t.centerX,
                        centerY: t.centerY,
                        fill: o || "transparent"
                    });
                    if (e.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
                        var h = e.config.plotOptions.radialBar.hollow.dropShadow;
                        l.dropShadow(u, h)
                    }
                    var d = 1;
                    !this.radialDataLabels.total.show && e.globals.series.length > 1 && (d = 0);
                    var f = null;
                    this.radialDataLabels.show && (f = this.renderInnerDataLabels(this.radialDataLabels, {
                        hollowSize: s,
                        centerX: t.centerX,
                        centerY: t.centerY,
                        opacity: d
                    })), "back" === e.config.plotOptions.radialBar.hollow.position && (r.add(u), f && r.add(f));
                    var p = !1;
                    e.config.plotOptions.radialBar.inverseOrder && (p = !0);
                    for (var g = p ? t.series.length - 1 : 0; p ? g >= 0 : g < t.series.length; p ? g-- : g++) {
                        var m = i.group({
                            class: "apexcharts-series apexcharts-radial-series",
                            seriesName: y.escapeString(e.globals.seriesNames[g])
                        });
                        r.add(m), m.attr({
                            rel: g + 1,
                            "data:realIndex": g
                        }), this.ctx.series.addCollapsedClassToSeries(m, g), t.size = t.size - a - this.margin;
                        var v = n.fillPath({
                                seriesNumber: g,
                                size: t.size,
                                value: t.series[g]
                            }),
                            b = this.startAngle,
                            _ = void 0,
                            k = y.negToZero(t.series[g] > 100 ? 100 : t.series[g]) / 100,
                            S = Math.round(this.totalAngle * k) + this.startAngle,
                            A = void 0;
                        e.globals.dataChanged && (_ = this.startAngle, A = Math.round(this.totalAngle * y.negToZero(e.globals.previousPaths[g]) / 100) + _), Math.abs(S) + Math.abs(b) >= 360 && (S -= .01), Math.abs(A) + Math.abs(_) >= 360 && (A -= .01);
                        var M = S - b,
                            C = Array.isArray(e.config.stroke.dashArray) ? e.config.stroke.dashArray[g] : e.config.stroke.dashArray,
                            E = i.drawPath({
                                d: "",
                                stroke: v,
                                strokeWidth: a,
                                fill: "none",
                                fillOpacity: e.config.fill.opacity,
                                classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + g,
                                strokeDashArray: C
                            });
                        if (w.setAttrs(E.node, {
                                "data:angle": M,
                                "data:value": t.series[g]
                            }), e.config.chart.dropShadow.enabled) {
                            var O = e.config.chart.dropShadow;
                            l.dropShadow(E, O, g)
                        }
                        l.setSelectionFilter(E, 0, g), this.addListeners(E, this.radialDataLabels), m.add(E), E.attr({
                            index: 0,
                            j: g
                        });
                        var P = 0;
                        !this.initialAnim || e.globals.resized || e.globals.dataChanged || (P = (S - b) / 360 * e.config.chart.animations.speed, this.animDur = P / (1.2 * t.series.length) + this.animDur, this.animBeginArr.push(this.animDur)), e.globals.dataChanged && (P = (S - b) / 360 * e.config.chart.animations.dynamicAnimation.speed, this.animDur = P / (1.2 * t.series.length) + this.animDur, this.animBeginArr.push(this.animDur)), this.animatePaths(E, {
                            centerX: t.centerX,
                            centerY: t.centerY,
                            endAngle: S,
                            startAngle: b,
                            prevEndAngle: A,
                            prevStartAngle: _,
                            size: t.size,
                            i: g,
                            totalItems: 2,
                            animBeginArr: this.animBeginArr,
                            dur: P,
                            shouldSetPrevPaths: !0,
                            easing: e.globals.easing
                        })
                    }
                    return {
                        g: r,
                        elHollow: u,
                        dataLabels: f
                    }
                }
            }, {
                key: "drawHollow",
                value: function (t) {
                    var e = new w(this.ctx).drawCircle(2 * t.size);
                    return e.attr({
                        class: "apexcharts-radialbar-hollow",
                        cx: t.centerX,
                        cy: t.centerY,
                        r: t.size,
                        fill: t.fill
                    }), e
                }
            }, {
                key: "drawHollowImage",
                value: function (t, e, i, n) {
                    var l = this.w,
                        r = new T(this.ctx),
                        a = y.randomId(),
                        o = l.config.plotOptions.radialBar.hollow.image;
                    if (l.config.plotOptions.radialBar.hollow.imageClipped) r.clippedImgArea({
                        width: i,
                        height: i,
                        image: o,
                        patternID: "pattern".concat(l.globals.cuid).concat(a)
                    }), n = "url(#pattern".concat(l.globals.cuid).concat(a, ")");
                    else {
                        var s = l.config.plotOptions.radialBar.hollow.imageWidth,
                            c = l.config.plotOptions.radialBar.hollow.imageHeight;
                        if (void 0 === s && void 0 === c) {
                            var u = l.globals.dom.Paper.image(o).loaded((function (e) {
                                this.move(t.centerX - e.width / 2 + l.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - e.height / 2 + l.config.plotOptions.radialBar.hollow.imageOffsetY)
                            }));
                            e.add(u)
                        } else {
                            var h = l.globals.dom.Paper.image(o).loaded((function (e) {
                                this.move(t.centerX - s / 2 + l.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - c / 2 + l.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(s, c)
                            }));
                            e.add(h)
                        }
                    }
                    return n
                }
            }, {
                key: "getStrokeWidth",
                value: function (t) {
                    var e = this.w;
                    return t.size * (100 - parseInt(e.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (t.series.length + 1) - this.margin
                }
            }]), i
        }(),
        Tt = function () {
            function t(e) {
                r(this, t), this.w = e.w, this.lineCtx = e
            }
            return o(t, [{
                key: "sameValueSeriesFix",
                value: function (t, e) {
                    var i = this.w;
                    if ("line" === i.config.chart.type && ("gradient" === i.config.fill.type || "gradient" === i.config.fill.type[t]) && new S(this.lineCtx.ctx, i).seriesHaveSameValues(t)) {
                        var n = e[t].slice();
                        n[n.length - 1] = n[n.length - 1] + 1e-6, e[t] = n
                    }
                    return e
                }
            }, {
                key: "calculatePoints",
                value: function (t) {
                    var e = t.series,
                        i = t.realIndex,
                        n = t.x,
                        l = t.y,
                        r = t.i,
                        a = t.j,
                        o = t.prevY,
                        s = this.w,
                        c = [],
                        u = [];
                    if (0 === a) {
                        var h = this.lineCtx.categoryAxisCorrection + s.config.markers.offsetX;
                        s.globals.isXNumeric && (h = (s.globals.seriesX[i][0] - s.globals.minX) / this.lineCtx.xRatio + s.config.markers.offsetX), c.push(h), u.push(y.isNumber(e[r][0]) ? o + s.config.markers.offsetY : null), c.push(n + s.config.markers.offsetX), u.push(y.isNumber(e[r][a + 1]) ? l + s.config.markers.offsetY : null)
                    } else c.push(n + s.config.markers.offsetX), u.push(y.isNumber(e[r][a + 1]) ? l + s.config.markers.offsetY : null);
                    return {
                        x: c,
                        y: u
                    }
                }
            }, {
                key: "checkPreviousPaths",
                value: function (t) {
                    for (var e = t.pathFromLine, i = t.pathFromArea, n = t.realIndex, l = this.w, r = 0; r < l.globals.previousPaths.length; r++) {
                        var a = l.globals.previousPaths[r];
                        ("line" === a.type || "area" === a.type) && a.paths.length > 0 && parseInt(a.realIndex, 10) === parseInt(n, 10) && ("line" === a.type ? (this.lineCtx.appendPathFrom = !1, e = l.globals.previousPaths[r].paths[0].d) : "area" === a.type && (this.lineCtx.appendPathFrom = !1, i = l.globals.previousPaths[r].paths[0].d, l.config.stroke.show && l.globals.previousPaths[r].paths[1] && (e = l.globals.previousPaths[r].paths[1].d)))
                    }
                    return {
                        pathFromLine: e,
                        pathFromArea: i
                    }
                }
            }, {
                key: "determineFirstPrevY",
                value: function (t) {
                    var e = t.i,
                        i = t.series,
                        n = t.prevY,
                        l = t.lineYPosition,
                        r = this.w;
                    if (void 0 !== i[e][0]) n = (l = r.config.chart.stacked && e > 0 ? this.lineCtx.prevSeriesY[e - 1][0] : this.lineCtx.zeroY) - i[e][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] + 2 * (this.lineCtx.isReversed ? i[e][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] : 0);
                    else if (r.config.chart.stacked && e > 0 && void 0 === i[e][0])
                        for (var a = e - 1; a >= 0; a--)
                            if (null !== i[a][0] && void 0 !== i[a][0]) {
                                n = l = this.lineCtx.prevSeriesY[a][0];
                                break
                            } return {
                        prevY: n,
                        lineYPosition: l
                    }
                }
            }]), t
        }(),
        Pt = function () {
            function t(e, i, n) {
                r(this, t), this.ctx = e, this.w = e.w, this.xyRatios = i, this.pointsChart = !("bubble" !== this.w.config.chart.type && "scatter" !== this.w.config.chart.type) || n, this.scatter = new L(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new Tt(this), this.markers = new P(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0
            }
            return o(t, [{
                key: "draw",
                value: function (t, e, i) {
                    var n = this.w,
                        l = new w(this.ctx),
                        r = n.globals.comboCharts ? e : n.config.chart.type,
                        a = l.group({
                            class: "apexcharts-".concat(r, "-series apexcharts-plot-series")
                        }),
                        o = new S(this.ctx, n);
                    this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, t = o.getLogSeries(t), this.yRatio = o.getLogYRatios(this.yRatio);
                    for (var s = [], c = 0; c < t.length; c++) {
                        t = this.lineHelpers.sameValueSeriesFix(c, t);
                        var u = n.globals.comboCharts ? i[c] : c;
                        this._initSerieVariables(t, c, u);
                        var h = [],
                            d = [],
                            f = n.globals.padHorizontal + this.categoryAxisCorrection;
                        this.ctx.series.addCollapsedClassToSeries(this.elSeries, u), n.globals.isXNumeric && n.globals.seriesX.length > 0 && (f = (n.globals.seriesX[u][0] - n.globals.minX) / this.xRatio), d.push(f);
                        var p, g = f,
                            m = g,
                            v = this.zeroY;
                        v = this.lineHelpers.determineFirstPrevY({
                            i: c,
                            series: t,
                            prevY: v,
                            lineYPosition: 0
                        }).prevY, h.push(v), p = v;
                        var y = this._calculatePathsFrom({
                                series: t,
                                i: c,
                                realIndex: u,
                                prevX: m,
                                prevY: v
                            }),
                            b = this._iterateOverDataPoints({
                                series: t,
                                realIndex: u,
                                i: c,
                                x: f,
                                y: 1,
                                pX: g,
                                pY: p,
                                pathsFrom: y,
                                linePaths: [],
                                areaPaths: [],
                                seriesIndex: i,
                                lineYPosition: 0,
                                xArrj: d,
                                yArrj: h
                            });
                        this._handlePaths({
                            type: r,
                            realIndex: u,
                            i: c,
                            paths: b
                        }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), s.push(this.elSeries)
                    }
                    if (n.config.chart.stacked)
                        for (var x = s.length; x > 0; x--) a.add(s[x - 1]);
                    else
                        for (var _ = 0; _ < s.length; _++) a.add(s[_]);
                    return a
                }
            }, {
                key: "_initSerieVariables",
                value: function (t, e, i) {
                    var n = this.w,
                        l = new w(this.ctx);
                    this.xDivision = n.globals.gridWidth / (n.globals.dataPoints - ("on" === n.config.xaxis.tickPlacement ? 1 : 0)), this.strokeWidth = Array.isArray(n.config.stroke.width) ? n.config.stroke.width[i] : n.config.stroke.width, this.yRatio.length > 1 && (this.yaxisIndex = i), this.isReversed = n.config.yaxis[this.yaxisIndex] && n.config.yaxis[this.yaxisIndex].reversed, this.zeroY = n.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? n.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), this.areaBottomY = this.zeroY, (this.zeroY > n.globals.gridHeight || "end" === n.config.plotOptions.area.fillTo) && (this.areaBottomY = n.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = l.group({
                        class: "apexcharts-series",
                        seriesName: y.escapeString(n.globals.seriesNames[i])
                    }), this.elPointsMain = l.group({
                        class: "apexcharts-series-markers-wrap",
                        "data:realIndex": i
                    }), this.elDataLabelsWrap = l.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": i
                    });
                    var r = t[e].length === n.globals.dataPoints;
                    this.elSeries.attr({
                        "data:longestSeries": r,
                        rel: e + 1,
                        "data:realIndex": i
                    }), this.appendPathFrom = !0
                }
            }, {
                key: "_calculatePathsFrom",
                value: function (t) {
                    var e, i, n, l, r = t.series,
                        a = t.i,
                        o = t.realIndex,
                        s = t.prevX,
                        c = t.prevY,
                        u = this.w,
                        h = new w(this.ctx);
                    if (null === r[a][0]) {
                        for (var d = 0; d < r[a].length; d++)
                            if (null !== r[a][d]) {
                                s = this.xDivision * d, c = this.zeroY - r[a][d] / this.yRatio[this.yaxisIndex], e = h.move(s, c), i = h.move(s, this.areaBottomY);
                                break
                            }
                    } else e = h.move(s, c), i = h.move(s, this.areaBottomY) + h.line(s, c);
                    if (n = h.move(-1, this.zeroY) + h.line(-1, this.zeroY), l = h.move(-1, this.zeroY) + h.line(-1, this.zeroY), u.globals.previousPaths.length > 0) {
                        var f = this.lineHelpers.checkPreviousPaths({
                            pathFromLine: n,
                            pathFromArea: l,
                            realIndex: o
                        });
                        n = f.pathFromLine, l = f.pathFromArea
                    }
                    return {
                        prevX: s,
                        prevY: c,
                        linePath: e,
                        areaPath: i,
                        pathFromLine: n,
                        pathFromArea: l
                    }
                }
            }, {
                key: "_handlePaths",
                value: function (t) {
                    var e = t.type,
                        i = t.realIndex,
                        n = t.i,
                        l = t.paths,
                        r = this.w,
                        a = new w(this.ctx),
                        o = new T(this.ctx);
                    this.prevSeriesY.push(l.yArrj), r.globals.seriesXvalues[i] = l.xArrj, r.globals.seriesYvalues[i] = l.yArrj, this.pointsChart || r.globals.delayedElements.push({
                        el: this.elPointsMain.node,
                        index: i
                    });
                    var s = {
                        i: n,
                        realIndex: i,
                        animationDelay: n,
                        initialSpeed: r.config.chart.animations.speed,
                        dataChangeSpeed: r.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-".concat(e)
                    };
                    if ("area" === e)
                        for (var c = o.fillPath({
                                seriesNumber: i
                            }), h = 0; h < l.areaPaths.length; h++) {
                            var d = a.renderPaths(u(u({}, s), {}, {
                                pathFrom: l.pathFromArea,
                                pathTo: l.areaPaths[h],
                                stroke: "none",
                                strokeWidth: 0,
                                strokeLineCap: null,
                                fill: c
                            }));
                            this.elSeries.add(d)
                        }
                    if (r.config.stroke.show && !this.pointsChart) {
                        var f;
                        f = "line" === e ? o.fillPath({
                            seriesNumber: i,
                            i: n
                        }) : r.globals.stroke.colors[i];
                        for (var p = 0; p < l.linePaths.length; p++) {
                            var g = a.renderPaths(u(u({}, s), {}, {
                                pathFrom: l.pathFromLine,
                                pathTo: l.linePaths[p],
                                stroke: f,
                                strokeWidth: this.strokeWidth,
                                strokeLineCap: r.config.stroke.lineCap,
                                fill: "none"
                            }));
                            this.elSeries.add(g)
                        }
                    }
                }
            }, {
                key: "_iterateOverDataPoints",
                value: function (t) {
                    for (var e = t.series, i = t.realIndex, n = t.i, l = t.x, r = t.y, a = t.pX, o = t.pY, s = t.pathsFrom, c = t.linePaths, u = t.areaPaths, h = t.seriesIndex, d = t.lineYPosition, f = t.xArrj, p = t.yArrj, g = this.w, m = new w(this.ctx), v = this.yRatio, b = s.prevY, x = s.linePath, _ = s.areaPath, k = s.pathFromLine, S = s.pathFromArea, A = y.isNumber(g.globals.minYArr[i]) ? g.globals.minYArr[i] : g.globals.minY, M = g.globals.dataPoints > 1 ? g.globals.dataPoints - 1 : g.globals.dataPoints, C = 0; C < M; C++) {
                        var E = void 0 === e[n][C + 1] || null === e[n][C + 1];
                        if (g.globals.isXNumeric) {
                            var O = g.globals.seriesX[i][C + 1];
                            void 0 === g.globals.seriesX[i][C + 1] && (O = g.globals.seriesX[i][M - 1]), l = (O - g.globals.minX) / this.xRatio
                        } else l += this.xDivision;
                        d = g.config.chart.stacked && n > 0 && g.globals.collapsedSeries.length < g.config.series.length - 1 ? this.prevSeriesY[function (t) {
                            for (var e = t, i = 0; i < g.globals.series.length; i++)
                                if (g.globals.collapsedSeriesIndices.indexOf(t) > -1) {
                                    e--;
                                    break
                                } return e >= 0 ? e : 0
                        }(n - 1)][C + 1] : this.zeroY, r = E ? d - A / v[this.yaxisIndex] + 2 * (this.isReversed ? A / v[this.yaxisIndex] : 0) : d - e[n][C + 1] / v[this.yaxisIndex] + 2 * (this.isReversed ? e[n][C + 1] / v[this.yaxisIndex] : 0), f.push(l), p.push(r);
                        var T = this.lineHelpers.calculatePoints({
                                series: e,
                                x: l,
                                y: r,
                                realIndex: i,
                                i: n,
                                j: C,
                                prevY: b
                            }),
                            P = this._createPaths({
                                series: e,
                                i: n,
                                realIndex: i,
                                j: C,
                                x: l,
                                y: r,
                                pX: a,
                                pY: o,
                                linePath: x,
                                areaPath: _,
                                linePaths: c,
                                areaPaths: u,
                                seriesIndex: h
                            });
                        u = P.areaPaths, c = P.linePaths, a = P.pX, o = P.pY, _ = P.areaPath, x = P.linePath, this.appendPathFrom && (k += m.line(l, this.zeroY), S += m.line(l, this.zeroY)), this.handleNullDataPoints(e, T, n, C, i), this._handleMarkersAndLabels({
                            pointsPos: T,
                            series: e,
                            x: l,
                            y: r,
                            prevY: b,
                            i: n,
                            j: C,
                            realIndex: i
                        })
                    }
                    return {
                        yArrj: p,
                        xArrj: f,
                        pathFromArea: S,
                        areaPaths: u,
                        pathFromLine: k,
                        linePaths: c
                    }
                }
            }, {
                key: "_handleMarkersAndLabels",
                value: function (t) {
                    var e = t.pointsPos,
                        i = (t.series, t.x, t.y, t.prevY, t.i),
                        n = t.j,
                        l = t.realIndex,
                        r = this.w,
                        a = new D(this.ctx);
                    if (this.pointsChart) this.scatter.draw(this.elSeries, n, {
                        realIndex: l,
                        pointsPos: e,
                        zRatio: this.zRatio,
                        elParent: this.elPointsMain
                    });
                    else {
                        r.globals.series[i].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
                        var o = this.markers.plotChartMarkers(e, l, n + 1);
                        null !== o && this.elPointsMain.add(o)
                    }
                    var s = a.drawDataLabel(e, l, n + 1, null);
                    null !== s && this.elDataLabelsWrap.add(s)
                }
            }, {
                key: "_createPaths",
                value: function (t) {
                    var e = t.series,
                        i = t.i,
                        n = t.realIndex,
                        l = t.j,
                        r = t.x,
                        a = t.y,
                        o = t.pX,
                        s = t.pY,
                        c = t.linePath,
                        u = t.areaPath,
                        h = t.linePaths,
                        d = t.areaPaths,
                        f = t.seriesIndex,
                        p = this.w,
                        g = new w(this.ctx),
                        m = p.config.stroke.curve,
                        v = this.areaBottomY;
                    if (Array.isArray(p.config.stroke.curve) && (m = Array.isArray(f) ? p.config.stroke.curve[f[i]] : p.config.stroke.curve[i]), "smooth" === m) {
                        var y = .35 * (r - o);
                        p.globals.hasNullValues ? (null !== e[i][l] && (null !== e[i][l + 1] ? (c = g.move(o, s) + g.curve(o + y, s, r - y, a, r + 1, a), u = g.move(o + 1, s) + g.curve(o + y, s, r - y, a, r + 1, a) + g.line(r, v) + g.line(o, v) + "z") : (c = g.move(o, s), u = g.move(o, s) + "z")), h.push(c), d.push(u)) : (c += g.curve(o + y, s, r - y, a, r, a), u += g.curve(o + y, s, r - y, a, r, a)), o = r, s = a, l === e[i].length - 2 && (u = u + g.curve(o, s, r, a, r, v) + g.move(r, a) + "z", p.globals.hasNullValues || (h.push(c), d.push(u)))
                    } else {
                        if (null === e[i][l + 1]) {
                            c += g.move(r, a);
                            var b = p.globals.isXNumeric ? (p.globals.seriesX[n][l] - p.globals.minX) / this.xRatio : r - this.xDivision;
                            u = u + g.line(b, v) + g.move(r, a) + "z"
                        }
                        null === e[i][l] && (c += g.move(r, a), u += g.move(r, v)), "stepline" === m ? (c = c + g.line(r, null, "H") + g.line(null, a, "V"), u = u + g.line(r, null, "H") + g.line(null, a, "V")) : "straight" === m && (c += g.line(r, a), u += g.line(r, a)), l === e[i].length - 2 && (u = u + g.line(r, v) + g.move(r, a) + "z", h.push(c), d.push(u))
                    }
                    return {
                        linePaths: h,
                        areaPaths: d,
                        pX: o,
                        pY: s,
                        linePath: c,
                        areaPath: u
                    }
                }
            }, {
                key: "handleNullDataPoints",
                value: function (t, e, i, n, l) {
                    var r = this.w;
                    if (null === t[i][n] && r.config.markers.showNullDataPoints || 1 === t[i].length) {
                        var a = this.markers.plotChartMarkers(e, l, n + 1, this.strokeWidth - r.config.markers.strokeWidth / 2, !0);
                        null !== a && this.elPointsMain.add(a)
                    }
                }
            }]), t
        }();
    window.TreemapSquared = {}, window.TreemapSquared.generate = function () {
        function t(e, i, n, l) {
            this.xoffset = e, this.yoffset = i, this.height = l, this.width = n, this.shortestEdge = function () {
                return Math.min(this.height, this.width)
            }, this.getCoordinates = function (t) {
                var e, i = [],
                    n = this.xoffset,
                    l = this.yoffset,
                    a = r(t) / this.height,
                    o = r(t) / this.width;
                if (this.width >= this.height)
                    for (e = 0; e < t.length; e++) i.push([n, l, n + a, l + t[e] / a]), l += t[e] / a;
                else
                    for (e = 0; e < t.length; e++) i.push([n, l, n + t[e] / o, l + o]), n += t[e] / o;
                return i
            }, this.cutArea = function (e) {
                var i;
                if (this.width >= this.height) {
                    var n = e / this.height,
                        l = this.width - n;
                    i = new t(this.xoffset + n, this.yoffset, l, this.height)
                } else {
                    var r = e / this.width,
                        a = this.height - r;
                    i = new t(this.xoffset, this.yoffset + r, this.width, a)
                }
                return i
            }
        }

        function e(e, n, l, a, o) {
            return a = void 0 === a ? 0 : a, o = void 0 === o ? 0 : o,
                function (t) {
                    var e, i, n = [];
                    for (e = 0; e < t.length; e++)
                        for (i = 0; i < t[e].length; i++) n.push(t[e][i]);
                    return n
                }(i(function (t, e) {
                    var i, n = [],
                        l = e / r(t);
                    for (i = 0; i < t.length; i++) n[i] = t[i] * l;
                    return n
                }(e, n * l), [], new t(a, o, n, l), []))
        }

        function i(t, e, l, a) {
            var o, s, c;
            if (0 !== t.length) return o = l.shortestEdge(),
                function (t, e, i) {
                    var l;
                    return 0 === t.length || ((l = t.slice()).push(e), n(t, i) >= n(l, i))
                }(e, s = t[0], o) ? (e.push(s), i(t.slice(1), e, l, a)) : (c = l.cutArea(r(e), a), a.push(l.getCoordinates(e)), i(t, [], c, a)), a;
            a.push(l.getCoordinates(e))
        }

        function n(t, e) {
            var i = Math.min.apply(Math, t),
                n = Math.max.apply(Math, t),
                l = r(t);
            return Math.max(Math.pow(e, 2) * n / Math.pow(l, 2), Math.pow(l, 2) / (Math.pow(e, 2) * i))
        }

        function l(t) {
            return t && t.constructor === Array
        }

        function r(t) {
            var e, i = 0;
            for (e = 0; e < t.length; e++) i += t[e];
            return i
        }

        function a(t) {
            var e, i = 0;
            if (l(t[0]))
                for (e = 0; e < t.length; e++) i += a(t[e]);
            else i = r(t);
            return i
        }
        return function t(i, n, r, o, s) {
            o = void 0 === o ? 0 : o, s = void 0 === s ? 0 : s;
            var c, u, h = [],
                d = [];
            if (l(i[0])) {
                for (u = 0; u < i.length; u++) h[u] = a(i[u]);
                for (c = e(h, n, r, o, s), u = 0; u < i.length; u++) d.push(t(i[u], c[u][2] - c[u][0], c[u][3] - c[u][1], c[u][0], c[u][1]))
            } else d = e(i, n, r, o, s);
            return d
        }
    }();
    var Lt, Dt, It = function () {
            function t(e, i) {
                r(this, t), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new St(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = []
            }
            return o(t, [{
                key: "draw",
                value: function (t) {
                    var e = this,
                        i = this.w,
                        n = new w(this.ctx),
                        l = new T(this.ctx),
                        r = n.group({
                            class: "apexcharts-treemap"
                        });
                    if (i.globals.noData) return r;
                    var a = [];
                    return t.forEach((function (t) {
                        var e = t.map((function (t) {
                            return Math.abs(t)
                        }));
                        a.push(e)
                    })), this.negRange = this.helpers.checkColorRange(), i.config.series.forEach((function (t, i) {
                        t.data.forEach((function (t) {
                            Array.isArray(e.labels[i]) || (e.labels[i] = []), e.labels[i].push(t.x)
                        }))
                    })), window.TreemapSquared.generate(a, i.globals.gridWidth, i.globals.gridHeight).forEach((function (a, o) {
                        var s = n.group({
                            class: "apexcharts-series apexcharts-treemap-series",
                            seriesName: y.escapeString(i.globals.seriesNames[o]),
                            rel: o + 1,
                            "data:realIndex": o
                        });
                        if (i.config.chart.dropShadow.enabled) {
                            var c = i.config.chart.dropShadow;
                            new x(e.ctx).dropShadow(r, c, o)
                        }
                        var u = n.group({
                            class: "apexcharts-data-labels"
                        });
                        a.forEach((function (r, a) {
                            var c = r[0],
                                u = r[1],
                                h = r[2],
                                d = r[3],
                                f = n.drawRect(c, u, h - c, d - u, 0, "#fff", 1, e.strokeWidth, i.config.plotOptions.treemap.useFillColorAsStroke ? g : i.globals.stroke.colors[o]);
                            f.attr({
                                cx: c,
                                cy: u,
                                index: o,
                                i: o,
                                j: a,
                                width: h - c,
                                height: d - u
                            });
                            var p = e.helpers.getShadeColor(i.config.chart.type, o, a, e.negRange),
                                g = p.color;
                            void 0 !== i.config.series[o].data[a] && i.config.series[o].data[a].fillColor && (g = i.config.series[o].data[a].fillColor);
                            var m = l.fillPath({
                                color: g,
                                seriesNumber: o,
                                dataPointIndex: a
                            });
                            f.node.classList.add("apexcharts-treemap-rect"), f.attr({
                                fill: m
                            }), e.helpers.addListeners(f);
                            var v = {
                                    x: c + (h - c) / 2,
                                    y: u + (d - u) / 2,
                                    width: 0,
                                    height: 0
                                },
                                y = {
                                    x: c,
                                    y: u,
                                    width: h - c,
                                    height: d - u
                                };
                            if (i.config.chart.animations.enabled && !i.globals.dataChanged) {
                                var b = 1;
                                i.globals.resized || (b = i.config.chart.animations.speed), e.animateTreemap(f, v, y, b)
                            }
                            if (i.globals.dataChanged) {
                                var x = 1;
                                e.dynamicAnim.enabled && i.globals.shouldAnimate && (x = e.dynamicAnim.speed, i.globals.previousPaths[o] && i.globals.previousPaths[o][a] && i.globals.previousPaths[o][a].rect && (v = i.globals.previousPaths[o][a].rect), e.animateTreemap(f, v, y, x))
                            }
                            var w = e.getFontSize(r),
                                _ = i.config.dataLabels.formatter(e.labels[o][a], {
                                    value: i.globals.series[o][a],
                                    seriesIndex: o,
                                    dataPointIndex: a,
                                    w: i
                                }),
                                k = e.helpers.calculateDataLabels({
                                    text: _,
                                    x: (c + h) / 2,
                                    y: (u + d) / 2 + e.strokeWidth / 2 + w / 3,
                                    i: o,
                                    j: a,
                                    colorProps: p,
                                    fontSize: w,
                                    series: t
                                });
                            i.config.dataLabels.enabled && k && e.rotateToFitLabel(k, _, c, u, h, d), s.add(f), null !== k && s.add(k)
                        })), s.add(u), r.add(s)
                    })), r
                }
            }, {
                key: "getFontSize",
                value: function (t) {
                    var e, i, n = this.w,
                        l = function t(e) {
                            var i, n = 0;
                            if (Array.isArray(e[0]))
                                for (i = 0; i < e.length; i++) n += t(e[i]);
                            else
                                for (i = 0; i < e.length; i++) n += e[i].length;
                            return n
                        }(this.labels) / function t(e) {
                            var i, n = 0;
                            if (Array.isArray(e[0]))
                                for (i = 0; i < e.length; i++) n += t(e[i]);
                            else
                                for (i = 0; i < e.length; i++) n += 1;
                            return n
                        }(this.labels);
                    return e = (t[2] - t[0]) * (t[3] - t[1]), i = Math.pow(e, .5), Math.min(i / l, parseInt(n.config.dataLabels.style.fontSize, 10))
                }
            }, {
                key: "rotateToFitLabel",
                value: function (t, e, i, n, l, r) {
                    var a = new w(this.ctx),
                        o = a.getTextRects(e);
                    if (o.width + 5 > l - i && o.width <= r - n) {
                        var s = a.rotateAroundCenter(t.node);
                        t.node.setAttribute("transform", "rotate(-90 ".concat(s.x, " ").concat(s.y, ")"))
                    }
                }
            }, {
                key: "animateTreemap",
                value: function (t, e, i, n) {
                    var l = new b(this.ctx);
                    l.animateRect(t, {
                        x: e.x,
                        y: e.y,
                        width: e.width,
                        height: e.height
                    }, {
                        x: i.x,
                        y: i.y,
                        width: i.width,
                        height: i.height
                    }, n, (function () {
                        l.animationCompleted(t)
                    }))
                }
            }]), t
        }(),
        jt = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC
            }
            return o(t, [{
                key: "calculateTimeScaleTicks",
                value: function (t, e) {
                    var i = this,
                        n = this.w;
                    if (n.globals.allSeriesCollapsed) return n.globals.labels = [], n.globals.timescaleLabels = [], [];
                    var l = new F(this.ctx),
                        r = (e - t) / 864e5;
                    this.determineInterval(r), n.globals.disableZoomIn = !1, n.globals.disableZoomOut = !1, r < .00011574074074074075 ? n.globals.disableZoomIn = !0 : r > 5e4 && (n.globals.disableZoomOut = !0);
                    var a = l.getTimeUnitsfromTimestamp(t, e, this.utc),
                        o = n.globals.gridWidth / r,
                        s = o / 24,
                        c = s / 60,
                        h = c / 60,
                        d = Math.floor(24 * r),
                        f = Math.floor(1440 * r),
                        p = Math.floor(86400 * r),
                        g = Math.floor(r),
                        m = Math.floor(r / 30),
                        v = Math.floor(r / 365),
                        y = {
                            minMillisecond: a.minMillisecond,
                            minSecond: a.minSecond,
                            minMinute: a.minMinute,
                            minHour: a.minHour,
                            minDate: a.minDate,
                            minMonth: a.minMonth,
                            minYear: a.minYear
                        },
                        b = {
                            firstVal: y,
                            currentMillisecond: y.minMillisecond,
                            currentSecond: y.minSecond,
                            currentMinute: y.minMinute,
                            currentHour: y.minHour,
                            currentMonthDate: y.minDate,
                            currentDate: y.minDate,
                            currentMonth: y.minMonth,
                            currentYear: y.minYear,
                            daysWidthOnXAxis: o,
                            hoursWidthOnXAxis: s,
                            minutesWidthOnXAxis: c,
                            secondsWidthOnXAxis: h,
                            numberOfSeconds: p,
                            numberOfMinutes: f,
                            numberOfHours: d,
                            numberOfDays: g,
                            numberOfMonths: m,
                            numberOfYears: v
                        };
                    switch (this.tickInterval) {
                        case "years":
                            this.generateYearScale(b);
                            break;
                        case "months":
                        case "half_year":
                            this.generateMonthScale(b);
                            break;
                        case "months_days":
                        case "months_fortnight":
                        case "days":
                        case "week_days":
                            this.generateDayScale(b);
                            break;
                        case "hours":
                            this.generateHourScale(b);
                            break;
                        case "minutes_fives":
                        case "minutes":
                            this.generateMinuteScale(b);
                            break;
                        case "seconds_tens":
                        case "seconds_fives":
                        case "seconds":
                            this.generateSecondScale(b)
                    }
                    var x = this.timeScaleArray.map((function (t) {
                        var e = {
                            position: t.position,
                            unit: t.unit,
                            year: t.year,
                            day: t.day ? t.day : 1,
                            hour: t.hour ? t.hour : 0,
                            month: t.month + 1
                        };
                        return "month" === t.unit ? u(u({}, e), {}, {
                            day: 1,
                            value: t.value + 1
                        }) : "day" === t.unit || "hour" === t.unit ? u(u({}, e), {}, {
                            value: t.value
                        }) : "minute" === t.unit ? u(u({}, e), {}, {
                            value: t.value,
                            minute: t.value
                        }) : "second" === t.unit ? u(u({}, e), {}, {
                            value: t.value,
                            minute: t.minute,
                            second: t.second
                        }) : t
                    }));
                    return x.filter((function (t) {
                        var e = 1,
                            l = Math.ceil(n.globals.gridWidth / 120),
                            r = t.value;
                        void 0 !== n.config.xaxis.tickAmount && (l = n.config.xaxis.tickAmount), x.length > l && (e = Math.floor(x.length / l));
                        var a = !1,
                            o = !1;
                        switch (i.tickInterval) {
                            case "years":
                                "year" === t.unit && (a = !0);
                                break;
                            case "half_year":
                                e = 7, "year" === t.unit && (a = !0);
                                break;
                            case "months":
                                e = 1, "year" === t.unit && (a = !0);
                                break;
                            case "months_fortnight":
                                e = 15, "year" !== t.unit && "month" !== t.unit || (a = !0), 30 === r && (o = !0);
                                break;
                            case "months_days":
                                e = 10, "month" === t.unit && (a = !0), 30 === r && (o = !0);
                                break;
                            case "week_days":
                                e = 8, "month" === t.unit && (a = !0);
                                break;
                            case "days":
                                e = 1, "month" === t.unit && (a = !0);
                                break;
                            case "hours":
                                "day" === t.unit && (a = !0);
                                break;
                            case "minutes_fives":
                                r % 5 != 0 && (o = !0);
                                break;
                            case "seconds_tens":
                                r % 10 != 0 && (o = !0);
                                break;
                            case "seconds_fives":
                                r % 5 != 0 && (o = !0)
                        }
                        if ("hours" === i.tickInterval || "minutes_fives" === i.tickInterval || "seconds_tens" === i.tickInterval || "seconds_fives" === i.tickInterval) {
                            if (!o) return !0
                        } else if ((r % e == 0 || a) && !o) return !0
                    }))
                }
            }, {
                key: "recalcDimensionsBasedOnFormat",
                value: function (t, e) {
                    var i = this.w,
                        n = this.formatDates(t),
                        l = this.removeOverlappingTS(n);
                    i.globals.timescaleLabels = l.slice(), new ut(this.ctx).plotCoords()
                }
            }, {
                key: "determineInterval",
                value: function (t) {
                    var e = 24 * t,
                        i = 60 * e;
                    switch (!0) {
                        case t / 365 > 5:
                            this.tickInterval = "years";
                            break;
                        case t > 800:
                            this.tickInterval = "half_year";
                            break;
                        case t > 180:
                            this.tickInterval = "months";
                            break;
                        case t > 90:
                            this.tickInterval = "months_fortnight";
                            break;
                        case t > 60:
                            this.tickInterval = "months_days";
                            break;
                        case t > 30:
                            this.tickInterval = "week_days";
                            break;
                        case t > 2:
                            this.tickInterval = "days";
                            break;
                        case e > 2.4:
                            this.tickInterval = "hours";
                            break;
                        case i > 15:
                            this.tickInterval = "minutes_fives";
                            break;
                        case i > 5:
                            this.tickInterval = "minutes";
                            break;
                        case i > 1:
                            this.tickInterval = "seconds_tens";
                            break;
                        case 60 * i > 20:
                            this.tickInterval = "seconds_fives";
                            break;
                        default:
                            this.tickInterval = "seconds"
                    }
                }
            }, {
                key: "generateYearScale",
                value: function (t) {
                    var e = t.firstVal,
                        i = t.currentMonth,
                        n = t.currentYear,
                        l = t.daysWidthOnXAxis,
                        r = t.numberOfYears,
                        a = e.minYear,
                        o = 0,
                        s = new F(this.ctx),
                        c = "year";
                    if (e.minDate > 1 || e.minMonth > 0) {
                        var u = s.determineRemainingDaysOfYear(e.minYear, e.minMonth, e.minDate);
                        o = (s.determineDaysOfYear(e.minYear) - u + 1) * l, a = e.minYear + 1, this.timeScaleArray.push({
                            position: o,
                            value: a,
                            unit: c,
                            year: a,
                            month: y.monthMod(i + 1)
                        })
                    } else 1 === e.minDate && 0 === e.minMonth && this.timeScaleArray.push({
                        position: o,
                        value: a,
                        unit: c,
                        year: n,
                        month: y.monthMod(i + 1)
                    });
                    for (var h = a, d = o, f = 0; f < r; f++) h++, d = s.determineDaysOfYear(h - 1) * l + d, this.timeScaleArray.push({
                        position: d,
                        value: h,
                        unit: c,
                        year: h,
                        month: 1
                    })
                }
            }, {
                key: "generateMonthScale",
                value: function (t) {
                    var e = t.firstVal,
                        i = t.currentMonthDate,
                        n = t.currentMonth,
                        l = t.currentYear,
                        r = t.daysWidthOnXAxis,
                        a = t.numberOfMonths,
                        o = n,
                        s = 0,
                        c = new F(this.ctx),
                        u = "month",
                        h = 0;
                    if (e.minDate > 1) {
                        s = (c.determineDaysOfMonths(n + 1, e.minYear) - i + 1) * r, o = y.monthMod(n + 1);
                        var d = l + h,
                            f = y.monthMod(o),
                            p = o;
                        0 === o && (u = "year", p = d, f = 1, d += h += 1), this.timeScaleArray.push({
                            position: s,
                            value: p,
                            unit: u,
                            year: d,
                            month: f
                        })
                    } else this.timeScaleArray.push({
                        position: s,
                        value: o,
                        unit: u,
                        year: l,
                        month: y.monthMod(n)
                    });
                    for (var g = o + 1, m = s, v = 0, b = 1; v < a; v++, b++) {
                        0 === (g = y.monthMod(g)) ? (u = "year", h += 1) : u = "month";
                        var x = this._getYear(l, g, h);
                        m = c.determineDaysOfMonths(g, x) * r + m;
                        var w = 0 === g ? x : g;
                        this.timeScaleArray.push({
                            position: m,
                            value: w,
                            unit: u,
                            year: x,
                            month: 0 === g ? 1 : g
                        }), g++
                    }
                }
            }, {
                key: "generateDayScale",
                value: function (t) {
                    var e = t.firstVal,
                        i = t.currentMonth,
                        n = t.currentYear,
                        l = t.hoursWidthOnXAxis,
                        r = t.numberOfDays,
                        a = new F(this.ctx),
                        o = "day",
                        s = e.minDate + 1,
                        c = s,
                        u = function (t, e, i) {
                            return t > a.determineDaysOfMonths(e + 1, i) ? (c = 1, o = "month", d = e += 1, e) : e
                        },
                        h = (24 - e.minHour) * l,
                        d = s,
                        f = u(c, i, n);
                    0 === e.minHour && 1 === e.minDate ? (h = 0, d = y.monthMod(e.minMonth), o = "month", c = e.minDate, r++) : 1 !== e.minDate && 0 === e.minHour && 0 === e.minMinute && (h = 0, s = e.minDate, d = s, f = u(c = s, i, n)), this.timeScaleArray.push({
                        position: h,
                        value: d,
                        unit: o,
                        year: this._getYear(n, f, 0),
                        month: y.monthMod(f),
                        day: c
                    });
                    for (var p = h, g = 0; g < r; g++) {
                        o = "day", f = u(c += 1, f, this._getYear(n, f, 0));
                        var m = this._getYear(n, f, 0);
                        p = 24 * l + p;
                        var v = 1 === c ? y.monthMod(f) : c;
                        this.timeScaleArray.push({
                            position: p,
                            value: v,
                            unit: o,
                            year: m,
                            month: y.monthMod(f),
                            day: v
                        })
                    }
                }
            }, {
                key: "generateHourScale",
                value: function (t) {
                    var e = t.firstVal,
                        i = t.currentDate,
                        n = t.currentMonth,
                        l = t.currentYear,
                        r = t.minutesWidthOnXAxis,
                        a = t.numberOfHours,
                        o = new F(this.ctx),
                        s = "hour",
                        c = function (t, e) {
                            return t > o.determineDaysOfMonths(e + 1, l) && (g = 1, e += 1), {
                                month: e,
                                date: g
                            }
                        },
                        u = function (t, e) {
                            return t > o.determineDaysOfMonths(e + 1, l) ? e += 1 : e
                        },
                        h = 60 - (e.minMinute + e.minSecond / 60),
                        d = h * r,
                        f = e.minHour + 1,
                        p = f + 1;
                    60 === h && (d = 0, p = (f = e.minHour) + 1);
                    var g = i,
                        m = u(g, n);
                    this.timeScaleArray.push({
                        position: d,
                        value: f,
                        unit: s,
                        day: g,
                        hour: p,
                        year: l,
                        month: y.monthMod(m)
                    });
                    for (var v = d, b = 0; b < a; b++) {
                        s = "hour", p >= 24 && (p = 0, s = "day", m = c(g += 1, m).month, m = u(g, m));
                        var x = this._getYear(l, m, 0);
                        v = 0 === p && 0 === b ? h * r : 60 * r + v;
                        var w = 0 === p ? g : p;
                        this.timeScaleArray.push({
                            position: v,
                            value: w,
                            unit: s,
                            hour: p,
                            day: g,
                            year: x,
                            month: y.monthMod(m)
                        }), p++
                    }
                }
            }, {
                key: "generateMinuteScale",
                value: function (t) {
                    for (var e = t.currentMillisecond, i = t.currentSecond, n = t.currentMinute, l = t.currentHour, r = t.currentDate, a = t.currentMonth, o = t.currentYear, s = t.minutesWidthOnXAxis, c = t.secondsWidthOnXAxis, u = t.numberOfMinutes, h = n + 1, d = r, f = a, p = o, g = l, m = (60 - i - e / 1e3) * c, v = 0; v < u; v++) h >= 60 && (h = 0, 24 === (g += 1) && (g = 0)), this.timeScaleArray.push({
                        position: m,
                        value: h,
                        unit: "minute",
                        hour: g,
                        minute: h,
                        day: d,
                        year: this._getYear(p, f, 0),
                        month: y.monthMod(f)
                    }), m += s, h++
                }
            }, {
                key: "generateSecondScale",
                value: function (t) {
                    for (var e = t.currentMillisecond, i = t.currentSecond, n = t.currentMinute, l = t.currentHour, r = t.currentDate, a = t.currentMonth, o = t.currentYear, s = t.secondsWidthOnXAxis, c = t.numberOfSeconds, u = i + 1, h = n, d = r, f = a, p = o, g = l, m = (1e3 - e) / 1e3 * s, v = 0; v < c; v++) u >= 60 && (u = 0, ++h >= 60 && (h = 0, 24 == ++g && (g = 0))), this.timeScaleArray.push({
                        position: m,
                        value: u,
                        unit: "second",
                        hour: g,
                        minute: h,
                        second: u,
                        day: d,
                        year: this._getYear(p, f, 0),
                        month: y.monthMod(f)
                    }), m += s, u++
                }
            }, {
                key: "createRawDateString",
                value: function (t, e) {
                    var i = t.year;
                    return 0 === t.month && (t.month = 1), i += "-" + ("0" + t.month.toString()).slice(-2), "day" === t.unit ? i += "day" === t.unit ? "-" + ("0" + e).slice(-2) : "-01" : i += "-" + ("0" + (t.day ? t.day : "1")).slice(-2), "hour" === t.unit ? i += "hour" === t.unit ? "T" + ("0" + e).slice(-2) : "T00" : i += "T" + ("0" + (t.hour ? t.hour : "0")).slice(-2), "minute" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":" + (t.minute ? ("0" + t.minute).slice(-2) : "00"), "second" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":00", this.utc && (i += ".000Z"), i
                }
            }, {
                key: "formatDates",
                value: function (t) {
                    var e = this,
                        i = this.w;
                    return t.map((function (t) {
                        var n = t.value.toString(),
                            l = new F(e.ctx),
                            r = e.createRawDateString(t, n),
                            a = l.getDate(l.parseDate(r));
                        if (e.utc || (a = l.getDate(l.parseDateWithTimezone(r))), void 0 === i.config.xaxis.labels.format) {
                            var o = "dd MMM",
                                s = i.config.xaxis.labels.datetimeFormatter;
                            "year" === t.unit && (o = s.year), "month" === t.unit && (o = s.month), "day" === t.unit && (o = s.day), "hour" === t.unit && (o = s.hour), "minute" === t.unit && (o = s.minute), "second" === t.unit && (o = s.second), n = l.formatDate(a, o)
                        } else n = l.formatDate(a, i.config.xaxis.labels.format);
                        return {
                            dateString: r,
                            position: t.position,
                            value: n,
                            unit: t.unit,
                            year: t.year,
                            month: t.month
                        }
                    }))
                }
            }, {
                key: "removeOverlappingTS",
                value: function (t) {
                    var e, i = this,
                        n = new w(this.ctx),
                        l = !1;
                    t.length > 0 && t[0].value && t.every((function (e) {
                        return e.value.length === t[0].value.length
                    })) && (l = !0, e = n.getTextRects(t[0].value).width);
                    var r = 0,
                        a = t.map((function (a, o) {
                            if (o > 0 && i.w.config.xaxis.labels.hideOverlappingLabels) {
                                var s = l ? e : n.getTextRects(t[r].value).width,
                                    c = t[r].position;
                                return a.position > c + s + 10 ? (r = o, a) : null
                            }
                            return a
                        }));
                    return a.filter((function (t) {
                        return null !== t
                    }))
                }
            }, {
                key: "_getYear",
                value: function (t, e, i) {
                    return t + Math.floor(e / 12) + i
                }
            }]), t
        }(),
        Nt = function () {
            function t(e, i) {
                r(this, t), this.ctx = i, this.w = i.w, this.el = e
            }
            return o(t, [{
                key: "setupElements",
                value: function () {
                    var t = this.w.globals,
                        e = this.w.config,
                        i = e.chart.type;
                    t.axisCharts = ["line", "area", "bar", "rangeBar", "candlestick", "boxPlot", "scatter", "bubble", "radar", "heatmap", "treemap"].indexOf(i) > -1, t.xyCharts = ["line", "area", "bar", "rangeBar", "candlestick", "boxPlot", "scatter", "bubble"].indexOf(i) > -1, t.isBarHorizontal = ("bar" === e.chart.type || "rangeBar" === e.chart.type) && e.plotOptions.bar.horizontal, t.chartClass = ".apexcharts" + t.chartID, t.dom.baseEl = this.el, t.dom.elWrap = document.createElement("div"), w.setAttrs(t.dom.elWrap, {
                        id: t.chartClass.substring(1),
                        class: "apexcharts-canvas " + t.chartClass.substring(1)
                    }), this.el.appendChild(t.dom.elWrap), t.dom.Paper = new window.SVG.Doc(t.dom.elWrap), t.dom.Paper.attr({
                        class: "apexcharts-svg",
                        "xmlns:data": "ApexChartsNS",
                        transform: "translate(".concat(e.chart.offsetX, ", ").concat(e.chart.offsetY, ")")
                    }), t.dom.Paper.node.style.background = e.chart.background, this.setSVGDimensions(), t.dom.elGraphical = t.dom.Paper.group().attr({
                        class: "apexcharts-inner apexcharts-graphical"
                    }), t.dom.elAnnotations = t.dom.Paper.group().attr({
                        class: "apexcharts-annotations"
                    }), t.dom.elDefs = t.dom.Paper.defs(), t.dom.elLegendWrap = document.createElement("div"), t.dom.elLegendWrap.classList.add("apexcharts-legend"), t.dom.elWrap.appendChild(t.dom.elLegendWrap), t.dom.Paper.add(t.dom.elGraphical), t.dom.elGraphical.add(t.dom.elDefs)
                }
            }, {
                key: "plotChartType",
                value: function (t, e) {
                    var i = this.w,
                        n = i.config,
                        l = i.globals,
                        r = {
                            series: [],
                            i: []
                        },
                        a = {
                            series: [],
                            i: []
                        },
                        o = {
                            series: [],
                            i: []
                        },
                        s = {
                            series: [],
                            i: []
                        },
                        c = {
                            series: [],
                            i: []
                        },
                        u = {
                            series: [],
                            i: []
                        },
                        h = {
                            series: [],
                            i: []
                        };
                    l.series.map((function (e, d) {
                        var f = 0;
                        void 0 !== t[d].type ? ("column" === t[d].type || "bar" === t[d].type ? (l.series.length > 1 && n.plotOptions.bar.horizontal && console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"), c.series.push(e), c.i.push(d), f++, i.globals.columnSeries = c.series) : "area" === t[d].type ? (a.series.push(e), a.i.push(d), f++) : "line" === t[d].type ? (r.series.push(e), r.i.push(d), f++) : "scatter" === t[d].type ? (o.series.push(e), o.i.push(d)) : "bubble" === t[d].type ? (s.series.push(e), s.i.push(d), f++) : "candlestick" === t[d].type ? (u.series.push(e), u.i.push(d), f++) : "boxPlot" === t[d].type ? (h.series.push(e), h.i.push(d), f++) : console.warn("You have specified an unrecognized chart type. Available types for this property are line/area/column/bar/scatter/bubble"), f > 1 && (l.comboCharts = !0)) : (r.series.push(e), r.i.push(d))
                    }));
                    var d = new Pt(this.ctx, e),
                        f = new kt(this.ctx, e);
                    this.ctx.pie = new Ct(this.ctx);
                    var p = new Ot(this.ctx);
                    this.ctx.rangeBar = new z(this.ctx, e);
                    var g = new Et(this.ctx),
                        m = [];
                    if (l.comboCharts) {
                        if (a.series.length > 0 && m.push(d.draw(a.series, "area", a.i)), c.series.length > 0)
                            if (i.config.chart.stacked) {
                                var v = new _t(this.ctx, e);
                                m.push(v.draw(c.series, c.i))
                            } else this.ctx.bar = new R(this.ctx, e), m.push(this.ctx.bar.draw(c.series, c.i));
                        if (r.series.length > 0 && m.push(d.draw(r.series, "line", r.i)), u.series.length > 0 && m.push(f.draw(u.series, u.i)), h.series.length > 0 && m.push(f.draw(h.series, h.i)), o.series.length > 0) {
                            var y = new Pt(this.ctx, e, !0);
                            m.push(y.draw(o.series, "scatter", o.i))
                        }
                        if (s.series.length > 0) {
                            var b = new Pt(this.ctx, e, !0);
                            m.push(b.draw(s.series, "bubble", s.i))
                        }
                    } else switch (n.chart.type) {
                        case "line":
                            m = d.draw(l.series, "line");
                            break;
                        case "area":
                            m = d.draw(l.series, "area");
                            break;
                        case "bar":
                            n.chart.stacked ? m = new _t(this.ctx, e).draw(l.series) : (this.ctx.bar = new R(this.ctx, e), m = this.ctx.bar.draw(l.series));
                            break;
                        case "candlestick":
                        case "boxPlot":
                            m = new kt(this.ctx, e).draw(l.series);
                            break;
                        case "rangeBar":
                            m = this.ctx.rangeBar.draw(l.series);
                            break;
                        case "heatmap":
                            m = new At(this.ctx, e).draw(l.series);
                            break;
                        case "treemap":
                            m = new It(this.ctx, e).draw(l.series);
                            break;
                        case "pie":
                        case "donut":
                        case "polarArea":
                            m = this.ctx.pie.draw(l.series);
                            break;
                        case "radialBar":
                            m = p.draw(l.series);
                            break;
                        case "radar":
                            m = g.draw(l.series);
                            break;
                        default:
                            m = d.draw(l.series)
                    }
                    return m
                }
            }, {
                key: "setSVGDimensions",
                value: function () {
                    var t = this.w.globals,
                        e = this.w.config;
                    t.svgWidth = e.chart.width, t.svgHeight = e.chart.height;
                    var i = y.getDimensions(this.el),
                        n = e.chart.width.toString().split(/[0-9]+/g).pop();
                    "%" === n ? y.isNumber(i[0]) && (0 === i[0].width && (i = y.getDimensions(this.el.parentNode)), t.svgWidth = i[0] * parseInt(e.chart.width, 10) / 100) : "px" !== n && "" !== n || (t.svgWidth = parseInt(e.chart.width, 10));
                    var l = e.chart.height.toString().split(/[0-9]+/g).pop();
                    if ("auto" !== t.svgHeight && "" !== t.svgHeight)
                        if ("%" === l) {
                            var r = y.getDimensions(this.el.parentNode);
                            t.svgHeight = r[1] * parseInt(e.chart.height, 10) / 100
                        } else t.svgHeight = parseInt(e.chart.height, 10);
                    else t.axisCharts ? t.svgHeight = t.svgWidth / 1.61 : t.svgHeight = t.svgWidth / 1.2;
                    if (t.svgWidth < 0 && (t.svgWidth = 0), t.svgHeight < 0 && (t.svgHeight = 0), w.setAttrs(t.dom.Paper.node, {
                            width: t.svgWidth,
                            height: t.svgHeight
                        }), "%" !== l) {
                        var a = e.chart.sparkline.enabled ? 0 : t.axisCharts ? e.chart.parentHeightOffset : 0;
                        t.dom.Paper.node.parentNode.parentNode.style.minHeight = t.svgHeight + a + "px"
                    }
                    t.dom.elWrap.style.width = t.svgWidth + "px", t.dom.elWrap.style.height = t.svgHeight + "px"
                }
            }, {
                key: "shiftGraphPosition",
                value: function () {
                    var t = this.w.globals,
                        e = t.translateY,
                        i = {
                            transform: "translate(" + t.translateX + ", " + e + ")"
                        };
                    w.setAttrs(t.dom.elGraphical.node, i)
                }
            }, {
                key: "resizeNonAxisCharts",
                value: function () {
                    var t = this.w,
                        e = t.globals,
                        i = 0,
                        n = t.config.chart.sparkline.enabled ? 1 : 15;
                    n += t.config.grid.padding.bottom, "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || !t.config.legend.show || t.config.legend.floating || (i = new dt(this.ctx).legendHelpers.getLegendBBox().clwh + 10);
                    var l = t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"),
                        r = 2.05 * t.globals.radialSize;
                    if (l && !t.config.chart.sparkline.enabled) {
                        var a = y.getBoundingClientRect(l);
                        r = a.bottom;
                        var o = a.bottom - a.top;
                        r = Math.max(2.05 * t.globals.radialSize, o)
                    }
                    var s = r + e.translateY + i + n;
                    e.dom.elLegendForeign && e.dom.elLegendForeign.setAttribute("height", s), e.dom.elWrap.style.height = s + "px", w.setAttrs(e.dom.Paper.node, {
                        height: s
                    }), e.dom.Paper.node.parentNode.parentNode.style.minHeight = s + "px"
                }
            }, {
                key: "coreCalculations",
                value: function () {
                    new $(this.ctx).init()
                }
            }, {
                key: "resetGlobals",
                value: function () {
                    var t = this,
                        e = function () {
                            return t.w.config.series.map((function (t) {
                                return []
                            }))
                        },
                        i = new Y,
                        n = this.w.globals;
                    i.initGlobalVars(n), n.seriesXvalues = e(), n.seriesYvalues = e()
                }
            }, {
                key: "isMultipleY",
                value: function () {
                    if (this.w.config.yaxis.constructor === Array && this.w.config.yaxis.length > 1) return this.w.globals.isMultipleYAxis = !0, !0
                }
            }, {
                key: "xySettings",
                value: function () {
                    var t = null,
                        e = this.w;
                    if (e.globals.axisCharts) {
                        if ("back" === e.config.xaxis.crosshairs.position && new it(this.ctx).drawXCrosshairs(), "back" === e.config.yaxis[0].crosshairs.position && new it(this.ctx).drawYCrosshairs(), "datetime" === e.config.xaxis.type && void 0 === e.config.xaxis.labels.formatter) {
                            this.ctx.timeScale = new jt(this.ctx);
                            var i = [];
                            isFinite(e.globals.minX) && isFinite(e.globals.maxX) && !e.globals.isBarHorizontal ? i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minX, e.globals.maxX) : e.globals.isBarHorizontal && (i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minY, e.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(i)
                        }
                        t = new S(this.ctx).getCalculatedRatios()
                    }
                    return t
                }
            }, {
                key: "updateSourceChart",
                value: function (t) {
                    this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({
                        chart: {
                            selection: {
                                xaxis: {
                                    min: t.w.globals.minX,
                                    max: t.w.globals.maxX
                                }
                            }
                        }
                    }, !1, !1)
                }
            }, {
                key: "setupBrushHandler",
                value: function () {
                    var t = this,
                        e = this.w;
                    if (e.config.chart.brush.enabled && "function" != typeof e.config.chart.events.selection) {
                        var i = e.config.chart.brush.targets || [e.config.chart.brush.target];
                        i.forEach((function (e) {
                            var i = ApexCharts.getChartByID(e);
                            i.w.globals.brushSource = t.ctx, "function" != typeof i.w.config.chart.events.zoomed && (i.w.config.chart.events.zoomed = function () {
                                t.updateSourceChart(i)
                            }), "function" != typeof i.w.config.chart.events.scrolled && (i.w.config.chart.events.scrolled = function () {
                                t.updateSourceChart(i)
                            })
                        })), e.config.chart.events.selection = function (t, n) {
                            i.forEach((function (t) {
                                var i = ApexCharts.getChartByID(t),
                                    l = y.clone(e.config.yaxis);
                                if (e.config.chart.brush.autoScaleYaxis && 1 === i.w.globals.series.length) {
                                    var r = new K(i);
                                    l = r.autoScaleY(i, l, n)
                                }
                                var a = i.w.config.yaxis.reduce((function (t, e, n) {
                                    return [].concat(m(t), [u(u({}, i.w.config.yaxis[n]), {}, {
                                        min: l[0].min,
                                        max: l[0].max
                                    })])
                                }), []);
                                i.ctx.updateHelpers._updateOptions({
                                    xaxis: {
                                        min: n.xaxis.min,
                                        max: n.xaxis.max
                                    },
                                    yaxis: a
                                }, !1, !1, !1, !1)
                            }))
                        }
                    }
                }
            }]), t
        }(),
        Rt = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "_updateOptions",
                value: function (t) {
                    var e = this,
                        i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                        n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                        r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
                        a = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
                        o = [this.ctx];
                    r && (o = this.ctx.getSyncedCharts()), this.ctx.w.globals.isExecCalled && (o = [this.ctx], this.ctx.w.globals.isExecCalled = !1), o.forEach((function (r) {
                        var o = r.w;
                        return o.globals.shouldAnimate = n, i || (o.globals.resized = !0, o.globals.dataChanged = !0, n && r.series.getPreviousPaths()), t && "object" === l(t) && (r.config = new B(t), t = S.extendArrayProps(r.config, t, o), r.w.globals.chartID !== e.ctx.w.globals.chartID && delete t.series, o.config = y.extend(o.config, t), a && (o.globals.lastXAxis = t.xaxis ? y.clone(t.xaxis) : [], o.globals.lastYAxis = t.yaxis ? y.clone(t.yaxis) : [], o.globals.initialConfig = y.extend({}, o.config), o.globals.initialSeries = y.clone(o.config.series))), r.update(t)
                    }))
                }
            }, {
                key: "_updateSeries",
                value: function (t, e) {
                    var i, n = this,
                        l = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                        r = this.w;
                    return r.globals.shouldAnimate = e, r.globals.dataChanged = !0, e && this.ctx.series.getPreviousPaths(), r.globals.axisCharts ? (0 === (i = t.map((function (t, e) {
                        return n._extendSeries(t, e)
                    }))).length && (i = [{
                        data: []
                    }]), r.config.series = i) : r.config.series = t.slice(), l && (r.globals.initialSeries = y.clone(r.config.series)), this.ctx.update()
                }
            }, {
                key: "_extendSeries",
                value: function (t, e) {
                    var i = this.w,
                        n = i.config.series[e];
                    return u(u({}, i.config.series[e]), {}, {
                        name: t.name ? t.name : n && n.name,
                        color: t.color ? t.color : n && n.color,
                        type: t.type ? t.type : n && n.type,
                        data: t.data ? t.data : n && n.data
                    })
                }
            }, {
                key: "toggleDataPointSelection",
                value: function (t, e) {
                    var i = this.w,
                        n = null,
                        l = ".apexcharts-series[data\\:realIndex='".concat(t, "']");
                    return i.globals.axisCharts ? n = i.globals.dom.Paper.select("".concat(l, " path[j='").concat(e, "'], ").concat(l, " circle[j='").concat(e, "'], ").concat(l, " rect[j='").concat(e, "']")).members[0] : void 0 === e && (n = i.globals.dom.Paper.select("".concat(l, " path[j='").concat(t, "']")).members[0], "pie" !== i.config.chart.type && "polarArea" !== i.config.chart.type && "donut" !== i.config.chart.type || this.ctx.pie.pieClicked(t)), n ? (new w(this.ctx).pathMouseDown(n, null), n.node ? n.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null)
                }
            }, {
                key: "forceXAxisUpdate",
                value: function (t) {
                    var e = this.w;
                    if (["min", "max"].forEach((function (i) {
                            void 0 !== t.xaxis[i] && (e.config.xaxis[i] = t.xaxis[i], e.globals.lastXAxis[i] = t.xaxis[i])
                        })), t.xaxis.categories && t.xaxis.categories.length && (e.config.xaxis.categories = t.xaxis.categories), e.config.xaxis.convertedCatToNumeric) {
                        var i = new H(t);
                        t = i.convertCatToNumericXaxis(t, this.ctx)
                    }
                    return t
                }
            }, {
                key: "forceYAxisUpdate",
                value: function (t) {
                    var e = this.w;
                    return e.config.chart.stacked && "100%" === e.config.chart.stackType && (Array.isArray(t.yaxis) ? t.yaxis.forEach((function (e, i) {
                        t.yaxis[i].min = 0, t.yaxis[i].max = 100
                    })) : (t.yaxis.min = 0, t.yaxis.max = 100)), t
                }
            }, {
                key: "revertDefaultAxisMinMax",
                value: function (t) {
                    var e = this,
                        i = this.w,
                        n = i.globals.lastXAxis,
                        l = i.globals.lastYAxis;
                    t && t.xaxis && (n = t.xaxis), t && t.yaxis && (l = t.yaxis), i.config.xaxis.min = n.min, i.config.xaxis.max = n.max;
                    i.config.yaxis.map((function (t, n) {
                        i.globals.zoomed || void 0 !== l[n] ? function (t) {
                            void 0 !== l[t] && (i.config.yaxis[t].min = l[t].min, i.config.yaxis[t].max = l[t].max)
                        }(n) : void 0 !== e.ctx.opts.yaxis[n] && (t.min = e.ctx.opts.yaxis[n].min, t.max = e.ctx.opts.yaxis[n].max)
                    }))
                }
            }]), t
        }();
    Lt = "undefined" != typeof window ? window : void 0, Dt = function (t, e) {
            var i = (void 0 !== this ? this : t).SVG = function (t) {
                if (i.supported) return t = new i.Doc(t), i.parser.draw || i.prepare(), t
            };
            if (i.ns = "http://www.w3.org/2000/svg", i.xmlns = "http://www.w3.org/2000/xmlns/", i.xlink = "http://www.w3.org/1999/xlink", i.svgjs = "http://svgjs.com/svgjs", i.supported = !0, !i.supported) return !1;
            i.did = 1e3, i.eid = function (t) {
                return "Svgjs" + h(t) + i.did++
            }, i.create = function (t) {
                var i = e.createElementNS(this.ns, t);
                return i.setAttribute("id", this.eid(t)), i
            }, i.extend = function () {
                var t, e;
                e = (t = [].slice.call(arguments)).pop();
                for (var n = t.length - 1; n >= 0; n--)
                    if (t[n])
                        for (var l in e) t[n].prototype[l] = e[l];
                i.Set && i.Set.inherit && i.Set.inherit()
            }, i.invent = function (t) {
                var e = "function" == typeof t.create ? t.create : function () {
                    this.constructor.call(this, i.create(t.create))
                };
                return t.inherit && (e.prototype = new t.inherit), t.extend && i.extend(e, t.extend), t.construct && i.extend(t.parent || i.Container, t.construct), e
            }, i.adopt = function (e) {
                return e ? e.instance ? e.instance : ((n = "svg" == e.nodeName ? e.parentNode instanceof t.SVGElement ? new i.Nested : new i.Doc : "linearGradient" == e.nodeName ? new i.Gradient("linear") : "radialGradient" == e.nodeName ? new i.Gradient("radial") : i[h(e.nodeName)] ? new(i[h(e.nodeName)]) : new i.Element(e)).type = e.nodeName, n.node = e, e.instance = n, n instanceof i.Doc && n.namespace().defs(), n.setData(JSON.parse(e.getAttribute("svgjs:data")) || {}), n) : null;
                var n
            }, i.prepare = function () {
                var t = e.getElementsByTagName("body")[0],
                    n = (t ? new i.Doc(t) : i.adopt(e.documentElement).nested()).size(2, 0);
                i.parser = {
                    body: t || e.documentElement,
                    draw: n.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,
                    poly: n.polyline().node,
                    path: n.path().node,
                    native: i.create("svg")
                }
            }, i.parser = {
                native: i.create("svg")
            }, e.addEventListener("DOMContentLoaded", (function () {
                i.parser.draw || i.prepare()
            }), !1), i.regex = {
                numberAndUnit: /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,
                hex: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
                rgb: /rgb\((\d+),(\d+),(\d+)\)/,
                reference: /#([a-z0-9\-_]+)/i,
                transforms: /\)\s*,?\s*/,
                whitespace: /\s/g,
                isHex: /^#[a-f0-9]{3,6}$/i,
                isRgb: /^rgb\(/,
                isCss: /[^:]+:[^;]+;?/,
                isBlank: /^(\s+)?$/,
                isNumber: /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
                isPercent: /^-?[\d\.]+%$/,
                isImage: /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,
                delimiter: /[\s,]+/,
                hyphen: /([^e])\-/gi,
                pathLetters: /[MLHVCSQTAZ]/gi,
                isPathLetter: /[MLHVCSQTAZ]/i,
                numbersWithDots: /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,
                dots: /\./g
            }, i.utils = {
                map: function (t, e) {
                    for (var i = t.length, n = [], l = 0; l < i; l++) n.push(e(t[l]));
                    return n
                },
                filter: function (t, e) {
                    for (var i = t.length, n = [], l = 0; l < i; l++) e(t[l]) && n.push(t[l]);
                    return n
                },
                filterSVGElements: function (e) {
                    return this.filter(e, (function (e) {
                        return e instanceof t.SVGElement
                    }))
                }
            }, i.defaults = {
                attrs: {
                    "fill-opacity": 1,
                    "stroke-opacity": 1,
                    "stroke-width": 0,
                    "stroke-linejoin": "miter",
                    "stroke-linecap": "butt",
                    fill: "#000000",
                    stroke: "#000000",
                    opacity: 1,
                    x: 0,
                    y: 0,
                    cx: 0,
                    cy: 0,
                    width: 0,
                    height: 0,
                    r: 0,
                    rx: 0,
                    ry: 0,
                    offset: 0,
                    "stop-opacity": 1,
                    "stop-color": "#000000",
                    "font-size": 16,
                    "font-family": "Helvetica, Arial, sans-serif",
                    "text-anchor": "start"
                }
            }, i.Color = function (t) {
                var e, n;
                this.r = 0, this.g = 0, this.b = 0, t && ("string" == typeof t ? i.regex.isRgb.test(t) ? (e = i.regex.rgb.exec(t.replace(i.regex.whitespace, "")), this.r = parseInt(e[1]), this.g = parseInt(e[2]), this.b = parseInt(e[3])) : i.regex.isHex.test(t) && (e = i.regex.hex.exec(4 == (n = t).length ? ["#", n.substring(1, 2), n.substring(1, 2), n.substring(2, 3), n.substring(2, 3), n.substring(3, 4), n.substring(3, 4)].join("") : n), this.r = parseInt(e[1], 16), this.g = parseInt(e[2], 16), this.b = parseInt(e[3], 16)) : "object" === l(t) && (this.r = t.r, this.g = t.g, this.b = t.b))
            }, i.extend(i.Color, {
                toString: function () {
                    return this.toHex()
                },
                toHex: function () {
                    return "#" + d(this.r) + d(this.g) + d(this.b)
                },
                toRgb: function () {
                    return "rgb(" + [this.r, this.g, this.b].join() + ")"
                },
                brightness: function () {
                    return this.r / 255 * .3 + this.g / 255 * .59 + this.b / 255 * .11
                },
                morph: function (t) {
                    return this.destination = new i.Color(t), this
                },
                at: function (t) {
                    return this.destination ? (t = t < 0 ? 0 : t > 1 ? 1 : t, new i.Color({
                        r: ~~(this.r + (this.destination.r - this.r) * t),
                        g: ~~(this.g + (this.destination.g - this.g) * t),
                        b: ~~(this.b + (this.destination.b - this.b) * t)
                    })) : this
                }
            }), i.Color.test = function (t) {
                return t += "", i.regex.isHex.test(t) || i.regex.isRgb.test(t)
            }, i.Color.isRgb = function (t) {
                return t && "number" == typeof t.r && "number" == typeof t.g && "number" == typeof t.b
            }, i.Color.isColor = function (t) {
                return i.Color.isRgb(t) || i.Color.test(t)
            }, i.Array = function (t, e) {
                0 == (t = (t || []).valueOf()).length && e && (t = e.valueOf()), this.value = this.parse(t)
            }, i.extend(i.Array, {
                toString: function () {
                    return this.value.join(" ")
                },
                valueOf: function () {
                    return this.value
                },
                parse: function (t) {
                    return t = t.valueOf(), Array.isArray(t) ? t : this.split(t)
                }
            }), i.PointArray = function (t, e) {
                i.Array.call(this, t, e || [
                    [0, 0]
                ])
            }, i.PointArray.prototype = new i.Array, i.PointArray.prototype.constructor = i.PointArray;
            for (var n = {
                    M: function (t, e, i) {
                        return e.x = i.x = t[0], e.y = i.y = t[1], ["M", e.x, e.y]
                    },
                    L: function (t, e) {
                        return e.x = t[0], e.y = t[1], ["L", t[0], t[1]]
                    },
                    H: function (t, e) {
                        return e.x = t[0], ["H", t[0]]
                    },
                    V: function (t, e) {
                        return e.y = t[0], ["V", t[0]]
                    },
                    C: function (t, e) {
                        return e.x = t[4], e.y = t[5], ["C", t[0], t[1], t[2], t[3], t[4], t[5]]
                    },
                    Q: function (t, e) {
                        return e.x = t[2], e.y = t[3], ["Q", t[0], t[1], t[2], t[3]]
                    },
                    Z: function (t, e, i) {
                        return e.x = i.x, e.y = i.y, ["Z"]
                    }
                }, r = "mlhvqtcsaz".split(""), a = 0, o = r.length; a < o; ++a) n[r[a]] = function (t) {
                return function (e, i, l) {
                    if ("H" == t) e[0] = e[0] + i.x;
                    else if ("V" == t) e[0] = e[0] + i.y;
                    else if ("A" == t) e[5] = e[5] + i.x, e[6] = e[6] + i.y;
                    else
                        for (var r = 0, a = e.length; r < a; ++r) e[r] = e[r] + (r % 2 ? i.y : i.x);
                    return n[t](e, i, l)
                }
            }(r[a].toUpperCase());
            i.PathArray = function (t, e) {
                i.Array.call(this, t, e || [
                    ["M", 0, 0]
                ])
            }, i.PathArray.prototype = new i.Array, i.PathArray.prototype.constructor = i.PathArray, i.extend(i.PathArray, {
                toString: function () {
                    return function (t) {
                        for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e][0], null != t[e][1] && (n += t[e][1], null != t[e][2] && (n += " ", n += t[e][2], null != t[e][3] && (n += " ", n += t[e][3], n += " ", n += t[e][4], null != t[e][5] && (n += " ", n += t[e][5], n += " ", n += t[e][6], null != t[e][7] && (n += " ", n += t[e][7])))));
                        return n + " "
                    }(this.value)
                },
                move: function (t, e) {
                    var i = this.bbox();
                    return i.x, i.y, this
                },
                at: function (t) {
                    if (!this.destination) return this;
                    for (var e = this.value, n = this.destination.value, l = [], r = new i.PathArray, a = 0, o = e.length; a < o; a++) {
                        l[a] = [e[a][0]];
                        for (var s = 1, c = e[a].length; s < c; s++) l[a][s] = e[a][s] + (n[a][s] - e[a][s]) * t;
                        "A" === l[a][0] && (l[a][4] = +(0 != l[a][4]), l[a][5] = +(0 != l[a][5]))
                    }
                    return r.value = l, r
                },
                parse: function (t) {
                    if (t instanceof i.PathArray) return t.valueOf();
                    var e, l = {
                        M: 2,
                        L: 2,
                        H: 1,
                        V: 1,
                        C: 6,
                        S: 4,
                        Q: 4,
                        T: 2,
                        A: 7,
                        Z: 0
                    };
                    t = "string" == typeof t ? t.replace(i.regex.numbersWithDots, c).replace(i.regex.pathLetters, " $& ").replace(i.regex.hyphen, "$1 -").trim().split(i.regex.delimiter) : t.reduce((function (t, e) {
                        return [].concat.call(t, e)
                    }), []);
                    var r = [],
                        a = new i.Point,
                        o = new i.Point,
                        s = 0,
                        u = t.length;
                    do {
                        i.regex.isPathLetter.test(t[s]) ? (e = t[s], ++s) : "M" == e ? e = "L" : "m" == e && (e = "l"), r.push(n[e].call(null, t.slice(s, s += l[e.toUpperCase()]).map(parseFloat), a, o))
                    } while (u > s);
                    return r
                },
                bbox: function () {
                    return i.parser.draw || i.prepare(), i.parser.path.setAttribute("d", this.toString()), i.parser.path.getBBox()
                }
            }), i.Number = i.invent({
                create: function (t, e) {
                    this.value = 0, this.unit = e || "", "number" == typeof t ? this.value = isNaN(t) ? 0 : isFinite(t) ? t : t < 0 ? -34e37 : 34e37 : "string" == typeof t ? (e = t.match(i.regex.numberAndUnit)) && (this.value = parseFloat(e[1]), "%" == e[5] ? this.value /= 100 : "s" == e[5] && (this.value *= 1e3), this.unit = e[5]) : t instanceof i.Number && (this.value = t.valueOf(), this.unit = t.unit)
                },
                extend: {
                    toString: function () {
                        return ("%" == this.unit ? ~~(1e8 * this.value) / 1e6 : "s" == this.unit ? this.value / 1e3 : this.value) + this.unit
                    },
                    toJSON: function () {
                        return this.toString()
                    },
                    valueOf: function () {
                        return this.value
                    },
                    plus: function (t) {
                        return t = new i.Number(t), new i.Number(this + t, this.unit || t.unit)
                    },
                    minus: function (t) {
                        return t = new i.Number(t), new i.Number(this - t, this.unit || t.unit)
                    },
                    times: function (t) {
                        return t = new i.Number(t), new i.Number(this * t, this.unit || t.unit)
                    },
                    divide: function (t) {
                        return t = new i.Number(t), new i.Number(this / t, this.unit || t.unit)
                    },
                    to: function (t) {
                        var e = new i.Number(this);
                        return "string" == typeof t && (e.unit = t), e
                    },
                    morph: function (t) {
                        return this.destination = new i.Number(t), t.relative && (this.destination.value += this.value), this
                    },
                    at: function (t) {
                        return this.destination ? new i.Number(this.destination).minus(this).times(t).plus(this) : this
                    }
                }
            }), i.Element = i.invent({
                create: function (t) {
                    this._stroke = i.defaults.attrs.stroke, this._event = null, this.dom = {}, (this.node = t) && (this.type = t.nodeName, this.node.instance = this, this._stroke = t.getAttribute("stroke") || this._stroke)
                },
                extend: {
                    x: function (t) {
                        return this.attr("x", t)
                    },
                    y: function (t) {
                        return this.attr("y", t)
                    },
                    cx: function (t) {
                        return null == t ? this.x() + this.width() / 2 : this.x(t - this.width() / 2)
                    },
                    cy: function (t) {
                        return null == t ? this.y() + this.height() / 2 : this.y(t - this.height() / 2)
                    },
                    move: function (t, e) {
                        return this.x(t).y(e)
                    },
                    center: function (t, e) {
                        return this.cx(t).cy(e)
                    },
                    width: function (t) {
                        return this.attr("width", t)
                    },
                    height: function (t) {
                        return this.attr("height", t)
                    },
                    size: function (t, e) {
                        var n = f(this, t, e);
                        return this.width(new i.Number(n.width)).height(new i.Number(n.height))
                    },
                    clone: function (t) {
                        this.writeDataToDom();
                        var e = m(this.node.cloneNode(!0));
                        return t ? t.add(e) : this.after(e), e
                    },
                    remove: function () {
                        return this.parent() && this.parent().removeElement(this), this
                    },
                    replace: function (t) {
                        return this.after(t).remove(), t
                    },
                    addTo: function (t) {
                        return t.put(this)
                    },
                    putIn: function (t) {
                        return t.add(this)
                    },
                    id: function (t) {
                        return this.attr("id", t)
                    },
                    show: function () {
                        return this.style("display", "")
                    },
                    hide: function () {
                        return this.style("display", "none")
                    },
                    visible: function () {
                        return "none" != this.style("display")
                    },
                    toString: function () {
                        return this.attr("id")
                    },
                    classes: function () {
                        var t = this.attr("class");
                        return null == t ? [] : t.trim().split(i.regex.delimiter)
                    },
                    hasClass: function (t) {
                        return -1 != this.classes().indexOf(t)
                    },
                    addClass: function (t) {
                        if (!this.hasClass(t)) {
                            var e = this.classes();
                            e.push(t), this.attr("class", e.join(" "))
                        }
                        return this
                    },
                    removeClass: function (t) {
                        return this.hasClass(t) && this.attr("class", this.classes().filter((function (e) {
                            return e != t
                        })).join(" ")), this
                    },
                    toggleClass: function (t) {
                        return this.hasClass(t) ? this.removeClass(t) : this.addClass(t)
                    },
                    reference: function (t) {
                        return i.get(this.attr(t))
                    },
                    parent: function (e) {
                        var n = this;
                        if (!n.node.parentNode) return null;
                        if (n = i.adopt(n.node.parentNode), !e) return n;
                        for (; n && n.node instanceof t.SVGElement;) {
                            if ("string" == typeof e ? n.matches(e) : n instanceof e) return n;
                            if (!n.node.parentNode || "#document" == n.node.parentNode.nodeName) return null;
                            n = i.adopt(n.node.parentNode)
                        }
                    },
                    doc: function () {
                        return this instanceof i.Doc ? this : this.parent(i.Doc)
                    },
                    parents: function (t) {
                        var e = [],
                            i = this;
                        do {
                            if (!(i = i.parent(t)) || !i.node) break;
                            e.push(i)
                        } while (i.parent);
                        return e
                    },
                    matches: function (t) {
                        return function (t, e) {
                            return (t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector).call(t, e)
                        }(this.node, t)
                    },
                    native: function () {
                        return this.node
                    },
                    svg: function (t) {
                        var n = e.createElement("svg");
                        if (!(t && this instanceof i.Parent)) return n.appendChild(t = e.createElement("svg")), this.writeDataToDom(), t.appendChild(this.node.cloneNode(!0)), n.innerHTML.replace(/^<svg>/, "").replace(/<\/svg>$/, "");
                        n.innerHTML = "<svg>" + t.replace(/\n/, "").replace(/<([\w:-]+)([^<]+?)\/>/g, "<$1$2></$1>") + "</svg>";
                        for (var l = 0, r = n.firstChild.childNodes.length; l < r; l++) this.node.appendChild(n.firstChild.firstChild);
                        return this
                    },
                    writeDataToDom: function () {
                        return (this.each || this.lines) && (this.each ? this : this.lines()).each((function () {
                            this.writeDataToDom()
                        })), this.node.removeAttribute("svgjs:data"), Object.keys(this.dom).length && this.node.setAttribute("svgjs:data", JSON.stringify(this.dom)), this
                    },
                    setData: function (t) {
                        return this.dom = t, this
                    },
                    is: function (t) {
                        return function (t, e) {
                            return t instanceof e
                        }(this, t)
                    }
                }
            }), i.easing = {
                "-": function (t) {
                    return t
                },
                "<>": function (t) {
                    return -Math.cos(t * Math.PI) / 2 + .5
                },
                ">": function (t) {
                    return Math.sin(t * Math.PI / 2)
                },
                "<": function (t) {
                    return 1 - Math.cos(t * Math.PI / 2)
                }
            }, i.morph = function (t) {
                return function (e, n) {
                    return new i.MorphObj(e, n).at(t)
                }
            }, i.Situation = i.invent({
                create: function (t) {
                    this.init = !1, this.reversed = !1, this.reversing = !1, this.duration = new i.Number(t.duration).valueOf(), this.delay = new i.Number(t.delay).valueOf(), this.start = +new Date + this.delay, this.finish = this.start + this.duration, this.ease = t.ease, this.loop = 0, this.loops = !1, this.animations = {}, this.attrs = {}, this.styles = {}, this.transforms = [], this.once = {}
                }
            }), i.FX = i.invent({
                create: function (t) {
                    this._target = t, this.situations = [], this.active = !1, this.situation = null, this.paused = !1, this.lastPos = 0, this.pos = 0, this.absPos = 0, this._speed = 1
                },
                extend: {
                    animate: function (t, e, n) {
                        "object" === l(t) && (e = t.ease, n = t.delay, t = t.duration);
                        var r = new i.Situation({
                            duration: t || 1e3,
                            delay: n || 0,
                            ease: i.easing[e || "-"] || e
                        });
                        return this.queue(r), this
                    },
                    target: function (t) {
                        return t && t instanceof i.Element ? (this._target = t, this) : this._target
                    },
                    timeToAbsPos: function (t) {
                        return (t - this.situation.start) / (this.situation.duration / this._speed)
                    },
                    absPosToTime: function (t) {
                        return this.situation.duration / this._speed * t + this.situation.start
                    },
                    startAnimFrame: function () {
                        this.stopAnimFrame(), this.animationFrame = t.requestAnimationFrame(function () {
                            this.step()
                        }.bind(this))
                    },
                    stopAnimFrame: function () {
                        t.cancelAnimationFrame(this.animationFrame)
                    },
                    start: function () {
                        return !this.active && this.situation && (this.active = !0, this.startCurrent()), this
                    },
                    startCurrent: function () {
                        return this.situation.start = +new Date + this.situation.delay / this._speed, this.situation.finish = this.situation.start + this.situation.duration / this._speed, this.initAnimations().step()
                    },
                    queue: function (t) {
                        return ("function" == typeof t || t instanceof i.Situation) && this.situations.push(t), this.situation || (this.situation = this.situations.shift()), this
                    },
                    dequeue: function () {
                        return this.stop(), this.situation = this.situations.shift(), this.situation && (this.situation instanceof i.Situation ? this.start() : this.situation.call(this)), this
                    },
                    initAnimations: function () {
                        var t, e = this.situation;
                        if (e.init) return this;
                        for (var n in e.animations) {
                            t = this.target()[n](), Array.isArray(t) || (t = [t]), Array.isArray(e.animations[n]) || (e.animations[n] = [e.animations[n]]);
                            for (var l = t.length; l--;) e.animations[n][l] instanceof i.Number && (t[l] = new i.Number(t[l])), e.animations[n][l] = t[l].morph(e.animations[n][l])
                        }
                        for (var n in e.attrs) e.attrs[n] = new i.MorphObj(this.target().attr(n), e.attrs[n]);
                        for (var n in e.styles) e.styles[n] = new i.MorphObj(this.target().style(n), e.styles[n]);
                        return e.initialTransformation = this.target().matrixify(), e.init = !0, this
                    },
                    clearQueue: function () {
                        return this.situations = [], this
                    },
                    clearCurrent: function () {
                        return this.situation = null, this
                    },
                    stop: function (t, e) {
                        var i = this.active;
                        return this.active = !1, e && this.clearQueue(), t && this.situation && (!i && this.startCurrent(), this.atEnd()), this.stopAnimFrame(), this.clearCurrent()
                    },
                    after: function (t) {
                        var e = this.last();
                        return this.target().on("finished.fx", (function i(n) {
                            n.detail.situation == e && (t.call(this, e), this.off("finished.fx", i))
                        })), this._callStart()
                    },
                    during: function (t) {
                        var e = this.last(),
                            n = function (n) {
                                n.detail.situation == e && t.call(this, n.detail.pos, i.morph(n.detail.pos), n.detail.eased, e)
                            };
                        return this.target().off("during.fx", n).on("during.fx", n), this.after((function () {
                            this.off("during.fx", n)
                        })), this._callStart()
                    },
                    afterAll: function (t) {
                        var e = function e(i) {
                            t.call(this), this.off("allfinished.fx", e)
                        };
                        return this.target().off("allfinished.fx", e).on("allfinished.fx", e), this._callStart()
                    },
                    last: function () {
                        return this.situations.length ? this.situations[this.situations.length - 1] : this.situation
                    },
                    add: function (t, e, i) {
                        return this.last()[i || "animations"][t] = e, this._callStart()
                    },
                    step: function (t) {
                        var e, i, n;
                        t || (this.absPos = this.timeToAbsPos(+new Date)), !1 !== this.situation.loops ? (e = Math.max(this.absPos, 0), i = Math.floor(e), !0 === this.situation.loops || i < this.situation.loops ? (this.pos = e - i, n = this.situation.loop, this.situation.loop = i) : (this.absPos = this.situation.loops, this.pos = 1, n = this.situation.loop - 1, this.situation.loop = this.situation.loops), this.situation.reversing && (this.situation.reversed = this.situation.reversed != Boolean((this.situation.loop - n) % 2))) : (this.absPos = Math.min(this.absPos, 1), this.pos = this.absPos), this.pos < 0 && (this.pos = 0), this.situation.reversed && (this.pos = 1 - this.pos);
                        var l = this.situation.ease(this.pos);
                        for (var r in this.situation.once) r > this.lastPos && r <= l && (this.situation.once[r].call(this.target(), this.pos, l), delete this.situation.once[r]);
                        return this.active && this.target().fire("during", {
                            pos: this.pos,
                            eased: l,
                            fx: this,
                            situation: this.situation
                        }), this.situation ? (this.eachAt(), 1 == this.pos && !this.situation.reversed || this.situation.reversed && 0 == this.pos ? (this.stopAnimFrame(), this.target().fire("finished", {
                            fx: this,
                            situation: this.situation
                        }), this.situations.length || (this.target().fire("allfinished"), this.situations.length || (this.target().off(".fx"), this.active = !1)), this.active ? this.dequeue() : this.clearCurrent()) : !this.paused && this.active && this.startAnimFrame(), this.lastPos = l, this) : this
                    },
                    eachAt: function () {
                        var t, e = this,
                            n = this.target(),
                            l = this.situation;
                        for (var r in l.animations) t = [].concat(l.animations[r]).map((function (t) {
                            return "string" != typeof t && t.at ? t.at(l.ease(e.pos), e.pos) : t
                        })), n[r].apply(n, t);
                        for (var r in l.attrs) t = [r].concat(l.attrs[r]).map((function (t) {
                            return "string" != typeof t && t.at ? t.at(l.ease(e.pos), e.pos) : t
                        })), n.attr.apply(n, t);
                        for (var r in l.styles) t = [r].concat(l.styles[r]).map((function (t) {
                            return "string" != typeof t && t.at ? t.at(l.ease(e.pos), e.pos) : t
                        })), n.style.apply(n, t);
                        if (l.transforms.length) {
                            t = l.initialTransformation, r = 0;
                            for (var a = l.transforms.length; r < a; r++) {
                                var o = l.transforms[r];
                                o instanceof i.Matrix ? t = o.relative ? t.multiply((new i.Matrix).morph(o).at(l.ease(this.pos))) : t.morph(o).at(l.ease(this.pos)) : (o.relative || o.undo(t.extract()), t = t.multiply(o.at(l.ease(this.pos))))
                            }
                            n.matrix(t)
                        }
                        return this
                    },
                    once: function (t, e, i) {
                        var n = this.last();
                        return i || (t = n.ease(t)), n.once[t] = e, this
                    },
                    _callStart: function () {
                        return setTimeout(function () {
                            this.start()
                        }.bind(this), 0), this
                    }
                },
                parent: i.Element,
                construct: {
                    animate: function (t, e, n) {
                        return (this.fx || (this.fx = new i.FX(this))).animate(t, e, n)
                    },
                    delay: function (t) {
                        return (this.fx || (this.fx = new i.FX(this))).delay(t)
                    },
                    stop: function (t, e) {
                        return this.fx && this.fx.stop(t, e), this
                    },
                    finish: function () {
                        return this.fx && this.fx.finish(), this
                    }
                }
            }), i.MorphObj = i.invent({
                create: function (t, e) {
                    return i.Color.isColor(e) ? new i.Color(t).morph(e) : i.regex.delimiter.test(t) ? i.regex.pathLetters.test(t) ? new i.PathArray(t).morph(e) : new i.Array(t).morph(e) : i.regex.numberAndUnit.test(e) ? new i.Number(t).morph(e) : (this.value = t, void(this.destination = e))
                },
                extend: {
                    at: function (t, e) {
                        return e < 1 ? this.value : this.destination
                    },
                    valueOf: function () {
                        return this.value
                    }
                }
            }), i.extend(i.FX, {
                attr: function (t, e, i) {
                    if ("object" === l(t))
                        for (var n in t) this.attr(n, t[n]);
                    else this.add(t, e, "attrs");
                    return this
                },
                plot: function (t, e, i, n) {
                    return 4 == arguments.length ? this.plot([t, e, i, n]) : this.add("plot", new(this.target().morphArray)(t))
                }
            }), i.Box = i.invent({
                create: function (t, e, n, r) {
                    if (!("object" !== l(t) || t instanceof i.Element)) return i.Box.call(this, null != t.left ? t.left : t.x, null != t.top ? t.top : t.y, t.width, t.height);
                    4 == arguments.length && (this.x = t, this.y = e, this.width = n, this.height = r), v(this)
                }
            }), i.BBox = i.invent({
                create: function (t) {
                    if (i.Box.apply(this, [].slice.call(arguments)), t instanceof i.Element) {
                        var n;
                        try {
                            if (!e.documentElement.contains) {
                                for (var l = t.node; l.parentNode;) l = l.parentNode;
                                if (l != e) throw new Error("Element not in the dom")
                            }
                            n = t.node.getBBox()
                        } catch (e) {
                            if (t instanceof i.Shape) {
                                i.parser.draw || i.prepare();
                                var r = t.clone(i.parser.draw.instance).show();
                                n = r.node.getBBox(), r.remove()
                            } else n = {
                                x: t.node.clientLeft,
                                y: t.node.clientTop,
                                width: t.node.clientWidth,
                                height: t.node.clientHeight
                            }
                        }
                        i.Box.call(this, n)
                    }
                },
                inherit: i.Box,
                parent: i.Element,
                construct: {
                    bbox: function () {
                        return new i.BBox(this)
                    }
                }
            }), i.BBox.prototype.constructor = i.BBox, i.Matrix = i.invent({
                create: function (t) {
                    var e = g([1, 0, 0, 1, 0, 0]);
                    t = t instanceof i.Element ? t.matrixify() : "string" == typeof t ? g(t.split(i.regex.delimiter).map(parseFloat)) : 6 == arguments.length ? g([].slice.call(arguments)) : Array.isArray(t) ? g(t) : "object" === l(t) ? t : e;
                    for (var n = b.length - 1; n >= 0; --n) this[b[n]] = null != t[b[n]] ? t[b[n]] : e[b[n]]
                },
                extend: {
                    extract: function () {
                        var t = p(this, 0, 1),
                            e = (p(this, 1, 0), 180 / Math.PI * Math.atan2(t.y, t.x) - 90);
                        return {
                            x: this.e,
                            y: this.f,
                            transformedX: (this.e * Math.cos(e * Math.PI / 180) + this.f * Math.sin(e * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b),
                            transformedY: (this.f * Math.cos(e * Math.PI / 180) + this.e * Math.sin(-e * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d),
                            rotation: e,
                            a: this.a,
                            b: this.b,
                            c: this.c,
                            d: this.d,
                            e: this.e,
                            f: this.f,
                            matrix: new i.Matrix(this)
                        }
                    },
                    clone: function () {
                        return new i.Matrix(this)
                    },
                    morph: function (t) {
                        return this.destination = new i.Matrix(t), this
                    },
                    multiply: function (t) {
                        return new i.Matrix(this.native().multiply(function (t) {
                            return t instanceof i.Matrix || (t = new i.Matrix(t)), t
                        }(t).native()))
                    },
                    inverse: function () {
                        return new i.Matrix(this.native().inverse())
                    },
                    translate: function (t, e) {
                        return new i.Matrix(this.native().translate(t || 0, e || 0))
                    },
                    native: function () {
                        for (var t = i.parser.native.createSVGMatrix(), e = b.length - 1; e >= 0; e--) t[b[e]] = this[b[e]];
                        return t
                    },
                    toString: function () {
                        return "matrix(" + y(this.a) + "," + y(this.b) + "," + y(this.c) + "," + y(this.d) + "," + y(this.e) + "," + y(this.f) + ")"
                    }
                },
                parent: i.Element,
                construct: {
                    ctm: function () {
                        return new i.Matrix(this.node.getCTM())
                    },
                    screenCTM: function () {
                        if (this instanceof i.Nested) {
                            var t = this.rect(1, 1),
                                e = t.node.getScreenCTM();
                            return t.remove(), new i.Matrix(e)
                        }
                        return new i.Matrix(this.node.getScreenCTM())
                    }
                }
            }), i.Point = i.invent({
                create: function (t, e) {
                    var i;
                    i = Array.isArray(t) ? {
                        x: t[0],
                        y: t[1]
                    } : "object" === l(t) ? {
                        x: t.x,
                        y: t.y
                    } : null != t ? {
                        x: t,
                        y: null != e ? e : t
                    } : {
                        x: 0,
                        y: 0
                    }, this.x = i.x, this.y = i.y
                },
                extend: {
                    clone: function () {
                        return new i.Point(this)
                    },
                    morph: function (t, e) {
                        return this.destination = new i.Point(t, e), this
                    }
                }
            }), i.extend(i.Element, {
                point: function (t, e) {
                    return new i.Point(t, e).transform(this.screenCTM().inverse())
                }
            }), i.extend(i.Element, {
                attr: function (t, e, n) {
                    if (null == t) {
                        for (t = {}, n = (e = this.node.attributes).length - 1; n >= 0; n--) t[e[n].nodeName] = i.regex.isNumber.test(e[n].nodeValue) ? parseFloat(e[n].nodeValue) : e[n].nodeValue;
                        return t
                    }
                    if ("object" === l(t))
                        for (var r in t) this.attr(r, t[r]);
                    else if (null === e) this.node.removeAttribute(t);
                    else {
                        if (null == e) return null == (e = this.node.getAttribute(t)) ? i.defaults.attrs[t] : i.regex.isNumber.test(e) ? parseFloat(e) : e;
                        "stroke-width" == t ? this.attr("stroke", parseFloat(e) > 0 ? this._stroke : null) : "stroke" == t && (this._stroke = e), "fill" != t && "stroke" != t || (i.regex.isImage.test(e) && (e = this.doc().defs().image(e, 0, 0)), e instanceof i.Image && (e = this.doc().defs().pattern(0, 0, (function () {
                            this.add(e)
                        })))), "number" == typeof e ? e = new i.Number(e) : i.Color.isColor(e) ? e = new i.Color(e) : Array.isArray(e) && (e = new i.Array(e)), "leading" == t ? this.leading && this.leading(e) : "string" == typeof n ? this.node.setAttributeNS(n, t, e.toString()) : this.node.setAttribute(t, e.toString()), !this.rebuild || "font-size" != t && "x" != t || this.rebuild(t, e)
                    }
                    return this
                }
            }), i.extend(i.Element, {
                transform: function (t, e) {
                    var n;
                    return "object" !== l(t) ? (n = new i.Matrix(this).extract(), "string" == typeof t ? n[t] : n) : (n = new i.Matrix(this), e = !!e || !!t.relative, null != t.a && (n = e ? n.multiply(new i.Matrix(t)) : new i.Matrix(t)), this.attr("transform", n))
                }
            }), i.extend(i.Element, {
                untransform: function () {
                    return this.attr("transform", null)
                },
                matrixify: function () {
                    return (this.attr("transform") || "").split(i.regex.transforms).slice(0, -1).map((function (t) {
                        var e = t.trim().split("(");
                        return [e[0], e[1].split(i.regex.delimiter).map((function (t) {
                            return parseFloat(t)
                        }))]
                    })).reduce((function (t, e) {
                        return "matrix" == e[0] ? t.multiply(g(e[1])) : t[e[0]].apply(t, e[1])
                    }), new i.Matrix)
                },
                toParent: function (t) {
                    if (this == t) return this;
                    var e = this.screenCTM(),
                        i = t.screenCTM().inverse();
                    return this.addTo(t).untransform().transform(i.multiply(e)), this
                },
                toDoc: function () {
                    return this.toParent(this.doc())
                }
            }), i.Transformation = i.invent({
                create: function (t, e) {
                    if (arguments.length > 1 && "boolean" != typeof e) return this.constructor.call(this, [].slice.call(arguments));
                    if (Array.isArray(t))
                        for (var i = 0, n = this.arguments.length; i < n; ++i) this[this.arguments[i]] = t[i];
                    else if ("object" === l(t))
                        for (i = 0, n = this.arguments.length; i < n; ++i) this[this.arguments[i]] = t[this.arguments[i]];
                    this.inversed = !1, !0 === e && (this.inversed = !0)
                }
            }), i.Translate = i.invent({
                parent: i.Matrix,
                inherit: i.Transformation,
                create: function (t, e) {
                    this.constructor.apply(this, [].slice.call(arguments))
                },
                extend: {
                    arguments: ["transformedX", "transformedY"],
                    method: "translate"
                }
            }), i.extend(i.Element, {
                style: function (t, e) {
                    if (0 == arguments.length) return this.node.style.cssText || "";
                    if (arguments.length < 2)
                        if ("object" === l(t))
                            for (var n in t) this.style(n, t[n]);
                        else {
                            if (!i.regex.isCss.test(t)) return this.node.style[u(t)];
                            for (t = t.split(/\s*;\s*/).filter((function (t) {
                                    return !!t
                                })).map((function (t) {
                                    return t.split(/\s*:\s*/)
                                })); e = t.pop();) this.style(e[0], e[1])
                        }
                    else this.node.style[u(t)] = null === e || i.regex.isBlank.test(e) ? "" : e;
                    return this
                }
            }), i.Parent = i.invent({
                create: function (t) {
                    this.constructor.call(this, t)
                },
                inherit: i.Element,
                extend: {
                    children: function () {
                        return i.utils.map(i.utils.filterSVGElements(this.node.childNodes), (function (t) {
                            return i.adopt(t)
                        }))
                    },
                    add: function (t, e) {
                        return null == e ? this.node.appendChild(t.node) : t.node != this.node.childNodes[e] && this.node.insertBefore(t.node, this.node.childNodes[e]), this
                    },
                    put: function (t, e) {
                        return this.add(t, e), t
                    },
                    has: function (t) {
                        return this.index(t) >= 0
                    },
                    index: function (t) {
                        return [].slice.call(this.node.childNodes).indexOf(t.node)
                    },
                    get: function (t) {
                        return i.adopt(this.node.childNodes[t])
                    },
                    first: function () {
                        return this.get(0)
                    },
                    last: function () {
                        return this.get(this.node.childNodes.length - 1)
                    },
                    each: function (t, e) {
                        for (var n = this.children(), l = 0, r = n.length; l < r; l++) n[l] instanceof i.Element && t.apply(n[l], [l, n]), e && n[l] instanceof i.Container && n[l].each(t, e);
                        return this
                    },
                    removeElement: function (t) {
                        return this.node.removeChild(t.node), this
                    },
                    clear: function () {
                        for (; this.node.hasChildNodes();) this.node.removeChild(this.node.lastChild);
                        return delete this._defs, this
                    },
                    defs: function () {
                        return this.doc().defs()
                    }
                }
            }), i.extend(i.Parent, {
                ungroup: function (t, e) {
                    return 0 === e || this instanceof i.Defs || this.node == i.parser.draw || (t = t || (this instanceof i.Doc ? this : this.parent(i.Parent)), e = e || 1 / 0, this.each((function () {
                        return this instanceof i.Defs ? this : this instanceof i.Parent ? this.ungroup(t, e - 1) : this.toParent(t)
                    })), this.node.firstChild || this.remove()), this
                },
                flatten: function (t, e) {
                    return this.ungroup(t, e)
                }
            }), i.Container = i.invent({
                create: function (t) {
                    this.constructor.call(this, t)
                },
                inherit: i.Parent
            }), i.ViewBox = i.invent({
                parent: i.Container,
                construct: {}
            }), ["click", "dblclick", "mousedown", "mouseup", "mouseover", "mouseout", "mousemove", "touchstart", "touchmove", "touchleave", "touchend", "touchcancel"].forEach((function (t) {
                i.Element.prototype[t] = function (e) {
                    return i.on(this.node, t, e), this
                }
            })), i.listeners = [], i.handlerMap = [], i.listenerId = 0, i.on = function (t, e, n, l, r) {
                var a = n.bind(l || t.instance || t),
                    o = (i.handlerMap.indexOf(t) + 1 || i.handlerMap.push(t)) - 1,
                    s = e.split(".")[0],
                    c = e.split(".")[1] || "*";
                i.listeners[o] = i.listeners[o] || {}, i.listeners[o][s] = i.listeners[o][s] || {}, i.listeners[o][s][c] = i.listeners[o][s][c] || {}, n._svgjsListenerId || (n._svgjsListenerId = ++i.listenerId), i.listeners[o][s][c][n._svgjsListenerId] = a, t.addEventListener(s, a, r || {
                    passive: !0
                })
            }, i.off = function (t, e, n) {
                var l = i.handlerMap.indexOf(t),
                    r = e && e.split(".")[0],
                    a = e && e.split(".")[1],
                    o = "";
                if (-1 != l)
                    if (n) {
                        if ("function" == typeof n && (n = n._svgjsListenerId), !n) return;
                        i.listeners[l][r] && i.listeners[l][r][a || "*"] && (t.removeEventListener(r, i.listeners[l][r][a || "*"][n], !1), delete i.listeners[l][r][a || "*"][n])
                    } else if (a && r) {
                    if (i.listeners[l][r] && i.listeners[l][r][a]) {
                        for (var s in i.listeners[l][r][a]) i.off(t, [r, a].join("."), s);
                        delete i.listeners[l][r][a]
                    }
                } else if (a)
                    for (var c in i.listeners[l])
                        for (var o in i.listeners[l][c]) a === o && i.off(t, [c, a].join("."));
                else if (r) {
                    if (i.listeners[l][r]) {
                        for (var o in i.listeners[l][r]) i.off(t, [r, o].join("."));
                        delete i.listeners[l][r]
                    }
                } else {
                    for (var c in i.listeners[l]) i.off(t, c);
                    delete i.listeners[l], delete i.handlerMap[l]
                }
            }, i.extend(i.Element, {
                on: function (t, e, n, l) {
                    return i.on(this.node, t, e, n, l), this
                },
                off: function (t, e) {
                    return i.off(this.node, t, e), this
                },
                fire: function (e, n) {
                    return e instanceof t.Event ? this.node.dispatchEvent(e) : this.node.dispatchEvent(e = new i.CustomEvent(e, {
                        detail: n,
                        cancelable: !0
                    })), this._event = e, this
                },
                event: function () {
                    return this._event
                }
            }), i.Defs = i.invent({
                create: "defs",
                inherit: i.Container
            }), i.G = i.invent({
                create: "g",
                inherit: i.Container,
                extend: {
                    x: function (t) {
                        return null == t ? this.transform("x") : this.transform({
                            x: t - this.x()
                        }, !0)
                    }
                },
                construct: {
                    group: function () {
                        return this.put(new i.G)
                    }
                }
            }), i.Doc = i.invent({
                create: function (t) {
                    t && ("svg" == (t = "string" == typeof t ? e.getElementById(t) : t).nodeName ? this.constructor.call(this, t) : (this.constructor.call(this, i.create("svg")), t.appendChild(this.node), this.size("100%", "100%")), this.namespace().defs())
                },
                inherit: i.Container,
                extend: {
                    namespace: function () {
                        return this.attr({
                            xmlns: i.ns,
                            version: "1.1"
                        }).attr("xmlns:xlink", i.xlink, i.xmlns).attr("xmlns:svgjs", i.svgjs, i.xmlns)
                    },
                    defs: function () {
                        var t;
                        return this._defs || ((t = this.node.getElementsByTagName("defs")[0]) ? this._defs = i.adopt(t) : this._defs = new i.Defs, this.node.appendChild(this._defs.node)), this._defs
                    },
                    parent: function () {
                        return this.node.parentNode && "#document" != this.node.parentNode.nodeName ? this.node.parentNode : null
                    },
                    remove: function () {
                        return this.parent() && this.parent().removeChild(this.node), this
                    },
                    clear: function () {
                        for (; this.node.hasChildNodes();) this.node.removeChild(this.node.lastChild);
                        return delete this._defs, i.parser.draw && !i.parser.draw.parentNode && this.node.appendChild(i.parser.draw), this
                    },
                    clone: function (t) {
                        this.writeDataToDom();
                        var e = this.node,
                            i = m(e.cloneNode(!0));
                        return t ? (t.node || t).appendChild(i.node) : e.parentNode.insertBefore(i.node, e.nextSibling), i
                    }
                }
            }), i.extend(i.Element, {}), i.Gradient = i.invent({
                create: function (t) {
                    this.constructor.call(this, i.create(t + "Gradient")), this.type = t
                },
                inherit: i.Container,
                extend: {
                    at: function (t, e, n) {
                        return this.put(new i.Stop).update(t, e, n)
                    },
                    update: function (t) {
                        return this.clear(), "function" == typeof t && t.call(this, this), this
                    },
                    fill: function () {
                        return "url(#" + this.id() + ")"
                    },
                    toString: function () {
                        return this.fill()
                    },
                    attr: function (t, e, n) {
                        return "transform" == t && (t = "gradientTransform"), i.Container.prototype.attr.call(this, t, e, n)
                    }
                },
                construct: {
                    gradient: function (t, e) {
                        return this.defs().gradient(t, e)
                    }
                }
            }), i.extend(i.Gradient, i.FX, {
                from: function (t, e) {
                    return "radial" == (this._target || this).type ? this.attr({
                        fx: new i.Number(t),
                        fy: new i.Number(e)
                    }) : this.attr({
                        x1: new i.Number(t),
                        y1: new i.Number(e)
                    })
                },
                to: function (t, e) {
                    return "radial" == (this._target || this).type ? this.attr({
                        cx: new i.Number(t),
                        cy: new i.Number(e)
                    }) : this.attr({
                        x2: new i.Number(t),
                        y2: new i.Number(e)
                    })
                }
            }), i.extend(i.Defs, {
                gradient: function (t, e) {
                    return this.put(new i.Gradient(t)).update(e)
                }
            }), i.Stop = i.invent({
                create: "stop",
                inherit: i.Element,
                extend: {
                    update: function (t) {
                        return ("number" == typeof t || t instanceof i.Number) && (t = {
                            offset: arguments[0],
                            color: arguments[1],
                            opacity: arguments[2]
                        }), null != t.opacity && this.attr("stop-opacity", t.opacity), null != t.color && this.attr("stop-color", t.color), null != t.offset && this.attr("offset", new i.Number(t.offset)), this
                    }
                }
            }), i.Pattern = i.invent({
                create: "pattern",
                inherit: i.Container,
                extend: {
                    fill: function () {
                        return "url(#" + this.id() + ")"
                    },
                    update: function (t) {
                        return this.clear(), "function" == typeof t && t.call(this, this), this
                    },
                    toString: function () {
                        return this.fill()
                    },
                    attr: function (t, e, n) {
                        return "transform" == t && (t = "patternTransform"), i.Container.prototype.attr.call(this, t, e, n)
                    }
                },
                construct: {
                    pattern: function (t, e, i) {
                        return this.defs().pattern(t, e, i)
                    }
                }
            }), i.extend(i.Defs, {
                pattern: function (t, e, n) {
                    return this.put(new i.Pattern).update(n).attr({
                        x: 0,
                        y: 0,
                        width: t,
                        height: e,
                        patternUnits: "userSpaceOnUse"
                    })
                }
            }), i.Shape = i.invent({
                create: function (t) {
                    this.constructor.call(this, t)
                },
                inherit: i.Element
            }), i.Symbol = i.invent({
                create: "symbol",
                inherit: i.Container,
                construct: {
                    symbol: function () {
                        return this.put(new i.Symbol)
                    }
                }
            }), i.Use = i.invent({
                create: "use",
                inherit: i.Shape,
                extend: {
                    element: function (t, e) {
                        return this.attr("href", (e || "") + "#" + t, i.xlink)
                    }
                },
                construct: {
                    use: function (t, e) {
                        return this.put(new i.Use).element(t, e)
                    }
                }
            }), i.Rect = i.invent({
                create: "rect",
                inherit: i.Shape,
                construct: {
                    rect: function (t, e) {
                        return this.put(new i.Rect).size(t, e)
                    }
                }
            }), i.Circle = i.invent({
                create: "circle",
                inherit: i.Shape,
                construct: {
                    circle: function (t) {
                        return this.put(new i.Circle).rx(new i.Number(t).divide(2)).move(0, 0)
                    }
                }
            }), i.extend(i.Circle, i.FX, {
                rx: function (t) {
                    return this.attr("r", t)
                },
                ry: function (t) {
                    return this.rx(t)
                }
            }), i.Ellipse = i.invent({
                create: "ellipse",
                inherit: i.Shape,
                construct: {
                    ellipse: function (t, e) {
                        return this.put(new i.Ellipse).size(t, e).move(0, 0)
                    }
                }
            }), i.extend(i.Ellipse, i.Rect, i.FX, {
                rx: function (t) {
                    return this.attr("rx", t)
                },
                ry: function (t) {
                    return this.attr("ry", t)
                }
            }), i.extend(i.Circle, i.Ellipse, {
                x: function (t) {
                    return null == t ? this.cx() - this.rx() : this.cx(t + this.rx())
                },
                y: function (t) {
                    return null == t ? this.cy() - this.ry() : this.cy(t + this.ry())
                },
                cx: function (t) {
                    return null == t ? this.attr("cx") : this.attr("cx", t)
                },
                cy: function (t) {
                    return null == t ? this.attr("cy") : this.attr("cy", t)
                },
                width: function (t) {
                    return null == t ? 2 * this.rx() : this.rx(new i.Number(t).divide(2))
                },
                height: function (t) {
                    return null == t ? 2 * this.ry() : this.ry(new i.Number(t).divide(2))
                },
                size: function (t, e) {
                    var n = f(this, t, e);
                    return this.rx(new i.Number(n.width).divide(2)).ry(new i.Number(n.height).divide(2))
                }
            }), i.Line = i.invent({
                create: "line",
                inherit: i.Shape,
                extend: {
                    array: function () {
                        return new i.PointArray([
                            [this.attr("x1"), this.attr("y1")],
                            [this.attr("x2"), this.attr("y2")]
                        ])
                    },
                    plot: function (t, e, n, l) {
                        return null == t ? this.array() : (t = void 0 !== e ? {
                            x1: t,
                            y1: e,
                            x2: n,
                            y2: l
                        } : new i.PointArray(t).toLine(), this.attr(t))
                    },
                    move: function (t, e) {
                        return this.attr(this.array().move(t, e).toLine())
                    },
                    size: function (t, e) {
                        var i = f(this, t, e);
                        return this.attr(this.array().size(i.width, i.height).toLine())
                    }
                },
                construct: {
                    line: function (t, e, n, l) {
                        return i.Line.prototype.plot.apply(this.put(new i.Line), null != t ? [t, e, n, l] : [0, 0, 0, 0])
                    }
                }
            }), i.Polyline = i.invent({
                create: "polyline",
                inherit: i.Shape,
                construct: {
                    polyline: function (t) {
                        return this.put(new i.Polyline).plot(t || new i.PointArray)
                    }
                }
            }), i.Polygon = i.invent({
                create: "polygon",
                inherit: i.Shape,
                construct: {
                    polygon: function (t) {
                        return this.put(new i.Polygon).plot(t || new i.PointArray)
                    }
                }
            }), i.extend(i.Polyline, i.Polygon, {
                array: function () {
                    return this._array || (this._array = new i.PointArray(this.attr("points")))
                },
                plot: function (t) {
                    return null == t ? this.array() : this.clear().attr("points", "string" == typeof t ? t : this._array = new i.PointArray(t))
                },
                clear: function () {
                    return delete this._array, this
                },
                move: function (t, e) {
                    return this.attr("points", this.array().move(t, e))
                },
                size: function (t, e) {
                    var i = f(this, t, e);
                    return this.attr("points", this.array().size(i.width, i.height))
                }
            }), i.extend(i.Line, i.Polyline, i.Polygon, {
                morphArray: i.PointArray,
                x: function (t) {
                    return null == t ? this.bbox().x : this.move(t, this.bbox().y)
                },
                y: function (t) {
                    return null == t ? this.bbox().y : this.move(this.bbox().x, t)
                },
                width: function (t) {
                    var e = this.bbox();
                    return null == t ? e.width : this.size(t, e.height)
                },
                height: function (t) {
                    var e = this.bbox();
                    return null == t ? e.height : this.size(e.width, t)
                }
            }), i.Path = i.invent({
                create: "path",
                inherit: i.Shape,
                extend: {
                    morphArray: i.PathArray,
                    array: function () {
                        return this._array || (this._array = new i.PathArray(this.attr("d")))
                    },
                    plot: function (t) {
                        return null == t ? this.array() : this.clear().attr("d", "string" == typeof t ? t : this._array = new i.PathArray(t))
                    },
                    clear: function () {
                        return delete this._array, this
                    }
                },
                construct: {
                    path: function (t) {
                        return this.put(new i.Path).plot(t || new i.PathArray)
                    }
                }
            }), i.Image = i.invent({
                create: "image",
                inherit: i.Shape,
                extend: {
                    load: function (e) {
                        if (!e) return this;
                        var n = this,
                            l = new t.Image;
                        return i.on(l, "load", (function () {
                            i.off(l);
                            var t = n.parent(i.Pattern);
                            null !== t && (0 == n.width() && 0 == n.height() && n.size(l.width, l.height), t && 0 == t.width() && 0 == t.height() && t.size(n.width(), n.height()), "function" == typeof n._loaded && n._loaded.call(n, {
                                width: l.width,
                                height: l.height,
                                ratio: l.width / l.height,
                                url: e
                            }))
                        })), i.on(l, "error", (function (t) {
                            i.off(l), "function" == typeof n._error && n._error.call(n, t)
                        })), this.attr("href", l.src = this.src = e, i.xlink)
                    },
                    loaded: function (t) {
                        return this._loaded = t, this
                    },
                    error: function (t) {
                        return this._error = t, this
                    }
                },
                construct: {
                    image: function (t, e, n) {
                        return this.put(new i.Image).load(t).size(e || 0, n || e || 0)
                    }
                }
            }), i.Text = i.invent({
                create: function () {
                    this.constructor.call(this, i.create("text")), this.dom.leading = new i.Number(1.3), this._rebuild = !0, this._build = !1, this.attr("font-family", i.defaults.attrs["font-family"])
                },
                inherit: i.Shape,
                extend: {
                    x: function (t) {
                        return null == t ? this.attr("x") : this.attr("x", t)
                    },
                    text: function (t) {
                        if (void 0 === t) {
                            t = "";
                            for (var e = this.node.childNodes, n = 0, l = e.length; n < l; ++n) 0 != n && 3 != e[n].nodeType && 1 == i.adopt(e[n]).dom.newLined && (t += "\n"), t += e[n].textContent;
                            return t
                        }
                        if (this.clear().build(!0), "function" == typeof t) t.call(this, this);
                        else {
                            n = 0;
                            for (var r = (t = t.split("\n")).length; n < r; n++) this.tspan(t[n]).newLine()
                        }
                        return this.build(!1).rebuild()
                    },
                    size: function (t) {
                        return this.attr("font-size", t).rebuild()
                    },
                    leading: function (t) {
                        return null == t ? this.dom.leading : (this.dom.leading = new i.Number(t), this.rebuild())
                    },
                    lines: function () {
                        var t = (this.textPath && this.textPath() || this).node,
                            e = i.utils.map(i.utils.filterSVGElements(t.childNodes), (function (t) {
                                return i.adopt(t)
                            }));
                        return new i.Set(e)
                    },
                    rebuild: function (t) {
                        if ("boolean" == typeof t && (this._rebuild = t), this._rebuild) {
                            var e = this,
                                n = 0,
                                l = this.dom.leading * new i.Number(this.attr("font-size"));
                            this.lines().each((function () {
                                this.dom.newLined && (e.textPath() || this.attr("x", e.attr("x")), "\n" == this.text() ? n += l : (this.attr("dy", l + n), n = 0))
                            })), this.fire("rebuild")
                        }
                        return this
                    },
                    build: function (t) {
                        return this._build = !!t, this
                    },
                    setData: function (t) {
                        return this.dom = t, this.dom.leading = new i.Number(t.leading || 1.3), this
                    }
                },
                construct: {
                    text: function (t) {
                        return this.put(new i.Text).text(t)
                    },
                    plain: function (t) {
                        return this.put(new i.Text).plain(t)
                    }
                }
            }), i.Tspan = i.invent({
                create: "tspan",
                inherit: i.Shape,
                extend: {
                    text: function (t) {
                        return null == t ? this.node.textContent + (this.dom.newLined ? "\n" : "") : ("function" == typeof t ? t.call(this, this) : this.plain(t), this)
                    },
                    dx: function (t) {
                        return this.attr("dx", t)
                    },
                    dy: function (t) {
                        return this.attr("dy", t)
                    },
                    newLine: function () {
                        var t = this.parent(i.Text);
                        return this.dom.newLined = !0, this.dy(t.dom.leading * t.attr("font-size")).attr("x", t.x())
                    }
                }
            }), i.extend(i.Text, i.Tspan, {
                plain: function (t) {
                    return !1 === this._build && this.clear(), this.node.appendChild(e.createTextNode(t)), this
                },
                tspan: function (t) {
                    var e = (this.textPath && this.textPath() || this).node,
                        n = new i.Tspan;
                    return !1 === this._build && this.clear(), e.appendChild(n.node), n.text(t)
                },
                clear: function () {
                    for (var t = (this.textPath && this.textPath() || this).node; t.hasChildNodes();) t.removeChild(t.lastChild);
                    return this
                },
                length: function () {
                    return this.node.getComputedTextLength()
                }
            }), i.TextPath = i.invent({
                create: "textPath",
                inherit: i.Parent,
                parent: i.Text,
                construct: {
                    morphArray: i.PathArray,
                    array: function () {
                        var t = this.track();
                        return t ? t.array() : null
                    },
                    plot: function (t) {
                        var e = this.track(),
                            i = null;
                        return e && (i = e.plot(t)), null == t ? i : this
                    },
                    track: function () {
                        var t = this.textPath();
                        if (t) return t.reference("href")
                    },
                    textPath: function () {
                        if (this.node.firstChild && "textPath" == this.node.firstChild.nodeName) return i.adopt(this.node.firstChild)
                    }
                }
            }), i.Nested = i.invent({
                create: function () {
                    this.constructor.call(this, i.create("svg")), this.style("overflow", "visible")
                },
                inherit: i.Container,
                construct: {
                    nested: function () {
                        return this.put(new i.Nested)
                    }
                }
            });
            var s = {
                stroke: ["color", "width", "opacity", "linecap", "linejoin", "miterlimit", "dasharray", "dashoffset"],
                fill: ["color", "opacity", "rule"],
                prefix: function (t, e) {
                    return "color" == e ? t : t + "-" + e
                }
            };

            function c(t, e, n, l) {
                return n + l.replace(i.regex.dots, " .")
            }

            function u(t) {
                return t.toLowerCase().replace(/-(.)/g, (function (t, e) {
                    return e.toUpperCase()
                }))
            }

            function h(t) {
                return t.charAt(0).toUpperCase() + t.slice(1)
            }

            function d(t) {
                var e = t.toString(16);
                return 1 == e.length ? "0" + e : e
            }

            function f(t, e, i) {
                if (null == e || null == i) {
                    var n = t.bbox();
                    null == e ? e = n.width / n.height * i : null == i && (i = n.height / n.width * e)
                }
                return {
                    width: e,
                    height: i
                }
            }

            function p(t, e, i) {
                return {
                    x: e * t.a + i * t.c + 0,
                    y: e * t.b + i * t.d + 0
                }
            }

            function g(t) {
                return {
                    a: t[0],
                    b: t[1],
                    c: t[2],
                    d: t[3],
                    e: t[4],
                    f: t[5]
                }
            }

            function m(e) {
                for (var n = e.childNodes.length - 1; n >= 0; n--) e.childNodes[n] instanceof t.SVGElement && m(e.childNodes[n]);
                return i.adopt(e).id(i.eid(e.nodeName))
            }

            function v(t) {
                return null == t.x && (t.x = 0, t.y = 0, t.width = 0, t.height = 0), t.w = t.width, t.h = t.height, t.x2 = t.x + t.width, t.y2 = t.y + t.height, t.cx = t.x + t.width / 2, t.cy = t.y + t.height / 2, t
            }

            function y(t) {
                return Math.abs(t) > 1e-37 ? t : 0
            } ["fill", "stroke"].forEach((function (t) {
                var e = {};
                e[t] = function (e) {
                    if (void 0 === e) return this;
                    if ("string" == typeof e || i.Color.isRgb(e) || e && "function" == typeof e.fill) this.attr(t, e);
                    else
                        for (var n = s[t].length - 1; n >= 0; n--) null != e[s[t][n]] && this.attr(s.prefix(t, s[t][n]), e[s[t][n]]);
                    return this
                }, i.extend(i.Element, i.FX, e)
            })), i.extend(i.Element, i.FX, {
                translate: function (t, e) {
                    return this.transform({
                        x: t,
                        y: e
                    })
                },
                matrix: function (t) {
                    return this.attr("transform", new i.Matrix(6 == arguments.length ? [].slice.call(arguments) : t))
                },
                opacity: function (t) {
                    return this.attr("opacity", t)
                },
                dx: function (t) {
                    return this.x(new i.Number(t).plus(this instanceof i.FX ? 0 : this.x()), !0)
                },
                dy: function (t) {
                    return this.y(new i.Number(t).plus(this instanceof i.FX ? 0 : this.y()), !0)
                }
            }), i.extend(i.Path, {
                length: function () {
                    return this.node.getTotalLength()
                },
                pointAt: function (t) {
                    return this.node.getPointAtLength(t)
                }
            }), i.Set = i.invent({
                create: function (t) {
                    Array.isArray(t) ? this.members = t : this.clear()
                },
                extend: {
                    add: function () {
                        for (var t = [].slice.call(arguments), e = 0, i = t.length; e < i; e++) this.members.push(t[e]);
                        return this
                    },
                    remove: function (t) {
                        var e = this.index(t);
                        return e > -1 && this.members.splice(e, 1), this
                    },
                    each: function (t) {
                        for (var e = 0, i = this.members.length; e < i; e++) t.apply(this.members[e], [e, this.members]);
                        return this
                    },
                    clear: function () {
                        return this.members = [], this
                    },
                    length: function () {
                        return this.members.length
                    },
                    has: function (t) {
                        return this.index(t) >= 0
                    },
                    index: function (t) {
                        return this.members.indexOf(t)
                    },
                    get: function (t) {
                        return this.members[t]
                    },
                    first: function () {
                        return this.get(0)
                    },
                    last: function () {
                        return this.get(this.members.length - 1)
                    },
                    valueOf: function () {
                        return this.members
                    }
                },
                construct: {
                    set: function (t) {
                        return new i.Set(t)
                    }
                }
            }), i.FX.Set = i.invent({
                create: function (t) {
                    this.set = t
                }
            }), i.Set.inherit = function () {
                var t = [];
                for (var e in i.Shape.prototype) "function" == typeof i.Shape.prototype[e] && "function" != typeof i.Set.prototype[e] && t.push(e);
                for (var e in t.forEach((function (t) {
                        i.Set.prototype[t] = function () {
                            for (var e = 0, n = this.members.length; e < n; e++) this.members[e] && "function" == typeof this.members[e][t] && this.members[e][t].apply(this.members[e], arguments);
                            return "animate" == t ? this.fx || (this.fx = new i.FX.Set(this)) : this
                        }
                    })), t = [], i.FX.prototype) "function" == typeof i.FX.prototype[e] && "function" != typeof i.FX.Set.prototype[e] && t.push(e);
                t.forEach((function (t) {
                    i.FX.Set.prototype[t] = function () {
                        for (var e = 0, i = this.set.members.length; e < i; e++) this.set.members[e].fx[t].apply(this.set.members[e].fx, arguments);
                        return this
                    }
                }))
            }, i.extend(i.Element, {}), i.extend(i.Element, {
                remember: function (t, e) {
                    if ("object" === l(arguments[0]))
                        for (var i in t) this.remember(i, t[i]);
                    else {
                        if (1 == arguments.length) return this.memory()[t];
                        this.memory()[t] = e
                    }
                    return this
                },
                forget: function () {
                    if (0 == arguments.length) this._memory = {};
                    else
                        for (var t = arguments.length - 1; t >= 0; t--) delete this.memory()[arguments[t]];
                    return this
                },
                memory: function () {
                    return this._memory || (this._memory = {})
                }
            }), i.get = function (t) {
                var n = e.getElementById(function (t) {
                    var e = (t || "").toString().match(i.regex.reference);
                    if (e) return e[1]
                }(t) || t);
                return i.adopt(n)
            }, i.select = function (t, n) {
                return new i.Set(i.utils.map((n || e).querySelectorAll(t), (function (t) {
                    return i.adopt(t)
                })))
            }, i.extend(i.Parent, {
                select: function (t) {
                    return i.select(t, this.node)
                }
            });
            var b = "abcdef".split("");
            if ("function" != typeof t.CustomEvent) {
                var x = function (t, i) {
                    i = i || {
                        bubbles: !1,
                        cancelable: !1,
                        detail: void 0
                    };
                    var n = e.createEvent("CustomEvent");
                    return n.initCustomEvent(t, i.bubbles, i.cancelable, i.detail), n
                };
                x.prototype = t.Event.prototype, i.CustomEvent = x
            } else i.CustomEvent = t.CustomEvent;
            return i
        }, void 0 !== (n = function () {
            return Dt(Lt, Lt.document)
        }.call(e, i, e, t)) && (t.exports = n),
        function () {
            SVG.Filter = SVG.invent({
                create: "filter",
                inherit: SVG.Parent,
                extend: {
                    source: "SourceGraphic",
                    sourceAlpha: "SourceAlpha",
                    background: "BackgroundImage",
                    backgroundAlpha: "BackgroundAlpha",
                    fill: "FillPaint",
                    stroke: "StrokePaint",
                    autoSetIn: !0,
                    put: function (t, e) {
                        return this.add(t, e), !t.attr("in") && this.autoSetIn && t.attr("in", this.source), t.attr("result") || t.attr("result", t), t
                    },
                    blend: function (t, e, i) {
                        return this.put(new SVG.BlendEffect(t, e, i))
                    },
                    colorMatrix: function (t, e) {
                        return this.put(new SVG.ColorMatrixEffect(t, e))
                    },
                    convolveMatrix: function (t) {
                        return this.put(new SVG.ConvolveMatrixEffect(t))
                    },
                    componentTransfer: function (t) {
                        return this.put(new SVG.ComponentTransferEffect(t))
                    },
                    composite: function (t, e, i) {
                        return this.put(new SVG.CompositeEffect(t, e, i))
                    },
                    flood: function (t, e) {
                        return this.put(new SVG.FloodEffect(t, e))
                    },
                    offset: function (t, e) {
                        return this.put(new SVG.OffsetEffect(t, e))
                    },
                    image: function (t) {
                        return this.put(new SVG.ImageEffect(t))
                    },
                    merge: function () {
                        var t = [void 0];
                        for (var e in arguments) t.push(arguments[e]);
                        return this.put(new(SVG.MergeEffect.bind.apply(SVG.MergeEffect, t)))
                    },
                    gaussianBlur: function (t, e) {
                        return this.put(new SVG.GaussianBlurEffect(t, e))
                    },
                    morphology: function (t, e) {
                        return this.put(new SVG.MorphologyEffect(t, e))
                    },
                    diffuseLighting: function (t, e, i) {
                        return this.put(new SVG.DiffuseLightingEffect(t, e, i))
                    },
                    displacementMap: function (t, e, i, n, l) {
                        return this.put(new SVG.DisplacementMapEffect(t, e, i, n, l))
                    },
                    specularLighting: function (t, e, i, n) {
                        return this.put(new SVG.SpecularLightingEffect(t, e, i, n))
                    },
                    tile: function () {
                        return this.put(new SVG.TileEffect)
                    },
                    turbulence: function (t, e, i, n, l) {
                        return this.put(new SVG.TurbulenceEffect(t, e, i, n, l))
                    },
                    toString: function () {
                        return "url(#" + this.attr("id") + ")"
                    }
                }
            }), SVG.extend(SVG.Defs, {
                filter: function (t) {
                    var e = this.put(new SVG.Filter);
                    return "function" == typeof t && t.call(e, e), e
                }
            }), SVG.extend(SVG.Container, {
                filter: function (t) {
                    return this.defs().filter(t)
                }
            }), SVG.extend(SVG.Element, SVG.G, SVG.Nested, {
                filter: function (t) {
                    return this.filterer = t instanceof SVG.Element ? t : this.doc().filter(t), this.doc() && this.filterer.doc() !== this.doc() && this.doc().defs().add(this.filterer), this.attr("filter", this.filterer), this.filterer
                },
                unfilter: function (t) {
                    return this.filterer && !0 === t && this.filterer.remove(), delete this.filterer, this.attr("filter", null)
                }
            }), SVG.Effect = SVG.invent({
                create: function () {
                    this.constructor.call(this)
                },
                inherit: SVG.Element,
                extend: {
                    in: function (t) {
                        return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t)
                    },
                    result: function (t) {
                        return null == t ? this.attr("result") : this.attr("result", t)
                    },
                    toString: function () {
                        return this.result()
                    }
                }
            }), SVG.ParentEffect = SVG.invent({
                create: function () {
                    this.constructor.call(this)
                },
                inherit: SVG.Parent,
                extend: {
                    in: function (t) {
                        return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t)
                    },
                    result: function (t) {
                        return null == t ? this.attr("result") : this.attr("result", t)
                    },
                    toString: function () {
                        return this.result()
                    }
                }
            });
            var t = {
                blend: function (t, e) {
                    return this.parent() && this.parent().blend(this, t, e)
                },
                colorMatrix: function (t, e) {
                    return this.parent() && this.parent().colorMatrix(t, e).in(this)
                },
                convolveMatrix: function (t) {
                    return this.parent() && this.parent().convolveMatrix(t).in(this)
                },
                componentTransfer: function (t) {
                    return this.parent() && this.parent().componentTransfer(t).in(this)
                },
                composite: function (t, e) {
                    return this.parent() && this.parent().composite(this, t, e)
                },
                flood: function (t, e) {
                    return this.parent() && this.parent().flood(t, e)
                },
                offset: function (t, e) {
                    return this.parent() && this.parent().offset(t, e).in(this)
                },
                image: function (t) {
                    return this.parent() && this.parent().image(t)
                },
                merge: function () {
                    return this.parent() && this.parent().merge.apply(this.parent(), [this].concat(arguments))
                },
                gaussianBlur: function (t, e) {
                    return this.parent() && this.parent().gaussianBlur(t, e).in(this)
                },
                morphology: function (t, e) {
                    return this.parent() && this.parent().morphology(t, e).in(this)
                },
                diffuseLighting: function (t, e, i) {
                    return this.parent() && this.parent().diffuseLighting(t, e, i).in(this)
                },
                displacementMap: function (t, e, i, n) {
                    return this.parent() && this.parent().displacementMap(this, t, e, i, n)
                },
                specularLighting: function (t, e, i, n) {
                    return this.parent() && this.parent().specularLighting(t, e, i, n).in(this)
                },
                tile: function () {
                    return this.parent() && this.parent().tile().in(this)
                },
                turbulence: function (t, e, i, n, l) {
                    return this.parent() && this.parent().turbulence(t, e, i, n, l).in(this)
                }
            };
            SVG.extend(SVG.Effect, t), SVG.extend(SVG.ParentEffect, t), SVG.ChildEffect = SVG.invent({
                create: function () {
                    this.constructor.call(this)
                },
                inherit: SVG.Element,
                extend: {
                    in: function (t) {
                        this.attr("in", t)
                    }
                }
            });
            var e = {
                    blend: function (t, e, i) {
                        this.attr({
                            in: t,
                            in2: e,
                            mode: i || "normal"
                        })
                    },
                    colorMatrix: function (t, e) {
                        "matrix" == t && (e = l(e)), this.attr({
                            type: t,
                            values: void 0 === e ? null : e
                        })
                    },
                    convolveMatrix: function (t) {
                        t = l(t), this.attr({
                            order: Math.sqrt(t.split(" ").length),
                            kernelMatrix: t
                        })
                    },
                    composite: function (t, e, i) {
                        this.attr({
                            in: t,
                            in2: e,
                            operator: i
                        })
                    },
                    flood: function (t, e) {
                        this.attr("flood-color", t), null != e && this.attr("flood-opacity", e)
                    },
                    offset: function (t, e) {
                        this.attr({
                            dx: t,
                            dy: e
                        })
                    },
                    image: function (t) {
                        this.attr("href", t, SVG.xlink)
                    },
                    displacementMap: function (t, e, i, n, l) {
                        this.attr({
                            in: t,
                            in2: e,
                            scale: i,
                            xChannelSelector: n,
                            yChannelSelector: l
                        })
                    },
                    gaussianBlur: function (t, e) {
                        null != t || null != e ? this.attr("stdDeviation", r(Array.prototype.slice.call(arguments))) : this.attr("stdDeviation", "0 0")
                    },
                    morphology: function (t, e) {
                        this.attr({
                            operator: t,
                            radius: e
                        })
                    },
                    tile: function () {},
                    turbulence: function (t, e, i, n, l) {
                        this.attr({
                            numOctaves: e,
                            seed: i,
                            stitchTiles: n,
                            baseFrequency: t,
                            type: l
                        })
                    }
                },
                i = {
                    merge: function () {
                        var t;
                        if (arguments[0] instanceof SVG.Set) {
                            var e = this;
                            arguments[0].each((function (t) {
                                this instanceof SVG.MergeNode ? e.put(this) : (this instanceof SVG.Effect || this instanceof SVG.ParentEffect) && e.put(new SVG.MergeNode(this))
                            }))
                        } else {
                            t = Array.isArray(arguments[0]) ? arguments[0] : arguments;
                            for (var i = 0; i < t.length; i++) t[i] instanceof SVG.MergeNode ? this.put(t[i]) : this.put(new SVG.MergeNode(t[i]))
                        }
                    },
                    componentTransfer: function (t) {
                        if (this.rgb = new SVG.Set, ["r", "g", "b", "a"].forEach(function (t) {
                                this[t] = new(SVG["Func" + t.toUpperCase()])("identity"), this.rgb.add(this[t]), this.node.appendChild(this[t].node)
                            }.bind(this)), t)
                            for (var e in t.rgb && (["r", "g", "b"].forEach(function (e) {
                                    this[e].attr(t.rgb)
                                }.bind(this)), delete t.rgb), t) this[e].attr(t[e])
                    },
                    diffuseLighting: function (t, e, i) {
                        this.attr({
                            surfaceScale: t,
                            diffuseConstant: e,
                            kernelUnitLength: i
                        })
                    },
                    specularLighting: function (t, e, i, n) {
                        this.attr({
                            surfaceScale: t,
                            diffuseConstant: e,
                            specularExponent: i,
                            kernelUnitLength: n
                        })
                    }
                },
                n = {
                    distantLight: function (t, e) {
                        this.attr({
                            azimuth: t,
                            elevation: e
                        })
                    },
                    pointLight: function (t, e, i) {
                        this.attr({
                            x: t,
                            y: e,
                            z: i
                        })
                    },
                    spotLight: function (t, e, i, n, l, r) {
                        this.attr({
                            x: t,
                            y: e,
                            z: i,
                            pointsAtX: n,
                            pointsAtY: l,
                            pointsAtZ: r
                        })
                    },
                    mergeNode: function (t) {
                        this.attr("in", t)
                    }
                };

            function l(t) {
                return Array.isArray(t) && (t = new SVG.Array(t)), t.toString().replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ")
            }

            function r(t) {
                if (!Array.isArray(t)) return t;
                for (var e = 0, i = t.length, n = []; e < i; e++) n.push(t[e]);
                return n.join(" ")
            }

            function a() {
                var t = function () {};
                for (var e in "function" == typeof arguments[arguments.length - 1] && (t = arguments[arguments.length - 1], Array.prototype.splice.call(arguments, arguments.length - 1, 1)), arguments)
                    for (var i in arguments[e]) t(arguments[e][i], i, arguments[e])
            } ["r", "g", "b", "a"].forEach((function (t) {
                n["Func" + t.toUpperCase()] = function (t) {
                    switch (this.attr("type", t), t) {
                        case "table":
                            this.attr("tableValues", arguments[1]);
                            break;
                        case "linear":
                            this.attr("slope", arguments[1]), this.attr("intercept", arguments[2]);
                            break;
                        case "gamma":
                            this.attr("amplitude", arguments[1]), this.attr("exponent", arguments[2]), this.attr("offset", arguments[2])
                    }
                }
            })), a(e, (function (t, e) {
                var i = e.charAt(0).toUpperCase() + e.slice(1);
                SVG[i + "Effect"] = SVG.invent({
                    create: function () {
                        this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out")
                    },
                    inherit: SVG.Effect,
                    extend: {}
                })
            })), a(i, (function (t, e) {
                var i = e.charAt(0).toUpperCase() + e.slice(1);
                SVG[i + "Effect"] = SVG.invent({
                    create: function () {
                        this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out")
                    },
                    inherit: SVG.ParentEffect,
                    extend: {}
                })
            })), a(n, (function (t, e) {
                var i = e.charAt(0).toUpperCase() + e.slice(1);
                SVG[i] = SVG.invent({
                    create: function () {
                        this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments)
                    },
                    inherit: SVG.ChildEffect,
                    extend: {}
                })
            })), SVG.extend(SVG.MergeEffect, {
                in: function (t) {
                    return t instanceof SVG.MergeNode ? this.add(t, 0) : this.add(new SVG.MergeNode(t), 0), this
                }
            }), SVG.extend(SVG.CompositeEffect, SVG.BlendEffect, SVG.DisplacementMapEffect, {
                in2: function (t) {
                    return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in2") + '"]').get(0) || this.attr("in2") : this.attr("in2", t)
                }
            }), SVG.filter = {
                sepiatone: [.343, .669, .119, 0, 0, .249, .626, .13, 0, 0, .172, .334, .111, 0, 0, 0, 0, 0, 1, 0]
            }
        }.call(void 0),
        function () {
            function t(t, l, r, a, o, s, c) {
                for (var u = t.slice(l, r || c), h = a.slice(o, s || c), d = 0, f = {
                        pos: [0, 0],
                        start: [0, 0]
                    }, p = {
                        pos: [0, 0],
                        start: [0, 0]
                    }; u[d] = e.call(f, u[d]), h[d] = e.call(p, h[d]), u[d][0] != h[d][0] || "M" == u[d][0] || "A" == u[d][0] && (u[d][4] != h[d][4] || u[d][5] != h[d][5]) ? (Array.prototype.splice.apply(u, [d, 1].concat(n.call(f, u[d]))), Array.prototype.splice.apply(h, [d, 1].concat(n.call(p, h[d])))) : (u[d] = i.call(f, u[d]), h[d] = i.call(p, h[d])), ++d != u.length || d != h.length;) d == u.length && u.push(["C", f.pos[0], f.pos[1], f.pos[0], f.pos[1], f.pos[0], f.pos[1]]), d == h.length && h.push(["C", p.pos[0], p.pos[1], p.pos[0], p.pos[1], p.pos[0], p.pos[1]]);
                return {
                    start: u,
                    dest: h
                }
            }

            function e(t) {
                switch (t[0]) {
                    case "z":
                    case "Z":
                        t[0] = "L", t[1] = this.start[0], t[2] = this.start[1];
                        break;
                    case "H":
                        t[0] = "L", t[2] = this.pos[1];
                        break;
                    case "V":
                        t[0] = "L", t[2] = t[1], t[1] = this.pos[0];
                        break;
                    case "T":
                        t[0] = "Q", t[3] = t[1], t[4] = t[2], t[1] = this.reflection[1], t[2] = this.reflection[0];
                        break;
                    case "S":
                        t[0] = "C", t[6] = t[4], t[5] = t[3], t[4] = t[2], t[3] = t[1], t[2] = this.reflection[1], t[1] = this.reflection[0]
                }
                return t
            }

            function i(t) {
                var e = t.length;
                return this.pos = [t[e - 2], t[e - 1]], -1 != "SCQT".indexOf(t[0]) && (this.reflection = [2 * this.pos[0] - t[e - 4], 2 * this.pos[1] - t[e - 3]]), t
            }

            function n(t) {
                var e = [t];
                switch (t[0]) {
                    case "M":
                        return this.pos = this.start = [t[1], t[2]], e;
                    case "L":
                        t[5] = t[3] = t[1], t[6] = t[4] = t[2], t[1] = this.pos[0], t[2] = this.pos[1];
                        break;
                    case "Q":
                        t[6] = t[4], t[5] = t[3], t[4] = 1 * t[4] / 3 + 2 * t[2] / 3, t[3] = 1 * t[3] / 3 + 2 * t[1] / 3, t[2] = 1 * this.pos[1] / 3 + 2 * t[2] / 3, t[1] = 1 * this.pos[0] / 3 + 2 * t[1] / 3;
                        break;
                    case "A":
                        t = (e = function (t, e) {
                            var i, n, l, r, a, o, s, c, u, h, d, f, p, g, m, v, y, b, x, w, _, k, S, A, M, C, E = Math.abs(e[1]),
                                O = Math.abs(e[2]),
                                T = e[3] % 360,
                                P = e[4],
                                L = e[5],
                                D = e[6],
                                I = e[7],
                                j = new SVG.Point(t),
                                N = new SVG.Point(D, I),
                                R = [];
                            if (0 === E || 0 === O || j.x === N.x && j.y === N.y) return [
                                ["C", j.x, j.y, N.x, N.y, N.x, N.y]
                            ];
                            for ((n = (i = new SVG.Point((j.x - N.x) / 2, (j.y - N.y) / 2).transform((new SVG.Matrix).rotate(T))).x * i.x / (E * E) + i.y * i.y / (O * O)) > 1 && (E *= n = Math.sqrt(n), O *= n), l = (new SVG.Matrix).rotate(T).scale(1 / E, 1 / O).rotate(-T), j = j.transform(l), o = (r = [(N = N.transform(l)).x - j.x, N.y - j.y])[0] * r[0] + r[1] * r[1], a = Math.sqrt(o), r[0] /= a, r[1] /= a, s = o < 4 ? Math.sqrt(1 - o / 4) : 0, P === L && (s *= -1), c = new SVG.Point((N.x + j.x) / 2 + s * -r[1], (N.y + j.y) / 2 + s * r[0]), u = new SVG.Point(j.x - c.x, j.y - c.y), h = new SVG.Point(N.x - c.x, N.y - c.y), d = Math.acos(u.x / Math.sqrt(u.x * u.x + u.y * u.y)), u.y < 0 && (d *= -1), f = Math.acos(h.x / Math.sqrt(h.x * h.x + h.y * h.y)), h.y < 0 && (f *= -1), L && d > f && (f += 2 * Math.PI), !L && d < f && (f -= 2 * Math.PI), v = [], y = d, p = (f - d) / (g = Math.ceil(2 * Math.abs(d - f) / Math.PI)), m = 4 * Math.tan(p / 4) / 3, _ = 0; _ <= g; _++) x = Math.cos(y), b = Math.sin(y), w = new SVG.Point(c.x + x, c.y + b), v[_] = [new SVG.Point(w.x + m * b, w.y - m * x), w, new SVG.Point(w.x - m * b, w.y + m * x)], y += p;
                            for (v[0][0] = v[0][1].clone(), v[v.length - 1][2] = v[v.length - 1][1].clone(), l = (new SVG.Matrix).rotate(T).scale(E, O).rotate(-T), _ = 0, k = v.length; _ < k; _++) v[_][0] = v[_][0].transform(l), v[_][1] = v[_][1].transform(l), v[_][2] = v[_][2].transform(l);
                            for (_ = 1, k = v.length; _ < k; _++) S = (w = v[_ - 1][2]).x, A = w.y, M = (w = v[_][0]).x, C = w.y, D = (w = v[_][1]).x, I = w.y, R.push(["C", S, A, M, C, D, I]);
                            return R
                        }(this.pos, t))[0]
                }
                return t[0] = "C", this.pos = [t[5], t[6]], this.reflection = [2 * t[5] - t[3], 2 * t[6] - t[4]], e
            }

            function l(t, e) {
                if (!1 === e) return !1;
                for (var i = e, n = t.length; i < n; ++i)
                    if ("M" == t[i][0]) return i;
                return !1
            }
            SVG.extend(SVG.PathArray, {
                morph: function (e) {
                    for (var i = this.value, n = this.parse(e), r = 0, a = 0, o = !1, s = !1; !1 !== r || !1 !== a;) {
                        var c;
                        o = l(i, !1 !== r && r + 1), s = l(n, !1 !== a && a + 1), !1 === r && (r = 0 == (c = new SVG.PathArray(u.start).bbox()).height || 0 == c.width ? i.push(i[0]) - 1 : i.push(["M", c.x + c.width / 2, c.y + c.height / 2]) - 1), !1 === a && (a = 0 == (c = new SVG.PathArray(u.dest).bbox()).height || 0 == c.width ? n.push(n[0]) - 1 : n.push(["M", c.x + c.width / 2, c.y + c.height / 2]) - 1);
                        var u = t(i, r, o, n, a, s);
                        i = i.slice(0, r).concat(u.start, !1 === o ? [] : i.slice(o)), n = n.slice(0, a).concat(u.dest, !1 === s ? [] : n.slice(s)), r = !1 !== o && r + u.start.length, a = !1 !== s && a + u.dest.length
                    }
                    return this.value = i, this.destination = new SVG.PathArray, this.destination.value = n, this
                }
            })
        }(),
        function () {
            function t(t) {
                t.remember("_draggable", this), this.el = t
            }
            t.prototype.init = function (t, e) {
                var i = this;
                this.constraint = t, this.value = e, this.el.on("mousedown.drag", (function (t) {
                    i.start(t)
                })), this.el.on("touchstart.drag", (function (t) {
                    i.start(t)
                }))
            }, t.prototype.transformPoint = function (t, e) {
                var i = (t = t || window.event).changedTouches && t.changedTouches[0] || t;
                return this.p.x = i.clientX - (e || 0), this.p.y = i.clientY, this.p.matrixTransform(this.m)
            }, t.prototype.getBBox = function () {
                var t = this.el.bbox();
                return this.el instanceof SVG.Nested && (t = this.el.rbox()), (this.el instanceof SVG.G || this.el instanceof SVG.Use || this.el instanceof SVG.Nested) && (t.x = this.el.x(), t.y = this.el.y()), t
            }, t.prototype.start = function (t) {
                if ("click" != t.type && "mousedown" != t.type && "mousemove" != t.type || 1 == (t.which || t.buttons)) {
                    var e = this;
                    if (this.el.fire("beforedrag", {
                            event: t,
                            handler: this
                        }), !this.el.event().defaultPrevented) {
                        t.preventDefault(), t.stopPropagation(), this.parent = this.parent || this.el.parent(SVG.Nested) || this.el.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = this.el.node.getScreenCTM().inverse();
                        var i, n = this.getBBox();
                        if (this.el instanceof SVG.Text) switch (i = this.el.node.getComputedTextLength(), this.el.attr("text-anchor")) {
                            case "middle":
                                i /= 2;
                                break;
                            case "start":
                                i = 0
                        }
                        this.startPoints = {
                            point: this.transformPoint(t, i),
                            box: n,
                            transform: this.el.transform()
                        }, SVG.on(window, "mousemove.drag", (function (t) {
                            e.drag(t)
                        })), SVG.on(window, "touchmove.drag", (function (t) {
                            e.drag(t)
                        })), SVG.on(window, "mouseup.drag", (function (t) {
                            e.end(t)
                        })), SVG.on(window, "touchend.drag", (function (t) {
                            e.end(t)
                        })), this.el.fire("dragstart", {
                            event: t,
                            p: this.startPoints.point,
                            m: this.m,
                            handler: this
                        })
                    }
                }
            }, t.prototype.drag = function (t) {
                var e = this.getBBox(),
                    i = this.transformPoint(t),
                    n = this.startPoints.box.x + i.x - this.startPoints.point.x,
                    l = this.startPoints.box.y + i.y - this.startPoints.point.y,
                    r = this.constraint,
                    a = i.x - this.startPoints.point.x,
                    o = i.y - this.startPoints.point.y;
                if (this.el.fire("dragmove", {
                        event: t,
                        p: i,
                        m: this.m,
                        handler: this
                    }), this.el.event().defaultPrevented) return i;
                if ("function" == typeof r) {
                    var s = r.call(this.el, n, l, this.m);
                    "boolean" == typeof s && (s = {
                        x: s,
                        y: s
                    }), !0 === s.x ? this.el.x(n) : !1 !== s.x && this.el.x(s.x), !0 === s.y ? this.el.y(l) : !1 !== s.y && this.el.y(s.y)
                } else "object" == typeof r && (null != r.minX && n < r.minX ? a = (n = r.minX) - this.startPoints.box.x : null != r.maxX && n > r.maxX - e.width && (a = (n = r.maxX - e.width) - this.startPoints.box.x), null != r.minY && l < r.minY ? o = (l = r.minY) - this.startPoints.box.y : null != r.maxY && l > r.maxY - e.height && (o = (l = r.maxY - e.height) - this.startPoints.box.y), null != r.snapToGrid && (n -= n % r.snapToGrid, l -= l % r.snapToGrid, a -= a % r.snapToGrid, o -= o % r.snapToGrid), this.el instanceof SVG.G ? this.el.matrix(this.startPoints.transform).transform({
                    x: a,
                    y: o
                }, !0) : this.el.move(n, l));
                return i
            }, t.prototype.end = function (t) {
                var e = this.drag(t);
                this.el.fire("dragend", {
                    event: t,
                    p: e,
                    m: this.m,
                    handler: this
                }), SVG.off(window, "mousemove.drag"), SVG.off(window, "touchmove.drag"), SVG.off(window, "mouseup.drag"), SVG.off(window, "touchend.drag")
            }, SVG.extend(SVG.Element, {
                draggable: function (e, i) {
                    "function" != typeof e && "object" != typeof e || (i = e, e = !0);
                    var n = this.remember("_draggable") || new t(this);
                    return (e = void 0 === e || e) ? n.init(i || {}, e) : (this.off("mousedown.drag"), this.off("touchstart.drag")), this
                }
            })
        }.call(void 0),
        function () {
            function t(t) {
                this.el = t, t.remember("_selectHandler", this), this.pointSelection = {
                    isSelected: !1
                }, this.rectSelection = {
                    isSelected: !1
                }, this.pointsList = {
                    lt: [0, 0],
                    rt: ["width", 0],
                    rb: ["width", "height"],
                    lb: [0, "height"],
                    t: ["width", 0],
                    r: ["width", "height"],
                    b: ["width", "height"],
                    l: [0, "height"]
                }, this.pointCoord = function (t, e, i) {
                    var n = "string" != typeof t ? t : e[t];
                    return i ? n / 2 : n
                }, this.pointCoords = function (t, e) {
                    var i = this.pointsList[t];
                    return {
                        x: this.pointCoord(i[0], e, "t" === t || "b" === t),
                        y: this.pointCoord(i[1], e, "r" === t || "l" === t)
                    }
                }
            }
            t.prototype.init = function (t, e) {
                var i = this.el.bbox();
                this.options = {};
                var n = this.el.selectize.defaults.points;
                for (var l in this.el.selectize.defaults) this.options[l] = this.el.selectize.defaults[l], void 0 !== e[l] && (this.options[l] = e[l]);
                var r = ["points", "pointsExclude"];
                for (var l in r) {
                    var a = this.options[r[l]];
                    "string" == typeof a ? a = a.length > 0 ? a.split(/\s*,\s*/i) : [] : "boolean" == typeof a && "points" === r[l] && (a = a ? n : []), this.options[r[l]] = a
                }
                this.options.points = [n, this.options.points].reduce((function (t, e) {
                    return t.filter((function (t) {
                        return e.indexOf(t) > -1
                    }))
                })), this.options.points = [this.options.points, this.options.pointsExclude].reduce((function (t, e) {
                    return t.filter((function (t) {
                        return e.indexOf(t) < 0
                    }))
                })), this.parent = this.el.parent(), this.nested = this.nested || this.parent.group(), this.nested.matrix(new SVG.Matrix(this.el).translate(i.x, i.y)), this.options.deepSelect && -1 !== ["line", "polyline", "polygon"].indexOf(this.el.type) ? this.selectPoints(t) : this.selectRect(t), this.observe(), this.cleanup()
            }, t.prototype.selectPoints = function (t) {
                return this.pointSelection.isSelected = t, this.pointSelection.set || (this.pointSelection.set = this.parent.set(), this.drawPoints()), this
            }, t.prototype.getPointArray = function () {
                var t = this.el.bbox();
                return this.el.array().valueOf().map((function (e) {
                    return [e[0] - t.x, e[1] - t.y]
                }))
            }, t.prototype.drawPoints = function () {
                for (var t = this, e = this.getPointArray(), i = 0, n = e.length; i < n; ++i) {
                    var l = function (e) {
                            return function (i) {
                                (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                                var n = i.pageX || i.touches[0].pageX,
                                    l = i.pageY || i.touches[0].pageY;
                                t.el.fire("point", {
                                    x: n,
                                    y: l,
                                    i: e,
                                    event: i
                                })
                            }
                        }(i),
                        r = this.drawPoint(e[i][0], e[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints + "_point").on("touchstart", l).on("mousedown", l);
                    this.pointSelection.set.add(r)
                }
            }, t.prototype.drawPoint = function (t, e) {
                var i = this.options.pointType;
                switch (i) {
                    case "circle":
                        return this.drawCircle(t, e);
                    case "rect":
                        return this.drawRect(t, e);
                    default:
                        if ("function" == typeof i) return i.call(this, t, e);
                        throw new Error("Unknown " + i + " point type!")
                }
            }, t.prototype.drawCircle = function (t, e) {
                return this.nested.circle(this.options.pointSize).center(t, e)
            }, t.prototype.drawRect = function (t, e) {
                return this.nested.rect(this.options.pointSize, this.options.pointSize).center(t, e)
            }, t.prototype.updatePointSelection = function () {
                var t = this.getPointArray();
                this.pointSelection.set.each((function (e) {
                    this.cx() === t[e][0] && this.cy() === t[e][1] || this.center(t[e][0], t[e][1])
                }))
            }, t.prototype.updateRectSelection = function () {
                var t = this,
                    e = this.el.bbox();
                if (this.rectSelection.set.get(0).attr({
                        width: e.width,
                        height: e.height
                    }), this.options.points.length && this.options.points.map((function (i, n) {
                        var l = t.pointCoords(i, e);
                        t.rectSelection.set.get(n + 1).center(l.x, l.y)
                    })), this.options.rotationPoint) {
                    var i = this.rectSelection.set.length();
                    this.rectSelection.set.get(i - 1).center(e.width / 2, 20)
                }
            }, t.prototype.selectRect = function (t) {
                var e = this,
                    i = this.el.bbox();

                function n(t) {
                    return function (i) {
                        (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                        var n = i.pageX || i.touches[0].pageX,
                            l = i.pageY || i.touches[0].pageY;
                        e.el.fire(t, {
                            x: n,
                            y: l,
                            event: i
                        })
                    }
                }
                if (this.rectSelection.isSelected = t, this.rectSelection.set = this.rectSelection.set || this.parent.set(), this.rectSelection.set.get(0) || this.rectSelection.set.add(this.nested.rect(i.width, i.height).addClass(this.options.classRect)), this.options.points.length && this.rectSelection.set.length() < 2 && (this.options.points.map((function (t, l) {
                        var r = e.pointCoords(t, i),
                            a = e.drawPoint(r.x, r.y).attr("class", e.options.classPoints + "_" + t).on("mousedown", n(t)).on("touchstart", n(t));
                        e.rectSelection.set.add(a)
                    })), this.rectSelection.set.each((function () {
                        this.addClass(e.options.classPoints)
                    }))), this.options.rotationPoint && (this.options.points && !this.rectSelection.set.get(9) || !this.options.points && !this.rectSelection.set.get(1))) {
                    var l = function (t) {
                            (t = t || window.event).preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation();
                            var i = t.pageX || t.touches[0].pageX,
                                n = t.pageY || t.touches[0].pageY;
                            e.el.fire("rot", {
                                x: i,
                                y: n,
                                event: t
                            })
                        },
                        r = this.drawPoint(i.width / 2, 20).attr("class", this.options.classPoints + "_rot").on("touchstart", l).on("mousedown", l);
                    this.rectSelection.set.add(r)
                }
            }, t.prototype.handler = function () {
                var t = this.el.bbox();
                this.nested.matrix(new SVG.Matrix(this.el).translate(t.x, t.y)), this.rectSelection.isSelected && this.updateRectSelection(), this.pointSelection.isSelected && this.updatePointSelection()
            }, t.prototype.observe = function () {
                var t = this;
                if (MutationObserver)
                    if (this.rectSelection.isSelected || this.pointSelection.isSelected) this.observerInst = this.observerInst || new MutationObserver((function () {
                        t.handler()
                    })), this.observerInst.observe(this.el.node, {
                        attributes: !0
                    });
                    else try {
                        this.observerInst.disconnect(), delete this.observerInst
                    } catch (t) {} else this.el.off("DOMAttrModified.select"), (this.rectSelection.isSelected || this.pointSelection.isSelected) && this.el.on("DOMAttrModified.select", (function () {
                        t.handler()
                    }))
            }, t.prototype.cleanup = function () {
                !this.rectSelection.isSelected && this.rectSelection.set && (this.rectSelection.set.each((function () {
                    this.remove()
                })), this.rectSelection.set.clear(), delete this.rectSelection.set), !this.pointSelection.isSelected && this.pointSelection.set && (this.pointSelection.set.each((function () {
                    this.remove()
                })), this.pointSelection.set.clear(), delete this.pointSelection.set), this.pointSelection.isSelected || this.rectSelection.isSelected || (this.nested.remove(), delete this.nested)
            }, SVG.extend(SVG.Element, {
                selectize: function (e, i) {
                    return "object" == typeof e && (i = e, e = !0), (this.remember("_selectHandler") || new t(this)).init(void 0 === e || e, i || {}), this
                }
            }), SVG.Element.prototype.selectize.defaults = {
                points: ["lt", "rt", "rb", "lb", "t", "r", "b", "l"],
                pointsExclude: [],
                classRect: "svg_select_boundingRect",
                classPoints: "svg_select_points",
                pointSize: 7,
                rotationPoint: !0,
                deepSelect: !1,
                pointType: "circle"
            }
        }(),
        function () {
            (function () {
                function t(t) {
                    t.remember("_resizeHandler", this), this.el = t, this.parameters = {}, this.lastUpdateCall = null, this.p = t.doc().node.createSVGPoint()
                }
                t.prototype.transformPoint = function (t, e, i) {
                    return this.p.x = t - (this.offset.x - window.pageXOffset), this.p.y = e - (this.offset.y - window.pageYOffset), this.p.matrixTransform(i || this.m)
                }, t.prototype._extractPosition = function (t) {
                    return {
                        x: null != t.clientX ? t.clientX : t.touches[0].clientX,
                        y: null != t.clientY ? t.clientY : t.touches[0].clientY
                    }
                }, t.prototype.init = function (t) {
                    var e = this;
                    if (this.stop(), "stop" !== t) {
                        for (var i in this.options = {}, this.el.resize.defaults) this.options[i] = this.el.resize.defaults[i], void 0 !== t[i] && (this.options[i] = t[i]);
                        this.el.on("lt.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.el.on("rt.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.el.on("rb.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.el.on("lb.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.el.on("t.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.el.on("r.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.el.on("b.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.el.on("l.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.el.on("rot.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.el.on("point.resize", (function (t) {
                            e.resize(t || window.event)
                        })), this.update()
                    }
                }, t.prototype.stop = function () {
                    return this.el.off("lt.resize"), this.el.off("rt.resize"), this.el.off("rb.resize"), this.el.off("lb.resize"), this.el.off("t.resize"), this.el.off("r.resize"), this.el.off("b.resize"), this.el.off("l.resize"), this.el.off("rot.resize"), this.el.off("point.resize"), this
                }, t.prototype.resize = function (t) {
                    var e = this;
                    this.m = this.el.node.getScreenCTM().inverse(), this.offset = {
                        x: window.pageXOffset,
                        y: window.pageYOffset
                    };
                    var i = this._extractPosition(t.detail.event);
                    if (this.parameters = {
                            type: this.el.type,
                            p: this.transformPoint(i.x, i.y),
                            x: t.detail.x,
                            y: t.detail.y,
                            box: this.el.bbox(),
                            rotation: this.el.transform().rotation
                        }, "text" === this.el.type && (this.parameters.fontSize = this.el.attr()["font-size"]), void 0 !== t.detail.i) {
                        var n = this.el.array().valueOf();
                        this.parameters.i = t.detail.i, this.parameters.pointCoords = [n[t.detail.i][0], n[t.detail.i][1]]
                    }
                    switch (t.type) {
                        case "lt":
                            this.calc = function (t, e) {
                                var i = this.snapToGrid(t, e);
                                if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                                    if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                                    i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y + i[1]).size(this.parameters.box.width - i[0], this.parameters.box.height - i[1])
                                }
                            };
                            break;
                        case "rt":
                            this.calc = function (t, e) {
                                var i = this.snapToGrid(t, e, 2);
                                if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                                    if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                                    i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).size(this.parameters.box.width + i[0], this.parameters.box.height - i[1])
                                }
                            };
                            break;
                        case "rb":
                            this.calc = function (t, e) {
                                var i = this.snapToGrid(t, e, 0);
                                if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                                    if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                                    i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x, this.parameters.box.y).size(this.parameters.box.width + i[0], this.parameters.box.height + i[1])
                                }
                            };
                            break;
                        case "lb":
                            this.calc = function (t, e) {
                                var i = this.snapToGrid(t, e, 1);
                                if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                                    if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                                    i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).size(this.parameters.box.width - i[0], this.parameters.box.height + i[1])
                                }
                            };
                            break;
                        case "t":
                            this.calc = function (t, e) {
                                var i = this.snapToGrid(t, e, 2);
                                if (this.parameters.box.height - i[1] > 0) {
                                    if ("text" === this.parameters.type) return;
                                    this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).height(this.parameters.box.height - i[1])
                                }
                            };
                            break;
                        case "r":
                            this.calc = function (t, e) {
                                var i = this.snapToGrid(t, e, 0);
                                if (this.parameters.box.width + i[0] > 0) {
                                    if ("text" === this.parameters.type) return;
                                    this.el.move(this.parameters.box.x, this.parameters.box.y).width(this.parameters.box.width + i[0])
                                }
                            };
                            break;
                        case "b":
                            this.calc = function (t, e) {
                                var i = this.snapToGrid(t, e, 0);
                                if (this.parameters.box.height + i[1] > 0) {
                                    if ("text" === this.parameters.type) return;
                                    this.el.move(this.parameters.box.x, this.parameters.box.y).height(this.parameters.box.height + i[1])
                                }
                            };
                            break;
                        case "l":
                            this.calc = function (t, e) {
                                var i = this.snapToGrid(t, e, 1);
                                if (this.parameters.box.width - i[0] > 0) {
                                    if ("text" === this.parameters.type) return;
                                    this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).width(this.parameters.box.width - i[0])
                                }
                            };
                            break;
                        case "rot":
                            this.calc = function (t, e) {
                                var i = t + this.parameters.p.x,
                                    n = e + this.parameters.p.y,
                                    l = Math.atan2(this.parameters.p.y - this.parameters.box.y - this.parameters.box.height / 2, this.parameters.p.x - this.parameters.box.x - this.parameters.box.width / 2),
                                    r = Math.atan2(n - this.parameters.box.y - this.parameters.box.height / 2, i - this.parameters.box.x - this.parameters.box.width / 2),
                                    a = this.parameters.rotation + 180 * (r - l) / Math.PI + this.options.snapToAngle / 2;
                                this.el.center(this.parameters.box.cx, this.parameters.box.cy).rotate(a - a % this.options.snapToAngle, this.parameters.box.cx, this.parameters.box.cy)
                            };
                            break;
                        case "point":
                            this.calc = function (t, e) {
                                var i = this.snapToGrid(t, e, this.parameters.pointCoords[0], this.parameters.pointCoords[1]),
                                    n = this.el.array().valueOf();
                                n[this.parameters.i][0] = this.parameters.pointCoords[0] + i[0], n[this.parameters.i][1] = this.parameters.pointCoords[1] + i[1], this.el.plot(n)
                            }
                    }
                    this.el.fire("resizestart", {
                        dx: this.parameters.x,
                        dy: this.parameters.y,
                        event: t
                    }), SVG.on(window, "touchmove.resize", (function (t) {
                        e.update(t || window.event)
                    })), SVG.on(window, "touchend.resize", (function () {
                        e.done()
                    })), SVG.on(window, "mousemove.resize", (function (t) {
                        e.update(t || window.event)
                    })), SVG.on(window, "mouseup.resize", (function () {
                        e.done()
                    }))
                }, t.prototype.update = function (t) {
                    if (t) {
                        var e = this._extractPosition(t),
                            i = this.transformPoint(e.x, e.y),
                            n = i.x - this.parameters.p.x,
                            l = i.y - this.parameters.p.y;
                        this.lastUpdateCall = [n, l], this.calc(n, l), this.el.fire("resizing", {
                            dx: n,
                            dy: l,
                            event: t
                        })
                    } else this.lastUpdateCall && this.calc(this.lastUpdateCall[0], this.lastUpdateCall[1])
                }, t.prototype.done = function () {
                    this.lastUpdateCall = null, SVG.off(window, "mousemove.resize"), SVG.off(window, "mouseup.resize"), SVG.off(window, "touchmove.resize"), SVG.off(window, "touchend.resize"), this.el.fire("resizedone")
                }, t.prototype.snapToGrid = function (t, e, i, n) {
                    var l;
                    return void 0 !== n ? l = [(i + t) % this.options.snapToGrid, (n + e) % this.options.snapToGrid] : (i = null == i ? 3 : i, l = [(this.parameters.box.x + t + (1 & i ? 0 : this.parameters.box.width)) % this.options.snapToGrid, (this.parameters.box.y + e + (2 & i ? 0 : this.parameters.box.height)) % this.options.snapToGrid]), t < 0 && (l[0] -= this.options.snapToGrid), e < 0 && (l[1] -= this.options.snapToGrid), t -= Math.abs(l[0]) < this.options.snapToGrid / 2 ? l[0] : l[0] - (t < 0 ? -this.options.snapToGrid : this.options.snapToGrid), e -= Math.abs(l[1]) < this.options.snapToGrid / 2 ? l[1] : l[1] - (e < 0 ? -this.options.snapToGrid : this.options.snapToGrid), this.constraintToBox(t, e, i, n)
                }, t.prototype.constraintToBox = function (t, e, i, n) {
                    var l, r, a = this.options.constraint || {};
                    return void 0 !== n ? (l = i, r = n) : (l = this.parameters.box.x + (1 & i ? 0 : this.parameters.box.width), r = this.parameters.box.y + (2 & i ? 0 : this.parameters.box.height)), void 0 !== a.minX && l + t < a.minX && (t = a.minX - l), void 0 !== a.maxX && l + t > a.maxX && (t = a.maxX - l), void 0 !== a.minY && r + e < a.minY && (e = a.minY - r), void 0 !== a.maxY && r + e > a.maxY && (e = a.maxY - r), [t, e]
                }, t.prototype.checkAspectRatio = function (t, e) {
                    if (!this.options.saveAspectRatio) return t;
                    var i = t.slice(),
                        n = this.parameters.box.width / this.parameters.box.height,
                        l = this.parameters.box.width + t[0],
                        r = this.parameters.box.height - t[1],
                        a = l / r;
                    return a < n ? (i[1] = l / n - this.parameters.box.height, e && (i[1] = -i[1])) : a > n && (i[0] = this.parameters.box.width - r * n, e && (i[0] = -i[0])), i
                }, SVG.extend(SVG.Element, {
                    resize: function (e) {
                        return (this.remember("_resizeHandler") || new t(this)).init(e || {}), this
                    }
                }), SVG.Element.prototype.resize.defaults = {
                    snapToAngle: .1,
                    snapToGrid: 1,
                    constraint: {},
                    saveAspectRatio: !1
                }
            }).call(this)
        }(),
        function (t, e) {
            void 0 === e && (e = {});
            var i = e.insertAt;
            if ("undefined" != typeof document) {
                var n = document.head || document.getElementsByTagName("head")[0],
                    l = document.createElement("style");
                l.type = "text/css", "top" === i && n.firstChild ? n.insertBefore(l, n.firstChild) : n.appendChild(l), l.styleSheet ? l.styleSheet.cssText = t : l.appendChild(document.createTextNode(t))
            }
        }('.apexcharts-canvas {\n  position: relative;\n  user-select: none;\n  /* cannot give overflow: hidden as it will crop tooltips which overflow outside chart area */\n}\n\n\n/* scrollbar is not visible by default for legend, hence forcing the visibility */\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px;\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, .5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n}\n\n\n.apexcharts-inner {\n  position: relative;\n}\n\n.apexcharts-text tspan {\n  font-family: inherit;\n}\n\n.legend-mouseover-inactive {\n  transition: 0.15s ease all;\n  opacity: 0.20;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0;\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255, 255, 255, 0.96);\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30, 30, 30, 0.8);\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit;\n}\n\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px;\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #ECEFF1;\n  border-bottom: 1px solid #ddd;\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0, 0, 0, 0.7);\n  border-bottom: 1px solid #333;\n}\n\n.apexcharts-tooltip-text-value,\n.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  font-weight: 600;\n  margin-left: 5px;\n}\n\n.apexcharts-tooltip-text-z-label:empty,\n.apexcharts-tooltip-text-z-value:empty {\n  display: none;\n}\n\n.apexcharts-tooltip-text-value,\n.apexcharts-tooltip-text-z-value {\n  font-weight: 600;\n}\n\n.apexcharts-tooltip-marker {\n  min-width: 12px;\n  min-height: 12px;\n  position: relative;\n  top: 0px;\n  margin-right: 10px;\n  border-radius: 50%;\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center;\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1;\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,\n.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px;\n}\n\n.apexcharts-tooltip-series-group-hidden {\n  opacity: 0;\n  height: 0;\n  line-height: 0;\n  padding: 0 !important;\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px;\n}\n\n.apexcharts-tooltip-box, .apexcharts-custom-tooltip {\n  padding: 4px 8px;\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0;\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: bold;\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px;\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777;\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: bold;\n  display: block;\n  margin-bottom: 5px;\n}\n\n.apexcharts-xaxistooltip {\n  opacity: 0;\n  padding: 9px 10px;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #ECEFF1;\n  border: 1px solid #90A4AE;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  color: #fff;\n}\n\n.apexcharts-xaxistooltip:after,\n.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: rgba(236, 239, 241, 0);\n  border-width: 6px;\n  margin-left: -6px;\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: rgba(144, 164, 174, 0);\n  border-width: 7px;\n  margin-left: -7px;\n}\n\n.apexcharts-xaxistooltip-bottom:after,\n.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%;\n}\n\n.apexcharts-xaxistooltip-top:after,\n.apexcharts-xaxistooltip-top:before {\n  top: 100%;\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #ECEFF1;\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90A4AE;\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after {\n  border-bottom-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #ECEFF1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90A4AE;\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after {\n  border-top-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-yaxistooltip {\n  opacity: 0;\n  padding: 4px 10px;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #ECEFF1;\n  border: 1px solid #90A4AE;\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  color: #fff;\n}\n\n.apexcharts-yaxistooltip:after,\n.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: rgba(236, 239, 241, 0);\n  border-width: 6px;\n  margin-top: -6px;\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: rgba(144, 164, 174, 0);\n  border-width: 7px;\n  margin-top: -7px;\n}\n\n.apexcharts-yaxistooltip-left:after,\n.apexcharts-yaxistooltip-left:before {\n  left: 100%;\n}\n\n.apexcharts-yaxistooltip-right:after,\n.apexcharts-yaxistooltip-right:before {\n  right: 100%;\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #ECEFF1;\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90A4AE;\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after {\n  border-left-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #ECEFF1;\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90A4AE;\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after {\n  border-right-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1;\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none;\n}\n\n.apexcharts-xcrosshairs,\n.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,\n.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0;\n}\n\n.apexcharts-selection-rect {\n  cursor: move;\n}\n\n.svg_select_boundingRect, .svg_select_points_rot {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n}\n.apexcharts-selection-rect + g .svg_select_boundingRect,\n.apexcharts-selection-rect + g .svg_select_points_rot {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.apexcharts-selection-rect + g .svg_select_points_l,\n.apexcharts-selection-rect + g .svg_select_points_r {\n  cursor: ew-resize;\n  opacity: 1;\n  visibility: visible;\n}\n\n.svg_select_points {\n  fill: #efefef;\n  stroke: #333;\n  rx: 2;\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-zoom-icon,\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon,\n.apexcharts-reset-icon,\n.apexcharts-pan-icon,\n.apexcharts-selection-icon,\n.apexcharts-menu-icon,\n.apexcharts-toolbar-custom-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6E8192;\n  text-align: center;\n}\n\n.apexcharts-zoom-icon svg,\n.apexcharts-zoomin-icon svg,\n.apexcharts-zoomout-icon svg,\n.apexcharts-reset-icon svg,\n.apexcharts-menu-icon svg {\n  fill: #6E8192;\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(0.76)\n}\n\n.apexcharts-theme-dark .apexcharts-zoom-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomin-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomout-icon svg,\n.apexcharts-theme-dark .apexcharts-reset-icon svg,\n.apexcharts-theme-dark .apexcharts-pan-icon svg,\n.apexcharts-theme-dark .apexcharts-selection-icon svg,\n.apexcharts-theme-dark .apexcharts-menu-icon svg,\n.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg {\n  fill: #f3f4f5;\n}\n\n.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg {\n  fill: #008FFB;\n}\n\n.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,\n.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg,\n.apexcharts-theme-light .apexcharts-reset-icon:hover svg,\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg {\n  fill: #333;\n}\n\n.apexcharts-selection-icon,\n.apexcharts-menu-icon {\n  position: relative;\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px;\n}\n\n.apexcharts-zoom-icon,\n.apexcharts-reset-icon,\n.apexcharts-menu-icon {\n  transform: scale(0.85);\n}\n\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n  transform: scale(0.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px;\n}\n\n.apexcharts-pan-icon {\n  transform: scale(0.62);\n  position: relative;\n  left: 1px;\n  top: 0px;\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6E8192;\n  stroke-width: 2;\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008FFB;\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333;\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0px 6px 2px 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: 0.15s ease all;\n  pointer-events: none;\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee;\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n}\n\n@media screen and (min-width: 768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n    opacity: 1;\n  }\n}\n\n.apexcharts-datalabel.apexcharts-element-hidden {\n  opacity: 0;\n}\n\n.apexcharts-pie-label,\n.apexcharts-datalabels,\n.apexcharts-datalabel,\n.apexcharts-datalabel-label,\n.apexcharts-datalabel-value {\n  cursor: default;\n  pointer-events: none;\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: 0.3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease;\n}\n\n.apexcharts-canvas .apexcharts-element-hidden {\n  opacity: 0;\n}\n\n.apexcharts-hide .apexcharts-series-points {\n  opacity: 0;\n}\n\n.apexcharts-gridline,\n.apexcharts-annotation-rect,\n.apexcharts-tooltip .apexcharts-marker,\n.apexcharts-area-series .apexcharts-area,\n.apexcharts-line,\n.apexcharts-zoom-rect,\n.apexcharts-toolbar svg,\n.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-radar-series path,\n.apexcharts-radar-series polygon {\n  pointer-events: none;\n}\n\n\n/* markers */\n\n.apexcharts-marker {\n  transition: 0.15s ease all;\n}\n\n@keyframes opaque {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n\n/* Resize generated styles */\n\n@keyframes resizeanim {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n}\n\n.resize-triggers,\n.resize-triggers>div,\n.contract-trigger:before {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.resize-triggers>div {\n  background: #eee;\n  overflow: auto;\n}\n\n.contract-trigger:before {\n  width: 200%;\n  height: 200%;\n}'),
        function () {
            function t(t) {
                var e = t.__resizeTriggers__,
                    i = e.firstElementChild,
                    n = e.lastElementChild,
                    l = i ? i.firstElementChild : null;
                n && (n.scrollLeft = n.scrollWidth, n.scrollTop = n.scrollHeight), l && (l.style.width = i.offsetWidth + 1 + "px", l.style.height = i.offsetHeight + 1 + "px"), i && (i.scrollLeft = i.scrollWidth, i.scrollTop = i.scrollHeight)
            }

            function e(e) {
                var i = this;
                t(this), this.__resizeRAF__ && r(this.__resizeRAF__), this.__resizeRAF__ = l((function () {
                    (function (t) {
                        return t.offsetWidth != t.__resizeLast__.width || t.offsetHeight != t.__resizeLast__.height
                    })(i) && (i.__resizeLast__.width = i.offsetWidth, i.__resizeLast__.height = i.offsetHeight, i.__resizeListeners__.forEach((function (t) {
                        t.call(e)
                    })))
                }))
            }
            var i, n, l = (i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (t) {
                    return window.setTimeout(t, 20)
                }, function (t) {
                    return i(t)
                }),
                r = (n = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout, function (t) {
                    return n(t)
                }),
                a = !1,
                o = "animationstart",
                s = "Webkit Moz O ms".split(" "),
                c = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "),
                u = document.createElement("fakeelement");
            if (void 0 !== u.style.animationName && (a = !0), !1 === a)
                for (var h = 0; h < s.length; h++)
                    if (void 0 !== u.style[s[h] + "AnimationName"]) {
                        o = c[h];
                        break
                    } window.addResizeListener = function (i, n) {
                i.__resizeTriggers__ || ("static" == getComputedStyle(i).position && (i.style.position = "relative"), i.__resizeLast__ = {}, i.__resizeListeners__ = [], (i.__resizeTriggers__ = document.createElement("div")).className = "resize-triggers", i.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>', i.appendChild(i.__resizeTriggers__), t(i), i.addEventListener("scroll", e, !0), o && i.__resizeTriggers__.addEventListener(o, (function (e) {
                    "resizeanim" == e.animationName && t(i)
                }))), i.__resizeListeners__.push(n)
            }, window.removeResizeListener = function (t, i) {
                t && (t.__resizeListeners__.splice(t.__resizeListeners__.indexOf(i), 1), t.__resizeListeners__.length || (t.removeEventListener("scroll", e), t.__resizeTriggers__.parentNode && (t.__resizeTriggers__ = !t.removeChild(t.__resizeTriggers__))))
            }
        }(), void 0 === window.Apex && (window.Apex = {});
    var Ft = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "initModules",
                value: function () {
                    this.ctx.publicMethods = ["updateOptions", "updateSeries", "appendData", "appendSeries", "toggleSeries", "showSeries", "hideSeries", "setLocale", "resetSeries", "zoomX", "toggleDataPointSelection", "dataURI", "addXaxisAnnotation", "addYaxisAnnotation", "addPointAnnotation", "clearAnnotations", "removeAnnotation", "paper", "destroy"], this.ctx.eventList = ["click", "mousedown", "mousemove", "touchstart", "touchmove", "mouseup", "touchend"], this.ctx.animations = new b(this.ctx), this.ctx.axes = new et(this.ctx), this.ctx.core = new Nt(this.ctx.el, this.ctx), this.ctx.config = new B({}), this.ctx.data = new V(this.ctx), this.ctx.grid = new U(this.ctx), this.ctx.graphics = new w(this.ctx), this.ctx.coreUtils = new S(this.ctx), this.ctx.crosshairs = new it(this.ctx), this.ctx.events = new J(this.ctx), this.ctx.exports = new Z(this.ctx), this.ctx.localization = new tt(this.ctx), this.ctx.options = new E, this.ctx.responsive = new nt(this.ctx), this.ctx.series = new j(this.ctx), this.ctx.theme = new lt(this.ctx), this.ctx.formatters = new X(this.ctx), this.ctx.titleSubtitle = new rt(this.ctx), this.ctx.legend = new dt(this.ctx), this.ctx.toolbar = new ft(this.ctx), this.ctx.dimensions = new ut(this.ctx), this.ctx.updateHelpers = new Rt(this.ctx), this.ctx.zoomPanSelection = new pt(this.ctx), this.ctx.w.globals.tooltip = new wt(this.ctx)
                }
            }]), t
        }(),
        zt = function () {
            function t(e) {
                r(this, t), this.ctx = e, this.w = e.w
            }
            return o(t, [{
                key: "clear",
                value: function (t) {
                    var e = t.isUpdating;
                    this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({
                        isUpdating: e
                    })
                }
            }, {
                key: "killSVG",
                value: function (t) {
                    t.each((function (t, e) {
                        this.removeClass("*"), this.off(), this.stop()
                    }), !0), t.ungroup(), t.clear()
                }
            }, {
                key: "clearDomElements",
                value: function (t) {
                    var e = this,
                        i = t.isUpdating,
                        n = this.w.globals.dom.Paper.node;
                    n.parentNode && n.parentNode.parentNode && !i && (n.parentNode.parentNode.style.minHeight = "unset");
                    var l = this.w.globals.dom.baseEl;
                    l && this.ctx.eventList.forEach((function (t) {
                        l.removeEventListener(t, e.ctx.events.documentEvent)
                    }));
                    var r = this.w.globals.dom;
                    if (null !== this.ctx.el)
                        for (; this.ctx.el.firstChild;) this.ctx.el.removeChild(this.ctx.el.firstChild);
                    this.killSVG(r.Paper), r.Paper.remove(), r.elWrap = null, r.elGraphical = null, r.elAnnotations = null, r.elLegendWrap = null, r.baseEl = null, r.elGridRect = null, r.elGridRectMask = null, r.elGridRectMarkerMask = null, r.elDefs = null
                }
            }]), t
        }(),
        Ht = function () {
            function t(e, i) {
                r(this, t), this.opts = i, this.ctx = this, this.w = new W(i).init(), this.el = e, this.w.globals.cuid = y.randomId(), this.w.globals.chartID = this.w.config.chart.id ? y.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new Ft(this).initModules(), this.create = y.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this)
            }
            return o(t, [{
                key: "render",
                value: function () {
                    var t = this;
                    return new Promise((function (e, i) {
                        if (null !== t.el) {
                            void 0 === Apex._chartInstances && (Apex._chartInstances = []), t.w.config.chart.id && Apex._chartInstances.push({
                                id: t.w.globals.chartID,
                                group: t.w.config.chart.group,
                                chart: t
                            }), t.setLocale(t.w.config.chart.defaultLocale);
                            var n = t.w.config.chart.events.beforeMount;
                            "function" == typeof n && n(t, t.w), t.events.fireEvent("beforeMount", [t, t.w]), window.addEventListener("resize", t.windowResizeHandler), window.addResizeListener(t.el.parentNode, t.parentResizeHandler);
                            var l = t.create(t.w.config.series, {});
                            if (!l) return e(t);
                            t.mount(l).then((function () {
                                "function" == typeof t.w.config.chart.events.mounted && t.w.config.chart.events.mounted(t, t.w), t.events.fireEvent("mounted", [t, t.w]), e(l)
                            })).catch((function (t) {
                                i(t)
                            }))
                        } else i(new Error("Element not found"))
                    }))
                }
            }, {
                key: "create",
                value: function (t, e) {
                    var i = this.w;
                    new Ft(this).initModules();
                    var n = this.w.globals;
                    if (n.noData = !1, n.animationEnded = !1, this.responsive.checkResponsiveConfig(e), i.config.xaxis.convertedCatToNumeric && new H(i.config).convertCatToNumericXaxis(i.config, this.ctx), null === this.el) return n.animationEnded = !0, null;
                    if (this.core.setupElements(), "treemap" === i.config.chart.type && (i.config.grid.show = !1, i.config.yaxis[0].show = !1), 0 === n.svgWidth) return n.animationEnded = !0, null;
                    var l = S.checkComboSeries(t);
                    n.comboCharts = l.comboCharts, n.comboBarCount = l.comboBarCount;
                    var r = t.every((function (t) {
                        return t.data && 0 === t.data.length
                    }));
                    (0 === t.length || r) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(t), this.theme.init(), new P(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), n.noData && n.collapsedSeries.length !== n.series.length && !i.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), n.axisCharts && (this.core.coreCalculations(), "category" !== i.config.xaxis.type && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = i.globals.minX, this.ctx.toolbar.maxX = i.globals.maxX), this.formatters.heatmapLabelFormatters(), this.dimensions.plotCoords();
                    var a = this.core.xySettings();
                    this.grid.createGridMask();
                    var o = this.core.plotChartType(t, a),
                        s = new D(this);
                    s.bringForward(), i.config.dataLabels.background.enabled && s.dataLabelsBackground(), this.core.shiftGraphPosition();
                    var c = {
                        plot: {
                            left: i.globals.translateX,
                            top: i.globals.translateY,
                            width: i.globals.gridWidth,
                            height: i.globals.gridHeight
                        }
                    };
                    return {
                        elGraph: o,
                        xyRatios: a,
                        elInner: i.globals.dom.elGraphical,
                        dimensions: c
                    }
                }
            }, {
                key: "mount",
                value: function () {
                    var t = this,
                        e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                        i = this,
                        n = i.w;
                    return new Promise((function (l, r) {
                        if (null === i.el) return r(new Error("Not enough data to display or target element not found"));
                        (null === e || n.globals.allSeriesCollapsed) && i.series.handleNoData(), "treemap" !== n.config.chart.type && i.axes.drawAxis(n.config.chart.type, e.xyRatios), i.grid = new U(i);
                        var a = i.grid.drawGrid();
                        i.annotations = new O(i), i.annotations.drawImageAnnos(), i.annotations.drawTextAnnos(), "back" === n.config.grid.position && a && n.globals.dom.elGraphical.add(a.el);
                        var o = new G(t.ctx),
                            s = new Q(t.ctx);
                        if (null !== a && (o.xAxisLabelCorrections(a.xAxisTickWidth), s.setYAxisTextAlignments(), n.config.yaxis.map((function (t, e) {
                                -1 === n.globals.ignoreYAxisIndexes.indexOf(e) && s.yAxisTitleRotate(e, t.opposite)
                            }))), "back" === n.config.annotations.position && (n.globals.dom.Paper.add(n.globals.dom.elAnnotations), i.annotations.drawAxesAnnotations()), Array.isArray(e.elGraph))
                            for (var c = 0; c < e.elGraph.length; c++) n.globals.dom.elGraphical.add(e.elGraph[c]);
                        else n.globals.dom.elGraphical.add(e.elGraph);
                        if ("front" === n.config.grid.position && a && n.globals.dom.elGraphical.add(a.el), "front" === n.config.xaxis.crosshairs.position && i.crosshairs.drawXCrosshairs(), "front" === n.config.yaxis[0].crosshairs.position && i.crosshairs.drawYCrosshairs(), "front" === n.config.annotations.position && (n.globals.dom.Paper.add(n.globals.dom.elAnnotations), i.annotations.drawAxesAnnotations()), !n.globals.noData) {
                            if (n.config.tooltip.enabled && !n.globals.noData && i.w.globals.tooltip.drawTooltip(e.xyRatios), n.globals.axisCharts && (n.globals.isXNumeric || n.config.xaxis.convertedCatToNumeric || n.globals.isTimelineBar))(n.config.chart.zoom.enabled || n.config.chart.selection && n.config.chart.selection.enabled || n.config.chart.pan && n.config.chart.pan.enabled) && i.zoomPanSelection.init({
                                xyRatios: e.xyRatios
                            });
                            else {
                                var u = n.config.chart.toolbar.tools;
                                ["zoom", "zoomin", "zoomout", "selection", "pan", "reset"].forEach((function (t) {
                                    u[t] = !1
                                }))
                            }
                            n.config.chart.toolbar.show && !n.globals.allSeriesCollapsed && i.toolbar.createToolbar()
                        }
                        n.globals.memory.methodsToExec.length > 0 && n.globals.memory.methodsToExec.forEach((function (t) {
                            t.method(t.params, !1, t.context)
                        })), n.globals.axisCharts || n.globals.noData || i.core.resizeNonAxisCharts(), l(i)
                    }))
                }
            }, {
                key: "destroy",
                value: function () {
                    window.removeEventListener("resize", this.windowResizeHandler), window.removeResizeListener(this.el.parentNode, this.parentResizeHandler);
                    var t = this.w.config.chart.id;
                    t && Apex._chartInstances.forEach((function (e, i) {
                        e.id === y.escapeString(t) && Apex._chartInstances.splice(i, 1)
                    })), new zt(this.ctx).clear({
                        isUpdating: !1
                    })
                }
            }, {
                key: "updateOptions",
                value: function (t) {
                    var e = this,
                        i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                        n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                        l = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
                        r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
                        a = this.w;
                    return a.globals.selection = void 0, t.series && (this.series.resetSeries(!1, !0, !1), t.series.length && t.series[0].data && (t.series = t.series.map((function (t, i) {
                        return e.updateHelpers._extendSeries(t, i)
                    }))), this.updateHelpers.revertDefaultAxisMinMax()), t.xaxis && (t = this.updateHelpers.forceXAxisUpdate(t)), t.yaxis && (t = this.updateHelpers.forceYAxisUpdate(t)), a.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), t.theme && (t = this.theme.updateThemeOptions(t)), this.updateHelpers._updateOptions(t, i, n, l, r)
                }
            }, {
                key: "updateSeries",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                        e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                        i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                    return this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(t, e, i)
                }
            }, {
                key: "appendSeries",
                value: function (t) {
                    var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                        i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                        n = this.w.config.series.slice();
                    return n.push(t), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(n, e, i)
                }
            }, {
                key: "appendData",
                value: function (t) {
                    var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                        i = this;
                    i.w.globals.dataChanged = !0, i.series.getPreviousPaths();
                    for (var n = i.w.config.series.slice(), l = 0; l < n.length; l++)
                        if (null !== t[l] && void 0 !== t[l])
                            for (var r = 0; r < t[l].data.length; r++) n[l].data.push(t[l].data[r]);
                    return i.w.config.series = n, e && (i.w.globals.initialSeries = y.clone(i.w.config.series)), this.update()
                }
            }, {
                key: "update",
                value: function (t) {
                    var e = this;
                    return new Promise((function (i, n) {
                        new zt(e.ctx).clear({
                            isUpdating: !0
                        });
                        var l = e.create(e.w.config.series, t);
                        if (!l) return i(e);
                        e.mount(l).then((function () {
                            "function" == typeof e.w.config.chart.events.updated && e.w.config.chart.events.updated(e, e.w), e.events.fireEvent("updated", [e, e.w]), e.w.globals.isDirty = !0, i(e)
                        })).catch((function (t) {
                            n(t)
                        }))
                    }))
                }
            }, {
                key: "getSyncedCharts",
                value: function () {
                    var t = this.getGroupedCharts(),
                        e = [this];
                    return t.length && (e = [], t.forEach((function (t) {
                        e.push(t)
                    }))), e
                }
            }, {
                key: "getGroupedCharts",
                value: function () {
                    var t = this;
                    return Apex._chartInstances.filter((function (t) {
                        if (t.group) return !0
                    })).map((function (e) {
                        return t.w.config.chart.group === e.group ? e.chart : t
                    }))
                }
            }, {
                key: "toggleSeries",
                value: function (t) {
                    return this.series.toggleSeries(t)
                }
            }, {
                key: "showSeries",
                value: function (t) {
                    this.series.showSeries(t)
                }
            }, {
                key: "hideSeries",
                value: function (t) {
                    this.series.hideSeries(t)
                }
            }, {
                key: "resetSeries",
                value: function () {
                    var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                        e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    this.series.resetSeries(t, e)
                }
            }, {
                key: "addEventListener",
                value: function (t, e) {
                    this.events.addEventListener(t, e)
                }
            }, {
                key: "removeEventListener",
                value: function (t, e) {
                    this.events.removeEventListener(t, e)
                }
            }, {
                key: "addXaxisAnnotation",
                value: function (t) {
                    var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0,
                        n = this;
                    i && (n = i), n.annotations.addXaxisAnnotationExternal(t, e, n)
                }
            }, {
                key: "addYaxisAnnotation",
                value: function (t) {
                    var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0,
                        n = this;
                    i && (n = i), n.annotations.addYaxisAnnotationExternal(t, e, n)
                }
            }, {
                key: "addPointAnnotation",
                value: function (t) {
                    var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0,
                        n = this;
                    i && (n = i), n.annotations.addPointAnnotationExternal(t, e, n)
                }
            }, {
                key: "clearAnnotations",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
                        e = this;
                    t && (e = t), e.annotations.clearAnnotations(e)
                }
            }, {
                key: "removeAnnotation",
                value: function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
                        i = this;
                    e && (i = e), i.annotations.removeAnnotation(i, t)
                }
            }, {
                key: "getChartArea",
                value: function () {
                    return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner")
                }
            }, {
                key: "getSeriesTotalXRange",
                value: function (t, e) {
                    return this.coreUtils.getSeriesTotalsXRange(t, e)
                }
            }, {
                key: "getHighestValueInSeries",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                        e = new $(this.ctx);
                    return e.getMinYMaxY(t).highestY
                }
            }, {
                key: "getLowestValueInSeries",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                        e = new $(this.ctx);
                    return e.getMinYMaxY(t).lowestY
                }
            }, {
                key: "getSeriesTotal",
                value: function () {
                    return this.w.globals.seriesTotals
                }
            }, {
                key: "toggleDataPointSelection",
                value: function (t, e) {
                    return this.updateHelpers.toggleDataPointSelection(t, e)
                }
            }, {
                key: "zoomX",
                value: function (t, e) {
                    this.ctx.toolbar.zoomUpdateOptions(t, e)
                }
            }, {
                key: "setLocale",
                value: function (t) {
                    this.localization.setCurrentLocaleValues(t)
                }
            }, {
                key: "dataURI",
                value: function () {
                    return new Z(this.ctx).dataURI()
                }
            }, {
                key: "paper",
                value: function () {
                    return this.w.globals.dom.Paper
                }
            }, {
                key: "_parentResizeCallback",
                value: function () {
                    this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize()
                }
            }, {
                key: "_windowResize",
                value: function () {
                    var t = this;
                    clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout((function () {
                        t.w.globals.resized = !0, t.w.globals.dataChanged = !1, t.ctx.update()
                    }), 150)
                }
            }, {
                key: "_windowResizeHandler",
                value: function () {
                    var t = this.w.config.chart.redrawOnWindowResize;
                    "function" == typeof t && (t = t()), t && this._windowResize()
                }
            }], [{
                key: "getChartByID",
                value: function (t) {
                    var e = y.escapeString(t),
                        i = Apex._chartInstances.filter((function (t) {
                            return t.id === e
                        }))[0];
                    return i && i.chart
                }
            }, {
                key: "initOnLoad",
                value: function () {
                    for (var e = document.querySelectorAll("[data-apexcharts]"), i = 0; i < e.length; i++) new t(e[i], JSON.parse(e[i].getAttribute("data-options"))).render()
                }
            }, {
                key: "exec",
                value: function (t, e) {
                    var i = this.getChartByID(t);
                    if (i) {
                        i.w.globals.isExecCalled = !0;
                        var n = null;
                        if (-1 !== i.publicMethods.indexOf(e)) {
                            for (var l = arguments.length, r = new Array(l > 2 ? l - 2 : 0), a = 2; a < l; a++) r[a - 2] = arguments[a];
                            n = i[e].apply(i, r)
                        }
                        return n
                    }
                }
            }, {
                key: "merge",
                value: function (t, e) {
                    return y.extend(t, e)
                }
            }]), t
        }();
    t.exports = Ht
}, function (t, e, i) {
    var n;
    window, n = function () {
        return function (t) {
            var e = {};

            function i(n) {
                if (e[n]) return e[n].exports;
                var l = e[n] = {
                    i: n,
                    l: !1,
                    exports: {}
                };
                return t[n].call(l.exports, l, l.exports, i), l.l = !0, l.exports
            }
            return i.m = t, i.c = e, i.d = function (t, e, n) {
                i.o(t, e) || Object.defineProperty(t, e, {
                    enumerable: !0,
                    get: n
                })
            }, i.r = function (t) {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(t, "__esModule", {
                    value: !0
                })
            }, i.t = function (t, e) {
                if (1 & e && (t = i(t)), 8 & e) return t;
                if (4 & e && "object" == typeof t && t && t.__esModule) return t;
                var n = Object.create(null);
                if (i.r(n), Object.defineProperty(n, "default", {
                        enumerable: !0,
                        value: t
                    }), 2 & e && "string" != typeof t)
                    for (var l in t) i.d(n, l, function (e) {
                        return t[e]
                    }.bind(null, l));
                return n
            }, i.n = function (t) {
                var e = t && t.__esModule ? function () {
                    return t.default
                } : function () {
                    return t
                };
                return i.d(e, "a", e), e
            }, i.o = function (t, e) {
                return Object.prototype.hasOwnProperty.call(t, e)
            }, i.p = "/public/assets/scripts/", i(i.s = 4)
        }([function (t, e, i) {
            "use strict";
            var n = function (t) {
                    return function (t) {
                        return !!t && "object" == typeof t
                    }(t) && ! function (t) {
                        var e = Object.prototype.toString.call(t);
                        return "[object RegExp]" === e || "[object Date]" === e || function (t) {
                            return t.$$typeof === l
                        }(t)
                    }(t)
                },
                l = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;

            function r(t, e) {
                return !1 !== e.clone && e.isMergeableObject(t) ? c((i = t, Array.isArray(i) ? [] : {}), t, e) : t;
                var i
            }

            function a(t, e, i) {
                return t.concat(e).map((function (t) {
                    return r(t, i)
                }))
            }

            function o(t) {
                return Object.keys(t).concat(function (t) {
                    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter((function (e) {
                        return t.propertyIsEnumerable(e)
                    })) : []
                }(t))
            }

            function s(t, e, i) {
                var n = {};
                return i.isMergeableObject(t) && o(t).forEach((function (e) {
                    n[e] = r(t[e], i)
                })), o(e).forEach((function (l) {
                    (function (t, e) {
                        try {
                            return e in t && !(Object.hasOwnProperty.call(t, e) && Object.propertyIsEnumerable.call(t, e))
                        } catch (t) {
                            return !1
                        }
                    })(t, l) || (i.isMergeableObject(e[l]) && t[l] ? n[l] = function (t, e) {
                        if (!e.customMerge) return c;
                        var i = e.customMerge(t);
                        return "function" == typeof i ? i : c
                    }(l, i)(t[l], e[l], i) : n[l] = r(e[l], i))
                })), n
            }

            function c(t, e, i) {
                (i = i || {}).arrayMerge = i.arrayMerge || a, i.isMergeableObject = i.isMergeableObject || n, i.cloneUnlessOtherwiseSpecified = r;
                var l = Array.isArray(e);
                return l === Array.isArray(t) ? l ? i.arrayMerge(t, e, i) : s(t, e, i) : r(e, i)
            }
            c.all = function (t, e) {
                if (!Array.isArray(t)) throw new Error("first argument should be an array");
                return t.reduce((function (t, i) {
                    return c(t, i, e)
                }), {})
            };
            var u = c;
            t.exports = u
        }, function (t, e, i) {
            "use strict";
            (function (t, n) {
                var l, r = i(3);
                l = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== t ? t : n;
                var a = Object(r.a)(l);
                e.a = a
            }).call(this, i(5), i(6)(t))
        }, function (t, e, i) {
            t.exports = function (t) {
                var e = {};

                function i(n) {
                    if (e[n]) return e[n].exports;
                    var l = e[n] = {
                        i: n,
                        l: !1,
                        exports: {}
                    };
                    return t[n].call(l.exports, l, l.exports, i), l.l = !0, l.exports
                }
                return i.m = t, i.c = e, i.d = function (t, e, n) {
                    i.o(t, e) || Object.defineProperty(t, e, {
                        enumerable: !0,
                        get: n
                    })
                }, i.r = function (t) {
                    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                        value: "Module"
                    }), Object.defineProperty(t, "__esModule", {
                        value: !0
                    })
                }, i.t = function (t, e) {
                    if (1 & e && (t = i(t)), 8 & e) return t;
                    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
                    var n = Object.create(null);
                    if (i.r(n), Object.defineProperty(n, "default", {
                            enumerable: !0,
                            value: t
                        }), 2 & e && "string" != typeof t)
                        for (var l in t) i.d(n, l, function (e) {
                            return t[e]
                        }.bind(null, l));
                    return n
                }, i.n = function (t) {
                    var e = t && t.__esModule ? function () {
                        return t.default
                    } : function () {
                        return t
                    };
                    return i.d(e, "a", e), e
                }, i.o = function (t, e) {
                    return Object.prototype.hasOwnProperty.call(t, e)
                }, i.p = "", i(i.s = 1)
            }([function (t, e) {
                t.exports = function (t) {
                    return Array.isArray ? Array.isArray(t) : "[object Array]" === Object.prototype.toString.call(t)
                }
            }, function (t, e, i) {
                function n(t) {
                    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                        return typeof t
                    } : function (t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    })(t)
                }

                function l(t, e) {
                    for (var i = 0; i < e.length; i++) {
                        var n = e[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                    }
                }
                var r = i(2),
                    a = i(8),
                    o = i(0),
                    s = function () {
                        function t(e, i) {
                            var n = i.location,
                                l = void 0 === n ? 0 : n,
                                r = i.distance,
                                o = void 0 === r ? 100 : r,
                                s = i.threshold,
                                c = void 0 === s ? .6 : s,
                                u = i.maxPatternLength,
                                h = void 0 === u ? 32 : u,
                                d = i.caseSensitive,
                                f = void 0 !== d && d,
                                p = i.tokenSeparator,
                                g = void 0 === p ? / +/g : p,
                                m = i.findAllMatches,
                                v = void 0 !== m && m,
                                y = i.minMatchCharLength,
                                b = void 0 === y ? 1 : y,
                                x = i.id,
                                w = void 0 === x ? null : x,
                                _ = i.keys,
                                k = void 0 === _ ? [] : _,
                                S = i.shouldSort,
                                A = void 0 === S || S,
                                M = i.getFn,
                                C = void 0 === M ? a : M,
                                E = i.sortFn,
                                O = void 0 === E ? function (t, e) {
                                    return t.score - e.score
                                } : E,
                                T = i.tokenize,
                                P = void 0 !== T && T,
                                L = i.matchAllTokens,
                                D = void 0 !== L && L,
                                I = i.includeMatches,
                                j = void 0 !== I && I,
                                N = i.includeScore,
                                R = void 0 !== N && N,
                                F = i.verbose,
                                z = void 0 !== F && F;
                            ! function (t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                            }(this, t), this.options = {
                                location: l,
                                distance: o,
                                threshold: c,
                                maxPatternLength: h,
                                isCaseSensitive: f,
                                tokenSeparator: g,
                                findAllMatches: v,
                                minMatchCharLength: b,
                                id: w,
                                keys: k,
                                includeMatches: j,
                                includeScore: R,
                                shouldSort: A,
                                getFn: C,
                                sortFn: O,
                                verbose: z,
                                tokenize: P,
                                matchAllTokens: D
                            }, this.setCollection(e)
                        }
                        var e, i, s;
                        return e = t, (i = [{
                            key: "setCollection",
                            value: function (t) {
                                return this.list = t, t
                            }
                        }, {
                            key: "search",
                            value: function (t) {
                                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                    limit: !1
                                };
                                this._log('---------\nSearch pattern: "'.concat(t, '"'));
                                var i = this._prepareSearchers(t),
                                    n = i.tokenSearchers,
                                    l = i.fullSearcher,
                                    r = this._search(n, l),
                                    a = r.weights,
                                    o = r.results;
                                return this._computeScore(a, o), this.options.shouldSort && this._sort(o), e.limit && "number" == typeof e.limit && (o = o.slice(0, e.limit)), this._format(o)
                            }
                        }, {
                            key: "_prepareSearchers",
                            value: function () {
                                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                                    e = [];
                                if (this.options.tokenize)
                                    for (var i = t.split(this.options.tokenSeparator), n = 0, l = i.length; n < l; n += 1) e.push(new r(i[n], this.options));
                                return {
                                    tokenSearchers: e,
                                    fullSearcher: new r(t, this.options)
                                }
                            }
                        }, {
                            key: "_search",
                            value: function () {
                                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                                    e = arguments.length > 1 ? arguments[1] : void 0,
                                    i = this.list,
                                    n = {},
                                    l = [];
                                if ("string" == typeof i[0]) {
                                    for (var r = 0, a = i.length; r < a; r += 1) this._analyze({
                                        key: "",
                                        value: i[r],
                                        record: r,
                                        index: r
                                    }, {
                                        resultMap: n,
                                        results: l,
                                        tokenSearchers: t,
                                        fullSearcher: e
                                    });
                                    return {
                                        weights: null,
                                        results: l
                                    }
                                }
                                for (var o = {}, s = 0, c = i.length; s < c; s += 1)
                                    for (var u = i[s], h = 0, d = this.options.keys.length; h < d; h += 1) {
                                        var f = this.options.keys[h];
                                        if ("string" != typeof f) {
                                            if (o[f.name] = {
                                                    weight: 1 - f.weight || 1
                                                }, f.weight <= 0 || f.weight > 1) throw new Error("Key weight has to be > 0 and <= 1");
                                            f = f.name
                                        } else o[f] = {
                                            weight: 1
                                        };
                                        this._analyze({
                                            key: f,
                                            value: this.options.getFn(u, f),
                                            record: u,
                                            index: s
                                        }, {
                                            resultMap: n,
                                            results: l,
                                            tokenSearchers: t,
                                            fullSearcher: e
                                        })
                                    }
                                return {
                                    weights: o,
                                    results: l
                                }
                            }
                        }, {
                            key: "_analyze",
                            value: function (t, e) {
                                var i = t.key,
                                    n = t.arrayIndex,
                                    l = void 0 === n ? -1 : n,
                                    r = t.value,
                                    a = t.record,
                                    s = t.index,
                                    c = e.tokenSearchers,
                                    u = void 0 === c ? [] : c,
                                    h = e.fullSearcher,
                                    d = void 0 === h ? [] : h,
                                    f = e.resultMap,
                                    p = void 0 === f ? {} : f,
                                    g = e.results,
                                    m = void 0 === g ? [] : g;
                                if (null != r) {
                                    var v = !1,
                                        y = -1,
                                        b = 0;
                                    if ("string" == typeof r) {
                                        this._log("\nKey: ".concat("" === i ? "-" : i));
                                        var x = d.search(r);
                                        if (this._log('Full text: "'.concat(r, '", score: ').concat(x.score)), this.options.tokenize) {
                                            for (var w = r.split(this.options.tokenSeparator), _ = [], k = 0; k < u.length; k += 1) {
                                                var S = u[k];
                                                this._log('\nPattern: "'.concat(S.pattern, '"'));
                                                for (var A = !1, M = 0; M < w.length; M += 1) {
                                                    var C = w[M],
                                                        E = S.search(C),
                                                        O = {};
                                                    E.isMatch ? (O[C] = E.score, v = !0, A = !0, _.push(E.score)) : (O[C] = 1, this.options.matchAllTokens || _.push(1)), this._log('Token: "'.concat(C, '", score: ').concat(O[C]))
                                                }
                                                A && (b += 1)
                                            }
                                            y = _[0];
                                            for (var T = _.length, P = 1; P < T; P += 1) y += _[P];
                                            y /= T, this._log("Token score average:", y)
                                        }
                                        var L = x.score;
                                        y > -1 && (L = (L + y) / 2), this._log("Score average:", L);
                                        var D = !this.options.tokenize || !this.options.matchAllTokens || b >= u.length;
                                        if (this._log("\nCheck Matches: ".concat(D)), (v || x.isMatch) && D) {
                                            var I = p[s];
                                            I ? I.output.push({
                                                key: i,
                                                arrayIndex: l,
                                                value: r,
                                                score: L,
                                                matchedIndices: x.matchedIndices
                                            }) : (p[s] = {
                                                item: a,
                                                output: [{
                                                    key: i,
                                                    arrayIndex: l,
                                                    value: r,
                                                    score: L,
                                                    matchedIndices: x.matchedIndices
                                                }]
                                            }, m.push(p[s]))
                                        }
                                    } else if (o(r))
                                        for (var j = 0, N = r.length; j < N; j += 1) this._analyze({
                                            key: i,
                                            arrayIndex: j,
                                            value: r[j],
                                            record: a,
                                            index: s
                                        }, {
                                            resultMap: p,
                                            results: m,
                                            tokenSearchers: u,
                                            fullSearcher: d
                                        })
                                }
                            }
                        }, {
                            key: "_computeScore",
                            value: function (t, e) {
                                this._log("\n\nComputing score:\n");
                                for (var i = 0, n = e.length; i < n; i += 1) {
                                    for (var l = e[i].output, r = l.length, a = 1, o = 1, s = 0; s < r; s += 1) {
                                        var c = t ? t[l[s].key].weight : 1,
                                            u = (1 === c ? l[s].score : l[s].score || .001) * c;
                                        1 !== c ? o = Math.min(o, u) : (l[s].nScore = u, a *= u)
                                    }
                                    e[i].score = 1 === o ? a : o, this._log(e[i])
                                }
                            }
                        }, {
                            key: "_sort",
                            value: function (t) {
                                this._log("\n\nSorting...."), t.sort(this.options.sortFn)
                            }
                        }, {
                            key: "_format",
                            value: function (t) {
                                var e = [];
                                if (this.options.verbose) {
                                    var i = [];
                                    this._log("\n\nOutput:\n\n", JSON.stringify(t, (function (t, e) {
                                        if ("object" === n(e) && null !== e) {
                                            if (-1 !== i.indexOf(e)) return;
                                            i.push(e)
                                        }
                                        return e
                                    }))), i = null
                                }
                                var l = [];
                                this.options.includeMatches && l.push((function (t, e) {
                                    var i = t.output;
                                    e.matches = [];
                                    for (var n = 0, l = i.length; n < l; n += 1) {
                                        var r = i[n];
                                        if (0 !== r.matchedIndices.length) {
                                            var a = {
                                                indices: r.matchedIndices,
                                                value: r.value
                                            };
                                            r.key && (a.key = r.key), r.hasOwnProperty("arrayIndex") && r.arrayIndex > -1 && (a.arrayIndex = r.arrayIndex), e.matches.push(a)
                                        }
                                    }
                                })), this.options.includeScore && l.push((function (t, e) {
                                    e.score = t.score
                                }));
                                for (var r = 0, a = t.length; r < a; r += 1) {
                                    var o = t[r];
                                    if (this.options.id && (o.item = this.options.getFn(o.item, this.options.id)[0]), l.length) {
                                        for (var s = {
                                                item: o.item
                                            }, c = 0, u = l.length; c < u; c += 1) l[c](o, s);
                                        e.push(s)
                                    } else e.push(o.item)
                                }
                                return e
                            }
                        }, {
                            key: "_log",
                            value: function () {
                                var t;
                                this.options.verbose && (t = console).log.apply(t, arguments)
                            }
                        }]) && l(e.prototype, i), s && l(e, s), t
                    }();
                t.exports = s
            }, function (t, e, i) {
                function n(t, e) {
                    for (var i = 0; i < e.length; i++) {
                        var n = e[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                    }
                }
                var l = i(3),
                    r = i(4),
                    a = i(7),
                    o = function () {
                        function t(e, i) {
                            var n = i.location,
                                l = void 0 === n ? 0 : n,
                                r = i.distance,
                                o = void 0 === r ? 100 : r,
                                s = i.threshold,
                                c = void 0 === s ? .6 : s,
                                u = i.maxPatternLength,
                                h = void 0 === u ? 32 : u,
                                d = i.isCaseSensitive,
                                f = void 0 !== d && d,
                                p = i.tokenSeparator,
                                g = void 0 === p ? / +/g : p,
                                m = i.findAllMatches,
                                v = void 0 !== m && m,
                                y = i.minMatchCharLength,
                                b = void 0 === y ? 1 : y;
                            ! function (t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                            }(this, t), this.options = {
                                location: l,
                                distance: o,
                                threshold: c,
                                maxPatternLength: h,
                                isCaseSensitive: f,
                                tokenSeparator: g,
                                findAllMatches: v,
                                minMatchCharLength: b
                            }, this.pattern = this.options.isCaseSensitive ? e : e.toLowerCase(), this.pattern.length <= h && (this.patternAlphabet = a(this.pattern))
                        }
                        var e, i, o;
                        return e = t, (i = [{
                            key: "search",
                            value: function (t) {
                                if (this.options.isCaseSensitive || (t = t.toLowerCase()), this.pattern === t) return {
                                    isMatch: !0,
                                    score: 0,
                                    matchedIndices: [
                                        [0, t.length - 1]
                                    ]
                                };
                                var e = this.options,
                                    i = e.maxPatternLength,
                                    n = e.tokenSeparator;
                                if (this.pattern.length > i) return l(t, this.pattern, n);
                                var a = this.options,
                                    o = a.location,
                                    s = a.distance,
                                    c = a.threshold,
                                    u = a.findAllMatches,
                                    h = a.minMatchCharLength;
                                return r(t, this.pattern, this.patternAlphabet, {
                                    location: o,
                                    distance: s,
                                    threshold: c,
                                    findAllMatches: u,
                                    minMatchCharLength: h
                                })
                            }
                        }]) && n(e.prototype, i), o && n(e, o), t
                    }();
                t.exports = o
            }, function (t, e) {
                var i = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;
                t.exports = function (t, e) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : / +/g,
                        l = new RegExp(e.replace(i, "\\$&").replace(n, "|")),
                        r = t.match(l),
                        a = !!r,
                        o = [];
                    if (a)
                        for (var s = 0, c = r.length; s < c; s += 1) {
                            var u = r[s];
                            o.push([t.indexOf(u), u.length - 1])
                        }
                    return {
                        score: a ? .5 : 1,
                        isMatch: a,
                        matchedIndices: o
                    }
                }
            }, function (t, e, i) {
                var n = i(5),
                    l = i(6);
                t.exports = function (t, e, i, r) {
                    for (var a = r.location, o = void 0 === a ? 0 : a, s = r.distance, c = void 0 === s ? 100 : s, u = r.threshold, h = void 0 === u ? .6 : u, d = r.findAllMatches, f = void 0 !== d && d, p = r.minMatchCharLength, g = void 0 === p ? 1 : p, m = o, v = t.length, y = h, b = t.indexOf(e, m), x = e.length, w = [], _ = 0; _ < v; _ += 1) w[_] = 0;
                    if (-1 !== b) {
                        var k = n(e, {
                            errors: 0,
                            currentLocation: b,
                            expectedLocation: m,
                            distance: c
                        });
                        if (y = Math.min(k, y), -1 !== (b = t.lastIndexOf(e, m + x))) {
                            var S = n(e, {
                                errors: 0,
                                currentLocation: b,
                                expectedLocation: m,
                                distance: c
                            });
                            y = Math.min(S, y)
                        }
                    }
                    b = -1;
                    for (var A = [], M = 1, C = x + v, E = 1 << x - 1, O = 0; O < x; O += 1) {
                        for (var T = 0, P = C; T < P;) n(e, {
                            errors: O,
                            currentLocation: m + P,
                            expectedLocation: m,
                            distance: c
                        }) <= y ? T = P : C = P, P = Math.floor((C - T) / 2 + T);
                        C = P;
                        var L = Math.max(1, m - P + 1),
                            D = f ? v : Math.min(m + P, v) + x,
                            I = Array(D + 2);
                        I[D + 1] = (1 << O) - 1;
                        for (var j = D; j >= L; j -= 1) {
                            var N = j - 1,
                                R = i[t.charAt(N)];
                            if (R && (w[N] = 1), I[j] = (I[j + 1] << 1 | 1) & R, 0 !== O && (I[j] |= (A[j + 1] | A[j]) << 1 | 1 | A[j + 1]), I[j] & E && (M = n(e, {
                                    errors: O,
                                    currentLocation: N,
                                    expectedLocation: m,
                                    distance: c
                                })) <= y) {
                                if (y = M, (b = N) <= m) break;
                                L = Math.max(1, 2 * m - b)
                            }
                        }
                        if (n(e, {
                                errors: O + 1,
                                currentLocation: m,
                                expectedLocation: m,
                                distance: c
                            }) > y) break;
                        A = I
                    }
                    return {
                        isMatch: b >= 0,
                        score: 0 === M ? .001 : M,
                        matchedIndices: l(w, g)
                    }
                }
            }, function (t, e) {
                t.exports = function (t, e) {
                    var i = e.errors,
                        n = void 0 === i ? 0 : i,
                        l = e.currentLocation,
                        r = void 0 === l ? 0 : l,
                        a = e.expectedLocation,
                        o = void 0 === a ? 0 : a,
                        s = e.distance,
                        c = void 0 === s ? 100 : s,
                        u = n / t.length,
                        h = Math.abs(o - r);
                    return c ? u + h / c : h ? 1 : u
                }
            }, function (t, e) {
                t.exports = function () {
                    for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, i = [], n = -1, l = -1, r = 0, a = t.length; r < a; r += 1) {
                        var o = t[r];
                        o && -1 === n ? n = r : o || -1 === n || ((l = r - 1) - n + 1 >= e && i.push([n, l]), n = -1)
                    }
                    return t[r - 1] && r - n >= e && i.push([n, r - 1]), i
                }
            }, function (t, e) {
                t.exports = function (t) {
                    for (var e = {}, i = t.length, n = 0; n < i; n += 1) e[t.charAt(n)] = 0;
                    for (var l = 0; l < i; l += 1) e[t.charAt(l)] |= 1 << i - l - 1;
                    return e
                }
            }, function (t, e, i) {
                var n = i(0);
                t.exports = function (t, e) {
                    return function t(e, i, l) {
                        if (i) {
                            var r = i.indexOf("."),
                                a = i,
                                o = null; - 1 !== r && (a = i.slice(0, r), o = i.slice(r + 1));
                            var s = e[a];
                            if (null != s)
                                if (o || "string" != typeof s && "number" != typeof s)
                                    if (n(s))
                                        for (var c = 0, u = s.length; c < u; c += 1) t(s[c], o, l);
                                    else o && t(s, o, l);
                            else l.push(s.toString())
                        } else l.push(e);
                        return l
                    }(t, e, [])
                }
            }])
        }, function (t, e, i) {
            "use strict";

            function n(t) {
                var e, i = t.Symbol;
                return "function" == typeof i ? i.observable ? e = i.observable : (e = i("observable"), i.observable = e) : e = "@@observable", e
            }
            i.d(e, "a", (function () {
                return n
            }))
        }, function (t, e, i) {
            t.exports = i(7)
        }, function (t, e) {
            var i;
            i = function () {
                return this
            }();
            try {
                i = i || new Function("return this")()
            } catch (t) {
                "object" == typeof window && (i = window)
            }
            t.exports = i
        }, function (t, e) {
            t.exports = function (t) {
                if (!t.webpackPolyfill) {
                    var e = Object.create(t);
                    e.children || (e.children = []), Object.defineProperty(e, "loaded", {
                        enumerable: !0,
                        get: function () {
                            return e.l
                        }
                    }), Object.defineProperty(e, "id", {
                        enumerable: !0,
                        get: function () {
                            return e.i
                        }
                    }), Object.defineProperty(e, "exports", {
                        enumerable: !0
                    }), e.webpackPolyfill = 1
                }
                return e
            }
        }, function (t, e, i) {
            "use strict";
            i.r(e);
            var n = i(2),
                l = i.n(n),
                r = i(0),
                a = i.n(r),
                o = i(1),
                s = function () {
                    return Math.random().toString(36).substring(7).split("").join(".")
                },
                c = {
                    INIT: "@@redux/INIT" + s(),
                    REPLACE: "@@redux/REPLACE" + s(),
                    PROBE_UNKNOWN_ACTION: function () {
                        return "@@redux/PROBE_UNKNOWN_ACTION" + s()
                    }
                };

            function u(t) {
                if ("object" != typeof t || null === t) return !1;
                for (var e = t; null !== Object.getPrototypeOf(e);) e = Object.getPrototypeOf(e);
                return Object.getPrototypeOf(t) === e
            }

            function h(t, e, i) {
                var n;
                if ("function" == typeof e && "function" == typeof i || "function" == typeof i && "function" == typeof arguments[3]) throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function.");
                if ("function" == typeof e && void 0 === i && (i = e, e = void 0), void 0 !== i) {
                    if ("function" != typeof i) throw new Error("Expected the enhancer to be a function.");
                    return i(h)(t, e)
                }
                if ("function" != typeof t) throw new Error("Expected the reducer to be a function.");
                var l = t,
                    r = e,
                    a = [],
                    s = a,
                    d = !1;

                function f() {
                    s === a && (s = a.slice())
                }

                function p() {
                    if (d) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
                    return r
                }

                function g(t) {
                    if ("function" != typeof t) throw new Error("Expected the listener to be a function.");
                    if (d) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
                    var e = !0;
                    return f(), s.push(t),
                        function () {
                            if (e) {
                                if (d) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
                                e = !1, f();
                                var i = s.indexOf(t);
                                s.splice(i, 1)
                            }
                        }
                }

                function m(t) {
                    if (!u(t)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
                    if (void 0 === t.type) throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
                    if (d) throw new Error("Reducers may not dispatch actions.");
                    try {
                        d = !0, r = l(r, t)
                    } finally {
                        d = !1
                    }
                    for (var e = a = s, i = 0; i < e.length; i++)(0, e[i])();
                    return t
                }

                function v(t) {
                    if ("function" != typeof t) throw new Error("Expected the nextReducer to be a function.");
                    l = t, m({
                        type: c.REPLACE
                    })
                }

                function y() {
                    var t, e = g;
                    return (t = {
                        subscribe: function (t) {
                            if ("object" != typeof t || null === t) throw new TypeError("Expected the observer to be an object.");

                            function i() {
                                t.next && t.next(p())
                            }
                            return i(), {
                                unsubscribe: e(i)
                            }
                        }
                    })[o.a] = function () {
                        return this
                    }, t
                }
                return m({
                    type: c.INIT
                }), (n = {
                    dispatch: m,
                    subscribe: g,
                    getState: p,
                    replaceReducer: v
                })[o.a] = y, n
            }

            function d(t, e) {
                var i = e && e.type;
                return "Given " + (i && 'action "' + String(i) + '"' || "an action") + ', reducer "' + t + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.'
            }
            var f, p = [],
                g = [],
                m = [],
                v = {
                    loading: !1
                },
                y = function (t, e) {
                    switch (void 0 === t && (t = v), e.type) {
                        case "SET_IS_LOADING":
                            return {
                                loading: e.isLoading
                            };
                        default:
                            return t
                    }
                },
                b = function (t) {
                    return Array.from({
                        length: t
                    }, (function () {
                        return (t = 0, e = 36, Math.floor(Math.random() * (e - t) + t)).toString(36);
                        var t, e
                    })).join("")
                },
                x = function (t) {
                    return Object.prototype.toString.call(t).slice(8, -1)
                },
                w = function (t, e) {
                    return null != e && x(e) === t
                },
                _ = function (t) {
                    return "string" != typeof t ? t : t.replace(/&/g, "&amp;").replace(/>/g, "&rt;").replace(/</g, "&lt;").replace(/"/g, "&quot;")
                },
                k = (f = document.createElement("div"), function (t) {
                    var e = t.trim();
                    f.innerHTML = e;
                    for (var i = f.children[0]; f.firstChild;) f.removeChild(f.firstChild);
                    return i
                }),
                S = function (t, e) {
                    return t.score - e.score
                },
                A = function (t) {
                    return JSON.parse(JSON.stringify(t))
                },
                M = function (t) {
                    for (var e = Object.keys(t), i = {}, n = 0; n < e.length; n++) {
                        var l = e[n];
                        "function" == typeof t[l] && (i[l] = t[l])
                    }
                    var r, a = Object.keys(i);
                    try {
                        ! function (t) {
                            Object.keys(t).forEach((function (e) {
                                var i = t[e];
                                if (void 0 === i(void 0, {
                                        type: c.INIT
                                    })) throw new Error('Reducer "' + e + "\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");
                                if (void 0 === i(void 0, {
                                        type: c.PROBE_UNKNOWN_ACTION()
                                    })) throw new Error('Reducer "' + e + "\" returned undefined when probed with a random type. Don't try to handle " + c.INIT + ' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.')
                            }))
                        }(i)
                    } catch (t) {
                        r = t
                    }
                    return function (t, e) {
                        if (void 0 === t && (t = {}), r) throw r;
                        for (var n = !1, l = {}, o = 0; o < a.length; o++) {
                            var s = a[o],
                                c = i[s],
                                u = t[s],
                                h = c(u, e);
                            if (void 0 === h) {
                                var f = d(s, e);
                                throw new Error(f)
                            }
                            l[s] = h, n = n || h !== u
                        }
                        return n ? l : t
                    }
                }({
                    items: function (t, e) {
                        switch (void 0 === t && (t = p), e.type) {
                            case "ADD_ITEM":
                                return [].concat(t, [{
                                    id: e.id,
                                    choiceId: e.choiceId,
                                    groupId: e.groupId,
                                    value: e.value,
                                    label: e.label,
                                    active: !0,
                                    highlighted: !1,
                                    customProperties: e.customProperties,
                                    placeholder: e.placeholder || !1,
                                    keyCode: null
                                }]).map((function (t) {
                                    var e = t;
                                    return e.highlighted = !1, e
                                }));
                            case "REMOVE_ITEM":
                                return t.map((function (t) {
                                    var i = t;
                                    return i.id === e.id && (i.active = !1), i
                                }));
                            case "HIGHLIGHT_ITEM":
                                return t.map((function (t) {
                                    var i = t;
                                    return i.id === e.id && (i.highlighted = e.highlighted), i
                                }));
                            default:
                                return t
                        }
                    },
                    groups: function (t, e) {
                        switch (void 0 === t && (t = g), e.type) {
                            case "ADD_GROUP":
                                return [].concat(t, [{
                                    id: e.id,
                                    value: e.value,
                                    active: e.active,
                                    disabled: e.disabled
                                }]);
                            case "CLEAR_CHOICES":
                                return [];
                            default:
                                return t
                        }
                    },
                    choices: function (t, e) {
                        switch (void 0 === t && (t = m), e.type) {
                            case "ADD_CHOICE":
                                return [].concat(t, [{
                                    id: e.id,
                                    elementId: e.elementId,
                                    groupId: e.groupId,
                                    value: e.value,
                                    label: e.label || e.value,
                                    disabled: e.disabled || !1,
                                    selected: !1,
                                    active: !0,
                                    score: 9999,
                                    customProperties: e.customProperties,
                                    placeholder: e.placeholder || !1,
                                    keyCode: null
                                }]);
                            case "ADD_ITEM":
                                return e.activateOptions ? t.map((function (t) {
                                    var i = t;
                                    return i.active = e.active, i
                                })) : e.choiceId > -1 ? t.map((function (t) {
                                    var i = t;
                                    return i.id === parseInt(e.choiceId, 10) && (i.selected = !0), i
                                })) : t;
                            case "REMOVE_ITEM":
                                return e.choiceId > -1 ? t.map((function (t) {
                                    var i = t;
                                    return i.id === parseInt(e.choiceId, 10) && (i.selected = !1), i
                                })) : t;
                            case "FILTER_CHOICES":
                                return t.map((function (t) {
                                    var i = t;
                                    return i.active = e.results.some((function (t) {
                                        var e = t.item,
                                            n = t.score;
                                        return e.id === i.id && (i.score = n, !0)
                                    })), i
                                }));
                            case "ACTIVATE_CHOICES":
                                return t.map((function (t) {
                                    var i = t;
                                    return i.active = e.active, i
                                }));
                            case "CLEAR_CHOICES":
                                return m;
                            default:
                                return t
                        }
                    },
                    general: y
                }),
                C = function (t, e) {
                    var i = t;
                    if ("CLEAR_ALL" === e.type) i = void 0;
                    else if ("RESET_TO" === e.type) return A(e.state);
                    return M(i, e)
                };

            function E(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                }
            }
            var O = function () {
                function t() {
                    this._store = h(C, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
                }
                var e, i, n, l = t.prototype;
                return l.subscribe = function (t) {
                    this._store.subscribe(t)
                }, l.dispatch = function (t) {
                    this._store.dispatch(t)
                }, l.isLoading = function () {
                    return this.state.general.loading
                }, l.getChoiceById = function (t) {
                    return this.activeChoices.find((function (e) {
                        return e.id === parseInt(t, 10)
                    }))
                }, l.getGroupById = function (t) {
                    return this.groups.find((function (e) {
                        return e.id === t
                    }))
                }, e = t, (i = [{
                    key: "state",
                    get: function () {
                        return this._store.getState()
                    }
                }, {
                    key: "items",
                    get: function () {
                        return this.state.items
                    }
                }, {
                    key: "activeItems",
                    get: function () {
                        return this.items.filter((function (t) {
                            return !0 === t.active
                        }))
                    }
                }, {
                    key: "highlightedActiveItems",
                    get: function () {
                        return this.items.filter((function (t) {
                            return t.active && t.highlighted
                        }))
                    }
                }, {
                    key: "choices",
                    get: function () {
                        return this.state.choices
                    }
                }, {
                    key: "activeChoices",
                    get: function () {
                        return this.choices.filter((function (t) {
                            return !0 === t.active
                        }))
                    }
                }, {
                    key: "selectableChoices",
                    get: function () {
                        return this.choices.filter((function (t) {
                            return !0 !== t.disabled
                        }))
                    }
                }, {
                    key: "searchableChoices",
                    get: function () {
                        return this.selectableChoices.filter((function (t) {
                            return !0 !== t.placeholder
                        }))
                    }
                }, {
                    key: "placeholderChoice",
                    get: function () {
                        return [].concat(this.choices).reverse().find((function (t) {
                            return !0 === t.placeholder
                        }))
                    }
                }, {
                    key: "groups",
                    get: function () {
                        return this.state.groups
                    }
                }, {
                    key: "activeGroups",
                    get: function () {
                        var t = this.groups,
                            e = this.choices;
                        return t.filter((function (t) {
                            var i = !0 === t.active && !1 === t.disabled,
                                n = e.some((function (t) {
                                    return !0 === t.active && !1 === t.disabled
                                }));
                            return i && n
                        }), [])
                    }
                }]) && E(e.prototype, i), n && E(e, n), t
            }();

            function T(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                }
            }
            var P = function () {
                    function t(t) {
                        var e = t.element,
                            i = t.type,
                            n = t.classNames;
                        this.element = e, this.classNames = n, this.type = i, this.isActive = !1
                    }
                    var e, i, n, l = t.prototype;
                    return l.getChild = function (t) {
                        return this.element.querySelector(t)
                    }, l.show = function () {
                        return this.element.classList.add(this.classNames.activeState), this.element.setAttribute("aria-expanded", "true"), this.isActive = !0, this
                    }, l.hide = function () {
                        return this.element.classList.remove(this.classNames.activeState), this.element.setAttribute("aria-expanded", "false"), this.isActive = !1, this
                    }, e = t, (i = [{
                        key: "distanceFromTopWindow",
                        get: function () {
                            return this.element.getBoundingClientRect().bottom
                        }
                    }]) && T(e.prototype, i), n && T(e, n), t
                }(),
                L = {
                    items: [],
                    choices: [],
                    silent: !1,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                    addItems: !0,
                    addItemFilter: null,
                    removeItems: !0,
                    removeItemButton: !1,
                    editItems: !1,
                    duplicateItemsAllowed: !0,
                    delimiter: ",",
                    paste: !0,
                    searchEnabled: !0,
                    searchChoices: !0,
                    searchFloor: 1,
                    searchResultLimit: 4,
                    searchFields: ["label", "value"],
                    position: "auto",
                    resetScrollPosition: !0,
                    shouldSort: !0,
                    shouldSortItems: !1,
                    sorter: function (t, e) {
                        var i = t.value,
                            n = t.label,
                            l = void 0 === n ? i : n,
                            r = e.value,
                            a = e.label,
                            o = void 0 === a ? r : a;
                        return l.localeCompare(o, [], {
                            sensitivity: "base",
                            ignorePunctuation: !0,
                            numeric: !0
                        })
                    },
                    placeholder: !0,
                    placeholderValue: null,
                    searchPlaceholderValue: null,
                    prependValue: null,
                    appendValue: null,
                    renderSelectedChoices: "auto",
                    loadingText: "Loading...",
                    noResultsText: "No results found",
                    noChoicesText: "No choices to choose from",
                    itemSelectText: "Press to select",
                    uniqueItemText: "Only unique values can be added",
                    customAddItemText: "Only values matching specific conditions can be added",
                    addItemText: function (t) {
                        return 'Press Enter to add <b>"' + _(t) + '"</b>'
                    },
                    maxItemText: function (t) {
                        return "Only " + t + " values can be added"
                    },
                    valueComparer: function (t, e) {
                        return t === e
                    },
                    fuseOptions: {
                        includeScore: !0
                    },
                    callbackOnInit: null,
                    callbackOnCreateTemplates: null,
                    classNames: {
                        containerOuter: "choices",
                        containerInner: "choices__inner",
                        input: "choices__input",
                        inputCloned: "choices__input--cloned",
                        list: "choices__list",
                        listItems: "choices__list--multiple",
                        listSingle: "choices__list--single",
                        listDropdown: "choices__list--dropdown",
                        item: "choices__item",
                        itemSelectable: "choices__item--selectable",
                        itemDisabled: "choices__item--disabled",
                        itemChoice: "choices__item--choice",
                        placeholder: "choices__placeholder",
                        group: "choices__group",
                        groupHeading: "choices__heading",
                        button: "choices__button",
                        activeState: "is-active",
                        focusState: "is-focused",
                        openState: "is-open",
                        disabledState: "is-disabled",
                        highlightedState: "is-highlighted",
                        selectedState: "is-selected",
                        flippedState: "is-flipped",
                        loadingState: "is-loading",
                        noResults: "has-no-results",
                        noChoices: "has-no-choices"
                    }
                },
                D = "showDropdown",
                I = "hideDropdown",
                j = "change",
                N = "choice",
                R = "search",
                F = "addItem",
                z = "removeItem",
                H = "highlightItem",
                B = "highlightChoice",
                Y = "ADD_CHOICE",
                W = "FILTER_CHOICES",
                V = "ACTIVATE_CHOICES",
                X = "CLEAR_CHOICES",
                q = "ADD_GROUP",
                Z = "ADD_ITEM",
                G = "REMOVE_ITEM",
                U = "HIGHLIGHT_ITEM",
                K = 46,
                $ = 8,
                Q = 13,
                J = 65,
                tt = 27,
                et = 38,
                it = 40,
                nt = 33,
                lt = 34,
                rt = "text",
                at = "select-one",
                ot = "select-multiple",
                st = function () {
                    function t(t) {
                        var e = t.element,
                            i = t.type,
                            n = t.classNames,
                            l = t.position;
                        this.element = e, this.classNames = n, this.type = i, this.position = l, this.isOpen = !1, this.isFlipped = !1, this.isFocussed = !1, this.isDisabled = !1, this.isLoading = !1, this._onFocus = this._onFocus.bind(this), this._onBlur = this._onBlur.bind(this)
                    }
                    var e = t.prototype;
                    return e.addEventListeners = function () {
                        this.element.addEventListener("focus", this._onFocus), this.element.addEventListener("blur", this._onBlur)
                    }, e.removeEventListeners = function () {
                        this.element.removeEventListener("focus", this._onFocus), this.element.removeEventListener("blur", this._onBlur)
                    }, e.shouldFlip = function (t) {
                        if ("number" != typeof t) return !1;
                        var e = !1;
                        return "auto" === this.position ? e = !window.matchMedia("(min-height: " + (t + 1) + "px)").matches : "top" === this.position && (e = !0), e
                    }, e.setActiveDescendant = function (t) {
                        this.element.setAttribute("aria-activedescendant", t)
                    }, e.removeActiveDescendant = function () {
                        this.element.removeAttribute("aria-activedescendant")
                    }, e.open = function (t) {
                        this.element.classList.add(this.classNames.openState), this.element.setAttribute("aria-expanded", "true"), this.isOpen = !0, this.shouldFlip(t) && (this.element.classList.add(this.classNames.flippedState), this.isFlipped = !0)
                    }, e.close = function () {
                        this.element.classList.remove(this.classNames.openState), this.element.setAttribute("aria-expanded", "false"), this.removeActiveDescendant(), this.isOpen = !1, this.isFlipped && (this.element.classList.remove(this.classNames.flippedState), this.isFlipped = !1)
                    }, e.focus = function () {
                        this.isFocussed || this.element.focus()
                    }, e.addFocusState = function () {
                        this.element.classList.add(this.classNames.focusState)
                    }, e.removeFocusState = function () {
                        this.element.classList.remove(this.classNames.focusState)
                    }, e.enable = function () {
                        this.element.classList.remove(this.classNames.disabledState), this.element.removeAttribute("aria-disabled"), this.type === at && this.element.setAttribute("tabindex", "0"), this.isDisabled = !1
                    }, e.disable = function () {
                        this.element.classList.add(this.classNames.disabledState), this.element.setAttribute("aria-disabled", "true"), this.type === at && this.element.setAttribute("tabindex", "-1"), this.isDisabled = !0
                    }, e.wrap = function (t) {
                        ! function (t, e) {
                            void 0 === e && (e = document.createElement("div")), t.nextSibling ? t.parentNode.insertBefore(e, t.nextSibling) : t.parentNode.appendChild(e), e.appendChild(t)
                        }(t, this.element)
                    }, e.unwrap = function (t) {
                        this.element.parentNode.insertBefore(t, this.element), this.element.parentNode.removeChild(this.element)
                    }, e.addLoadingState = function () {
                        this.element.classList.add(this.classNames.loadingState), this.element.setAttribute("aria-busy", "true"), this.isLoading = !0
                    }, e.removeLoadingState = function () {
                        this.element.classList.remove(this.classNames.loadingState), this.element.removeAttribute("aria-busy"), this.isLoading = !1
                    }, e._onFocus = function () {
                        this.isFocussed = !0
                    }, e._onBlur = function () {
                        this.isFocussed = !1
                    }, t
                }();

            function ct(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                }
            }
            var ut = function () {
                    function t(t) {
                        var e = t.element,
                            i = t.type,
                            n = t.classNames,
                            l = t.preventPaste;
                        this.element = e, this.type = i, this.classNames = n, this.preventPaste = l, this.isFocussed = this.element === document.activeElement, this.isDisabled = e.disabled, this._onPaste = this._onPaste.bind(this), this._onInput = this._onInput.bind(this), this._onFocus = this._onFocus.bind(this), this._onBlur = this._onBlur.bind(this)
                    }
                    var e, i, n, l = t.prototype;
                    return l.addEventListeners = function () {
                        this.element.addEventListener("paste", this._onPaste), this.element.addEventListener("input", this._onInput, {
                            passive: !0
                        }), this.element.addEventListener("focus", this._onFocus, {
                            passive: !0
                        }), this.element.addEventListener("blur", this._onBlur, {
                            passive: !0
                        })
                    }, l.removeEventListeners = function () {
                        this.element.removeEventListener("input", this._onInput, {
                            passive: !0
                        }), this.element.removeEventListener("paste", this._onPaste), this.element.removeEventListener("focus", this._onFocus, {
                            passive: !0
                        }), this.element.removeEventListener("blur", this._onBlur, {
                            passive: !0
                        })
                    }, l.enable = function () {
                        this.element.removeAttribute("disabled"), this.isDisabled = !1
                    }, l.disable = function () {
                        this.element.setAttribute("disabled", ""), this.isDisabled = !0
                    }, l.focus = function () {
                        this.isFocussed || this.element.focus()
                    }, l.blur = function () {
                        this.isFocussed && this.element.blur()
                    }, l.clear = function (t) {
                        return void 0 === t && (t = !0), this.element.value && (this.element.value = ""), t && this.setWidth(), this
                    }, l.setWidth = function () {
                        var t = this.element,
                            e = t.style,
                            i = t.value,
                            n = t.placeholder;
                        e.minWidth = n.length + 1 + "ch", e.width = i.length + 1 + "ch"
                    }, l.setActiveDescendant = function (t) {
                        this.element.setAttribute("aria-activedescendant", t)
                    }, l.removeActiveDescendant = function () {
                        this.element.removeAttribute("aria-activedescendant")
                    }, l._onInput = function () {
                        this.type !== at && this.setWidth()
                    }, l._onPaste = function (t) {
                        this.preventPaste && t.preventDefault()
                    }, l._onFocus = function () {
                        this.isFocussed = !0
                    }, l._onBlur = function () {
                        this.isFocussed = !1
                    }, e = t, (i = [{
                        key: "placeholder",
                        set: function (t) {
                            this.element.placeholder = t
                        }
                    }, {
                        key: "value",
                        get: function () {
                            return _(this.element.value)
                        },
                        set: function (t) {
                            this.element.value = t
                        }
                    }]) && ct(e.prototype, i), n && ct(e, n), t
                }(),
                ht = function () {
                    function t(t) {
                        var e = t.element;
                        this.element = e, this.scrollPos = this.element.scrollTop, this.height = this.element.offsetHeight
                    }
                    var e = t.prototype;
                    return e.clear = function () {
                        this.element.innerHTML = ""
                    }, e.append = function (t) {
                        this.element.appendChild(t)
                    }, e.getChild = function (t) {
                        return this.element.querySelector(t)
                    }, e.hasChildren = function () {
                        return this.element.hasChildNodes()
                    }, e.scrollToTop = function () {
                        this.element.scrollTop = 0
                    }, e.scrollToChildElement = function (t, e) {
                        var i = this;
                        if (t) {
                            var n = this.element.offsetHeight,
                                l = this.element.scrollTop + n,
                                r = t.offsetHeight,
                                a = t.offsetTop + r,
                                o = e > 0 ? this.element.scrollTop + a - l : t.offsetTop;
                            requestAnimationFrame((function () {
                                i._animateScroll(o, e)
                            }))
                        }
                    }, e._scrollDown = function (t, e, i) {
                        var n = (i - t) / e,
                            l = n > 1 ? n : 1;
                        this.element.scrollTop = t + l
                    }, e._scrollUp = function (t, e, i) {
                        var n = (t - i) / e,
                            l = n > 1 ? n : 1;
                        this.element.scrollTop = t - l
                    }, e._animateScroll = function (t, e) {
                        var i = this,
                            n = this.element.scrollTop,
                            l = !1;
                        e > 0 ? (this._scrollDown(n, 4, t), n < t && (l = !0)) : (this._scrollUp(n, 4, t), n > t && (l = !0)), l && requestAnimationFrame((function () {
                            i._animateScroll(t, e)
                        }))
                    }, t
                }();

            function dt(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                }
            }
            var ft = function () {
                function t(t) {
                    var e = t.element,
                        i = t.classNames;
                    if (this.element = e, this.classNames = i, !(e instanceof HTMLInputElement || e instanceof HTMLSelectElement)) throw new TypeError("Invalid element passed");
                    this.isDisabled = !1
                }
                var e, i, n, l = t.prototype;
                return l.conceal = function () {
                    this.element.classList.add(this.classNames.input), this.element.hidden = !0, this.element.tabIndex = -1;
                    var t = this.element.getAttribute("style");
                    t && this.element.setAttribute("data-choice-orig-style", t), this.element.setAttribute("data-choice", "active")
                }, l.reveal = function () {
                    this.element.classList.remove(this.classNames.input), this.element.hidden = !1, this.element.removeAttribute("tabindex");
                    var t = this.element.getAttribute("data-choice-orig-style");
                    t ? (this.element.removeAttribute("data-choice-orig-style"), this.element.setAttribute("style", t)) : this.element.removeAttribute("style"), this.element.removeAttribute("data-choice"), this.element.value = this.element.value
                }, l.enable = function () {
                    this.element.removeAttribute("disabled"), this.element.disabled = !1, this.isDisabled = !1
                }, l.disable = function () {
                    this.element.setAttribute("disabled", ""), this.element.disabled = !0, this.isDisabled = !0
                }, l.triggerEvent = function (t, e) {
                    ! function (t, e, i) {
                        void 0 === i && (i = null);
                        var n = new CustomEvent(e, {
                            detail: i,
                            bubbles: !0,
                            cancelable: !0
                        });
                        t.dispatchEvent(n)
                    }(this.element, t, e)
                }, e = t, (i = [{
                    key: "isActive",
                    get: function () {
                        return "active" === this.element.dataset.choice
                    }
                }, {
                    key: "dir",
                    get: function () {
                        return this.element.dir
                    }
                }, {
                    key: "value",
                    get: function () {
                        return this.element.value
                    },
                    set: function (t) {
                        this.element.value = t
                    }
                }]) && dt(e.prototype, i), n && dt(e, n), t
            }();

            function pt(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                }
            }
            var gt = function (t) {
                var e, i, n, l, r;

                function a(e) {
                    var i, n = e.element,
                        l = e.classNames,
                        r = e.delimiter;
                    return (i = t.call(this, {
                        element: n,
                        classNames: l
                    }) || this).delimiter = r, i
                }
                return i = t, (e = a).prototype = Object.create(i.prototype), e.prototype.constructor = e, e.__proto__ = i, n = a, (l = [{
                    key: "value",
                    get: function () {
                        return this.element.value
                    },
                    set: function (t) {
                        var e = t.map((function (t) {
                            return t.value
                        })).join(this.delimiter);
                        this.element.setAttribute("value", e), this.element.value = e
                    }
                }]) && pt(n.prototype, l), r && pt(n, r), a
            }(ft);

            function mt(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                }
            }
            var vt = function (t) {
                    var e, i, n, l, r;

                    function a(e) {
                        var i, n = e.element,
                            l = e.classNames,
                            r = e.template;
                        return (i = t.call(this, {
                            element: n,
                            classNames: l
                        }) || this).template = r, i
                    }
                    return i = t, (e = a).prototype = Object.create(i.prototype), e.prototype.constructor = e, e.__proto__ = i, a.prototype.appendDocFragment = function (t) {
                        this.element.innerHTML = "", this.element.appendChild(t)
                    }, n = a, (l = [{
                        key: "placeholderOption",
                        get: function () {
                            return this.element.querySelector('option[value=""]') || this.element.querySelector("option[placeholder]")
                        }
                    }, {
                        key: "optionGroups",
                        get: function () {
                            return Array.from(this.element.getElementsByTagName("OPTGROUP"))
                        }
                    }, {
                        key: "options",
                        get: function () {
                            return Array.from(this.element.options)
                        },
                        set: function (t) {
                            var e = this,
                                i = document.createDocumentFragment();
                            t.forEach((function (t) {
                                return n = t, l = e.template(n), void i.appendChild(l);
                                var n, l
                            })), this.appendDocFragment(i)
                        }
                    }]) && mt(n.prototype, l), r && mt(n, r), a
                }(ft),
                yt = {
                    containerOuter: function (t, e, i, n, l, r) {
                        var a = t.containerOuter,
                            o = Object.assign(document.createElement("div"), {
                                className: a
                            });
                        return o.dataset.type = r, e && (o.dir = e), n && (o.tabIndex = 0), i && (o.setAttribute("role", l ? "combobox" : "listbox"), l && o.setAttribute("aria-autocomplete", "list")), o.setAttribute("aria-haspopup", "true"), o.setAttribute("aria-expanded", "false"), o
                    },
                    containerInner: function (t) {
                        var e = t.containerInner;
                        return Object.assign(document.createElement("div"), {
                            className: e
                        })
                    },
                    itemList: function (t, e) {
                        var i = t.list,
                            n = t.listSingle,
                            l = t.listItems;
                        return Object.assign(document.createElement("div"), {
                            className: i + " " + (e ? n : l)
                        })
                    },
                    placeholder: function (t, e) {
                        var i = t.placeholder;
                        return Object.assign(document.createElement("div"), {
                            className: i,
                            innerHTML: e
                        })
                    },
                    item: function (t, e, i) {
                        var n = t.item,
                            l = t.button,
                            r = t.highlightedState,
                            a = t.itemSelectable,
                            o = t.placeholder,
                            s = e.id,
                            c = e.value,
                            u = e.label,
                            h = e.customProperties,
                            d = e.active,
                            f = e.disabled,
                            p = e.highlighted,
                            g = e.placeholder,
                            m = Object.assign(document.createElement("div"), {
                                className: n,
                                innerHTML: u
                            });
                        if (Object.assign(m.dataset, {
                                item: "",
                                id: s,
                                value: c,
                                customProperties: h
                            }), d && m.setAttribute("aria-selected", "true"), f && m.setAttribute("aria-disabled", "true"), g && m.classList.add(o), m.classList.add(p ? r : a), i) {
                            f && m.classList.remove(a), m.dataset.deletable = "";
                            var v = "Remove item",
                                y = Object.assign(document.createElement("button"), {
                                    type: "button",
                                    className: l,
                                    innerHTML: v
                                });
                            y.setAttribute("aria-label", "Remove item: '" + c + "'"), y.dataset.button = "", m.appendChild(y)
                        }
                        return m
                    },
                    choiceList: function (t, e) {
                        var i = t.list,
                            n = Object.assign(document.createElement("div"), {
                                className: i
                            });
                        return e || n.setAttribute("aria-multiselectable", "true"), n.setAttribute("role", "listbox"), n
                    },
                    choiceGroup: function (t, e) {
                        var i = t.group,
                            n = t.groupHeading,
                            l = t.itemDisabled,
                            r = e.id,
                            a = e.value,
                            o = e.disabled,
                            s = Object.assign(document.createElement("div"), {
                                className: i + " " + (o ? l : "")
                            });
                        return s.setAttribute("role", "group"), Object.assign(s.dataset, {
                            group: "",
                            id: r,
                            value: a
                        }), o && s.setAttribute("aria-disabled", "true"), s.appendChild(Object.assign(document.createElement("div"), {
                            className: n,
                            innerHTML: a
                        })), s
                    },
                    choice: function (t, e, i) {
                        var n = t.item,
                            l = t.itemChoice,
                            r = t.itemSelectable,
                            a = t.selectedState,
                            o = t.itemDisabled,
                            s = t.placeholder,
                            c = e.id,
                            u = e.value,
                            h = e.label,
                            d = e.groupId,
                            f = e.elementId,
                            p = e.disabled,
                            g = e.selected,
                            m = e.placeholder,
                            v = Object.assign(document.createElement("div"), {
                                id: f,
                                innerHTML: h,
                                className: n + " " + l
                            });
                        return g && v.classList.add(a), m && v.classList.add(s), v.setAttribute("role", d > 0 ? "treeitem" : "option"), Object.assign(v.dataset, {
                            choice: "",
                            id: c,
                            value: u,
                            selectText: i
                        }), p ? (v.classList.add(o), v.dataset.choiceDisabled = "", v.setAttribute("aria-disabled", "true")) : (v.classList.add(r), v.dataset.choiceSelectable = ""), v
                    },
                    input: function (t, e) {
                        var i = t.input,
                            n = t.inputCloned,
                            l = Object.assign(document.createElement("input"), {
                                type: "text",
                                className: i + " " + n,
                                autocomplete: "off",
                                autocapitalize: "off",
                                spellcheck: !1
                            });
                        return l.setAttribute("role", "textbox"), l.setAttribute("aria-autocomplete", "list"), l.setAttribute("aria-label", e), l
                    },
                    dropdown: function (t) {
                        var e = t.list,
                            i = t.listDropdown,
                            n = document.createElement("div");
                        return n.classList.add(e, i), n.setAttribute("aria-expanded", "false"), n
                    },
                    notice: function (t, e, i) {
                        var n = t.item,
                            l = t.itemChoice,
                            r = t.noResults,
                            a = t.noChoices;
                        void 0 === i && (i = "");
                        var o = [n, l];
                        return "no-choices" === i ? o.push(a) : "no-results" === i && o.push(r), Object.assign(document.createElement("div"), {
                            innerHTML: e,
                            className: o.join(" ")
                        })
                    },
                    option: function (t) {
                        var e = t.label,
                            i = t.value,
                            n = t.customProperties,
                            l = t.active,
                            r = t.disabled,
                            a = new Option(e, i, !1, l);
                        return n && (a.dataset.customProperties = n), a.disabled = r, a
                    }
                },
                bt = function (t) {
                    return void 0 === t && (t = !0), {
                        type: V,
                        active: t
                    }
                },
                xt = function (t, e) {
                    return {
                        type: U,
                        id: t,
                        highlighted: e
                    }
                },
                wt = function (t) {
                    var e = t.value,
                        i = t.id,
                        n = t.active,
                        l = t.disabled;
                    return {
                        type: q,
                        value: e,
                        id: i,
                        active: n,
                        disabled: l
                    }
                },
                _t = function (t) {
                    return {
                        type: "SET_IS_LOADING",
                        isLoading: t
                    }
                };

            function kt(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
                }
            }
            var St = "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style,
                At = {},
                Mt = function () {
                    var t, e, i;

                    function n(t, e) {
                        var i = this;
                        void 0 === t && (t = "[data-choice]"), void 0 === e && (e = {}), this.config = a.a.all([L, n.defaults.options, e], {
                            arrayMerge: function (t, e) {
                                return [].concat(e)
                            }
                        });
                        var l, r, o, s, c = (l = this.config, r = L, o = Object.keys(l).sort(), s = Object.keys(r).sort(), o.filter((function (t) {
                            return s.indexOf(t) < 0
                        })));
                        c.length && console.warn("Unknown config option(s) passed", c.join(", "));
                        var u = "string" == typeof t ? document.querySelector(t) : t;
                        if (!(u instanceof HTMLInputElement || u instanceof HTMLSelectElement)) throw TypeError("Expected one of the following types text|select-one|select-multiple");
                        if (this._isTextElement = u.type === rt, this._isSelectOneElement = u.type === at, this._isSelectMultipleElement = u.type === ot, this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement, this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled, ["auto", "always"].includes(this.config.renderSelectedChoices) || (this.config.renderSelectedChoices = "auto"), e.addItemFilter && "function" != typeof e.addItemFilter) {
                            var h = e.addItemFilter instanceof RegExp ? e.addItemFilter : new RegExp(e.addItemFilter);
                            this.config.addItemFilter = h.test.bind(h)
                        }
                        if (this._isTextElement ? this.passedElement = new gt({
                                element: u,
                                classNames: this.config.classNames,
                                delimiter: this.config.delimiter
                            }) : this.passedElement = new vt({
                                element: u,
                                classNames: this.config.classNames,
                                template: function (t) {
                                    return i._templates.option(t)
                                }
                            }), this.initialised = !1, this._store = new O, this._initialState = {}, this._currentState = {}, this._prevState = {}, this._currentValue = "", this._canSearch = this.config.searchEnabled, this._isScrollingOnIe = !1, this._highlightPosition = 0, this._wasTap = !0, this._placeholderValue = this._generatePlaceholderValue(), this._baseId = function (t, e) {
                                var i = t.id || t.name && t.name + "-" + b(2) || b(4);
                                return e + "-" + i.replace(/(:|\.|\[|\]|,)/g, "")
                            }(this.passedElement.element, "choices-"), this._direction = this.passedElement.dir, !this._direction) {
                            var d = window.getComputedStyle(this.passedElement.element).direction;
                            d !== window.getComputedStyle(document.documentElement).direction && (this._direction = d)
                        }
                        if (this._idNames = {
                                itemChoice: "item-choice"
                            }, this._presetGroups = this.passedElement.optionGroups, this._presetOptions = this.passedElement.options, this._presetChoices = this.config.choices, this._presetItems = this.config.items, this.passedElement.value && (this._presetItems = this._presetItems.concat(this.passedElement.value.split(this.config.delimiter))), this.passedElement.options && this.passedElement.options.forEach((function (t) {
                                i._presetChoices.push({
                                    value: t.value,
                                    label: t.innerHTML,
                                    selected: t.selected,
                                    disabled: t.disabled || t.parentNode.disabled,
                                    placeholder: "" === t.value || t.hasAttribute("placeholder"),
                                    customProperties: t.getAttribute("data-custom-properties")
                                })
                            })), this._render = this._render.bind(this), this._onFocus = this._onFocus.bind(this), this._onBlur = this._onBlur.bind(this), this._onKeyUp = this._onKeyUp.bind(this), this._onKeyDown = this._onKeyDown.bind(this), this._onClick = this._onClick.bind(this), this._onTouchMove = this._onTouchMove.bind(this), this._onTouchEnd = this._onTouchEnd.bind(this), this._onMouseDown = this._onMouseDown.bind(this), this._onMouseOver = this._onMouseOver.bind(this), this._onFormReset = this._onFormReset.bind(this), this._onAKey = this._onAKey.bind(this), this._onEnterKey = this._onEnterKey.bind(this), this._onEscapeKey = this._onEscapeKey.bind(this), this._onDirectionKey = this._onDirectionKey.bind(this), this._onDeleteKey = this._onDeleteKey.bind(this), this.passedElement.isActive) return this.config.silent || console.warn("Trying to initialise Choices on element already initialised"), void(this.initialised = !0);
                        this.init()
                    }
                    t = n, i = [{
                        key: "defaults",
                        get: function () {
                            return Object.preventExtensions({
                                get options() {
                                    return At
                                },
                                get templates() {
                                    return yt
                                }
                            })
                        }
                    }], (e = null) && kt(t.prototype, e), i && kt(t, i);
                    var r = n.prototype;
                    return r.init = function () {
                        if (!this.initialised) {
                            this._createTemplates(), this._createElements(), this._createStructure(), this._initialState = A(this._store.state), this._store.subscribe(this._render), this._render(), this._addEventListeners(), (!this.config.addItems || this.passedElement.element.hasAttribute("disabled")) && this.disable(), this.initialised = !0;
                            var t = this.config.callbackOnInit;
                            t && "function" == typeof t && t.call(this)
                        }
                    }, r.destroy = function () {
                        this.initialised && (this._removeEventListeners(), this.passedElement.reveal(), this.containerOuter.unwrap(this.passedElement.element), this.clearStore(), this._isSelectElement && (this.passedElement.options = this._presetOptions), this._templates = null, this.initialised = !1)
                    }, r.enable = function () {
                        return this.passedElement.isDisabled && this.passedElement.enable(), this.containerOuter.isDisabled && (this._addEventListeners(), this.input.enable(), this.containerOuter.enable()), this
                    }, r.disable = function () {
                        return this.passedElement.isDisabled || this.passedElement.disable(), this.containerOuter.isDisabled || (this._removeEventListeners(), this.input.disable(), this.containerOuter.disable()), this
                    }, r.highlightItem = function (t, e) {
                        if (void 0 === e && (e = !0), !t) return this;
                        var i = t.id,
                            n = t.groupId,
                            l = void 0 === n ? -1 : n,
                            r = t.value,
                            a = void 0 === r ? "" : r,
                            o = t.label,
                            s = void 0 === o ? "" : o,
                            c = l >= 0 ? this._store.getGroupById(l) : null;
                        return this._store.dispatch(xt(i, !0)), e && this.passedElement.triggerEvent(H, {
                            id: i,
                            value: a,
                            label: s,
                            groupValue: c && c.value ? c.value : null
                        }), this
                    }, r.unhighlightItem = function (t) {
                        if (!t) return this;
                        var e = t.id,
                            i = t.groupId,
                            n = void 0 === i ? -1 : i,
                            l = t.value,
                            r = void 0 === l ? "" : l,
                            a = t.label,
                            o = void 0 === a ? "" : a,
                            s = n >= 0 ? this._store.getGroupById(n) : null;
                        return this._store.dispatch(xt(e, !1)), this.passedElement.triggerEvent(H, {
                            id: e,
                            value: r,
                            label: o,
                            groupValue: s && s.value ? s.value : null
                        }), this
                    }, r.highlightAll = function () {
                        var t = this;
                        return this._store.items.forEach((function (e) {
                            return t.highlightItem(e)
                        })), this
                    }, r.unhighlightAll = function () {
                        var t = this;
                        return this._store.items.forEach((function (e) {
                            return t.unhighlightItem(e)
                        })), this
                    }, r.removeActiveItemsByValue = function (t) {
                        var e = this;
                        return this._store.activeItems.filter((function (e) {
                            return e.value === t
                        })).forEach((function (t) {
                            return e._removeItem(t)
                        })), this
                    }, r.removeActiveItems = function (t) {
                        var e = this;
                        return this._store.activeItems.filter((function (e) {
                            return e.id !== t
                        })).forEach((function (t) {
                            return e._removeItem(t)
                        })), this
                    }, r.removeHighlightedItems = function (t) {
                        var e = this;
                        return void 0 === t && (t = !1), this._store.highlightedActiveItems.forEach((function (i) {
                            e._removeItem(i), t && e._triggerChange(i.value)
                        })), this
                    }, r.showDropdown = function (t) {
                        var e = this;
                        return this.dropdown.isActive || requestAnimationFrame((function () {
                            e.dropdown.show(), e.containerOuter.open(e.dropdown.distanceFromTopWindow), !t && e._canSearch && e.input.focus(), e.passedElement.triggerEvent(D, {})
                        })), this
                    }, r.hideDropdown = function (t) {
                        var e = this;
                        return this.dropdown.isActive ? (requestAnimationFrame((function () {
                            e.dropdown.hide(), e.containerOuter.close(), !t && e._canSearch && (e.input.removeActiveDescendant(), e.input.blur()), e.passedElement.triggerEvent(I, {})
                        })), this) : this
                    }, r.getValue = function (t) {
                        void 0 === t && (t = !1);
                        var e = this._store.activeItems.reduce((function (e, i) {
                            var n = t ? i.value : i;
                            return e.push(n), e
                        }), []);
                        return this._isSelectOneElement ? e[0] : e
                    }, r.setValue = function (t) {
                        var e = this;
                        return this.initialised ? (t.forEach((function (t) {
                            return e._setChoiceOrItem(t)
                        })), this) : this
                    }, r.setChoiceByValue = function (t) {
                        var e = this;
                        return !this.initialised || this._isTextElement || (Array.isArray(t) ? t : [t]).forEach((function (t) {
                            return e._findAndSelectChoiceByValue(t)
                        })), this
                    }, r.setChoices = function (t, e, i, n) {
                        var l = this;
                        if (void 0 === t && (t = []), void 0 === e && (e = "value"), void 0 === i && (i = "label"), void 0 === n && (n = !1), !this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                        if ("string" != typeof e || !e) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                        if (n && this.clearChoices(), "function" == typeof t) {
                            var r = t(this);
                            if ("function" == typeof Promise && r instanceof Promise) return new Promise((function (t) {
                                return requestAnimationFrame(t)
                            })).then((function () {
                                return l._handleLoadingState(!0)
                            })).then((function () {
                                return r
                            })).then((function (t) {
                                return l.setChoices(t, e, i, n)
                            })).catch((function (t) {
                                l.config.silent || console.error(t)
                            })).then((function () {
                                return l._handleLoadingState(!1)
                            })).then((function () {
                                return l
                            }));
                            if (!Array.isArray(r)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: " + typeof r);
                            return this.setChoices(r, e, i, !1)
                        }
                        if (!Array.isArray(t)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                        return this.containerOuter.removeLoadingState(), this._startLoading(), t.forEach((function (t) {
                            t.choices ? l._addGroup({
                                id: parseInt(t.id, 10) || null,
                                group: t,
                                valueKey: e,
                                labelKey: i
                            }) : l._addChoice({
                                value: t[e],
                                label: t[i],
                                isSelected: t.selected,
                                isDisabled: t.disabled,
                                customProperties: t.customProperties,
                                placeholder: t.placeholder
                            })
                        })), this._stopLoading(), this
                    }, r.clearChoices = function () {
                        return this._store.dispatch({
                            type: X
                        }), this
                    }, r.clearStore = function () {
                        return this._store.dispatch({
                            type: "CLEAR_ALL"
                        }), this
                    }, r.clearInput = function () {
                        var t = !this._isSelectOneElement;
                        return this.input.clear(t), !this._isTextElement && this._canSearch && (this._isSearching = !1, this._store.dispatch(bt(!0))), this
                    }, r._render = function () {
                        if (!this._store.isLoading()) {
                            this._currentState = this._store.state;
                            var t = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items,
                                e = this._isSelectElement,
                                i = this._currentState.items !== this._prevState.items;
                            t && (e && this._renderChoices(), i && this._renderItems(), this._prevState = this._currentState)
                        }
                    }, r._renderChoices = function () {
                        var t = this,
                            e = this._store,
                            i = e.activeGroups,
                            n = e.activeChoices,
                            l = document.createDocumentFragment();
                        if (this.choiceList.clear(), this.config.resetScrollPosition && requestAnimationFrame((function () {
                                return t.choiceList.scrollToTop()
                            })), i.length >= 1 && !this._isSearching) {
                            var r = n.filter((function (t) {
                                return !0 === t.placeholder && -1 === t.groupId
                            }));
                            r.length >= 1 && (l = this._createChoicesFragment(r, l)), l = this._createGroupsFragment(i, n, l)
                        } else n.length >= 1 && (l = this._createChoicesFragment(n, l));
                        if (l.childNodes && l.childNodes.length > 0) {
                            var a = this._store.activeItems,
                                o = this._canAddItem(a, this.input.value);
                            o.response ? (this.choiceList.append(l), this._highlightChoice()) : this.choiceList.append(this._getTemplate("notice", o.notice))
                        } else {
                            var s, c;
                            this._isSearching ? (c = "function" == typeof this.config.noResultsText ? this.config.noResultsText() : this.config.noResultsText, s = this._getTemplate("notice", c, "no-results")) : (c = "function" == typeof this.config.noChoicesText ? this.config.noChoicesText() : this.config.noChoicesText, s = this._getTemplate("notice", c, "no-choices")), this.choiceList.append(s)
                        }
                    }, r._renderItems = function () {
                        var t = this._store.activeItems || [];
                        this.itemList.clear();
                        var e = this._createItemsFragment(t);
                        e.childNodes && this.itemList.append(e)
                    }, r._createGroupsFragment = function (t, e, i) {
                        var n = this;
                        return void 0 === i && (i = document.createDocumentFragment()), this.config.shouldSort && t.sort(this.config.sorter), t.forEach((function (t) {
                            var l = function (t) {
                                return e.filter((function (e) {
                                    return n._isSelectOneElement ? e.groupId === t.id : e.groupId === t.id && ("always" === n.config.renderSelectedChoices || !e.selected)
                                }))
                            }(t);
                            if (l.length >= 1) {
                                var r = n._getTemplate("choiceGroup", t);
                                i.appendChild(r), n._createChoicesFragment(l, i, !0)
                            }
                        })), i
                    }, r._createChoicesFragment = function (t, e, i) {
                        var n = this;
                        void 0 === e && (e = document.createDocumentFragment()), void 0 === i && (i = !1);
                        var l = this.config,
                            r = l.renderSelectedChoices,
                            a = l.searchResultLimit,
                            o = l.renderChoiceLimit,
                            s = this._isSearching ? S : this.config.sorter,
                            c = function (t) {
                                if ("auto" !== r || n._isSelectOneElement || !t.selected) {
                                    var i = n._getTemplate("choice", t, n.config.itemSelectText);
                                    e.appendChild(i)
                                }
                            },
                            u = t;
                        "auto" !== r || this._isSelectOneElement || (u = t.filter((function (t) {
                            return !t.selected
                        })));
                        var h = u.reduce((function (t, e) {
                                return e.placeholder ? t.placeholderChoices.push(e) : t.normalChoices.push(e), t
                            }), {
                                placeholderChoices: [],
                                normalChoices: []
                            }),
                            d = h.placeholderChoices,
                            f = h.normalChoices;
                        (this.config.shouldSort || this._isSearching) && f.sort(s);
                        var p = u.length,
                            g = this._isSelectOneElement ? [].concat(d, f) : f;
                        this._isSearching ? p = a : o && o > 0 && !i && (p = o);
                        for (var m = 0; m < p; m += 1) g[m] && c(g[m]);
                        return e
                    }, r._createItemsFragment = function (t, e) {
                        var i = this;
                        void 0 === e && (e = document.createDocumentFragment());
                        var n = this.config,
                            l = n.shouldSortItems,
                            r = n.sorter,
                            a = n.removeItemButton;
                        return l && !this._isSelectOneElement && t.sort(r), this._isTextElement ? this.passedElement.value = t : this.passedElement.options = t, t.forEach((function (t) {
                            var n = i._getTemplate("item", t, a);
                            e.appendChild(n)
                        })), e
                    }, r._triggerChange = function (t) {
                        null != t && this.passedElement.triggerEvent(j, {
                            value: t
                        })
                    }, r._selectPlaceholderChoice = function () {
                        var t = this._store.placeholderChoice;
                        t && (this._addItem({
                            value: t.value,
                            label: t.label,
                            choiceId: t.id,
                            groupId: t.groupId,
                            placeholder: t.placeholder
                        }), this._triggerChange(t.value))
                    }, r._handleButtonAction = function (t, e) {
                        if (t && e && this.config.removeItems && this.config.removeItemButton) {
                            var i = e.parentNode.getAttribute("data-id"),
                                n = t.find((function (t) {
                                    return t.id === parseInt(i, 10)
                                }));
                            this._removeItem(n), this._triggerChange(n.value), this._isSelectOneElement && this._selectPlaceholderChoice()
                        }
                    }, r._handleItemAction = function (t, e, i) {
                        var n = this;
                        if (void 0 === i && (i = !1), t && e && this.config.removeItems && !this._isSelectOneElement) {
                            var l = e.getAttribute("data-id");
                            t.forEach((function (t) {
                                t.id !== parseInt(l, 10) || t.highlighted ? !i && t.highlighted && n.unhighlightItem(t) : n.highlightItem(t)
                            })), this.input.focus()
                        }
                    }, r._handleChoiceAction = function (t, e) {
                        if (t && e) {
                            var i = e.dataset.id,
                                n = this._store.getChoiceById(i);
                            if (n) {
                                var l = t[0] && t[0].keyCode ? t[0].keyCode : null,
                                    r = this.dropdown.isActive;
                                n.keyCode = l, this.passedElement.triggerEvent(N, {
                                    choice: n
                                }), n.selected || n.disabled || this._canAddItem(t, n.value).response && (this._addItem({
                                    value: n.value,
                                    label: n.label,
                                    choiceId: n.id,
                                    groupId: n.groupId,
                                    customProperties: n.customProperties,
                                    placeholder: n.placeholder,
                                    keyCode: n.keyCode
                                }), this._triggerChange(n.value)), this.clearInput(), r && this._isSelectOneElement && (this.hideDropdown(!0), this.containerOuter.focus())
                            }
                        }
                    }, r._handleBackspace = function (t) {
                        if (this.config.removeItems && t) {
                            var e = t[t.length - 1],
                                i = t.some((function (t) {
                                    return t.highlighted
                                }));
                            this.config.editItems && !i && e ? (this.input.value = e.value, this.input.setWidth(), this._removeItem(e), this._triggerChange(e.value)) : (i || this.highlightItem(e, !1), this.removeHighlightedItems(!0))
                        }
                    }, r._startLoading = function () {
                        this._store.dispatch(_t(!0))
                    }, r._stopLoading = function () {
                        this._store.dispatch(_t(!1))
                    }, r._handleLoadingState = function (t) {
                        void 0 === t && (t = !0);
                        var e = this.itemList.getChild("." + this.config.classNames.placeholder);
                        t ? (this.disable(), this.containerOuter.addLoadingState(), this._isSelectOneElement ? e ? e.innerHTML = this.config.loadingText : (e = this._getTemplate("placeholder", this.config.loadingText), this.itemList.append(e)) : this.input.placeholder = this.config.loadingText) : (this.enable(), this.containerOuter.removeLoadingState(), this._isSelectOneElement ? e.innerHTML = this._placeholderValue || "" : this.input.placeholder = this._placeholderValue || "")
                    }, r._handleSearch = function (t) {
                        if (t && this.input.isFocussed) {
                            var e = this._store.choices,
                                i = this.config,
                                n = i.searchFloor,
                                l = i.searchChoices,
                                r = e.some((function (t) {
                                    return !t.active
                                }));
                            if (t && t.length >= n) {
                                var a = l ? this._searchChoices(t) : 0;
                                this.passedElement.triggerEvent(R, {
                                    value: t,
                                    resultCount: a
                                })
                            } else r && (this._isSearching = !1, this._store.dispatch(bt(!0)))
                        }
                    }, r._canAddItem = function (t, e) {
                        var i = !0,
                            n = "function" == typeof this.config.addItemText ? this.config.addItemText(e) : this.config.addItemText;
                        if (!this._isSelectOneElement) {
                            var l = function (t, e, i) {
                                return void 0 === i && (i = "value"), t.some((function (t) {
                                    return "string" == typeof e ? t[i] === e.trim() : t[i] === e
                                }))
                            }(t, e);
                            this.config.maxItemCount > 0 && this.config.maxItemCount <= t.length && (i = !1, n = "function" == typeof this.config.maxItemText ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText), !this.config.duplicateItemsAllowed && l && i && (i = !1, n = "function" == typeof this.config.uniqueItemText ? this.config.uniqueItemText(e) : this.config.uniqueItemText), this._isTextElement && this.config.addItems && i && "function" == typeof this.config.addItemFilter && !this.config.addItemFilter(e) && (i = !1, n = "function" == typeof this.config.customAddItemText ? this.config.customAddItemText(e) : this.config.customAddItemText)
                        }
                        return {
                            response: i,
                            notice: n
                        }
                    }, r._searchChoices = function (t) {
                        var e = "string" == typeof t ? t.trim() : t,
                            i = "string" == typeof this._currentValue ? this._currentValue.trim() : this._currentValue;
                        if (e.length < 1 && e === i + " ") return 0;
                        var n = this._store.searchableChoices,
                            r = e,
                            a = [].concat(this.config.searchFields),
                            o = Object.assign(this.config.fuseOptions, {
                                keys: a
                            }),
                            s = new l.a(n, o).search(r);
                        return this._currentValue = e, this._highlightPosition = 0, this._isSearching = !0, this._store.dispatch(function (t) {
                            return {
                                type: W,
                                results: t
                            }
                        }(s)), s.length
                    }, r._addEventListeners = function () {
                        var t = document.documentElement;
                        t.addEventListener("touchend", this._onTouchEnd, !0), this.containerOuter.element.addEventListener("keydown", this._onKeyDown, !0), this.containerOuter.element.addEventListener("mousedown", this._onMouseDown, !0), t.addEventListener("click", this._onClick, {
                            passive: !0
                        }), t.addEventListener("touchmove", this._onTouchMove, {
                            passive: !0
                        }), this.dropdown.element.addEventListener("mouseover", this._onMouseOver, {
                            passive: !0
                        }), this._isSelectOneElement && (this.containerOuter.element.addEventListener("focus", this._onFocus, {
                            passive: !0
                        }), this.containerOuter.element.addEventListener("blur", this._onBlur, {
                            passive: !0
                        })), this.input.element.addEventListener("keyup", this._onKeyUp, {
                            passive: !0
                        }), this.input.element.addEventListener("focus", this._onFocus, {
                            passive: !0
                        }), this.input.element.addEventListener("blur", this._onBlur, {
                            passive: !0
                        }), this.input.element.form && this.input.element.form.addEventListener("reset", this._onFormReset, {
                            passive: !0
                        }), this.input.addEventListeners()
                    }, r._removeEventListeners = function () {
                        var t = document.documentElement;
                        t.removeEventListener("touchend", this._onTouchEnd, !0), this.containerOuter.element.removeEventListener("keydown", this._onKeyDown, !0), this.containerOuter.element.removeEventListener("mousedown", this._onMouseDown, !0), t.removeEventListener("click", this._onClick), t.removeEventListener("touchmove", this._onTouchMove), this.dropdown.element.removeEventListener("mouseover", this._onMouseOver), this._isSelectOneElement && (this.containerOuter.element.removeEventListener("focus", this._onFocus), this.containerOuter.element.removeEventListener("blur", this._onBlur)), this.input.element.removeEventListener("keyup", this._onKeyUp), this.input.element.removeEventListener("focus", this._onFocus), this.input.element.removeEventListener("blur", this._onBlur), this.input.element.form && this.input.element.form.removeEventListener("reset", this._onFormReset), this.input.removeEventListeners()
                    }, r._onKeyDown = function (t) {
                        var e, i = t.target,
                            n = t.keyCode,
                            l = t.ctrlKey,
                            r = t.metaKey,
                            a = this._store.activeItems,
                            o = this.input.isFocussed,
                            s = this.dropdown.isActive,
                            c = this.itemList.hasChildren(),
                            u = String.fromCharCode(n),
                            h = K,
                            d = $,
                            f = Q,
                            p = J,
                            g = tt,
                            m = et,
                            v = it,
                            y = nt,
                            b = lt,
                            x = l || r;
                        !this._isTextElement && /[a-zA-Z0-9-_ ]/.test(u) && this.showDropdown();
                        var w = ((e = {})[p] = this._onAKey, e[f] = this._onEnterKey, e[g] = this._onEscapeKey, e[m] = this._onDirectionKey, e[y] = this._onDirectionKey, e[v] = this._onDirectionKey, e[b] = this._onDirectionKey, e[d] = this._onDeleteKey, e[h] = this._onDeleteKey, e);
                        w[n] && w[n]({
                            event: t,
                            target: i,
                            keyCode: n,
                            metaKey: r,
                            activeItems: a,
                            hasFocusedInput: o,
                            hasActiveDropdown: s,
                            hasItems: c,
                            hasCtrlDownKeyPressed: x
                        })
                    }, r._onKeyUp = function (t) {
                        var e = t.target,
                            i = t.keyCode,
                            n = this.input.value,
                            l = this._store.activeItems,
                            r = this._canAddItem(l, n),
                            a = K,
                            o = $;
                        if (this._isTextElement)
                            if (r.notice && n) {
                                var s = this._getTemplate("notice", r.notice);
                                this.dropdown.element.innerHTML = s.outerHTML, this.showDropdown(!0)
                            } else this.hideDropdown(!0);
                        else {
                            var c = (i === a || i === o) && !e.value,
                                u = !this._isTextElement && this._isSearching,
                                h = this._canSearch && r.response;
                            c && u ? (this._isSearching = !1, this._store.dispatch(bt(!0))) : h && this._handleSearch(this.input.value)
                        }
                        this._canSearch = this.config.searchEnabled
                    }, r._onAKey = function (t) {
                        var e = t.hasItems;
                        t.hasCtrlDownKeyPressed && e && (this._canSearch = !1, this.config.removeItems && !this.input.value && this.input.element === document.activeElement && this.highlightAll())
                    }, r._onEnterKey = function (t) {
                        var e = t.event,
                            i = t.target,
                            n = t.activeItems,
                            l = t.hasActiveDropdown,
                            r = Q,
                            a = i.hasAttribute("data-button");
                        if (this._isTextElement && i.value) {
                            var o = this.input.value;
                            this._canAddItem(n, o).response && (this.hideDropdown(!0), this._addItem({
                                value: o
                            }), this._triggerChange(o), this.clearInput())
                        }
                        if (a && (this._handleButtonAction(n, i), e.preventDefault()), l) {
                            var s = this.dropdown.getChild("." + this.config.classNames.highlightedState);
                            s && (n[0] && (n[0].keyCode = r), this._handleChoiceAction(n, s)), e.preventDefault()
                        } else this._isSelectOneElement && (this.showDropdown(), e.preventDefault())
                    }, r._onEscapeKey = function (t) {
                        t.hasActiveDropdown && (this.hideDropdown(!0), this.containerOuter.focus())
                    }, r._onDirectionKey = function (t) {
                        var e, i, n, l = t.event,
                            r = t.hasActiveDropdown,
                            a = t.keyCode,
                            o = t.metaKey,
                            s = it,
                            c = nt,
                            u = lt;
                        if (r || this._isSelectOneElement) {
                            this.showDropdown(), this._canSearch = !1;
                            var h, d = a === s || a === u ? 1 : -1,
                                f = "[data-choice-selectable]";
                            if (o || a === u || a === c) h = d > 0 ? this.dropdown.element.querySelector("[data-choice-selectable]:last-of-type") : this.dropdown.element.querySelector(f);
                            else {
                                var p = this.dropdown.element.querySelector("." + this.config.classNames.highlightedState);
                                h = p ? function (t, e, i) {
                                    if (void 0 === i && (i = 1), t instanceof Element && "string" == typeof e) {
                                        for (var n = (i > 0 ? "next" : "previous") + "ElementSibling", l = t[n]; l;) {
                                            if (l.matches(e)) return l;
                                            l = l[n]
                                        }
                                        return l
                                    }
                                }(p, f, d) : this.dropdown.element.querySelector(f)
                            }
                            h && (e = h, i = this.choiceList.element, void 0 === (n = d) && (n = 1), e && (n > 0 ? i.scrollTop + i.offsetHeight >= e.offsetTop + e.offsetHeight : e.offsetTop >= i.scrollTop) || this.choiceList.scrollToChildElement(h, d), this._highlightChoice(h)), l.preventDefault()
                        }
                    }, r._onDeleteKey = function (t) {
                        var e = t.event,
                            i = t.target,
                            n = t.hasFocusedInput,
                            l = t.activeItems;
                        !n || i.value || this._isSelectOneElement || (this._handleBackspace(l), e.preventDefault())
                    }, r._onTouchMove = function () {
                        this._wasTap && (this._wasTap = !1)
                    }, r._onTouchEnd = function (t) {
                        var e = (t || t.touches[0]).target;
                        this._wasTap && this.containerOuter.element.contains(e) && ((e === this.containerOuter.element || e === this.containerInner.element) && (this._isTextElement ? this.input.focus() : this._isSelectMultipleElement && this.showDropdown()), t.stopPropagation()), this._wasTap = !0
                    }, r._onMouseDown = function (t) {
                        var e = t.target;
                        if (e instanceof HTMLElement) {
                            if (St && this.choiceList.element.contains(e)) {
                                var i = this.choiceList.element.firstElementChild,
                                    n = "ltr" === this._direction ? t.offsetX >= i.offsetWidth : t.offsetX < i.offsetLeft;
                                this._isScrollingOnIe = n
                            }
                            if (e !== this.input.element) {
                                var l = e.closest("[data-button],[data-item],[data-choice]");
                                if (l instanceof HTMLElement) {
                                    var r = t.shiftKey,
                                        a = this._store.activeItems,
                                        o = l.dataset;
                                    "button" in o ? this._handleButtonAction(a, l) : "item" in o ? this._handleItemAction(a, l, r) : "choice" in o && this._handleChoiceAction(a, l)
                                }
                                t.preventDefault()
                            }
                        }
                    }, r._onMouseOver = function (t) {
                        var e = t.target;
                        e instanceof HTMLElement && "choice" in e.dataset && this._highlightChoice(e)
                    }, r._onClick = function (t) {
                        var e = t.target;
                        this.containerOuter.element.contains(e) ? this.dropdown.isActive || this.containerOuter.isDisabled ? this._isSelectOneElement && e !== this.input.element && !this.dropdown.element.contains(e) && this.hideDropdown() : this._isTextElement ? document.activeElement !== this.input.element && this.input.focus() : (this.showDropdown(), this.containerOuter.focus()) : (this._store.highlightedActiveItems.length > 0 && this.unhighlightAll(), this.containerOuter.removeFocusState(), this.hideDropdown(!0))
                    }, r._onFocus = function (t) {
                        var e, i = this,
                            n = t.target;
                        this.containerOuter.element.contains(n) && ((e = {}).text = function () {
                            n === i.input.element && i.containerOuter.addFocusState()
                        }, e["select-one"] = function () {
                            i.containerOuter.addFocusState(), n === i.input.element && i.showDropdown(!0)
                        }, e["select-multiple"] = function () {
                            n === i.input.element && (i.showDropdown(!0), i.containerOuter.addFocusState())
                        }, e)[this.passedElement.element.type]()
                    }, r._onBlur = function (t) {
                        var e = this,
                            i = t.target;
                        if (this.containerOuter.element.contains(i) && !this._isScrollingOnIe) {
                            var n, l = this._store.activeItems.some((function (t) {
                                return t.highlighted
                            }));
                            ((n = {}).text = function () {
                                i === e.input.element && (e.containerOuter.removeFocusState(), l && e.unhighlightAll(), e.hideDropdown(!0))
                            }, n["select-one"] = function () {
                                e.containerOuter.removeFocusState(), (i === e.input.element || i === e.containerOuter.element && !e._canSearch) && e.hideDropdown(!0)
                            }, n["select-multiple"] = function () {
                                i === e.input.element && (e.containerOuter.removeFocusState(), e.hideDropdown(!0), l && e.unhighlightAll())
                            }, n)[this.passedElement.element.type]()
                        } else this._isScrollingOnIe = !1, this.input.element.focus()
                    }, r._onFormReset = function () {
                        this._store.dispatch({
                            type: "RESET_TO",
                            state: this._initialState
                        })
                    }, r._highlightChoice = function (t) {
                        var e = this;
                        void 0 === t && (t = null);
                        var i = Array.from(this.dropdown.element.querySelectorAll("[data-choice-selectable]"));
                        if (i.length) {
                            var n = t;
                            Array.from(this.dropdown.element.querySelectorAll("." + this.config.classNames.highlightedState)).forEach((function (t) {
                                t.classList.remove(e.config.classNames.highlightedState), t.setAttribute("aria-selected", "false")
                            })), n ? this._highlightPosition = i.indexOf(n) : (n = i.length > this._highlightPosition ? i[this._highlightPosition] : i[i.length - 1]) || (n = i[0]), n.classList.add(this.config.classNames.highlightedState), n.setAttribute("aria-selected", "true"), this.passedElement.triggerEvent(B, {
                                el: n
                            }), this.dropdown.isActive && (this.input.setActiveDescendant(n.id), this.containerOuter.setActiveDescendant(n.id))
                        }
                    }, r._addItem = function (t) {
                        var e = t.value,
                            i = t.label,
                            n = void 0 === i ? null : i,
                            l = t.choiceId,
                            r = void 0 === l ? -1 : l,
                            a = t.groupId,
                            o = void 0 === a ? -1 : a,
                            s = t.customProperties,
                            c = void 0 === s ? null : s,
                            u = t.placeholder,
                            h = void 0 !== u && u,
                            d = t.keyCode,
                            f = void 0 === d ? null : d,
                            p = "string" == typeof e ? e.trim() : e,
                            g = f,
                            m = c,
                            v = this._store.items,
                            y = n || p,
                            b = r || -1,
                            x = o >= 0 ? this._store.getGroupById(o) : null,
                            w = v ? v.length + 1 : 1;
                        return this.config.prependValue && (p = this.config.prependValue + p.toString()), this.config.appendValue && (p += this.config.appendValue.toString()), this._store.dispatch(function (t) {
                            var e = t.value,
                                i = t.label,
                                n = t.id,
                                l = t.choiceId,
                                r = t.groupId,
                                a = t.customProperties,
                                o = t.placeholder,
                                s = t.keyCode;
                            return {
                                type: Z,
                                value: e,
                                label: i,
                                id: n,
                                choiceId: l,
                                groupId: r,
                                customProperties: a,
                                placeholder: o,
                                keyCode: s
                            }
                        }({
                            value: p,
                            label: y,
                            id: w,
                            choiceId: b,
                            groupId: o,
                            customProperties: c,
                            placeholder: h,
                            keyCode: g
                        })), this._isSelectOneElement && this.removeActiveItems(w), this.passedElement.triggerEvent(F, {
                            id: w,
                            value: p,
                            label: y,
                            customProperties: m,
                            groupValue: x && x.value ? x.value : void 0,
                            keyCode: g
                        }), this
                    }, r._removeItem = function (t) {
                        if (!t || !w("Object", t)) return this;
                        var e = t.id,
                            i = t.value,
                            n = t.label,
                            l = t.choiceId,
                            r = t.groupId,
                            a = r >= 0 ? this._store.getGroupById(r) : null;
                        return this._store.dispatch(function (t, e) {
                            return {
                                type: G,
                                id: t,
                                choiceId: e
                            }
                        }(e, l)), a && a.value ? this.passedElement.triggerEvent(z, {
                            id: e,
                            value: i,
                            label: n,
                            groupValue: a.value
                        }) : this.passedElement.triggerEvent(z, {
                            id: e,
                            value: i,
                            label: n
                        }), this
                    }, r._addChoice = function (t) {
                        var e = t.value,
                            i = t.label,
                            n = void 0 === i ? null : i,
                            l = t.isSelected,
                            r = void 0 !== l && l,
                            a = t.isDisabled,
                            o = void 0 !== a && a,
                            s = t.groupId,
                            c = void 0 === s ? -1 : s,
                            u = t.customProperties,
                            h = void 0 === u ? null : u,
                            d = t.placeholder,
                            f = void 0 !== d && d,
                            p = t.keyCode,
                            g = void 0 === p ? null : p;
                        if (null != e) {
                            var m = this._store.choices,
                                v = n || e,
                                y = m ? m.length + 1 : 1,
                                b = this._baseId + "-" + this._idNames.itemChoice + "-" + y;
                            this._store.dispatch(function (t) {
                                var e = t.value,
                                    i = t.label,
                                    n = t.id,
                                    l = t.groupId,
                                    r = t.disabled,
                                    a = t.elementId,
                                    o = t.customProperties,
                                    s = t.placeholder,
                                    c = t.keyCode;
                                return {
                                    type: Y,
                                    value: e,
                                    label: i,
                                    id: n,
                                    groupId: l,
                                    disabled: r,
                                    elementId: a,
                                    customProperties: o,
                                    placeholder: s,
                                    keyCode: c
                                }
                            }({
                                id: y,
                                groupId: c,
                                elementId: b,
                                value: e,
                                label: v,
                                disabled: o,
                                customProperties: h,
                                placeholder: f,
                                keyCode: g
                            })), r && this._addItem({
                                value: e,
                                label: v,
                                choiceId: y,
                                customProperties: h,
                                placeholder: f,
                                keyCode: g
                            })
                        }
                    }, r._addGroup = function (t) {
                        var e = this,
                            i = t.group,
                            n = t.id,
                            l = t.valueKey,
                            r = void 0 === l ? "value" : l,
                            a = t.labelKey,
                            o = void 0 === a ? "label" : a,
                            s = w("Object", i) ? i.choices : Array.from(i.getElementsByTagName("OPTION")),
                            c = n || Math.floor((new Date).valueOf() * Math.random()),
                            u = !!i.disabled && i.disabled;
                        s ? (this._store.dispatch(wt({
                            value: i.label,
                            id: c,
                            active: !0,
                            disabled: u
                        })), s.forEach((function (t) {
                            var i = t.disabled || t.parentNode && t.parentNode.disabled;
                            e._addChoice({
                                value: t[r],
                                label: w("Object", t) ? t[o] : t.innerHTML,
                                isSelected: t.selected,
                                isDisabled: i,
                                groupId: c,
                                customProperties: t.customProperties,
                                placeholder: t.placeholder
                            })
                        }))) : this._store.dispatch(wt({
                            value: i.label,
                            id: i.id,
                            active: !1,
                            disabled: i.disabled
                        }))
                    }, r._getTemplate = function (t) {
                        var e;
                        if (!t) return null;
                        for (var i = this.config.classNames, n = arguments.length, l = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) l[r - 1] = arguments[r];
                        return (e = this._templates[t]).call.apply(e, [this, i].concat(l))
                    }, r._createTemplates = function () {
                        var t = this.config.callbackOnCreateTemplates,
                            e = {};
                        t && "function" == typeof t && (e = t.call(this, k)), this._templates = a()(yt, e)
                    }, r._createElements = function () {
                        this.containerOuter = new st({
                            element: this._getTemplate("containerOuter", this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        }), this.containerInner = new st({
                            element: this._getTemplate("containerInner"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        }), this.input = new ut({
                            element: this._getTemplate("input", this._placeholderValue),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            preventPaste: !this.config.paste
                        }), this.choiceList = new ht({
                            element: this._getTemplate("choiceList", this._isSelectOneElement)
                        }), this.itemList = new ht({
                            element: this._getTemplate("itemList", this._isSelectOneElement)
                        }), this.dropdown = new P({
                            element: this._getTemplate("dropdown"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type
                        })
                    }, r._createStructure = function () {
                        this.passedElement.conceal(), this.containerInner.wrap(this.passedElement.element), this.containerOuter.wrap(this.containerInner.element), this._isSelectOneElement ? this.input.placeholder = this.config.searchPlaceholderValue || "" : this._placeholderValue && (this.input.placeholder = this._placeholderValue, this.input.setWidth()), this.containerOuter.element.appendChild(this.containerInner.element), this.containerOuter.element.appendChild(this.dropdown.element), this.containerInner.element.appendChild(this.itemList.element), this._isTextElement || this.dropdown.element.appendChild(this.choiceList.element), this._isSelectOneElement ? this.config.searchEnabled && this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild) : this.containerInner.element.appendChild(this.input.element), this._isSelectElement && (this._highlightPosition = 0, this._isSearching = !1, this._startLoading(), this._presetGroups.length ? this._addPredefinedGroups(this._presetGroups) : this._addPredefinedChoices(this._presetChoices), this._stopLoading()), this._isTextElement && this._addPredefinedItems(this._presetItems)
                    }, r._addPredefinedGroups = function (t) {
                        var e = this,
                            i = this.passedElement.placeholderOption;
                        i && "SELECT" === i.parentNode.tagName && this._addChoice({
                            value: i.value,
                            label: i.innerHTML,
                            isSelected: i.selected,
                            isDisabled: i.disabled,
                            placeholder: !0
                        }), t.forEach((function (t) {
                            return e._addGroup({
                                group: t,
                                id: t.id || null
                            })
                        }))
                    }, r._addPredefinedChoices = function (t) {
                        var e = this;
                        this.config.shouldSort && t.sort(this.config.sorter);
                        var i = t.some((function (t) {
                                return t.selected
                            })),
                            n = t.findIndex((function (t) {
                                return void 0 === t.disabled || !t.disabled
                            }));
                        t.forEach((function (t, l) {
                            var r = t.value,
                                a = t.label,
                                o = t.customProperties,
                                s = t.placeholder;
                            if (e._isSelectElement)
                                if (t.choices) e._addGroup({
                                    group: t,
                                    id: t.id || null
                                });
                                else {
                                    var c = !(!e._isSelectOneElement || i || l !== n) || t.selected,
                                        u = t.disabled;
                                    e._addChoice({
                                        value: r,
                                        label: a,
                                        isSelected: c,
                                        isDisabled: u,
                                        customProperties: o,
                                        placeholder: s
                                    })
                                }
                            else e._addChoice({
                                value: r,
                                label: a,
                                isSelected: t.selected,
                                isDisabled: t.disabled,
                                customProperties: o,
                                placeholder: s
                            })
                        }))
                    }, r._addPredefinedItems = function (t) {
                        var e = this;
                        t.forEach((function (t) {
                            "object" == typeof t && t.value && e._addItem({
                                value: t.value,
                                label: t.label,
                                choiceId: t.id,
                                customProperties: t.customProperties,
                                placeholder: t.placeholder
                            }), "string" == typeof t && e._addItem({
                                value: t
                            })
                        }))
                    }, r._setChoiceOrItem = function (t) {
                        var e = this;
                        ({
                            object: function () {
                                t.value && (e._isTextElement ? e._addItem({
                                    value: t.value,
                                    label: t.label,
                                    choiceId: t.id,
                                    customProperties: t.customProperties,
                                    placeholder: t.placeholder
                                }) : e._addChoice({
                                    value: t.value,
                                    label: t.label,
                                    isSelected: !0,
                                    isDisabled: !1,
                                    customProperties: t.customProperties,
                                    placeholder: t.placeholder
                                }))
                            },
                            string: function () {
                                e._isTextElement ? e._addItem({
                                    value: t
                                }) : e._addChoice({
                                    value: t,
                                    label: t,
                                    isSelected: !0,
                                    isDisabled: !1
                                })
                            }
                        })[x(t).toLowerCase()]()
                    }, r._findAndSelectChoiceByValue = function (t) {
                        var e = this,
                            i = this._store.choices.find((function (i) {
                                return e.config.valueComparer(i.value, t)
                            }));
                        i && !i.selected && this._addItem({
                            value: i.value,
                            label: i.label,
                            choiceId: i.id,
                            groupId: i.groupId,
                            customProperties: i.customProperties,
                            placeholder: i.placeholder,
                            keyCode: i.keyCode
                        })
                    }, r._generatePlaceholderValue = function () {
                        if (this._isSelectElement) {
                            var t = this.passedElement.placeholderOption;
                            return !!t && t.text
                        }
                        var e = this.config,
                            i = e.placeholder,
                            n = e.placeholderValue,
                            l = this.passedElement.element.dataset;
                        if (i) {
                            if (n) return n;
                            if (l.placeholder) return l.placeholder
                        }
                        return !1
                    }, n
                }();
            e.default = Mt
        }]).default
    }, t.exports = n()
}, , function (t, e, i) {
    "use strict";
    var n = i(6),
        l = i(144)(1);
    n(n.P + n.F * !i(147)([].map, !0), "Array", {
        map: function (t) {
            return l(this, t, arguments[1])
        }
    })
}, function (t, e, i) {
    var n = i(41),
        l = i(64),
        r = i(26),
        a = i(22),
        o = i(145);
    t.exports = function (t, e) {
        var i = 1 == t,
            s = 2 == t,
            c = 3 == t,
            u = 4 == t,
            h = 6 == t,
            d = 5 == t || h,
            f = e || o;
        return function (e, o, p) {
            for (var g, m, v = r(e), y = l(v), b = n(o, p, 3), x = a(y.length), w = 0, _ = i ? f(e, x) : s ? f(e, 0) : void 0; x > w; w++)
                if ((d || w in y) && (m = b(g = y[w], w, v), t))
                    if (i) _[w] = m;
                    else if (m) switch (t) {
                case 3:
                    return !0;
                case 5:
                    return g;
                case 6:
                    return w;
                case 2:
                    _.push(g)
            } else if (u) return !1;
            return h ? -1 : c || u ? u : _
        }
    }
}, function (t, e, i) {
    var n = i(146);
    t.exports = function (t, e) {
        return new(n(t))(e)
    }
}, function (t, e, i) {
    var n = i(11),
        l = i(65),
        r = i(0)("species");
    t.exports = function (t) {
        var e;
        return l(t) && ("function" != typeof (e = t.constructor) || e !== Array && !l(e.prototype) || (e = void 0), n(e) && null === (e = e[r]) && (e = void 0)), void 0 === e ? Array : e
    }
}, function (t, e, i) {
    "use strict";
    var n = i(3);
    t.exports = function (t, e) {
        return !!t && n((function () {
            e ? t.call(null, (function () {}), 1) : t.call(null)
        }))
    }
}, function (t, e, i) {
    "use strict";
    var n = i(27),
        l = i(105);
    n({
        target: "Array",
        proto: !0,
        forced: [].forEach != l
    }, {
        forEach: l
    })
}, function (t, e, i) {
    var n = i(15),
        l = i(150),
        r = i(95),
        a = i(31);
    t.exports = function (t, e) {
        for (var i = l(e), o = a.f, s = r.f, c = 0; c < i.length; c++) {
            var u = i[c];
            n(t, u) || o(t, u, s(e, u))
        }
    }
}, function (t, e, i) {
    var n = i(73),
        l = i(152),
        r = i(103),
        a = i(16);
    t.exports = n("Reflect", "ownKeys") || function (t) {
        var e = l.f(a(t)),
            i = r.f;
        return i ? e.concat(i(t)) : e
    }
}, function (t, e, i) {
    var n = i(1);
    t.exports = n
}, function (t, e, i) {
    var n = i(102),
        l = i(74).concat("length", "prototype");
    e.f = Object.getOwnPropertyNames || function (t) {
        return n(t, l)
    }
}, function (t, e, i) {
    var n = i(52),
        l = i(37),
        r = i(154),
        a = function (t) {
            return function (e, i, a) {
                var o, s = n(e),
                    c = l(s.length),
                    u = r(a, c);
                if (t && i != i) {
                    for (; c > u;)
                        if ((o = s[u++]) != o) return !0
                } else
                    for (; c > u; u++)
                        if ((t || u in s) && s[u] === i) return t || u || 0;
                return !t && -1
            }
        };
    t.exports = {
        includes: a(!0),
        indexOf: a(!1)
    }
}, function (t, e, i) {
    var n = i(55),
        l = Math.max,
        r = Math.min;
    t.exports = function (t, e) {
        var i = n(t);
        return i < 0 ? l(i + e, 0) : r(i, e)
    }
}, function (t, e, i) {
    var n = i(14),
        l = i(156),
        r = i(9)("species");
    t.exports = function (t, e) {
        var i;
        return l(t) && ("function" != typeof (i = t.constructor) || i !== Array && !l(i.prototype) ? n(i) && null === (i = i[r]) && (i = void 0) : i = void 0), new(void 0 === i ? Array : i)(0 === e ? 0 : e)
    }
}, function (t, e, i) {
    var n = i(42);
    t.exports = Array.isArray || function (t) {
        return "Array" == n(t)
    }
}, function (t, e, i) {
    var n = i(73);
    t.exports = n("navigator", "userAgent") || ""
}, function (t, e, i) {
    var n = i(108);
    t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator
}, function (t, e, i) {
    var n = i(1),
        l = i(110),
        r = i(105),
        a = i(24);
    for (var o in l) {
        var s = n[o],
            c = s && s.prototype;
        if (c && c.forEach !== r) try {
            a(c, "forEach", r)
        } catch (t) {
            c.forEach = r
        }
    }
}, function (t, e, i) {
    "use strict";
    var n = i(27),
        l = i(75).filter;
    n({
        target: "Array",
        proto: !0,
        forced: !i(161)("filter")
    }, {
        filter: function (t) {
            return l(this, t, arguments.length > 1 ? arguments[1] : void 0)
        }
    })
}, function (t, e, i) {
    var n = i(4),
        l = i(9),
        r = i(76),
        a = l("species");
    t.exports = function (t) {
        return r >= 51 || !n((function () {
            var e = [];
            return (e.constructor = {})[a] = function () {
                return {
                    foo: 1
                }
            }, 1 !== e[t](Boolean).foo
        }))
    }
}, function (t, e, i) {
    var n = i(9),
        l = i(112),
        r = i(31),
        a = n("unscopables"),
        o = Array.prototype;
    null == o[a] && r.f(o, a, {
        configurable: !0,
        value: l(null)
    }), t.exports = function (t) {
        o[a][t] = !0
    }
}, function (t, e, i) {
    var n = i(30),
        l = i(31),
        r = i(16),
        a = i(113);
    t.exports = n ? Object.defineProperties : function (t, e) {
        r(t);
        for (var i, n = a(e), o = n.length, s = 0; o > s;) l.f(t, i = n[s++], e[i]);
        return t
    }
}, function (t, e, i) {
    var n = i(73);
    t.exports = n("document", "documentElement")
}, function (t, e, i) {
    "use strict";
    var n = i(115).IteratorPrototype,
        l = i(112),
        r = i(66),
        a = i(77),
        o = i(44),
        s = function () {
            return this
        };
    t.exports = function (t, e, i) {
        var c = e + " Iterator";
        return t.prototype = l(n, {
            next: r(1, i)
        }), a(t, c, !1, !0), o[c] = s, t
    }
}, function (t, e, i) {
    var n = i(4);
    t.exports = !n((function () {
        function t() {}
        return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype
    }))
}, function (t, e, i) {
    var n = i(14);
    t.exports = function (t) {
        if (!n(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
        return t
    }
}, function (t, e, i) {
    var n = i(27),
        l = i(169);
    n({
        target: "Object",
        stat: !0,
        forced: Object.assign !== l
    }, {
        assign: l
    })
}, function (t, e, i) {
    "use strict";
    var n = i(30),
        l = i(4),
        r = i(113),
        a = i(103),
        o = i(96),
        s = i(35),
        c = i(53),
        u = Object.assign,
        h = Object.defineProperty;
    t.exports = !u || l((function () {
        if (n && 1 !== u({
                b: 1
            }, u(h({}, "a", {
                enumerable: !0,
                get: function () {
                    h(this, "b", {
                        value: 3,
                        enumerable: !1
                    })
                }
            }), {
                b: 2
            })).b) return !0;
        var t = {},
            e = {},
            i = Symbol(),
            l = "abcdefghijklmnopqrst";
        return t[i] = 7, l.split("").forEach((function (t) {
            e[t] = t
        })), 7 != u({}, t)[i] || r(u({}, e)).join("") != l
    })) ? function (t, e) {
        for (var i = s(t), l = arguments.length, u = 1, h = a.f, d = o.f; l > u;)
            for (var f, p = c(arguments[u++]), g = h ? r(p).concat(h(p)) : r(p), m = g.length, v = 0; m > v;) f = g[v++], n && !d.call(p, f) || (i[f] = p[f]);
        return i
    } : u
}, function (t, e, i) {
    var n = i(78),
        l = i(36),
        r = i(171);
    n || l(Object.prototype, "toString", r, {
        unsafe: !0
    })
}, function (t, e, i) {
    "use strict";
    var n = i(78),
        l = i(118);
    t.exports = n ? {}.toString : function () {
        return "[object " + l(this) + "]"
    }
}, function (t, e, i) {
    var n = i(27),
        l = i(173);
    n({
        global: !0,
        forced: parseInt != l
    }, {
        parseInt: l
    })
}, function (t, e, i) {
    var n = i(1),
        l = i(174).trim,
        r = i(119),
        a = n.parseInt,
        o = /^[+-]?0[Xx]/,
        s = 8 !== a(r + "08") || 22 !== a(r + "0x16");
    t.exports = s ? function (t, e) {
        var i = l(String(t));
        return a(i, e >>> 0 || (o.test(i) ? 16 : 10))
    } : a
}, function (t, e, i) {
    var n = i(34),
        l = "[" + i(119) + "]",
        r = RegExp("^" + l + l + "*"),
        a = RegExp(l + l + "*$"),
        o = function (t) {
            return function (e) {
                var i = String(n(e));
                return 1 & t && (i = i.replace(r, "")), 2 & t && (i = i.replace(a, "")), i
            }
        };
    t.exports = {
        start: o(1),
        end: o(2),
        trim: o(3)
    }
}, function (t, e, i) {
    "use strict";
    var n = i(120).charAt,
        l = i(43),
        r = i(114),
        a = "String Iterator",
        o = l.set,
        s = l.getterFor(a);
    r(String, "String", (function (t) {
        o(this, {
            type: a,
            string: String(t),
            index: 0
        })
    }), (function () {
        var t, e = s(this),
            i = e.string,
            l = e.index;
        return l >= i.length ? {
            value: void 0,
            done: !0
        } : (t = n(i, l), e.index += t.length, {
            value: t,
            done: !1
        })
    }))
}, function (t, e, i) {
    "use strict";
    var n, l = i(1),
        r = i(121),
        a = i(79),
        o = i(178),
        s = i(184),
        c = i(14),
        u = i(43).enforce,
        h = i(101),
        d = !l.ActiveXObject && "ActiveXObject" in l,
        f = Object.isExtensible,
        p = function (t) {
            return function () {
                return t(this, arguments.length ? arguments[0] : void 0)
            }
        },
        g = t.exports = o("WeakMap", p, s);
    if (h && d) {
        n = s.getConstructor(p, "WeakMap", !0), a.REQUIRED = !0;
        var m = g.prototype,
            v = m.delete,
            y = m.has,
            b = m.get,
            x = m.set;
        r(m, {
            delete: function (t) {
                if (c(t) && !f(t)) {
                    var e = u(this);
                    return e.frozen || (e.frozen = new n), v.call(this, t) || e.frozen.delete(t)
                }
                return v.call(this, t)
            },
            has: function (t) {
                if (c(t) && !f(t)) {
                    var e = u(this);
                    return e.frozen || (e.frozen = new n), y.call(this, t) || e.frozen.has(t)
                }
                return y.call(this, t)
            },
            get: function (t) {
                if (c(t) && !f(t)) {
                    var e = u(this);
                    return e.frozen || (e.frozen = new n), y.call(this, t) ? b.call(this, t) : e.frozen.get(t)
                }
                return b.call(this, t)
            },
            set: function (t, e) {
                if (c(t) && !f(t)) {
                    var i = u(this);
                    i.frozen || (i.frozen = new n), y.call(this, t) ? x.call(this, t, e) : i.frozen.set(t, e)
                } else x.call(this, t, e);
                return this
            }
        })
    }
}, function (t, e, i) {
    var n = i(4);
    t.exports = !n((function () {
        return Object.isExtensible(Object.preventExtensions({}))
    }))
}, function (t, e, i) {
    "use strict";
    var n = i(27),
        l = i(1),
        r = i(104),
        a = i(36),
        o = i(79),
        s = i(122),
        c = i(123),
        u = i(14),
        h = i(4),
        d = i(182),
        f = i(77),
        p = i(183);
    t.exports = function (t, e, i) {
        var g = -1 !== t.indexOf("Map"),
            m = -1 !== t.indexOf("Weak"),
            v = g ? "set" : "add",
            y = l[t],
            b = y && y.prototype,
            x = y,
            w = {},
            _ = function (t) {
                var e = b[t];
                a(b, t, "add" == t ? function (t) {
                    return e.call(this, 0 === t ? 0 : t), this
                } : "delete" == t ? function (t) {
                    return !(m && !u(t)) && e.call(this, 0 === t ? 0 : t)
                } : "get" == t ? function (t) {
                    return m && !u(t) ? void 0 : e.call(this, 0 === t ? 0 : t)
                } : "has" == t ? function (t) {
                    return !(m && !u(t)) && e.call(this, 0 === t ? 0 : t)
                } : function (t, i) {
                    return e.call(this, 0 === t ? 0 : t, i), this
                })
            };
        if (r(t, "function" != typeof y || !(m || b.forEach && !h((function () {
                (new y).entries().next()
            }))))) x = i.getConstructor(e, t, g, v), o.REQUIRED = !0;
        else if (r(t, !0)) {
            var k = new x,
                S = k[v](m ? {} : -0, 1) != k,
                A = h((function () {
                    k.has(1)
                })),
                M = d((function (t) {
                    new y(t)
                })),
                C = !m && h((function () {
                    for (var t = new y, e = 5; e--;) t[v](e, e);
                    return !t.has(-0)
                }));
            M || ((x = e((function (e, i) {
                c(e, x, t);
                var n = p(new y, e, x);
                return null != i && s(i, n[v], {
                    that: n,
                    AS_ENTRIES: g
                }), n
            }))).prototype = b, b.constructor = x), (A || C) && (_("delete"), _("has"), g && _("get")), (C || S) && _(v), m && b.clear && delete b.clear
        }
        return w[t] = x, n({
            global: !0,
            forced: x != y
        }, w), f(x, t), m || i.setStrong(x, t, g), x
    }
}, function (t, e, i) {
    var n = i(9),
        l = i(44),
        r = n("iterator"),
        a = Array.prototype;
    t.exports = function (t) {
        return void 0 !== t && (l.Array === t || a[r] === t)
    }
}, function (t, e, i) {
    var n = i(118),
        l = i(44),
        r = i(9)("iterator");
    t.exports = function (t) {
        if (null != t) return t[r] || t["@@iterator"] || l[n(t)]
    }
}, function (t, e, i) {
    var n = i(16);
    t.exports = function (t) {
        var e = t.return;
        if (void 0 !== e) return n(e.call(t)).value
    }
}, function (t, e, i) {
    var n = i(9)("iterator"),
        l = !1;
    try {
        var r = 0,
            a = {
                next: function () {
                    return {
                        done: !!r++
                    }
                },
                return: function () {
                    l = !0
                }
            };
        a[n] = function () {
            return this
        }, Array.from(a, (function () {
            throw 2
        }))
    } catch (t) {}
    t.exports = function (t, e) {
        if (!e && !l) return !1;
        var i = !1;
        try {
            var r = {};
            r[n] = function () {
                return {
                    next: function () {
                        return {
                            done: i = !0
                        }
                    }
                }
            }, t(r)
        } catch (t) {}
        return i
    }
}, function (t, e, i) {
    var n = i(14),
        l = i(117);
    t.exports = function (t, e, i) {
        var r, a;
        return l && "function" == typeof (r = e.constructor) && r !== i && n(a = r.prototype) && a !== i.prototype && l(t, a), t
    }
}, function (t, e, i) {
    "use strict";
    var n = i(121),
        l = i(79).getWeakData,
        r = i(16),
        a = i(14),
        o = i(123),
        s = i(122),
        c = i(75),
        u = i(15),
        h = i(43),
        d = h.set,
        f = h.getterFor,
        p = c.find,
        g = c.findIndex,
        m = 0,
        v = function (t) {
            return t.frozen || (t.frozen = new y)
        },
        y = function () {
            this.entries = []
        },
        b = function (t, e) {
            return p(t.entries, (function (t) {
                return t[0] === e
            }))
        };
    y.prototype = {
        get: function (t) {
            var e = b(this, t);
            if (e) return e[1]
        },
        has: function (t) {
            return !!b(this, t)
        },
        set: function (t, e) {
            var i = b(this, t);
            i ? i[1] = e : this.entries.push([t, e])
        },
        delete: function (t) {
            var e = g(this.entries, (function (e) {
                return e[0] === t
            }));
            return ~e && this.entries.splice(e, 1), !!~e
        }
    }, t.exports = {
        getConstructor: function (t, e, i, c) {
            var h = t((function (t, n) {
                    o(t, h, e), d(t, {
                        type: e,
                        id: m++,
                        frozen: void 0
                    }), null != n && s(n, t[c], {
                        that: t,
                        AS_ENTRIES: i
                    })
                })),
                p = f(e),
                g = function (t, e, i) {
                    var n = p(t),
                        a = l(r(e), !0);
                    return !0 === a ? v(n).set(e, i) : a[n.id] = i, t
                };
            return n(h.prototype, {
                delete: function (t) {
                    var e = p(this);
                    if (!a(t)) return !1;
                    var i = l(t);
                    return !0 === i ? v(e).delete(t) : i && u(i, e.id) && delete i[e.id]
                },
                has: function (t) {
                    var e = p(this);
                    if (!a(t)) return !1;
                    var i = l(t);
                    return !0 === i ? v(e).has(t) : i && u(i, e.id)
                }
            }), n(h.prototype, i ? {
                get: function (t) {
                    var e = p(this);
                    if (a(t)) {
                        var i = l(t);
                        return !0 === i ? v(e).get(t) : i ? i[e.id] : void 0
                    }
                },
                set: function (t, e) {
                    return g(this, t, e)
                }
            } : {
                add: function (t) {
                    return g(this, t, !0)
                }
            }), h
        }
    }
}, function (t, e, i) {
    var n = i(1),
        l = i(110),
        r = i(111),
        a = i(24),
        o = i(9),
        s = o("iterator"),
        c = o("toStringTag"),
        u = r.values;
    for (var h in l) {
        var d = n[h],
            f = d && d.prototype;
        if (f) {
            if (f[s] !== u) try {
                a(f, s, u)
            } catch (t) {
                f[s] = u
            }
            if (f[c] || a(f, c, h), l[h])
                for (var p in r)
                    if (f[p] !== r[p]) try {
                        a(f, p, r[p])
                    } catch (t) {
                        f[p] = r[p]
                    }
        }
    }
}, function (t, e, i) {
    "use strict";
    var n = i(27),
        l = i(187).left,
        r = i(109),
        a = i(76),
        o = i(188);
    n({
        target: "Array",
        proto: !0,
        forced: !r("reduce") || !o && a > 79 && a < 83
    }, {
        reduce: function (t) {
            return l(this, t, arguments.length, arguments.length > 1 ? arguments[1] : void 0)
        }
    })
}, function (t, e, i) {
    var n = i(107),
        l = i(35),
        r = i(53),
        a = i(37),
        o = function (t) {
            return function (e, i, o, s) {
                n(i);
                var c = l(e),
                    u = r(c),
                    h = a(c.length),
                    d = t ? h - 1 : 0,
                    f = t ? -1 : 1;
                if (o < 2)
                    for (;;) {
                        if (d in u) {
                            s = u[d], d += f;
                            break
                        }
                        if (d += f, t ? d < 0 : h <= d) throw TypeError("Reduce of empty array with no initial value")
                    }
                for (; t ? d >= 0 : h > d; d += f) d in u && (s = i(s, u[d], d, c));
                return s
            }
        };
    t.exports = {
        left: o(!1),
        right: o(!0)
    }
}, function (t, e, i) {
    var n = i(42),
        l = i(1);
    t.exports = "process" == n(l.process)
}, function (t, e, i) {
    var n = i(30),
        l = i(31).f,
        r = Function.prototype,
        a = r.toString,
        o = /^\s*function ([^ (]*)/,
        s = "name";
    n && !(s in r) && l(r, s, {
        configurable: !0,
        get: function () {
            try {
                return a.call(this).match(o)[1]
            } catch (t) {
                return ""
            }
        }
    })
}, function (t, e, i) {
    "use strict";
    var n = i(16);
    t.exports = function () {
        var t = n(this),
            e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e
    }
}, function (t, e, i) {
    "use strict";
    var n = i(4);

    function l(t, e) {
        return RegExp(t, e)
    }
    e.UNSUPPORTED_Y = n((function () {
        var t = l("a", "y");
        return t.lastIndex = 2, null != t.exec("abcd")
    })), e.BROKEN_CARET = n((function () {
        var t = l("^r", "gy");
        return t.lastIndex = 2, null != t.exec("str")
    }))
}, function (t, e, i) {
    "use strict";
    var n = i(125),
        l = i(16),
        r = i(37),
        a = i(34),
        o = i(126),
        s = i(127);
    n("match", 1, (function (t, e, i) {
        return [function (e) {
            var i = a(this),
                n = null == e ? void 0 : e[t];
            return void 0 !== n ? n.call(e, i) : new RegExp(e)[t](String(i))
        }, function (t) {
            var n = i(e, t, this);
            if (n.done) return n.value;
            var a = l(t),
                c = String(this);
            if (!a.global) return s(a, c);
            var u = a.unicode;
            a.lastIndex = 0;
            for (var h, d = [], f = 0; null !== (h = s(a, c));) {
                var p = String(h[0]);
                d[f] = p, "" === p && (a.lastIndex = o(c, r(a.lastIndex), u)), f++
            }
            return 0 === f ? null : d
        }]
    }))
}, function (t, e, i) {
    "use strict";
    var n = i(125),
        l = i(16),
        r = i(37),
        a = i(55),
        o = i(34),
        s = i(126),
        c = i(194),
        u = i(127),
        h = Math.max,
        d = Math.min;
    n("replace", 2, (function (t, e, i, n) {
        var f = n.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,
            p = n.REPLACE_KEEPS_$0,
            g = f ? "$" : "$0";
        return [function (i, n) {
            var l = o(this),
                r = null == i ? void 0 : i[t];
            return void 0 !== r ? r.call(i, l, n) : e.call(String(l), i, n)
        }, function (t, n) {
            if (!f && p || "string" == typeof n && -1 === n.indexOf(g)) {
                var o = i(e, t, this, n);
                if (o.done) return o.value
            }
            var m = l(t),
                v = String(this),
                y = "function" == typeof n;
            y || (n = String(n));
            var b = m.global;
            if (b) {
                var x = m.unicode;
                m.lastIndex = 0
            }
            for (var w = [];;) {
                var _ = u(m, v);
                if (null === _) break;
                if (w.push(_), !b) break;
                "" === String(_[0]) && (m.lastIndex = s(v, r(m.lastIndex), x))
            }
            for (var k, S = "", A = 0, M = 0; M < w.length; M++) {
                _ = w[M];
                for (var C = String(_[0]), E = h(d(a(_.index), v.length), 0), O = [], T = 1; T < _.length; T++) O.push(void 0 === (k = _[T]) ? k : String(k));
                var P = _.groups;
                if (y) {
                    var L = [C].concat(O, E, v);
                    void 0 !== P && L.push(P);
                    var D = String(n.apply(void 0, L))
                } else D = c(C, v, E, O, P, n);
                E >= A && (S += v.slice(A, E) + D, A = E + C.length)
            }
            return S + v.slice(A)
        }]
    }))
}, function (t, e, i) {
    var n = i(35),
        l = Math.floor,
        r = "".replace,
        a = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
        o = /\$([$&'`]|\d{1,2})/g;
    t.exports = function (t, e, i, s, c, u) {
        var h = i + t.length,
            d = s.length,
            f = o;
        return void 0 !== c && (c = n(c), f = a), r.call(u, f, (function (n, r) {
            var a;
            switch (r.charAt(0)) {
                case "$":
                    return "$";
                case "&":
                    return t;
                case "`":
                    return e.slice(0, i);
                case "'":
                    return e.slice(h);
                case "<":
                    a = c[r.slice(1, -1)];
                    break;
                default:
                    var o = +r;
                    if (0 === o) return n;
                    if (o > d) {
                        var u = l(o / 10);
                        return 0 === u ? n : u <= d ? void 0 === s[u - 1] ? r.charAt(1) : s[u - 1] + r.charAt(1) : n
                    }
                    a = s[o - 1]
            }
            return void 0 === a ? "" : a
        }))
    }
}, function (t, e, i) {
    "use strict";
    var n = i(81),
        l = i(7),
        r = i(196),
        a = i(56),
        o = i(22),
        s = i(58),
        c = i(38),
        u = i(3),
        h = Math.min,
        d = [].push,
        f = 4294967295,
        p = !u((function () {
            RegExp(f, "y")
        }));
    i(59)("split", 2, (function (t, e, i, u) {
        var g;
        return g = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (t, e) {
            var l = String(this);
            if (void 0 === t && 0 === e) return [];
            if (!n(t)) return i.call(l, t, e);
            for (var r, a, o, s = [], u = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), h = 0, p = void 0 === e ? f : e >>> 0, g = new RegExp(t.source, u + "g");
                (r = c.call(g, l)) && !((a = g.lastIndex) > h && (s.push(l.slice(h, r.index)), r.length > 1 && r.index < l.length && d.apply(s, r.slice(1)), o = r[0].length, h = a, s.length >= p));) g.lastIndex === r.index && g.lastIndex++;
            return h === l.length ? !o && g.test("") || s.push("") : s.push(l.slice(h)), s.length > p ? s.slice(0, p) : s
        } : "0".split(void 0, 0).length ? function (t, e) {
            return void 0 === t && 0 === e ? [] : i.call(this, t, e)
        } : i, [function (i, n) {
            var l = t(this),
                r = null == i ? void 0 : i[e];
            return void 0 !== r ? r.call(i, l, n) : g.call(String(l), i, n)
        }, function (t, e) {
            var n = u(g, t, this, e, g !== i);
            if (n.done) return n.value;
            var c = l(t),
                d = String(this),
                m = r(c, RegExp),
                v = c.unicode,
                y = (c.ignoreCase ? "i" : "") + (c.multiline ? "m" : "") + (c.unicode ? "u" : "") + (p ? "y" : "g"),
                b = new m(p ? c : "^(?:" + c.source + ")", y),
                x = void 0 === e ? f : e >>> 0;
            if (0 === x) return [];
            if (0 === d.length) return null === s(b, d) ? [d] : [];
            for (var w = 0, _ = 0, k = []; _ < d.length;) {
                b.lastIndex = p ? _ : 0;
                var S, A = s(b, p ? d : d.slice(_));
                if (null === A || (S = h(o(b.lastIndex + (p ? 0 : _)), d.length)) === w) _ = a(d, _, v);
                else {
                    if (k.push(d.slice(w, _)), k.length === x) return k;
                    for (var M = 1; M <= A.length - 1; M++)
                        if (k.push(A[M]), k.length === x) return k;
                    _ = w = S
                }
            }
            return k.push(d.slice(w)), k
        }]
    }))
}, function (t, e, i) {
    var n = i(7),
        l = i(49),
        r = i(0)("species");
    t.exports = function (t, e) {
        var i, a = n(t).constructor;
        return void 0 === a || null == (i = n(a)[r]) ? e : l(i)
    }
}, function (t, e) {
    document.querySelectorAll(".js-fullscreen").forEach((function (t) {
        t.addEventListener("click", (function () {
            !!document.fullscreenElement ? document.exitFullscreen() : document.body.requestFullscreen()
        }))
    }))
}, function (t, e, i) {
    "use strict";
    var n = i(199),
        l = i(200);
    t.exports = function (t, e) {
        var i = e || {},
            r = {};
        return void 0 === t && (t = {}), t.on = function (e, i) {
            return r[e] ? r[e].push(i) : r[e] = [i], t
        }, t.once = function (e, i) {
            return i._once = !0, t.on(e, i), t
        }, t.off = function (e, i) {
            var n = arguments.length;
            if (1 === n) delete r[e];
            else if (0 === n) r = {};
            else {
                var l = r[e];
                if (!l) return t;
                l.splice(l.indexOf(i), 1)
            }
            return t
        }, t.emit = function () {
            var e = n(arguments);
            return t.emitterSnapshot(e.shift()).apply(this, e)
        }, t.emitterSnapshot = function (e) {
            var a = (r[e] || []).slice(0);
            return function () {
                var r = n(arguments),
                    o = this || t;
                if ("error" === e && !1 !== i.throws && !a.length) throw 1 === r.length ? r[0] : r;
                return a.forEach((function (n) {
                    i.async ? l(n, r, o) : n.apply(o, r), n._once && t.off(e, n)
                })), t
            }
        }, t
    }
}, function (t, e) {
    t.exports = function (t, e) {
        return Array.prototype.slice.call(t, e)
    }
}, function (t, e, i) {
    "use strict";
    var n = i(201);
    t.exports = function (t, e, i) {
        t && n((function () {
            t.apply(i || null, e || [])
        }))
    }
}, function (t, e, i) {
    (function (e) {
        var i;
        i = "function" == typeof e ? function (t) {
            e(t)
        } : function (t) {
            setTimeout(t, 0)
        }, t.exports = i
    }).call(this, i(202).setImmediate)
}, function (t, e, i) {
    (function (t) {
        var n = void 0 !== t && t || "undefined" != typeof self && self || window,
            l = Function.prototype.apply;

        function r(t, e) {
            this._id = t, this._clearFn = e
        }
        e.setTimeout = function () {
            return new r(l.call(setTimeout, n, arguments), clearTimeout)
        }, e.setInterval = function () {
            return new r(l.call(setInterval, n, arguments), clearInterval)
        }, e.clearTimeout = e.clearInterval = function (t) {
            t && t.close()
        }, r.prototype.unref = r.prototype.ref = function () {}, r.prototype.close = function () {
            this._clearFn.call(n, this._id)
        }, e.enroll = function (t, e) {
            clearTimeout(t._idleTimeoutId), t._idleTimeout = e
        }, e.unenroll = function (t) {
            clearTimeout(t._idleTimeoutId), t._idleTimeout = -1
        }, e._unrefActive = e.active = function (t) {
            clearTimeout(t._idleTimeoutId);
            var e = t._idleTimeout;
            e >= 0 && (t._idleTimeoutId = setTimeout((function () {
                t._onTimeout && t._onTimeout()
            }), e))
        }, i(203), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate
    }).call(this, i(8))
}, function (t, e, i) {
    (function (t, e) {
        ! function (t, i) {
            "use strict";
            if (!t.setImmediate) {
                var n, l, r, a, o, s = 1,
                    c = {},
                    u = !1,
                    h = t.document,
                    d = Object.getPrototypeOf && Object.getPrototypeOf(t);
                d = d && d.setTimeout ? d : t, "[object process]" === {}.toString.call(t.process) ? n = function (t) {
                    e.nextTick((function () {
                        p(t)
                    }))
                } : ! function () {
                    if (t.postMessage && !t.importScripts) {
                        var e = !0,
                            i = t.onmessage;
                        return t.onmessage = function () {
                            e = !1
                        }, t.postMessage("", "*"), t.onmessage = i, e
                    }
                }() ? t.MessageChannel ? ((r = new MessageChannel).port1.onmessage = function (t) {
                    p(t.data)
                }, n = function (t) {
                    r.port2.postMessage(t)
                }) : h && "onreadystatechange" in h.createElement("script") ? (l = h.documentElement, n = function (t) {
                    var e = h.createElement("script");
                    e.onreadystatechange = function () {
                        p(t), e.onreadystatechange = null, l.removeChild(e), e = null
                    }, l.appendChild(e)
                }) : n = function (t) {
                    setTimeout(p, 0, t)
                } : (a = "setImmediate$" + Math.random() + "$", o = function (e) {
                    e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && p(+e.data.slice(a.length))
                }, t.addEventListener ? t.addEventListener("message", o, !1) : t.attachEvent("onmessage", o), n = function (e) {
                    t.postMessage(a + e, "*")
                }), d.setImmediate = function (t) {
                    "function" != typeof t && (t = new Function("" + t));
                    for (var e = new Array(arguments.length - 1), i = 0; i < e.length; i++) e[i] = arguments[i + 1];
                    var l = {
                        callback: t,
                        args: e
                    };
                    return c[s] = l, n(s), s++
                }, d.clearImmediate = f
            }

            function f(t) {
                delete c[t]
            }

            function p(t) {
                if (u) setTimeout(p, 0, t);
                else {
                    var e = c[t];
                    if (e) {
                        u = !0;
                        try {
                            ! function (t) {
                                var e = t.callback,
                                    i = t.args;
                                switch (i.length) {
                                    case 0:
                                        e();
                                        break;
                                    case 1:
                                        e(i[0]);
                                        break;
                                    case 2:
                                        e(i[0], i[1]);
                                        break;
                                    case 3:
                                        e(i[0], i[1], i[2]);
                                        break;
                                    default:
                                        e.apply(void 0, i)
                                }
                            }(e)
                        } finally {
                            f(t), u = !1
                        }
                    }
                }
            }
        }("undefined" == typeof self ? void 0 === t ? this : t : self)
    }).call(this, i(8), i(85))
}, function (t, e, i) {
    "use strict";
    (function (e) {
        var n = i(205),
            l = i(206),
            r = e.document,
            a = function (t, e, i, n) {
                return t.addEventListener(e, i, n)
            },
            o = function (t, e, i, n) {
                return t.removeEventListener(e, i, n)
            },
            s = [];

        function c(t, e, i) {
            var n = function (t, e, i) {
                var n, l;
                for (n = 0; n < s.length; n++)
                    if ((l = s[n]).element === t && l.type === e && l.fn === i) return n
            }(t, e, i);
            if (n) {
                var l = s[n].wrapper;
                return s.splice(n, 1), l
            }
        }
        e.addEventListener || (a = function (t, i, n) {
            return t.attachEvent("on" + i, function (t, i, n) {
                var l = c(t, i, n) || function (t, i, n) {
                    return function (i) {
                        var l = i || e.event;
                        l.target = l.target || l.srcElement, l.preventDefault = l.preventDefault || function () {
                            l.returnValue = !1
                        }, l.stopPropagation = l.stopPropagation || function () {
                            l.cancelBubble = !0
                        }, l.which = l.which || l.keyCode, n.call(t, l)
                    }
                }(t, 0, n);
                return s.push({
                    wrapper: l,
                    element: t,
                    type: i,
                    fn: n
                }), l
            }(t, i, n))
        }, o = function (t, e, i) {
            var n = c(t, e, i);
            if (n) return t.detachEvent("on" + e, n)
        }), t.exports = {
            add: a,
            remove: o,
            fabricate: function (t, e, i) {
                var a = -1 === l.indexOf(e) ? new n(e, {
                    detail: i
                }) : function () {
                    var t;
                    r.createEvent ? (t = r.createEvent("Event")).initEvent(e, !0, !0) : r.createEventObject && (t = r.createEventObject());
                    return t
                }();
                t.dispatchEvent ? t.dispatchEvent(a) : t.fireEvent("on" + e, a)
            }
        }
    }).call(this, i(8))
}, function (t, e, i) {
    (function (e) {
        var i = e.CustomEvent;
        t.exports = function () {
            try {
                var t = new i("cat", {
                    detail: {
                        foo: "bar"
                    }
                });
                return "cat" === t.type && "bar" === t.detail.foo
            } catch (t) {}
            return !1
        }() ? i : "undefined" != typeof document && "function" == typeof document.createEvent ? function (t, e) {
            var i = document.createEvent("CustomEvent");
            return e ? i.initCustomEvent(t, e.bubbles, e.cancelable, e.detail) : i.initCustomEvent(t, !1, !1, void 0), i
        } : function (t, e) {
            var i = document.createEventObject();
            return i.type = t, e ? (i.bubbles = Boolean(e.bubbles), i.cancelable = Boolean(e.cancelable), i.detail = e.detail) : (i.bubbles = !1, i.cancelable = !1, i.detail = void 0), i
        }
    }).call(this, i(8))
}, function (t, e, i) {
    "use strict";
    (function (e) {
        var i = [],
            n = "",
            l = /^on/;
        for (n in e) l.test(n) && i.push(n.slice(2));
        t.exports = i
    }).call(this, i(8))
}, function (t, e, i) {
    "use strict";
    var n = {};

    function l(t) {
        var e = n[t];
        return e ? e.lastIndex = 0 : n[t] = e = new RegExp("(?:^|\\s)" + t + "(?:\\s|$)", "g"), e
    }
    t.exports = {
        add: function (t, e) {
            var i = t.className;
            i.length ? l(e).test(i) || (t.className += " " + e) : t.className = e
        },
        rm: function (t, e) {
            t.className = t.className.replace(l(e), " ").trim()
        }
    }
}, function (t, e, i) {
    (function (t) {
        t.exports = function () {
            "use strict";
            var e, i;

            function n() {
                return e.apply(null, arguments)
            }

            function l(t) {
                e = t
            }

            function r(t) {
                return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t)
            }

            function a(t) {
                return null != t && "[object Object]" === Object.prototype.toString.call(t)
            }

            function o(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e)
            }

            function s(t) {
                if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
                var e;
                for (e in t)
                    if (o(t, e)) return !1;
                return !0
            }

            function c(t) {
                return void 0 === t
            }

            function u(t) {
                return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t)
            }

            function h(t) {
                return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t)
            }

            function d(t, e) {
                var i, n = [];
                for (i = 0; i < t.length; ++i) n.push(e(t[i], i));
                return n
            }

            function f(t, e) {
                for (var i in e) o(e, i) && (t[i] = e[i]);
                return o(e, "toString") && (t.toString = e.toString), o(e, "valueOf") && (t.valueOf = e.valueOf), t
            }

            function p(t, e, i, n) {
                return qi(t, e, i, n, !0).utc()
            }

            function g() {
                return {
                    empty: !1,
                    unusedTokens: [],
                    unusedInput: [],
                    overflow: -2,
                    charsLeftOver: 0,
                    nullInput: !1,
                    invalidEra: null,
                    invalidMonth: null,
                    invalidFormat: !1,
                    userInvalidated: !1,
                    iso: !1,
                    parsedDateParts: [],
                    era: null,
                    meridiem: null,
                    rfc2822: !1,
                    weekdayMismatch: !1
                }
            }

            function m(t) {
                return null == t._pf && (t._pf = g()), t._pf
            }

            function v(t) {
                if (null == t._isValid) {
                    var e = m(t),
                        n = i.call(e.parsedDateParts, (function (t) {
                            return null != t
                        })),
                        l = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidEra && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && n);
                    if (t._strict && (l = l && 0 === e.charsLeftOver && 0 === e.unusedTokens.length && void 0 === e.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return l;
                    t._isValid = l
                }
                return t._isValid
            }

            function y(t) {
                var e = p(NaN);
                return null != t ? f(m(e), t) : m(e).userInvalidated = !0, e
            }
            i = Array.prototype.some ? Array.prototype.some : function (t) {
                var e, i = Object(this),
                    n = i.length >>> 0;
                for (e = 0; e < n; e++)
                    if (e in i && t.call(this, i[e], e, i)) return !0;
                return !1
            };
            var b = n.momentProperties = [],
                x = !1;

            function w(t, e) {
                var i, n, l;
                if (c(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), c(e._i) || (t._i = e._i), c(e._f) || (t._f = e._f), c(e._l) || (t._l = e._l), c(e._strict) || (t._strict = e._strict), c(e._tzm) || (t._tzm = e._tzm), c(e._isUTC) || (t._isUTC = e._isUTC), c(e._offset) || (t._offset = e._offset), c(e._pf) || (t._pf = m(e)), c(e._locale) || (t._locale = e._locale), b.length > 0)
                    for (i = 0; i < b.length; i++) c(l = e[n = b[i]]) || (t[n] = l);
                return t
            }

            function _(t) {
                w(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === x && (x = !0, n.updateOffset(this), x = !1)
            }

            function k(t) {
                return t instanceof _ || null != t && null != t._isAMomentObject
            }

            function S(t) {
                !1 === n.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t)
            }

            function A(t, e) {
                var i = !0;
                return f((function () {
                    if (null != n.deprecationHandler && n.deprecationHandler(null, t), i) {
                        var l, r, a, s = [];
                        for (r = 0; r < arguments.length; r++) {
                            if (l = "", "object" == typeof arguments[r]) {
                                for (a in l += "\n[" + r + "] ", arguments[0]) o(arguments[0], a) && (l += a + ": " + arguments[0][a] + ", ");
                                l = l.slice(0, -2)
                            } else l = arguments[r];
                            s.push(l)
                        }
                        S(t + "\nArguments: " + Array.prototype.slice.call(s).join("") + "\n" + (new Error).stack), i = !1
                    }
                    return e.apply(this, arguments)
                }), e)
            }
            var M, C = {};

            function E(t, e) {
                null != n.deprecationHandler && n.deprecationHandler(t, e), C[t] || (S(e), C[t] = !0)
            }

            function O(t) {
                return "undefined" != typeof Function && t instanceof Function || "[object Function]" === Object.prototype.toString.call(t)
            }

            function T(t) {
                var e, i;
                for (i in t) o(t, i) && (O(e = t[i]) ? this[i] = e : this["_" + i] = e);
                this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source)
            }

            function P(t, e) {
                var i, n = f({}, t);
                for (i in e) o(e, i) && (a(t[i]) && a(e[i]) ? (n[i] = {}, f(n[i], t[i]), f(n[i], e[i])) : null != e[i] ? n[i] = e[i] : delete n[i]);
                for (i in t) o(t, i) && !o(e, i) && a(t[i]) && (n[i] = f({}, n[i]));
                return n
            }

            function L(t) {
                null != t && this.set(t)
            }
            n.suppressDeprecationWarnings = !1, n.deprecationHandler = null, M = Object.keys ? Object.keys : function (t) {
                var e, i = [];
                for (e in t) o(t, e) && i.push(e);
                return i
            };
            var D = {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            };

            function I(t, e, i) {
                var n = this._calendar[t] || this._calendar.sameElse;
                return O(n) ? n.call(e, i) : n
            }

            function j(t, e, i) {
                var n = "" + Math.abs(t),
                    l = e - n.length;
                return (t >= 0 ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, l)).toString().substr(1) + n
            }
            var N = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
                R = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
                F = {},
                z = {};

            function H(t, e, i, n) {
                var l = n;
                "string" == typeof n && (l = function () {
                    return this[n]()
                }), t && (z[t] = l), e && (z[e[0]] = function () {
                    return j(l.apply(this, arguments), e[1], e[2])
                }), i && (z[i] = function () {
                    return this.localeData().ordinal(l.apply(this, arguments), t)
                })
            }

            function B(t) {
                return t.match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "")
            }

            function Y(t) {
                var e, i, n = t.match(N);
                for (e = 0, i = n.length; e < i; e++) z[n[e]] ? n[e] = z[n[e]] : n[e] = B(n[e]);
                return function (e) {
                    var l, r = "";
                    for (l = 0; l < i; l++) r += O(n[l]) ? n[l].call(e, t) : n[l];
                    return r
                }
            }

            function W(t, e) {
                return t.isValid() ? (e = V(e, t.localeData()), F[e] = F[e] || Y(e), F[e](t)) : t.localeData().invalidDate()
            }

            function V(t, e) {
                var i = 5;

                function n(t) {
                    return e.longDateFormat(t) || t
                }
                for (R.lastIndex = 0; i >= 0 && R.test(t);) t = t.replace(R, n), R.lastIndex = 0, i -= 1;
                return t
            }
            var X = {
                LTS: "h:mm:ss A",
                LT: "h:mm A",
                L: "MM/DD/YYYY",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY h:mm A",
                LLLL: "dddd, MMMM D, YYYY h:mm A"
            };

            function q(t) {
                var e = this._longDateFormat[t],
                    i = this._longDateFormat[t.toUpperCase()];
                return e || !i ? e : (this._longDateFormat[t] = i.match(N).map((function (t) {
                    return "MMMM" === t || "MM" === t || "DD" === t || "dddd" === t ? t.slice(1) : t
                })).join(""), this._longDateFormat[t])
            }
            var Z = "Invalid date";

            function G() {
                return this._invalidDate
            }
            var U = "%d",
                K = /\d{1,2}/;

            function $(t) {
                return this._ordinal.replace("%d", t)
            }
            var Q = {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                w: "a week",
                ww: "%d weeks",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            };

            function J(t, e, i, n) {
                var l = this._relativeTime[i];
                return O(l) ? l(t, e, i, n) : l.replace(/%d/i, t)
            }

            function tt(t, e) {
                var i = this._relativeTime[t > 0 ? "future" : "past"];
                return O(i) ? i(e) : i.replace(/%s/i, e)
            }
            var et = {};

            function it(t, e) {
                var i = t.toLowerCase();
                et[i] = et[i + "s"] = et[e] = t
            }

            function nt(t) {
                return "string" == typeof t ? et[t] || et[t.toLowerCase()] : void 0
            }

            function lt(t) {
                var e, i, n = {};
                for (i in t) o(t, i) && (e = nt(i)) && (n[e] = t[i]);
                return n
            }
            var rt = {};

            function at(t, e) {
                rt[t] = e
            }

            function ot(t) {
                var e, i = [];
                for (e in t) o(t, e) && i.push({
                    unit: e,
                    priority: rt[e]
                });
                return i.sort((function (t, e) {
                    return t.priority - e.priority
                })), i
            }

            function st(t) {
                return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
            }

            function ct(t) {
                return t < 0 ? Math.ceil(t) || 0 : Math.floor(t)
            }

            function ut(t) {
                var e = +t,
                    i = 0;
                return 0 !== e && isFinite(e) && (i = ct(e)), i
            }

            function ht(t, e) {
                return function (i) {
                    return null != i ? (ft(this, t, i), n.updateOffset(this, e), this) : dt(this, t)
                }
            }

            function dt(t, e) {
                return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN
            }

            function ft(t, e, i) {
                t.isValid() && !isNaN(i) && ("FullYear" === e && st(t.year()) && 1 === t.month() && 29 === t.date() ? (i = ut(i), t._d["set" + (t._isUTC ? "UTC" : "") + e](i, t.month(), Jt(i, t.month()))) : t._d["set" + (t._isUTC ? "UTC" : "") + e](i))
            }

            function pt(t) {
                return O(this[t = nt(t)]) ? this[t]() : this
            }

            function gt(t, e) {
                if ("object" == typeof t) {
                    var i, n = ot(t = lt(t));
                    for (i = 0; i < n.length; i++) this[n[i].unit](t[n[i].unit])
                } else if (O(this[t = nt(t)])) return this[t](e);
                return this
            }
            var mt, vt = /\d/,
                yt = /\d\d/,
                bt = /\d{3}/,
                xt = /\d{4}/,
                wt = /[+-]?\d{6}/,
                _t = /\d\d?/,
                kt = /\d\d\d\d?/,
                St = /\d\d\d\d\d\d?/,
                At = /\d{1,3}/,
                Mt = /\d{1,4}/,
                Ct = /[+-]?\d{1,6}/,
                Et = /\d+/,
                Ot = /[+-]?\d+/,
                Tt = /Z|[+-]\d\d:?\d\d/gi,
                Pt = /Z|[+-]\d\d(?::?\d\d)?/gi,
                Lt = /[+-]?\d+(\.\d{1,3})?/,
                Dt = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

            function It(t, e, i) {
                mt[t] = O(e) ? e : function (t, n) {
                    return t && i ? i : e
                }
            }

            function jt(t, e) {
                return o(mt, t) ? mt[t](e._strict, e._locale) : new RegExp(Nt(t))
            }

            function Nt(t) {
                return Rt(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, (function (t, e, i, n, l) {
                    return e || i || n || l
                })))
            }

            function Rt(t) {
                return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
            }
            mt = {};
            var Ft = {};

            function zt(t, e) {
                var i, n = e;
                for ("string" == typeof t && (t = [t]), u(e) && (n = function (t, i) {
                        i[e] = ut(t)
                    }), i = 0; i < t.length; i++) Ft[t[i]] = n
            }

            function Ht(t, e) {
                zt(t, (function (t, i, n, l) {
                    n._w = n._w || {}, e(t, n._w, n, l)
                }))
            }

            function Bt(t, e, i) {
                null != e && o(Ft, t) && Ft[t](e, i._a, i, t)
            }
            var Yt, Wt = 0,
                Vt = 1,
                Xt = 2,
                qt = 3,
                Zt = 4,
                Gt = 5,
                Ut = 6,
                Kt = 7,
                $t = 8;

            function Qt(t, e) {
                return (t % e + e) % e
            }

            function Jt(t, e) {
                if (isNaN(t) || isNaN(e)) return NaN;
                var i = Qt(e, 12);
                return t += (e - i) / 12, 1 === i ? st(t) ? 29 : 28 : 31 - i % 7 % 2
            }
            Yt = Array.prototype.indexOf ? Array.prototype.indexOf : function (t) {
                var e;
                for (e = 0; e < this.length; ++e)
                    if (this[e] === t) return e;
                return -1
            }, H("M", ["MM", 2], "Mo", (function () {
                return this.month() + 1
            })), H("MMM", 0, 0, (function (t) {
                return this.localeData().monthsShort(this, t)
            })), H("MMMM", 0, 0, (function (t) {
                return this.localeData().months(this, t)
            })), it("month", "M"), at("month", 8), It("M", _t), It("MM", _t, yt), It("MMM", (function (t, e) {
                return e.monthsShortRegex(t)
            })), It("MMMM", (function (t, e) {
                return e.monthsRegex(t)
            })), zt(["M", "MM"], (function (t, e) {
                e[Vt] = ut(t) - 1
            })), zt(["MMM", "MMMM"], (function (t, e, i, n) {
                var l = i._locale.monthsParse(t, n, i._strict);
                null != l ? e[Vt] = l : m(i).invalidMonth = t
            }));
            var te = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                ee = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
                ie = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
                ne = Dt,
                le = Dt;

            function re(t, e) {
                return t ? r(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || ie).test(e) ? "format" : "standalone"][t.month()] : r(this._months) ? this._months : this._months.standalone
            }

            function ae(t, e) {
                return t ? r(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[ie.test(e) ? "format" : "standalone"][t.month()] : r(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone
            }

            function oe(t, e, i) {
                var n, l, r, a = t.toLocaleLowerCase();
                if (!this._monthsParse)
                    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n) r = p([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(r, "").toLocaleLowerCase(), this._longMonthsParse[n] = this.months(r, "").toLocaleLowerCase();
                return i ? "MMM" === e ? -1 !== (l = Yt.call(this._shortMonthsParse, a)) ? l : null : -1 !== (l = Yt.call(this._longMonthsParse, a)) ? l : null : "MMM" === e ? -1 !== (l = Yt.call(this._shortMonthsParse, a)) || -1 !== (l = Yt.call(this._longMonthsParse, a)) ? l : null : -1 !== (l = Yt.call(this._longMonthsParse, a)) || -1 !== (l = Yt.call(this._shortMonthsParse, a)) ? l : null
            }

            function se(t, e, i) {
                var n, l, r;
                if (this._monthsParseExact) return oe.call(this, t, e, i);
                for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
                    if (l = p([2e3, n]), i && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp("^" + this.months(l, "").replace(".", "") + "$", "i"), this._shortMonthsParse[n] = new RegExp("^" + this.monthsShort(l, "").replace(".", "") + "$", "i")), i || this._monthsParse[n] || (r = "^" + this.months(l, "") + "|^" + this.monthsShort(l, ""), this._monthsParse[n] = new RegExp(r.replace(".", ""), "i")), i && "MMMM" === e && this._longMonthsParse[n].test(t)) return n;
                    if (i && "MMM" === e && this._shortMonthsParse[n].test(t)) return n;
                    if (!i && this._monthsParse[n].test(t)) return n
                }
            }

            function ce(t, e) {
                var i;
                if (!t.isValid()) return t;
                if ("string" == typeof e)
                    if (/^\d+$/.test(e)) e = ut(e);
                    else if (!u(e = t.localeData().monthsParse(e))) return t;
                return i = Math.min(t.date(), Jt(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, i), t
            }

            function ue(t) {
                return null != t ? (ce(this, t), n.updateOffset(this, !0), this) : dt(this, "Month")
            }

            function he() {
                return Jt(this.year(), this.month())
            }

            function de(t) {
                return this._monthsParseExact ? (o(this, "_monthsRegex") || pe.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (o(this, "_monthsShortRegex") || (this._monthsShortRegex = ne), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex)
            }

            function fe(t) {
                return this._monthsParseExact ? (o(this, "_monthsRegex") || pe.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (o(this, "_monthsRegex") || (this._monthsRegex = le), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex)
            }

            function pe() {
                function t(t, e) {
                    return e.length - t.length
                }
                var e, i, n = [],
                    l = [],
                    r = [];
                for (e = 0; e < 12; e++) i = p([2e3, e]), n.push(this.monthsShort(i, "")), l.push(this.months(i, "")), r.push(this.months(i, "")), r.push(this.monthsShort(i, ""));
                for (n.sort(t), l.sort(t), r.sort(t), e = 0; e < 12; e++) n[e] = Rt(n[e]), l[e] = Rt(l[e]);
                for (e = 0; e < 24; e++) r[e] = Rt(r[e]);
                this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + n.join("|") + ")", "i")
            }

            function ge(t) {
                return st(t) ? 366 : 365
            }
            H("Y", 0, 0, (function () {
                var t = this.year();
                return t <= 9999 ? j(t, 4) : "+" + t
            })), H(0, ["YY", 2], 0, (function () {
                return this.year() % 100
            })), H(0, ["YYYY", 4], 0, "year"), H(0, ["YYYYY", 5], 0, "year"), H(0, ["YYYYYY", 6, !0], 0, "year"), it("year", "y"), at("year", 1), It("Y", Ot), It("YY", _t, yt), It("YYYY", Mt, xt), It("YYYYY", Ct, wt), It("YYYYYY", Ct, wt), zt(["YYYYY", "YYYYYY"], Wt), zt("YYYY", (function (t, e) {
                e[Wt] = 2 === t.length ? n.parseTwoDigitYear(t) : ut(t)
            })), zt("YY", (function (t, e) {
                e[Wt] = n.parseTwoDigitYear(t)
            })), zt("Y", (function (t, e) {
                e[Wt] = parseInt(t, 10)
            })), n.parseTwoDigitYear = function (t) {
                return ut(t) + (ut(t) > 68 ? 1900 : 2e3)
            };
            var me = ht("FullYear", !0);

            function ve() {
                return st(this.year())
            }

            function ye(t, e, i, n, l, r, a) {
                var o;
                return t < 100 && t >= 0 ? (o = new Date(t + 400, e, i, n, l, r, a), isFinite(o.getFullYear()) && o.setFullYear(t)) : o = new Date(t, e, i, n, l, r, a), o
            }

            function be(t) {
                var e, i;
                return t < 100 && t >= 0 ? ((i = Array.prototype.slice.call(arguments))[0] = t + 400, e = new Date(Date.UTC.apply(null, i)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t)) : e = new Date(Date.UTC.apply(null, arguments)), e
            }

            function xe(t, e, i) {
                var n = 7 + e - i;
                return -(7 + be(t, 0, n).getUTCDay() - e) % 7 + n - 1
            }

            function we(t, e, i, n, l) {
                var r, a, o = 1 + 7 * (e - 1) + (7 + i - n) % 7 + xe(t, n, l);
                return o <= 0 ? a = ge(r = t - 1) + o : o > ge(t) ? (r = t + 1, a = o - ge(t)) : (r = t, a = o), {
                    year: r,
                    dayOfYear: a
                }
            }

            function _e(t, e, i) {
                var n, l, r = xe(t.year(), e, i),
                    a = Math.floor((t.dayOfYear() - r - 1) / 7) + 1;
                return a < 1 ? n = a + ke(l = t.year() - 1, e, i) : a > ke(t.year(), e, i) ? (n = a - ke(t.year(), e, i), l = t.year() + 1) : (l = t.year(), n = a), {
                    week: n,
                    year: l
                }
            }

            function ke(t, e, i) {
                var n = xe(t, e, i),
                    l = xe(t + 1, e, i);
                return (ge(t) - n + l) / 7
            }

            function Se(t) {
                return _e(t, this._week.dow, this._week.doy).week
            }
            H("w", ["ww", 2], "wo", "week"), H("W", ["WW", 2], "Wo", "isoWeek"), it("week", "w"), it("isoWeek", "W"), at("week", 5), at("isoWeek", 5), It("w", _t), It("ww", _t, yt), It("W", _t), It("WW", _t, yt), Ht(["w", "ww", "W", "WW"], (function (t, e, i, n) {
                e[n.substr(0, 1)] = ut(t)
            }));
            var Ae = {
                dow: 0,
                doy: 6
            };

            function Me() {
                return this._week.dow
            }

            function Ce() {
                return this._week.doy
            }

            function Ee(t) {
                var e = this.localeData().week(this);
                return null == t ? e : this.add(7 * (t - e), "d")
            }

            function Oe(t) {
                var e = _e(this, 1, 4).week;
                return null == t ? e : this.add(7 * (t - e), "d")
            }

            function Te(t, e) {
                return "string" != typeof t ? t : isNaN(t) ? "number" == typeof (t = e.weekdaysParse(t)) ? t : null : parseInt(t, 10)
            }

            function Pe(t, e) {
                return "string" == typeof t ? e.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t
            }

            function Le(t, e) {
                return t.slice(e, 7).concat(t.slice(0, e))
            }
            H("d", 0, "do", "day"), H("dd", 0, 0, (function (t) {
                return this.localeData().weekdaysMin(this, t)
            })), H("ddd", 0, 0, (function (t) {
                return this.localeData().weekdaysShort(this, t)
            })), H("dddd", 0, 0, (function (t) {
                return this.localeData().weekdays(this, t)
            })), H("e", 0, 0, "weekday"), H("E", 0, 0, "isoWeekday"), it("day", "d"), it("weekday", "e"), it("isoWeekday", "E"), at("day", 11), at("weekday", 11), at("isoWeekday", 11), It("d", _t), It("e", _t), It("E", _t), It("dd", (function (t, e) {
                return e.weekdaysMinRegex(t)
            })), It("ddd", (function (t, e) {
                return e.weekdaysShortRegex(t)
            })), It("dddd", (function (t, e) {
                return e.weekdaysRegex(t)
            })), Ht(["dd", "ddd", "dddd"], (function (t, e, i, n) {
                var l = i._locale.weekdaysParse(t, n, i._strict);
                null != l ? e.d = l : m(i).invalidWeekday = t
            })), Ht(["d", "e", "E"], (function (t, e, i, n) {
                e[n] = ut(t)
            }));
            var De = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                Ie = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
                je = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
                Ne = Dt,
                Re = Dt,
                Fe = Dt;

            function ze(t, e) {
                var i = r(this._weekdays) ? this._weekdays : this._weekdays[t && !0 !== t && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
                return !0 === t ? Le(i, this._week.dow) : t ? i[t.day()] : i
            }

            function He(t) {
                return !0 === t ? Le(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort
            }

            function Be(t) {
                return !0 === t ? Le(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin
            }

            function Ye(t, e, i) {
                var n, l, r, a = t.toLocaleLowerCase();
                if (!this._weekdaysParse)
                    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n) r = p([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(r, "").toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(r, "").toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(r, "").toLocaleLowerCase();
                return i ? "dddd" === e ? -1 !== (l = Yt.call(this._weekdaysParse, a)) ? l : null : "ddd" === e ? -1 !== (l = Yt.call(this._shortWeekdaysParse, a)) ? l : null : -1 !== (l = Yt.call(this._minWeekdaysParse, a)) ? l : null : "dddd" === e ? -1 !== (l = Yt.call(this._weekdaysParse, a)) || -1 !== (l = Yt.call(this._shortWeekdaysParse, a)) || -1 !== (l = Yt.call(this._minWeekdaysParse, a)) ? l : null : "ddd" === e ? -1 !== (l = Yt.call(this._shortWeekdaysParse, a)) || -1 !== (l = Yt.call(this._weekdaysParse, a)) || -1 !== (l = Yt.call(this._minWeekdaysParse, a)) ? l : null : -1 !== (l = Yt.call(this._minWeekdaysParse, a)) || -1 !== (l = Yt.call(this._weekdaysParse, a)) || -1 !== (l = Yt.call(this._shortWeekdaysParse, a)) ? l : null
            }

            function We(t, e, i) {
                var n, l, r;
                if (this._weekdaysParseExact) return Ye.call(this, t, e, i);
                for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
                    if (l = p([2e3, 1]).day(n), i && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp("^" + this.weekdays(l, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[n] = new RegExp("^" + this.weekdaysShort(l, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[n] = new RegExp("^" + this.weekdaysMin(l, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[n] || (r = "^" + this.weekdays(l, "") + "|^" + this.weekdaysShort(l, "") + "|^" + this.weekdaysMin(l, ""), this._weekdaysParse[n] = new RegExp(r.replace(".", ""), "i")), i && "dddd" === e && this._fullWeekdaysParse[n].test(t)) return n;
                    if (i && "ddd" === e && this._shortWeekdaysParse[n].test(t)) return n;
                    if (i && "dd" === e && this._minWeekdaysParse[n].test(t)) return n;
                    if (!i && this._weekdaysParse[n].test(t)) return n
                }
            }

            function Ve(t) {
                if (!this.isValid()) return null != t ? this : NaN;
                var e = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                return null != t ? (t = Te(t, this.localeData()), this.add(t - e, "d")) : e
            }

            function Xe(t) {
                if (!this.isValid()) return null != t ? this : NaN;
                var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
                return null == t ? e : this.add(t - e, "d")
            }

            function qe(t) {
                if (!this.isValid()) return null != t ? this : NaN;
                if (null != t) {
                    var e = Pe(t, this.localeData());
                    return this.day(this.day() % 7 ? e : e - 7)
                }
                return this.day() || 7
            }

            function Ze(t) {
                return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Ke.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (o(this, "_weekdaysRegex") || (this._weekdaysRegex = Ne), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex)
            }

            function Ge(t) {
                return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Ke.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (o(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Re), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
            }

            function Ue(t) {
                return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Ke.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (o(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Fe), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
            }

            function Ke() {
                function t(t, e) {
                    return e.length - t.length
                }
                var e, i, n, l, r, a = [],
                    o = [],
                    s = [],
                    c = [];
                for (e = 0; e < 7; e++) i = p([2e3, 1]).day(e), n = Rt(this.weekdaysMin(i, "")), l = Rt(this.weekdaysShort(i, "")), r = Rt(this.weekdays(i, "")), a.push(n), o.push(l), s.push(r), c.push(n), c.push(l), c.push(r);
                a.sort(t), o.sort(t), s.sort(t), c.sort(t), this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + a.join("|") + ")", "i")
            }

            function $e() {
                return this.hours() % 12 || 12
            }

            function Qe() {
                return this.hours() || 24
            }

            function Je(t, e) {
                H(t, 0, 0, (function () {
                    return this.localeData().meridiem(this.hours(), this.minutes(), e)
                }))
            }

            function ti(t, e) {
                return e._meridiemParse
            }

            function ei(t) {
                return "p" === (t + "").toLowerCase().charAt(0)
            }
            H("H", ["HH", 2], 0, "hour"), H("h", ["hh", 2], 0, $e), H("k", ["kk", 2], 0, Qe), H("hmm", 0, 0, (function () {
                return "" + $e.apply(this) + j(this.minutes(), 2)
            })), H("hmmss", 0, 0, (function () {
                return "" + $e.apply(this) + j(this.minutes(), 2) + j(this.seconds(), 2)
            })), H("Hmm", 0, 0, (function () {
                return "" + this.hours() + j(this.minutes(), 2)
            })), H("Hmmss", 0, 0, (function () {
                return "" + this.hours() + j(this.minutes(), 2) + j(this.seconds(), 2)
            })), Je("a", !0), Je("A", !1), it("hour", "h"), at("hour", 13), It("a", ti), It("A", ti), It("H", _t), It("h", _t), It("k", _t), It("HH", _t, yt), It("hh", _t, yt), It("kk", _t, yt), It("hmm", kt), It("hmmss", St), It("Hmm", kt), It("Hmmss", St), zt(["H", "HH"], qt), zt(["k", "kk"], (function (t, e, i) {
                var n = ut(t);
                e[qt] = 24 === n ? 0 : n
            })), zt(["a", "A"], (function (t, e, i) {
                i._isPm = i._locale.isPM(t), i._meridiem = t
            })), zt(["h", "hh"], (function (t, e, i) {
                e[qt] = ut(t), m(i).bigHour = !0
            })), zt("hmm", (function (t, e, i) {
                var n = t.length - 2;
                e[qt] = ut(t.substr(0, n)), e[Zt] = ut(t.substr(n)), m(i).bigHour = !0
            })), zt("hmmss", (function (t, e, i) {
                var n = t.length - 4,
                    l = t.length - 2;
                e[qt] = ut(t.substr(0, n)), e[Zt] = ut(t.substr(n, 2)), e[Gt] = ut(t.substr(l)), m(i).bigHour = !0
            })), zt("Hmm", (function (t, e, i) {
                var n = t.length - 2;
                e[qt] = ut(t.substr(0, n)), e[Zt] = ut(t.substr(n))
            })), zt("Hmmss", (function (t, e, i) {
                var n = t.length - 4,
                    l = t.length - 2;
                e[qt] = ut(t.substr(0, n)), e[Zt] = ut(t.substr(n, 2)), e[Gt] = ut(t.substr(l))
            }));
            var ii = /[ap]\.?m?\.?/i,
                ni = ht("Hours", !0);

            function li(t, e, i) {
                return t > 11 ? i ? "pm" : "PM" : i ? "am" : "AM"
            }
            var ri, ai = {
                    calendar: D,
                    longDateFormat: X,
                    invalidDate: Z,
                    ordinal: U,
                    dayOfMonthOrdinalParse: K,
                    relativeTime: Q,
                    months: te,
                    monthsShort: ee,
                    week: Ae,
                    weekdays: De,
                    weekdaysMin: je,
                    weekdaysShort: Ie,
                    meridiemParse: ii
                },
                oi = {},
                si = {};

            function ci(t, e) {
                var i, n = Math.min(t.length, e.length);
                for (i = 0; i < n; i += 1)
                    if (t[i] !== e[i]) return i;
                return n
            }

            function ui(t) {
                return t ? t.toLowerCase().replace("_", "-") : t
            }

            function hi(t) {
                for (var e, i, n, l, r = 0; r < t.length;) {
                    for (e = (l = ui(t[r]).split("-")).length, i = (i = ui(t[r + 1])) ? i.split("-") : null; e > 0;) {
                        if (n = di(l.slice(0, e).join("-"))) return n;
                        if (i && i.length >= e && ci(l, i) >= e - 1) break;
                        e--
                    }
                    r++
                }
                return ri
            }

            function di(e) {
                var i = null;
                if (void 0 === oi[e] && void 0 !== t && t && t.exports) try {
                    i = ri._abbr,
                        function () {
                            var t = new Error("Cannot find module 'undefined'");
                            throw t.code = "MODULE_NOT_FOUND", t
                        }(), fi(i)
                } catch (t) {
                    oi[e] = null
                }
                return oi[e]
            }

            function fi(t, e) {
                var i;
                return t && ((i = c(e) ? mi(t) : pi(t, e)) ? ri = i : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), ri._abbr
            }

            function pi(t, e) {
                if (null !== e) {
                    var i, n = ai;
                    if (e.abbr = t, null != oi[t]) E("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), n = oi[t]._config;
                    else if (null != e.parentLocale)
                        if (null != oi[e.parentLocale]) n = oi[e.parentLocale]._config;
                        else {
                            if (null == (i = di(e.parentLocale))) return si[e.parentLocale] || (si[e.parentLocale] = []), si[e.parentLocale].push({
                                name: t,
                                config: e
                            }), null;
                            n = i._config
                        } return oi[t] = new L(P(n, e)), si[t] && si[t].forEach((function (t) {
                        pi(t.name, t.config)
                    })), fi(t), oi[t]
                }
                return delete oi[t], null
            }

            function gi(t, e) {
                if (null != e) {
                    var i, n, l = ai;
                    null != oi[t] && null != oi[t].parentLocale ? oi[t].set(P(oi[t]._config, e)) : (null != (n = di(t)) && (l = n._config), e = P(l, e), null == n && (e.abbr = t), (i = new L(e)).parentLocale = oi[t], oi[t] = i), fi(t)
                } else null != oi[t] && (null != oi[t].parentLocale ? (oi[t] = oi[t].parentLocale, t === fi() && fi(t)) : null != oi[t] && delete oi[t]);
                return oi[t]
            }

            function mi(t) {
                var e;
                if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return ri;
                if (!r(t)) {
                    if (e = di(t)) return e;
                    t = [t]
                }
                return hi(t)
            }

            function vi() {
                return M(oi)
            }

            function yi(t) {
                var e, i = t._a;
                return i && -2 === m(t).overflow && (e = i[Vt] < 0 || i[Vt] > 11 ? Vt : i[Xt] < 1 || i[Xt] > Jt(i[Wt], i[Vt]) ? Xt : i[qt] < 0 || i[qt] > 24 || 24 === i[qt] && (0 !== i[Zt] || 0 !== i[Gt] || 0 !== i[Ut]) ? qt : i[Zt] < 0 || i[Zt] > 59 ? Zt : i[Gt] < 0 || i[Gt] > 59 ? Gt : i[Ut] < 0 || i[Ut] > 999 ? Ut : -1, m(t)._overflowDayOfYear && (e < Wt || e > Xt) && (e = Xt), m(t)._overflowWeeks && -1 === e && (e = Kt), m(t)._overflowWeekday && -1 === e && (e = $t), m(t).overflow = e), t
            }
            var bi = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                xi = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                wi = /Z|[+-]\d\d(?::?\d\d)?/,
                _i = [
                    ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
                    ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
                    ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
                    ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
                    ["YYYY-DDD", /\d{4}-\d{3}/],
                    ["YYYY-MM", /\d{4}-\d\d/, !1],
                    ["YYYYYYMMDD", /[+-]\d{10}/],
                    ["YYYYMMDD", /\d{8}/],
                    ["GGGG[W]WWE", /\d{4}W\d{3}/],
                    ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
                    ["YYYYDDD", /\d{7}/],
                    ["YYYYMM", /\d{6}/, !1],
                    ["YYYY", /\d{4}/, !1]
                ],
                ki = [
                    ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
                    ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
                    ["HH:mm:ss", /\d\d:\d\d:\d\d/],
                    ["HH:mm", /\d\d:\d\d/],
                    ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
                    ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
                    ["HHmmss", /\d\d\d\d\d\d/],
                    ["HHmm", /\d\d\d\d/],
                    ["HH", /\d\d/]
                ],
                Si = /^\/?Date\((-?\d+)/i,
                Ai = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
                Mi = {
                    UT: 0,
                    GMT: 0,
                    EDT: -240,
                    EST: -300,
                    CDT: -300,
                    CST: -360,
                    MDT: -360,
                    MST: -420,
                    PDT: -420,
                    PST: -480
                };

            function Ci(t) {
                var e, i, n, l, r, a, o = t._i,
                    s = bi.exec(o) || xi.exec(o);
                if (s) {
                    for (m(t).iso = !0, e = 0, i = _i.length; e < i; e++)
                        if (_i[e][1].exec(s[1])) {
                            l = _i[e][0], n = !1 !== _i[e][2];
                            break
                        } if (null == l) return void(t._isValid = !1);
                    if (s[3]) {
                        for (e = 0, i = ki.length; e < i; e++)
                            if (ki[e][1].exec(s[3])) {
                                r = (s[2] || " ") + ki[e][0];
                                break
                            } if (null == r) return void(t._isValid = !1)
                    }
                    if (!n && null != r) return void(t._isValid = !1);
                    if (s[4]) {
                        if (!wi.exec(s[4])) return void(t._isValid = !1);
                        a = "Z"
                    }
                    t._f = l + (r || "") + (a || ""), zi(t)
                } else t._isValid = !1
            }

            function Ei(t, e, i, n, l, r) {
                var a = [Oi(t), ee.indexOf(e), parseInt(i, 10), parseInt(n, 10), parseInt(l, 10)];
                return r && a.push(parseInt(r, 10)), a
            }

            function Oi(t) {
                var e = parseInt(t, 10);
                return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e
            }

            function Ti(t) {
                return t.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
            }

            function Pi(t, e, i) {
                return !t || Ie.indexOf(t) === new Date(e[0], e[1], e[2]).getDay() || (m(i).weekdayMismatch = !0, i._isValid = !1, !1)
            }

            function Li(t, e, i) {
                if (t) return Mi[t];
                if (e) return 0;
                var n = parseInt(i, 10),
                    l = n % 100;
                return (n - l) / 100 * 60 + l
            }

            function Di(t) {
                var e, i = Ai.exec(Ti(t._i));
                if (i) {
                    if (e = Ei(i[4], i[3], i[2], i[5], i[6], i[7]), !Pi(i[1], e, t)) return;
                    t._a = e, t._tzm = Li(i[8], i[9], i[10]), t._d = be.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), m(t).rfc2822 = !0
                } else t._isValid = !1
            }

            function Ii(t) {
                var e = Si.exec(t._i);
                null === e ? (Ci(t), !1 === t._isValid && (delete t._isValid, Di(t), !1 === t._isValid && (delete t._isValid, t._strict ? t._isValid = !1 : n.createFromInputFallback(t)))) : t._d = new Date(+e[1])
            }

            function ji(t, e, i) {
                return null != t ? t : null != e ? e : i
            }

            function Ni(t) {
                var e = new Date(n.now());
                return t._useUTC ? [e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()] : [e.getFullYear(), e.getMonth(), e.getDate()]
            }

            function Ri(t) {
                var e, i, n, l, r, a = [];
                if (!t._d) {
                    for (n = Ni(t), t._w && null == t._a[Xt] && null == t._a[Vt] && Fi(t), null != t._dayOfYear && (r = ji(t._a[Wt], n[Wt]), (t._dayOfYear > ge(r) || 0 === t._dayOfYear) && (m(t)._overflowDayOfYear = !0), i = be(r, 0, t._dayOfYear), t._a[Vt] = i.getUTCMonth(), t._a[Xt] = i.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) t._a[e] = a[e] = n[e];
                    for (; e < 7; e++) t._a[e] = a[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
                    24 === t._a[qt] && 0 === t._a[Zt] && 0 === t._a[Gt] && 0 === t._a[Ut] && (t._nextDay = !0, t._a[qt] = 0), t._d = (t._useUTC ? be : ye).apply(null, a), l = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[qt] = 24), t._w && void 0 !== t._w.d && t._w.d !== l && (m(t).weekdayMismatch = !0)
                }
            }

            function Fi(t) {
                var e, i, n, l, r, a, o, s, c;
                null != (e = t._w).GG || null != e.W || null != e.E ? (r = 1, a = 4, i = ji(e.GG, t._a[Wt], _e(Zi(), 1, 4).year), n = ji(e.W, 1), ((l = ji(e.E, 1)) < 1 || l > 7) && (s = !0)) : (r = t._locale._week.dow, a = t._locale._week.doy, c = _e(Zi(), r, a), i = ji(e.gg, t._a[Wt], c.year), n = ji(e.w, c.week), null != e.d ? ((l = e.d) < 0 || l > 6) && (s = !0) : null != e.e ? (l = e.e + r, (e.e < 0 || e.e > 6) && (s = !0)) : l = r), n < 1 || n > ke(i, r, a) ? m(t)._overflowWeeks = !0 : null != s ? m(t)._overflowWeekday = !0 : (o = we(i, n, l, r, a), t._a[Wt] = o.year, t._dayOfYear = o.dayOfYear)
            }

            function zi(t) {
                if (t._f !== n.ISO_8601)
                    if (t._f !== n.RFC_2822) {
                        t._a = [], m(t).empty = !0;
                        var e, i, l, r, a, o, s = "" + t._i,
                            c = s.length,
                            u = 0;
                        for (l = V(t._f, t._locale).match(N) || [], e = 0; e < l.length; e++) r = l[e], (i = (s.match(jt(r, t)) || [])[0]) && ((a = s.substr(0, s.indexOf(i))).length > 0 && m(t).unusedInput.push(a), s = s.slice(s.indexOf(i) + i.length), u += i.length), z[r] ? (i ? m(t).empty = !1 : m(t).unusedTokens.push(r), Bt(r, i, t)) : t._strict && !i && m(t).unusedTokens.push(r);
                        m(t).charsLeftOver = c - u, s.length > 0 && m(t).unusedInput.push(s), t._a[qt] <= 12 && !0 === m(t).bigHour && t._a[qt] > 0 && (m(t).bigHour = void 0), m(t).parsedDateParts = t._a.slice(0), m(t).meridiem = t._meridiem, t._a[qt] = Hi(t._locale, t._a[qt], t._meridiem), null !== (o = m(t).era) && (t._a[Wt] = t._locale.erasConvertYear(o, t._a[Wt])), Ri(t), yi(t)
                    } else Di(t);
                else Ci(t)
            }

            function Hi(t, e, i) {
                var n;
                return null == i ? e : null != t.meridiemHour ? t.meridiemHour(e, i) : null != t.isPM ? ((n = t.isPM(i)) && e < 12 && (e += 12), n || 12 !== e || (e = 0), e) : e
            }

            function Bi(t) {
                var e, i, n, l, r, a, o = !1;
                if (0 === t._f.length) return m(t).invalidFormat = !0, void(t._d = new Date(NaN));
                for (l = 0; l < t._f.length; l++) r = 0, a = !1, e = w({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[l], zi(e), v(e) && (a = !0), r += m(e).charsLeftOver, r += 10 * m(e).unusedTokens.length, m(e).score = r, o ? r < n && (n = r, i = e) : (null == n || r < n || a) && (n = r, i = e, a && (o = !0));
                f(t, i || e)
            }

            function Yi(t) {
                if (!t._d) {
                    var e = lt(t._i),
                        i = void 0 === e.day ? e.date : e.day;
                    t._a = d([e.year, e.month, i, e.hour, e.minute, e.second, e.millisecond], (function (t) {
                        return t && parseInt(t, 10)
                    })), Ri(t)
                }
            }

            function Wi(t) {
                var e = new _(yi(Vi(t)));
                return e._nextDay && (e.add(1, "d"), e._nextDay = void 0), e
            }

            function Vi(t) {
                var e = t._i,
                    i = t._f;
                return t._locale = t._locale || mi(t._l), null === e || void 0 === i && "" === e ? y({
                    nullInput: !0
                }) : ("string" == typeof e && (t._i = e = t._locale.preparse(e)), k(e) ? new _(yi(e)) : (h(e) ? t._d = e : r(i) ? Bi(t) : i ? zi(t) : Xi(t), v(t) || (t._d = null), t))
            }

            function Xi(t) {
                var e = t._i;
                c(e) ? t._d = new Date(n.now()) : h(e) ? t._d = new Date(e.valueOf()) : "string" == typeof e ? Ii(t) : r(e) ? (t._a = d(e.slice(0), (function (t) {
                    return parseInt(t, 10)
                })), Ri(t)) : a(e) ? Yi(t) : u(e) ? t._d = new Date(e) : n.createFromInputFallback(t)
            }

            function qi(t, e, i, n, l) {
                var o = {};
                return !0 !== e && !1 !== e || (n = e, e = void 0), !0 !== i && !1 !== i || (n = i, i = void 0), (a(t) && s(t) || r(t) && 0 === t.length) && (t = void 0), o._isAMomentObject = !0, o._useUTC = o._isUTC = l, o._l = i, o._i = t, o._f = e, o._strict = n, Wi(o)
            }

            function Zi(t, e, i, n) {
                return qi(t, e, i, n, !1)
            }
            n.createFromInputFallback = A("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", (function (t) {
                t._d = new Date(t._i + (t._useUTC ? " UTC" : ""))
            })), n.ISO_8601 = function () {}, n.RFC_2822 = function () {};
            var Gi = A("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", (function () {
                    var t = Zi.apply(null, arguments);
                    return this.isValid() && t.isValid() ? t < this ? this : t : y()
                })),
                Ui = A("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", (function () {
                    var t = Zi.apply(null, arguments);
                    return this.isValid() && t.isValid() ? t > this ? this : t : y()
                }));

            function Ki(t, e) {
                var i, n;
                if (1 === e.length && r(e[0]) && (e = e[0]), !e.length) return Zi();
                for (i = e[0], n = 1; n < e.length; ++n) e[n].isValid() && !e[n][t](i) || (i = e[n]);
                return i
            }

            function $i() {
                return Ki("isBefore", [].slice.call(arguments, 0))
            }

            function Qi() {
                return Ki("isAfter", [].slice.call(arguments, 0))
            }
            var Ji = function () {
                    return Date.now ? Date.now() : +new Date
                },
                tn = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

            function en(t) {
                var e, i, n = !1;
                for (e in t)
                    if (o(t, e) && (-1 === Yt.call(tn, e) || null != t[e] && isNaN(t[e]))) return !1;
                for (i = 0; i < tn.length; ++i)
                    if (t[tn[i]]) {
                        if (n) return !1;
                        parseFloat(t[tn[i]]) !== ut(t[tn[i]]) && (n = !0)
                    } return !0
            }

            function nn() {
                return this._isValid
            }

            function ln() {
                return Cn(NaN)
            }

            function rn(t) {
                var e = lt(t),
                    i = e.year || 0,
                    n = e.quarter || 0,
                    l = e.month || 0,
                    r = e.week || e.isoWeek || 0,
                    a = e.day || 0,
                    o = e.hour || 0,
                    s = e.minute || 0,
                    c = e.second || 0,
                    u = e.millisecond || 0;
                this._isValid = en(e), this._milliseconds = +u + 1e3 * c + 6e4 * s + 1e3 * o * 60 * 60, this._days = +a + 7 * r, this._months = +l + 3 * n + 12 * i, this._data = {}, this._locale = mi(), this._bubble()
            }

            function an(t) {
                return t instanceof rn
            }

            function on(t) {
                return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t)
            }

            function sn(t, e, i) {
                var n, l = Math.min(t.length, e.length),
                    r = Math.abs(t.length - e.length),
                    a = 0;
                for (n = 0; n < l; n++)(i && t[n] !== e[n] || !i && ut(t[n]) !== ut(e[n])) && a++;
                return a + r
            }

            function cn(t, e) {
                H(t, 0, 0, (function () {
                    var t = this.utcOffset(),
                        i = "+";
                    return t < 0 && (t = -t, i = "-"), i + j(~~(t / 60), 2) + e + j(~~t % 60, 2)
                }))
            }
            cn("Z", ":"), cn("ZZ", ""), It("Z", Pt), It("ZZ", Pt), zt(["Z", "ZZ"], (function (t, e, i) {
                i._useUTC = !0, i._tzm = hn(Pt, t)
            }));
            var un = /([\+\-]|\d\d)/gi;

            function hn(t, e) {
                var i, n, l = (e || "").match(t);
                return null === l ? null : 0 === (n = 60 * (i = ((l[l.length - 1] || []) + "").match(un) || ["-", 0, 0])[1] + ut(i[2])) ? 0 : "+" === i[0] ? n : -n
            }

            function dn(t, e) {
                var i, l;
                return e._isUTC ? (i = e.clone(), l = (k(t) || h(t) ? t.valueOf() : Zi(t).valueOf()) - i.valueOf(), i._d.setTime(i._d.valueOf() + l), n.updateOffset(i, !1), i) : Zi(t).local()
            }

            function fn(t) {
                return -Math.round(t._d.getTimezoneOffset())
            }

            function pn(t, e, i) {
                var l, r = this._offset || 0;
                if (!this.isValid()) return null != t ? this : NaN;
                if (null != t) {
                    if ("string" == typeof t) {
                        if (null === (t = hn(Pt, t))) return this
                    } else Math.abs(t) < 16 && !i && (t *= 60);
                    return !this._isUTC && e && (l = fn(this)), this._offset = t, this._isUTC = !0, null != l && this.add(l, "m"), r !== t && (!e || this._changeInProgress ? Ln(this, Cn(t - r, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, n.updateOffset(this, !0), this._changeInProgress = null)), this
                }
                return this._isUTC ? r : fn(this)
            }

            function gn(t, e) {
                return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset()
            }

            function mn(t) {
                return this.utcOffset(0, t)
            }

            function vn(t) {
                return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(fn(this), "m")), this
            }

            function yn() {
                if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
                else if ("string" == typeof this._i) {
                    var t = hn(Tt, this._i);
                    null != t ? this.utcOffset(t) : this.utcOffset(0, !0)
                }
                return this
            }

            function bn(t) {
                return !!this.isValid() && (t = t ? Zi(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0)
            }

            function xn() {
                return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
            }

            function wn() {
                if (!c(this._isDSTShifted)) return this._isDSTShifted;
                var t, e = {};
                return w(e, this), (e = Vi(e))._a ? (t = e._isUTC ? p(e._a) : Zi(e._a), this._isDSTShifted = this.isValid() && sn(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted
            }

            function _n() {
                return !!this.isValid() && !this._isUTC
            }

            function kn() {
                return !!this.isValid() && this._isUTC
            }

            function Sn() {
                return !!this.isValid() && this._isUTC && 0 === this._offset
            }
            n.updateOffset = function () {};
            var An = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
                Mn = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

            function Cn(t, e) {
                var i, n, l, r = t,
                    a = null;
                return an(t) ? r = {
                    ms: t._milliseconds,
                    d: t._days,
                    M: t._months
                } : u(t) || !isNaN(+t) ? (r = {}, e ? r[e] = +t : r.milliseconds = +t) : (a = An.exec(t)) ? (i = "-" === a[1] ? -1 : 1, r = {
                    y: 0,
                    d: ut(a[Xt]) * i,
                    h: ut(a[qt]) * i,
                    m: ut(a[Zt]) * i,
                    s: ut(a[Gt]) * i,
                    ms: ut(on(1e3 * a[Ut])) * i
                }) : (a = Mn.exec(t)) ? (i = "-" === a[1] ? -1 : 1, r = {
                    y: En(a[2], i),
                    M: En(a[3], i),
                    w: En(a[4], i),
                    d: En(a[5], i),
                    h: En(a[6], i),
                    m: En(a[7], i),
                    s: En(a[8], i)
                }) : null == r ? r = {} : "object" == typeof r && ("from" in r || "to" in r) && (l = Tn(Zi(r.from), Zi(r.to)), (r = {}).ms = l.milliseconds, r.M = l.months), n = new rn(r), an(t) && o(t, "_locale") && (n._locale = t._locale), an(t) && o(t, "_isValid") && (n._isValid = t._isValid), n
            }

            function En(t, e) {
                var i = t && parseFloat(t.replace(",", "."));
                return (isNaN(i) ? 0 : i) * e
            }

            function On(t, e) {
                var i = {};
                return i.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(i.months, "M").isAfter(e) && --i.months, i.milliseconds = +e - +t.clone().add(i.months, "M"), i
            }

            function Tn(t, e) {
                var i;
                return t.isValid() && e.isValid() ? (e = dn(e, t), t.isBefore(e) ? i = On(t, e) : ((i = On(e, t)).milliseconds = -i.milliseconds, i.months = -i.months), i) : {
                    milliseconds: 0,
                    months: 0
                }
            }

            function Pn(t, e) {
                return function (i, n) {
                    var l;
                    return null === n || isNaN(+n) || (E(e, "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), l = i, i = n, n = l), Ln(this, Cn(i, n), t), this
                }
            }

            function Ln(t, e, i, l) {
                var r = e._milliseconds,
                    a = on(e._days),
                    o = on(e._months);
                t.isValid() && (l = null == l || l, o && ce(t, dt(t, "Month") + o * i), a && ft(t, "Date", dt(t, "Date") + a * i), r && t._d.setTime(t._d.valueOf() + r * i), l && n.updateOffset(t, a || o))
            }
            Cn.fn = rn.prototype, Cn.invalid = ln;
            var Dn = Pn(1, "add"),
                In = Pn(-1, "subtract");

            function jn(t) {
                return "string" == typeof t || t instanceof String
            }

            function Nn(t) {
                return k(t) || h(t) || jn(t) || u(t) || Fn(t) || Rn(t) || null == t
            }

            function Rn(t) {
                var e, i, n = a(t) && !s(t),
                    l = !1,
                    r = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"];
                for (e = 0; e < r.length; e += 1) i = r[e], l = l || o(t, i);
                return n && l
            }

            function Fn(t) {
                var e = r(t),
                    i = !1;
                return e && (i = 0 === t.filter((function (e) {
                    return !u(e) && jn(t)
                })).length), e && i
            }

            function zn(t) {
                var e, i, n = a(t) && !s(t),
                    l = !1,
                    r = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
                for (e = 0; e < r.length; e += 1) i = r[e], l = l || o(t, i);
                return n && l
            }

            function Hn(t, e) {
                var i = t.diff(e, "days", !0);
                return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse"
            }

            function Bn(t, e) {
                1 === arguments.length && (arguments[0] ? Nn(arguments[0]) ? (t = arguments[0], e = void 0) : zn(arguments[0]) && (e = arguments[0], t = void 0) : (t = void 0, e = void 0));
                var i = t || Zi(),
                    l = dn(i, this).startOf("day"),
                    r = n.calendarFormat(this, l) || "sameElse",
                    a = e && (O(e[r]) ? e[r].call(this, i) : e[r]);
                return this.format(a || this.localeData().calendar(r, this, Zi(i)))
            }

            function Yn() {
                return new _(this)
            }

            function Wn(t, e) {
                var i = k(t) ? t : Zi(t);
                return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = nt(e) || "millisecond") ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(e).valueOf())
            }

            function Vn(t, e) {
                var i = k(t) ? t : Zi(t);
                return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = nt(e) || "millisecond") ? this.valueOf() < i.valueOf() : this.clone().endOf(e).valueOf() < i.valueOf())
            }

            function Xn(t, e, i, n) {
                var l = k(t) ? t : Zi(t),
                    r = k(e) ? e : Zi(e);
                return !!(this.isValid() && l.isValid() && r.isValid()) && ("(" === (n = n || "()")[0] ? this.isAfter(l, i) : !this.isBefore(l, i)) && (")" === n[1] ? this.isBefore(r, i) : !this.isAfter(r, i))
            }

            function qn(t, e) {
                var i, n = k(t) ? t : Zi(t);
                return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = nt(e) || "millisecond") ? this.valueOf() === n.valueOf() : (i = n.valueOf(), this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf()))
            }

            function Zn(t, e) {
                return this.isSame(t, e) || this.isAfter(t, e)
            }

            function Gn(t, e) {
                return this.isSame(t, e) || this.isBefore(t, e)
            }

            function Un(t, e, i) {
                var n, l, r;
                if (!this.isValid()) return NaN;
                if (!(n = dn(t, this)).isValid()) return NaN;
                switch (l = 6e4 * (n.utcOffset() - this.utcOffset()), e = nt(e)) {
                    case "year":
                        r = Kn(this, n) / 12;
                        break;
                    case "month":
                        r = Kn(this, n);
                        break;
                    case "quarter":
                        r = Kn(this, n) / 3;
                        break;
                    case "second":
                        r = (this - n) / 1e3;
                        break;
                    case "minute":
                        r = (this - n) / 6e4;
                        break;
                    case "hour":
                        r = (this - n) / 36e5;
                        break;
                    case "day":
                        r = (this - n - l) / 864e5;
                        break;
                    case "week":
                        r = (this - n - l) / 6048e5;
                        break;
                    default:
                        r = this - n
                }
                return i ? r : ct(r)
            }

            function Kn(t, e) {
                if (t.date() < e.date()) return -Kn(e, t);
                var i = 12 * (e.year() - t.year()) + (e.month() - t.month()),
                    n = t.clone().add(i, "months");
                return -(i + (e - n < 0 ? (e - n) / (n - t.clone().add(i - 1, "months")) : (e - n) / (t.clone().add(i + 1, "months") - n))) || 0
            }

            function $n() {
                return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
            }

            function Qn(t) {
                if (!this.isValid()) return null;
                var e = !0 !== t,
                    i = e ? this.clone().utc() : this;
                return i.year() < 0 || i.year() > 9999 ? W(i, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : O(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", W(i, "Z")) : W(i, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ")
            }

            function Jn() {
                if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
                var t, e, i, n, l = "moment",
                    r = "";
                return this.isLocal() || (l = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", r = "Z"), t = "[" + l + '("]', e = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = "-MM-DD[T]HH:mm:ss.SSS", n = r + '[")]', this.format(t + e + i + n)
            }

            function tl(t) {
                t || (t = this.isUtc() ? n.defaultFormatUtc : n.defaultFormat);
                var e = W(this, t);
                return this.localeData().postformat(e)
            }

            function el(t, e) {
                return this.isValid() && (k(t) && t.isValid() || Zi(t).isValid()) ? Cn({
                    to: this,
                    from: t
                }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
            }

            function il(t) {
                return this.from(Zi(), t)
            }

            function nl(t, e) {
                return this.isValid() && (k(t) && t.isValid() || Zi(t).isValid()) ? Cn({
                    from: this,
                    to: t
                }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
            }

            function ll(t) {
                return this.to(Zi(), t)
            }

            function rl(t) {
                var e;
                return void 0 === t ? this._locale._abbr : (null != (e = mi(t)) && (this._locale = e), this)
            }
            n.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", n.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
            var al = A("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", (function (t) {
                return void 0 === t ? this.localeData() : this.locale(t)
            }));

            function ol() {
                return this._locale
            }
            var sl = 1e3,
                cl = 60 * sl,
                ul = 60 * cl,
                hl = 3506328 * ul;

            function dl(t, e) {
                return (t % e + e) % e
            }

            function fl(t, e, i) {
                return t < 100 && t >= 0 ? new Date(t + 400, e, i) - hl : new Date(t, e, i).valueOf()
            }

            function pl(t, e, i) {
                return t < 100 && t >= 0 ? Date.UTC(t + 400, e, i) - hl : Date.UTC(t, e, i)
            }

            function gl(t) {
                var e, i;
                if (void 0 === (t = nt(t)) || "millisecond" === t || !this.isValid()) return this;
                switch (i = this._isUTC ? pl : fl, t) {
                    case "year":
                        e = i(this.year(), 0, 1);
                        break;
                    case "quarter":
                        e = i(this.year(), this.month() - this.month() % 3, 1);
                        break;
                    case "month":
                        e = i(this.year(), this.month(), 1);
                        break;
                    case "week":
                        e = i(this.year(), this.month(), this.date() - this.weekday());
                        break;
                    case "isoWeek":
                        e = i(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                        break;
                    case "day":
                    case "date":
                        e = i(this.year(), this.month(), this.date());
                        break;
                    case "hour":
                        e = this._d.valueOf(), e -= dl(e + (this._isUTC ? 0 : this.utcOffset() * cl), ul);
                        break;
                    case "minute":
                        e = this._d.valueOf(), e -= dl(e, cl);
                        break;
                    case "second":
                        e = this._d.valueOf(), e -= dl(e, sl)
                }
                return this._d.setTime(e), n.updateOffset(this, !0), this
            }

            function ml(t) {
                var e, i;
                if (void 0 === (t = nt(t)) || "millisecond" === t || !this.isValid()) return this;
                switch (i = this._isUTC ? pl : fl, t) {
                    case "year":
                        e = i(this.year() + 1, 0, 1) - 1;
                        break;
                    case "quarter":
                        e = i(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                        break;
                    case "month":
                        e = i(this.year(), this.month() + 1, 1) - 1;
                        break;
                    case "week":
                        e = i(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                        break;
                    case "isoWeek":
                        e = i(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                        break;
                    case "day":
                    case "date":
                        e = i(this.year(), this.month(), this.date() + 1) - 1;
                        break;
                    case "hour":
                        e = this._d.valueOf(), e += ul - dl(e + (this._isUTC ? 0 : this.utcOffset() * cl), ul) - 1;
                        break;
                    case "minute":
                        e = this._d.valueOf(), e += cl - dl(e, cl) - 1;
                        break;
                    case "second":
                        e = this._d.valueOf(), e += sl - dl(e, sl) - 1
                }
                return this._d.setTime(e), n.updateOffset(this, !0), this
            }

            function vl() {
                return this._d.valueOf() - 6e4 * (this._offset || 0)
            }

            function yl() {
                return Math.floor(this.valueOf() / 1e3)
            }

            function bl() {
                return new Date(this.valueOf())
            }

            function xl() {
                var t = this;
                return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()]
            }

            function wl() {
                var t = this;
                return {
                    years: t.year(),
                    months: t.month(),
                    date: t.date(),
                    hours: t.hours(),
                    minutes: t.minutes(),
                    seconds: t.seconds(),
                    milliseconds: t.milliseconds()
                }
            }

            function _l() {
                return this.isValid() ? this.toISOString() : null
            }

            function kl() {
                return v(this)
            }

            function Sl() {
                return f({}, m(this))
            }

            function Al() {
                return m(this).overflow
            }

            function Ml() {
                return {
                    input: this._i,
                    format: this._f,
                    locale: this._locale,
                    isUTC: this._isUTC,
                    strict: this._strict
                }
            }

            function Cl(t, e) {
                var i, l, r, a = this._eras || mi("en")._eras;
                for (i = 0, l = a.length; i < l; ++i) {
                    switch (typeof a[i].since) {
                        case "string":
                            r = n(a[i].since).startOf("day"), a[i].since = r.valueOf()
                    }
                    switch (typeof a[i].until) {
                        case "undefined":
                            a[i].until = 1 / 0;
                            break;
                        case "string":
                            r = n(a[i].until).startOf("day").valueOf(), a[i].until = r.valueOf()
                    }
                }
                return a
            }

            function El(t, e, i) {
                var n, l, r, a, o, s = this.eras();
                for (t = t.toUpperCase(), n = 0, l = s.length; n < l; ++n)
                    if (r = s[n].name.toUpperCase(), a = s[n].abbr.toUpperCase(), o = s[n].narrow.toUpperCase(), i) switch (e) {
                        case "N":
                        case "NN":
                        case "NNN":
                            if (a === t) return s[n];
                            break;
                        case "NNNN":
                            if (r === t) return s[n];
                            break;
                        case "NNNNN":
                            if (o === t) return s[n]
                    } else if ([r, a, o].indexOf(t) >= 0) return s[n]
            }

            function Ol(t, e) {
                var i = t.since <= t.until ? 1 : -1;
                return void 0 === e ? n(t.since).year() : n(t.since).year() + (e - t.offset) * i
            }

            function Tl() {
                var t, e, i, n = this.localeData().eras();
                for (t = 0, e = n.length; t < e; ++t) {
                    if (i = this.clone().startOf("day").valueOf(), n[t].since <= i && i <= n[t].until) return n[t].name;
                    if (n[t].until <= i && i <= n[t].since) return n[t].name
                }
                return ""
            }

            function Pl() {
                var t, e, i, n = this.localeData().eras();
                for (t = 0, e = n.length; t < e; ++t) {
                    if (i = this.clone().startOf("day").valueOf(), n[t].since <= i && i <= n[t].until) return n[t].narrow;
                    if (n[t].until <= i && i <= n[t].since) return n[t].narrow
                }
                return ""
            }

            function Ll() {
                var t, e, i, n = this.localeData().eras();
                for (t = 0, e = n.length; t < e; ++t) {
                    if (i = this.clone().startOf("day").valueOf(), n[t].since <= i && i <= n[t].until) return n[t].abbr;
                    if (n[t].until <= i && i <= n[t].since) return n[t].abbr
                }
                return ""
            }

            function Dl() {
                var t, e, i, l, r = this.localeData().eras();
                for (t = 0, e = r.length; t < e; ++t)
                    if (i = r[t].since <= r[t].until ? 1 : -1, l = this.clone().startOf("day").valueOf(), r[t].since <= l && l <= r[t].until || r[t].until <= l && l <= r[t].since) return (this.year() - n(r[t].since).year()) * i + r[t].offset;
                return this.year()
            }

            function Il(t) {
                return o(this, "_erasNameRegex") || Bl.call(this), t ? this._erasNameRegex : this._erasRegex
            }

            function jl(t) {
                return o(this, "_erasAbbrRegex") || Bl.call(this), t ? this._erasAbbrRegex : this._erasRegex
            }

            function Nl(t) {
                return o(this, "_erasNarrowRegex") || Bl.call(this), t ? this._erasNarrowRegex : this._erasRegex
            }

            function Rl(t, e) {
                return e.erasAbbrRegex(t)
            }

            function Fl(t, e) {
                return e.erasNameRegex(t)
            }

            function zl(t, e) {
                return e.erasNarrowRegex(t)
            }

            function Hl(t, e) {
                return e._eraYearOrdinalRegex || Et
            }

            function Bl() {
                var t, e, i = [],
                    n = [],
                    l = [],
                    r = [],
                    a = this.eras();
                for (t = 0, e = a.length; t < e; ++t) n.push(Rt(a[t].name)), i.push(Rt(a[t].abbr)), l.push(Rt(a[t].narrow)), r.push(Rt(a[t].name)), r.push(Rt(a[t].abbr)), r.push(Rt(a[t].narrow));
                this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + l.join("|") + ")", "i")
            }

            function Yl(t, e) {
                H(0, [t, t.length], 0, e)
            }

            function Wl(t) {
                return Ul.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
            }

            function Vl(t) {
                return Ul.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4)
            }

            function Xl() {
                return ke(this.year(), 1, 4)
            }

            function ql() {
                return ke(this.isoWeekYear(), 1, 4)
            }

            function Zl() {
                var t = this.localeData()._week;
                return ke(this.year(), t.dow, t.doy)
            }

            function Gl() {
                var t = this.localeData()._week;
                return ke(this.weekYear(), t.dow, t.doy)
            }

            function Ul(t, e, i, n, l) {
                var r;
                return null == t ? _e(this, n, l).year : (e > (r = ke(t, n, l)) && (e = r), Kl.call(this, t, e, i, n, l))
            }

            function Kl(t, e, i, n, l) {
                var r = we(t, e, i, n, l),
                    a = be(r.year, 0, r.dayOfYear);
                return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this
            }

            function $l(t) {
                return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3)
            }
            H("N", 0, 0, "eraAbbr"), H("NN", 0, 0, "eraAbbr"), H("NNN", 0, 0, "eraAbbr"), H("NNNN", 0, 0, "eraName"), H("NNNNN", 0, 0, "eraNarrow"), H("y", ["y", 1], "yo", "eraYear"), H("y", ["yy", 2], 0, "eraYear"), H("y", ["yyy", 3], 0, "eraYear"), H("y", ["yyyy", 4], 0, "eraYear"), It("N", Rl), It("NN", Rl), It("NNN", Rl), It("NNNN", Fl), It("NNNNN", zl), zt(["N", "NN", "NNN", "NNNN", "NNNNN"], (function (t, e, i, n) {
                var l = i._locale.erasParse(t, n, i._strict);
                l ? m(i).era = l : m(i).invalidEra = t
            })), It("y", Et), It("yy", Et), It("yyy", Et), It("yyyy", Et), It("yo", Hl), zt(["y", "yy", "yyy", "yyyy"], Wt), zt(["yo"], (function (t, e, i, n) {
                var l;
                i._locale._eraYearOrdinalRegex && (l = t.match(i._locale._eraYearOrdinalRegex)), i._locale.eraYearOrdinalParse ? e[Wt] = i._locale.eraYearOrdinalParse(t, l) : e[Wt] = parseInt(t, 10)
            })), H(0, ["gg", 2], 0, (function () {
                return this.weekYear() % 100
            })), H(0, ["GG", 2], 0, (function () {
                return this.isoWeekYear() % 100
            })), Yl("gggg", "weekYear"), Yl("ggggg", "weekYear"), Yl("GGGG", "isoWeekYear"), Yl("GGGGG", "isoWeekYear"), it("weekYear", "gg"), it("isoWeekYear", "GG"), at("weekYear", 1), at("isoWeekYear", 1), It("G", Ot), It("g", Ot), It("GG", _t, yt), It("gg", _t, yt), It("GGGG", Mt, xt), It("gggg", Mt, xt), It("GGGGG", Ct, wt), It("ggggg", Ct, wt), Ht(["gggg", "ggggg", "GGGG", "GGGGG"], (function (t, e, i, n) {
                e[n.substr(0, 2)] = ut(t)
            })), Ht(["gg", "GG"], (function (t, e, i, l) {
                e[l] = n.parseTwoDigitYear(t)
            })), H("Q", 0, "Qo", "quarter"), it("quarter", "Q"), at("quarter", 7), It("Q", vt), zt("Q", (function (t, e) {
                e[Vt] = 3 * (ut(t) - 1)
            })), H("D", ["DD", 2], "Do", "date"), it("date", "D"), at("date", 9), It("D", _t), It("DD", _t, yt), It("Do", (function (t, e) {
                return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient
            })), zt(["D", "DD"], Xt), zt("Do", (function (t, e) {
                e[Xt] = ut(t.match(_t)[0])
            }));
            var Ql = ht("Date", !0);

            function Jl(t) {
                var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
                return null == t ? e : this.add(t - e, "d")
            }
            H("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), it("dayOfYear", "DDD"), at("dayOfYear", 4), It("DDD", At), It("DDDD", bt), zt(["DDD", "DDDD"], (function (t, e, i) {
                i._dayOfYear = ut(t)
            })), H("m", ["mm", 2], 0, "minute"), it("minute", "m"), at("minute", 14), It("m", _t), It("mm", _t, yt), zt(["m", "mm"], Zt);
            var tr = ht("Minutes", !1);
            H("s", ["ss", 2], 0, "second"), it("second", "s"), at("second", 15), It("s", _t), It("ss", _t, yt), zt(["s", "ss"], Gt);
            var er, ir, nr = ht("Seconds", !1);
            for (H("S", 0, 0, (function () {
                    return ~~(this.millisecond() / 100)
                })), H(0, ["SS", 2], 0, (function () {
                    return ~~(this.millisecond() / 10)
                })), H(0, ["SSS", 3], 0, "millisecond"), H(0, ["SSSS", 4], 0, (function () {
                    return 10 * this.millisecond()
                })), H(0, ["SSSSS", 5], 0, (function () {
                    return 100 * this.millisecond()
                })), H(0, ["SSSSSS", 6], 0, (function () {
                    return 1e3 * this.millisecond()
                })), H(0, ["SSSSSSS", 7], 0, (function () {
                    return 1e4 * this.millisecond()
                })), H(0, ["SSSSSSSS", 8], 0, (function () {
                    return 1e5 * this.millisecond()
                })), H(0, ["SSSSSSSSS", 9], 0, (function () {
                    return 1e6 * this.millisecond()
                })), it("millisecond", "ms"), at("millisecond", 16), It("S", At, vt), It("SS", At, yt), It("SSS", At, bt), er = "SSSS"; er.length <= 9; er += "S") It(er, Et);

            function lr(t, e) {
                e[Ut] = ut(1e3 * ("0." + t))
            }
            for (er = "S"; er.length <= 9; er += "S") zt(er, lr);

            function rr() {
                return this._isUTC ? "UTC" : ""
            }

            function ar() {
                return this._isUTC ? "Coordinated Universal Time" : ""
            }
            ir = ht("Milliseconds", !1), H("z", 0, 0, "zoneAbbr"), H("zz", 0, 0, "zoneName");
            var or = _.prototype;

            function sr(t) {
                return Zi(1e3 * t)
            }

            function cr() {
                return Zi.apply(null, arguments).parseZone()
            }

            function ur(t) {
                return t
            }
            or.add = Dn, or.calendar = Bn, or.clone = Yn, or.diff = Un, or.endOf = ml, or.format = tl, or.from = el, or.fromNow = il, or.to = nl, or.toNow = ll, or.get = pt, or.invalidAt = Al, or.isAfter = Wn, or.isBefore = Vn, or.isBetween = Xn, or.isSame = qn, or.isSameOrAfter = Zn, or.isSameOrBefore = Gn, or.isValid = kl, or.lang = al, or.locale = rl, or.localeData = ol, or.max = Ui, or.min = Gi, or.parsingFlags = Sl, or.set = gt, or.startOf = gl, or.subtract = In, or.toArray = xl, or.toObject = wl, or.toDate = bl, or.toISOString = Qn, or.inspect = Jn, "undefined" != typeof Symbol && null != Symbol.for && (or[Symbol.for("nodejs.util.inspect.custom")] = function () {
                return "Moment<" + this.format() + ">"
            }), or.toJSON = _l, or.toString = $n, or.unix = yl, or.valueOf = vl, or.creationData = Ml, or.eraName = Tl, or.eraNarrow = Pl, or.eraAbbr = Ll, or.eraYear = Dl, or.year = me, or.isLeapYear = ve, or.weekYear = Wl, or.isoWeekYear = Vl, or.quarter = or.quarters = $l, or.month = ue, or.daysInMonth = he, or.week = or.weeks = Ee, or.isoWeek = or.isoWeeks = Oe, or.weeksInYear = Zl, or.weeksInWeekYear = Gl, or.isoWeeksInYear = Xl, or.isoWeeksInISOWeekYear = ql, or.date = Ql, or.day = or.days = Ve, or.weekday = Xe, or.isoWeekday = qe, or.dayOfYear = Jl, or.hour = or.hours = ni, or.minute = or.minutes = tr, or.second = or.seconds = nr, or.millisecond = or.milliseconds = ir, or.utcOffset = pn, or.utc = mn, or.local = vn, or.parseZone = yn, or.hasAlignedHourOffset = bn, or.isDST = xn, or.isLocal = _n, or.isUtcOffset = kn, or.isUtc = Sn, or.isUTC = Sn, or.zoneAbbr = rr, or.zoneName = ar, or.dates = A("dates accessor is deprecated. Use date instead.", Ql), or.months = A("months accessor is deprecated. Use month instead", ue), or.years = A("years accessor is deprecated. Use year instead", me), or.zone = A("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", gn), or.isDSTShifted = A("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", wn);
            var hr = L.prototype;

            function dr(t, e, i, n) {
                var l = mi(),
                    r = p().set(n, e);
                return l[i](r, t)
            }

            function fr(t, e, i) {
                if (u(t) && (e = t, t = void 0), t = t || "", null != e) return dr(t, e, i, "month");
                var n, l = [];
                for (n = 0; n < 12; n++) l[n] = dr(t, n, i, "month");
                return l
            }

            function pr(t, e, i, n) {
                "boolean" == typeof t ? (u(e) && (i = e, e = void 0), e = e || "") : (i = e = t, t = !1, u(e) && (i = e, e = void 0), e = e || "");
                var l, r = mi(),
                    a = t ? r._week.dow : 0,
                    o = [];
                if (null != i) return dr(e, (i + a) % 7, n, "day");
                for (l = 0; l < 7; l++) o[l] = dr(e, (l + a) % 7, n, "day");
                return o
            }

            function gr(t, e) {
                return fr(t, e, "months")
            }

            function mr(t, e) {
                return fr(t, e, "monthsShort")
            }

            function vr(t, e, i) {
                return pr(t, e, i, "weekdays")
            }

            function yr(t, e, i) {
                return pr(t, e, i, "weekdaysShort")
            }

            function br(t, e, i) {
                return pr(t, e, i, "weekdaysMin")
            }
            hr.calendar = I, hr.longDateFormat = q, hr.invalidDate = G, hr.ordinal = $, hr.preparse = ur, hr.postformat = ur, hr.relativeTime = J, hr.pastFuture = tt, hr.set = T, hr.eras = Cl, hr.erasParse = El, hr.erasConvertYear = Ol, hr.erasAbbrRegex = jl, hr.erasNameRegex = Il, hr.erasNarrowRegex = Nl, hr.months = re, hr.monthsShort = ae, hr.monthsParse = se, hr.monthsRegex = fe, hr.monthsShortRegex = de, hr.week = Se, hr.firstDayOfYear = Ce, hr.firstDayOfWeek = Me, hr.weekdays = ze, hr.weekdaysMin = Be, hr.weekdaysShort = He, hr.weekdaysParse = We, hr.weekdaysRegex = Ze, hr.weekdaysShortRegex = Ge, hr.weekdaysMinRegex = Ue, hr.isPM = ei, hr.meridiem = li, fi("en", {
                eras: [{
                    since: "0001-01-01",
                    until: 1 / 0,
                    offset: 1,
                    name: "Anno Domini",
                    narrow: "AD",
                    abbr: "AD"
                }, {
                    since: "0000-12-31",
                    until: -1 / 0,
                    offset: 1,
                    name: "Before Christ",
                    narrow: "BC",
                    abbr: "BC"
                }],
                dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                ordinal: function (t) {
                    var e = t % 10;
                    return t + (1 === ut(t % 100 / 10) ? "th" : 1 === e ? "st" : 2 === e ? "nd" : 3 === e ? "rd" : "th")
                }
            }), n.lang = A("moment.lang is deprecated. Use moment.locale instead.", fi), n.langData = A("moment.langData is deprecated. Use moment.localeData instead.", mi);
            var xr = Math.abs;

            function wr() {
                var t = this._data;
                return this._milliseconds = xr(this._milliseconds), this._days = xr(this._days), this._months = xr(this._months), t.milliseconds = xr(t.milliseconds), t.seconds = xr(t.seconds), t.minutes = xr(t.minutes), t.hours = xr(t.hours), t.months = xr(t.months), t.years = xr(t.years), this
            }

            function _r(t, e, i, n) {
                var l = Cn(e, i);
                return t._milliseconds += n * l._milliseconds, t._days += n * l._days, t._months += n * l._months, t._bubble()
            }

            function kr(t, e) {
                return _r(this, t, e, 1)
            }

            function Sr(t, e) {
                return _r(this, t, e, -1)
            }

            function Ar(t) {
                return t < 0 ? Math.floor(t) : Math.ceil(t)
            }

            function Mr() {
                var t, e, i, n, l, r = this._milliseconds,
                    a = this._days,
                    o = this._months,
                    s = this._data;
                return r >= 0 && a >= 0 && o >= 0 || r <= 0 && a <= 0 && o <= 0 || (r += 864e5 * Ar(Er(o) + a), a = 0, o = 0), s.milliseconds = r % 1e3, t = ct(r / 1e3), s.seconds = t % 60, e = ct(t / 60), s.minutes = e % 60, i = ct(e / 60), s.hours = i % 24, a += ct(i / 24), o += l = ct(Cr(a)), a -= Ar(Er(l)), n = ct(o / 12), o %= 12, s.days = a, s.months = o, s.years = n, this
            }

            function Cr(t) {
                return 4800 * t / 146097
            }

            function Er(t) {
                return 146097 * t / 4800
            }

            function Or(t) {
                if (!this.isValid()) return NaN;
                var e, i, n = this._milliseconds;
                if ("month" === (t = nt(t)) || "quarter" === t || "year" === t) switch (e = this._days + n / 864e5, i = this._months + Cr(e), t) {
                    case "month":
                        return i;
                    case "quarter":
                        return i / 3;
                    case "year":
                        return i / 12
                } else switch (e = this._days + Math.round(Er(this._months)), t) {
                    case "week":
                        return e / 7 + n / 6048e5;
                    case "day":
                        return e + n / 864e5;
                    case "hour":
                        return 24 * e + n / 36e5;
                    case "minute":
                        return 1440 * e + n / 6e4;
                    case "second":
                        return 86400 * e + n / 1e3;
                    case "millisecond":
                        return Math.floor(864e5 * e) + n;
                    default:
                        throw new Error("Unknown unit " + t)
                }
            }

            function Tr() {
                return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * ut(this._months / 12) : NaN
            }

            function Pr(t) {
                return function () {
                    return this.as(t)
                }
            }
            var Lr = Pr("ms"),
                Dr = Pr("s"),
                Ir = Pr("m"),
                jr = Pr("h"),
                Nr = Pr("d"),
                Rr = Pr("w"),
                Fr = Pr("M"),
                zr = Pr("Q"),
                Hr = Pr("y");

            function Br() {
                return Cn(this)
            }

            function Yr(t) {
                return t = nt(t), this.isValid() ? this[t + "s"]() : NaN
            }

            function Wr(t) {
                return function () {
                    return this.isValid() ? this._data[t] : NaN
                }
            }
            var Vr = Wr("milliseconds"),
                Xr = Wr("seconds"),
                qr = Wr("minutes"),
                Zr = Wr("hours"),
                Gr = Wr("days"),
                Ur = Wr("months"),
                Kr = Wr("years");

            function $r() {
                return ct(this.days() / 7)
            }
            var Qr = Math.round,
                Jr = {
                    ss: 44,
                    s: 45,
                    m: 45,
                    h: 22,
                    d: 26,
                    w: null,
                    M: 11
                };

            function ta(t, e, i, n, l) {
                return l.relativeTime(e || 1, !!i, t, n)
            }

            function ea(t, e, i, n) {
                var l = Cn(t).abs(),
                    r = Qr(l.as("s")),
                    a = Qr(l.as("m")),
                    o = Qr(l.as("h")),
                    s = Qr(l.as("d")),
                    c = Qr(l.as("M")),
                    u = Qr(l.as("w")),
                    h = Qr(l.as("y")),
                    d = r <= i.ss && ["s", r] || r < i.s && ["ss", r] || a <= 1 && ["m"] || a < i.m && ["mm", a] || o <= 1 && ["h"] || o < i.h && ["hh", o] || s <= 1 && ["d"] || s < i.d && ["dd", s];
                return null != i.w && (d = d || u <= 1 && ["w"] || u < i.w && ["ww", u]), (d = d || c <= 1 && ["M"] || c < i.M && ["MM", c] || h <= 1 && ["y"] || ["yy", h])[2] = e, d[3] = +t > 0, d[4] = n, ta.apply(null, d)
            }

            function ia(t) {
                return void 0 === t ? Qr : "function" == typeof t && (Qr = t, !0)
            }

            function na(t, e) {
                return void 0 !== Jr[t] && (void 0 === e ? Jr[t] : (Jr[t] = e, "s" === t && (Jr.ss = e - 1), !0))
            }

            function la(t, e) {
                if (!this.isValid()) return this.localeData().invalidDate();
                var i, n, l = !1,
                    r = Jr;
                return "object" == typeof t && (e = t, t = !1), "boolean" == typeof t && (l = t), "object" == typeof e && (r = Object.assign({}, Jr, e), null != e.s && null == e.ss && (r.ss = e.s - 1)), n = ea(this, !l, r, i = this.localeData()), l && (n = i.pastFuture(+this, n)), i.postformat(n)
            }
            var ra = Math.abs;

            function aa(t) {
                return (t > 0) - (t < 0) || +t
            }

            function oa() {
                if (!this.isValid()) return this.localeData().invalidDate();
                var t, e, i, n, l, r, a, o, s = ra(this._milliseconds) / 1e3,
                    c = ra(this._days),
                    u = ra(this._months),
                    h = this.asSeconds();
                return h ? (t = ct(s / 60), e = ct(t / 60), s %= 60, t %= 60, i = ct(u / 12), u %= 12, n = s ? s.toFixed(3).replace(/\.?0+$/, "") : "", l = h < 0 ? "-" : "", r = aa(this._months) !== aa(h) ? "-" : "", a = aa(this._days) !== aa(h) ? "-" : "", o = aa(this._milliseconds) !== aa(h) ? "-" : "", l + "P" + (i ? r + i + "Y" : "") + (u ? r + u + "M" : "") + (c ? a + c + "D" : "") + (e || t || s ? "T" : "") + (e ? o + e + "H" : "") + (t ? o + t + "M" : "") + (s ? o + n + "S" : "")) : "P0D"
            }
            var sa = rn.prototype;
            return sa.isValid = nn, sa.abs = wr, sa.add = kr, sa.subtract = Sr, sa.as = Or, sa.asMilliseconds = Lr, sa.asSeconds = Dr, sa.asMinutes = Ir, sa.asHours = jr, sa.asDays = Nr, sa.asWeeks = Rr, sa.asMonths = Fr, sa.asQuarters = zr, sa.asYears = Hr, sa.valueOf = Tr, sa._bubble = Mr, sa.clone = Br, sa.get = Yr, sa.milliseconds = Vr, sa.seconds = Xr, sa.minutes = qr, sa.hours = Zr, sa.days = Gr, sa.weeks = $r, sa.months = Ur, sa.years = Kr, sa.humanize = la, sa.toISOString = oa, sa.toString = oa, sa.toJSON = oa, sa.locale = rl, sa.localeData = ol, sa.toIsoString = A("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", oa), sa.lang = al, H("X", 0, 0, "unix"), H("x", 0, 0, "valueOf"), It("x", Ot), It("X", Lt), zt("X", (function (t, e, i) {
                i._d = new Date(1e3 * parseFloat(t))
            })), zt("x", (function (t, e, i) {
                i._d = new Date(ut(t))
            })), n.version = "2.29.1", l(Zi), n.fn = or, n.min = $i, n.max = Qi, n.now = Ji, n.utc = p, n.unix = sr, n.months = gr, n.isDate = h, n.locale = fi, n.invalid = y, n.duration = Cn, n.isMoment = k, n.weekdays = vr, n.parseZone = cr, n.localeData = mi, n.isDuration = an, n.monthsShort = mr, n.weekdaysMin = br, n.defineLocale = pi, n.updateLocale = gi, n.locales = vi, n.weekdaysShort = yr, n.normalizeUnits = nt, n.relativeTimeRounding = ia, n.relativeTimeThreshold = na, n.calendarFormat = Hn, n.prototype = or, n.HTML5_FMT = {
                DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
                DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
                DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
                DATE: "YYYY-MM-DD",
                TIME: "HH:mm",
                TIME_SECONDS: "HH:mm:ss",
                TIME_MS: "HH:mm:ss.SSS",
                WEEK: "GGGG-[W]WW",
                MONTH: "YYYY-MM"
            }, n
        }()
    }).call(this, i(86)(t))
}, function (t, e, i) {
    "use strict";
    "function" != typeof Object.assign && (Object.assign = function (t, ...e) {
        if (!t) throw TypeError("Cannot convert undefined or null to object");
        for (const i of e) i && Object.keys(i).forEach((e => t[e] = i[e]));
        return t
    })
}, function (module, exports, __webpack_require__) {
    var factory;
    window, factory = function () {
        return modules = [function (t) {
            t.exports = JSON.parse('{"BACKSPACE":8,"BACKSPACE_SAFARI":127,"DELETE":46,"DOWN":40,"END":35,"ENTER":13,"ESCAPE":27,"HOME":36,"INSERT":45,"LEFT":37,"PAGE_DOWN":34,"PAGE_UP":33,"RIGHT":39,"SPACE":32,"TAB":9,"UP":38,"X":88,"CONTROL":17,"KEY_229":229}')
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = void 0, i(10);
            var n = i(11),
                l = g(i(9)),
                r = g(i(6)),
                a = i(19),
                o = i(3),
                s = i(2),
                c = i(4),
                u = i(5),
                h = i(12),
                d = g(i(20)),
                f = g(i(21));

            function p(t) {
                return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                    return typeof t
                } : function (t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }

            function g(t) {
                return t && t.__esModule ? t : {
                    default: t
                }
            }
            var m = r.default.document,
                v = "_inputmask_opts";

            function y(t, e, i) {
                if (!(this instanceof y)) return new y(t, e, i);
                this.dependencyLib = l.default, this.el = void 0, this.events = {}, this.maskset = void 0, !0 !== i && ("[object Object]" === Object.prototype.toString.call(t) ? e = t : (e = e || {}, t && (e.alias = t)), this.opts = l.default.extend(!0, {}, this.defaults, e), this.noMasksCache = e && void 0 !== e.definitions, this.userOptions = e || {}, b(this.opts.alias, e, this.opts)), this.refreshValue = !1, this.undoValue = void 0, this.$el = void 0, this.skipKeyPressEvent = !1, this.skipInputEvent = !1, this.validationEvent = !1, this.ignorable = !1, this.maxLength, this.mouseEnter = !1, this.originalPlaceholder = void 0, this.isComposing = !1
            }

            function b(t, e, i) {
                var n = y.prototype.aliases[t];
                return n ? (n.alias && b(n.alias, void 0, i), l.default.extend(!0, i, n), l.default.extend(!0, i, e), !0) : (null === i.mask && (i.mask = t), !1)
            }
            y.prototype = {
                dataAttribute: "data-inputmask",
                defaults: f.default,
                definitions: d.default,
                aliases: {},
                masksCache: {},
                get isRTL() {
                    return this.opts.isRTL || this.opts.numericInput
                },
                mask: function (t) {
                    var e = this;
                    return "string" == typeof t && (t = m.getElementById(t) || m.querySelectorAll(t)), (t = t.nodeName ? [t] : t).forEach((function (t, i) {
                        var o = l.default.extend(!0, {}, e.opts);
                        if (function (t, e, i, n) {
                                function a(e, l) {
                                    var a = "" === n ? e : n + "-" + e;
                                    null !== (l = void 0 !== l ? l : t.getAttribute(a)) && ("string" == typeof l && (0 === e.indexOf("on") ? l = r.default[l] : "false" === l ? l = !1 : "true" === l && (l = !0)), i[e] = l)
                                }
                                if (!0 === e.importDataAttributes) {
                                    var o, s, c, u, h = t.getAttribute(n);
                                    if (h && "" !== h && (h = h.replace(/'/g, '"'), s = JSON.parse("{" + h + "}")), s)
                                        for (u in c = void 0, s)
                                            if ("alias" === u.toLowerCase()) {
                                                c = s[u];
                                                break
                                            } for (o in a("alias", c), i.alias && b(i.alias, i, e), e) {
                                        if (s)
                                            for (u in c = void 0, s)
                                                if (u.toLowerCase() === o.toLowerCase()) {
                                                    c = s[u];
                                                    break
                                                } a(o, c)
                                    }
                                }
                                return l.default.extend(!0, e, i), "rtl" !== t.dir && !e.rightAlign || (t.style.textAlign = "right"), "rtl" !== t.dir && !e.numericInput || (t.dir = "ltr", t.removeAttribute("dir"), e.isRTL = !0), Object.keys(i).length
                            }(t, o, l.default.extend(!0, {}, e.userOptions), e.dataAttribute)) {
                            var s = (0, a.generateMaskSet)(o, e.noMasksCache);
                            void 0 !== s && (void 0 !== t.inputmask && (t.inputmask.opts.autoUnmask = !0, t.inputmask.remove()), t.inputmask = new y(void 0, void 0, !0), t.inputmask.opts = o, t.inputmask.noMasksCache = e.noMasksCache, t.inputmask.userOptions = l.default.extend(!0, {}, e.userOptions), t.inputmask.el = t, t.inputmask.$el = (0, l.default)(t), t.inputmask.maskset = s, l.default.data(t, v, e.userOptions), n.mask.call(t.inputmask))
                        }
                    })), t && t[0] && t[0].inputmask || this
                },
                option: function (t, e) {
                    return "string" == typeof t ? this.opts[t] : "object" === p(t) ? (l.default.extend(this.userOptions, t), this.el && !0 !== e && this.mask(this.el), this) : void 0
                },
                unmaskedvalue: function (t) {
                    if (this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), void 0 === this.el || void 0 !== t) {
                        var e = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, t, this.opts) || t).split("");
                        u.checkVal.call(this, void 0, !1, !1, e), "function" == typeof this.opts.onBeforeWrite && this.opts.onBeforeWrite.call(this, void 0, s.getBuffer.call(this), 0, this.opts)
                    }
                    return u.unmaskedvalue.call(this, this.el)
                },
                remove: function () {
                    if (this.el) {
                        l.default.data(this.el, v, null);
                        var t = this.opts.autoUnmask ? (0, u.unmaskedvalue)(this.el) : this._valueGet(this.opts.autoUnmask);
                        t !== s.getBufferTemplate.call(this).join("") ? this._valueSet(t, this.opts.autoUnmask) : this._valueSet(""), h.EventRuler.off(this.el), Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(this.el), "value") && this.__valueGet && Object.defineProperty(this.el, "value", {
                            get: this.__valueGet,
                            set: this.__valueSet,
                            configurable: !0
                        }) : m.__lookupGetter__ && this.el.__lookupGetter__("value") && this.__valueGet && (this.el.__defineGetter__("value", this.__valueGet), this.el.__defineSetter__("value", this.__valueSet)), this.el.inputmask = void 0
                    }
                    return this.el
                },
                getemptymask: function () {
                    return this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), s.getBufferTemplate.call(this).join("")
                },
                hasMaskedValue: function () {
                    return !this.opts.autoUnmask
                },
                isComplete: function () {
                    return this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), c.isComplete.call(this, s.getBuffer.call(this))
                },
                getmetadata: function () {
                    if (this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), Array.isArray(this.maskset.metadata)) {
                        var t = o.getMaskTemplate.call(this, !0, 0, !1).join("");
                        return this.maskset.metadata.forEach((function (e) {
                            return e.mask !== t || (t = e, !1)
                        })), t
                    }
                    return this.maskset.metadata
                },
                isValid: function (t) {
                    if (this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), t) {
                        var e = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, t, this.opts) || t).split("");
                        u.checkVal.call(this, void 0, !0, !1, e)
                    } else t = this.isRTL ? s.getBuffer.call(this).slice().reverse().join("") : s.getBuffer.call(this).join("");
                    for (var i = s.getBuffer.call(this), n = s.determineLastRequiredPosition.call(this), l = i.length - 1; n < l && !s.isMask.call(this, l); l--);
                    return i.splice(n, l + 1 - n), c.isComplete.call(this, i) && t === (this.isRTL ? s.getBuffer.call(this).slice().reverse().join("") : s.getBuffer.call(this).join(""))
                },
                format: function (t, e) {
                    this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache);
                    var i = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, t, this.opts) || t).split("");
                    u.checkVal.call(this, void 0, !0, !1, i);
                    var n = this.isRTL ? s.getBuffer.call(this).slice().reverse().join("") : s.getBuffer.call(this).join("");
                    return e ? {
                        value: n,
                        metadata: this.getmetadata()
                    } : n
                },
                setValue: function (t) {
                    this.el && (0, l.default)(this.el).trigger("setvalue", [t])
                },
                analyseMask: a.analyseMask
            }, y.extendDefaults = function (t) {
                l.default.extend(!0, y.prototype.defaults, t)
            }, y.extendDefinitions = function (t) {
                l.default.extend(!0, y.prototype.definitions, t)
            }, y.extendAliases = function (t) {
                l.default.extend(!0, y.prototype.aliases, t)
            }, y.format = function (t, e, i) {
                return y(e).format(t, i)
            }, y.unmask = function (t, e) {
                return y(e).unmaskedvalue(t)
            }, y.isValid = function (t, e) {
                return y(e).isValid(t)
            }, y.remove = function (t) {
                "string" == typeof t && (t = m.getElementById(t) || m.querySelectorAll(t)), (t = t.nodeName ? [t] : t).forEach((function (t) {
                    t.inputmask && t.inputmask.remove()
                }))
            }, y.setValue = function (t, e) {
                "string" == typeof t && (t = m.getElementById(t) || m.querySelectorAll(t)), (t = t.nodeName ? [t] : t).forEach((function (t) {
                    t.inputmask ? t.inputmask.setValue(e) : (0, l.default)(t).trigger("setvalue", [e])
                }))
            }, y.dependencyLib = l.default, r.default.Inputmask = y;
            var x = y;
            e.default = x
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.caret = function (t, e, i, n, l) {
                var r, a = this.opts;
                if (void 0 === e) return "selectionStart" in t && "selectionEnd" in t ? (e = t.selectionStart, i = t.selectionEnd) : window.getSelection ? (r = window.getSelection().getRangeAt(0)).commonAncestorContainer.parentNode !== t && r.commonAncestorContainer !== t || (e = r.startOffset, i = r.endOffset) : document.selection && document.selection.createRange && (r = document.selection.createRange(), e = 0 - r.duplicate().moveStart("character", -t.inputmask._valueGet().length), i = e + r.text.length), {
                    begin: n ? e : c.call(this, e),
                    end: n ? i : c.call(this, i)
                };
                if (Array.isArray(e) && (i = this.isRTL ? e[0] : e[1], e = this.isRTL ? e[1] : e[0]), void 0 !== e.begin && (i = this.isRTL ? e.begin : e.end, e = this.isRTL ? e.end : e.begin), "number" == typeof e) {
                    e = n ? e : c.call(this, e), i = "number" == typeof (i = n ? i : c.call(this, i)) ? i : e;
                    var o = parseInt(((t.ownerDocument.defaultView || window).getComputedStyle ? (t.ownerDocument.defaultView || window).getComputedStyle(t, null) : t.currentStyle).fontSize) * i;
                    if (t.scrollLeft = o > t.scrollWidth ? o : 0, t.inputmask.caretPos = {
                            begin: e,
                            end: i
                        }, a.insertModeVisual && !1 === a.insertMode && e === i && (l || i++), t === (t.inputmask.shadowRoot || document).activeElement)
                        if ("setSelectionRange" in t) t.setSelectionRange(e, i);
                        else if (window.getSelection) {
                        if (r = document.createRange(), void 0 === t.firstChild || null === t.firstChild) {
                            var s = document.createTextNode("");
                            t.appendChild(s)
                        }
                        r.setStart(t.firstChild, e < t.inputmask._valueGet().length ? e : t.inputmask._valueGet().length), r.setEnd(t.firstChild, i < t.inputmask._valueGet().length ? i : t.inputmask._valueGet().length), r.collapse(!0);
                        var u = window.getSelection();
                        u.removeAllRanges(), u.addRange(r)
                    } else t.createTextRange && ((r = t.createTextRange()).collapse(!0), r.moveEnd("character", i), r.moveStart("character", e), r.select())
                }
            }, e.determineLastRequiredPosition = function (t) {
                var e, i, r = this.maskset,
                    o = this.dependencyLib,
                    s = n.getMaskTemplate.call(this, !0, a.call(this), !0, !0),
                    c = s.length,
                    u = a.call(this),
                    h = {},
                    d = r.validPositions[u],
                    f = void 0 !== d ? d.locator.slice() : void 0;
                for (e = u + 1; e < s.length; e++) i = n.getTestTemplate.call(this, e, f, e - 1), f = i.locator.slice(), h[e] = o.extend(!0, {}, i);
                var p = d && void 0 !== d.alternation ? d.locator[d.alternation] : void 0;
                for (e = c - 1; u < e && ((i = h[e]).match.optionality || i.match.optionalQuantifier && i.match.newBlockMarker || p && (p !== h[e].locator[d.alternation] && 1 != i.match.static || !0 === i.match.static && i.locator[d.alternation] && l.checkAlternationMatch.call(this, i.locator[d.alternation].toString().split(","), p.toString().split(",")) && "" !== n.getTests.call(this, e)[0].def)) && s[e] === n.getPlaceholder.call(this, e, i.match); e--) c--;
                return t ? {
                    l: c,
                    def: h[c] ? h[c].match : void 0
                } : c
            }, e.determineNewCaretPosition = function (t, e) {
                var i = this,
                    l = this.maskset,
                    c = this.opts;
                if (e && (i.isRTL ? t.end = t.begin : t.begin = t.end), t.begin === t.end) {
                    switch (c.positionCaretOnClick) {
                        case "none":
                            break;
                        case "select":
                            t = {
                                begin: 0,
                                end: r.call(i).length
                            };
                            break;
                        case "ignore":
                            t.end = t.begin = s.call(i, a.call(i));
                            break;
                        case "radixFocus":
                            if (function (t) {
                                    if ("" !== c.radixPoint && 0 !== c.digits) {
                                        var e = l.validPositions;
                                        if (void 0 === e[t] || e[t].input === n.getPlaceholder.call(i, t)) {
                                            if (t < s.call(i, -1)) return !0;
                                            var a = r.call(i).indexOf(c.radixPoint);
                                            if (-1 !== a) {
                                                for (var o in e)
                                                    if (e[o] && a < o && e[o].input !== n.getPlaceholder.call(i, o)) return !1;
                                                return !0
                                            }
                                        }
                                    }
                                    return !1
                                }(t.begin)) {
                                var u = r.call(i).join("").indexOf(c.radixPoint);
                                t.end = t.begin = c.numericInput ? s.call(i, u) : u;
                                break
                            }
                            default:
                                var h = t.begin,
                                    d = a.call(i, h, !0),
                                    f = s.call(i, -1 !== d || o.call(i, 0) ? d : -1);
                                if (h <= f) t.end = t.begin = o.call(i, h, !1, !0) ? h : s.call(i, h);
                                else {
                                    var p = l.validPositions[d],
                                        g = n.getTestTemplate.call(i, f, p ? p.match.locator : void 0, p),
                                        m = n.getPlaceholder.call(i, f, g.match);
                                    if ("" !== m && r.call(i)[f] !== m && !0 !== g.match.optionalQuantifier && !0 !== g.match.newBlockMarker || !o.call(i, f, c.keepStatic, !0) && g.match.def === m) {
                                        var v = s.call(i, f);
                                        (v <= h || h === f) && (f = v)
                                    }
                                    t.end = t.begin = f
                                }
                    }
                    return t
                }
            }, e.getBuffer = r, e.getBufferTemplate = function () {
                var t = this.maskset;
                return void 0 === t._buffer && (t._buffer = n.getMaskTemplate.call(this, !1, 1), void 0 === t.buffer && (t.buffer = t._buffer.slice())), t._buffer
            }, e.getLastValidPosition = a, e.isMask = o, e.resetMaskSet = function (t) {
                var e = this.maskset;
                e.buffer = void 0, !0 !== t && (e.validPositions = {}, e.p = 0)
            }, e.seekNext = s, e.seekPrevious = function (t, e) {
                var i = t - 1;
                if (t <= 0) return 0;
                for (; 0 < i && (!0 === e && (!0 !== n.getTest.call(this, i).match.newBlockMarker || !o.call(this, i, void 0, !0)) || !0 !== e && !o.call(this, i, void 0, !0));) i--;
                return i
            }, e.translatePosition = c;
            var n = i(3),
                l = i(4);

            function r(t) {
                var e = this.maskset;
                return void 0 !== e.buffer && !0 !== t || (e.buffer = n.getMaskTemplate.call(this, !0, a.call(this), !0), void 0 === e._buffer && (e._buffer = e.buffer.slice())), e.buffer
            }

            function a(t, e, i) {
                var n = this.maskset,
                    l = -1,
                    r = -1,
                    a = i || n.validPositions;
                for (var o in void 0 === t && (t = -1), a) {
                    var s = parseInt(o);
                    a[s] && (e || !0 !== a[s].generatedInput) && (s <= t && (l = s), t <= s && (r = s))
                }
                return -1 === l || l == t ? r : -1 == r || t - l < r - t ? l : r
            }

            function o(t, e, i) {
                var l = this.maskset,
                    r = n.getTestTemplate.call(this, t).match;
                if ("" === r.def && (r = n.getTest.call(this, t).match), !0 !== r.static) return r.fn;
                if (!0 === i && void 0 !== l.validPositions[t] && !0 !== l.validPositions[t].generatedInput) return !0;
                if (!0 !== e && -1 < t) {
                    if (i) {
                        var a = n.getTests.call(this, t);
                        return a.length > 1 + ("" === a[a.length - 1].match.def ? 1 : 0)
                    }
                    var o = n.determineTestTemplate.call(this, t, n.getTests.call(this, t)),
                        s = n.getPlaceholder.call(this, t, o.match);
                    return o.match.def !== s
                }
                return !1
            }

            function s(t, e, i) {
                void 0 === i && (i = !0);
                for (var l = t + 1;
                    "" !== n.getTest.call(this, l).match.def && (!0 === e && (!0 !== n.getTest.call(this, l).match.newBlockMarker || !o.call(this, l, void 0, !0)) || !0 !== e && !o.call(this, l, void 0, i));) l++;
                return l
            }

            function c(t) {
                var e = this.opts,
                    i = this.el;
                return !this.isRTL || "number" != typeof t || e.greedy && "" === e.placeholder || !i || (t = this._valueGet().length - t), t
            }
            i(11)
        }, function (t, e, i) {
            "use strict";

            function n(t, e) {
                var i = (null != t.alternation ? t.mloc[l(t)] : t.locator).join("");
                if ("" !== i)
                    for (; i.length < e;) i += "0";
                return i
            }

            function l(t) {
                var e = t.locator[t.alternation];
                return "string" == typeof e && 0 < e.length && (e = e.split(",")[0]), void 0 !== e ? e.toString() : ""
            }

            function r(t, e, i) {
                var n = this.opts,
                    l = this.maskset;
                if (void 0 !== (e = e || s.call(this, t).match).placeholder || !0 === i) return "function" == typeof e.placeholder ? e.placeholder(n) : e.placeholder;
                if (!0 !== e.static) return n.placeholder.charAt(t % n.placeholder.length);
                if (-1 < t && void 0 === l.validPositions[t]) {
                    var r, a = c.call(this, t),
                        o = [];
                    if (a.length > 1 + ("" === a[a.length - 1].match.def ? 1 : 0))
                        for (var u = 0; u < a.length; u++)
                            if ("" !== a[u].match.def && !0 !== a[u].match.optionality && !0 !== a[u].match.optionalQuantifier && (!0 === a[u].match.static || void 0 === r || !1 !== a[u].match.fn.test(r.match.def, l, t, !0, n)) && (o.push(a[u]), !0 === a[u].match.static && (r = a[u]), 1 < o.length && /[0-9a-bA-Z]/.test(o[0].match.def))) return n.placeholder.charAt(t % n.placeholder.length)
                }
                return e.def
            }

            function a(t, e, i) {
                return this.maskset.validPositions[t] || o.call(this, t, c.call(this, t, e ? e.slice() : e, i))
            }

            function o(t, e) {
                var i = this.opts;
                t = 0 < t ? t - 1 : 0;
                for (var l, r, a, o = n(s.call(this, t)), c = 0; c < e.length; c++) {
                    var u = e[c];
                    l = n(u, o.length);
                    var h = Math.abs(l - o);
                    (void 0 === r || "" !== l && h < r || a && !i.greedy && a.match.optionality && "master" === a.match.newBlockMarker && (!u.match.optionality || !u.match.newBlockMarker) || a && a.match.optionalQuantifier && !u.match.optionalQuantifier) && (r = h, a = u)
                }
                return a
            }

            function s(t, e) {
                var i = this.maskset;
                return i.validPositions[t] ? i.validPositions[t] : (e || c.call(this, t))[0]
            }

            function c(t, e, i) {
                var n, l = this,
                    r = this.dependencyLib,
                    a = this.maskset,
                    s = this.opts,
                    c = this.el,
                    u = a.maskToken,
                    h = e ? i : 0,
                    d = e ? e.slice() : [0],
                    f = [],
                    p = !1,
                    g = e ? e.join("") : "";

                function m(e, i, l, r) {
                    function o(l, r, u) {
                        function d(t, e) {
                            var i = 0 === e.matches.indexOf(t);
                            return i || e.matches.every((function (n, l) {
                                return !0 === n.isQuantifier ? i = d(t, e.matches[l - 1]) : Object.prototype.hasOwnProperty.call(n, "matches") && (i = d(t, n)), !i
                            })), i
                        }

                        function v(t, e, i) {
                            var n, l;
                            if ((a.tests[t] || a.validPositions[t]) && (a.tests[t] || [a.validPositions[t]]).every((function (t, r) {
                                    if (t.mloc[e]) return n = t, !1;
                                    var a = void 0 !== i ? i : t.alternation,
                                        o = void 0 !== t.locator[a] ? t.locator[a].toString().indexOf(e) : -1;
                                    return (void 0 === l || o < l) && -1 !== o && (n = t, l = o), !0
                                })), n) {
                                var r = n.locator[n.alternation];
                                return (n.mloc[e] || n.mloc[r] || n.locator).slice((void 0 !== i ? i : n.alternation) + 1)
                            }
                            return void 0 !== i ? v(t, e) : void 0
                        }

                        function y(t, e) {
                            function i(t) {
                                for (var e, i = [], n = -1, l = 0, r = t.length; l < r; l++)
                                    if ("-" === t.charAt(l))
                                        for (e = t.charCodeAt(l + 1); ++n < e;) i.push(String.fromCharCode(n));
                                    else n = t.charCodeAt(l), i.push(t.charAt(l));
                                return i.join("")
                            }
                            return t.match.def === e.match.nativeDef || !(!(s.regex || t.match.fn instanceof RegExp && e.match.fn instanceof RegExp) || !0 === t.match.static || !0 === e.match.static) && -1 !== i(e.match.fn.toString().replace(/[[\]/]/g, "")).indexOf(i(t.match.fn.toString().replace(/[[\]/]/g, "")))
                        }

                        function b(t, e) {
                            var i = t.alternation,
                                n = void 0 === e || i === e.alternation && -1 === t.locator[i].toString().indexOf(e.locator[i]);
                            if (!n && i > e.alternation)
                                for (var l = e.alternation; l < i; l++)
                                    if (t.locator[l] !== e.locator[l]) {
                                        i = l, n = !0;
                                        break
                                    } if (n) {
                                t.mloc = t.mloc || {};
                                var r = t.locator[i];
                                if (void 0 !== r) {
                                    if ("string" == typeof r && (r = r.split(",")[0]), void 0 === t.mloc[r] && (t.mloc[r] = t.locator.slice()), void 0 !== e) {
                                        for (var a in e.mloc) "string" == typeof a && (a = a.split(",")[0]), void 0 === t.mloc[a] && (t.mloc[a] = e.mloc[a]);
                                        t.locator[i] = Object.keys(t.mloc).join(",")
                                    }
                                    return !0
                                }
                                t.alternation = void 0
                            }
                            return !1
                        }

                        function x(t, e) {
                            if (t.locator.length !== e.locator.length) return !1;
                            for (var i = t.alternation + 1; i < t.locator.length; i++)
                                if (t.locator[i] !== e.locator[i]) return !1;
                            return !0
                        }
                        if (h > t + s._maxTestPos) throw "Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. " + a.mask;
                        if (h === t && void 0 === l.matches) return f.push({
                            match: l,
                            locator: r.reverse(),
                            cd: g,
                            mloc: {}
                        }), !0;
                        if (void 0 !== l.matches) {
                            if (l.isGroup && u !== l) {
                                if (l = o(e.matches[e.matches.indexOf(l) + 1], r, u)) return !0
                            } else if (l.isOptional) {
                                var w = l,
                                    _ = f.length;
                                if (l = m(l, i, r, u)) {
                                    if (f.forEach((function (t, e) {
                                            _ <= e && (t.match.optionality = !0)
                                        })), n = f[f.length - 1].match, void 0 !== u || !d(n, w)) return !0;
                                    p = !0, h = t
                                }
                            } else if (l.isAlternator) {
                                var k, S = l,
                                    A = [],
                                    M = f.slice(),
                                    C = r.length,
                                    E = 0 < i.length ? i.shift() : -1;
                                if (-1 === E || "string" == typeof E) {
                                    var O, T = h,
                                        P = i.slice(),
                                        L = [];
                                    if ("string" == typeof E) L = E.split(",");
                                    else
                                        for (O = 0; O < S.matches.length; O++) L.push(O.toString());
                                    if (void 0 !== a.excludes[t]) {
                                        for (var D = L.slice(), I = 0, j = a.excludes[t].length; I < j; I++) {
                                            var N = a.excludes[t][I].toString().split(":");
                                            r.length == N[1] && L.splice(L.indexOf(N[0]), 1)
                                        }
                                        0 === L.length && (delete a.excludes[t], L = D)
                                    }(!0 === s.keepStatic || isFinite(parseInt(s.keepStatic)) && T >= s.keepStatic) && (L = L.slice(0, 1));
                                    for (var R = !1, F = 0; F < L.length; F++) {
                                        O = parseInt(L[F]), f = [], i = "string" == typeof E && v(h, O, C) || P.slice(), S.matches[O] && o(S.matches[O], [O].concat(r), u) ? l = !0 : 0 === F && (R = !0), k = f.slice(), h = T, f = [];
                                        for (var z = 0; z < k.length; z++) {
                                            var H = k[z],
                                                B = !1;
                                            H.match.jit = H.match.jit || R, H.alternation = H.alternation || C, b(H);
                                            for (var Y = 0; Y < A.length; Y++) {
                                                var W = A[Y];
                                                if ("string" != typeof E || void 0 !== H.alternation && L.includes(H.locator[H.alternation].toString())) {
                                                    if (H.match.nativeDef === W.match.nativeDef) {
                                                        B = !0, b(W, H);
                                                        break
                                                    }
                                                    if (y(H, W)) {
                                                        b(H, W) && (B = !0, A.splice(A.indexOf(W), 0, H));
                                                        break
                                                    }
                                                    if (y(W, H)) {
                                                        b(W, H);
                                                        break
                                                    }
                                                    if (G = W, !0 === (Z = H).match.static && !0 !== G.match.static && G.match.fn.test(Z.match.def, a, t, !1, s, !1)) {
                                                        x(H, W) || void 0 !== c.inputmask.userOptions.keepStatic ? b(H, W) && (B = !0, A.splice(A.indexOf(W), 0, H)) : s.keepStatic = !0;
                                                        break
                                                    }
                                                }
                                            }
                                            B || A.push(H)
                                        }
                                    }
                                    f = M.concat(A), h = t, p = 0 < f.length, l = 0 < A.length, i = P.slice()
                                } else l = o(S.matches[E] || e.matches[E], [E].concat(r), u);
                                if (l) return !0
                            } else if (l.isQuantifier && u !== e.matches[e.matches.indexOf(l) - 1])
                                for (var V = l, X = 0 < i.length ? i.shift() : 0; X < (isNaN(V.quantifier.max) ? X + 1 : V.quantifier.max) && h <= t; X++) {
                                    var q = e.matches[e.matches.indexOf(V) - 1];
                                    if (l = o(q, [X].concat(r), q)) {
                                        if ((n = f[f.length - 1].match).optionalQuantifier = X >= V.quantifier.min, n.jit = (X || 1) * q.matches.indexOf(n) >= V.quantifier.jit, n.optionalQuantifier && d(n, q)) {
                                            p = !0, h = t;
                                            break
                                        }
                                        return n.jit && (a.jitOffset[t] = q.matches.length - q.matches.indexOf(n)), !0
                                    }
                                } else if (l = m(l, i, r, u)) return !0
                        } else h++;
                        var Z, G
                    }
                    for (var u = 0 < i.length ? i.shift() : 0; u < e.matches.length; u++)
                        if (!0 !== e.matches[u].isQuantifier) {
                            var d = o(e.matches[u], [u].concat(l), r);
                            if (d && h === t) return d;
                            if (t < h) break
                        }
                }
                if (-1 < t && (void 0 === l.maxLength || t < l.maxLength)) {
                    if (void 0 === e) {
                        for (var v, y = t - 1; void 0 === (v = a.validPositions[y] || a.tests[y]) && -1 < y;) y--;
                        void 0 !== v && -1 < y && (d = function (t, e) {
                            var i, n = [];
                            return Array.isArray(e) || (e = [e]), 0 < e.length && (void 0 === e[0].alternation || !0 === s.keepStatic ? 0 === (n = o.call(l, t, e.slice()).locator.slice()).length && (n = e[0].locator.slice()) : e.forEach((function (t) {
                                "" !== t.def && (0 === n.length ? (i = t.alternation, n = t.locator.slice()) : t.locator[i] && -1 === n[i].toString().indexOf(t.locator[i]) && (n[i] += "," + t.locator[i]))
                            }))), n
                        }(y, v), g = d.join(""), h = y)
                    }
                    if (a.tests[t] && a.tests[t][0].cd === g) return a.tests[t];
                    for (var b = d.shift(); b < u.length && !(m(u[b], d, [b]) && h === t || t < h); b++);
                }
                return 0 !== f.length && !p || f.push({
                    match: {
                        fn: null,
                        static: !0,
                        optionality: !1,
                        casing: null,
                        def: "",
                        placeholder: ""
                    },
                    locator: [],
                    mloc: {},
                    cd: g
                }), void 0 !== e && a.tests[t] ? r.extend(!0, [], f) : (a.tests[t] = r.extend(!0, [], f), a.tests[t])
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.determineTestTemplate = o, e.getDecisionTaker = l, e.getMaskTemplate = function (t, e, i, n, l) {
                var s = this.opts,
                    u = this.maskset,
                    h = s.greedy;
                l && (s.greedy = !1), e = e || 0;
                var d, f, p, g, m = [],
                    v = 0;
                do {
                    if (!0 === t && u.validPositions[v]) f = (p = l && !0 === u.validPositions[v].match.optionality && void 0 === u.validPositions[v + 1] && (!0 === u.validPositions[v].generatedInput || u.validPositions[v].input == s.skipOptionalPartCharacter && 0 < v) ? o.call(this, v, c.call(this, v, d, v - 1)) : u.validPositions[v]).match, d = p.locator.slice(), m.push(!0 === i ? p.input : !1 === i ? f.nativeDef : r.call(this, v, f));
                    else {
                        f = (p = a.call(this, v, d, v - 1)).match, d = p.locator.slice();
                        var y = !0 !== n && (!1 !== s.jitMasking ? s.jitMasking : f.jit);
                        (g = g && f.static && f.def !== s.groupSeparator && null === f.fn || u.validPositions[v - 1] && f.static && f.def !== s.groupSeparator && null === f.fn) || !1 === y || void 0 === y || "number" == typeof y && isFinite(y) && v < y ? m.push(!1 === i ? f.nativeDef : r.call(this, v, f)) : g = !1
                    }
                    v++
                } while ((void 0 === this.maxLength || v < this.maxLength) && (!0 !== f.static || "" !== f.def) || v < e);
                return "" === m[m.length - 1] && m.pop(), !1 === i && void 0 !== u.maskLength || (u.maskLength = v - 1), s.greedy = h, m
            }, e.getPlaceholder = r, e.getTest = s, e.getTests = c, e.getTestTemplate = a
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.alternate = s, e.checkAlternationMatch = function (t, e, i) {
                for (var n, l = this.opts.greedy ? e : e.slice(0, 1), r = !1, a = void 0 !== i ? i.split(",") : [], o = 0; o < a.length; o++) - 1 !== (n = t.indexOf(a[o])) && t.splice(n, 1);
                for (var s = 0; s < t.length; s++)
                    if (l.includes(t[s])) {
                        r = !0;
                        break
                    } return r
            }, e.isComplete = u, e.isValid = h, e.refreshFromBuffer = f, e.revalidateMask = g, e.handleRemove = function (t, e, i, n, o) {
                var c = this.maskset,
                    u = this.opts;
                if ((u.numericInput || this.isRTL) && (e === r.default.BACKSPACE ? e = r.default.DELETE : e === r.default.DELETE && (e = r.default.BACKSPACE), this.isRTL)) {
                    var h = i.end;
                    i.end = i.begin, i.begin = h
                }
                var d, f = a.getLastValidPosition.call(this, void 0, !0);
                if (i.end >= a.getBuffer.call(this).length && f >= i.end && (i.end = f + 1), e === r.default.BACKSPACE ? i.end - i.begin < 1 && (i.begin = a.seekPrevious.call(this, i.begin)) : e === r.default.DELETE && i.begin === i.end && (i.end = a.isMask.call(this, i.end, !0, !0) ? i.end + 1 : a.seekNext.call(this, i.end) + 1), !1 !== (d = g.call(this, i))) {
                    if (!0 !== n && !1 !== u.keepStatic || null !== u.regex && -1 !== l.getTest.call(this, i.begin).match.def.indexOf("|")) {
                        var p = s.call(this, !0);
                        if (p) {
                            var m = void 0 !== p.caret ? p.caret : p.pos ? a.seekNext.call(this, p.pos.begin ? p.pos.begin : p.pos) : a.getLastValidPosition.call(this, -1, !0);
                            (e !== r.default.DELETE || i.begin > m) && i.begin
                        }
                    }!0 !== n && (c.p = e === r.default.DELETE ? i.begin + d : i.begin)
                }
            };
            var n, l = i(3),
                r = (n = i(0)) && n.__esModule ? n : {
                    default: n
                },
                a = i(2),
                o = i(7);

            function s(t, e, i, n, r, o) {
                var c, u, d, f, p, g, m, v, y, b, x, w = this.dependencyLib,
                    _ = this.opts,
                    k = this.maskset,
                    S = w.extend(!0, {}, k.validPositions),
                    A = w.extend(!0, {}, k.tests),
                    M = !1,
                    C = !1,
                    E = void 0 !== r ? r : a.getLastValidPosition.call(this);
                if (o && (b = o.begin, x = o.end, o.begin > o.end && (b = o.end, x = o.begin)), -1 === E && void 0 === r) c = 0, u = (f = l.getTest.call(this, c)).alternation;
                else
                    for (; 0 <= E; E--)
                        if ((d = k.validPositions[E]) && void 0 !== d.alternation) {
                            if (f && f.locator[d.alternation] !== d.locator[d.alternation]) break;
                            c = E, u = k.validPositions[c].alternation, f = d
                        } if (void 0 !== u) {
                    m = parseInt(c), k.excludes[m] = k.excludes[m] || [], !0 !== t && k.excludes[m].push((0, l.getDecisionTaker)(f) + ":" + f.alternation);
                    var O = [],
                        T = -1;
                    for (p = m; p < a.getLastValidPosition.call(this, void 0, !0) + 1; p++) - 1 === T && t <= p && void 0 !== e && (O.push(e), T = O.length - 1), (g = k.validPositions[p]) && !0 !== g.generatedInput && (void 0 === o || p < b || x <= p) && O.push(g.input), delete k.validPositions[p];
                    for (-1 === T && void 0 !== e && (O.push(e), T = O.length - 1); void 0 !== k.excludes[m] && k.excludes[m].length < 10;) {
                        for (k.tests = {}, a.resetMaskSet.call(this, !0), M = !0, p = 0; p < O.length && (v = M.caret || a.getLastValidPosition.call(this, void 0, !0) + 1, y = O[p], M = h.call(this, v, y, !1, n, !0)); p++) p === T && (C = M), 1 == t && M && (C = {
                            caretPos: p
                        });
                        if (M) break;
                        if (a.resetMaskSet.call(this), f = l.getTest.call(this, m), k.validPositions = w.extend(!0, {}, S), k.tests = w.extend(!0, {}, A), !k.excludes[m]) {
                            C = s.call(this, t, e, i, n, m - 1, o);
                            break
                        }
                        var P = (0, l.getDecisionTaker)(f);
                        if (-1 !== k.excludes[m].indexOf(P + ":" + f.alternation)) {
                            C = s.call(this, t, e, i, n, m - 1, o);
                            break
                        }
                        for (k.excludes[m].push(P + ":" + f.alternation), p = m; p < a.getLastValidPosition.call(this, void 0, !0) + 1; p++) delete k.validPositions[p]
                    }
                }
                return C && !1 === _.keepStatic || delete k.excludes[m], C
            }

            function c(t, e, i) {
                var n = this.opts,
                    l = this.maskset;
                switch (n.casing || e.casing) {
                    case "upper":
                        t = t.toUpperCase();
                        break;
                    case "lower":
                        t = t.toLowerCase();
                        break;
                    case "title":
                        var a = l.validPositions[i - 1];
                        t = 0 === i || a && a.input === String.fromCharCode(r.default.SPACE) ? t.toUpperCase() : t.toLowerCase();
                        break;
                    default:
                        if ("function" == typeof n.casing) {
                            var o = Array.prototype.slice.call(arguments);
                            o.push(l.validPositions), t = n.casing.apply(this, o)
                        }
                }
                return t
            }

            function u(t) {
                var e = this.opts,
                    i = this.maskset;
                if ("function" == typeof e.isComplete) return e.isComplete(t, e);
                if ("*" !== e.repeat) {
                    var n = !1,
                        r = a.determineLastRequiredPosition.call(this, !0),
                        o = a.seekPrevious.call(this, r.l);
                    if (void 0 === r.def || r.def.newBlockMarker || r.def.optionality || r.def.optionalQuantifier) {
                        n = !0;
                        for (var s = 0; s <= o; s++) {
                            var c = l.getTestTemplate.call(this, s).match;
                            if (!0 !== c.static && void 0 === i.validPositions[s] && !0 !== c.optionality && !0 !== c.optionalQuantifier || !0 === c.static && t[s] !== l.getPlaceholder.call(this, s, c)) {
                                n = !1;
                                break
                            }
                        }
                    }
                    return n
                }
            }

            function h(t, e, i, n, r, o, d) {
                var m = this,
                    v = this.dependencyLib,
                    y = this.opts,
                    b = m.el,
                    x = m.maskset;

                function w(t) {
                    return m.isRTL ? 1 < t.begin - t.end || t.begin - t.end == 1 : 1 < t.end - t.begin || t.end - t.begin == 1
                }
                i = !0 === i;
                var _ = t;

                function k(t) {
                    if (void 0 !== t) {
                        if (void 0 !== t.remove && (Array.isArray(t.remove) || (t.remove = [t.remove]), t.remove.sort((function (t, e) {
                                return e.pos - t.pos
                            })).forEach((function (t) {
                                g.call(m, {
                                    begin: t,
                                    end: t + 1
                                })
                            })), t.remove = void 0), void 0 !== t.insert && (Array.isArray(t.insert) || (t.insert = [t.insert]), t.insert.sort((function (t, e) {
                                return t.pos - e.pos
                            })).forEach((function (t) {
                                "" !== t.c && h.call(m, t.pos, t.c, void 0 === t.strict || t.strict, void 0 !== t.fromIsValid ? t.fromIsValid : n)
                            })), t.insert = void 0), t.refreshFromBuffer && t.buffer) {
                            var e = t.refreshFromBuffer;
                            f.call(m, !0 === e ? e : e.start, e.end, t.buffer), t.refreshFromBuffer = void 0
                        }
                        void 0 !== t.rewritePosition && (_ = t.rewritePosition, t = !0)
                    }
                    return t
                }

                function S(e, i, r) {
                    var o = !1;
                    return l.getTests.call(m, e).every((function (s, u) {
                        var h = s.match;
                        if (a.getBuffer.call(m, !0), !1 === (o = null != h.fn ? h.fn.test(i, x, e, r, y, w(t)) : (i === h.def || i === y.skipOptionalPartCharacter) && "" !== h.def && {
                                c: l.getPlaceholder.call(m, e, h, !0) || h.def,
                                pos: e
                            })) return !0;
                        var d = void 0 !== o.c ? o.c : i,
                            f = e;
                        return d = d === y.skipOptionalPartCharacter && !0 === h.static ? l.getPlaceholder.call(m, e, h, !0) || h.def : d, !0 !== (o = k(o)) && void 0 !== o.pos && o.pos !== e && (f = o.pos), !0 !== o && void 0 === o.pos && void 0 === o.c || !1 === g.call(m, t, v.extend({}, s, {
                            input: c.call(m, d, h, f)
                        }), n, f) && (o = !1), !1
                    })), o
                }
                void 0 !== t.begin && (_ = m.isRTL ? t.end : t.begin);
                var A = !0,
                    M = v.extend(!0, {}, x.validPositions);
                if (!1 === y.keepStatic && void 0 !== x.excludes[_] && !0 !== r && !0 !== n)
                    for (var C = _; C < (m.isRTL ? t.begin : t.end); C++) void 0 !== x.excludes[C] && (x.excludes[C] = void 0, delete x.tests[C]);
                if ("function" == typeof y.preValidation && !0 !== n && !0 !== o && (A = k(A = y.preValidation.call(b, a.getBuffer.call(m), _, e, w(t), y, x, t, i || r))), !0 === A) {
                    if (void 0 === m.maxLength || _ < m.maxLength) {
                        if (A = S(_, e, i), (!i || !0 === n) && !1 === A && !0 !== o) {
                            var E = x.validPositions[_];
                            if (!E || !0 !== E.match.static || E.match.def !== e && e !== y.skipOptionalPartCharacter) {
                                if (y.insertMode || void 0 === x.validPositions[a.seekNext.call(m, _)] || t.end > _) {
                                    var O = !1;
                                    if (x.jitOffset[_] && void 0 === x.validPositions[a.seekNext.call(m, _)] && !1 !== (A = h.call(m, _ + x.jitOffset[_], e, !0)) && (!0 !== r && (A.caret = _), O = !0), t.end > _ && (x.validPositions[_] = void 0), !O && !a.isMask.call(m, _, y.keepStatic && 0 === _))
                                        for (var T = _ + 1, P = a.seekNext.call(m, _, !1, 0 !== _); T <= P; T++)
                                            if (!1 !== (A = S(T, e, i))) {
                                                A = p.call(m, _, void 0 !== A.pos ? A.pos : T) || A, _ = T;
                                                break
                                            }
                                }
                            } else A = {
                                caret: a.seekNext.call(m, _)
                            }
                        }
                    } else A = !1;
                    !1 !== A || !y.keepStatic || !u.call(m, a.getBuffer.call(m)) && 0 !== _ || i || !0 === r ? w(t) && x.tests[_] && 1 < x.tests[_].length && y.keepStatic && !i && !0 !== r && (A = s.call(m, !0)) : A = s.call(m, _, e, i, n, void 0, t), !0 === A && (A = {
                        pos: _
                    })
                }
                if ("function" == typeof y.postValidation && !0 !== n && !0 !== o) {
                    var L = y.postValidation.call(b, a.getBuffer.call(m, !0), void 0 !== t.begin ? m.isRTL ? t.end : t.begin : t, e, A, y, x, i, d);
                    void 0 !== L && (A = !0 === L ? A : L)
                }
                return A && void 0 === A.pos && (A.pos = _), !1 === A || !0 === o ? (a.resetMaskSet.call(m, !0), x.validPositions = v.extend(!0, {}, M)) : p.call(m, void 0, _, !0), k(A)
            }

            function d(t, e, i) {
                for (var n = this.maskset, r = !1, a = l.getTests.call(this, t), o = 0; o < a.length; o++) {
                    if (a[o].match && (!(a[o].match.nativeDef !== e.match[i.shiftPositions ? "def" : "nativeDef"] || i.shiftPositions && e.match.static) || a[o].match.nativeDef === e.match.nativeDef)) {
                        r = !0;
                        break
                    }
                    if (a[o].match && a[o].match.def === e.match.nativeDef) {
                        r = void 0;
                        break
                    }
                }
                return !1 === r && void 0 !== n.jitOffset[t] && (r = d.call(this, t + n.jitOffset[t], e, i)), r
            }

            function f(t, e, i) {
                var n, l, r = this.maskset,
                    s = this.opts,
                    c = this.dependencyLib,
                    u = this.el,
                    h = s.skipOptionalPartCharacter,
                    d = this.isRTL ? i.slice().reverse() : i;
                if (s.skipOptionalPartCharacter = "", !0 === t) a.resetMaskSet.call(this), r.tests = {}, t = 0, e = i.length, l = a.determineNewCaretPosition.call(this, {
                    begin: 0,
                    end: 0
                }, !1).begin;
                else {
                    for (n = t; n < e; n++) delete r.validPositions[n];
                    l = t
                }
                var f = new c.Event("keypress");
                for (n = t; n < e; n++) {
                    f.which = d[n].toString().charCodeAt(0), this.ignorable = !1;
                    var p = o.EventHandlers.keypressEvent.call(u, f, !0, !1, !1, l);
                    !1 !== p && (l = p.forwardPosition)
                }
                s.skipOptionalPartCharacter = h
            }

            function p(t, e, i) {
                var n = this.maskset,
                    r = this.dependencyLib;
                if (void 0 === t)
                    for (t = e - 1; 0 < t && !n.validPositions[t]; t--);
                for (var o = t; o < e; o++)
                    if (void 0 === n.validPositions[o] && !a.isMask.call(this, o, !0) && (0 == o ? l.getTest.call(this, o) : n.validPositions[o - 1])) {
                        var s = l.getTests.call(this, o).slice();
                        "" === s[s.length - 1].match.def && s.pop();
                        var c, u = l.determineTestTemplate.call(this, o, s);
                        if (u && (!0 !== u.match.jit || "master" === u.match.newBlockMarker && (c = n.validPositions[o + 1]) && !0 === c.match.optionalQuantifier) && ((u = r.extend({}, u, {
                                input: l.getPlaceholder.call(this, o, u.match, !0) || u.match.def
                            })).generatedInput = !0, g.call(this, o, u, !0), !0 !== i)) {
                            var d = n.validPositions[e].input;
                            return n.validPositions[e] = void 0, h.call(this, e, d, !0, !0)
                        }
                    }
            }

            function g(t, e, i, n) {
                var r = this.maskset,
                    o = this.opts,
                    s = this.dependencyLib;

                function c(t, e, i) {
                    var n = e[t];
                    if (void 0 === n || !0 !== n.match.static || !0 === n.match.optionality || void 0 !== e[0] && void 0 !== e[0].alternation) return !1;
                    var l = i.begin <= t - 1 ? e[t - 1] && !0 === e[t - 1].match.static && e[t - 1] : e[t - 1],
                        r = i.end > t + 1 ? e[t + 1] && !0 === e[t + 1].match.static && e[t + 1] : e[t + 1];
                    return l && r
                }
                var u = 0,
                    f = void 0 !== t.begin ? t.begin : t,
                    p = void 0 !== t.end ? t.end : t;
                if (t.begin > t.end && (f = t.end, p = t.begin), n = void 0 !== n ? n : f, f !== p || o.insertMode && void 0 !== r.validPositions[n] && void 0 === i || void 0 === e) {
                    var g, m = s.extend(!0, {}, r.validPositions),
                        v = a.getLastValidPosition.call(this, void 0, !0);
                    for (r.p = f, g = v; f <= g; g--) delete r.validPositions[g], void 0 === e && delete r.tests[g + 1];
                    var y, b, x = !0,
                        w = n,
                        _ = w;
                    for (e && (r.validPositions[n] = s.extend(!0, {}, e), _++, w++), g = e ? p : p - 1; g <= v; g++) {
                        if (void 0 !== (y = m[g]) && !0 !== y.generatedInput && (p <= g || f <= g && c(g, m, {
                                begin: f,
                                end: p
                            }))) {
                            for (;
                                "" !== l.getTest.call(this, _).match.def;) {
                                if (!1 !== (b = d.call(this, _, y, o)) || "+" === y.match.def) {
                                    "+" === y.match.def && a.getBuffer.call(this, !0);
                                    var k = h.call(this, _, y.input, "+" !== y.match.def, "+" !== y.match.def);
                                    if (x = !1 !== k, w = (k.pos || _) + 1, !x && b) break
                                } else x = !1;
                                if (x) {
                                    void 0 === e && y.match.static && g === t.begin && u++;
                                    break
                                }
                                if (!x && _ > r.maskLength) break;
                                _++
                            }
                            "" == l.getTest.call(this, _).match.def && (x = !1), _ = w
                        }
                        if (!x) break
                    }
                    if (!x) return r.validPositions = s.extend(!0, {}, m), a.resetMaskSet.call(this, !0), !1
                } else e && l.getTest.call(this, n).match.cd === e.match.cd && (r.validPositions[n] = s.extend(!0, {}, e));
                return a.resetMaskSet.call(this, !0), u
            }
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.applyInputValue = u, e.clearOptionalTail = h, e.checkVal = d, e.HandleNativePlaceholder = function (t, e) {
                var i = t ? t.inputmask : this;
                if (s.ie) {
                    if (t.inputmask._valueGet() !== e && (t.placeholder !== e || "" === t.placeholder)) {
                        var n = a.getBuffer.call(i).slice(),
                            l = t.inputmask._valueGet();
                        if (l !== e) {
                            var r = a.getLastValidPosition.call(i); - 1 === r && l === a.getBufferTemplate.call(i).join("") ? n = [] : -1 !== r && h.call(i, n), f(t, n)
                        }
                    }
                } else t.placeholder !== e && (t.placeholder = e, "" === t.placeholder && t.removeAttribute("placeholder"))
            }, e.unmaskedvalue = function (t) {
                var e = t ? t.inputmask : this,
                    i = e.opts,
                    n = e.maskset;
                if (t) {
                    if (void 0 === t.inputmask) return t.value;
                    t.inputmask && t.inputmask.refreshValue && u(t, t.inputmask._valueGet(!0))
                }
                var l = [],
                    r = n.validPositions;
                for (var o in r) r[o] && r[o].match && (1 != r[o].match.static || Array.isArray(n.metadata) && !0 !== r[o].generatedInput) && l.push(r[o].input);
                var s = 0 === l.length ? "" : (e.isRTL ? l.reverse() : l).join("");
                if ("function" == typeof i.onUnMask) {
                    var c = (e.isRTL ? a.getBuffer.call(e).slice().reverse() : a.getBuffer.call(e)).join("");
                    s = i.onUnMask.call(e, c, s, i)
                }
                return s
            }, e.writeBuffer = f;
            var n, l = (n = i(0)) && n.__esModule ? n : {
                    default: n
                },
                r = i(3),
                a = i(2),
                o = i(4),
                s = i(8),
                c = i(7);

            function u(t, e) {
                var i = t ? t.inputmask : this,
                    n = i.opts;
                t.inputmask.refreshValue = !1, "function" == typeof n.onBeforeMask && (e = n.onBeforeMask.call(i, e, n) || e), d(t, !0, !1, e = e.toString().split("")), i.undoValue = a.getBuffer.call(i).join(""), (n.clearMaskOnLostFocus || n.clearIncomplete) && t.inputmask._valueGet() === a.getBufferTemplate.call(i).join("") && -1 === a.getLastValidPosition.call(i) && t.inputmask._valueSet("")
            }

            function h(t) {
                t.length = 0;
                for (var e, i = r.getMaskTemplate.call(this, !0, 0, !0, void 0, !0); void 0 !== (e = i.shift());) t.push(e);
                return t
            }

            function d(t, e, i, n, l) {
                var s = t ? t.inputmask : this,
                    u = s.maskset,
                    h = s.opts,
                    d = s.dependencyLib,
                    p = n.slice(),
                    g = "",
                    m = -1,
                    v = void 0,
                    y = h.skipOptionalPartCharacter;
                h.skipOptionalPartCharacter = "", a.resetMaskSet.call(s), u.tests = {}, m = h.radixPoint ? a.determineNewCaretPosition.call(s, {
                    begin: 0,
                    end: 0
                }).begin : 0, u.p = m, s.caretPos = {
                    begin: m
                };
                var b = [],
                    x = s.caretPos;
                if (p.forEach((function (e, n) {
                        if (void 0 !== e)
                            if (void 0 === u.validPositions[n] && p[n] === r.getPlaceholder.call(s, n) && a.isMask.call(s, n, !0) && !1 === o.isValid.call(s, n, p[n], !0, void 0, void 0, !0)) u.p++;
                            else {
                                var l = new d.Event("_checkval");
                                l.which = e.toString().charCodeAt(0), g += e;
                                var h = a.getLastValidPosition.call(s, void 0, !0);
                                ! function (t, e) {
                                    for (var i = r.getMaskTemplate.call(s, !0, 0).slice(t, a.seekNext.call(s, t)).join("").replace(/'/g, ""), n = i.indexOf(e); 0 < n && " " === i[n - 1];) n--;
                                    var l = 0 === n && !a.isMask.call(s, t) && (r.getTest.call(s, t).match.nativeDef === e.charAt(0) || !0 === r.getTest.call(s, t).match.static && r.getTest.call(s, t).match.nativeDef === "'" + e.charAt(0) || " " === r.getTest.call(s, t).match.nativeDef && (r.getTest.call(s, t + 1).match.nativeDef === e.charAt(0) || !0 === r.getTest.call(s, t + 1).match.static && r.getTest.call(s, t + 1).match.nativeDef === "'" + e.charAt(0)));
                                    if (!l && 0 < n && !a.isMask.call(s, t, !1, !0)) {
                                        var o = a.seekNext.call(s, t);
                                        s.caretPos.begin < o && (s.caretPos = {
                                            begin: o
                                        })
                                    }
                                    return l
                                }(m, g) ? (v = c.EventHandlers.keypressEvent.call(t || s, l, !0, !1, i, s.caretPos.begin)) && (m = s.caretPos.begin + 1, g = "") : v = c.EventHandlers.keypressEvent.call(t || s, l, !0, !1, i, h + 1), v ? (void 0 !== v.pos && u.validPositions[v.pos] && !0 === u.validPositions[v.pos].match.static && void 0 === u.validPositions[v.pos].alternation && (b.push(v.pos), s.isRTL || (v.forwardPosition = v.pos + 1)), f.call(s, void 0, a.getBuffer.call(s), v.forwardPosition, l, !1), s.caretPos = {
                                    begin: v.forwardPosition,
                                    end: v.forwardPosition
                                }, x = s.caretPos) : s.caretPos = x
                            }
                    })), 0 < b.length) {
                    var w, _, k = a.seekNext.call(s, -1, void 0, !1);
                    if (!o.isComplete.call(s, a.getBuffer.call(s)) && b.length <= k || o.isComplete.call(s, a.getBuffer.call(s)) && 0 < b.length && b.length !== k && 0 === b[0])
                        for (var S = k; void 0 !== (w = b.shift());) {
                            var A = new d.Event("_checkval");
                            if ((_ = u.validPositions[w]).generatedInput = !0, A.which = _.input.charCodeAt(0), (v = c.EventHandlers.keypressEvent.call(t, A, !0, !1, i, S)) && void 0 !== v.pos && v.pos !== w && u.validPositions[v.pos] && !0 === u.validPositions[v.pos].match.static) b.push(v.pos);
                            else if (!v) break;
                            S++
                        }
                }
                e && f.call(s, t, a.getBuffer.call(s), v ? v.forwardPosition : s.caretPos.begin, l || new d.Event("checkval"), l && "input" === l.type && s.undoValue !== a.getBuffer.call(s).join("")), h.skipOptionalPartCharacter = y
            }

            function f(t, e, i, n, r) {
                var s = t ? t.inputmask : this,
                    c = s.opts,
                    u = s.dependencyLib;
                if (n && "function" == typeof c.onBeforeWrite) {
                    var h = c.onBeforeWrite.call(s, n, e, i, c);
                    if (h) {
                        if (h.refreshFromBuffer) {
                            var d = h.refreshFromBuffer;
                            o.refreshFromBuffer.call(s, !0 === d ? d : d.start, d.end, h.buffer || e), e = a.getBuffer.call(s, !0)
                        }
                        void 0 !== i && (i = void 0 !== h.caret ? h.caret : i)
                    }
                }
                if (void 0 !== t && (t.inputmask._valueSet(e.join("")), void 0 === i || void 0 !== n && "blur" === n.type || a.caret.call(s, t, i, void 0, void 0, void 0 !== n && "keydown" === n.type && (n.keyCode === l.default.DELETE || n.keyCode === l.default.BACKSPACE)), !0 === r)) {
                    var f = u(t),
                        p = t.inputmask._valueGet();
                    t.inputmask.skipInputEvent = !0, f.trigger("input"), setTimeout((function () {
                        p === a.getBufferTemplate.call(s).join("") ? f.trigger("cleared") : !0 === o.isComplete.call(s, e) && f.trigger("complete")
                    }), 0)
                }
            }
        }, function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: !0
            }), exports.default = void 0;
            var _default = "undefined" != typeof window ? window : new(eval("require('jsdom').JSDOM"))("").window;
            exports.default = _default
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.EventHandlers = void 0;
            var n, l = i(2),
                r = (n = i(0)) && n.__esModule ? n : {
                    default: n
                },
                a = i(8),
                o = i(4),
                s = i(5),
                c = i(3),
                u = {
                    keydownEvent: function (t) {
                        var e = this.inputmask,
                            i = e.opts,
                            n = e.dependencyLib,
                            u = e.maskset,
                            h = this,
                            d = n(h),
                            f = t.keyCode,
                            p = l.caret.call(e, h),
                            g = i.onKeyDown.call(this, t, l.getBuffer.call(e), p, i);
                        if (void 0 !== g) return g;
                        if (f === r.default.BACKSPACE || f === r.default.DELETE || a.iphone && f === r.default.BACKSPACE_SAFARI || t.ctrlKey && f === r.default.X && !("oncut" in h)) t.preventDefault(), o.handleRemove.call(e, h, f, p), (0, s.writeBuffer)(h, l.getBuffer.call(e, !0), u.p, t, h.inputmask._valueGet() !== l.getBuffer.call(e).join(""));
                        else if (f === r.default.END || f === r.default.PAGE_DOWN) {
                            t.preventDefault();
                            var m = l.seekNext.call(e, l.getLastValidPosition.call(e));
                            l.caret.call(e, h, t.shiftKey ? p.begin : m, m, !0)
                        } else f === r.default.HOME && !t.shiftKey || f === r.default.PAGE_UP ? (t.preventDefault(), l.caret.call(e, h, 0, t.shiftKey ? p.begin : 0, !0)) : (i.undoOnEscape && f === r.default.ESCAPE || 90 === f && t.ctrlKey) && !0 !== t.altKey ? ((0, s.checkVal)(h, !0, !1, e.undoValue.split("")), d.trigger("click")) : !0 === i.tabThrough && f === r.default.TAB ? !0 === t.shiftKey ? (p.end = l.seekPrevious.call(e, p.end, !0), !0 === c.getTest.call(e, p.end - 1).match.static && p.end--, p.begin = l.seekPrevious.call(e, p.end, !0), 0 <= p.begin && 0 < p.end && (t.preventDefault(), l.caret.call(e, h, p.begin, p.end))) : (p.begin = l.seekNext.call(e, p.begin, !0), p.end = l.seekNext.call(e, p.begin, !0), p.end < u.maskLength && p.end--, p.begin <= u.maskLength && (t.preventDefault(), l.caret.call(e, h, p.begin, p.end))) : t.shiftKey || i.insertModeVisual && !1 === i.insertMode && (f === r.default.RIGHT ? setTimeout((function () {
                            var t = l.caret.call(e, h);
                            l.caret.call(e, h, t.begin)
                        }), 0) : f === r.default.LEFT && setTimeout((function () {
                            var t = l.translatePosition.call(e, h.inputmask.caretPos.begin);
                            l.translatePosition.call(e, h.inputmask.caretPos.end), e.isRTL ? l.caret.call(e, h, t + (t === u.maskLength ? 0 : 1)) : l.caret.call(e, h, t - (0 === t ? 0 : 1))
                        }), 0));
                        e.ignorable = i.ignorables.includes(f)
                    },
                    keypressEvent: function (t, e, i, n, a) {
                        var c = this.inputmask || this,
                            u = c.opts,
                            h = c.dependencyLib,
                            d = c.maskset,
                            f = c.el,
                            p = h(f),
                            g = t.which || t.charCode || t.keyCode;
                        if (!(!0 === e || t.ctrlKey && t.altKey) && (t.ctrlKey || t.metaKey || c.ignorable)) return g === r.default.ENTER && c.undoValue !== l.getBuffer.call(c).join("") && (c.undoValue = l.getBuffer.call(c).join(""), setTimeout((function () {
                            p.trigger("change")
                        }), 0)), c.skipInputEvent = !0, !0;
                        if (g) {
                            44 !== g && 46 !== g || 3 !== t.location || "" === u.radixPoint || (g = u.radixPoint.charCodeAt(0));
                            var m, v = e ? {
                                    begin: a,
                                    end: a
                                } : l.caret.call(c, f),
                                y = String.fromCharCode(g);
                            d.writeOutBuffer = !0;
                            var b = o.isValid.call(c, v, y, n, void 0, void 0, void 0, e);
                            if (!1 !== b && (l.resetMaskSet.call(c, !0), m = void 0 !== b.caret ? b.caret : l.seekNext.call(c, b.pos.begin ? b.pos.begin : b.pos), d.p = m), m = u.numericInput && void 0 === b.caret ? l.seekPrevious.call(c, m) : m, !1 !== i && (setTimeout((function () {
                                    u.onKeyValidation.call(f, g, b)
                                }), 0), d.writeOutBuffer && !1 !== b)) {
                                var x = l.getBuffer.call(c);
                                (0, s.writeBuffer)(f, x, m, t, !0 !== e)
                            }
                            if (t.preventDefault(), e) return !1 !== b && (b.forwardPosition = m), b
                        }
                    },
                    keyupEvent: function (t) {
                        var e = this.inputmask;
                        !e.isComposing || t.keyCode !== r.default.KEY_229 && t.keyCode !== r.default.ENTER || e.$el.trigger("input")
                    },
                    pasteEvent: function (t) {
                        var e, i = this.inputmask,
                            n = i.opts,
                            r = i._valueGet(!0),
                            a = l.caret.call(i, this);
                        i.isRTL && (e = a.end, a.end = a.begin, a.begin = e);
                        var o = r.substr(0, a.begin),
                            c = r.substr(a.end, r.length);
                        if (o == (i.isRTL ? l.getBufferTemplate.call(i).slice().reverse() : l.getBufferTemplate.call(i)).slice(0, a.begin).join("") && (o = ""), c == (i.isRTL ? l.getBufferTemplate.call(i).slice().reverse() : l.getBufferTemplate.call(i)).slice(a.end).join("") && (c = ""), window.clipboardData && window.clipboardData.getData) r = o + window.clipboardData.getData("Text") + c;
                        else {
                            if (!t.clipboardData || !t.clipboardData.getData) return !0;
                            r = o + t.clipboardData.getData("text/plain") + c
                        }
                        var u = r;
                        if ("function" == typeof n.onBeforePaste) {
                            if (!1 === (u = n.onBeforePaste.call(i, r, n))) return t.preventDefault();
                            u = u || r
                        }
                        return (0, s.checkVal)(this, !0, !1, u.toString().split(""), t), t.preventDefault()
                    },
                    inputFallBackEvent: function (t) {
                        var e = this.inputmask,
                            i = e.opts,
                            n = e.dependencyLib,
                            o = this,
                            h = o.inputmask._valueGet(!0),
                            d = (e.isRTL ? l.getBuffer.call(e).slice().reverse() : l.getBuffer.call(e)).join(""),
                            f = l.caret.call(e, o, void 0, void 0, !0);
                        if (d !== h) {
                            var p = function (t, n, r) {
                                for (var a, o, s, u = t.substr(0, r.begin).split(""), h = t.substr(r.begin).split(""), d = n.substr(0, r.begin).split(""), f = n.substr(r.begin).split(""), p = u.length >= d.length ? u.length : d.length, g = h.length >= f.length ? h.length : f.length, m = "", v = []; u.length < p;) u.push("~");
                                for (; d.length < p;) d.push("~");
                                for (; h.length < g;) h.unshift("~");
                                for (; f.length < g;) f.unshift("~");
                                var y = u.concat(h),
                                    b = d.concat(f);
                                for (o = 0, a = y.length; o < a; o++) switch (s = c.getPlaceholder.call(e, l.translatePosition.call(e, o)), m) {
                                    case "insertText":
                                        b[o - 1] === y[o] && r.begin == y.length - 1 && v.push(y[o]), o = a;
                                        break;
                                    case "insertReplacementText":
                                    case "deleteContentBackward":
                                        "~" === y[o] ? r.end++ : o = a;
                                        break;
                                    default:
                                        y[o] !== b[o] && ("~" !== y[o + 1] && y[o + 1] !== s && void 0 !== y[o + 1] || (b[o] !== s || "~" !== b[o + 1]) && "~" !== b[o] ? "~" === b[o + 1] && b[o] === y[o + 1] ? (m = "insertText", v.push(y[o]), r.begin--, r.end--) : y[o] !== s && "~" !== y[o] && ("~" === y[o + 1] || b[o] !== y[o] && b[o + 1] === y[o + 1]) ? (m = "insertReplacementText", v.push(y[o]), r.begin--) : "~" === y[o] ? (m = "deleteContentBackward", !l.isMask.call(e, l.translatePosition.call(e, o), !0) && b[o] !== i.radixPoint || r.end++) : o = a : (m = "insertText", v.push(y[o]), r.begin--, r.end--))
                                }
                                return {
                                    action: m,
                                    data: v,
                                    caret: r
                                }
                            }(h = function (t, i, n) {
                                if (a.iemobile) {
                                    var r = i.replace(l.getBuffer.call(e).join(""), "");
                                    if (1 === r.length) {
                                        var o = i.split("");
                                        o.splice(n.begin, 0, r), i = o.join("")
                                    }
                                }
                                return i
                            }(0, h, f), d, f);
                            switch ((o.inputmask.shadowRoot || document).activeElement !== o && o.focus(), (0, s.writeBuffer)(o, l.getBuffer.call(e)), l.caret.call(e, o, f.begin, f.end, !0), p.action) {
                                case "insertText":
                                case "insertReplacementText":
                                    p.data.forEach((function (t, i) {
                                        var l = new n.Event("keypress");
                                        l.which = t.charCodeAt(0), e.ignorable = !1, u.keypressEvent.call(o, l)
                                    })), setTimeout((function () {
                                        e.$el.trigger("keyup")
                                    }), 0);
                                    break;
                                case "deleteContentBackward":
                                    var g = new n.Event("keydown");
                                    g.keyCode = r.default.BACKSPACE, u.keydownEvent.call(o, g);
                                    break;
                                default:
                                    (0, s.applyInputValue)(o, h)
                            }
                            t.preventDefault()
                        }
                    },
                    compositionendEvent: function (t) {
                        var e = this.inputmask;
                        e.isComposing = !1, e.$el.trigger("input")
                    },
                    setValueEvent: function (t, e, i) {
                        var n = this.inputmask,
                            r = t && t.detail ? t.detail[0] : e;
                        void 0 === r && (r = this.inputmask._valueGet(!0)), (0, s.applyInputValue)(this, r), (t.detail && void 0 !== t.detail[1] || void 0 !== i) && l.caret.call(n, this, t.detail ? t.detail[1] : i)
                    },
                    focusEvent: function (t) {
                        var e = this.inputmask,
                            i = e.opts,
                            n = this.inputmask._valueGet();
                        i.showMaskOnFocus && n !== l.getBuffer.call(e).join("") && (0, s.writeBuffer)(this, l.getBuffer.call(e), l.seekNext.call(e, l.getLastValidPosition.call(e))), !0 !== i.positionCaretOnTab || !1 !== e.mouseEnter || o.isComplete.call(e, l.getBuffer.call(e)) && -1 !== l.getLastValidPosition.call(e) || u.clickEvent.apply(this, [t, !0]), e.undoValue = l.getBuffer.call(e).join("")
                    },
                    invalidEvent: function (t) {
                        this.inputmask.validationEvent = !0
                    },
                    mouseleaveEvent: function () {
                        var t = this.inputmask,
                            e = t.opts;
                        t.mouseEnter = !1, e.clearMaskOnLostFocus && (this.inputmask.shadowRoot || document).activeElement !== this && (0, s.HandleNativePlaceholder)(this, t.originalPlaceholder)
                    },
                    clickEvent: function (t, e) {
                        var i = this.inputmask;
                        if ((this.inputmask.shadowRoot || document).activeElement === this) {
                            var n = l.determineNewCaretPosition.call(i, l.caret.call(i, this), e);
                            void 0 !== n && l.caret.call(i, this, n)
                        }
                    },
                    cutEvent: function (t) {
                        var e = this.inputmask,
                            i = e.maskset,
                            n = l.caret.call(e, this),
                            a = window.clipboardData || t.clipboardData,
                            c = e.isRTL ? l.getBuffer.call(e).slice(n.end, n.begin) : l.getBuffer.call(e).slice(n.begin, n.end);
                        a.setData("text", e.isRTL ? c.reverse().join("") : c.join("")), document.execCommand && document.execCommand("copy"), o.handleRemove.call(e, this, r.default.DELETE, n), (0, s.writeBuffer)(this, l.getBuffer.call(e), i.p, t, e.undoValue !== l.getBuffer.call(e).join(""))
                    },
                    blurEvent: function (t) {
                        var e = this.inputmask,
                            i = e.opts,
                            n = (0, e.dependencyLib)(this);
                        if (this.inputmask) {
                            (0, s.HandleNativePlaceholder)(this, e.originalPlaceholder);
                            var r = this.inputmask._valueGet(),
                                a = l.getBuffer.call(e).slice();
                            "" !== r && (i.clearMaskOnLostFocus && (-1 === l.getLastValidPosition.call(e) && r === l.getBufferTemplate.call(e).join("") ? a = [] : s.clearOptionalTail.call(e, a)), !1 === o.isComplete.call(e, a) && (setTimeout((function () {
                                n.trigger("incomplete")
                            }), 0), i.clearIncomplete && (l.resetMaskSet.call(e), a = i.clearMaskOnLostFocus ? [] : l.getBufferTemplate.call(e).slice())), (0, s.writeBuffer)(this, a, void 0, t)), e.undoValue !== l.getBuffer.call(e).join("") && (e.undoValue = l.getBuffer.call(e).join(""), n.trigger("change"))
                        }
                    },
                    mouseenterEvent: function () {
                        var t = this.inputmask,
                            e = t.opts;
                        t.mouseEnter = !0, (this.inputmask.shadowRoot || document).activeElement !== this && (null == t.originalPlaceholder && this.placeholder !== t.originalPlaceholder && (t.originalPlaceholder = this.placeholder), e.showMaskOnHover && (0, s.HandleNativePlaceholder)(this, (t.isRTL ? l.getBufferTemplate.call(t).slice().reverse() : l.getBufferTemplate.call(t)).join("")))
                    },
                    submitEvent: function () {
                        var t = this.inputmask,
                            e = t.opts;
                        t.undoValue !== l.getBuffer.call(t).join("") && t.$el.trigger("change"), e.clearMaskOnLostFocus && -1 === l.getLastValidPosition.call(t) && t._valueGet && t._valueGet() === l.getBufferTemplate.call(t).join("") && t._valueSet(""), e.clearIncomplete && !1 === o.isComplete.call(t, l.getBuffer.call(t)) && t._valueSet(""), e.removeMaskOnSubmit && (t._valueSet(t.unmaskedvalue(), !0), setTimeout((function () {
                            (0, s.writeBuffer)(t.el, l.getBuffer.call(t))
                        }), 0))
                    },
                    resetEvent: function () {
                        var t = this.inputmask;
                        t.refreshValue = !0, setTimeout((function () {
                            (0, s.applyInputValue)(t.el, t._valueGet(!0))
                        }), 0)
                    }
                };
            e.EventHandlers = u
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.iphone = e.iemobile = e.mobile = e.ie = e.ua = void 0;
            var n = window.navigator && window.navigator.userAgent || "",
                l = 0 < n.indexOf("MSIE ") || 0 < n.indexOf("Trident/"),
                r = "ontouchstart" in window,
                a = /iemobile/i.test(n),
                o = /iphone/i.test(n) && !a;
            e.iphone = o, e.iemobile = a, e.mobile = r, e.ie = l, e.ua = n
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = void 0;
            var n = o(i(13)),
                l = o(i(6)),
                r = o(i(17)),
                a = i(18);

            function o(t) {
                return t && t.__esModule ? t : {
                    default: t
                }
            }
            var s = l.default.document;

            function c(t) {
                return t instanceof c ? t : this instanceof c ? void(null != t && t !== l.default && (this[0] = t.nodeName ? t : void 0 !== t[0] && t[0].nodeName ? t[0] : s.querySelector(t), void 0 !== this[0] && null !== this[0] && (this[0].eventRegistry = this[0].eventRegistry || {}))) : new c(t)
            }
            c.prototype = {
                on: a.on,
                off: a.off,
                trigger: a.trigger
            }, c.extend = n.default, c.data = r.default, c.Event = a.Event;
            var u = c;
            e.default = u
        }, function (t, e, i) {
            "use strict";

            function n(t) {
                return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                    return typeof t
                } : function (t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }
            "function" != typeof Object.getPrototypeOf && (Object.getPrototypeOf = "object" === n("test".__proto__) ? function (t) {
                return t.__proto__
            } : function (t) {
                return t.constructor.prototype
            })
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.mask = function () {
                var t = this,
                    e = this.opts,
                    i = this.el,
                    n = this.dependencyLib;
                o.EventRuler.off(i);
                var h = function (e, i) {
                    "textarea" !== e.tagName.toLowerCase() && i.ignorables.push(l.default.ENTER);
                    var s = e.getAttribute("type"),
                        c = "input" === e.tagName.toLowerCase() && i.supportsInputType.includes(s) || e.isContentEditable || "textarea" === e.tagName.toLowerCase();
                    if (!c)
                        if ("input" === e.tagName.toLowerCase()) {
                            var u = document.createElement("input");
                            u.setAttribute("type", s), c = "text" === u.type, u = null
                        } else c = "partial";
                    return !1 !== c ? function (e) {
                        var l, s;

                        function c() {
                            return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : -1 !== r.getLastValidPosition.call(t) || !0 !== i.nullable ? (this.inputmask.shadowRoot || document.activeElement) === this && i.clearMaskOnLostFocus ? (t.isRTL ? a.clearOptionalTail.call(t, r.getBuffer.call(t).slice()).reverse() : a.clearOptionalTail.call(t, r.getBuffer.call(t).slice())).join("") : l.call(this) : "" : l.call(this)
                        }

                        function u(t) {
                            s.call(this, t), this.inputmask && (0, a.applyInputValue)(this, t)
                        }
                        if (!e.inputmask.__valueGet) {
                            if (!0 !== i.noValuePatching) {
                                if (Object.getOwnPropertyDescriptor) {
                                    var h = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(e), "value") : void 0;
                                    h && h.get && h.set ? (l = h.get, s = h.set, Object.defineProperty(e, "value", {
                                        get: c,
                                        set: u,
                                        configurable: !0
                                    })) : "input" !== e.tagName.toLowerCase() && (l = function () {
                                        return this.textContent
                                    }, s = function (t) {
                                        this.textContent = t
                                    }, Object.defineProperty(e, "value", {
                                        get: c,
                                        set: u,
                                        configurable: !0
                                    }))
                                } else document.__lookupGetter__ && e.__lookupGetter__("value") && (l = e.__lookupGetter__("value"), s = e.__lookupSetter__("value"), e.__defineGetter__("value", c), e.__defineSetter__("value", u));
                                e.inputmask.__valueGet = l, e.inputmask.__valueSet = s
                            }
                            e.inputmask._valueGet = function (e) {
                                return t.isRTL && !0 !== e ? l.call(this.el).split("").reverse().join("") : l.call(this.el)
                            }, e.inputmask._valueSet = function (e, i) {
                                s.call(this.el, null == e ? "" : !0 !== i && t.isRTL ? e.split("").reverse().join("") : e)
                            }, void 0 === l && (l = function () {
                                return this.value
                            }, s = function (t) {
                                this.value = t
                            }, function (e) {
                                if (n.valHooks && (void 0 === n.valHooks[e] || !0 !== n.valHooks[e].inputmaskpatch)) {
                                    var l = n.valHooks[e] && n.valHooks[e].get ? n.valHooks[e].get : function (t) {
                                            return t.value
                                        },
                                        o = n.valHooks[e] && n.valHooks[e].set ? n.valHooks[e].set : function (t, e) {
                                            return t.value = e, t
                                        };
                                    n.valHooks[e] = {
                                        get: function (e) {
                                            if (e.inputmask) {
                                                if (e.inputmask.opts.autoUnmask) return e.inputmask.unmaskedvalue();
                                                var n = l(e);
                                                return -1 !== r.getLastValidPosition.call(t, void 0, void 0, e.inputmask.maskset.validPositions) || !0 !== i.nullable ? n : ""
                                            }
                                            return l(e)
                                        },
                                        set: function (t, e) {
                                            var i = o(t, e);
                                            return t.inputmask && (0, a.applyInputValue)(t, e), i
                                        },
                                        inputmaskpatch: !0
                                    }
                                }
                            }(e.type), function (e) {
                                o.EventRuler.on(e, "mouseenter", (function () {
                                    var e = this.inputmask._valueGet(!0);
                                    e !== (t.isRTL ? r.getBuffer.call(t).reverse() : r.getBuffer.call(t)).join("") && (0, a.applyInputValue)(this, e)
                                }))
                            }(e))
                        }
                    }(e) : e.inputmask = void 0, c
                }(i, e);
                if (!1 !== h) {
                    t.originalPlaceholder = i.placeholder, t.maxLength = void 0 !== i ? i.maxLength : void 0, -1 === t.maxLength && (t.maxLength = void 0), "inputMode" in i && null === i.getAttribute("inputmode") && (i.inputMode = e.inputmode, i.setAttribute("inputmode", e.inputmode)), !0 === h && (e.showMaskOnFocus = e.showMaskOnFocus && -1 === ["cc-number", "cc-exp"].indexOf(i.autocomplete), s.iphone && (e.insertModeVisual = !1), o.EventRuler.on(i, "submit", u.EventHandlers.submitEvent), o.EventRuler.on(i, "reset", u.EventHandlers.resetEvent), o.EventRuler.on(i, "blur", u.EventHandlers.blurEvent), o.EventRuler.on(i, "focus", u.EventHandlers.focusEvent), o.EventRuler.on(i, "invalid", u.EventHandlers.invalidEvent), o.EventRuler.on(i, "click", u.EventHandlers.clickEvent), o.EventRuler.on(i, "mouseleave", u.EventHandlers.mouseleaveEvent), o.EventRuler.on(i, "mouseenter", u.EventHandlers.mouseenterEvent), o.EventRuler.on(i, "paste", u.EventHandlers.pasteEvent), o.EventRuler.on(i, "cut", u.EventHandlers.cutEvent), o.EventRuler.on(i, "complete", e.oncomplete), o.EventRuler.on(i, "incomplete", e.onincomplete), o.EventRuler.on(i, "cleared", e.oncleared), !0 !== e.inputEventOnly && (o.EventRuler.on(i, "keydown", u.EventHandlers.keydownEvent), o.EventRuler.on(i, "keypress", u.EventHandlers.keypressEvent), o.EventRuler.on(i, "keyup", u.EventHandlers.keyupEvent)), (s.mobile || e.inputEventOnly) && i.removeAttribute("maxLength"), o.EventRuler.on(i, "input", u.EventHandlers.inputFallBackEvent), o.EventRuler.on(i, "compositionend", u.EventHandlers.compositionendEvent)), o.EventRuler.on(i, "setvalue", u.EventHandlers.setValueEvent), t.undoValue = r.getBufferTemplate.call(t).join("");
                    var d = (i.inputmask.shadowRoot || document).activeElement;
                    if ("" !== i.inputmask._valueGet(!0) || !1 === e.clearMaskOnLostFocus || d === i) {
                        (0, a.applyInputValue)(i, i.inputmask._valueGet(!0), e);
                        var f = r.getBuffer.call(t).slice();
                        !1 === c.isComplete.call(t, f) && e.clearIncomplete && r.resetMaskSet.call(t), e.clearMaskOnLostFocus && d !== i && (-1 === r.getLastValidPosition.call(t) ? f = [] : a.clearOptionalTail.call(t, f)), (!1 === e.clearMaskOnLostFocus || e.showMaskOnFocus && d === i || "" !== i.inputmask._valueGet(!0)) && (0, a.writeBuffer)(i, f), d === i && r.caret.call(t, i, r.seekNext.call(t, r.getLastValidPosition.call(t)))
                    }
                }
            }, i(10);
            var n, l = (n = i(0)) && n.__esModule ? n : {
                    default: n
                },
                r = i(2),
                a = i(5),
                o = i(12),
                s = i(8),
                c = i(4),
                u = i(7)
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.EventRuler = void 0;
            var n = o(i(1)),
                l = o(i(0)),
                r = i(2),
                a = i(5);

            function o(t) {
                return t && t.__esModule ? t : {
                    default: t
                }
            }
            var s = {
                on: function (t, e, i) {
                    var o = t.inputmask.dependencyLib,
                        s = function (e) {
                            e.originalEvent && (e = e.originalEvent || e, arguments[0] = e);
                            var o, s = this,
                                c = s.inputmask,
                                u = c ? c.opts : void 0,
                                h = c.dependencyLib;
                            if (void 0 === c && "FORM" !== this.nodeName) {
                                var d = h.data(s, "_inputmask_opts");
                                h(s).off(), d && new n.default(d).mask(s)
                            } else {
                                if ("setvalue" === e.type || "FORM" === this.nodeName || !(s.disabled || s.readOnly && !("keydown" === e.type && e.ctrlKey && 67 === e.keyCode || !1 === u.tabThrough && e.keyCode === l.default.TAB))) {
                                    switch (e.type) {
                                        case "input":
                                            if (!0 === c.skipInputEvent || e.inputType && "insertCompositionText" === e.inputType) return c.skipInputEvent = !1, e.preventDefault();
                                            break;
                                        case "keydown":
                                            c.skipKeyPressEvent = !1, c.skipInputEvent = c.isComposing = e.keyCode === l.default.KEY_229;
                                            break;
                                        case "keyup":
                                        case "compositionend":
                                            c.isComposing && (c.skipInputEvent = !1);
                                            break;
                                        case "keypress":
                                            if (!0 === c.skipKeyPressEvent) return e.preventDefault();
                                            c.skipKeyPressEvent = !0;
                                            break;
                                        case "click":
                                        case "focus":
                                            return c.validationEvent ? (c.validationEvent = !1, t.blur(), (0, a.HandleNativePlaceholder)(t, (c.isRTL ? r.getBufferTemplate.call(c).slice().reverse() : r.getBufferTemplate.call(c)).join("")), setTimeout((function () {
                                                t.focus()
                                            }), 3e3)) : (o = arguments, setTimeout((function () {
                                                t.inputmask && i.apply(s, o)
                                            }), 0)), !1
                                    }
                                    var f = i.apply(s, arguments);
                                    return !1 === f && (e.preventDefault(), e.stopPropagation()), f
                                }
                                e.preventDefault()
                            }
                        };
                    t.inputmask.events[e] = t.inputmask.events[e] || [], t.inputmask.events[e].push(s), ["submit", "reset"].includes(e) ? null !== t.form && o(t.form).on(e, s.bind(t)) : o(t).on(e, s)
                },
                off: function (t, e) {
                    if (t.inputmask && t.inputmask.events) {
                        var i = t.inputmask.dependencyLib,
                            n = t.inputmask.events;
                        for (var l in e && ((n = [])[e] = t.inputmask.events[e]), n) {
                            for (var r = n[l]; 0 < r.length;) {
                                var a = r.pop();
                                ["submit", "reset"].includes(l) ? null !== t.form && i(t.form).off(l, a) : i(t).off(l, a)
                            }
                            delete t.inputmask.events[l]
                        }
                    }
                }
            };
            e.EventRuler = s
        }, function (t, e, i) {
            "use strict";

            function n(t) {
                return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                    return typeof t
                } : function (t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = function t() {
                var e, i, l, r, a, o, s = arguments[0] || {},
                    c = 1,
                    u = arguments.length,
                    h = !1;
                for ("boolean" == typeof s && (h = s, s = arguments[c] || {}, c++), "object" !== n(s) && "function" != typeof s && (s = {}); c < u; c++)
                    if (null != (e = arguments[c]))
                        for (i in e) l = s[i], s !== (r = e[i]) && (h && r && ("[object Object]" === Object.prototype.toString.call(r) || (a = Array.isArray(r))) ? (o = a ? (a = !1, l && Array.isArray(l) ? l : []) : l && "[object Object]" === Object.prototype.toString.call(l) ? l : {}, s[i] = t(h, o, r)) : void 0 !== r && (s[i] = r));
                return s
            }
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = function (t) {
                return t.replace(n, "\\$1")
            };
            var n = new RegExp("(\\" + ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^"].join("|\\") + ")", "gim")
        }, function (t, e, i) {
            "use strict";
            var n;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = void 0, i(16), i(22), i(23), i(24);
            var l = ((n = i(1)) && n.__esModule ? n : {
                default: n
            }).default;
            e.default = l
        }, function (t, e, i) {
            "use strict";
            var n, l = (n = i(1)) && n.__esModule ? n : {
                default: n
            };
            l.default.extendDefinitions({
                A: {
                    validator: "[A-Za-zÐ-ÑÐÑ‘Ã€-Ã¿Âµ]",
                    casing: "upper"
                },
                "&": {
                    validator: "[0-9A-Za-zÐ-ÑÐÑ‘Ã€-Ã¿Âµ]",
                    casing: "upper"
                },
                "#": {
                    validator: "[0-9A-Fa-f]",
                    casing: "upper"
                }
            });
            var r = new RegExp("25[0-5]|2[0-4][0-9]|[01][0-9][0-9]");

            function a(t, e, i, n, l) {
                return t = -1 < i - 1 && "." !== e.buffer[i - 1] ? (t = e.buffer[i - 1] + t, -1 < i - 2 && "." !== e.buffer[i - 2] ? e.buffer[i - 2] + t : "0" + t) : "00" + t, r.test(t)
            }
            l.default.extendAliases({
                cssunit: {
                    regex: "[+-]?[0-9]+\\.?([0-9]+)?(px|em|rem|ex|%|in|cm|mm|pt|pc)"
                },
                url: {
                    regex: "(https?|ftp)://.*",
                    autoUnmask: !1,
                    keepStatic: !1,
                    tabThrough: !0
                },
                ip: {
                    mask: "i[i[i]].j[j[j]].k[k[k]].l[l[l]]",
                    definitions: {
                        i: {
                            validator: a
                        },
                        j: {
                            validator: a
                        },
                        k: {
                            validator: a
                        },
                        l: {
                            validator: a
                        }
                    },
                    onUnMask: function (t, e, i) {
                        return t
                    },
                    inputmode: "numeric"
                },
                email: {
                    mask: "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]",
                    greedy: !1,
                    casing: "lower",
                    onBeforePaste: function (t, e) {
                        return (t = t.toLowerCase()).replace("mailto:", "")
                    },
                    definitions: {
                        "*": {
                            validator: "[0-9ï¼‘-ï¼™A-Za-zÐ-ÑÐÑ‘Ã€-Ã¿Âµ!#$%&'*+/=?^_`{|}~-]"
                        },
                        "-": {
                            validator: "[0-9A-Za-z-]"
                        }
                    },
                    onUnMask: function (t, e, i) {
                        return t
                    },
                    inputmode: "email"
                },
                mac: {
                    mask: "##:##:##:##:##:##"
                },
                vin: {
                    mask: "V{13}9{4}",
                    definitions: {
                        V: {
                            validator: "[A-HJ-NPR-Za-hj-npr-z\\d]",
                            casing: "upper"
                        }
                    },
                    clearIncomplete: !0,
                    autoUnmask: !0
                },
                ssn: {
                    mask: "999-99-9999",
                    postValidation: function (t, e, i, n, l, r, a) {
                        return /^(?!219-09-9999|078-05-1120)(?!666|000|9.{2}).{3}-(?!00).{2}-(?!0{4}).{4}$/.test(t.join(""))
                    }
                }
            })
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = function (t, e, i) {
                if (void 0 === i) return t.__data ? t.__data[e] : null;
                t.__data = t.__data || {}, t.__data[e] = i
            }
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.on = function (t, e) {
                function i(t, i) {
                    l.addEventListener ? l.addEventListener(t, e, !1) : l.attachEvent && l.attachEvent("on" + t, e), n[t] = n[t] || {}, n[t][i] = n[t][i] || [], n[t][i].push(e)
                }
                if (s(this[0]))
                    for (var n = this[0].eventRegistry, l = this[0], r = t.split(" "), a = 0; a < r.length; a++) {
                        var o = r[a].split("."),
                            c = o[0],
                            u = o[1] || "global";
                        i(c, u)
                    }
                return this
            }, e.off = function (t, e) {
                var i, n;

                function l(t, e, l) {
                    if (t in i == 1)
                        if (n.removeEventListener ? n.removeEventListener(t, l, !1) : n.detachEvent && n.detachEvent("on" + t, l), "global" === e)
                            for (var r in i[t]) i[t][r].splice(i[t][r].indexOf(l), 1);
                        else i[t][e].splice(i[t][e].indexOf(l), 1)
                }

                function r(t, n) {
                    var l, r, a = [];
                    if (0 < t.length)
                        if (void 0 === e)
                            for (l = 0, r = i[t][n].length; l < r; l++) a.push({
                                ev: t,
                                namespace: n && 0 < n.length ? n : "global",
                                handler: i[t][n][l]
                            });
                        else a.push({
                            ev: t,
                            namespace: n && 0 < n.length ? n : "global",
                            handler: e
                        });
                    else if (0 < n.length)
                        for (var o in i)
                            for (var s in i[o])
                                if (s === n)
                                    if (void 0 === e)
                                        for (l = 0, r = i[o][s].length; l < r; l++) a.push({
                                            ev: o,
                                            namespace: s,
                                            handler: i[o][s][l]
                                        });
                                    else a.push({
                                        ev: o,
                                        namespace: s,
                                        handler: e
                                    });
                    return a
                }
                if (s(this[0])) {
                    i = this[0].eventRegistry, n = this[0];
                    for (var a = t.split(" "), o = 0; o < a.length; o++)
                        for (var c = a[o].split("."), u = r(c[0], c[1]), h = 0, d = u.length; h < d; h++) l(u[h].ev, u[h].namespace, u[h].handler)
                }
                return this
            }, e.trigger = function (t) {
                if (s(this[0]))
                    for (var e = this[0].eventRegistry, i = this[0], n = "string" == typeof t ? t.split(" ") : [t.type], r = 0; r < n.length; r++) {
                        var o = n[r].split("."),
                            c = o[0],
                            u = o[1] || "global";
                        if (void 0 !== document && "global" === u) {
                            var h, d, f = {
                                bubbles: !0,
                                cancelable: !0,
                                detail: arguments[1]
                            };
                            if (document.createEvent) {
                                try {
                                    h = new CustomEvent(c, f)
                                } catch (t) {
                                    (h = document.createEvent("CustomEvent")).initCustomEvent(c, f.bubbles, f.cancelable, f.detail)
                                }
                                t.type && (0, l.default)(h, t), i.dispatchEvent(h)
                            } else(h = document.createEventObject()).eventType = c, h.detail = arguments[1], t.type && (0, l.default)(h, t), i.fireEvent("on" + h.eventType, h)
                        } else if (void 0 !== e[c])
                            if (arguments[0] = arguments[0].type ? arguments[0] : a.default.Event(arguments[0]), arguments[0].detail = arguments.slice(1), "global" === u)
                                for (var p in e[c])
                                    for (d = 0; d < e[c][p].length; d++) e[c][p][d].apply(i, arguments);
                            else
                                for (d = 0; d < e[c][u].length; d++) e[c][u][d].apply(i, arguments)
                    }
                return this
            }, e.Event = void 0;
            var n, l = o(i(13)),
                r = o(i(6)),
                a = o(i(9));

            function o(t) {
                return t && t.__esModule ? t : {
                    default: t
                }
            }

            function s(t) {
                return t instanceof Element
            }
            e.Event = n, "function" == typeof r.default.CustomEvent ? e.Event = n = r.default.CustomEvent : (e.Event = n = function (t, e) {
                e = e || {
                    bubbles: !1,
                    cancelable: !1,
                    detail: void 0
                };
                var i = document.createEvent("CustomEvent");
                return i.initCustomEvent(t, e.bubbles, e.cancelable, e.detail), i
            }, n.prototype = r.default.Event.prototype)
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.generateMaskSet = function (t, e) {
                function i(t, i, n) {
                    var r, a, o = !1;
                    if (null !== t && "" !== t || (t = (o = null !== n.regex) ? (t = n.regex).replace(/^(\^)(.*)(\$)$/, "$2") : (o = !0, ".*")), 1 === t.length && !1 === n.greedy && 0 !== n.repeat && (n.placeholder = ""), 0 < n.repeat || "*" === n.repeat || "+" === n.repeat) {
                        var s = "*" === n.repeat ? 0 : "+" === n.repeat ? 1 : n.repeat;
                        t = n.groupmarker[0] + t + n.groupmarker[1] + n.quantifiermarker[0] + s + "," + n.repeat + n.quantifiermarker[1]
                    }
                    return a = o ? "regex_" + n.regex : n.numericInput ? t.split("").reverse().join("") : t, !1 !== n.keepStatic && (a = "ks_" + a), void 0 === Inputmask.prototype.masksCache[a] || !0 === e ? (r = {
                        mask: t,
                        maskToken: Inputmask.prototype.analyseMask(t, o, n),
                        validPositions: {},
                        _buffer: void 0,
                        buffer: void 0,
                        tests: {},
                        excludes: {},
                        metadata: i,
                        maskLength: void 0,
                        jitOffset: {}
                    }, !0 !== e && (Inputmask.prototype.masksCache[a] = r, r = l.default.extend(!0, {}, Inputmask.prototype.masksCache[a]))) : r = l.default.extend(!0, {}, Inputmask.prototype.masksCache[a]), r
                }
                if ("function" == typeof t.mask && (t.mask = t.mask(t)), Array.isArray(t.mask)) {
                    if (1 < t.mask.length) {
                        null === t.keepStatic && (t.keepStatic = !0);
                        var n = t.groupmarker[0];
                        return (t.isRTL ? t.mask.reverse() : t.mask).forEach((function (e) {
                            1 < n.length && (n += t.groupmarker[1] + t.alternatormarker + t.groupmarker[0]), void 0 !== e.mask && "function" != typeof e.mask ? n += e.mask : n += e
                        })), i(n += t.groupmarker[1], t.mask, t)
                    }
                    t.mask = t.mask.pop()
                }
                return null === t.keepStatic && (t.keepStatic = !1), t.mask && void 0 !== t.mask.mask && "function" != typeof t.mask.mask ? i(t.mask.mask, t.mask, t) : i(t.mask, t.mask, t)
            }, e.analyseMask = function (t, e, i) {
                var n, l, r, a, o, s, c = /(?:[?*+]|\{[0-9+*]+(?:,[0-9+*]*)?(?:\|[0-9+*]*)?\})|[^.?*+^${[]()|\\]+|./g,
                    u = /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g,
                    h = !1,
                    d = new m,
                    f = [],
                    p = [],
                    g = !1;

                function m(t, e, i, n) {
                    this.matches = [], this.openGroup = t || !1, this.alternatorGroup = !1, this.isGroup = t || !1, this.isOptional = e || !1, this.isQuantifier = i || !1, this.isAlternator = n || !1, this.quantifier = {
                        min: 1,
                        max: 1
                    }
                }

                function v(t, n, l) {
                    l = void 0 !== l ? l : t.matches.length;
                    var r = t.matches[l - 1];
                    if (e) 0 === n.indexOf("[") || h && /\\d|\\s|\\w]/i.test(n) || "." === n ? t.matches.splice(l++, 0, {
                        fn: new RegExp(n, i.casing ? "i" : ""),
                        static: !1,
                        optionality: !1,
                        newBlockMarker: void 0 === r ? "master" : r.def !== n,
                        casing: null,
                        def: n,
                        placeholder: void 0,
                        nativeDef: n
                    }) : (h && (n = n[n.length - 1]), n.split("").forEach((function (e, n) {
                        r = t.matches[l - 1], t.matches.splice(l++, 0, {
                            fn: /[a-z]/i.test(i.staticDefinitionSymbol || e) ? new RegExp("[" + (i.staticDefinitionSymbol || e) + "]", i.casing ? "i" : "") : null,
                            static: !0,
                            optionality: !1,
                            newBlockMarker: void 0 === r ? "master" : r.def !== e && !0 !== r.static,
                            casing: null,
                            def: i.staticDefinitionSymbol || e,
                            placeholder: void 0 !== i.staticDefinitionSymbol ? e : void 0,
                            nativeDef: (h ? "'" : "") + e
                        })
                    }))), h = !1;
                    else {
                        var a = i.definitions && i.definitions[n] || i.usePrototypeDefinitions && Inputmask.prototype.definitions[n];
                        a && !h ? t.matches.splice(l++, 0, {
                            fn: a.validator ? "string" == typeof a.validator ? new RegExp(a.validator, i.casing ? "i" : "") : new function () {
                                this.test = a.validator
                            } : new RegExp("."),
                            static: a.static || !1,
                            optionality: !1,
                            newBlockMarker: void 0 === r ? "master" : r.def !== (a.definitionSymbol || n),
                            casing: a.casing,
                            def: a.definitionSymbol || n,
                            placeholder: a.placeholder,
                            nativeDef: n,
                            generated: a.generated
                        }) : (t.matches.splice(l++, 0, {
                            fn: /[a-z]/i.test(i.staticDefinitionSymbol || n) ? new RegExp("[" + (i.staticDefinitionSymbol || n) + "]", i.casing ? "i" : "") : null,
                            static: !0,
                            optionality: !1,
                            newBlockMarker: void 0 === r ? "master" : r.def !== n && !0 !== r.static,
                            casing: null,
                            def: i.staticDefinitionSymbol || n,
                            placeholder: void 0 !== i.staticDefinitionSymbol ? n : void 0,
                            nativeDef: (h ? "'" : "") + n
                        }), h = !1)
                    }
                }

                function y() {
                    if (0 < f.length) {
                        if (v(a = f[f.length - 1], l), a.isAlternator) {
                            o = f.pop();
                            for (var t = 0; t < o.matches.length; t++) o.matches[t].isGroup && (o.matches[t].isGroup = !1);
                            0 < f.length ? (a = f[f.length - 1]).matches.push(o) : d.matches.push(o)
                        }
                    } else v(d, l)
                }

                function b(t) {
                    var e = new m(!0);
                    return e.openGroup = !1, e.matches = t, e
                }

                function x() {
                    if ((r = f.pop()).openGroup = !1, void 0 !== r)
                        if (0 < f.length) {
                            if ((a = f[f.length - 1]).matches.push(r), a.isAlternator) {
                                o = f.pop();
                                for (var t = 0; t < o.matches.length; t++) o.matches[t].isGroup = !1, o.matches[t].alternatorGroup = !1;
                                0 < f.length ? (a = f[f.length - 1]).matches.push(o) : d.matches.push(o)
                            }
                        } else d.matches.push(r);
                    else y()
                }

                function w(t) {
                    var e = t.pop();
                    return e.isQuantifier && (e = b([t.pop(), e])), e
                }
                for (e && (i.optionalmarker[0] = void 0, i.optionalmarker[1] = void 0); n = e ? u.exec(t) : c.exec(t);) {
                    if (l = n[0], e) switch (l.charAt(0)) {
                        case "?":
                            l = "{0,1}";
                            break;
                        case "+":
                        case "*":
                            l = "{" + l + "}";
                            break;
                        case "|":
                            if (0 === f.length) {
                                var _ = b(d.matches);
                                _.openGroup = !0, f.push(_), d.matches = [], g = !0
                            }
                    }
                    if (h) y();
                    else switch (l.charAt(0)) {
                        case "$":
                        case "^":
                            e || y();
                            break;
                        case "(?=":
                        case "(?!":
                        case "(?<=":
                        case "(?<!":
                            break;
                        case i.escapeChar:
                            h = !0, e && y();
                            break;
                        case i.optionalmarker[1]:
                        case i.groupmarker[1]:
                            x();
                            break;
                        case i.optionalmarker[0]:
                            f.push(new m(!1, !0));
                            break;
                        case i.groupmarker[0]:
                            f.push(new m(!0));
                            break;
                        case i.quantifiermarker[0]:
                            var k = new m(!1, !1, !0),
                                S = (l = l.replace(/[{}]/g, "")).split("|"),
                                A = S[0].split(","),
                                M = isNaN(A[0]) ? A[0] : parseInt(A[0]),
                                C = 1 === A.length ? M : isNaN(A[1]) ? A[1] : parseInt(A[1]);
                            "*" !== M && "+" !== M || (M = "*" === C ? 0 : 1), k.quantifier = {
                                min: M,
                                max: C,
                                jit: S[1]
                            };
                            var E = 0 < f.length ? f[f.length - 1].matches : d.matches;
                            if ((n = E.pop()).isAlternator) {
                                E.push(n), E = n.matches;
                                var O = new m(!0),
                                    T = E.pop();
                                E.push(O), E = O.matches, n = T
                            }
                            n.isGroup || (n = b([n])), E.push(n), E.push(k);
                            break;
                        case i.alternatormarker:
                            if (0 < f.length) {
                                var P = (a = f[f.length - 1]).matches[a.matches.length - 1];
                                s = a.openGroup && (void 0 === P.matches || !1 === P.isGroup && !1 === P.isAlternator) ? f.pop() : w(a.matches)
                            } else s = w(d.matches);
                            if (s.isAlternator) f.push(s);
                            else if (s.alternatorGroup ? (o = f.pop(), s.alternatorGroup = !1) : o = new m(!1, !1, !1, !0), o.matches.push(s), f.push(o), s.openGroup) {
                                s.openGroup = !1;
                                var L = new m(!0);
                                L.alternatorGroup = !0, f.push(L)
                            }
                            break;
                        default:
                            y()
                    }
                }
                for (g && x(); 0 < f.length;) r = f.pop(), d.matches.push(r);
                return 0 < d.matches.length && (function t(n) {
                    n && n.matches && n.matches.forEach((function (l, r) {
                        var a = n.matches[r + 1];
                        (void 0 === a || void 0 === a.matches || !1 === a.isQuantifier) && l && l.isGroup && (l.isGroup = !1, e || (v(l, i.groupmarker[0], 0), !0 !== l.openGroup && v(l, i.groupmarker[1]))), t(l)
                    }))
                }(d), p.push(d)), (i.numericInput || i.isRTL) && function t(e) {
                    for (var n in e.matches = e.matches.reverse(), e.matches)
                        if (Object.prototype.hasOwnProperty.call(e.matches, n)) {
                            var l = parseInt(n);
                            if (e.matches[n].isQuantifier && e.matches[l + 1] && e.matches[l + 1].isGroup) {
                                var r = e.matches[n];
                                e.matches.splice(n, 1), e.matches.splice(l + 1, 0, r)
                            }
                            void 0 !== e.matches[n].matches ? e.matches[n] = t(e.matches[n]) : e.matches[n] = ((a = e.matches[n]) === i.optionalmarker[0] ? a = i.optionalmarker[1] : a === i.optionalmarker[1] ? a = i.optionalmarker[0] : a === i.groupmarker[0] ? a = i.groupmarker[1] : a === i.groupmarker[1] && (a = i.groupmarker[0]), a)
                        } var a;
                    return e
                }(p[0]), p
            };
            var n, l = (n = i(9)) && n.__esModule ? n : {
                default: n
            }
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = void 0, e.default = {
                9: {
                    validator: "[0-9ï¼-ï¼™]",
                    definitionSymbol: "*"
                },
                a: {
                    validator: "[A-Za-zÐ-ÑÐÑ‘Ã€-Ã¿Âµ]",
                    definitionSymbol: "*"
                },
                "*": {
                    validator: "[0-9ï¼-ï¼™A-Za-zÐ-ÑÐÑ‘Ã€-Ã¿Âµ]"
                }
            }
        }, function (t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = void 0, e.default = {
                _maxTestPos: 500,
                placeholder: "_",
                optionalmarker: ["[", "]"],
                quantifiermarker: ["{", "}"],
                groupmarker: ["(", ")"],
                alternatormarker: "|",
                escapeChar: "\\",
                mask: null,
                regex: null,
                oncomplete: function () {},
                onincomplete: function () {},
                oncleared: function () {},
                repeat: 0,
                greedy: !1,
                autoUnmask: !1,
                removeMaskOnSubmit: !1,
                clearMaskOnLostFocus: !0,
                insertMode: !0,
                insertModeVisual: !0,
                clearIncomplete: !1,
                alias: null,
                onKeyDown: function () {},
                onBeforeMask: null,
                onBeforePaste: function (t, e) {
                    return "function" == typeof e.onBeforeMask ? e.onBeforeMask.call(this, t, e) : t
                },
                onBeforeWrite: null,
                onUnMask: null,
                showMaskOnFocus: !0,
                showMaskOnHover: !0,
                onKeyValidation: function () {},
                skipOptionalPartCharacter: " ",
                numericInput: !1,
                rightAlign: !1,
                undoOnEscape: !0,
                radixPoint: "",
                _radixDance: !1,
                groupSeparator: "",
                keepStatic: null,
                positionCaretOnTab: !0,
                tabThrough: !1,
                supportsInputType: ["text", "tel", "url", "password", "search"],
                ignorables: [8, 9, 19, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 0, 229],
                isComplete: null,
                preValidation: null,
                postValidation: null,
                staticDefinitionSymbol: void 0,
                jitMasking: !1,
                nullable: !0,
                inputEventOnly: !1,
                noValuePatching: !1,
                positionCaretOnClick: "lvp",
                casing: null,
                inputmode: "text",
                importDataAttributes: !0,
                shiftPositions: !0,
                usePrototypeDefinitions: !0
            }
        }, function (t, e, i) {
            "use strict";
            var n = o(i(1)),
                l = o(i(0)),
                r = o(i(14));

            function a(t) {
                return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                    return typeof t
                } : function (t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }

            function o(t) {
                return t && t.__esModule ? t : {
                    default: t
                }
            }
            var s = n.default.dependencyLib,
                c = (new Date).getFullYear(),
                u = {
                    d: ["[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", Date.prototype.getDate],
                    dd: ["0[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", function () {
                        return g(Date.prototype.getDate.call(this), 2)
                    }],
                    ddd: [""],
                    dddd: [""],
                    m: ["[1-9]|1[012]", Date.prototype.setMonth, "month", function () {
                        return Date.prototype.getMonth.call(this) + 1
                    }],
                    mm: ["0[1-9]|1[012]", Date.prototype.setMonth, "month", function () {
                        return g(Date.prototype.getMonth.call(this) + 1, 2)
                    }],
                    mmm: [""],
                    mmmm: [""],
                    yy: ["[0-9]{2}", Date.prototype.setFullYear, "year", function () {
                        return g(Date.prototype.getFullYear.call(this), 2)
                    }],
                    yyyy: ["[0-9]{4}", Date.prototype.setFullYear, "year", function () {
                        return g(Date.prototype.getFullYear.call(this), 4)
                    }],
                    h: ["[1-9]|1[0-2]", Date.prototype.setHours, "hours", Date.prototype.getHours],
                    hh: ["0[1-9]|1[0-2]", Date.prototype.setHours, "hours", function () {
                        return g(Date.prototype.getHours.call(this), 2)
                    }],
                    hx: [function (t) {
                        return "[0-9]{".concat(t, "}")
                    }, Date.prototype.setHours, "hours", function (t) {
                        return Date.prototype.getHours
                    }],
                    H: ["1?[0-9]|2[0-3]", Date.prototype.setHours, "hours", Date.prototype.getHours],
                    HH: ["0[0-9]|1[0-9]|2[0-3]", Date.prototype.setHours, "hours", function () {
                        return g(Date.prototype.getHours.call(this), 2)
                    }],
                    Hx: [function (t) {
                        return "[0-9]{".concat(t, "}")
                    }, Date.prototype.setHours, "hours", function (t) {
                        return function () {
                            return g(Date.prototype.getHours.call(this), t)
                        }
                    }],
                    M: ["[1-5]?[0-9]", Date.prototype.setMinutes, "minutes", Date.prototype.getMinutes],
                    MM: ["0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]", Date.prototype.setMinutes, "minutes", function () {
                        return g(Date.prototype.getMinutes.call(this), 2)
                    }],
                    s: ["[1-5]?[0-9]", Date.prototype.setSeconds, "seconds", Date.prototype.getSeconds],
                    ss: ["0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]", Date.prototype.setSeconds, "seconds", function () {
                        return g(Date.prototype.getSeconds.call(this), 2)
                    }],
                    l: ["[0-9]{3}", Date.prototype.setMilliseconds, "milliseconds", function () {
                        return g(Date.prototype.getMilliseconds.call(this), 3)
                    }],
                    L: ["[0-9]{2}", Date.prototype.setMilliseconds, "milliseconds", function () {
                        return g(Date.prototype.getMilliseconds.call(this), 2)
                    }],
                    t: ["[ap]"],
                    tt: ["[ap]m"],
                    T: ["[AP]"],
                    TT: ["[AP]M"],
                    Z: [""],
                    o: [""],
                    S: [""]
                },
                h = {
                    isoDate: "yyyy-mm-dd",
                    isoTime: "HH:MM:ss",
                    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
                    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
                };

            function d(t) {
                var e = new RegExp("\\d+$").exec(t[0]);
                if (e && void 0 !== e[0]) {
                    var i = u[t[0][0] + "x"].slice("");
                    return i[0] = i[0](e[0]), i[3] = i[3](e[0]), i
                }
                if (u[t[0]]) return u[t[0]]
            }

            function f(t) {
                if (!t.tokenizer) {
                    var e = [],
                        i = [];
                    for (var n in u)
                        if (/\.*x$/.test(n)) {
                            var l = n[0] + "\\d+"; - 1 === i.indexOf(l) && i.push(l)
                        } else -1 === e.indexOf(n[0]) && e.push(n[0]);
                    t.tokenizer = "(" + (0 < i.length ? i.join("|") + "|" : "") + e.join("+|") + ")+?|.", t.tokenizer = new RegExp(t.tokenizer, "g")
                }
                return t.tokenizer
            }

            function p(t, e, i, n) {
                var l, a, o = "";
                for (f(i).lastIndex = 0; l = f(i).exec(t);)
                    if (void 0 === e)
                        if (a = d(l)) o += "(" + a[0] + ")";
                        else switch (l[0]) {
                            case "[":
                                o += "(";
                                break;
                            case "]":
                                o += ")?";
                                break;
                            default:
                                o += (0, r.default)(l[0])
                        } else(a = d(l)) ? !0 !== n && a[3] ? o += a[3].call(e.date) : a[2] ? o += e["raw" + a[2]] : o += l[0] : o += l[0];
                return o
            }

            function g(t, e) {
                for (t = String(t), e = e || 2; t.length < e;) t = "0" + t;
                return t
            }

            function m(t, e, i) {
                var n, l, r, o = {
                        date: new Date(1, 0, 1)
                    },
                    s = t;

                function c(t, e, i) {
                    t[n] = e.replace(/[^0-9]/g, "0"), t["raw" + n] = e, void 0 !== r && r.call(t.date, "month" == n ? parseInt(t[n]) - 1 : t[n])
                }
                if ("string" == typeof s) {
                    for (f(i).lastIndex = 0; l = f(i).exec(e);) {
                        var h = new RegExp("\\d+$").exec(l[0]),
                            d = h ? l[0][0] + "x" : l[0],
                            p = void 0;
                        if (h) {
                            var g = f(i).lastIndex,
                                m = y(l.index, i);
                            f(i).lastIndex = g, p = s.slice(0, s.indexOf(m.nextMatch[0]))
                        } else p = s.slice(0, d.length);
                        Object.prototype.hasOwnProperty.call(u, d) && (n = u[d][2], r = u[d][1], c(o, p)), s = s.slice(p.length)
                    }
                    return o
                }
                if (s && "object" === a(s) && Object.prototype.hasOwnProperty.call(s, "date")) return s
            }

            function v(t, e) {
                return p(e.inputFormat, {
                    date: t
                }, e)
            }

            function y(t, e) {
                var i, n, l = 0,
                    r = 0;
                for (f(e).lastIndex = 0; n = f(e).exec(e.inputFormat);) {
                    var a = new RegExp("\\d+$").exec(n[0]);
                    if (t <= (l += r = a ? parseInt(a[0]) : n[0].length)) {
                        i = n, n = f(e).exec(e.inputFormat);
                        break
                    }
                }
                return {
                    targetMatchIndex: l - r,
                    nextMatch: n,
                    targetMatch: i
                }
            }
            n.default.extendAliases({
                datetime: {
                    mask: function (t) {
                        return t.numericInput = !1, u.S = t.i18n.ordinalSuffix.join("|"), t.inputFormat = h[t.inputFormat] || t.inputFormat, t.displayFormat = h[t.displayFormat] || t.displayFormat || t.inputFormat, t.outputFormat = h[t.outputFormat] || t.outputFormat || t.inputFormat, t.placeholder = "" !== t.placeholder ? t.placeholder : t.inputFormat.replace(/[[\]]/, ""), t.regex = p(t.inputFormat, void 0, t), t.min = m(t.min, t.inputFormat, t), t.max = m(t.max, t.inputFormat, t), null
                    },
                    placeholder: "",
                    inputFormat: "isoDateTime",
                    displayFormat: void 0,
                    outputFormat: void 0,
                    min: null,
                    max: null,
                    skipOptionalPartCharacter: "",
                    i18n: {
                        dayNames: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                        monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                        ordinalSuffix: ["st", "nd", "rd", "th"]
                    },
                    preValidation: function (t, e, i, n, l, r, a, o) {
                        if (o) return !0;
                        if (isNaN(i) && t[e] !== i) {
                            var s = y(e, l);
                            if (s.nextMatch && s.nextMatch[0] === i && 1 < s.targetMatch[0].length) {
                                var c = u[s.targetMatch[0]][0];
                                if (new RegExp(c).test("0" + t[e - 1])) return t[e] = t[e - 1], t[e - 1] = "0", {
                                    fuzzy: !0,
                                    buffer: t,
                                    refreshFromBuffer: {
                                        start: e - 1,
                                        end: e + 1
                                    },
                                    pos: e + 1
                                }
                            }
                        }
                        return !0
                    },
                    postValidation: function (t, e, i, n, l, r, a, o) {
                        if (a) return !0;
                        var s, h;
                        if (!1 === n) return (s = y(e + 1, l)).targetMatch && s.targetMatchIndex === e && 1 < s.targetMatch[0].length && void 0 !== u[s.targetMatch[0]] && (h = u[s.targetMatch[0]][0], new RegExp(h).test("0" + i)) ? {
                            insert: [{
                                pos: e,
                                c: "0"
                            }, {
                                pos: e + 1,
                                c: i
                            }],
                            pos: e + 1
                        } : n;
                        if (n.fuzzy && (t = n.buffer, e = n.pos), (s = y(e, l)).targetMatch && s.targetMatch[0] && void 0 !== u[s.targetMatch[0]]) {
                            h = u[s.targetMatch[0]][0];
                            var d = t.slice(s.targetMatchIndex, s.targetMatchIndex + s.targetMatch[0].length);
                            !1 === new RegExp(h).test(d.join("")) && 2 === s.targetMatch[0].length && r.validPositions[s.targetMatchIndex] && r.validPositions[s.targetMatchIndex + 1] && (r.validPositions[s.targetMatchIndex + 1].input = "0")
                        }
                        var f = n,
                            g = m(t.join(""), l.inputFormat, l);
                        return f && g.date.getTime() == g.date.getTime() && (f = function (t, e, i) {
                            if (t.year !== t.rawyear) {
                                var n = c.toString(),
                                    l = t.rawyear.replace(/[^0-9]/g, ""),
                                    r = n.slice(0, l.length),
                                    a = n.slice(l.length);
                                if (2 === l.length && l === r) {
                                    var o = new Date(c, t.month - 1, t.day);
                                    t.day == o.getDate() && (!i.max || i.max.date.getTime() >= o.getTime()) && (t.date.setFullYear(c), t.year = n, e.insert = [{
                                        pos: e.pos + 1,
                                        c: a[0]
                                    }, {
                                        pos: e.pos + 2,
                                        c: a[1]
                                    }])
                                }
                            }
                            return e
                        }(g, f, l), f = function (t, e, i) {
                            if (!isFinite(t.rawday) || "29" == t.day && !isFinite(t.rawyear) || new Date(t.date.getFullYear(), isFinite(t.rawmonth) ? t.month : t.date.getMonth() + 1, 0).getDate() >= t.day) return e;
                            if ("29" == t.day) {
                                var n = y(e.pos, i);
                                if ("yyyy" === n.targetMatch[0] && e.pos - n.targetMatchIndex == 2) return e.remove = e.pos + 1, e
                            }
                            return !1
                        }(g, f, l), f = function (t, e, i, n, l) {
                            if (!e) return e;
                            if (i.min) {
                                if (t.rawyear) {
                                    var r, a = t.rawyear.replace(/[^0-9]/g, ""),
                                        o = i.min.year.substr(0, a.length);
                                    if (a < o) {
                                        var s = y(e.pos, i);
                                        if (a = t.rawyear.substr(0, e.pos - s.targetMatchIndex + 1), (o = i.min.year.substr(0, a.length)) <= a) return e.remove = s.targetMatchIndex + a.length, e;
                                        if (a = "yyyy" === s.targetMatch[0] ? t.rawyear.substr(1, 1) : t.rawyear.substr(0, 1), o = i.min.year.substr(2, 1), r = i.max ? i.max.year.substr(2, 1) : a, 1 === a.length && o <= a <= r && !0 !== l) return "yyyy" === s.targetMatch[0] ? (e.insert = [{
                                            pos: e.pos + 1,
                                            c: a,
                                            strict: !0
                                        }], e.caret = e.pos + 2, n.validPositions[e.pos].input = i.min.year[1]) : (e.insert = [{
                                            pos: e.pos + 1,
                                            c: i.min.year[1],
                                            strict: !0
                                        }, {
                                            pos: e.pos + 2,
                                            c: a,
                                            strict: !0
                                        }], e.caret = e.pos + 3, n.validPositions[e.pos].input = i.min.year[0]), e;
                                        e = !1
                                    }
                                }
                                e && t.year && t.year === t.rawyear && i.min.date.getTime() == i.min.date.getTime() && (e = i.min.date.getTime() <= t.date.getTime())
                            }
                            return e && i.max && i.max.date.getTime() == i.max.date.getTime() && (e = i.max.date.getTime() >= t.date.getTime()), e
                        }(g, f, l, r, o)), e && f && n.pos !== e ? {
                            buffer: p(l.inputFormat, g, l).split(""),
                            refreshFromBuffer: {
                                start: e,
                                end: n.pos
                            }
                        } : f
                    },
                    onKeyDown: function (t, e, i, n) {
                        t.ctrlKey && t.keyCode === l.default.RIGHT && (this.inputmask._valueSet(v(new Date, n)), s(this).trigger("setvalue"))
                    },
                    onUnMask: function (t, e, i) {
                        return e ? p(i.outputFormat, m(t, i.inputFormat, i), i, !0) : e
                    },
                    casing: function (t, e, i, n) {
                        return 0 == e.nativeDef.indexOf("[ap]") ? t.toLowerCase() : 0 == e.nativeDef.indexOf("[AP]") ? t.toUpperCase() : t
                    },
                    onBeforeMask: function (t, e) {
                        return "[object Date]" === Object.prototype.toString.call(t) && (t = v(t, e)), t
                    },
                    insertMode: !1,
                    shiftPositions: !1,
                    keepStatic: !1,
                    inputmode: "numeric"
                }
            })
        }, function (t, e, i) {
            "use strict";
            var n = a(i(1)),
                l = a(i(0)),
                r = a(i(14));

            function a(t) {
                return t && t.__esModule ? t : {
                    default: t
                }
            }
            var o = n.default.dependencyLib;

            function s(t, e) {
                for (var i = "", l = 0; l < t.length; l++) n.default.prototype.definitions[t.charAt(l)] || e.definitions[t.charAt(l)] || e.optionalmarker[0] === t.charAt(l) || e.optionalmarker[1] === t.charAt(l) || e.quantifiermarker[0] === t.charAt(l) || e.quantifiermarker[1] === t.charAt(l) || e.groupmarker[0] === t.charAt(l) || e.groupmarker[1] === t.charAt(l) || e.alternatormarker === t.charAt(l) ? i += "\\" + t.charAt(l) : i += t.charAt(l);
                return i
            }

            function c(t, e, i, n) {
                if (0 < t.length && 0 < e && (!i.digitsOptional || n)) {
                    var l = t.indexOf(i.radixPoint),
                        r = !1;
                    i.negationSymbol.back === t[t.length - 1] && (r = !0, t.length--), -1 === l && (t.push(i.radixPoint), l = t.length - 1);
                    for (var a = 1; a <= e; a++) isFinite(t[l + a]) || (t[l + a] = "0")
                }
                return r && t.push(i.negationSymbol.back), t
            }

            function u(t, e) {
                var i = 0;
                if ("+" === t) {
                    for (i in e.validPositions);
                    i = parseInt(i)
                }
                for (var n in e.tests)
                    if (i <= (n = parseInt(n)))
                        for (var l = 0, r = e.tests[n].length; l < r; l++)
                            if ((void 0 === e.validPositions[n] || "-" === t) && e.tests[n][l].match.def === t) return n + (void 0 !== e.validPositions[n] && "-" !== t ? 1 : 0);
                return i
            }

            function h(t, e) {
                var i = -1;
                for (var n in e.validPositions) {
                    var l = e.validPositions[n];
                    if (l && l.match.def === t) {
                        i = parseInt(n);
                        break
                    }
                }
                return i
            }

            function d(t, e, i, n, l) {
                var r = e.buffer ? e.buffer.indexOf(l.radixPoint) : -1,
                    a = -1 !== r && new RegExp("[0-9ï¼‘-ï¼™]").test(t);
                return l._radixDance && a && null == e.validPositions[r] ? {
                    insert: {
                        pos: r === i ? r + 1 : r,
                        c: l.radixPoint
                    },
                    pos: i
                } : a
            }
            n.default.extendAliases({
                numeric: {
                    mask: function (t) {
                        t.repeat = 0, t.groupSeparator === t.radixPoint && t.digits && "0" !== t.digits && ("." === t.radixPoint ? t.groupSeparator = "," : "," === t.radixPoint ? t.groupSeparator = "." : t.groupSeparator = ""), " " === t.groupSeparator && (t.skipOptionalPartCharacter = void 0), 1 < t.placeholder.length && (t.placeholder = t.placeholder.charAt(0)), "radixFocus" === t.positionCaretOnClick && "" === t.placeholder && (t.positionCaretOnClick = "lvp");
                        var e = "0",
                            i = t.radixPoint;
                        !0 === t.numericInput && void 0 === t.__financeInput ? (e = "1", t.positionCaretOnClick = "radixFocus" === t.positionCaretOnClick ? "lvp" : t.positionCaretOnClick, t.digitsOptional = !1, isNaN(t.digits) && (t.digits = 2), t._radixDance = !1, i = "," === t.radixPoint ? "?" : "!", "" !== t.radixPoint && void 0 === t.definitions[i] && (t.definitions[i] = {}, t.definitions[i].validator = "[" + t.radixPoint + "]", t.definitions[i].placeholder = t.radixPoint, t.definitions[i].static = !0, t.definitions[i].generated = !0)) : (t.__financeInput = !1, t.numericInput = !0);
                        var n, l = "[+]";
                        if (l += s(t.prefix, t), "" !== t.groupSeparator ? (void 0 === t.definitions[t.groupSeparator] && (t.definitions[t.groupSeparator] = {}, t.definitions[t.groupSeparator].validator = "[" + t.groupSeparator + "]", t.definitions[t.groupSeparator].placeholder = t.groupSeparator, t.definitions[t.groupSeparator].static = !0, t.definitions[t.groupSeparator].generated = !0), l += t._mask(t)) : l += "9{+}", void 0 !== t.digits && 0 !== t.digits) {
                            var a = t.digits.toString().split(",");
                            isFinite(a[0]) && a[1] && isFinite(a[1]) ? l += i + e + "{" + t.digits + "}" : (isNaN(t.digits) || 0 < parseInt(t.digits)) && (t.digitsOptional ? (n = l + i + e + "{0," + t.digits + "}", t.keepStatic = !0) : l += i + e + "{" + t.digits + "}")
                        }
                        return l += s(t.suffix, t), l += "[-]", n && (l = [n + s(t.suffix, t) + "[-]", l]), t.greedy = !1,
                            function (t) {
                                void 0 === t.parseMinMaxOptions && (null !== t.min && (t.min = t.min.toString().replace(new RegExp((0, r.default)(t.groupSeparator), "g"), ""), "," === t.radixPoint && (t.min = t.min.replace(t.radixPoint, ".")), t.min = isFinite(t.min) ? parseFloat(t.min) : NaN, isNaN(t.min) && (t.min = Number.MIN_VALUE)), null !== t.max && (t.max = t.max.toString().replace(new RegExp((0, r.default)(t.groupSeparator), "g"), ""), "," === t.radixPoint && (t.max = t.max.replace(t.radixPoint, ".")), t.max = isFinite(t.max) ? parseFloat(t.max) : NaN, isNaN(t.max) && (t.max = Number.MAX_VALUE)), t.parseMinMaxOptions = "done")
                            }(t), l
                    },
                    _mask: function (t) {
                        return "(" + t.groupSeparator + "999){+|1}"
                    },
                    digits: "*",
                    digitsOptional: !0,
                    enforceDigitsOnBlur: !1,
                    radixPoint: ".",
                    positionCaretOnClick: "radixFocus",
                    _radixDance: !0,
                    groupSeparator: "",
                    allowMinus: !0,
                    negationSymbol: {
                        front: "-",
                        back: ""
                    },
                    prefix: "",
                    suffix: "",
                    min: null,
                    max: null,
                    SetMaxOnOverflow: !1,
                    step: 1,
                    inputType: "text",
                    unmaskAsNumber: !1,
                    roundingFN: Math.round,
                    inputmode: "numeric",
                    shortcuts: {
                        k: "000",
                        m: "000000"
                    },
                    placeholder: "0",
                    greedy: !1,
                    rightAlign: !0,
                    insertMode: !0,
                    autoUnmask: !1,
                    skipOptionalPartCharacter: "",
                    definitions: {
                        0: {
                            validator: d
                        },
                        1: {
                            validator: d,
                            definitionSymbol: "9"
                        },
                        "+": {
                            validator: function (t, e, i, n, l) {
                                return l.allowMinus && ("-" === t || t === l.negationSymbol.front)
                            }
                        },
                        "-": {
                            validator: function (t, e, i, n, l) {
                                return l.allowMinus && t === l.negationSymbol.back
                            }
                        }
                    },
                    preValidation: function (t, e, i, n, l, r, a, o) {
                        if (!1 !== l.__financeInput && i === l.radixPoint) return !1;
                        var s;
                        if (s = l.shortcuts && l.shortcuts[i]) {
                            if (1 < s.length)
                                for (var c = [], d = 0; d < s.length; d++) c.push({
                                    pos: e + d,
                                    c: s[d],
                                    strict: !1
                                });
                            return {
                                insert: c
                            }
                        }
                        var f = t.indexOf(l.radixPoint),
                            p = e;
                        if (e = function (t, e, i, n, l) {
                                return l._radixDance && l.numericInput && e !== l.negationSymbol.back && t <= i && (0 < i || e == l.radixPoint) && (void 0 === n.validPositions[t - 1] || n.validPositions[t - 1].input !== l.negationSymbol.back) && (t -= 1), t
                            }(e, i, f, r, l), "-" === i || i === l.negationSymbol.front) {
                            if (!0 !== l.allowMinus) return !1;
                            var g = !1,
                                m = h("+", r),
                                v = h("-", r);
                            return -1 !== m && (g = [m, v]), !1 !== g ? {
                                remove: g,
                                caret: p - l.negationSymbol.front.length
                            } : {
                                insert: [{
                                    pos: u("+", r),
                                    c: l.negationSymbol.front,
                                    fromIsValid: !0
                                }, {
                                    pos: u("-", r),
                                    c: l.negationSymbol.back,
                                    fromIsValid: void 0
                                }],
                                caret: p + l.negationSymbol.back.length
                            }
                        }
                        if (i === l.groupSeparator) return {
                            caret: p
                        };
                        if (o) return !0;
                        if (-1 !== f && !0 === l._radixDance && !1 === n && i === l.radixPoint && void 0 !== l.digits && (isNaN(l.digits) || 0 < parseInt(l.digits)) && f !== e) return {
                            caret: l._radixDance && e === f - 1 ? f + 1 : f
                        };
                        if (!1 === l.__financeInput)
                            if (n) {
                                if (l.digitsOptional) return {
                                    rewritePosition: a.end
                                };
                                if (!l.digitsOptional) {
                                    if (a.begin > f && a.end <= f) return i === l.radixPoint ? {
                                        insert: {
                                            pos: f + 1,
                                            c: "0",
                                            fromIsValid: !0
                                        },
                                        rewritePosition: f
                                    } : {
                                        rewritePosition: f + 1
                                    };
                                    if (a.begin < f) return {
                                        rewritePosition: a.begin - 1
                                    }
                                }
                            } else if (!l.showMaskOnHover && !l.showMaskOnFocus && !l.digitsOptional && 0 < l.digits && "" === this.inputmask.__valueGet.call(this)) return {
                            rewritePosition: f
                        };
                        return {
                            rewritePosition: e
                        }
                    },
                    postValidation: function (t, e, i, n, l, r, a) {
                        if (!1 === n) return n;
                        if (a) return !0;
                        if (null !== l.min || null !== l.max) {
                            var s = l.onUnMask(t.slice().reverse().join(""), void 0, o.extend({}, l, {
                                unmaskAsNumber: !0
                            }));
                            if (null !== l.min && s < l.min && (s.toString().length > l.min.toString().length || s < 0)) return !1;
                            if (null !== l.max && s > l.max) return !!l.SetMaxOnOverflow && {
                                refreshFromBuffer: !0,
                                buffer: c(l.max.toString().replace(".", l.radixPoint).split(""), l.digits, l).reverse()
                            }
                        }
                        return n
                    },
                    onUnMask: function (t, e, i) {
                        if ("" === e && !0 === i.nullable) return e;
                        var n = t.replace(i.prefix, "");
                        return n = (n = n.replace(i.suffix, "")).replace(new RegExp((0, r.default)(i.groupSeparator), "g"), ""), "" !== i.placeholder.charAt(0) && (n = n.replace(new RegExp(i.placeholder.charAt(0), "g"), "0")), i.unmaskAsNumber ? ("" !== i.radixPoint && -1 !== n.indexOf(i.radixPoint) && (n = n.replace(r.default.call(this, i.radixPoint), ".")), n = (n = n.replace(new RegExp("^" + (0, r.default)(i.negationSymbol.front)), "-")).replace(new RegExp((0, r.default)(i.negationSymbol.back) + "$"), ""), Number(n)) : n
                    },
                    isComplete: function (t, e) {
                        var i = (e.numericInput ? t.slice().reverse() : t).join("");
                        return i = (i = (i = (i = (i = i.replace(new RegExp("^" + (0, r.default)(e.negationSymbol.front)), "-")).replace(new RegExp((0, r.default)(e.negationSymbol.back) + "$"), "")).replace(e.prefix, "")).replace(e.suffix, "")).replace(new RegExp((0, r.default)(e.groupSeparator) + "([0-9]{3})", "g"), "$1"), "," === e.radixPoint && (i = i.replace((0, r.default)(e.radixPoint), ".")), isFinite(i)
                    },
                    onBeforeMask: function (t, e) {
                        var i = e.radixPoint || ",";
                        isFinite(e.digits) && (e.digits = parseInt(e.digits)), "number" != typeof t && "number" !== e.inputType || "" === i || (t = t.toString().replace(".", i));
                        var n = "-" === t.charAt(0) || t.charAt(0) === e.negationSymbol.front,
                            l = t.split(i),
                            a = l[0].replace(/[^\-0-9]/g, ""),
                            o = 1 < l.length ? l[1].replace(/[^0-9]/g, "") : "",
                            s = 1 < l.length;
                        t = a + ("" !== o ? i + o : o);
                        var u = 0;
                        if ("" !== i && (u = e.digitsOptional ? e.digits < o.length ? e.digits : o.length : e.digits, "" !== o || !e.digitsOptional)) {
                            var h = Math.pow(10, u || 1);
                            t = t.replace((0, r.default)(i), "."), isNaN(parseFloat(t)) || (t = (e.roundingFN(parseFloat(t) * h) / h).toFixed(u)), t = t.toString().replace(".", i)
                        }
                        if (0 === e.digits && -1 !== t.indexOf(i) && (t = t.substring(0, t.indexOf(i))), null !== e.min || null !== e.max) {
                            var d = t.toString().replace(i, ".");
                            null !== e.min && d < e.min ? t = e.min.toString().replace(".", i) : null !== e.max && d > e.max && (t = e.max.toString().replace(".", i))
                        }
                        return n && "-" !== t.charAt(0) && (t = "-" + t), c(t.toString().split(""), u, e, s).join("")
                    },
                    onBeforeWrite: function (t, e, i, n) {
                        function l(t, e) {
                            if (!1 !== n.__financeInput || e) {
                                var i = t.indexOf(n.radixPoint); - 1 !== i && t.splice(i, 1)
                            }
                            if ("" !== n.groupSeparator)
                                for (; - 1 !== (i = t.indexOf(n.groupSeparator));) t.splice(i, 1);
                            return t
                        }
                        var a, s = function (t, e) {
                            var i = new RegExp("(^" + ("" !== e.negationSymbol.front ? (0, r.default)(e.negationSymbol.front) + "?" : "") + (0, r.default)(e.prefix) + ")(.*)(" + (0, r.default)(e.suffix) + ("" != e.negationSymbol.back ? (0, r.default)(e.negationSymbol.back) + "?" : "") + "$)").exec(t.slice().reverse().join("")),
                                n = i ? i[2] : "",
                                l = !1;
                            return n && (n = n.split(e.radixPoint.charAt(0))[0], l = new RegExp("^[0" + e.groupSeparator + "]*").exec(n)), !(!l || !(1 < l[0].length || 0 < l[0].length && l[0].length < n.length)) && l
                        }(e, n);
                        if (s)
                            for (var u = e.join("").lastIndexOf(s[0].split("").reverse().join("")) - (s[0] == s.input ? 0 : 1), h = s[0] == s.input ? 1 : 0, d = s[0].length - h; 0 < d; d--) delete this.maskset.validPositions[u + d], delete e[u + d];
                        if (t) switch (t.type) {
                            case "blur":
                            case "checkval":
                                if (null !== n.min) {
                                    var f = n.onUnMask(e.slice().reverse().join(""), void 0, o.extend({}, n, {
                                        unmaskAsNumber: !0
                                    }));
                                    if (null !== n.min && f < n.min) return {
                                        refreshFromBuffer: !0,
                                        buffer: c(n.min.toString().replace(".", n.radixPoint).split(""), n.digits, n).reverse()
                                    }
                                }
                                if (e[e.length - 1] === n.negationSymbol.front) {
                                    var p = new RegExp("(^" + ("" != n.negationSymbol.front ? (0, r.default)(n.negationSymbol.front) + "?" : "") + (0, r.default)(n.prefix) + ")(.*)(" + (0, r.default)(n.suffix) + ("" != n.negationSymbol.back ? (0, r.default)(n.negationSymbol.back) + "?" : "") + "$)").exec(l(e.slice(), !0).reverse().join(""));
                                    0 == (p ? p[2] : "") && (a = {
                                        refreshFromBuffer: !0,
                                        buffer: [0]
                                    })
                                } else "" !== n.radixPoint && e[0] === n.radixPoint && (a && a.buffer ? a.buffer.shift() : (e.shift(), a = {
                                    refreshFromBuffer: !0,
                                    buffer: l(e)
                                }));
                                if (n.enforceDigitsOnBlur) {
                                    var g = (a = a || {}) && a.buffer || e.slice().reverse();
                                    a.refreshFromBuffer = !0, a.buffer = c(g, n.digits, n, !0).reverse()
                                }
                        }
                        return a
                    },
                    onKeyDown: function (t, e, i, n) {
                        var r, a = o(this);
                        if (t.ctrlKey) switch (t.keyCode) {
                            case l.default.UP:
                                return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) + parseInt(n.step)), a.trigger("setvalue"), !1;
                            case l.default.DOWN:
                                return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) - parseInt(n.step)), a.trigger("setvalue"), !1
                        }
                        if (!t.shiftKey && (t.keyCode === l.default.DELETE || t.keyCode === l.default.BACKSPACE || t.keyCode === l.default.BACKSPACE_SAFARI) && i.begin !== e.length) {
                            if (e[t.keyCode === l.default.DELETE ? i.begin - 1 : i.end] === n.negationSymbol.front) return r = e.slice().reverse(), "" !== n.negationSymbol.front && r.shift(), "" !== n.negationSymbol.back && r.pop(), a.trigger("setvalue", [r.join(""), i.begin]), !1;
                            if (!0 === n._radixDance) {
                                var s = e.indexOf(n.radixPoint);
                                if (n.digitsOptional) {
                                    if (0 === s) return (r = e.slice().reverse()).pop(), a.trigger("setvalue", [r.join(""), i.begin >= r.length ? r.length : i.begin]), !1
                                } else if (-1 !== s && (i.begin < s || i.end < s || t.keyCode === l.default.DELETE && i.begin === s)) return i.begin !== i.end || t.keyCode !== l.default.BACKSPACE && t.keyCode !== l.default.BACKSPACE_SAFARI || i.begin++, (r = e.slice().reverse()).splice(r.length - i.begin, i.begin - i.end + 1), r = c(r, n.digits, n).join(""), a.trigger("setvalue", [r, i.begin >= r.length ? s + 1 : i.begin]), !1
                            }
                        }
                    }
                },
                currency: {
                    prefix: "",
                    groupSeparator: ",",
                    alias: "numeric",
                    digits: 2,
                    digitsOptional: !1
                },
                decimal: {
                    alias: "numeric"
                },
                integer: {
                    alias: "numeric",
                    digits: 0
                },
                percentage: {
                    alias: "numeric",
                    min: 0,
                    max: 100,
                    suffix: " %",
                    digits: 0,
                    allowMinus: !1
                },
                indianns: {
                    alias: "numeric",
                    _mask: function (t) {
                        return "(" + t.groupSeparator + "99){*|1}(" + t.groupSeparator + "999){1|1}"
                    },
                    groupSeparator: ",",
                    radixPoint: ".",
                    placeholder: "0",
                    digits: 2,
                    digitsOptional: !1
                }
            })
        }, function (t, e, i) {
            "use strict";
            var n = d(i(6)),
                l = d(i(1));

            function r(t) {
                return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                    return typeof t
                } : function (t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }

            function a(t, e) {
                return !e || "object" !== r(e) && "function" != typeof e ? function (t) {
                    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t
                }(t) : e
            }

            function o(t) {
                var e = "function" == typeof Map ? new Map : void 0;
                return (o = function (t) {
                    if (null === t || (i = t, -1 === Function.toString.call(i).indexOf("[native code]"))) return t;
                    var i;
                    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== e) {
                        if (e.has(t)) return e.get(t);
                        e.set(t, n)
                    }

                    function n() {
                        return s(t, arguments, h(this).constructor)
                    }
                    return n.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: n,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), u(n, t)
                })(t)
            }

            function s(t, e, i) {
                return (s = c() ? Reflect.construct : function (t, e, i) {
                    var n = [null];
                    n.push.apply(n, e);
                    var l = new(Function.bind.apply(t, n));
                    return i && u(l, i.prototype), l
                }).apply(null, arguments)
            }

            function c() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Date.prototype.toString.call(Reflect.construct(Date, [], (function () {}))), !0
                } catch (t) {
                    return !1
                }
            }

            function u(t, e) {
                return (u = Object.setPrototypeOf || function (t, e) {
                    return t.__proto__ = e, t
                })(t, e)
            }

            function h(t) {
                return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
                    return t.__proto__ || Object.getPrototypeOf(t)
                })(t)
            }

            function d(t) {
                return t && t.__esModule ? t : {
                    default: t
                }
            }
            var f = n.default.document;
            if (f && f.head && f.head.attachShadow && n.default.customElements && void 0 === n.default.customElements.get("input-mask")) {
                var p = function (t) {
                    ! function (t, e) {
                        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                        t.prototype = Object.create(e && e.prototype, {
                            constructor: {
                                value: t,
                                writable: !0,
                                configurable: !0
                            }
                        }), e && u(t, e)
                    }(r, t);
                    var e, i, n = (e = r, i = c(), function () {
                        var t, n = h(e);
                        if (i) {
                            var l = h(this).constructor;
                            t = Reflect.construct(n, arguments, l)
                        } else t = n.apply(this, arguments);
                        return a(this, t)
                    });

                    function r() {
                        var t;
                        ! function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                        }(this, r);
                        var e = (t = n.call(this)).getAttributeNames(),
                            i = t.attachShadow({
                                mode: "closed"
                            }),
                            a = f.createElement("input");
                        for (var o in a.type = "text", i.appendChild(a), e) Object.prototype.hasOwnProperty.call(e, o) && a.setAttribute(e[o], t.getAttribute(e[o]));
                        var s = new l.default;
                        return s.dataAttribute = "", s.mask(a), a.inputmask.shadowRoot = i, t
                    }
                    return r
                }(o(HTMLElement));
                n.default.customElements.define("input-mask", p)
            }
        }], installedModules = {}, __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (t, e, i) {
            __webpack_require__.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: i
            })
        }, __webpack_require__.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            })
        }, __webpack_require__.t = function (t, e) {
            if (1 & e && (t = __webpack_require__(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var i = Object.create(null);
            if (__webpack_require__.r(i), Object.defineProperty(i, "default", {
                    enumerable: !0,
                    value: t
                }), 2 & e && "string" != typeof t)
                for (var n in t) __webpack_require__.d(i, n, function (e) {
                    return t[e]
                }.bind(null, n));
            return i
        }, __webpack_require__.n = function (t) {
            var e = t && t.__esModule ? function () {
                return t.default
            } : function () {
                return t
            };
            return __webpack_require__.d(e, "a", e), e
        }, __webpack_require__.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 15);

        function __webpack_require__(t) {
            if (installedModules[t]) return installedModules[t].exports;
            var e = installedModules[t] = {
                i: t,
                l: !1,
                exports: {}
            };
            return modules[t].call(e.exports, e, e.exports, __webpack_require__), e.l = !0, e.exports
        }
        var modules, installedModules
    }, module.exports = factory()
}, function (t, e, i) {
    i(5)(i(212))
}, function (t, e) {
    t.exports = '/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.Quill=e():t.Quill=e()}("undefined"!=typeof self?self:this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=45)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(17),o=n(18),i=n(19),l=n(48),a=n(49),s=n(50),u=n(51),c=n(52),f=n(11),h=n(29),p=n(30),d=n(28),y=n(1),v={Scope:y.Scope,create:y.create,find:y.find,query:y.query,register:y.register,Container:r.default,Format:o.default,Leaf:i.default,Embed:u.default,Scroll:l.default,Block:s.default,Inline:a.default,Text:c.default,Attributor:{Attribute:f.default,Class:h.default,Style:p.default,Store:d.default}};e.default=v},function(t,e,n){"use strict";function r(t,e){var n=i(t);if(null==n)throw new s("Unable to create "+t+" blot");var r=n;return new r(t instanceof Node||t.nodeType===Node.TEXT_NODE?t:r.create(e),e)}function o(t,n){return void 0===n&&(n=!1),null==t?null:null!=t[e.DATA_KEY]?t[e.DATA_KEY].blot:n?o(t.parentNode,n):null}function i(t,e){void 0===e&&(e=p.ANY);var n;if("string"==typeof t)n=h[t]||u[t];else if(t instanceof Text||t.nodeType===Node.TEXT_NODE)n=h.text;else if("number"==typeof t)t&p.LEVEL&p.BLOCK?n=h.block:t&p.LEVEL&p.INLINE&&(n=h.inline);else if(t instanceof HTMLElement){var r=(t.getAttribute("class")||"").split(/\\s+/);for(var o in r)if(n=c[r[o]])break;n=n||f[t.tagName]}return null==n?null:e&p.LEVEL&n.scope&&e&p.TYPE&n.scope?n:null}function l(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if(t.length>1)return t.map(function(t){return l(t)});var n=t[0];if("string"!=typeof n.blotName&&"string"!=typeof n.attrName)throw new s("Invalid definition");if("abstract"===n.blotName)throw new s("Cannot register abstract class");if(h[n.blotName||n.attrName]=n,"string"==typeof n.keyName)u[n.keyName]=n;else if(null!=n.className&&(c[n.className]=n),null!=n.tagName){Array.isArray(n.tagName)?n.tagName=n.tagName.map(function(t){return t.toUpperCase()}):n.tagName=n.tagName.toUpperCase();var r=Array.isArray(n.tagName)?n.tagName:[n.tagName];r.forEach(function(t){null!=f[t]&&null!=n.className||(f[t]=n)})}return n}var a=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var s=function(t){function e(e){var n=this;return e="[Parchment] "+e,n=t.call(this,e)||this,n.message=e,n.name=n.constructor.name,n}return a(e,t),e}(Error);e.ParchmentError=s;var u={},c={},f={},h={};e.DATA_KEY="__blot";var p;!function(t){t[t.TYPE=3]="TYPE",t[t.LEVEL=12]="LEVEL",t[t.ATTRIBUTE=13]="ATTRIBUTE",t[t.BLOT=14]="BLOT",t[t.INLINE=7]="INLINE",t[t.BLOCK=11]="BLOCK",t[t.BLOCK_BLOT=10]="BLOCK_BLOT",t[t.INLINE_BLOT=6]="INLINE_BLOT",t[t.BLOCK_ATTRIBUTE=9]="BLOCK_ATTRIBUTE",t[t.INLINE_ATTRIBUTE=5]="INLINE_ATTRIBUTE",t[t.ANY=15]="ANY"}(p=e.Scope||(e.Scope={})),e.create=r,e.find=o,e.query=i,e.register=l},function(t,e){"use strict";var n=Object.prototype.hasOwnProperty,r=Object.prototype.toString,o=Object.defineProperty,i=Object.getOwnPropertyDescriptor,l=function(t){return"function"==typeof Array.isArray?Array.isArray(t):"[object Array]"===r.call(t)},a=function(t){if(!t||"[object Object]"!==r.call(t))return!1;var e=n.call(t,"constructor"),o=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!e&&!o)return!1;var i;for(i in t);return void 0===i||n.call(t,i)},s=function(t,e){o&&"__proto__"===e.name?o(t,e.name,{enumerable:!0,configurable:!0,value:e.newValue,writable:!0}):t[e.name]=e.newValue},u=function(t,e){if("__proto__"===e){if(!n.call(t,e))return;if(i)return i(t,e).value}return t[e]};t.exports=function t(){var e,n,r,o,i,c,f=arguments[0],h=1,p=arguments.length,d=!1;for("boolean"==typeof f&&(d=f,f=arguments[1]||{},h=2),(null==f||"object"!=typeof f&&"function"!=typeof f)&&(f={});h<p;++h)if(null!=(e=arguments[h]))for(n in e)r=u(f,n),o=u(e,n),f!==o&&(d&&o&&(a(o)||(i=l(o)))?(i?(i=!1,c=r&&l(r)?r:[]):c=r&&a(r)?r:{},s(f,{name:n,newValue:t(d,c,o)})):void 0!==o&&s(f,{name:n,newValue:o}));return f}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return null==t?e:("function"==typeof t.formats&&(e=(0,f.default)(e,t.formats())),null==t.parent||"scroll"==t.parent.blotName||t.parent.statics.scope!==t.statics.scope?e:a(t.parent,e))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BlockEmbed=e.bubbleFormats=void 0;var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},c=n(2),f=r(c),h=n(4),p=r(h),d=n(0),y=r(d),v=n(14),b=r(v),g=n(5),m=r(g),_=n(8),O=r(_),w=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),s(e,[{key:"attach",value:function(){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"attach",this).call(this),this.attributes=new y.default.Attributor.Store(this.domNode)}},{key:"delta",value:function(){return(new p.default).insert(this.value(),(0,f.default)(this.formats(),this.attributes.values()))}},{key:"format",value:function(t,e){var n=y.default.query(t,y.default.Scope.BLOCK_ATTRIBUTE);null!=n&&this.attributes.attribute(n,e)}},{key:"formatAt",value:function(t,e,n,r){this.format(n,r)}},{key:"insertAt",value:function(t,n,r){if("string"==typeof n&&n.endsWith("\\n")){var o=y.default.create(x.blotName);this.parent.insertBefore(o,0===t?this:this.next),o.insertAt(0,n.slice(0,-1))}else u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r)}}]),e}(y.default.Embed);w.scope=y.default.Scope.BLOCK_BLOT;var x=function(t){function e(t){o(this,e);var n=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.cache={},n}return l(e,t),s(e,[{key:"delta",value:function(){return null==this.cache.delta&&(this.cache.delta=this.descendants(y.default.Leaf).reduce(function(t,e){return 0===e.length()?t:t.insert(e.value(),a(e))},new p.default).insert("\\n",a(this))),this.cache.delta}},{key:"deleteAt",value:function(t,n){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"deleteAt",this).call(this,t,n),this.cache={}}},{key:"formatAt",value:function(t,n,r,o){n<=0||(y.default.query(r,y.default.Scope.BLOCK)?t+n===this.length()&&this.format(r,o):u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,Math.min(n,this.length()-t-1),r,o),this.cache={})}},{key:"insertAt",value:function(t,n,r){if(null!=r)return u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r);if(0!==n.length){var o=n.split("\\n"),i=o.shift();i.length>0&&(t<this.length()-1||null==this.children.tail?u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,Math.min(t,this.length()-1),i):this.children.tail.insertAt(this.children.tail.length(),i),this.cache={});var l=this;o.reduce(function(t,e){return l=l.split(t,!0),l.insertAt(0,e),e.length},t+i.length)}}},{key:"insertBefore",value:function(t,n){var r=this.children.head;u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n),r instanceof b.default&&r.remove(),this.cache={}}},{key:"length",value:function(){return null==this.cache.length&&(this.cache.length=u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"length",this).call(this)+1),this.cache.length}},{key:"moveChildren",value:function(t,n){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"moveChildren",this).call(this,t,n),this.cache={}}},{key:"optimize",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.cache={}}},{key:"path",value:function(t){return u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"path",this).call(this,t,!0)}},{key:"removeChild",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"removeChild",this).call(this,t),this.cache={}}},{key:"split",value:function(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(n&&(0===t||t>=this.length()-1)){var r=this.clone();return 0===t?(this.parent.insertBefore(r,this),this):(this.parent.insertBefore(r,this.next),r)}var o=u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"split",this).call(this,t,n);return this.cache={},o}}]),e}(y.default.Block);x.blotName="block",x.tagName="P",x.defaultChild="break",x.allowedChildren=[m.default,y.default.Embed,O.default],e.bubbleFormats=a,e.BlockEmbed=w,e.default=x},function(t,e,n){var r=n(54),o=n(12),i=n(2),l=n(20),a=String.fromCharCode(0),s=function(t){Array.isArray(t)?this.ops=t:null!=t&&Array.isArray(t.ops)?this.ops=t.ops:this.ops=[]};s.prototype.insert=function(t,e){var n={};return 0===t.length?this:(n.insert=t,null!=e&&"object"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n))},s.prototype.delete=function(t){return t<=0?this:this.push({delete:t})},s.prototype.retain=function(t,e){if(t<=0)return this;var n={retain:t};return null!=e&&"object"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n)},s.prototype.push=function(t){var e=this.ops.length,n=this.ops[e-1];if(t=i(!0,{},t),"object"==typeof n){if("number"==typeof t.delete&&"number"==typeof n.delete)return this.ops[e-1]={delete:n.delete+t.delete},this;if("number"==typeof n.delete&&null!=t.insert&&(e-=1,"object"!=typeof(n=this.ops[e-1])))return this.ops.unshift(t),this;if(o(t.attributes,n.attributes)){if("string"==typeof t.insert&&"string"==typeof n.insert)return this.ops[e-1]={insert:n.insert+t.insert},"object"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this;if("number"==typeof t.retain&&"number"==typeof n.retain)return this.ops[e-1]={retain:n.retain+t.retain},"object"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this}}return e===this.ops.length?this.ops.push(t):this.ops.splice(e,0,t),this},s.prototype.chop=function(){var t=this.ops[this.ops.length-1];return t&&t.retain&&!t.attributes&&this.ops.pop(),this},s.prototype.filter=function(t){return this.ops.filter(t)},s.prototype.forEach=function(t){this.ops.forEach(t)},s.prototype.map=function(t){return this.ops.map(t)},s.prototype.partition=function(t){var e=[],n=[];return this.forEach(function(r){(t(r)?e:n).push(r)}),[e,n]},s.prototype.reduce=function(t,e){return this.ops.reduce(t,e)},s.prototype.changeLength=function(){return this.reduce(function(t,e){return e.insert?t+l.length(e):e.delete?t-e.delete:t},0)},s.prototype.length=function(){return this.reduce(function(t,e){return t+l.length(e)},0)},s.prototype.slice=function(t,e){t=t||0,"number"!=typeof e&&(e=1/0);for(var n=[],r=l.iterator(this.ops),o=0;o<e&&r.hasNext();){var i;o<t?i=r.next(t-o):(i=r.next(e-o),n.push(i)),o+=l.length(i)}return new s(n)},s.prototype.compose=function(t){var e=l.iterator(this.ops),n=l.iterator(t.ops),r=[],i=n.peek();if(null!=i&&"number"==typeof i.retain&&null==i.attributes){for(var a=i.retain;"insert"===e.peekType()&&e.peekLength()<=a;)a-=e.peekLength(),r.push(e.next());i.retain-a>0&&n.next(i.retain-a)}for(var u=new s(r);e.hasNext()||n.hasNext();)if("insert"===n.peekType())u.push(n.next());else if("delete"===e.peekType())u.push(e.next());else{var c=Math.min(e.peekLength(),n.peekLength()),f=e.next(c),h=n.next(c);if("number"==typeof h.retain){var p={};"number"==typeof f.retain?p.retain=c:p.insert=f.insert;var d=l.attributes.compose(f.attributes,h.attributes,"number"==typeof f.retain);if(d&&(p.attributes=d),u.push(p),!n.hasNext()&&o(u.ops[u.ops.length-1],p)){var y=new s(e.rest());return u.concat(y).chop()}}else"number"==typeof h.delete&&"number"==typeof f.retain&&u.push(h)}return u.chop()},s.prototype.concat=function(t){var e=new s(this.ops.slice());return t.ops.length>0&&(e.push(t.ops[0]),e.ops=e.ops.concat(t.ops.slice(1))),e},s.prototype.diff=function(t,e){if(this.ops===t.ops)return new s;var n=[this,t].map(function(e){return e.map(function(n){if(null!=n.insert)return"string"==typeof n.insert?n.insert:a;var r=e===t?"on":"with";throw new Error("diff() called "+r+" non-document")}).join("")}),i=new s,u=r(n[0],n[1],e),c=l.iterator(this.ops),f=l.iterator(t.ops);return u.forEach(function(t){for(var e=t[1].length;e>0;){var n=0;switch(t[0]){case r.INSERT:n=Math.min(f.peekLength(),e),i.push(f.next(n));break;case r.DELETE:n=Math.min(e,c.peekLength()),c.next(n),i.delete(n);break;case r.EQUAL:n=Math.min(c.peekLength(),f.peekLength(),e);var a=c.next(n),s=f.next(n);o(a.insert,s.insert)?i.retain(n,l.attributes.diff(a.attributes,s.attributes)):i.push(s).delete(n)}e-=n}}),i.chop()},s.prototype.eachLine=function(t,e){e=e||"\\n";for(var n=l.iterator(this.ops),r=new s,o=0;n.hasNext();){if("insert"!==n.peekType())return;var i=n.peek(),a=l.length(i)-n.peekLength(),u="string"==typeof i.insert?i.insert.indexOf(e,a)-a:-1;if(u<0)r.push(n.next());else if(u>0)r.push(n.next(u));else{if(!1===t(r,n.next(1).attributes||{},o))return;o+=1,r=new s}}r.length()>0&&t(r,{},o)},s.prototype.transform=function(t,e){if(e=!!e,"number"==typeof t)return this.transformPosition(t,e);for(var n=l.iterator(this.ops),r=l.iterator(t.ops),o=new s;n.hasNext()||r.hasNext();)if("insert"!==n.peekType()||!e&&"insert"===r.peekType())if("insert"===r.peekType())o.push(r.next());else{var i=Math.min(n.peekLength(),r.peekLength()),a=n.next(i),u=r.next(i);if(a.delete)continue;u.delete?o.push(u):o.retain(i,l.attributes.transform(a.attributes,u.attributes,e))}else o.retain(l.length(n.next()));return o.chop()},s.prototype.transformPosition=function(t,e){e=!!e;for(var n=l.iterator(this.ops),r=0;n.hasNext()&&r<=t;){var o=n.peekLength(),i=n.peekType();n.next(),"delete"!==i?("insert"===i&&(r<t||!e)&&(t+=o),r+=o):t-=Math.min(o,t-r)}return t},t.exports=s},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(8),c=r(u),f=n(0),h=r(f),p=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),a(e,[{key:"formatAt",value:function(t,n,r,o){if(e.compare(this.statics.blotName,r)<0&&h.default.query(r,h.default.Scope.BLOT)){var i=this.isolate(t,n);o&&i.wrap(r,o)}else s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,n,r,o)}},{key:"optimize",value:function(t){if(s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.parent instanceof e&&e.compare(this.statics.blotName,this.parent.statics.blotName)>0){var n=this.parent.isolate(this.offset(),this.length());this.moveChildren(n),n.wrap(this)}}}],[{key:"compare",value:function(t,n){var r=e.order.indexOf(t),o=e.order.indexOf(n);return r>=0||o>=0?r-o:t===n?0:t<n?-1:1}}]),e}(h.default.Inline);p.allowedChildren=[p,h.default.Embed,c.default],p.order=["cursor","inline","underline","strike","italic","bold","script","link","code"],e.default=p},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(e=(0,N.default)(!0,{container:t,modules:{clipboard:!0,keyboard:!0,history:!0}},e),e.theme&&e.theme!==S.DEFAULTS.theme){if(e.theme=S.import("themes/"+e.theme),null==e.theme)throw new Error("Invalid theme "+e.theme+". Did you register it?")}else e.theme=T.default;var n=(0,N.default)(!0,{},e.theme.DEFAULTS);[n,e].forEach(function(t){t.modules=t.modules||{},Object.keys(t.modules).forEach(function(e){!0===t.modules[e]&&(t.modules[e]={})})});var r=Object.keys(n.modules).concat(Object.keys(e.modules)),o=r.reduce(function(t,e){var n=S.import("modules/"+e);return null==n?P.error("Cannot load "+e+" module. Are you sure you registered it?"):t[e]=n.DEFAULTS||{},t},{});return null!=e.modules&&e.modules.toolbar&&e.modules.toolbar.constructor!==Object&&(e.modules.toolbar={container:e.modules.toolbar}),e=(0,N.default)(!0,{},S.DEFAULTS,{modules:o},n,e),["bounds","container","scrollingContainer"].forEach(function(t){"string"==typeof e[t]&&(e[t]=document.querySelector(e[t]))}),e.modules=Object.keys(e.modules).reduce(function(t,n){return e.modules[n]&&(t[n]=e.modules[n]),t},{}),e}function a(t,e,n,r){if(this.options.strict&&!this.isEnabled()&&e===g.default.sources.USER)return new d.default;var o=null==n?null:this.getSelection(),i=this.editor.delta,l=t();if(null!=o&&(!0===n&&(n=o.index),null==r?o=u(o,l,e):0!==r&&(o=u(o,n,r,e)),this.setSelection(o,g.default.sources.SILENT)),l.length()>0){var a,s=[g.default.events.TEXT_CHANGE,l,i,e];if((a=this.emitter).emit.apply(a,[g.default.events.EDITOR_CHANGE].concat(s)),e!==g.default.sources.SILENT){var c;(c=this.emitter).emit.apply(c,s)}}return l}function s(t,e,n,r,o){var i={};return"number"==typeof t.index&&"number"==typeof t.length?"number"!=typeof e?(o=r,r=n,n=e,e=t.length,t=t.index):(e=t.length,t=t.index):"number"!=typeof e&&(o=r,r=n,n=e,e=0),"object"===(void 0===n?"undefined":c(n))?(i=n,o=r):"string"==typeof n&&(null!=r?i[n]=r:o=n),o=o||g.default.sources.API,[t,e,i,o]}function u(t,e,n,r){if(null==t)return null;var o=void 0,i=void 0;if(e instanceof d.default){var l=[t.index,t.index+t.length].map(function(t){return e.transformPosition(t,r!==g.default.sources.USER)}),a=f(l,2);o=a[0],i=a[1]}else{var s=[t.index,t.index+t.length].map(function(t){return t<e||t===e&&r===g.default.sources.USER?t:n>=0?t+n:Math.max(e,t+n)}),u=f(s,2);o=u[0],i=u[1]}return new x.Range(o,i-o)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.overload=e.expandConfig=void 0;var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},f=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),h=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();n(53);var p=n(4),d=r(p),y=n(57),v=r(y),b=n(9),g=r(b),m=n(7),_=r(m),O=n(0),w=r(O),x=n(22),k=r(x),E=n(2),N=r(E),j=n(10),A=r(j),q=n(32),T=r(q),P=(0,A.default)("quill"),S=function(){function t(e){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(i(this,t),this.options=l(e,r),this.container=this.options.container,null==this.container)return P.error("Invalid Quill container",e);this.options.debug&&t.debug(this.options.debug);var o=this.container.innerHTML.trim();this.container.classList.add("ql-container"),this.container.innerHTML="",this.container.__quill=this,this.root=this.addContainer("ql-editor"),this.root.classList.add("ql-blank"),this.root.setAttribute("data-gramm",!1),this.scrollingContainer=this.options.scrollingContainer||this.root,this.emitter=new g.default,this.scroll=w.default.create(this.root,{emitter:this.emitter,whitelist:this.options.formats}),this.editor=new v.default(this.scroll),this.selection=new k.default(this.scroll,this.emitter),this.theme=new this.options.theme(this,this.options),this.keyboard=this.theme.addModule("keyboard"),this.clipboard=this.theme.addModule("clipboard"),this.history=this.theme.addModule("history"),this.theme.init(),this.emitter.on(g.default.events.EDITOR_CHANGE,function(t){t===g.default.events.TEXT_CHANGE&&n.root.classList.toggle("ql-blank",n.editor.isBlank())}),this.emitter.on(g.default.events.SCROLL_UPDATE,function(t,e){var r=n.selection.lastRange,o=r&&0===r.length?r.index:void 0;a.call(n,function(){return n.editor.update(null,e,o)},t)});var s=this.clipboard.convert("<div class=\'ql-editor\' style=\\"white-space: normal;\\">"+o+"<p><br></p></div>");this.setContents(s),this.history.clear(),this.options.placeholder&&this.root.setAttribute("data-placeholder",this.options.placeholder),this.options.readOnly&&this.disable()}return h(t,null,[{key:"debug",value:function(t){!0===t&&(t="log"),A.default.level(t)}},{key:"find",value:function(t){return t.__quill||w.default.find(t)}},{key:"import",value:function(t){return null==this.imports[t]&&P.error("Cannot import "+t+". Are you sure it was registered?"),this.imports[t]}},{key:"register",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if("string"!=typeof t){var o=t.attrName||t.blotName;"string"==typeof o?this.register("formats/"+o,t,e):Object.keys(t).forEach(function(r){n.register(r,t[r],e)})}else null==this.imports[t]||r||P.warn("Overwriting "+t+" with",e),this.imports[t]=e,(t.startsWith("blots/")||t.startsWith("formats/"))&&"abstract"!==e.blotName?w.default.register(e):t.startsWith("modules")&&"function"==typeof e.register&&e.register()}}]),h(t,[{key:"addContainer",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if("string"==typeof t){var n=t;t=document.createElement("div"),t.classList.add(n)}return this.container.insertBefore(t,e),t}},{key:"blur",value:function(){this.selection.setRange(null)}},{key:"deleteText",value:function(t,e,n){var r=this,o=s(t,e,n),i=f(o,4);return t=i[0],e=i[1],n=i[3],a.call(this,function(){return r.editor.deleteText(t,e)},n,t,-1*e)}},{key:"disable",value:function(){this.enable(!1)}},{key:"enable",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.scroll.enable(t),this.container.classList.toggle("ql-disabled",!t)}},{key:"focus",value:function(){var t=this.scrollingContainer.scrollTop;this.selection.focus(),this.scrollingContainer.scrollTop=t,this.scrollIntoView()}},{key:"format",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:g.default.sources.API;return a.call(this,function(){var r=n.getSelection(!0),i=new d.default;if(null==r)return i;if(w.default.query(t,w.default.Scope.BLOCK))i=n.editor.formatLine(r.index,r.length,o({},t,e));else{if(0===r.length)return n.selection.format(t,e),i;i=n.editor.formatText(r.index,r.length,o({},t,e))}return n.setSelection(r,g.default.sources.SILENT),i},r)}},{key:"formatLine",value:function(t,e,n,r,o){var i=this,l=void 0,u=s(t,e,n,r,o),c=f(u,4);return t=c[0],e=c[1],l=c[2],o=c[3],a.call(this,function(){return i.editor.formatLine(t,e,l)},o,t,0)}},{key:"formatText",value:function(t,e,n,r,o){var i=this,l=void 0,u=s(t,e,n,r,o),c=f(u,4);return t=c[0],e=c[1],l=c[2],o=c[3],a.call(this,function(){return i.editor.formatText(t,e,l)},o,t,0)}},{key:"getBounds",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=void 0;n="number"==typeof t?this.selection.getBounds(t,e):this.selection.getBounds(t.index,t.length);var r=this.container.getBoundingClientRect();return{bottom:n.bottom-r.top,height:n.height,left:n.left-r.left,right:n.right-r.left,top:n.top-r.top,width:n.width}}},{key:"getContents",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=s(t,e),r=f(n,2);return t=r[0],e=r[1],this.editor.getContents(t,e)}},{key:"getFormat",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.getSelection(!0),e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return"number"==typeof t?this.editor.getFormat(t,e):this.editor.getFormat(t.index,t.length)}},{key:"getIndex",value:function(t){return t.offset(this.scroll)}},{key:"getLength",value:function(){return this.scroll.length()}},{key:"getLeaf",value:function(t){return this.scroll.leaf(t)}},{key:"getLine",value:function(t){return this.scroll.line(t)}},{key:"getLines",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE;return"number"!=typeof t?this.scroll.lines(t.index,t.length):this.scroll.lines(t,e)}},{key:"getModule",value:function(t){return this.theme.modules[t]}},{key:"getSelection",value:function(){return arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&this.focus(),this.update(),this.selection.getRange()[0]}},{key:"getText",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=s(t,e),r=f(n,2);return t=r[0],e=r[1],this.editor.getText(t,e)}},{key:"hasFocus",value:function(){return this.selection.hasFocus()}},{key:"insertEmbed",value:function(e,n,r){var o=this,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:t.sources.API;return a.call(this,function(){return o.editor.insertEmbed(e,n,r)},i,e)}},{key:"insertText",value:function(t,e,n,r,o){var i=this,l=void 0,u=s(t,0,n,r,o),c=f(u,4);return t=c[0],l=c[2],o=c[3],a.call(this,function(){return i.editor.insertText(t,e,l)},o,t,e.length)}},{key:"isEnabled",value:function(){return!this.container.classList.contains("ql-disabled")}},{key:"off",value:function(){return this.emitter.off.apply(this.emitter,arguments)}},{key:"on",value:function(){return this.emitter.on.apply(this.emitter,arguments)}},{key:"once",value:function(){return this.emitter.once.apply(this.emitter,arguments)}},{key:"pasteHTML",value:function(t,e,n){this.clipboard.dangerouslyPasteHTML(t,e,n)}},{key:"removeFormat",value:function(t,e,n){var r=this,o=s(t,e,n),i=f(o,4);return t=i[0],e=i[1],n=i[3],a.call(this,function(){return r.editor.removeFormat(t,e)},n,t)}},{key:"scrollIntoView",value:function(){this.selection.scrollIntoView(this.scrollingContainer)}},{key:"setContents",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:g.default.sources.API;return a.call(this,function(){t=new d.default(t);var n=e.getLength(),r=e.editor.deleteText(0,n),o=e.editor.applyDelta(t),i=o.ops[o.ops.length-1];return null!=i&&"string"==typeof i.insert&&"\\n"===i.insert[i.insert.length-1]&&(e.editor.deleteText(e.getLength()-1,1),o.delete(1)),r.compose(o)},n)}},{key:"setSelection",value:function(e,n,r){if(null==e)this.selection.setRange(null,n||t.sources.API);else{var o=s(e,n,r),i=f(o,4);e=i[0],n=i[1],r=i[3],this.selection.setRange(new x.Range(e,n),r),r!==g.default.sources.SILENT&&this.selection.scrollIntoView(this.scrollingContainer)}}},{key:"setText",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:g.default.sources.API,n=(new d.default).insert(t);return this.setContents(n,e)}},{key:"update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:g.default.sources.USER,e=this.scroll.update(t);return this.selection.update(t),e}},{key:"updateContents",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:g.default.sources.API;return a.call(this,function(){return t=new d.default(t),e.editor.applyDelta(t,n)},n,!0)}}]),t}();S.DEFAULTS={bounds:null,formats:null,modules:{},placeholder:"",readOnly:!1,scrollingContainer:null,strict:!0,theme:"default"},S.events=g.default.events,S.sources=g.default.sources,S.version="1.3.7",S.imports={delta:d.default,parchment:w.default,"core/module":_.default,"core/theme":T.default},e.expandConfig=l,e.overload=s,e.default=S},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};r(this,t),this.quill=e,this.options=n};o.DEFAULTS={},e.default=o},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(0),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default.Text);e.default=s},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(58),c=r(u),f=n(10),h=r(f),p=(0,h.default)("quill:events");["selectionchange","mousedown","mouseup","click"].forEach(function(t){document.addEventListener(t,function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];[].slice.call(document.querySelectorAll(".ql-container")).forEach(function(t){if(t.__quill&&t.__quill.emitter){var n;(n=t.__quill.emitter).handleDOM.apply(n,e)}})})});var d=function(t){function e(){o(this,e);var t=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t.listeners={},t.on("error",p.error),t}return l(e,t),a(e,[{key:"emit",value:function(){p.log.apply(p,arguments),s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"emit",this).apply(this,arguments)}},{key:"handleDOM",value:function(t){for(var e=arguments.length,n=Array(e>1?e-1:0),r=1;r<e;r++)n[r-1]=arguments[r];(this.listeners[t.type]||[]).forEach(function(e){var r=e.node,o=e.handler;(t.target===r||r.contains(t.target))&&o.apply(void 0,[t].concat(n))})}},{key:"listenDOM",value:function(t,e,n){this.listeners[t]||(this.listeners[t]=[]),this.listeners[t].push({node:e,handler:n})}}]),e}(c.default);d.events={EDITOR_CHANGE:"editor-change",SCROLL_BEFORE_UPDATE:"scroll-before-update",SCROLL_OPTIMIZE:"scroll-optimize",SCROLL_UPDATE:"scroll-update",SELECTION_CHANGE:"selection-change",TEXT_CHANGE:"text-change"},d.sources={API:"api",SILENT:"silent",USER:"user"},e.default=d},function(t,e,n){"use strict";function r(t){if(i.indexOf(t)<=i.indexOf(l)){for(var e,n=arguments.length,r=Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];(e=console)[t].apply(e,r)}}function o(t){return i.reduce(function(e,n){return e[n]=r.bind(console,n,t),e},{})}Object.defineProperty(e,"__esModule",{value:!0});var i=["error","warn","log","info"],l="warn";r.level=o.level=function(t){l=t},e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(1),o=function(){function t(t,e,n){void 0===n&&(n={}),this.attrName=t,this.keyName=e;var o=r.Scope.TYPE&r.Scope.ATTRIBUTE;null!=n.scope?this.scope=n.scope&r.Scope.LEVEL|o:this.scope=r.Scope.ATTRIBUTE,null!=n.whitelist&&(this.whitelist=n.whitelist)}return t.keys=function(t){return[].map.call(t.attributes,function(t){return t.name})},t.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.setAttribute(this.keyName,e),!0)},t.prototype.canAdd=function(t,e){return null!=r.query(t,r.Scope.BLOT&(this.scope|r.Scope.TYPE))&&(null==this.whitelist||("string"==typeof e?this.whitelist.indexOf(e.replace(/["\']/g,""))>-1:this.whitelist.indexOf(e)>-1))},t.prototype.remove=function(t){t.removeAttribute(this.keyName)},t.prototype.value=function(t){var e=t.getAttribute(this.keyName);return this.canAdd(t,e)&&e?e:""},t}();e.default=o},function(t,e,n){function r(t){return null===t||void 0===t}function o(t){return!(!t||"object"!=typeof t||"number"!=typeof t.length)&&("function"==typeof t.copy&&"function"==typeof t.slice&&!(t.length>0&&"number"!=typeof t[0]))}function i(t,e,n){var i,c;if(r(t)||r(e))return!1;if(t.prototype!==e.prototype)return!1;if(s(t))return!!s(e)&&(t=l.call(t),e=l.call(e),u(t,e,n));if(o(t)){if(!o(e))return!1;if(t.length!==e.length)return!1;for(i=0;i<t.length;i++)if(t[i]!==e[i])return!1;return!0}try{var f=a(t),h=a(e)}catch(t){return!1}if(f.length!=h.length)return!1;for(f.sort(),h.sort(),i=f.length-1;i>=0;i--)if(f[i]!=h[i])return!1;for(i=f.length-1;i>=0;i--)if(c=f[i],!u(t[c],e[c],n))return!1;return typeof t==typeof e}var l=Array.prototype.slice,a=n(55),s=n(56),u=t.exports=function(t,e,n){return n||(n={}),t===e||(t instanceof Date&&e instanceof Date?t.getTime()===e.getTime():!t||!e||"object"!=typeof t&&"object"!=typeof e?n.strict?t===e:t==e:i(t,e,n))}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.Code=void 0;var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},c=n(4),f=r(c),h=n(0),p=r(h),d=n(3),y=r(d),v=n(5),b=r(v),g=n(8),m=r(g),_=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),e}(b.default);_.blotName="code",_.tagName="CODE";var O=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),s(e,[{key:"delta",value:function(){var t=this,e=this.domNode.textContent;return e.endsWith("\\n")&&(e=e.slice(0,-1)),e.split("\\n").reduce(function(e,n){return e.insert(n).insert("\\n",t.formats())},new f.default)}},{key:"format",value:function(t,n){if(t!==this.statics.blotName||!n){var r=this.descendant(m.default,this.length()-1),o=a(r,1),i=o[0];null!=i&&i.deleteAt(i.length()-1,1),u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}},{key:"formatAt",value:function(t,n,r,o){if(0!==n&&null!=p.default.query(r,p.default.Scope.BLOCK)&&(r!==this.statics.blotName||o!==this.statics.formats(this.domNode))){var i=this.newlineIndex(t);if(!(i<0||i>=t+n)){var l=this.newlineIndex(t,!0)+1,a=i-l+1,s=this.isolate(l,a),u=s.next;s.format(r,o),u instanceof e&&u.formatAt(0,t-l+n-a,r,o)}}}},{key:"insertAt",value:function(t,e,n){if(null==n){var r=this.descendant(m.default,t),o=a(r,2),i=o[0],l=o[1];i.insertAt(l,e)}}},{key:"length",value:function(){var t=this.domNode.textContent.length;return this.domNode.textContent.endsWith("\\n")?t:t+1}},{key:"newlineIndex",value:function(t){if(arguments.length>1&&void 0!==arguments[1]&&arguments[1])return this.domNode.textContent.slice(0,t).lastIndexOf("\\n");var e=this.domNode.textContent.slice(t).indexOf("\\n");return e>-1?t+e:-1}},{key:"optimize",value:function(t){this.domNode.textContent.endsWith("\\n")||this.appendChild(p.default.create("text","\\n")),u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&this.statics.formats(this.domNode)===n.statics.formats(n.domNode)&&(n.optimize(t),n.moveChildren(this),n.remove())}},{key:"replace",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replace",this).call(this,t),[].slice.call(this.domNode.querySelectorAll("*")).forEach(function(t){var e=p.default.find(t);null==e?t.parentNode.removeChild(t):e instanceof p.default.Embed?e.remove():e.unwrap()})}}],[{key:"create",value:function(t){var n=u(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return n.setAttribute("spellcheck",!1),n}},{key:"formats",value:function(){return!0}}]),e}(y.default);O.blotName="code-block",O.tagName="PRE",O.TAB="  ",e.Code=_,e.default=O},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"insertInto",value:function(t,n){0===t.children.length?a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertInto",this).call(this,t,n):this.remove()}},{key:"length",value:function(){return 0}},{key:"value",value:function(){return""}}],[{key:"value",value:function(){}}]),e}(u.default.Embed);c.blotName="break",c.tagName="BR",e.default=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function l(t,e){var n=document.createElement("a");n.href=t;var r=n.href.slice(0,n.href.indexOf(":"));return e.indexOf(r)>-1}Object.defineProperty(e,"__esModule",{value:!0}),e.sanitize=e.default=void 0;var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(5),c=function(t){return t&&t.__esModule?t:{default:t}}(u),f=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),a(e,[{key:"format",value:function(t,n){if(t!==this.statics.blotName||!n)return s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n);n=this.constructor.sanitize(n),this.domNode.setAttribute("href",n)}}],[{key:"create",value:function(t){var n=s(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return t=this.sanitize(t),n.setAttribute("href",t),n.setAttribute("rel","noopener noreferrer"),n.setAttribute("target","_blank"),n}},{key:"formats",value:function(t){return t.getAttribute("href")}},{key:"sanitize",value:function(t){return l(t,this.PROTOCOL_WHITELIST)?t:this.SANITIZED_URL}}]),e}(c.default);f.blotName="link",f.tagName="A",f.SANITIZED_URL="about:blank",f.PROTOCOL_WHITELIST=["http","https","mailto","tel"],e.default=f,e.sanitize=l},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){t.setAttribute(e,!("true"===t.getAttribute(e)))}Object.defineProperty(e,"__esModule",{value:!0});var l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=n(25),u=r(s),c=n(106),f=r(c),h=0,p=function(){function t(e){var n=this;o(this,t),this.select=e,this.container=document.createElement("span"),this.buildPicker(),this.select.style.display="none",this.select.parentNode.insertBefore(this.container,this.select),this.label.addEventListener("mousedown",function(){n.togglePicker()}),this.label.addEventListener("keydown",function(t){switch(t.keyCode){case u.default.keys.ENTER:n.togglePicker();break;case u.default.keys.ESCAPE:n.escape(),t.preventDefault()}}),this.select.addEventListener("change",this.update.bind(this))}return a(t,[{key:"togglePicker",value:function(){this.container.classList.toggle("ql-expanded"),i(this.label,"aria-expanded"),i(this.options,"aria-hidden")}},{key:"buildItem",value:function(t){var e=this,n=document.createElement("span");return n.tabIndex="0",n.setAttribute("role","button"),n.classList.add("ql-picker-item"),t.hasAttribute("value")&&n.setAttribute("data-value",t.getAttribute("value")),t.textContent&&n.setAttribute("data-label",t.textContent),n.addEventListener("click",function(){e.selectItem(n,!0)}),n.addEventListener("keydown",function(t){switch(t.keyCode){case u.default.keys.ENTER:e.selectItem(n,!0),t.preventDefault();break;case u.default.keys.ESCAPE:e.escape(),t.preventDefault()}}),n}},{key:"buildLabel",value:function(){var t=document.createElement("span");return t.classList.add("ql-picker-label"),t.innerHTML=f.default,t.tabIndex="0",t.setAttribute("role","button"),t.setAttribute("aria-expanded","false"),this.container.appendChild(t),t}},{key:"buildOptions",value:function(){var t=this,e=document.createElement("span");e.classList.add("ql-picker-options"),e.setAttribute("aria-hidden","true"),e.tabIndex="-1",e.id="ql-picker-options-"+h,h+=1,this.label.setAttribute("aria-controls",e.id),this.options=e,[].slice.call(this.select.options).forEach(function(n){var r=t.buildItem(n);e.appendChild(r),!0===n.selected&&t.selectItem(r)}),this.container.appendChild(e)}},{key:"buildPicker",value:function(){var t=this;[].slice.call(this.select.attributes).forEach(function(e){t.container.setAttribute(e.name,e.value)}),this.container.classList.add("ql-picker"),this.label=this.buildLabel(),this.buildOptions()}},{key:"escape",value:function(){var t=this;this.close(),setTimeout(function(){return t.label.focus()},1)}},{key:"close",value:function(){this.container.classList.remove("ql-expanded"),this.label.setAttribute("aria-expanded","false"),this.options.setAttribute("aria-hidden","true")}},{key:"selectItem",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.container.querySelector(".ql-selected");if(t!==n&&(null!=n&&n.classList.remove("ql-selected"),null!=t&&(t.classList.add("ql-selected"),this.select.selectedIndex=[].indexOf.call(t.parentNode.children,t),t.hasAttribute("data-value")?this.label.setAttribute("data-value",t.getAttribute("data-value")):this.label.removeAttribute("data-value"),t.hasAttribute("data-label")?this.label.setAttribute("data-label",t.getAttribute("data-label")):this.label.removeAttribute("data-label"),e))){if("function"==typeof Event)this.select.dispatchEvent(new Event("change"));else if("object"===("undefined"==typeof Event?"undefined":l(Event))){var r=document.createEvent("Event");r.initEvent("change",!0,!0),this.select.dispatchEvent(r)}this.close()}}},{key:"update",value:function(){var t=void 0;if(this.select.selectedIndex>-1){var e=this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];t=this.select.options[this.select.selectedIndex],this.selectItem(e)}else this.selectItem(null);var n=null!=t&&t!==this.select.querySelector("option[selected]");this.label.classList.toggle("ql-active",n)}}]),t}();e.default=p},function(t,e,n){"use strict";function r(t){var e=a.find(t);if(null==e)try{e=a.create(t)}catch(n){e=a.create(a.Scope.INLINE),[].slice.call(t.childNodes).forEach(function(t){e.domNode.appendChild(t)}),t.parentNode&&t.parentNode.replaceChild(e.domNode,t),e.attach()}return e}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var i=n(47),l=n(27),a=n(1),s=function(t){function e(e){var n=t.call(this,e)||this;return n.build(),n}return o(e,t),e.prototype.appendChild=function(t){this.insertBefore(t)},e.prototype.attach=function(){t.prototype.attach.call(this),this.children.forEach(function(t){t.attach()})},e.prototype.build=function(){var t=this;this.children=new i.default,[].slice.call(this.domNode.childNodes).reverse().forEach(function(e){try{var n=r(e);t.insertBefore(n,t.children.head||void 0)}catch(t){if(t instanceof a.ParchmentError)return;throw t}})},e.prototype.deleteAt=function(t,e){if(0===t&&e===this.length())return this.remove();this.children.forEachAt(t,e,function(t,e,n){t.deleteAt(e,n)})},e.prototype.descendant=function(t,n){var r=this.children.find(n),o=r[0],i=r[1];return null==t.blotName&&t(o)||null!=t.blotName&&o instanceof t?[o,i]:o instanceof e?o.descendant(t,i):[null,-1]},e.prototype.descendants=function(t,n,r){void 0===n&&(n=0),void 0===r&&(r=Number.MAX_VALUE);var o=[],i=r;return this.children.forEachAt(n,r,function(n,r,l){(null==t.blotName&&t(n)||null!=t.blotName&&n instanceof t)&&o.push(n),n instanceof e&&(o=o.concat(n.descendants(t,r,i))),i-=l}),o},e.prototype.detach=function(){this.children.forEach(function(t){t.detach()}),t.prototype.detach.call(this)},e.prototype.formatAt=function(t,e,n,r){this.children.forEachAt(t,e,function(t,e,o){t.formatAt(e,o,n,r)})},e.prototype.insertAt=function(t,e,n){var r=this.children.find(t),o=r[0],i=r[1];if(o)o.insertAt(i,e,n);else{var l=null==n?a.create("text",e):a.create(e,n);this.appendChild(l)}},e.prototype.insertBefore=function(t,e){if(null!=this.statics.allowedChildren&&!this.statics.allowedChildren.some(function(e){return t instanceof e}))throw new a.ParchmentError("Cannot insert "+t.statics.blotName+" into "+this.statics.blotName);t.insertInto(this,e)},e.prototype.length=function(){return this.children.reduce(function(t,e){return t+e.length()},0)},e.prototype.moveChildren=function(t,e){this.children.forEach(function(n){t.insertBefore(n,e)})},e.prototype.optimize=function(e){if(t.prototype.optimize.call(this,e),0===this.children.length)if(null!=this.statics.defaultChild){var n=a.create(this.statics.defaultChild);this.appendChild(n),n.optimize(e)}else this.remove()},e.prototype.path=function(t,n){void 0===n&&(n=!1);var r=this.children.find(t,n),o=r[0],i=r[1],l=[[this,t]];return o instanceof e?l.concat(o.path(i,n)):(null!=o&&l.push([o,i]),l)},e.prototype.removeChild=function(t){this.children.remove(t)},e.prototype.replace=function(n){n instanceof e&&n.moveChildren(this),t.prototype.replace.call(this,n)},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=this.clone();return this.parent.insertBefore(n,this.next),this.children.forEachAt(t,this.length(),function(t,r,o){t=t.split(r,e),n.appendChild(t)}),n},e.prototype.unwrap=function(){this.moveChildren(this.parent,this.next),this.remove()},e.prototype.update=function(t,e){var n=this,o=[],i=[];t.forEach(function(t){t.target===n.domNode&&"childList"===t.type&&(o.push.apply(o,t.addedNodes),i.push.apply(i,t.removedNodes))}),i.forEach(function(t){if(!(null!=t.parentNode&&"IFRAME"!==t.tagName&&document.body.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY)){var e=a.find(t);null!=e&&(null!=e.domNode.parentNode&&e.domNode.parentNode!==n.domNode||e.detach())}}),o.filter(function(t){return t.parentNode==n.domNode}).sort(function(t,e){return t===e?0:t.compareDocumentPosition(e)&Node.DOCUMENT_POSITION_FOLLOWING?1:-1}).forEach(function(t){var e=null;null!=t.nextSibling&&(e=a.find(t.nextSibling));var o=r(t);o.next==e&&null!=o.next||(null!=o.parent&&o.parent.removeChild(n),n.insertBefore(o,e||void 0))})},e}(l.default);e.default=s},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(11),i=n(28),l=n(17),a=n(1),s=function(t){function e(e){var n=t.call(this,e)||this;return n.attributes=new i.default(n.domNode),n}return r(e,t),e.formats=function(t){return"string"==typeof this.tagName||(Array.isArray(this.tagName)?t.tagName.toLowerCase():void 0)},e.prototype.format=function(t,e){var n=a.query(t);n instanceof o.default?this.attributes.attribute(n,e):e&&(null==n||t===this.statics.blotName&&this.formats()[t]===e||this.replaceWith(t,e))},e.prototype.formats=function(){var t=this.attributes.values(),e=this.statics.formats(this.domNode);return null!=e&&(t[this.statics.blotName]=e),t},e.prototype.replaceWith=function(e,n){var r=t.prototype.replaceWith.call(this,e,n);return this.attributes.copy(r),r},e.prototype.update=function(e,n){var r=this;t.prototype.update.call(this,e,n),e.some(function(t){return t.target===r.domNode&&"attributes"===t.type})&&this.attributes.build()},e.prototype.wrap=function(n,r){var o=t.prototype.wrap.call(this,n,r);return o instanceof e&&o.statics.scope===this.statics.scope&&this.attributes.move(o),o},e}(l.default);e.default=s},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(27),i=n(1),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return r(e,t),e.value=function(t){return!0},e.prototype.index=function(t,e){return this.domNode===t||this.domNode.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY?Math.min(e,1):-1},e.prototype.position=function(t,e){var n=[].indexOf.call(this.parent.domNode.childNodes,this.domNode);return t>0&&(n+=1),[this.parent.domNode,n]},e.prototype.value=function(){var t;return t={},t[this.statics.blotName]=this.statics.value(this.domNode)||!0,t},e.scope=i.Scope.INLINE_BLOT,e}(o.default);e.default=l},function(t,e,n){function r(t){this.ops=t,this.index=0,this.offset=0}var o=n(12),i=n(2),l={attributes:{compose:function(t,e,n){"object"!=typeof t&&(t={}),"object"!=typeof e&&(e={});var r=i(!0,{},e);n||(r=Object.keys(r).reduce(function(t,e){return null!=r[e]&&(t[e]=r[e]),t},{}));for(var o in t)void 0!==t[o]&&void 0===e[o]&&(r[o]=t[o]);return Object.keys(r).length>0?r:void 0},diff:function(t,e){"object"!=typeof t&&(t={}),"object"!=typeof e&&(e={});var n=Object.keys(t).concat(Object.keys(e)).reduce(function(n,r){return o(t[r],e[r])||(n[r]=void 0===e[r]?null:e[r]),n},{});return Object.keys(n).length>0?n:void 0},transform:function(t,e,n){if("object"!=typeof t)return e;if("object"==typeof e){if(!n)return e;var r=Object.keys(e).reduce(function(n,r){return void 0===t[r]&&(n[r]=e[r]),n},{});return Object.keys(r).length>0?r:void 0}}},iterator:function(t){return new r(t)},length:function(t){return"number"==typeof t.delete?t.delete:"number"==typeof t.retain?t.retain:"string"==typeof t.insert?t.insert.length:1}};r.prototype.hasNext=function(){return this.peekLength()<1/0},r.prototype.next=function(t){t||(t=1/0);var e=this.ops[this.index];if(e){var n=this.offset,r=l.length(e);if(t>=r-n?(t=r-n,this.index+=1,this.offset=0):this.offset+=t,"number"==typeof e.delete)return{delete:t};var o={};return e.attributes&&(o.attributes=e.attributes),"number"==typeof e.retain?o.retain=t:"string"==typeof e.insert?o.insert=e.insert.substr(n,t):o.insert=e.insert,o}return{retain:1/0}},r.prototype.peek=function(){return this.ops[this.index]},r.prototype.peekLength=function(){return this.ops[this.index]?l.length(this.ops[this.index])-this.offset:1/0},r.prototype.peekType=function(){return this.ops[this.index]?"number"==typeof this.ops[this.index].delete?"delete":"number"==typeof this.ops[this.index].retain?"retain":"insert":"retain"},r.prototype.rest=function(){if(this.hasNext()){if(0===this.offset)return this.ops.slice(this.index);var t=this.offset,e=this.index,n=this.next(),r=this.ops.slice(this.index);return this.offset=t,this.index=e,[n].concat(r)}return[]},t.exports=l},function(t,e){var n=function(){"use strict";function t(t,e){return null!=e&&t instanceof e}function e(n,r,o,i,c){function f(n,o){if(null===n)return null;if(0===o)return n;var y,v;if("object"!=typeof n)return n;if(t(n,a))y=new a;else if(t(n,s))y=new s;else if(t(n,u))y=new u(function(t,e){n.then(function(e){t(f(e,o-1))},function(t){e(f(t,o-1))})});else if(e.__isArray(n))y=[];else if(e.__isRegExp(n))y=new RegExp(n.source,l(n)),n.lastIndex&&(y.lastIndex=n.lastIndex);else if(e.__isDate(n))y=new Date(n.getTime());else{if(d&&Buffer.isBuffer(n))return y=Buffer.allocUnsafe?Buffer.allocUnsafe(n.length):new Buffer(n.length),n.copy(y),y;t(n,Error)?y=Object.create(n):void 0===i?(v=Object.getPrototypeOf(n),y=Object.create(v)):(y=Object.create(i),v=i)}if(r){var b=h.indexOf(n);if(-1!=b)return p[b];h.push(n),p.push(y)}t(n,a)&&n.forEach(function(t,e){var n=f(e,o-1),r=f(t,o-1);y.set(n,r)}),t(n,s)&&n.forEach(function(t){var e=f(t,o-1);y.add(e)});for(var g in n){var m;v&&(m=Object.getOwnPropertyDescriptor(v,g)),m&&null==m.set||(y[g]=f(n[g],o-1))}if(Object.getOwnPropertySymbols)for(var _=Object.getOwnPropertySymbols(n),g=0;g<_.length;g++){var O=_[g],w=Object.getOwnPropertyDescriptor(n,O);(!w||w.enumerable||c)&&(y[O]=f(n[O],o-1),w.enumerable||Object.defineProperty(y,O,{enumerable:!1}))}if(c)for(var x=Object.getOwnPropertyNames(n),g=0;g<x.length;g++){var k=x[g],w=Object.getOwnPropertyDescriptor(n,k);w&&w.enumerable||(y[k]=f(n[k],o-1),Object.defineProperty(y,k,{enumerable:!1}))}return y}"object"==typeof r&&(o=r.depth,i=r.prototype,c=r.includeNonEnumerable,r=r.circular);var h=[],p=[],d="undefined"!=typeof Buffer;return void 0===r&&(r=!0),void 0===o&&(o=1/0),f(n,o)}function n(t){return Object.prototype.toString.call(t)}function r(t){return"object"==typeof t&&"[object Date]"===n(t)}function o(t){return"object"==typeof t&&"[object Array]"===n(t)}function i(t){return"object"==typeof t&&"[object RegExp]"===n(t)}function l(t){var e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),e}var a;try{a=Map}catch(t){a=function(){}}var s;try{s=Set}catch(t){s=function(){}}var u;try{u=Promise}catch(t){u=function(){}}return e.clonePrototype=function(t){if(null===t)return null;var e=function(){};return e.prototype=t,new e},e.__objToStr=n,e.__isDate=r,e.__isArray=o,e.__isRegExp=i,e.__getRegExpFlags=l,e}();"object"==typeof t&&t.exports&&(t.exports=n)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){try{e.parentNode}catch(t){return!1}return e instanceof Text&&(e=e.parentNode),t.contains(e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.Range=void 0;var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(0),c=r(u),f=n(21),h=r(f),p=n(12),d=r(p),y=n(9),v=r(y),b=n(10),g=r(b),m=(0,g.default)("quill:selection"),_=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;i(this,t),this.index=e,this.length=n},O=function(){function t(e,n){var r=this;i(this,t),this.emitter=n,this.scroll=e,this.composing=!1,this.mouseDown=!1,this.root=this.scroll.domNode,this.cursor=c.default.create("cursor",this),this.lastRange=this.savedRange=new _(0,0),this.handleComposition(),this.handleDragging(),this.emitter.listenDOM("selectionchange",document,function(){r.mouseDown||setTimeout(r.update.bind(r,v.default.sources.USER),1)}),this.emitter.on(v.default.events.EDITOR_CHANGE,function(t,e){t===v.default.events.TEXT_CHANGE&&e.length()>0&&r.update(v.default.sources.SILENT)}),this.emitter.on(v.default.events.SCROLL_BEFORE_UPDATE,function(){if(r.hasFocus()){var t=r.getNativeRange();null!=t&&t.start.node!==r.cursor.textNode&&r.emitter.once(v.default.events.SCROLL_UPDATE,function(){try{r.setNativeRange(t.start.node,t.start.offset,t.end.node,t.end.offset)}catch(t){}})}}),this.emitter.on(v.default.events.SCROLL_OPTIMIZE,function(t,e){if(e.range){var n=e.range,o=n.startNode,i=n.startOffset,l=n.endNode,a=n.endOffset;r.setNativeRange(o,i,l,a)}}),this.update(v.default.sources.SILENT)}return s(t,[{key:"handleComposition",value:function(){var t=this;this.root.addEventListener("compositionstart",function(){t.composing=!0}),this.root.addEventListener("compositionend",function(){if(t.composing=!1,t.cursor.parent){var e=t.cursor.restore();if(!e)return;setTimeout(function(){t.setNativeRange(e.startNode,e.startOffset,e.endNode,e.endOffset)},1)}})}},{key:"handleDragging",value:function(){var t=this;this.emitter.listenDOM("mousedown",document.body,function(){t.mouseDown=!0}),this.emitter.listenDOM("mouseup",document.body,function(){t.mouseDown=!1,t.update(v.default.sources.USER)})}},{key:"focus",value:function(){this.hasFocus()||(this.root.focus(),this.setRange(this.savedRange))}},{key:"format",value:function(t,e){if(null==this.scroll.whitelist||this.scroll.whitelist[t]){this.scroll.update();var n=this.getNativeRange();if(null!=n&&n.native.collapsed&&!c.default.query(t,c.default.Scope.BLOCK)){if(n.start.node!==this.cursor.textNode){var r=c.default.find(n.start.node,!1);if(null==r)return;if(r instanceof c.default.Leaf){var o=r.split(n.start.offset);r.parent.insertBefore(this.cursor,o)}else r.insertBefore(this.cursor,n.start.node);this.cursor.attach()}this.cursor.format(t,e),this.scroll.optimize(),this.setNativeRange(this.cursor.textNode,this.cursor.textNode.data.length),this.update()}}}},{key:"getBounds",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=this.scroll.length();t=Math.min(t,n-1),e=Math.min(t+e,n-1)-t;var r=void 0,o=this.scroll.leaf(t),i=a(o,2),l=i[0],s=i[1];if(null==l)return null;var u=l.position(s,!0),c=a(u,2);r=c[0],s=c[1];var f=document.createRange();if(e>0){f.setStart(r,s);var h=this.scroll.leaf(t+e),p=a(h,2);if(l=p[0],s=p[1],null==l)return null;var d=l.position(s,!0),y=a(d,2);return r=y[0],s=y[1],f.setEnd(r,s),f.getBoundingClientRect()}var v="left",b=void 0;return r instanceof Text?(s<r.data.length?(f.setStart(r,s),f.setEnd(r,s+1)):(f.setStart(r,s-1),f.setEnd(r,s),v="right"),b=f.getBoundingClientRect()):(b=l.domNode.getBoundingClientRect(),s>0&&(v="right")),{bottom:b.top+b.height,height:b.height,left:b[v],right:b[v],top:b.top,width:0}}},{key:"getNativeRange",value:function(){var t=document.getSelection();if(null==t||t.rangeCount<=0)return null;var e=t.getRangeAt(0);if(null==e)return null;var n=this.normalizeNative(e);return m.info("getNativeRange",n),n}},{key:"getRange",value:function(){var t=this.getNativeRange();return null==t?[null,null]:[this.normalizedToRange(t),t]}},{key:"hasFocus",value:function(){return document.activeElement===this.root}},{key:"normalizedToRange",value:function(t){var e=this,n=[[t.start.node,t.start.offset]];t.native.collapsed||n.push([t.end.node,t.end.offset]);var r=n.map(function(t){var n=a(t,2),r=n[0],o=n[1],i=c.default.find(r,!0),l=i.offset(e.scroll);return 0===o?l:i instanceof c.default.Container?l+i.length():l+i.index(r,o)}),i=Math.min(Math.max.apply(Math,o(r)),this.scroll.length()-1),l=Math.min.apply(Math,[i].concat(o(r)));return new _(l,i-l)}},{key:"normalizeNative",value:function(t){if(!l(this.root,t.startContainer)||!t.collapsed&&!l(this.root,t.endContainer))return null;var e={start:{node:t.startContainer,offset:t.startOffset},end:{node:t.endContainer,offset:t.endOffset},native:t};return[e.start,e.end].forEach(function(t){for(var e=t.node,n=t.offset;!(e instanceof Text)&&e.childNodes.length>0;)if(e.childNodes.length>n)e=e.childNodes[n],n=0;else{if(e.childNodes.length!==n)break;e=e.lastChild,n=e instanceof Text?e.data.length:e.childNodes.length+1}t.node=e,t.offset=n}),e}},{key:"rangeToNative",value:function(t){var e=this,n=t.collapsed?[t.index]:[t.index,t.index+t.length],r=[],o=this.scroll.length();return n.forEach(function(t,n){t=Math.min(o-1,t);var i=void 0,l=e.scroll.leaf(t),s=a(l,2),u=s[0],c=s[1],f=u.position(c,0!==n),h=a(f,2);i=h[0],c=h[1],r.push(i,c)}),r.length<2&&(r=r.concat(r)),r}},{key:"scrollIntoView",value:function(t){var e=this.lastRange;if(null!=e){var n=this.getBounds(e.index,e.length);if(null!=n){var r=this.scroll.length()-1,o=this.scroll.line(Math.min(e.index,r)),i=a(o,1),l=i[0],s=l;if(e.length>0){var u=this.scroll.line(Math.min(e.index+e.length,r));s=a(u,1)[0]}if(null!=l&&null!=s){var c=t.getBoundingClientRect();n.top<c.top?t.scrollTop-=c.top-n.top:n.bottom>c.bottom&&(t.scrollTop+=n.bottom-c.bottom)}}}}},{key:"setNativeRange",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:e,o=arguments.length>4&&void 0!==arguments[4]&&arguments[4];if(m.info("setNativeRange",t,e,n,r),null==t||null!=this.root.parentNode&&null!=t.parentNode&&null!=n.parentNode){var i=document.getSelection();if(null!=i)if(null!=t){this.hasFocus()||this.root.focus();var l=(this.getNativeRange()||{}).native;if(null==l||o||t!==l.startContainer||e!==l.startOffset||n!==l.endContainer||r!==l.endOffset){"BR"==t.tagName&&(e=[].indexOf.call(t.parentNode.childNodes,t),t=t.parentNode),"BR"==n.tagName&&(r=[].indexOf.call(n.parentNode.childNodes,n),n=n.parentNode);var a=document.createRange();a.setStart(t,e),a.setEnd(n,r),i.removeAllRanges(),i.addRange(a)}}else i.removeAllRanges(),this.root.blur(),document.body.focus()}}},{key:"setRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:v.default.sources.API;if("string"==typeof e&&(n=e,e=!1),m.info("setRange",t),null!=t){var r=this.rangeToNative(t);this.setNativeRange.apply(this,o(r).concat([e]))}else this.setNativeRange(null);this.update(n)}},{key:"update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v.default.sources.USER,e=this.lastRange,n=this.getRange(),r=a(n,2),o=r[0],i=r[1];if(this.lastRange=o,null!=this.lastRange&&(this.savedRange=this.lastRange),!(0,d.default)(e,this.lastRange)){var l;!this.composing&&null!=i&&i.native.collapsed&&i.start.node!==this.cursor.textNode&&this.cursor.restore();var s=[v.default.events.SELECTION_CHANGE,(0,h.default)(this.lastRange),(0,h.default)(e),t];if((l=this.emitter).emit.apply(l,[v.default.events.EDITOR_CHANGE].concat(s)),t!==v.default.sources.SILENT){var u;(u=this.emitter).emit.apply(u,s)}}}}]),t}();e.Range=_,e.default=O},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(0),s=r(a),u=n(3),c=r(u),f=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),e}(s.default.Container);f.allowedChildren=[c.default,u.BlockEmbed,f],e.default=f},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.ColorStyle=e.ColorClass=e.ColorAttributor=void 0;var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"value",value:function(t){var n=a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t);return n.startsWith("rgb(")?(n=n.replace(/^[^\\d]+/,"").replace(/[^\\d]+$/,""),"#"+n.split(",").map(function(t){return("00"+parseInt(t).toString(16)).slice(-2)}).join("")):n}}]),e}(u.default.Attributor.Style),f=new u.default.Attributor.Class("color","ql-color",{scope:u.default.Scope.INLINE}),h=new c("color","color",{scope:u.default.Scope.INLINE});e.ColorAttributor=c,e.ColorClass=f,e.ColorStyle=h},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e){var n,r=t===D.keys.LEFT?"prefix":"suffix";return n={key:t,shiftKey:e,altKey:null},o(n,r,/^$/),o(n,"handler",function(n){var r=n.index;t===D.keys.RIGHT&&(r+=n.length+1);var o=this.quill.getLeaf(r);return!(b(o,1)[0]instanceof T.default.Embed)||(t===D.keys.LEFT?e?this.quill.setSelection(n.index-1,n.length+1,S.default.sources.USER):this.quill.setSelection(n.index-1,S.default.sources.USER):e?this.quill.setSelection(n.index,n.length+1,S.default.sources.USER):this.quill.setSelection(n.index+n.length+1,S.default.sources.USER),!1)}),n}function u(t,e){if(!(0===t.index||this.quill.getLength()<=1)){var n=this.quill.getLine(t.index),r=b(n,1),o=r[0],i={};if(0===e.offset){var l=this.quill.getLine(t.index-1),a=b(l,1),s=a[0];if(null!=s&&s.length()>1){var u=o.formats(),c=this.quill.getFormat(t.index-1,1);i=A.default.attributes.diff(u,c)||{}}}var f=/[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]$/.test(e.prefix)?2:1;this.quill.deleteText(t.index-f,f,S.default.sources.USER),Object.keys(i).length>0&&this.quill.formatLine(t.index-f,f,i,S.default.sources.USER),this.quill.focus()}}function c(t,e){var n=/^[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]/.test(e.suffix)?2:1;if(!(t.index>=this.quill.getLength()-n)){var r={},o=0,i=this.quill.getLine(t.index),l=b(i,1),a=l[0];if(e.offset>=a.length()-1){var s=this.quill.getLine(t.index+1),u=b(s,1),c=u[0];if(c){var f=a.formats(),h=this.quill.getFormat(t.index,1);r=A.default.attributes.diff(f,h)||{},o=c.length()}}this.quill.deleteText(t.index,n,S.default.sources.USER),Object.keys(r).length>0&&this.quill.formatLine(t.index+o-1,n,r,S.default.sources.USER)}}function f(t){var e=this.quill.getLines(t),n={};if(e.length>1){var r=e[0].formats(),o=e[e.length-1].formats();n=A.default.attributes.diff(o,r)||{}}this.quill.deleteText(t,S.default.sources.USER),Object.keys(n).length>0&&this.quill.formatLine(t.index,1,n,S.default.sources.USER),this.quill.setSelection(t.index,S.default.sources.SILENT),this.quill.focus()}function h(t,e){var n=this;t.length>0&&this.quill.scroll.deleteAt(t.index,t.length);var r=Object.keys(e.format).reduce(function(t,n){return T.default.query(n,T.default.Scope.BLOCK)&&!Array.isArray(e.format[n])&&(t[n]=e.format[n]),t},{});this.quill.insertText(t.index,"\\n",r,S.default.sources.USER),this.quill.setSelection(t.index+1,S.default.sources.SILENT),this.quill.focus(),Object.keys(e.format).forEach(function(t){null==r[t]&&(Array.isArray(e.format[t])||"link"!==t&&n.quill.format(t,e.format[t],S.default.sources.USER))})}function p(t){return{key:D.keys.TAB,shiftKey:!t,format:{"code-block":!0},handler:function(e){var n=T.default.query("code-block"),r=e.index,o=e.length,i=this.quill.scroll.descendant(n,r),l=b(i,2),a=l[0],s=l[1];if(null!=a){var u=this.quill.getIndex(a),c=a.newlineIndex(s,!0)+1,f=a.newlineIndex(u+s+o),h=a.domNode.textContent.slice(c,f).split("\\n");s=0,h.forEach(function(e,i){t?(a.insertAt(c+s,n.TAB),s+=n.TAB.length,0===i?r+=n.TAB.length:o+=n.TAB.length):e.startsWith(n.TAB)&&(a.deleteAt(c+s,n.TAB.length),s-=n.TAB.length,0===i?r-=n.TAB.length:o-=n.TAB.length),s+=e.length+1}),this.quill.update(S.default.sources.USER),this.quill.setSelection(r,o,S.default.sources.SILENT)}}}}function d(t){return{key:t[0].toUpperCase(),shortKey:!0,handler:function(e,n){this.quill.format(t,!n.format[t],S.default.sources.USER)}}}function y(t){if("string"==typeof t||"number"==typeof t)return y({key:t});if("object"===(void 0===t?"undefined":v(t))&&(t=(0,_.default)(t,!1)),"string"==typeof t.key)if(null!=D.keys[t.key.toUpperCase()])t.key=D.keys[t.key.toUpperCase()];else{if(1!==t.key.length)return null;t.key=t.key.toUpperCase().charCodeAt(0)}return t.shortKey&&(t[B]=t.shortKey,delete t.shortKey),t}Object.defineProperty(e,"__esModule",{value:!0}),e.SHORTKEY=e.default=void 0;var v="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},b=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),g=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),m=n(21),_=r(m),O=n(12),w=r(O),x=n(2),k=r(x),E=n(4),N=r(E),j=n(20),A=r(j),q=n(0),T=r(q),P=n(6),S=r(P),C=n(10),L=r(C),M=n(7),R=r(M),I=(0,L.default)("quill:keyboard"),B=/Mac/i.test(navigator.platform)?"metaKey":"ctrlKey",D=function(t){function e(t,n){i(this,e);var r=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.bindings={},Object.keys(r.options.bindings).forEach(function(e){("list autofill"!==e||null==t.scroll.whitelist||t.scroll.whitelist.list)&&r.options.bindings[e]&&r.addBinding(r.options.bindings[e])}),r.addBinding({key:e.keys.ENTER,shiftKey:null},h),r.addBinding({key:e.keys.ENTER,metaKey:null,ctrlKey:null,altKey:null},function(){}),/Firefox/i.test(navigator.userAgent)?(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0},u),r.addBinding({key:e.keys.DELETE},{collapsed:!0},c)):(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0,prefix:/^.?$/},u),r.addBinding({key:e.keys.DELETE},{collapsed:!0,suffix:/^.?$/},c)),r.addBinding({key:e.keys.BACKSPACE},{collapsed:!1},f),r.addBinding({key:e.keys.DELETE},{collapsed:!1},f),r.addBinding({key:e.keys.BACKSPACE,altKey:null,ctrlKey:null,metaKey:null,shiftKey:null},{collapsed:!0,offset:0},u),r.listen(),r}return a(e,t),g(e,null,[{key:"match",value:function(t,e){return e=y(e),!["altKey","ctrlKey","metaKey","shiftKey"].some(function(n){return!!e[n]!==t[n]&&null!==e[n]})&&e.key===(t.which||t.keyCode)}}]),g(e,[{key:"addBinding",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=y(t);if(null==r||null==r.key)return I.warn("Attempted to add invalid keyboard binding",r);"function"==typeof e&&(e={handler:e}),"function"==typeof n&&(n={handler:n}),r=(0,k.default)(r,e,n),this.bindings[r.key]=this.bindings[r.key]||[],this.bindings[r.key].push(r)}},{key:"listen",value:function(){var t=this;this.quill.root.addEventListener("keydown",function(n){if(!n.defaultPrevented){var r=n.which||n.keyCode,o=(t.bindings[r]||[]).filter(function(t){return e.match(n,t)});if(0!==o.length){var i=t.quill.getSelection();if(null!=i&&t.quill.hasFocus()){var l=t.quill.getLine(i.index),a=b(l,2),s=a[0],u=a[1],c=t.quill.getLeaf(i.index),f=b(c,2),h=f[0],p=f[1],d=0===i.length?[h,p]:t.quill.getLeaf(i.index+i.length),y=b(d,2),g=y[0],m=y[1],_=h instanceof T.default.Text?h.value().slice(0,p):"",O=g instanceof T.default.Text?g.value().slice(m):"",x={collapsed:0===i.length,empty:0===i.length&&s.length()<=1,format:t.quill.getFormat(i),offset:u,prefix:_,suffix:O};o.some(function(e){if(null!=e.collapsed&&e.collapsed!==x.collapsed)return!1;if(null!=e.empty&&e.empty!==x.empty)return!1;if(null!=e.offset&&e.offset!==x.offset)return!1;if(Array.isArray(e.format)){if(e.format.every(function(t){return null==x.format[t]}))return!1}else if("object"===v(e.format)&&!Object.keys(e.format).every(function(t){return!0===e.format[t]?null!=x.format[t]:!1===e.format[t]?null==x.format[t]:(0,w.default)(e.format[t],x.format[t])}))return!1;return!(null!=e.prefix&&!e.prefix.test(x.prefix))&&(!(null!=e.suffix&&!e.suffix.test(x.suffix))&&!0!==e.handler.call(t,i,x))})&&n.preventDefault()}}}})}}]),e}(R.default);D.keys={BACKSPACE:8,TAB:9,ENTER:13,ESCAPE:27,LEFT:37,UP:38,RIGHT:39,DOWN:40,DELETE:46},D.DEFAULTS={bindings:{bold:d("bold"),italic:d("italic"),underline:d("underline"),indent:{key:D.keys.TAB,format:["blockquote","indent","list"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format("indent","+1",S.default.sources.USER)}},outdent:{key:D.keys.TAB,shiftKey:!0,format:["blockquote","indent","list"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format("indent","-1",S.default.sources.USER)}},"outdent backspace":{key:D.keys.BACKSPACE,collapsed:!0,shiftKey:null,metaKey:null,ctrlKey:null,altKey:null,format:["indent","list"],offset:0,handler:function(t,e){null!=e.format.indent?this.quill.format("indent","-1",S.default.sources.USER):null!=e.format.list&&this.quill.format("list",!1,S.default.sources.USER)}},"indent code-block":p(!0),"outdent code-block":p(!1),"remove tab":{key:D.keys.TAB,shiftKey:!0,collapsed:!0,prefix:/\\t$/,handler:function(t){this.quill.deleteText(t.index-1,1,S.default.sources.USER)}},tab:{key:D.keys.TAB,handler:function(t){this.quill.history.cutoff();var e=(new N.default).retain(t.index).delete(t.length).insert("\\t");this.quill.updateContents(e,S.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index+1,S.default.sources.SILENT)}},"list empty enter":{key:D.keys.ENTER,collapsed:!0,format:["list"],empty:!0,handler:function(t,e){this.quill.format("list",!1,S.default.sources.USER),e.format.indent&&this.quill.format("indent",!1,S.default.sources.USER)}},"checklist enter":{key:D.keys.ENTER,collapsed:!0,format:{list:"checked"},handler:function(t){var e=this.quill.getLine(t.index),n=b(e,2),r=n[0],o=n[1],i=(0,k.default)({},r.formats(),{list:"checked"}),l=(new N.default).retain(t.index).insert("\\n",i).retain(r.length()-o-1).retain(1,{list:"unchecked"});this.quill.updateContents(l,S.default.sources.USER),this.quill.setSelection(t.index+1,S.default.sources.SILENT),this.quill.scrollIntoView()}},"header enter":{key:D.keys.ENTER,collapsed:!0,format:["header"],suffix:/^$/,handler:function(t,e){var n=this.quill.getLine(t.index),r=b(n,2),o=r[0],i=r[1],l=(new N.default).retain(t.index).insert("\\n",e.format).retain(o.length()-i-1).retain(1,{header:null});this.quill.updateContents(l,S.default.sources.USER),this.quill.setSelection(t.index+1,S.default.sources.SILENT),this.quill.scrollIntoView()}},"list autofill":{key:" ",collapsed:!0,format:{list:!1},prefix:/^\\s*?(\\d+\\.|-|\\*|\\[ ?\\]|\\[x\\])$/,handler:function(t,e){var n=e.prefix.length,r=this.quill.getLine(t.index),o=b(r,2),i=o[0],l=o[1];if(l>n)return!0;var a=void 0;switch(e.prefix.trim()){case"[]":case"[ ]":a="unchecked";break;case"[x]":a="checked";break;case"-":case"*":a="bullet";break;default:a="ordered"}this.quill.insertText(t.index," ",S.default.sources.USER),this.quill.history.cutoff();var s=(new N.default).retain(t.index-l).delete(n+1).retain(i.length()-2-l).retain(1,{list:a});this.quill.updateContents(s,S.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index-n,S.default.sources.SILENT)}},"code exit":{key:D.keys.ENTER,collapsed:!0,format:["code-block"],prefix:/\\n\\n$/,suffix:/^\\s+$/,handler:function(t){var e=this.quill.getLine(t.index),n=b(e,2),r=n[0],o=n[1],i=(new N.default).retain(t.index+r.length()-o-2).retain(1,{"code-block":null}).delete(1);this.quill.updateContents(i,S.default.sources.USER)}},"embed left":s(D.keys.LEFT,!1),"embed left shift":s(D.keys.LEFT,!0),"embed right":s(D.keys.RIGHT,!1),"embed right shift":s(D.keys.RIGHT,!0)}},e.default=D,e.SHORTKEY=B},function(t,e,n){"use strict";t.exports={align:{"":n(75),center:n(76),right:n(77),justify:n(78)},background:n(79),blockquote:n(80),bold:n(81),clean:n(82),code:n(40),"code-block":n(40),color:n(83),direction:{"":n(84),rtl:n(85)},float:{center:n(86),full:n(87),left:n(88),right:n(89)},formula:n(90),header:{1:n(91),2:n(92)},italic:n(93),image:n(94),indent:{"+1":n(95),"-1":n(96)},link:n(97),list:{ordered:n(98),bullet:n(99),check:n(100)},script:{sub:n(101),super:n(102)},strike:n(103),underline:n(104),video:n(105)}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(1),o=function(){function t(t){this.domNode=t,this.domNode[r.DATA_KEY]={blot:this}}return Object.defineProperty(t.prototype,"statics",{get:function(){return this.constructor},enumerable:!0,configurable:!0}),t.create=function(t){if(null==this.tagName)throw new r.ParchmentError("Blot definition missing tagName");var e;return Array.isArray(this.tagName)?("string"==typeof t&&(t=t.toUpperCase(),parseInt(t).toString()===t&&(t=parseInt(t))),e="number"==typeof t?document.createElement(this.tagName[t-1]):this.tagName.indexOf(t)>-1?document.createElement(t):document.createElement(this.tagName[0])):e=document.createElement(this.tagName),this.className&&e.classList.add(this.className),e},t.prototype.attach=function(){null!=this.parent&&(this.scroll=this.parent.scroll)},t.prototype.clone=function(){var t=this.domNode.cloneNode(!1);return r.create(t)},t.prototype.detach=function(){null!=this.parent&&this.parent.removeChild(this),delete this.domNode[r.DATA_KEY]},t.prototype.deleteAt=function(t,e){this.isolate(t,e).remove()},t.prototype.formatAt=function(t,e,n,o){var i=this.isolate(t,e);if(null!=r.query(n,r.Scope.BLOT)&&o)i.wrap(n,o);else if(null!=r.query(n,r.Scope.ATTRIBUTE)){var l=r.create(this.statics.scope);i.wrap(l),l.format(n,o)}},t.prototype.insertAt=function(t,e,n){var o=null==n?r.create("text",e):r.create(e,n),i=this.split(t);this.parent.insertBefore(o,i)},t.prototype.insertInto=function(t,e){void 0===e&&(e=null),null!=this.parent&&this.parent.children.remove(this);var n=null;t.children.insertBefore(this,e),null!=e&&(n=e.domNode),this.domNode.parentNode==t.domNode&&this.domNode.nextSibling==n||t.domNode.insertBefore(this.domNode,n),this.parent=t,this.attach()},t.prototype.isolate=function(t,e){var n=this.split(t);return n.split(e),n},t.prototype.length=function(){return 1},t.prototype.offset=function(t){return void 0===t&&(t=this.parent),null==this.parent||this==t?0:this.parent.children.offset(this)+this.parent.offset(t)},t.prototype.optimize=function(t){null!=this.domNode[r.DATA_KEY]&&delete this.domNode[r.DATA_KEY].mutations},t.prototype.remove=function(){null!=this.domNode.parentNode&&this.domNode.parentNode.removeChild(this.domNode),this.detach()},t.prototype.replace=function(t){null!=t.parent&&(t.parent.insertBefore(this,t.next),t.remove())},t.prototype.replaceWith=function(t,e){var n="string"==typeof t?r.create(t,e):t;return n.replace(this),n},t.prototype.split=function(t,e){return 0===t?this:this.next},t.prototype.update=function(t,e){},t.prototype.wrap=function(t,e){var n="string"==typeof t?r.create(t,e):t;return null!=this.parent&&this.parent.insertBefore(n,this.next),n.appendChild(this),n},t.blotName="abstract",t}();e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(11),o=n(29),i=n(30),l=n(1),a=function(){function t(t){this.attributes={},this.domNode=t,this.build()}return t.prototype.attribute=function(t,e){e?t.add(this.domNode,e)&&(null!=t.value(this.domNode)?this.attributes[t.attrName]=t:delete this.attributes[t.attrName]):(t.remove(this.domNode),delete this.attributes[t.attrName])},t.prototype.build=function(){var t=this;this.attributes={};var e=r.default.keys(this.domNode),n=o.default.keys(this.domNode),a=i.default.keys(this.domNode);e.concat(n).concat(a).forEach(function(e){var n=l.query(e,l.Scope.ATTRIBUTE);n instanceof r.default&&(t.attributes[n.attrName]=n)})},t.prototype.copy=function(t){var e=this;Object.keys(this.attributes).forEach(function(n){var r=e.attributes[n].value(e.domNode);t.format(n,r)})},t.prototype.move=function(t){var e=this;this.copy(t),Object.keys(this.attributes).forEach(function(t){e.attributes[t].remove(e.domNode)}),this.attributes={}},t.prototype.values=function(){var t=this;return Object.keys(this.attributes).reduce(function(e,n){return e[n]=t.attributes[n].value(t.domNode),e},{})},t}();e.default=a},function(t,e,n){"use strict";function r(t,e){return(t.getAttribute("class")||"").split(/\\s+/).filter(function(t){return 0===t.indexOf(e+"-")})}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var i=n(11),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute("class")||"").split(/\\s+/).map(function(t){return t.split("-").slice(0,-1).join("-")})},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(this.remove(t),t.classList.add(this.keyName+"-"+e),!0)},e.prototype.remove=function(t){r(t,this.keyName).forEach(function(e){t.classList.remove(e)}),0===t.classList.length&&t.removeAttribute("class")},e.prototype.value=function(t){var e=r(t,this.keyName)[0]||"",n=e.slice(this.keyName.length+1);return this.canAdd(t,n)?n:""},e}(i.default);e.default=l},function(t,e,n){"use strict";function r(t){var e=t.split("-"),n=e.slice(1).map(function(t){return t[0].toUpperCase()+t.slice(1)}).join("");return e[0]+n}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var i=n(11),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute("style")||"").split(";").map(function(t){return t.split(":")[0].trim()})},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.style[r(this.keyName)]=e,!0)},e.prototype.remove=function(t){t.style[r(this.keyName)]="",t.getAttribute("style")||t.removeAttribute("style")},e.prototype.value=function(t){var e=t.style[r(this.keyName)];return this.canAdd(t,e)?e:""},e}(i.default);e.default=l},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(0),f=r(c),h=n(8),p=r(h),d=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.selection=n,r.textNode=document.createTextNode(e.CONTENTS),r.domNode.appendChild(r.textNode),r._length=0,r}return l(e,t),u(e,null,[{key:"value",value:function(){}}]),u(e,[{key:"detach",value:function(){null!=this.parent&&this.parent.removeChild(this)}},{key:"format",value:function(t,n){if(0!==this._length)return s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n);for(var r=this,o=0;null!=r&&r.statics.scope!==f.default.Scope.BLOCK_BLOT;)o+=r.offset(r.parent),r=r.parent;null!=r&&(this._length=e.CONTENTS.length,r.optimize(),r.formatAt(o,e.CONTENTS.length,t,n),this._length=0)}},{key:"index",value:function(t,n){return t===this.textNode?0:s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"index",this).call(this,t,n)}},{key:"length",value:function(){return this._length}},{key:"position",value:function(){return[this.textNode,this.textNode.data.length]}},{key:"remove",value:function(){s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"remove",this).call(this),this.parent=null}},{key:"restore",value:function(){if(!this.selection.composing&&null!=this.parent){var t=this.textNode,n=this.selection.getNativeRange(),r=void 0,o=void 0,i=void 0;if(null!=n&&n.start.node===t&&n.end.node===t){var l=[t,n.start.offset,n.end.offset];r=l[0],o=l[1],i=l[2]}for(;null!=this.domNode.lastChild&&this.domNode.lastChild!==this.textNode;)this.domNode.parentNode.insertBefore(this.domNode.lastChild,this.domNode);if(this.textNode.data!==e.CONTENTS){var s=this.textNode.data.split(e.CONTENTS).join("");this.next instanceof p.default?(r=this.next.domNode,this.next.insertAt(0,s),this.textNode.data=e.CONTENTS):(this.textNode.data=s,this.parent.insertBefore(f.default.create(this.textNode),this),this.textNode=document.createTextNode(e.CONTENTS),this.domNode.appendChild(this.textNode))}if(this.remove(),null!=o){var u=[o,i].map(function(t){return Math.max(0,Math.min(r.data.length,t-1))}),c=a(u,2);return o=c[0],i=c[1],{startNode:r,startOffset:o,endNode:r,endOffset:i}}}}},{key:"update",value:function(t,e){var n=this;if(t.some(function(t){return"characterData"===t.type&&t.target===n.textNode})){var r=this.restore();r&&(e.range=r)}}},{key:"value",value:function(){return""}}]),e}(f.default.Embed);d.blotName="cursor",d.className="ql-cursor",d.tagName="span",d.CONTENTS="\\ufeff",e.default=d},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,n){r(this,t),this.quill=e,this.options=n,this.modules={}}return o(t,[{key:"init",value:function(){var t=this;Object.keys(this.options.modules).forEach(function(e){null==t.modules[e]&&t.addModule(e)})}},{key:"addModule",value:function(t){var e=this.quill.constructor.import("modules/"+t);return this.modules[t]=new e(this.quill,this.options.modules[t]||{}),this.modules[t]}}]),t}();i.DEFAULTS={modules:{}},i.themes={default:i},e.default=i},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(0),c=r(u),f=n(8),h=r(f),p="\\ufeff",d=function(t){function e(t){o(this,e);var n=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.contentNode=document.createElement("span"),n.contentNode.setAttribute("contenteditable",!1),[].slice.call(n.domNode.childNodes).forEach(function(t){n.contentNode.appendChild(t)}),n.leftGuard=document.createTextNode(p),n.rightGuard=document.createTextNode(p),n.domNode.appendChild(n.leftGuard),n.domNode.appendChild(n.contentNode),n.domNode.appendChild(n.rightGuard),n}return l(e,t),a(e,[{key:"index",value:function(t,n){return t===this.leftGuard?0:t===this.rightGuard?1:s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"index",this).call(this,t,n)}},{key:"restore",value:function(t){var e=void 0,n=void 0,r=t.data.split(p).join("");if(t===this.leftGuard)if(this.prev instanceof h.default){var o=this.prev.length();this.prev.insertAt(o,r),e={startNode:this.prev.domNode,startOffset:o+r.length}}else n=document.createTextNode(r),this.parent.insertBefore(c.default.create(n),this),e={startNode:n,startOffset:r.length};else t===this.rightGuard&&(this.next instanceof h.default?(this.next.insertAt(0,r),e={startNode:this.next.domNode,startOffset:r.length}):(n=document.createTextNode(r),this.parent.insertBefore(c.default.create(n),this.next),e={startNode:n,startOffset:r.length}));return t.data=p,e}},{key:"update",value:function(t,e){var n=this;t.forEach(function(t){if("characterData"===t.type&&(t.target===n.leftGuard||t.target===n.rightGuard)){var r=n.restore(t.target);r&&(e.range=r)}})}}]),e}(c.default.Embed);e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.AlignStyle=e.AlignClass=e.AlignAttribute=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i={scope:o.default.Scope.BLOCK,whitelist:["right","center","justify"]},l=new o.default.Attributor.Attribute("align","align",i),a=new o.default.Attributor.Class("align","ql-align",i),s=new o.default.Attributor.Style("align","text-align",i);e.AlignAttribute=l,e.AlignClass=a,e.AlignStyle=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.BackgroundStyle=e.BackgroundClass=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i=n(24),l=new o.default.Attributor.Class("background","ql-bg",{scope:o.default.Scope.INLINE}),a=new i.ColorAttributor("background","background-color",{scope:o.default.Scope.INLINE});e.BackgroundClass=l,e.BackgroundStyle=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.DirectionStyle=e.DirectionClass=e.DirectionAttribute=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i={scope:o.default.Scope.BLOCK,whitelist:["rtl"]},l=new o.default.Attributor.Attribute("direction","dir",i),a=new o.default.Attributor.Class("direction","ql-direction",i),s=new o.default.Attributor.Style("direction","direction",i);e.DirectionAttribute=l,e.DirectionClass=a,e.DirectionStyle=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.FontClass=e.FontStyle=void 0;var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c={scope:u.default.Scope.INLINE,whitelist:["serif","monospace"]},f=new u.default.Attributor.Class("font","ql-font",c),h=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"value",value:function(t){return a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t).replace(/["\']/g,"")}}]),e}(u.default.Attributor.Style),p=new h("font","font-family",c);e.FontStyle=p,e.FontClass=f},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SizeStyle=e.SizeClass=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i=new o.default.Attributor.Class("size","ql-size",{scope:o.default.Scope.INLINE,whitelist:["small","large","huge"]}),l=new o.default.Attributor.Style("size","font-size",{scope:o.default.Scope.INLINE,whitelist:["10px","18px","32px"]});e.SizeClass=i,e.SizeStyle=l},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(5),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"optimize",value:function(t){a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.domNode.tagName!==this.statics.tagName[0]&&this.replaceWith(this.statics.blotName)}}],[{key:"create",value:function(){return a(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this)}},{key:"formats",value:function(){return!0}}]),e}(u.default);c.blotName="bold",c.tagName=["STRONG","B"],e.default=c},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>\'},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(16),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return i.label.innerHTML=n,i.container.classList.add("ql-color-picker"),[].slice.call(i.container.querySelectorAll(".ql-picker-item"),0,7).forEach(function(t){t.classList.add("ql-primary")}),i}return i(e,t),l(e,[{key:"buildItem",value:function(t){var n=a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"buildItem",this).call(this,t);return n.style.backgroundColor=t.getAttribute("value")||"",n}},{key:"selectItem",value:function(t,n){a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"selectItem",this).call(this,t,n);var r=this.label.querySelector(".ql-color-label"),o=t?t.getAttribute("data-value")||"":"";r&&("line"===r.tagName?r.style.stroke=o:r.style.fill=o)}}]),e}(u.default);e.default=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(16),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return i.container.classList.add("ql-icon-picker"),[].forEach.call(i.container.querySelectorAll(".ql-picker-item"),function(t){t.innerHTML=n[t.getAttribute("data-value")||""]}),i.defaultItem=i.container.querySelector(".ql-selected"),i.selectItem(i.defaultItem),i}return i(e,t),l(e,[{key:"selectItem",value:function(t,n){a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"selectItem",this).call(this,t,n),t=t||this.defaultItem,this.label.innerHTML=t.innerHTML}}]),e}(u.default);e.default=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,n){var o=this;r(this,t),this.quill=e,this.boundsContainer=n||document.body,this.root=e.addContainer("ql-tooltip"),this.root.innerHTML=this.constructor.TEMPLATE,this.quill.root===this.quill.scrollingContainer&&this.quill.root.addEventListener("scroll",function(){o.root.style.marginTop=-1*o.quill.root.scrollTop+"px"}),this.hide()}return o(t,[{key:"hide",value:function(){this.root.classList.add("ql-hidden")}},{key:"position",value:function(t){var e=t.left+t.width/2-this.root.offsetWidth/2,n=t.bottom+this.quill.root.scrollTop;this.root.style.left=e+"px",this.root.style.top=n+"px",this.root.classList.remove("ql-flip");var r=this.boundsContainer.getBoundingClientRect(),o=this.root.getBoundingClientRect(),i=0;if(o.right>r.right&&(i=r.right-o.right,this.root.style.left=e+i+"px"),o.left<r.left&&(i=r.left-o.left,this.root.style.left=e+i+"px"),o.bottom>r.bottom){var l=o.bottom-o.top,a=t.bottom-t.top+l;this.root.style.top=n-a+"px",this.root.classList.add("ql-flip")}return i}},{key:"show",value:function(){this.root.classList.remove("ql-editing"),this.root.classList.remove("ql-hidden")}}]),t}();e.default=i},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e=t.match(/^(?:(https?):\\/\\/)?(?:(?:www|m)\\.)?youtube\\.com\\/watch.*v=([a-zA-Z0-9_-]+)/)||t.match(/^(?:(https?):\\/\\/)?(?:(?:www|m)\\.)?youtu\\.be\\/([a-zA-Z0-9_-]+)/);return e?(e[1]||"https")+"://www.youtube.com/embed/"+e[2]+"?showinfo=0":(e=t.match(/^(?:(https?):\\/\\/)?(?:www\\.)?vimeo\\.com\\/(\\d+)/))?(e[1]||"https")+"://player.vimeo.com/video/"+e[2]+"/":t}function s(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];e.forEach(function(e){var r=document.createElement("option");e===n?r.setAttribute("selected","selected"):r.setAttribute("value",e),t.appendChild(r)})}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BaseTooltip=void 0;var u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},f=n(2),h=r(f),p=n(4),d=r(p),y=n(9),v=r(y),b=n(25),g=r(b),m=n(32),_=r(m),O=n(41),w=r(O),x=n(42),k=r(x),E=n(16),N=r(E),j=n(43),A=r(j),q=[!1,"center","right","justify"],T=["#000000","#e60000","#ff9900","#ffff00","#008a00","#0066cc","#9933ff","#ffffff","#facccc","#ffebcc","#ffffcc","#cce8cc","#cce0f5","#ebd6ff","#bbbbbb","#f06666","#ffc266","#ffff66","#66b966","#66a3e0","#c285ff","#888888","#a10000","#b26b00","#b2b200","#006100","#0047b2","#6b24b2","#444444","#5c0000","#663d00","#666600","#003700","#002966","#3d1466"],P=[!1,"serif","monospace"],S=["1","2","3",!1],C=["small",!1,"large","huge"],L=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n)),l=function e(n){if(!document.body.contains(t.root))return document.body.removeEventListener("click",e);null==r.tooltip||r.tooltip.root.contains(n.target)||document.activeElement===r.tooltip.textbox||r.quill.hasFocus()||r.tooltip.hide(),null!=r.pickers&&r.pickers.forEach(function(t){t.container.contains(n.target)||t.close()})};return t.emitter.listenDOM("click",document.body,l),r}return l(e,t),u(e,[{key:"addModule",value:function(t){var n=c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"addModule",this).call(this,t);return"toolbar"===t&&this.extendToolbar(n),n}},{key:"buildButtons",value:function(t,e){t.forEach(function(t){(t.getAttribute("class")||"").split(/\\s+/).forEach(function(n){if(n.startsWith("ql-")&&(n=n.slice("ql-".length),null!=e[n]))if("direction"===n)t.innerHTML=e[n][""]+e[n].rtl;else if("string"==typeof e[n])t.innerHTML=e[n];else{var r=t.value||"";null!=r&&e[n][r]&&(t.innerHTML=e[n][r])}})})}},{key:"buildPickers",value:function(t,e){var n=this;this.pickers=t.map(function(t){if(t.classList.contains("ql-align"))return null==t.querySelector("option")&&s(t,q),new k.default(t,e.align);if(t.classList.contains("ql-background")||t.classList.contains("ql-color")){var n=t.classList.contains("ql-background")?"background":"color";return null==t.querySelector("option")&&s(t,T,"background"===n?"#ffffff":"#000000"),new w.default(t,e[n])}return null==t.querySelector("option")&&(t.classList.contains("ql-font")?s(t,P):t.classList.contains("ql-header")?s(t,S):t.classList.contains("ql-size")&&s(t,C)),new N.default(t)});var r=function(){n.pickers.forEach(function(t){t.update()})};this.quill.on(v.default.events.EDITOR_CHANGE,r)}}]),e}(_.default);L.DEFAULTS=(0,h.default)(!0,{},_.default.DEFAULTS,{modules:{toolbar:{handlers:{formula:function(){this.quill.theme.tooltip.edit("formula")},image:function(){var t=this,e=this.container.querySelector("input.ql-image[type=file]");null==e&&(e=document.createElement("input"),e.setAttribute("type","file"),e.setAttribute("accept","image/png, image/gif, image/jpeg, image/bmp, image/x-icon"),e.classList.add("ql-image"),e.addEventListener("change",function(){if(null!=e.files&&null!=e.files[0]){var n=new FileReader;n.onload=function(n){var r=t.quill.getSelection(!0);t.quill.updateContents((new d.default).retain(r.index).delete(r.length).insert({image:n.target.result}),v.default.sources.USER),t.quill.setSelection(r.index+1,v.default.sources.SILENT),e.value=""},n.readAsDataURL(e.files[0])}}),this.container.appendChild(e)),e.click()},video:function(){this.quill.theme.tooltip.edit("video")}}}}});var M=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.textbox=r.root.querySelector(\'input[type="text"]\'),r.listen(),r}return l(e,t),u(e,[{key:"listen",value:function(){var t=this;this.textbox.addEventListener("keydown",function(e){g.default.match(e,"enter")?(t.save(),e.preventDefault()):g.default.match(e,"escape")&&(t.cancel(),e.preventDefault())})}},{key:"cancel",value:function(){this.hide()}},{key:"edit",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"link",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;this.root.classList.remove("ql-hidden"),this.root.classList.add("ql-editing"),null!=e?this.textbox.value=e:t!==this.root.getAttribute("data-mode")&&(this.textbox.value=""),this.position(this.quill.getBounds(this.quill.selection.savedRange)),this.textbox.select(),this.textbox.setAttribute("placeholder",this.textbox.getAttribute("data-"+t)||""),this.root.setAttribute("data-mode",t)}},{key:"restoreFocus",value:function(){var t=this.quill.scrollingContainer.scrollTop;this.quill.focus(),this.quill.scrollingContainer.scrollTop=t}},{key:"save",value:function(){var t=this.textbox.value;switch(this.root.getAttribute("data-mode")){case"link":var e=this.quill.root.scrollTop;this.linkRange?(this.quill.formatText(this.linkRange,"link",t,v.default.sources.USER),delete this.linkRange):(this.restoreFocus(),this.quill.format("link",t,v.default.sources.USER)),this.quill.root.scrollTop=e;break;case"video":t=a(t);case"formula":if(!t)break;var n=this.quill.getSelection(!0);if(null!=n){var r=n.index+n.length;this.quill.insertEmbed(r,this.root.getAttribute("data-mode"),t,v.default.sources.USER),"formula"===this.root.getAttribute("data-mode")&&this.quill.insertText(r+1," ",v.default.sources.USER),this.quill.setSelection(r+2,v.default.sources.USER)}}this.textbox.value="",this.hide()}}]),e}(A.default);e.BaseTooltip=M,e.default=L},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(46),i=r(o),l=n(34),a=n(36),s=n(62),u=n(63),c=r(u),f=n(64),h=r(f),p=n(65),d=r(p),y=n(35),v=n(24),b=n(37),g=n(38),m=n(39),_=r(m),O=n(66),w=r(O),x=n(15),k=r(x),E=n(67),N=r(E),j=n(68),A=r(j),q=n(69),T=r(q),P=n(70),S=r(P),C=n(71),L=r(C),M=n(13),R=r(M),I=n(72),B=r(I),D=n(73),U=r(D),F=n(74),H=r(F),K=n(26),z=r(K),V=n(16),Z=r(V),W=n(41),G=r(W),Y=n(42),X=r(Y),$=n(43),Q=r($),J=n(107),tt=r(J),et=n(108),nt=r(et);i.default.register({"attributors/attribute/direction":a.DirectionAttribute,"attributors/class/align":l.AlignClass,"attributors/class/background":y.BackgroundClass,"attributors/class/color":v.ColorClass,"attributors/class/direction":a.DirectionClass,"attributors/class/font":b.FontClass,"attributors/class/size":g.SizeClass,"attributors/style/align":l.AlignStyle,"attributors/style/background":y.BackgroundStyle,"attributors/style/color":v.ColorStyle,"attributors/style/direction":a.DirectionStyle,"attributors/style/font":b.FontStyle,"attributors/style/size":g.SizeStyle},!0),i.default.register({"formats/align":l.AlignClass,"formats/direction":a.DirectionClass,"formats/indent":s.IndentClass,"formats/background":y.BackgroundStyle,"formats/color":v.ColorStyle,"formats/font":b.FontClass,"formats/size":g.SizeClass,"formats/blockquote":c.default,"formats/code-block":R.default,"formats/header":h.default,"formats/list":d.default,"formats/bold":_.default,"formats/code":M.Code,"formats/italic":w.default,"formats/link":k.default,"formats/script":N.default,"formats/strike":A.default,"formats/underline":T.default,"formats/image":S.default,"formats/video":L.default,"formats/list/item":p.ListItem,"modules/formula":B.default,"modules/syntax":U.default,"modules/toolbar":H.default,"themes/bubble":tt.default,"themes/snow":nt.default,"ui/icons":z.default,"ui/picker":Z.default,"ui/icon-picker":X.default,"ui/color-picker":G.default,"ui/tooltip":Q.default},!0),e.default=i.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),i=r(o),l=n(6),a=r(l),s=n(3),u=r(s),c=n(14),f=r(c),h=n(23),p=r(h),d=n(31),y=r(d),v=n(33),b=r(v),g=n(5),m=r(g),_=n(59),O=r(_),w=n(8),x=r(w),k=n(60),E=r(k),N=n(61),j=r(N),A=n(25),q=r(A);a.default.register({"blots/block":u.default,"blots/block/embed":s.BlockEmbed,"blots/break":f.default,"blots/container":p.default,"blots/cursor":y.default,"blots/embed":b.default,"blots/inline":m.default,"blots/scroll":O.default,"blots/text":x.default,"modules/clipboard":E.default,"modules/history":j.default,"modules/keyboard":q.default}),i.default.register(u.default,f.default,y.default,m.default,O.default,x.default),e.default=a.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(){this.head=this.tail=null,this.length=0}return t.prototype.append=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this.insertBefore(t[0],null),t.length>1&&this.append.apply(this,t.slice(1))},t.prototype.contains=function(t){for(var e,n=this.iterator();e=n();)if(e===t)return!0;return!1},t.prototype.insertBefore=function(t,e){t&&(t.next=e,null!=e?(t.prev=e.prev,null!=e.prev&&(e.prev.next=t),e.prev=t,e===this.head&&(this.head=t)):null!=this.tail?(this.tail.next=t,t.prev=this.tail,this.tail=t):(t.prev=null,this.head=this.tail=t),this.length+=1)},t.prototype.offset=function(t){for(var e=0,n=this.head;null!=n;){if(n===t)return e;e+=n.length(),n=n.next}return-1},t.prototype.remove=function(t){this.contains(t)&&(null!=t.prev&&(t.prev.next=t.next),null!=t.next&&(t.next.prev=t.prev),t===this.head&&(this.head=t.next),t===this.tail&&(this.tail=t.prev),this.length-=1)},t.prototype.iterator=function(t){return void 0===t&&(t=this.head),function(){var e=t;return null!=t&&(t=t.next),e}},t.prototype.find=function(t,e){void 0===e&&(e=!1);for(var n,r=this.iterator();n=r();){var o=n.length();if(t<o||e&&t===o&&(null==n.next||0!==n.next.length()))return[n,t];t-=o}return[null,0]},t.prototype.forEach=function(t){for(var e,n=this.iterator();e=n();)t(e)},t.prototype.forEachAt=function(t,e,n){if(!(e<=0))for(var r,o=this.find(t),i=o[0],l=o[1],a=t-l,s=this.iterator(i);(r=s())&&a<t+e;){var u=r.length();t>a?n(r,t-a,Math.min(e,a+u-t)):n(r,0,Math.min(u,t+e-a)),a+=u}},t.prototype.map=function(t){return this.reduce(function(e,n){return e.push(t(n)),e},[])},t.prototype.reduce=function(t,e){for(var n,r=this.iterator();n=r();)e=t(e,n);return e},t}();e.default=r},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(17),i=n(1),l={attributes:!0,characterData:!0,characterDataOldValue:!0,childList:!0,subtree:!0},a=function(t){function e(e){var n=t.call(this,e)||this;return n.scroll=n,n.observer=new MutationObserver(function(t){n.update(t)}),n.observer.observe(n.domNode,l),n.attach(),n}return r(e,t),e.prototype.detach=function(){t.prototype.detach.call(this),this.observer.disconnect()},e.prototype.deleteAt=function(e,n){this.update(),0===e&&n===this.length()?this.children.forEach(function(t){t.remove()}):t.prototype.deleteAt.call(this,e,n)},e.prototype.formatAt=function(e,n,r,o){this.update(),t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){this.update(),t.prototype.insertAt.call(this,e,n,r)},e.prototype.optimize=function(e,n){var r=this;void 0===e&&(e=[]),void 0===n&&(n={}),t.prototype.optimize.call(this,n);for(var l=[].slice.call(this.observer.takeRecords());l.length>0;)e.push(l.pop());for(var a=function(t,e){void 0===e&&(e=!0),null!=t&&t!==r&&null!=t.domNode.parentNode&&(null==t.domNode[i.DATA_KEY].mutations&&(t.domNode[i.DATA_KEY].mutations=[]),e&&a(t.parent))},s=function(t){null!=t.domNode[i.DATA_KEY]&&null!=t.domNode[i.DATA_KEY].mutations&&(t instanceof o.default&&t.children.forEach(s),t.optimize(n))},u=e,c=0;u.length>0;c+=1){if(c>=100)throw new Error("[Parchment] Maximum optimize iterations reached");for(u.forEach(function(t){var e=i.find(t.target,!0);null!=e&&(e.domNode===t.target&&("childList"===t.type?(a(i.find(t.previousSibling,!1)),[].forEach.call(t.addedNodes,function(t){var e=i.find(t,!1);a(e,!1),e instanceof o.default&&e.children.forEach(function(t){a(t,!1)})})):"attributes"===t.type&&a(e.prev)),a(e))}),this.children.forEach(s),u=[].slice.call(this.observer.takeRecords()),l=u.slice();l.length>0;)e.push(l.pop())}},e.prototype.update=function(e,n){var r=this;void 0===n&&(n={}),e=e||this.observer.takeRecords(),e.map(function(t){var e=i.find(t.target,!0);return null==e?null:null==e.domNode[i.DATA_KEY].mutations?(e.domNode[i.DATA_KEY].mutations=[t],e):(e.domNode[i.DATA_KEY].mutations.push(t),null)}).forEach(function(t){null!=t&&t!==r&&null!=t.domNode[i.DATA_KEY]&&t.update(t.domNode[i.DATA_KEY].mutations||[],n)}),null!=this.domNode[i.DATA_KEY].mutations&&t.prototype.update.call(this,this.domNode[i.DATA_KEY].mutations,n),this.optimize(e,n)},e.blotName="scroll",e.defaultChild="block",e.scope=i.Scope.BLOCK_BLOT,e.tagName="DIV",e}(o.default);e.default=a},function(t,e,n){"use strict";function r(t,e){if(Object.keys(t).length!==Object.keys(e).length)return!1;for(var n in t)if(t[n]!==e[n])return!1;return!0}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var i=n(18),l=n(1),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.formats=function(n){if(n.tagName!==e.tagName)return t.formats.call(this,n)},e.prototype.format=function(n,r){var o=this;n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):(this.children.forEach(function(t){t instanceof i.default||(t=t.wrap(e.blotName,!0)),o.attributes.copy(t)}),this.unwrap())},e.prototype.formatAt=function(e,n,r,o){if(null!=this.formats()[r]||l.query(r,l.Scope.ATTRIBUTE)){this.isolate(e,n).format(r,o)}else t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n);var o=this.formats();if(0===Object.keys(o).length)return this.unwrap();var i=this.next;i instanceof e&&i.prev===this&&r(o,i.formats())&&(i.moveChildren(this),i.remove())},e.blotName="inline",e.scope=l.Scope.INLINE_BLOT,e.tagName="SPAN",e}(i.default);e.default=a},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(18),i=n(1),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return r(e,t),e.formats=function(n){var r=i.query(e.blotName).tagName;if(n.tagName!==r)return t.formats.call(this,n)},e.prototype.format=function(n,r){null!=i.query(n,i.Scope.BLOCK)&&(n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):this.replaceWith(e.blotName))},e.prototype.formatAt=function(e,n,r,o){null!=i.query(r,i.Scope.BLOCK)?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){if(null==r||null!=i.query(n,i.Scope.INLINE))t.prototype.insertAt.call(this,e,n,r);else{var o=this.split(e),l=i.create(n,r);o.parent.insertBefore(l,o)}},e.prototype.update=function(e,n){navigator.userAgent.match(/Trident/)?this.build():t.prototype.update.call(this,e,n)},e.blotName="block",e.scope=i.Scope.BLOCK_BLOT,e.tagName="P",e}(o.default);e.default=l},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(19),i=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return r(e,t),e.formats=function(t){},e.prototype.format=function(e,n){t.prototype.formatAt.call(this,0,this.length(),e,n)},e.prototype.formatAt=function(e,n,r,o){0===e&&n===this.length()?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.formats=function(){return this.statics.formats(this.domNode)},e}(o.default);e.default=i},function(t,e,n){"use strict";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=n(19),i=n(1),l=function(t){function e(e){var n=t.call(this,e)||this;return n.text=n.statics.value(n.domNode),n}return r(e,t),e.create=function(t){return document.createTextNode(t)},e.value=function(t){var e=t.data;return e.normalize&&(e=e.normalize()),e},e.prototype.deleteAt=function(t,e){this.domNode.data=this.text=this.text.slice(0,t)+this.text.slice(t+e)},e.prototype.index=function(t,e){return this.domNode===t?e:-1},e.prototype.insertAt=function(e,n,r){null==r?(this.text=this.text.slice(0,e)+n+this.text.slice(e),this.domNode.data=this.text):t.prototype.insertAt.call(this,e,n,r)},e.prototype.length=function(){return this.text.length},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n),this.text=this.statics.value(this.domNode),0===this.text.length?this.remove():this.next instanceof e&&this.next.prev===this&&(this.insertAt(this.length(),this.next.value()),this.next.remove())},e.prototype.position=function(t,e){return void 0===e&&(e=!1),[this.domNode,t]},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=i.create(this.domNode.splitText(t));return this.parent.insertBefore(n,this.next),this.text=this.statics.value(this.domNode),n},e.prototype.update=function(t,e){var n=this;t.some(function(t){return"characterData"===t.type&&t.target===n.domNode})&&(this.text=this.statics.value(this.domNode))},e.prototype.value=function(){return this.text},e.blotName="text",e.scope=i.Scope.INLINE_BLOT,e}(o.default);e.default=l},function(t,e,n){"use strict";var r=document.createElement("div");if(r.classList.toggle("test-class",!1),r.classList.contains("test-class")){var o=DOMTokenList.prototype.toggle;DOMTokenList.prototype.toggle=function(t,e){return arguments.length>1&&!this.contains(t)==!e?e:o.call(this,t)}}String.prototype.startsWith||(String.prototype.startsWith=function(t,e){return e=e||0,this.substr(e,t.length)===t}),String.prototype.endsWith||(String.prototype.endsWith=function(t,e){var n=this.toString();("number"!=typeof e||!isFinite(e)||Math.floor(e)!==e||e>n.length)&&(e=n.length),e-=t.length;var r=n.indexOf(t,e);return-1!==r&&r===e}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null===this)throw new TypeError("Array.prototype.find called on null or undefined");if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var e,n=Object(this),r=n.length>>>0,o=arguments[1],i=0;i<r;i++)if(e=n[i],t.call(o,e,i,n))return e}}),document.addEventListener("DOMContentLoaded",function(){document.execCommand("enableObjectResizing",!1,!1),document.execCommand("autoUrlDetect",!1,!1)})},function(t,e){function n(t,e,n){if(t==e)return t?[[v,t]]:[];(n<0||t.length<n)&&(n=null);var o=l(t,e),i=t.substring(0,o);t=t.substring(o),e=e.substring(o),o=a(t,e);var s=t.substring(t.length-o);t=t.substring(0,t.length-o),e=e.substring(0,e.length-o);var c=r(t,e);return i&&c.unshift([v,i]),s&&c.push([v,s]),u(c),null!=n&&(c=f(c,n)),c=h(c)}function r(t,e){var r;if(!t)return[[y,e]];if(!e)return[[d,t]];var i=t.length>e.length?t:e,l=t.length>e.length?e:t,a=i.indexOf(l);if(-1!=a)return r=[[y,i.substring(0,a)],[v,l],[y,i.substring(a+l.length)]],t.length>e.length&&(r[0][0]=r[2][0]=d),r;if(1==l.length)return[[d,t],[y,e]];var u=s(t,e);if(u){var c=u[0],f=u[1],h=u[2],p=u[3],b=u[4],g=n(c,h),m=n(f,p);return g.concat([[v,b]],m)}return o(t,e)}function o(t,e){for(var n=t.length,r=e.length,o=Math.ceil((n+r)/2),l=o,a=2*o,s=new Array(a),u=new Array(a),c=0;c<a;c++)s[c]=-1,u[c]=-1;s[l+1]=0,u[l+1]=0;for(var f=n-r,h=f%2!=0,p=0,v=0,b=0,g=0,m=0;m<o;m++){for(var _=-m+p;_<=m-v;_+=2){var O,w=l+_;O=_==-m||_!=m&&s[w-1]<s[w+1]?s[w+1]:s[w-1]+1;for(var x=O-_;O<n&&x<r&&t.charAt(O)==e.charAt(x);)O++,x++;if(s[w]=O,O>n)v+=2;else if(x>r)p+=2;else if(h){var k=l+f-_;if(k>=0&&k<a&&-1!=u[k]){var E=n-u[k];if(O>=E)return i(t,e,O,x)}}}for(var N=-m+b;N<=m-g;N+=2){var E,k=l+N;E=N==-m||N!=m&&u[k-1]<u[k+1]?u[k+1]:u[k-1]+1;for(var j=E-N;E<n&&j<r&&t.charAt(n-E-1)==e.charAt(r-j-1);)E++,j++;if(u[k]=E,E>n)g+=2;else if(j>r)b+=2;else if(!h){var w=l+f-N;if(w>=0&&w<a&&-1!=s[w]){var O=s[w],x=l+O-w;if(E=n-E,O>=E)return i(t,e,O,x)}}}}return[[d,t],[y,e]]}function i(t,e,r,o){var i=t.substring(0,r),l=e.substring(0,o),a=t.substring(r),s=e.substring(o),u=n(i,l),c=n(a,s);return u.concat(c)}function l(t,e){if(!t||!e||t.charAt(0)!=e.charAt(0))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(i,o)==e.substring(i,o)?(n=o,i=n):r=o,o=Math.floor((r-n)/2+n);return o}function a(t,e){if(!t||!e||t.charAt(t.length-1)!=e.charAt(e.length-1))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(t.length-o,t.length-i)==e.substring(e.length-o,e.length-i)?(n=o,i=n):r=o,o=Math.floor((r-n)/2+n);return o}function s(t,e){function n(t,e,n){for(var r,o,i,s,u=t.substring(n,n+Math.floor(t.length/4)),c=-1,f="";-1!=(c=e.indexOf(u,c+1));){var h=l(t.substring(n),e.substring(c)),p=a(t.substring(0,n),e.substring(0,c));f.length<p+h&&(f=e.substring(c-p,c)+e.substring(c,c+h),r=t.substring(0,n-p),o=t.substring(n+h),i=e.substring(0,c-p),s=e.substring(c+h))}return 2*f.length>=t.length?[r,o,i,s,f]:null}var r=t.length>e.length?t:e,o=t.length>e.length?e:t;if(r.length<4||2*o.length<r.length)return null;var i,s=n(r,o,Math.ceil(r.length/4)),u=n(r,o,Math.ceil(r.length/2));if(!s&&!u)return null;i=u?s&&s[4].length>u[4].length?s:u:s;var c,f,h,p;return t.length>e.length?(c=i[0],f=i[1],h=i[2],p=i[3]):(h=i[0],p=i[1],c=i[2],f=i[3]),[c,f,h,p,i[4]]}function u(t){t.push([v,""]);for(var e,n=0,r=0,o=0,i="",s="";n<t.length;)switch(t[n][0]){case y:o++,s+=t[n][1],n++;break;case d:r++,i+=t[n][1],n++;break;case v:r+o>1?(0!==r&&0!==o&&(e=l(s,i),0!==e&&(n-r-o>0&&t[n-r-o-1][0]==v?t[n-r-o-1][1]+=s.substring(0,e):(t.splice(0,0,[v,s.substring(0,e)]),n++),s=s.substring(e),i=i.substring(e)),0!==(e=a(s,i))&&(t[n][1]=s.substring(s.length-e)+t[n][1],s=s.substring(0,s.length-e),i=i.substring(0,i.length-e))),0===r?t.splice(n-o,r+o,[y,s]):0===o?t.splice(n-r,r+o,[d,i]):t.splice(n-r-o,r+o,[d,i],[y,s]),n=n-r-o+(r?1:0)+(o?1:0)+1):0!==n&&t[n-1][0]==v?(t[n-1][1]+=t[n][1],t.splice(n,1)):n++,o=0,r=0,i="",s=""}""===t[t.length-1][1]&&t.pop();var c=!1;for(n=1;n<t.length-1;)t[n-1][0]==v&&t[n+1][0]==v&&(t[n][1].substring(t[n][1].length-t[n-1][1].length)==t[n-1][1]?(t[n][1]=t[n-1][1]+t[n][1].substring(0,t[n][1].length-t[n-1][1].length),t[n+1][1]=t[n-1][1]+t[n+1][1],t.splice(n-1,1),c=!0):t[n][1].substring(0,t[n+1][1].length)==t[n+1][1]&&(t[n-1][1]+=t[n+1][1],t[n][1]=t[n][1].substring(t[n+1][1].length)+t[n+1][1],t.splice(n+1,1),c=!0)),n++;c&&u(t)}function c(t,e){if(0===e)return[v,t];for(var n=0,r=0;r<t.length;r++){var o=t[r];if(o[0]===d||o[0]===v){var i=n+o[1].length;if(e===i)return[r+1,t];if(e<i){t=t.slice();var l=e-n,a=[o[0],o[1].slice(0,l)],s=[o[0],o[1].slice(l)];return t.splice(r,1,a,s),[r+1,t]}n=i}}throw new Error("cursor_pos is out of bounds!")}function f(t,e){var n=c(t,e),r=n[1],o=n[0],i=r[o],l=r[o+1];if(null==i)return t;if(i[0]!==v)return t;if(null!=l&&i[1]+l[1]===l[1]+i[1])return r.splice(o,2,l,i),p(r,o,2);if(null!=l&&0===l[1].indexOf(i[1])){r.splice(o,2,[l[0],i[1]],[0,i[1]]);var a=l[1].slice(i[1].length);return a.length>0&&r.splice(o+2,0,[l[0],a]),p(r,o,3)}return t}function h(t){for(var e=!1,n=function(t){return t.charCodeAt(0)>=56320&&t.charCodeAt(0)<=57343},r=2;r<t.length;r+=1)t[r-2][0]===v&&function(t){return t.charCodeAt(t.length-1)>=55296&&t.charCodeAt(t.length-1)<=56319}(t[r-2][1])&&t[r-1][0]===d&&n(t[r-1][1])&&t[r][0]===y&&n(t[r][1])&&(e=!0,t[r-1][1]=t[r-2][1].slice(-1)+t[r-1][1],t[r][1]=t[r-2][1].slice(-1)+t[r][1],t[r-2][1]=t[r-2][1].slice(0,-1));if(!e)return t;for(var o=[],r=0;r<t.length;r+=1)t[r][1].length>0&&o.push(t[r]);return o}function p(t,e,n){for(var r=e+n-1;r>=0&&r>=e-1;r--)if(r+1<t.length){var o=t[r],i=t[r+1];o[0]===i[1]&&t.splice(r,2,[o[0],o[1]+i[1]])}return t}var d=-1,y=1,v=0,b=n;b.INSERT=y,b.DELETE=d,b.EQUAL=v,t.exports=b},function(t,e){function n(t){var e=[];for(var n in t)e.push(n);return e}e=t.exports="function"==typeof Object.keys?Object.keys:n,e.shim=n},function(t,e){function n(t){return"[object Arguments]"==Object.prototype.toString.call(t)}function r(t){return t&&"object"==typeof t&&"number"==typeof t.length&&Object.prototype.hasOwnProperty.call(t,"callee")&&!Object.prototype.propertyIsEnumerable.call(t,"callee")||!1}var o="[object Arguments]"==function(){return Object.prototype.toString.call(arguments)}();e=t.exports=o?n:r,e.supported=n,e.unsupported=r},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){return Object.keys(e).reduce(function(n,r){return null==t[r]?n:(e[r]===t[r]?n[r]=e[r]:Array.isArray(e[r])?e[r].indexOf(t[r])<0&&(n[r]=e[r].concat([t[r]])):n[r]=[e[r],t[r]],n)},{})}function a(t){return t.reduce(function(t,e){if(1===e.insert){var n=(0,N.default)(e.attributes);return delete n.image,t.insert({image:e.attributes.image},n)}if(null==e.attributes||!0!==e.attributes.list&&!0!==e.attributes.bullet||(e=(0,N.default)(e),e.attributes.list?e.attributes.list="ordered":(e.attributes.list="bullet",delete e.attributes.bullet)),"string"==typeof e.insert){var r=e.insert.replace(/\\r\\n/g,"\\n").replace(/\\r/g,"\\n");return t.insert(r,e.attributes)}return t.push(e)},new h.default)}Object.defineProperty(e,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},u=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),c=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),f=n(4),h=r(f),p=n(20),d=r(p),y=n(0),v=r(y),b=n(13),g=r(b),m=n(31),_=r(m),O=n(3),w=r(O),x=n(14),k=r(x),E=n(21),N=r(E),j=n(12),A=r(j),q=n(2),T=r(q),P=/^[ -~]*$/,S=function(){function t(e){i(this,t),this.scroll=e,this.delta=this.getDelta()}return c(t,[{key:"applyDelta",value:function(t){var e=this,n=!1;this.scroll.update();var r=this.scroll.length();return this.scroll.batchStart(),t=a(t),t.reduce(function(t,o){var i=o.retain||o.delete||o.insert.length||1,l=o.attributes||{};if(null!=o.insert){if("string"==typeof o.insert){var a=o.insert;a.endsWith("\\n")&&n&&(n=!1,a=a.slice(0,-1)),t>=r&&!a.endsWith("\\n")&&(n=!0),e.scroll.insertAt(t,a);var c=e.scroll.line(t),f=u(c,2),h=f[0],p=f[1],y=(0,T.default)({},(0,O.bubbleFormats)(h));if(h instanceof w.default){var b=h.descendant(v.default.Leaf,p),g=u(b,1),m=g[0];y=(0,T.default)(y,(0,O.bubbleFormats)(m))}l=d.default.attributes.diff(y,l)||{}}else if("object"===s(o.insert)){var _=Object.keys(o.insert)[0];if(null==_)return t;e.scroll.insertAt(t,_,o.insert[_])}r+=i}return Object.keys(l).forEach(function(n){e.scroll.formatAt(t,i,n,l[n])}),t+i},0),t.reduce(function(t,n){return"number"==typeof n.delete?(e.scroll.deleteAt(t,n.delete),t):t+(n.retain||n.insert.length||1)},0),this.scroll.batchEnd(),this.update(t)}},{key:"deleteText",value:function(t,e){return this.scroll.deleteAt(t,e),this.update((new h.default).retain(t).delete(e))}},{key:"formatLine",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this.scroll.update(),Object.keys(r).forEach(function(o){if(null==n.scroll.whitelist||n.scroll.whitelist[o]){var i=n.scroll.lines(t,Math.max(e,1)),l=e;i.forEach(function(e){var i=e.length();if(e instanceof g.default){var a=t-e.offset(n.scroll),s=e.newlineIndex(a+l)-a+1;e.formatAt(a,s,o,r[o])}else e.format(o,r[o]);l-=i})}}),this.scroll.optimize(),this.update((new h.default).retain(t).retain(e,(0,N.default)(r)))}},{key:"formatText",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return Object.keys(r).forEach(function(o){n.scroll.formatAt(t,e,o,r[o])}),this.update((new h.default).retain(t).retain(e,(0,N.default)(r)))}},{key:"getContents",value:function(t,e){return this.delta.slice(t,t+e)}},{key:"getDelta",value:function(){return this.scroll.lines().reduce(function(t,e){return t.concat(e.delta())},new h.default)}},{key:"getFormat",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=[],r=[];0===e?this.scroll.path(t).forEach(function(t){var e=u(t,1),o=e[0];o instanceof w.default?n.push(o):o instanceof v.default.Leaf&&r.push(o)}):(n=this.scroll.lines(t,e),r=this.scroll.descendants(v.default.Leaf,t,e));var o=[n,r].map(function(t){if(0===t.length)return{};for(var e=(0,O.bubbleFormats)(t.shift());Object.keys(e).length>0;){var n=t.shift();if(null==n)return e;e=l((0,O.bubbleFormats)(n),e)}return e});return T.default.apply(T.default,o)}},{key:"getText",value:function(t,e){return this.getContents(t,e).filter(function(t){return"string"==typeof t.insert}).map(function(t){return t.insert}).join("")}},{key:"insertEmbed",value:function(t,e,n){return this.scroll.insertAt(t,e,n),this.update((new h.default).retain(t).insert(o({},e,n)))}},{key:"insertText",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return e=e.replace(/\\r\\n/g,"\\n").replace(/\\r/g,"\\n"),this.scroll.insertAt(t,e),Object.keys(r).forEach(function(o){n.scroll.formatAt(t,e.length,o,r[o])}),this.update((new h.default).retain(t).insert(e,(0,N.default)(r)))}},{key:"isBlank",value:function(){if(0==this.scroll.children.length)return!0;if(this.scroll.children.length>1)return!1;var t=this.scroll.children.head;return t.statics.blotName===w.default.blotName&&(!(t.children.length>1)&&t.children.head instanceof k.default)}},{key:"removeFormat",value:function(t,e){var n=this.getText(t,e),r=this.scroll.line(t+e),o=u(r,2),i=o[0],l=o[1],a=0,s=new h.default;null!=i&&(a=i instanceof g.default?i.newlineIndex(l)-l+1:i.length()-l,s=i.delta().slice(l,l+a-1).insert("\\n"));var c=this.getContents(t,e+a),f=c.diff((new h.default).insert(n).concat(s)),p=(new h.default).retain(t).concat(f);return this.applyDelta(p)}},{key:"update",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,r=this.delta;if(1===e.length&&"characterData"===e[0].type&&e[0].target.data.match(P)&&v.default.find(e[0].target)){var o=v.default.find(e[0].target),i=(0,O.bubbleFormats)(o),l=o.offset(this.scroll),a=e[0].oldValue.replace(_.default.CONTENTS,""),s=(new h.default).insert(a),u=(new h.default).insert(o.value());t=(new h.default).retain(l).concat(s.diff(u,n)).reduce(function(t,e){return e.insert?t.insert(e.insert,i):t.push(e)},new h.default),this.delta=r.compose(t)}else this.delta=this.getDelta(),t&&(0,A.default)(r.compose(t),this.delta)||(t=r.diff(this.delta,n));return t}}]),t}();e.default=S},function(t,e){"use strict";function n(){}function r(t,e,n){this.fn=t,this.context=e,this.once=n||!1}function o(){this._events=new n,this._eventsCount=0}var i=Object.prototype.hasOwnProperty,l="~";Object.create&&(n.prototype=Object.create(null),(new n).__proto__||(l=!1)),o.prototype.eventNames=function(){var t,e,n=[];if(0===this._eventsCount)return n;for(e in t=this._events)i.call(t,e)&&n.push(l?e.slice(1):e);return Object.getOwnPropertySymbols?n.concat(Object.getOwnPropertySymbols(t)):n},o.prototype.listeners=function(t,e){var n=l?l+t:t,r=this._events[n];if(e)return!!r;if(!r)return[];if(r.fn)return[r.fn];for(var o=0,i=r.length,a=new Array(i);o<i;o++)a[o]=r[o].fn;return a},o.prototype.emit=function(t,e,n,r,o,i){var a=l?l+t:t;if(!this._events[a])return!1;var s,u,c=this._events[a],f=arguments.length;if(c.fn){switch(c.once&&this.removeListener(t,c.fn,void 0,!0),f){case 1:return c.fn.call(c.context),!0;case 2:return c.fn.call(c.context,e),!0;case 3:return c.fn.call(c.context,e,n),!0;case 4:return c.fn.call(c.context,e,n,r),!0;case 5:return c.fn.call(c.context,e,n,r,o),!0;case 6:return c.fn.call(c.context,e,n,r,o,i),!0}for(u=1,s=new Array(f-1);u<f;u++)s[u-1]=arguments[u];c.fn.apply(c.context,s)}else{var h,p=c.length;for(u=0;u<p;u++)switch(c[u].once&&this.removeListener(t,c[u].fn,void 0,!0),f){case 1:c[u].fn.call(c[u].context);break;case 2:c[u].fn.call(c[u].context,e);break;case 3:c[u].fn.call(c[u].context,e,n);break;case 4:c[u].fn.call(c[u].context,e,n,r);break;default:if(!s)for(h=1,s=new Array(f-1);h<f;h++)s[h-1]=arguments[h];c[u].fn.apply(c[u].context,s)}}return!0},o.prototype.on=function(t,e,n){var o=new r(e,n||this),i=l?l+t:t;return this._events[i]?this._events[i].fn?this._events[i]=[this._events[i],o]:this._events[i].push(o):(this._events[i]=o,this._eventsCount++),this},o.prototype.once=function(t,e,n){var o=new r(e,n||this,!0),i=l?l+t:t;return this._events[i]?this._events[i].fn?this._events[i]=[this._events[i],o]:this._events[i].push(o):(this._events[i]=o,this._eventsCount++),this},o.prototype.removeListener=function(t,e,r,o){var i=l?l+t:t;if(!this._events[i])return this;if(!e)return 0==--this._eventsCount?this._events=new n:delete this._events[i],this;var a=this._events[i];if(a.fn)a.fn!==e||o&&!a.once||r&&a.context!==r||(0==--this._eventsCount?this._events=new n:delete this._events[i]);else{for(var s=0,u=[],c=a.length;s<c;s++)(a[s].fn!==e||o&&!a[s].once||r&&a[s].context!==r)&&u.push(a[s]);u.length?this._events[i]=1===u.length?u[0]:u:0==--this._eventsCount?this._events=new n:delete this._events[i]}return this},o.prototype.removeAllListeners=function(t){var e;return t?(e=l?l+t:t,this._events[e]&&(0==--this._eventsCount?this._events=new n:delete this._events[e])):(this._events=new n,this._eventsCount=0),this},o.prototype.off=o.prototype.removeListener,o.prototype.addListener=o.prototype.on,o.prototype.setMaxListeners=function(){return this},o.prefixed=l,o.EventEmitter=o,void 0!==t&&(t.exports=o)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){return t instanceof v.default||t instanceof y.BlockEmbed}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},f=n(0),h=r(f),p=n(9),d=r(p),y=n(3),v=r(y),b=n(14),g=r(b),m=n(13),_=r(m),O=n(23),w=r(O),x=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.emitter=n.emitter,Array.isArray(n.whitelist)&&(r.whitelist=n.whitelist.reduce(function(t,e){return t[e]=!0,t},{})),r.domNode.addEventListener("DOMNodeInserted",function(){}),r.optimize(),r.enable(),r}return l(e,t),u(e,[{key:"batchStart",value:function(){this.batch=!0}},{key:"batchEnd",value:function(){this.batch=!1,this.optimize()}},{key:"deleteAt",value:function(t,n){var r=this.line(t),o=s(r,2),i=o[0],l=o[1],a=this.line(t+n),u=s(a,1),f=u[0];if(c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"deleteAt",this).call(this,t,n),null!=f&&i!==f&&l>0){if(i instanceof y.BlockEmbed||f instanceof y.BlockEmbed)return void this.optimize();if(i instanceof _.default){var h=i.newlineIndex(i.length(),!0);if(h>-1&&(i=i.split(h+1))===f)return void this.optimize()}else if(f instanceof _.default){var p=f.newlineIndex(0);p>-1&&f.split(p+1)}var d=f.children.head instanceof g.default?null:f.children.head;i.moveChildren(f,d),i.remove()}this.optimize()}},{key:"enable",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.domNode.setAttribute("contenteditable",t)}},{key:"formatAt",value:function(t,n,r,o){(null==this.whitelist||this.whitelist[r])&&(c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,n,r,o),this.optimize())}},{key:"insertAt",value:function(t,n,r){if(null==r||null==this.whitelist||this.whitelist[n]){if(t>=this.length())if(null==r||null==h.default.query(n,h.default.Scope.BLOCK)){var o=h.default.create(this.statics.defaultChild);this.appendChild(o),null==r&&n.endsWith("\\n")&&(n=n.slice(0,-1)),o.insertAt(0,n,r)}else{var i=h.default.create(n,r);this.appendChild(i)}else c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r);this.optimize()}}},{key:"insertBefore",value:function(t,n){if(t.statics.scope===h.default.Scope.INLINE_BLOT){var r=h.default.create(this.statics.defaultChild);r.appendChild(t),t=r}c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n)}},{key:"leaf",value:function(t){return this.path(t).pop()||[null,-1]}},{key:"line",value:function(t){return t===this.length()?this.line(t-1):this.descendant(a,t)}},{key:"lines",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE;return function t(e,n,r){var o=[],i=r;return e.children.forEachAt(n,r,function(e,n,r){a(e)?o.push(e):e instanceof h.default.Container&&(o=o.concat(t(e,n,i))),i-=r}),o}(this,t,e)}},{key:"optimize",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};!0!==this.batch&&(c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t,n),t.length>0&&this.emitter.emit(d.default.events.SCROLL_OPTIMIZE,t,n))}},{key:"path",value:function(t){return c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"path",this).call(this,t).slice(1)}},{key:"update",value:function(t){if(!0!==this.batch){var n=d.default.sources.USER;"string"==typeof t&&(n=t),Array.isArray(t)||(t=this.observer.takeRecords()),t.length>0&&this.emitter.emit(d.default.events.SCROLL_BEFORE_UPDATE,n,t),c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"update",this).call(this,t.concat([])),t.length>0&&this.emitter.emit(d.default.events.SCROLL_UPDATE,n,t)}}}]),e}(h.default.Scroll);x.blotName="scroll",x.className="ql-editor",x.tagName="DIV",x.defaultChild="block",x.allowedChildren=[v.default,y.BlockEmbed,w.default],e.default=x},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e,n){return"object"===(void 0===e?"undefined":x(e))?Object.keys(e).reduce(function(t,n){return s(t,n,e[n])},t):t.reduce(function(t,r){return r.attributes&&r.attributes[e]?t.push(r):t.insert(r.insert,(0,j.default)({},o({},e,n),r.attributes))},new q.default)}function u(t){if(t.nodeType!==Node.ELEMENT_NODE)return{};return t["__ql-computed-style"]||(t["__ql-computed-style"]=window.getComputedStyle(t))}function c(t,e){for(var n="",r=t.ops.length-1;r>=0&&n.length<e.length;--r){var o=t.ops[r];if("string"!=typeof o.insert)break;n=o.insert+n}return n.slice(-1*e.length)===e}function f(t){return 0!==t.childNodes.length&&["block","list-item"].indexOf(u(t).display)>-1}function h(t,e,n){return t.nodeType===t.TEXT_NODE?n.reduce(function(e,n){return n(t,e)},new q.default):t.nodeType===t.ELEMENT_NODE?[].reduce.call(t.childNodes||[],function(r,o){var i=h(o,e,n);return o.nodeType===t.ELEMENT_NODE&&(i=e.reduce(function(t,e){return e(o,t)},i),i=(o[W]||[]).reduce(function(t,e){return e(o,t)},i)),r.concat(i)},new q.default):new q.default}function p(t,e,n){return s(n,t,!0)}function d(t,e){var n=P.default.Attributor.Attribute.keys(t),r=P.default.Attributor.Class.keys(t),o=P.default.Attributor.Style.keys(t),i={};return n.concat(r).concat(o).forEach(function(e){var n=P.default.query(e,P.default.Scope.ATTRIBUTE);null!=n&&(i[n.attrName]=n.value(t),i[n.attrName])||(n=Y[e],null==n||n.attrName!==e&&n.keyName!==e||(i[n.attrName]=n.value(t)||void 0),null==(n=X[e])||n.attrName!==e&&n.keyName!==e||(n=X[e],i[n.attrName]=n.value(t)||void 0))}),Object.keys(i).length>0&&(e=s(e,i)),e}function y(t,e){var n=P.default.query(t);if(null==n)return e;if(n.prototype instanceof P.default.Embed){var r={},o=n.value(t);null!=o&&(r[n.blotName]=o,e=(new q.default).insert(r,n.formats(t)))}else"function"==typeof n.formats&&(e=s(e,n.blotName,n.formats(t)));return e}function v(t,e){return c(e,"\\n")||e.insert("\\n"),e}function b(){return new q.default}function g(t,e){var n=P.default.query(t);if(null==n||"list-item"!==n.blotName||!c(e,"\\n"))return e;for(var r=-1,o=t.parentNode;!o.classList.contains("ql-clipboard");)"list"===(P.default.query(o)||{}).blotName&&(r+=1),o=o.parentNode;return r<=0?e:e.compose((new q.default).retain(e.length()-1).retain(1,{indent:r}))}function m(t,e){return c(e,"\\n")||(f(t)||e.length()>0&&t.nextSibling&&f(t.nextSibling))&&e.insert("\\n"),e}function _(t,e){if(f(t)&&null!=t.nextElementSibling&&!c(e,"\\n\\n")){var n=t.offsetHeight+parseFloat(u(t).marginTop)+parseFloat(u(t).marginBottom);t.nextElementSibling.offsetTop>t.offsetTop+1.5*n&&e.insert("\\n")}return e}function O(t,e){var n={},r=t.style||{};return r.fontStyle&&"italic"===u(t).fontStyle&&(n.italic=!0),r.fontWeight&&(u(t).fontWeight.startsWith("bold")||parseInt(u(t).fontWeight)>=700)&&(n.bold=!0),Object.keys(n).length>0&&(e=s(e,n)),parseFloat(r.textIndent||0)>0&&(e=(new q.default).insert("\\t").concat(e)),e}function w(t,e){var n=t.data;if("O:P"===t.parentNode.tagName)return e.insert(n.trim());if(0===n.trim().length&&t.parentNode.classList.contains("ql-clipboard"))return e;if(!u(t.parentNode).whiteSpace.startsWith("pre")){var r=function(t,e){return e=e.replace(/[^\\u00a0]/g,""),e.length<1&&t?" ":e};n=n.replace(/\\r\\n/g," ").replace(/\\n/g," "),n=n.replace(/\\s\\s+/g,r.bind(r,!0)),(null==t.previousSibling&&f(t.parentNode)||null!=t.previousSibling&&f(t.previousSibling))&&(n=n.replace(/^\\s+/,r.bind(r,!1))),(null==t.nextSibling&&f(t.parentNode)||null!=t.nextSibling&&f(t.nextSibling))&&(n=n.replace(/\\s+$/,r.bind(r,!1)))}return e.insert(n)}Object.defineProperty(e,"__esModule",{value:!0}),e.matchText=e.matchSpacing=e.matchNewline=e.matchBlot=e.matchAttributor=e.default=void 0;var x="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},k=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),E=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),N=n(2),j=r(N),A=n(4),q=r(A),T=n(0),P=r(T),S=n(6),C=r(S),L=n(10),M=r(L),R=n(7),I=r(R),B=n(34),D=n(35),U=n(13),F=r(U),H=n(24),K=n(36),z=n(37),V=n(38),Z=(0,M.default)("quill:clipboard"),W="__ql-matcher",G=[[Node.TEXT_NODE,w],[Node.TEXT_NODE,m],["br",v],[Node.ELEMENT_NODE,m],[Node.ELEMENT_NODE,y],[Node.ELEMENT_NODE,_],[Node.ELEMENT_NODE,d],[Node.ELEMENT_NODE,O],["li",g],["b",p.bind(p,"bold")],["i",p.bind(p,"italic")],["style",b]],Y=[B.AlignAttribute,K.DirectionAttribute].reduce(function(t,e){return t[e.keyName]=e,t},{}),X=[B.AlignStyle,D.BackgroundStyle,H.ColorStyle,K.DirectionStyle,z.FontStyle,V.SizeStyle].reduce(function(t,e){return t[e.keyName]=e,t},{}),$=function(t){function e(t,n){i(this,e);var r=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.root.addEventListener("paste",r.onPaste.bind(r)),r.container=r.quill.addContainer("ql-clipboard"),r.container.setAttribute("contenteditable",!0),r.container.setAttribute("tabindex",-1),r.matchers=[],G.concat(r.options.matchers).forEach(function(t){var e=k(t,2),o=e[0],i=e[1];(n.matchVisual||i!==_)&&r.addMatcher(o,i)}),r}return a(e,t),E(e,[{key:"addMatcher",value:function(t,e){this.matchers.push([t,e])}},{key:"convert",value:function(t){if("string"==typeof t)return this.container.innerHTML=t.replace(/\\>\\r?\\n +\\</g,"><"),this.convert();var e=this.quill.getFormat(this.quill.selection.savedRange.index);if(e[F.default.blotName]){var n=this.container.innerText;return this.container.innerHTML="",(new q.default).insert(n,o({},F.default.blotName,e[F.default.blotName]))}var r=this.prepareMatching(),i=k(r,2),l=i[0],a=i[1],s=h(this.container,l,a);return c(s,"\\n")&&null==s.ops[s.ops.length-1].attributes&&(s=s.compose((new q.default).retain(s.length()-1).delete(1))),Z.log("convert",this.container.innerHTML,s),this.container.innerHTML="",s}},{key:"dangerouslyPasteHTML",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:C.default.sources.API;if("string"==typeof t)this.quill.setContents(this.convert(t),e),this.quill.setSelection(0,C.default.sources.SILENT);else{var r=this.convert(e);this.quill.updateContents((new q.default).retain(t).concat(r),n),this.quill.setSelection(t+r.length(),C.default.sources.SILENT)}}},{key:"onPaste",value:function(t){var e=this;if(!t.defaultPrevented&&this.quill.isEnabled()){var n=this.quill.getSelection(),r=(new q.default).retain(n.index),o=this.quill.scrollingContainer.scrollTop;this.container.focus(),this.quill.selection.update(C.default.sources.SILENT),setTimeout(function(){r=r.concat(e.convert()).delete(n.length),e.quill.updateContents(r,C.default.sources.USER),e.quill.setSelection(r.length()-n.length,C.default.sources.SILENT),e.quill.scrollingContainer.scrollTop=o,e.quill.focus()},1)}}},{key:"prepareMatching",value:function(){var t=this,e=[],n=[];return this.matchers.forEach(function(r){var o=k(r,2),i=o[0],l=o[1];switch(i){case Node.TEXT_NODE:n.push(l);break;case Node.ELEMENT_NODE:e.push(l);break;default:[].forEach.call(t.container.querySelectorAll(i),function(t){t[W]=t[W]||[],t[W].push(l)})}}),[e,n]}}]),e}(I.default);$.DEFAULTS={matchers:[],matchVisual:!0},e.default=$,e.matchAttributor=d,e.matchBlot=y,e.matchNewline=m,e.matchSpacing=_,e.matchText=w},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e=t.ops[t.ops.length-1];return null!=e&&(null!=e.insert?"string"==typeof e.insert&&e.insert.endsWith("\\n"):null!=e.attributes&&Object.keys(e.attributes).some(function(t){return null!=f.default.query(t,f.default.Scope.BLOCK)}))}function s(t){var e=t.reduce(function(t,e){return t+=e.delete||0},0),n=t.length()-e;return a(t)&&(n-=1),n}Object.defineProperty(e,"__esModule",{value:!0}),e.getLastChangeIndex=e.default=void 0;var u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(0),f=r(c),h=n(6),p=r(h),d=n(7),y=r(d),v=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.lastRecorded=0,r.ignoreChange=!1,r.clear(),r.quill.on(p.default.events.EDITOR_CHANGE,function(t,e,n,o){t!==p.default.events.TEXT_CHANGE||r.ignoreChange||(r.options.userOnly&&o!==p.default.sources.USER?r.transform(e):r.record(e,n))}),r.quill.keyboard.addBinding({key:"Z",shortKey:!0},r.undo.bind(r)),r.quill.keyboard.addBinding({key:"Z",shortKey:!0,shiftKey:!0},r.redo.bind(r)),/Win/i.test(navigator.platform)&&r.quill.keyboard.addBinding({key:"Y",shortKey:!0},r.redo.bind(r)),r}return l(e,t),u(e,[{key:"change",value:function(t,e){if(0!==this.stack[t].length){var n=this.stack[t].pop();this.stack[e].push(n),this.lastRecorded=0,this.ignoreChange=!0,this.quill.updateContents(n[t],p.default.sources.USER),this.ignoreChange=!1;var r=s(n[t]);this.quill.setSelection(r)}}},{key:"clear",value:function(){this.stack={undo:[],redo:[]}}},{key:"cutoff",value:function(){this.lastRecorded=0}},{key:"record",value:function(t,e){if(0!==t.ops.length){this.stack.redo=[];var n=this.quill.getContents().diff(e),r=Date.now();if(this.lastRecorded+this.options.delay>r&&this.stack.undo.length>0){var o=this.stack.undo.pop();n=n.compose(o.undo),t=o.redo.compose(t)}else this.lastRecorded=r;this.stack.undo.push({redo:t,undo:n}),this.stack.undo.length>this.options.maxStack&&this.stack.undo.shift()}}},{key:"redo",value:function(){this.change("redo","undo")}},{key:"transform",value:function(t){this.stack.undo.forEach(function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)}),this.stack.redo.forEach(function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)})}},{key:"undo",value:function(){this.change("undo","redo")}}]),e}(y.default);v.DEFAULTS={delay:1e3,maxStack:100,userOnly:!1},e.default=v,e.getLastChangeIndex=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.IndentClass=void 0;var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"add",value:function(t,n){if("+1"===n||"-1"===n){var r=this.value(t)||0;n="+1"===n?r+1:r-1}return 0===n?(this.remove(t),!0):a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"add",this).call(this,t,n)}},{key:"canAdd",value:function(t,n){return a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"canAdd",this).call(this,t,n)||a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"canAdd",this).call(this,t,parseInt(n))}},{key:"value",value:function(t){return parseInt(a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t))||void 0}}]),e}(u.default.Attributor.Class),f=new c("indent","ql-indent",{scope:u.default.Scope.BLOCK,whitelist:[1,2,3,4,5,6,7,8]});e.IndentClass=f},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(3),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName="blockquote",s.tagName="blockquote",e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=n(3),s=function(t){return t&&t.__esModule?t:{default:t}}(a),u=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,null,[{key:"formats",value:function(t){return this.tagName.indexOf(t.tagName)+1}}]),e}(s.default);u.blotName="header",u.tagName=["H1","H2","H3","H4","H5","H6"],e.default=u},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.ListItem=void 0;var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},c=n(0),f=r(c),h=n(3),p=r(h),d=n(23),y=r(d),v=function(t){function e(){return i(this,e),l(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return a(e,t),s(e,[{key:"format",value:function(t,n){t!==b.blotName||n?u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n):this.replaceWith(f.default.create(this.statics.scope))}},{key:"remove",value:function(){null==this.prev&&null==this.next?this.parent.remove():u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"remove",this).call(this)}},{key:"replaceWith",value:function(t,n){return this.parent.isolate(this.offset(this.parent),this.length()),t===this.parent.statics.blotName?(this.parent.replaceWith(t,n),this):(this.parent.unwrap(),u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replaceWith",this).call(this,t,n))}}],[{key:"formats",value:function(t){return t.tagName===this.tagName?void 0:u(e.__proto__||Object.getPrototypeOf(e),"formats",this).call(this,t)}}]),e}(p.default);v.blotName="list-item",v.tagName="LI";var b=function(t){function e(t){i(this,e);var n=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t)),r=function(e){if(e.target.parentNode===t){var r=n.statics.formats(t),o=f.default.find(e.target);"checked"===r?o.format("list","unchecked"):"unchecked"===r&&o.format("list","checked")}};return t.addEventListener("touchstart",r),t.addEventListener("mousedown",r),n}return a(e,t),s(e,null,[{key:"create",value:function(t){var n="ordered"===t?"OL":"UL",r=u(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,n);return"checked"!==t&&"unchecked"!==t||r.setAttribute("data-checked","checked"===t),r}},{key:"formats",value:function(t){return"OL"===t.tagName?"ordered":"UL"===t.tagName?t.hasAttribute("data-checked")?"true"===t.getAttribute("data-checked")?"checked":"unchecked":"bullet":void 0}}]),s(e,[{key:"format",value:function(t,e){this.children.length>0&&this.children.tail.format(t,e)}},{key:"formats",value:function(){return o({},this.statics.blotName,this.statics.formats(this.domNode))}},{key:"insertBefore",value:function(t,n){if(t instanceof v)u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n);else{var r=null==n?this.length():n.offset(this),o=this.split(r);o.parent.insertBefore(t,o)}}},{key:"optimize",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&n.domNode.tagName===this.domNode.tagName&&n.domNode.getAttribute("data-checked")===this.domNode.getAttribute("data-checked")&&(n.moveChildren(this),n.remove())}},{key:"replace",value:function(t){if(t.statics.blotName!==this.statics.blotName){var n=f.default.create(this.statics.defaultChild);t.moveChildren(n),this.appendChild(n)}u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replace",this).call(this,t)}}]),e}(y.default);b.blotName="list",b.scope=f.default.Scope.BLOCK_BLOT,b.tagName=["OL","UL"],b.defaultChild="list-item",b.allowedChildren=[v],e.ListItem=v,e.default=b},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(39),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName="italic",s.tagName=["EM","I"],e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(5),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,null,[{key:"create",value:function(t){return"super"===t?document.createElement("sup"):"sub"===t?document.createElement("sub"):a(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t)}},{key:"formats",value:function(t){return"SUB"===t.tagName?"sub":"SUP"===t.tagName?"super":void 0}}]),e}(u.default);c.blotName="script",c.tagName=["SUB","SUP"],e.default=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(5),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName="strike",s.tagName="S",e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(5),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName="underline",s.tagName="U",e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=n(15),f=["alt","height","width"],h=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"format",value:function(t,n){f.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}],[{key:"create",value:function(t){var n=a(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return"string"==typeof t&&n.setAttribute("src",this.sanitize(t)),n}},{key:"formats",value:function(t){return f.reduce(function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e},{})}},{key:"match",value:function(t){return/\\.(jpe?g|gif|png)$/.test(t)||/^data:image\\/.+;base64/.test(t)}},{key:"sanitize",value:function(t){return(0,c.sanitize)(t,["http","https","data"])?t:"//:0"}},{key:"value",value:function(t){return t.getAttribute("src")}}]),e}(u.default.Embed);h.blotName="image",h.tagName="IMG",e.default=h},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(3),u=n(15),c=function(t){return t&&t.__esModule?t:{default:t}}(u),f=["height","width"],h=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:"format",value:function(t,n){f.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}],[{key:"create",value:function(t){var n=a(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return n.setAttribute("frameborder","0"),n.setAttribute("allowfullscreen",!0),n.setAttribute("src",this.sanitize(t)),n}},{key:"formats",value:function(t){return f.reduce(function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e},{})}},{key:"sanitize",value:function(t){return c.default.sanitize(t)}},{key:"value",value:function(t){return t.getAttribute("src")}}]),e}(s.BlockEmbed);h.blotName="video",h.className="ql-video",h.tagName="IFRAME",e.default=h},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.FormulaBlot=void 0;var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(33),c=r(u),f=n(6),h=r(f),p=n(7),d=r(p),y=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),a(e,null,[{key:"create",value:function(t){var n=s(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return"string"==typeof t&&(window.katex.render(t,n,{throwOnError:!1,errorColor:"#f00"}),n.setAttribute("data-value",t)),n}},{key:"value",value:function(t){return t.getAttribute("data-value")}}]),e}(c.default);y.blotName="formula",y.className="ql-formula",y.tagName="SPAN";var v=function(t){function e(){o(this,e);var t=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));if(null==window.katex)throw new Error("Formula module requires KaTeX.");return t}return l(e,t),a(e,null,[{key:"register",value:function(){h.default.register(y,!0)}}]),e}(d.default);e.FormulaBlot=y,e.default=v},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.CodeToken=e.CodeBlock=void 0;var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(0),c=r(u),f=n(6),h=r(f),p=n(7),d=r(p),y=n(13),v=r(y),b=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),a(e,[{key:"replaceWith",value:function(t){this.domNode.textContent=this.domNode.textContent,this.attach(),s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replaceWith",this).call(this,t)}},{key:"highlight",value:function(t){var e=this.domNode.textContent;this.cachedText!==e&&((e.trim().length>0||null==this.cachedText)&&(this.domNode.innerHTML=t(e),this.domNode.normalize(),this.attach()),this.cachedText=e)}}]),e}(v.default);b.className="ql-syntax";var g=new c.default.Attributor.Class("token","hljs",{scope:c.default.Scope.INLINE}),m=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if("function"!=typeof r.options.highlight)throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");var l=null;return r.quill.on(h.default.events.SCROLL_OPTIMIZE,function(){clearTimeout(l),l=setTimeout(function(){r.highlight(),l=null},r.options.interval)}),r.highlight(),r}return l(e,t),a(e,null,[{key:"register",value:function(){h.default.register(g,!0),h.default.register(b,!0)}}]),a(e,[{key:"highlight",value:function(){var t=this;if(!this.quill.selection.composing){this.quill.update(h.default.sources.USER);var e=this.quill.getSelection();this.quill.scroll.descendants(b).forEach(function(e){e.highlight(t.options.highlight)}),this.quill.update(h.default.sources.SILENT),null!=e&&this.quill.setSelection(e,h.default.sources.SILENT)}}}]),e}(d.default);m.DEFAULTS={highlight:function(){return null==window.hljs?null:function(t){return window.hljs.highlightAuto(t).value}}(),interval:1e3},e.CodeBlock=b,e.CodeToken=g,e.default=m},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e,n){var r=document.createElement("button");r.setAttribute("type","button"),r.classList.add("ql-"+e),null!=n&&(r.value=n),t.appendChild(r)}function u(t,e){Array.isArray(e[0])||(e=[e]),e.forEach(function(e){var n=document.createElement("span");n.classList.add("ql-formats"),e.forEach(function(t){if("string"==typeof t)s(n,t);else{var e=Object.keys(t)[0],r=t[e];Array.isArray(r)?c(n,e,r):s(n,e,r)}}),t.appendChild(n)})}function c(t,e,n){var r=document.createElement("select");r.classList.add("ql-"+e),n.forEach(function(t){var e=document.createElement("option");!1!==t?e.setAttribute("value",t):e.setAttribute("selected","selected"),r.appendChild(e)}),t.appendChild(r)}Object.defineProperty(e,"__esModule",{value:!0}),e.addControls=e.default=void 0;var f=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),h=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),p=n(4),d=r(p),y=n(0),v=r(y),b=n(6),g=r(b),m=n(10),_=r(m),O=n(7),w=r(O),x=(0,_.default)("quill:toolbar"),k=function(t){function e(t,n){i(this,e);var r=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if(Array.isArray(r.options.container)){var o=document.createElement("div");u(o,r.options.container),t.container.parentNode.insertBefore(o,t.container),r.container=o}else"string"==typeof r.options.container?r.container=document.querySelector(r.options.container):r.container=r.options.container;if(!(r.container instanceof HTMLElement)){var a;return a=x.error("Container required for toolbar",r.options),l(r,a)}return r.container.classList.add("ql-toolbar"),r.controls=[],r.handlers={},Object.keys(r.options.handlers).forEach(function(t){r.addHandler(t,r.options.handlers[t])}),[].forEach.call(r.container.querySelectorAll("button, select"),function(t){r.attach(t)}),r.quill.on(g.default.events.EDITOR_CHANGE,function(t,e){t===g.default.events.SELECTION_CHANGE&&r.update(e)}),r.quill.on(g.default.events.SCROLL_OPTIMIZE,function(){var t=r.quill.selection.getRange(),e=f(t,1),n=e[0];r.update(n)}),r}return a(e,t),h(e,[{key:"addHandler",value:function(t,e){this.handlers[t]=e}},{key:"attach",value:function(t){var e=this,n=[].find.call(t.classList,function(t){return 0===t.indexOf("ql-")});if(n){if(n=n.slice("ql-".length),"BUTTON"===t.tagName&&t.setAttribute("type","button"),null==this.handlers[n]){if(null!=this.quill.scroll.whitelist&&null==this.quill.scroll.whitelist[n])return void x.warn("ignoring attaching to disabled format",n,t);if(null==v.default.query(n))return void x.warn("ignoring attaching to nonexistent format",n,t)}var r="SELECT"===t.tagName?"change":"click";t.addEventListener(r,function(r){var i=void 0;if("SELECT"===t.tagName){if(t.selectedIndex<0)return;var l=t.options[t.selectedIndex];i=!l.hasAttribute("selected")&&(l.value||!1)}else i=!t.classList.contains("ql-active")&&(t.value||!t.hasAttribute("value")),r.preventDefault();e.quill.focus();var a=e.quill.selection.getRange(),s=f(a,1),u=s[0];if(null!=e.handlers[n])e.handlers[n].call(e,i);else if(v.default.query(n).prototype instanceof v.default.Embed){if(!(i=prompt("Enter "+n)))return;e.quill.updateContents((new d.default).retain(u.index).delete(u.length).insert(o({},n,i)),g.default.sources.USER)}else e.quill.format(n,i,g.default.sources.USER);e.update(u)}),this.controls.push([n,t])}}},{key:"update",value:function(t){var e=null==t?{}:this.quill.getFormat(t);this.controls.forEach(function(n){var r=f(n,2),o=r[0],i=r[1];if("SELECT"===i.tagName){var l=void 0;if(null==t)l=null;else if(null==e[o])l=i.querySelector("option[selected]");else if(!Array.isArray(e[o])){var a=e[o];"string"==typeof a&&(a=a.replace(/\\"/g,\'\\\\"\')),l=i.querySelector(\'option[value="\'+a+\'"]\')}null==l?(i.value="",i.selectedIndex=-1):l.selected=!0}else if(null==t)i.classList.remove("ql-active");else if(i.hasAttribute("value")){var s=e[o]===i.getAttribute("value")||null!=e[o]&&e[o].toString()===i.getAttribute("value")||null==e[o]&&!i.getAttribute("value");i.classList.toggle("ql-active",s)}else i.classList.toggle("ql-active",null!=e[o])})}}]),e}(w.default);k.DEFAULTS={},k.DEFAULTS={container:null,handlers:{clean:function(){var t=this,e=this.quill.getSelection();if(null!=e)if(0==e.length){var n=this.quill.getFormat();Object.keys(n).forEach(function(e){null!=v.default.query(e,v.default.Scope.INLINE)&&t.quill.format(e,!1)})}else this.quill.removeFormat(e,g.default.sources.USER)},direction:function(t){var e=this.quill.getFormat().align;"rtl"===t&&null==e?this.quill.format("align","right",g.default.sources.USER):t||"right"!==e||this.quill.format("align",!1,g.default.sources.USER),this.quill.format("direction",t,g.default.sources.USER)},indent:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e),r=parseInt(n.indent||0);if("+1"===t||"-1"===t){var o="+1"===t?1:-1;"rtl"===n.direction&&(o*=-1),this.quill.format("indent",r+o,g.default.sources.USER)}},link:function(t){!0===t&&(t=prompt("Enter link URL:")),this.quill.format("link",t,g.default.sources.USER)},list:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e);"check"===t?"checked"===n.list||"unchecked"===n.list?this.quill.format("list",!1,g.default.sources.USER):this.quill.format("list","unchecked",g.default.sources.USER):this.quill.format("list",t,g.default.sources.USER)}}},e.default=k,e.addControls=u},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>\'},function(t,e){t.exports=\'<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>\'},function(t,e){t.exports=\'<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>\'},function(t,e){t.exports=\'<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>\'},function(t,e){t.exports=\'<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>\'},function(t,e){t.exports=\'<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>\'},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BubbleTooltip=void 0;var a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(2),c=r(u),f=n(9),h=r(f),p=n(44),d=r(p),y=n(22),v=n(26),b=r(v),g=[["bold","italic","link"],[{header:1},{header:2},"blockquote"]],m=function(t){function e(t,n){o(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=g);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add("ql-bubble"),r}return l(e,t),s(e,[{key:"extendToolbar",value:function(t){this.tooltip=new _(this.quill,this.options.bounds),this.tooltip.root.appendChild(t.container),this.buildButtons([].slice.call(t.container.querySelectorAll("button")),b.default),this.buildPickers([].slice.call(t.container.querySelectorAll("select")),b.default)}}]),e}(d.default);m.DEFAULTS=(0,c.default)(!0,{},d.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){t?this.quill.theme.tooltip.edit():this.quill.format("link",!1)}}}}});var _=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.on(h.default.events.EDITOR_CHANGE,function(t,e,n,o){if(t===h.default.events.SELECTION_CHANGE)if(null!=e&&e.length>0&&o===h.default.sources.USER){r.show(),r.root.style.left="0px",r.root.style.width="",r.root.style.width=r.root.offsetWidth+"px";var i=r.quill.getLines(e.index,e.length);if(1===i.length)r.position(r.quill.getBounds(e));else{var l=i[i.length-1],a=r.quill.getIndex(l),s=Math.min(l.length()-1,e.index+e.length-a),u=r.quill.getBounds(new y.Range(a,s));r.position(u)}}else document.activeElement!==r.textbox&&r.quill.hasFocus()&&r.hide()}),r}return l(e,t),s(e,[{key:"listen",value:function(){var t=this;a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"listen",this).call(this),this.root.querySelector(".ql-close").addEventListener("click",function(){t.root.classList.remove("ql-editing")}),this.quill.on(h.default.events.SCROLL_OPTIMIZE,function(){setTimeout(function(){if(!t.root.classList.contains("ql-hidden")){var e=t.quill.getSelection();null!=e&&t.position(t.quill.getBounds(e))}},1)})}},{key:"cancel",value:function(){this.show()}},{key:"position",value:function(t){var n=a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"position",this).call(this,t),r=this.root.querySelector(".ql-tooltip-arrow");if(r.style.marginLeft="",0===n)return n;r.style.marginLeft=-1*n-r.offsetWidth/2+"px"}}]),e}(p.BaseTooltip);_.TEMPLATE=[\'<span class="ql-tooltip-arrow"></span>\',\'<div class="ql-tooltip-editor">\',\'<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">\',\'<a class="ql-close"></a>\',"</div>"].join(""),e.BubbleTooltip=_,e.default=m},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function l(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(2),f=r(c),h=n(9),p=r(h),d=n(44),y=r(d),v=n(15),b=r(v),g=n(22),m=n(26),_=r(m),O=[[{header:["1","2","3",!1]}],["bold","italic","underline","link"],[{list:"ordered"},{list:"bullet"}],["clean"]],w=function(t){function e(t,n){o(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=O);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add("ql-snow"),r}return l(e,t),u(e,[{key:"extendToolbar",value:function(t){t.container.classList.add("ql-snow"),this.buildButtons([].slice.call(t.container.querySelectorAll("button")),_.default),this.buildPickers([].slice.call(t.container.querySelectorAll("select")),_.default),this.tooltip=new x(this.quill,this.options.bounds),t.container.querySelector(".ql-link")&&this.quill.keyboard.addBinding({key:"K",shortKey:!0},function(e,n){t.handlers.link.call(t,!n.format.link)})}}]),e}(y.default);w.DEFAULTS=(0,f.default)(!0,{},y.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){if(t){var e=this.quill.getSelection();if(null==e||0==e.length)return;var n=this.quill.getText(e);/^\\S+@\\S+\\.\\S+$/.test(n)&&0!==n.indexOf("mailto:")&&(n="mailto:"+n);this.quill.theme.tooltip.edit("link",n)}else this.quill.format("link",!1)}}}}});var x=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.preview=r.root.querySelector("a.ql-preview"),r}return l(e,t),u(e,[{key:"listen",value:function(){var t=this;s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"listen",this).call(this),this.root.querySelector("a.ql-action").addEventListener("click",function(e){t.root.classList.contains("ql-editing")?t.save():t.edit("link",t.preview.textContent),e.preventDefault()}),this.root.querySelector("a.ql-remove").addEventListener("click",function(e){if(null!=t.linkRange){var n=t.linkRange;t.restoreFocus(),t.quill.formatText(n,"link",!1,p.default.sources.USER),delete t.linkRange}e.preventDefault(),t.hide()}),this.quill.on(p.default.events.SELECTION_CHANGE,function(e,n,r){if(null!=e){if(0===e.length&&r===p.default.sources.USER){var o=t.quill.scroll.descendant(b.default,e.index),i=a(o,2),l=i[0],s=i[1];if(null!=l){t.linkRange=new g.Range(e.index-s,l.length());var u=b.default.formats(l.domNode);return t.preview.textContent=u,t.preview.setAttribute("href",u),t.show(),void t.position(t.quill.getBounds(t.linkRange))}}else delete t.linkRange;t.hide()}})}},{key:"show",value:function(){s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"show",this).call(this),this.root.removeAttribute("data-mode")}}]),e}(d.BaseTooltip);x.TEMPLATE=[\'<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>\',\'<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">\',\'<a class="ql-action"></a>\',\'<a class="ql-remove"></a>\'].join(""),e.default=w}]).default});\n//# sourceMappingURL=quill.min.js.map'
}, function (t, e, i) {
    t.exports = function () {
        "use strict";
        Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (t) {
            for (var e = (this.document || this.ownerDocument).querySelectorAll(t), i = e.length; --i >= 0 && e.item(i) !== this;);
            return i > -1
        }), Object.assign || Object.defineProperty(Object, "assign", {
            enumerable: !1,
            configurable: !0,
            writable: !0,
            value: function (t) {
                if (null == t) throw new TypeError("Cannot convert first argument to object");
                for (var e = Object(t), i = 1; i < arguments.length; i++) {
                    var n = arguments[i];
                    if (null != n) {
                        n = Object(n);
                        for (var l = Object.keys(Object(n)), r = 0, a = l.length; r < a; r++) {
                            var o = l[r],
                                s = Object.getOwnPropertyDescriptor(n, o);
                            void 0 !== s && s.enumerable && (e[o] = n[o])
                        }
                    }
                }
                return e
            }
        });
        var t = {},
            e = 1,
            i = function (i, n, l, r) {
                void 0 === r && (r = {}), t["jvm:" + n + "::" + e++] = {
                    selector: i,
                    handler: l
                }, i.addEventListener(n, l, r)
            },
            n = function (e, i, n) {
                var l = i.split(":")[1];
                e.removeEventListener(l, n), delete t[i]
            },
            l = function () {
                return t
            },
            r = function () {
                function t(t) {
                    return t instanceof Element ? (this.selector = t, this) : (this.selector = document.querySelector(t), this)
                }
                var e = t.prototype;
                return e.on = function (t, e, n) {
                    return void 0 === n && (n = {}), i(this.selector, t, e, n), this
                }, e.delegate = function (t, e, i) {
                    for (var n in e = e.split(" ")) this.on(e[n], (function (e) {
                        var n = e.target;
                        n.matches(t) && i.call(n, e)
                    }))
                }, e.css = function (t) {
                    for (var e in t) this.selector.style[e] = t[e];
                    return this
                }, e.text = function (t) {
                    return t ? (this.selector.textContent = t, this) : this.selector.textContent
                }, e.attr = function (t, e) {
                    return t && e ? (this.selector.setAttribute(t, e), this) : this.selector.getAttribute(t)
                }, e.addClass = function (t) {
                    return this.selector.classList ? (this.selector.classList.add(t), this) : (-1 == this.selector.className.split(" ").indexOf(t) && (this.selector.className += " " + t), this)
                }, e.append = function (t) {
                    return this.selector.appendChild(t), this
                }, e.show = function () {
                    this.css({
                        display: "block"
                    })
                }, e.hide = function () {
                    this.css({
                        display: "none"
                    })
                }, e.height = function () {
                    return this.selector.offsetHeight
                }, e.width = function () {
                    return this.selector.offsetWidth
                }, t
            }(),
            a = function (t) {
                return function (t) {
                    return !!t && "object" == typeof t
                }(t) && ! function (t) {
                    var e = Object.prototype.toString.call(t);
                    return "[object RegExp]" === e || "[object Date]" === e || function (t) {
                        return t.$$typeof === o
                    }(t)
                }(t)
            },
            o = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;

        function s(t, e) {
            return !1 !== e.clone && e.isMergeableObject(t) ? f((i = t, Array.isArray(i) ? [] : {}), t, e) : t;
            var i
        }

        function c(t, e, i) {
            return t.concat(e).map((function (t) {
                return s(t, i)
            }))
        }

        function u(t) {
            return Object.keys(t).concat(function (t) {
                return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter((function (e) {
                    return t.propertyIsEnumerable(e)
                })) : []
            }(t))
        }

        function h(t, e) {
            try {
                return e in t
            } catch (t) {
                return !1
            }
        }

        function d(t, e, i) {
            var n = {};
            return i.isMergeableObject(t) && u(t).forEach((function (e) {
                n[e] = s(t[e], i)
            })), u(e).forEach((function (l) {
                (function (t, e) {
                    return h(t, e) && !(Object.hasOwnProperty.call(t, e) && Object.propertyIsEnumerable.call(t, e))
                })(t, l) || (h(t, l) && i.isMergeableObject(e[l]) ? n[l] = function (t, e) {
                    if (!e.customMerge) return f;
                    var i = e.customMerge(t);
                    return "function" == typeof i ? i : f
                }(l, i)(t[l], e[l], i) : n[l] = s(e[l], i))
            })), n
        }
        var f = function (t, e, i) {
                (i = i || {}).arrayMerge = i.arrayMerge || c, i.isMergeableObject = i.isMergeableObject || a, i.cloneUnlessOtherwiseSpecified = s;
                var n = Array.isArray(e);
                return n === Array.isArray(t) ? n ? i.arrayMerge(t, e, i) : d(t, e, i) : s(e, i)
            },
            p = function (t) {
                return /\.(jpg|gif|png)$/.test(t)
            },
            g = function (t, e, i, n) {
                void 0 === n && (n = !1);
                var l = document.createElement(t);
                return i && (l[n ? "innerHTML" : "textContent"] = i), e && (l.className = e), l
            },
            m = function (t) {
                return new r(t)
            },
            v = function (t) {
                return t.replace(/[\w]([A-Z])/g, (function (t) {
                    return t[0] + "-" + t[1]
                })).toLowerCase()
            },
            y = function (t) {
                return "function" == typeof t
            },
            b = function (t) {
                return "object" == typeof t
            },
            x = function (t) {
                return Array.isArray(t)
            },
            w = function (t, e) {
                return Object.assign(t, e)
            },
            _ = function (t, e) {
                return f(t, e)
            },
            k = function (t) {
                return Object.keys(t)
            };

        function S(t, e) {
            t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e
        }
        var A = function () {
                function t(t, e) {
                    this._name = t, this.node = this.createElement(t), e && this.set(e)
                }
                var e = t.prototype;
                return e.createElement = function (t) {
                    return document.createElementNS("http://www.w3.org/2000/svg", t)
                }, e.addClass = function (t) {
                    this.node.setAttribute("class", t)
                }, e.getBBox = function () {
                    return this.node.getBBox()
                }, e.set = function (t, e) {
                    if (b(t))
                        for (var i in t) this.applyAttr(i, t[i]);
                    else this.applyAttr(t, e)
                }, e.get = function (t) {
                    return this.style.initial[t]
                }, e.applyAttr = function (t, e) {
                    this.node.setAttribute(v(t), e)
                }, e.remove = function () {
                    this.node.parentNode.removeChild(this.node)
                }, t
            }(),
            M = function (t) {
                function e(e, i, n) {
                    var l;
                    return void 0 === n && (n = {}), (l = t.call(this, e, i) || this).isHovered = !1, l.isSelected = !1, l.style = n, l.style.current = {}, l.updateStyle(), l
                }
                S(e, t);
                var i = e.prototype;
                return i.setStyle = function (t, e) {
                    var i;
                    b(t) ? w(this.style.current, t) : w(this.style.current, ((i = {})[t] = e, i)), this.updateStyle()
                }, i.updateStyle = function () {
                    var t = {};
                    w(t, this.style.initial), w(t, this.style.current), this.isHovered && w(t, this.style.hover), this.isSelected && (w(t, this.style.selected), this.isHovered && w(t, this.style.selectedHover)), this.set(t)
                }, e
            }(A),
            C = function (t) {
                function e(e, i) {
                    return t.call(this, "text", e, i) || this
                }
                return S(e, t), e.prototype.applyAttr = function (e, i) {
                    "text" === e ? this.node.textContent = i : t.prototype.applyAttr.call(this, e, i)
                }, e
            }(M),
            E = function (t) {
                function e(e, i) {
                    return t.call(this, "image", e, i) || this
                }
                return S(e, t), e.prototype.applyAttr = function (e, i) {
                    var n;
                    "image" === e ? (b(i) ? (n = i.url, this.offset = i.offset || [0, 0]) : (n = i, this.offset = [0, 0]), this.node.setAttributeNS("http://www.w3.org/1999/xlink", "href", n), this.width = 23, this.height = 23, this.applyAttr("width", this.width), this.applyAttr("height", this.height), this.applyAttr("x", this.cx - this.width / 2 + this.offset[0]), this.applyAttr("y", this.cy - this.height / 2 + this.offset[1])) : "cx" == e ? (this.cx = i, this.width && this.applyAttr("x", i - this.width / 2 + this.offset[0])) : "cy" == e ? (this.cy = i, this.height && this.applyAttr("y", i - this.height / 2 + this.offset[1])) : t.prototype.applyAttr.apply(this, arguments)
                }, e
            }(M),
            O = function (t) {
                function e(e) {
                    var i;
                    return (i = t.call(this, "svg") || this)._container = e, i._defsElement = new A("defs"), i._rootElement = new A("g", {
                        id: "jvm-regions-group"
                    }), i.node.appendChild(i._defsElement.node), i.node.appendChild(i._rootElement.node), i._container.append(i.node), i
                }
                S(e, t);
                var i = e.prototype;
                return i.setSize = function (t, e) {
                    this.node.setAttribute("width", t), this.node.setAttribute("height", e)
                }, i.applyTransformParams = function (t, e, i) {
                    this._rootElement.node.setAttribute("transform", "scale(" + t + ") translate(" + e + ", " + i + ")")
                }, i.createPath = function (t, e) {
                    var i = new M("path", t, e);
                    return i.node.setAttribute("fill-rule", "evenodd"), this.add(i)
                }, i.createCircle = function (t, e, i) {
                    var n = new M("circle", t, e);
                    return this.add(n, i)
                }, i.createLine = function (t, e, i) {
                    var n = new M("line", t, e);
                    return this.add(n, i)
                }, i.createText = function (t, e, i) {
                    var n = new C(t, e);
                    return this.add(n, i)
                }, i.createImage = function (t, e, i) {
                    var n = new E(t, e);
                    return this.add(n, i)
                }, i.createGroup = function (t) {
                    var e = new A("g");
                    return this.node.appendChild(e.node), t && (e.node.id = t), e.canvas = this, e
                }, i.add = function (t, e) {
                    return (e = e || this._rootElement).node.appendChild(t.node), t
                }, e
            }(A);

        function T(t, e, i) {
            var n = m(e),
                l = -1 === n.attr("class").indexOf("jvm-region") ? "marker" : "region",
                r = "region" === l ? n.attr("data-code") : n.attr("data-index"),
                a = l + ":select";
            return i && (a = l + ".tooltip:show"), {
                event: a,
                type: l,
                code: r,
                element: "region" === l ? t.regions[r].element : t.markers[r].element,
                tooltipText: "region" === l ? t.mapData.paths[r].name || "" : t.markers[r].config.name || ""
            }
        }
        var P = function () {
                function t() {}
                var e = t.prototype;
                return e.getLabelText = function (t, e) {
                    if (e) {
                        if (y(e.render)) {
                            var i = [];
                            return this.config.marker && i.push(this.config.marker), i.push(t), e.render.apply(this, i)
                        }
                        return t
                    }
                }, e.getLabelOffsets = function (t, e) {
                    return y(e.offsets) ? e.offsets(t) : x(e.offsets) ? e.offsets[t] : [0, 0]
                }, e.setStyle = function (t, e) {
                    this.shape.setStyle(t, e)
                }, e.remove = function () {
                    this.shape.remove(), this.label && this.label.remove()
                }, e.hover = function (t) {
                    this._setStatus("isHovered", t)
                }, e.select = function (t) {
                    this._setStatus("isSelected", t)
                }, e._setStatus = function (t, e) {
                    this.shape[t] = e, this.shape.updateStyle(), this[t] = e, this.label && (this.label[t] = e, this.label.updateStyle())
                }, t
            }(),
            L = function (t) {
                function e(e) {
                    var i, n = e.map,
                        l = e.code,
                        r = e.path,
                        a = e.style,
                        o = e.label,
                        s = e.labelStyle,
                        c = e.labelsGroup;
                    (i = t.call(this) || this).config = arguments[0], i.canvas = n.canvas, i.map = n, i.shape = i.canvas.createPath({
                        d: r,
                        dataCode: l
                    }, a), i.shape.addClass("jvm-region jvm-element");
                    var u = i.shape.getBBox(),
                        h = i.getLabelText(l, o);
                    if (o && h) {
                        var d = i.getLabelOffsets(l);
                        i.labelX = u.x + u.width / 2 + d[0], i.labelY = u.y + u.height / 2 + d[1], i.label = i.canvas.createText({
                            text: h,
                            textAnchor: "middle",
                            alignmentBaseline: "central",
                            dataCode: l,
                            x: i.labelX,
                            y: i.labelY
                        }, s, c), i.label.addClass("jvm-region jvm-element")
                    }
                    return i
                }
                return S(e, t), e.prototype.updateLabelPosition = function () {
                    this.label && this.label.set({
                        x: this.labelX * this.map.scale + this.map.transX * this.map.scale,
                        y: this.labelY * this.map.scale + this.map.transY * this.map.scale
                    })
                }, e
            }(P),
            D = function (t) {
                function e(e) {
                    var i, n = e.index,
                        l = e.map,
                        r = e.style,
                        a = e.x1,
                        o = e.y1,
                        s = e.x2,
                        c = e.y2,
                        u = e.group;
                    return (i = t.call(this) || this).shape = l.canvas.createLine({
                        x1: a,
                        y1: o,
                        x2: s,
                        y2: c,
                        dataIndex: n
                    }, r, u), i.shape.addClass("jvm-line"), i
                }
                return S(e, t), e
            }(P);

        function I(t, e) {
            return t.toLowerCase() + ":to:" + e.toLowerCase()
        }
        var j = function (t) {
                function e(e) {
                    var i, n = e.index,
                        l = e.style,
                        r = e.label,
                        a = e.cx,
                        o = e.cy,
                        s = e.map,
                        c = e.group;
                    return (i = t.call(this) || this)._map = s, i._isImage = !!l.initial.image, i.config = arguments[0], i.shape = s.canvas[i._isImage ? "createImage" : "createCircle"]({
                        dataIndex: n,
                        cx: a,
                        cy: o
                    }, i._getStyle(), c), i.shape.addClass("jvm-marker jvm-element"), i._isImage && i.updateLabelPosition(), r && i._createLabel(i.config), i
                }
                S(e, t);
                var i = e.prototype;
                return i.updateLabelPosition = function () {
                    this.label && this.label.set({
                        x: this._labelX * this._map.scale + this._offsets[0] + this._map.transX * this._map.scale + 5 + (this._isImage ? (this.shape.width || 0) / 2 : this.shape.node.r.baseVal.value),
                        y: this._labelY * this._map.scale + this._map.transY * this._map.scale + this._offsets[1]
                    })
                }, i._createLabel = function (t) {
                    var e = t.index,
                        i = t.map,
                        n = t.label,
                        l = t.labelsGroup,
                        r = t.cx,
                        a = t.cy,
                        o = t.marker,
                        s = t.isRecentlyCreated,
                        c = this.getLabelText(e, n);
                    this._labelX = r / i.scale - i.transX, this._labelY = a / i.scale - i.transY, this._offsets = s && o.offsets ? o.offsets : this.getLabelOffsets(e, n), this.label = i.canvas.createText({
                        text: c,
                        dataIndex: e,
                        x: this._labelX,
                        y: this._labelY,
                        dy: "0.6ex"
                    }, i.params.markerLabelStyle, l), this.label.addClass("jvm-marker jvm-element"), s && this.updateLabelPosition()
                }, i._getStyle = function () {
                    var t = {};
                    return this._isImage ? t.initial = {
                        image: this.config.style.initial.image
                    } : t = this.config.style, t
                }, e
            }(P),
            N = function () {
                function t(t) {
                    void 0 === t && (t = {}), this._options = t, this._map = this._options.map, this._series = this._options.series, this._body = g("div", "jvm-legend"), this._options.cssClass && this._body.setAttribute("class", this._options.cssClass), t.vertical ? this._map.legendVertical.appendChild(this._body) : this._map.legendHorizontal.appendChild(this._body), this.render()
                }
                return t.prototype.render = function () {
                    var t, e, i, n = this._series.scale.getTicks(),
                        l = g("div", "jvm-legend-inner");
                    if (this._body.innderHTML = "", this._options.title) {
                        var r = g("div", "jvm-legend-title", this._options.title);
                        this._body.appendChild(r)
                    }
                    this._body.appendChild(l);
                    for (var a = 0; a < n.length; a++) {
                        switch (t = g("div", "jvm-legend-tick"), e = g("div", "jvm-legend-tick-sample"), this._series.config.attribute) {
                            case "fill":
                                p(n[a].value) ? e.style.background = "url(" + n[a].value + ")" : e.style.background = n[a].value;
                                break;
                            case "stroke":
                                e.style.background = n[a].value;
                                break;
                            case "image":
                                e.style.background = "url(" + (b(n[a].value) ? n[a].value.url : n[a].value) + ") no-repeat center center", e.style.backgroundSize = "cover"
                        }
                        t.appendChild(e), i = n[a].label, this._options.labelRender && (i = this._options.labelRender(i));
                        var o = g("div", "jvm-legend-tick-text", i);
                        t.appendChild(o), l.appendChild(t)
                    }
                }, t
            }(),
            R = function () {
                function t(t) {
                    this._scale = t
                }
                var e = t.prototype;
                return e.getValue = function (t) {
                    return this._scale[t]
                }, e.getTicks = function () {
                    var t = [];
                    for (var e in this._scale) t.push({
                        label: e,
                        value: this._scale[e]
                    });
                    return t
                }, t
            }(),
            F = function () {
                function t(t, e, i) {
                    void 0 === t && (t = {}), this._map = i, this._elements = e, this._values = t.values || {}, this.config = t, this.config.attribute = t.attribute || "fill", t.attributes && this.setAttributes(t.attributes), b(t.scale) && (this.scale = new R(t.scale)), this.config.legend && (this.legend = new N(w({
                        map: this._map,
                        series: this
                    }, this.config.legend))), this.setValues(this._values)
                }
                var e = t.prototype;
                return e.setValues = function (t) {
                    var e = {};
                    for (var i in t) t[i] && (e[i] = this.scale.getValue(t[i]));
                    this.setAttributes(e)
                }, e.setAttributes = function (t) {
                    for (var e in t) this._elements[e] && this._elements[e].element.setStyle(this.config.attribute, t[e])
                }, e.clear = function () {
                    var t, e = {};
                    for (t in this._values) this._elements[t] && (e[t] = this._elements[t].element.shape.style.initial[this.config.attribute]);
                    this.setAttributes(e), this._values = {}
                }, t
            }(),
            z = {
                mill: function (t, e, i) {
                    return {
                        x: this.radius * (e - i) * this.radDeg,
                        y: -this.radius * Math.log(Math.tan((45 + .4 * t) * this.radDeg)) / .8
                    }
                },
                merc: function (t, e, i) {
                    return {
                        x: this.radius * (e - i) * this.radDeg,
                        y: -this.radius * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))
                    }
                },
                aea: function (t, e, i) {
                    var n = i * this.radDeg,
                        l = 29.5 * this.radDeg,
                        r = 45.5 * this.radDeg,
                        a = t * this.radDeg,
                        o = e * this.radDeg,
                        s = (Math.sin(l) + Math.sin(r)) / 2,
                        c = Math.cos(l) * Math.cos(l) + 2 * s * Math.sin(l),
                        u = s * (o - n),
                        h = Math.sqrt(c - 2 * s * Math.sin(a)) / s,
                        d = Math.sqrt(c - 2 * s * Math.sin(0)) / s;
                    return {
                        x: h * Math.sin(u) * this.radius,
                        y: -(d - h * Math.cos(u)) * this.radius
                    }
                },
                lcc: function (t, e, i) {
                    var n = i * this.radDeg,
                        l = e * this.radDeg,
                        r = 33 * this.radDeg,
                        a = 45 * this.radDeg,
                        o = t * this.radDeg,
                        s = Math.log(Math.cos(r) * (1 / Math.cos(a))) / Math.log(Math.tan(Math.PI / 4 + a / 2) * (1 / Math.tan(Math.PI / 4 + r / 2))),
                        c = Math.cos(r) * Math.pow(Math.tan(Math.PI / 4 + r / 2), s) / s,
                        u = c * Math.pow(1 / Math.tan(Math.PI / 4 + o / 2), s),
                        h = c * Math.pow(1 / Math.tan(Math.PI / 4 + 0), s);
                    return {
                        x: u * Math.sin(s * (l - n)) * this.radius,
                        y: -(h - u * Math.cos(s * (l - n))) * this.radius
                    }
                }
            };
        z.degRad = 180 / Math.PI, z.radDeg = Math.PI / 180, z.radius = 6381372;
        var H = function () {
                function t(t, e) {
                    var i = t.scale,
                        n = t.values;
                    this._scale = i, this._values = n, this._fromColor = this.hexToRgb(i[0]), this._toColor = this.hexToRgb(i[1]), this._map = e, this.setMinMaxValues(n), this.visualize()
                }
                var e = t.prototype;
                return e.setMinMaxValues = function (t) {
                    for (var e in this.min = Number.MAX_VALUE, this.max = 0, t)(e = parseFloat(t[e])) > this.max && (this.max = e), e < this.min && (this.min = e)
                }, e.visualize = function () {
                    var t, e = {};
                    for (var i in this._values) t = parseFloat(this._values[i]), isNaN(t) || (e[i] = this.getValue(t));
                    this.setAttributes(e)
                }, e.setAttributes = function (t) {
                    for (var e in t) this._map.regions[e] && this._map.regions[e].element.setStyle("fill", t[e])
                }, e.getValue = function (t) {
                    for (var e, i = "#", n = 0; n < 3; n++) i += (1 === (e = Math.round(this._fromColor[n] + (this._toColor[n] - this._fromColor[n]) * ((t - this.min) / (this.max - this.min))).toString(16)).length ? "0" : "") + e;
                    return i
                }, e.hexToRgb = function (t) {
                    var e = 0,
                        i = 0,
                        n = 0;
                    return 4 == t.length ? (e = "0x" + t[1] + t[1], i = "0x" + t[2] + t[2], n = "0x" + t[3] + t[3]) : 7 == t.length && (e = "0x" + t[1] + t[2], i = "0x" + t[3] + t[4], n = "0x" + t[5] + t[6]), [parseInt(e), parseInt(i), parseInt(n)]
                }, t
            }(),
            B = Object.freeze({
                __proto__: null,
                handleContainerEvents: function () {
                    var t, e, i = this,
                        n = !1,
                        l = this;
                    this.params.draggable && (this.container.on("mousemove", (function (i) {
                        return n && (l.transX -= (t - i.pageX) / l.scale, l.transY -= (e - i.pageY) / l.scale, l.applyTransform(), t = i.pageX, e = i.pageY), !1
                    })).on("mousedown", (function (i) {
                        return n = !0, t = i.pageX, e = i.pageY, !1
                    })), m("body").on("mouseup", (function () {
                        n = !1
                    }))), this.params.zoomOnScroll && this.container.on("wheel", (function (t) {
                        var e = 0;
                        e = (t.deltaY || -t.wheelDelta || t.detail) >> 10 || 1, e *= 75;
                        var n = i.container.selector.getBoundingClientRect(),
                            r = t.pageX - n.left - window.pageXOffset,
                            a = t.pageY - n.top - window.pageYOffset,
                            o = Math.pow(1 + l.params.zoomOnScrollSpeed / 1e3, -1.5 * e);
                        l.tooltip && l.tooltip.hide(), l.setScale(l.scale * o, r, a)
                    }), {
                        passive: !0
                    })
                },
                handleElementEvents: function () {
                    var t = this;
                    this.container.delegate(".jvm-element", "mouseover mouseout", (function (e) {
                        var i = T(t, this, !0),
                            n = t.params.showTooltip;
                        "mouseover" === e.type ? e.defaultPrevented || (i.element.hover(!0), n && (t.tooltip.text(i.tooltipText), t.tooltip.show(), t.emit(i.event, [t.tooltip, i.code]))) : (i.element.hover(!1), n && t.tooltip.hide())
                    })), this.container.delegate(".jvm-element", "mouseup", (function (e) {
                        var i = T(t, this);
                        if ("region" === i.type && t.params.regionsSelectable || "marker" === i.type && t.params.markersSelectable && !e.defaultPrevented) {
                            var n = i.element;
                            t.params[i.type + "sSelectableOne"] && t.clearSelected(i.type + "s"), i.element.isSelected ? n.select(!1) : n.select(!0), t.emit(i.event, [i.code, n.isSelected, t.getSelected(i.type + "s")])
                        }
                    }))
                },
                handleZoomButtons: function () {
                    var t = this,
                        e = this,
                        n = g("div", "jvm-zoom-btn jvm-zoomin", "&#43;", !0),
                        l = g("div", "jvm-zoom-btn jvm-zoomout", "&#x2212", !0);
                    this.container.append(n).append(l), i(n, "click", (function () {
                        t.setScale(e.scale * e.params.zoomStep, e.width / 2, e.height / 2, !1, e.params.zoomAnimate)
                    })), i(l, "click", (function () {
                        t.setScale(e.scale / e.params.zoomStep, e.width / 2, e.height / 2, !1, e.params.zoomAnimate)
                    }))
                },
                bindContainerTouchEvents: function () {
                    var t, e, i, n, l, r, a, o = this,
                        s = function (s) {
                            var c, u, h, d, f = s.touches;
                            if ("touchstart" == s.type && (a = 0), 1 == f.length) 1 == a && (h = o.transX, d = o.transY, o.transX -= (i - f[0].pageX) / o.scale, o.transY -= (n - f[0].pageY) / o.scale, o.tooltip.hide(), o.applyTransform(), h == o.transX && d == o.transY || s.preventDefault()), i = f[0].pageX, n = f[0].pageY;
                            else if (2 == f.length)
                                if (2 == a) u = Math.sqrt(Math.pow(f[0].pageX - f[1].pageX, 2) + Math.pow(f[0].pageY - f[1].pageY, 2)) / e, o.setScale(t * u, l, r), o.tooltip.hide(), s.preventDefault();
                                else {
                                    var p = o.container.selector.getBoundingClientRect();
                                    c = {
                                        top: p.top + window.scrollY,
                                        left: p.left + window.scrollX
                                    }, l = f[0].pageX > f[1].pageX ? f[1].pageX + (f[0].pageX - f[1].pageX) / 2 : f[0].pageX + (f[1].pageX - f[0].pageX) / 2, r = f[0].pageY > f[1].pageY ? f[1].pageY + (f[0].pageY - f[1].pageY) / 2 : f[0].pageY + (f[1].pageY - f[0].pageY) / 2, l -= c.left, r -= c.top, t = o.scale, e = Math.sqrt(Math.pow(f[0].pageX - f[1].pageX, 2) + Math.pow(f[0].pageY - f[1].pageY, 2))
                                } a = f.length
                        };
                    this.container.on("touchstart", s).on("touchmove", s)
                },
                createRegions: function () {
                    var t, e;
                    for (t in this.regionLabelsGroup = this.regionLabelsGroup || this.canvas.createGroup("jvm-regions-labels-group"), this.mapData.paths) e = new L({
                        map: this,
                        code: t,
                        path: this.mapData.paths[t].path,
                        style: w({}, this.params.regionStyle),
                        labelStyle: this.params.regionLabelStyle,
                        labelsGroup: this.regionLabelsGroup,
                        label: this.params.labels && this.params.labels.regions
                    }), this.regions[t] = {
                        config: this.mapData.paths[t],
                        element: e
                    }
                },
                createLines: function (t, e, i) {
                    var n = this;
                    void 0 === i && (i = !1);
                    var l, r = !1,
                        a = !1;
                    for (var o in this.linesGroup = this.linesGroup || this.canvas.createGroup("jvm-lines-group"), t) {
                        var s = t[o];
                        for (var c in e) {
                            var u = i ? e[c].config : e[c];
                            u.name === s.from && (r = this.getMarkerPosition(u)), u.name === s.to && (a = this.getMarkerPosition(u))
                        }!1 !== r && !1 !== a && (l = new D({
                            index: o,
                            map: this,
                            style: _({
                                initial: this.params.lineStyle
                            }, {
                                initial: s.style || {}
                            }),
                            x1: r.x,
                            y1: r.y,
                            x2: a.x,
                            y2: a.y,
                            group: this.linesGroup
                        }), i && Object.keys(this.lines).forEach((function (e) {
                            e === I(t[0].from, t[0].to) && n.lines[e].element.remove()
                        })), this.lines[I(s.from, s.to)] = {
                            element: l,
                            config: s
                        })
                    }
                },
                createMarkers: function (t, e) {
                    var i, n, l, r, a = this;
                    for (var o in void 0 === t && (t = {}), void 0 === e && (e = !1), this.markersGroup = this.markersGroup || this.canvas.createGroup("jvm-markers-group"), this.markerLabelsGroup = this.markerLabelsGroup || this.canvas.createGroup("jvm-markers-labels-group"), t) {
                        if (i = t[o], l = this.getMarkerPosition(i), r = i.coords.join(":"), e) {
                            if (k(this.markers).filter((function (t) {
                                    return a.markers[t]._uid === r
                                })).length) continue;
                            o = k(this.markers).length
                        }!1 !== l && (n = new j({
                            index: o,
                            map: this,
                            style: _(this.params.markerStyle, {
                                initial: i.style || {}
                            }),
                            label: this.params.labels && this.params.labels.markers,
                            labelsGroup: this.markerLabelsGroup,
                            cx: l.x,
                            cy: l.y,
                            group: this.markersGroup,
                            marker: i,
                            isRecentlyCreated: e
                        }), this.markers[o] && this.removeMarkers([o]), this.markers[o] = {
                            _uid: r,
                            config: i,
                            element: n
                        })
                    }
                },
                createTooltip: function () {
                    var t = this,
                        e = this,
                        i = g("div", "jvm-tooltip");
                    this.tooltip = m(document.body.appendChild(i)), this.container.on("mousemove", (function (n) {
                        if ("block" === e.tooltip.selector.style.display) {
                            var l = t.container.selector.querySelector("#jvm-regions-group").getBoundingClientRect(),
                                r = i.getBoundingClientRect(),
                                a = r.height,
                                o = r.width,
                                s = n.clientY <= l.top + a + 5,
                                c = n.pageY - a - 5,
                                u = n.pageX - o - 5;
                            s && (c += a + 5, u -= 10), n.clientX < l.left + o + 5 && (u = n.pageX + 5 + 2, s && (u += 10)), t.tooltip.css({
                                top: c + "px",
                                left: u + "px"
                            })
                        }
                    }))
                },
                createSeries: function () {
                    for (var t in this.series = {
                            markers: [],
                            regions: []
                        }, this.params.series)
                        for (var e = 0; e < this.params.series[t].length; e++) this.series[t][e] = new F(this.params.series[t][e], this[t], this)
                },
                applyTransform: function () {
                    var t, e, i, n;
                    this.defaultWidth * this.scale <= this.width ? (t = (this.width - this.defaultWidth * this.scale) / (2 * this.scale), i = (this.width - this.defaultWidth * this.scale) / (2 * this.scale)) : (t = 0, i = (this.width - this.defaultWidth * this.scale) / this.scale), this.defaultHeight * this.scale <= this.height ? (e = (this.height - this.defaultHeight * this.scale) / (2 * this.scale), n = (this.height - this.defaultHeight * this.scale) / (2 * this.scale)) : (e = 0, n = (this.height - this.defaultHeight * this.scale) / this.scale), this.transY > e ? this.transY = e : this.transY < n && (this.transY = n), this.transX > t ? this.transX = t : this.transX < i && (this.transX = i), this.canvas.applyTransformParams(this.scale, this.transX, this.transY), this.markers && this.repositionMarkers(), this.lines && this.repositionLines(), this.repositionLabels()
                },
                setFocus: function (t) {
                    var e = this;
                    void 0 === t && (t = {});
                    var i, n = [];
                    if (t.region ? n.push(t.region) : t.regions && (n = t.regions), n.length) return n.forEach((function (t) {
                        if (e.regions[t]) {
                            var n = e.regions[t].element.shape.getBBox();
                            n && (i = void 0 === i ? n : {
                                x: Math.min(i.x, n.x),
                                y: Math.min(i.y, n.y),
                                width: Math.max(i.x + i.width, n.x + n.width) - Math.min(i.x, n.x),
                                height: Math.max(i.y + i.height, n.y + n.height) - Math.min(i.y, n.y)
                            })
                        }
                    })), this.setScale(Math.min(this.width / i.width, this.height / i.height), -(i.x + i.width / 2), -(i.y + i.height / 2), !0, t.animate);
                    if (t.coords) {
                        var l = this.coordsToPoint(t.coords[0], t.coords[1]),
                            r = this.transX - l.x / this.scale,
                            a = this.transY - l.y / this.scale;
                        return this.setScale(t.scale * this.baseScale, r, a, !0, t.animate)
                    }
                },
                resize: function () {
                    var t = this.baseScale;
                    this.width / this.height > this.defaultWidth / this.defaultHeight ? (this.baseScale = this.height / this.defaultHeight, this.baseTransX = Math.abs(this.width - this.defaultWidth * this.baseScale) / (2 * this.baseScale)) : (this.baseScale = this.width / this.defaultWidth, this.baseTransY = Math.abs(this.height - this.defaultHeight * this.baseScale) / (2 * this.baseScale)), this.scale *= this.baseScale / t, this.transX *= this.baseScale / t, this.transY *= this.baseScale / t
                },
                setScale: function (t, e, i, n, l) {
                    var r, a, o, s, c, u, h, d, f, p, g = this,
                        m = 0,
                        v = Math.abs(Math.round(60 * (t - this.scale) / Math.max(t, this.scale)));
                    t > this.params.zoomMax * this.baseScale ? t = this.params.zoomMax * this.baseScale : t < this.params.zoomMin * this.baseScale && (t = this.params.zoomMin * this.baseScale), void 0 !== e && void 0 !== i && (r = t / this.scale, n ? (f = e + this.defaultWidth * (this.width / (this.defaultWidth * t)) / 2, p = i + this.defaultHeight * (this.height / (this.defaultHeight * t)) / 2) : (f = this.transX - (r - 1) / t * e, p = this.transY - (r - 1) / t * i)), l && v > 0 ? (o = this.scale, s = (t - o) / v, c = this.transX * this.scale, h = this.transY * this.scale, u = (f * t - c) / v, d = (p * t - h) / v, a = setInterval((function () {
                        m += 1, g.scale = o + s * m, g.transX = (c + u * m) / g.scale, g.transY = (h + d * m) / g.scale, g.applyTransform(), m == v && (clearInterval(a), g.emit("viewport:changed", [g.scale, g.transX, g.transY]))
                    }), 10)) : (this.transX = f, this.transY = p, this.scale = t, this.applyTransform(), this.emit("viewport:changed", [this.scale, this.transX, this.transY]))
                },
                updateSize: function () {
                    this.width = this.container.width(), this.height = this.container.height(), this.resize(), this.canvas.setSize(this.width, this.height), this.applyTransform()
                },
                coordsToPoint: function (t, e) {
                    var i, n, l, r = W.maps[this.params.map].projection,
                        a = r.centralMeridian;
                    return i = z[r.type](t, e, a), !!(n = this.getInsetForPoint(i.x, i.y)) && (l = n.bbox, i.x = (i.x - l[0].x) / (l[1].x - l[0].x) * n.width * this.scale, i.y = (i.y - l[0].y) / (l[1].y - l[0].y) * n.height * this.scale, {
                        x: i.x + this.transX * this.scale + n.left * this.scale,
                        y: i.y + this.transY * this.scale + n.top * this.scale
                    })
                },
                getInsetForPoint: function (t, e) {
                    var i, n, l = W.maps[this.params.map].insets;
                    for (i = 0; i < l.length; i++)
                        if (t > (n = l[i].bbox)[0].x && t < n[1].x && e > n[0].y && e < n[1].y) return l[i]
                },
                getMarkerPosition: function (t) {
                    var e = t.coords;
                    return W.maps[this.params.map].projection ? this.coordsToPoint.apply(this, e) : {
                        x: e[0] * this.scale + this.transX * this.scale,
                        y: e[1] * this.scale + this.transY * this.scale
                    }
                },
                repositionLines: function () {
                    var t = !1,
                        e = !1;
                    for (var i in this.lines) {
                        for (var n in this.markers) {
                            var l = this.markers[n];
                            l.config.name === this.lines[i].config.from && (t = this.getMarkerPosition(l.config)), l.config.name === this.lines[i].config.to && (e = this.getMarkerPosition(l.config))
                        }!1 !== t && !1 !== e && this.lines[i].element.setStyle({
                            x1: t.x,
                            y1: t.y,
                            x2: e.x,
                            y2: e.y
                        })
                    }
                },
                repositionMarkers: function () {
                    var t;
                    for (var e in this.markers) !1 !== (t = this.getMarkerPosition(this.markers[e].config)) && this.markers[e].element.setStyle({
                        cx: t.x,
                        cy: t.y
                    })
                },
                repositionLabels: function () {
                    var t = this.params.labels;
                    if (t) {
                        if (t.regions)
                            for (var e in this.regions) this.regions[e].element.updateLabelPosition();
                        if (t.markers)
                            for (var i in this.markers) this.markers[i].element.updateLabelPosition()
                    }
                },
                visualizeData: function (t) {
                    b(t) && (this.dataVisualization = new H(t, this))
                }
            }),
            Y = {
                onViewportChange: "viewport:changed",
                onRegionSelected: "region:select",
                onMarkerSelected: "marker:select",
                onRegionTooltipShow: "region.tooltip:show",
                onMarkerTooltipShow: "marker.tooltip:show",
                onLoaded: "map:loaded"
            },
            W = function () {
                function t(e) {
                    if (void 0 === e && (e = {}), this.params = _(t.defaults, e), !t.maps[this.params.map]) throw new Error("Attempt to use map which was not loaded: " + e.map);
                    this.mapData = t.maps[this.params.map], this.regions = {}, this.markers = {}, this.lines = {}, this.defaultWidth = this.mapData.width, this.defaultHeight = this.mapData.height, this.height = 0, this.width = 0, this.scale = 1, this.baseScale = 1, this.transX = 0, this.transY = 0, this.baseTransX = 0, this.baseTransY = 0, "loading" !== window.document.readyState ? this.init(e.selector) : window.addEventListener("DOMContentLoaded", this.init.bind(this, e.selector))
                }
                var e = t.prototype;
                return e.init = function (t) {
                    this.container = m(t).addClass("jvm-container"), this.canvas = new O(this.container, this.width, this.height), this.setBackgroundColor(this.params.backgroundColor), this.handleContainerEvents(), this.createRegions(), this.updateSize(), this.createLines(this.params.lines || {}, this.params.markers || {}), this.createMarkers(this.params.markers), this.handleElementEvents(), this.repositionLabels(), this.params.showTooltip && this.createTooltip(), this.params.zoomButtons && this.handleZoomButtons(), this.params.selectedRegions && this.setSelected("regions", this.params.selectedRegions), this.params.selectedMarkers && this.setSelected("markers", this.params.selectedMarkers), this.params.focusOn && this.setFocus(this.params.focusOn), this.params.visualizeData && this.visualizeData(this.params.visualizeData), this.params.bindTouchEvents && ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch) && this.bindContainerTouchEvents(), this.params.series && (this.container.append(this.legendHorizontal = g("div", "jvm-series-container jvm-series-h")).append(this.legendVertical = g("div", "jvm-series-container jvm-series-v")), this.createSeries()), this.emit("map:loaded", [this])
                }, e.emit = function (t, e) {
                    for (var i in Y) Y[i] === t && y(this.params[i]) && this.params[i].apply(this, e)
                }, e.setBackgroundColor = function (t) {
                    this.container.css({
                        backgroundColor: t
                    })
                }, e.getSelected = function (t) {
                    var e, i = [];
                    for (e in this[t]) this[t][e].element.isSelected && i.push(e);
                    return i
                }, e.clearSelected = function (t) {
                    var e = this;
                    this.getSelected(t).forEach((function (i) {
                        e[t][i].element.select(!1)
                    }))
                }, e.setSelected = function (t, e) {
                    var i = this;
                    e.forEach((function (e) {
                        i[t][e] && i[t][e].element.select(!0)
                    }))
                }, e.getSelectedRegions = function () {
                    return this.getSelected("regions")
                }, e.clearSelectedRegions = function () {
                    var t = this;
                    this.getSelected("regions").forEach((function (e) {
                        t.regions[e].element.select(!1)
                    }))
                }, e.getSelectedMarkers = function () {
                    return this.getSelected("markers")
                }, e.clearSelectedMarkers = function () {
                    var t = this;
                    this.getSelected("markers").forEach((function (e) {
                        t.markers[e].element.select(!1)
                    }))
                }, e.addMarker = function (t) {
                    this.createMarkers([t], !0)
                }, e.removeMarkers = function (t) {
                    var e = this;
                    t.forEach((function (t) {
                        e.markers[t].element.remove(), delete e.markers[t]
                    }))
                }, e.addLine = function (t, e, i) {
                    void 0 === i && (i = {}), this.createLines([{
                        from: t,
                        to: e,
                        style: i
                    }], this.markers, !0)
                }, e.reset = function () {
                    for (var t in this.series)
                        for (var e = 0; e < this.series[t].length; e++) this.series[t][e].clear();
                    this.scale = this.baseScale, this.transX = this.baseTransX, this.transY = this.baseTransY, this.clearSelectedMarkers(), this.clearSelectedRegions(), this.applyTransform()
                }, e.destroy = function (t) {
                    var e = this;
                    void 0 === t && (t = !0);
                    var i = l(),
                        r = this.tooltip.selector,
                        a = Object.keys;
                    r.parentElement.removeChild(r), a(i).forEach((function (t) {
                        n(i[t].selector, t, i[t].handler)
                    })), t && a(this).forEach((function (t) {
                        try {
                            delete e[t]
                        } catch (t) {}
                    }))
                }, t
            }();
        W.maps = {}, W.defaults = {
            map: "world",
            backgroundColor: "tranparent",
            draggable: !0,
            zoomButtons: !0,
            zoomOnScroll: !0,
            zoomOnScrollSpeed: 3,
            zoomMax: 12,
            zoomMin: 1,
            zoomAnimate: !0,
            showTooltip: !0,
            zoomStep: 1.5,
            bindTouchEvents: !0,
            lineStyle: {
                stroke: "#808080",
                strokeWidth: 1,
                strokeLinecap: "round"
            },
            markersSelectable: !1,
            markersSelectableOne: !1,
            markerStyle: {
                initial: {
                    r: 7,
                    fill: "#374151",
                    fillOpacity: 1,
                    stroke: "#FFF",
                    strokeWidth: 5,
                    strokeOpacity: .5
                },
                hover: {
                    fill: "#3cc0ff",
                    cursor: "pointer"
                },
                selected: {
                    fill: "blue"
                },
                selectedHover: {}
            },
            markerLabelStyle: {
                initial: {
                    fontFamily: "Verdana",
                    fontSize: 12,
                    fontWeight: 500,
                    cursor: "default",
                    fill: "#374151"
                },
                hover: {
                    cursor: "pointer"
                },
                selected: {},
                selectedHover: {}
            },
            regionsSelectable: !1,
            regionsSelectableOne: !1,
            regionStyle: {
                initial: {
                    fill: "#dee2e8",
                    fillOpacity: 1,
                    stroke: "none",
                    strokeWidth: 0
                },
                hover: {
                    fillOpacity: .7,
                    cursor: "pointer"
                },
                selected: {
                    fill: "#9ca3af"
                },
                selectedHover: {}
            },
            regionLabelStyle: {
                initial: {
                    fontFamily: "Verdana",
                    fontSize: "12",
                    fontWeight: "bold",
                    cursor: "default",
                    fill: "#35373e"
                },
                hover: {
                    cursor: "pointer"
                }
            }
        }, Object.assign(W.prototype, B);
        var V = function () {
            function t(t) {
                if (void 0 === t && (t = {}), !t.selector) throw new Error("Selector is not given.");
                return new W(t)
            }
            return t.prototype.addMap = function (t, e) {
                W.maps[t] = e
            }, t
        }();
        return window.jsVectorMap = V
    }()
}, function (t, e) {
    jsVectorMap.prototype.addMap("world", {
        insets: [{
            width: 900,
            top: 0,
            left: 0,
            height: 440.70631074413296,
            bbox: [{
                y: -12671671.123330014,
                x: -20004297.151525836
            }, {
                y: 6930392.025135122,
                x: 20026572.39474939
            }]
        }],
        paths: {
            BD: {
                path: "M651.84,230.21l-0.6,-2.0l-1.36,-1.71l-2.31,-0.11l-0.41,0.48l0.2,0.94l-0.53,0.99l-0.72,-0.36l-0.68,0.35l-1.2,-0.36l-0.37,-2.0l-0.81,-1.86l0.39,-1.46l-0.22,-0.47l-1.14,-0.53l0.29,-0.5l1.48,-0.94l0.03,-0.65l-1.55,-1.22l0.55,-1.14l1.61,0.94l1.04,0.15l0.18,1.54l0.34,0.35l5.64,0.63l-0.84,1.64l-1.22,0.34l-0.77,1.51l0.07,0.47l1.37,1.37l0.67,-0.19l0.42,-1.39l1.21,3.84l-0.03,1.21l-0.33,-0.15l-0.4,0.28Z",
                name: "Bangladesh"
            },
            BE: {
                path: "M429.29,144.05l1.91,0.24l2.1,-0.63l2.63,1.99l-0.21,1.66l-0.69,0.4l-0.18,1.2l-1.66,-1.13l-1.39,0.15l-2.73,-2.7l-1.17,-0.18l-0.16,-0.52l1.54,-0.5Z",
                name: "Belgium"
            },
            BF: {
                path: "M421.42,247.64l-0.11,0.95l0.34,1.16l1.4,1.71l0.07,1.1l0.32,0.37l2.55,0.51l-0.04,1.28l-0.38,0.53l-1.07,0.21l-0.72,1.18l-0.63,0.21l-3.22,-0.25l-0.94,0.39l-5.4,-0.05l-0.39,0.38l0.16,2.73l-1.23,-0.43l-1.17,0.1l-0.89,0.57l-2.27,-1.72l-0.13,-1.11l0.61,-0.96l0.02,-0.93l1.87,-1.98l0.44,-1.81l0.43,-0.39l1.28,0.26l1.05,-0.52l0.47,-0.73l1.84,-1.09l0.55,-0.83l2.2,-1.0l1.15,-0.3l0.72,0.45l1.13,-0.01Z",
                name: "Burkina Faso"
            },
            BG: {
                path: "M491.65,168.18l-0.86,0.88l-0.91,2.17l0.48,1.34l-1.6,-0.24l-2.55,0.95l-0.28,1.51l-1.8,0.22l-2.0,-1.0l-1.92,0.79l-1.42,-0.07l-0.15,-1.63l-1.05,-0.97l0.0,-0.8l1.2,-1.57l0.01,-0.56l-1.14,-1.23l-0.05,-0.94l0.88,0.97l0.88,-0.2l1.91,0.47l3.68,0.16l1.42,-0.81l2.72,-0.66l2.55,1.24Z",
                name: "Bulgaria"
            },
            BA: {
                path: "M463.49,163.65l2.1,0.5l1.72,-0.03l1.52,0.68l-0.36,0.78l0.08,0.45l1.04,1.02l-0.25,0.98l-1.81,1.15l-0.38,1.38l-1.67,-0.87l-0.89,-1.2l-2.11,-1.83l-1.63,-2.22l0.23,-0.57l0.48,0.38l0.55,-0.06l0.43,-0.51l0.94,-0.06Z",
                name: "Bosnia and Herz."
            },
            BN: {
                path: "M707.48,273.58l0.68,-0.65l1.41,-0.91l-0.15,1.63l-0.81,-0.05l-0.61,0.58l-0.53,-0.6Z",
                name: "Brunei"
            },
            BO: {
                path: "M263.83,340.69l-3.09,-0.23l-0.38,0.23l-0.7,1.52l-1.31,-1.53l-3.28,-0.64l-2.37,2.4l-1.31,0.26l-0.88,-3.26l-1.3,-2.86l0.74,-2.37l-0.13,-0.43l-1.2,-1.01l-0.37,-1.89l-1.08,-1.55l1.45,-2.56l-0.96,-2.33l0.47,-1.06l-0.34,-0.73l0.91,-1.32l0.16,-3.84l0.5,-1.18l-1.81,-3.41l2.46,0.07l0.8,-0.85l3.4,-1.91l2.66,-0.35l-0.19,1.38l0.3,1.07l-0.05,1.97l2.72,2.27l2.88,0.49l0.89,0.86l1.79,0.58l0.98,0.7l1.71,0.05l1.17,0.61l0.6,2.7l-0.7,0.54l0.96,2.99l0.37,0.28l4.3,0.1l-0.25,1.2l0.27,1.02l1.43,0.9l0.5,1.35l-0.41,1.86l-0.65,1.08l0.12,1.35l-2.69,-1.65l-2.4,-0.03l-4.36,0.76l-1.49,2.5l-0.11,1.52l-0.75,2.37Z",
                name: "Bolivia"
            },
            JP: {
                path: "M781.12,166.87l1.81,0.68l1.62,-0.97l0.39,2.42l-3.35,0.75l-2.23,2.88l-3.63,-1.9l-0.56,0.2l-1.26,3.05l-2.16,0.03l-0.29,-2.51l1.08,-2.03l2.45,-0.16l0.37,-0.33l1.25,-5.94l2.47,2.71l2.03,1.12ZM773.56,187.34l-0.91,2.22l0.37,1.52l-1.14,1.75l-3.02,1.26l-4.58,0.27l-3.34,3.01l-1.25,-0.8l-0.09,-1.9l-0.46,-0.38l-4.35,0.62l-3.0,1.32l-2.85,0.05l-0.37,0.27l0.13,0.44l2.32,1.89l-1.54,4.34l-1.26,0.9l-0.79,-0.7l0.56,-2.27l-0.21,-0.45l-1.47,-0.75l-0.74,-1.4l2.12,-0.84l1.26,-1.7l2.45,-1.42l1.83,-1.91l4.78,-0.81l2.6,0.57l0.44,-0.21l2.39,-4.66l1.29,1.06l0.5,0.01l5.1,-4.02l1.69,-3.73l-0.38,-3.4l0.9,-1.61l2.14,-0.44l1.23,3.72l-0.07,2.18l-2.23,2.84l-0.04,3.16ZM757.78,196.26l0.19,0.56l-1.01,1.21l-1.16,-0.68l-1.28,0.65l-0.69,1.45l-1.02,-0.5l0.01,-0.93l1.14,-1.38l1.57,0.14l0.85,-0.98l1.4,0.46Z",
                name: "Japan"
            },
            BI: {
                path: "M495.45,295.49l-1.08,-2.99l1.14,-0.11l0.64,-1.19l0.76,0.09l0.65,1.83l-2.1,2.36Z",
                name: "Burundi"
            },
            BJ: {
                path: "M429.57,255.75l-0.05,0.8l0.5,1.34l-0.42,0.86l0.17,0.79l-1.81,2.12l-0.57,1.76l-0.08,5.42l-1.41,0.2l-0.48,-1.36l0.11,-5.71l-0.52,-0.7l-0.2,-1.35l-1.48,-1.48l0.21,-0.9l0.89,-0.43l0.42,-0.92l1.27,-0.36l1.22,-1.34l0.61,-0.0l1.62,1.24Z",
                name: "Benin"
            },
            BT: {
                path: "M650.32,213.86l0.84,0.71l-0.12,1.1l-3.76,-0.11l-1.57,0.4l-1.93,-0.87l1.48,-1.96l1.13,-0.57l1.63,0.57l1.33,0.08l0.99,0.65Z",
                name: "Bhutan"
            },
            JM: {
                path: "M228.38,239.28l-0.8,0.4l-2.26,-1.06l0.84,-0.23l2.14,0.3l1.17,0.56l-1.08,0.03Z",
                name: "Jamaica"
            },
            BW: {
                path: "M483.92,330.07l2.27,4.01l2.83,2.86l0.96,0.31l0.78,2.43l2.13,0.61l1.02,0.76l-3.0,1.64l-2.32,2.02l-1.54,2.69l-1.52,0.45l-0.64,1.94l-1.34,0.52l-1.85,-0.12l-1.21,-0.74l-1.35,-0.3l-1.22,0.62l-0.75,1.37l-2.31,1.9l-1.4,0.21l-0.35,-0.59l0.16,-1.75l-1.48,-2.54l-0.62,-0.43l-0.0,-7.1l2.08,-0.08l0.39,-0.4l0.07,-8.9l5.19,-0.93l0.8,0.89l0.51,0.07l1.5,-0.95l2.21,-0.49Z",
                name: "Botswana"
            },
            BR: {
                path: "M259.98,275.05l3.24,0.7l0.65,-0.53l4.55,-1.32l1.08,-1.06l-0.02,-0.63l0.55,-0.05l0.28,0.28l-0.26,0.87l0.22,0.48l0.73,0.32l0.4,0.81l-0.62,0.86l-0.4,2.13l0.82,2.56l1.69,1.43l1.43,0.2l3.17,-1.68l3.18,0.3l0.65,-0.75l-0.27,-0.92l1.9,-0.09l2.39,0.99l1.06,-0.61l0.84,0.78l1.2,-0.18l1.18,-1.06l0.84,-1.94l1.36,-2.11l0.37,-0.05l1.89,5.45l1.33,0.59l0.05,1.28l-1.77,1.94l0.02,0.56l1.02,0.87l4.07,0.36l0.08,2.16l0.66,0.29l1.74,-1.5l6.97,2.32l1.02,1.22l-0.35,1.18l0.49,0.5l2.81,-0.74l4.77,1.3l3.75,-0.08l3.57,2.0l3.29,2.86l1.93,0.72l2.12,0.12l0.71,0.62l1.21,4.51l-0.95,3.98l-4.72,5.06l-1.64,2.92l-1.72,2.05l-0.8,0.3l-0.72,2.03l0.18,4.75l-0.94,5.53l-0.81,1.13l-0.43,3.36l-2.55,3.5l-0.4,2.51l-1.86,1.04l-0.67,1.53l-2.54,0.01l-3.94,1.01l-1.83,1.2l-2.87,0.82l-3.03,2.19l-2.2,2.83l-0.36,2.0l0.4,1.58l-0.44,2.6l-0.51,1.2l-1.77,1.54l-2.75,4.78l-3.83,3.42l-1.24,2.74l-1.18,1.15l-0.36,-0.83l0.95,-1.14l0.01,-0.5l-1.52,-1.97l-4.56,-3.32l-1.03,-0.0l-2.38,-2.02l-0.81,-0.0l5.34,-5.45l3.77,-2.58l0.22,-2.46l-1.35,-1.81l-0.91,0.07l0.58,-2.33l0.01,-1.54l-1.11,-0.83l-1.75,0.3l-0.44,-3.11l-0.52,-0.95l-1.88,-0.88l-1.24,0.47l-2.17,-0.41l0.15,-3.21l-0.62,-1.34l0.66,-0.73l-0.22,-1.34l0.66,-1.13l0.44,-2.04l-0.61,-1.83l-1.4,-0.86l-0.2,-0.75l0.34,-1.39l-0.38,-0.5l-4.52,-0.1l-0.72,-2.22l0.59,-0.42l-0.03,-1.1l-0.5,-0.87l-0.32,-1.7l-1.45,-0.76l-1.63,-0.02l-1.05,-0.72l-1.6,-0.48l-1.13,-0.99l-2.69,-0.4l-2.47,-2.06l0.13,-4.35l-0.45,-0.45l-3.46,0.5l-3.44,1.94l-0.6,0.74l-2.9,-0.17l-1.47,0.42l-0.72,-0.18l0.15,-3.52l-0.63,-0.34l-1.94,1.41l-1.87,-0.06l-0.83,-1.18l-1.37,-0.26l0.21,-1.01l-1.35,-1.49l-0.88,-1.91l0.56,-0.6l-0.0,-0.81l1.29,-0.62l0.22,-0.43l-0.22,-1.19l0.61,-0.91l0.15,-0.99l2.65,-1.58l1.99,-0.47l0.42,-0.36l2.06,0.11l0.42,-0.33l1.19,-8.0l-0.41,-1.56l-1.1,-1.0l0.01,-1.33l1.91,-0.42l0.08,-0.96l-0.33,-0.43l-1.14,-0.2l-0.02,-0.83l4.47,0.05l0.82,-0.67l0.82,1.81l0.8,0.07l1.15,1.1l2.26,-0.05l0.71,-0.83l2.78,-0.96l0.48,-1.13l1.6,-0.64l0.24,-0.47l-0.48,-0.82l-1.83,-0.19l-0.36,-3.22Z",
                name: "Brazil"
            },
            BS: {
                path: "M226.4,223.87l-0.48,-1.15l-0.84,-0.75l0.36,-1.11l0.95,1.95l0.01,1.06ZM225.56,216.43l-1.87,0.29l-0.04,-0.22l0.74,-0.14l1.17,0.06Z",
                name: "Bahamas"
            },
            BY: {
                path: "M493.84,128.32l0.29,0.7l0.49,0.23l1.19,-0.38l2.09,0.72l0.19,1.26l-0.45,1.24l1.57,2.26l0.89,0.59l0.17,0.81l1.58,0.56l0.4,0.5l-0.53,0.41l-1.87,-0.11l-0.73,0.38l-0.13,0.52l1.04,2.74l-1.91,0.26l-0.89,0.99l-0.11,1.18l-2.73,-0.04l-0.53,-0.62l-0.52,-0.08l-0.75,0.46l-0.91,-0.42l-1.92,-0.07l-2.75,-0.79l-2.6,-0.28l-2.0,0.07l-1.5,0.92l-0.67,0.07l-0.08,-1.22l-0.59,-1.19l1.36,-0.88l0.01,-1.35l-0.7,-1.41l-0.07,-1.0l2.16,-0.02l2.72,-1.3l0.75,-2.04l1.91,-1.04l0.2,-0.41l-0.19,-1.25l3.8,-1.78l2.3,0.77Z",
                name: "Belarus"
            },
            BZ: {
                path: "M198.03,244.38l0.1,-4.49l0.69,-0.06l0.74,-1.3l0.34,0.28l-0.4,1.3l0.17,0.58l-0.34,2.25l-1.3,1.42Z",
                name: "Belize"
            },
            RU: {
                path: "M491.55,115.25l2.55,-1.85l-0.01,-0.65l-2.2,-1.5l7.32,-6.76l1.03,-2.11l-0.13,-0.49l-3.46,-2.52l0.86,-2.7l-2.11,-2.81l1.56,-3.67l-2.77,-4.52l2.15,-2.99l-0.08,-0.55l-3.65,-2.73l0.3,-2.54l1.81,-0.37l4.26,-1.77l2.42,-1.45l4.06,2.61l6.79,1.04l9.34,4.85l1.78,1.88l0.14,2.46l-2.55,2.02l-3.9,1.06l-11.07,-3.14l-2.06,0.53l-0.13,0.7l3.94,2.94l0.31,5.86l0.26,0.36l5.14,2.24l0.58,-0.29l0.32,-1.94l-1.35,-1.78l1.13,-1.09l6.13,2.42l2.11,-0.98l0.18,-0.56l-1.51,-2.67l5.41,-3.76l2.07,0.22l2.26,1.41l0.57,-0.16l1.46,-2.87l-0.05,-0.44l-1.92,-2.32l1.12,-2.32l-1.32,-2.27l5.87,1.16l1.04,1.75l-2.59,0.43l-0.33,0.4l0.02,2.36l2.46,1.83l3.87,-0.91l0.86,-2.8l13.69,-5.65l0.99,0.11l-1.92,2.06l0.23,0.67l3.11,0.45l2.0,-1.48l4.56,-0.12l3.64,-1.73l2.65,2.44l0.56,-0.01l2.85,-2.88l-0.01,-0.57l-2.35,-2.29l0.9,-1.01l7.14,1.3l3.41,1.36l9.05,4.97l0.51,-0.11l1.67,-2.27l-0.05,-0.53l-2.43,-2.21l-0.06,-0.78l-0.34,-0.36l-2.52,-0.36l0.64,-1.93l-1.32,-3.46l-0.06,-1.21l4.48,-4.06l1.69,-4.29l1.6,-0.81l6.23,1.18l0.44,2.21l-2.29,3.64l0.06,0.5l1.47,1.39l0.76,3.0l-0.56,6.03l2.69,2.82l-0.96,2.57l-4.86,5.95l0.23,0.64l2.86,0.61l0.42,-0.17l0.93,-1.4l2.64,-1.03l0.87,-2.24l2.09,-1.96l0.07,-0.5l-1.36,-2.28l1.09,-2.69l-0.32,-0.55l-2.47,-0.33l-0.5,-2.06l1.94,-4.38l-0.06,-0.42l-2.96,-3.4l4.12,-2.88l0.16,-0.4l-0.51,-2.93l0.54,-0.05l1.13,2.25l-0.96,4.35l0.27,0.47l2.68,0.84l0.5,-0.51l-1.02,-2.99l3.79,-1.66l5.01,-0.24l4.53,2.61l0.48,-0.06l0.07,-0.48l-2.18,-3.82l-0.23,-4.67l3.98,-0.9l5.97,0.21l5.49,-0.64l0.27,-0.65l-1.83,-2.31l2.56,-2.9l2.87,-0.17l4.8,-2.47l6.54,-0.67l1.03,-1.42l6.25,-0.45l2.32,1.11l5.53,-2.7l4.5,0.08l0.39,-0.28l0.66,-2.15l2.26,-2.12l5.69,-2.11l3.21,1.29l-2.46,0.94l-0.25,0.42l0.34,0.35l5.41,0.77l0.61,2.33l0.58,0.25l2.2,-1.22l7.13,0.07l5.51,2.47l1.79,1.72l-0.53,2.24l-9.16,4.15l-1.97,1.52l0.16,0.71l6.77,1.91l2.16,-0.78l1.13,2.74l0.67,0.11l1.01,-1.15l3.81,-0.73l7.7,0.77l0.54,1.99l0.36,0.29l10.47,0.71l0.43,-0.38l0.13,-3.23l4.87,0.78l3.95,-0.02l3.83,2.4l1.03,2.71l-1.35,1.79l0.02,0.5l3.15,3.64l4.07,1.96l0.53,-0.18l2.23,-4.47l3.95,1.93l4.16,-1.21l4.73,1.39l2.05,-1.26l3.94,0.62l0.43,-0.55l-1.68,-4.02l2.89,-1.8l22.31,3.03l2.16,2.75l6.55,3.51l10.29,-0.81l4.82,0.73l1.85,1.66l-0.29,3.08l0.25,0.41l3.08,1.26l3.56,-0.88l4.35,-0.11l4.8,0.87l4.57,-0.47l4.23,3.79l0.43,0.07l3.1,-1.4l0.16,-0.6l-1.88,-2.62l0.85,-1.52l7.71,1.21l5.22,-0.26l7.09,2.09l9.59,5.22l6.35,4.11l-0.2,2.38l1.88,1.41l0.6,-0.42l-0.48,-2.53l6.15,0.57l4.4,3.51l-1.97,1.43l-4.0,0.41l-0.36,0.39l-0.06,3.79l-0.74,0.62l-2.07,-0.11l-1.91,-1.39l-3.14,-1.11l-0.78,-1.85l-2.72,-0.68l-2.63,0.49l-1.04,-1.1l0.46,-1.31l-0.5,-0.51l-3.0,0.98l-0.22,0.58l0.99,1.7l-1.21,1.48l-3.04,1.68l-3.12,-0.28l-0.4,0.23l0.09,0.46l2.2,2.09l1.46,3.2l1.15,1.1l0.24,1.33l-0.42,0.67l-4.63,-0.77l-6.96,2.9l-2.19,0.44l-7.6,5.06l-0.84,1.45l-3.61,-2.37l-6.24,2.82l-0.94,-1.15l-0.53,-0.08l-2.28,1.52l-3.2,-0.49l-0.44,0.27l-0.78,2.37l-3.05,3.78l0.09,1.47l0.29,0.36l2.54,0.72l-0.29,4.53l-1.97,0.11l-0.35,0.26l-1.07,2.94l0.8,1.45l-3.91,1.58l-1.05,3.95l-3.48,0.77l-0.3,0.3l-0.72,3.29l-3.09,2.65l-0.7,-1.74l-2.44,-12.44l1.16,-4.71l2.04,-2.06l0.22,-1.64l3.8,-0.86l4.46,-4.61l4.28,-3.81l4.48,-3.01l2.17,-5.63l-0.42,-0.54l-3.04,0.33l-1.77,3.31l-5.86,3.86l-1.86,-4.25l-0.45,-0.23l-6.46,1.3l-6.47,6.44l-0.01,0.55l1.58,1.74l-8.24,1.17l0.15,-2.2l-0.34,-0.42l-3.89,-0.56l-3.25,1.81l-7.62,-0.62l-8.45,1.19l-17.71,15.41l0.22,0.7l3.74,0.41l1.36,2.17l2.43,0.76l1.88,-1.68l2.4,0.2l3.4,3.54l0.08,2.6l-1.95,3.42l-0.21,3.9l-1.1,5.06l-3.71,4.54l-0.87,2.21l-8.29,8.89l-3.19,1.7l-1.32,0.03l-1.45,-1.36l-0.49,-0.04l-2.27,1.5l0.41,-3.65l-0.59,-2.47l1.75,-0.89l2.91,0.53l0.42,-0.2l1.68,-3.03l0.87,-3.46l0.97,-1.18l1.32,-2.88l-0.45,-0.56l-4.14,0.95l-2.19,1.25l-3.41,-0.0l-1.06,-2.93l-2.97,-2.3l-4.28,-1.06l-1.75,-5.07l-2.66,-5.01l-2.29,-1.29l-3.75,-1.01l-3.44,0.08l-3.18,0.62l-2.24,1.77l0.05,0.66l1.18,0.69l0.02,1.43l-1.33,1.05l-2.26,3.51l-0.04,1.43l-3.16,1.84l-2.82,-1.16l-3.01,0.23l-1.35,-1.07l-1.5,-0.35l-3.9,2.31l-3.22,0.52l-2.27,0.79l-3.05,-0.51l-2.21,0.03l-1.48,-1.6l-2.6,-1.63l-2.63,-0.43l-5.46,1.01l-3.23,-1.25l-0.72,-2.57l-5.2,-1.24l-2.75,-1.36l-0.5,0.12l-2.59,3.45l0.84,2.1l-2.06,1.93l-3.41,-0.77l-2.42,-0.12l-1.83,-1.54l-2.53,-0.05l-2.42,-0.98l-3.86,1.57l-4.72,2.78l-3.3,0.75l-1.55,-1.92l-3.0,0.41l-1.11,-1.33l-1.62,-0.59l-1.31,-1.94l-1.38,-0.6l-3.7,0.79l-3.31,-1.83l-0.51,0.11l-0.99,1.29l-5.29,-8.05l-2.96,-2.48l0.65,-0.77l0.01,-0.51l-0.5,-0.11l-6.2,3.21l-1.84,0.15l0.15,-1.39l-0.26,-0.42l-3.22,-1.17l-2.46,0.7l-0.69,-3.16l-0.32,-0.31l-4.5,-0.75l-2.47,1.47l-6.19,1.27l-1.29,0.86l-9.51,1.3l-1.15,1.17l-0.03,0.53l1.47,1.9l-1.89,0.69l-0.22,0.56l0.31,0.6l-2.11,1.44l0.03,0.68l3.75,2.12l-0.39,0.98l-3.23,-0.13l-0.86,0.86l-3.09,-1.59l-3.97,0.07l-2.66,1.35l-8.32,-3.56l-4.07,0.06l-5.39,3.68l-0.39,2.0l-2.03,-1.5l-0.59,0.13l-2.0,3.59l0.57,0.93l-1.28,2.16l0.06,0.48l2.13,2.17l1.95,0.04l1.37,1.82l-0.23,1.46l0.25,0.43l0.83,0.33l-0.8,1.31l-2.49,0.62l-2.49,3.2l0.0,0.49l2.17,2.78l-0.15,2.18l2.5,3.24l-1.58,1.59l-0.7,-0.13l-1.63,-1.72l-2.29,-0.84l-0.94,-1.31l-2.34,-0.63l-1.48,0.4l-0.43,-0.47l-3.51,-1.48l-5.76,-1.01l-0.45,0.19l-2.89,-2.34l-2.9,-1.2l-1.53,-1.29l1.29,-0.43l2.08,-2.61l-0.05,-0.55l-0.89,-0.79l3.05,-1.06l0.27,-0.42l-0.07,-0.69l-0.49,-0.35l-1.73,0.39l0.04,-0.68l1.04,-0.72l2.66,-0.48l0.4,-1.32l-0.5,-1.6l0.92,-1.54l0.03,-1.17l-0.29,-0.37l-3.69,-1.06l-1.41,0.02l-1.42,-1.41l-2.19,0.38l-2.77,-1.01l-0.03,-0.59l-0.89,-1.43l-2.0,-0.32l-0.11,-0.54l0.49,-0.53l0.01,-0.53l-1.6,-1.9l-3.58,0.02l-0.88,0.73l-0.46,-0.07l-1.0,-2.79l2.22,-0.02l0.97,-0.74l0.07,-0.57l-0.9,-1.04l-1.35,-0.48l-0.11,-0.7l-0.95,-0.58l-1.38,-1.99l0.46,-0.98l-0.51,-1.96l-2.45,-0.84l-1.21,0.3l-0.46,-0.76l-2.46,-0.83l-0.72,-1.87l-0.21,-1.69l-0.99,-0.85l0.85,-1.17l-0.7,-3.21l1.66,-1.97l-0.16,-0.79ZM749.2,170.72l-0.6,0.4l-0.13,0.16l-0.01,-0.51l0.74,-0.05ZM874.85,67.94l-5.63,0.48l-0.26,-0.84l3.15,-1.89l1.94,0.01l3.19,1.16l-2.39,1.09ZM797.39,48.49l-2.0,1.36l-3.8,-0.42l-4.25,-1.8l0.35,-0.97l9.69,1.83ZM783.67,46.12l-1.63,3.09l-8.98,-0.13l-4.09,1.14l-4.54,-2.97l1.16,-3.01l3.05,-0.89l6.5,0.22l8.54,2.56ZM778.2,134.98l-0.56,-0.9l0.27,-0.12l0.29,1.01ZM778.34,135.48l0.94,3.53l-0.05,3.38l1.05,3.39l2.18,5.0l-2.89,-0.83l-0.49,0.26l-1.54,4.65l2.42,3.5l-0.04,1.13l-1.24,-1.24l-0.61,0.06l-1.09,1.61l-0.28,-1.61l0.27,-3.1l-0.28,-3.4l0.58,-2.47l0.11,-4.39l-1.46,-3.36l0.21,-4.32l2.15,-1.46l0.07,-0.34ZM771.95,56.61l1.76,-1.42l2.89,-0.42l3.28,1.71l0.14,0.6l-3.27,0.03l-4.81,-0.5ZM683.76,31.09l-13.01,1.93l4.03,-6.35l1.82,-0.56l1.73,0.34l5.99,2.98l-0.56,1.66ZM670.85,27.93l-5.08,0.64l-6.86,-1.57l-3.99,-2.05l-2.1,-4.16l-2.6,-0.87l5.72,-3.5l5.2,-1.28l4.69,2.85l5.59,5.4l-0.56,4.53ZM564.15,68.94l-0.64,0.17l-7.85,-0.57l-0.86,-2.04l-4.28,-1.17l-0.28,-1.94l2.27,-0.89l0.25,-0.39l-0.08,-2.38l4.81,-3.97l-0.15,-0.7l-1.47,-0.38l5.3,-3.81l0.15,-0.44l-0.58,-1.94l5.28,-2.51l8.21,-3.27l8.28,-0.96l4.35,-1.94l4.6,-0.64l1.36,1.61l-1.34,1.28l-16.43,4.94l-7.97,4.88l-7.74,9.63l0.66,4.14l4.16,3.27ZM548.81,18.48l-5.5,1.18l-0.58,1.02l-2.59,0.84l-2.13,-1.07l1.12,-1.42l-0.3,-0.65l-2.33,-0.07l1.68,-0.36l3.47,-0.06l0.42,1.29l0.66,0.16l1.38,-1.34l2.15,-0.88l2.94,1.01l-0.39,0.36ZM477.37,133.15l-4.08,0.05l-2.56,-0.32l0.33,-0.87l3.17,-1.03l3.24,0.96l-0.09,1.23Z",
                name: "Russia"
            },
            RW: {
                path: "M497.0,288.25l0.71,1.01l-0.11,1.09l-1.63,0.03l-1.04,1.39l-0.83,-0.11l0.51,-1.2l0.08,-1.34l0.42,-0.41l0.7,0.14l1.19,-0.61Z",
                name: "Rwanda"
            },
            RS: {
                path: "M469.4,163.99l0.42,-0.5l-0.01,-0.52l-1.15,-1.63l1.43,-0.62l1.33,0.12l1.17,1.06l0.46,1.13l1.34,0.64l0.35,1.35l1.46,0.9l0.76,-0.29l0.2,0.69l-0.48,0.78l0.22,1.12l1.05,1.22l-0.77,0.8l-0.37,1.52l-1.21,0.08l0.24,-0.64l-0.39,-0.54l-2.08,-1.64l-0.9,0.05l-0.48,0.94l-2.12,-1.37l0.53,-1.6l-1.11,-1.37l0.51,-1.1l-0.41,-0.57Z",
                name: "Serbia"
            },
            LT: {
                path: "M486.93,129.3l0.17,1.12l-1.81,0.98l-0.72,2.02l-2.47,1.18l-2.1,-0.02l-0.73,-1.05l-1.06,-0.3l-0.09,-1.87l-3.56,-1.13l-0.43,-2.36l2.48,-0.94l4.12,0.22l2.25,-0.31l0.52,0.69l1.24,0.21l2.19,1.56Z",
                name: "Lithuania"
            },
            LU: {
                path: "M436.08,149.45l-0.48,-0.07l0.3,-1.28l0.27,0.4l-0.09,0.96Z",
                name: "Luxembourg"
            },
            LR: {
                path: "M399.36,265.97l0.18,1.54l-0.48,0.99l0.08,0.47l2.47,1.8l-0.33,2.8l-2.65,-1.13l-5.78,-4.61l0.58,-1.32l2.1,-2.33l0.86,-0.22l0.77,1.14l-0.14,0.85l0.59,0.87l1.0,0.14l0.76,-0.99Z",
                name: "Liberia"
            },
            RO: {
                path: "M487.53,154.23l0.6,0.24l2.87,3.98l-0.17,2.69l0.45,1.42l1.32,0.81l1.35,-0.42l0.76,0.36l0.02,0.31l-0.83,0.45l-0.59,-0.22l-0.54,0.3l-0.62,3.3l-1.0,-0.22l-2.07,-1.13l-2.95,0.71l-1.25,0.76l-3.51,-0.15l-1.89,-0.47l-0.87,0.16l-0.82,-1.3l0.29,-0.26l-0.06,-0.64l-1.09,-0.34l-0.56,0.5l-1.05,-0.64l-0.39,-1.39l-1.36,-0.65l-0.35,-1.0l-0.83,-0.75l1.54,-0.54l2.66,-4.21l2.4,-1.24l2.96,0.34l1.48,0.73l0.79,-0.45l1.78,-0.3l0.75,-0.74l0.79,0.0Z",
                name: "Romania"
            },
            GW: {
                path: "M386.23,253.6l-0.29,0.84l0.15,0.6l-2.21,0.59l-0.86,0.96l-1.04,-0.83l-1.09,-0.23l-0.54,-1.06l-0.66,-0.49l2.41,-0.48l4.13,0.1Z",
                name: "Guinea-Bissau"
            },
            GT: {
                path: "M195.08,249.77l-2.48,-0.37l-1.03,-0.45l-1.14,-0.89l0.3,-0.99l-0.24,-0.68l0.96,-1.66l2.98,-0.01l0.4,-0.37l-0.19,-1.28l-1.67,-1.4l0.51,-0.4l0.0,-1.05l3.85,0.02l-0.21,4.53l0.4,0.43l1.46,0.38l-1.48,0.98l-0.35,0.7l0.12,0.57l-2.2,1.96Z",
                name: "Guatemala"
            },
            GR: {
                path: "M487.07,174.59l-0.59,1.43l-0.37,0.21l-2.84,-0.35l-3.03,0.77l-0.18,0.68l1.28,1.23l-0.61,0.23l-1.14,0.0l-1.2,-1.39l-0.63,0.03l-0.53,1.01l0.56,1.76l1.03,1.19l-0.56,0.38l-0.05,0.62l2.52,2.12l0.02,0.87l-1.78,-0.59l-0.48,0.56l0.5,1.0l-1.07,0.2l-0.3,0.53l0.75,2.01l-0.98,0.02l-1.84,-1.12l-1.37,-4.2l-2.21,-2.95l-0.11,-0.56l1.04,-1.28l0.2,-0.95l0.85,-0.66l0.03,-0.46l1.32,-0.21l1.01,-0.64l1.22,0.05l0.65,-0.56l2.26,-0.0l1.82,-0.75l1.85,1.0l2.28,-0.28l0.35,-0.39l0.01,-0.77l0.34,0.22ZM480.49,192.16l0.58,0.4l-0.68,-0.12l0.11,-0.28ZM482.52,192.82l2.51,0.06l0.24,0.32l-1.99,0.13l-0.77,-0.51Z",
                name: "Greece"
            },
            GQ: {
                path: "M448.79,279.62l0.02,2.22l-4.09,0.0l0.69,-2.27l3.38,0.05Z",
                name: "Eq. Guinea"
            },
            GY: {
                path: "M277.42,270.07l-0.32,1.83l-1.32,0.57l-0.23,0.46l-0.28,2.0l1.11,1.82l0.83,0.19l0.32,1.25l1.13,1.62l-1.21,-0.19l-1.08,0.71l-1.77,0.5l-0.44,0.46l-0.86,-0.09l-1.32,-1.01l-0.77,-2.27l0.36,-1.9l0.68,-1.23l-0.57,-1.17l-0.74,-0.43l0.12,-1.16l-0.9,-0.69l-1.1,0.09l-1.31,-1.48l0.53,-0.72l-0.04,-0.84l1.99,-0.86l0.05,-0.59l-0.71,-0.78l0.14,-0.57l1.66,-1.24l1.36,0.77l1.41,1.49l0.06,1.15l0.37,0.38l0.8,0.05l2.06,1.86Z",
                name: "Guyana"
            },
            GE: {
                path: "M521.71,168.93l5.29,0.89l4.07,2.01l1.41,-0.44l2.07,0.56l0.68,1.1l1.07,0.55l-0.12,0.59l0.98,1.29l-1.01,-0.13l-1.81,-0.83l-0.94,0.47l-3.23,0.43l-2.29,-1.39l-2.33,0.05l0.21,-0.97l-0.76,-2.26l-1.45,-1.12l-1.43,-0.39l-0.41,-0.42Z",
                name: "Georgia"
            },
            GB: {
                path: "M412.61,118.72l-2.19,3.22l-0.0,0.45l5.13,-0.3l-0.53,2.37l-2.2,3.12l0.29,0.63l2.37,0.21l2.33,4.3l1.76,0.69l2.2,5.12l2.94,0.77l-0.23,1.62l-1.15,0.88l-0.1,0.52l0.82,1.42l-1.86,1.43l-3.3,-0.02l-4.12,0.87l-1.04,-0.58l-0.47,0.06l-1.51,1.41l-2.12,-0.34l-1.86,1.18l-0.6,-0.29l3.19,-3.0l2.16,-0.69l0.28,-0.41l-0.34,-0.36l-3.73,-0.53l-0.4,-0.76l2.2,-0.87l0.17,-0.61l-1.26,-1.67l0.36,-1.7l3.38,0.28l0.43,-0.33l0.37,-1.99l-1.79,-2.49l-3.11,-0.72l-0.38,-0.59l0.79,-1.35l-0.04,-0.46l-0.82,-0.97l-0.61,0.01l-0.68,0.84l-0.1,-2.34l-1.23,-1.88l0.85,-3.47l1.77,-2.68l1.85,0.26l2.17,-0.22ZM406.26,132.86l-1.01,1.77l-1.57,-0.59l-1.16,0.01l0.37,-1.54l-0.39,-1.39l1.45,-0.1l2.3,1.84Z",
                name: "United Kingdom"
            },
            GA: {
                path: "M453.24,279.52l-0.08,0.98l0.7,1.29l2.36,0.24l-0.98,2.63l1.18,1.79l0.25,1.78l-0.29,1.52l-0.6,0.93l-1.84,-0.09l-1.23,-1.11l-0.66,0.23l-0.15,0.84l-1.42,0.26l-1.02,0.7l-0.11,0.52l0.77,1.35l-1.34,0.97l-3.94,-4.3l-1.44,-2.45l0.06,-0.6l0.54,-0.81l1.05,-3.46l4.17,-0.07l0.4,-0.4l-0.02,-2.66l2.39,0.21l1.25,-0.27Z",
                name: "Gabon"
            },
            GN: {
                path: "M391.8,254.11l0.47,0.8l1.11,-0.32l0.98,0.7l1.07,0.2l2.26,-1.22l0.64,0.44l1.13,1.56l-0.48,1.4l0.8,0.3l-0.08,0.48l0.46,0.68l-0.35,1.36l1.05,2.61l-1.0,0.69l0.03,1.41l-0.72,-0.06l-1.08,1.0l-0.24,-0.27l0.07,-1.11l-1.05,-1.54l-1.79,0.21l-0.35,-2.01l-1.6,-2.18l-2.0,-0.0l-1.31,0.54l-1.95,2.18l-1.86,-2.19l-1.2,-0.78l-0.3,-1.11l-0.8,-0.85l0.65,-0.72l0.81,-0.03l1.64,-0.8l0.23,-1.87l2.67,0.64l0.89,-0.3l1.21,0.15Z",
                name: "Guinea"
            },
            GM: {
                path: "M379.31,251.39l0.1,-0.35l2.43,-0.07l0.74,-0.61l0.51,-0.03l0.77,0.49l-1.03,-0.3l-1.87,0.9l-1.65,-0.04ZM384.03,250.91l0.91,0.05l0.75,-0.24l-0.59,0.31l-1.08,-0.13Z",
                name: "Gambia"
            },
            GL: {
                path: "M353.02,1.2l14.69,4.67l-3.68,1.89l-22.97,0.86l-0.36,0.27l0.12,0.43l1.55,1.18l8.79,-0.66l7.48,2.07l4.86,-1.77l1.66,1.73l-2.53,3.19l-0.01,0.48l0.46,0.15l6.35,-2.2l12.06,-2.31l7.24,1.13l1.09,1.99l-9.79,4.01l-1.44,1.32l-7.87,0.98l-0.35,0.41l0.38,0.38l5.07,0.24l-2.53,3.58l-2.07,3.81l0.08,6.05l2.57,3.11l-3.22,0.2l-4.12,1.66l-0.05,0.72l4.45,2.65l0.51,3.75l-2.3,0.4l-0.25,0.64l2.79,3.69l-4.82,0.31l-0.36,0.29l0.16,0.44l2.62,1.8l-0.59,1.22l-3.3,0.7l-3.45,0.01l-0.29,0.68l3.03,3.12l0.02,1.34l-4.4,-1.73l-1.72,1.35l0.15,0.66l3.31,1.15l3.13,2.71l0.81,3.16l-3.85,0.75l-4.89,-4.26l-0.47,-0.03l-0.17,0.44l0.79,2.86l-2.71,2.21l-0.13,0.44l0.37,0.27l8.73,0.34l-12.32,6.64l-7.24,1.48l-2.94,0.08l-2.69,1.75l-3.43,4.41l-5.24,2.84l-1.73,0.18l-7.12,2.1l-2.15,2.52l-0.13,2.99l-1.19,2.45l-4.01,3.09l-0.14,0.44l0.97,2.9l-2.28,6.48l-3.1,0.2l-3.83,-3.07l-4.86,-0.02l-2.25,-1.93l-1.7,-3.79l-4.3,-4.84l-1.21,-2.49l-0.44,-3.8l-3.32,-3.63l0.84,-2.86l-1.56,-1.7l2.28,-4.6l3.83,-1.74l1.03,-1.96l0.52,-3.47l-0.59,-0.41l-4.17,2.21l-2.07,0.58l-2.72,-1.28l-0.15,-2.71l0.85,-2.09l2.01,-0.06l5.06,1.2l0.46,-0.23l-0.14,-0.49l-6.54,-4.47l-2.67,0.55l-1.58,-0.86l2.56,-4.01l-0.03,-0.48l-1.5,-1.74l-4.98,-8.5l-3.13,-1.96l0.03,-1.88l-0.24,-0.37l-6.85,-3.02l-5.36,-0.38l-12.7,0.58l-2.78,-1.57l-3.66,-2.77l5.73,-1.45l5.0,-0.28l0.38,-0.38l-0.35,-0.41l-10.67,-1.38l-5.3,-2.06l0.25,-1.54l18.41,-5.26l1.22,-2.27l-0.25,-0.55l-6.14,-1.86l1.68,-1.77l8.55,-4.03l3.59,-0.63l0.3,-0.54l-0.88,-2.27l5.47,-1.47l7.65,-0.95l7.55,-0.05l3.04,1.85l6.48,-3.27l5.81,2.22l3.56,0.5l5.16,1.94l0.5,-0.21l-0.17,-0.52l-5.71,-3.13l0.28,-2.13l8.12,-3.6l8.7,0.28l3.35,-2.34l8.71,-0.6l19.93,0.8Z",
                name: "Greenland"
            },
            KW: {
                path: "M540.81,207.91l0.37,0.86l-0.17,0.76l0.6,1.53l-0.95,0.04l-0.82,-1.28l-1.57,-0.18l1.31,-1.88l1.22,0.17Z",
                name: "Kuwait"
            },
            GH: {
                path: "M420.53,257.51l-0.01,0.72l0.96,1.2l0.24,3.73l0.59,0.95l-0.51,2.1l0.19,1.41l1.02,2.21l-6.97,2.84l-1.8,-0.57l0.04,-0.89l-1.02,-2.04l0.61,-2.65l1.07,-2.32l-0.96,-6.47l5.01,0.07l0.94,-0.39l0.61,0.11Z",
                name: "Ghana"
            },
            OM: {
                path: "M568.09,230.93l-0.91,1.67l-1.22,0.04l-0.6,0.76l-0.41,1.51l0.27,1.58l-1.16,0.05l-1.56,0.97l-0.76,1.74l-1.62,0.05l-0.98,0.65l-0.17,1.15l-0.89,0.52l-1.49,-0.18l-2.4,0.94l-2.47,-5.4l7.35,-2.71l1.67,-5.23l-1.12,-2.09l0.05,-0.83l0.67,-1.0l0.07,-1.05l0.9,-0.42l-0.05,-2.07l0.7,-0.01l1.0,1.62l1.51,1.08l3.3,0.84l1.73,2.29l0.81,0.37l-1.23,2.35l-0.99,0.79Z",
                name: "Oman"
            },
            _2: {
                path: "M531.15,258.94l1.51,0.12l5.13,-0.95l5.3,-1.48l-0.01,4.4l-2.67,3.39l-1.85,0.01l-8.04,-2.94l-2.55,-3.17l1.12,-1.71l2.04,2.34Z",
                name: "Somaliland"
            },
            _1: {
                path: "M472.77,172.64l-1.08,-1.29l0.96,-0.77l0.29,-0.83l1.98,1.64l-0.36,0.67l-1.79,0.58Z",
                name: "Kosovo"
            },
            _0: {
                path: "M504.91,192.87l0.34,0.01l0.27,-0.07l-0.29,0.26l-0.31,-0.2Z",
                name: "N. Cyprus"
            },
            JO: {
                path: "M518.64,201.38l-5.14,1.56l-0.19,0.65l2.16,2.39l-0.89,1.14l-1.71,0.34l-1.71,1.8l-2.34,-0.37l1.21,-4.32l0.56,-4.07l2.8,0.94l4.46,-2.71l0.79,2.66Z",
                name: "Jordan"
            },
            HR: {
                path: "M455.59,162.84l1.09,0.07l-0.82,0.94l-0.27,-1.01ZM456.96,162.92l0.62,-0.41l1.73,0.45l0.42,-0.4l-0.01,-0.59l0.86,-0.52l0.2,-1.05l1.63,-0.68l2.57,1.68l2.07,0.6l0.87,-0.31l1.05,1.57l-0.52,0.63l-1.05,-0.56l-1.68,0.04l-2.1,-0.5l-1.29,0.06l-0.57,0.49l-0.59,-0.47l-0.62,0.16l-0.46,1.7l1.79,2.42l2.79,2.75l-1.18,-0.87l-2.21,-0.87l-1.67,-1.78l0.13,-0.63l-1.05,-1.19l-0.32,-1.27l-1.42,-0.43Z",
                name: "Croatia"
            },
            HT: {
                path: "M237.05,238.38l-1.16,0.43l-0.91,-0.55l0.05,-0.2l2.02,0.31ZM237.53,238.43l1.06,0.12l-0.05,0.01l-1.01,-0.12ZM239.25,238.45l0.79,-0.51l0.06,-0.62l-1.02,-1.0l0.02,-0.82l-0.3,-0.4l-0.93,-0.32l3.16,0.45l0.02,1.84l-0.48,0.34l-0.08,0.58l0.54,0.72l-1.78,-0.26Z",
                name: "Haiti"
            },
            HU: {
                path: "M462.08,157.89l0.65,-1.59l-0.09,-0.44l0.64,-0.0l0.39,-0.34l0.1,-0.69l1.75,0.87l2.32,-0.37l0.43,-0.66l3.49,-0.78l0.69,-0.78l0.57,-0.14l2.57,0.93l0.67,-0.23l1.03,0.65l0.08,0.37l-1.42,0.71l-2.59,4.14l-1.8,0.53l-1.68,-0.1l-2.74,1.23l-1.85,-0.54l-2.54,-1.66l-0.66,-1.1Z",
                name: "Hungary"
            },
            HN: {
                path: "M199.6,249.52l-1.7,-1.21l0.06,-0.94l3.04,-2.14l2.37,0.28l1.27,-0.09l1.1,-0.52l1.3,0.28l1.14,-0.25l1.38,0.37l2.23,1.37l-2.36,0.93l-1.23,-0.39l-0.88,1.3l-1.28,0.99l-0.98,-0.22l-0.42,0.52l-0.96,0.05l-0.36,0.41l0.04,0.88l-0.52,0.6l-0.3,0.04l-0.3,-0.55l-0.66,-0.31l0.11,-0.67l-0.48,-0.65l-0.87,-0.26l-0.73,0.2Z",
                name: "Honduras"
            },
            PR: {
                path: "M256.17,238.73l-0.26,0.27l-2.83,0.05l-0.07,-0.55l1.95,-0.1l1.22,0.33Z",
                name: "Puerto Rico"
            },
            PS: {
                path: "M509.21,203.07l0.1,-0.06l-0.02,0.03l-0.09,0.03ZM509.36,202.91l-0.02,-0.63l-0.33,-0.16l0.31,-1.09l0.24,0.1l-0.2,1.78Z",
                name: "Palestine"
            },
            PT: {
                path: "M401.84,187.38l-0.64,0.47l-1.13,-0.35l-0.91,0.17l0.28,-1.78l-0.24,-1.78l-1.25,-0.56l-0.45,-0.84l0.17,-1.66l1.01,-1.18l0.69,-2.92l-0.04,-1.39l-0.59,-1.9l1.3,-0.85l0.84,1.35l3.1,-0.3l0.46,0.99l-1.05,0.94l-0.03,2.16l-0.41,0.57l-0.08,1.1l-0.79,0.18l-0.26,0.59l0.91,1.6l-0.63,1.75l0.76,1.09l-1.1,1.52l0.07,1.05Z",
                name: "Portugal"
            },
            PY: {
                path: "M274.9,336.12l0.74,1.52l-0.16,3.45l0.32,0.41l2.64,0.5l1.11,-0.47l1.4,0.59l0.36,0.6l0.53,3.42l1.27,0.4l0.98,-0.38l0.51,0.27l-0.0,1.18l-1.21,5.32l-2.09,1.9l-1.8,0.4l-4.71,-0.98l2.2,-3.63l-0.32,-1.5l-2.78,-1.28l-3.03,-1.94l-2.07,-0.44l-4.34,-4.06l0.91,-2.9l0.08,-1.42l1.07,-2.04l4.13,-0.72l2.18,0.03l2.05,1.17l0.03,0.59Z",
                name: "Paraguay"
            },
            PA: {
                path: "M213.8,263.68l0.26,-1.52l-0.36,-0.26l-0.01,-0.49l0.44,-0.1l0.93,1.4l1.26,0.03l0.77,0.49l1.38,-0.23l2.51,-1.11l0.86,-0.72l3.45,0.85l1.4,1.18l0.41,1.74l-0.21,0.34l-0.53,-0.12l-0.47,0.29l-0.16,0.6l-0.68,-1.28l0.45,-0.49l-0.19,-0.66l-0.47,-0.13l-0.54,-0.84l-1.5,-0.75l-1.1,0.16l-0.75,0.99l-1.62,0.84l-0.18,0.96l0.85,0.97l-0.58,0.45l-0.69,0.08l-0.34,-1.18l-1.27,0.03l-0.71,-1.05l-2.59,-0.46Z",
                name: "Panama"
            },
            PG: {
                path: "M808.58,298.86l2.54,2.56l-0.13,0.26l-0.33,0.12l-0.87,-0.78l-1.22,-2.16ZM801.41,293.04l0.5,0.29l0.26,0.27l-0.49,-0.35l-0.27,-0.21ZM803.17,294.58l0.59,0.5l0.08,1.06l-0.29,-0.91l-0.38,-0.65ZM796.68,298.41l0.52,0.75l1.43,-0.19l2.27,-1.81l-0.01,-1.43l1.12,0.16l-0.04,1.1l-0.7,1.28l-1.12,0.18l-0.62,0.79l-2.46,1.11l-1.17,-0.0l-3.08,-1.25l3.41,0.0l0.45,-0.68ZM789.15,303.55l2.31,1.8l1.59,2.61l1.34,0.13l-0.06,0.66l0.31,0.43l1.06,0.24l0.06,0.65l2.25,1.05l-1.22,0.13l-0.72,-0.63l-4.56,-0.65l-3.22,-2.87l-1.49,-2.34l-3.27,-1.1l-2.38,0.72l-1.59,0.86l-0.2,0.42l0.27,1.55l-1.55,0.68l-1.36,-0.4l-2.21,-0.09l-0.08,-15.41l8.39,2.93l2.95,2.4l0.6,1.64l4.02,1.49l0.31,0.68l-1.76,0.21l-0.33,0.52l0.55,1.68Z",
                name: "Papua New Guinea"
            },
            PE: {
                path: "M244.96,295.21l-1.26,-0.07l-0.57,0.42l-1.93,0.45l-2.98,1.75l-0.36,1.36l-0.58,0.8l0.12,1.37l-1.24,0.59l-0.22,1.22l-0.62,0.84l1.04,2.27l1.28,1.44l-0.41,0.84l0.32,0.57l1.48,0.13l1.16,1.37l2.21,0.07l1.63,-1.08l-0.13,3.02l0.3,0.4l1.14,0.29l1.31,-0.34l1.9,3.59l-0.48,0.85l-0.17,3.85l-0.94,1.59l0.35,0.75l-0.47,1.07l0.98,1.97l-2.1,3.82l-0.98,0.5l-2.17,-1.28l-0.39,-1.16l-4.95,-2.58l-4.46,-2.79l-1.84,-1.51l-0.91,-1.84l0.3,-0.96l-2.11,-3.33l-4.82,-9.68l-1.04,-1.2l-0.87,-1.94l-3.4,-2.48l0.58,-1.18l-1.13,-2.23l0.66,-1.49l1.45,-1.15l-0.6,0.98l0.07,0.92l0.47,0.36l1.74,0.03l0.97,1.17l0.54,0.07l1.42,-1.03l0.6,-1.84l1.42,-2.02l3.04,-1.04l2.73,-2.62l0.86,-1.74l-0.1,-1.87l1.44,1.02l0.9,1.25l1.06,0.59l1.7,2.73l1.86,0.31l1.45,-0.61l0.96,0.39l1.36,-0.19l1.45,0.89l-1.4,2.21l0.31,0.61l0.59,0.05l0.47,0.5Z",
                name: "Peru"
            },
            PK: {
                path: "M615.09,192.34l-1.83,1.81l-2.6,0.39l-3.73,-0.68l-1.58,1.33l-0.09,0.42l1.77,4.39l1.7,1.23l-1.69,1.27l-0.12,2.14l-2.33,2.64l-1.6,2.8l-2.46,2.67l-3.03,-0.07l-2.76,2.83l0.05,0.6l1.5,1.11l0.26,1.9l1.44,1.5l0.37,1.68l-5.01,-0.01l-1.78,1.7l-1.42,-0.52l-0.76,-1.87l-2.27,-2.15l-11.61,0.86l0.71,-2.34l3.43,-1.32l0.25,-0.44l-0.21,-1.24l-1.2,-0.65l-0.28,-2.46l-2.29,-1.14l-1.28,-1.94l2.82,0.94l2.62,-0.38l1.42,0.33l0.76,-0.56l1.71,0.19l3.25,-1.14l0.27,-0.36l0.08,-2.19l1.18,-1.32l1.68,0.0l0.58,-0.82l1.6,-0.3l1.19,0.16l0.98,-0.78l0.02,-1.88l0.93,-1.47l1.48,-0.66l0.19,-0.55l-0.66,-1.25l2.04,-0.11l0.69,-1.01l-0.02,-1.16l1.11,-1.06l-0.17,-1.78l-0.49,-1.03l1.15,-0.98l5.42,-0.91l2.6,-0.82l1.6,1.16l0.97,2.34l3.45,0.97Z",
                name: "Pakistan"
            },
            PH: {
                path: "M737.01,263.84l0.39,2.97l-0.44,1.18l-0.55,-1.53l-0.67,-0.14l-1.17,1.28l0.65,2.09l-0.42,0.69l-2.48,-1.23l-0.57,-1.49l0.65,-1.03l-0.1,-0.54l-1.59,-1.19l-0.56,0.08l-0.65,0.87l-1.23,0.0l-1.58,0.97l0.83,-1.8l2.56,-1.42l0.65,0.84l0.45,0.13l1.9,-0.69l0.56,-1.11l1.5,-0.06l0.38,-0.43l-0.09,-1.19l1.21,0.71l0.36,2.02ZM733.59,256.58l0.05,0.75l0.08,0.26l-0.8,-0.42l-0.18,-0.71l0.85,0.12ZM734.08,256.1l-0.12,-1.12l-1.0,-1.27l1.36,0.03l0.53,0.73l0.51,2.04l-1.27,-0.4ZM733.76,257.68l0.38,0.98l-0.32,0.15l-0.07,-1.13ZM724.65,238.43l1.46,0.7l0.72,-0.31l-0.32,1.17l0.79,1.71l-0.57,1.84l-1.53,1.04l-0.39,2.25l0.56,2.04l1.63,0.57l1.16,-0.27l2.71,1.23l-0.19,1.08l0.76,0.84l-0.08,0.36l-1.4,-0.9l-0.88,-1.27l-0.66,0.0l-0.38,0.55l-1.6,-1.31l-2.15,0.36l-0.87,-0.39l0.07,-0.61l0.66,-0.55l-0.01,-0.62l-0.75,-0.59l-0.72,0.44l-0.74,-0.87l-0.39,-2.49l0.32,0.27l0.66,-0.28l0.26,-3.97l0.7,-2.02l1.14,0.0ZM731.03,258.87l-0.88,0.85l-1.19,1.94l-1.05,-1.19l0.93,-1.1l0.32,-1.47l0.52,-0.06l-0.27,1.15l0.22,0.45l0.49,-0.12l1.0,-1.32l-0.08,0.85ZM726.83,255.78l0.83,0.38l1.17,-0.0l-0.02,0.48l-2.0,1.4l0.03,-2.26ZM724.81,252.09l-0.38,1.27l-1.42,-1.95l1.2,0.05l0.6,0.63ZM716.55,261.82l1.1,-0.95l0.03,-0.03l-0.28,0.36l-0.85,0.61ZM719.22,259.06l0.04,-0.06l0.8,-1.53l0.16,0.75l-1.0,0.84Z",
                name: "Philippines"
            },
            PL: {
                path: "M468.44,149.42l-1.11,-1.54l-1.86,-0.33l-0.48,-1.05l-1.72,-0.37l-0.65,0.69l-0.72,-0.36l0.11,-0.61l-0.33,-0.46l-1.75,-0.27l-1.04,-0.93l-0.94,-1.94l0.16,-1.22l-0.62,-1.8l-0.78,-1.07l0.57,-1.04l-0.48,-1.43l1.41,-0.83l6.91,-2.71l2.14,0.5l0.52,0.91l5.51,0.44l4.55,-0.05l1.07,0.31l0.48,0.84l0.15,1.58l0.65,1.2l-0.01,0.99l-1.27,0.58l-0.19,0.54l0.73,1.48l0.08,1.55l1.2,2.76l-0.17,0.58l-1.23,0.44l-2.27,2.72l0.18,0.95l-1.97,-1.03l-1.98,0.4l-1.36,-0.28l-1.24,0.58l-1.07,-0.97l-1.16,0.24Z",
                name: "Poland"
            },
            ZM: {
                path: "M481.47,313.3l0.39,0.31l2.52,0.14l0.99,1.17l2.01,0.35l1.4,-0.64l0.69,1.17l1.78,0.33l1.84,2.35l2.23,0.18l0.4,-0.43l-0.21,-2.74l-0.62,-0.3l-0.48,0.32l-1.98,-1.17l0.72,-5.29l-0.51,-1.18l0.57,-1.3l3.68,-0.62l0.26,0.63l1.21,0.63l0.9,-0.22l2.16,0.67l1.33,0.71l1.07,1.02l0.56,1.87l-0.88,2.7l0.43,2.09l-0.73,0.87l-0.76,2.37l0.59,0.68l-6.6,1.83l-0.29,0.44l0.19,1.45l-1.68,0.35l-1.43,1.02l-0.38,0.87l-0.87,0.26l-3.48,3.69l-4.16,-0.53l-1.52,-1.0l-1.77,-0.13l-1.83,0.52l-3.04,-3.4l0.11,-7.59l4.82,0.03l0.39,-0.49l-0.18,-0.76l0.33,-0.83l-0.4,-1.36l0.24,-1.05Z",
                name: "Zambia"
            },
            EH: {
                path: "M384.42,230.28l0.25,-0.79l1.06,-1.29l0.8,-3.51l3.38,-2.78l0.7,-1.81l0.06,4.84l-1.98,0.2l-0.94,1.59l0.39,3.56l-3.7,-0.01ZM392.01,218.1l0.7,-1.8l1.77,-0.24l2.09,0.34l0.95,-0.62l1.28,-0.07l-0.0,2.51l-6.79,-0.12Z",
                name: "W. Sahara"
            },
            EE: {
                path: "M485.71,115.04l2.64,0.6l2.56,0.11l-1.6,1.91l0.61,3.54l-0.81,0.87l-1.78,-0.01l-3.22,-1.76l-1.8,0.45l0.21,-1.53l-0.58,-0.41l-0.69,0.34l-1.26,-1.03l-0.17,-1.63l2.83,-0.92l3.05,-0.52Z",
                name: "Estonia"
            },
            EG: {
                path: "M492.06,205.03l1.46,0.42l2.95,-1.64l2.04,-0.21l1.53,0.3l0.59,1.19l0.69,0.04l0.41,-0.64l1.81,0.58l1.95,0.16l1.04,-0.51l1.42,4.08l-2.03,4.54l-1.66,-1.77l-1.76,-3.85l-0.64,-0.12l-0.36,0.67l1.04,2.88l3.44,6.95l1.78,3.04l2.03,2.65l-0.36,0.53l0.23,2.01l2.7,2.19l-28.41,0.0l0.0,-18.96l-0.73,-2.2l0.59,-1.56l-0.32,-1.26l0.68,-0.99l3.06,-0.04l4.82,1.52Z",
                name: "Egypt"
            },
            ZA: {
                path: "M467.14,373.21l-0.13,-1.96l-0.68,-1.56l0.7,-0.68l-0.13,-2.33l-4.56,-8.19l0.77,-0.86l0.6,0.45l0.69,1.31l2.83,0.72l1.5,-0.26l2.24,-1.39l0.19,-9.55l1.35,2.3l-0.21,1.5l0.61,1.2l0.4,0.19l1.79,-0.27l2.6,-2.07l0.69,-1.32l0.96,-0.48l2.19,1.04l2.04,0.13l1.77,-0.65l0.85,-2.12l1.38,-0.33l1.59,-2.76l2.15,-1.89l3.41,-1.87l2.0,0.45l1.02,-0.28l0.99,0.2l1.75,5.29l-0.38,3.25l-0.81,-0.23l-1.0,0.46l-0.87,1.68l-0.05,1.16l1.97,1.84l1.47,-0.29l0.69,-1.18l1.09,0.01l-0.76,3.69l-0.58,1.09l-2.2,1.79l-3.17,4.76l-2.8,2.83l-3.57,2.88l-2.53,1.05l-1.22,0.14l-0.51,0.7l-1.18,-0.32l-1.39,0.5l-2.59,-0.52l-1.61,0.33l-1.18,-0.11l-2.55,1.1l-2.1,0.44l-1.6,1.07l-0.85,0.05l-0.93,-0.89l-0.93,-0.15l-0.97,-1.13l-0.25,0.05ZM491.45,364.19l0.62,-0.93l1.48,-0.59l1.18,-2.19l-0.07,-0.49l-1.99,-1.69l-1.66,0.56l-1.43,1.14l-1.34,1.73l0.02,0.51l1.88,2.11l1.31,-0.16Z",
                name: "South Africa"
            },
            EC: {
                path: "M231.86,285.53l0.29,1.59l-0.69,1.45l-2.61,2.51l-3.13,1.11l-1.53,2.18l-0.49,1.68l-1.0,0.73l-1.02,-1.11l-1.78,-0.16l0.67,-1.15l-0.24,-0.86l1.25,-2.13l-0.54,-1.09l-0.67,-0.08l-0.72,0.87l-0.87,-0.64l0.35,-0.69l-0.36,-1.96l0.81,-0.51l0.45,-1.51l0.92,-1.57l-0.07,-0.97l2.65,-1.33l2.75,1.35l0.77,1.05l2.12,0.35l0.76,-0.32l1.96,1.21Z",
                name: "Ecuador"
            },
            AL: {
                path: "M470.32,171.8l0.74,0.03l0.92,0.89l-0.17,1.95l0.36,1.28l1.01,0.82l-1.82,2.83l-0.19,-0.61l-1.25,-0.89l-0.18,-1.2l0.53,-2.82l-0.54,-1.47l0.6,-0.83Z",
                name: "Albania"
            },
            AO: {
                path: "M461.55,300.03l1.26,3.15l1.94,2.36l2.47,-0.53l1.25,0.32l0.44,-0.18l0.93,-1.92l1.31,-0.08l0.41,-0.44l0.47,-0.0l-0.1,0.41l0.39,0.49l2.65,-0.02l0.03,1.19l0.48,1.01l-0.34,1.52l0.18,1.55l0.83,1.04l-0.13,2.85l0.54,0.39l3.96,-0.41l-0.1,1.79l0.39,1.05l-0.24,1.43l-4.7,-0.03l-0.4,0.39l-0.12,8.13l2.92,3.49l-3.83,0.88l-5.89,-0.36l-1.88,-1.24l-10.47,0.22l-1.3,-1.01l-1.85,-0.16l-2.4,0.77l-0.15,-1.06l0.33,-2.16l1.0,-3.45l1.35,-3.2l2.24,-2.8l0.33,-2.06l-0.13,-1.53l-0.8,-1.08l-1.21,-2.87l0.87,-1.62l-1.27,-4.12l-1.17,-1.53l2.47,-0.63l7.03,0.03ZM451.71,298.87l-0.47,-1.25l1.25,-1.11l0.32,0.3l-0.99,1.03l-0.12,1.03Z",
                name: "Angola"
            },
            KZ: {
                path: "M552.8,172.89l0.46,-1.27l-0.48,-1.05l-2.96,-1.19l-1.06,-2.58l-1.37,-0.87l-0.03,-0.3l1.95,0.23l0.45,-0.38l0.08,-1.96l1.75,-0.41l2.1,0.45l0.48,-0.33l0.45,-3.04l-0.45,-2.09l-0.41,-0.31l-2.42,0.15l-2.36,-0.73l-2.87,1.37l-2.17,0.61l-0.85,-0.34l0.13,-1.61l-1.6,-2.12l-2.02,-0.08l-1.78,-1.82l1.29,-2.18l-0.57,-0.95l1.62,-2.91l2.21,1.63l0.63,-0.27l0.29,-2.22l4.92,-3.43l3.71,-0.08l8.4,3.6l2.92,-1.36l3.77,-0.06l3.11,1.66l0.51,-0.11l0.6,-0.81l3.31,0.13l0.39,-0.25l0.63,-1.57l-0.17,-0.5l-3.5,-1.98l1.87,-1.27l-0.13,-1.03l1.98,-0.72l0.18,-0.62l-1.59,-2.06l0.81,-0.82l9.23,-1.18l1.33,-0.88l6.18,-1.26l2.26,-1.42l4.08,0.68l0.73,3.33l0.51,0.3l2.48,-0.8l2.79,1.02l-0.17,1.56l0.43,0.44l2.55,-0.24l4.89,-2.53l0.03,0.32l3.15,2.61l5.56,8.47l0.65,0.02l1.12,-1.46l3.15,1.74l3.76,-0.78l1.15,0.49l1.14,1.8l1.84,0.76l0.99,1.29l3.35,-0.25l1.02,1.52l-1.6,1.81l-1.93,0.28l-0.34,0.38l-0.11,3.05l-1.13,1.16l-4.75,-1.0l-0.46,0.27l-1.76,5.47l-1.1,0.59l-4.91,1.23l-0.27,0.54l2.1,4.97l-1.37,0.63l-0.23,0.41l0.13,1.13l-0.88,-0.25l-1.42,-1.13l-7.89,-0.4l-0.92,0.31l-3.73,-1.22l-1.42,0.63l-0.53,1.66l-3.72,-0.94l-1.85,0.43l-0.76,1.4l-4.65,2.62l-1.13,2.08l-0.44,0.01l-0.92,-1.4l-2.87,-0.09l-0.45,-2.14l-0.38,-0.32l-0.8,-0.01l0.0,-2.96l-3.0,-2.22l-7.31,0.58l-2.35,-2.68l-6.71,-3.69l-6.45,1.83l-0.29,0.39l0.1,10.85l-0.7,0.08l-1.62,-2.17l-1.83,-0.96l-3.11,0.59l-0.64,0.51Z",
                name: "Kazakhstan"
            },
            ET: {
                path: "M516.04,247.79l1.1,0.84l1.63,-0.45l0.68,0.47l1.63,0.03l2.01,0.94l1.73,1.66l1.64,2.07l-1.52,2.04l0.16,1.72l0.39,0.38l2.05,0.0l-0.36,1.03l2.86,3.58l8.32,3.08l1.31,0.02l-6.32,6.75l-3.1,0.11l-2.36,1.77l-1.47,0.04l-0.86,0.79l-1.38,-0.0l-1.32,-0.81l-2.29,1.05l-0.76,0.98l-3.29,-0.41l-3.07,-2.07l-1.8,-0.07l-0.62,-0.6l0.0,-1.24l-0.28,-0.38l-1.15,-0.37l-1.4,-2.59l-1.19,-0.68l-0.47,-1.0l-1.27,-1.23l-1.16,-0.22l0.43,-0.72l1.45,-0.28l0.41,-0.95l-0.03,-2.21l0.68,-2.44l1.05,-0.63l1.43,-3.06l1.57,-1.37l1.02,-2.51l0.35,-1.88l2.52,0.46l0.44,-0.24l0.58,-1.43Z",
                name: "Ethiopia"
            },
            ZW: {
                path: "M498.91,341.09l-1.11,-0.22l-0.92,0.28l-2.09,-0.44l-1.5,-1.11l-1.89,-0.43l-0.62,-1.4l-0.01,-0.84l-0.3,-0.38l-0.97,-0.25l-2.71,-2.74l-1.92,-3.32l3.83,0.45l3.73,-3.82l1.08,-0.44l0.26,-0.77l1.25,-0.9l1.41,-0.26l0.5,0.89l1.99,-0.05l1.72,1.17l1.11,0.17l1.05,0.66l0.01,2.99l-0.59,3.76l0.38,0.86l-0.23,1.23l-0.39,0.35l-0.63,1.81l-2.43,2.75Z",
                name: "Zimbabwe"
            },
            ES: {
                path: "M416.0,169.21l1.07,1.17l4.61,1.38l1.06,-0.57l2.6,1.26l2.71,-0.3l0.09,1.12l-2.14,1.8l-3.11,0.61l-0.31,0.31l-0.2,0.89l-1.54,1.69l-0.97,2.4l0.84,1.74l-1.32,1.27l-0.48,1.68l-1.88,0.65l-1.66,2.07l-5.36,-0.01l-1.79,1.08l-0.89,0.98l-0.88,-0.17l-0.79,-0.82l-0.68,-1.59l-2.37,-0.63l-0.11,-0.5l1.21,-1.82l-0.77,-1.13l0.61,-1.68l-0.76,-1.62l0.87,-0.49l0.09,-1.25l0.42,-0.6l0.03,-2.11l0.99,-0.69l0.13,-0.5l-1.03,-1.73l-1.46,-0.11l-0.61,0.38l-1.06,0.0l-0.52,-1.23l-0.53,-0.21l-1.32,0.67l-0.01,-1.49l-0.75,-0.96l3.03,-1.88l2.99,0.53l3.32,-0.02l2.63,0.51l6.01,-0.06Z",
                name: "Spain"
            },
            ER: {
                path: "M520.38,246.23l3.42,2.43l3.5,3.77l0.84,0.54l-0.95,-0.01l-3.51,-3.89l-2.33,-1.15l-1.73,-0.07l-0.91,-0.51l-1.26,0.51l-1.34,-1.02l-0.61,0.17l-0.66,1.61l-2.35,-0.43l-0.17,-0.67l1.29,-5.29l0.61,-0.61l1.95,-0.53l0.87,-1.01l1.17,2.41l0.68,2.33l1.49,1.43Z",
                name: "Eritrea"
            },
            ME: {
                path: "M468.91,172.53l-1.22,-1.02l0.47,-1.81l0.89,-0.72l2.26,1.51l-0.5,0.57l-0.75,-0.27l-1.14,1.73Z",
                name: "Montenegro"
            },
            MD: {
                path: "M488.41,153.73l1.4,-0.27l1.72,0.93l1.07,0.15l0.85,0.65l-0.14,0.84l0.96,0.85l1.12,2.47l-1.15,-0.07l-0.66,-0.41l-0.52,0.25l-0.09,0.86l-1.08,1.89l-0.27,-0.86l0.25,-1.34l-0.16,-1.6l-3.29,-4.34Z",
                name: "Moldova"
            },
            MG: {
                path: "M545.91,319.14l0.4,3.03l0.62,1.21l-0.21,1.02l-0.57,-0.8l-0.69,-0.01l-0.47,0.76l0.41,2.12l-0.18,0.87l-0.73,0.78l-0.15,2.14l-4.71,15.2l-1.06,2.88l-3.92,1.64l-3.12,-1.49l-0.6,-1.21l-0.19,-2.4l-0.86,-2.05l-0.21,-1.77l0.38,-1.62l1.21,-0.75l0.01,-0.76l1.19,-2.04l0.23,-1.66l-1.06,-2.99l-0.19,-2.21l0.81,-1.33l0.32,-1.46l4.63,-1.22l3.44,-3.0l0.85,-1.4l-0.08,-0.7l0.78,-0.04l1.38,-1.77l0.13,-1.64l0.45,-0.61l1.16,1.69l0.59,1.6Z",
                name: "Madagascar"
            },
            MA: {
                path: "M378.78,230.02l0.06,-0.59l0.92,-0.73l0.82,-1.37l-0.09,-1.04l0.79,-1.7l1.31,-1.58l0.96,-0.59l0.66,-1.55l0.09,-1.47l0.81,-1.48l1.72,-1.07l1.55,-2.69l1.16,-0.96l2.44,-0.39l1.94,-1.82l1.31,-0.78l2.09,-2.28l-0.51,-3.65l1.24,-3.7l1.5,-1.75l4.46,-2.57l2.37,-4.47l1.44,0.01l1.68,1.21l2.32,-0.19l3.47,0.65l0.8,1.54l0.16,1.71l0.86,2.96l0.56,0.59l-0.26,0.61l-3.05,0.44l-1.26,1.05l-1.33,0.22l-0.33,0.37l-0.09,1.78l-2.68,1.0l-1.07,1.42l-4.47,1.13l-4.04,2.01l-0.54,4.64l-1.15,0.06l-0.92,0.61l-1.96,-0.35l-2.42,0.54l-0.74,1.9l-0.86,0.4l-1.14,3.26l-3.53,3.01l-0.8,3.55l-0.96,1.1l-0.29,0.82l-4.95,0.18Z",
                name: "Morocco"
            },
            UZ: {
                path: "M598.64,172.75l-1.63,1.52l0.06,0.64l1.85,1.12l1.97,-0.64l2.21,1.17l-2.52,1.68l-2.59,-0.22l-0.18,-0.41l0.46,-1.23l-0.45,-0.53l-3.35,0.69l-2.1,3.51l-1.87,-0.12l-1.03,1.51l0.22,0.55l1.64,0.62l0.46,1.83l-1.19,2.49l-2.66,-0.53l0.05,-1.36l-0.26,-0.39l-3.3,-1.23l-2.56,-1.4l-4.4,-3.34l-1.34,-3.14l-1.08,-0.6l-2.58,0.13l-0.69,-0.44l-0.47,-2.52l-3.37,-1.6l-0.43,0.05l-2.07,1.72l-2.1,1.01l-0.21,0.47l0.28,1.01l-1.91,0.03l-0.09,-10.5l5.99,-1.7l6.19,3.54l2.71,2.84l7.05,-0.67l2.71,2.01l-0.17,2.81l0.39,0.42l0.9,0.02l0.44,2.14l0.38,0.32l2.94,0.09l0.95,1.42l1.28,-0.24l1.05,-2.04l4.43,-2.5Z",
                name: "Uzbekistan"
            },
            MM: {
                path: "M673.9,230.21l-1.97,1.57l-0.57,0.96l-1.4,0.6l-1.36,1.05l-1.99,0.36l-1.08,2.66l-0.91,0.4l-0.19,0.55l1.21,2.27l2.52,3.43l-0.79,1.91l-0.74,0.41l-0.17,0.52l0.65,1.37l1.61,1.95l0.25,2.58l0.9,2.13l-1.92,3.57l0.68,-2.25l-0.81,-1.74l0.19,-2.65l-1.05,-1.53l-1.24,-6.17l-1.12,-2.26l-0.6,-0.13l-4.34,3.02l-2.39,-0.65l0.77,-2.84l-0.52,-2.61l-1.91,-2.96l0.25,-0.75l-0.29,-0.51l-1.33,-0.3l-1.61,-1.93l-0.1,-1.3l0.82,-0.24l0.04,-1.64l1.02,-0.52l0.21,-0.45l-0.23,-0.95l0.54,-0.96l0.08,-2.22l1.46,0.45l0.47,-0.2l1.12,-2.19l0.16,-1.35l1.33,-2.16l-0.0,-1.52l2.89,-1.66l1.63,0.44l0.5,-0.44l-0.17,-1.4l0.64,-0.36l0.08,-1.04l0.77,-0.11l0.71,1.35l1.06,0.69l-0.03,3.86l-2.38,2.37l-0.3,3.15l0.46,0.43l2.28,-0.38l0.51,2.08l1.47,0.67l-0.6,1.8l0.19,0.48l2.97,1.48l1.64,-0.55l0.02,0.32Z",
                name: "Myanmar"
            },
            ML: {
                path: "M392.61,254.08l-0.19,-2.37l-0.99,-0.87l-0.44,-1.3l-0.09,-1.28l0.81,-0.58l0.35,-1.24l2.37,0.65l1.31,-0.47l0.86,0.15l0.66,-0.56l9.83,-0.04l0.38,-0.28l0.56,-1.8l-0.44,-0.65l-2.35,-21.95l3.27,-0.04l16.7,11.38l0.74,1.31l2.5,1.09l0.02,1.38l0.44,0.39l2.34,-0.21l0.01,5.38l-1.28,1.61l-0.26,1.49l-5.31,0.57l-1.07,0.92l-2.9,0.1l-0.86,-0.48l-1.38,0.36l-2.4,1.08l-0.6,0.87l-1.85,1.09l-0.43,0.7l-0.79,0.39l-1.44,-0.21l-0.81,0.84l-0.34,1.64l-1.91,2.02l-0.06,1.03l-0.67,1.22l0.13,1.16l-0.97,0.39l-0.23,-0.64l-0.52,-0.24l-1.35,0.4l-0.34,0.55l-2.69,-0.28l-0.37,-0.35l-0.02,-0.9l-0.65,-0.35l0.45,-0.64l-0.03,-0.53l-2.12,-2.44l-0.76,-0.01l-2.0,1.16l-0.78,-0.15l-0.8,-0.67l-1.21,0.23Z",
                name: "Mali"
            },
            MN: {
                path: "M676.61,146.48l3.81,1.68l5.67,-1.0l2.37,0.41l2.34,1.5l1.79,1.75l2.29,-0.03l3.12,0.52l2.47,-0.81l3.41,-0.59l3.53,-2.21l1.25,0.29l1.53,1.13l2.27,-0.21l-2.66,5.01l0.64,1.68l0.47,0.21l1.32,-0.38l2.38,0.48l2.02,-1.11l1.76,0.89l2.06,2.02l-0.13,0.53l-1.72,-0.29l-3.77,0.46l-1.88,0.99l-1.76,1.99l-3.71,1.17l-2.45,1.6l-3.83,-0.87l-0.41,0.17l-1.31,1.99l1.04,2.24l-1.52,0.9l-1.74,1.57l-2.79,1.02l-3.78,0.13l-4.05,1.05l-2.77,1.52l-1.16,-0.85l-2.94,0.0l-3.62,-1.79l-2.58,-0.49l-3.4,0.41l-5.12,-0.67l-2.63,0.06l-1.31,-1.6l-1.4,-3.0l-1.48,-0.33l-3.13,-1.94l-6.16,-0.93l-0.71,-1.06l0.86,-3.82l-1.93,-2.71l-3.5,-1.18l-1.95,-1.58l-0.5,-1.72l2.34,-0.52l4.75,-2.8l3.62,-1.47l2.18,0.97l2.46,0.05l1.81,1.53l2.46,0.12l3.95,0.71l2.43,-2.28l0.08,-0.48l-0.9,-1.72l2.24,-2.98l2.62,1.27l4.94,1.17l0.43,2.24Z",
                name: "Mongolia"
            },
            MK: {
                path: "M472.8,173.98l0.49,-0.71l3.57,-0.71l1.0,0.77l0.13,1.45l-0.65,0.53l-1.15,-0.05l-1.12,0.67l-1.39,0.22l-0.79,-0.55l-0.29,-1.03l0.19,-0.6Z",
                name: "Macedonia"
            },
            MW: {
                path: "M505.5,309.31l0.85,1.95l0.15,2.86l-0.69,1.65l0.71,1.8l0.06,1.28l0.49,0.64l0.07,1.06l0.4,0.55l0.8,-0.23l0.55,0.61l0.69,-0.21l0.34,0.6l0.19,2.94l-1.04,0.62l-0.54,1.25l-1.11,-1.08l-0.16,-1.56l0.51,-1.31l-0.32,-1.3l-0.99,-0.65l-0.82,0.12l-2.36,-1.64l0.63,-1.96l0.82,-1.18l-0.46,-2.01l0.9,-2.86l-0.94,-2.51l0.96,0.18l0.29,0.4Z",
                name: "Malawi"
            },
            MR: {
                path: "M407.36,220.66l-2.58,0.03l-0.39,0.44l2.42,22.56l0.36,0.43l-0.39,1.24l-9.75,0.04l-0.56,0.53l-0.91,-0.11l-1.27,0.45l-1.61,-0.66l-0.97,0.03l-0.36,0.29l-0.38,1.35l-0.42,0.23l-2.93,-3.4l-2.96,-1.52l-1.62,-0.03l-1.27,0.54l-1.12,-0.2l-0.65,0.4l-0.08,-0.49l0.68,-1.29l0.31,-2.43l-0.57,-3.91l0.23,-1.21l-0.69,-1.5l-1.15,-1.02l0.25,-0.39l9.58,0.02l0.4,-0.45l-0.46,-3.68l0.47,-1.04l2.12,-0.21l0.36,-0.4l-0.08,-6.4l7.81,0.13l0.41,-0.4l0.01,-3.31l7.76,5.35Z",
                name: "Mauritania"
            },
            UG: {
                path: "M498.55,276.32l0.7,-0.46l1.65,0.5l1.96,-0.57l1.7,0.01l1.45,-0.98l0.91,1.33l1.33,3.95l-2.57,4.03l-1.46,-0.4l-2.54,0.91l-1.37,1.61l-0.01,0.81l-2.42,-0.01l-2.26,1.01l-0.17,-1.59l0.58,-1.04l0.14,-1.94l1.37,-2.28l1.78,-1.58l-0.17,-0.65l-0.72,-0.24l0.13,-2.43Z",
                name: "Uganda"
            },
            MY: {
                path: "M717.47,273.46l-1.39,0.65l-2.12,-0.41l-2.88,-0.0l-0.38,0.28l-0.84,2.75l-0.99,0.96l-1.21,3.29l-1.73,0.45l-2.45,-0.68l-1.39,0.31l-1.33,1.15l-1.59,-0.14l-1.41,0.44l-1.44,-1.19l-0.18,-0.73l1.34,0.53l1.93,-0.47l0.75,-2.22l4.02,-1.03l2.75,-3.21l0.82,0.94l0.64,-0.05l0.4,-0.65l0.96,0.06l0.42,-0.36l0.24,-2.68l1.81,-1.64l1.21,-1.86l0.63,-0.01l1.07,1.05l0.34,1.28l3.44,1.35l-0.06,0.35l-1.37,0.1l-0.35,0.54l0.32,0.88ZM673.68,269.59l0.17,1.09l0.47,0.33l1.65,-0.3l0.87,-0.94l1.61,1.52l0.98,1.56l-0.12,2.81l0.41,2.29l0.95,0.9l0.88,2.44l-1.27,0.12l-5.1,-3.67l-0.34,-1.29l-1.37,-1.59l-0.33,-1.97l-0.88,-1.4l0.25,-1.68l-0.46,-1.05l1.63,0.84Z",
                name: "Malaysia"
            },
            MX: {
                path: "M133.12,200.41l0.2,0.47l9.63,3.33l6.96,-0.02l0.4,-0.4l0.0,-0.74l3.77,0.0l3.55,2.93l1.39,2.83l1.52,1.04l2.08,0.82l0.47,-0.14l1.46,-2.0l1.73,-0.04l1.59,0.98l2.05,3.35l1.47,1.56l1.26,3.14l2.18,1.02l2.26,0.58l-1.18,3.72l-0.42,5.04l1.79,4.89l1.62,1.89l0.61,1.52l1.2,1.42l2.55,0.66l1.37,1.1l7.54,-1.89l1.86,-1.3l1.14,-4.3l4.1,-1.21l3.57,-0.11l0.32,0.3l-0.06,0.94l-1.26,1.45l-0.67,1.71l0.38,0.7l-0.72,2.27l-0.49,-0.3l-1.0,0.08l-1.0,1.39l-0.47,-0.11l-0.53,0.47l-4.26,-0.02l-0.4,0.4l-0.0,1.06l-1.1,0.26l0.1,0.44l1.82,1.44l0.56,0.91l-3.19,0.21l-1.21,2.09l0.24,0.72l-0.2,0.44l-2.24,-2.18l-1.45,-0.93l-2.22,-0.69l-1.52,0.22l-3.07,1.16l-10.55,-3.85l-2.86,-1.96l-3.78,-0.92l-1.08,-1.19l-2.62,-1.43l-1.18,-1.54l-0.38,-0.81l0.66,-0.63l-0.18,-0.53l0.52,-0.76l0.01,-0.91l-2.0,-3.82l-2.21,-2.63l-2.53,-2.09l-1.19,-1.62l-2.2,-1.17l-0.3,-0.43l0.34,-1.48l-0.21,-0.45l-1.23,-0.6l-1.36,-1.2l-0.59,-1.78l-1.54,-0.47l-2.44,-2.55l-0.16,-0.9l-1.33,-2.03l-0.84,-1.99l-0.16,-1.33l-1.81,-1.1l-0.97,0.05l-1.31,-0.7l-0.57,0.22l-0.4,1.12l0.72,3.77l3.51,3.89l0.28,0.78l0.53,0.26l0.41,1.43l1.33,1.73l1.58,1.41l0.8,2.39l1.43,2.41l0.13,1.32l0.37,0.36l1.04,0.08l1.67,2.28l-0.85,0.76l-0.66,-1.51l-1.68,-1.54l-2.91,-1.87l0.06,-1.82l-0.54,-1.68l-2.91,-2.03l-0.55,0.09l-1.95,-1.1l-0.88,-0.94l0.68,-0.08l0.93,-1.01l0.08,-1.78l-1.93,-1.94l-1.46,-0.77l-3.75,-7.56l4.88,-0.42Z",
                name: "Mexico"
            },
            VU: {
                path: "M839.04,322.8l0.22,1.14l-0.44,0.03l-0.2,-1.45l0.42,0.27Z",
                name: "Vanuatu"
            },
            FR: {
                path: "M444.48,172.62l-0.64,1.78l-0.58,-0.31l-0.49,-1.72l0.4,-0.89l1.0,-0.72l0.3,1.85ZM429.64,147.1l1.78,1.58l1.46,-0.13l2.1,1.42l1.35,0.27l1.23,0.83l3.04,0.5l-1.03,1.85l-0.3,2.12l-0.41,0.32l-0.95,-0.24l-0.5,0.43l0.06,0.61l-1.81,1.92l-0.04,1.42l0.55,0.38l0.88,-0.36l0.61,0.97l-0.03,1.0l0.57,0.91l-0.75,1.09l0.65,2.39l1.27,0.57l-0.18,0.82l-2.01,1.53l-4.77,-0.8l-3.82,1.0l-0.53,1.85l-2.49,0.34l-2.71,-1.31l-1.16,0.57l-4.31,-1.29l-0.72,-0.86l1.19,-1.78l0.39,-6.45l-2.58,-3.3l-1.9,-1.66l-3.72,-1.23l-0.19,-1.72l2.81,-0.61l4.12,0.81l0.47,-0.48l-0.6,-2.77l1.94,0.95l5.83,-2.54l0.92,-2.74l1.6,-0.49l0.24,0.78l1.36,0.33l1.05,1.19ZM289.01,278.39l-0.81,0.8l-0.78,0.12l-0.5,-0.66l-0.56,-0.1l-0.91,0.6l-0.46,-0.22l1.09,-2.96l-0.96,-1.77l-0.17,-1.49l1.07,-1.77l2.32,0.75l2.51,2.01l0.3,0.74l-2.14,3.96Z",
                name: "France"
            },
            FI: {
                path: "M492.17,76.39l-0.23,3.5l3.52,2.63l-2.08,2.88l-0.02,0.44l2.8,4.56l-1.59,3.31l2.16,3.24l-0.94,2.39l0.14,0.47l3.44,2.51l-0.77,1.62l-7.52,6.95l-4.5,0.31l-4.38,1.37l-3.8,0.74l-1.44,-1.96l-2.17,-1.11l0.5,-3.66l-1.16,-3.33l1.09,-2.08l2.21,-2.42l5.67,-4.32l1.64,-0.83l0.21,-0.42l-0.46,-2.02l-3.38,-1.89l-0.75,-1.43l-0.22,-6.74l-6.79,-4.8l0.8,-0.62l2.54,2.12l3.46,-0.12l3.0,0.96l2.51,-2.11l1.17,-3.08l3.55,-1.38l2.76,1.53l-0.95,2.79Z",
                name: "Finland"
            },
            FJ: {
                path: "M871.53,326.34l-2.8,1.05l-0.08,-0.23l2.97,-1.21l-0.1,0.39ZM867.58,329.25l0.43,0.37l-0.27,0.88l-1.24,0.28l-1.04,-0.24l-0.14,-0.66l0.63,-0.58l0.92,0.26l0.7,-0.31Z",
                name: "Fiji"
            },
            FK: {
                path: "M274.36,425.85l1.44,1.08l-0.47,0.73l-3.0,0.89l-0.96,-1.0l-0.52,-0.05l-1.83,1.29l-0.73,-0.88l2.46,-1.64l1.93,0.76l1.67,-1.19Z",
                name: "Falkland Is."
            },
            NI: {
                path: "M202.33,252.67l0.81,-0.18l1.03,-1.02l-0.04,-0.88l0.68,-0.0l0.63,-0.54l0.97,0.22l1.53,-1.26l0.58,-0.99l1.17,0.34l2.41,-0.94l0.13,1.32l-0.81,1.94l0.1,2.74l-0.36,0.37l-0.11,1.75l-0.47,0.81l0.18,1.14l-1.73,-0.85l-0.71,0.27l-1.47,-0.6l-0.52,0.16l-4.01,-3.81Z",
                name: "Nicaragua"
            },
            NL: {
                path: "M430.31,143.39l0.6,-0.5l2.13,-4.8l3.2,-1.33l1.74,0.08l0.33,0.8l-0.59,2.92l-0.5,0.99l-1.26,0.0l-0.4,0.45l0.33,2.7l-2.2,-1.78l-2.62,0.58l-0.75,-0.11Z",
                name: "Netherlands"
            },
            NO: {
                path: "M491.44,67.41l6.8,2.89l-2.29,0.86l-0.15,0.65l2.33,2.38l-4.98,1.79l0.84,-2.45l-0.18,-0.48l-3.55,-1.8l-3.89,1.52l-1.42,3.38l-2.12,1.72l-2.64,-1.0l-3.11,0.21l-2.66,-2.22l-0.5,-0.01l-1.41,1.1l-1.44,0.17l-0.35,0.35l-0.32,2.47l-4.32,-0.64l-0.44,0.29l-0.58,2.11l-2.45,0.2l-4.15,7.68l-3.88,5.76l0.78,1.62l-0.64,1.16l-2.24,-0.06l-0.38,0.24l-1.66,3.89l0.15,5.17l1.57,2.04l-0.78,4.16l-2.02,2.48l-0.85,1.63l-1.3,-1.75l-0.58,-0.07l-4.87,4.19l-3.1,0.79l-3.16,-1.7l-0.85,-3.77l-0.77,-8.55l2.14,-2.31l6.55,-3.27l5.02,-4.17l10.63,-13.84l10.98,-8.7l5.35,-1.91l4.34,0.12l3.69,-3.64l4.49,0.19l4.37,-0.89ZM484.55,20.04l4.26,1.75l-3.1,2.55l-7.1,0.65l-7.08,-0.9l-0.37,-1.31l-0.37,-0.29l-3.44,-0.1l-2.08,-2.0l6.87,-1.44l3.9,1.31l2.39,-1.64l6.13,1.4ZM481.69,33.93l-4.45,1.74l-3.54,-0.99l1.12,-0.9l0.05,-0.58l-1.06,-1.22l4.22,-0.89l1.09,1.97l2.57,0.87ZM466.44,24.04l7.43,3.77l-5.41,1.86l-1.58,4.08l-2.26,1.2l-1.12,4.11l-2.61,0.18l-4.79,-2.86l1.84,-1.54l-0.1,-0.68l-3.69,-1.53l-4.77,-4.51l-1.73,-3.89l6.11,-1.82l1.54,1.92l3.57,-0.08l1.2,-1.96l3.32,-0.18l3.05,1.92Z",
                name: "Norway"
            },
            NA: {
                path: "M474.26,330.66l-0.97,0.04l-0.38,0.4l-0.07,8.9l-2.09,0.08l-0.39,0.4l-0.0,17.42l-1.98,1.23l-1.17,0.17l-2.44,-0.66l-0.48,-1.13l-0.99,-0.74l-0.54,0.05l-0.9,1.01l-1.53,-1.68l-0.93,-1.88l-1.99,-8.56l-0.06,-3.12l-0.33,-1.52l-2.3,-3.34l-1.91,-4.83l-1.96,-2.43l-0.12,-1.57l2.33,-0.79l1.43,0.07l1.81,1.13l10.23,-0.25l1.84,1.23l5.87,0.35ZM474.66,330.64l6.51,-1.6l1.9,0.39l-1.69,0.4l-1.31,0.83l-1.12,-0.94l-4.29,0.92Z",
                name: "Namibia"
            },
            NC: {
                path: "M838.78,341.24l-0.33,0.22l-2.9,-1.75l-3.26,-3.37l1.65,0.83l4.85,4.07Z",
                name: "New Caledonia"
            },
            NE: {
                path: "M454.75,226.53l1.33,1.37l0.48,0.07l1.27,-0.7l0.53,3.52l0.94,0.83l0.17,0.92l0.81,0.69l-0.44,0.95l-0.96,5.26l-0.13,3.22l-3.04,2.31l-1.22,3.57l1.02,1.24l-0.0,1.46l0.39,0.4l1.13,0.04l-0.9,1.25l-1.47,-2.42l-0.86,-0.29l-2.09,1.37l-1.74,-0.67l-1.45,-0.17l-0.85,0.35l-1.36,-0.07l-1.64,1.09l-1.06,0.05l-2.94,-1.28l-1.44,0.59l-1.01,-0.03l-0.97,-0.94l-2.7,-0.98l-2.69,0.3l-0.87,0.64l-0.47,1.6l-0.75,1.16l-0.12,1.53l-1.57,-1.1l-1.31,0.24l0.03,-0.81l-0.32,-0.41l-2.59,-0.52l-0.15,-1.16l-1.35,-1.6l-0.29,-1.0l0.13,-0.84l1.29,-0.08l1.08,-0.92l3.31,-0.22l2.22,-0.41l0.32,-0.34l0.2,-1.47l1.39,-1.88l-0.01,-5.66l3.36,-1.12l7.24,-5.12l8.42,-4.92l3.69,1.06Z",
                name: "Niger"
            },
            NG: {
                path: "M456.32,253.89l0.64,0.65l-0.28,1.04l-2.11,2.01l-2.03,5.18l-1.37,1.16l-1.15,3.18l-1.33,0.66l-1.46,-0.97l-1.21,0.16l-1.38,1.36l-0.91,0.24l-1.79,4.06l-2.33,0.81l-1.11,-0.07l-0.86,0.5l-1.71,-0.05l-1.19,-1.39l-0.89,-1.89l-1.77,-1.66l-3.95,-0.08l0.07,-5.21l0.42,-1.43l1.95,-2.3l-0.14,-0.91l0.43,-1.18l-0.53,-1.41l0.25,-2.92l0.72,-1.07l0.32,-1.34l0.46,-0.39l2.47,-0.28l2.34,0.89l1.15,1.02l1.28,0.04l1.22,-0.58l3.03,1.27l1.49,-0.14l1.36,-1.0l1.33,0.07l0.82,-0.35l3.45,0.8l1.82,-1.32l1.84,2.67l0.66,0.16Z",
                name: "Nigeria"
            },
            NZ: {
                path: "M857.8,379.65l1.86,3.12l0.44,0.18l0.3,-0.38l0.03,-1.23l0.38,0.27l0.57,2.31l2.02,0.94l1.81,0.27l1.57,-1.06l0.7,0.18l-1.15,3.59l-1.98,0.11l-0.74,1.2l0.2,1.11l-2.42,3.98l-1.49,0.92l-1.04,-0.85l1.21,-2.05l-0.81,-2.01l-2.63,-1.25l0.04,-0.57l1.82,-1.19l0.43,-2.34l-0.16,-2.03l-0.95,-1.82l-0.06,-0.72l-3.11,-3.64l-0.79,-1.52l1.56,1.45l1.76,0.66l0.65,2.34ZM853.83,393.59l0.57,1.24l0.59,0.16l1.42,-0.97l0.46,0.79l0.0,1.03l-2.47,3.48l-1.26,1.2l-0.06,0.5l0.55,0.87l-1.41,0.07l-2.33,1.38l-2.03,5.02l-3.02,2.16l-2.06,-0.06l-1.71,-1.04l-2.47,-0.2l-0.27,-0.73l1.22,-2.1l3.05,-2.94l1.62,-0.59l4.02,-2.82l1.57,-1.67l1.07,-2.16l0.88,-0.7l0.48,-1.75l1.24,-0.97l0.35,0.79Z",
                name: "New Zealand"
            },
            NP: {
                path: "M641.14,213.62l0.01,3.19l-1.74,0.04l-4.8,-0.86l-1.58,-1.39l-3.37,-0.34l-7.65,-3.7l0.8,-2.09l2.33,-1.7l1.77,0.75l2.49,1.76l1.38,0.41l0.99,1.35l1.9,0.52l1.99,1.17l5.49,0.9Z",
                name: "Nepal"
            },
            CI: {
                path: "M407.4,259.27l0.86,0.42l0.56,0.9l1.13,0.53l1.19,-0.61l0.97,-0.08l1.42,0.54l0.6,3.24l-1.03,2.08l-0.65,2.84l1.06,2.33l-0.06,0.53l-2.54,-0.47l-1.66,0.03l-3.06,0.46l-4.11,1.6l0.32,-3.06l-1.18,-1.31l-1.32,-0.66l0.42,-0.85l-0.2,-1.4l0.5,-0.67l0.01,-1.59l0.84,-0.32l0.26,-0.5l-1.15,-3.01l0.12,-0.5l0.51,-0.25l0.66,0.31l1.93,0.02l0.67,-0.71l0.71,-0.14l0.25,0.69l0.57,0.22l1.4,-0.61Z",
                name: "CÃ´te d'Ivoire"
            },
            CH: {
                path: "M444.62,156.35l-0.29,0.87l0.18,0.53l1.13,0.58l1.0,0.1l-0.1,0.65l-0.79,0.38l-1.72,-0.37l-0.45,0.23l-0.45,1.04l-0.75,0.06l-0.84,-0.4l-1.32,1.0l-0.96,0.12l-0.88,-0.55l-0.81,-1.3l-0.49,-0.16l-0.63,0.26l0.02,-0.65l1.71,-1.66l0.1,-0.56l0.93,0.08l0.58,-0.46l1.99,0.02l0.66,-0.61l2.19,0.79Z",
                name: "Switzerland"
            },
            CO: {
                path: "M242.07,254.93l-1.7,0.59l-0.59,1.18l-1.7,1.69l-0.38,1.93l-0.67,1.43l0.31,0.57l1.03,0.13l0.25,0.9l0.57,0.64l-0.04,2.34l1.64,1.42l3.16,-0.24l1.26,0.28l1.67,2.06l0.41,0.13l4.09,-0.39l0.45,0.22l-0.92,1.95l-0.2,1.8l0.52,1.83l0.75,1.05l-1.12,1.1l0.07,0.63l0.84,0.51l0.74,1.29l-0.39,-0.45l-0.59,-0.01l-0.71,0.74l-4.71,-0.05l-0.4,0.41l0.03,1.57l0.33,0.39l1.11,0.2l-1.68,0.4l-0.29,0.38l-0.01,1.82l1.16,1.14l0.34,1.25l-1.05,7.05l-1.04,-0.87l1.26,-1.99l-0.13,-0.56l-2.18,-1.23l-1.38,0.2l-1.14,-0.38l-1.27,0.61l-1.55,-0.26l-1.38,-2.46l-1.23,-0.75l-0.85,-1.2l-1.67,-1.19l-0.86,0.13l-2.11,-1.32l-1.01,0.31l-1.8,-0.29l-0.52,-0.91l-3.09,-1.68l0.77,-0.52l-0.1,-1.12l0.41,-0.64l1.34,-0.32l2.0,-2.88l-0.11,-0.57l-0.66,-0.43l0.39,-1.38l-0.52,-2.1l0.49,-0.83l-0.4,-2.13l-0.97,-1.35l0.17,-0.66l0.86,-0.08l0.47,-0.75l-0.46,-1.63l1.41,-0.07l1.8,-1.69l0.93,-0.24l0.3,-0.38l0.45,-2.76l1.22,-1.0l1.44,-0.04l0.45,-0.5l1.91,0.12l2.93,-1.84l1.15,-1.14l0.91,0.46l-0.25,0.45Z",
                name: "Colombia"
            },
            CN: {
                path: "M740.23,148.97l4.57,1.3l2.8,2.17l0.98,2.9l0.38,0.27l3.8,0.0l2.32,-1.28l3.29,-0.75l-0.96,2.09l-1.02,1.28l-0.85,3.4l-1.52,2.73l-2.76,-0.5l-2.4,1.13l-0.21,0.45l0.64,2.57l-0.32,3.2l-0.94,0.06l-0.37,0.89l-0.91,-1.01l-0.64,0.07l-0.92,1.57l-3.73,1.25l-0.26,0.48l0.26,1.06l-1.5,-0.08l-1.09,-0.86l-0.56,0.06l-1.67,2.06l-2.7,1.56l-2.03,1.88l-3.4,0.83l-1.93,1.4l-1.15,0.34l0.33,-0.7l-0.41,-0.89l1.79,-1.79l0.02,-0.54l-1.32,-1.56l-0.48,-0.1l-2.24,1.09l-2.83,2.06l-1.51,1.83l-2.28,0.13l-1.55,1.49l-0.04,0.5l1.32,1.97l2.0,0.58l0.31,1.35l1.98,0.84l3.0,-1.96l2.0,1.02l1.49,0.11l0.22,0.83l-3.37,0.86l-1.12,1.48l-2.5,1.52l-1.29,1.99l0.14,0.56l2.57,1.48l0.97,2.7l3.17,4.63l-0.03,1.66l-1.35,0.65l-0.2,0.51l0.6,1.47l1.4,0.91l-0.89,3.82l-1.43,0.38l-3.85,6.44l-2.27,3.11l-6.78,4.57l-2.73,0.29l-1.45,1.04l-0.62,-0.61l-0.55,-0.01l-1.36,1.25l-3.39,1.27l-2.61,0.4l-1.1,2.79l-0.81,0.09l-0.49,-1.42l0.5,-0.85l-0.25,-0.59l-3.36,-0.84l-1.3,0.4l-2.31,-0.62l-0.94,-0.84l0.33,-1.28l-0.3,-0.49l-2.19,-0.46l-1.13,-0.93l-0.47,-0.02l-2.06,1.36l-4.29,0.28l-2.76,1.05l-0.28,0.43l0.32,2.53l-0.59,-0.03l-0.19,-1.34l-0.55,-0.34l-1.68,0.7l-2.46,-1.23l0.62,-1.87l-0.26,-0.51l-1.37,-0.44l-0.54,-2.22l-0.45,-0.3l-2.13,0.35l0.24,-2.48l2.39,-2.4l0.03,-4.31l-1.19,-0.92l-0.78,-1.49l-0.41,-0.21l-1.41,0.19l-1.98,-0.3l0.46,-1.07l-1.17,-1.7l-0.55,-0.11l-1.63,1.05l-2.25,-0.57l-2.89,1.73l-2.25,1.98l-1.75,0.29l-1.17,-0.71l-3.31,-0.65l-1.48,0.79l-1.04,1.27l-0.12,-1.17l-0.54,-0.34l-1.44,0.54l-5.55,-0.86l-1.98,-1.16l-1.89,-0.54l-0.99,-1.35l-1.34,-0.37l-2.55,-1.79l-2.01,-0.84l-1.21,0.56l-5.57,-3.45l-0.53,-2.31l1.19,0.25l0.48,-0.37l0.08,-1.42l-0.98,-1.56l0.15,-2.44l-2.69,-3.32l-4.12,-1.23l-0.67,-2.0l-1.92,-1.48l-0.38,-0.7l-0.51,-3.01l-1.52,-0.66l-0.7,0.13l-0.48,-2.05l0.55,-0.51l-0.09,-0.82l2.03,-1.19l1.6,-0.54l2.56,0.38l0.42,-0.22l0.85,-1.7l3.0,-0.33l1.1,-1.26l4.05,-1.77l0.39,-0.91l-0.17,-1.44l1.45,-0.67l0.2,-0.52l-2.07,-4.9l4.51,-1.12l1.37,-0.73l1.89,-5.51l4.98,0.86l1.51,-1.7l0.11,-2.87l1.99,-0.38l1.83,-2.06l0.49,-0.13l0.68,2.08l2.23,1.77l3.44,1.16l1.55,2.29l-0.92,3.49l0.96,1.67l6.54,1.13l2.95,1.87l1.47,0.35l1.06,2.62l1.53,1.91l3.05,0.08l5.14,0.67l3.37,-0.41l2.36,0.43l3.65,1.8l3.06,0.04l1.45,0.88l2.87,-1.59l3.95,-1.02l3.83,-0.14l3.06,-1.14l1.77,-1.6l1.72,-1.01l0.17,-0.49l-1.1,-2.05l1.02,-1.54l4.02,0.8l2.45,-1.61l3.76,-1.19l1.96,-2.13l1.63,-0.83l3.51,-0.4l1.92,0.34l0.46,-0.3l0.17,-1.5l-2.27,-2.22l-2.11,-1.09l-2.18,1.11l-2.32,-0.47l-1.29,0.32l-0.4,-0.82l2.73,-5.16l3.02,1.06l3.53,-2.06l0.18,-1.68l2.16,-3.35l1.49,-1.35l-0.03,-1.85l-1.07,-0.85l1.54,-1.26l2.98,-0.59l3.23,-0.09l3.64,0.99l2.04,1.16l3.29,6.71l0.92,3.19ZM696.92,237.31l-1.87,1.08l-1.63,-0.64l-0.06,-1.79l1.03,-0.98l2.58,-0.69l1.16,0.05l0.3,0.54l-0.98,1.06l-0.53,1.37Z",
                name: "China"
            },
            CM: {
                path: "M457.92,257.49l1.05,1.91l-1.4,0.16l-1.05,-0.23l-0.45,0.22l-0.54,1.19l0.08,0.45l1.48,1.47l1.05,0.45l1.01,2.46l-1.52,2.99l-0.68,0.68l-0.13,3.69l2.38,3.84l1.09,0.8l0.24,2.48l-3.67,-1.14l-11.27,-0.13l0.23,-1.79l-0.98,-1.66l-1.19,-0.54l-0.44,-0.97l-0.6,-0.42l1.71,-4.27l0.75,-0.13l1.38,-1.36l0.65,-0.03l1.71,0.99l1.93,-1.12l1.14,-3.18l1.38,-1.17l2.0,-5.14l2.17,-2.13l0.3,-1.64l-0.86,-0.88l0.03,-0.33l0.94,1.28l0.07,3.22Z",
                name: "Cameroon"
            },
            CL: {
                path: "M246.5,429.18l-3.14,1.83l-0.57,3.16l-0.64,0.05l-2.68,-1.06l-2.82,-2.33l-3.04,-1.89l-0.69,-1.85l0.63,-2.14l-1.21,-2.11l-0.31,-5.37l1.01,-2.91l2.57,-2.38l-0.18,-0.68l-3.16,-0.77l2.05,-2.47l0.77,-4.65l2.32,0.9l0.54,-0.29l1.31,-6.31l-0.22,-0.44l-1.68,-0.8l-0.56,0.28l-0.7,3.36l-0.81,-0.22l1.56,-9.41l1.15,-2.24l-0.71,-2.82l-0.18,-2.84l1.01,-0.33l3.26,-9.14l1.07,-4.22l-0.56,-4.21l0.74,-2.34l-0.29,-3.27l1.46,-3.34l2.04,-16.59l-0.66,-7.76l1.03,-0.53l0.54,-0.9l0.79,1.14l0.32,1.78l1.25,1.16l-0.69,2.55l1.33,2.9l0.97,3.59l0.46,0.29l1.5,-0.3l0.11,0.23l-0.76,2.44l-2.57,1.23l-0.23,0.37l0.08,4.33l-0.46,0.77l0.56,1.21l-1.58,1.51l-1.68,2.62l-0.89,2.47l0.2,2.7l-1.48,2.73l1.12,5.09l0.64,0.61l-0.01,2.29l-1.38,2.68l0.01,2.4l-1.89,2.04l0.02,2.75l0.69,2.57l-1.43,1.13l-1.26,5.68l0.39,3.51l-0.97,0.89l0.58,3.5l1.02,1.14l-0.65,1.02l0.15,0.57l1.0,0.53l0.16,0.69l-1.03,0.85l0.26,1.75l-0.89,4.03l-1.31,2.66l0.24,1.75l-0.71,1.83l-1.99,1.7l0.3,3.67l0.88,1.19l1.58,0.01l0.01,2.21l1.04,1.95l5.98,0.63ZM248.69,430.79l0.0,7.33l0.4,0.4l3.52,0.05l-0.44,0.75l-1.94,0.98l-2.49,-0.37l-1.88,-1.06l-2.55,-0.49l-5.59,-3.71l-2.38,-2.63l4.1,2.48l3.32,1.23l0.45,-0.12l1.29,-1.57l0.83,-2.32l2.05,-1.24l1.31,0.29Z",
                name: "Chile"
            },
            CA: {
                path: "M280.06,145.6l-1.67,2.88l0.07,0.49l0.5,0.04l1.46,-0.98l1.0,0.42l-0.56,0.72l0.17,0.62l2.22,0.89l1.35,-0.71l1.95,0.78l-0.66,2.01l0.5,0.51l1.32,-0.42l0.98,3.17l-0.91,2.41l-0.8,0.08l-1.23,-0.45l0.47,-2.25l-0.89,-0.83l-0.48,0.06l-2.78,2.63l-0.34,-0.02l1.02,-0.85l-0.14,-0.69l-2.4,-0.77l-7.4,0.08l-0.17,-0.41l1.3,-0.94l0.02,-0.64l-0.73,-0.58l1.85,-1.74l2.57,-5.16l1.47,-1.79l1.99,-1.05l0.46,0.06l-1.53,2.45ZM68.32,74.16l4.13,0.95l4.02,2.14l2.61,0.4l2.47,-1.89l2.88,-1.31l3.85,0.48l3.71,-1.94l3.82,-1.04l1.56,1.68l0.49,0.08l1.87,-1.04l0.65,-1.98l1.24,0.35l4.16,3.94l0.54,0.01l2.75,-2.49l0.26,2.59l0.49,0.35l3.08,-0.73l1.04,-1.27l2.73,0.23l3.83,1.86l5.86,1.61l3.47,0.75l2.44,-0.26l2.73,1.78l-2.98,1.81l-0.19,0.41l0.31,0.32l4.53,0.92l6.87,-0.5l2.0,-0.69l2.49,2.39l0.53,0.02l2.72,-2.16l-0.02,-0.64l-2.16,-1.54l1.15,-1.06l4.83,-0.61l1.84,0.95l2.48,2.31l3.01,-0.23l4.55,1.92l3.85,-0.67l3.61,0.1l0.41,-0.44l-0.25,-2.36l1.79,-0.61l3.49,1.32l-0.01,3.77l0.31,0.39l0.45,-0.22l1.48,-3.16l1.74,0.1l0.41,-0.3l1.13,-4.37l-2.78,-3.11l-2.8,-1.74l0.19,-4.64l2.71,-3.07l2.98,0.67l2.41,1.95l3.19,4.8l-1.99,1.97l0.21,0.68l4.33,0.84l-0.01,4.15l0.25,0.37l0.44,-0.09l3.07,-3.15l2.54,2.39l-0.61,3.33l2.42,2.88l0.61,0.0l2.61,-3.08l1.88,-3.82l0.17,-4.58l6.72,0.94l3.13,2.04l0.13,1.82l-1.76,2.19l-0.01,0.49l1.66,2.16l-0.26,1.71l-4.68,2.8l-3.28,0.61l-2.47,-1.2l-0.55,0.23l-0.73,2.04l-2.38,3.43l-0.74,1.77l-2.74,2.57l-3.44,0.25l-2.21,1.78l-0.28,2.53l-2.82,0.55l-3.12,3.22l-2.72,4.31l-1.03,3.17l-0.14,4.31l0.33,0.41l3.44,0.57l2.24,5.95l0.45,0.23l3.4,-0.69l4.52,1.51l2.43,1.31l1.91,1.73l3.1,0.96l2.62,1.46l6.6,0.54l-0.35,2.74l0.81,3.53l1.81,3.78l3.83,3.3l0.45,0.04l2.1,-1.28l1.37,-3.69l-1.31,-5.38l-1.45,-1.58l3.57,-1.47l2.84,-2.46l1.52,-2.8l-0.25,-2.55l-1.7,-3.07l-2.85,-2.61l2.8,-3.95l-1.08,-3.37l-0.79,-5.67l1.36,-0.7l6.76,1.41l2.12,-0.96l5.12,3.36l1.05,1.61l4.08,0.26l-0.06,2.87l0.83,4.7l0.3,0.32l2.16,0.54l1.73,2.06l0.5,0.09l3.63,-2.03l2.52,-4.19l1.26,-1.32l7.6,11.72l-0.92,2.04l0.16,0.51l3.3,1.97l2.22,1.98l4.1,0.98l1.43,0.99l0.95,2.79l2.1,0.68l0.84,1.08l0.17,3.45l-3.37,2.26l-4.22,1.24l-3.06,2.63l-4.06,0.51l-5.35,-0.69l-6.39,0.2l-2.3,2.41l-3.26,1.51l-6.47,7.15l-0.06,0.48l0.44,0.19l2.13,-0.52l4.17,-4.24l5.12,-2.62l3.52,-0.3l1.69,1.21l-2.12,2.21l0.81,3.47l1.02,2.61l3.47,1.6l4.14,-0.45l2.15,-2.8l0.26,1.48l1.14,0.8l-2.56,1.69l-5.5,1.82l-2.54,1.27l-2.74,2.15l-1.4,-0.16l-0.07,-2.01l4.14,-2.44l0.18,-0.45l-0.39,-0.29l-6.63,0.45l-1.39,-1.49l-0.14,-4.43l-1.11,-0.91l-1.82,0.39l-0.66,-0.66l-0.6,0.03l-1.91,2.39l-0.82,2.52l-0.8,1.27l-1.67,0.56l-0.46,0.76l-8.31,0.07l-1.21,0.62l-2.35,1.97l-0.71,-0.14l-1.37,0.96l-1.12,-0.48l-4.74,1.26l-0.9,1.17l0.21,0.62l1.73,0.3l-1.81,0.31l-1.85,0.81l-2.11,-0.13l-2.95,1.78l-0.69,-0.09l1.39,-2.1l1.73,-1.21l0.1,-2.29l1.16,-1.99l0.49,0.53l2.03,0.42l1.2,-1.16l0.02,-0.47l-2.66,-3.51l-2.28,-0.61l-5.64,-0.71l-0.4,-0.57l-0.79,0.13l0.2,-0.41l-0.22,-0.55l-0.68,-0.26l0.19,-1.26l-0.78,-0.73l0.31,-0.64l-0.29,-0.57l-2.6,-0.44l-0.75,-1.63l-0.94,-0.66l-4.31,-0.65l-1.13,1.19l-1.48,0.59l-0.85,1.06l-2.83,-0.76l-2.09,0.39l-2.39,-0.97l-4.24,-0.7l-0.57,-0.4l-0.41,-1.63l-0.4,-0.3l-0.85,0.02l-0.39,0.4l-0.01,0.85l-69.13,-0.01l-6.51,-4.52l-4.5,-1.38l-1.26,-2.66l0.33,-1.93l-0.23,-0.43l-3.01,-1.35l-0.55,-2.77l-2.89,-2.38l-0.04,-1.45l1.39,-1.83l-0.28,-2.55l-4.16,-2.2l-4.07,-6.6l-4.02,-3.22l-1.3,-1.88l-0.5,-0.13l-2.51,1.21l-2.23,1.87l-3.85,-3.88l-2.44,-1.04l-2.22,-0.13l0.03,-37.49ZM260.37,148.65l3.04,0.76l2.26,1.2l-3.78,-0.95l-1.53,-1.01ZM249.4,3.81l6.68,0.49l5.32,0.79l4.26,1.57l-0.07,1.1l-5.85,2.53l-6.02,1.21l-2.39,1.39l-0.18,0.45l0.39,0.29l4.01,-0.02l-4.65,2.82l-4.2,1.74l-4.19,4.59l-5.03,0.92l-1.67,1.15l-7.47,0.59l-0.37,0.37l0.32,0.42l2.41,0.49l-0.81,0.47l-0.12,0.59l1.83,2.41l-2.02,1.59l-3.81,1.51l-1.32,2.16l-3.38,1.53l-0.22,0.48l0.35,1.19l0.4,0.29l3.88,-0.18l0.03,0.61l-6.33,2.95l-6.41,-1.4l-7.43,0.79l-3.72,-0.62l-4.4,-0.25l-0.23,-1.83l4.29,-1.11l0.28,-0.51l-1.1,-3.45l1.0,-0.25l6.58,2.28l0.47,-0.16l-0.05,-0.49l-3.41,-3.45l-3.58,-0.98l1.48,-1.55l4.34,-1.29l0.97,-2.19l-0.16,-0.48l-3.42,-2.13l-0.81,-2.26l6.2,0.22l2.24,0.58l3.91,-2.1l0.2,-0.43l-0.35,-0.32l-5.64,-0.67l-8.73,0.36l-4.26,-1.9l-2.12,-2.4l-2.78,-1.66l-0.41,-1.52l3.31,-1.03l2.93,-0.2l4.91,-0.99l3.7,-2.27l2.87,0.3l2.62,1.67l0.56,-0.14l1.82,-3.2l3.13,-0.94l4.44,-0.69l7.53,-0.26l1.48,0.67l7.19,-1.06l10.8,0.79ZM203.85,57.54l0.01,0.42l1.97,2.97l0.68,-0.02l2.24,-3.72l5.95,-1.86l4.01,4.64l-0.35,2.91l0.5,0.43l4.95,-1.36l2.32,-1.8l5.31,2.28l3.27,2.11l0.3,1.84l0.48,0.33l4.42,-0.99l2.64,2.87l5.97,1.77l2.06,1.72l2.11,3.71l-4.19,1.86l-0.01,0.73l5.9,2.83l3.94,0.94l3.78,3.95l3.46,0.25l-0.63,2.37l-4.11,4.47l-2.76,-1.56l-3.9,-3.94l-3.59,0.41l-0.33,0.34l-0.19,2.72l2.63,2.38l3.42,1.89l0.94,0.97l1.55,3.75l-0.7,2.29l-2.74,-0.92l-6.25,-3.15l-0.51,0.13l0.05,0.52l6.07,5.69l0.18,0.59l-6.09,-1.39l-5.31,-2.24l-2.63,-1.66l0.6,-0.77l-0.12,-0.6l-7.39,-4.01l-0.59,0.37l0.03,0.79l-6.73,0.6l-1.69,-1.1l1.36,-2.46l4.51,-0.07l5.15,-0.52l0.31,-0.6l-0.74,-1.3l0.78,-1.84l3.21,-4.05l-0.67,-2.35l-1.11,-1.6l-3.84,-2.1l-4.35,-1.28l0.91,-0.63l0.06,-0.61l-2.65,-2.75l-2.34,-0.36l-1.89,-1.46l-0.53,0.03l-1.24,1.23l-4.36,0.55l-9.04,-0.99l-9.26,-1.98l-1.6,-1.22l2.22,-1.77l0.13,-0.44l-0.38,-0.27l-3.22,-0.02l-0.72,-4.25l1.83,-4.04l2.42,-1.85l5.5,-1.1l-1.39,2.35ZM261.19,159.33l2.07,0.61l1.44,-0.04l-1.15,0.63l-2.94,-1.23l-0.4,-0.68l0.36,-0.37l0.61,1.07ZM230.83,84.39l-2.37,0.18l-0.49,-1.63l0.93,-2.09l1.94,-0.51l1.62,0.99l0.02,1.52l-1.66,1.54ZM229.43,58.25l0.11,0.65l-4.87,-0.21l-2.72,0.62l-3.1,-2.57l0.08,-1.26l0.86,-0.23l5.57,0.51l4.08,2.5ZM222.0,105.02l-0.72,1.49l-0.63,-0.19l-0.48,-0.84l0.81,-0.99l0.65,0.05l0.37,0.46ZM183.74,38.32l2.9,1.7l4.79,-0.01l1.84,1.46l-0.49,1.68l0.23,0.48l2.82,1.14l1.76,1.26l7.01,0.65l4.1,-1.1l5.03,-0.43l3.93,0.35l2.48,1.77l0.46,1.7l-1.3,1.1l-3.56,1.01l-3.23,-0.59l-7.17,0.76l-5.09,0.09l-3.99,-0.6l-6.42,-1.54l-0.79,-2.51l-0.3,-2.49l-2.64,-2.5l-5.32,-0.72l-2.52,-1.4l0.68,-1.57l4.78,0.31ZM207.38,91.35l0.4,1.56l0.56,0.26l1.06,-0.52l1.32,0.96l5.42,2.57l0.2,1.68l0.46,0.35l1.68,-0.28l1.15,0.85l-1.55,0.87l-3.61,-0.88l-1.32,-1.69l-0.57,-0.06l-2.45,2.1l-3.12,1.79l-0.7,-1.87l-0.42,-0.26l-2.16,0.24l1.39,-1.39l0.32,-3.14l0.76,-3.35l1.18,0.22ZM215.49,102.6l-2.67,1.95l-1.4,-0.07l-0.3,-0.58l1.53,-1.48l2.84,0.18ZM202.7,24.12l2.53,1.59l-2.87,1.4l-4.53,4.05l-4.25,0.38l-5.03,-0.68l-2.45,-2.04l0.03,-1.62l1.82,-1.37l0.14,-0.45l-0.38,-0.27l-4.45,0.04l-2.59,-1.76l-1.41,-2.29l1.57,-2.32l1.62,-1.66l2.44,-0.39l0.25,-0.65l-0.6,-0.74l4.86,-0.25l3.24,3.11l8.16,2.3l1.9,3.61ZM187.47,59.2l-2.76,3.49l-2.38,-0.15l-1.44,-3.84l0.04,-2.2l1.19,-1.88l2.3,-1.23l5.07,0.17l4.11,1.02l-3.24,3.72l-2.88,0.89ZM186.07,48.79l-1.08,1.53l-3.34,-0.34l-2.56,-1.1l1.03,-1.75l3.25,-1.23l1.95,1.58l0.75,1.3ZM185.71,35.32l-5.3,-0.2l-0.32,-0.71l4.31,0.07l1.3,0.84ZM180.68,32.48l-3.34,1.0l-1.79,-1.1l-0.98,-1.87l-0.15,-1.73l4.1,0.53l2.67,1.7l-0.51,1.47ZM180.9,76.31l-1.1,1.08l-3.13,-1.23l-2.12,0.43l-2.71,-1.57l1.72,-1.09l1.55,-1.72l3.81,1.9l1.98,2.2ZM169.74,54.87l2.96,0.97l4.17,-0.57l0.41,0.88l-2.14,2.11l0.09,0.64l3.55,1.92l-0.4,3.72l-3.79,1.65l-2.17,-0.35l-1.72,-1.74l-6.02,-3.5l0.03,-0.85l4.68,0.54l0.4,-0.21l-0.05,-0.45l-2.48,-2.81l2.46,-1.95ZM174.45,40.74l1.37,1.73l0.07,2.44l-1.05,3.45l-3.79,0.47l-2.32,-0.69l0.05,-2.64l-0.44,-0.41l-3.68,0.35l-0.12,-3.1l2.45,0.1l3.67,-1.73l3.41,0.29l0.37,-0.26ZM170.05,31.55l0.67,1.56l-3.33,-0.49l-4.22,-1.77l-4.35,-0.16l1.4,-0.94l-0.06,-0.7l-2.81,-1.23l-0.12,-1.39l4.39,0.68l6.62,1.98l1.81,2.47ZM134.5,58.13l-1.02,1.82l0.45,0.58l5.4,-1.39l3.33,2.29l0.49,-0.03l2.6,-2.23l1.94,1.32l2.0,4.5l0.7,0.06l1.3,-2.29l-1.63,-4.46l1.69,-0.54l2.31,0.71l2.65,1.81l2.49,7.92l8.48,4.27l-0.19,1.35l-3.79,0.33l-0.26,0.67l1.4,1.49l-0.58,1.1l-4.23,-0.64l-4.43,-1.19l-3.0,0.28l-4.66,1.47l-10.52,1.04l-1.43,-2.02l-3.42,-1.2l-2.21,0.43l-2.51,-2.86l4.84,-1.05l3.6,0.19l3.27,-0.78l0.31,-0.39l-0.31,-0.39l-4.84,-1.06l-8.79,0.27l-0.85,-1.07l5.26,-1.66l0.27,-0.45l-0.4,-0.34l-3.8,0.06l-3.81,-1.06l1.81,-3.01l1.66,-1.79l6.48,-2.81l1.97,0.71ZM158.7,56.61l-1.7,2.44l-3.2,-2.75l0.37,-0.3l3.11,-0.18l1.42,0.79ZM149.61,42.73l1.01,1.89l0.5,0.18l2.14,-0.82l2.23,0.19l0.36,2.04l-1.33,2.09l-8.28,0.76l-6.35,2.15l-3.41,0.1l-0.19,-0.96l4.9,-2.08l0.23,-0.46l-0.41,-0.31l-11.25,0.59l-2.89,-0.74l3.04,-4.44l2.14,-1.32l6.81,1.69l4.58,3.06l4.37,0.39l0.36,-0.63l-3.36,-4.6l1.85,-1.53l2.18,0.51l0.77,2.26ZM144.76,34.41l-4.36,1.44l-3.0,-1.4l1.46,-1.24l3.47,-0.52l2.96,0.71l-0.52,1.01ZM145.13,29.83l-1.9,0.66l-3.67,-0.0l2.27,-1.61l3.3,0.95ZM118.92,65.79l-6.03,2.02l-1.33,-1.9l-5.38,-2.28l2.59,-5.05l2.16,-3.14l-0.02,-0.48l-1.97,-2.41l7.64,-0.7l3.6,1.02l6.3,0.27l4.42,2.95l-2.53,0.98l-6.24,3.43l-3.1,3.28l-0.11,2.01ZM129.54,35.53l-0.28,3.37l-1.72,1.62l-2.33,0.28l-4.61,2.19l-3.86,0.76l-2.64,-0.87l3.72,-3.4l5.01,-3.34l3.72,0.07l3.0,-0.67ZM111.09,152.69l-0.67,0.24l-3.85,-1.37l-0.83,-1.17l-2.12,-1.07l-0.66,-1.02l-2.4,-0.55l-0.74,-1.71l6.02,1.45l2.0,2.55l2.52,1.39l0.73,1.27ZM87.8,134.64l0.89,0.29l1.86,-0.21l-0.65,3.34l1.69,2.33l-1.31,-1.33l-0.99,-1.62l-1.17,-0.98l-0.33,-1.82Z",
                name: "Canada"
            },
            CG: {
                path: "M466.72,276.48l-0.1,1.03l-1.25,2.97l-0.19,3.62l-0.46,1.78l-0.23,0.63l-1.61,1.19l-1.21,1.39l-1.09,2.43l0.04,2.09l-3.25,3.24l-0.5,-0.24l-0.5,-0.83l-1.36,-0.02l-0.98,0.89l-1.68,-0.99l-1.54,1.24l-1.52,-1.96l1.57,-1.14l0.11,-0.52l-0.77,-1.35l2.1,-0.66l0.39,-0.73l1.05,0.82l2.21,0.11l1.12,-1.37l0.37,-1.81l-0.27,-2.09l-1.13,-1.5l1.0,-2.69l-0.13,-0.45l-0.92,-0.58l-1.6,0.17l-0.51,-0.94l0.1,-0.61l2.75,0.09l3.97,1.24l0.51,-0.33l0.17,-1.28l1.24,-2.21l1.28,-1.14l2.76,0.49Z",
                name: "Congo"
            },
            CF: {
                path: "M461.16,278.2l-0.26,-1.19l-1.09,-0.77l-0.84,-1.17l-0.29,-1.0l-1.04,-1.15l0.08,-3.43l0.58,-0.49l1.16,-2.35l1.85,-0.17l0.61,-0.62l0.97,0.58l3.15,-0.96l2.48,-1.92l0.02,-0.96l2.81,0.02l2.36,-1.17l1.93,-2.85l1.16,-0.93l1.11,-0.3l0.27,0.86l1.34,1.47l-0.39,2.01l0.3,1.01l4.01,2.75l0.17,0.93l2.63,2.31l0.6,1.44l2.08,1.4l-3.84,-0.21l-1.94,0.88l-1.23,-0.49l-2.67,1.2l-1.29,-0.18l-0.51,0.36l-0.6,1.22l-3.35,-0.65l-1.57,-0.91l-2.42,-0.83l-1.45,0.91l-0.97,1.27l-0.26,1.56l-3.22,-0.43l-1.49,1.33l-0.94,1.62Z",
                name: "Central African Rep."
            },
            CD: {
                path: "M487.01,272.38l2.34,-0.14l1.35,1.84l1.34,0.45l0.86,-0.39l1.21,0.12l1.07,-0.41l0.54,0.89l2.04,1.54l-0.14,2.72l0.7,0.54l-1.38,1.13l-1.53,2.54l-0.17,2.05l-0.59,1.08l-0.02,1.72l-0.72,0.84l-0.66,3.01l0.63,1.32l-0.44,4.26l0.64,1.47l-0.37,1.22l0.86,1.8l1.53,1.41l0.3,1.26l0.44,0.5l-4.08,0.75l-0.92,1.81l0.51,1.34l-0.74,5.43l0.17,0.38l2.45,1.46l0.54,-0.1l0.12,1.62l-1.28,-0.01l-1.85,-2.35l-1.94,-0.45l-0.48,-1.13l-0.55,-0.2l-1.41,0.74l-1.71,-0.3l-1.01,-1.18l-2.49,-0.19l-0.44,-0.77l-1.98,-0.21l-2.88,0.36l0.11,-2.41l-0.85,-1.13l-0.16,-1.36l0.32,-1.73l-0.46,-0.89l-0.04,-1.49l-0.4,-0.39l-2.53,0.02l0.1,-0.41l-0.39,-0.49l-1.28,0.01l-0.43,0.45l-1.62,0.32l-0.83,1.79l-1.09,-0.28l-2.4,0.52l-1.37,-1.91l-1.3,-3.3l-0.38,-0.27l-7.39,-0.03l-2.46,0.42l0.5,-0.45l0.37,-1.47l0.66,-0.38l0.92,0.08l0.73,-0.82l0.87,0.02l0.31,0.68l1.4,0.36l3.59,-3.63l0.01,-2.23l1.02,-2.29l2.69,-2.39l0.43,-0.99l0.49,-1.96l0.17,-3.51l1.25,-2.95l0.36,-3.14l0.86,-1.13l1.1,-0.66l3.57,1.73l3.65,0.73l0.46,-0.21l0.8,-1.46l1.24,0.19l2.61,-1.17l0.81,0.44l1.04,-0.03l0.59,-0.66l0.7,-0.16l1.81,0.25Z",
                name: "Dem. Rep. Congo"
            },
            CZ: {
                path: "M458.46,144.88l1.22,1.01l1.47,0.23l0.13,0.93l1.36,0.68l0.54,-0.2l0.24,-0.55l1.15,0.25l0.53,1.09l1.68,0.18l0.6,0.84l-1.04,0.73l-0.96,1.28l-1.6,0.17l-0.55,0.56l-1.04,-0.46l-1.05,0.15l-2.12,-0.96l-1.05,0.34l-1.2,1.12l-1.56,-0.87l-2.57,-2.1l-0.53,-1.88l4.7,-2.52l0.71,0.26l0.9,-0.28Z",
                name: "Czech Rep."
            },
            CY: {
                path: "M504.36,193.47l0.43,0.28l-1.28,0.57l-0.92,-0.28l-0.24,-0.46l2.01,-0.13Z",
                name: "Cyprus"
            },
            CR: {
                path: "M211.34,258.05l0.48,0.99l1.6,1.6l-0.54,0.45l0.29,1.42l-0.25,1.19l-1.09,-0.59l-0.05,-1.25l-2.46,-1.42l-0.28,-0.77l-0.66,-0.45l-0.45,-0.0l-0.11,1.04l-1.32,-0.95l0.31,-1.3l-0.36,-0.6l0.31,-0.27l1.42,0.58l1.29,-0.14l0.56,0.56l0.74,0.17l0.55,-0.27Z",
                name: "Costa Rica"
            },
            CU: {
                path: "M221.21,227.25l1.27,1.02l2.19,-0.28l4.43,3.33l2.08,0.43l-0.1,0.38l0.36,0.5l1.75,0.1l1.48,0.84l-3.11,0.51l-4.15,-0.03l0.77,-0.67l-0.04,-0.64l-1.2,-0.74l-1.49,-0.16l-0.7,-0.61l-0.56,-1.4l-0.4,-0.25l-1.34,0.1l-2.2,-0.66l-0.88,-0.58l-3.18,-0.4l-0.27,-0.16l0.58,-0.74l-0.36,-0.29l-2.72,-0.05l-1.7,1.29l-0.91,0.03l-0.61,0.69l-1.01,0.22l1.11,-1.29l1.01,-0.52l3.69,-1.01l3.98,0.21l2.21,0.84Z",
                name: "Cuba"
            },
            SZ: {
                path: "M500.35,351.36l0.5,2.04l-0.38,0.89l-1.05,0.21l-1.23,-1.2l-0.02,-0.64l0.83,-1.57l1.34,0.27Z",
                name: "Swaziland"
            },
            SY: {
                path: "M511.0,199.79l0.05,-1.33l0.54,-1.36l1.28,-0.99l0.13,-0.45l-0.41,-1.11l-1.14,-0.36l-0.19,-1.74l0.52,-1.0l1.29,-1.21l0.2,-1.18l0.59,0.23l2.62,-0.76l1.36,0.52l2.06,-0.01l2.95,-1.08l3.25,-0.26l-0.67,0.94l-1.28,0.66l-0.21,0.4l0.23,2.01l-0.88,3.19l-10.15,5.73l-2.15,-0.85Z",
                name: "Syria"
            },
            KG: {
                path: "M621.35,172.32l-3.87,1.69l-0.96,1.18l-3.04,0.34l-1.13,1.86l-2.36,-0.35l-1.99,0.63l-2.39,1.4l0.06,0.95l-0.4,0.37l-4.52,0.43l-3.02,-0.93l-2.37,0.17l0.11,-0.79l2.32,0.42l1.13,-0.88l1.99,0.2l3.21,-2.14l-0.03,-0.69l-2.97,-1.57l-1.94,0.65l-1.22,-0.74l1.71,-1.58l-0.12,-0.67l-0.36,-0.15l0.32,-0.77l1.36,-0.35l4.02,1.02l0.49,-0.3l0.35,-1.59l1.09,-0.48l3.42,1.22l1.11,-0.31l7.64,0.39l1.16,1.0l1.23,0.39Z",
                name: "Kyrgyzstan"
            },
            KE: {
                path: "M506.26,284.69l1.87,-2.56l0.93,-2.15l-1.38,-4.08l-1.06,-1.6l2.82,-2.75l0.79,0.26l0.12,1.41l0.86,0.83l1.9,0.11l3.28,2.13l3.57,0.44l1.05,-1.12l1.96,-0.9l0.82,0.68l1.16,0.09l-1.78,2.45l0.03,9.12l1.3,1.94l-1.37,0.78l-0.67,1.03l-1.08,0.46l-0.34,1.67l-0.81,1.07l-0.45,1.55l-0.68,0.56l-3.2,-2.23l-0.35,-1.58l-8.86,-4.98l0.14,-1.6l-0.57,-1.04Z",
                name: "Kenya"
            },
            SS: {
                path: "M481.71,263.34l1.07,-0.72l1.2,-3.18l1.36,-0.26l1.61,1.99l0.87,0.34l1.1,-0.41l1.5,0.07l0.57,0.53l2.49,0.0l0.44,-0.63l1.07,-0.4l0.45,-0.84l0.59,-0.33l1.9,1.33l1.6,-0.2l2.83,-3.33l-0.32,-2.21l1.59,-0.52l-0.24,1.6l0.3,1.83l1.35,1.18l0.2,1.87l0.35,0.41l0.02,1.53l-0.23,0.47l-1.42,0.25l-0.85,1.44l0.3,0.6l1.4,0.16l1.11,1.08l0.59,1.13l1.03,0.53l1.28,2.36l-4.41,3.98l-1.74,0.01l-1.89,0.55l-1.47,-0.52l-1.15,0.57l-2.96,-2.62l-1.3,0.49l-1.06,-0.15l-0.79,0.39l-0.82,-0.22l-1.8,-2.7l-1.91,-1.1l-0.66,-1.5l-2.62,-2.32l-0.18,-0.94l-2.37,-1.6Z",
                name: "S. Sudan"
            },
            SR: {
                path: "M283.12,270.19l2.1,0.53l-1.08,1.95l0.2,1.72l0.93,1.49l-0.59,2.03l-0.43,0.71l-1.12,-0.42l-1.32,0.22l-0.93,-0.2l-0.46,0.26l-0.25,0.73l0.33,0.7l-0.89,-0.13l-1.39,-1.97l-0.31,-1.34l-0.97,-0.31l-0.89,-1.47l0.35,-1.61l1.45,-0.82l0.33,-1.87l2.61,0.44l0.57,-0.47l1.75,-0.16Z",
                name: "Suriname"
            },
            KH: {
                path: "M689.52,249.39l0.49,1.45l-0.28,2.74l-4.0,1.86l-0.16,0.6l0.68,0.95l-2.06,0.17l-2.05,0.97l-1.82,-0.32l-2.12,-3.7l-0.55,-2.85l1.4,-1.85l3.02,-0.45l2.23,0.35l2.01,0.98l0.51,-0.14l0.95,-1.48l1.74,0.74Z",
                name: "Cambodia"
            },
            SV: {
                path: "M195.8,250.13l1.4,-1.19l2.24,1.45l0.98,-0.27l0.44,0.2l-0.27,1.05l-1.14,-0.03l-3.64,-1.21Z",
                name: "El Salvador"
            },
            SK: {
                path: "M476.82,151.17l-1.14,1.9l-2.73,-0.92l-0.82,0.2l-0.74,0.8l-3.46,0.73l-0.47,0.69l-1.76,0.33l-1.88,-1.0l-0.18,-0.81l0.38,-0.75l1.87,-0.32l1.74,-1.89l0.83,0.16l0.79,-0.34l1.51,1.04l1.34,-0.63l1.25,0.3l1.65,-0.42l1.81,0.95Z",
                name: "Slovakia"
            },
            KR: {
                path: "M737.51,185.84l0.98,-0.1l0.87,-1.17l2.69,-0.32l0.33,-0.29l1.76,2.79l0.58,1.76l0.02,3.12l-0.8,1.32l-2.21,0.55l-1.93,1.13l-1.8,0.19l-0.2,-1.1l0.43,-2.28l-0.95,-2.56l1.43,-0.37l0.23,-0.62l-1.43,-2.06Z",
                name: "Korea"
            },
            SI: {
                path: "M456.18,162.07l-0.51,-1.32l0.18,-1.05l1.69,0.2l1.42,-0.71l2.09,-0.07l0.62,-0.51l0.21,0.47l-1.61,0.67l-0.44,1.34l-0.66,0.24l-0.26,0.82l-1.22,-0.49l-0.84,0.46l-0.69,-0.04Z",
                name: "Slovenia"
            },
            KP: {
                path: "M736.77,185.16l-0.92,-0.42l-0.88,0.62l-1.21,-0.88l0.96,-1.15l0.59,-2.59l-0.46,-0.74l-2.09,-0.77l1.64,-1.52l2.72,-1.58l1.58,-1.91l1.11,0.78l2.17,0.11l0.41,-0.5l-0.3,-1.22l3.52,-1.18l0.94,-1.4l0.98,1.08l-2.19,2.18l0.01,2.14l-1.06,0.54l-1.41,1.4l-1.7,0.52l-1.25,1.09l-0.14,1.98l0.94,0.45l1.15,1.04l-0.13,0.26l-2.6,0.29l-1.13,1.29l-1.22,0.08Z",
                name: "Dem. Rep. Korea"
            },
            SO: {
                path: "M525.13,288.48l-1.13,-1.57l-0.03,-8.86l2.66,-3.38l1.67,-0.13l2.13,-1.69l3.41,-0.23l7.08,-7.55l2.91,-3.69l0.08,-4.82l2.98,-0.67l1.24,-0.86l0.45,-0.0l-0.2,3.0l-1.21,3.62l-2.73,5.97l-2.13,3.65l-5.03,6.16l-8.56,6.4l-2.78,3.08l-0.8,1.56Z",
                name: "Somalia"
            },
            SN: {
                path: "M390.09,248.21l0.12,1.55l0.49,1.46l0.96,0.82l0.05,1.28l-1.26,-0.19l-0.75,0.33l-1.84,-0.61l-5.84,-0.13l-2.54,0.51l-0.22,-1.03l1.77,0.04l2.01,-0.91l1.03,0.48l1.09,0.04l1.29,-0.62l0.14,-0.58l-0.51,-0.74l-1.81,0.25l-1.13,-0.63l-0.79,0.04l-0.72,0.61l-2.31,0.06l-0.92,-1.77l-0.81,-0.64l0.64,-0.35l2.46,-3.74l1.04,0.19l1.38,-0.56l1.19,-0.02l2.72,1.37l3.03,3.48Z",
                name: "Senegal"
            },
            SL: {
                path: "M394.46,264.11l-1.73,1.98l-0.58,1.33l-2.07,-1.06l-1.22,-1.26l-0.65,-2.39l1.16,-0.96l0.67,-1.17l1.21,-0.52l1.66,0.0l1.03,1.64l0.52,2.41Z",
                name: "Sierra Leone"
            },
            SB: {
                path: "M826.69,311.6l-0.61,0.09l-0.2,-0.33l0.37,0.15l0.44,0.09ZM824.18,307.38l-0.26,-0.3l-0.31,-0.91l0.03,0.0l0.54,1.21ZM823.04,309.33l-1.66,-0.22l-0.2,-0.52l1.16,0.28l0.69,0.46ZM819.28,304.68l1.14,0.65l0.02,0.03l-0.81,-0.44l-0.35,-0.23Z",
                name: "Solomon Is."
            },
            SA: {
                path: "M537.53,210.34l2.0,0.24l0.9,1.32l1.49,-0.06l0.87,2.08l1.29,0.76l0.51,0.99l1.56,1.03l-0.1,1.9l0.32,0.9l1.58,2.47l0.76,0.53l0.7,-0.04l1.68,4.23l7.53,1.33l0.51,-0.29l0.77,1.25l-1.55,4.87l-7.29,2.52l-7.3,1.03l-2.34,1.17l-1.88,2.74l-0.76,0.28l-0.82,-0.78l-0.91,0.12l-2.88,-0.51l-3.51,0.25l-0.86,-0.56l-0.57,0.15l-0.66,1.27l0.16,1.11l-0.43,0.32l-0.93,-1.4l-0.33,-1.16l-1.23,-0.88l-1.27,-2.06l-0.78,-2.22l-1.73,-1.79l-1.14,-0.48l-1.54,-2.31l-0.21,-3.41l-1.44,-2.93l-1.27,-1.16l-1.33,-0.57l-1.31,-3.37l-0.77,-0.67l-0.97,-1.97l-2.8,-4.03l-1.06,-0.17l0.37,-1.96l0.2,-0.72l2.74,0.3l1.08,-0.84l0.6,-0.94l1.74,-0.35l0.65,-1.03l0.71,-0.4l0.1,-0.62l-2.06,-2.28l4.39,-1.22l0.48,-0.37l2.77,0.69l3.66,1.9l7.03,5.5l4.87,0.3Z",
                name: "Saudi Arabia"
            },
            SE: {
                path: "M480.22,89.3l-4.03,1.17l-2.43,2.86l0.26,2.57l-8.77,6.64l-1.78,5.79l1.78,2.68l2.22,1.96l-2.07,3.77l-2.72,1.13l-0.95,6.04l-1.29,3.01l-2.74,-0.31l-0.4,0.22l-1.31,2.59l-2.34,0.13l-0.75,-3.09l-2.08,-4.03l-1.83,-4.96l1.0,-1.93l2.14,-2.7l0.83,-4.45l-1.6,-2.17l-0.15,-4.94l1.48,-3.39l2.58,-0.15l0.87,-1.59l-0.78,-1.57l3.76,-5.59l4.04,-7.48l2.17,0.01l0.39,-0.29l0.57,-2.07l4.37,0.64l0.46,-0.34l0.33,-2.56l1.1,-0.13l6.94,4.87l0.06,6.32l0.66,1.36Z",
                name: "Sweden"
            },
            SD: {
                path: "M505.98,259.4l-0.34,-0.77l-1.17,-0.9l-0.26,-1.61l0.29,-1.81l-0.34,-0.46l-1.16,-0.17l-0.54,0.59l-1.23,0.11l-0.28,0.65l0.53,0.65l0.17,1.22l-2.44,3.0l-0.96,0.19l-2.39,-1.4l-0.95,0.52l-0.38,0.78l-1.11,0.41l-0.29,0.5l-1.94,0.0l-0.54,-0.52l-1.81,-0.09l-0.95,0.4l-2.45,-2.35l-2.07,0.54l-0.73,1.26l-0.6,2.1l-1.25,0.58l-0.75,-0.62l0.27,-2.65l-1.48,-1.78l-0.22,-1.48l-0.92,-0.96l-0.02,-1.29l-0.57,-1.16l-0.68,-0.16l0.69,-1.29l-0.18,-1.14l0.65,-0.62l0.03,-0.55l-0.36,-0.41l1.55,-2.97l1.91,0.16l0.43,-0.4l-0.1,-10.94l2.49,-0.01l0.4,-0.4l-0.0,-4.82l29.02,0.0l0.64,2.04l-0.49,0.66l0.36,2.69l0.93,3.16l2.12,1.55l-0.89,1.04l-1.72,0.39l-0.98,0.9l-1.43,5.65l0.24,1.15l-0.38,2.06l-0.96,2.38l-1.53,1.31l-1.32,2.91l-1.22,0.86l-0.37,1.34Z",
                name: "Sudan"
            },
            DO: {
                path: "M241.8,239.2l0.05,-0.65l-0.46,-0.73l0.42,-0.44l0.19,-1.0l-0.09,-1.53l1.66,0.01l1.99,0.63l0.33,0.67l1.28,0.19l0.33,0.76l1.0,0.08l0.8,0.62l-0.45,0.51l-1.13,-0.47l-1.88,-0.01l-1.27,0.59l-0.75,-0.55l-1.01,0.54l-0.79,1.4l-0.23,-0.61Z",
                name: "Dominican Rep."
            },
            DJ: {
                path: "M528.43,256.18l-0.45,0.66l-0.58,-0.25l-1.51,0.13l-0.18,-1.01l1.45,-1.95l0.83,0.17l0.77,-0.44l0.2,1.0l-1.2,0.51l-0.06,0.7l0.73,0.47Z",
                name: "Djibouti"
            },
            DK: {
                path: "M452.28,129.07l-1.19,2.24l-2.13,-1.6l-0.23,-0.95l2.98,-0.95l0.57,1.26ZM447.74,126.31l-0.26,0.57l-0.88,-0.07l-1.8,2.53l0.48,1.69l-1.09,0.36l-1.61,-0.39l-0.89,-1.69l-0.07,-3.43l0.96,-1.73l2.02,-0.2l1.09,-1.07l1.33,-0.67l-0.05,1.06l-0.73,1.41l0.3,1.0l1.2,0.64Z",
                name: "Denmark"
            },
            DE: {
                path: "M453.14,155.55l-0.55,-0.36l-1.2,-0.1l-1.87,0.57l-2.13,-0.13l-0.56,0.63l-0.86,-0.6l-0.96,0.09l-2.57,-0.93l-0.85,0.67l-1.47,-0.02l0.24,-1.75l1.23,-2.14l-0.28,-0.59l-3.52,-0.58l-0.92,-0.66l0.12,-1.2l-0.48,-0.88l0.27,-2.17l-0.37,-3.03l1.41,-0.22l0.63,-1.26l0.66,-3.19l-0.41,-1.18l0.26,-0.39l1.66,-0.15l0.33,0.54l0.62,0.07l1.7,-1.69l-0.54,-3.02l1.37,0.33l1.31,-0.37l0.31,1.18l2.25,0.71l-0.02,0.92l0.5,0.4l2.55,-0.65l1.34,-0.87l2.57,1.24l1.06,0.98l0.48,1.44l-0.57,0.74l-0.0,0.48l0.87,1.15l0.57,1.64l-0.14,1.29l0.82,1.7l-1.5,-0.07l-0.56,0.57l-4.47,2.15l-0.22,0.54l0.68,2.26l2.58,2.16l-0.66,1.11l-0.79,0.36l-0.23,0.43l0.32,1.87Z",
                name: "Germany"
            },
            YE: {
                path: "M528.27,246.72l0.26,-0.42l-0.22,-1.01l0.19,-1.5l0.92,-0.69l-0.07,-1.35l0.39,-0.75l1.01,0.47l3.34,-0.27l3.76,0.41l0.95,0.81l1.36,-0.58l1.74,-2.62l2.18,-1.09l6.86,-0.94l2.48,5.41l-1.64,0.76l-0.56,1.9l-6.23,2.16l-2.29,1.8l-1.93,0.05l-1.41,1.02l-4.24,0.74l-1.72,1.49l-3.28,0.19l-0.52,-1.18l0.02,-1.51l-1.34,-3.29Z",
                name: "Yemen"
            },
            AT: {
                path: "M462.89,152.8l0.04,2.25l-1.07,0.0l-0.33,0.63l0.36,0.51l-1.04,2.13l-2.02,0.07l-1.33,0.7l-5.29,-0.99l-0.47,-0.93l-0.44,-0.21l-2.47,0.55l-0.42,0.51l-3.18,-0.81l0.43,-0.91l1.12,0.78l0.6,-0.17l0.25,-0.58l1.93,0.12l1.86,-0.56l1.0,0.08l0.68,0.57l0.62,-0.15l0.26,-0.77l-0.3,-1.78l0.8,-0.44l0.68,-1.15l1.52,0.85l0.47,-0.06l1.34,-1.25l0.64,-0.17l1.81,0.92l1.28,-0.11l0.7,0.37Z",
                name: "Austria"
            },
            DZ: {
                path: "M441.46,188.44l-0.32,1.07l0.39,2.64l-0.54,2.16l-1.58,1.82l0.37,2.39l1.91,1.55l0.18,0.8l1.42,1.03l1.84,7.23l0.12,1.16l-0.57,5.0l0.2,1.51l-0.87,0.99l-0.02,0.51l1.41,1.86l0.14,1.2l0.89,1.48l0.5,0.16l0.98,-0.41l1.73,1.08l0.82,1.23l-8.22,4.81l-7.23,5.11l-3.43,1.13l-2.3,0.21l-0.28,-1.59l-2.56,-1.09l-0.67,-1.25l-26.12,-17.86l0.01,-3.47l3.77,-1.88l2.44,-0.41l2.12,-0.75l1.08,-1.42l2.81,-1.05l0.35,-2.08l1.33,-0.29l1.04,-0.94l3.47,-0.69l0.46,-1.08l-0.1,-0.45l-0.58,-0.52l-0.82,-2.81l-0.19,-1.83l-0.78,-1.49l2.03,-1.31l2.63,-0.48l1.7,-1.22l2.31,-0.84l8.24,-0.73l1.49,0.38l2.28,-1.1l2.46,-0.02l0.92,0.6l1.35,-0.05Z",
                name: "Algeria"
            },
            US: {
                path: "M892.72,99.2l1.31,0.53l1.41,-0.37l1.89,0.98l1.89,0.42l-1.32,0.58l-2.9,-1.53l-2.08,0.22l-0.26,-0.15l0.07,-0.67ZM183.22,150.47l0.37,1.47l1.12,0.85l4.23,0.7l2.39,0.98l2.17,-0.38l1.85,0.5l-1.55,0.65l-3.49,2.61l-0.16,0.77l0.5,0.39l2.33,-0.61l1.77,1.02l5.15,-2.4l-0.31,0.65l0.25,0.56l1.36,0.38l1.71,1.16l4.7,-0.88l0.67,0.85l1.31,0.21l0.58,0.58l-1.34,0.17l-2.18,-0.32l-3.6,0.89l-2.71,3.25l0.35,0.9l0.59,-0.0l0.55,-0.6l-1.36,4.65l0.29,3.09l0.67,1.58l0.61,0.45l1.77,-0.44l1.6,-1.96l0.14,-2.21l-0.82,-1.96l0.11,-1.13l1.19,-2.37l0.44,-0.33l0.48,0.75l0.4,-0.29l0.4,-1.37l0.6,-0.47l0.24,-0.8l1.69,0.49l1.65,1.08l-0.03,2.37l-1.27,1.13l-0.0,1.13l0.87,0.36l1.66,-1.29l0.5,0.17l0.5,2.6l-2.49,3.75l0.17,0.61l1.54,0.62l1.48,0.17l1.92,-0.44l4.72,-2.15l2.16,-1.8l-0.05,-1.24l0.75,-0.22l3.92,0.36l2.12,-1.05l0.21,-0.4l-0.28,-1.48l3.27,-2.4l8.32,-0.02l0.56,-0.82l1.9,-0.77l0.93,-1.51l0.74,-2.37l1.58,-1.98l0.92,0.62l1.47,-0.47l0.8,0.66l-0.0,4.09l1.96,2.6l-2.34,1.31l-5.37,2.09l-1.83,2.72l0.02,1.79l0.83,1.59l0.54,0.23l-6.19,0.94l-2.2,0.89l-0.23,0.48l0.45,0.29l2.99,-0.46l-2.19,0.56l-1.13,0.0l-0.15,-0.32l-0.48,0.08l-0.76,0.82l0.22,0.67l0.32,0.06l-0.41,1.62l-1.27,1.58l-1.48,-1.07l-0.49,-0.04l-0.16,0.46l0.52,1.58l0.61,0.59l0.03,0.79l-0.95,1.38l-1.21,-1.22l-0.27,-2.27l-0.35,-0.35l-0.42,0.25l-0.48,1.27l0.33,1.41l-0.97,-0.27l-0.48,0.24l0.18,0.5l1.52,0.83l0.1,2.52l0.79,0.51l0.52,3.42l-1.42,1.88l-2.47,0.8l-1.71,1.66l-1.31,0.25l-1.27,1.03l-0.43,0.99l-2.69,1.78l-2.64,3.03l-0.45,2.12l0.45,2.08l0.85,2.38l1.09,1.9l0.04,1.2l1.16,3.06l-0.18,2.69l-0.55,1.43l-0.47,0.21l-0.89,-0.23l-0.49,-1.18l-0.87,-0.56l-2.75,-5.16l0.48,-1.68l-0.72,-1.78l-2.01,-2.38l-1.12,-0.53l-2.72,1.18l-1.47,-1.35l-1.57,-0.68l-2.99,0.31l-2.17,-0.3l-2.0,0.19l-1.15,0.46l-0.19,0.58l0.39,0.63l0.14,1.34l-0.84,-0.2l-0.84,0.46l-1.58,-0.07l-2.08,-1.44l-2.09,0.33l-1.91,-0.62l-3.73,0.84l-2.39,2.07l-2.54,1.22l-1.45,1.41l-0.61,1.38l0.34,3.71l-0.29,0.02l-3.5,-1.33l-1.25,-3.11l-1.44,-1.5l-2.24,-3.56l-1.76,-1.09l-2.27,-0.01l-1.71,2.07l-1.76,-0.69l-1.16,-0.74l-1.52,-2.98l-3.93,-3.16l-4.34,-0.0l-0.4,0.4l-0.0,0.74l-6.5,0.02l-9.02,-3.14l-0.34,-0.71l-5.7,0.49l-0.43,-1.29l-1.62,-1.61l-1.14,-0.38l-0.55,-0.88l-1.28,-0.13l-1.01,-0.77l-2.22,-0.27l-0.43,-0.3l-0.36,-1.58l-2.4,-2.83l-2.01,-3.85l-0.06,-0.9l-2.92,-3.26l-0.33,-2.29l-1.3,-1.66l0.52,-2.37l-0.09,-2.57l-0.78,-2.3l0.95,-2.82l0.61,-5.68l-0.47,-4.27l-1.46,-4.08l3.19,0.79l1.26,2.83l0.69,0.08l0.69,-1.14l-1.1,-4.79l68.76,-0.0l0.4,-0.4l0.14,-0.86ZM32.44,67.52l1.73,1.97l0.55,0.05l0.99,-0.79l3.65,0.24l-0.09,0.62l0.32,0.45l3.83,0.77l2.61,-0.43l5.19,1.4l4.84,0.43l1.89,0.57l3.42,-0.7l6.14,1.87l-0.03,38.06l0.38,0.4l2.39,0.11l2.31,0.98l3.9,3.99l0.55,0.04l2.4,-2.03l2.16,-1.04l1.2,1.71l3.95,3.14l4.09,6.63l4.2,2.29l0.06,1.83l-1.02,1.23l-1.16,-1.08l-2.04,-1.03l-0.67,-2.89l-3.28,-3.03l-1.65,-3.57l-6.35,-0.32l-2.82,-1.01l-5.26,-3.85l-6.77,-2.04l-3.53,0.3l-4.81,-1.69l-3.25,-1.63l-2.78,0.8l-0.28,0.46l0.44,2.21l-3.91,0.96l-2.26,1.27l-2.3,0.65l-0.27,-1.65l1.05,-3.42l2.49,-1.09l0.16,-0.6l-0.69,-0.96l-0.55,-0.1l-3.19,2.12l-1.78,2.56l-3.55,2.61l-0.04,0.61l1.56,1.52l-2.07,2.29l-5.11,2.57l-0.77,1.66l-3.76,1.77l-0.92,1.73l-2.69,1.38l-1.81,-0.22l-6.95,3.32l-3.97,0.91l4.85,-2.5l2.59,-1.86l3.26,-0.52l1.19,-1.4l3.42,-2.1l2.59,-2.27l0.42,-2.68l1.23,-2.1l-0.04,-0.46l-0.45,-0.11l-2.68,1.03l-0.63,-0.49l-0.53,0.03l-1.05,1.04l-1.36,-1.54l-0.66,0.08l-0.32,0.62l-0.58,-1.14l-0.56,-0.16l-2.41,1.42l-1.07,-0.0l-0.17,-1.75l0.3,-1.71l-1.61,-1.33l-3.41,0.59l-1.96,-1.63l-1.57,-0.84l-0.15,-2.21l-1.7,-1.43l0.82,-1.88l1.99,-2.12l0.88,-1.92l1.71,-0.24l2.04,0.51l1.87,-1.77l1.91,0.25l1.91,-1.23l0.17,-0.43l-0.47,-1.82l-1.07,-0.7l1.39,-1.17l0.12,-0.45l-0.39,-0.26l-1.65,0.07l-2.66,0.88l-0.75,0.78l-1.92,-0.8l-3.46,0.44l-3.44,-0.91l-1.06,-1.61l-2.65,-1.99l2.91,-1.43l5.5,-2.0l1.52,0.0l-0.26,1.62l0.41,0.46l5.29,-0.16l0.3,-0.65l-2.03,-2.59l-3.14,-1.68l-1.79,-2.12l-2.4,-1.83l-3.09,-1.24l1.04,-1.69l4.23,-0.14l3.36,-2.07l0.73,-2.27l2.39,-1.99l2.42,-0.52l4.65,-1.97l2.46,0.23l3.71,-2.35l3.5,0.89ZM37.6,123.41l-2.25,1.23l-0.95,-0.69l-0.29,-1.24l3.21,-1.63l1.42,0.21l0.67,0.7l-1.8,1.42ZM31.06,234.03l0.98,0.47l0.74,0.87l-1.77,1.07l-0.44,-1.53l0.49,-0.89ZM29.34,232.07l0.18,0.05l0.08,0.05l-0.16,0.03l-0.11,-0.14ZM25.16,230.17l0.05,-0.03l0.18,0.22l-0.13,-0.01l-0.1,-0.18ZM5.89,113.26l-1.08,0.41l-2.21,-1.12l1.53,-0.4l1.62,0.28l0.14,0.83Z",
                name: "United States"
            },
            LV: {
                path: "M489.16,122.85l0.96,0.66l0.22,1.65l0.68,1.76l-3.65,1.7l-2.23,-1.58l-1.29,-0.26l-0.68,-0.77l-2.42,0.34l-4.16,-0.23l-2.47,0.9l0.06,-1.98l1.13,-2.06l1.95,-1.02l2.12,2.58l2.01,-0.07l0.38,-0.33l0.44,-2.52l1.76,-0.53l3.06,1.7l2.15,0.07Z",
                name: "Latvia"
            },
            UY: {
                path: "M286.85,372.74l-0.92,1.5l-2.59,1.44l-1.69,-0.52l-1.42,0.26l-2.39,-1.19l-1.52,0.08l-1.27,-1.3l0.16,-1.5l0.56,-0.79l-0.02,-2.73l1.21,-4.74l1.19,-0.21l2.37,2.0l1.08,0.03l4.36,3.17l1.22,1.6l-0.96,1.5l0.61,1.4Z",
                name: "Uruguay"
            },
            LB: {
                path: "M510.37,198.01l-0.88,0.51l1.82,-3.54l0.62,0.08l0.22,0.61l-1.13,0.88l-0.65,1.47Z",
                name: "Lebanon"
            },
            LA: {
                path: "M689.54,248.53l-1.76,-0.74l-0.49,0.15l-0.94,1.46l-1.32,-0.64l0.62,-0.98l0.11,-2.17l-2.04,-2.42l-0.25,-2.65l-1.9,-2.1l-2.15,-0.31l-0.78,0.91l-1.12,0.06l-1.05,-0.4l-2.06,1.2l-0.04,-1.59l0.61,-2.68l-0.36,-0.49l-1.35,-0.1l-0.11,-1.23l-0.96,-0.88l1.96,-1.89l0.39,0.36l1.33,0.07l0.42,-0.45l-0.34,-2.66l0.7,-0.21l1.28,1.81l1.11,2.35l0.36,0.23l2.82,0.02l0.71,1.67l-1.39,0.65l-0.72,0.93l0.13,0.6l2.91,1.51l3.6,5.25l1.88,1.78l0.56,1.62l-0.35,1.96Z",
                name: "Lao PDR"
            },
            TW: {
                path: "M724.01,226.68l-0.74,1.48l-0.9,-1.52l-0.25,-1.74l1.38,-2.44l1.73,-1.74l0.64,0.44l-1.85,5.52Z",
                name: "Taiwan"
            },
            TT: {
                path: "M266.64,259.32l0.28,-1.16l1.13,-0.22l-0.06,1.2l-1.35,0.18Z",
                name: "Trinidad and Tobago"
            },
            TR: {
                path: "M513.21,175.47l3.64,1.17l3.05,-0.44l2.1,0.26l3.11,-1.56l2.46,-0.13l2.19,1.33l0.33,0.82l-0.22,1.33l0.25,0.44l2.28,1.13l-1.17,0.57l-0.21,0.45l0.75,3.2l-0.41,1.16l1.13,1.92l-0.55,0.22l-0.9,-0.67l-2.91,-0.37l-1.24,0.46l-4.23,0.41l-2.81,1.05l-1.91,0.01l-1.52,-0.53l-2.58,0.75l-0.66,-0.45l-0.62,0.3l-0.12,1.45l-0.89,0.84l-0.47,-0.67l0.79,-1.3l-0.41,-0.2l-1.43,0.23l-2.0,-0.63l-2.02,1.65l-3.51,0.3l-2.13,-1.53l-2.7,-0.1l-0.86,1.24l-1.38,0.27l-2.29,-1.44l-2.71,-0.01l-1.37,-2.65l-1.68,-1.52l1.07,-1.99l-0.09,-0.49l-1.27,-1.12l2.37,-2.41l3.7,-0.11l1.28,-2.24l4.49,0.37l3.21,-1.97l2.81,-0.82l3.99,-0.06l4.29,2.07ZM488.79,176.72l-1.72,1.31l-0.5,-0.88l1.37,-2.57l-0.7,-0.85l1.7,-0.63l1.8,0.34l0.46,1.17l1.76,0.78l-2.87,0.32l-1.3,1.01Z",
                name: "Turkey"
            },
            LK: {
                path: "M624.16,268.99l-1.82,0.48l-0.99,-1.67l-0.42,-3.46l0.95,-3.43l1.21,0.98l2.26,4.19l-0.34,2.33l-0.85,0.58Z",
                name: "Sri Lanka"
            },
            TN: {
                path: "M448.1,188.24l-1.0,1.27l-0.02,1.32l0.84,0.88l-0.28,2.09l-1.53,1.32l-0.12,0.42l0.48,1.54l1.42,0.32l0.53,1.11l0.9,0.52l-0.11,1.67l-3.54,2.64l-0.1,2.38l-0.58,0.3l-0.96,-4.45l-1.54,-1.25l-0.16,-0.78l-1.92,-1.56l-0.18,-1.76l1.51,-1.62l0.59,-2.34l-0.38,-2.78l0.42,-1.21l2.45,-1.05l1.29,0.26l-0.06,1.11l0.58,0.38l1.47,-0.73Z",
                name: "Tunisia"
            },
            TL: {
                path: "M734.55,307.93l-0.1,-0.97l4.5,-0.86l-2.82,1.28l-1.59,0.55Z",
                name: "Timor-Leste"
            },
            TM: {
                path: "M553.03,173.76l-0.04,0.34l-0.09,-0.22l0.13,-0.12ZM555.87,172.66l0.45,-0.1l1.48,0.74l2.06,2.43l4.07,-0.18l0.38,-0.51l-0.32,-1.19l1.92,-0.94l1.91,-1.59l2.94,1.39l0.43,2.47l1.19,0.67l2.58,-0.13l0.62,0.4l1.32,3.12l4.54,3.44l2.67,1.45l3.06,1.14l-0.04,1.05l-1.33,-0.75l-0.59,0.19l-0.32,0.84l-2.2,0.81l-0.46,2.13l-1.21,0.74l-1.91,0.42l-0.73,1.33l-1.56,0.31l-2.22,-0.94l-0.2,-2.17l-0.38,-0.36l-1.73,-0.09l-2.76,-2.46l-2.14,-0.4l-2.84,-1.48l-1.78,-0.27l-1.24,0.53l-1.57,-0.08l-2.0,1.69l-1.7,0.43l-0.36,-1.58l0.36,-2.98l-0.22,-0.4l-1.65,-0.84l0.54,-1.69l-0.34,-0.52l-1.22,-0.13l0.36,-1.64l2.22,0.59l2.2,-0.95l0.12,-0.65l-1.77,-1.74l-0.66,-1.57Z",
                name: "Turkmenistan"
            },
            TJ: {
                path: "M597.75,178.82l-2.54,-0.44l-0.47,0.34l-0.24,1.7l0.43,0.45l2.64,-0.22l3.18,0.95l4.39,-0.41l0.56,2.37l0.52,0.29l0.67,-0.24l1.11,0.49l0.21,2.13l-3.76,-0.21l-1.8,1.32l-1.76,0.74l-0.61,-0.58l0.21,-2.23l-0.64,-0.49l-0.07,-0.93l-1.36,-0.66l-0.45,0.07l-1.08,1.01l-0.55,1.48l-1.31,-0.05l-0.95,1.16l-0.9,-0.35l-1.86,0.74l1.26,-2.83l-0.54,-2.17l-1.67,-0.82l0.33,-0.66l2.18,-0.04l1.19,-1.63l0.76,-1.79l2.43,-0.5l-0.26,1.0l0.73,1.05Z",
                name: "Tajikistan"
            },
            LS: {
                path: "M491.06,363.48l-0.49,0.15l-1.49,-1.67l1.1,-1.43l2.19,-1.44l1.51,1.27l-0.98,1.82l-1.23,0.38l-0.62,0.93Z",
                name: "Lesotho"
            },
            TH: {
                path: "M670.27,255.86l-1.41,3.87l0.15,2.0l0.38,0.36l1.38,0.07l0.9,2.04l0.55,2.34l1.4,1.44l1.61,0.38l0.96,0.97l-0.5,0.64l-1.1,0.2l-0.34,-1.18l-2.04,-1.1l-0.63,0.23l-0.63,-0.62l-0.48,-1.3l-2.56,-2.63l-0.73,0.41l0.95,-3.89l2.16,-4.22ZM670.67,254.77l-0.92,-2.18l-0.26,-2.61l-2.14,-3.06l0.71,-0.49l0.89,-2.59l-3.61,-5.45l0.87,-0.51l1.05,-2.58l1.74,-0.18l2.6,-1.59l0.76,0.56l0.13,1.39l0.37,0.36l1.23,0.09l-0.51,2.28l0.05,2.42l0.6,0.34l2.43,-1.42l0.77,0.39l1.47,-0.07l0.71,-0.88l1.48,0.14l1.71,1.88l0.25,2.65l1.92,2.11l-0.1,1.89l-0.61,0.86l-2.22,-0.33l-3.5,0.64l-1.6,2.12l0.36,2.58l-1.51,-0.79l-1.84,-0.01l0.28,-1.52l-0.4,-0.47l-2.21,0.01l-0.4,0.37l-0.19,2.74l-0.34,0.93Z",
                name: "Thailand"
            },
            TF: {
                path: "M596.68,420.38l-3.2,0.18l-0.05,-1.26l0.39,-1.41l1.3,0.78l2.08,0.35l-0.52,1.36Z",
                name: "Fr. S. Antarctic Lands"
            },
            TG: {
                path: "M422.7,257.63l-0.09,1.23l1.53,1.52l0.08,1.09l0.5,0.65l-0.11,5.62l0.49,1.47l-1.31,0.35l-1.02,-2.13l-0.18,-1.12l0.53,-2.19l-0.63,-1.16l-0.22,-3.68l-1.01,-1.4l0.07,-0.28l1.37,0.03Z",
                name: "Togo"
            },
            TD: {
                path: "M480.25,235.49l0.12,9.57l-2.1,0.05l-1.14,1.89l-0.69,1.63l0.34,0.73l-0.66,0.91l0.24,0.89l-0.86,1.95l0.45,0.5l0.6,-0.1l0.34,0.64l0.03,1.38l0.9,1.04l-1.45,0.43l-1.27,1.03l-1.83,2.76l-2.16,1.07l-2.31,-0.15l-0.86,0.25l-0.26,0.49l0.17,0.61l-2.11,1.68l-2.85,0.87l-1.09,-0.57l-0.73,0.66l-1.12,0.1l-1.1,-3.12l-1.25,-0.64l-1.22,-1.22l0.29,-0.64l3.01,0.04l0.35,-0.6l-1.3,-2.2l-0.08,-3.31l-0.97,-1.66l0.22,-1.04l-0.38,-0.48l-1.22,-0.04l0.0,-1.25l-0.98,-1.07l0.96,-3.01l3.25,-2.65l0.13,-3.33l0.95,-5.18l0.52,-1.07l-0.1,-0.48l-0.91,-0.78l-0.2,-0.96l-0.8,-0.58l-0.55,-3.65l2.1,-1.2l19.57,9.83Z",
                name: "Chad"
            },
            LY: {
                path: "M483.48,203.15l-0.75,1.1l0.29,1.39l-0.6,1.83l0.73,2.14l0.0,24.12l-2.48,0.01l-0.41,0.85l-19.41,-9.76l-4.41,2.28l-1.37,-1.33l-3.82,-1.1l-1.14,-1.65l-1.98,-1.23l-1.22,0.32l-0.66,-1.11l-0.17,-1.26l-1.28,-1.69l0.87,-1.19l-0.07,-4.34l0.43,-2.27l-0.86,-3.45l1.13,-0.76l0.22,-1.16l-0.2,-1.03l3.48,-2.61l0.29,-1.94l2.45,0.8l1.18,-0.21l1.98,0.44l3.15,1.18l1.37,2.54l5.72,1.67l2.64,1.35l1.61,-0.72l1.29,-1.34l-0.44,-2.34l0.66,-1.13l1.67,-1.21l1.57,-0.35l3.14,0.53l1.08,1.28l3.99,0.78l0.36,0.54Z",
                name: "Libya"
            },
            AE: {
                path: "M550.76,223.97l1.88,-0.4l3.84,0.02l4.78,-4.75l0.19,0.36l0.26,1.58l-0.81,0.01l-0.39,0.35l-0.08,2.04l-0.81,0.63l-0.01,0.96l-0.66,0.99l-0.39,1.41l-7.08,-1.25l-0.7,-1.96Z",
                name: "United Arab Emirates"
            },
            VE: {
                path: "M240.68,256.69l0.53,0.75l-0.02,1.06l-1.07,1.78l0.95,2.0l0.42,0.22l1.4,-0.44l0.56,-1.83l-0.77,-1.17l-0.1,-1.47l2.82,-0.93l0.26,-0.49l-0.28,-0.96l0.3,-0.28l0.66,1.31l1.96,0.26l1.4,1.22l0.08,0.68l0.39,0.35l4.81,-0.22l1.49,1.11l1.92,0.31l1.67,-0.84l0.22,-0.6l3.44,-0.14l-0.17,0.55l0.86,1.19l2.19,0.35l1.67,1.1l0.37,1.86l0.41,0.32l1.55,0.17l-1.66,1.35l-0.22,0.92l0.65,0.97l-1.67,0.54l-0.3,0.4l0.04,0.99l-0.56,0.57l-0.01,0.55l1.85,2.27l-0.66,0.69l-4.47,1.29l-0.72,0.54l-3.69,-0.9l-0.71,0.27l-0.02,0.7l0.91,0.53l-0.08,1.54l0.35,1.58l0.35,0.31l1.66,0.17l-1.3,0.52l-0.48,1.13l-2.68,0.91l-0.6,0.77l-1.57,0.13l-1.17,-1.13l-0.8,-2.52l-1.25,-1.26l1.02,-1.23l-1.29,-2.95l0.18,-1.62l1.0,-2.21l-0.2,-0.49l-1.14,-0.46l-4.02,0.36l-1.82,-2.1l-1.57,-0.33l-2.99,0.22l-1.06,-0.97l0.25,-1.23l-0.2,-1.01l-0.59,-0.69l-0.29,-1.06l-1.08,-0.39l0.78,-2.79l1.9,-2.11Z",
                name: "Venezuela"
            },
            AF: {
                path: "M600.7,188.88l-1.57,1.3l-0.1,0.48l0.8,2.31l-1.09,1.04l-0.03,1.27l-0.48,0.71l-2.16,-0.08l-0.37,0.59l0.78,1.48l-1.38,0.69l-1.06,1.69l0.06,1.7l-0.65,0.52l-0.91,-0.21l-1.91,0.36l-0.48,0.77l-1.88,0.13l-1.4,1.56l-0.18,2.32l-2.91,1.02l-1.65,-0.23l-0.71,0.55l-1.41,-0.3l-2.41,0.39l-3.52,-1.17l1.96,-2.35l-0.21,-1.78l-0.3,-0.34l-1.63,-0.4l-0.19,-1.58l-0.75,-2.03l0.95,-1.36l-0.19,-0.6l-0.73,-0.28l1.47,-4.8l2.14,0.9l2.12,-0.36l0.74,-1.34l1.77,-0.39l1.54,-0.92l0.63,-2.31l1.87,-0.5l0.49,-0.81l0.94,0.56l2.13,0.11l2.55,0.92l1.95,-0.83l0.65,0.43l0.56,-0.13l0.69,-1.12l1.57,-0.08l0.72,-1.66l0.79,-0.74l0.8,0.39l-0.17,0.56l0.71,0.58l-0.08,2.39l1.11,0.95ZM601.37,188.71l1.73,-0.71l1.43,-1.18l4.03,0.35l-2.23,0.74l-4.95,0.8Z",
                name: "Afghanistan"
            },
            IQ: {
                path: "M530.82,187.47l0.79,0.66l1.26,-0.28l1.46,3.08l1.63,0.94l0.14,1.23l-1.22,1.05l-0.53,2.52l1.73,2.67l3.12,1.62l1.15,1.88l-0.38,1.85l0.39,0.48l0.41,-0.0l0.02,1.07l0.76,0.94l-2.47,-0.1l-1.71,2.44l-4.31,-0.2l-7.02,-5.48l-3.73,-1.94l-2.88,-0.73l-0.85,-2.87l5.45,-3.02l0.95,-3.43l-0.19,-1.96l1.27,-0.7l1.22,-1.7l0.87,-0.36l2.69,0.34Z",
                name: "Iraq"
            },
            IS: {
                path: "M384.14,88.06l-0.37,2.61l2.54,2.51l-2.9,2.75l-9.19,3.4l-9.25,-1.66l1.7,-1.22l-0.1,-0.7l-4.05,-1.47l2.96,-0.53l0.33,-0.43l-0.11,-1.2l-0.33,-0.36l-4.67,-0.85l1.28,-2.04l3.45,-0.56l3.77,2.72l0.44,0.02l3.64,-2.16l3.3,1.08l3.98,-2.16l3.58,0.26Z",
                name: "Iceland"
            },
            IR: {
                path: "M533.43,187.16l-1.27,-2.15l0.42,-0.98l-0.71,-3.04l1.03,-0.5l0.33,0.83l1.26,1.35l2.05,0.51l1.11,-0.16l2.89,-2.11l0.62,-0.14l0.39,0.46l-0.72,1.2l0.06,0.49l1.56,1.53l0.65,0.04l0.67,1.81l2.56,0.83l1.87,1.48l3.69,0.49l3.91,-0.76l0.47,-0.73l2.17,-0.6l1.66,-1.54l1.51,0.08l1.18,-0.53l1.59,0.24l2.83,1.48l1.88,0.3l2.77,2.47l1.77,0.18l0.18,1.99l-1.68,5.49l0.24,0.5l0.61,0.23l-0.82,1.48l0.8,2.18l0.19,1.71l0.3,0.34l1.63,0.4l0.15,1.32l-2.15,2.35l-0.01,0.53l2.21,3.03l2.34,1.24l0.06,2.14l1.24,0.72l0.11,0.69l-3.31,1.27l-1.08,3.03l-9.68,-1.68l-0.99,-3.05l-1.43,-0.73l-2.17,0.46l-2.47,1.26l-2.83,-0.82l-2.46,-2.02l-2.41,-0.8l-3.42,-6.06l-0.48,-0.2l-1.18,0.39l-1.44,-0.82l-0.5,0.08l-0.65,0.74l-0.97,-1.01l-0.02,-1.31l-0.71,-0.39l0.26,-1.81l-1.29,-2.11l-3.13,-1.63l-1.58,-2.43l0.5,-1.9l1.31,-1.26l-0.19,-1.66l-1.74,-1.1l-1.57,-3.3Z",
                name: "Iran"
            },
            AM: {
                path: "M536.99,182.33l-0.28,0.03l-1.23,-2.13l-0.93,0.01l-0.62,-0.66l-0.69,-0.07l-0.96,-0.81l-1.56,-0.62l0.19,-1.12l-0.26,-0.79l2.72,-0.36l1.09,1.01l-0.17,0.92l1.02,0.78l-0.47,0.62l0.08,0.56l2.04,1.23l0.04,1.4Z",
                name: "Armenia"
            },
            IT: {
                path: "M451.59,158.63l3.48,0.94l-0.21,1.17l0.3,0.83l-1.49,-0.24l-2.04,1.1l-0.21,0.39l0.13,1.45l-0.25,1.12l0.82,1.57l2.39,1.63l1.31,2.54l2.79,2.43l2.05,0.08l0.21,0.23l-0.39,0.33l0.09,0.67l4.05,1.97l2.17,1.76l-0.16,0.36l-1.17,-1.08l-2.18,-0.49l-0.44,0.2l-1.05,1.91l0.14,0.54l1.57,0.95l-0.19,0.98l-1.06,0.33l-1.25,2.34l-0.37,0.08l0.0,-0.33l1.0,-2.45l-1.73,-3.17l-1.12,-0.51l-0.88,-1.33l-1.51,-0.51l-1.27,-1.25l-1.75,-0.18l-4.12,-3.21l-1.62,-1.65l-1.03,-3.19l-3.53,-1.36l-1.3,0.51l-1.69,1.41l0.16,-0.72l-0.28,-0.47l-1.14,-0.33l-0.53,-1.96l0.72,-0.78l0.04,-0.48l-0.65,-1.17l0.8,0.39l1.4,-0.23l1.11,-0.84l0.52,0.35l1.19,-0.1l0.75,-1.2l1.53,0.33l1.36,-0.56l0.35,-1.14l1.08,0.32l0.68,-0.64l1.98,-0.44l0.42,0.82ZM459.19,184.75l-0.65,1.65l0.32,1.05l-0.31,0.89l-1.5,-0.85l-4.5,-1.67l0.19,-0.82l2.67,0.23l3.78,-0.48ZM443.93,176.05l1.18,1.66l-0.3,3.32l-1.06,-0.01l-0.77,0.73l-0.53,-0.44l-0.1,-3.37l-0.39,-1.22l1.04,0.01l0.92,-0.68Z",
                name: "Italy"
            },
            VN: {
                path: "M690.56,230.25l-2.7,1.82l-2.09,2.46l-0.63,1.95l4.31,6.45l2.32,1.65l1.43,1.94l1.11,4.59l-0.32,4.24l-1.93,1.54l-2.84,1.61l-2.11,2.15l-2.73,2.06l-0.59,-1.05l0.63,-1.53l-0.13,-0.47l-1.34,-1.04l1.51,-0.71l2.55,-0.18l0.3,-0.63l-0.82,-1.14l4.0,-2.07l0.31,-3.05l-0.57,-1.77l0.42,-2.66l-0.73,-1.97l-1.86,-1.76l-3.63,-5.29l-2.72,-1.46l0.36,-0.47l1.5,-0.64l0.21,-0.52l-0.97,-2.27l-0.37,-0.24l-2.83,-0.02l-2.24,-3.9l0.83,-0.4l4.39,-0.29l2.06,-1.31l1.15,0.89l1.88,0.4l-0.17,1.51l1.35,1.16l1.67,0.45Z",
                name: "Vietnam"
            },
            AR: {
                path: "M249.29,428.93l-2.33,-0.52l-5.83,-0.43l-0.89,-1.66l0.05,-2.37l-0.45,-0.4l-1.43,0.18l-0.67,-0.91l-0.2,-3.13l1.88,-1.47l0.79,-2.04l-0.25,-1.7l1.3,-2.68l0.91,-4.15l-0.22,-1.69l0.85,-0.45l0.2,-0.44l-0.27,-1.16l-0.98,-0.68l0.59,-0.92l-0.05,-0.5l-1.04,-1.07l-0.52,-3.1l0.97,-0.86l-0.42,-3.58l1.2,-5.43l1.38,-0.98l0.16,-0.43l-0.75,-2.79l-0.01,-2.43l1.78,-1.75l0.06,-2.57l1.43,-2.85l0.01,-2.58l-0.69,-0.74l-1.09,-4.52l1.47,-2.7l-0.18,-2.79l0.85,-2.35l1.59,-2.46l1.73,-1.64l0.05,-0.52l-0.6,-0.84l0.44,-0.85l-0.07,-4.19l2.7,-1.44l0.86,-2.75l-0.21,-0.71l1.76,-2.01l2.9,0.57l1.38,1.78l0.68,-0.08l0.87,-1.87l2.39,0.09l4.95,4.77l2.17,0.49l3.0,1.92l2.47,1.0l0.25,0.82l-2.37,3.93l0.23,0.59l5.39,1.16l2.12,-0.44l2.45,-2.16l0.5,-2.38l0.76,-0.31l0.98,1.2l-0.04,1.8l-3.67,2.51l-2.85,2.66l-3.43,3.88l-1.3,5.07l0.01,2.72l-0.54,0.73l-0.36,3.28l3.14,2.64l-0.16,2.11l1.4,1.11l-0.1,1.09l-2.29,3.52l-3.55,1.49l-4.92,0.6l-2.71,-0.29l-0.43,0.51l0.5,1.65l-0.49,2.1l0.38,1.42l-1.19,0.83l-2.36,0.38l-2.3,-1.04l-1.38,0.83l0.41,3.64l1.69,0.91l1.4,-0.71l0.36,0.76l-2.04,0.86l-2.01,1.89l-0.97,4.63l-2.34,0.1l-2.09,1.78l-0.61,2.75l2.46,2.31l2.17,0.63l-0.7,2.32l-2.83,1.73l-1.73,3.86l-2.17,1.22l-1.16,1.67l0.75,3.76l1.04,1.28ZM256.71,438.88l-2.0,0.15l-1.4,-1.22l-3.82,-0.1l-0.0,-5.83l1.6,3.05l3.26,2.07l3.08,0.78l-0.71,1.1Z",
                name: "Argentina"
            },
            AU: {
                path: "M705.8,353.26l0.26,0.04l0.17,-0.47l-0.48,-1.42l0.92,1.11l0.45,0.15l0.27,-0.39l-0.1,-1.56l-1.98,-3.63l1.09,-3.31l-0.24,-1.57l0.34,-0.62l0.38,1.06l0.43,-0.19l0.99,-1.7l1.91,-0.83l1.29,-1.15l1.81,-0.91l0.96,-0.17l0.92,0.26l1.92,-0.95l1.47,-0.28l1.03,-0.8l1.43,0.04l2.78,-0.84l1.36,-1.15l0.71,-1.45l1.41,-1.26l0.3,-2.58l1.27,-1.59l0.78,1.65l0.54,0.19l1.07,-0.51l0.15,-0.6l-0.73,-1.0l0.45,-0.71l0.78,0.39l0.58,-0.3l0.28,-1.82l1.87,-2.14l1.12,-0.39l0.28,-0.58l0.62,0.17l0.53,-0.73l1.87,-0.57l1.65,1.05l1.35,1.48l3.39,0.38l0.43,-0.54l-0.46,-1.23l1.05,-1.79l1.04,-0.61l0.14,-0.55l-0.25,-0.41l0.88,-1.17l1.31,-0.77l1.3,0.27l2.1,-0.48l0.31,-0.4l-0.05,-1.3l-0.92,-0.77l1.48,0.56l1.41,1.07l2.11,0.65l0.81,-0.2l1.4,0.7l1.69,-0.66l0.8,0.19l0.64,-0.33l0.71,0.77l-1.33,1.94l-0.71,0.07l-0.35,0.51l0.24,0.86l-1.52,2.35l0.12,1.05l2.15,1.65l1.97,0.85l3.04,2.36l1.97,0.65l0.55,0.88l2.72,0.85l1.84,-1.1l2.07,-5.97l-0.42,-3.59l0.3,-1.73l0.47,-0.87l-0.31,-0.68l1.09,-3.28l0.46,-0.47l0.4,0.71l0.16,1.51l0.65,0.52l0.16,1.04l0.85,1.21l0.12,2.38l0.9,2.0l0.57,0.18l1.3,-0.78l1.69,1.7l-0.2,1.08l0.53,2.2l0.39,1.3l0.68,0.48l0.6,1.95l-0.19,1.48l0.81,1.76l6.01,3.69l-0.11,0.76l1.38,1.58l0.95,2.77l0.58,0.22l0.72,-0.41l0.8,0.9l0.61,0.01l0.46,2.41l4.81,4.71l0.66,2.02l-0.07,3.31l1.14,2.2l-0.13,2.24l-1.1,3.68l0.03,1.64l-0.47,1.89l-1.05,2.4l-1.9,1.47l-1.72,3.51l-2.38,6.09l-0.24,2.82l-1.14,0.8l-2.85,0.15l-2.31,1.19l-2.51,2.25l-3.09,-1.57l0.3,-1.15l-0.54,-0.47l-1.5,0.63l-2.01,1.94l-7.12,-2.18l-1.48,-1.63l-1.14,-3.74l-1.45,-1.26l-1.81,-0.26l0.56,-1.18l-0.61,-2.1l-0.72,-0.1l-1.14,1.82l-0.9,0.21l0.63,-0.82l0.36,-1.55l0.92,-1.31l-0.13,-2.34l-0.7,-0.22l-2.0,2.34l-1.51,0.93l-0.94,2.01l-1.35,-0.81l-0.02,-1.52l-1.57,-2.04l-1.09,-0.88l0.24,-0.33l-0.14,-0.59l-3.21,-1.69l-1.83,-0.12l-2.54,-1.35l-4.58,0.28l-6.02,1.9l-2.53,-0.13l-2.62,1.41l-2.13,0.63l-1.49,2.6l-3.49,0.31l-2.29,-0.5l-3.48,0.43l-1.6,1.47l-0.81,-0.04l-2.37,1.63l-3.26,-0.1l-3.72,-2.21l0.04,-1.05l1.19,-0.46l0.49,-0.89l0.21,-2.97l-0.28,-1.64l-1.34,-2.86l-0.38,-1.47l0.05,-1.72l-0.95,-1.7l-0.18,-0.97l-1.01,-0.99l-0.29,-1.98l-1.13,-1.75ZM784.92,393.44l2.65,1.02l3.23,-0.96l1.09,0.14l0.15,3.06l-0.85,1.13l-0.17,1.63l-0.87,-0.24l-1.57,1.91l-1.68,-0.18l-1.4,-2.36l-0.37,-2.04l-1.39,-2.51l0.04,-0.8l1.15,0.18Z",
                name: "Australia"
            },
            IL: {
                path: "M507.76,203.05l0.4,-0.78l0.18,0.4l-0.33,1.03l0.52,0.44l0.68,-0.22l-0.86,3.6l-1.16,-3.32l0.59,-0.74l-0.03,-0.41ZM508.73,200.34l0.37,-1.02l0.64,0.0l0.52,-0.51l-0.49,1.53l-0.56,-0.24l-0.48,0.23Z",
                name: "Palestine"
            },
            IN: {
                path: "M623.34,207.03l-1.24,1.04l-0.97,2.55l0.22,0.51l8.04,3.87l3.42,0.37l1.57,1.38l4.92,0.88l2.18,-0.04l0.38,-0.3l0.29,-1.24l-0.32,-1.64l0.14,-0.87l0.82,-0.31l0.45,2.48l2.28,1.02l1.77,-0.38l4.14,0.1l0.38,-0.36l0.18,-1.66l-0.5,-0.65l1.37,-0.29l2.25,-1.99l2.7,-1.62l1.93,0.62l1.8,-0.98l0.79,1.14l-0.68,0.91l0.26,0.63l2.42,0.36l0.09,0.47l-0.83,0.75l0.13,1.07l-1.52,-0.29l-3.24,1.86l-0.13,1.78l-1.32,2.14l-0.18,1.39l-0.93,1.82l-1.64,-0.5l-0.52,0.37l-0.09,2.63l-0.56,1.11l0.19,0.81l-0.53,0.27l-1.18,-3.73l-1.08,-0.27l-0.38,0.31l-0.24,1.0l-0.66,-0.66l0.54,-1.06l1.22,-0.34l1.15,-2.25l-0.24,-0.56l-1.57,-0.47l-4.34,-0.28l-0.18,-1.56l-0.35,-0.35l-1.11,-0.12l-1.91,-1.12l-0.56,0.17l-0.88,1.82l0.11,0.49l1.36,1.07l-1.09,0.69l-0.69,1.11l0.18,0.56l1.24,0.57l-0.32,1.54l0.85,1.94l0.36,2.01l-0.22,0.59l-4.58,0.52l-0.33,0.42l0.13,1.8l-1.17,1.36l-3.65,1.81l-2.79,3.03l-4.32,3.28l-0.18,1.27l-4.65,1.79l-0.77,2.16l0.64,5.3l-1.06,2.49l-0.01,3.94l-1.24,0.28l-1.14,1.93l0.39,0.84l-1.68,0.53l-1.04,1.83l-0.65,0.47l-2.06,-2.05l-2.1,-6.02l-2.2,-3.64l-1.05,-4.75l-2.29,-3.57l-1.76,-8.2l0.01,-3.11l-0.49,-2.53l-0.55,-0.29l-3.53,1.52l-1.53,-0.27l-2.86,-2.77l0.85,-0.67l0.08,-0.55l-0.74,-1.03l-2.67,-2.06l1.24,-1.32l5.34,0.01l0.39,-0.49l-0.5,-2.29l-1.42,-1.46l-0.27,-1.93l-1.43,-1.2l2.31,-2.37l3.05,0.06l2.62,-2.85l1.6,-2.81l2.4,-2.73l0.07,-2.04l1.97,-1.48l-0.02,-0.65l-1.93,-1.31l-0.82,-1.78l-0.8,-2.21l0.9,-0.89l3.59,0.65l2.92,-0.42l2.33,-2.19l2.31,2.85l-0.24,2.13l0.99,1.59l-0.05,0.82l-1.34,-0.28l-0.47,0.48l0.7,3.06l2.62,1.99l2.99,1.65Z",
                name: "India"
            },
            TZ: {
                path: "M495.56,296.42l2.8,-3.12l-0.02,-0.81l-0.64,-1.3l0.68,-0.52l0.14,-1.47l-0.76,-1.25l0.31,-0.11l2.26,0.03l-0.51,2.76l0.76,1.3l0.5,0.12l1.05,-0.53l1.19,-0.12l0.61,0.24l1.43,-0.62l0.1,-0.67l-0.71,-0.62l1.57,-1.7l8.65,4.86l0.32,1.53l3.34,2.33l-1.05,2.8l0.13,1.61l1.63,1.12l-0.6,1.76l-0.01,2.33l1.89,4.03l0.57,0.43l-1.46,1.08l-2.61,0.94l-1.43,-0.04l-1.06,0.77l-2.29,0.36l-2.87,-0.68l-0.83,0.07l-0.63,-0.75l-0.31,-2.78l-1.32,-1.35l-3.25,-0.77l-3.96,-1.58l-1.18,-2.41l-0.32,-1.75l-1.76,-1.49l0.42,-1.05l-0.44,-0.89l0.08,-0.96l-0.46,-0.58l0.06,-0.56Z",
                name: "Tanzania"
            },
            AZ: {
                path: "M539.29,175.73l1.33,0.32l1.94,-1.8l2.3,3.34l1.43,0.43l-1.26,0.15l-0.35,0.32l-0.8,3.14l-0.99,0.96l0.05,1.11l-1.26,-1.13l0.7,-1.18l-0.04,-0.47l-0.74,-0.86l-1.48,0.15l-2.34,1.71l-0.03,-1.27l-2.03,-1.35l0.47,-0.62l-0.08,-0.56l-1.03,-0.79l0.29,-0.43l-0.14,-0.58l-1.13,-0.86l1.89,0.68l1.69,0.06l0.37,-0.87l-0.81,-1.37l0.42,0.06l1.63,1.72ZM533.78,180.57l0.61,0.46l0.69,-0.0l0.59,1.15l-0.68,-0.15l-1.21,-1.45Z",
                name: "Azerbaijan"
            },
            IE: {
                path: "M405.08,135.42l0.35,2.06l-1.75,2.78l-4.22,1.88l-2.84,-0.4l1.73,-3.0l-1.18,-3.53l4.6,-3.74l0.32,1.15l-0.49,1.74l0.4,0.51l1.47,-0.04l1.6,0.6Z",
                name: "Ireland"
            },
            ID: {
                path: "M756.47,287.89l0.69,4.01l2.79,1.78l0.51,-0.1l2.04,-2.59l2.71,-1.43l2.05,-0.0l3.9,1.73l2.46,0.45l0.08,15.12l-1.75,-1.54l-2.54,-0.51l-0.88,0.71l-2.32,0.06l0.69,-1.33l1.45,-0.64l0.23,-0.46l-0.65,-2.74l-1.24,-2.21l-5.04,-2.29l-2.09,-0.23l-3.68,-2.27l-0.55,0.13l-0.65,1.07l-0.52,0.12l-0.55,-1.89l-1.21,-0.78l1.84,-0.62l1.72,0.05l0.39,-0.52l-0.21,-0.66l-0.38,-0.28l-3.45,-0.0l-1.13,-1.48l-2.1,-0.43l-0.52,-0.6l2.69,-0.48l1.28,-0.78l3.66,0.94l0.3,0.71ZM757.91,300.34l-0.62,0.82l-0.1,-0.8l0.59,-1.12l0.13,1.1ZM747.38,292.98l0.34,0.72l-1.22,-0.57l-4.68,-0.1l0.27,-0.62l2.78,-0.09l2.52,0.67ZM741.05,285.25l-0.67,-2.88l0.64,-2.01l0.41,0.86l1.21,0.18l0.16,0.7l-0.1,1.68l-0.84,-0.16l-0.46,0.3l-0.34,1.34ZM739.05,293.5l-0.5,0.44l-1.34,-0.36l-0.17,-0.37l1.73,-0.08l0.27,0.36ZM721.45,284.51l-0.19,1.97l2.24,2.23l0.54,0.02l1.27,-1.07l2.75,-0.5l-0.9,1.21l-2.11,0.93l-0.16,0.6l2.22,3.01l-0.3,1.07l1.36,1.74l-2.26,0.85l-0.28,-0.31l0.12,-1.19l-1.64,-1.34l0.17,-2.23l-0.56,-0.39l-1.67,0.76l-0.23,0.39l0.3,6.17l-1.1,0.25l-0.69,-0.47l0.64,-2.21l-0.39,-2.42l-0.39,-0.34l-0.8,-0.01l-0.58,-1.29l0.98,-1.6l0.35,-1.96l1.32,-3.87ZM728.59,296.27l0.38,0.49l-0.02,1.28l-0.88,0.49l-0.53,-0.47l1.04,-1.79ZM729.04,286.98l0.27,-0.05l-0.02,0.13l-0.24,-0.08ZM721.68,284.05l0.16,-0.32l1.89,-1.65l1.83,0.68l3.16,0.35l2.94,-0.1l2.39,-1.66l-1.73,2.13l-1.66,0.43l-2.41,-0.48l-4.17,0.13l-2.39,0.51ZM730.55,310.47l1.11,-1.93l2.03,-0.82l0.08,0.62l-1.45,1.67l-1.77,0.46ZM728.12,305.88l-0.1,0.38l-3.46,0.66l-2.91,-0.27l-0.0,-0.25l1.54,-0.41l1.66,0.73l1.67,-0.19l1.61,-0.65ZM722.9,310.24l-0.64,0.03l-2.26,-1.2l1.11,-0.24l1.78,1.41ZM716.26,305.77l0.88,0.51l1.28,-0.17l0.2,0.35l-4.65,0.73l0.39,-0.67l1.15,-0.02l0.75,-0.73ZM711.66,293.84l-0.38,-0.16l-2.54,1.01l-1.12,-1.44l-1.69,-0.13l-1.16,-0.75l-3.04,0.77l-1.1,-1.15l-3.31,-0.11l-0.35,-3.05l-1.35,-0.95l-1.11,-1.98l-0.33,-2.06l0.27,-2.14l0.9,-1.01l0.37,1.15l2.09,1.49l1.53,-0.48l1.82,0.08l1.38,-1.19l1.0,-0.18l2.28,0.67l2.26,-0.53l1.52,-3.64l1.01,-0.99l0.78,-2.57l4.1,0.3l-1.11,1.77l0.02,0.46l1.7,2.2l-0.23,1.39l2.07,1.71l-2.33,0.42l-0.88,1.9l0.1,2.05l-2.4,1.9l-0.06,2.45l-0.7,2.79ZM692.58,302.03l0.35,0.26l4.8,0.25l0.78,-0.97l4.17,1.09l1.13,1.68l3.69,0.45l2.13,1.04l-1.8,0.6l-2.77,-0.99l-4.8,-0.12l-5.24,-1.41l-1.84,-0.25l-1.11,0.3l-4.26,-0.97l-0.7,-1.14l-1.59,-0.13l1.18,-1.65l2.74,0.13l2.87,1.13l0.26,0.68ZM685.53,299.17l-2.22,0.04l-2.06,-2.03l-3.15,-2.01l-2.93,-3.51l-3.11,-5.33l-2.2,-2.12l-1.64,-4.06l-2.32,-1.69l-1.27,-2.07l-1.96,-1.5l-2.51,-2.65l-0.11,-0.66l4.81,0.53l2.15,2.38l3.31,2.74l2.35,2.66l2.7,0.17l1.95,1.59l1.54,2.17l1.59,0.95l-0.84,1.71l0.15,0.52l1.44,0.87l0.79,0.1l0.4,1.58l0.87,1.4l1.96,0.39l1.0,1.31l-0.6,3.01l-0.09,3.5Z",
                name: "Indonesia"
            },
            UA: {
                path: "M492.5,162.44l1.28,-2.49l1.82,0.19l0.66,-0.23l0.09,-0.71l-0.25,-0.75l-0.79,-0.72l-0.33,-1.21l-0.86,-0.62l-0.02,-1.19l-1.13,-0.86l-1.15,-0.19l-2.04,-1.0l-1.66,0.32l-0.66,0.47l-0.92,-0.0l-0.84,0.78l-2.48,0.7l-1.18,-0.71l-3.07,-0.36l-0.89,0.43l-0.24,-0.55l-1.11,-0.7l0.35,-0.93l1.26,-1.02l-0.54,-1.23l2.04,-2.43l1.4,-0.62l0.25,-1.19l-1.04,-2.39l0.83,-0.13l1.28,-0.84l1.8,-0.07l2.47,0.26l2.86,0.81l1.88,0.06l0.86,0.44l1.04,-0.41l0.77,0.66l2.18,-0.15l0.92,0.3l0.52,-0.34l0.15,-1.53l0.56,-0.54l2.85,-0.05l0.84,-0.72l3.04,-0.18l1.23,1.46l-0.48,0.77l0.21,1.03l0.36,0.32l1.8,0.14l0.93,2.08l3.18,1.15l1.94,-0.45l1.67,1.49l1.4,-0.03l3.35,0.96l0.02,0.54l-0.96,1.59l0.47,1.97l-0.26,0.7l-2.36,0.28l-1.29,0.89l-0.23,1.38l-1.83,0.27l-1.58,0.97l-2.41,0.21l-2.16,1.17l-0.21,0.38l0.34,2.26l1.23,0.75l2.13,-0.08l-0.14,0.31l-2.65,0.53l-3.23,1.69l-0.87,-0.39l0.42,-1.1l-0.25,-0.52l-2.21,-0.73l2.35,-1.06l0.12,-0.65l-0.93,-0.82l-3.62,-0.74l-0.13,-0.89l-0.46,-0.34l-2.61,0.59l-0.91,1.69l-1.71,2.04l-0.86,-0.4l-1.62,0.27Z",
                name: "Ukraine"
            },
            QA: {
                path: "M549.33,221.64l-0.76,-0.23l-0.14,-1.64l0.84,-1.29l0.47,0.52l0.04,1.34l-0.45,1.3Z",
                name: "Qatar"
            },
            MZ: {
                path: "M508.58,318.75l-0.34,-2.57l0.51,-2.05l3.55,0.63l2.5,-0.38l1.02,-0.76l1.49,0.01l2.74,-0.98l1.66,-1.2l0.5,9.24l0.41,1.23l-0.68,1.67l-0.93,1.71l-1.5,1.5l-5.16,2.28l-2.78,2.73l-1.02,0.53l-1.71,1.8l-0.98,0.57l-0.35,2.41l1.16,1.94l0.49,2.17l0.43,0.31l-0.06,2.06l-0.39,1.17l0.5,0.72l-0.25,0.73l-0.92,0.83l-5.12,2.39l-1.22,1.36l0.21,1.13l0.58,0.39l-0.11,0.72l-1.22,-0.01l-0.73,-2.97l0.42,-3.09l-1.78,-5.37l2.49,-2.81l0.69,-1.89l0.44,-0.43l0.28,-1.53l-0.39,-0.93l0.59,-3.65l-0.01,-3.26l-1.49,-1.16l-1.2,-0.22l-1.74,-1.17l-1.92,0.01l-0.29,-2.08l7.06,-1.96l1.28,1.09l0.89,-0.1l0.67,0.44l0.1,0.73l-0.51,1.29l0.19,1.81l1.75,1.83l0.65,-0.13l0.71,-1.65l1.17,-0.86l-0.26,-3.47l-1.05,-1.85l-1.04,-0.94Z",
                name: "Mozambique"
            }
        },
        height: 440.70631074413296,
        width: 900,
        projection: {
            type: "mill",
            centralMeridian: 11.5
        }
    })
}, function (t, e) {
    jsVectorMap.prototype.addMap("us_aea_en", {
        insets: [{
            width: 220,
            top: 440,
            height: 146.9158157558812,
            bbox: [{
                y: -8441281.712315228,
                x: -5263934.893342895
            }, {
                y: -6227992.545028123,
                x: -1949631.2950683108
            }],
            left: 0
        }, {
            width: 80,
            top: 460,
            height: 129.05725678001465,
            bbox: [{
                y: -4207380.690946597,
                x: -5958501.652314129
            }, {
                y: -3658201.4570359783,
                x: -5618076.48127754
            }],
            left: 245
        }, {
            width: 900,
            top: 0,
            height: 550.2150229714246,
            bbox: [{
                y: -5490839.2352678,
                x: -2029243.6460439637
            }, {
                y: -2690044.485299302,
                x: 2552083.9617675776
            }],
            left: 0
        }],
        paths: {
            "US-VA": {
                path: "M682.42,290.04l1.61,-0.93l1.65,-0.48l1.12,-0.95l3.57,-1.69l0.74,-2.33l0.82,-0.19l2.32,-1.54l0.05,-1.81l2.04,-1.86l-0.13,-1.58l0.26,-0.42l5.0,-4.09l4.76,-6.0l0.09,0.63l0.96,0.54l0.33,1.37l1.32,0.74l0.71,0.81l1.46,0.09l0.79,0.65l1.3,0.48l1.41,-0.09l0.79,-0.41l0.76,-1.22l1.17,-0.57l0.53,-1.38l2.72,1.49l1.42,-1.1l2.25,-0.99l0.76,0.06l1.08,-0.97l0.33,-0.82l-0.48,-0.96l0.23,-0.42l1.9,0.58l3.26,-2.62l0.3,-0.1l0.51,0.73l0.66,-0.07l2.38,-2.34l0.17,-0.85l-0.49,-0.51l0.99,-1.12l0.1,-0.6l-0.28,-0.51l-1.0,-0.46l0.71,-3.03l2.6,-4.8l0.55,-2.15l-0.01,-1.91l1.61,-2.55l-0.22,-0.94l0.24,-0.84l0.5,-0.48l0.39,-1.7l-0.0,-3.18l1.23,0.19l1.18,1.73l3.8,0.43l0.59,-0.28l1.05,-2.52l0.2,-2.36l0.71,-1.05l-0.04,-1.61l0.76,-2.31l1.78,0.75l0.65,-0.17l1.3,-3.3l0.57,0.05l0.59,-0.39l0.52,-1.2l0.81,-0.68l0.44,-1.8l1.38,-2.43l-0.35,-2.57l0.54,-1.76l-0.3,-2.01l9.18,4.58l0.59,-0.29l0.63,-4.0l2.6,-0.07l0.63,0.57l1.05,0.23l-0.5,1.74l0.6,0.88l1.61,0.85l2.52,-0.04l1.03,1.18l1.64,0.12l1.94,1.52l0.57,2.53l-0.94,0.78l-0.45,0.02l-0.3,0.43l0.13,0.71l-0.61,-0.05l-0.49,0.59l-0.37,2.5l0.07,2.29l-0.43,0.25l0.01,0.6l1.05,0.77l-0.36,0.14l-0.17,0.6l0.44,0.3l1.64,-0.08l1.38,-0.61l1.77,-1.61l0.39,0.58l-0.58,0.35l0.02,0.58l1.9,1.07l0.64,1.08l1.69,0.35l1.37,-0.11l0.95,0.49l0.82,-0.65l1.05,-0.08l0.33,0.56l1.26,0.63l-0.1,0.55l0.36,0.55l0.94,-0.23l0.41,0.56l3.96,0.88l0.25,1.12l-0.85,-0.41l-0.57,0.44l0.89,1.74l-0.35,0.57l0.62,0.78l-0.44,0.89l0.24,0.59l-1.36,-0.36l-0.59,-0.72l-0.67,0.18l-0.1,0.43l-2.44,-2.3l-0.56,0.05l-0.38,-0.56l-0.52,0.32l-1.36,-1.51l-1.23,-0.43l-2.86,-2.72l-1.34,-0.12l-1.11,-0.81l-1.17,0.05l-0.39,0.52l0.47,0.71l1.1,-0.01l0.63,0.68l1.33,0.07l0.6,0.43l0.62,1.4l1.46,1.11l1.13,0.34l1.53,1.8l2.55,0.94l1.4,1.89l2.14,-0.02l0.56,0.41l0.72,0.06l-0.61,0.7l0.3,0.49l2.03,0.34l0.26,0.72l0.55,0.1l0.13,1.67l-1.0,-0.75l-0.39,0.21l-1.13,-1.0l-0.58,0.29l0.1,0.82l-0.31,0.68l0.7,0.7l-0.18,0.6l1.12,0.32l-0.86,0.44l-2.12,-0.73l-1.39,-1.38l-0.83,-0.32l-2.23,-1.87l-0.58,0.11l-0.22,0.53l0.26,0.81l0.64,0.21l3.81,3.15l2.69,1.12l1.28,-0.33l0.45,1.07l1.27,0.26l-0.44,0.67l0.3,0.56l0.93,-0.19l0.0,1.24l-0.92,0.41l-0.57,0.73l-0.71,-0.93l-3.2,-1.58l-0.29,-1.16l-0.59,-0.59l-0.87,-0.11l-1.2,0.67l-1.71,-0.44l-0.36,-1.15l-0.71,-0.05l-0.05,1.32l-0.33,0.41l-1.43,-1.32l-0.51,0.09l-0.48,0.57l-0.65,-0.4l-0.99,0.45l-2.23,-0.1l-0.37,0.94l0.34,0.46l1.9,0.22l1.4,-0.31l0.85,0.24l0.56,-0.69l0.63,0.88l1.34,0.43l1.95,-0.31l1.5,0.71l0.67,-0.63l0.94,2.47l3.16,1.23l0.37,0.91l-0.57,1.03l0.56,0.44l1.72,-1.32l0.88,-0.02l0.83,0.65l0.8,-0.26l-0.61,-0.9l-0.2,-1.17l3.78,0.08l1.13,-0.44l1.89,3.23l-0.46,0.71l0.65,3.09l-1.19,-0.58l-0.02,0.88l-30.95,7.83l-37.19,8.41l-19.52,3.35l-7.08,0.85l-0.46,-0.26l-4.24,0.64l-0.82,0.62l-28.2,5.01ZM781.15,223.32l0.14,0.09l-0.06,0.07l-0.01,-0.03l-0.07,-0.12ZM808.05,244.59l0.53,-1.14l-0.26,-0.54l-0.36,-0.08l0.58,-0.98l-0.39,-0.71l-0.03,-0.49l0.44,-0.35l-0.17,-0.73l0.62,-0.3l0.23,-0.6l0.14,-2.33l1.01,-0.39l-0.12,-0.9l0.48,-0.14l-0.26,-1.53l-0.79,-0.4l0.87,-0.57l0.1,-1.03l2.69,-1.11l0.36,2.48l-1.08,4.2l-0.22,2.38l0.33,1.09l-0.34,0.97l-0.6,-0.79l-0.81,0.15l-0.39,0.95l0.27,0.37l-0.65,0.46l-0.3,0.85l0.17,1.05l-0.31,1.46l0.38,2.47l-0.6,0.6l0.07,1.33l-1.37,-1.9l0.23,-0.94l-0.33,-1.57l0.28,-0.97l-0.38,-0.3Z",
                name: "Virginia"
            },
            "US-PA": {
                path: "M716.46,159.99l0.63,-0.19l4.3,-3.73l1.13,5.2l0.48,0.31l34.84,-7.93l34.28,-8.64l1.42,0.58l0.71,1.39l0.64,0.13l0.77,-0.33l1.24,0.59l0.14,0.85l0.81,0.41l-0.16,0.58l0.89,2.69l1.9,2.07l2.12,0.75l2.21,-0.2l0.72,0.79l-0.89,0.87l-0.73,1.49l-0.17,2.25l-1.41,3.35l-1.37,1.58l0.04,0.79l1.79,1.72l-0.31,1.65l-0.84,0.43l-0.22,0.66l0.14,1.48l1.04,2.87l0.52,0.25l1.2,-0.18l1.18,2.39l0.95,0.58l0.66,-0.26l0.6,0.9l4.23,2.75l0.12,0.41l-1.29,0.93l-3.71,4.22l-0.23,0.76l0.17,0.9l-1.36,1.13l-0.84,0.15l-1.33,1.08l-0.33,0.66l-1.72,-0.12l-2.03,0.84l-1.15,1.37l-0.41,1.39l-37.23,9.21l-39.1,8.66l-10.03,-48.21l1.92,-1.22l3.08,-3.04Z",
                name: "Pennsylvania"
            },
            "US-TN": {
                path: "M571.72,341.09l0.86,-0.84l0.29,-1.37l1.0,0.04l0.65,-0.79l-0.99,-4.89l1.41,-1.93l0.06,-1.32l1.18,-0.46l0.36,-0.48l-0.63,-1.31l0.53,-0.65l0.05,-0.56l-0.89,-1.33l2.55,-1.57l1.09,-1.13l-0.14,-0.84l-0.85,-0.53l0.14,-0.19l0.34,-0.16l0.85,0.37l0.46,-0.33l-0.27,-1.31l-0.85,-0.9l0.06,-0.71l0.51,-1.43l1.0,-1.11l-1.35,-2.06l1.37,-0.21l0.61,-0.55l-0.13,-0.64l-1.17,-0.82l0.82,-0.15l0.58,-0.54l0.13,-0.69l-0.59,-1.38l0.02,-0.36l0.37,0.53l0.47,0.08l0.58,-0.29l0.6,-0.86l23.67,-2.81l0.35,-0.41l-0.1,-1.35l-0.84,-2.39l2.98,-0.08l0.82,0.58l22.79,-3.55l7.64,-0.46l7.5,-0.86l8.82,-1.42l24.01,-3.1l1.11,-0.6l29.3,-5.2l0.73,-0.6l3.56,-0.54l-0.4,1.44l0.43,0.85l-0.4,2.0l0.36,0.82l-1.15,-0.03l-1.71,1.79l-1.21,3.89l-0.55,0.7l-0.56,0.08l-0.63,-0.74l-1.44,-0.02l-2.66,1.73l-1.42,2.73l-0.96,0.89l-0.34,-0.34l-0.13,-1.05l-0.73,-0.54l-0.53,0.15l-2.3,1.81l-0.29,1.32l-0.93,-0.24l-0.9,0.48l-0.16,0.77l0.32,0.73l-0.85,2.18l-1.29,0.06l-1.75,1.14l-1.28,1.24l-0.61,1.06l-0.78,0.27l-2.28,2.46l-4.04,0.78l-2.58,1.7l-0.49,1.09l-0.88,0.55l-0.55,0.81l-0.18,2.88l-0.35,0.6l-1.65,0.52l-0.89,-0.16l-1.06,1.14l0.21,5.24l-20.21,3.32l-21.62,3.04l-25.56,2.95l-0.34,0.31l-7.39,0.9l-28.73,3.17Z",
                name: "Tennessee"
            },
            "US-ID": {
                path: "M132.38,121.39l-0.34,-0.44l0.08,-1.99l0.53,-1.74l1.42,-1.22l2.11,-3.59l1.68,-0.92l1.39,-1.53l1.08,-2.15l0.05,-1.22l2.21,-2.41l1.43,-2.7l0.37,-1.37l2.04,-2.26l1.89,-2.81l0.03,-1.01l-0.79,-2.95l-2.13,-1.94l-0.87,-0.36l-0.85,-1.61l-0.41,-3.02l-0.59,-1.19l0.94,-1.19l-0.12,-2.35l-1.04,-2.69l0.46,-0.98l9.67,-54.45l13.39,2.35l-3.54,20.72l1.29,2.89l1.0,1.27l0.27,1.55l1.17,1.76l-0.12,0.83l0.39,1.14l-0.99,0.95l0.83,1.76l-0.83,0.11l-0.28,0.71l1.93,1.68l1.03,2.04l2.24,1.22l0.54,1.58l1.09,1.33l1.49,2.79l0.08,0.68l1.64,1.81l0.01,1.88l1.79,1.71l-0.07,1.35l0.74,0.19l0.9,-0.58l0.36,0.46l-0.36,0.55l0.07,0.54l1.11,0.96l1.61,0.15l1.81,-0.36l-0.63,2.61l-0.99,0.54l0.25,1.14l-1.83,3.73l0.06,1.72l-0.81,0.07l-0.37,0.54l0.6,1.33l-0.62,0.9l-0.03,1.16l0.97,0.93l-0.37,0.81l0.28,1.01l-1.57,0.43l-1.21,1.41l0.1,1.11l0.46,0.77l-0.13,0.74l-0.83,0.77l-0.2,1.52l1.48,0.63l1.38,1.79l0.78,0.27l1.08,-0.35l0.56,-0.8l1.85,-0.41l1.21,-1.28l0.81,-0.29l0.15,-0.76l0.78,0.81l0.23,0.71l1.06,0.64l-0.42,1.23l0.73,0.95l-0.34,1.38l0.57,1.34l-0.21,1.61l1.54,2.64l0.31,1.73l0.82,0.37l0.67,2.08l-0.18,0.98l-0.76,0.64l0.51,1.9l1.24,1.16l0.3,0.79l0.81,0.08l0.86,-0.37l1.04,0.93l1.06,2.79l-0.5,0.81l0.89,1.83l-0.28,0.6l0.11,0.98l2.29,2.41l0.97,-0.14l-0.01,-1.14l1.07,-0.89l0.93,-0.22l4.53,1.62l0.69,-0.32l0.67,-1.35l1.19,-0.39l2.25,0.93l3.3,-0.1l0.96,0.88l2.29,-0.58l3.23,0.78l0.45,-0.49l-0.67,-0.76l0.26,-1.06l0.74,-0.48l-0.07,-0.96l1.23,-0.51l0.48,0.37l1.07,2.11l0.12,1.11l1.36,1.95l0.73,0.45l-6.27,53.86l-47.48,-6.32l-46.97,-7.73l6.88,-39.17l1.12,-1.18l1.07,-2.67l-0.21,-1.75l0.74,-0.15l0.77,-1.62l-0.9,-1.27l-0.18,-1.2l-1.24,-0.08l-0.64,-0.81l-0.88,0.29Z",
                name: "Idaho"
            },
            "US-NV": {
                path: "M139.36,329.2l-12.7,-16.93l-36.59,-51.1l-25.35,-34.52l13.7,-64.19l46.89,9.24l46.99,7.74l-18.72,125.83l-0.9,1.16l-0.99,2.19l-0.44,0.17l-1.34,-0.22l-0.98,-2.24l-0.7,-0.63l-1.41,0.22l-1.95,-1.02l-1.6,0.23l-1.78,0.96l-0.76,2.48l0.88,2.59l-0.6,0.97l-0.24,1.31l0.38,3.12l-0.76,2.54l0.77,3.71l-0.13,3.07l-0.3,1.07l-1.04,0.31l-0.12,0.51l0.32,0.8l-0.52,0.62Z",
                name: "Nevada"
            },
            "US-TX": {
                path: "M276.16,412.59l33.07,1.99l32.79,1.35l0.41,-0.39l3.6,-98.71l25.86,0.61l26.29,0.22l0.05,42.09l0.44,0.4l1.02,-0.13l0.78,0.28l3.74,3.82l1.66,0.21l0.88,-0.58l2.49,0.64l0.6,-0.68l0.11,-1.05l0.6,0.76l0.92,0.22l0.38,0.93l0.77,0.78l-0.01,1.64l0.52,0.83l2.85,0.42l1.25,-0.2l1.38,0.89l2.78,0.69l1.82,-0.56l0.63,0.1l1.89,1.8l1.4,-0.11l1.25,-1.43l2.43,0.26l1.67,-0.46l0.1,2.28l0.91,0.67l1.62,0.4l-0.04,2.09l1.56,0.79l1.82,-0.66l1.57,-1.68l1.02,-0.65l0.41,0.19l0.45,1.64l2.01,0.2l0.24,1.05l0.72,0.48l1.47,-0.21l0.88,-0.93l0.39,0.33l0.59,-0.08l0.61,-0.99l0.26,0.41l-0.45,1.23l0.14,0.76l0.67,1.14l0.78,0.42l0.57,-0.04l0.6,-0.5l0.68,-2.36l0.91,-0.65l0.35,-1.54l0.57,-0.14l0.4,0.14l0.29,0.99l0.57,0.64l1.21,0.02l0.83,0.5l1.26,-0.2l0.68,-1.34l0.48,0.15l-0.13,0.7l0.49,0.69l1.21,0.45l0.49,0.72l1.52,-0.05l1.49,1.74l0.52,0.02l0.63,-0.62l0.08,-0.71l1.49,-0.1l0.93,-1.43l1.88,-0.41l1.66,-1.13l1.52,0.83l1.51,-0.22l0.29,-0.83l2.29,-0.73l0.53,-0.55l0.5,0.32l0.38,0.88l1.82,0.42l1.69,-0.06l1.86,-1.14l0.41,-1.05l1.06,0.31l2.24,1.56l1.16,0.17l1.79,2.08l2.14,0.41l1.04,0.92l0.76,-0.11l2.48,0.85l1.04,0.04l0.37,0.79l1.38,0.97l1.45,-0.12l0.39,-0.72l0.8,0.36l0.88,-0.4l0.92,0.35l0.76,-0.15l0.64,0.36l2.23,34.03l1.51,1.67l1.3,0.82l1.25,1.87l0.57,1.63l-0.1,2.64l1.0,1.21l0.85,0.4l-0.12,0.85l0.75,0.54l0.28,0.87l0.65,0.7l-0.19,1.17l1.0,1.02l0.59,1.63l0.5,0.34l0.55,-0.1l-0.16,1.71l0.81,1.22l-0.64,0.25l-0.35,0.68l0.77,1.27l-0.55,0.89l0.19,1.39l-0.75,2.69l-0.74,0.85l-0.36,1.54l-0.79,1.13l0.64,2.0l-0.83,2.28l0.17,1.07l0.83,1.2l-0.19,1.01l0.49,1.6l-0.24,1.41l-1.13,1.67l-1.02,0.2l-1.76,3.37l-0.04,1.06l1.79,2.37l-3.43,0.08l-7.37,3.78l-0.02,-0.43l-2.19,-0.46l-3.24,1.07l1.09,-3.51l-0.3,-1.21l-0.8,-0.76l-0.62,-0.07l-1.52,0.85l-0.99,2.0l-1.56,-0.96l-1.64,0.12l-0.07,0.63l0.89,0.62l0.0,1.06l0.56,0.39l-0.47,0.69l0.07,1.02l1.63,0.64l-0.62,0.71l0.49,0.97l0.91,0.23l0.28,0.37l-0.4,1.25l-0.45,-0.12l-0.97,0.81l-1.72,2.25l-1.18,-0.4l-0.49,0.12l0.32,1.0l0.08,2.55l-1.85,1.49l-1.91,2.11l-0.96,0.37l-4.1,2.9l-3.3,0.45l-2.54,1.06l-0.2,1.12l-0.75,-0.34l-2.04,0.89l-0.33,-0.34l-1.11,0.18l0.43,-0.87l-0.52,-0.6l-1.43,0.22l-1.22,1.08l-0.6,-0.62l-0.11,-1.2l-1.38,-0.81l-0.5,0.44l0.65,1.44l0.01,1.12l-0.71,0.09l-0.54,-0.44l-0.75,-0.0l-0.55,-1.34l-1.46,-0.37l-0.58,0.39l0.04,0.54l0.94,1.7l0.03,1.24l0.58,0.37l0.36,-0.16l1.13,0.78l-0.75,0.37l-0.27,0.54l0.15,0.36l0.7,0.23l1.08,-0.54l0.96,0.6l-4.27,2.42l-0.57,-0.13l-0.37,-1.44l-0.5,-0.18l-1.13,-1.46l-0.49,-0.03l-0.48,0.51l0.1,0.63l-0.62,0.34l-0.05,0.51l1.18,1.61l-0.31,1.04l0.33,0.85l-1.66,1.79l-0.37,0.2l0.37,-0.64l-0.18,-0.72l0.25,-0.73l-0.46,-0.67l-0.52,0.17l-0.71,1.1l0.26,0.72l-0.39,0.95l-0.07,-1.13l-0.52,-0.55l-1.95,1.29l-0.78,-0.33l-0.7,0.52l0.07,0.75l-0.81,0.99l0.02,0.49l1.25,0.64l0.03,0.56l0.78,0.28l0.7,-1.41l0.86,-0.41l0.01,0.62l-2.82,4.36l-1.23,-1.0l-1.36,0.38l-0.32,-0.34l-2.4,0.39l-0.46,-0.31l-0.65,0.16l-0.18,0.58l0.41,0.61l0.55,0.38l1.53,0.03l-0.01,0.91l0.55,0.64l2.07,1.03l-2.7,7.63l-0.2,0.1l-0.38,-0.54l-0.34,0.1l0.18,-0.76l-0.57,-0.43l-2.35,1.95l-1.72,-2.36l-1.19,-0.91l-0.61,0.4l0.09,0.52l1.44,2.0l-0.11,0.82l-0.93,-0.09l-0.33,0.63l0.51,0.56l1.88,0.07l2.14,0.72l2.08,-0.72l-0.43,1.75l0.24,0.77l-0.98,0.7l0.37,1.59l-1.12,0.14l-0.43,0.41l0.4,2.11l-0.33,1.6l0.45,0.64l0.84,0.24l0.87,2.86l0.71,2.81l-0.91,0.82l0.62,0.49l-0.08,1.28l0.72,0.3l0.18,0.61l0.58,0.29l0.4,1.79l0.68,0.31l0.45,3.22l1.46,0.62l-0.52,1.1l0.31,1.07l-0.63,0.77l-0.84,-0.05l-0.53,0.44l0.08,1.31l-0.49,-0.33l-0.49,0.25l-0.39,-0.67l-1.49,-0.45l-2.92,-2.53l-2.2,-0.18l-0.81,-0.51l-4.2,0.09l-0.9,0.42l-0.78,-0.63l-1.06,0.25l-1.25,-0.2l-1.45,-0.7l-0.72,-0.97l-0.6,-0.14l-0.21,-0.72l-1.17,-0.49l-0.99,-0.02l-1.98,-0.87l-1.45,0.39l-0.83,-1.09l-0.6,-0.21l-1.43,-1.38l-1.96,0.01l-1.47,-0.64l-0.86,0.12l-1.62,-0.41l0.28,-1.26l-0.54,-1.01l-0.96,-0.35l-1.65,-6.03l-2.77,-3.02l-0.29,-1.12l-1.08,-0.75l0.35,-0.77l-0.24,-0.76l0.34,-2.18l-0.45,-0.96l-1.04,-1.01l0.65,-1.99l0.05,-1.19l-0.18,-0.7l-0.54,-0.33l-0.15,-1.81l-1.85,-1.44l-0.85,0.21l-0.29,-0.41l-0.81,-0.11l-0.74,-1.31l-2.22,-1.71l0.01,-0.69l-0.51,-0.58l0.12,-0.86l-0.97,-0.92l-0.08,-0.75l-1.12,-0.61l-1.3,-2.88l-2.66,-1.48l-0.38,-0.91l-1.13,-0.59l-0.06,-1.16l-0.82,-1.19l-0.59,-1.95l0.41,-0.22l-0.04,-0.73l-1.03,-0.49l-0.26,-1.29l-0.81,-0.57l-0.94,-1.74l-0.61,-2.38l-1.85,-2.36l-0.87,-4.24l-1.81,-1.34l0.05,-0.7l-0.75,-1.21l-3.96,-2.67l-0.71,-1.86l-1.82,-0.62l-1.44,-0.99l-0.01,-1.63l-0.6,-0.39l-0.88,0.24l-0.12,-0.77l-0.98,-0.33l-0.8,-2.08l-0.57,-0.47l-0.46,0.12l-0.46,-0.44l-0.86,0.27l-0.14,-0.6l-0.44,-0.31l-0.47,0.15l-0.25,0.61l-1.05,0.16l-2.89,-0.47l-0.39,-0.38l-1.48,-0.03l-0.79,0.29l-0.77,-0.44l-2.67,0.27l-3.92,-2.08l-1.35,0.86l-0.64,1.61l-1.98,-0.17l-0.52,0.44l-0.49,-0.17l-1.05,0.49l-1.33,0.14l-3.22,6.4l-0.18,1.77l-0.76,0.67l-0.38,1.8l0.35,0.59l-1.99,1.01l-0.72,1.3l-1.11,0.65l-1.12,2.0l-2.67,-0.46l-1.04,-0.87l-0.55,0.3l-1.69,-1.21l-1.31,-1.63l-2.9,-0.85l-1.15,-0.95l-0.02,-0.67l-0.42,-0.41l-2.75,-0.51l-2.28,-1.03l-1.89,-1.75l-0.91,-1.53l-0.96,-0.91l-1.53,-0.29l-1.77,-1.26l-0.22,-0.56l-1.31,-1.18l-0.65,-2.68l-0.86,-1.01l-0.24,-1.1l-0.76,-1.28l-0.26,-2.34l0.52,-3.05l-3.01,-5.07l-0.06,-1.94l-1.26,-2.51l-0.99,-0.44l-0.43,-1.24l-1.43,-0.81l-2.15,-2.18l-1.02,-0.1l-2.01,-1.25l-3.18,-3.35l-0.59,-1.55l-3.13,-2.55l-1.59,-2.45l-1.19,-0.95l-0.61,-1.05l-4.42,-2.6l-1.19,-2.19l-1.21,-3.23l-1.37,-1.08l-1.12,-0.08l-1.75,-1.67l-0.79,-3.05ZM502.09,468.18l-0.33,0.17l0.18,-0.16l0.15,-0.02ZM498.69,470.85l-0.09,0.12l-0.04,0.02l0.13,-0.14ZM497.79,472.33l0.15,0.05l-0.2,0.18l0.04,-0.11l0.01,-0.12ZM497.02,473.23l-0.13,0.12l0.03,-0.09l0.09,-0.03ZM467.54,489.19l0.03,0.02l-0.02,0.01l-0.0,-0.03ZM453.94,547.19l0.75,-0.5l0.25,-0.68l0.11,1.08l-1.1,0.1ZM460.89,499.8l-0.14,-0.59l1.22,-0.36l-0.28,0.33l-0.79,0.63ZM463.51,497.84l0.1,-0.23l1.27,-0.88l-0.92,0.85l-0.45,0.26ZM465.8,496.12l0.28,-0.24l0.47,-0.04l-0.25,0.13l-0.5,0.15ZM457.96,502.92l0.71,-1.64l0.64,-0.71l-0.02,0.75l-1.33,1.6ZM451.06,515.13l0.06,-0.22l0.07,-0.15l-0.13,0.37ZM451.5,513.91l0.16,-0.35l0.02,-0.02l-0.18,0.37ZM452.44,511.95l-0.01,-0.04l0.05,-0.04l-0.04,0.08Z",
                name: "Texas"
            },
            "US-NH": {
                path: "M829.94,105.42l0.2,-1.33l-1.43,-5.38l0.53,-1.45l-0.28,-2.22l1.0,-1.86l-0.13,-2.3l0.64,-2.28l-0.44,-0.62l0.29,-2.31l-0.93,-3.8l0.08,-0.7l0.3,-0.45l1.83,-0.8l0.7,-1.39l1.43,-1.62l0.74,-1.8l-0.25,-1.13l0.52,-0.62l-2.34,-3.49l0.87,-3.26l-0.11,-0.78l-0.81,-1.29l0.27,-0.59l-0.23,-0.7l0.48,-3.2l-0.36,-0.82l0.91,-1.49l2.44,0.33l0.65,-0.88l13.0,34.89l0.84,3.65l2.6,2.21l0.88,0.34l0.36,1.6l1.72,1.31l0.0,0.35l0.77,0.23l-0.06,0.58l-0.46,3.09l-1.57,0.24l-1.32,1.19l-0.51,0.94l-0.96,0.37l-0.5,1.68l-1.1,1.44l-17.61,4.74l-1.7,-1.43l-0.41,-0.89l-0.1,-2.0l0.54,-0.59l0.03,-0.52l-1.02,-5.18Z",
                name: "New Hampshire"
            },
            "US-NY": {
                path: "M821.38,166.44l0.69,-2.05l0.62,-0.02l0.55,-0.75l0.76,0.15l0.54,-0.41l-0.04,-0.31l0.57,-0.03l0.28,-0.66l0.66,-0.02l0.2,-0.55l-0.42,-0.83l0.22,-0.53l0.61,-0.37l1.34,0.22l0.54,-0.59l1.45,-0.18l0.21,-0.8l1.85,0.02l1.08,-0.91l0.11,-0.78l0.62,0.24l0.43,-0.61l4.83,-1.29l2.26,-1.3l1.99,-2.91l-0.2,1.16l-0.98,0.86l-1.22,2.31l0.55,0.46l1.6,-0.35l0.28,0.63l-0.43,0.49l-1.37,0.87l-0.51,-0.07l-2.26,0.92l-0.08,0.93l-0.87,-0.0l-2.73,1.72l-1.01,0.15l-0.17,0.8l-1.24,0.09l-2.24,1.91l-4.44,2.17l-0.2,0.71l-0.29,0.08l-0.45,-0.83l-1.41,-0.06l-0.73,0.42l-0.42,0.8l0.23,0.32l-0.92,0.69l-0.76,-0.84l0.32,-1.05ZM828.05,159.06l-0.02,-0.01l0.02,-0.06l-0.01,0.08ZM845.16,149.05l0.06,-0.06l0.18,-0.06l-0.11,0.19l-0.13,-0.07ZM844.3,154.94l0.1,-0.89l0.74,-1.16l1.65,-1.52l1.01,0.31l0.05,-0.82l0.79,0.67l-3.36,3.21l-0.67,0.45l-0.31,-0.25ZM850.39,150.14l0.02,-0.03l0.07,-0.07l-0.09,0.1ZM722.09,155.56l3.76,-3.85l1.27,-2.19l1.76,-1.86l1.16,-0.78l1.28,-3.35l1.56,-1.3l0.53,-0.83l-0.21,-1.83l-1.61,-2.42l0.43,-1.13l-0.17,-0.78l-0.83,-0.53l-2.11,-0.0l0.04,-0.99l-0.57,-2.22l4.99,-2.94l4.49,-1.8l2.38,-0.19l1.84,-0.74l5.64,-0.24l3.13,1.25l3.16,-1.68l5.49,-1.06l0.58,0.45l0.68,-0.2l0.12,-0.98l1.45,-0.72l1.03,-0.93l0.75,-0.2l0.69,-2.05l1.87,-1.76l0.79,-1.26l1.12,0.03l1.13,-0.52l1.07,-1.63l-0.46,-0.7l0.36,-1.2l-0.25,-0.51l-0.64,0.02l-0.17,-1.17l-0.94,-1.59l-1.01,-0.62l0.12,-0.18l0.59,0.39l0.53,-0.27l0.75,-1.44l-0.01,-0.91l0.81,-0.65l-0.01,-0.97l-0.93,-0.19l-0.6,0.7l-0.28,0.12l0.56,-1.3l-0.81,-0.62l-1.26,0.05l-0.87,0.77l-0.92,-0.41l-0.06,-0.29l2.05,-2.5l1.78,-1.47l1.67,-2.64l0.7,-0.56l0.11,-0.59l0.78,-0.95l0.07,-0.56l-0.5,-0.95l0.78,-1.89l4.82,-7.61l4.77,-4.5l2.84,-0.51l19.67,-5.66l0.41,0.88l-0.08,2.01l1.02,1.22l0.43,3.8l2.29,3.25l-0.09,1.89l0.85,2.42l-0.59,1.07l-0.0,3.41l0.71,0.9l1.32,2.76l0.19,1.09l0.62,0.84l0.12,3.92l0.55,0.85l0.54,0.07l0.53,-0.61l0.06,-0.87l0.33,-0.07l1.05,1.12l3.97,15.58l0.74,1.2l0.22,15.32l0.6,0.62l3.57,16.23l1.26,1.34l-2.82,3.18l0.03,0.54l1.52,1.31l0.19,0.6l-0.78,0.88l-0.64,1.8l-0.41,0.39l0.15,0.69l-1.25,0.64l0.04,-4.02l-0.57,-2.28l-0.74,-1.62l-1.46,-1.1l-0.17,-1.13l-0.7,-0.1l-0.42,1.33l0.68,1.27l1.05,0.83l0.97,2.85l-13.75,-4.06l-1.28,-1.47l-2.39,0.24l-0.63,-0.43l-1.06,-0.15l-1.74,-1.91l-0.75,-2.33l0.12,-0.72l-0.36,-0.63l-0.56,-0.21l0.09,-0.46l-0.35,-0.42l-1.64,-0.68l-1.08,0.32l-0.53,-1.22l-1.92,-0.93l-34.6,8.73l-34.44,7.84l-1.11,-5.15ZM818.84,168.69l1.08,-0.48l0.14,0.63l-1.17,1.53l-0.05,-1.68ZM730.07,136.63l0.03,-0.69l0.78,-0.07l-0.38,1.09l-0.43,-0.33Z",
                name: "New York"
            },
            "US-HI": {
                path: "M295.5,583.17l0.06,-1.75l4.12,-4.97l1.03,-3.4l-0.33,-0.64l0.94,-2.43l-0.05,-3.52l0.39,-0.78l2.47,-0.7l1.55,0.23l4.45,-1.4l0.51,-0.7l-0.17,-2.69l0.4,-1.66l1.78,-1.16l1.74,2.15l-0.15,0.94l1.88,3.6l0.94,0.35l5.13,7.65l0.86,3.93l-1.52,3.14l0.22,0.58l1.47,0.95l-0.68,2.07l0.35,1.51l1.6,3.0l-1.39,0.86l-2.28,-0.2l-3.27,0.51l-4.56,-1.32l-2.15,-1.34l-6.66,-0.15l-1.59,0.26l-1.56,1.19l-1.63,0.58l-1.14,0.02l-0.7,-2.54l-2.09,-2.18ZM306.33,530.7l1.6,0.08l0.51,2.07l-0.3,2.25l0.37,0.59l2.33,0.88l1.38,0.1l1.55,1.39l0.27,1.55l0.93,0.97l-0.13,1.05l1.83,2.52l-0.13,0.66l-0.61,0.48l-1.82,0.38l-1.84,-0.18l-1.47,-1.19l-2.21,-0.24l-2.69,-1.48l0.01,-1.23l1.15,-1.86l0.41,-2.07l-1.76,-1.28l-1.08,-1.75l-0.1,-2.61l1.79,-1.08ZM297.2,518.01l0.71,0.31l0.38,1.05l2.64,2.0l0.9,1.11l0.92,0.08l0.8,1.67l1.56,1.05l0.72,0.06l1.07,1.11l-1.31,0.41l-2.75,-0.66l-3.23,-3.93l-3.16,-2.01l-1.39,-0.44l-0.05,-0.7l1.58,-0.43l0.62,-0.67ZM301.59,541.55l-2.09,-0.98l-0.28,-0.51l2.92,0.34l-0.56,1.15ZM298.23,532.36l-0.92,-0.29l-0.72,-0.89l0.92,-2.06l-0.49,-1.73l2.6,1.38l0.61,2.08l0.14,1.06l-2.15,0.45ZM281.13,503.64l0.57,-1.85l-0.38,-0.9l-0.16,-2.84l0.75,-0.92l-0.12,-1.22l2.74,1.9l2.9,-0.62l1.56,0.15l0.38,1.01l-0.33,2.17l0.29,1.5l-0.69,0.6l-0.19,1.55l0.38,1.54l0.86,0.51l0.29,1.07l-0.52,1.14l0.53,1.28l-1.18,-0.0l-0.2,-0.48l-2.04,-0.86l-0.77,-2.83l-1.27,-0.38l0.8,-0.11l0.32,-0.46l-0.08,-0.66l-0.63,-0.68l-1.75,-0.32l0.23,1.82l-2.28,-1.1ZM259.66,469.47l-0.24,-2.03l-0.91,-0.69l-0.68,-1.23l0.08,-1.2l0.08,-0.34l2.39,-0.81l4.6,0.53l0.67,1.04l2.51,1.09l0.69,1.25l-0.15,1.9l-2.3,1.32l-0.74,1.3l-0.79,0.34l-2.78,0.09l-0.92,-1.53l-1.52,-1.0ZM245.78,462.61l-0.23,-0.74l1.03,-0.75l4.32,-0.72l0.43,0.3l-0.92,0.4l-0.68,0.94l-1.66,-0.5l-1.36,0.34l-0.94,0.72Z",
                name: "Hawaii"
            },
            "US-VT": {
                path: "M805.56,72.69l26.03,-7.97l0.89,1.85l-0.74,2.37l-0.03,1.54l2.22,2.75l-0.51,0.58l0.26,1.13l-0.67,1.6l-1.35,1.49l-0.64,1.32l-1.72,0.7l-0.62,0.92l-0.1,0.98l0.93,3.74l-0.29,2.44l0.4,0.54l-0.6,2.11l0.15,2.19l-1.0,1.87l0.27,2.36l-0.53,1.54l1.43,5.44l-0.22,1.22l1.05,5.3l-0.58,0.85l0.11,2.31l0.6,1.26l1.51,1.1l-11.44,2.89l-0.57,-0.85l-4.02,-15.75l-1.72,-1.59l-0.91,0.25l-0.3,1.19l-0.12,-0.26l-0.11,-3.91l-0.68,-1.0l-0.14,-0.98l-1.37,-2.85l-0.63,-0.68l0.01,-3.15l0.6,-1.15l-0.86,-2.57l0.08,-1.93l-0.39,-0.91l-1.55,-1.63l-0.38,-0.81l-0.41,-3.71l-1.03,-1.27l0.11,-1.87l-0.43,-1.01Z",
                name: "Vermont"
            },
            "US-NM": {
                path: "M230.86,422.88l11.82,-123.66l25.67,2.24l26.1,1.86l26.12,1.45l25.74,1.02l-0.31,10.24l-0.74,0.39l-3.59,98.69l-32.38,-1.34l-33.53,-2.02l-0.44,0.76l0.54,2.31l0.44,1.26l0.99,0.76l-30.55,-2.46l-0.43,0.36l-0.82,9.46l-14.63,-1.33Z",
                name: "New Mexico"
            },
            "US-NC": {
                path: "M826.87,289.49l0.07,-0.05l-0.02,0.03l-0.04,0.02ZM819.58,272.4l0.2,0.23l-0.05,0.01l-0.16,-0.24ZM821.84,276.68l0.19,0.15l-0.02,0.18l-0.05,-0.08l-0.12,-0.25ZM676.72,321.77l0.92,0.17l1.52,-0.39l0.42,-0.39l0.52,-0.97l0.13,-2.7l1.34,-1.19l0.47,-1.05l2.24,-1.47l2.12,-0.52l0.76,0.18l1.32,-0.52l2.36,-2.52l0.78,-0.25l1.84,-2.29l1.48,-1.0l1.55,-0.19l1.15,-2.65l-0.28,-1.22l1.66,0.06l0.51,-1.65l0.93,-0.77l1.08,-0.77l0.51,1.52l1.07,0.33l1.34,-1.17l1.35,-2.64l2.49,-1.59l0.79,0.08l0.82,0.8l1.06,-0.21l0.84,-1.07l1.47,-4.18l1.08,-1.1l1.47,0.09l0.44,-0.31l-0.69,-1.26l0.4,-2.0l-0.42,-0.9l0.38,-1.25l7.42,-0.86l19.54,-3.36l37.22,-8.42l31.12,-7.87l0.4,1.21l3.54,3.24l1.0,1.53l-1.21,-1.0l-0.16,-0.63l-0.92,-0.4l-0.52,0.05l-0.24,0.65l0.66,0.54l0.59,1.56l-0.53,0.01l-0.91,-0.75l-2.31,-0.8l-0.4,-0.48l-0.55,0.13l-0.31,0.69l0.14,0.64l1.37,0.44l1.69,1.38l-1.11,0.66l-2.48,-1.2l-0.36,0.51l0.14,0.42l1.6,1.18l-1.84,-0.33l-2.23,-0.87l-0.46,0.14l0.01,0.48l0.6,0.7l1.71,0.83l-0.97,0.58l0.0,0.6l-0.43,0.53l-1.48,0.74l-0.89,-0.77l-0.61,0.22l-0.1,0.35l-0.2,-0.13l-1.32,-2.32l0.21,-2.63l-0.42,-0.48l-0.89,-0.22l-0.37,0.64l0.62,0.71l-0.43,0.99l-0.02,1.04l0.49,1.73l1.6,2.2l-0.31,1.28l0.48,0.29l2.97,-0.59l2.1,-1.49l0.27,0.01l0.37,0.79l0.76,-0.34l1.56,0.05l0.16,-0.71l-0.57,-0.32l1.29,-0.76l2.04,-0.46l-0.1,1.19l0.64,0.29l-0.6,0.88l0.89,1.19l-0.84,0.1l-0.19,0.66l1.38,0.46l0.26,0.94l-1.21,0.05l-0.19,0.66l0.66,0.59l1.25,-0.16l0.52,0.26l0.4,-0.38l0.18,-1.95l-0.75,-3.33l0.41,-0.48l0.56,0.43l0.94,0.06l0.28,-0.57l-0.29,-0.44l0.48,-0.57l1.71,1.84l-0.0,1.41l0.62,0.9l-0.53,0.18l-0.25,0.47l0.9,1.14l-0.08,0.37l-0.42,0.55l-0.78,0.09l-0.91,-0.86l-0.32,0.33l0.13,1.26l-1.08,1.61l0.2,0.57l-0.32,0.22l-0.15,0.98l-0.74,0.55l0.1,0.91l-0.9,0.96l-1.06,0.21l-0.59,-0.37l-0.52,0.52l-0.93,-0.81l-0.86,0.1l-0.4,-0.82l-0.59,-0.21l-0.52,0.38l0.08,0.94l-0.52,0.22l-1.42,-1.25l1.31,-0.4l0.23,-0.88l-0.57,-0.42l-2.02,0.31l-1.14,1.01l0.29,0.67l0.44,0.16l0.09,0.82l0.35,0.25l-0.03,0.12l-0.57,-0.34l-1.69,0.83l-1.12,-0.43l-1.45,0.06l-3.32,-0.7l0.42,1.08l0.97,0.45l0.36,0.64l0.63,0.11l0.87,-0.32l1.68,0.63l2.35,0.39l3.51,0.11l0.47,0.42l-0.06,0.52l-0.99,0.05l-0.38,0.5l0.13,0.23l-1.62,1.44l0.32,0.58l1.85,0.01l-2.55,3.5l-1.67,0.04l-1.59,-0.98l-0.9,-0.19l-1.21,-1.02l-1.12,0.07l0.07,0.47l1.04,1.14l2.32,2.09l2.68,0.26l1.31,0.49l1.71,-2.16l0.51,0.47l1.17,0.33l0.4,-0.57l-0.55,-0.9l0.87,0.16l0.19,0.57l0.66,0.24l1.63,-1.2l-0.18,0.61l0.29,0.57l-0.29,0.38l-0.43,-0.2l-0.41,0.37l0.03,0.9l-0.97,1.72l0.01,0.78l-0.71,-0.07l-0.06,-0.74l-1.12,-0.61l-0.42,0.47l0.27,1.45l-0.52,-1.1l-0.65,-0.16l-1.22,1.08l-0.21,0.52l0.25,0.27l-2.03,0.32l-2.75,1.84l-0.67,-1.04l-0.75,-0.29l-0.37,0.49l0.43,1.26l-0.57,-0.01l-0.09,0.82l-0.94,1.73l-0.91,0.85l-0.59,-0.26l0.49,-0.69l-0.02,-0.77l-1.06,-0.93l-0.08,-0.52l-1.69,-0.41l-0.16,0.47l0.43,1.16l0.2,0.33l0.58,0.07l0.3,0.61l-0.88,0.37l-0.08,0.71l0.65,0.64l0.77,0.18l-0.01,0.37l-2.12,1.67l-1.92,2.65l-2.0,4.31l-0.34,2.13l0.12,1.34l-0.15,-1.03l-1.01,-1.59l-0.55,-0.17l-0.3,0.48l1.17,3.95l-0.63,2.27l-3.9,0.19l-1.43,0.65l-0.35,-0.52l-0.58,-0.18l-0.54,1.07l-1.9,1.14l-0.61,-0.02l-23.25,-15.36l-1.05,-0.02l-18.68,3.49l-0.65,-2.77l-3.25,-2.84l-0.47,0.08l-1.23,1.31l-0.01,-1.29l-0.82,-0.54l-22.82,3.35l-0.64,-0.27l-0.62,0.46l-0.25,0.65l-3.98,1.93l-0.89,1.23l-1.01,0.08l-4.78,2.66l-20.95,3.93l-0.34,-4.55l0.7,-0.95ZM817.0,271.48l0.19,0.35l0.24,0.39l-0.45,-0.41l0.02,-0.32ZM807.53,290.29l0.2,0.32l-0.16,-0.09l-0.03,-0.23ZM815.31,299.15l0.16,-0.36l0.16,0.07l-0.13,0.29l-0.19,0.01ZM812.76,299.11l-0.06,-0.28l-0.03,-0.11l0.3,0.26l-0.21,0.13ZM812.97,264.02l0.37,-0.24l0.15,0.42l-0.42,0.07l-0.1,-0.25ZM791.92,329.4l0.04,-0.08l0.22,0.03l-0.0,0.09l-0.26,-0.05Z",
                name: "North Carolina"
            },
            "US-ND": {
                path: "M438.54,42.78l2.06,6.9l-0.73,2.53l0.57,2.36l-0.27,1.17l0.47,1.99l0.01,3.26l1.42,3.95l0.45,0.54l-0.08,0.97l0.39,1.52l0.62,0.74l1.48,3.74l-0.06,3.9l0.42,0.7l0.5,8.35l0.51,1.54l0.51,0.25l-0.47,2.64l0.36,1.63l-0.14,1.75l0.69,1.1l0.2,2.16l0.49,1.13l1.8,2.56l0.15,2.2l0.51,1.08l0.17,1.39l-0.24,1.36l0.28,1.74l-27.89,0.73l-28.38,0.19l-28.38,-0.37l-28.49,-0.93l2.75,-65.47l23.08,0.78l25.57,0.42l25.57,-0.06l24.11,-0.49Z",
                name: "North Dakota"
            },
            "US-NE": {
                path: "M422.58,174.02l3.92,2.71l3.93,1.9l1.34,-0.22l0.51,-0.47l0.36,-1.08l0.48,-0.2l2.49,0.34l1.32,-0.47l1.58,0.25l3.45,-0.65l2.37,1.98l1.4,0.14l1.55,0.77l1.45,0.08l0.88,1.1l1.49,0.17l-0.06,0.98l1.68,2.08l3.32,0.6l0.19,0.68l-0.22,1.87l1.13,1.94l0.01,2.29l1.15,1.08l0.34,1.72l1.73,1.46l0.07,1.88l1.5,2.11l-0.49,2.33l0.44,3.09l0.52,0.54l0.94,-0.2l-0.04,1.25l1.21,0.5l-0.41,2.36l0.21,0.44l1.12,0.4l-0.6,0.77l-0.09,1.01l0.13,0.59l0.82,0.5l0.16,1.45l-0.26,0.92l0.26,1.27l0.55,0.61l0.3,1.93l-0.22,1.33l0.23,0.72l-0.57,0.92l0.02,0.79l0.45,0.88l1.23,0.63l0.25,2.5l1.1,0.51l0.03,0.79l1.18,2.75l-0.23,0.96l1.16,0.21l0.8,0.99l1.1,0.24l-0.15,0.96l1.31,1.68l-0.21,1.12l0.51,0.91l-26.15,1.05l-27.83,0.63l-27.84,0.14l-27.89,-0.35l0.46,-21.66l-0.39,-0.41l-32.36,-1.04l1.85,-43.24l43.36,1.22l44.67,-0.04Z",
                name: "Nebraska"
            },
            "US-LA": {
                path: "M508.97,412.97l-1.33,-21.76l51.44,-4.07l0.34,0.83l1.48,0.66l-0.92,1.35l-0.25,2.13l0.49,0.72l1.18,0.31l-1.21,0.47l-0.45,0.78l0.45,1.36l1.05,0.84l0.08,2.15l0.46,0.54l1.51,0.74l0.45,1.05l1.42,0.44l-0.87,1.22l-0.85,2.34l-0.75,0.04l-0.52,0.51l-0.02,0.73l0.63,0.72l-0.22,1.16l-1.35,0.96l-1.08,1.89l-1.37,0.67l-0.68,0.83l-0.79,2.42l-0.25,3.52l-1.55,1.74l0.13,1.21l0.62,0.96l-0.35,2.38l-1.61,0.29l-0.6,0.57l0.28,0.97l0.64,0.59l-0.26,1.41l0.98,1.51l-1.18,1.18l-0.08,0.45l0.4,0.23l6.18,-0.55l29.23,-2.92l-0.68,3.47l-0.52,1.02l-0.2,2.24l0.69,0.98l-0.09,0.66l0.6,1.0l1.31,0.7l1.22,1.42l0.14,0.88l0.89,1.39l0.14,1.05l1.11,1.84l-1.85,0.39l-0.38,-0.08l-0.01,-0.56l-0.53,-0.57l-1.28,0.28l-1.18,-0.59l-1.51,0.17l-0.61,-0.98l-1.24,-0.86l-2.84,-0.47l-1.24,0.63l-1.39,2.3l-1.3,1.42l-0.42,0.91l0.07,1.2l0.55,0.89l0.82,0.57l4.25,0.82l3.35,-1.0l1.32,-1.19l0.68,-1.19l0.34,0.59l1.08,0.43l0.59,-0.4l0.81,0.03l0.51,-0.46l-0.76,1.21l-1.12,-0.12l-0.57,0.32l-0.38,0.62l0.0,0.83l0.77,1.22l1.48,-0.02l0.65,0.89l1.1,0.48l0.94,-0.21l0.51,-0.45l0.46,-1.11l-0.02,-1.37l0.93,-0.58l0.42,-0.99l0.23,0.05l0.1,1.16l-0.24,0.25l0.18,0.57l0.43,0.15l-0.07,0.75l1.34,1.08l0.34,-0.16l-0.48,0.59l0.18,0.63l-0.35,0.13l-0.52,-0.57l-0.92,-0.19l-1.0,1.89l-0.85,0.14l-0.46,0.53l0.16,1.19l-1.6,-0.61l-0.43,0.19l0.04,0.46l1.14,1.06l-1.17,-0.14l-0.92,0.61l0.68,0.43l1.26,2.04l2.74,0.97l-0.08,1.2l0.34,0.41l2.07,-0.32l0.77,0.17l0.17,0.53l0.73,0.32l1.35,-0.34l0.53,0.78l1.08,-0.46l1.13,0.74l0.14,0.3l-0.4,0.62l1.54,0.86l-0.39,0.65l0.39,0.58l-0.18,0.62l-0.95,1.49l-1.3,-1.56l-0.68,0.34l0.1,0.66l-0.38,0.12l0.41,-1.88l-1.33,-0.76l-0.5,0.5l0.2,1.18l-0.54,0.45l-0.27,-1.02l-0.57,-0.25l-0.89,-1.27l0.03,-0.77l-0.96,-0.14l-0.47,0.5l-1.41,-0.17l-0.41,-0.61l0.14,-0.63l-0.39,-0.46l-0.45,-0.02l-0.81,0.73l-1.18,0.02l0.12,-1.23l-0.46,-0.88l-0.91,0.04l0.09,-0.96l-0.37,-0.36l-0.91,-0.03l-0.22,0.58l-0.85,-0.38l-0.48,0.27l-2.61,-1.26l-1.24,-0.03l-0.67,-0.64l-0.61,0.19l-0.3,0.56l-0.05,1.25l1.72,0.94l1.67,0.35l-0.16,0.92l0.28,0.39l-0.34,0.35l0.23,0.68l-0.76,0.95l-0.02,0.66l0.81,0.97l-0.95,1.43l-1.33,0.94l-0.76,-1.15l0.22,-1.5l-0.35,-0.92l-0.49,-0.18l-0.4,0.36l-1.15,-1.08l-0.59,0.42l-0.76,-1.05l-0.62,-0.2l-0.64,1.33l-0.85,0.26l-0.88,-0.53l-0.86,0.53l-0.1,0.62l0.48,0.41l-0.68,0.56l-0.13,1.44l-0.46,0.13l-0.39,0.83l-0.92,0.08l-0.11,-0.68l-1.6,-0.4l-0.77,0.97l-1.92,-0.93l-0.3,-0.54l-0.99,0.01l-0.35,0.6l-1.16,-0.51l0.42,-0.4l0.01,-1.46l-0.38,-0.57l-1.9,-1.19l-0.08,-0.54l-0.83,-0.72l-0.09,-0.91l0.73,-1.15l-0.34,-1.14l-0.87,-0.19l-0.34,0.57l0.16,0.43l-0.59,0.81l0.04,0.91l-1.8,-0.4l0.07,-0.39l-0.47,-0.54l-1.97,0.76l-0.7,-2.22l-1.32,0.23l-0.18,-2.12l-1.31,-0.35l-1.89,0.3l-1.09,0.65l-0.21,-0.71l0.84,-0.26l-0.05,-0.8l-0.6,-0.58l-1.03,-0.1l-0.85,0.42l-0.95,-0.15l-0.4,0.8l-2.0,1.11l-0.63,-0.31l-1.29,0.71l0.54,1.37l0.8,0.31l0.97,1.51l-1.39,0.19l-1.83,1.03l-3.69,-0.4l-1.24,0.21l-3.09,-0.45l-1.99,-0.68l-1.81,-1.07l-3.7,-1.1l-3.19,-0.48l-2.53,0.58l-5.62,0.45l-1.0,0.26l-1.82,1.25l-0.59,-0.63l-0.26,-1.08l1.59,-0.47l0.7,-1.76l-0.02,-1.55l-0.39,-0.56l1.11,-1.54l0.23,-1.59l-0.5,-1.83l0.07,-1.46l-0.66,-0.7l-0.21,-1.04l0.83,-2.22l-0.64,-1.95l0.76,-0.84l0.3,-1.49l0.78,-0.94l0.79,-2.83l-0.18,-1.42l0.58,-0.97l-0.75,-1.33l0.84,-0.39l0.2,-0.44l-0.89,-1.36l0.03,-2.13l-1.07,-0.23l-0.57,-1.57l-0.92,-0.84l0.28,-1.27l-0.81,-0.76l-0.33,-0.95l-0.64,-0.34l0.22,-0.98l-1.16,-0.58l-0.81,-0.93l0.16,-2.46l-0.68,-1.93l-1.33,-1.98l-2.63,-2.21ZM607.49,467.45l-0.03,-0.03l-0.07,-0.04l0.13,-0.01l-0.03,0.08ZM607.51,465.85l-0.02,-0.01l0.03,-0.01l-0.02,0.02ZM567.04,468.98l-2.0,-0.42l-0.66,-0.5l0.73,-0.43l0.35,-0.76l0.39,0.49l0.83,0.21l-0.15,0.61l0.5,0.81ZM550.39,463.0l1.73,-1.05l3.34,1.07l-0.69,0.56l-0.17,0.81l-0.68,0.17l-3.53,-1.57Z",
                name: "Louisiana"
            },
            "US-SD": {
                path: "M336.37,128.84l0.3,-0.53l0.75,-19.93l28.5,0.93l28.4,0.37l28.4,-0.19l27.78,-0.73l-0.18,1.71l-0.73,1.71l-2.9,2.46l-0.42,1.27l1.59,2.13l1.06,2.06l0.55,0.36l1.74,0.24l1.01,0.84l0.57,1.02l1.45,38.83l-1.84,0.09l-0.42,0.56l0.24,1.44l0.88,1.14l0.01,1.45l-0.65,0.36l0.17,1.48l0.48,0.43l1.09,0.04l0.34,1.68l-0.16,0.91l-0.62,0.83l0.02,1.73l-0.68,2.45l-0.49,0.44l-0.67,1.88l0.5,1.1l1.33,1.08l-0.16,0.62l0.64,0.66l0.35,1.15l-1.65,-0.28l-0.34,-0.94l-0.85,-0.73l0.19,-0.61l-0.28,-0.59l-1.58,-0.23l-1.03,-1.18l-1.57,-0.11l-1.51,-0.75l-1.34,-0.12l-2.38,-1.99l-3.78,0.6l-1.65,-0.25l-1.19,0.46l-2.62,-0.33l-0.98,0.48l-0.76,1.45l-0.72,0.05l-3.67,-1.82l-4.13,-2.8l-44.83,0.05l-43.33,-1.22l1.79,-43.2Z",
                name: "South Dakota"
            },
            "US-DC": {
                path: "M781.25,216.97l0.45,-0.77l2.04,1.26l-0.66,1.14l-0.55,-1.05l-1.28,-0.58Z",
                name: "District of Columbia"
            },
            "US-DE": {
                path: "M798.52,195.11l0.42,-1.51l0.92,-1.11l1.72,-0.71l1.12,0.06l-0.33,0.56l-0.08,1.38l-1.13,1.92l0.1,1.09l1.11,1.1l-0.07,1.52l2.29,2.48l1.25,0.6l0.93,1.52l0.99,3.35l1.72,1.57l0.57,1.32l3.06,1.99l1.44,-0.09l0.45,1.25l-1.06,0.56l0.16,1.32l0.36,0.19l-0.83,0.57l-0.08,1.21l0.66,0.21l0.85,-0.73l0.71,0.34l0.3,-0.21l0.75,1.55l-10.19,2.82l-8.12,-26.12Z",
                name: "Delaware"
            },
            "US-FL": {
                path: "M630.28,423.69l47.19,-6.86l1.53,1.91l0.87,2.72l1.47,1.0l48.79,-5.11l1.03,1.38l0.03,1.09l0.55,1.05l1.04,0.48l1.64,-0.28l0.85,-0.75l-0.14,-4.57l-0.98,-1.49l-0.22,-1.77l0.28,-0.74l0.62,-0.3l0.12,-0.7l5.6,0.96l4.03,-0.16l0.14,1.24l-0.75,-0.12l-0.33,0.43l0.25,1.54l2.11,1.81l0.22,1.01l0.42,0.38l0.29,1.92l1.87,3.29l1.7,4.87l0.73,0.84l0.51,1.5l1.64,2.46l0.64,1.57l2.79,3.71l1.93,3.18l2.29,2.77l0.16,0.6l0.63,0.36l6.82,7.53l-0.48,-0.03l-0.27,0.61l-1.35,-0.02l-0.34,-0.65l0.38,-1.38l-0.16,-0.56l-2.3,-0.92l-0.46,0.53l1.0,2.8l0.78,0.97l2.14,4.77l9.92,13.71l1.37,3.11l3.66,5.34l-1.38,-0.35l-0.43,0.74l0.8,0.65l0.85,0.24l0.56,-0.22l1.46,0.94l2.05,3.05l-0.5,0.34l-0.12,0.53l1.16,0.53l0.89,1.83l-0.08,1.06l0.59,0.95l0.61,2.64l-0.27,0.75l0.93,8.98l-0.31,1.07l0.46,0.67l0.5,3.1l-0.81,1.46l0.07,2.23l-0.84,0.74l-0.22,1.8l-0.48,0.85l0.21,1.47l-0.3,1.75l0.54,1.74l0.45,0.23l-1.15,1.8l-0.39,1.28l-0.94,0.24l-0.53,-0.22l-1.37,0.45l-0.35,1.06l-0.89,0.3l-0.18,0.58l-0.85,0.67l-1.44,0.14l-0.27,-0.32l-1.23,-0.1l-0.9,1.05l-3.17,1.13l-1.06,-0.59l-0.7,-1.04l0.06,-1.79l1.0,0.84l1.64,0.47l0.26,0.63l0.52,0.07l1.35,-0.72l0.2,-0.69l-0.26,-0.64l-1.58,-1.11l-2.4,-0.26l-0.91,-0.46l-0.85,-1.67l-0.89,-0.72l0.22,-0.98l-0.48,-0.28l-0.53,0.15l-1.38,-2.51l-0.44,-0.3l-0.64,0.07l-0.44,-0.61l0.22,-0.89l-0.7,-0.65l-1.21,-0.6l-1.06,-0.08l-0.75,-0.54l-0.57,0.18l-2.8,-0.59l-0.5,0.64l0.25,-0.91l-0.46,-0.42l-0.87,0.12l-0.26,-0.72l-0.88,-0.65l-0.61,-1.41l-0.55,-0.11l-0.72,-2.94l-0.77,-1.0l-0.16,-1.52l-0.44,-0.83l-0.71,-0.89l-0.49,-0.15l-0.12,0.93l-1.29,-0.26l1.06,-1.3l0.3,-0.75l-0.12,-0.63l0.86,-1.46l0.65,-0.34l0.28,-0.83l-0.61,-0.38l-1.42,0.93l-0.89,1.29l-0.42,2.17l-1.37,0.35l-0.21,-1.33l-0.79,-1.33l-0.27,-4.04l-0.86,-0.6l1.63,-1.33l0.22,-0.97l-0.58,-0.42l-3.06,1.92l-0.75,-0.66l-0.4,0.26l-1.27,-0.89l-0.37,0.74l1.13,1.09l0.52,0.1l1.26,2.0l-1.04,0.23l-1.42,-0.38l-0.84,-1.6l-1.13,-0.6l-1.94,-2.55l-1.04,-2.28l-1.28,-0.87l0.1,-0.87l-0.97,-1.8l-1.77,-0.98l0.09,-0.67l0.99,-0.41l-0.35,-0.49l0.44,-0.73l-0.39,-0.35l0.4,-1.21l2.47,-4.47l-1.05,-2.41l-0.68,-0.46l-0.92,0.42l-0.28,0.93l0.29,1.2l-0.24,0.03l-0.73,-2.44l-0.99,-0.28l-1.19,-0.87l-1.52,-0.31l0.29,1.95l-0.48,0.61l0.27,0.59l2.21,0.56l0.25,0.97l-0.37,2.46l-0.31,-0.58l-0.8,-0.22l-2.13,-1.53l-0.41,0.2l-0.29,-0.63l0.59,-2.11l0.07,-2.97l-0.66,-1.97l0.42,-0.51l0.48,-1.91l-0.24,-0.54l0.66,-3.04l-0.35,-5.26l-0.71,-1.7l0.35,-0.47l-0.47,-2.18l-2.1,-1.33l-0.05,-0.52l-0.55,-0.43l-0.1,-1.01l-0.92,-0.73l-0.55,-1.51l-0.64,-0.25l-1.44,0.32l-1.03,-0.2l-1.57,0.54l-1.14,-1.74l-1.51,-0.48l-0.19,-0.6l-1.35,-1.51l-0.87,-0.59l-0.62,0.07l-1.52,-1.16l-0.8,-0.21l-0.51,-2.75l-3.06,-1.13l-0.65,-0.59l-0.52,-1.23l-2.15,-1.93l-2.19,-1.09l-1.45,-0.12l-3.44,-1.68l-2.85,0.98l-1.0,-0.4l-1.05,0.42l-0.35,0.68l-1.33,0.68l-0.5,0.7l0.03,0.64l-0.73,-0.22l-0.59,0.6l0.67,0.94l1.51,0.08l0.41,0.21l-3.03,0.23l-1.58,1.51l-0.91,0.45l-1.3,1.56l-1.56,1.03l-0.32,0.13l0.2,-0.48l-0.26,-0.54l-0.66,-0.04l-0.96,0.75l-1.12,1.5l-2.2,0.23l-2.11,1.06l-0.78,0.03l-0.27,-2.03l-1.71,-2.23l-2.21,-1.0l-0.18,-0.41l-2.51,-1.5l2.79,1.33l1.21,-0.74l0.0,-0.74l-1.32,-0.34l-0.36,0.55l-0.21,-1.01l-0.34,-0.1l0.13,-0.52l-0.49,-0.33l-1.39,0.61l-2.3,-0.76l0.65,-1.08l0.83,-0.1l1.03,-1.45l-0.91,-0.95l-0.46,0.12l-0.49,1.02l-0.44,-0.04l-0.81,0.56l-0.72,-0.9l-0.7,0.09l-0.17,0.38l-1.34,0.73l-0.14,0.68l0.29,0.46l-3.95,-1.35l-5.05,-0.71l0.12,-0.24l1.27,0.29l0.61,-0.53l2.1,0.39l0.23,-0.78l-0.94,-1.02l0.09,-0.7l-0.63,-0.28l-0.5,0.32l-0.28,-0.47l-1.9,0.19l-2.25,1.1l0.3,-0.63l-0.41,-0.58l-0.96,0.35l-0.58,-0.25l-0.23,0.44l0.2,0.71l-1.45,0.8l-0.4,0.63l-5.18,0.97l0.32,-0.52l-0.4,-0.52l-1.35,-0.28l-0.72,-0.53l0.69,-0.53l0.01,-0.78l-0.68,-0.13l-0.81,-0.66l-0.46,0.11l0.14,0.76l-0.42,1.77l-1.05,-1.39l-0.69,-0.45l-0.55,0.07l-0.3,0.71l0.82,1.77l-0.25,0.79l-1.39,0.99l-0.05,1.04l-0.6,0.22l-0.17,0.57l-1.48,0.56l0.28,-0.65l-0.21,-0.46l1.14,-1.03l0.07,-0.74l-0.4,-0.58l-1.19,-0.24l-0.41,-0.84l0.3,-1.7l-0.18,-1.61l-2.17,-1.12l-2.39,-2.46l0.32,-1.44l-0.15,-1.04ZM767.29,490.44l0.48,1.07l0.9,0.39l0.78,-0.15l1.41,1.67l0.91,0.58l1.86,0.69l1.61,0.07l0.55,-0.44l-0.08,-0.87l0.55,-0.65l-0.16,-1.21l0.76,-1.36l0.09,-1.81l-0.64,-1.62l-1.46,-2.01l-1.74,-1.32l-1.19,-0.13l-1.12,0.83l-1.83,3.16l-2.12,1.94l-0.13,0.77l0.57,0.41ZM644.36,434.13l-0.94,0.26l0.41,-0.44l0.53,0.18ZM665.13,435.7l0.98,-0.28l0.35,0.32l0.09,0.72l-1.42,-0.75ZM770.56,455.01l0.42,0.56l-0.43,0.75l0.0,-1.31ZM788.88,525.23l0.01,-0.07l0.01,0.03l-0.03,0.04ZM789.47,522.87l-0.22,-0.23l0.49,-0.32l-0.27,0.55ZM768.83,453.61l0.21,0.76l-0.31,2.33l0.28,1.79l-1.38,-3.23l1.19,-1.65ZM679.81,445.61l0.22,-0.2l0.36,0.02l-0.11,0.42l-0.47,-0.25Z",
                name: "Florida"
            },
            "US-WA": {
                path: "M38.52,55.26l0.46,-1.32l0.18,0.45l0.65,0.3l1.04,-0.74l0.43,0.59l0.7,-0.03l0.17,-0.77l-0.92,-1.56l0.79,-0.74l-0.09,-1.36l0.49,-0.39l-0.1,-1.03l0.81,-0.27l0.05,0.5l0.48,0.41l0.95,-0.31l-0.09,-0.68l-1.35,-1.65l-0.9,0.15l-1.88,-0.56l0.17,-1.98l0.66,0.53l0.52,-0.07l0.29,-0.56l-0.16,-0.67l3.3,-0.52l0.26,-0.69l-1.7,-0.96l-0.86,-0.14l-0.37,-1.51l-0.7,-0.42l-0.81,-0.02l0.32,-4.73l-0.49,-1.28l0.1,-0.69l-0.4,-0.34l0.76,-5.74l-0.13,-2.46l-0.45,-0.62l-0.16,-1.36l-0.65,-1.33l-0.73,-0.57l-0.32,-2.45l0.35,-2.27l-0.15,-1.11l1.74,-3.3l-0.52,-1.23l4.59,3.9l1.19,0.38l0.92,0.75l0.81,1.3l1.86,1.08l3.24,0.91l0.84,0.77l1.42,0.11l1.73,1.02l2.33,0.73l1.46,-0.47l0.52,0.29l0.55,0.69l-0.03,1.09l0.55,0.74l0.31,0.11l0.49,-0.35l0.07,-0.75l0.45,0.03l0.63,1.39l-0.4,0.58l0.34,0.49l0.56,-0.04l0.72,-0.84l-0.38,-1.7l1.03,-0.24l-0.44,0.23l-0.21,0.69l1.27,4.41l-0.46,0.1l-1.67,1.73l0.22,-1.29l-0.22,-0.41l-1.31,0.31l-0.38,0.81l0.09,0.95l-1.37,1.7l-1.98,1.38l-1.06,1.41l-0.96,0.69l-1.1,1.67l-0.06,0.71l0.62,0.6l0.96,0.12l2.77,-0.48l1.22,-0.58l-0.03,-0.7l-0.64,-0.23l-2.94,0.79l-0.35,-0.3l3.23,-3.42l3.06,-0.88l0.89,-1.51l1.73,-1.54l0.53,0.57l0.54,-0.19l0.22,-1.81l-0.06,2.25l0.26,0.91l-0.99,-0.21l-0.64,0.77l-0.41,-0.73l-0.52,-0.19l-0.39,0.64l0.3,0.71l0.02,1.63l-0.21,-1.07l-0.67,-0.21l-0.47,0.69l-0.07,0.75l0.46,0.66l-0.63,0.58l-0.0,0.45l0.42,0.17l1.68,-0.57l0.25,1.09l-1.08,1.79l-0.08,1.05l-0.83,0.7l0.13,1.0l-0.85,-0.68l1.12,-1.44l-0.23,-0.96l-1.96,1.08l-0.38,0.64l-0.05,-2.11l-0.52,0.02l-1.03,1.59l-1.26,0.53l-1.14,1.87l-1.51,0.3l-0.46,0.43l-0.21,1.18l1.11,-0.03l-0.25,0.36l0.27,0.37l0.93,0.02l0.06,0.68l0.53,0.47l0.52,-0.27l0.35,-1.76l0.14,0.42l0.83,-0.15l1.11,1.48l1.31,-0.61l1.65,-1.48l0.98,-1.56l0.63,0.78l0.73,0.14l0.44,-0.23l-0.06,-0.86l1.56,-0.55l0.35,-0.94l-0.33,-1.27l0.22,-1.19l-0.18,-1.36l0.83,0.2l0.3,-0.92l-0.19,-0.75l-0.72,-0.63l0.89,-1.13l0.07,-1.75l1.24,-1.24l0.61,-1.37l1.61,-0.49l0.78,-1.16l-0.45,-0.66l-0.51,-0.02l-0.86,-1.3l0.16,-2.09l-0.26,-0.87l0.49,-0.79l0.06,-0.84l-1.15,-1.73l-0.63,-0.4l-0.17,-0.64l0.18,-0.5l0.59,0.23l0.53,-0.33l0.24,-1.8l0.79,-0.24l0.3,-1.0l-0.61,-2.32l0.44,-0.53l-0.03,-0.86l-0.96,-0.88l-0.95,0.3l-1.09,-2.66l0.93,-1.83l41.31,9.4l38.96,7.65l-9.66,54.39l-0.47,1.02l1.04,3.0l0.13,2.0l-1.0,1.3l0.73,1.88l-31.18,-5.92l-1.67,0.79l-7.24,-1.02l-1.68,0.92l-4.19,-0.12l-3.18,0.45l-1.64,0.75l-0.88,-0.26l-1.2,0.3l-1.51,-0.23l-2.43,-0.94l-0.91,0.46l-3.45,0.51l-2.11,-0.71l-1.65,0.3l-0.31,-1.36l-1.09,-0.88l-4.34,-1.46l-2.32,-0.11l-1.15,-0.51l-1.27,0.21l-1.89,0.86l-4.5,0.58l-1.11,-0.71l-1.15,-0.3l-1.61,-1.15l-1.84,-0.51l-0.63,-0.81l0.64,-6.82l-0.47,-0.95l-0.22,-1.9l-0.98,-1.35l-1.96,-1.67l-2.82,-0.11l-1.03,-1.31l-0.15,-1.05l-0.56,-0.63l-2.36,-0.31l-0.56,-0.3l-0.24,-0.79l-0.5,-0.18l-0.97,0.35l-0.84,-0.26l-1.1,0.4l-0.97,-1.47l-0.89,-0.22ZM61.85,39.78l0.16,0.74l-0.42,0.49l0.0,-0.91l0.26,-0.31ZM71.27,20.38l-0.61,0.87l-0.15,0.52l0.11,-1.01l0.65,-0.38ZM71.14,15.62l-0.09,-0.05l0.05,-0.04l0.04,0.1ZM70.37,15.48l-0.77,0.39l0.37,-0.68l-0.07,-0.6l0.22,-0.07l0.25,0.97ZM57.56,42.45l0.05,-0.02l-0.01,0.01l-0.04,0.02ZM67.75,19.23l1.73,-2.1l0.47,-0.02l0.53,1.71l-0.35,-0.55l-0.51,-0.12l-0.55,0.44l-0.35,-0.09l-0.35,0.73l-0.63,-0.01ZM67.87,20.4l0.44,0.0l0.61,0.5l0.08,0.35l-0.79,-0.2l-0.33,-0.65ZM68.84,23.16l-0.1,0.51l-0.0,0.0l-0.02,-0.24l0.12,-0.28ZM69.15,25.42l0.08,0.04l0.12,-0.04l-0.16,0.11l-0.05,-0.1ZM69.52,25.33l0.48,-0.93l1.02,1.21l0.11,1.12l-0.34,0.36l-0.34,-0.09l-0.27,-1.55l-0.67,-0.12ZM66.34,9.97l0.48,-0.34l0.18,1.51l-0.22,-0.05l-0.44,-1.12ZM68.04,9.66l0.83,0.8l-0.65,0.31l-0.18,-1.11ZM66.69,38.03l0.34,-1.07l0.21,-0.25l-0.03,1.07l-0.52,0.26ZM66.99,33.31l0.1,-1.04l0.35,-0.34l-0.23,1.56l-0.22,-0.18ZM66.51,14.27l-0.41,-0.4l0.6,-0.75l-0.18,0.61l-0.01,0.55ZM66.68,14.62l0.4,0.2l-0.08,0.12l-0.29,-0.12l-0.03,-0.2ZM66.74,12.96l-0.01,-0.1l0.05,-0.12l-0.04,0.23ZM64.36,13.12l-1.06,-0.82l0.19,-1.81l1.33,1.92l-0.35,0.18l-0.11,0.54ZM62.18,42.55l0.23,-0.25l0.02,0.01l-0.13,0.31l-0.12,-0.07ZM60.04,40.3l-0.09,-0.19l0.04,-0.07l0.0,0.13l0.05,0.14Z",
                name: "Washington"
            },
            "US-KS": {
                path: "M477.9,239.67l0.44,0.63l0.76,0.18l1.04,0.8l2.19,-1.08l-0.0,0.75l1.08,0.79l0.23,1.44l-0.95,-0.15l-0.6,0.31l-0.17,0.97l-1.14,1.37l-0.06,1.14l-0.79,0.5l0.04,0.64l1.56,2.1l2.0,1.49l0.2,1.13l0.42,0.86l0.74,0.56l0.32,1.11l1.89,0.91l1.54,0.26l2.67,46.82l-31.55,1.48l-31.97,0.88l-31.98,0.26l-32.05,-0.37l1.21,-65.47l27.9,0.35l27.86,-0.14l27.85,-0.64l27.68,-1.12l1.65,1.23Z",
                name: "Kansas"
            },
            "US-WI": {
                path: "M598.7,107.43l0.83,-0.15l-0.13,0.81l-0.56,0.01l-0.14,-0.68ZM594.22,116.05l0.47,-0.41l0.26,-2.36l0.95,-0.25l0.64,-0.69l0.22,-1.4l0.41,-0.63l0.63,-0.03l0.06,0.38l-0.76,0.06l-0.18,0.51l0.17,1.27l-0.38,0.17l-0.11,0.58l0.56,0.57l-0.24,0.65l-0.5,0.33l-0.69,1.91l0.07,1.23l-1.05,2.28l-0.41,0.15l-0.86,-0.97l-0.19,-0.72l0.31,-1.57l0.62,-1.05ZM510.06,124.08l0.41,-0.27l0.28,-0.9l-0.45,-1.48l0.04,-1.91l0.7,-1.16l0.53,-2.25l-1.61,-2.91l-0.83,-0.36l-1.28,-0.01l-0.21,-2.31l1.67,-2.26l-0.05,-0.77l0.77,-1.55l1.95,-1.09l0.48,-0.75l0.97,-0.25l0.45,-0.75l1.16,-0.14l1.04,-1.56l-0.97,-12.11l1.03,-0.35l0.22,-1.1l0.73,-0.97l0.78,0.69l1.68,0.64l2.61,-0.56l3.28,-1.57l2.65,-0.82l2.21,-2.12l0.31,0.29l1.39,-0.11l1.25,-1.48l0.79,-0.58l1.04,-0.1l0.4,-0.52l1.07,0.99l-0.48,1.68l-0.67,1.01l0.23,1.61l-1.21,2.21l0.64,0.66l2.5,-1.09l0.72,-0.86l2.16,1.22l2.34,0.47l0.44,0.54l0.86,-0.13l1.6,0.7l2.23,3.54l15.48,2.52l4.65,1.96l1.68,-0.17l1.63,0.42l1.33,-0.59l3.17,0.71l2.18,0.09l0.85,0.41l0.56,0.89l-0.42,1.09l0.41,0.77l3.4,0.63l1.41,1.13l-0.16,0.71l0.59,1.11l-0.36,0.81l0.43,1.25l-0.78,1.25l-0.03,1.76l0.91,0.63l1.38,-0.26l1.02,-0.72l0.2,0.26l-0.79,2.44l0.04,1.31l1.32,1.46l0.84,0.35l-0.24,2.02l-2.42,1.2l-0.51,0.79l0.04,1.26l-1.61,3.49l-0.4,3.5l1.11,0.82l0.92,-0.04l0.5,-0.36l0.49,-1.37l1.82,-1.47l0.66,-2.53l1.06,-1.7l0.14,0.25l0.45,-0.07l0.57,-0.7l0.88,-0.4l1.12,1.12l0.59,0.19l-0.29,2.21l-1.18,2.82l-0.56,5.58l0.23,1.11l0.8,0.93l0.07,0.52l-0.51,0.98l-1.3,1.34l-0.86,3.89l0.15,2.57l0.72,1.2l0.06,1.24l-1.07,3.22l0.12,2.12l-0.73,2.11l-0.28,2.47l0.59,2.02l-0.04,1.32l0.49,0.54l-0.21,1.7l0.92,0.78l0.54,2.43l1.2,1.54l0.08,1.69l-0.33,1.45l0.47,2.95l-44.2,4.6l-0.19,-0.79l-1.56,-2.19l-4.94,-0.84l-1.06,-1.35l-0.36,-1.69l-0.9,-1.21l-0.86,-4.9l1.04,-2.62l-0.09,-0.99l-0.71,-0.79l-1.44,-0.48l-0.71,-1.76l-0.47,-6.02l-0.7,-1.4l-0.52,-2.56l-1.15,-0.6l-1.1,-1.56l-0.93,-0.11l-1.17,-0.75l-1.71,0.09l-2.67,-1.79l-2.3,-3.5l-2.64,-2.1l-2.94,-0.53l-0.73,-1.24l-1.12,-1.0l-3.12,-0.45l-3.53,-2.74l0.45,-1.24l-0.12,-1.61l0.25,-0.81l-0.88,-3.11ZM541.58,78.25l0.05,-0.28l0.03,0.16l-0.08,0.12ZM537.91,83.72l0.28,-0.21l0.05,0.08l-0.33,0.12Z",
                name: "Wisconsin"
            },
            "US-OR": {
                path: "M10.69,140.12l0.01,-1.77l0.5,-0.84l0.32,-1.95l1.12,-1.91l0.24,-1.9l-0.72,-2.57l-0.33,-0.15l-0.12,-1.81l3.04,-3.82l2.5,-5.98l0.01,0.77l0.52,0.52l0.49,-0.28l0.6,-1.6l0.47,-0.48l0.31,0.98l1.12,0.41l0.33,-0.54l-0.45,-1.76l0.27,-0.87l-0.45,-0.14l-0.79,0.32l1.74,-3.16l1.13,-0.96l0.89,0.3l0.49,-0.29l-0.47,-1.08l-0.81,-0.4l1.77,-4.63l0.47,-0.57l0.02,-0.99l1.08,-2.67l0.62,-2.6l1.04,-1.92l0.33,0.28l0.66,-0.33l-0.04,-0.6l-0.76,-0.62l1.06,-2.6l0.32,0.22l0.59,-0.19l0.13,-0.35l-0.04,-0.51l-0.57,-0.32l0.85,-3.84l1.23,-1.8l0.83,-3.04l1.14,-1.76l0.83,-2.45l0.26,-1.21l-0.18,-0.5l1.19,-1.08l-0.32,-1.64l0.96,0.57l0.78,-0.63l-0.39,-0.75l0.2,-0.65l-0.77,-0.77l0.51,-1.07l1.3,-0.86l0.06,-0.46l-0.93,-0.34l-0.33,-1.25l0.97,-2.14l-0.04,-1.48l0.86,-0.53l0.58,-1.33l0.18,-1.96l-0.21,-1.45l0.83,1.17l0.6,0.18l-0.11,0.89l0.55,0.53l0.83,-0.96l-0.27,-0.99l0.21,-0.07l0.24,0.56l0.69,0.32l1.51,0.04l0.37,-0.36l1.37,-0.19l0.99,2.08l2.43,0.92l1.25,-0.64l0.78,0.04l1.72,1.51l0.77,1.04l0.21,1.9l0.43,0.78l-0.03,2.05l-0.39,1.24l0.19,0.93l-0.43,1.74l0.26,1.45l0.79,0.85l1.94,0.56l1.44,1.05l1.36,0.41l1.04,0.69l4.98,-0.53l2.9,-1.06l1.14,0.51l2.23,0.09l4.24,1.43l0.69,0.54l0.19,1.15l0.57,0.58l1.86,-0.27l2.11,0.71l3.79,-0.55l0.69,-0.42l2.19,0.93l1.64,0.24l1.2,-0.3l0.88,0.26l1.89,-0.78l3.07,-0.43l4.16,0.13l1.61,-0.91l7.17,1.02l0.96,-0.19l0.79,-0.58l31.27,5.93l0.23,1.81l0.93,1.82l1.16,0.63l1.96,1.86l0.57,2.45l-0.16,1.0l-3.69,4.55l-0.4,1.41l-1.39,2.63l-2.21,2.42l-0.65,2.68l-1.49,1.84l-2.23,1.5l-1.92,3.35l-1.49,1.27l-0.62,2.02l-0.12,1.87l0.28,0.92l0.56,0.61l0.54,0.04l0.39,-0.35l0.63,0.76l0.89,-0.05l0.07,0.88l0.81,0.95l-0.46,1.0l-0.65,0.06l-0.33,0.4l0.21,1.8l-1.03,2.56l-1.22,1.41l-6.86,39.16l-26.21,-4.99l-28.9,-6.05l-28.8,-6.61l-28.95,-7.24l-1.48,-2.59l0.2,-2.36l-0.23,-0.89Z",
                name: "Oregon"
            },
            "US-KY": {
                path: "M583.02,306.59l0.35,-2.18l1.13,0.96l0.72,0.2l0.75,-0.36l0.46,-0.88l0.87,-3.55l-0.54,-1.75l0.38,-0.86l-0.1,-1.88l-1.27,-2.04l1.79,-3.21l1.24,-0.51l0.73,0.06l7.03,2.56l0.81,-0.2l0.65,-0.72l0.24,-1.93l-1.49,-2.14l-0.24,-1.44l0.2,-0.87l0.4,-0.52l1.1,-0.18l1.24,-0.83l3.0,-0.95l0.64,-0.51l0.15,-1.13l-1.53,-2.05l-0.08,-0.68l1.33,-1.97l0.14,-1.16l1.25,0.42l1.12,-1.33l-0.68,-2.0l1.92,0.9l1.72,-0.84l0.03,1.18l1.0,0.46l0.99,-0.94l0.02,-1.36l0.51,0.16l1.9,-0.96l4.41,1.52l0.64,0.94l0.86,0.18l0.59,-0.59l0.73,-2.53l1.38,-0.55l1.39,-1.34l0.86,1.29l0.77,0.42l1.16,-0.13l0.11,0.75l0.95,0.19l0.67,-0.62l0.03,-1.01l0.84,-0.38l0.26,-0.48l-0.25,-2.09l0.84,-0.4l0.34,-0.56l-0.06,-0.69l1.25,-0.56l0.34,-0.72l0.38,1.47l0.61,0.6l1.46,0.64l1.25,-0.0l1.11,0.81l0.53,-0.11l0.26,-0.55l1.1,-0.46l0.53,-0.69l0.04,-3.48l0.85,-2.18l1.02,0.18l1.55,-1.19l0.75,-3.46l1.04,-0.37l1.65,-2.23l0.0,-0.81l-1.18,-2.88l2.78,-0.59l1.54,0.81l3.85,-2.82l2.23,-0.46l-0.18,-1.07l0.36,-1.47l-0.32,-0.36l-1.22,-0.04l0.58,-1.39l-1.09,-1.54l1.65,-1.83l1.81,1.18l0.92,-0.11l1.93,-1.01l0.78,0.88l1.76,0.54l0.57,1.28l0.94,0.92l0.79,1.84l2.6,0.67l1.87,-0.57l1.63,0.27l2.18,1.85l0.96,0.43l1.28,-0.18l0.61,-1.31l0.99,-0.54l1.35,0.5l1.34,0.04l1.33,1.09l1.26,-0.69l1.41,-0.15l1.81,-2.55l1.72,-1.03l0.92,2.35l0.7,0.83l2.45,0.81l1.35,0.97l0.75,1.05l0.93,3.35l-0.37,0.45l0.09,0.72l-0.44,0.61l0.02,0.53l2.24,2.62l1.35,0.92l-0.08,0.89l1.34,0.97l0.58,1.36l1.55,1.2l0.98,1.62l2.14,0.84l1.09,1.12l2.14,0.25l-4.86,6.13l-5.06,4.16l-0.42,0.86l0.22,1.25l-2.07,1.93l0.04,1.64l-3.06,1.63l-0.8,2.38l-1.71,0.6l-2.7,1.83l-1.66,0.48l-3.39,2.42l-23.95,3.09l-8.8,1.42l-7.47,0.86l-7.68,0.46l-22.71,3.52l-0.64,-0.56l-3.63,0.09l-0.41,0.6l1.03,3.57l-23.0,2.73ZM580.9,306.78l-0.59,0.08l-0.06,-0.55l0.47,-0.01l0.18,0.49Z",
                name: "Kentucky"
            },
            "US-CO": {
                path: "M364.18,239.57l-1.22,65.87l-29.29,-0.9l-29.38,-1.43l-29.35,-1.95l-32.17,-2.75l8.33,-87.15l27.79,2.4l28.23,1.92l29.58,1.46l27.95,0.87l-0.46,21.66Z",
                name: "Colorado"
            },
            "US-OH": {
                path: "M664.99,178.81l1.67,0.47l1.04,-0.3l1.74,1.07l2.07,0.26l1.47,1.18l1.71,0.23l-2.19,1.18l-0.12,0.47l0.42,0.24l2.46,0.19l1.39,-1.1l1.77,-0.25l3.39,0.96l0.92,-0.08l1.48,-1.29l1.74,-0.6l1.15,-0.96l1.91,-0.97l2.62,-0.03l1.09,-0.62l1.24,-0.06l1.07,-0.8l4.24,-5.46l4.53,-3.47l6.92,-4.36l5.83,28.05l-0.51,0.54l-1.28,0.43l-0.41,0.95l1.65,2.24l0.02,2.11l0.41,0.26l0.31,0.94l-0.04,0.76l-0.54,0.83l-0.5,4.08l0.18,3.21l-0.58,0.41l0.34,1.11l-0.35,1.74l-0.39,0.54l0.76,1.23l-0.25,1.87l-2.41,2.65l-0.82,1.86l-1.37,1.5l-1.24,0.67l-0.6,0.7l-0.87,-0.92l-1.18,0.14l-1.32,1.74l-0.09,1.32l-1.78,0.85l-0.78,2.25l0.28,1.58l-0.94,0.85l0.3,0.67l0.63,0.41l0.27,1.3l-0.8,0.17l-0.5,1.6l0.06,-0.93l-0.91,-1.26l-1.53,-0.55l-1.07,0.71l-0.82,1.98l-0.34,2.69l-0.53,0.82l1.22,3.58l-1.27,0.39l-0.28,0.42l-0.25,3.12l-2.66,1.2l-1.0,0.05l-0.76,-1.06l-1.51,-1.1l-2.34,-0.73l-1.17,-1.92l-0.31,-1.14l-0.42,-0.33l-0.73,0.13l-1.84,1.17l-1.1,1.29l-0.4,1.05l-1.43,0.15l-0.87,0.61l-1.11,-1.0l-3.14,-0.59l-1.37,0.72l-0.53,1.25l-0.71,0.05l-3.04,-2.26l-1.93,-0.29l-1.77,0.56l-2.14,-0.52l-0.55,-1.54l-0.96,-0.97l-0.63,-1.38l-2.03,-0.76l-1.14,-1.01l-0.97,0.26l-1.31,0.89l-0.46,0.03l-1.79,-1.23l-0.61,0.2l-0.6,0.71l-8.53,-55.69l20.43,-4.26ZM675.61,181.34l0.53,-0.79l0.67,0.41l-0.48,0.35l-0.72,0.03ZM677.31,180.77l0.01,-0.0l0.01,-0.0l-0.02,0.0Z",
                name: "Ohio"
            },
            "US-OK": {
                path: "M399.06,359.31l-0.05,-42.03l-0.39,-0.4l-26.69,-0.22l-25.13,-0.6l0.31,-10.23l36.7,0.74l36.0,-0.07l35.99,-0.86l35.56,-1.62l0.6,10.68l4.55,24.34l1.41,37.88l-1.2,-0.22l-0.29,-0.36l-2.13,-0.21l-0.82,-0.79l-2.11,-0.39l-1.77,-2.05l-1.23,-0.22l-2.25,-1.57l-1.5,-0.4l-0.8,0.46l-0.23,0.88l-0.82,0.24l-0.46,0.62l-2.47,-0.14l-0.47,-0.19l-0.27,-0.68l-1.05,-0.61l-2.3,1.29l-1.17,0.2l-0.19,0.56l-0.63,0.28l-2.12,-0.77l-1.7,1.18l-1.17,0.08l-0.89,0.42l-0.83,1.37l-1.48,0.06l-0.57,1.25l-1.26,-1.55l-1.7,-0.1l-0.32,-0.58l-1.21,-0.46l-0.02,-0.96l-0.44,-0.5l-1.24,-0.18l-0.73,1.38l-0.66,0.11l-0.84,-0.5l-0.97,0.07l-0.71,-1.51l-1.09,-0.35l-1.17,0.57l-0.45,1.7l-0.7,-0.08l-0.49,0.43l0.29,0.73l-0.51,1.68l-0.43,0.19l-0.55,-0.55l-0.3,-0.91l0.39,-1.65l-0.75,-0.86l-0.8,0.18l-0.49,0.76l-0.84,-0.18l-0.92,0.98l-1.07,0.13l-0.53,-1.36l-1.99,-0.19l-0.3,-1.48l-1.19,-0.53l-0.82,0.33l-2.12,2.15l-1.21,0.51l-0.97,-0.38l0.19,-1.25l-0.28,-1.13l-2.33,-0.68l-0.07,-2.18l-0.43,-0.55l-2.11,0.39l-2.52,-0.25l-0.64,0.26l-0.81,1.21l-0.95,0.06l-1.77,-1.77l-0.97,-0.12l-1.5,0.56l-2.68,-0.63l-1.86,-1.0l-1.05,0.25l-2.46,-0.3l-0.17,-2.12l-0.85,-0.87l-0.44,-1.02l-1.16,-0.41l-0.7,-0.83l-0.83,0.08l-0.44,1.64l-2.22,-0.68l-1.07,0.6l-0.96,-0.09l-3.79,-3.78l-1.12,-0.43l-0.8,0.08Z",
                name: "Oklahoma"
            },
            "US-WV": {
                path: "M693.03,248.42l3.95,-1.54l0.35,-0.71l0.12,-2.77l1.15,-0.22l0.4,-0.61l-0.57,-2.49l-0.61,-1.24l0.49,-0.64l0.36,-2.77l0.68,-1.66l0.45,-0.39l1.24,0.55l0.41,0.71l-0.14,1.13l0.71,0.46l0.78,-0.44l0.48,-1.42l0.49,0.21l0.57,-0.2l0.2,-0.44l-0.63,-2.09l-0.75,-0.55l0.81,-0.79l-0.26,-1.71l0.74,-2.0l1.65,-0.51l0.17,-1.6l1.02,-1.42l0.43,-0.08l0.65,0.79l0.67,0.19l2.28,-1.59l1.5,-1.64l0.79,-1.83l2.45,-2.67l0.37,-2.41l-0.73,-1.0l0.71,-2.33l-0.25,-0.76l0.59,-0.58l-0.27,-3.43l0.47,-3.93l0.53,-0.8l0.08,-1.11l-0.38,-1.21l-0.39,-0.33l-0.04,-2.01l-1.57,-1.91l0.44,-0.54l0.85,-0.1l0.3,-0.33l4.03,19.34l0.47,0.31l16.6,-3.55l2.17,10.68l0.5,0.37l2.06,-2.5l0.97,-0.56l0.34,-1.03l1.63,-1.99l0.25,-1.05l0.52,-0.4l1.19,0.45l0.74,-0.32l1.32,-2.6l0.6,-0.46l-0.04,-0.85l0.42,0.59l1.81,0.52l3.2,-0.57l0.78,-0.86l0.07,-1.46l2.0,-0.74l1.02,-1.69l0.67,-0.1l3.16,1.5l1.81,-0.71l-0.45,1.02l0.56,0.92l1.27,0.42l0.09,0.96l1.13,0.43l0.09,1.2l0.33,0.42l-0.58,3.64l-9.0,-4.48l-0.64,0.24l-0.31,1.14l0.38,1.61l-0.52,1.62l0.41,2.28l-1.36,2.4l-0.42,1.76l-0.72,0.53l-0.42,1.11l-0.27,0.21l-0.61,-0.23l-0.37,0.33l-1.25,3.28l-1.84,-0.78l-0.64,0.25l-0.94,2.77l0.08,1.47l-0.73,1.14l-0.19,2.33l-0.89,2.2l-3.25,-0.36l-1.44,-1.76l-1.71,-0.24l-0.5,0.41l-0.26,2.17l0.19,1.3l-0.32,1.45l-0.49,0.45l-0.31,1.04l0.23,0.92l-1.58,2.44l-0.04,2.1l-0.52,2.0l-2.58,4.73l-0.75,3.16l0.14,0.76l1.14,0.55l-1.08,1.38l0.06,0.6l0.45,0.4l-2.16,2.13l-0.55,-0.7l-0.84,0.15l-3.12,2.53l-1.03,-0.56l-1.32,0.26l-0.44,0.91l0.45,1.17l-0.91,0.91l-0.73,-0.05l-2.27,1.0l-1.21,0.96l-2.18,-1.36l-0.73,-0.01l-0.82,1.58l-1.1,0.49l-1.22,1.46l-1.08,0.08l-1.98,-1.09l-1.31,-0.01l-0.61,-0.74l-1.19,-0.6l-0.31,-1.33l-0.89,-0.55l0.36,-0.67l-0.3,-0.81l-0.85,-0.37l-0.84,0.25l-1.33,-0.17l-1.26,-1.19l-2.06,-0.79l-0.76,-1.43l-1.58,-1.24l-0.7,-1.49l-1.0,-0.6l-0.12,-1.09l-1.38,-0.95l-2.0,-2.27l0.71,-2.03l-0.25,-1.62l-0.66,-1.46Z",
                name: "West Virginia"
            },
            "US-WY": {
                path: "M218.53,207.02l10.1,-86.6l25.46,2.74l26.8,2.4l26.83,1.91l27.85,1.46l-3.67,87.11l-27.32,-1.41l-28.21,-1.97l-29.69,-2.63l-28.14,-3.02Z",
                name: "Wyoming"
            },
            "US-UT": {
                path: "M178.67,180.38l41.53,5.44l-2.51,21.5l0.35,0.45l32.24,3.43l-8.33,87.15l-42.54,-4.67l-42.41,-5.77l16.08,-108.34l5.58,0.82ZM187.74,191.46l-0.3,0.04l-0.25,0.62l0.74,3.68l-0.81,0.19l-0.5,1.31l1.15,0.59l0.35,-0.84l0.37,-0.18l0.92,1.14l0.83,1.68l-0.25,1.0l0.16,1.45l-0.4,0.77l0.4,0.52l-0.05,0.56l1.58,1.84l0.02,0.59l1.13,1.92l0.71,-0.1l0.83,-1.74l0.08,2.28l0.53,0.94l0.06,1.8l0.99,0.47l1.65,-0.67l2.48,-1.77l0.37,-1.25l3.32,-1.44l0.17,-0.54l-0.52,-1.02l-0.68,-0.84l-1.36,-0.7l-1.87,-4.59l-0.87,-0.46l0.87,-0.92l1.3,0.6l1.33,-0.15l0.92,-0.83l-0.06,-1.12l-1.55,-0.5l-0.81,0.42l-1.17,-0.12l0.27,-0.76l-0.58,-0.79l-1.86,-0.22l-0.56,1.13l0.28,0.78l-0.35,0.69l0.55,2.44l-0.91,0.32l-0.34,-0.42l0.22,-1.8l-0.42,-0.69l-0.06,-1.74l-0.68,-0.6l-1.32,-0.11l-1.07,-1.55l-0.19,-0.69l0.64,-0.55l0.36,-1.29l-0.83,-1.38l-1.23,-0.28l-0.99,0.81l-2.73,0.2l-0.35,0.63l0.62,0.83l-0.28,0.43ZM199.13,204.0l0.03,0.02l0.04,0.11l-0.07,-0.13ZM199.17,204.81l0.31,0.91l-0.18,0.9l-0.39,-0.93l0.25,-0.88Z",
                name: "Utah"
            },
            "US-IN": {
                path: "M600.86,189.63l1.43,0.87l2.1,0.14l1.52,-0.38l2.63,-1.39l2.73,-2.1l32.3,-4.83l8.81,57.45l-0.66,1.15l0.3,0.92l0.81,0.79l-0.66,1.14l0.49,0.8l1.12,0.04l-0.36,1.14l0.18,0.51l-1.81,0.29l-3.18,2.55l-0.43,0.17l-1.4,-0.81l-3.46,0.91l-0.09,0.78l1.19,3.1l-1.4,1.88l-1.18,0.49l-0.45,0.89l-0.31,2.6l-1.11,0.88l-1.06,-0.24l-0.47,0.47l-0.85,1.95l0.05,3.14l-0.39,1.0l-1.38,0.85l-0.93,-0.68l-1.24,0.01l-1.48,-0.69l-0.62,-1.84l-1.89,-0.73l-0.44,0.3l-0.04,0.5l0.83,0.68l-0.62,0.31l-0.89,-0.35l-0.36,0.29l-0.04,0.48l0.54,0.93l-1.08,0.68l0.14,2.37l-1.06,0.65l-0.0,0.83l-0.16,0.37l0.08,-0.5l-0.33,-0.51l-1.6,0.18l-1.4,-1.69l-0.5,-0.08l-1.67,1.5l-1.57,0.69l-1.07,2.89l-0.81,-1.07l-2.79,-0.77l-1.11,-0.61l-1.08,-0.18l-1.76,0.92l-0.64,-1.02l-0.58,-0.18l-0.53,0.56l0.64,1.86l-0.34,0.84l-0.28,0.09l-0.02,-1.18l-0.42,-0.4l-0.58,0.01l-1.46,0.79l-1.41,-0.84l-0.85,0.0l-0.48,0.95l0.71,1.55l-0.49,0.74l-1.15,-0.39l-0.07,-0.54l-0.53,-0.44l0.55,-0.63l-0.35,-3.09l0.96,-0.78l-0.07,-0.58l-0.44,-0.23l0.69,-0.46l0.25,-0.61l-1.17,-1.47l0.46,-1.16l0.32,0.19l1.39,-0.55l0.33,-1.8l0.55,-0.4l0.44,-0.92l-0.06,-0.83l1.52,-1.07l0.06,-0.69l-0.41,-0.93l0.57,-0.86l0.14,-1.29l0.87,-0.51l0.4,-1.91l-1.08,-2.54l0.22,-0.8l-0.16,-1.11l-0.93,-0.91l-0.61,-1.5l-1.05,-0.78l-0.04,-0.59l0.92,-1.39l-0.63,-2.25l1.27,-1.31l-6.5,-50.68Z",
                name: "Indiana"
            },
            "US-IL": {
                path: "M540.07,225.55l0.86,-0.35l0.37,-0.67l-0.23,-2.33l-0.73,-0.93l0.15,-0.41l0.72,-0.69l2.42,-0.98l0.71,-0.65l0.63,-1.68l0.17,-2.11l1.65,-2.47l0.27,-0.94l-0.03,-1.22l-0.59,-1.95l-2.23,-1.88l-0.11,-1.77l0.67,-2.38l0.45,-0.37l4.6,-0.85l0.81,-0.41l0.82,-1.12l2.55,-1.0l1.43,-1.56l-0.01,-1.57l0.4,-1.71l1.42,-1.46l0.29,-0.74l0.33,-4.37l-0.76,-2.14l-4.02,-2.47l-0.28,-1.5l-0.48,-0.82l-3.64,-2.48l44.58,-4.64l-0.01,2.66l0.57,2.59l1.37,2.49l1.31,0.95l0.76,2.6l1.26,2.71l1.42,1.84l6.6,51.49l-1.22,1.13l-0.1,0.69l0.67,1.76l-0.84,1.09l-0.03,1.11l1.19,1.09l0.56,1.41l0.89,0.82l-0.1,1.8l1.06,2.31l-0.28,1.49l-0.87,0.56l-0.21,1.47l-0.59,0.93l0.34,1.2l-1.48,1.13l-0.23,0.41l0.28,0.7l-0.93,1.17l-0.31,1.19l-1.64,0.67l-0.63,1.67l0.15,0.8l0.97,0.83l-1.27,1.15l0.42,0.76l-0.49,0.23l-0.13,0.54l0.43,2.94l-1.15,0.19l0.08,0.45l0.92,0.78l-0.48,0.17l-0.03,0.64l0.83,0.29l0.04,0.42l-1.31,1.97l-0.25,1.19l0.59,1.22l0.7,0.64l0.37,1.08l-3.31,1.22l-1.19,0.82l-1.24,0.24l-0.77,1.01l-0.18,2.04l0.3,0.88l1.4,1.93l0.07,0.54l-0.53,1.19l-0.96,0.03l-6.3,-2.43l-1.08,-0.08l-1.57,0.64l-0.68,0.72l-1.44,2.95l0.06,0.66l-1.18,-1.2l-0.79,0.14l-0.35,0.47l0.59,1.13l-1.24,-0.79l-0.01,-0.68l-1.6,-2.21l-0.4,-1.12l-0.76,-0.37l-0.05,-0.49l0.94,-1.35l0.2,-1.03l-0.32,-1.01l-1.44,-2.02l-0.47,-3.18l-2.26,-0.99l-1.55,-2.14l-1.95,-0.82l-1.72,-1.34l-1.56,-0.14l-1.82,-0.96l-2.32,-1.78l-2.34,-2.44l-0.36,-1.95l2.37,-6.85l-0.25,-2.32l0.98,-2.06l-0.38,-0.84l-2.66,-1.45l-2.59,-0.67l-1.29,0.45l-0.86,1.45l-0.46,0.28l-0.44,-0.13l-1.3,-1.9l-0.43,-1.52l0.16,-0.87l-0.54,-0.91l-0.29,-1.65l-0.83,-1.36l-0.94,-0.9l-4.11,-2.52l-1.01,-1.64l-4.53,-3.53l-0.73,-1.9l-1.04,-1.21l-0.04,-1.6l-0.96,-1.48l-0.75,-3.54l0.1,-2.94l0.6,-1.28ZM585.52,295.52l0.05,0.05l0.04,0.04l-0.05,-0.0l-0.04,-0.09Z",
                name: "Illinois"
            },
            "US-AK": {
                path: "M89.36,517.03l0.84,0.08l0.09,0.36l-0.3,0.32l-0.64,0.3l-0.15,-0.15l0.25,-0.4l-0.12,-0.31l0.04,-0.2ZM91.79,517.2l0.42,-0.02l0.19,-0.11l0.26,-0.56l1.74,-0.37l2.26,0.07l1.57,0.63l0.84,0.69l0.02,1.85l0.32,0.18l0.0,0.34l0.25,0.27l-0.35,0.09l-0.25,-0.16l-0.23,0.08l-0.41,-0.33l-0.29,-0.04l-0.69,0.23l-0.91,-0.21l-0.07,-0.26l-0.24,-0.17l0.27,-0.21l0.74,0.72l0.46,-0.02l0.2,-0.48l-0.28,-0.44l-0.03,-0.3l-0.31,-0.67l-0.96,-0.52l-1.05,0.27l-0.57,0.69l-1.04,0.3l-0.44,-0.3l-0.48,0.12l-0.06,0.12l-0.63,-0.14l-0.26,0.06l-0.22,0.24l0.2,-0.3l-0.1,-0.55l0.12,-0.79ZM99.83,520.19l0.3,-0.07l0.29,-0.28l-0.03,-0.55l0.31,0.2l-0.06,0.45l0.83,0.92l-0.93,-0.51l-0.44,0.41l-0.13,-0.54l-0.13,-0.04ZM100.07,520.81l0.0,0.04l-0.03,0.0l0.02,-0.04ZM102.01,520.78l0.05,-0.34l0.33,-0.2l0.01,-0.12l-0.58,-1.24l0.1,-0.2l0.59,-0.24l0.29,-0.3l0.65,-0.34l0.62,-0.01l0.41,-0.13l0.81,0.1l1.42,-0.06l0.64,0.15l0.49,0.27l0.88,0.11l0.27,0.15l0.23,-0.22l0.27,-0.05l0.39,0.09l0.2,0.21l0.26,-0.05l0.2,0.38l0.44,0.31l0.1,0.23l0.7,-0.06l0.3,-0.77l0.44,-0.61l0.47,-0.21l1.78,-0.45l0.5,0.04l0.37,0.23l1.13,-0.38l0.66,0.04l-0.11,0.41l0.43,0.51l0.42,0.26l0.62,0.06l0.42,-0.43l0.14,-0.42l-0.34,-0.29l-0.31,-0.03l0.15,-0.44l-0.15,-0.38l1.04,-1.0l0.83,-0.99l0.12,-0.08l0.34,0.17l0.38,-0.02l0.32,0.3l0.19,0.37l0.66,-0.29l-0.1,-0.57l-0.43,-0.58l-0.46,-0.24l0.15,-0.44l0.77,-0.47l0.36,0.04l0.68,-0.2l0.8,-0.08l0.58,0.18l0.45,-0.16l-0.12,-0.52l0.66,-0.6l0.4,0.06l0.26,-0.11l0.43,-0.52l0.34,-0.12l0.23,-0.46l-0.42,-0.3l-0.38,0.03l-0.33,0.15l-0.36,0.39l-0.51,-0.09l-0.5,0.27l-2.19,-0.52l-1.69,-0.24l-0.71,-0.26l-0.12,-0.2l0.17,-0.32l0.04,-0.44l-0.28,-0.56l0.45,-0.35l0.43,-0.13l0.36,0.38l0.04,0.25l-0.15,0.44l0.07,0.39l0.56,0.12l0.32,-0.15l-0.03,-0.3l0.16,-0.35l-0.05,-0.75l-0.84,-1.05l0.01,-0.7l-0.67,-0.19l-0.19,0.24l-0.06,0.48l-0.41,0.22l-0.09,0.03l-0.26,-0.56l-0.34,-0.09l-0.51,0.41l-0.02,0.26l-0.15,0.15l-0.38,-0.02l-0.48,0.27l-0.24,0.54l-0.22,1.13l-0.13,0.32l-0.19,0.05l-0.31,-0.31l0.1,-2.67l-0.23,-0.99l0.19,-0.33l0.02,-0.27l-0.16,-0.29l-0.53,-0.27l-0.46,0.26l-0.1,-0.07l-0.35,0.13l-0.01,-0.54l-0.54,-0.61l0.19,-0.22l0.08,-0.65l-0.16,-0.37l-0.55,-0.26l-1.89,-0.01l-0.58,-0.34l-1.01,-0.12l-0.16,-0.12l-0.07,-0.22l-0.23,-0.07l-1.06,0.53l-0.75,-0.16l-0.12,-0.44l0.3,0.09l0.48,-0.08l0.31,-0.44l-0.21,-0.49l0.37,-0.49l0.83,0.04l0.43,-0.16l0.12,-0.35l-0.14,-0.42l-1.11,-0.64l0.09,-0.27l0.34,-0.17l0.38,-0.44l1.12,-0.0l0.23,-0.09l0.19,-0.32l0.03,-0.95l0.22,-0.54l0.07,-1.42l0.25,-0.45l-0.08,-0.58l0.07,-0.2l0.88,-0.74l0.02,-0.1l-0.09,-0.02l0.19,-0.16l-0.31,-0.35l-0.27,0.05l-0.04,-0.25l-0.09,-0.04l0.57,-0.22l0.33,-0.25l0.51,-0.1l0.24,-0.25l0.42,-0.0l0.19,0.18l0.41,0.08l0.29,-0.08l0.44,-0.55l-0.3,-0.34l-0.39,-0.07l-0.05,-0.33l-0.27,-0.31l-0.6,0.4l-0.43,-0.07l-1.12,0.62l-1.04,0.06l-0.34,0.18l-0.48,-0.03l-0.12,0.5l0.4,0.64l-0.26,0.19l-0.29,0.45l-0.19,-0.09l-0.17,-0.27l-0.76,-0.04l-1.16,-0.25l-0.81,-0.4l-1.05,-0.59l-0.78,-0.61l-0.52,-0.69l0.01,-0.21l0.6,-0.1l-0.06,-0.4l0.1,-0.24l-0.51,-1.06l0.1,-0.78l-0.18,-0.52l0.33,-0.54l-0.4,-0.34l-0.23,0.0l-0.44,-0.69l-0.01,-0.2l0.59,-0.14l0.3,-0.37l-0.05,-0.44l-0.36,-0.26l0.72,0.04l0.29,-0.13l0.18,-0.25l0.63,0.01l0.08,0.51l0.56,0.51l0.32,0.49l-0.03,0.09l-0.79,0.11l-0.53,0.51l0.31,0.45l0.94,-0.08l0.4,0.24l0.26,-0.01l0.39,-0.22l0.29,0.03l0.08,0.07l-0.51,0.6l-0.05,0.38l0.22,0.43l0.46,0.24l1.42,0.07l0.28,-0.17l0.16,-0.35l0.19,-0.08l-0.2,-0.74l0.35,-0.35l-0.02,-0.33l-0.18,-0.25l0.15,-0.43l-0.08,-0.13l-0.52,-0.26l-0.77,-0.01l-0.34,0.1l-1.51,-1.2l-0.01,-0.53l-0.35,-0.39l-0.26,-0.12l-0.15,-0.38l0.55,0.15l0.53,-0.4l-0.17,-0.41l-0.7,-0.51l0.4,-0.45l-0.14,-0.5l0.31,-0.15l0.27,0.08l0.44,-0.1l0.45,0.27l0.75,-0.04l0.67,-0.44l-0.08,-0.48l-0.18,-0.19l-0.48,-0.03l-0.51,0.16l-0.43,-0.19l-1.02,-0.02l-0.26,0.14l-0.44,0.04l-0.36,0.29l-0.62,0.09l-0.15,0.12l-0.15,0.42l-0.13,-0.19l0.27,-0.52l0.36,-0.24l-0.1,-0.44l-0.48,-0.6l0.03,-0.1l0.37,0.1l0.4,-0.18l0.16,-0.22l0.07,-0.36l-0.22,-0.6l0.55,0.23l0.42,-0.5l-0.44,-0.59l0.38,0.32l0.94,0.37l0.2,-0.44l0.14,0.01l-0.04,-0.54l0.12,-0.36l0.48,-0.28l0.49,0.01l1.96,-0.47l0.8,-0.03l0.3,0.25l-0.01,0.44l0.19,0.27l-0.27,0.16l0.13,0.47l0.35,0.15l0.74,0.01l0.29,-0.39l-0.13,-0.45l0.08,-0.34l1.21,-0.11l0.29,-0.63l-0.31,-0.24l-0.93,-0.04l0.03,-0.08l0.41,-0.03l0.15,-0.63l0.72,-0.27l0.86,0.88l0.32,0.11l0.38,-0.28l0.08,-0.27l-0.04,-0.41l-0.18,-0.26l0.34,0.0l0.69,0.32l0.35,0.31l0.54,0.81l-0.06,0.29l-0.38,-0.09l-0.52,0.21l-0.13,0.47l0.43,0.24l1.07,0.06l0.05,0.52l0.31,0.3l0.91,0.49l1.02,0.09l0.53,-0.18l0.41,0.17l0.49,-0.0l1.61,-0.32l0.1,0.49l1.67,0.97l0.28,0.31l0.53,0.32l1.06,0.37l1.81,-0.2l0.56,-0.21l0.47,-0.49l0.2,-0.57l0.15,-0.95l0.61,-1.1l0.01,-0.29l-0.24,-0.88l0.14,-0.05l-0.03,-0.19l0.58,0.25l0.2,-0.1l0.86,0.0l0.36,-0.17l0.41,-0.47l0.07,-0.93l-0.19,-0.43l0.22,-0.03l0.11,-0.44l-0.23,-0.32l-0.73,-0.39l-0.29,0.12l-0.43,-0.04l-0.52,0.2l-0.21,-0.12l-0.29,-0.6l-0.31,-0.29l-0.51,0.0l-0.02,0.1l-0.52,-0.04l-0.43,-0.31l-0.56,-0.02l-0.32,0.1l-1.04,-0.24l-0.48,0.03l-0.33,0.16l0.04,-0.42l-0.29,-0.71l-0.21,-0.97l-0.49,-0.23l-0.55,-0.08l-0.29,0.09l-0.47,-0.64l-0.48,-0.4l-0.5,-0.25l-1.14,-1.02l-0.95,-0.24l-0.2,-0.27l-0.49,-0.27l-0.11,-0.23l-0.63,-0.01l-0.04,0.13l-0.9,-1.22l-1.86,-2.14l-0.25,-0.55l-0.0,-0.32l0.07,-0.19l0.27,0.06l0.27,-0.13l0.35,-0.76l-0.41,-1.02l0.05,-0.11l0.4,0.19l0.51,-0.05l0.41,-0.17l0.51,0.66l0.43,0.23l0.48,-0.4l-0.02,-0.33l-0.32,-0.66l-0.48,-0.41l-0.46,-0.78l-0.84,-0.88l-0.12,-0.02l-0.98,-1.16l-0.33,-0.52l-0.04,-0.3l-0.46,-0.96l0.41,0.03l0.54,0.45l0.34,0.15l0.44,-0.1l0.12,-0.17l0.2,0.03l0.06,-0.15l0.18,0.03l0.17,0.41l0.2,0.18l1.09,0.35l1.08,-0.18l1.53,0.45l0.14,0.13l-0.06,0.06l0.19,0.45l0.88,0.89l1.03,0.47l0.56,-0.36l-0.06,-0.35l-0.37,-0.64l1.48,0.48l0.36,0.26l0.11,0.4l0.61,0.16l1.2,0.07l0.48,0.24l1.49,0.99l0.18,0.45l-0.34,0.04l-0.1,0.06l-0.4,0.34l-0.16,0.3l-0.6,-0.28l-0.52,-0.06l-0.12,0.69l0.62,0.52l0.02,0.52l0.16,0.37l0.28,0.32l0.91,0.59l0.18,0.29l0.46,0.4l0.69,0.3l0.39,0.29l-0.14,0.25l0.02,0.32l0.38,0.24l0.2,-0.05l0.26,0.12l0.44,0.49l0.56,0.16l0.39,0.46l-0.08,0.39l0.24,0.31l0.41,0.19l0.41,-0.15l0.03,-0.15l1.39,-0.46l0.24,0.52l0.24,0.25l-0.25,0.06l0.01,0.5l0.38,0.29l0.43,0.02l0.5,-0.24l0.36,-0.41l-0.05,-0.98l-0.45,-0.65l0.19,0.01l0.65,1.54l0.23,0.25l1.6,0.95l0.53,-0.01l0.29,-0.27l0.34,-0.59l-0.02,-0.44l0.3,-0.38l-0.16,-0.23l-0.72,-0.38l-0.44,-0.04l-0.49,-0.92l-0.89,-0.53l-0.42,-0.12l-0.61,0.21l-0.32,-0.28l-0.0,-0.43l-0.16,-0.19l-0.23,-0.71l0.64,-0.39l0.29,-0.02l0.35,0.29l0.32,0.05l0.37,-0.41l-0.0,-0.15l-0.75,-1.21l-1.13,-0.68l-0.06,-0.29l0.18,-0.28l-0.15,-0.48l-0.43,-0.23l-0.43,0.29l-0.42,0.07l-0.25,-0.44l-0.53,-0.4l-0.31,-0.1l-0.25,-0.41l-1.35,-1.4l0.59,-1.11l0.15,-1.07l-0.1,-1.05l-0.51,-1.13l-0.29,-1.11l-0.36,-0.48l-0.85,-2.25l-1.06,-1.45l-0.08,-0.73l-0.38,-0.89l0.17,-0.17l0.91,-0.32l1.04,-1.04l1.08,1.08l1.75,1.29l0.84,0.44l1.33,0.95l1.37,0.54l1.36,0.24l1.49,-0.09l0.3,0.11l0.42,-0.05l0.4,-0.16l0.23,-0.26l0.3,-0.14l0.42,-0.5l0.56,-0.03l0.17,-0.31l1.66,0.14l0.96,-0.29l0.5,0.12l0.03,0.15l0.87,0.52l0.35,0.13l0.52,-0.01l0.77,0.56l0.91,0.33l0.1,0.2l0.28,-0.04l0.42,0.16l1.99,0.27l-0.05,0.31l0.11,0.18l-0.18,0.06l-0.15,0.66l0.44,0.21l0.04,0.83l0.28,0.36l0.44,-0.14l0.1,-0.13l0.05,-0.46l0.22,-0.51l1.1,0.62l0.73,0.1l0.29,-0.35l-0.22,-0.39l-0.74,-0.5l-0.43,-0.14l-0.07,-0.18l0.03,-0.25l0.76,-0.07l0.26,0.1l0.01,0.3l0.27,0.62l0.54,0.33l0.14,-0.17l0.45,0.24l0.16,-0.08l0.63,0.55l1.13,0.63l0.13,-0.03l0.81,0.55l0.59,0.22l1.21,0.25l1.27,0.12l1.06,-0.17l1.19,0.0l0.01,0.22l0.26,0.49l0.68,0.48l0.08,0.62l0.56,0.17l0.57,0.45l-0.61,-0.02l-0.77,-0.42l-0.42,0.03l-0.44,0.21l0.1,0.48l0.23,0.26l-0.19,0.32l0.18,0.59l0.33,0.11l0.33,-0.12l0.64,0.36l0.3,0.06l0.31,-0.08l0.23,-0.23l0.33,-0.02l0.39,0.36l0.26,0.01l0.25,0.18l0.33,0.02l0.27,-0.16l0.13,0.09l0.16,0.38l-0.54,-0.04l-0.29,0.34l0.21,0.4l0.2,0.11l0.07,0.35l0.89,0.58l-0.04,0.13l0.18,0.3l0.49,0.21l0.94,-0.04l0.96,0.68l0.58,0.26l0.32,0.03l0.37,0.42l0.23,0.1l0.1,0.31l0.34,0.26l0.21,0.38l0.34,0.08l0.26,-0.12l0.25,0.23l-0.55,0.05l-0.29,0.34l-0.41,0.04l-0.18,0.63l0.35,0.33l1.4,0.72l-0.08,0.69l1.48,0.96l0.49,0.67l0.27,0.15l0.49,-0.16l1.05,0.48l0.24,-0.05l0.38,0.32l0.16,0.58l1.1,0.42l0.72,0.06l0.21,0.19l0.85,0.38l0.32,0.34l0.31,0.09l0.59,0.53l0.2,0.37l0.73,0.47l0.25,0.29l0.1,0.53l0.48,0.29l0.55,0.03l0.31,0.44l0.56,0.33l-0.11,0.34l0.39,0.41l1.66,1.19l0.76,0.36l0.16,-0.03l1.78,1.0l0.42,0.4l0.69,0.34l0.47,0.65l0.08,-0.08l-0.02,0.25l0.22,0.06l0.5,0.55l0.02,0.21l0.5,0.23l0.54,0.42l1.19,0.58l0.8,0.03l0.63,0.31l0.03,0.31l0.43,0.12l0.33,-0.2l0.19,-0.0l0.43,0.12l1.02,0.51l0.05,0.25l0.41,0.27l0.22,-0.19l0.58,0.53l0.31,0.09l0.53,0.55l-0.01,0.24l0.49,0.42l0.02,0.24l0.27,0.43l0.55,0.34l0.18,0.4l0.42,0.15l0.58,0.51l0.56,0.96l0.35,0.26l0.53,0.01l0.15,0.11l-23.69,51.51l0.09,0.46l1.53,1.4l0.52,0.02l0.19,-0.15l1.17,1.29l0.41,0.12l1.37,-0.4l1.79,0.68l-0.86,0.96l-0.08,0.38l0.35,1.01l0.91,0.92l-0.08,0.65l0.1,0.44l2.43,4.76l-0.2,1.48l-0.29,0.38l0.19,0.62l0.58,0.12l0.83,-0.25l0.54,-0.07l0.07,0.08l0.03,0.1l-0.66,0.3l-0.33,0.34l0.29,0.54l0.35,-0.0l0.37,-0.18l0.25,0.12l0.02,0.21l0.44,0.11l0.09,0.11l0.26,1.19l-0.17,0.03l-0.1,0.51l0.24,0.32l0.94,0.22l0.04,0.16l-0.27,0.18l0.01,0.12l0.21,0.32l0.21,0.09l-0.05,0.37l-0.24,-0.02l-0.1,-0.46l-0.35,-0.31l-0.11,0.06l-0.28,-0.47l-0.47,-0.03l-0.26,0.35l-0.45,0.01l-0.08,0.13l-0.26,-0.63l-0.14,0.01l-0.35,-0.41l-0.47,-0.12l-0.89,-1.43l0.11,-0.01l0.32,-0.49l-0.08,-0.26l-0.34,-0.28l-0.51,0.01l-0.47,-0.93l-0.05,-0.15l0.12,-0.53l-0.08,-0.41l-0.52,-1.06l-0.46,-0.7l-0.19,-0.07l0.1,-0.61l-0.29,-0.28l-0.72,-0.14l-1.24,-1.44l-0.27,-0.47l-0.01,-0.21l-0.32,-0.23l-0.24,-0.34l-0.28,-0.11l-0.49,-0.63l0.39,-0.11l0.12,-0.23l0.05,0.05l0.59,-0.3l-0.02,0.13l-0.16,0.06l-0.16,0.55l0.3,0.41l0.38,0.07l0.43,-0.3l0.25,-1.03l0.15,-0.22l0.42,0.2l0.36,0.46l0.36,0.04l0.35,-0.35l-0.47,-0.83l-0.69,-0.39l-0.27,-0.91l-0.35,-0.63l-0.4,-0.17l-0.67,0.44l-0.39,0.06l-0.79,0.37l-1.9,-0.05l-1.0,-0.5l-0.45,-0.34l-1.46,-1.5l0.23,-0.14l0.21,-0.32l0.16,-0.74l-0.43,-0.94l-0.52,-0.09l-0.33,0.19l-0.12,0.52l-0.6,-0.04l-0.85,-0.89l-2.81,-1.97l-1.68,-0.48l-1.62,-0.65l-1.13,-0.19l-0.1,-0.53l-0.27,-0.5l0.13,-0.25l-0.02,-0.26l-0.22,-0.25l-0.8,-0.28l-0.36,-0.35l-0.17,-0.01l-0.13,-0.55l-0.2,-0.34l-0.2,-0.12l0.7,-0.5l0.09,-0.27l-0.09,-0.08l0.21,-0.27l0.23,-0.09l0.38,0.08l0.38,-0.17l0.18,-0.32l-0.03,-0.34l-0.35,-0.22l-0.55,-0.07l-0.81,0.27l-0.24,0.2l-0.57,0.02l-0.56,0.35l-0.61,0.15l-0.2,-0.13l-0.19,-0.59l-0.58,-0.63l0.77,-0.37l0.19,-0.38l-0.32,-0.45l-0.53,-0.01l-0.15,-0.48l-0.19,-0.17l0.09,-0.49l-0.16,-0.25l0.04,-0.22l-0.31,-0.55l-0.43,-0.22l-0.53,0.17l-0.07,-0.2l-0.27,-0.03l-0.09,-0.14l0.22,-0.56l0.26,0.03l0.08,-0.09l0.65,0.37l0.38,0.07l0.42,-0.49l-0.14,-0.42l-0.27,-0.26l-1.05,-0.52l-1.54,0.27l-0.1,-0.21l-0.41,-0.3l-0.42,-0.01l-0.08,-0.23l-0.47,0.02l-0.21,-0.16l0.21,-0.26l-0.05,-0.39l0.14,-0.4l-0.28,-0.27l-0.25,-0.05l0.21,-0.77l-0.33,-0.28l-0.29,0.02l-1.36,0.57l0.02,-0.11l-0.34,-0.35l-1.19,-0.19l-0.14,0.25l-0.55,0.26l0.08,0.49l0.21,0.14l-0.01,0.1l-0.83,-0.27l-0.63,-0.03l-0.23,0.49l-0.51,0.38l0.12,0.52l0.31,0.16l0.46,-0.02l-0.05,0.11l-0.98,0.16l-0.3,0.14l-0.16,0.16l-0.05,0.46l0.37,0.28l0.83,-0.12l0.12,0.14l-0.04,0.25l0.31,0.21l-0.27,0.12l-0.15,0.24l-0.51,-0.02l-0.23,0.34l-0.3,0.12l0.05,0.54l-0.3,0.32l-0.12,-0.14l-0.66,0.24l-0.32,-0.27l-0.44,-0.13l-0.32,-0.39l0.11,-0.5l-0.38,-0.29l-0.64,0.04l0.13,-0.4l-0.05,-0.34l-0.23,-0.26l-0.26,-0.07l-0.4,0.16l-0.47,0.73l-0.25,-0.01l-0.23,-0.49l-0.46,-0.07l-0.37,0.4l-0.4,-0.06l-0.16,0.33l-0.29,-0.31l-0.42,-0.03l-0.26,0.25l-0.01,0.21l-0.31,-0.08l-0.11,-0.32l-0.12,-0.03l-0.37,0.06l-0.72,0.4l-0.01,-0.27l-0.13,-0.08l-0.8,-0.04l-0.38,0.2l-0.0,0.45l-0.09,0.05l-1.16,0.08l-0.3,0.13l-0.87,-0.77l-0.22,-0.05l-0.29,0.29l-0.4,-0.28l-1.02,-0.03l0.03,-0.13l-0.35,-0.39l-0.01,-0.13l0.45,0.02l0.16,-0.37l0.53,0.01l0.43,0.3l0.3,0.45l0.49,-0.04l0.2,-0.43l0.23,0.09l0.44,-0.04l0.48,-0.17l0.06,-0.15l0.45,-0.23l0.46,-0.08l0.32,-0.52l-0.21,-0.37l-0.49,-0.19l-1.84,0.04l-0.57,-0.71l-0.07,-0.28l1.28,-0.98l1.62,-0.44l0.37,-0.26l0.33,-0.45l0.46,-0.1l0.65,-0.89l0.14,-1.04l0.36,-0.03l0.74,0.3l1.54,-0.17l1.4,0.03l0.01,0.5l0.23,0.42l0.56,0.48l1.06,0.16l0.14,0.1l0.28,0.41l0.4,0.26l1.19,1.07l0.2,0.34l0.25,0.13l0.5,-0.37l0.0,-0.44l-0.13,-0.39l-0.42,-0.46l-0.43,-0.13l-0.32,-0.52l-0.43,-0.35l-0.69,-1.19l0.45,-0.11l0.44,-0.3l0.35,0.02l0.33,-0.17l1.56,0.33l0.37,-0.06l0.15,-0.62l-0.09,-0.11l-0.67,-0.46l-0.84,-0.3l-0.61,-0.04l-0.74,0.14l-0.37,0.19l-0.29,0.35l-0.76,-0.52l-0.11,-0.24l-0.42,-0.02l-0.16,-0.12l0.14,-0.2l-0.17,-0.67l-0.09,-0.02l-1.07,0.27l-0.85,-0.19l-0.49,0.0l-0.85,0.41l-0.65,-0.15l-0.6,-0.29l-1.18,0.04l-0.71,0.35l-0.19,0.5l-0.35,-0.15l-0.65,0.04l-0.5,0.24l-0.62,0.03l-0.54,0.15l-0.41,0.33l-0.12,0.36l-0.49,0.22l-0.59,-0.02l-0.4,-0.27l-0.26,-0.68l-0.43,-0.32l-0.3,-0.11l-0.42,0.02l-0.3,0.28l0.16,0.51l0.31,0.08l0.01,0.37l0.37,0.61l0.21,0.72l-0.38,0.08l-0.35,0.26l-0.33,-0.06l-0.56,-0.39l-0.98,-0.37l-0.58,0.21l0.02,0.44l-0.07,-0.38l-0.32,-0.34l-0.42,0.19l-0.23,0.4l-0.2,-0.38l-0.81,0.14l-0.08,0.05l-0.02,0.41l-0.37,-0.32l-0.33,-0.04l-0.36,0.28l0.13,0.39l-1.49,-0.27l-0.16,0.49l-0.25,0.14l-0.28,0.36l-0.51,0.04l-0.02,0.17l-0.2,0.09l0.03,0.42l-0.16,0.27l-0.01,0.39l0.33,0.34l0.59,-0.05l0.39,0.38l0.56,0.31l0.08,0.49l0.23,0.34l0.3,0.19l0.03,0.3l-0.64,0.54l-0.5,-0.05l-0.44,0.18l-0.88,-0.46l-0.37,0.02l-0.48,0.41l-0.2,-0.12l-0.45,-0.01l-0.34,0.59l-0.75,-0.12l-0.4,0.05l-0.27,0.3l-0.1,-0.02l0.07,0.06l-0.11,0.01l0.0,0.1l-0.42,-0.28l-0.36,0.33l-0.19,-0.1l-0.32,0.19l-0.3,-0.11l-0.37,0.07l-0.53,-0.44l-0.45,-0.15l-0.9,0.53l-0.18,-0.15l-0.71,-0.02l-0.45,0.28l-0.15,-0.37l-0.41,-0.28l-0.42,0.1l-0.43,0.49l-0.37,-0.15l-0.28,0.31l-0.47,-0.08l-0.4,-0.43l-0.4,0.07l-0.3,0.24l-0.14,-0.11l-0.43,-0.05l-0.14,0.08l-1.45,-0.04l-0.31,0.12l-0.22,0.28l0.24,0.95l-0.31,-0.03l-0.15,0.18l-0.69,-0.24l-0.41,-0.28l-0.26,0.05l-0.26,0.26l-0.2,-0.24l-0.49,0.22l-0.65,0.09l-0.32,-0.22l-0.27,0.2l-0.19,-0.65l-0.39,-0.22l-0.43,0.08l-0.28,0.31l-0.44,0.09l-0.26,-0.07l-0.14,0.34l-0.06,-0.31l-0.26,-0.25l-0.54,-0.14l-1.29,-0.05l-0.62,0.31l-0.42,-0.34l-0.51,-0.04l-0.84,0.27l-0.73,0.11l-0.16,0.12l-0.11,0.56l-0.26,-0.07l-0.44,0.3l-0.03,0.21l-0.23,0.15l-0.26,-0.25l-0.37,-0.03l-0.36,0.17l-0.6,-0.33l-0.87,-0.22l-0.41,-0.18l-0.09,-0.37l-0.55,-0.15l-0.25,0.15l-0.71,-0.67l-0.41,0.02l-0.78,-0.24l-0.4,0.21ZM111.25,502.71l-0.44,0.21l-0.03,-0.02l0.24,-0.26l0.23,0.07ZM128.45,468.26l-0.1,0.14l-0.06,0.02l0.02,-0.15l0.14,-0.02ZM191.55,470.09l-0.0,0.04l-0.02,-0.04l0.03,-0.01ZM191.85,541.2l-0.08,-0.21l0.06,-0.51l0.25,-0.06l0.08,0.39l-0.31,0.39ZM165.84,518.29l-0.19,0.37l-0.34,0.04l-0.07,0.31l-0.27,-0.07l-0.45,0.06l-0.04,-0.09l0.46,-0.29l0.06,-0.15l0.84,-0.19ZM162.12,521.34l0.09,0.0l-0.06,0.02l-0.02,-0.03ZM162.26,521.34l0.08,-0.02l0.01,0.04l-0.04,0.04l-0.05,-0.05ZM141.64,514.73l0.19,0.06l0.26,0.22l-0.46,0.03l-0.07,-0.12l0.08,-0.19ZM132.07,521.13l-0.0,0.0l0.0,-0.0l0.0,0.0ZM132.06,520.84l-0.02,-0.07l0.06,-0.01l-0.03,0.08ZM109.91,522.38l0.07,-0.02l0.05,0.12l-0.03,0.01l-0.09,-0.11ZM107.83,523.67l0.01,0.02l-0.02,0.0l0.0,-0.02l0.01,-0.01ZM136.02,515.64l-0.01,-0.04l0.07,0.01l-0.06,0.03ZM199.71,549.76l0.43,-0.06l0.87,0.3l0.36,-0.05l0.76,-0.54l0.39,-0.87l0.67,-0.03l0.47,-0.34l0.17,-0.49l0.96,0.19l1.89,-0.14l0.49,0.7l0.06,0.43l0.38,0.59l-0.1,0.26l-0.29,0.17l-0.1,0.55l0.11,0.16l-0.11,0.33l0.13,0.53l0.17,0.24l0.69,0.46l0.02,0.37l0.3,0.56l0.35,0.24l0.08,0.34l-0.15,0.26l0.26,1.28l1.33,1.5l0.24,0.78l-0.64,-0.19l-0.38,0.04l-0.33,0.37l-0.51,0.26l-0.01,0.29l-0.38,0.15l-0.21,0.29l-0.52,-0.98l-0.84,-0.64l0.11,-0.44l-0.27,-1.06l0.14,-0.11l0.26,-1.09l-0.26,-0.26l0.04,-0.09l-0.12,-0.01l0.04,-0.06l-0.09,0.05l-0.1,-0.1l-0.04,0.1l-0.12,-0.01l-0.03,-0.07l0.24,-0.92l0.1,-1.07l-0.15,-1.05l0.51,-0.94l0.02,-0.37l-0.66,-0.25l-0.5,0.69l-0.24,-0.13l-0.45,0.11l0.01,0.55l-0.32,0.35l0.3,1.04l-0.34,0.85l0.13,1.32l-0.11,0.36l0.04,0.39l-0.27,0.34l0.03,1.86l-0.28,0.29l-0.27,-0.31l0.02,-1.36l-0.28,-0.43l-0.53,0.1l-0.08,0.1l-0.88,-0.14l0.22,-0.05l0.2,-0.25l0.2,-0.91l-0.12,-0.1l-0.13,-1.06l0.88,0.13l0.45,-0.45l-0.11,-0.33l-0.74,-0.45l-0.23,0.1l0.0,-0.84l-0.33,-0.34l-0.31,-0.01l-0.29,0.56l-0.24,0.06l-0.27,0.41l0.12,0.13l-0.5,-0.23l0.24,-0.5l-0.28,-0.54l-0.29,-0.02l-0.18,-0.5l-0.47,-0.15l-0.19,0.31l-0.22,-0.47ZM201.64,551.89l0.21,0.2l-0.19,0.19l-0.03,-0.38ZM210.83,558.1l0.42,0.83l-0.23,0.38l0.09,0.66l0.47,1.27l0.06,1.07l0.15,0.48l-0.33,-0.38l-1.31,-0.73l-0.26,-0.05l0.19,-0.2l-0.17,-0.39l0.14,-0.1l0.31,-0.63l-0.47,-0.31l-0.27,0.01l-0.75,0.68l-0.11,-0.36l0.09,-0.18l-0.03,-0.41l0.26,-0.33l0.36,-0.19l0.16,-0.56l0.43,-0.42l0.36,0.09l0.44,-0.23ZM211.88,563.05l1.25,5.46l-0.54,0.45l0.03,0.64l0.81,0.55l-0.47,0.67l0.05,0.52l0.58,0.54l-0.08,0.3l0.06,0.48l-0.14,0.55l0.15,0.3l0.2,0.13l0.9,0.26l1.46,1.84l1.18,0.8l0.34,0.76l0.55,0.42l-0.01,0.53l0.1,0.24l0.78,0.58l0.49,0.11l0.03,0.16l-0.16,0.69l-0.68,0.46l-0.31,0.4l-0.04,0.78l-0.31,0.67l0.11,0.99l-0.15,0.54l0.03,0.33l-0.4,0.17l-1.34,1.4l-0.41,0.31l-0.48,0.16l-0.2,-0.13l-0.28,0.01l0.12,-0.5l-0.16,-0.42l-0.64,0.07l-0.08,0.17l-0.1,-0.51l0.24,-0.03l0.12,0.14l0.5,0.14l1.27,-0.81l0.75,-0.65l-0.23,-0.63l-0.48,0.07l0.01,-0.13l-0.37,-0.36l-0.54,0.12l0.59,-1.72l0.0,-0.38l0.15,-0.3l-0.06,-0.43l0.09,-0.51l-0.36,-0.24l-0.06,-0.35l-0.27,-0.49l0.49,-0.15l0.35,-0.35l0.18,-0.48l-0.43,-0.27l-0.43,0.08l-0.61,0.31l-0.45,0.04l-0.55,-0.29l-1.43,0.28l-0.59,-0.05l0.17,-0.09l0.2,-0.36l0.21,-0.85l0.32,0.02l0.81,0.41l0.31,0.03l0.71,-0.34l-0.07,-0.49l-0.33,-0.19l-0.4,0.02l-0.88,-0.43l0.03,-0.84l-0.23,-0.29l-0.46,-0.26l0.02,-0.43l-0.43,-0.61l0.27,-0.3l-0.16,-0.68l-0.35,-0.03l0.1,-0.07l0.01,-0.21l0.42,-0.17l0.22,-0.62l-0.38,-0.26l-0.67,0.18l-0.27,-0.29l-0.2,-0.32l-0.06,-0.35l0.33,-0.21l0.18,-1.04l-0.39,-0.3l-0.47,0.16l-0.17,-0.08l-0.29,-0.36l0.13,-0.2l-0.14,-0.35l-0.45,-0.27l1.08,-0.08l0.35,-0.42l-0.28,-0.52l-0.49,0.08l-0.44,-0.14l0.18,-0.32l-0.03,-0.32l-0.51,-0.26l0.04,-0.13l0.64,0.01l0.41,0.72l0.28,0.23l0.31,0.02l0.28,-0.15l0.04,-0.52l-0.24,-0.23l-0.1,-0.4l-0.37,-0.63l-0.78,-0.91l0.12,-0.39l1.23,0.83l0.52,-0.45ZM214.19,585.45l-0.17,0.68l-0.05,-0.01l0.09,-0.42l0.13,-0.25ZM215.44,583.76l-0.46,0.24l-0.25,-0.22l-0.63,0.14l0.05,-0.14l0.52,-0.28l0.76,0.25ZM211.63,577.78l-0.08,0.43l0.26,0.27l-0.46,0.4l-0.51,-0.23l-0.26,0.45l0.06,0.32l-0.15,-0.2l0.08,-0.67l0.25,-0.15l0.49,-0.04l0.32,-0.57ZM209.08,567.17l-0.25,-0.24l0.08,-0.14l0.49,0.2l-0.32,0.18ZM138.39,458.34l-0.47,-0.44l0.06,-0.45l0.41,0.27l0.0,0.62ZM108.63,500.59l-0.13,0.01l0.09,-0.03l0.04,0.02ZM211.75,580.86l0.58,-0.24l-0.2,0.44l0.02,0.52l-0.22,-0.23l-0.18,-0.5ZM212.61,580.43l0.18,-0.49l-0.1,-0.18l0.52,-0.05l0.31,-0.26l0.18,-0.36l0.14,-0.03l0.14,-0.52l0.57,-0.03l0.29,1.05l0.12,1.09l-0.15,0.19l0.03,0.12l-0.16,0.04l-0.27,0.73l-0.28,0.21l-0.2,-0.36l0.13,-1.47l-0.39,-0.42l-0.41,0.19l-0.18,0.46l-0.46,0.07ZM211.52,574.36l0.23,0.31l0.37,0.12l0.01,0.48l-0.14,0.07l-0.12,-0.08l-0.4,-0.44l-0.11,-0.22l0.15,-0.24ZM209.53,575.0l0.17,-0.21l0.28,-0.04l-0.06,0.38l0.09,0.09l0.27,0.14l0.34,0.0l0.41,0.28l0.04,0.12l-0.35,0.14l0.09,0.38l-0.06,0.17l-0.28,0.08l0.14,-0.47l-0.34,-0.41l-0.06,-0.25l-0.69,-0.39ZM210.36,574.41l0.1,-0.07l0.07,0.06l-0.0,0.01l-0.16,-0.0ZM209.54,571.91l0.03,-0.1l0.32,-0.15l0.14,-0.29l-0.04,-0.37l0.05,-0.1l0.34,1.01l-0.09,-0.09l-0.52,-0.06l-0.15,0.21l-0.08,-0.04ZM206.97,580.16l0.1,-0.52l-0.42,-0.36l0.1,-0.03l-0.05,-0.5l-0.28,-0.2l0.14,-0.17l0.28,-0.1l0.36,0.03l0.21,-0.67l-0.39,-0.23l-1.18,-0.03l-0.2,-0.17l0.19,-0.17l0.46,-0.05l0.67,-0.52l0.19,-0.54l-0.08,-0.32l-0.26,-0.01l0.23,-0.63l0.14,0.22l0.53,0.22l0.24,0.31l0.4,0.27l0.42,1.0l0.12,0.56l-0.14,0.62l-0.17,-0.03l-0.11,0.19l-0.32,0.19l0.02,0.34l-0.75,0.25l-0.08,0.43l0.07,0.45l0.56,-0.01l-0.02,0.13l0.38,0.45l0.22,-0.01l0.23,0.23l0.25,-0.06l0.21,0.38l-0.39,-0.07l-0.32,0.43l-0.06,0.32l0.22,0.37l0.41,0.04l0.21,0.09l-0.2,-0.03l-0.41,0.47l-0.47,0.15l0.11,0.7l0.38,0.27l-0.13,0.2l0.18,0.53l-0.2,0.06l-0.06,0.23l-0.22,-0.08l0.18,-0.35l-0.4,-1.09l0.11,-0.08l0.05,-0.73l-0.28,-0.13l-0.15,-0.32l0.01,-0.81l-0.21,-0.78l-0.46,-0.01l-0.11,0.08l-0.05,-0.39ZM207.26,574.01l-0.02,-0.27l-0.21,-0.27l0.29,-0.14l0.03,0.3l0.15,0.15l-0.04,0.21l-0.2,0.0ZM206.9,573.41l-0.43,-0.14l-0.38,-0.35l0.21,-0.11l0.28,0.14l0.04,0.28l0.27,0.18ZM208.72,573.09l0.26,-0.17l0.43,0.23l0.25,-0.0l-0.15,0.15l-0.09,0.37l-0.14,0.04l-0.23,-0.02l-0.33,-0.6ZM206.49,567.38l1.0,0.59l0.81,0.7l0.06,0.4l-0.46,0.04l-0.19,0.76l0.03,0.31l0.19,0.26l-0.17,0.31l0.43,0.76l-0.15,0.1l-0.85,-0.57l-0.44,0.12l-0.01,0.16l-0.22,-0.06l0.24,-0.51l-0.06,-0.27l0.08,0.03l0.08,-0.27l-0.06,-0.29l0.42,-0.7l0.08,-0.44l-0.28,-0.43l0.06,-0.22l-0.32,-0.31l-0.25,-0.5ZM208.6,569.24l0.34,0.07l0.2,-0.33l0.2,0.07l0.2,0.44l-0.0,0.19l-0.3,0.2l-0.13,0.86l-0.14,-0.44l-0.01,-0.6l-0.07,-0.17l-0.2,-0.03l-0.09,-0.25ZM209.57,569.66l0.0,-0.0l0.03,-0.02l-0.04,0.02ZM204.29,565.52l0.44,-0.15l-0.03,-0.36l0.29,-0.2l0.29,0.26l0.51,-0.3l-0.08,0.47l-0.15,0.23l-0.33,-0.04l-0.36,0.3l-0.27,-0.06l-0.16,0.09l0.02,0.12l-0.36,0.07l0.19,-0.44ZM206.36,564.27l-0.49,0.31l-0.02,-0.59l-0.46,-0.14l-0.02,-0.1l0.53,-0.05l0.24,-0.65l-0.35,-0.23l-0.51,-0.03l-0.1,-0.28l0.09,-0.84l0.2,-0.34l0.16,-0.72l0.07,-1.03l0.34,-0.33l0.69,0.17l0.26,0.31l-0.04,0.27l-0.16,0.12l0.03,0.24l-0.13,0.05l-0.05,0.65l-0.22,0.57l0.02,0.09l0.33,0.11l0.23,1.01l-0.15,0.27l0.43,0.45l-0.08,0.23l-0.57,-0.12l-0.09,0.19l-0.15,0.04l-0.01,0.39ZM206.15,574.28l-0.13,-0.03l0.0,-0.02l0.15,-0.04l-0.02,0.09ZM205.18,574.32l-0.02,0.0l0.01,-0.01l0.01,0.0ZM204.96,570.25l-0.05,-0.24l0.09,0.22l-0.04,0.01ZM205.25,569.02l-0.25,0.19l-0.3,-0.19l-0.18,-0.37l-0.42,-0.07l0.04,-0.08l0.41,0.09l0.15,-0.2l0.31,0.17l0.28,-0.13l0.03,0.52l-0.07,0.07ZM198.99,558.2l0.09,-0.07l0.23,0.49l-0.21,-0.07l-0.11,-0.35ZM199.36,558.71l0.38,0.44l0.56,-0.45l-0.44,-1.09l0.59,0.02l0.03,-0.77l0.24,0.32l0.51,0.01l0.2,-0.29l0.29,-0.06l0.19,0.34l0.24,0.12l0.18,0.27l-0.28,0.14l-0.69,-0.17l-0.13,0.26l-0.17,-0.1l-0.57,0.26l0.08,0.42l0.27,0.54l0.56,0.48l0.25,0.5l0.39,0.36l-0.12,0.15l0.09,0.44l-0.94,-1.32l-0.28,-0.2l-0.61,0.35l0.06,0.34l-0.2,0.14l0.2,0.7l0.21,0.07l-0.14,0.51l0.2,0.13l0.05,0.18l-0.28,0.06l-0.12,-0.56l-0.37,-0.57l0.25,-0.15l-0.16,-0.49l-0.21,-0.17l-0.02,-0.33l-0.28,-0.49l-0.01,-0.31ZM202.27,558.92l0.38,-0.28l0.43,-0.1l0.76,0.39l0.05,0.17l0.43,0.38l-0.11,0.18l-0.41,-0.45l-0.58,-0.11l-0.2,0.41l0.19,0.59l-0.97,-1.19ZM202.11,560.96l0.33,0.1l0.14,0.21l0.26,0.09l0.85,-0.01l-0.23,1.25l-0.31,-0.14l-1.03,-1.5ZM201.29,562.69l0.18,0.07l0.33,-0.09l0.0,0.25l0.48,0.21l0.22,0.28l-0.11,0.08l0.12,0.52l-0.05,0.29l0.23,0.34l-0.06,0.8l0.13,0.32l-0.1,0.03l-0.14,0.56l-0.14,0.99l0.02,0.73l-0.25,0.74l-0.22,-0.02l-0.19,0.34l-0.01,0.5l-0.44,1.06l-0.2,-0.86l-0.08,-0.92l0.3,-0.02l0.63,-0.49l-0.06,-0.73l-0.22,-0.05l0.02,-0.45l-0.19,-0.26l-0.25,-0.01l-0.16,-0.59l-0.47,-0.03l0.24,-0.17l0.01,-0.27l0.65,-0.05l0.22,-0.32l-0.13,-0.51l-0.53,-0.24l0.57,-0.27l-0.34,-1.16l-0.33,-0.12l0.28,-0.19l0.04,-0.3ZM199.27,560.14l0.0,0.0l-0.01,0.0l0.0,-0.0ZM199.1,564.31l0.25,-0.07l0.1,-0.06l-0.12,0.15l-0.23,-0.02ZM199.63,563.32l0.06,-0.2l-0.05,-0.13l0.09,0.13l-0.1,0.2ZM162.15,525.49l0.25,-0.21l0.11,-0.0l-0.2,0.31l-0.16,-0.1ZM136.7,524.68l0.22,0.25l0.59,-0.1l0.04,-0.44l0.61,0.38l0.29,-0.23l0.18,-0.67l0.1,-0.05l0.25,0.13l0.16,-0.06l-0.14,0.5l0.39,0.72l-0.5,0.38l-0.19,-0.72l-0.36,-0.02l-0.69,0.57l-0.12,-0.24l-0.46,0.06l-0.15,0.16l-0.22,-0.52l-0.13,-0.04l0.04,-0.14l0.07,0.07ZM139.88,525.13l-0.03,-0.01l0.02,-0.02l0.01,0.03ZM127.78,528.13l0.49,-0.13l0.09,0.05l-0.34,0.29l-0.18,0.01l-0.06,-0.22ZM128.01,526.82l0.09,-0.93l-0.34,-0.41l0.27,-0.06l0.19,-0.29l0.22,-0.02l0.24,-0.25l0.44,0.22l0.16,-0.11l0.5,0.1l0.1,-0.23l0.15,-0.03l0.38,0.09l0.25,0.25l-0.43,0.12l0.02,0.5l0.44,0.31l-0.25,0.64l0.13,1.11l0.36,0.59l0.43,0.15l-0.37,0.07l-0.19,0.39l-0.11,-0.05l0.03,-0.41l-0.23,-0.36l-0.69,-0.05l-0.43,-0.59l-0.47,-0.4l-0.65,-0.34l-0.26,-0.01ZM131.4,528.57l0.28,-0.39l-0.19,-0.6l0.07,-0.55l0.15,-0.28l0.3,0.13l0.31,-0.27l0.44,0.14l0.52,-0.02l0.3,-0.22l0.26,0.17l0.23,-0.03l0.19,0.33l0.66,-0.29l0.18,-0.29l0.28,0.22l-0.13,0.25l-0.0,0.39l0.26,0.35l0.46,-0.02l0.28,-0.39l0.28,0.18l0.44,-0.16l0.31,0.17l0.08,-0.05l-0.05,0.23l-0.73,0.21l-0.21,0.41l0.22,0.27l-0.07,0.65l0.3,0.23l0.29,0.05l-0.5,0.18l-0.19,-0.24l-0.3,-0.08l-0.09,-0.22l-0.26,-0.17l-0.13,-0.32l-0.96,-0.67l-0.23,0.18l-0.65,0.18l-0.19,0.27l0.12,0.28l-0.38,-0.39l-0.44,0.12l-0.19,0.46l-0.91,-0.26l-0.07,0.08l-0.35,-0.23ZM134.19,529.01l0.07,-0.02l0.09,0.03l-0.15,-0.01l-0.01,0.0ZM134.4,529.04l0.27,0.1l0.23,0.58l-0.25,-0.11l0.04,-0.1l-0.29,-0.47ZM135.83,526.14l0.09,-0.06l0.01,0.01l-0.11,0.04ZM132.89,525.47l-0.57,-0.58l0.11,-0.17l0.27,-0.08l0.34,0.07l0.08,0.37l-0.22,0.39ZM98.14,450.76l0.34,-0.44l0.56,-0.16l0.06,0.49l-0.13,0.02l0.1,0.29l0.7,0.54l0.29,0.6l0.36,0.4l-0.66,-0.36l-1.21,-0.26l-0.45,-0.8l0.04,-0.32ZM100.81,452.78l1.01,0.2l0.26,0.2l0.38,0.11l0.3,0.33l0.23,0.8l-0.26,0.19l-0.26,0.4l0.43,0.51l0.28,0.71l0.39,0.33l-0.09,0.31l0.05,0.32l0.21,0.31l0.5,0.32l0.0,0.35l-0.82,-0.26l-0.09,0.09l-0.51,-0.1l-0.33,0.07l-0.08,-0.93l-0.57,-1.1l0.12,-0.48l-0.3,-0.98l-0.39,-0.84l-0.28,-0.35l-0.01,-0.23l-0.17,-0.28ZM104.84,458.76l0.28,0.01l0.41,0.53l-0.25,0.05l-0.44,-0.59ZM96.98,478.79l0.06,-0.22l1.37,1.26l0.38,-0.0l0.32,-0.21l0.21,0.06l0.2,0.25l0.72,-0.01l-0.01,0.32l0.69,0.19l0.2,0.27l-0.05,0.32l0.09,0.16l0.27,0.29l0.49,0.19l0.07,0.2l-0.23,0.33l-0.32,0.22l-0.42,1.13l-0.7,-0.22l-0.36,-0.42l-0.19,0.11l-0.26,-0.08l-0.29,-0.35l-0.42,-0.13l-0.26,-0.41l-0.51,-0.41l-0.61,-1.56l0.07,-0.19l-0.47,-0.5l0.04,-0.31l-0.09,-0.3ZM97.68,522.17l0.05,-0.07l0.04,-0.11l0.07,0.18l-0.15,-0.01ZM98.03,522.39l0.04,0.02l-0.0,0.03l-0.03,-0.05ZM80.23,514.88l0.08,-0.15l0.69,0.24l0.38,-0.02l1.55,-0.69l0.18,0.0l0.16,0.37l0.44,0.39l0.27,0.08l0.4,-0.16l0.54,0.24l0.6,-0.01l0.53,0.26l0.44,0.41l0.03,0.72l-0.26,0.4l-0.13,0.44l-0.31,0.06l-0.22,0.21l-0.27,0.01l-0.3,-0.08l-0.46,-0.58l-1.38,-0.93l-0.45,-0.11l-0.76,0.03l-0.42,0.3l-0.21,0.03l-0.91,-0.42l-0.33,-0.34l0.14,-0.67ZM74.26,514.0l0.03,-0.25l0.32,0.05l0.02,0.35l-0.37,-0.15ZM64.81,513.23l0.09,-0.01l0.13,0.09l-0.17,0.0l-0.05,-0.08ZM70.29,514.35l-0.12,-0.05l-0.16,0.39l-0.25,-0.27l-0.36,0.08l0.24,-0.12l0.32,0.02l0.41,-0.61l-0.31,-0.35l-0.31,-0.63l-0.3,-0.24l0.05,-0.29l0.13,-0.06l0.67,0.13l0.43,0.28l0.16,0.24l-0.29,0.4l0.11,0.51l-0.06,0.17l-0.33,0.11l-0.04,0.31ZM68.8,514.2l-0.28,0.32l-0.09,-0.1l0.24,-0.29l-0.1,-0.27l0.19,-0.02l0.04,0.36ZM59.97,511.71l0.2,-0.13l0.18,-0.38l0.48,-0.06l0.27,0.03l0.13,0.21l0.36,0.14l0.1,0.15l-0.09,0.12l-0.23,-0.03l-0.61,0.18l-0.41,-0.22l-0.36,0.0ZM62.67,511.56l0.07,-0.35l0.28,-0.32l0.75,-0.02l0.67,0.35l0.17,0.49l-0.28,0.29l-1.25,-0.24l-0.41,-0.2ZM37.79,498.38l0.07,-0.23l-0.1,-0.23l0.32,0.03l0.09,0.49l-0.29,0.05l-0.1,-0.11ZM36.41,498.87l-0.02,0.01l0.01,-0.02l0.01,0.01ZM36.85,498.71l-0.0,-0.07l-0.0,-0.01l0.02,0.01l-0.01,0.07ZM30.2,493.17l-0.02,-0.03l0.04,-0.04l0.0,0.08l-0.02,-0.0ZM26.76,492.74l0.41,-0.33l0.12,0.35l-0.02,0.08l-0.25,0.01l-0.26,-0.12ZM25.01,490.83l0.02,0.0l-0.01,0.01l-0.02,-0.01ZM23.18,488.38l-0.09,0.01l0.05,-0.17l0.04,0.08l0.01,0.08ZM23.19,487.9l-0.06,0.1l-0.14,-0.54l0.19,0.18l0.0,0.26ZM15.95,478.85l0.25,0.07l-0.02,0.19l-0.14,-0.01l-0.09,-0.25ZM1.23,449.67l0.23,0.17l0.21,0.66l0.47,0.45l-0.25,0.16l0.12,0.39l-0.24,-0.38l-0.54,-0.19l-0.11,-0.3l0.19,-0.08l0.2,-0.42l-0.28,-0.47Z",
                name: "Alaska"
            },
            "US-NJ": {
                path: "M801.67,165.24l1.31,-1.55l0.48,-1.57l0.5,-0.62l0.54,-1.45l0.11,-2.05l0.68,-1.35l0.92,-0.71l14.12,4.17l-0.3,5.66l-0.51,0.83l-0.13,-0.3l-0.65,-0.07l-0.34,0.44l-0.56,1.46l-0.46,2.72l0.26,1.55l0.63,0.61l1.06,0.15l1.23,-0.43l2.46,0.29l0.66,1.87l-0.2,4.55l0.29,0.47l-0.54,0.44l0.27,0.81l-0.72,0.74l0.03,0.35l0.43,0.22l-0.21,0.6l0.48,0.6l-0.17,3.8l0.59,0.52l-0.36,1.36l-1.14,1.82l-0.11,0.94l-1.36,0.07l0.09,1.21l0.64,0.83l-0.82,0.56l-0.18,1.15l1.05,0.77l-0.31,0.29l-0.17,-0.44l-0.53,-0.18l-0.5,0.22l-0.44,1.51l-1.28,0.61l-0.2,0.45l0.46,0.55l0.8,0.06l-0.66,1.26l-0.26,1.5l-0.68,0.65l0.19,0.48l0.4,0.04l-0.89,1.57l0.07,0.95l-1.56,1.66l-0.17,-1.65l0.33,-2.07l-0.11,-0.87l-0.58,-0.82l-0.89,-0.28l-1.11,0.34l-0.81,-0.35l-1.51,0.88l-0.31,-0.71l-1.62,-0.96l-1.0,0.04l-0.65,-0.71l-0.7,0.07l-3.24,-2.03l-0.06,-1.72l-1.02,-0.94l0.48,-0.68l0.0,-0.88l0.43,-0.83l-0.12,-0.73l0.51,-1.19l1.2,-1.16l2.6,-1.49l0.54,-0.86l-0.38,-0.85l0.5,-0.37l0.47,-1.44l1.24,-1.7l2.52,-2.22l0.18,-0.67l-0.47,-0.82l-4.26,-2.78l-0.75,-1.05l-0.9,0.24l-0.48,-0.33l-1.24,-2.46l-1.62,-0.02l-1.0,-3.45l1.02,-1.03l0.36,-2.23l-1.87,-1.91Z",
                name: "New Jersey"
            },
            "US-ME": {
                path: "M837.04,56.27l0.86,-1.15l1.42,1.7l0.84,0.04l0.39,-2.12l-0.46,-2.19l1.7,0.36l0.73,-0.42l0.21,-0.52l-0.32,-0.7l-1.18,-0.47l-0.44,-0.62l0.19,-1.43l0.86,-2.02l2.08,-2.25l0.01,-0.98l-0.52,-0.93l1.02,-1.64l0.39,-1.51l-0.22,-0.91l-1.02,-0.35l-0.07,-1.42l-0.4,-0.43l0.55,-0.96l-0.04,-0.63l-1.0,-1.26l0.13,-1.73l0.37,-0.63l-0.15,-0.97l1.22,-1.93l-0.96,-6.17l5.58,-18.88l2.25,-0.23l1.15,3.18l0.55,0.43l2.54,0.56l1.83,-1.73l1.68,-0.83l1.24,-1.72l1.25,-0.12l0.64,-0.47l0.25,-1.43l0.42,-0.3l1.36,0.04l3.68,1.41l1.14,0.96l2.36,1.05l8.38,22.7l0.64,0.65l-0.25,0.95l0.72,1.02l-0.1,1.41l0.54,1.3l0.67,0.47l1.05,-0.12l1.12,0.58l0.97,0.1l2.47,-0.53l0.4,0.95l-0.59,1.42l1.69,1.86l0.28,2.69l2.72,1.68l0.98,-0.1l0.47,-0.74l-0.06,-0.5l1.21,0.25l2.95,2.8l0.04,0.47l-0.52,-0.14l-0.38,0.41l0.18,0.77l-0.76,-0.15l-0.35,0.4l0.15,0.63l1.84,1.62l0.16,-0.88l0.39,-0.17l0.8,0.32l0.27,-0.83l0.33,0.41l-0.31,0.85l-0.53,0.19l-1.21,3.24l-0.62,-0.04l-0.31,0.44l-0.55,-1.05l-0.72,0.03l-0.3,0.5l-0.56,0.06l-0.02,0.49l0.58,0.85l-0.91,-0.45l-0.32,0.63l0.26,0.52l-1.2,-0.28l-0.37,0.3l-0.37,0.78l0.08,0.45l0.44,0.08l0.07,1.21l-0.37,-0.57l-0.54,-0.06l-0.39,0.45l-0.2,1.09l-0.48,-1.53l-1.14,0.01l-0.68,0.75l-0.36,1.48l0.59,0.63l-0.83,0.63l-0.7,-0.46l-0.73,1.04l0.1,0.64l0.99,0.63l-0.35,0.21l-0.1,0.82l-0.45,-0.2l-0.85,-1.82l-1.03,-0.46l-0.39,0.22l-0.45,-0.41l-0.57,0.63l-1.25,-0.19l-0.26,0.86l0.78,0.4l0.01,0.37l-0.51,-0.06l-0.56,0.4l-0.09,0.69l-0.49,-1.02l-1.17,-0.02l-0.16,0.64l0.52,0.87l-1.44,0.96l0.84,1.11l0.08,1.06l0.53,0.65l-0.96,-0.41l-0.96,0.22l-1.2,-0.42l-0.17,-0.91l0.74,-0.28l-0.08,-0.55l-0.43,-0.5l-0.67,-0.12l-0.3,0.33l-0.23,-2.37l-0.37,-0.22l-1.1,0.26l0.04,1.96l-1.85,1.92l0.02,0.49l1.25,1.47l-0.64,0.96l-0.19,3.87l0.77,1.41l-0.57,0.53l0.0,0.63l-0.51,0.55l-0.8,-0.19l-0.45,0.93l-0.62,-0.06l-0.41,-1.15l-0.73,-0.21l-0.52,1.03l0.11,0.69l-0.45,0.59l0.12,2.41l-0.95,-1.01l0.14,-1.28l-0.24,-0.59l-0.81,0.29l-0.08,2.01l-0.44,-0.25l0.15,-1.55l-0.48,-0.4l-0.68,0.49l-0.76,3.04l-0.75,-1.84l0.07,-1.51l-0.77,0.05l-1.06,2.76l0.51,0.55l0.73,-0.25l0.91,2.04l-0.28,-0.59l-0.52,-0.23l-0.66,0.3l-0.07,0.64l-1.38,-0.1l-2.16,3.18l-0.53,1.86l0.29,0.6l-0.68,0.65l0.51,0.43l0.91,-0.21l0.37,0.92l-0.77,0.3l-0.2,0.39l-0.4,-0.04l-0.51,0.57l-0.14,1.03l0.67,1.37l-0.08,0.68l-0.79,1.29l-0.94,0.61l-0.41,1.07l-0.1,1.28l0.44,0.9l-0.4,2.81l-0.8,-0.33l-0.41,0.6l-1.02,-0.76l-0.57,-1.86l-0.93,-0.37l-2.36,-1.99l-0.76,-3.45l-13.25,-35.55ZM863.92,80.85l0.09,0.26l-0.08,0.23l0.03,-0.29l-0.04,-0.2ZM865.33,81.07l0.47,0.7l-0.04,0.47l-0.32,-0.25l-0.1,-0.93ZM867.67,77.93l0.43,0.83l-0.16,0.14l-0.42,-0.19l0.16,-0.77ZM877.04,64.5l-0.14,0.2l-0.03,-0.24l0.17,0.04ZM873.08,74.84l0.01,0.02l-0.03,0.03l0.01,-0.06ZM882.73,63.41l0.04,-1.17l0.41,-0.66l-0.18,-0.44l0.4,-0.5l0.62,-0.11l1.54,1.36l-0.49,0.65l-1.08,0.04l-0.27,0.43l0.57,1.3l-0.99,-0.18l-0.14,-0.57l-0.44,-0.16ZM879.31,65.98l0.61,0.41l-0.35,0.29l0.15,0.96l-0.39,-0.63l0.19,-0.53l-0.21,-0.5ZM878.07,70.51l0.09,-0.01l0.48,-0.08l-0.25,0.46l-0.32,-0.37Z",
                name: "Maine"
            },
            "US-MD": {
                path: "M740.69,219.66l-2.04,-10.06l19.85,-4.49l-0.66,1.29l-0.94,0.08l-1.55,0.81l0.16,0.7l-0.42,0.49l0.23,0.78l-1.04,0.09l-0.72,0.41l-1.48,0.03l-1.14,-0.39l0.21,-0.36l-0.3,-0.49l-1.11,-0.31l-0.47,1.8l-1.63,2.85l-1.37,-0.39l-1.03,0.62l-0.41,1.26l-1.6,1.93l-0.36,1.04l-0.88,0.45l-1.3,1.87ZM760.76,204.58l37.02,-9.15l8.22,26.4l0.48,0.26l8.48,-2.22l0.24,0.71l0.6,0.03l0.38,0.95l0.52,-0.05l-0.38,1.96l-0.12,-0.26l-0.47,0.06l-0.73,0.86l-0.17,2.7l-0.6,0.19l-0.36,0.71l-0.02,1.47l-3.64,1.51l-0.37,0.76l-2.25,0.43l-0.56,0.65l-0.3,-1.09l0.5,-0.31l0.87,-1.85l-0.4,-0.51l-0.45,0.12l0.08,-0.5l-0.44,-0.42l-2.29,0.63l0.3,-0.6l1.15,-0.83l-0.17,-0.69l-1.36,-0.18l0.38,-2.24l-0.18,-1.02l-0.91,0.16l-0.53,1.76l-0.34,-0.69l-0.62,-0.07l-0.44,0.47l-0.5,1.39l0.53,1.02l-2.87,-2.14l-0.43,-0.19l-0.61,0.36l-0.73,-0.76l0.37,-0.84l-0.04,-0.84l0.76,-0.6l-0.08,-1.35l2.08,0.1l0.89,-0.45l0.36,-0.9l-0.32,-1.42l-0.43,-0.05l-0.54,1.31l-0.39,0.09l-1.05,-0.72l0.06,-0.4l-0.52,-0.28l-0.55,0.23l-0.22,-0.68l-0.73,0.1l-0.12,0.28l0.07,-0.74l0.65,-0.01l0.49,-0.37l0.22,-1.04l-0.54,-0.55l-0.57,0.71l-0.2,-0.53l0.88,-0.87l-0.25,-0.65l-0.54,-0.08l-0.09,-0.48l-0.42,-0.27l-0.35,0.15l-0.66,-0.53l0.89,-0.8l-0.24,-1.03l0.94,-2.38l-0.17,-0.43l-0.46,0.02l-0.66,0.66l-0.56,-0.16l-0.61,0.95l-0.74,-0.6l0.49,-3.59l0.6,-0.52l0.06,-0.61l4.22,-1.21l0.12,-0.7l-0.51,-0.3l-2.38,0.43l0.76,-1.27l1.42,-0.05l0.35,-0.5l-0.99,-0.67l0.44,-1.9l-0.63,-0.32l-1.2,1.82l0.05,-1.5l-0.59,-0.34l-0.68,1.1l-1.62,0.67l-0.31,1.65l0.39,0.54l0.65,0.12l-1.45,1.92l-0.2,-1.64l-0.64,-0.42l-0.61,0.73l0.07,1.45l-0.85,-0.29l-1.16,0.64l0.02,0.71l1.01,0.27l-0.37,0.54l-0.83,0.22l-0.05,0.34l-0.44,-0.04l-0.35,0.64l1.15,1.2l-1.88,-0.67l-1.21,0.59l0.16,0.69l1.56,0.58l0.91,0.93l0.72,-0.12l0.56,0.75l-0.98,-0.07l-1.15,1.36l0.32,0.77l1.57,0.92l-0.67,0.12l-0.21,0.41l0.8,1.08l-0.32,0.56l0.32,0.97l0.58,0.45l-0.52,1.09l0.99,1.25l0.96,3.54l0.61,0.84l2.07,1.63l0.42,0.81l-0.58,0.17l-0.64,-0.75l-1.45,-0.31l-1.64,-1.26l-1.33,-3.16l-0.73,-0.68l-0.3,0.37l0.11,0.7l1.28,3.54l1.14,1.31l2.05,0.74l1.03,1.11l0.64,0.14l0.91,-0.36l-0.03,1.11l1.66,1.54l0.1,1.1l-0.89,-0.35l-0.51,-1.29l-0.63,-0.45l-0.45,0.04l-0.13,0.44l0.27,0.79l-0.67,0.09l-0.65,-0.82l-1.41,-0.67l-2.39,0.63l-0.7,-0.67l-0.71,-1.49l-1.26,-0.71l-0.46,0.14l0.01,0.48l1.13,1.84l-0.22,-0.08l-1.62,-1.2l-1.66,-2.28l-0.45,-0.02l-0.37,1.44l-0.32,-0.79l-0.74,0.2l-0.21,0.27l0.33,0.72l-0.11,0.56l-0.76,0.53l-0.94,-1.5l0.07,-1.68l0.76,-0.6l-0.19,-0.74l0.78,-0.47l0.21,-1.61l1.07,-1.03l-0.0,-1.03l-0.46,-0.86l1.27,-2.19l-0.14,-0.54l-2.72,-1.68l-0.56,0.14l-0.63,1.08l-1.87,-0.26l-0.52,-0.83l-1.11,-0.51l-2.41,0.07l-1.25,-0.91l0.61,-1.35l-0.4,-0.97l-1.19,-0.3l-0.89,-0.66l-2.69,0.07l-0.36,-0.23l-0.11,-1.26l-1.04,-0.6l0.09,-1.2l-0.51,-0.29l-0.49,0.19l-0.23,-0.64l-0.52,-0.13l0.26,-0.83l-0.45,-0.58l-0.69,-0.12l-1.81,0.67l-2.24,-1.27ZM790.04,212.1l1.14,0.18l0.3,0.17l-0.52,0.29l-0.93,-0.63ZM803.05,225.67l-0.02,0.33l-0.21,-0.15l0.23,-0.19ZM807.02,229.13l-0.16,0.3l-0.13,0.07l0.02,-0.24l0.26,-0.12ZM797.57,220.61l-0.06,0.01l-0.09,0.03l0.12,-0.07l0.03,0.02ZM797.24,220.74l-0.26,0.56l-0.18,0.12l0.15,-0.61l0.29,-0.07ZM795.94,216.76l-0.29,0.29l-0.72,-0.27l0.02,-0.33l0.26,-0.36l0.72,0.67ZM794.58,212.85l-0.34,0.78l-0.59,0.23l0.02,-1.48l0.92,0.47ZM802.18,228.89l0.1,-0.11l0.12,0.08l-0.22,0.03Z",
                name: "Maryland"
            },
            "US-AR": {
                path: "M498.73,376.99l-1.42,-38.01l-4.48,-23.98l37.68,-2.58l39.02,-3.58l0.8,1.6l1.01,0.7l0.11,1.77l-0.77,0.57l-0.22,0.94l-1.42,0.93l-0.29,1.04l-0.83,0.54l-1.19,2.59l0.02,0.7l0.53,0.26l10.94,-1.46l0.86,0.93l-1.18,0.37l-0.52,0.96l0.25,0.49l0.84,0.41l-3.6,2.7l0.02,0.84l0.83,1.04l-0.6,1.15l0.62,0.97l-1.42,0.74l-0.11,1.44l-1.45,2.09l0.12,1.64l0.91,3.1l-0.15,0.27l-1.08,-0.01l-0.33,0.26l-0.51,1.73l-1.52,0.95l-0.04,0.51l0.79,0.91l0.05,0.65l-1.11,1.21l-2.02,1.13l-0.21,0.62l0.43,1.0l-0.19,0.27l-1.23,0.03l-0.42,0.67l-0.32,1.89l0.47,1.57l0.02,3.08l-1.27,1.09l-1.54,0.13l0.23,1.49l-0.21,0.48l-0.93,0.25l-0.59,1.77l-1.49,1.19l-0.02,0.93l1.39,0.76l-0.03,0.7l-1.23,0.3l-2.24,1.23l0.03,0.67l0.99,0.82l-0.45,1.14l0.53,1.38l-1.09,0.62l-1.9,2.57l0.52,0.7l1.0,0.49l0.01,0.58l-0.98,0.29l-0.42,0.64l0.51,0.84l1.63,1.01l0.06,1.77l-0.59,0.98l-0.09,0.84l0.29,0.4l1.05,0.39l0.5,2.17l-1.09,1.01l0.06,2.11l-51.46,4.07l-0.83,-11.53l-1.18,-0.85l-0.9,0.16l-0.83,-0.35l-0.93,0.39l-1.22,-0.33l-0.57,0.72l-0.47,0.01l-0.49,-0.48l-0.82,-0.15l-0.63,-1.0Z",
                name: "Arkansas"
            },
            "US-MA": {
                path: "M877.65,135.84l1.07,-0.19l0.85,-1.13l0.45,0.58l-1.06,0.64l-1.31,0.1ZM831.87,132.65l-0.46,-0.28l-10.4,2.53l-0.25,-0.18l-0.27,-14.8l29.99,-7.86l1.53,-1.8l0.34,-1.48l0.95,-0.35l0.61,-1.04l1.3,-1.08l1.23,-0.08l-0.44,1.05l1.36,0.55l-0.16,0.61l0.44,0.83l1.0,0.36l-0.06,0.32l0.39,0.28l1.31,0.19l-0.16,0.56l-2.52,1.87l-0.05,1.07l0.45,0.16l-1.11,1.41l0.23,1.08l-1.01,0.96l0.58,1.41l1.4,0.45l0.5,0.63l1.36,-0.57l0.33,-0.59l1.2,0.09l0.79,0.47l0.23,0.68l1.78,1.37l-0.07,1.25l-0.36,0.29l0.11,0.61l1.58,0.82l1.19,-0.14l0.68,1.2l0.22,1.14l0.89,0.68l1.33,0.41l1.48,-0.12l0.43,0.38l1.05,-0.23l3.35,-2.76l0.39,-0.69l0.54,0.02l0.56,1.86l-3.32,1.52l-0.94,0.82l-2.75,0.98l-0.49,1.65l-1.94,1.27l-0.81,-2.53l0.11,-1.35l-0.55,-0.31l-0.5,0.39l-0.93,-0.11l-0.3,0.51l0.25,0.92l-0.26,0.79l-0.4,0.06l-0.63,1.1l-0.6,-0.2l-0.5,0.48l0.22,1.86l-0.9,0.87l-0.63,-0.8l-0.47,0.01l-0.11,0.55l-0.26,0.03l-0.7,-2.02l-1.02,-0.35l0.44,-2.5l-0.21,-0.4l-0.77,0.4l-0.29,1.47l-0.69,0.2l-1.4,-0.64l-0.78,-2.12l-0.8,-0.22l-0.78,-2.15l-0.49,-0.24l-6.13,2.0l-0.3,-0.15l-14.84,4.19l-0.28,0.5ZM860.89,110.08l-0.02,-0.37l-0.14,-0.48l0.51,0.23l-0.35,0.62ZM876.37,122.8l-0.42,-0.66l0.06,-0.05l0.44,0.67l-0.09,0.05ZM875.46,121.25l-0.86,-0.11l-0.94,-1.42l1.44,1.0l0.36,0.54ZM871.54,119.46l-0.06,0.25l-0.35,-0.2l0.13,0.02l0.29,-0.07ZM871.87,135.18l0.01,-0.02l0.01,0.04l-0.02,-0.02ZM867.18,137.63l0.78,-0.56l0.28,-1.17l0.84,-1.19l0.17,0.26l0.46,-0.11l0.34,0.52l0.71,-0.01l0.19,0.38l-2.11,0.73l-1.34,1.31l-0.33,-0.17Z",
                name: "Massachusetts"
            },
            "US-AL": {
                path: "M608.66,337.47l25.17,-2.91l19.4,-2.75l14.04,43.3l0.79,1.4l0.22,1.05l1.17,1.59l0.59,1.87l2.24,2.5l0.92,1.8l-0.11,2.13l1.8,1.13l-0.17,0.74l-0.63,0.1l-0.16,0.7l-0.98,0.84l-0.22,2.29l0.25,1.48l-0.77,2.3l-0.14,1.84l1.1,2.94l1.21,1.52l0.53,1.6l-0.08,5.02l-0.25,0.81l0.48,2.03l1.35,1.16l1.14,2.07l-47.65,6.92l-0.42,0.61l-0.08,2.99l2.64,2.75l2.0,0.97l-0.34,2.7l0.56,1.6l0.43,0.39l-0.94,1.69l-1.24,1.0l-1.13,-0.75l-0.34,0.49l0.66,1.46l-2.82,1.05l0.29,-0.64l-0.45,-0.86l-0.99,-0.77l-0.1,-1.11l-0.57,-0.22l-0.53,0.61l-0.32,-0.1l-0.89,-1.53l0.41,-1.67l-0.97,-2.21l-0.46,-0.45l-0.86,-0.2l-0.3,-0.89l-0.56,-0.17l-0.37,0.61l0.14,0.35l-0.77,3.1l-0.01,5.08l-0.59,0.0l-0.24,-0.71l-2.22,-0.44l-1.65,0.31l-5.46,-31.99l-0.99,-66.49l-0.02,-0.37l-1.07,-0.63l-0.69,-1.02Z",
                name: "Alabama"
            },
            "US-MO": {
                path: "M468.68,225.54l24.71,-0.73l18.94,-1.43l22.11,-2.58l0.42,0.35l0.39,0.91l2.43,1.65l0.29,0.74l1.21,0.87l-0.51,1.37l-0.1,3.21l0.78,3.65l0.95,1.44l0.03,1.59l1.11,1.37l0.46,1.55l4.96,4.1l1.06,1.69l4.93,3.31l0.7,1.15l0.27,1.62l0.5,0.82l-0.18,0.69l0.47,1.8l0.97,1.63l0.77,0.73l1.04,0.16l0.83,-0.56l0.84,-1.4l0.57,-0.19l2.41,0.61l1.68,0.76l0.84,0.77l-0.97,1.95l0.26,2.28l-2.37,6.86l0.01,1.02l0.7,1.92l4.67,4.05l1.99,1.05l1.46,0.09l1.66,1.31l1.91,0.8l1.51,2.11l2.04,0.83l0.42,2.96l1.72,2.9l-1.1,1.94l0.18,1.38l0.75,0.33l2.31,4.25l1.94,0.92l0.55,-0.32l0.0,-0.65l0.87,1.1l1.07,-0.08l0.14,1.85l-0.37,1.07l0.53,1.6l-1.07,3.86l-0.51,0.07l-1.37,-1.13l-0.65,0.13l-0.78,3.34l-0.52,0.74l0.13,-1.06l-0.56,-1.09l-0.97,-0.2l-0.74,0.63l0.02,1.05l0.53,0.66l-0.04,0.7l0.58,1.34l-0.2,0.4l-1.2,0.39l-0.17,0.41l0.15,0.55l0.86,0.84l-1.71,0.37l-0.14,0.62l1.53,1.97l-0.89,0.75l-0.63,2.13l-10.61,1.42l1.06,-2.28l0.87,-0.61l0.18,-0.87l1.44,-0.96l0.25,-0.96l0.63,-0.37l0.29,-0.59l-0.22,-2.28l-1.05,-0.75l-0.2,-0.77l-1.09,-1.18l-39.24,3.61l-37.72,2.58l-3.21,-58.2l-1.03,-0.63l-1.2,-0.02l-1.52,-0.73l-0.19,-0.93l-0.76,-0.59l-0.34,-0.71l-0.36,-1.55l-0.55,-0.09l-0.3,-0.56l-1.13,-0.66l-1.4,-1.84l0.73,-0.51l0.09,-1.24l1.12,-1.27l0.09,-0.79l1.01,0.16l0.56,-0.43l-0.2,-2.24l-1.02,-0.74l-0.32,-1.1l-1.17,-0.01l-1.31,0.96l-0.81,-0.7l-0.73,-0.17l-2.67,-2.35l-1.05,-0.28l0.13,-1.6l-1.32,-1.72l0.1,-1.02l-0.37,-0.36l-1.01,-0.18l-0.59,-0.85l-0.84,-0.26l0.07,-0.53l-1.24,-2.88l-0.0,-0.74l-0.4,-0.49l-0.85,-0.29l-0.05,-0.54ZM583.77,294.59l-0.1,-0.1l-0.08,-0.15l0.11,-0.01l0.07,0.26Z",
                name: "Missouri"
            },
            "US-MN": {
                path: "M439.34,42.76l26.81,-1.05l0.34,1.46l1.28,0.84l1.79,-0.5l1.05,-1.43l0.78,-0.31l2.13,2.19l1.71,0.28l0.31,1.2l1.83,1.4l1.79,0.48l2.64,-0.41l0.39,0.85l0.67,0.4l5.12,0.01l0.37,0.23l0.54,1.59l0.71,0.61l4.27,-0.78l0.77,-0.65l0.07,-0.69l2.43,-0.79l3.97,-0.02l1.42,0.7l3.39,0.66l-1.01,0.79l0.0,0.82l1.18,0.54l2.23,-0.16l0.52,2.08l1.58,2.29l0.71,0.05l1.03,-0.78l-0.04,-1.73l2.67,-0.46l1.43,2.17l2.01,0.79l1.54,0.18l0.54,0.57l-0.03,0.83l0.58,0.35l1.32,0.06l0.38,0.83l1.43,-0.19l1.12,0.22l2.22,-0.85l2.78,-2.55l2.49,-1.54l1.24,2.52l0.96,0.51l2.23,-0.66l0.87,0.36l5.98,-1.3l0.56,0.18l1.32,1.64l1.24,0.59l0.62,-0.01l1.61,-0.83l1.35,0.08l-0.93,1.03l-4.69,3.07l-6.35,2.82l-3.68,2.48l-2.15,2.49l-0.95,0.58l-6.63,8.66l-0.95,0.61l-1.08,1.56l-1.96,1.96l-4.17,3.55l-0.86,1.79l-0.55,0.44l-0.14,0.96l-0.78,-0.01l-0.46,0.51l0.98,12.22l-0.79,1.2l-1.05,0.08l-0.52,0.82l-0.83,0.15l-0.61,0.83l-2.06,1.19l-0.94,1.86l0.06,0.72l-1.69,2.39l-0.01,2.06l0.38,0.91l2.15,0.39l1.42,2.49l-0.52,1.92l-0.71,1.25l-0.05,2.12l0.45,1.32l-0.71,1.23l0.91,3.14l-0.51,4.08l3.95,3.03l3.02,0.4l1.89,2.25l2.87,0.5l2.45,1.93l2.39,3.59l2.64,1.8l2.09,0.09l1.07,0.71l0.88,0.1l0.82,1.36l1.03,0.45l0.23,0.39l0.28,2.03l0.68,1.3l0.39,4.82l-40.63,3.2l-40.63,2.09l-1.46,-38.98l-0.7,-1.27l-0.83,-0.78l-2.57,-0.79l-0.94,-1.91l-1.46,-1.79l0.21,-0.68l2.83,-2.34l0.97,-2.12l0.4,-2.44l-0.35,-1.58l0.23,-1.58l-0.18,-1.79l-0.5,-1.03l-0.18,-2.33l-1.81,-2.59l-0.47,-1.13l-0.21,-2.16l-0.66,-0.98l0.15,-1.66l-0.35,-1.52l0.53,-2.69l-1.08,-1.85l-0.49,-8.33l-0.42,-0.79l0.06,-3.92l-1.58,-3.96l-0.53,-0.65l-0.4,-1.37l0.05,-1.19l-0.48,-0.53l-1.36,-3.77l0.0,-3.22l-0.47,-1.97l0.27,-1.12l-0.57,-2.32l0.73,-2.56l-2.06,-6.9ZM468.97,33.61l1.22,0.46l0.99,-0.2l0.33,0.45l-0.05,1.72l-1.78,1.12l-0.15,-0.47l-0.4,-0.14l-0.16,-2.95Z",
                name: "Minnesota"
            },
            "US-CA": {
                path: "M2.95,175.4l0.78,-1.24l0.46,0.46l0.59,-0.08l0.52,-1.18l0.8,-0.86l1.3,-0.26l0.56,-0.53l-0.15,-0.71l-0.93,-0.32l1.53,-2.79l-0.3,-1.58l0.14,-0.87l2.04,-3.3l1.31,-3.03l0.36,-2.12l-0.28,-1.0l0.16,-3.11l-1.36,-2.16l1.18,-1.38l0.67,-2.53l32.73,8.13l32.58,7.34l-13.67,64.68l25.45,34.66l36.6,51.1l13.3,17.72l-0.19,2.73l0.73,0.94l0.21,1.71l0.85,0.63l0.81,2.56l-0.07,0.91l0.63,1.46l-0.16,1.36l3.8,3.82l0.01,0.5l-1.95,1.53l-3.11,1.26l-1.2,1.99l-1.72,1.14l-0.33,0.81l0.38,1.03l-0.51,0.51l-0.1,0.9l0.08,2.29l-0.6,0.72l-0.64,2.44l-2.02,2.47l-1.6,0.14l-0.42,0.51l0.33,0.89l-0.59,1.34l0.54,1.12l-0.01,1.19l-0.78,2.68l0.57,1.02l2.74,1.13l0.34,0.83l-0.19,2.4l-1.18,0.78l-0.42,1.37l-2.27,-0.62l-1.25,0.6l-43.38,-3.34l0.17,-1.15l0.67,-0.51l-0.17,-1.06l-1.17,-1.38l-1.04,-0.15l0.23,-1.2l-0.28,-1.07l0.78,-1.33l-0.3,-4.25l-0.6,-2.3l-1.92,-4.07l-3.56,-4.07l-1.29,-1.98l-2.42,-2.11l-2.04,-3.01l-2.22,-0.89l-0.94,0.3l-0.39,0.96l-0.62,-0.73l-0.88,-0.22l-0.15,-0.31l0.61,-0.76l0.17,-1.57l-0.44,-2.06l-1.01,-1.95l-1.0,-0.74l-4.44,-0.19l-3.33,-1.81l-1.36,-1.26l-0.7,-0.12l-1.02,-1.19l-0.44,-2.6l-0.97,-0.47l-1.68,-2.31l-2.19,-1.73l-1.24,-0.41l-1.66,0.37l-1.15,-1.01l-1.25,0.03l-2.48,-1.83l-1.06,0.01l-1.49,-0.69l-4.91,-0.52l-1.12,-2.35l-1.43,-0.76l1.34,-2.45l-0.25,-1.36l0.74,-1.99l-0.63,-1.35l1.27,-2.45l0.33,-2.44l-0.99,-1.24l-1.26,-0.23l-1.4,-1.28l0.41,-1.62l0.79,-0.09l0.25,-0.45l-0.47,-2.2l-0.65,-0.77l-1.47,-0.84l-1.78,-3.97l-1.82,-1.25l-0.36,-2.75l-1.61,-2.58l0.07,-1.39l-0.33,-1.26l-1.16,-0.94l-0.74,-2.95l-2.41,-2.69l-0.55,-1.25l-0.02,-4.63l0.59,-0.57l-0.59,-1.14l0.51,-0.59l0.53,0.61l0.78,-0.02l0.84,-0.81l0.56,-1.33l0.8,0.04l0.21,-0.88l-0.43,-0.27l0.47,-1.19l-1.22,-3.68l-0.62,-0.48l-1.05,0.08l-1.93,-0.51l-1.04,-1.06l-1.89,-3.21l-0.8,-2.28l0.86,-2.39l0.09,-1.11l-0.27,-2.38l-0.32,-0.64l-0.54,-0.24l0.25,-1.19l0.69,-1.07l0.24,-2.71l0.47,-0.64l0.88,0.13l0.18,0.94l-0.7,2.13l0.05,1.15l1.18,1.32l0.55,0.1l0.58,1.28l1.16,0.78l0.4,1.01l0.89,0.41l0.83,-0.21l-0.21,-1.45l-0.65,-0.43l-0.18,-0.58l-0.24,-3.57l-0.56,-0.71l0.26,-0.69l-1.48,-1.06l0.5,-1.07l0.09,-1.06l-1.2,-1.58l0.78,-0.74l0.79,0.06l1.24,-0.73l1.25,1.02l1.87,-0.32l5.55,2.41l0.61,-0.09l0.64,-1.38l0.69,-0.04l1.92,2.53l0.25,0.18l0.63,-0.24l0.02,-0.38l-0.39,-0.93l-1.57,-1.89l-1.66,-0.32l0.27,-0.62l-0.28,-0.54l-0.48,0.09l-1.05,1.01l-1.84,-0.22l-0.43,0.28l-0.15,-0.51l-1.05,-0.4l0.24,-1.05l-0.85,-0.47l-1.0,0.28l-0.6,0.84l-1.09,0.4l-1.35,-0.9l-0.39,-0.88l-1.51,-1.44l-0.58,0.03l-0.64,0.61l-0.92,-0.12l-0.48,0.36l-0.33,1.88l0.21,0.78l-0.76,1.36l0.36,0.65l-0.47,0.59l-0.04,0.69l-2.16,-2.89l-0.44,-0.15l-0.25,0.32l-0.73,-1.0l-0.21,-1.03l-1.2,-1.17l-0.4,-1.05l-0.61,-0.18l0.65,-1.48l0.11,0.95l0.76,1.49l0.44,0.25l0.33,-0.38l-1.45,-5.21l-1.08,-1.42l-0.31,-2.68l-2.5,-2.87l-1.8,-4.48l-3.05,-5.54l1.09,-1.7l0.25,-1.97l-0.46,-2.11l-0.14,-3.61l1.34,-2.92l0.7,-0.74l-0.07,-1.54l0.42,-1.53l-0.41,-1.63l0.11,-1.96l-1.41,-4.06l-0.97,-1.15l0.06,-0.8l-0.42,-1.19l-2.91,-4.03l0.51,-1.35l-0.21,-2.69l2.23,-3.44ZM31.5,240.45l-0.06,0.1l-0.34,0.04l0.21,-0.05l0.19,-0.09ZM64.32,351.64l0.27,0.13l0.19,0.18l-0.31,-0.18l-0.15,-0.13ZM65.92,352.88l1.32,0.84l0.76,1.73l-0.89,-0.66l-1.14,0.03l-0.05,-1.94ZM62.72,363.08l1.36,2.08l0.57,0.53l-0.46,0.06l-0.83,-0.79l-0.65,-1.88ZM43.54,333.81l0.88,0.73l1.37,0.36l1.36,1.0l-2.82,-0.18l-0.71,-0.58l0.24,-0.66l-0.32,-0.67ZM47.89,335.89l0.94,-0.5l0.32,0.36l-0.37,0.14l-0.88,-0.0ZM46.05,352.4l0.29,-0.06l0.95,0.92l-0.61,-0.17l-0.64,-0.69ZM37.57,334.04l2.57,0.16l0.2,0.74l0.6,0.45l-1.21,0.64l-1.17,-0.1l-0.49,-0.44l-0.5,-1.44ZM34.94,332.37l0.06,-0.02l0.05,0.06l-0.01,-0.0l-0.1,-0.04Z",
                name: "California"
            },
            "US-IA": {
                path: "M452.9,162.25l42.83,-2.19l40.56,-3.19l0.96,2.52l2.0,1.0l0.08,0.59l-0.9,1.8l-0.16,1.04l0.9,5.09l0.92,1.26l0.39,1.75l1.46,1.72l4.95,0.85l1.27,2.03l-0.3,1.03l0.29,0.66l3.61,2.37l0.85,2.41l3.84,2.31l0.62,1.68l-0.31,4.21l-1.64,1.98l-0.5,1.94l0.13,1.28l-1.26,1.36l-2.51,0.97l-0.89,1.18l-0.55,0.25l-4.56,0.83l-0.89,0.73l-0.61,1.71l-0.15,2.56l0.4,1.08l2.01,1.47l0.54,2.65l-1.87,3.25l-0.22,2.24l-0.53,1.42l-2.88,1.39l-1.02,1.02l-0.2,0.99l0.72,0.87l0.2,2.15l-0.58,0.23l-1.34,-0.82l-0.31,-0.76l-1.29,-0.82l-0.29,-0.51l-0.88,-0.36l-0.3,-0.82l-0.95,-0.68l-22.3,2.61l-15.13,1.17l-7.59,0.51l-20.78,0.47l-0.22,-1.06l-1.3,-0.73l-0.33,-0.67l0.58,-1.16l-0.21,-0.95l0.22,-1.39l-0.36,-2.19l-0.6,-0.73l0.07,-3.65l-1.05,-0.5l0.05,-0.91l0.71,-1.02l-0.05,-0.44l-1.31,-0.56l0.33,-2.54l-0.41,-0.45l-0.89,-0.16l0.23,-0.8l-0.3,-0.58l-0.51,-0.25l-0.74,0.23l-0.42,-2.81l0.5,-2.36l-0.2,-0.67l-1.36,-1.71l-0.08,-1.92l-1.78,-1.54l-0.36,-1.74l-1.09,-0.94l0.03,-2.18l-1.1,-1.87l0.21,-1.7l-0.27,-1.08l-1.38,-0.67l-0.42,-1.58l-0.45,-0.59l0.05,-0.63l-1.81,-1.82l0.56,-1.61l0.54,-0.47l0.73,-2.68l0.0,-1.68l0.55,-0.69l0.21,-1.19l-0.51,-2.24l-1.33,-0.29l-0.05,-0.73l0.45,-0.56l-0.0,-1.71l-0.95,-1.42l-0.05,-0.87Z",
                name: "Iowa"
            },
            "US-MI": {
                path: "M612.24,185.84l1.83,-2.17l0.7,-1.59l1.18,-4.4l1.43,-3.04l1.01,-5.05l0.09,-5.37l-0.86,-5.54l-2.4,-5.18l0.61,-0.51l0.3,-0.79l-0.57,-0.42l-1.08,0.55l-3.82,-7.04l-0.21,-1.11l1.13,-2.69l-0.01,-0.97l-0.74,-3.13l-1.28,-1.65l-0.05,-0.62l1.73,-2.73l1.22,-4.14l-0.21,-5.34l-0.77,-1.6l1.09,-1.15l0.81,-0.02l0.56,-0.47l-0.27,-3.49l1.08,-0.11l0.67,-1.43l1.19,0.48l0.65,-0.33l0.76,-2.59l0.82,-1.2l0.56,-1.68l0.55,-0.18l-0.58,0.87l0.6,1.65l-0.71,1.8l0.71,0.42l-0.48,2.61l0.88,1.42l0.73,-0.06l0.52,0.56l0.65,-0.24l0.89,-2.26l0.66,-3.52l-0.08,-2.07l-0.76,-3.42l0.58,-1.02l2.13,-1.64l2.74,-0.54l0.98,-0.63l0.28,-0.64l-0.25,-0.54l-1.76,-0.1l-0.96,-0.86l-0.52,-1.99l1.85,-2.98l-0.11,-0.73l1.72,-0.23l0.74,-0.94l4.16,2.0l0.83,0.13l1.98,-0.4l1.37,0.39l1.19,1.04l0.53,1.14l0.77,0.49l2.41,-0.29l1.7,1.02l1.92,0.09l0.8,0.64l3.27,0.45l1.1,0.78l-0.01,1.12l1.04,1.31l0.64,0.21l0.38,0.92l-0.16,0.54l-0.66,-0.25l-0.94,0.57l-0.23,1.83l0.81,1.29l1.6,0.99l0.69,1.37l0.65,2.26l-0.12,1.73l0.77,5.57l-0.14,0.6l-0.57,0.2l-0.48,0.96l-0.75,0.08l-0.79,0.81l-0.17,4.47l-1.12,0.49l-0.18,0.82l-1.86,0.43l-0.73,0.6l-0.58,2.61l0.26,0.45l-0.21,0.52l0.25,2.58l1.38,1.31l2.9,0.84l0.91,-0.07l1.08,-1.23l0.6,-1.44l0.62,0.19l0.38,-0.24l1.01,-3.59l0.6,-1.06l-0.08,-0.52l0.97,-1.45l1.39,-0.39l1.07,-0.69l0.83,-1.1l0.87,-0.44l2.06,0.59l1.13,0.7l1.0,1.09l1.21,2.16l2.0,5.91l0.82,1.6l1.03,3.71l1.49,3.63l1.27,1.73l-0.33,3.93l0.45,2.49l-0.48,2.79l-0.34,0.44l-0.24,-0.33l-0.31,-1.71l-1.46,-0.52l-0.47,0.08l-1.48,1.36l-0.06,0.83l0.55,0.67l-0.83,0.57l-0.29,0.79l0.28,2.94l-0.49,0.75l-1.62,0.92l-1.06,1.85l-0.43,3.73l0.27,1.55l-0.33,0.93l-0.42,0.19l0.02,0.91l-0.64,0.3l-0.37,1.08l-0.52,0.52l-0.5,1.28l-0.02,1.05l-0.52,0.78l-20.37,4.25l-0.14,-0.86l-0.46,-0.33l-31.6,4.74ZM621.47,115.87l0.0,-0.07l0.12,-0.12l-0.01,0.03l-0.11,0.16ZM621.73,114.95l-0.07,-0.16l0.07,-0.14l-0.0,0.3ZM543.48,88.04l4.87,-2.38l3.55,-3.62l5.77,-1.36l1.39,-0.84l2.36,-2.71l0.97,0.04l1.52,-0.73l1.0,-2.25l2.82,-2.84l0.23,1.72l1.85,0.59l0.05,1.45l0.66,0.14l0.51,0.6l-0.17,3.14l0.44,0.95l-0.34,0.47l0.2,0.47l0.74,-0.02l1.08,-2.21l1.08,-0.9l-0.42,1.15l0.59,0.45l0.82,-0.67l0.52,-1.22l1.0,-0.43l3.09,-0.25l1.51,0.21l1.18,0.93l1.54,0.44l0.47,1.05l2.31,2.58l1.17,0.55l0.53,1.55l0.73,0.34l1.87,0.07l0.73,-0.4l1.07,-0.06l0.52,-0.65l0.88,-0.43l1.0,1.11l1.1,0.64l1.02,-0.25l0.68,-0.82l1.87,1.06l0.64,-0.34l1.65,-2.59l2.81,-1.89l1.7,-1.65l0.91,0.11l3.27,-1.21l5.17,-0.25l4.49,-2.72l2.56,-0.37l-0.01,3.24l0.29,0.71l-0.36,1.1l0.67,0.85l0.66,0.11l0.71,-0.39l2.2,0.7l1.14,-0.43l1.03,-0.87l0.66,0.48l0.21,0.71l0.85,0.22l1.27,-0.8l0.95,-1.55l0.66,-0.02l0.84,0.75l1.98,3.78l-0.86,1.04l0.48,0.89l0.47,0.36l1.37,-0.42l0.58,0.46l0.64,0.04l0.18,1.2l0.98,0.87l1.53,0.52l-1.17,0.68l-4.96,-0.14l-0.53,0.29l-1.35,-0.17l-0.88,0.41l-0.66,-0.76l-1.63,-0.07l-0.59,0.47l-0.07,1.22l-0.49,0.75l0.38,2.05l-0.92,-0.22l-0.89,-0.92l-0.77,-0.13l-1.96,-1.65l-2.41,-0.6l-1.6,0.04l-1.04,-0.5l-2.89,0.47l-0.61,0.45l-1.18,2.52l-3.48,0.73l-0.58,0.77l-2.06,-0.34l-2.82,0.93l-0.68,0.83l-0.56,2.51l-0.78,0.28l-0.81,0.87l-0.65,0.28l0.16,-1.96l-0.75,-0.91l-1.02,0.34l-0.76,0.92l-0.97,-0.39l-0.68,0.17l-0.37,0.4l0.1,0.83l-0.73,2.01l-1.2,0.59l-0.11,-1.38l-0.46,-1.06l0.34,-1.69l-0.17,-0.37l-0.66,-0.17l-0.45,0.58l-0.6,2.12l-0.22,2.57l-1.12,0.91l-1.26,3.02l-0.62,2.66l-2.56,5.33l-0.69,0.74l0.12,0.91l-1.4,-1.28l0.18,-1.75l0.63,-1.69l-0.41,-0.81l-0.62,-0.31l-1.36,0.85l-1.16,0.09l0.04,-1.29l0.81,-1.45l-0.41,-1.34l0.3,-1.09l-0.58,-0.98l0.15,-0.83l-1.9,-1.55l-1.1,-0.06l-0.59,-0.44l-0.86,0.2l-0.62,-0.2l0.3,-1.36l-0.94,-1.45l-1.13,-0.51l-2.23,-0.1l-3.2,-0.71l-1.55,0.59l-1.43,-0.42l-1.62,0.17l-4.56,-1.94l-15.37,-2.5l-2.0,-3.4l-1.88,-0.96l-0.76,0.26l-0.1,-0.3ZM603.38,98.65l-0.01,0.52l-0.46,0.32l-0.7,1.39l0.08,0.57l-0.65,-0.58l0.91,-2.16l0.83,-0.06ZM643.87,87.47l1.99,-1.52l0.17,-0.57l-0.27,-0.64l1.05,0.16l0.8,1.24l0.81,0.19l-0.27,1.08l-0.36,0.19l-1.5,-0.34l-0.77,0.45l-1.63,-0.24ZM635.6,77.64l0.56,-0.83l0.52,0.05l-0.37,1.32l0.11,0.71l-0.35,-0.9l-0.46,-0.35ZM636.53,79.17l0.09,0.14l0.01,0.01l-0.02,-0.01l-0.08,-0.14ZM637.39,81.25l0.4,0.45l0.22,0.61l-0.63,-0.71l0.01,-0.34ZM633.73,93.13l1.41,0.25l0.36,-0.18l0.4,0.21l-0.17,0.52l-0.75,0.11l-1.24,-0.9ZM618.85,96.77l0.62,2.25l-0.8,0.78l-0.39,-0.27l0.56,-2.76ZM613.26,110.83l0.47,0.3l-0.09,0.57l-0.45,-0.69l0.06,-0.17ZM612.23,113.57l0.0,-0.03l0.02,-0.04l-0.03,0.07ZM599.41,82.64l-0.23,-0.37l0.03,-0.4l0.37,0.32l-0.17,0.45ZM570.51,72.75l-0.51,-0.27l-1.16,0.06l-0.04,-1.56l1.0,-1.03l1.17,-2.09l1.84,-1.49l0.63,-0.0l0.53,-0.58l2.08,-0.89l3.34,-0.42l1.1,0.66l-0.54,0.38l-1.31,-0.12l-2.27,0.78l-0.15,0.29l0.3,0.59l0.71,0.13l-1.19,0.98l-1.4,1.89l-0.7,0.29l-0.36,1.45l-1.15,1.37l-0.66,2.04l-0.67,-0.87l0.75,-0.97l0.14,-1.95l-0.63,-0.37l-0.21,0.15l-0.6,0.92l-0.05,0.67ZM558.28,58.21l0.75,-0.98l-0.39,-0.33l0.56,-0.53l4.62,-2.98l1.97,-1.72l0.62,-0.18l-0.45,0.65l0.1,0.79l-0.43,0.49l-4.25,2.56l-0.86,0.99l0.24,0.36l-1.87,1.17l-0.61,-0.28Z",
                name: "Michigan"
            },
            "US-GA": {
                path: "M654.05,331.71l22.02,-3.57l20.65,-3.86l-1.48,1.42l-0.51,1.68l-0.66,0.82l-0.41,1.73l0.11,1.23l0.82,0.78l1.84,0.8l1.03,0.12l2.7,2.03l0.84,0.24l1.9,-0.37l0.6,0.25l0.8,1.64l1.51,1.6l1.04,2.5l1.33,0.82l0.84,1.16l0.56,0.26l1.0,1.77l1.07,0.3l1.17,0.99l3.81,1.85l2.41,3.16l2.25,0.58l2.53,1.67l0.5,2.34l1.25,1.02l0.47,-0.16l0.31,0.49l-0.1,0.62l0.79,0.73l0.79,0.09l0.56,1.21l4.99,1.89l0.4,1.78l1.54,1.73l1.02,2.01l-0.07,0.81l0.49,0.69l0.11,1.24l1.04,0.79l1.17,0.17l1.25,0.62l0.28,0.53l0.57,0.23l1.12,2.56l0.76,0.57l0.08,2.68l0.77,1.48l1.38,0.9l1.52,-0.27l1.44,0.76l1.45,0.11l-0.59,0.78l-0.56,-0.35l-0.47,0.28l-0.4,0.99l0.62,0.91l-0.38,0.48l-1.38,-0.16l-0.77,-0.55l-0.65,0.44l0.26,0.71l-0.49,0.52l0.36,0.61l0.94,-0.04l0.5,0.29l-0.58,1.35l-1.43,0.27l-1.33,-0.44l-0.44,0.39l0.34,0.85l1.23,0.35l-0.5,0.87l0.23,0.35l-0.2,0.64l0.83,0.64l-0.33,0.44l-0.72,-0.13l-0.96,0.51l-0.1,0.62l1.09,0.45l0.05,0.95l0.48,-0.07l1.2,-1.17l-0.92,2.31l-0.31,-0.58l-0.59,-0.08l-0.44,0.72l0.29,0.7l0.98,0.83l-2.32,0.04l-0.92,-0.28l-0.63,0.3l0.06,0.63l0.55,0.34l2.76,0.24l1.07,0.66l-0.02,0.34l-0.56,0.22l-0.88,1.95l-0.5,-1.41l-0.45,-0.13l-0.6,0.33l-0.15,0.84l0.34,0.96l-0.6,0.11l-0.03,0.84l-0.3,0.16l0.07,0.46l1.33,1.15l-1.09,1.03l0.32,0.47l0.77,0.07l-0.39,0.92l0.06,0.88l-0.46,0.51l1.1,1.66l0.03,0.76l-0.79,0.33l-2.64,-0.17l-4.06,-0.96l-1.31,0.35l-0.18,0.74l-0.68,0.26l-0.35,1.25l0.28,2.08l0.95,1.36l0.13,4.25l-1.97,0.4l-0.54,-0.92l-0.12,-1.3l-1.33,-1.82l-49.22,5.14l-0.72,-0.56l-0.86,-2.7l-0.94,-1.51l-0.56,-0.38l0.16,-0.68l-0.73,-1.51l-1.82,-1.81l-0.43,-1.75l0.25,-0.8l0.06,-5.18l-0.6,-1.81l-1.19,-1.47l-1.03,-2.65l0.12,-1.65l0.78,-2.36l-0.25,-1.53l0.19,-2.11l1.62,-1.33l0.46,-1.47l-0.55,-0.61l-1.42,-0.69l0.09,-2.15l-0.97,-1.87l-2.18,-2.42l-1.03,-2.81l-0.75,-0.68l-0.17,-0.96l-0.77,-1.37l-13.99,-43.12ZM745.21,389.83l0.7,-0.26l-0.07,0.82l-0.29,-0.33l-0.34,-0.24ZM743.75,406.73l0.05,0.87l-0.01,0.46l-0.34,-0.56l0.3,-0.76Z",
                name: "Georgia"
            },
            "US-AZ": {
                path: "M128.39,384.21l0.44,-1.81l1.29,-1.29l0.54,-1.11l0.48,-0.25l1.66,0.62l0.96,-0.03l0.52,-0.46l0.28,-1.17l1.31,-1.0l0.24,-2.73l-0.46,-1.24l-0.84,-0.66l-2.07,-0.67l-0.3,-0.61l0.8,-2.4l0.0,-1.39l-0.52,-1.2l0.57,-0.86l-0.2,-0.87l1.57,-0.27l2.29,-2.81l0.65,-2.43l0.65,-0.81l0.02,-3.17l0.55,-0.62l-0.29,-1.43l1.71,-1.14l1.03,-1.85l3.16,-1.29l2.03,-1.58l0.26,-0.53l-0.13,-1.04l-3.25,-3.49l-0.51,-0.22l0.22,-1.26l-0.66,-1.46l0.07,-0.91l-0.88,-2.76l-0.84,-0.56l-0.19,-1.65l-0.69,-0.8l0.19,-3.54l0.58,-0.87l-0.3,-0.86l1.04,-0.4l0.4,-1.42l0.14,-3.2l-0.76,-3.66l0.47,-0.88l0.29,-1.67l-0.4,-3.0l0.85,-2.56l-0.8,-1.87l-0.03,-0.92l0.43,-0.52l0.34,-1.35l2.54,-0.63l1.75,0.99l1.43,-0.19l0.96,2.24l0.79,0.71l1.54,0.14l1.01,-0.5l1.02,-2.27l0.94,-1.19l2.57,-16.95l42.43,5.78l42.56,4.67l-11.82,123.66l-36.89,-4.05l-36.34,-18.98l-28.44,-15.56Z",
                name: "Arizona"
            },
            "US-MT": {
                path: "M166.3,57.31l0.69,-0.1l0.33,-0.38l-0.9,-1.99l0.83,-0.96l-0.39,-1.3l0.09,-0.96l-1.24,-1.93l-0.24,-1.49l-1.03,-1.33l-1.19,-2.44l3.53,-20.65l43.66,6.71l43.06,5.23l42.75,3.84l43.15,2.53l-3.53,86.06l-28.11,-1.47l-26.82,-1.91l-26.78,-2.4l-25.84,-2.79l-0.44,0.35l-1.22,10.41l-1.51,-2.01l-0.03,-0.91l-1.19,-2.35l-1.25,-0.74l-1.8,0.92l0.03,1.05l-0.72,0.42l-0.34,1.56l-2.42,-0.41l-1.91,0.57l-0.92,-0.85l-3.36,0.09l-2.38,-0.96l-1.68,0.58l-0.84,1.49l-4.66,-1.6l-1.3,0.37l-1.12,0.9l-0.31,0.67l-1.65,-1.4l0.22,-1.43l-0.9,-1.71l0.4,-0.36l0.07,-0.62l-1.17,-3.08l-1.45,-1.25l-1.44,0.36l-0.21,-0.64l-1.08,-0.9l-0.41,-1.37l0.68,-0.61l0.2,-1.41l-0.77,-2.38l-0.77,-0.35l-0.31,-1.58l-1.51,-2.54l0.23,-1.51l-0.56,-1.26l0.34,-1.4l-0.73,-0.86l0.48,-0.98l-0.21,-0.74l-1.14,-0.75l-0.13,-0.59l-0.85,-0.91l-0.8,-0.4l-0.51,0.37l-0.07,0.74l-0.7,0.27l-1.13,1.22l-1.75,0.37l-1.21,1.07l-1.08,-0.85l-0.64,-1.01l-1.06,-0.44l0.02,-0.86l0.74,-0.63l0.24,-1.06l-0.61,-1.6l0.9,-1.09l1.07,-0.08l0.83,-0.8l-0.26,-1.14l0.38,-1.07l-0.95,-0.81l-0.04,-0.81l0.66,-1.28l-0.59,-1.07l0.74,-0.07l0.38,-0.42l-0.04,-1.77l1.83,-3.73l-0.14,-1.05l0.89,-0.62l0.6,-3.17l-0.78,-0.5l-1.8,0.37l-1.33,-0.11l-0.64,-0.55l0.37,-0.83l-0.62,-0.97l-0.66,-0.23l-0.72,0.35l-0.07,-0.95l-1.74,-1.63l0.04,-1.84l-1.68,-1.82l-0.08,-0.69l-1.55,-2.88l-1.07,-1.29l-0.57,-1.63l-2.35,-1.34l-0.95,-1.95l-1.44,-1.19Z",
                name: "Montana"
            },
            "US-MS": {
                path: "M555.49,431.1l0.67,-0.97l-1.05,-1.76l0.18,-1.63l-0.81,-0.87l1.69,-0.25l0.47,-0.54l0.4,-2.74l-0.77,-1.82l1.56,-1.79l0.25,-3.58l0.74,-2.26l1.89,-1.25l1.15,-1.97l1.4,-1.04l0.34,-0.78l-0.04,-0.99l-0.63,-0.96l1.14,-0.28l0.96,-2.59l0.91,-1.31l-0.16,-0.86l-1.54,-0.43l-0.35,-0.96l-1.83,-1.04l-0.07,-2.14l-0.93,-0.74l-0.45,-0.84l-0.02,-0.37l1.14,-0.29l0.47,-0.69l-0.26,-0.89l-1.41,-0.49l0.23,-1.77l0.98,-1.54l-0.77,-1.06l-1.08,-0.31l-0.15,-2.82l0.9,-0.54l0.23,-0.8l-0.62,-2.52l-1.25,-0.66l0.7,-1.33l-0.07,-2.22l-2.02,-1.52l1.14,-0.47l0.12,-1.41l-1.34,-0.89l1.58,-2.04l0.93,-0.31l0.36,-0.69l-0.52,-1.56l0.42,-1.35l-0.9,-0.89l1.6,-0.83l1.24,-0.27l0.59,-0.77l-0.09,-1.07l-1.41,-0.95l1.39,-1.08l0.62,-1.77l0.5,0.11l0.45,-0.28l0.34,-0.98l-0.2,-0.77l1.48,-0.43l1.22,-1.21l0.07,-3.53l-0.46,-1.53l0.36,-1.78l0.73,0.09l0.68,-0.33l0.42,-0.87l-0.41,-1.06l2.72,-1.71l0.58,-1.06l-0.29,-1.28l36.45,-4.1l0.86,1.26l0.85,0.45l0.99,66.5l5.52,32.95l-0.73,0.69l-1.53,-0.3l-0.91,-0.94l-1.32,1.06l-1.23,0.17l-2.17,-1.26l-1.85,-0.19l-0.83,0.36l-0.34,0.44l0.32,0.41l-0.56,0.36l-3.96,1.66l-0.05,-0.5l-0.96,-0.52l-1.0,0.04l-0.59,1.0l0.76,0.61l-1.59,1.21l-0.32,1.28l-0.69,0.3l-1.34,-0.06l-1.16,-1.86l-0.08,-0.89l-0.92,-1.47l-0.21,-1.01l-1.4,-1.63l-1.16,-0.54l-0.47,-0.78l0.1,-0.62l-0.69,-0.92l0.21,-1.99l0.5,-0.93l0.66,-2.98l-0.06,-1.23l-0.43,-0.29l-34.66,3.41Z",
                name: "Mississippi"
            },
            "US-SC": {
                path: "M697.56,324.11l4.86,-2.69l1.02,-0.05l1.11,-1.38l3.93,-1.9l0.45,-0.88l0.63,0.22l22.71,-3.36l0.07,1.22l0.42,0.57l0.71,0.01l1.21,-1.3l2.82,2.54l0.46,2.48l0.55,0.52l19.74,-3.49l22.74,15.07l0.02,0.55l-2.48,2.18l-2.44,3.67l-2.41,5.72l-0.09,2.74l-1.08,-0.21l0.85,-2.73l-0.64,-0.23l-0.76,0.87l-0.56,1.38l-0.11,1.55l0.84,0.95l1.05,0.23l0.44,0.91l-0.75,0.08l-0.41,0.56l-0.87,0.02l-0.24,0.68l0.94,0.45l-1.1,1.13l-0.07,1.02l-1.34,0.63l-0.5,-0.61l-0.5,-0.08l-1.07,0.87l-0.56,1.76l0.43,0.87l-1.2,1.23l-0.61,1.44l-1.2,1.01l-0.9,-0.4l0.27,-0.6l-0.53,-0.74l-1.38,0.31l-0.11,0.43l0.36,0.77l-0.52,0.03l0.05,0.76l0.72,0.58l1.3,0.43l-0.12,0.39l-0.88,0.94l-1.22,0.23l-0.25,0.51l0.33,0.45l-2.3,1.34l-1.42,-0.85l-0.56,0.11l-0.11,0.67l1.19,0.78l-1.54,1.57l-0.72,-0.75l-0.5,0.52l-0.0,0.74l-0.69,-0.37l-0.85,-0.0l-1.34,-0.84l-0.45,0.5l0.16,0.53l-1.73,0.17l-0.44,0.37l-0.06,0.77l0.65,0.23l1.43,-0.17l-0.26,0.55l0.42,0.25l1.91,-0.15l0.11,0.22l-0.97,0.86l-0.32,0.78l0.57,0.49l0.94,-0.53l0.03,0.21l-1.12,1.09l-0.99,0.43l-0.21,-2.04l-0.69,-0.27l-0.22,-1.55l-0.88,-0.15l-0.31,0.58l0.86,2.7l-1.12,-0.66l-0.63,-1.0l-0.4,-1.76l-0.65,-0.2l-0.52,-0.63l-0.69,0.0l-0.27,0.6l0.84,1.02l0.01,0.68l1.11,1.83l-0.02,0.86l1.22,1.17l-0.62,0.35l0.03,0.98l-1.2,3.56l-1.52,-0.78l-1.52,0.26l-0.97,-0.68l-0.54,-1.03l-0.17,-2.93l-0.86,-0.75l-1.06,-2.47l-1.04,-0.95l-3.23,-1.33l-0.49,-2.65l-1.12,-2.17l-1.43,-1.58l-0.06,-1.07l-0.76,-1.21l-4.82,-1.69l-0.58,-1.27l-1.21,-0.37l0.02,-0.7l-0.53,-0.87l-0.87,0.0l-0.73,-0.61l0.03,-1.21l-0.66,-1.26l-2.7,-1.78l-2.16,-0.52l-2.36,-3.12l-3.93,-1.93l-1.22,-1.03l-0.83,-0.12l-1.05,-1.81l-0.51,-0.22l-0.91,-1.21l-1.18,-0.68l-0.99,-2.42l-1.54,-1.65l-1.02,-1.87l-1.06,-0.37l-1.93,0.37l-0.46,-0.16l-2.75,-2.19l-1.06,0.02l-1.7,-0.74l-0.52,-0.53l0.36,-2.22l0.64,-0.78l0.34,-1.39l1.36,-1.23l0.4,-0.98ZM750.38,375.27l0.73,-0.08l0.51,0.45l-1.23,1.9l0.28,-1.22l-0.3,-1.06Z",
                name: "South Carolina"
            },
            "US-RI": {
                path: "M859.15,133.1l0.33,0.01l1.02,2.65l-0.31,0.56l-1.04,-3.22ZM858.41,136.77l-0.28,-0.34l0.24,-1.5l0.41,1.53l-0.37,0.31ZM851.13,141.49l0.22,-0.46l-0.53,-2.22l-3.14,-10.0l5.61,-1.84l0.76,2.06l0.8,0.25l0.19,0.73l0.08,0.41l-0.77,0.25l0.03,0.29l0.51,1.45l0.59,0.5l-0.6,0.15l-0.46,0.73l0.87,0.97l-0.14,1.22l0.94,2.18l-0.32,2.08l-1.33,0.23l-3.15,2.19l-0.16,-1.21ZM855.93,131.57l0.26,0.1l0.01,0.09l-0.17,-0.08l-0.1,-0.11ZM857.32,132.24l0.23,0.48l-0.2,0.31l-0.04,-0.39l0.01,-0.4ZM855.92,145.03l0.11,0.11l-0.18,0.1l-0.03,-0.14l0.11,-0.07Z",
                name: "Rhode Island"
            },
            "US-CT": {
                path: "M823.44,156.54l2.83,-3.23l-0.07,-0.54l-1.31,-1.25l-3.5,-15.89l9.81,-2.41l0.6,0.46l0.65,-0.26l0.23,-0.58l14.16,-4.0l3.2,10.18l0.47,1.96l-0.04,1.69l-1.65,0.32l-0.91,0.81l-0.69,-0.36l-0.5,0.11l-0.18,0.91l-1.15,0.07l-1.27,1.27l-0.62,-0.14l-0.56,-1.02l-0.89,-0.09l-0.21,0.67l0.75,0.64l0.08,0.54l-0.89,-0.02l-1.02,0.87l-1.65,0.07l-1.15,0.94l-0.86,-0.09l-2.05,0.82l-0.4,-0.68l-0.61,0.11l-0.89,2.12l-0.59,0.29l-0.83,1.29l-0.79,-0.05l-0.94,0.74l-0.2,0.63l-0.53,0.05l-0.88,0.75l-2.77,3.07l-0.96,0.27l-1.24,-1.04Z",
                name: "Connecticut"
            }
        },
        height: 589.0572567800147,
        projection: {
            type: "aea",
            centralMeridian: -100
        },
        width: 900
    })
}, , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , function (t, e, i) {
    "use strict";
    i.r(e);
    var n = {};
    i.r(n), i.d(n, "top", (function () {
        return r
    })), i.d(n, "bottom", (function () {
        return a
    })), i.d(n, "right", (function () {
        return o
    })), i.d(n, "left", (function () {
        return s
    })), i.d(n, "auto", (function () {
        return c
    })), i.d(n, "basePlacements", (function () {
        return u
    })), i.d(n, "start", (function () {
        return h
    })), i.d(n, "end", (function () {
        return d
    })), i.d(n, "clippingParents", (function () {
        return f
    })), i.d(n, "viewport", (function () {
        return p
    })), i.d(n, "popper", (function () {
        return g
    })), i.d(n, "reference", (function () {
        return m
    })), i.d(n, "variationPlacements", (function () {
        return v
    })), i.d(n, "placements", (function () {
        return y
    })), i.d(n, "beforeRead", (function () {
        return b
    })), i.d(n, "read", (function () {
        return x
    })), i.d(n, "afterRead", (function () {
        return w
    })), i.d(n, "beforeMain", (function () {
        return _
    })), i.d(n, "main", (function () {
        return k
    })), i.d(n, "afterMain", (function () {
        return S
    })), i.d(n, "beforeWrite", (function () {
        return A
    })), i.d(n, "write", (function () {
        return M
    })), i.d(n, "afterWrite", (function () {
        return C
    })), i.d(n, "modifierPhases", (function () {
        return E
    })), i.d(n, "applyStyles", (function () {
        return I
    })), i.d(n, "arrow", (function () {
        return Q
    })), i.d(n, "computeStyles", (function () {
        return et
    })), i.d(n, "eventListeners", (function () {
        return nt
    })), i.d(n, "flip", (function () {
        return bt
    })), i.d(n, "hide", (function () {
        return _t
    })), i.d(n, "offset", (function () {
        return kt
    })), i.d(n, "popperOffsets", (function () {
        return St
    })), i.d(n, "preventOverflow", (function () {
        return At
    })), i.d(n, "popperGenerator", (function () {
        return Tt
    })), i.d(n, "detectOverflow", (function () {
        return yt
    })), i.d(n, "createPopperBase", (function () {
        return Pt
    })), i.d(n, "createPopper", (function () {
        return Lt
    })), i.d(n, "createPopperLite", (function () {
        return Dt
    }));
    var l = {};
    i.r(l), i.d(l, "Alert", (function () {
        return we
    })), i.d(l, "Button", (function () {
        return Se
    })), i.d(l, "Carousel", (function () {
        return He
    })), i.d(l, "Collapse", (function () {
        return $e
    })), i.d(l, "Dropdown", (function () {
        return yi
    })), i.d(l, "Modal", (function () {
        return Gi
    })), i.d(l, "Offcanvas", (function () {
        return ln
    })), i.d(l, "Popover", (function () {
        return Pn
    })), i.d(l, "ScrollSpy", (function () {
        return Hn
    })), i.d(l, "Tab", (function () {
        return Zn
    })), i.d(l, "Toast", (function () {
        return el
    })), i.d(l, "Tooltip", (function () {
        return An
    }));
    i(62), i(143);
    var r = "top",
        a = "bottom",
        o = "right",
        s = "left",
        c = "auto",
        u = [r, a, o, s],
        h = "start",
        d = "end",
        f = "clippingParents",
        p = "viewport",
        g = "popper",
        m = "reference",
        v = u.reduce((function (t, e) {
            return t.concat([e + "-" + h, e + "-" + d])
        }), []),
        y = [].concat(u, [c]).reduce((function (t, e) {
            return t.concat([e, e + "-" + h, e + "-" + d])
        }), []),
        b = "beforeRead",
        x = "read",
        w = "afterRead",
        _ = "beforeMain",
        k = "main",
        S = "afterMain",
        A = "beforeWrite",
        M = "write",
        C = "afterWrite",
        E = [b, x, w, _, k, S, A, M, C];

    function O(t) {
        return t ? (t.nodeName || "").toLowerCase() : null
    }

    function T(t) {
        if (null == t) return window;
        if ("[object Window]" !== t.toString()) {
            var e = t.ownerDocument;
            return e && e.defaultView || window
        }
        return t
    }

    function P(t) {
        return t instanceof T(t).Element || t instanceof Element
    }

    function L(t) {
        return t instanceof T(t).HTMLElement || t instanceof HTMLElement
    }

    function D(t) {
        return "undefined" != typeof ShadowRoot && (t instanceof T(t).ShadowRoot || t instanceof ShadowRoot)
    }
    var I = {
        name: "applyStyles",
        enabled: !0,
        phase: "write",
        fn: function (t) {
            var e = t.state;
            Object.keys(e.elements).forEach((function (t) {
                var i = e.styles[t] || {},
                    n = e.attributes[t] || {},
                    l = e.elements[t];
                L(l) && O(l) && (Object.assign(l.style, i), Object.keys(n).forEach((function (t) {
                    var e = n[t];
                    !1 === e ? l.removeAttribute(t) : l.setAttribute(t, !0 === e ? "" : e)
                })))
            }))
        },
        effect: function (t) {
            var e = t.state,
                i = {
                    popper: {
                        position: e.options.strategy,
                        left: "0",
                        top: "0",
                        margin: "0"
                    },
                    arrow: {
                        position: "absolute"
                    },
                    reference: {}
                };
            return Object.assign(e.elements.popper.style, i.popper), e.styles = i, e.elements.arrow && Object.assign(e.elements.arrow.style, i.arrow),
                function () {
                    Object.keys(e.elements).forEach((function (t) {
                        var n = e.elements[t],
                            l = e.attributes[t] || {},
                            r = Object.keys(e.styles.hasOwnProperty(t) ? e.styles[t] : i[t]).reduce((function (t, e) {
                                return t[e] = "", t
                            }), {});
                        L(n) && O(n) && (Object.assign(n.style, r), Object.keys(l).forEach((function (t) {
                            n.removeAttribute(t)
                        })))
                    }))
                }
        },
        requires: ["computeStyles"]
    };

    function j(t) {
        return t.split("-")[0]
    }

    function N(t) {
        var e = t.getBoundingClientRect();
        return {
            width: e.width,
            height: e.height,
            top: e.top,
            right: e.right,
            bottom: e.bottom,
            left: e.left,
            x: e.left,
            y: e.top
        }
    }

    function R(t) {
        var e = N(t),
            i = t.offsetWidth,
            n = t.offsetHeight;
        return Math.abs(e.width - i) <= 1 && (i = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
            x: t.offsetLeft,
            y: t.offsetTop,
            width: i,
            height: n
        }
    }

    function F(t, e) {
        var i = e.getRootNode && e.getRootNode();
        if (t.contains(e)) return !0;
        if (i && D(i)) {
            var n = e;
            do {
                if (n && t.isSameNode(n)) return !0;
                n = n.parentNode || n.host
            } while (n)
        }
        return !1
    }

    function z(t) {
        return T(t).getComputedStyle(t)
    }

    function H(t) {
        return ["table", "td", "th"].indexOf(O(t)) >= 0
    }

    function B(t) {
        return ((P(t) ? t.ownerDocument : t.document) || window.document).documentElement
    }

    function Y(t) {
        return "html" === O(t) ? t : t.assignedSlot || t.parentNode || (D(t) ? t.host : null) || B(t)
    }

    function W(t) {
        return L(t) && "fixed" !== z(t).position ? t.offsetParent : null
    }

    function V(t) {
        for (var e = T(t), i = W(t); i && H(i) && "static" === z(i).position;) i = W(i);
        return i && ("html" === O(i) || "body" === O(i) && "static" === z(i).position) ? e : i || function (t) {
            var e = -1 !== navigator.userAgent.toLowerCase().indexOf("firefox");
            if (-1 !== navigator.userAgent.indexOf("Trident") && L(t) && "fixed" === z(t).position) return null;
            for (var i = Y(t); L(i) && ["html", "body"].indexOf(O(i)) < 0;) {
                var n = z(i);
                if ("none" !== n.transform || "none" !== n.perspective || "paint" === n.contain || -1 !== ["transform", "perspective"].indexOf(n.willChange) || e && "filter" === n.willChange || e && n.filter && "none" !== n.filter) return i;
                i = i.parentNode
            }
            return null
        }(t) || e
    }

    function X(t) {
        return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y"
    }
    var q = Math.max,
        Z = Math.min,
        G = Math.round;

    function U(t, e, i) {
        return q(t, Z(e, i))
    }

    function K(t) {
        return Object.assign({}, {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, t)
    }

    function $(t, e) {
        return e.reduce((function (e, i) {
            return e[i] = t, e
        }), {})
    }
    var Q = {
            name: "arrow",
            enabled: !0,
            phase: "main",
            fn: function (t) {
                var e, i = t.state,
                    n = t.name,
                    l = t.options,
                    c = i.elements.arrow,
                    h = i.modifiersData.popperOffsets,
                    d = j(i.placement),
                    f = X(d),
                    p = [s, o].indexOf(d) >= 0 ? "height" : "width";
                if (c && h) {
                    var g = function (t, e) {
                            return K("number" != typeof (t = "function" == typeof t ? t(Object.assign({}, e.rects, {
                                placement: e.placement
                            })) : t) ? t : $(t, u))
                        }(l.padding, i),
                        m = R(c),
                        v = "y" === f ? r : s,
                        y = "y" === f ? a : o,
                        b = i.rects.reference[p] + i.rects.reference[f] - h[f] - i.rects.popper[p],
                        x = h[f] - i.rects.reference[f],
                        w = V(c),
                        _ = w ? "y" === f ? w.clientHeight || 0 : w.clientWidth || 0 : 0,
                        k = b / 2 - x / 2,
                        S = g[v],
                        A = _ - m[p] - g[y],
                        M = _ / 2 - m[p] / 2 + k,
                        C = U(S, M, A),
                        E = f;
                    i.modifiersData[n] = ((e = {})[E] = C, e.centerOffset = C - M, e)
                }
            },
            effect: function (t) {
                var e = t.state,
                    i = t.options.element,
                    n = void 0 === i ? "[data-popper-arrow]" : i;
                null != n && ("string" != typeof n || (n = e.elements.popper.querySelector(n))) && F(e.elements.popper, n) && (e.elements.arrow = n)
            },
            requires: ["popperOffsets"],
            requiresIfExists: ["preventOverflow"]
        },
        J = {
            top: "auto",
            right: "auto",
            bottom: "auto",
            left: "auto"
        };

    function tt(t) {
        var e, i = t.popper,
            n = t.popperRect,
            l = t.placement,
            c = t.offsets,
            u = t.position,
            h = t.gpuAcceleration,
            d = t.adaptive,
            f = t.roundOffsets,
            p = !0 === f ? function (t) {
                var e = t.x,
                    i = t.y,
                    n = window.devicePixelRatio || 1;
                return {
                    x: G(G(e * n) / n) || 0,
                    y: G(G(i * n) / n) || 0
                }
            }(c) : "function" == typeof f ? f(c) : c,
            g = p.x,
            m = void 0 === g ? 0 : g,
            v = p.y,
            y = void 0 === v ? 0 : v,
            b = c.hasOwnProperty("x"),
            x = c.hasOwnProperty("y"),
            w = s,
            _ = r,
            k = window;
        if (d) {
            var S = V(i),
                A = "clientHeight",
                M = "clientWidth";
            S === T(i) && "static" !== z(S = B(i)).position && (A = "scrollHeight", M = "scrollWidth"), S = S, l === r && (_ = a, y -= S[A] - n.height, y *= h ? 1 : -1), l === s && (w = o, m -= S[M] - n.width, m *= h ? 1 : -1)
        }
        var C, E = Object.assign({
            position: u
        }, d && J);
        return h ? Object.assign({}, E, ((C = {})[_] = x ? "0" : "", C[w] = b ? "0" : "", C.transform = (k.devicePixelRatio || 1) < 2 ? "translate(" + m + "px, " + y + "px)" : "translate3d(" + m + "px, " + y + "px, 0)", C)) : Object.assign({}, E, ((e = {})[_] = x ? y + "px" : "", e[w] = b ? m + "px" : "", e.transform = "", e))
    }
    var et = {
            name: "computeStyles",
            enabled: !0,
            phase: "beforeWrite",
            fn: function (t) {
                var e = t.state,
                    i = t.options,
                    n = i.gpuAcceleration,
                    l = void 0 === n || n,
                    r = i.adaptive,
                    a = void 0 === r || r,
                    o = i.roundOffsets,
                    s = void 0 === o || o,
                    c = {
                        placement: j(e.placement),
                        popper: e.elements.popper,
                        popperRect: e.rects.popper,
                        gpuAcceleration: l
                    };
                null != e.modifiersData.popperOffsets && (e.styles.popper = Object.assign({}, e.styles.popper, tt(Object.assign({}, c, {
                    offsets: e.modifiersData.popperOffsets,
                    position: e.options.strategy,
                    adaptive: a,
                    roundOffsets: s
                })))), null != e.modifiersData.arrow && (e.styles.arrow = Object.assign({}, e.styles.arrow, tt(Object.assign({}, c, {
                    offsets: e.modifiersData.arrow,
                    position: "absolute",
                    adaptive: !1,
                    roundOffsets: s
                })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
                    "data-popper-placement": e.placement
                })
            },
            data: {}
        },
        it = {
            passive: !0
        };
    var nt = {
            name: "eventListeners",
            enabled: !0,
            phase: "write",
            fn: function () {},
            effect: function (t) {
                var e = t.state,
                    i = t.instance,
                    n = t.options,
                    l = n.scroll,
                    r = void 0 === l || l,
                    a = n.resize,
                    o = void 0 === a || a,
                    s = T(e.elements.popper),
                    c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
                return r && c.forEach((function (t) {
                        t.addEventListener("scroll", i.update, it)
                    })), o && s.addEventListener("resize", i.update, it),
                    function () {
                        r && c.forEach((function (t) {
                            t.removeEventListener("scroll", i.update, it)
                        })), o && s.removeEventListener("resize", i.update, it)
                    }
            },
            data: {}
        },
        lt = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };

    function rt(t) {
        return t.replace(/left|right|bottom|top/g, (function (t) {
            return lt[t]
        }))
    }
    var at = {
        start: "end",
        end: "start"
    };

    function ot(t) {
        return t.replace(/start|end/g, (function (t) {
            return at[t]
        }))
    }

    function st(t) {
        var e = T(t);
        return {
            scrollLeft: e.pageXOffset,
            scrollTop: e.pageYOffset
        }
    }

    function ct(t) {
        return N(B(t)).left + st(t).scrollLeft
    }

    function ut(t) {
        var e = z(t),
            i = e.overflow,
            n = e.overflowX,
            l = e.overflowY;
        return /auto|scroll|overlay|hidden/.test(i + l + n)
    }

    function ht(t) {
        return ["html", "body", "#document"].indexOf(O(t)) >= 0 ? t.ownerDocument.body : L(t) && ut(t) ? t : ht(Y(t))
    }

    function dt(t, e) {
        var i;
        void 0 === e && (e = []);
        var n = ht(t),
            l = n === (null == (i = t.ownerDocument) ? void 0 : i.body),
            r = T(n),
            a = l ? [r].concat(r.visualViewport || [], ut(n) ? n : []) : n,
            o = e.concat(a);
        return l ? o : o.concat(dt(Y(a)))
    }

    function ft(t) {
        return Object.assign({}, t, {
            left: t.x,
            top: t.y,
            right: t.x + t.width,
            bottom: t.y + t.height
        })
    }

    function pt(t, e) {
        return e === p ? ft(function (t) {
            var e = T(t),
                i = B(t),
                n = e.visualViewport,
                l = i.clientWidth,
                r = i.clientHeight,
                a = 0,
                o = 0;
            return n && (l = n.width, r = n.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (a = n.offsetLeft, o = n.offsetTop)), {
                width: l,
                height: r,
                x: a + ct(t),
                y: o
            }
        }(t)) : L(e) ? function (t) {
            var e = N(t);
            return e.top = e.top + t.clientTop, e.left = e.left + t.clientLeft, e.bottom = e.top + t.clientHeight, e.right = e.left + t.clientWidth, e.width = t.clientWidth, e.height = t.clientHeight, e.x = e.left, e.y = e.top, e
        }(e) : ft(function (t) {
            var e, i = B(t),
                n = st(t),
                l = null == (e = t.ownerDocument) ? void 0 : e.body,
                r = q(i.scrollWidth, i.clientWidth, l ? l.scrollWidth : 0, l ? l.clientWidth : 0),
                a = q(i.scrollHeight, i.clientHeight, l ? l.scrollHeight : 0, l ? l.clientHeight : 0),
                o = -n.scrollLeft + ct(t),
                s = -n.scrollTop;
            return "rtl" === z(l || i).direction && (o += q(i.clientWidth, l ? l.clientWidth : 0) - r), {
                width: r,
                height: a,
                x: o,
                y: s
            }
        }(B(t)))
    }

    function gt(t, e, i) {
        var n = "clippingParents" === e ? function (t) {
                var e = dt(Y(t)),
                    i = ["absolute", "fixed"].indexOf(z(t).position) >= 0 && L(t) ? V(t) : t;
                return P(i) ? e.filter((function (t) {
                    return P(t) && F(t, i) && "body" !== O(t)
                })) : []
            }(t) : [].concat(e),
            l = [].concat(n, [i]),
            r = l[0],
            a = l.reduce((function (e, i) {
                var n = pt(t, i);
                return e.top = q(n.top, e.top), e.right = Z(n.right, e.right), e.bottom = Z(n.bottom, e.bottom), e.left = q(n.left, e.left), e
            }), pt(t, r));
        return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a
    }

    function mt(t) {
        return t.split("-")[1]
    }

    function vt(t) {
        var e, i = t.reference,
            n = t.element,
            l = t.placement,
            c = l ? j(l) : null,
            u = l ? mt(l) : null,
            f = i.x + i.width / 2 - n.width / 2,
            p = i.y + i.height / 2 - n.height / 2;
        switch (c) {
            case r:
                e = {
                    x: f,
                    y: i.y - n.height
                };
                break;
            case a:
                e = {
                    x: f,
                    y: i.y + i.height
                };
                break;
            case o:
                e = {
                    x: i.x + i.width,
                    y: p
                };
                break;
            case s:
                e = {
                    x: i.x - n.width,
                    y: p
                };
                break;
            default:
                e = {
                    x: i.x,
                    y: i.y
                }
        }
        var g = c ? X(c) : null;
        if (null != g) {
            var m = "y" === g ? "height" : "width";
            switch (u) {
                case h:
                    e[g] = e[g] - (i[m] / 2 - n[m] / 2);
                    break;
                case d:
                    e[g] = e[g] + (i[m] / 2 - n[m] / 2)
            }
        }
        return e
    }

    function yt(t, e) {
        void 0 === e && (e = {});
        var i = e,
            n = i.placement,
            l = void 0 === n ? t.placement : n,
            s = i.boundary,
            c = void 0 === s ? f : s,
            h = i.rootBoundary,
            d = void 0 === h ? p : h,
            v = i.elementContext,
            y = void 0 === v ? g : v,
            b = i.altBoundary,
            x = void 0 !== b && b,
            w = i.padding,
            _ = void 0 === w ? 0 : w,
            k = K("number" != typeof _ ? _ : $(_, u)),
            S = y === g ? m : g,
            A = t.elements.reference,
            M = t.rects.popper,
            C = t.elements[x ? S : y],
            E = gt(P(C) ? C : C.contextElement || B(t.elements.popper), c, d),
            O = N(A),
            T = vt({
                reference: O,
                element: M,
                strategy: "absolute",
                placement: l
            }),
            L = ft(Object.assign({}, M, T)),
            D = y === g ? L : O,
            I = {
                top: E.top - D.top + k.top,
                bottom: D.bottom - E.bottom + k.bottom,
                left: E.left - D.left + k.left,
                right: D.right - E.right + k.right
            },
            j = t.modifiersData.offset;
        if (y === g && j) {
            var R = j[l];
            Object.keys(I).forEach((function (t) {
                var e = [o, a].indexOf(t) >= 0 ? 1 : -1,
                    i = [r, a].indexOf(t) >= 0 ? "y" : "x";
                I[t] += R[i] * e
            }))
        }
        return I
    }
    var bt = {
        name: "flip",
        enabled: !0,
        phase: "main",
        fn: function (t) {
            var e = t.state,
                i = t.options,
                n = t.name;
            if (!e.modifiersData[n]._skip) {
                for (var l = i.mainAxis, d = void 0 === l || l, f = i.altAxis, p = void 0 === f || f, g = i.fallbackPlacements, m = i.padding, b = i.boundary, x = i.rootBoundary, w = i.altBoundary, _ = i.flipVariations, k = void 0 === _ || _, S = i.allowedAutoPlacements, A = e.options.placement, M = j(A), C = g || (M === A || !k ? [rt(A)] : function (t) {
                        if (j(t) === c) return [];
                        var e = rt(t);
                        return [ot(t), e, ot(e)]
                    }(A)), E = [A].concat(C).reduce((function (t, i) {
                        return t.concat(j(i) === c ? function (t, e) {
                            void 0 === e && (e = {});
                            var i = e,
                                n = i.placement,
                                l = i.boundary,
                                r = i.rootBoundary,
                                a = i.padding,
                                o = i.flipVariations,
                                s = i.allowedAutoPlacements,
                                c = void 0 === s ? y : s,
                                h = mt(n),
                                d = h ? o ? v : v.filter((function (t) {
                                    return mt(t) === h
                                })) : u,
                                f = d.filter((function (t) {
                                    return c.indexOf(t) >= 0
                                }));
                            0 === f.length && (f = d);
                            var p = f.reduce((function (e, i) {
                                return e[i] = yt(t, {
                                    placement: i,
                                    boundary: l,
                                    rootBoundary: r,
                                    padding: a
                                })[j(i)], e
                            }), {});
                            return Object.keys(p).sort((function (t, e) {
                                return p[t] - p[e]
                            }))
                        }(e, {
                            placement: i,
                            boundary: b,
                            rootBoundary: x,
                            padding: m,
                            flipVariations: k,
                            allowedAutoPlacements: S
                        }) : i)
                    }), []), O = e.rects.reference, T = e.rects.popper, P = new Map, L = !0, D = E[0], I = 0; I < E.length; I++) {
                    var N = E[I],
                        R = j(N),
                        F = mt(N) === h,
                        z = [r, a].indexOf(R) >= 0,
                        H = z ? "width" : "height",
                        B = yt(e, {
                            placement: N,
                            boundary: b,
                            rootBoundary: x,
                            altBoundary: w,
                            padding: m
                        }),
                        Y = z ? F ? o : s : F ? a : r;
                    O[H] > T[H] && (Y = rt(Y));
                    var W = rt(Y),
                        V = [];
                    if (d && V.push(B[R] <= 0), p && V.push(B[Y] <= 0, B[W] <= 0), V.every((function (t) {
                            return t
                        }))) {
                        D = N, L = !1;
                        break
                    }
                    P.set(N, V)
                }
                if (L)
                    for (var X = function (t) {
                            var e = E.find((function (e) {
                                var i = P.get(e);
                                if (i) return i.slice(0, t).every((function (t) {
                                    return t
                                }))
                            }));
                            if (e) return D = e, "break"
                        }, q = k ? 3 : 1; q > 0; q--) {
                        if ("break" === X(q)) break
                    }
                e.placement !== D && (e.modifiersData[n]._skip = !0, e.placement = D, e.reset = !0)
            }
        },
        requiresIfExists: ["offset"],
        data: {
            _skip: !1
        }
    };

    function xt(t, e, i) {
        return void 0 === i && (i = {
            x: 0,
            y: 0
        }), {
            top: t.top - e.height - i.y,
            right: t.right - e.width + i.x,
            bottom: t.bottom - e.height + i.y,
            left: t.left - e.width - i.x
        }
    }

    function wt(t) {
        return [r, o, a, s].some((function (e) {
            return t[e] >= 0
        }))
    }
    var _t = {
        name: "hide",
        enabled: !0,
        phase: "main",
        requiresIfExists: ["preventOverflow"],
        fn: function (t) {
            var e = t.state,
                i = t.name,
                n = e.rects.reference,
                l = e.rects.popper,
                r = e.modifiersData.preventOverflow,
                a = yt(e, {
                    elementContext: "reference"
                }),
                o = yt(e, {
                    altBoundary: !0
                }),
                s = xt(a, n),
                c = xt(o, l, r),
                u = wt(s),
                h = wt(c);
            e.modifiersData[i] = {
                referenceClippingOffsets: s,
                popperEscapeOffsets: c,
                isReferenceHidden: u,
                hasPopperEscaped: h
            }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
                "data-popper-reference-hidden": u,
                "data-popper-escaped": h
            })
        }
    };
    var kt = {
        name: "offset",
        enabled: !0,
        phase: "main",
        requires: ["popperOffsets"],
        fn: function (t) {
            var e = t.state,
                i = t.options,
                n = t.name,
                l = i.offset,
                a = void 0 === l ? [0, 0] : l,
                c = y.reduce((function (t, i) {
                    return t[i] = function (t, e, i) {
                        var n = j(t),
                            l = [s, r].indexOf(n) >= 0 ? -1 : 1,
                            a = "function" == typeof i ? i(Object.assign({}, e, {
                                placement: t
                            })) : i,
                            c = a[0],
                            u = a[1];
                        return c = c || 0, u = (u || 0) * l, [s, o].indexOf(n) >= 0 ? {
                            x: u,
                            y: c
                        } : {
                            x: c,
                            y: u
                        }
                    }(i, e.rects, a), t
                }), {}),
                u = c[e.placement],
                h = u.x,
                d = u.y;
            null != e.modifiersData.popperOffsets && (e.modifiersData.popperOffsets.x += h, e.modifiersData.popperOffsets.y += d), e.modifiersData[n] = c
        }
    };
    var St = {
        name: "popperOffsets",
        enabled: !0,
        phase: "read",
        fn: function (t) {
            var e = t.state,
                i = t.name;
            e.modifiersData[i] = vt({
                reference: e.rects.reference,
                element: e.rects.popper,
                strategy: "absolute",
                placement: e.placement
            })
        },
        data: {}
    };
    var At = {
        name: "preventOverflow",
        enabled: !0,
        phase: "main",
        fn: function (t) {
            var e = t.state,
                i = t.options,
                n = t.name,
                l = i.mainAxis,
                c = void 0 === l || l,
                u = i.altAxis,
                d = void 0 !== u && u,
                f = i.boundary,
                p = i.rootBoundary,
                g = i.altBoundary,
                m = i.padding,
                v = i.tether,
                y = void 0 === v || v,
                b = i.tetherOffset,
                x = void 0 === b ? 0 : b,
                w = yt(e, {
                    boundary: f,
                    rootBoundary: p,
                    padding: m,
                    altBoundary: g
                }),
                _ = j(e.placement),
                k = mt(e.placement),
                S = !k,
                A = X(_),
                M = "x" === A ? "y" : "x",
                C = e.modifiersData.popperOffsets,
                E = e.rects.reference,
                O = e.rects.popper,
                T = "function" == typeof x ? x(Object.assign({}, e.rects, {
                    placement: e.placement
                })) : x,
                P = {
                    x: 0,
                    y: 0
                };
            if (C) {
                if (c || d) {
                    var L = "y" === A ? r : s,
                        D = "y" === A ? a : o,
                        I = "y" === A ? "height" : "width",
                        N = C[A],
                        F = C[A] + w[L],
                        z = C[A] - w[D],
                        H = y ? -O[I] / 2 : 0,
                        B = k === h ? E[I] : O[I],
                        Y = k === h ? -O[I] : -E[I],
                        W = e.elements.arrow,
                        G = y && W ? R(W) : {
                            width: 0,
                            height: 0
                        },
                        K = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        $ = K[L],
                        Q = K[D],
                        J = U(0, E[I], G[I]),
                        tt = S ? E[I] / 2 - H - J - $ - T : B - J - $ - T,
                        et = S ? -E[I] / 2 + H + J + Q + T : Y + J + Q + T,
                        it = e.elements.arrow && V(e.elements.arrow),
                        nt = it ? "y" === A ? it.clientTop || 0 : it.clientLeft || 0 : 0,
                        lt = e.modifiersData.offset ? e.modifiersData.offset[e.placement][A] : 0,
                        rt = C[A] + tt - lt - nt,
                        at = C[A] + et - lt;
                    if (c) {
                        var ot = U(y ? Z(F, rt) : F, N, y ? q(z, at) : z);
                        C[A] = ot, P[A] = ot - N
                    }
                    if (d) {
                        var st = "x" === A ? r : s,
                            ct = "x" === A ? a : o,
                            ut = C[M],
                            ht = ut + w[st],
                            dt = ut - w[ct],
                            ft = U(y ? Z(ht, rt) : ht, ut, y ? q(dt, at) : dt);
                        C[M] = ft, P[M] = ft - ut
                    }
                }
                e.modifiersData[n] = P
            }
        },
        requiresIfExists: ["offset"]
    };

    function Mt(t, e, i) {
        void 0 === i && (i = !1);
        var n, l, r = B(e),
            a = N(t),
            o = L(e),
            s = {
                scrollLeft: 0,
                scrollTop: 0
            },
            c = {
                x: 0,
                y: 0
            };
        return (o || !o && !i) && (("body" !== O(e) || ut(r)) && (s = (n = e) !== T(n) && L(n) ? {
            scrollLeft: (l = n).scrollLeft,
            scrollTop: l.scrollTop
        } : st(n)), L(e) ? ((c = N(e)).x += e.clientLeft, c.y += e.clientTop) : r && (c.x = ct(r))), {
            x: a.left + s.scrollLeft - c.x,
            y: a.top + s.scrollTop - c.y,
            width: a.width,
            height: a.height
        }
    }

    function Ct(t) {
        var e = new Map,
            i = new Set,
            n = [];

        function l(t) {
            i.add(t.name), [].concat(t.requires || [], t.requiresIfExists || []).forEach((function (t) {
                if (!i.has(t)) {
                    var n = e.get(t);
                    n && l(n)
                }
            })), n.push(t)
        }
        return t.forEach((function (t) {
            e.set(t.name, t)
        })), t.forEach((function (t) {
            i.has(t.name) || l(t)
        })), n
    }
    var Et = {
        placement: "bottom",
        modifiers: [],
        strategy: "absolute"
    };

    function Ot() {
        for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
        return !e.some((function (t) {
            return !(t && "function" == typeof t.getBoundingClientRect)
        }))
    }

    function Tt(t) {
        void 0 === t && (t = {});
        var e = t,
            i = e.defaultModifiers,
            n = void 0 === i ? [] : i,
            l = e.defaultOptions,
            r = void 0 === l ? Et : l;
        return function (t, e, i) {
            void 0 === i && (i = r);
            var l, a, o = {
                    placement: "bottom",
                    orderedModifiers: [],
                    options: Object.assign({}, Et, r),
                    modifiersData: {},
                    elements: {
                        reference: t,
                        popper: e
                    },
                    attributes: {},
                    styles: {}
                },
                s = [],
                c = !1,
                u = {
                    state: o,
                    setOptions: function (i) {
                        h(), o.options = Object.assign({}, r, o.options, i), o.scrollParents = {
                            reference: P(t) ? dt(t) : t.contextElement ? dt(t.contextElement) : [],
                            popper: dt(e)
                        };
                        var l = function (t) {
                            var e = Ct(t);
                            return E.reduce((function (t, i) {
                                return t.concat(e.filter((function (t) {
                                    return t.phase === i
                                })))
                            }), [])
                        }(function (t) {
                            var e = t.reduce((function (t, e) {
                                var i = t[e.name];
                                return t[e.name] = i ? Object.assign({}, i, e, {
                                    options: Object.assign({}, i.options, e.options),
                                    data: Object.assign({}, i.data, e.data)
                                }) : e, t
                            }), {});
                            return Object.keys(e).map((function (t) {
                                return e[t]
                            }))
                        }([].concat(n, o.options.modifiers)));
                        return o.orderedModifiers = l.filter((function (t) {
                            return t.enabled
                        })), o.orderedModifiers.forEach((function (t) {
                            var e = t.name,
                                i = t.options,
                                n = void 0 === i ? {} : i,
                                l = t.effect;
                            if ("function" == typeof l) {
                                var r = l({
                                        state: o,
                                        name: e,
                                        instance: u,
                                        options: n
                                    }),
                                    a = function () {};
                                s.push(r || a)
                            }
                        })), u.update()
                    },
                    forceUpdate: function () {
                        if (!c) {
                            var t = o.elements,
                                e = t.reference,
                                i = t.popper;
                            if (Ot(e, i)) {
                                o.rects = {
                                    reference: Mt(e, V(i), "fixed" === o.options.strategy),
                                    popper: R(i)
                                }, o.reset = !1, o.placement = o.options.placement, o.orderedModifiers.forEach((function (t) {
                                    return o.modifiersData[t.name] = Object.assign({}, t.data)
                                }));
                                for (var n = 0; n < o.orderedModifiers.length; n++)
                                    if (!0 !== o.reset) {
                                        var l = o.orderedModifiers[n],
                                            r = l.fn,
                                            a = l.options,
                                            s = void 0 === a ? {} : a,
                                            h = l.name;
                                        "function" == typeof r && (o = r({
                                            state: o,
                                            options: s,
                                            name: h,
                                            instance: u
                                        }) || o)
                                    } else o.reset = !1, n = -1
                            }
                        }
                    },
                    update: (l = function () {
                        return new Promise((function (t) {
                            u.forceUpdate(), t(o)
                        }))
                    }, function () {
                        return a || (a = new Promise((function (t) {
                            Promise.resolve().then((function () {
                                a = void 0, t(l())
                            }))
                        }))), a
                    }),
                    destroy: function () {
                        h(), c = !0
                    }
                };
            if (!Ot(t, e)) return u;

            function h() {
                s.forEach((function (t) {
                    return t()
                })), s = []
            }
            return u.setOptions(i).then((function (t) {
                !c && i.onFirstUpdate && i.onFirstUpdate(t)
            })), u
        }
    }
    var Pt = Tt(),
        Lt = Tt({
            defaultModifiers: [nt, St, et, I, kt, bt, At, Q, _t]
        }),
        Dt = Tt({
            defaultModifiers: [nt, St, et, I]
        });
    const It = {
            find: (t, e = document.documentElement) => [].concat(...Element.prototype.querySelectorAll.call(e, t)),
            findOne: (t, e = document.documentElement) => Element.prototype.querySelector.call(e, t),
            children: (t, e) => [].concat(...t.children).filter((t => t.matches(e))),
            parents(t, e) {
                const i = [];
                let n = t.parentNode;
                for (; n && n.nodeType === Node.ELEMENT_NODE && 3 !== n.nodeType;) n.matches(e) && i.push(n), n = n.parentNode;
                return i
            },
            prev(t, e) {
                let i = t.previousElementSibling;
                for (; i;) {
                    if (i.matches(e)) return [i];
                    i = i.previousElementSibling
                }
                return []
            },
            next(t, e) {
                let i = t.nextElementSibling;
                for (; i;) {
                    if (i.matches(e)) return [i];
                    i = i.nextElementSibling
                }
                return []
            }
        },
        jt = "transitionend",
        Nt = t => {
            do {
                t += Math.floor(1e6 * Math.random())
            } while (document.getElementById(t));
            return t
        },
        Rt = t => {
            let e = t.getAttribute("data-bs-target");
            if (!e || "#" === e) {
                let i = t.getAttribute("href");
                if (!i || !i.includes("#") && !i.startsWith(".")) return null;
                i.includes("#") && !i.startsWith("#") && (i = `#${i.split("#")[1]}`), e = i && "#" !== i ? i.trim() : null
            }
            return e
        },
        Ft = t => {
            const e = Rt(t);
            return e && document.querySelector(e) ? e : null
        },
        zt = t => {
            const e = Rt(t);
            return e ? document.querySelector(e) : null
        },
        Ht = t => {
            if (!t) return 0;
            let {
                transitionDuration: e,
                transitionDelay: i
            } = window.getComputedStyle(t);
            const n = Number.parseFloat(e),
                l = Number.parseFloat(i);
            return n || l ? (e = e.split(",")[0], i = i.split(",")[0], 1e3 * (Number.parseFloat(e) + Number.parseFloat(i))) : 0
        },
        Bt = t => {
            t.dispatchEvent(new Event(jt))
        },
        Yt = t => !(!t || "object" != typeof t) && (void 0 !== t.jquery && (t = t[0]), void 0 !== t.nodeType),
        Wt = t => Yt(t) ? t.jquery ? t[0] : t : "string" == typeof t && t.length > 0 ? It.findOne(t) : null,
        Vt = (t, e) => {
            let i = !1;
            const n = e + 5;
            t.addEventListener(jt, (function e() {
                i = !0, t.removeEventListener(jt, e)
            })), setTimeout((() => {
                i || Bt(t)
            }), n)
        },
        Xt = (t, e, i) => {
            Object.keys(i).forEach((n => {
                const l = i[n],
                    r = e[n],
                    a = r && Yt(r) ? "element" : null == (o = r) ? `${o}` : {}.toString.call(o).match(/\s([a-z]+)/i)[1].toLowerCase();
                var o;
                if (!new RegExp(l).test(a)) throw new TypeError(`${t.toUpperCase()}: Option "${n}" provided type "${a}" but expected type "${l}".`)
            }))
        },
        qt = t => {
            if (!t) return !1;
            if (t.style && t.parentNode && t.parentNode.style) {
                const e = getComputedStyle(t),
                    i = getComputedStyle(t.parentNode);
                return "none" !== e.display && "none" !== i.display && "hidden" !== e.visibility
            }
            return !1
        },
        Zt = t => !t || t.nodeType !== Node.ELEMENT_NODE || (!!t.classList.contains("disabled") || (void 0 !== t.disabled ? t.disabled : t.hasAttribute("disabled") && "false" !== t.getAttribute("disabled"))),
        Gt = t => {
            if (!document.documentElement.attachShadow) return null;
            if ("function" == typeof t.getRootNode) {
                const e = t.getRootNode();
                return e instanceof ShadowRoot ? e : null
            }
            return t instanceof ShadowRoot ? t : t.parentNode ? Gt(t.parentNode) : null
        },
        Ut = () => {},
        Kt = t => t.offsetHeight,
        $t = () => {
            const {
                jQuery: t
            } = window;
            return t && !document.body.hasAttribute("data-bs-no-jquery") ? t : null
        },
        Qt = () => "rtl" === document.documentElement.dir,
        Jt = t => {
            var e;
            e = () => {
                const e = $t();
                if (e) {
                    const i = t.NAME,
                        n = e.fn[i];
                    e.fn[i] = t.jQueryInterface, e.fn[i].Constructor = t, e.fn[i].noConflict = () => (e.fn[i] = n, t.jQueryInterface)
                }
            }, "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", e) : e()
        },
        te = t => {
            "function" == typeof t && t()
        },
        ee = new Map;
    var ie = {
        set(t, e, i) {
            ee.has(t) || ee.set(t, new Map);
            const n = ee.get(t);
            n.has(e) || 0 === n.size ? n.set(e, i) : console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`)
        },
        get: (t, e) => ee.has(t) && ee.get(t).get(e) || null,
        remove(t, e) {
            if (!ee.has(t)) return;
            const i = ee.get(t);
            i.delete(e), 0 === i.size && ee.delete(t)
        }
    };
    const ne = /[^.]*(?=\..*)\.|.*/,
        le = /\..*/,
        re = /::\d+$/,
        ae = {};
    let oe = 1;
    const se = {
            mouseenter: "mouseover",
            mouseleave: "mouseout"
        },
        ce = /^(mouseenter|mouseleave)/i,
        ue = new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);

    function he(t, e) {
        return e && `${e}::${oe++}` || t.uidEvent || oe++
    }

    function de(t) {
        const e = he(t);
        return t.uidEvent = e, ae[e] = ae[e] || {}, ae[e]
    }

    function fe(t, e, i = null) {
        const n = Object.keys(t);
        for (let l = 0, r = n.length; l < r; l++) {
            const r = t[n[l]];
            if (r.originalHandler === e && r.delegationSelector === i) return r
        }
        return null
    }

    function pe(t, e, i) {
        const n = "string" == typeof e,
            l = n ? i : e;
        let r = ve(t);
        return ue.has(r) || (r = t), [n, l, r]
    }

    function ge(t, e, i, n, l) {
        if ("string" != typeof e || !t) return;
        if (i || (i = n, n = null), ce.test(e)) {
            const t = t => function (e) {
                if (!e.relatedTarget || e.relatedTarget !== e.delegateTarget && !e.delegateTarget.contains(e.relatedTarget)) return t.call(this, e)
            };
            n ? n = t(n) : i = t(i)
        }
        const [r, a, o] = pe(e, i, n), s = de(t), c = s[o] || (s[o] = {}), u = fe(c, a, r ? i : null);
        if (u) return void(u.oneOff = u.oneOff && l);
        const h = he(a, e.replace(ne, "")),
            d = r ? function (t, e, i) {
                return function n(l) {
                    const r = t.querySelectorAll(e);
                    for (let {
                            target: a
                        } = l; a && a !== this; a = a.parentNode)
                        for (let o = r.length; o--;)
                            if (r[o] === a) return l.delegateTarget = a, n.oneOff && ye.off(t, l.type, e, i), i.apply(a, [l]);
                    return null
                }
            }(t, i, n) : function (t, e) {
                return function i(n) {
                    return n.delegateTarget = t, i.oneOff && ye.off(t, n.type, e), e.apply(t, [n])
                }
            }(t, i);
        d.delegationSelector = r ? i : null, d.originalHandler = a, d.oneOff = l, d.uidEvent = h, c[h] = d, t.addEventListener(o, d, r)
    }

    function me(t, e, i, n, l) {
        const r = fe(e[i], n, l);
        r && (t.removeEventListener(i, r, Boolean(l)), delete e[i][r.uidEvent])
    }

    function ve(t) {
        return t = t.replace(le, ""), se[t] || t
    }
    const ye = {
        on(t, e, i, n) {
            ge(t, e, i, n, !1)
        },
        one(t, e, i, n) {
            ge(t, e, i, n, !0)
        },
        off(t, e, i, n) {
            if ("string" != typeof e || !t) return;
            const [l, r, a] = pe(e, i, n), o = a !== e, s = de(t), c = e.startsWith(".");
            if (void 0 !== r) {
                if (!s || !s[a]) return;
                return void me(t, s, a, r, l ? i : null)
            }
            c && Object.keys(s).forEach((i => {
                ! function (t, e, i, n) {
                    const l = e[i] || {};
                    Object.keys(l).forEach((r => {
                        if (r.includes(n)) {
                            const n = l[r];
                            me(t, e, i, n.originalHandler, n.delegationSelector)
                        }
                    }))
                }(t, s, i, e.slice(1))
            }));
            const u = s[a] || {};
            Object.keys(u).forEach((i => {
                const n = i.replace(re, "");
                if (!o || e.includes(n)) {
                    const e = u[i];
                    me(t, s, a, e.originalHandler, e.delegationSelector)
                }
            }))
        },
        trigger(t, e, i) {
            if ("string" != typeof e || !t) return null;
            const n = $t(),
                l = ve(e),
                r = e !== l,
                a = ue.has(l);
            let o, s = !0,
                c = !0,
                u = !1,
                h = null;
            return r && n && (o = n.Event(e, i), n(t).trigger(o), s = !o.isPropagationStopped(), c = !o.isImmediatePropagationStopped(), u = o.isDefaultPrevented()), a ? (h = document.createEvent("HTMLEvents"), h.initEvent(l, s, !0)) : h = new CustomEvent(e, {
                bubbles: s,
                cancelable: !0
            }), void 0 !== i && Object.keys(i).forEach((t => {
                Object.defineProperty(h, t, {
                    get: () => i[t]
                })
            })), u && h.preventDefault(), c && t.dispatchEvent(h), h.defaultPrevented && void 0 !== o && o.preventDefault(), h
        }
    };
    class be {
        constructor(t) {
            (t = Wt(t)) && (this._element = t, ie.set(this._element, this.constructor.DATA_KEY, this))
        }
        dispose() {
            ie.remove(this._element, this.constructor.DATA_KEY), ye.off(this._element, this.constructor.EVENT_KEY), Object.getOwnPropertyNames(this).forEach((t => {
                this[t] = null
            }))
        }
        _queueCallback(t, e, i = !0) {
            if (!i) return void te(t);
            const n = Ht(e);
            ye.one(e, "transitionend", (() => te(t))), Vt(e, n)
        }
        static getInstance(t) {
            return ie.get(t, this.DATA_KEY)
        }
        static get VERSION() {
            return "5.0.1"
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!')
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`
        }
    }
    const xe = "bs.alert";
    class we extends be {
        static get NAME() {
            return "alert"
        }
        close(t) {
            const e = t ? this._getRootElement(t) : this._element,
                i = this._triggerCloseEvent(e);
            null === i || i.defaultPrevented || this._removeElement(e)
        }
        _getRootElement(t) {
            return zt(t) || t.closest(".alert")
        }
        _triggerCloseEvent(t) {
            return ye.trigger(t, "close.bs.alert")
        }
        _removeElement(t) {
            t.classList.remove("show");
            const e = t.classList.contains("fade");
            this._queueCallback((() => this._destroyElement(t)), t, e)
        }
        _destroyElement(t) {
            t.parentNode && t.parentNode.removeChild(t), ye.trigger(t, "closed.bs.alert")
        }
        static jQueryInterface(t) {
            return this.each((function () {
                let e = ie.get(this, xe);
                e || (e = new we(this)), "close" === t && e[t](this)
            }))
        }
        static handleDismiss(t) {
            return function (e) {
                e && e.preventDefault(), t.close(this)
            }
        }
    }
    ye.on(document, "click.bs.alert.data-api", '[data-bs-dismiss="alert"]', we.handleDismiss(new we)), Jt(we);
    const _e = "bs.button",
        ke = '[data-bs-toggle="button"]';
    class Se extends be {
        static get NAME() {
            return "button"
        }
        toggle() {
            this._element.setAttribute("aria-pressed", this._element.classList.toggle("active"))
        }
        static jQueryInterface(t) {
            return this.each((function () {
                let e = ie.get(this, _e);
                e || (e = new Se(this)), "toggle" === t && e[t]()
            }))
        }
    }

    function Ae(t) {
        return "true" === t || "false" !== t && (t === Number(t).toString() ? Number(t) : "" === t || "null" === t ? null : t)
    }

    function Me(t) {
        return t.replace(/[A-Z]/g, (t => `-${t.toLowerCase()}`))
    }
    ye.on(document, "click.bs.button.data-api", ke, (t => {
        t.preventDefault();
        const e = t.target.closest(ke);
        let i = ie.get(e, _e);
        i || (i = new Se(e)), i.toggle()
    })), Jt(Se);
    const Ce = {
            setDataAttribute(t, e, i) {
                t.setAttribute(`data-bs-${Me(e)}`, i)
            },
            removeDataAttribute(t, e) {
                t.removeAttribute(`data-bs-${Me(e)}`)
            },
            getDataAttributes(t) {
                if (!t) return {};
                const e = {};
                return Object.keys(t.dataset).filter((t => t.startsWith("bs"))).forEach((i => {
                    let n = i.replace(/^bs/, "");
                    n = n.charAt(0).toLowerCase() + n.slice(1, n.length), e[n] = Ae(t.dataset[i])
                })), e
            },
            getDataAttribute: (t, e) => Ae(t.getAttribute(`data-bs-${Me(e)}`)),
            offset(t) {
                const e = t.getBoundingClientRect();
                return {
                    top: e.top + document.body.scrollTop,
                    left: e.left + document.body.scrollLeft
                }
            },
            position: t => ({
                top: t.offsetTop,
                left: t.offsetLeft
            })
        },
        Ee = "carousel",
        Oe = "bs.carousel",
        Te = {
            interval: 5e3,
            keyboard: !0,
            slide: !1,
            pause: "hover",
            wrap: !0,
            touch: !0
        },
        Pe = {
            interval: "(number|boolean)",
            keyboard: "boolean",
            slide: "(boolean|string)",
            pause: "(string|boolean)",
            wrap: "boolean",
            touch: "boolean"
        },
        Le = "next",
        De = "prev",
        Ie = "left",
        je = "right",
        Ne = "slid.bs.carousel",
        Re = "active",
        Fe = ".active.carousel-item",
        ze = "touch";
    class He extends be {
        constructor(t, e) {
            super(t), this._items = null, this._interval = null, this._activeElement = null, this._isPaused = !1, this._isSliding = !1, this.touchTimeout = null, this.touchStartX = 0, this.touchDeltaX = 0, this._config = this._getConfig(e), this._indicatorsElement = It.findOne(".carousel-indicators", this._element), this._touchSupported = "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0, this._pointerEvent = Boolean(window.PointerEvent), this._addEventListeners()
        }
        static get Default() {
            return Te
        }
        static get NAME() {
            return Ee
        }
        next() {
            this._isSliding || this._slide(Le)
        }
        nextWhenVisible() {
            !document.hidden && qt(this._element) && this.next()
        }
        prev() {
            this._isSliding || this._slide(De)
        }
        pause(t) {
            t || (this._isPaused = !0), It.findOne(".carousel-item-next, .carousel-item-prev", this._element) && (Bt(this._element), this.cycle(!0)), clearInterval(this._interval), this._interval = null
        }
        cycle(t) {
            t || (this._isPaused = !1), this._interval && (clearInterval(this._interval), this._interval = null), this._config && this._config.interval && !this._isPaused && (this._updateInterval(), this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval))
        }
        to(t) {
            this._activeElement = It.findOne(Fe, this._element);
            const e = this._getItemIndex(this._activeElement);
            if (t > this._items.length - 1 || t < 0) return;
            if (this._isSliding) return void ye.one(this._element, Ne, (() => this.to(t)));
            if (e === t) return this.pause(), void this.cycle();
            const i = t > e ? Le : De;
            this._slide(i, this._items[t])
        }
        _getConfig(t) {
            return t = {
                ...Te,
                ...t
            }, Xt(Ee, t, Pe), t
        }
        _handleSwipe() {
            const t = Math.abs(this.touchDeltaX);
            if (t <= 40) return;
            const e = t / this.touchDeltaX;
            this.touchDeltaX = 0, e && this._slide(e > 0 ? je : Ie)
        }
        _addEventListeners() {
            this._config.keyboard && ye.on(this._element, "keydown.bs.carousel", (t => this._keydown(t))), "hover" === this._config.pause && (ye.on(this._element, "mouseenter.bs.carousel", (t => this.pause(t))), ye.on(this._element, "mouseleave.bs.carousel", (t => this.cycle(t)))), this._config.touch && this._touchSupported && this._addTouchEventListeners()
        }
        _addTouchEventListeners() {
            const t = t => {
                    !this._pointerEvent || "pen" !== t.pointerType && t.pointerType !== ze ? this._pointerEvent || (this.touchStartX = t.touches[0].clientX) : this.touchStartX = t.clientX
                },
                e = t => {
                    this.touchDeltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this.touchStartX
                },
                i = t => {
                    !this._pointerEvent || "pen" !== t.pointerType && t.pointerType !== ze || (this.touchDeltaX = t.clientX - this.touchStartX), this._handleSwipe(), "hover" === this._config.pause && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout((t => this.cycle(t)), 500 + this._config.interval))
                };
            It.find(".carousel-item img", this._element).forEach((t => {
                ye.on(t, "dragstart.bs.carousel", (t => t.preventDefault()))
            })), this._pointerEvent ? (ye.on(this._element, "pointerdown.bs.carousel", (e => t(e))), ye.on(this._element, "pointerup.bs.carousel", (t => i(t))), this._element.classList.add("pointer-event")) : (ye.on(this._element, "touchstart.bs.carousel", (e => t(e))), ye.on(this._element, "touchmove.bs.carousel", (t => e(t))), ye.on(this._element, "touchend.bs.carousel", (t => i(t))))
        }
        _keydown(t) {
            /input|textarea/i.test(t.target.tagName) || ("ArrowLeft" === t.key ? (t.preventDefault(), this._slide(je)) : "ArrowRight" === t.key && (t.preventDefault(), this._slide(Ie)))
        }
        _getItemIndex(t) {
            return this._items = t && t.parentNode ? It.find(".carousel-item", t.parentNode) : [], this._items.indexOf(t)
        }
        _getItemByOrder(t, e) {
            const i = t === Le,
                n = t === De,
                l = this._getItemIndex(e),
                r = this._items.length - 1;
            if ((n && 0 === l || i && l === r) && !this._config.wrap) return e;
            const a = (l + (n ? -1 : 1)) % this._items.length;
            return -1 === a ? this._items[this._items.length - 1] : this._items[a]
        }
        _triggerSlideEvent(t, e) {
            const i = this._getItemIndex(t),
                n = this._getItemIndex(It.findOne(Fe, this._element));
            return ye.trigger(this._element, "slide.bs.carousel", {
                relatedTarget: t,
                direction: e,
                from: n,
                to: i
            })
        }
        _setActiveIndicatorElement(t) {
            if (this._indicatorsElement) {
                const e = It.findOne(".active", this._indicatorsElement);
                e.classList.remove(Re), e.removeAttribute("aria-current");
                const i = It.find("[data-bs-target]", this._indicatorsElement);
                for (let e = 0; e < i.length; e++)
                    if (Number.parseInt(i[e].getAttribute("data-bs-slide-to"), 10) === this._getItemIndex(t)) {
                        i[e].classList.add(Re), i[e].setAttribute("aria-current", "true");
                        break
                    }
            }
        }
        _updateInterval() {
            const t = this._activeElement || It.findOne(Fe, this._element);
            if (!t) return;
            const e = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
            e ? (this._config.defaultInterval = this._config.defaultInterval || this._config.interval, this._config.interval = e) : this._config.interval = this._config.defaultInterval || this._config.interval
        }
        _slide(t, e) {
            const i = this._directionToOrder(t),
                n = It.findOne(Fe, this._element),
                l = this._getItemIndex(n),
                r = e || this._getItemByOrder(i, n),
                a = this._getItemIndex(r),
                o = Boolean(this._interval),
                s = i === Le,
                c = s ? "carousel-item-start" : "carousel-item-end",
                u = s ? "carousel-item-next" : "carousel-item-prev",
                h = this._orderToDirection(i);
            if (r && r.classList.contains(Re)) return void(this._isSliding = !1);
            if (this._triggerSlideEvent(r, h).defaultPrevented) return;
            if (!n || !r) return;
            this._isSliding = !0, o && this.pause(), this._setActiveIndicatorElement(r), this._activeElement = r;
            const d = () => {
                ye.trigger(this._element, Ne, {
                    relatedTarget: r,
                    direction: h,
                    from: l,
                    to: a
                })
            };
            if (this._element.classList.contains("slide")) {
                r.classList.add(u), Kt(r), n.classList.add(c), r.classList.add(c);
                const t = () => {
                    r.classList.remove(c, u), r.classList.add(Re), n.classList.remove(Re, u, c), this._isSliding = !1, setTimeout(d, 0)
                };
                this._queueCallback(t, n, !0)
            } else n.classList.remove(Re), r.classList.add(Re), this._isSliding = !1, d();
            o && this.cycle()
        }
        _directionToOrder(t) {
            return [je, Ie].includes(t) ? Qt() ? t === Ie ? De : Le : t === Ie ? Le : De : t
        }
        _orderToDirection(t) {
            return [Le, De].includes(t) ? Qt() ? t === De ? Ie : je : t === De ? je : Ie : t
        }
        static carouselInterface(t, e) {
            let i = ie.get(t, Oe),
                n = {
                    ...Te,
                    ...Ce.getDataAttributes(t)
                };
            "object" == typeof e && (n = {
                ...n,
                ...e
            });
            const l = "string" == typeof e ? e : n.slide;
            if (i || (i = new He(t, n)), "number" == typeof e) i.to(e);
            else if ("string" == typeof l) {
                if (void 0 === i[l]) throw new TypeError(`No method named "${l}"`);
                i[l]()
            } else n.interval && n.ride && (i.pause(), i.cycle())
        }
        static jQueryInterface(t) {
            return this.each((function () {
                He.carouselInterface(this, t)
            }))
        }
        static dataApiClickHandler(t) {
            const e = zt(this);
            if (!e || !e.classList.contains("carousel")) return;
            const i = {
                    ...Ce.getDataAttributes(e),
                    ...Ce.getDataAttributes(this)
                },
                n = this.getAttribute("data-bs-slide-to");
            n && (i.interval = !1), He.carouselInterface(e, i), n && ie.get(e, Oe).to(n), t.preventDefault()
        }
    }
    ye.on(document, "click.bs.carousel.data-api", "[data-bs-slide], [data-bs-slide-to]", He.dataApiClickHandler), ye.on(window, "load.bs.carousel.data-api", (() => {
        const t = It.find('[data-bs-ride="carousel"]');
        for (let e = 0, i = t.length; e < i; e++) He.carouselInterface(t[e], ie.get(t[e], Oe))
    })), Jt(He);
    const Be = "collapse",
        Ye = "bs.collapse",
        We = {
            toggle: !0,
            parent: ""
        },
        Ve = {
            toggle: "boolean",
            parent: "(string|element)"
        },
        Xe = "show",
        qe = "collapse",
        Ze = "collapsing",
        Ge = "collapsed",
        Ue = "width",
        Ke = '[data-bs-toggle="collapse"]';
    class $e extends be {
        constructor(t, e) {
            super(t), this._isTransitioning = !1, this._config = this._getConfig(e), this._triggerArray = It.find(`${Ke}[href="#${this._element.id}"],${Ke}[data-bs-target="#${this._element.id}"]`);
            const i = It.find(Ke);
            for (let t = 0, e = i.length; t < e; t++) {
                const e = i[t],
                    n = Ft(e),
                    l = It.find(n).filter((t => t === this._element));
                null !== n && l.length && (this._selector = n, this._triggerArray.push(e))
            }
            this._parent = this._config.parent ? this._getParent() : null, this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray), this._config.toggle && this.toggle()
        }
        static get Default() {
            return We
        }
        static get NAME() {
            return Be
        }
        toggle() {
            this._element.classList.contains(Xe) ? this.hide() : this.show()
        }
        show() {
            if (this._isTransitioning || this._element.classList.contains(Xe)) return;
            let t, e;
            this._parent && (t = It.find(".show, .collapsing", this._parent).filter((t => "string" == typeof this._config.parent ? t.getAttribute("data-bs-parent") === this._config.parent : t.classList.contains(qe))), 0 === t.length && (t = null));
            const i = It.findOne(this._selector);
            if (t) {
                const n = t.find((t => i !== t));
                if (e = n ? ie.get(n, Ye) : null, e && e._isTransitioning) return
            }
            if (ye.trigger(this._element, "show.bs.collapse").defaultPrevented) return;
            t && t.forEach((t => {
                i !== t && $e.collapseInterface(t, "hide"), e || ie.set(t, Ye, null)
            }));
            const n = this._getDimension();
            this._element.classList.remove(qe), this._element.classList.add(Ze), this._element.style[n] = 0, this._triggerArray.length && this._triggerArray.forEach((t => {
                t.classList.remove(Ge), t.setAttribute("aria-expanded", !0)
            })), this.setTransitioning(!0);
            const l = `scroll${n[0].toUpperCase()+n.slice(1)}`;
            this._queueCallback((() => {
                this._element.classList.remove(Ze), this._element.classList.add(qe, Xe), this._element.style[n] = "", this.setTransitioning(!1), ye.trigger(this._element, "shown.bs.collapse")
            }), this._element, !0), this._element.style[n] = `${this._element[l]}px`
        }
        hide() {
            if (this._isTransitioning || !this._element.classList.contains(Xe)) return;
            if (ye.trigger(this._element, "hide.bs.collapse").defaultPrevented) return;
            const t = this._getDimension();
            this._element.style[t] = `${this._element.getBoundingClientRect()[t]}px`, Kt(this._element), this._element.classList.add(Ze), this._element.classList.remove(qe, Xe);
            const e = this._triggerArray.length;
            if (e > 0)
                for (let t = 0; t < e; t++) {
                    const e = this._triggerArray[t],
                        i = zt(e);
                    i && !i.classList.contains(Xe) && (e.classList.add(Ge), e.setAttribute("aria-expanded", !1))
                }
            this.setTransitioning(!0);
            this._element.style[t] = "", this._queueCallback((() => {
                this.setTransitioning(!1), this._element.classList.remove(Ze), this._element.classList.add(qe), ye.trigger(this._element, "hidden.bs.collapse")
            }), this._element, !0)
        }
        setTransitioning(t) {
            this._isTransitioning = t
        }
        _getConfig(t) {
            return (t = {
                ...We,
                ...t
            }).toggle = Boolean(t.toggle), Xt(Be, t, Ve), t
        }
        _getDimension() {
            return this._element.classList.contains(Ue) ? Ue : "height"
        }
        _getParent() {
            let {
                parent: t
            } = this._config;
            t = Wt(t);
            const e = `${Ke}[data-bs-parent="${t}"]`;
            return It.find(e, t).forEach((t => {
                const e = zt(t);
                this._addAriaAndCollapsedClass(e, [t])
            })), t
        }
        _addAriaAndCollapsedClass(t, e) {
            if (!t || !e.length) return;
            const i = t.classList.contains(Xe);
            e.forEach((t => {
                i ? t.classList.remove(Ge) : t.classList.add(Ge), t.setAttribute("aria-expanded", i)
            }))
        }
        static collapseInterface(t, e) {
            let i = ie.get(t, Ye);
            const n = {
                ...We,
                ...Ce.getDataAttributes(t),
                ..."object" == typeof e && e ? e : {}
            };
            if (!i && n.toggle && "string" == typeof e && /show|hide/.test(e) && (n.toggle = !1), i || (i = new $e(t, n)), "string" == typeof e) {
                if (void 0 === i[e]) throw new TypeError(`No method named "${e}"`);
                i[e]()
            }
        }
        static jQueryInterface(t) {
            return this.each((function () {
                $e.collapseInterface(this, t)
            }))
        }
    }
    ye.on(document, "click.bs.collapse.data-api", Ke, (function (t) {
        ("A" === t.target.tagName || t.delegateTarget && "A" === t.delegateTarget.tagName) && t.preventDefault();
        const e = Ce.getDataAttributes(this),
            i = Ft(this);
        It.find(i).forEach((t => {
            const i = ie.get(t, Ye);
            let n;
            i ? (null === i._parent && "string" == typeof e.parent && (i._config.parent = e.parent, i._parent = i._getParent()), n = "toggle") : n = e, $e.collapseInterface(t, n)
        }))
    })), Jt($e);
    const Qe = "dropdown",
        Je = "bs.dropdown",
        ti = "Escape",
        ei = "Space",
        ii = "ArrowUp",
        ni = "ArrowDown",
        li = new RegExp("ArrowUp|ArrowDown|Escape"),
        ri = "click.bs.dropdown.data-api",
        ai = "keydown.bs.dropdown.data-api",
        oi = "show",
        si = '[data-bs-toggle="dropdown"]',
        ci = ".dropdown-menu",
        ui = Qt() ? "top-end" : "top-start",
        hi = Qt() ? "top-start" : "top-end",
        di = Qt() ? "bottom-end" : "bottom-start",
        fi = Qt() ? "bottom-start" : "bottom-end",
        pi = Qt() ? "left-start" : "right-start",
        gi = Qt() ? "right-start" : "left-start",
        mi = {
            offset: [0, 2],
            boundary: "clippingParents",
            reference: "toggle",
            display: "dynamic",
            popperConfig: null,
            autoClose: !0
        },
        vi = {
            offset: "(array|string|function)",
            boundary: "(string|element)",
            reference: "(string|element|object)",
            display: "string",
            popperConfig: "(null|object|function)",
            autoClose: "(boolean|string)"
        };
    class yi extends be {
        constructor(t, e) {
            super(t), this._popper = null, this._config = this._getConfig(e), this._menu = this._getMenuElement(), this._inNavbar = this._detectNavbar(), this._addEventListeners()
        }
        static get Default() {
            return mi
        }
        static get DefaultType() {
            return vi
        }
        static get NAME() {
            return Qe
        }
        toggle() {
            if (Zt(this._element)) return;
            this._element.classList.contains(oi) ? this.hide() : this.show()
        }
        show() {
            if (Zt(this._element) || this._menu.classList.contains(oi)) return;
            const t = yi.getParentFromElement(this._element),
                e = {
                    relatedTarget: this._element
                };
            if (!ye.trigger(this._element, "show.bs.dropdown", e).defaultPrevented) {
                if (this._inNavbar) Ce.setDataAttribute(this._menu, "popper", "none");
                else {
                    if (void 0 === n) throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                    let e = this._element;
                    "parent" === this._config.reference ? e = t : Yt(this._config.reference) ? e = Wt(this._config.reference) : "object" == typeof this._config.reference && (e = this._config.reference);
                    const i = this._getPopperConfig(),
                        l = i.modifiers.find((t => "applyStyles" === t.name && !1 === t.enabled));
                    this._popper = Lt(e, this._menu, i), l && Ce.setDataAttribute(this._menu, "popper", "static")
                }
                "ontouchstart" in document.documentElement && !t.closest(".navbar-nav") && [].concat(...document.body.children).forEach((t => ye.on(t, "mouseover", Ut))), this._element.focus(), this._element.setAttribute("aria-expanded", !0), this._menu.classList.toggle(oi), this._element.classList.toggle(oi), ye.trigger(this._element, "shown.bs.dropdown", e)
            }
        }
        hide() {
            if (Zt(this._element) || !this._menu.classList.contains(oi)) return;
            const t = {
                relatedTarget: this._element
            };
            this._completeHide(t)
        }
        dispose() {
            this._popper && this._popper.destroy(), super.dispose()
        }
        update() {
            this._inNavbar = this._detectNavbar(), this._popper && this._popper.update()
        }
        _addEventListeners() {
            ye.on(this._element, "click.bs.dropdown", (t => {
                t.preventDefault(), this.toggle()
            }))
        }
        _completeHide(t) {
            ye.trigger(this._element, "hide.bs.dropdown", t).defaultPrevented || ("ontouchstart" in document.documentElement && [].concat(...document.body.children).forEach((t => ye.off(t, "mouseover", Ut))), this._popper && this._popper.destroy(), this._menu.classList.remove(oi), this._element.classList.remove(oi), this._element.setAttribute("aria-expanded", "false"), Ce.removeDataAttribute(this._menu, "popper"), ye.trigger(this._element, "hidden.bs.dropdown", t))
        }
        _getConfig(t) {
            if (t = {
                    ...this.constructor.Default,
                    ...Ce.getDataAttributes(this._element),
                    ...t
                }, Xt(Qe, t, this.constructor.DefaultType), "object" == typeof t.reference && !Yt(t.reference) && "function" != typeof t.reference.getBoundingClientRect) throw new TypeError(`${Qe.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return t
        }
        _getMenuElement() {
            return It.next(this._element, ci)[0]
        }
        _getPlacement() {
            const t = this._element.parentNode;
            if (t.classList.contains("dropend")) return pi;
            if (t.classList.contains("dropstart")) return gi;
            const e = "end" === getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();
            return t.classList.contains("dropup") ? e ? hi : ui : e ? fi : di
        }
        _detectNavbar() {
            return null !== this._element.closest(".navbar")
        }
        _getOffset() {
            const {
                offset: t
            } = this._config;
            return "string" == typeof t ? t.split(",").map((t => Number.parseInt(t, 10))) : "function" == typeof t ? e => t(e, this._element) : t
        }
        _getPopperConfig() {
            const t = {
                placement: this._getPlacement(),
                modifiers: [{
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                }, {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }]
            };
            return "static" === this._config.display && (t.modifiers = [{
                name: "applyStyles",
                enabled: !1
            }]), {
                ...t,
                ..."function" == typeof this._config.popperConfig ? this._config.popperConfig(t) : this._config.popperConfig
            }
        }
        _selectMenuItem(t) {
            const e = It.find(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", this._menu).filter(qt);
            if (!e.length) return;
            let i = e.indexOf(t.target);
            t.key === ii && i > 0 && i--, t.key === ni && i < e.length - 1 && i++, i = -1 === i ? 0 : i, e[i].focus()
        }
        static dropdownInterface(t, e) {
            let i = ie.get(t, Je);
            if (i || (i = new yi(t, "object" == typeof e ? e : null)), "string" == typeof e) {
                if (void 0 === i[e]) throw new TypeError(`No method named "${e}"`);
                i[e]()
            }
        }
        static jQueryInterface(t) {
            return this.each((function () {
                yi.dropdownInterface(this, t)
            }))
        }
        static clearMenus(t) {
            if (t && (2 === t.button || "keyup" === t.type && "Tab" !== t.key)) return;
            const e = It.find(si);
            for (let i = 0, n = e.length; i < n; i++) {
                const n = ie.get(e[i], Je);
                if (!n || !1 === n._config.autoClose) continue;
                if (!n._element.classList.contains(oi)) continue;
                const l = {
                    relatedTarget: n._element
                };
                if (t) {
                    const e = t.composedPath(),
                        i = e.includes(n._menu);
                    if (e.includes(n._element) || "inside" === n._config.autoClose && !i || "outside" === n._config.autoClose && i) continue;
                    if (n._menu.contains(t.target) && ("keyup" === t.type && "Tab" === t.key || /input|select|option|textarea|form/i.test(t.target.tagName))) continue;
                    "click" === t.type && (l.clickEvent = t)
                }
                n._completeHide(l)
            }
        }
        static getParentFromElement(t) {
            return zt(t) || t.parentNode
        }
        static dataApiKeydownHandler(t) {
            if (/input|textarea/i.test(t.target.tagName) ? t.key === ei || t.key !== ti && (t.key !== ni && t.key !== ii || t.target.closest(ci)) : !li.test(t.key)) return;
            const e = this.classList.contains(oi);
            if (!e && t.key === ti) return;
            if (t.preventDefault(), t.stopPropagation(), Zt(this)) return;
            const i = () => this.matches(si) ? this : It.prev(this, si)[0];
            if (t.key === ti) return i().focus(), void yi.clearMenus();
            e || t.key !== ii && t.key !== ni ? e && t.key !== ei ? yi.getInstance(i())._selectMenuItem(t) : yi.clearMenus() : i().click()
        }
    }
    ye.on(document, ai, si, yi.dataApiKeydownHandler), ye.on(document, ai, ci, yi.dataApiKeydownHandler), ye.on(document, ri, yi.clearMenus), ye.on(document, "keyup.bs.dropdown.data-api", yi.clearMenus), ye.on(document, ri, si, (function (t) {
        t.preventDefault(), yi.dropdownInterface(this)
    })), Jt(yi);
    const bi = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
        xi = ".sticky-top",
        wi = () => {
            const t = document.documentElement.clientWidth;
            return Math.abs(window.innerWidth - t)
        },
        _i = (t = wi()) => {
            ki(), Si("body", "paddingRight", (e => e + t)), Si(bi, "paddingRight", (e => e + t)), Si(xi, "marginRight", (e => e - t))
        },
        ki = () => {
            const t = document.body.style.overflow;
            t && Ce.setDataAttribute(document.body, "overflow", t), document.body.style.overflow = "hidden"
        },
        Si = (t, e, i) => {
            const n = wi();
            It.find(t).forEach((t => {
                if (t !== document.body && window.innerWidth > t.clientWidth + n) return;
                const l = t.style[e],
                    r = window.getComputedStyle(t)[e];
                Ce.setDataAttribute(t, e, l), t.style[e] = `${i(Number.parseFloat(r))}px`
            }))
        },
        Ai = () => {
            Mi("body", "overflow"), Mi("body", "paddingRight"), Mi(bi, "paddingRight"), Mi(xi, "marginRight")
        },
        Mi = (t, e) => {
            It.find(t).forEach((t => {
                const i = Ce.getDataAttribute(t, e);
                void 0 === i ? t.style.removeProperty(e) : (Ce.removeDataAttribute(t, e), t.style[e] = i)
            }))
        },
        Ci = {
            isVisible: !0,
            isAnimated: !1,
            rootElement: document.body,
            clickCallback: null
        },
        Ei = {
            isVisible: "boolean",
            isAnimated: "boolean",
            rootElement: "element",
            clickCallback: "(function|null)"
        },
        Oi = "backdrop",
        Ti = "show",
        Pi = "mousedown.bs.backdrop";
    class Li {
        constructor(t) {
            this._config = this._getConfig(t), this._isAppended = !1, this._element = null
        }
        show(t) {
            this._config.isVisible ? (this._append(), this._config.isAnimated && Kt(this._getElement()), this._getElement().classList.add(Ti), this._emulateAnimation((() => {
                te(t)
            }))) : te(t)
        }
        hide(t) {
            this._config.isVisible ? (this._getElement().classList.remove(Ti), this._emulateAnimation((() => {
                this.dispose(), te(t)
            }))) : te(t)
        }
        _getElement() {
            if (!this._element) {
                const t = document.createElement("div");
                t.className = "modal-backdrop", this._config.isAnimated && t.classList.add("fade"), this._element = t
            }
            return this._element
        }
        _getConfig(t) {
            return (t = {
                ...Ci,
                ..."object" == typeof t ? t : {}
            }).rootElement = t.rootElement || document.body, Xt(Oi, t, Ei), t
        }
        _append() {
            this._isAppended || (this._config.rootElement.appendChild(this._getElement()), ye.on(this._getElement(), Pi, (() => {
                te(this._config.clickCallback)
            })), this._isAppended = !0)
        }
        dispose() {
            this._isAppended && (ye.off(this._element, Pi), this._getElement().parentNode.removeChild(this._element), this._isAppended = !1)
        }
        _emulateAnimation(t) {
            if (!this._config.isAnimated) return void te(t);
            const e = Ht(this._getElement());
            ye.one(this._getElement(), "transitionend", (() => te(t))), Vt(this._getElement(), e)
        }
    }
    const Di = "modal",
        Ii = ".bs.modal",
        ji = "Escape",
        Ni = {
            backdrop: !0,
            keyboard: !0,
            focus: !0
        },
        Ri = {
            backdrop: "(boolean|string)",
            keyboard: "boolean",
            focus: "boolean"
        },
        Fi = "hidden.bs.modal",
        zi = "show.bs.modal",
        Hi = "focusin.bs.modal",
        Bi = "resize.bs.modal",
        Yi = "click.dismiss.bs.modal",
        Wi = "keydown.dismiss.bs.modal",
        Vi = "mousedown.dismiss.bs.modal",
        Xi = "modal-open",
        qi = "show",
        Zi = "modal-static";
    class Gi extends be {
        constructor(t, e) {
            super(t), this._config = this._getConfig(e), this._dialog = It.findOne(".modal-dialog", this._element), this._backdrop = this._initializeBackDrop(), this._isShown = !1, this._ignoreBackdropClick = !1, this._isTransitioning = !1
        }
        static get Default() {
            return Ni
        }
        static get NAME() {
            return Di
        }
        toggle(t) {
            return this._isShown ? this.hide() : this.show(t)
        }
        show(t) {
            if (this._isShown || this._isTransitioning) return;
            this._isAnimated() && (this._isTransitioning = !0);
            const e = ye.trigger(this._element, zi, {
                relatedTarget: t
            });
            this._isShown || e.defaultPrevented || (this._isShown = !0, _i(), document.body.classList.add(Xi), this._adjustDialog(), this._setEscapeEvent(), this._setResizeEvent(), ye.on(this._element, Yi, '[data-bs-dismiss="modal"]', (t => this.hide(t))), ye.on(this._dialog, Vi, (() => {
                ye.one(this._element, "mouseup.dismiss.bs.modal", (t => {
                    t.target === this._element && (this._ignoreBackdropClick = !0)
                }))
            })), this._showBackdrop((() => this._showElement(t))))
        }
        hide(t) {
            if (t && t.preventDefault(), !this._isShown || this._isTransitioning) return;
            if (ye.trigger(this._element, "hide.bs.modal").defaultPrevented) return;
            this._isShown = !1;
            const e = this._isAnimated();
            e && (this._isTransitioning = !0), this._setEscapeEvent(), this._setResizeEvent(), ye.off(document, Hi), this._element.classList.remove(qi), ye.off(this._element, Yi), ye.off(this._dialog, Vi), this._queueCallback((() => this._hideModal()), this._element, e)
        }
        dispose() {
            [window, this._dialog].forEach((t => ye.off(t, Ii))), this._backdrop.dispose(), super.dispose(), ye.off(document, Hi)
        }
        handleUpdate() {
            this._adjustDialog()
        }
        _initializeBackDrop() {
            return new Li({
                isVisible: Boolean(this._config.backdrop),
                isAnimated: this._isAnimated()
            })
        }
        _getConfig(t) {
            return t = {
                ...Ni,
                ...Ce.getDataAttributes(this._element),
                ...t
            }, Xt(Di, t, Ri), t
        }
        _showElement(t) {
            const e = this._isAnimated(),
                i = It.findOne(".modal-body", this._dialog);
            this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0, i && (i.scrollTop = 0), e && Kt(this._element), this._element.classList.add(qi), this._config.focus && this._enforceFocus();
            this._queueCallback((() => {
                this._config.focus && this._element.focus(), this._isTransitioning = !1, ye.trigger(this._element, "shown.bs.modal", {
                    relatedTarget: t
                })
            }), this._dialog, e)
        }
        _enforceFocus() {
            ye.off(document, Hi), ye.on(document, Hi, (t => {
                document === t.target || this._element === t.target || this._element.contains(t.target) || this._element.focus()
            }))
        }
        _setEscapeEvent() {
            this._isShown ? ye.on(this._element, Wi, (t => {
                this._config.keyboard && t.key === ji ? (t.preventDefault(), this.hide()) : this._config.keyboard || t.key !== ji || this._triggerBackdropTransition()
            })) : ye.off(this._element, Wi)
        }
        _setResizeEvent() {
            this._isShown ? ye.on(window, Bi, (() => this._adjustDialog())) : ye.off(window, Bi)
        }
        _hideModal() {
            this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide((() => {
                document.body.classList.remove(Xi), this._resetAdjustments(), Ai(), ye.trigger(this._element, Fi)
            }))
        }
        _showBackdrop(t) {
            ye.on(this._element, Yi, (t => {
                this._ignoreBackdropClick ? this._ignoreBackdropClick = !1 : t.target === t.currentTarget && (!0 === this._config.backdrop ? this.hide() : "static" === this._config.backdrop && this._triggerBackdropTransition())
            })), this._backdrop.show(t)
        }
        _isAnimated() {
            return this._element.classList.contains("fade")
        }
        _triggerBackdropTransition() {
            if (ye.trigger(this._element, "hidePrevented.bs.modal").defaultPrevented) return;
            const t = this._element.scrollHeight > document.documentElement.clientHeight;
            t || (this._element.style.overflowY = "hidden"), this._element.classList.add(Zi);
            const e = Ht(this._dialog);
            ye.off(this._element, "transitionend"), ye.one(this._element, "transitionend", (() => {
                this._element.classList.remove(Zi), t || (ye.one(this._element, "transitionend", (() => {
                    this._element.style.overflowY = ""
                })), Vt(this._element, e))
            })), Vt(this._element, e), this._element.focus()
        }
        _adjustDialog() {
            const t = this._element.scrollHeight > document.documentElement.clientHeight,
                e = wi(),
                i = e > 0;
            (!i && t && !Qt() || i && !t && Qt()) && (this._element.style.paddingLeft = `${e}px`), (i && !t && !Qt() || !i && t && Qt()) && (this._element.style.paddingRight = `${e}px`)
        }
        _resetAdjustments() {
            this._element.style.paddingLeft = "", this._element.style.paddingRight = ""
        }
        static jQueryInterface(t, e) {
            return this.each((function () {
                const i = Gi.getInstance(this) || new Gi(this, "object" == typeof t ? t : {});
                if ("string" == typeof t) {
                    if (void 0 === i[t]) throw new TypeError(`No method named "${t}"`);
                    i[t](e)
                }
            }))
        }
    }
    ye.on(document, "click.bs.modal.data-api", '[data-bs-toggle="modal"]', (function (t) {
        const e = zt(this);
        ["A", "AREA"].includes(this.tagName) && t.preventDefault(), ye.one(e, zi, (t => {
            t.defaultPrevented || ye.one(e, Fi, (() => {
                qt(this) && this.focus()
            }))
        }));
        (Gi.getInstance(e) || new Gi(e)).toggle(this)
    })), Jt(Gi);
    const Ui = "offcanvas",
        Ki = "bs.offcanvas",
        $i = {
            backdrop: !0,
            keyboard: !0,
            scroll: !1
        },
        Qi = {
            backdrop: "boolean",
            keyboard: "boolean",
            scroll: "boolean"
        },
        Ji = "show",
        tn = ".offcanvas.show",
        en = "hidden.bs.offcanvas",
        nn = "focusin.bs.offcanvas";
    class ln extends be {
        constructor(t, e) {
            super(t), this._config = this._getConfig(e), this._isShown = !1, this._backdrop = this._initializeBackDrop(), this._addEventListeners()
        }
        static get NAME() {
            return Ui
        }
        static get Default() {
            return $i
        }
        toggle(t) {
            return this._isShown ? this.hide() : this.show(t)
        }
        show(t) {
            if (this._isShown) return;
            if (ye.trigger(this._element, "show.bs.offcanvas", {
                    relatedTarget: t
                }).defaultPrevented) return;
            this._isShown = !0, this._element.style.visibility = "visible", this._backdrop.show(), this._config.scroll || (_i(), this._enforceFocusOnElement(this._element)), this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.classList.add(Ji);
            this._queueCallback((() => {
                ye.trigger(this._element, "shown.bs.offcanvas", {
                    relatedTarget: t
                })
            }), this._element, !0)
        }
        hide() {
            if (!this._isShown) return;
            if (ye.trigger(this._element, "hide.bs.offcanvas").defaultPrevented) return;
            ye.off(document, nn), this._element.blur(), this._isShown = !1, this._element.classList.remove(Ji), this._backdrop.hide();
            this._queueCallback((() => {
                this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._element.style.visibility = "hidden", this._config.scroll || Ai(), ye.trigger(this._element, en)
            }), this._element, !0)
        }
        dispose() {
            this._backdrop.dispose(), super.dispose(), ye.off(document, nn)
        }
        _getConfig(t) {
            return t = {
                ...$i,
                ...Ce.getDataAttributes(this._element),
                ..."object" == typeof t ? t : {}
            }, Xt(Ui, t, Qi), t
        }
        _initializeBackDrop() {
            return new Li({
                isVisible: this._config.backdrop,
                isAnimated: !0,
                rootElement: this._element.parentNode,
                clickCallback: () => this.hide()
            })
        }
        _enforceFocusOnElement(t) {
            ye.off(document, nn), ye.on(document, nn, (e => {
                document === e.target || t === e.target || t.contains(e.target) || t.focus()
            })), t.focus()
        }
        _addEventListeners() {
            ye.on(this._element, "click.dismiss.bs.offcanvas", '[data-bs-dismiss="offcanvas"]', (() => this.hide())), ye.on(this._element, "keydown.dismiss.bs.offcanvas", (t => {
                this._config.keyboard && "Escape" === t.key && this.hide()
            }))
        }
        static jQueryInterface(t) {
            return this.each((function () {
                const e = ie.get(this, Ki) || new ln(this, "object" == typeof t ? t : {});
                if ("string" == typeof t) {
                    if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                    e[t](this)
                }
            }))
        }
    }
    ye.on(document, "click.bs.offcanvas.data-api", '[data-bs-toggle="offcanvas"]', (function (t) {
        const e = zt(this);
        if (["A", "AREA"].includes(this.tagName) && t.preventDefault(), Zt(this)) return;
        ye.one(e, en, (() => {
            qt(this) && this.focus()
        }));
        const i = It.findOne(tn);
        i && i !== e && ln.getInstance(i).hide();
        (ie.get(e, Ki) || new ln(e)).toggle(this)
    })), ye.on(window, "load.bs.offcanvas.data-api", (() => {
        It.find(tn).forEach((t => (ie.get(t, Ki) || new ln(t)).show()))
    })), Jt(ln);
    const rn = new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]),
        an = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/i,
        on = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i,
        sn = (t, e) => {
            const i = t.nodeName.toLowerCase();
            if (e.includes(i)) return !rn.has(i) || Boolean(an.test(t.nodeValue) || on.test(t.nodeValue));
            const n = e.filter((t => t instanceof RegExp));
            for (let t = 0, e = n.length; t < e; t++)
                if (n[t].test(i)) return !0;
            return !1
        },
        cn = {
            "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
            a: ["target", "href", "title", "rel"],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: ["src", "srcset", "alt", "title", "width", "height"],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: []
        };

    function un(t, e, i) {
        if (!t.length) return t;
        if (i && "function" == typeof i) return i(t);
        const n = (new window.DOMParser).parseFromString(t, "text/html"),
            l = Object.keys(e),
            r = [].concat(...n.body.querySelectorAll("*"));
        for (let t = 0, i = r.length; t < i; t++) {
            const i = r[t],
                n = i.nodeName.toLowerCase();
            if (!l.includes(n)) {
                i.parentNode.removeChild(i);
                continue
            }
            const a = [].concat(...i.attributes),
                o = [].concat(e["*"] || [], e[n] || []);
            a.forEach((t => {
                sn(t, o) || i.removeAttribute(t.nodeName)
            }))
        }
        return n.body.innerHTML
    }
    const hn = "tooltip",
        dn = "bs.tooltip",
        fn = new RegExp("(^|\\s)bs-tooltip\\S+", "g"),
        pn = new Set(["sanitize", "allowList", "sanitizeFn"]),
        gn = {
            animation: "boolean",
            template: "string",
            title: "(string|element|function)",
            trigger: "string",
            delay: "(number|object)",
            html: "boolean",
            selector: "(string|boolean)",
            placement: "(string|function)",
            offset: "(array|string|function)",
            container: "(string|element|boolean)",
            fallbackPlacements: "array",
            boundary: "(string|element)",
            customClass: "(string|function)",
            sanitize: "boolean",
            sanitizeFn: "(null|function)",
            allowList: "object",
            popperConfig: "(null|object|function)"
        },
        mn = {
            AUTO: "auto",
            TOP: "top",
            RIGHT: Qt() ? "left" : "right",
            BOTTOM: "bottom",
            LEFT: Qt() ? "right" : "left"
        },
        vn = {
            animation: !0,
            template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
            trigger: "hover focus",
            title: "",
            delay: 0,
            html: !1,
            selector: !1,
            placement: "top",
            offset: [0, 0],
            container: !1,
            fallbackPlacements: ["top", "right", "bottom", "left"],
            boundary: "clippingParents",
            customClass: "",
            sanitize: !0,
            sanitizeFn: null,
            allowList: cn,
            popperConfig: null
        },
        yn = {
            HIDE: "hide.bs.tooltip",
            HIDDEN: "hidden.bs.tooltip",
            SHOW: "show.bs.tooltip",
            SHOWN: "shown.bs.tooltip",
            INSERTED: "inserted.bs.tooltip",
            CLICK: "click.bs.tooltip",
            FOCUSIN: "focusin.bs.tooltip",
            FOCUSOUT: "focusout.bs.tooltip",
            MOUSEENTER: "mouseenter.bs.tooltip",
            MOUSELEAVE: "mouseleave.bs.tooltip"
        },
        bn = "fade",
        xn = "show",
        wn = "show",
        _n = "out",
        kn = "hover",
        Sn = "focus";
    class An extends be {
        constructor(t, e) {
            if (void 0 === n) throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
            super(t), this._isEnabled = !0, this._timeout = 0, this._hoverState = "", this._activeTrigger = {}, this._popper = null, this._config = this._getConfig(e), this.tip = null, this._setListeners()
        }
        static get Default() {
            return vn
        }
        static get NAME() {
            return hn
        }
        static get Event() {
            return yn
        }
        static get DefaultType() {
            return gn
        }
        enable() {
            this._isEnabled = !0
        }
        disable() {
            this._isEnabled = !1
        }
        toggleEnabled() {
            this._isEnabled = !this._isEnabled
        }
        toggle(t) {
            if (this._isEnabled)
                if (t) {
                    const e = this._initializeOnDelegatedTarget(t);
                    e._activeTrigger.click = !e._activeTrigger.click, e._isWithActiveTrigger() ? e._enter(null, e) : e._leave(null, e)
                } else {
                    if (this.getTipElement().classList.contains(xn)) return void this._leave(null, this);
                    this._enter(null, this)
                }
        }
        dispose() {
            clearTimeout(this._timeout), ye.off(this._element.closest(".modal"), "hide.bs.modal", this._hideModalHandler), this.tip && this.tip.parentNode && this.tip.parentNode.removeChild(this.tip), this._popper && this._popper.destroy(), super.dispose()
        }
        show() {
            if ("none" === this._element.style.display) throw new Error("Please use show on visible elements");
            if (!this.isWithContent() || !this._isEnabled) return;
            const t = ye.trigger(this._element, this.constructor.Event.SHOW),
                e = Gt(this._element),
                i = null === e ? this._element.ownerDocument.documentElement.contains(this._element) : e.contains(this._element);
            if (t.defaultPrevented || !i) return;
            const n = this.getTipElement(),
                l = Nt(this.constructor.NAME);
            n.setAttribute("id", l), this._element.setAttribute("aria-describedby", l), this.setContent(), this._config.animation && n.classList.add(bn);
            const r = "function" == typeof this._config.placement ? this._config.placement.call(this, n, this._element) : this._config.placement,
                a = this._getAttachment(r);
            this._addAttachmentClass(a);
            const {
                container: o
            } = this._config;
            ie.set(n, this.constructor.DATA_KEY, this), this._element.ownerDocument.documentElement.contains(this.tip) || (o.appendChild(n), ye.trigger(this._element, this.constructor.Event.INSERTED)), this._popper ? this._popper.update() : this._popper = Lt(this._element, n, this._getPopperConfig(a)), n.classList.add(xn);
            const s = "function" == typeof this._config.customClass ? this._config.customClass() : this._config.customClass;
            s && n.classList.add(...s.split(" ")), "ontouchstart" in document.documentElement && [].concat(...document.body.children).forEach((t => {
                ye.on(t, "mouseover", Ut)
            }));
            const c = this.tip.classList.contains(bn);
            this._queueCallback((() => {
                const t = this._hoverState;
                this._hoverState = null, ye.trigger(this._element, this.constructor.Event.SHOWN), t === _n && this._leave(null, this)
            }), this.tip, c)
        }
        hide() {
            if (!this._popper) return;
            const t = this.getTipElement();
            if (ye.trigger(this._element, this.constructor.Event.HIDE).defaultPrevented) return;
            t.classList.remove(xn), "ontouchstart" in document.documentElement && [].concat(...document.body.children).forEach((t => ye.off(t, "mouseover", Ut))), this._activeTrigger.click = !1, this._activeTrigger.focus = !1, this._activeTrigger.hover = !1;
            const e = this.tip.classList.contains(bn);
            this._queueCallback((() => {
                this._isWithActiveTrigger() || (this._hoverState !== wn && t.parentNode && t.parentNode.removeChild(t), this._cleanTipClass(), this._element.removeAttribute("aria-describedby"), ye.trigger(this._element, this.constructor.Event.HIDDEN), this._popper && (this._popper.destroy(), this._popper = null))
            }), this.tip, e), this._hoverState = ""
        }
        update() {
            null !== this._popper && this._popper.update()
        }
        isWithContent() {
            return Boolean(this.getTitle())
        }
        getTipElement() {
            if (this.tip) return this.tip;
            const t = document.createElement("div");
            return t.innerHTML = this._config.template, this.tip = t.children[0], this.tip
        }
        setContent() {
            const t = this.getTipElement();
            this.setElementContent(It.findOne(".tooltip-inner", t), this.getTitle()), t.classList.remove(bn, xn)
        }
        setElementContent(t, e) {
            if (null !== t) return Yt(e) ? (e = Wt(e), void(this._config.html ? e.parentNode !== t && (t.innerHTML = "", t.appendChild(e)) : t.textContent = e.textContent)) : void(this._config.html ? (this._config.sanitize && (e = un(e, this._config.allowList, this._config.sanitizeFn)), t.innerHTML = e) : t.textContent = e)
        }
        getTitle() {
            let t = this._element.getAttribute("data-bs-original-title");
            return t || (t = "function" == typeof this._config.title ? this._config.title.call(this._element) : this._config.title), t
        }
        updateAttachment(t) {
            return "right" === t ? "end" : "left" === t ? "start" : t
        }
        _initializeOnDelegatedTarget(t, e) {
            const i = this.constructor.DATA_KEY;
            return (e = e || ie.get(t.delegateTarget, i)) || (e = new this.constructor(t.delegateTarget, this._getDelegateConfig()), ie.set(t.delegateTarget, i, e)), e
        }
        _getOffset() {
            const {
                offset: t
            } = this._config;
            return "string" == typeof t ? t.split(",").map((t => Number.parseInt(t, 10))) : "function" == typeof t ? e => t(e, this._element) : t
        }
        _getPopperConfig(t) {
            const e = {
                placement: t,
                modifiers: [{
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                }, {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }, {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                }, {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                }, {
                    name: "onChange",
                    enabled: !0,
                    phase: "afterWrite",
                    fn: t => this._handlePopperPlacementChange(t)
                }],
                onFirstUpdate: t => {
                    t.options.placement !== t.placement && this._handlePopperPlacementChange(t)
                }
            };
            return {
                ...e,
                ..."function" == typeof this._config.popperConfig ? this._config.popperConfig(e) : this._config.popperConfig
            }
        }
        _addAttachmentClass(t) {
            this.getTipElement().classList.add(`bs-tooltip-${this.updateAttachment(t)}`)
        }
        _getAttachment(t) {
            return mn[t.toUpperCase()]
        }
        _setListeners() {
            this._config.trigger.split(" ").forEach((t => {
                if ("click" === t) ye.on(this._element, this.constructor.Event.CLICK, this._config.selector, (t => this.toggle(t)));
                else if ("manual" !== t) {
                    const e = t === kn ? this.constructor.Event.MOUSEENTER : this.constructor.Event.FOCUSIN,
                        i = t === kn ? this.constructor.Event.MOUSELEAVE : this.constructor.Event.FOCUSOUT;
                    ye.on(this._element, e, this._config.selector, (t => this._enter(t))), ye.on(this._element, i, this._config.selector, (t => this._leave(t)))
                }
            })), this._hideModalHandler = () => {
                this._element && this.hide()
            }, ye.on(this._element.closest(".modal"), "hide.bs.modal", this._hideModalHandler), this._config.selector ? this._config = {
                ...this._config,
                trigger: "manual",
                selector: ""
            } : this._fixTitle()
        }
        _fixTitle() {
            const t = this._element.getAttribute("title"),
                e = typeof this._element.getAttribute("data-bs-original-title");
            (t || "string" !== e) && (this._element.setAttribute("data-bs-original-title", t || ""), !t || this._element.getAttribute("aria-label") || this._element.textContent || this._element.setAttribute("aria-label", t), this._element.setAttribute("title", ""))
        }
        _enter(t, e) {
            e = this._initializeOnDelegatedTarget(t, e), t && (e._activeTrigger["focusin" === t.type ? Sn : kn] = !0), e.getTipElement().classList.contains(xn) || e._hoverState === wn ? e._hoverState = wn : (clearTimeout(e._timeout), e._hoverState = wn, e._config.delay && e._config.delay.show ? e._timeout = setTimeout((() => {
                e._hoverState === wn && e.show()
            }), e._config.delay.show) : e.show())
        }
        _leave(t, e) {
            e = this._initializeOnDelegatedTarget(t, e), t && (e._activeTrigger["focusout" === t.type ? Sn : kn] = e._element.contains(t.relatedTarget)), e._isWithActiveTrigger() || (clearTimeout(e._timeout), e._hoverState = _n, e._config.delay && e._config.delay.hide ? e._timeout = setTimeout((() => {
                e._hoverState === _n && e.hide()
            }), e._config.delay.hide) : e.hide())
        }
        _isWithActiveTrigger() {
            for (const t in this._activeTrigger)
                if (this._activeTrigger[t]) return !0;
            return !1
        }
        _getConfig(t) {
            const e = Ce.getDataAttributes(this._element);
            return Object.keys(e).forEach((t => {
                pn.has(t) && delete e[t]
            })), (t = {
                ...this.constructor.Default,
                ...e,
                ..."object" == typeof t && t ? t : {}
            }).container = !1 === t.container ? document.body : Wt(t.container), "number" == typeof t.delay && (t.delay = {
                show: t.delay,
                hide: t.delay
            }), "number" == typeof t.title && (t.title = t.title.toString()), "number" == typeof t.content && (t.content = t.content.toString()), Xt(hn, t, this.constructor.DefaultType), t.sanitize && (t.template = un(t.template, t.allowList, t.sanitizeFn)), t
        }
        _getDelegateConfig() {
            const t = {};
            if (this._config)
                for (const e in this._config) this.constructor.Default[e] !== this._config[e] && (t[e] = this._config[e]);
            return t
        }
        _cleanTipClass() {
            const t = this.getTipElement(),
                e = t.getAttribute("class").match(fn);
            null !== e && e.length > 0 && e.map((t => t.trim())).forEach((e => t.classList.remove(e)))
        }
        _handlePopperPlacementChange(t) {
            const {
                state: e
            } = t;
            e && (this.tip = e.elements.popper, this._cleanTipClass(), this._addAttachmentClass(this._getAttachment(e.placement)))
        }
        static jQueryInterface(t) {
            return this.each((function () {
                let e = ie.get(this, dn);
                const i = "object" == typeof t && t;
                if ((e || !/dispose|hide/.test(t)) && (e || (e = new An(this, i)), "string" == typeof t)) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]()
                }
            }))
        }
    }
    Jt(An);
    const Mn = "bs.popover",
        Cn = new RegExp("(^|\\s)bs-popover\\S+", "g"),
        En = {
            ...An.Default,
            placement: "right",
            offset: [0, 8],
            trigger: "click",
            content: "",
            template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
        },
        On = {
            ...An.DefaultType,
            content: "(string|element|function)"
        },
        Tn = {
            HIDE: "hide.bs.popover",
            HIDDEN: "hidden.bs.popover",
            SHOW: "show.bs.popover",
            SHOWN: "shown.bs.popover",
            INSERTED: "inserted.bs.popover",
            CLICK: "click.bs.popover",
            FOCUSIN: "focusin.bs.popover",
            FOCUSOUT: "focusout.bs.popover",
            MOUSEENTER: "mouseenter.bs.popover",
            MOUSELEAVE: "mouseleave.bs.popover"
        };
    class Pn extends An {
        static get Default() {
            return En
        }
        static get NAME() {
            return "popover"
        }
        static get Event() {
            return Tn
        }
        static get DefaultType() {
            return On
        }
        isWithContent() {
            return this.getTitle() || this._getContent()
        }
        setContent() {
            const t = this.getTipElement();
            this.setElementContent(It.findOne(".popover-header", t), this.getTitle());
            let e = this._getContent();
            "function" == typeof e && (e = e.call(this._element)), this.setElementContent(It.findOne(".popover-body", t), e), t.classList.remove("fade", "show")
        }
        _addAttachmentClass(t) {
            this.getTipElement().classList.add(`bs-popover-${this.updateAttachment(t)}`)
        }
        _getContent() {
            return this._element.getAttribute("data-bs-content") || this._config.content
        }
        _cleanTipClass() {
            const t = this.getTipElement(),
                e = t.getAttribute("class").match(Cn);
            null !== e && e.length > 0 && e.map((t => t.trim())).forEach((e => t.classList.remove(e)))
        }
        static jQueryInterface(t) {
            return this.each((function () {
                let e = ie.get(this, Mn);
                const i = "object" == typeof t ? t : null;
                if ((e || !/dispose|hide/.test(t)) && (e || (e = new Pn(this, i), ie.set(this, Mn, e)), "string" == typeof t)) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]()
                }
            }))
        }
    }
    Jt(Pn);
    const Ln = "scrollspy",
        Dn = ".bs.scrollspy",
        In = {
            offset: 10,
            method: "auto",
            target: ""
        },
        jn = {
            offset: "number",
            method: "string",
            target: "(string|element)"
        },
        Nn = "dropdown-item",
        Rn = "active",
        Fn = ".nav-link",
        zn = "position";
    class Hn extends be {
        constructor(t, e) {
            super(t), this._scrollElement = "BODY" === this._element.tagName ? window : this._element, this._config = this._getConfig(e), this._selector = `${this._config.target} .nav-link, ${this._config.target} .list-group-item, ${this._config.target} .dropdown-item`, this._offsets = [], this._targets = [], this._activeTarget = null, this._scrollHeight = 0, ye.on(this._scrollElement, "scroll.bs.scrollspy", (() => this._process())), this.refresh(), this._process()
        }
        static get Default() {
            return In
        }
        static get NAME() {
            return Ln
        }
        refresh() {
            const t = this._scrollElement === this._scrollElement.window ? "offset" : zn,
                e = "auto" === this._config.method ? t : this._config.method,
                i = e === zn ? this._getScrollTop() : 0;
            this._offsets = [], this._targets = [], this._scrollHeight = this._getScrollHeight();
            It.find(this._selector).map((t => {
                const n = Ft(t),
                    l = n ? It.findOne(n) : null;
                if (l) {
                    const t = l.getBoundingClientRect();
                    if (t.width || t.height) return [Ce[e](l).top + i, n]
                }
                return null
            })).filter((t => t)).sort(((t, e) => t[0] - e[0])).forEach((t => {
                this._offsets.push(t[0]), this._targets.push(t[1])
            }))
        }
        dispose() {
            ye.off(this._scrollElement, Dn), super.dispose()
        }
        _getConfig(t) {
            if ("string" != typeof (t = {
                    ...In,
                    ...Ce.getDataAttributes(this._element),
                    ..."object" == typeof t && t ? t : {}
                }).target && Yt(t.target)) {
                let {
                    id: e
                } = t.target;
                e || (e = Nt(Ln), t.target.id = e), t.target = `#${e}`
            }
            return Xt(Ln, t, jn), t
        }
        _getScrollTop() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop
        }
        _getScrollHeight() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
        }
        _getOffsetHeight() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height
        }
        _process() {
            const t = this._getScrollTop() + this._config.offset,
                e = this._getScrollHeight(),
                i = this._config.offset + e - this._getOffsetHeight();
            if (this._scrollHeight !== e && this.refresh(), t >= i) {
                const t = this._targets[this._targets.length - 1];
                this._activeTarget !== t && this._activate(t)
            } else {
                if (this._activeTarget && t < this._offsets[0] && this._offsets[0] > 0) return this._activeTarget = null, void this._clear();
                for (let e = this._offsets.length; e--;) {
                    this._activeTarget !== this._targets[e] && t >= this._offsets[e] && (void 0 === this._offsets[e + 1] || t < this._offsets[e + 1]) && this._activate(this._targets[e])
                }
            }
        }
        _activate(t) {
            this._activeTarget = t, this._clear();
            const e = this._selector.split(",").map((e => `${e}[data-bs-target="${t}"],${e}[href="${t}"]`)),
                i = It.findOne(e.join(","));
            i.classList.contains(Nn) ? (It.findOne(".dropdown-toggle", i.closest(".dropdown")).classList.add(Rn), i.classList.add(Rn)) : (i.classList.add(Rn), It.parents(i, ".nav, .list-group").forEach((t => {
                It.prev(t, ".nav-link, .list-group-item").forEach((t => t.classList.add(Rn))), It.prev(t, ".nav-item").forEach((t => {
                    It.children(t, Fn).forEach((t => t.classList.add(Rn)))
                }))
            }))), ye.trigger(this._scrollElement, "activate.bs.scrollspy", {
                relatedTarget: t
            })
        }
        _clear() {
            It.find(this._selector).filter((t => t.classList.contains(Rn))).forEach((t => t.classList.remove(Rn)))
        }
        static jQueryInterface(t) {
            return this.each((function () {
                const e = Hn.getInstance(this) || new Hn(this, "object" == typeof t ? t : {});
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]()
                }
            }))
        }
    }
    ye.on(window, "load.bs.scrollspy.data-api", (() => {
        It.find('[data-bs-spy="scroll"]').forEach((t => new Hn(t)))
    })), Jt(Hn);
    const Bn = "bs.tab",
        Yn = "active",
        Wn = "fade",
        Vn = "show",
        Xn = ".active",
        qn = ":scope > li > .active";
    class Zn extends be {
        static get NAME() {
            return "tab"
        }
        show() {
            if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && this._element.classList.contains(Yn)) return;
            let t;
            const e = zt(this._element),
                i = this._element.closest(".nav, .list-group");
            if (i) {
                const e = "UL" === i.nodeName || "OL" === i.nodeName ? qn : Xn;
                t = It.find(e, i), t = t[t.length - 1]
            }
            const n = t ? ye.trigger(t, "hide.bs.tab", {
                relatedTarget: this._element
            }) : null;
            if (ye.trigger(this._element, "show.bs.tab", {
                    relatedTarget: t
                }).defaultPrevented || null !== n && n.defaultPrevented) return;
            this._activate(this._element, i);
            const l = () => {
                ye.trigger(t, "hidden.bs.tab", {
                    relatedTarget: this._element
                }), ye.trigger(this._element, "shown.bs.tab", {
                    relatedTarget: t
                })
            };
            e ? this._activate(e, e.parentNode, l) : l()
        }
        _activate(t, e, i) {
            const n = (!e || "UL" !== e.nodeName && "OL" !== e.nodeName ? It.children(e, Xn) : It.find(qn, e))[0],
                l = i && n && n.classList.contains(Wn),
                r = () => this._transitionComplete(t, n, i);
            n && l ? (n.classList.remove(Vn), this._queueCallback(r, t, !0)) : r()
        }
        _transitionComplete(t, e, i) {
            if (e) {
                e.classList.remove(Yn);
                const t = It.findOne(":scope > .dropdown-menu .active", e.parentNode);
                t && t.classList.remove(Yn), "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !1)
            }
            t.classList.add(Yn), "tab" === t.getAttribute("role") && t.setAttribute("aria-selected", !0), Kt(t), t.classList.contains(Wn) && t.classList.add(Vn);
            let n = t.parentNode;
            if (n && "LI" === n.nodeName && (n = n.parentNode), n && n.classList.contains("dropdown-menu")) {
                const e = t.closest(".dropdown");
                e && It.find(".dropdown-toggle", e).forEach((t => t.classList.add(Yn))), t.setAttribute("aria-expanded", !0)
            }
            i && i()
        }
        static jQueryInterface(t) {
            return this.each((function () {
                const e = ie.get(this, Bn) || new Zn(this);
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]()
                }
            }))
        }
    }
    ye.on(document, "click.bs.tab.data-api", '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', (function (t) {
        if (["A", "AREA"].includes(this.tagName) && t.preventDefault(), Zt(this)) return;
        (ie.get(this, Bn) || new Zn(this)).show()
    })), Jt(Zn);
    const Gn = "toast",
        Un = "bs.toast",
        Kn = "hide",
        $n = "show",
        Qn = "showing",
        Jn = {
            animation: "boolean",
            autohide: "boolean",
            delay: "number"
        },
        tl = {
            animation: !0,
            autohide: !0,
            delay: 5e3
        };
    class el extends be {
        constructor(t, e) {
            super(t), this._config = this._getConfig(e), this._timeout = null, this._hasMouseInteraction = !1, this._hasKeyboardInteraction = !1, this._setListeners()
        }
        static get DefaultType() {
            return Jn
        }
        static get Default() {
            return tl
        }
        static get NAME() {
            return Gn
        }
        show() {
            if (ye.trigger(this._element, "show.bs.toast").defaultPrevented) return;
            this._clearTimeout(), this._config.animation && this._element.classList.add("fade");
            this._element.classList.remove(Kn), Kt(this._element), this._element.classList.add(Qn), this._queueCallback((() => {
                this._element.classList.remove(Qn), this._element.classList.add($n), ye.trigger(this._element, "shown.bs.toast"), this._maybeScheduleHide()
            }), this._element, this._config.animation)
        }
        hide() {
            if (!this._element.classList.contains($n)) return;
            if (ye.trigger(this._element, "hide.bs.toast").defaultPrevented) return;
            this._element.classList.remove($n), this._queueCallback((() => {
                this._element.classList.add(Kn), ye.trigger(this._element, "hidden.bs.toast")
            }), this._element, this._config.animation)
        }
        dispose() {
            this._clearTimeout(), this._element.classList.contains($n) && this._element.classList.remove($n), super.dispose()
        }
        _getConfig(t) {
            return t = {
                ...tl,
                ...Ce.getDataAttributes(this._element),
                ..."object" == typeof t && t ? t : {}
            }, Xt(Gn, t, this.constructor.DefaultType), t
        }
        _maybeScheduleHide() {
            this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout((() => {
                this.hide()
            }), this._config.delay)))
        }
        _onInteraction(t, e) {
            switch (t.type) {
                case "mouseover":
                case "mouseout":
                    this._hasMouseInteraction = e;
                    break;
                case "focusin":
                case "focusout":
                    this._hasKeyboardInteraction = e
            }
            if (e) return void this._clearTimeout();
            const i = t.relatedTarget;
            this._element === i || this._element.contains(i) || this._maybeScheduleHide()
        }
        _setListeners() {
            ye.on(this._element, "click.dismiss.bs.toast", '[data-bs-dismiss="toast"]', (() => this.hide())), ye.on(this._element, "mouseover.bs.toast", (t => this._onInteraction(t, !0))), ye.on(this._element, "mouseout.bs.toast", (t => this._onInteraction(t, !1))), ye.on(this._element, "focusin.bs.toast", (t => this._onInteraction(t, !0))), ye.on(this._element, "focusout.bs.toast", (t => this._onInteraction(t, !1)))
        }
        _clearTimeout() {
            clearTimeout(this._timeout), this._timeout = null
        }
        static jQueryInterface(t) {
            return this.each((function () {
                let e = ie.get(this, Un);
                if (e || (e = new el(this, "object" == typeof t && t)), "string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t](this)
                }
            }))
        }
    }
    Jt(el), [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).map((function (t) {
        return new Pn(t)
    })), [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map((function (t) {
        return new An(t)
    })), window.bootstrap = l;
    i(148), i(159);
    var il = i(61),
        nl = i.n(il),
        ll = (i(160), i(111), i(168), i(170), i(172), i(175), i(176), i(185), i(90)),
        rl = i.n(ll),
        al = i(91),
        ol = i.n(al),
        sl = i(137),
        cl = i.n(sl),
        ul = i(138),
        hl = (i(186), i(189), i(124), i(192), i(193), function (t) {
            return Array.prototype.reduce.call(t, (function (t, e) {
                var i = e.name.match(/data-simplebar-(.+)/);
                if (i) {
                    var n = i[1].replace(/\W+(.)/g, (function (t, e) {
                        return e.toUpperCase()
                    }));
                    switch (e.value) {
                        case "true":
                            t[n] = !0;
                            break;
                        case "false":
                            t[n] = !1;
                            break;
                        case void 0:
                            t[n] = !0;
                            break;
                        default:
                            t[n] = e.value
                    }
                }
                return t
            }), {})
        });

    function dl(t) {
        return t && t.ownerDocument && t.ownerDocument.defaultView ? t.ownerDocument.defaultView : window
    }

    function fl(t) {
        return t && t.ownerDocument ? t.ownerDocument : document
    }
    var pl = null,
        gl = null;

    function ml(t) {
        if (null === pl) {
            var e = fl(t);
            if (void 0 === e) return pl = 0;
            var i = e.body,
                n = e.createElement("div");
            n.classList.add("simplebar-hide-scrollbar"), i.appendChild(n);
            var l = n.getBoundingClientRect().right;
            i.removeChild(n), pl = l
        }
        return pl
    }
    nl.a && window.addEventListener("resize", (function () {
        gl !== window.devicePixelRatio && (gl = window.devicePixelRatio, pl = null)
    }));
    var vl = function () {
        function t(e, i) {
            var n = this;
            this.onScroll = function () {
                var t = dl(n.el);
                n.scrollXTicking || (t.requestAnimationFrame(n.scrollX), n.scrollXTicking = !0), n.scrollYTicking || (t.requestAnimationFrame(n.scrollY), n.scrollYTicking = !0)
            }, this.scrollX = function () {
                n.axis.x.isOverflowing && (n.showScrollbar("x"), n.positionScrollbar("x")), n.scrollXTicking = !1
            }, this.scrollY = function () {
                n.axis.y.isOverflowing && (n.showScrollbar("y"), n.positionScrollbar("y")), n.scrollYTicking = !1
            }, this.onMouseEnter = function () {
                n.showScrollbar("x"), n.showScrollbar("y")
            }, this.onMouseMove = function (t) {
                n.mouseX = t.clientX, n.mouseY = t.clientY, (n.axis.x.isOverflowing || n.axis.x.forceVisible) && n.onMouseMoveForAxis("x"), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && n.onMouseMoveForAxis("y")
            }, this.onMouseLeave = function () {
                n.onMouseMove.cancel(), (n.axis.x.isOverflowing || n.axis.x.forceVisible) && n.onMouseLeaveForAxis("x"), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && n.onMouseLeaveForAxis("y"), n.mouseX = -1, n.mouseY = -1
            }, this.onWindowResize = function () {
                n.scrollbarWidth = n.getScrollbarWidth(), n.hideNativeScrollbar()
            }, this.hideScrollbars = function () {
                n.axis.x.track.rect = n.axis.x.track.el.getBoundingClientRect(), n.axis.y.track.rect = n.axis.y.track.el.getBoundingClientRect(), n.isWithinBounds(n.axis.y.track.rect) || (n.axis.y.scrollbar.el.classList.remove(n.classNames.visible), n.axis.y.isVisible = !1), n.isWithinBounds(n.axis.x.track.rect) || (n.axis.x.scrollbar.el.classList.remove(n.classNames.visible), n.axis.x.isVisible = !1)
            }, this.onPointerEvent = function (t) {
                var e, i;
                n.axis.x.track.rect = n.axis.x.track.el.getBoundingClientRect(), n.axis.y.track.rect = n.axis.y.track.el.getBoundingClientRect(), (n.axis.x.isOverflowing || n.axis.x.forceVisible) && (e = n.isWithinBounds(n.axis.x.track.rect)), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && (i = n.isWithinBounds(n.axis.y.track.rect)), (e || i) && (t.preventDefault(), t.stopPropagation(), "mousedown" === t.type && (e && (n.axis.x.scrollbar.rect = n.axis.x.scrollbar.el.getBoundingClientRect(), n.isWithinBounds(n.axis.x.scrollbar.rect) ? n.onDragStart(t, "x") : n.onTrackClick(t, "x")), i && (n.axis.y.scrollbar.rect = n.axis.y.scrollbar.el.getBoundingClientRect(), n.isWithinBounds(n.axis.y.scrollbar.rect) ? n.onDragStart(t, "y") : n.onTrackClick(t, "y"))))
            }, this.drag = function (e) {
                var i = n.axis[n.draggedAxis].track,
                    l = i.rect[n.axis[n.draggedAxis].sizeAttr],
                    r = n.axis[n.draggedAxis].scrollbar,
                    a = n.contentWrapperEl[n.axis[n.draggedAxis].scrollSizeAttr],
                    o = parseInt(n.elStyles[n.axis[n.draggedAxis].sizeAttr], 10);
                e.preventDefault(), e.stopPropagation();
                var s = (("y" === n.draggedAxis ? e.pageY : e.pageX) - i.rect[n.axis[n.draggedAxis].offsetAttr] - n.axis[n.draggedAxis].dragOffset) / (l - r.size) * (a - o);
                "x" === n.draggedAxis && (s = n.isRtl && t.getRtlHelpers().isRtlScrollbarInverted ? s - (l + r.size) : s, s = n.isRtl && t.getRtlHelpers().isRtlScrollingInverted ? -s : s), n.contentWrapperEl[n.axis[n.draggedAxis].scrollOffsetAttr] = s
            }, this.onEndDrag = function (t) {
                var e = fl(n.el),
                    i = dl(n.el);
                t.preventDefault(), t.stopPropagation(), n.el.classList.remove(n.classNames.dragging), e.removeEventListener("mousemove", n.drag, !0), e.removeEventListener("mouseup", n.onEndDrag, !0), n.removePreventClickId = i.setTimeout((function () {
                    e.removeEventListener("click", n.preventClick, !0), e.removeEventListener("dblclick", n.preventClick, !0), n.removePreventClickId = null
                }))
            }, this.preventClick = function (t) {
                t.preventDefault(), t.stopPropagation()
            }, this.el = e, this.minScrollbarWidth = 20, this.options = Object.assign({}, t.defaultOptions, {}, i), this.classNames = Object.assign({}, t.defaultOptions.classNames, {}, this.options.classNames), this.axis = {
                x: {
                    scrollOffsetAttr: "scrollLeft",
                    sizeAttr: "width",
                    scrollSizeAttr: "scrollWidth",
                    offsetSizeAttr: "offsetWidth",
                    offsetAttr: "left",
                    overflowAttr: "overflowX",
                    dragOffset: 0,
                    isOverflowing: !0,
                    isVisible: !1,
                    forceVisible: !1,
                    track: {},
                    scrollbar: {}
                },
                y: {
                    scrollOffsetAttr: "scrollTop",
                    sizeAttr: "height",
                    scrollSizeAttr: "scrollHeight",
                    offsetSizeAttr: "offsetHeight",
                    offsetAttr: "top",
                    overflowAttr: "overflowY",
                    dragOffset: 0,
                    isOverflowing: !0,
                    isVisible: !1,
                    forceVisible: !1,
                    track: {},
                    scrollbar: {}
                }
            }, this.removePreventClickId = null, t.instances.has(this.el) || (this.recalculate = rl()(this.recalculate.bind(this), 64), this.onMouseMove = rl()(this.onMouseMove.bind(this), 64), this.hideScrollbars = ol()(this.hideScrollbars.bind(this), this.options.timeout), this.onWindowResize = ol()(this.onWindowResize.bind(this), 64, {
                leading: !0
            }), t.getRtlHelpers = cl()(t.getRtlHelpers), this.init())
        }
        t.getRtlHelpers = function () {
            var e = document.createElement("div");
            e.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
            var i = e.firstElementChild;
            document.body.appendChild(i);
            var n = i.firstElementChild;
            i.scrollLeft = 0;
            var l = t.getOffset(i),
                r = t.getOffset(n);
            i.scrollLeft = 999;
            var a = t.getOffset(n);
            return {
                isRtlScrollingInverted: l.left !== r.left && r.left - a.left != 0,
                isRtlScrollbarInverted: l.left !== r.left
            }
        }, t.getOffset = function (t) {
            var e = t.getBoundingClientRect(),
                i = fl(t),
                n = dl(t);
            return {
                top: e.top + (n.pageYOffset || i.documentElement.scrollTop),
                left: e.left + (n.pageXOffset || i.documentElement.scrollLeft)
            }
        };
        var e = t.prototype;
        return e.init = function () {
            t.instances.set(this.el, this), nl.a && (this.initDOM(), this.scrollbarWidth = this.getScrollbarWidth(), this.recalculate(), this.initListeners())
        }, e.initDOM = function () {
            var t = this;
            if (Array.prototype.filter.call(this.el.children, (function (e) {
                    return e.classList.contains(t.classNames.wrapper)
                })).length) this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper), this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper), this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl), this.offsetEl = this.el.querySelector("." + this.classNames.offset), this.maskEl = this.el.querySelector("." + this.classNames.mask), this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder), this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl), this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl), this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal), this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
            else {
                for (this.wrapperEl = document.createElement("div"), this.contentWrapperEl = document.createElement("div"), this.offsetEl = document.createElement("div"), this.maskEl = document.createElement("div"), this.contentEl = document.createElement("div"), this.placeholderEl = document.createElement("div"), this.heightAutoObserverWrapperEl = document.createElement("div"), this.heightAutoObserverEl = document.createElement("div"), this.wrapperEl.classList.add(this.classNames.wrapper), this.contentWrapperEl.classList.add(this.classNames.contentWrapper), this.offsetEl.classList.add(this.classNames.offset), this.maskEl.classList.add(this.classNames.mask), this.contentEl.classList.add(this.classNames.contentEl), this.placeholderEl.classList.add(this.classNames.placeholder), this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl), this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl); this.el.firstChild;) this.contentEl.appendChild(this.el.firstChild);
                this.contentWrapperEl.appendChild(this.contentEl), this.offsetEl.appendChild(this.contentWrapperEl), this.maskEl.appendChild(this.offsetEl), this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl), this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl), this.wrapperEl.appendChild(this.maskEl), this.wrapperEl.appendChild(this.placeholderEl), this.el.appendChild(this.wrapperEl)
            }
            if (!this.axis.x.track.el || !this.axis.y.track.el) {
                var e = document.createElement("div"),
                    i = document.createElement("div");
                e.classList.add(this.classNames.track), i.classList.add(this.classNames.scrollbar), e.appendChild(i), this.axis.x.track.el = e.cloneNode(!0), this.axis.x.track.el.classList.add(this.classNames.horizontal), this.axis.y.track.el = e.cloneNode(!0), this.axis.y.track.el.classList.add(this.classNames.vertical), this.el.appendChild(this.axis.x.track.el), this.el.appendChild(this.axis.y.track.el)
            }
            this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar), this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar), this.options.autoHide || (this.axis.x.scrollbar.el.classList.add(this.classNames.visible), this.axis.y.scrollbar.el.classList.add(this.classNames.visible)), this.el.setAttribute("data-simplebar", "init")
        }, e.initListeners = function () {
            var t = this,
                e = dl(this.el);
            this.options.autoHide && this.el.addEventListener("mouseenter", this.onMouseEnter), ["mousedown", "click", "dblclick"].forEach((function (e) {
                t.el.addEventListener(e, t.onPointerEvent, !0)
            })), ["touchstart", "touchend", "touchmove"].forEach((function (e) {
                t.el.addEventListener(e, t.onPointerEvent, {
                    capture: !0,
                    passive: !0
                })
            })), this.el.addEventListener("mousemove", this.onMouseMove), this.el.addEventListener("mouseleave", this.onMouseLeave), this.contentWrapperEl.addEventListener("scroll", this.onScroll), e.addEventListener("resize", this.onWindowResize);
            var i = !1,
                n = e.ResizeObserver || ul.a;
            this.resizeObserver = new n((function () {
                i && t.recalculate()
            })), this.resizeObserver.observe(this.el), this.resizeObserver.observe(this.contentEl), e.requestAnimationFrame((function () {
                i = !0
            })), this.mutationObserver = new e.MutationObserver(this.recalculate), this.mutationObserver.observe(this.contentEl, {
                childList: !0,
                subtree: !0,
                characterData: !0
            })
        }, e.recalculate = function () {
            var t = dl(this.el);
            this.elStyles = t.getComputedStyle(this.el), this.isRtl = "rtl" === this.elStyles.direction;
            var e = this.heightAutoObserverEl.offsetHeight <= 1,
                i = this.heightAutoObserverEl.offsetWidth <= 1,
                n = this.contentEl.offsetWidth,
                l = this.contentWrapperEl.offsetWidth,
                r = this.elStyles.overflowX,
                a = this.elStyles.overflowY;
            this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft, this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
            var o = this.contentEl.scrollHeight,
                s = this.contentEl.scrollWidth;
            this.contentWrapperEl.style.height = e ? "auto" : "100%", this.placeholderEl.style.width = i ? n + "px" : "auto", this.placeholderEl.style.height = o + "px";
            var c = this.contentWrapperEl.offsetHeight;
            this.axis.x.isOverflowing = s > n, this.axis.y.isOverflowing = o > c, this.axis.x.isOverflowing = "hidden" !== r && this.axis.x.isOverflowing, this.axis.y.isOverflowing = "hidden" !== a && this.axis.y.isOverflowing, this.axis.x.forceVisible = "x" === this.options.forceVisible || !0 === this.options.forceVisible, this.axis.y.forceVisible = "y" === this.options.forceVisible || !0 === this.options.forceVisible, this.hideNativeScrollbar();
            var u = this.axis.x.isOverflowing ? this.scrollbarWidth : 0,
                h = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
            this.axis.x.isOverflowing = this.axis.x.isOverflowing && s > l - h, this.axis.y.isOverflowing = this.axis.y.isOverflowing && o > c - u, this.axis.x.scrollbar.size = this.getScrollbarSize("x"), this.axis.y.scrollbar.size = this.getScrollbarSize("y"), this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px", this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px", this.positionScrollbar("x"), this.positionScrollbar("y"), this.toggleTrackVisibility("x"), this.toggleTrackVisibility("y")
        }, e.getScrollbarSize = function (t) {
            if (void 0 === t && (t = "y"), !this.axis[t].isOverflowing) return 0;
            var e, i = this.contentEl[this.axis[t].scrollSizeAttr],
                n = this.axis[t].track.el[this.axis[t].offsetSizeAttr],
                l = n / i;
            return e = Math.max(~~(l * n), this.options.scrollbarMinSize), this.options.scrollbarMaxSize && (e = Math.min(e, this.options.scrollbarMaxSize)), e
        }, e.positionScrollbar = function (e) {
            if (void 0 === e && (e = "y"), this.axis[e].isOverflowing) {
                var i = this.contentWrapperEl[this.axis[e].scrollSizeAttr],
                    n = this.axis[e].track.el[this.axis[e].offsetSizeAttr],
                    l = parseInt(this.elStyles[this.axis[e].sizeAttr], 10),
                    r = this.axis[e].scrollbar,
                    a = this.contentWrapperEl[this.axis[e].scrollOffsetAttr],
                    o = (a = "x" === e && this.isRtl && t.getRtlHelpers().isRtlScrollingInverted ? -a : a) / (i - l),
                    s = ~~((n - r.size) * o);
                s = "x" === e && this.isRtl && t.getRtlHelpers().isRtlScrollbarInverted ? s + (n - r.size) : s, r.el.style.transform = "x" === e ? "translate3d(" + s + "px, 0, 0)" : "translate3d(0, " + s + "px, 0)"
            }
        }, e.toggleTrackVisibility = function (t) {
            void 0 === t && (t = "y");
            var e = this.axis[t].track.el,
                i = this.axis[t].scrollbar.el;
            this.axis[t].isOverflowing || this.axis[t].forceVisible ? (e.style.visibility = "visible", this.contentWrapperEl.style[this.axis[t].overflowAttr] = "scroll") : (e.style.visibility = "hidden", this.contentWrapperEl.style[this.axis[t].overflowAttr] = "hidden"), this.axis[t].isOverflowing ? i.style.display = "block" : i.style.display = "none"
        }, e.hideNativeScrollbar = function () {
            this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0, this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0
        }, e.onMouseMoveForAxis = function (t) {
            void 0 === t && (t = "y"), this.axis[t].track.rect = this.axis[t].track.el.getBoundingClientRect(), this.axis[t].scrollbar.rect = this.axis[t].scrollbar.el.getBoundingClientRect(), this.isWithinBounds(this.axis[t].scrollbar.rect) ? this.axis[t].scrollbar.el.classList.add(this.classNames.hover) : this.axis[t].scrollbar.el.classList.remove(this.classNames.hover), this.isWithinBounds(this.axis[t].track.rect) ? (this.showScrollbar(t), this.axis[t].track.el.classList.add(this.classNames.hover)) : this.axis[t].track.el.classList.remove(this.classNames.hover)
        }, e.onMouseLeaveForAxis = function (t) {
            void 0 === t && (t = "y"), this.axis[t].track.el.classList.remove(this.classNames.hover), this.axis[t].scrollbar.el.classList.remove(this.classNames.hover)
        }, e.showScrollbar = function (t) {
            void 0 === t && (t = "y");
            var e = this.axis[t].scrollbar.el;
            this.axis[t].isVisible || (e.classList.add(this.classNames.visible), this.axis[t].isVisible = !0), this.options.autoHide && this.hideScrollbars()
        }, e.onDragStart = function (t, e) {
            void 0 === e && (e = "y");
            var i = fl(this.el),
                n = dl(this.el),
                l = this.axis[e].scrollbar,
                r = "y" === e ? t.pageY : t.pageX;
            this.axis[e].dragOffset = r - l.rect[this.axis[e].offsetAttr], this.draggedAxis = e, this.el.classList.add(this.classNames.dragging), i.addEventListener("mousemove", this.drag, !0), i.addEventListener("mouseup", this.onEndDrag, !0), null === this.removePreventClickId ? (i.addEventListener("click", this.preventClick, !0), i.addEventListener("dblclick", this.preventClick, !0)) : (n.clearTimeout(this.removePreventClickId), this.removePreventClickId = null)
        }, e.onTrackClick = function (t, e) {
            var i = this;
            if (void 0 === e && (e = "y"), this.options.clickOnTrack) {
                var n = dl(this.el);
                this.axis[e].scrollbar.rect = this.axis[e].scrollbar.el.getBoundingClientRect();
                var l = this.axis[e].scrollbar.rect[this.axis[e].offsetAttr],
                    r = parseInt(this.elStyles[this.axis[e].sizeAttr], 10),
                    a = this.contentWrapperEl[this.axis[e].scrollOffsetAttr],
                    o = ("y" === e ? this.mouseY - l : this.mouseX - l) < 0 ? -1 : 1,
                    s = -1 === o ? a - r : a + r;
                ! function t() {
                    var l, r; - 1 === o ? a > s && (a -= i.options.clickOnTrackSpeed, i.contentWrapperEl.scrollTo(((l = {})[i.axis[e].offsetAttr] = a, l)), n.requestAnimationFrame(t)) : a < s && (a += i.options.clickOnTrackSpeed, i.contentWrapperEl.scrollTo(((r = {})[i.axis[e].offsetAttr] = a, r)), n.requestAnimationFrame(t))
                }()
            }
        }, e.getContentElement = function () {
            return this.contentEl
        }, e.getScrollElement = function () {
            return this.contentWrapperEl
        }, e.getScrollbarWidth = function () {
            try {
                return "none" === getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style ? 0 : ml(this.el)
            } catch (t) {
                return ml(this.el)
            }
        }, e.removeListeners = function () {
            var t = this,
                e = dl(this.el);
            this.options.autoHide && this.el.removeEventListener("mouseenter", this.onMouseEnter), ["mousedown", "click", "dblclick"].forEach((function (e) {
                t.el.removeEventListener(e, t.onPointerEvent, !0)
            })), ["touchstart", "touchend", "touchmove"].forEach((function (e) {
                t.el.removeEventListener(e, t.onPointerEvent, {
                    capture: !0,
                    passive: !0
                })
            })), this.el.removeEventListener("mousemove", this.onMouseMove), this.el.removeEventListener("mouseleave", this.onMouseLeave), this.contentWrapperEl && this.contentWrapperEl.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onWindowResize), this.mutationObserver && this.mutationObserver.disconnect(), this.resizeObserver && this.resizeObserver.disconnect(), this.recalculate.cancel(), this.onMouseMove.cancel(), this.hideScrollbars.cancel(), this.onWindowResize.cancel()
        }, e.unMount = function () {
            this.removeListeners(), t.instances.delete(this.el)
        }, e.isWithinBounds = function (t) {
            return this.mouseX >= t.left && this.mouseX <= t.left + t.width && this.mouseY >= t.top && this.mouseY <= t.top + t.height
        }, e.findChild = function (t, e) {
            var i = t.matches || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector;
            return Array.prototype.filter.call(t.children, (function (t) {
                return i.call(t, e)
            }))[0]
        }, t
    }();
    vl.defaultOptions = {
        autoHide: !0,
        forceVisible: !1,
        clickOnTrack: !0,
        clickOnTrackSpeed: 40,
        classNames: {
            contentEl: "simplebar-content",
            contentWrapper: "simplebar-content-wrapper",
            offset: "simplebar-offset",
            mask: "simplebar-mask",
            wrapper: "simplebar-wrapper",
            placeholder: "simplebar-placeholder",
            scrollbar: "simplebar-scrollbar",
            track: "simplebar-track",
            heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
            heightAutoObserverEl: "simplebar-height-auto-observer",
            visible: "simplebar-visible",
            horizontal: "simplebar-horizontal",
            vertical: "simplebar-vertical",
            hover: "simplebar-hover",
            dragging: "simplebar-dragging"
        },
        scrollbarMinSize: 25,
        scrollbarMaxSize: 0,
        timeout: 1e3
    }, vl.instances = new WeakMap, vl.initDOMLoadedElements = function () {
        document.removeEventListener("DOMContentLoaded", this.initDOMLoadedElements), window.removeEventListener("load", this.initDOMLoadedElements), Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"), (function (t) {
            "init" === t.getAttribute("data-simplebar") || vl.instances.has(t) || new vl(t, hl(t.attributes))
        }))
    }, vl.removeObserver = function () {
        this.globalObserver.disconnect()
    }, vl.initHtmlApi = function () {
        this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this), "undefined" != typeof MutationObserver && (this.globalObserver = new MutationObserver(vl.handleMutations), this.globalObserver.observe(document, {
            childList: !0,
            subtree: !0
        })), "complete" === document.readyState || "loading" !== document.readyState && !document.documentElement.doScroll ? window.setTimeout(this.initDOMLoadedElements) : (document.addEventListener("DOMContentLoaded", this.initDOMLoadedElements), window.addEventListener("load", this.initDOMLoadedElements))
    }, vl.handleMutations = function (t) {
        t.forEach((function (t) {
            Array.prototype.forEach.call(t.addedNodes, (function (t) {
                1 === t.nodeType && (t.hasAttribute("data-simplebar") ? !vl.instances.has(t) && new vl(t, hl(t.attributes)) : Array.prototype.forEach.call(t.querySelectorAll("[data-simplebar]"), (function (t) {
                    "init" === t.getAttribute("data-simplebar") || vl.instances.has(t) || new vl(t, hl(t.attributes))
                })))
            })), Array.prototype.forEach.call(t.removedNodes, (function (t) {
                1 === t.nodeType && (t.hasAttribute('[data-simplebar="init"]') ? vl.instances.has(t) && vl.instances.get(t).unMount() : Array.prototype.forEach.call(t.querySelectorAll('[data-simplebar="init"]'), (function (t) {
                    vl.instances.has(t) && vl.instances.get(t).unMount()
                })))
            }))
        }))
    }, vl.getOptions = hl, nl.a && vl.initHtmlApi();
    var yl = vl,
        bl = function () {
            if (document.getElementsByClassName("js-simplebar")[0]) {
                var t = new yl(document.getElementsByClassName("js-simplebar")[0]);
                document.querySelectorAll(".js-sidebar [data-bs-parent]").forEach((function (e) {
                    e.addEventListener("shown.bs.collapse", (function () {
                        t.recalculate()
                    })), e.addEventListener("hidden.bs.collapse", (function () {
                        t.recalculate()
                    }))
                }))
            }
        },
        xl = function () {
            var t = document.getElementsByClassName("js-sidebar")[0],
                e = document.getElementsByClassName("js-sidebar-toggle")[0];
            t && e && e.addEventListener("click", (function () {
                t.classList.toggle("collapsed"), t.addEventListener("transitionend", (function () {
                    window.dispatchEvent(new Event("resize"))
                }))
            }))
        };
    document.addEventListener("DOMContentLoaded", (function () {
        return bl(), void xl()
    }));
    i(195);
    var wl = {
            id: "light",
            name: "Light",
            primary: "#3B7DDD",
            secondary: "#6c757d",
            success: "#1cbb8c",
            info: "#17a2b8",
            warning: "#fcb92c",
            danger: "#dc3545",
            white: "#fff",
            "gray-100": "#f8f9fa",
            "gray-200": "#e9ecef",
            "gray-300": "#dee2e6",
            "gray-400": "#ced4da",
            "gray-500": "#adb5bd",
            "gray-600": "#6c757d",
            "gray-700": "#495057",
            "gray-800": "#343a40",
            "gray-900": "#212529",
            black: "#000"
        },
        _l = {
            id: "dark",
            name: "Dark",
            primary: "#3B7DDD",
            secondary: "#7a828a",
            success: "#1cbb8c",
            info: "#17a2b8",
            warning: "#fcb92c",
            danger: "#dc3545",
            white: "#222E3C",
            "gray-100": "#384350",
            "gray-200": "#4e5863",
            "gray-300": "#646d77",
            "gray-400": "#7a828a",
            "gray-500": "#91979e",
            "gray-600": "#a7abb1",
            "gray-700": "#bdc0c5",
            "gray-800": "#d3d5d8",
            "gray-900": "#e9eaec",
            black: "#fff"
        };
    document.querySelectorAll("link[href]").forEach((function (t) {
        "dark.css" === t.href.split("/").pop() ? window.theme = _l : window.theme = wl
    }));
    i(197), i(84);
    var kl = i(92),
        Sl = i.n(kl);
    document.addEventListener("DOMContentLoaded", (function () {
        Sl.a.replace()
    })), window.feather = Sl.a;
    var Al = i(139),
        Ml = i.n(Al);
    window.dragula = Ml.a;
    var Cl, El = function () {
            return (El = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++)
                    for (var l in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, l) && (t[l] = e[l]);
                return t
            }).apply(this, arguments)
        },
        Ol = function () {
            function t(t) {
                this.options = t, this.listeners = {}
            }
            return t.prototype.on = function (t, e) {
                var i = this.listeners[t] || [];
                this.listeners[t] = i.concat([e])
            }, t.prototype.triggerEvent = function (t, e) {
                var i = this;
                (this.listeners[t] || []).forEach((function (t) {
                    return t({
                        target: i,
                        event: e
                    })
                }))
            }, t
        }();
    ! function (t) {
        t[t.Add = 0] = "Add", t[t.Remove = 1] = "Remove"
    }(Cl || (Cl = {}));
    var Tl, Pl = function () {
        function t() {
            this.notifications = []
        }
        return t.prototype.push = function (t) {
            this.notifications.push(t), this.updateFn(t, Cl.Add, this.notifications)
        }, t.prototype.splice = function (t, e) {
            var i = this.notifications.splice(t, e)[0];
            return this.updateFn(i, Cl.Remove, this.notifications), i
        }, t.prototype.indexOf = function (t) {
            return this.notifications.indexOf(t)
        }, t.prototype.onUpdate = function (t) {
            this.updateFn = t
        }, t
    }();
    ! function (t) {
        t.Dismiss = "dismiss", t.Click = "click"
    }(Tl || (Tl = {}));
    var Ll = {
            types: [{
                type: "success",
                className: "notyf__toast--success",
                backgroundColor: "#3dc763",
                icon: {
                    className: "notyf__icon--success",
                    tagName: "i"
                }
            }, {
                type: "error",
                className: "notyf__toast--error",
                backgroundColor: "#ed3d3d",
                icon: {
                    className: "notyf__icon--error",
                    tagName: "i"
                }
            }],
            duration: 2e3,
            ripple: !0,
            position: {
                x: "right",
                y: "bottom"
            },
            dismissible: !1
        },
        Dl = function () {
            function t() {
                this.notifications = [], this.events = {}, this.X_POSITION_FLEX_MAP = {
                    left: "flex-start",
                    center: "center",
                    right: "flex-end"
                }, this.Y_POSITION_FLEX_MAP = {
                    top: "flex-start",
                    center: "center",
                    bottom: "flex-end"
                };
                var t = document.createDocumentFragment(),
                    e = this._createHTLMElement({
                        tagName: "div",
                        className: "notyf"
                    });
                t.appendChild(e), document.body.appendChild(t), this.container = e, this.animationEndEventName = this._getAnimationEndEventName(), this._createA11yContainer()
            }
            return t.prototype.on = function (t, e) {
                var i;
                this.events = El(El({}, this.events), ((i = {})[t] = e, i))
            }, t.prototype.update = function (t, e) {
                e === Cl.Add ? this.addNotification(t) : e === Cl.Remove && this.removeNotification(t)
            }, t.prototype.removeNotification = function (t) {
                var e, i, n = this,
                    l = this._popRenderedNotification(t);
                l && ((e = l.node).classList.add("notyf__toast--disappear"), e.addEventListener(this.animationEndEventName, i = function (t) {
                    t.target === e && (e.removeEventListener(n.animationEndEventName, i), n.container.removeChild(e))
                }))
            }, t.prototype.addNotification = function (t) {
                var e = this._renderNotification(t);
                this.notifications.push({
                    notification: t,
                    node: e
                }), this._announce(t.options.message || "Notification")
            }, t.prototype._renderNotification = function (t) {
                var e, i = this._buildNotificationCard(t),
                    n = t.options.className;
                return n && (e = i.classList).add.apply(e, n.split(" ")), this.container.appendChild(i), i
            }, t.prototype._popRenderedNotification = function (t) {
                for (var e = -1, i = 0; i < this.notifications.length && e < 0; i++) this.notifications[i].notification === t && (e = i);
                if (-1 !== e) return this.notifications.splice(e, 1)[0]
            }, t.prototype.getXPosition = function (t) {
                var e;
                return (null === (e = null == t ? void 0 : t.position) || void 0 === e ? void 0 : e.x) || "right"
            }, t.prototype.getYPosition = function (t) {
                var e;
                return (null === (e = null == t ? void 0 : t.position) || void 0 === e ? void 0 : e.y) || "bottom"
            }, t.prototype.adjustContainerAlignment = function (t) {
                var e = this.X_POSITION_FLEX_MAP[this.getXPosition(t)],
                    i = this.Y_POSITION_FLEX_MAP[this.getYPosition(t)],
                    n = this.container.style;
                n.setProperty("justify-content", i), n.setProperty("align-items", e)
            }, t.prototype._buildNotificationCard = function (t) {
                var e, i = this,
                    n = t.options,
                    l = n.icon;
                this.adjustContainerAlignment(n);
                var r = this._createHTLMElement({
                        tagName: "div",
                        className: "notyf__toast"
                    }),
                    a = this._createHTLMElement({
                        tagName: "div",
                        className: "notyf__ripple"
                    }),
                    o = this._createHTLMElement({
                        tagName: "div",
                        className: "notyf__wrapper"
                    }),
                    s = this._createHTLMElement({
                        tagName: "div",
                        className: "notyf__message"
                    });
                s.innerHTML = n.message || "";
                var c = n.background || n.backgroundColor;
                if (l && "object" == typeof l) {
                    var u = this._createHTLMElement({
                            tagName: "div",
                            className: "notyf__icon"
                        }),
                        h = this._createHTLMElement({
                            tagName: l.tagName || "i",
                            className: l.className,
                            text: l.text
                        }),
                        d = null !== (e = l.color) && void 0 !== e ? e : c;
                    d && (h.style.color = d), u.appendChild(h), o.appendChild(u)
                }
                if (o.appendChild(s), r.appendChild(o), c && (n.ripple ? (a.style.background = c, r.appendChild(a)) : r.style.background = c), n.dismissible) {
                    var f = this._createHTLMElement({
                            tagName: "div",
                            className: "notyf__dismiss"
                        }),
                        p = this._createHTLMElement({
                            tagName: "button",
                            className: "notyf__dismiss-btn"
                        });
                    f.appendChild(p), o.appendChild(f), r.classList.add("notyf__toast--dismissible"), p.addEventListener("click", (function (e) {
                        var n, l;
                        null === (l = (n = i.events)[Tl.Dismiss]) || void 0 === l || l.call(n, {
                            target: t,
                            event: e
                        }), e.stopPropagation()
                    }))
                }
                r.addEventListener("click", (function (e) {
                    var n, l;
                    return null === (l = (n = i.events)[Tl.Click]) || void 0 === l ? void 0 : l.call(n, {
                        target: t,
                        event: e
                    })
                }));
                var g = "top" === this.getYPosition(n) ? "upper" : "lower";
                return r.classList.add("notyf__toast--" + g), r
            }, t.prototype._createHTLMElement = function (t) {
                var e = t.tagName,
                    i = t.className,
                    n = t.text,
                    l = document.createElement(e);
                return i && (l.className = i), l.textContent = n || null, l
            }, t.prototype._createA11yContainer = function () {
                var t = this._createHTLMElement({
                    tagName: "div",
                    className: "notyf-announcer"
                });
                t.setAttribute("aria-atomic", "true"), t.setAttribute("aria-live", "polite"), t.style.border = "0", t.style.clip = "rect(0 0 0 0)", t.style.height = "1px", t.style.margin = "-1px", t.style.overflow = "hidden", t.style.padding = "0", t.style.position = "absolute", t.style.width = "1px", t.style.outline = "0", document.body.appendChild(t), this.a11yContainer = t
            }, t.prototype._announce = function (t) {
                var e = this;
                this.a11yContainer.textContent = "", setTimeout((function () {
                    e.a11yContainer.textContent = t
                }), 100)
            }, t.prototype._getAnimationEndEventName = function () {
                var t, e = document.createElement("_fake"),
                    i = {
                        MozTransition: "animationend",
                        OTransition: "oAnimationEnd",
                        WebkitTransition: "webkitAnimationEnd",
                        transition: "animationend"
                    };
                for (t in i)
                    if (void 0 !== e.style[t]) return i[t];
                return "animationend"
            }, t
        }(),
        Il = function () {
            function t(t) {
                var e = this;
                this.dismiss = this._removeNotification, this.notifications = new Pl, this.view = new Dl;
                var i = this.registerTypes(t);
                this.options = El(El({}, Ll), t), this.options.types = i, this.notifications.onUpdate((function (t, i) {
                    return e.view.update(t, i)
                })), this.view.on(Tl.Dismiss, (function (t) {
                    var i = t.target,
                        n = t.event;
                    e._removeNotification(i), i.triggerEvent(Tl.Dismiss, n)
                })), this.view.on(Tl.Click, (function (t) {
                    var e = t.target,
                        i = t.event;
                    return e.triggerEvent(Tl.Click, i)
                }))
            }
            return t.prototype.error = function (t) {
                var e = this.normalizeOptions("error", t);
                return this.open(e)
            }, t.prototype.success = function (t) {
                var e = this.normalizeOptions("success", t);
                return this.open(e)
            }, t.prototype.open = function (t) {
                var e = this.options.types.find((function (e) {
                        return e.type === t.type
                    })) || {},
                    i = El(El({}, e), t);
                this.assignProps(["ripple", "position", "dismissible"], i);
                var n = new Ol(i);
                return this._pushNotification(n), n
            }, t.prototype.dismissAll = function () {
                for (; this.notifications.splice(0, 1););
            }, t.prototype.assignProps = function (t, e) {
                var i = this;
                t.forEach((function (t) {
                    e[t] = null == e[t] ? i.options[t] : e[t]
                }))
            }, t.prototype._pushNotification = function (t) {
                var e = this;
                this.notifications.push(t);
                var i = void 0 !== t.options.duration ? t.options.duration : this.options.duration;
                i && setTimeout((function () {
                    return e._removeNotification(t)
                }), i)
            }, t.prototype._removeNotification = function (t) {
                var e = this.notifications.indexOf(t); - 1 !== e && this.notifications.splice(e, 1)
            }, t.prototype.normalizeOptions = function (t, e) {
                var i = {
                    type: t
                };
                return "string" == typeof e ? i.message = e : "object" == typeof e && (i = El(El({}, i), e)), i
            }, t.prototype.registerTypes = function (t) {
                var e = (t && t.types || []).slice();
                return Ll.types.map((function (t) {
                    var i = -1;
                    e.forEach((function (e, n) {
                        e.type === t.type && (i = n)
                    }));
                    var n = -1 !== i ? e.splice(i, 1)[0] : {};
                    return El(El({}, t), n)
                })).concat(e)
            }, t
        }();
    window.notyf = new Il({
        duration: 5e3,
        position: {
            x: "right",
            y: "top"
        },
        types: [{
            type: "default",
            backgroundColor: "#3B7DDD",
            icon: {
                className: "notyf__icon--success",
                tagName: "i"
            }
        }, {
            type: "success",
            backgroundColor: "#28a745",
            icon: {
                className: "notyf__icon--success",
                tagName: "i"
            }
        }, {
            type: "warning",
            backgroundColor: "#ffc107",
            icon: {
                className: "notyf__icon--error",
                tagName: "i"
            }
        }, {
            type: "danger",
            backgroundColor: "#dc3545",
            icon: {
                className: "notyf__icon--error",
                tagName: "i"
            }
        }]
    });
    var jl = i(140),
        Nl = i.n(jl);
    window.ApexCharts = Nl.a, document.addEventListener("DOMContentLoaded", (function () {
        window.Apex = {
            colors: [window.theme.primary, window.theme.success, window.theme.warning, window.theme.danger, window.theme.info],
            chart: {
                foreColor: window.theme["gray-600"]
            }
        }, setTimeout((function () {
            window.dispatchEvent(new Event("resize"))
        }), 250)
    }));
    var Rl = i(93),
        Fl = i.n(Rl);
    Fl.a.defaults.global.defaultFontFamily = "'Inter', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif", window.Chart = Fl.a;
    var zl = i(141),
        Hl = i.n(zl);
    window.Choices = Hl.a;
    const Bl = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"],
        Yl = {
            _disable: [],
            allowInput: !1,
            allowInvalidPreload: !1,
            altFormat: "F j, Y",
            altInput: !1,
            altInputClass: "form-control input",
            animate: "object" == typeof window && -1 === window.navigator.userAgent.indexOf("MSIE"),
            ariaDateFormat: "F j, Y",
            autoFillDefaultTime: !0,
            clickOpens: !0,
            closeOnSelect: !0,
            conjunction: ", ",
            dateFormat: "Y-m-d",
            defaultHour: 12,
            defaultMinute: 0,
            defaultSeconds: 0,
            disable: [],
            disableMobile: !1,
            enableSeconds: !1,
            enableTime: !1,
            errorHandler: t => "undefined" != typeof console && console.warn(t),
            getWeek: t => {
                const e = new Date(t.getTime());
                e.setHours(0, 0, 0, 0), e.setDate(e.getDate() + 3 - (e.getDay() + 6) % 7);
                var i = new Date(e.getFullYear(), 0, 4);
                return 1 + Math.round(((e.getTime() - i.getTime()) / 864e5 - 3 + (i.getDay() + 6) % 7) / 7)
            },
            hourIncrement: 1,
            ignoredFocusElements: [],
            inline: !1,
            locale: "default",
            minuteIncrement: 5,
            mode: "single",
            monthSelectorType: "dropdown",
            nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
            noCalendar: !1,
            now: new Date,
            onChange: [],
            onClose: [],
            onDayCreate: [],
            onDestroy: [],
            onKeyDown: [],
            onMonthChange: [],
            onOpen: [],
            onParseConfig: [],
            onReady: [],
            onValueUpdate: [],
            onYearChange: [],
            onPreCalendarPosition: [],
            plugins: [],
            position: "auto",
            positionElement: void 0,
            prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
            shorthandCurrentMonth: !1,
            showMonths: 1,
            static: !1,
            time_24hr: !1,
            weekNumbers: !1,
            wrap: !1
        },
        Wl = {
            weekdays: {
                shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
            },
            months: {
                shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            },
            daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            firstDayOfWeek: 0,
            ordinal: t => {
                const e = t % 100;
                if (e > 3 && e < 21) return "th";
                switch (e % 10) {
                    case 1:
                        return "st";
                    case 2:
                        return "nd";
                    case 3:
                        return "rd";
                    default:
                        return "th"
                }
            },
            rangeSeparator: " to ",
            weekAbbreviation: "Wk",
            scrollTitle: "Scroll to increment",
            toggleTitle: "Click to toggle",
            amPM: ["AM", "PM"],
            yearAriaLabel: "Year",
            monthAriaLabel: "Month",
            hourAriaLabel: "Hour",
            minuteAriaLabel: "Minute",
            time_24hr: !1
        };
    var Vl = Wl;
    const Xl = (t, e = 2) => `000${t}`.slice(-1 * e),
        ql = t => !0 === t ? 1 : 0;

    function Zl(t, e) {
        let i;
        return function () {
            clearTimeout(i), i = setTimeout((() => t.apply(this, arguments)), e)
        }
    }
    const Gl = t => t instanceof Array ? t : [t];

    function Ul(t, e, i) {
        if (!0 === i) return t.classList.add(e);
        t.classList.remove(e)
    }

    function Kl(t, e, i) {
        const n = window.document.createElement(t);
        return e = e || "", i = i || "", n.className = e, void 0 !== i && (n.textContent = i), n
    }

    function $l(t) {
        for (; t.firstChild;) t.removeChild(t.firstChild)
    }

    function Ql(t, e) {
        return e(t) ? t : t.parentNode ? Ql(t.parentNode, e) : void 0
    }

    function Jl(t, e) {
        const i = Kl("div", "numInputWrapper"),
            n = Kl("input", "numInput " + t),
            l = Kl("span", "arrowUp"),
            r = Kl("span", "arrowDown");
        if (-1 === navigator.userAgent.indexOf("MSIE 9.0") ? n.type = "number" : (n.type = "text", n.pattern = "\\d*"), void 0 !== e)
            for (const t in e) n.setAttribute(t, e[t]);
        return i.appendChild(n), i.appendChild(l), i.appendChild(r), i
    }

    function tr(t) {
        try {
            if ("function" == typeof t.composedPath) {
                return t.composedPath()[0]
            }
            return t.target
        } catch (e) {
            return t.target
        }
    }
    const er = () => {},
        ir = (t, e, i) => i.months[e ? "shorthand" : "longhand"][t],
        nr = {
            D: er,
            F: function (t, e, i) {
                t.setMonth(i.months.longhand.indexOf(e))
            },
            G: (t, e) => {
                t.setHours(parseFloat(e))
            },
            H: (t, e) => {
                t.setHours(parseFloat(e))
            },
            J: (t, e) => {
                t.setDate(parseFloat(e))
            },
            K: (t, e, i) => {
                t.setHours(t.getHours() % 12 + 12 * ql(new RegExp(i.amPM[1], "i").test(e)))
            },
            M: function (t, e, i) {
                t.setMonth(i.months.shorthand.indexOf(e))
            },
            S: (t, e) => {
                t.setSeconds(parseFloat(e))
            },
            U: (t, e) => new Date(1e3 * parseFloat(e)),
            W: function (t, e, i) {
                const n = parseInt(e),
                    l = new Date(t.getFullYear(), 0, 2 + 7 * (n - 1), 0, 0, 0, 0);
                return l.setDate(l.getDate() - l.getDay() + i.firstDayOfWeek), l
            },
            Y: (t, e) => {
                t.setFullYear(parseFloat(e))
            },
            Z: (t, e) => new Date(e),
            d: (t, e) => {
                t.setDate(parseFloat(e))
            },
            h: (t, e) => {
                t.setHours(parseFloat(e))
            },
            i: (t, e) => {
                t.setMinutes(parseFloat(e))
            },
            j: (t, e) => {
                t.setDate(parseFloat(e))
            },
            l: er,
            m: (t, e) => {
                t.setMonth(parseFloat(e) - 1)
            },
            n: (t, e) => {
                t.setMonth(parseFloat(e) - 1)
            },
            s: (t, e) => {
                t.setSeconds(parseFloat(e))
            },
            u: (t, e) => new Date(parseFloat(e)),
            w: er,
            y: (t, e) => {
                t.setFullYear(2e3 + parseFloat(e))
            }
        },
        lr = {
            D: "(\\w+)",
            F: "(\\w+)",
            G: "(\\d\\d|\\d)",
            H: "(\\d\\d|\\d)",
            J: "(\\d\\d|\\d)\\w+",
            K: "",
            M: "(\\w+)",
            S: "(\\d\\d|\\d)",
            U: "(.+)",
            W: "(\\d\\d|\\d)",
            Y: "(\\d{4})",
            Z: "(.+)",
            d: "(\\d\\d|\\d)",
            h: "(\\d\\d|\\d)",
            i: "(\\d\\d|\\d)",
            j: "(\\d\\d|\\d)",
            l: "(\\w+)",
            m: "(\\d\\d|\\d)",
            n: "(\\d\\d|\\d)",
            s: "(\\d\\d|\\d)",
            u: "(.+)",
            w: "(\\d\\d|\\d)",
            y: "(\\d{2})"
        },
        rr = {
            Z: t => t.toISOString(),
            D: function (t, e, i) {
                return e.weekdays.shorthand[rr.w(t, e, i)]
            },
            F: function (t, e, i) {
                return ir(rr.n(t, e, i) - 1, !1, e)
            },
            G: function (t, e, i) {
                return Xl(rr.h(t, e, i))
            },
            H: t => Xl(t.getHours()),
            J: function (t, e) {
                return void 0 !== e.ordinal ? t.getDate() + e.ordinal(t.getDate()) : t.getDate()
            },
            K: (t, e) => e.amPM[ql(t.getHours() > 11)],
            M: function (t, e) {
                return ir(t.getMonth(), !0, e)
            },
            S: t => Xl(t.getSeconds()),
            U: t => t.getTime() / 1e3,
            W: function (t, e, i) {
                return i.getWeek(t)
            },
            Y: t => Xl(t.getFullYear(), 4),
            d: t => Xl(t.getDate()),
            h: t => t.getHours() % 12 ? t.getHours() % 12 : 12,
            i: t => Xl(t.getMinutes()),
            j: t => t.getDate(),
            l: function (t, e) {
                return e.weekdays.longhand[t.getDay()]
            },
            m: t => Xl(t.getMonth() + 1),
            n: t => t.getMonth() + 1,
            s: t => t.getSeconds(),
            u: t => t.getTime(),
            w: t => t.getDay(),
            y: t => String(t.getFullYear()).substring(2)
        },
        ar = ({
            config: t = Yl,
            l10n: e = Wl,
            isMobile: i = !1
        }) => (n, l, r) => {
            const a = r || e;
            return void 0 === t.formatDate || i ? l.split("").map(((e, i, l) => rr[e] && "\\" !== l[i - 1] ? rr[e](n, a, t) : "\\" !== e ? e : "")).join("") : t.formatDate(n, l, a)
        },
        or = ({
            config: t = Yl,
            l10n: e = Wl
        }) => (i, n, l, r) => {
            if (0 !== i && !i) return;
            const a = r || e;
            let o;
            const s = i;
            if (i instanceof Date) o = new Date(i.getTime());
            else if ("string" != typeof i && void 0 !== i.toFixed) o = new Date(i);
            else if ("string" == typeof i) {
                const e = n || (t || Yl).dateFormat,
                    r = String(i).trim();
                if ("today" === r) o = new Date, l = !0;
                else if (/Z$/.test(r) || /GMT$/.test(r)) o = new Date(i);
                else if (t && t.parseDate) o = t.parseDate(i, e);
                else {
                    o = t && t.noCalendar ? new Date((new Date).setHours(0, 0, 0, 0)) : new Date((new Date).getFullYear(), 0, 1, 0, 0, 0, 0);
                    let n, l = [];
                    for (let t = 0, r = 0, s = ""; t < e.length; t++) {
                        const c = e[t],
                            u = "\\" === c,
                            h = "\\" === e[t - 1] || u;
                        if (lr[c] && !h) {
                            s += lr[c];
                            const t = new RegExp(s).exec(i);
                            t && (n = !0) && l["Y" !== c ? "push" : "unshift"]({
                                fn: nr[c],
                                val: t[++r]
                            })
                        } else u || (s += ".");
                        l.forEach((({
                            fn: t,
                            val: e
                        }) => o = t(o, e, a) || o))
                    }
                    o = n ? o : void 0
                }
            }
            if (o instanceof Date && !isNaN(o.getTime())) return !0 === l && o.setHours(0, 0, 0, 0), o;
            t.errorHandler(new Error(`Invalid date provided: ${s}`))
        };

    function sr(t, e, i = !0) {
        return !1 !== i ? new Date(t.getTime()).setHours(0, 0, 0, 0) - new Date(e.getTime()).setHours(0, 0, 0, 0) : t.getTime() - e.getTime()
    }
    const cr = 864e5;

    function ur(t) {
        let e = t.defaultHour,
            i = t.defaultMinute,
            n = t.defaultSeconds;
        if (void 0 !== t.minDate) {
            const l = t.minDate.getHours(),
                r = t.minDate.getMinutes(),
                a = t.minDate.getSeconds();
            e < l && (e = l), e === l && i < r && (i = r), e === l && i === r && n < a && (n = t.minDate.getSeconds())
        }
        if (void 0 !== t.maxDate) {
            const l = t.maxDate.getHours(),
                r = t.maxDate.getMinutes();
            e = Math.min(e, l), e === l && (i = Math.min(r, i)), e === l && i === r && (n = t.maxDate.getSeconds())
        }
        return {
            hours: e,
            minutes: i,
            seconds: n
        }
    }
    i(209);

    function hr(t, e) {
        const i = {
            config: Object.assign(Object.assign({}, Yl), fr.defaultConfig),
            l10n: Vl
        };

        function n(t) {
            return t.bind(i)
        }

        function l() {
            const t = i.config;
            !1 === t.weekNumbers && 1 === t.showMonths || !0 !== t.noCalendar && window.requestAnimationFrame((function () {
                if (void 0 !== i.calendarContainer && (i.calendarContainer.style.visibility = "hidden", i.calendarContainer.style.display = "block"), void 0 !== i.daysContainer) {
                    const e = (i.days.offsetWidth + 1) * t.showMonths;
                    i.daysContainer.style.width = e + "px", i.calendarContainer.style.width = e + (void 0 !== i.weekWrapper ? i.weekWrapper.offsetWidth : 0) + "px", i.calendarContainer.style.removeProperty("visibility"), i.calendarContainer.style.removeProperty("display")
                }
            }))
        }

        function r(t) {
            if (0 === i.selectedDates.length) {
                const t = void 0 === i.config.minDate || sr(new Date, i.config.minDate) >= 0 ? new Date : new Date(i.config.minDate.getTime()),
                    e = ur(i.config);
                t.setHours(e.hours, e.minutes, e.seconds, t.getMilliseconds()), i.selectedDates = [t], i.latestSelectedDateObj = t
            }
            void 0 !== t && "blur" !== t.type && function (t) {
                t.preventDefault();
                const e = "keydown" === t.type,
                    n = tr(t),
                    l = n;
                void 0 !== i.amPM && n === i.amPM && (i.amPM.textContent = i.l10n.amPM[ql(i.amPM.textContent === i.l10n.amPM[0])]);
                const r = parseFloat(l.getAttribute("min")),
                    a = parseFloat(l.getAttribute("max")),
                    o = parseFloat(l.getAttribute("step")),
                    s = parseInt(l.value, 10),
                    c = t.delta || (e ? 38 === t.which ? 1 : -1 : 0);
                let u = s + o * c;
                if (void 0 !== l.value && 2 === l.value.length) {
                    const t = l === i.hourElement,
                        e = l === i.minuteElement;
                    u < r ? (u = a + u + ql(!t) + (ql(t) && ql(!i.amPM)), e && p(void 0, -1, i.hourElement)) : u > a && (u = l === i.hourElement ? u - a - ql(!i.amPM) : r, e && p(void 0, 1, i.hourElement)), i.amPM && t && (1 === o ? u + s === 23 : Math.abs(u - s) > o) && (i.amPM.textContent = i.l10n.amPM[ql(i.amPM.textContent === i.l10n.amPM[0])]), l.value = Xl(u)
                }
            }(t);
            const e = i._input.value;
            a(), $(), i._input.value !== e && i._debouncedChange()
        }

        function a() {
            if (void 0 === i.hourElement || void 0 === i.minuteElement) return;
            let t = (parseInt(i.hourElement.value.slice(-2), 10) || 0) % 24,
                e = (parseInt(i.minuteElement.value, 10) || 0) % 60,
                n = void 0 !== i.secondElement ? (parseInt(i.secondElement.value, 10) || 0) % 60 : 0;
            var l, r;
            void 0 !== i.amPM && (l = t, r = i.amPM.textContent, t = l % 12 + 12 * ql(r === i.l10n.amPM[1]));
            const a = void 0 !== i.config.minTime || i.config.minDate && i.minDateHasTime && i.latestSelectedDateObj && 0 === sr(i.latestSelectedDateObj, i.config.minDate, !0);
            if (void 0 !== i.config.maxTime || i.config.maxDate && i.maxDateHasTime && i.latestSelectedDateObj && 0 === sr(i.latestSelectedDateObj, i.config.maxDate, !0)) {
                const l = void 0 !== i.config.maxTime ? i.config.maxTime : i.config.maxDate;
                t = Math.min(t, l.getHours()), t === l.getHours() && (e = Math.min(e, l.getMinutes())), e === l.getMinutes() && (n = Math.min(n, l.getSeconds()))
            }
            if (a) {
                const l = void 0 !== i.config.minTime ? i.config.minTime : i.config.minDate;
                t = Math.max(t, l.getHours()), t === l.getHours() && e < l.getMinutes() && (e = l.getMinutes()), e === l.getMinutes() && (n = Math.max(n, l.getSeconds()))
            }
            s(t, e, n)
        }

        function o(t) {
            const e = t || i.latestSelectedDateObj;
            e && s(e.getHours(), e.getMinutes(), e.getSeconds())
        }

        function s(t, e, n) {
            void 0 !== i.latestSelectedDateObj && i.latestSelectedDateObj.setHours(t % 24, e, n || 0, 0), i.hourElement && i.minuteElement && !i.isMobile && (i.hourElement.value = Xl(i.config.time_24hr ? t : (12 + t) % 12 + 12 * ql(t % 12 == 0)), i.minuteElement.value = Xl(e), void 0 !== i.amPM && (i.amPM.textContent = i.l10n.amPM[ql(t >= 12)]), void 0 !== i.secondElement && (i.secondElement.value = Xl(n)))
        }

        function c(t) {
            const e = tr(t),
                i = parseInt(e.value) + (t.delta || 0);
            (i / 1e3 > 1 || "Enter" === t.key && !/[^\d]/.test(i.toString())) && O(i)
        }

        function u(t, e, n, l) {
            return e instanceof Array ? e.forEach((e => u(t, e, n, l))) : t instanceof Array ? t.forEach((t => u(t, e, n, l))) : (t.addEventListener(e, n, l), void i._handlers.push({
                remove: () => t.removeEventListener(e, n)
            }))
        }

        function h() {
            q("onChange")
        }

        function d(t, e) {
            const n = void 0 !== t ? i.parseDate(t) : i.latestSelectedDateObj || (i.config.minDate && i.config.minDate > i.now ? i.config.minDate : i.config.maxDate && i.config.maxDate < i.now ? i.config.maxDate : i.now),
                l = i.currentYear,
                r = i.currentMonth;
            try {
                void 0 !== n && (i.currentYear = n.getFullYear(), i.currentMonth = n.getMonth())
            } catch (t) {
                t.message = "Invalid date supplied: " + n, i.config.errorHandler(t)
            }
            e && i.currentYear !== l && (q("onYearChange"), w()), !e || i.currentYear === l && i.currentMonth === r || q("onMonthChange"), i.redraw()
        }

        function f(t) {
            const e = tr(t);
            ~e.className.indexOf("arrow") && p(t, e.classList.contains("arrowUp") ? 1 : -1)
        }

        function p(t, e, i) {
            const n = t && tr(t),
                l = i || n && n.parentNode && n.parentNode.firstChild,
                r = Z("increment");
            r.delta = e, l && l.dispatchEvent(r)
        }

        function g(t, e, n, l) {
            const r = T(e, !0),
                a = Kl("span", "flatpickr-day " + t, e.getDate().toString());
            return a.dateObj = e, a.$i = l, a.setAttribute("aria-label", i.formatDate(e, i.config.ariaDateFormat)), -1 === t.indexOf("hidden") && 0 === sr(e, i.now) && (i.todayDateElem = a, a.classList.add("today"), a.setAttribute("aria-current", "date")), r ? (a.tabIndex = -1, G(e) && (a.classList.add("selected"), i.selectedDateElem = a, "range" === i.config.mode && (Ul(a, "startRange", i.selectedDates[0] && 0 === sr(e, i.selectedDates[0], !0)), Ul(a, "endRange", i.selectedDates[1] && 0 === sr(e, i.selectedDates[1], !0)), "nextMonthDay" === t && a.classList.add("inRange")))) : a.classList.add("flatpickr-disabled"), "range" === i.config.mode && function (t) {
                return !("range" !== i.config.mode || i.selectedDates.length < 2) && (sr(t, i.selectedDates[0]) >= 0 && sr(t, i.selectedDates[1]) <= 0)
            }(e) && !G(e) && a.classList.add("inRange"), i.weekNumbers && 1 === i.config.showMonths && "prevMonthDay" !== t && n % 7 == 1 && i.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + i.config.getWeek(e) + "</span>"), q("onDayCreate", a), a
        }

        function m(t) {
            t.focus(), "range" === i.config.mode && I(t)
        }

        function v(t) {
            const e = t > 0 ? 0 : i.config.showMonths - 1,
                n = t > 0 ? i.config.showMonths : -1;
            for (let l = e; l != n; l += t) {
                const e = i.daysContainer.children[l],
                    n = t > 0 ? 0 : e.children.length - 1,
                    r = t > 0 ? e.children.length : -1;
                for (let i = n; i != r; i += t) {
                    const t = e.children[i];
                    if (-1 === t.className.indexOf("hidden") && T(t.dateObj)) return t
                }
            }
        }

        function y(t, e) {
            const n = P(document.activeElement || document.body),
                l = void 0 !== t ? t : n ? document.activeElement : void 0 !== i.selectedDateElem && P(i.selectedDateElem) ? i.selectedDateElem : void 0 !== i.todayDateElem && P(i.todayDateElem) ? i.todayDateElem : v(e > 0 ? 1 : -1);
            void 0 === l ? i._input.focus() : n ? function (t, e) {
                const n = -1 === t.className.indexOf("Month") ? t.dateObj.getMonth() : i.currentMonth,
                    l = e > 0 ? i.config.showMonths : -1,
                    r = e > 0 ? 1 : -1;
                for (let a = n - i.currentMonth; a != l; a += r) {
                    const l = i.daysContainer.children[a],
                        o = n - i.currentMonth === a ? t.$i + e : e < 0 ? l.children.length - 1 : 0,
                        s = l.children.length;
                    for (let i = o; i >= 0 && i < s && i != (e > 0 ? s : -1); i += r) {
                        const n = l.children[i];
                        if (-1 === n.className.indexOf("hidden") && T(n.dateObj) && Math.abs(t.$i - i) >= Math.abs(e)) return m(n)
                    }
                }
                i.changeMonth(r), y(v(r), 0)
            }(l, e) : m(l)
        }

        function b(t, e) {
            const n = (new Date(t, e, 1).getDay() - i.l10n.firstDayOfWeek + 7) % 7,
                l = i.utils.getDaysInMonth((e - 1 + 12) % 12, t),
                r = i.utils.getDaysInMonth(e, t),
                a = window.document.createDocumentFragment(),
                o = i.config.showMonths > 1,
                s = o ? "prevMonthDay hidden" : "prevMonthDay",
                c = o ? "nextMonthDay hidden" : "nextMonthDay";
            let u = l + 1 - n,
                h = 0;
            for (; u <= l; u++, h++) a.appendChild(g(s, new Date(t, e - 1, u), u, h));
            for (u = 1; u <= r; u++, h++) a.appendChild(g("", new Date(t, e, u), u, h));
            for (let l = r + 1; l <= 42 - n && (1 === i.config.showMonths || h % 7 != 0); l++, h++) a.appendChild(g(c, new Date(t, e + 1, l % r), l, h));
            const d = Kl("div", "dayContainer");
            return d.appendChild(a), d
        }

        function x() {
            if (void 0 === i.daysContainer) return;
            $l(i.daysContainer), i.weekNumbers && $l(i.weekNumbers);
            const t = document.createDocumentFragment();
            for (let e = 0; e < i.config.showMonths; e++) {
                const n = new Date(i.currentYear, i.currentMonth, 1);
                n.setMonth(i.currentMonth + e), t.appendChild(b(n.getFullYear(), n.getMonth()))
            }
            i.daysContainer.appendChild(t), i.days = i.daysContainer.firstChild, "range" === i.config.mode && 1 === i.selectedDates.length && I()
        }

        function w() {
            if (i.config.showMonths > 1 || "dropdown" !== i.config.monthSelectorType) return;
            const t = function (t) {
                return !(void 0 !== i.config.minDate && i.currentYear === i.config.minDate.getFullYear() && t < i.config.minDate.getMonth()) && !(void 0 !== i.config.maxDate && i.currentYear === i.config.maxDate.getFullYear() && t > i.config.maxDate.getMonth())
            };
            i.monthsDropdownContainer.tabIndex = -1, i.monthsDropdownContainer.innerHTML = "";
            for (let e = 0; e < 12; e++) {
                if (!t(e)) continue;
                const n = Kl("option", "flatpickr-monthDropdown-month");
                n.value = new Date(i.currentYear, e).getMonth().toString(), n.textContent = ir(e, i.config.shorthandCurrentMonth, i.l10n), n.tabIndex = -1, i.currentMonth === e && (n.selected = !0), i.monthsDropdownContainer.appendChild(n)
            }
        }

        function _() {
            const t = Kl("div", "flatpickr-month"),
                e = window.document.createDocumentFragment();
            let n;
            i.config.showMonths > 1 || "static" === i.config.monthSelectorType ? n = Kl("span", "cur-month") : (i.monthsDropdownContainer = Kl("select", "flatpickr-monthDropdown-months"), i.monthsDropdownContainer.setAttribute("aria-label", i.l10n.monthAriaLabel), u(i.monthsDropdownContainer, "change", (t => {
                const e = tr(t),
                    n = parseInt(e.value, 10);
                i.changeMonth(n - i.currentMonth), q("onMonthChange")
            })), w(), n = i.monthsDropdownContainer);
            const l = Jl("cur-year", {
                    tabindex: "-1"
                }),
                r = l.getElementsByTagName("input")[0];
            r.setAttribute("aria-label", i.l10n.yearAriaLabel), i.config.minDate && r.setAttribute("min", i.config.minDate.getFullYear().toString()), i.config.maxDate && (r.setAttribute("max", i.config.maxDate.getFullYear().toString()), r.disabled = !!i.config.minDate && i.config.minDate.getFullYear() === i.config.maxDate.getFullYear());
            const a = Kl("div", "flatpickr-current-month");
            return a.appendChild(n), a.appendChild(l), e.appendChild(a), t.appendChild(e), {
                container: t,
                yearElement: r,
                monthElement: n
            }
        }

        function k() {
            $l(i.monthNav), i.monthNav.appendChild(i.prevMonthNav), i.config.showMonths && (i.yearElements = [], i.monthElements = []);
            for (let t = i.config.showMonths; t--;) {
                const t = _();
                i.yearElements.push(t.yearElement), i.monthElements.push(t.monthElement), i.monthNav.appendChild(t.container)
            }
            i.monthNav.appendChild(i.nextMonthNav)
        }

        function S() {
            i.weekdayContainer ? $l(i.weekdayContainer) : i.weekdayContainer = Kl("div", "flatpickr-weekdays");
            for (let t = i.config.showMonths; t--;) {
                const t = Kl("div", "flatpickr-weekdaycontainer");
                i.weekdayContainer.appendChild(t)
            }
            return A(), i.weekdayContainer
        }

        function A() {
            if (!i.weekdayContainer) return;
            const t = i.l10n.firstDayOfWeek;
            let e = [...i.l10n.weekdays.shorthand];
            t > 0 && t < e.length && (e = [...e.splice(t, e.length), ...e.splice(0, t)]);
            for (let t = i.config.showMonths; t--;) i.weekdayContainer.children[t].innerHTML = `\n      <span class='flatpickr-weekday'>\n        ${e.join("</span><span class='flatpickr-weekday'>")}\n      </span>\n      `
        }

        function M(t, e = !0) {
            const n = e ? t : t - i.currentMonth;
            n < 0 && !0 === i._hidePrevMonthArrow || n > 0 && !0 === i._hideNextMonthArrow || (i.currentMonth += n, (i.currentMonth < 0 || i.currentMonth > 11) && (i.currentYear += i.currentMonth > 11 ? 1 : -1, i.currentMonth = (i.currentMonth + 12) % 12, q("onYearChange"), w()), x(), q("onMonthChange"), U())
        }

        function C(t) {
            return !(!i.config.appendTo || !i.config.appendTo.contains(t)) || i.calendarContainer.contains(t)
        }

        function E(t) {
            if (i.isOpen && !i.config.inline) {
                const e = tr(t),
                    n = C(e),
                    l = e === i.input || e === i.altInput || i.element.contains(e) || t.path && t.path.indexOf && (~t.path.indexOf(i.input) || ~t.path.indexOf(i.altInput)),
                    a = "blur" === t.type ? l && t.relatedTarget && !C(t.relatedTarget) : !l && !n && !C(t.relatedTarget),
                    o = !i.config.ignoredFocusElements.some((t => t.contains(e)));
                a && o && (void 0 !== i.timeContainer && void 0 !== i.minuteElement && void 0 !== i.hourElement && "" !== i.input.value && void 0 !== i.input.value && r(), i.close(), i.config && "range" === i.config.mode && 1 === i.selectedDates.length && (i.clear(!1), i.redraw()))
            }
        }

        function O(t) {
            if (!t || i.config.minDate && t < i.config.minDate.getFullYear() || i.config.maxDate && t > i.config.maxDate.getFullYear()) return;
            const e = t,
                n = i.currentYear !== e;
            i.currentYear = e || i.currentYear, i.config.maxDate && i.currentYear === i.config.maxDate.getFullYear() ? i.currentMonth = Math.min(i.config.maxDate.getMonth(), i.currentMonth) : i.config.minDate && i.currentYear === i.config.minDate.getFullYear() && (i.currentMonth = Math.max(i.config.minDate.getMonth(), i.currentMonth)), n && (i.redraw(), q("onYearChange"), w())
        }

        function T(t, e = !0) {
            var n;
            const l = i.parseDate(t, void 0, e);
            if (i.config.minDate && l && sr(l, i.config.minDate, void 0 !== e ? e : !i.minDateHasTime) < 0 || i.config.maxDate && l && sr(l, i.config.maxDate, void 0 !== e ? e : !i.maxDateHasTime) > 0) return !1;
            if (!i.config.enable && 0 === i.config.disable.length) return !0;
            if (void 0 === l) return !1;
            const r = !!i.config.enable,
                a = null !== (n = i.config.enable) && void 0 !== n ? n : i.config.disable;
            for (let t, e = 0; e < a.length; e++) {
                if (t = a[e], "function" == typeof t && t(l)) return r;
                if (t instanceof Date && void 0 !== l && t.getTime() === l.getTime()) return r;
                if ("string" == typeof t) {
                    const e = i.parseDate(t, void 0, !0);
                    return e && e.getTime() === l.getTime() ? r : !r
                }
                if ("object" == typeof t && void 0 !== l && t.from && t.to && l.getTime() >= t.from.getTime() && l.getTime() <= t.to.getTime()) return r
            }
            return !r
        }

        function P(t) {
            return void 0 !== i.daysContainer && (-1 === t.className.indexOf("hidden") && -1 === t.className.indexOf("flatpickr-disabled") && i.daysContainer.contains(t))
        }

        function L(t) {
            !(t.target === i._input) || !(i.selectedDates.length > 0 || i._input.value.length > 0) || t.relatedTarget && C(t.relatedTarget) || i.setDate(i._input.value, !0, t.target === i.altInput ? i.config.altFormat : i.config.dateFormat)
        }

        function D(e) {
            const n = tr(e),
                l = i.config.wrap ? t.contains(n) : n === i._input,
                o = i.config.allowInput,
                s = i.isOpen && (!o || !l),
                c = i.config.inline && l && !o;
            if (13 === e.keyCode && l) {
                if (o) return i.setDate(i._input.value, !0, n === i.altInput ? i.config.altFormat : i.config.dateFormat), n.blur();
                i.open()
            } else if (C(n) || s || c) {
                const t = !!i.timeContainer && i.timeContainer.contains(n);
                switch (e.keyCode) {
                    case 13:
                        t ? (e.preventDefault(), r(), B()) : Y(e);
                        break;
                    case 27:
                        e.preventDefault(), B();
                        break;
                    case 8:
                    case 46:
                        l && !i.config.allowInput && (e.preventDefault(), i.clear());
                        break;
                    case 37:
                    case 39:
                        if (t || l) i.hourElement && i.hourElement.focus();
                        else if (e.preventDefault(), void 0 !== i.daysContainer && (!1 === o || document.activeElement && P(document.activeElement))) {
                            const t = 39 === e.keyCode ? 1 : -1;
                            e.ctrlKey ? (e.stopPropagation(), M(t), y(v(1), 0)) : y(void 0, t)
                        }
                        break;
                    case 38:
                    case 40:
                        e.preventDefault();
                        const a = 40 === e.keyCode ? 1 : -1;
                        i.daysContainer && void 0 !== n.$i || n === i.input || n === i.altInput ? e.ctrlKey ? (e.stopPropagation(), O(i.currentYear - a), y(v(1), 0)) : t || y(void 0, 7 * a) : n === i.currentYearElement ? O(i.currentYear - a) : i.config.enableTime && (!t && i.hourElement && i.hourElement.focus(), r(e), i._debouncedChange());
                        break;
                    case 9:
                        if (t) {
                            const t = [i.hourElement, i.minuteElement, i.secondElement, i.amPM].concat(i.pluginElements).filter((t => t)),
                                l = t.indexOf(n);
                            if (-1 !== l) {
                                const n = t[l + (e.shiftKey ? -1 : 1)];
                                e.preventDefault(), (n || i._input).focus()
                            }
                        } else !i.config.noCalendar && i.daysContainer && i.daysContainer.contains(n) && e.shiftKey && (e.preventDefault(), i._input.focus())
                }
            }
            if (void 0 !== i.amPM && n === i.amPM) switch (e.key) {
                case i.l10n.amPM[0].charAt(0):
                case i.l10n.amPM[0].charAt(0).toLowerCase():
                    i.amPM.textContent = i.l10n.amPM[0], a(), $();
                    break;
                case i.l10n.amPM[1].charAt(0):
                case i.l10n.amPM[1].charAt(0).toLowerCase():
                    i.amPM.textContent = i.l10n.amPM[1], a(), $()
            }(l || C(n)) && q("onKeyDown", e)
        }

        function I(t) {
            if (1 !== i.selectedDates.length || t && (!t.classList.contains("flatpickr-day") || t.classList.contains("flatpickr-disabled"))) return;
            const e = t ? t.dateObj.getTime() : i.days.firstElementChild.dateObj.getTime(),
                n = i.parseDate(i.selectedDates[0], void 0, !0).getTime(),
                l = Math.min(e, i.selectedDates[0].getTime()),
                r = Math.max(e, i.selectedDates[0].getTime());
            let a = !1,
                o = 0,
                s = 0;
            for (let t = l; t < r; t += cr) T(new Date(t), !0) || (a = a || t > l && t < r, t < n && (!o || t > o) ? o = t : t > n && (!s || t < s) && (s = t));
            for (let l = 0; l < i.config.showMonths; l++) {
                const r = i.daysContainer.children[l];
                for (let l = 0, d = r.children.length; l < d; l++) {
                    const d = r.children[l],
                        f = d.dateObj.getTime(),
                        p = o > 0 && f < o || s > 0 && f > s;
                    p ? (d.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach((t => {
                        d.classList.remove(t)
                    }))) : a && !p || (["startRange", "inRange", "endRange", "notAllowed"].forEach((t => {
                        d.classList.remove(t)
                    })), void 0 !== t && (t.classList.add(e <= i.selectedDates[0].getTime() ? "startRange" : "endRange"), n < e && f === n ? d.classList.add("startRange") : n > e && f === n && d.classList.add("endRange"), f >= o && (0 === s || f <= s) && (u = n, h = e, (c = f) > Math.min(u, h) && c < Math.max(u, h)) && d.classList.add("inRange")))
                }
            }
            var c, u, h
        }

        function j() {
            !i.isOpen || i.config.static || i.config.inline || z()
        }

        function N(t) {
            return e => {
                const n = i.config[`_${t}Date`] = i.parseDate(e, i.config.dateFormat),
                    l = i.config[`_${"min"===t?"max":"min"}Date`];
                void 0 !== n && (i["min" === t ? "minDateHasTime" : "maxDateHasTime"] = n.getHours() > 0 || n.getMinutes() > 0 || n.getSeconds() > 0), i.selectedDates && (i.selectedDates = i.selectedDates.filter((t => T(t))), i.selectedDates.length || "min" !== t || o(n), $()), i.daysContainer && (H(), void 0 !== n ? i.currentYearElement[t] = n.getFullYear().toString() : i.currentYearElement.removeAttribute(t), i.currentYearElement.disabled = !!l && void 0 !== n && l.getFullYear() === n.getFullYear())
            }
        }

        function R() {
            return i.config.wrap ? t.querySelector("[data-input]") : t
        }

        function F() {
            "object" != typeof i.config.locale && void 0 === fr.l10ns[i.config.locale] && i.config.errorHandler(new Error(`flatpickr: invalid locale ${i.config.locale}`)), i.l10n = Object.assign(Object.assign({}, fr.l10ns.default), "object" == typeof i.config.locale ? i.config.locale : "default" !== i.config.locale ? fr.l10ns[i.config.locale] : void 0), lr.K = `(${i.l10n.amPM[0]}|${i.l10n.amPM[1]}|${i.l10n.amPM[0].toLowerCase()}|${i.l10n.amPM[1].toLowerCase()})`;
            void 0 === Object.assign(Object.assign({}, e), JSON.parse(JSON.stringify(t.dataset || {}))).time_24hr && void 0 === fr.defaultConfig.time_24hr && (i.config.time_24hr = i.l10n.time_24hr), i.formatDate = ar(i), i.parseDate = or({
                config: i.config,
                l10n: i.l10n
            })
        }

        function z(t) {
            if ("function" == typeof i.config.position) return void i.config.position(i, t);
            if (void 0 === i.calendarContainer) return;
            q("onPreCalendarPosition");
            const e = t || i._positionElement,
                n = Array.prototype.reduce.call(i.calendarContainer.children, ((t, e) => t + e.offsetHeight), 0),
                l = i.calendarContainer.offsetWidth,
                r = i.config.position.split(" "),
                a = r[0],
                o = r.length > 1 ? r[1] : null,
                s = e.getBoundingClientRect(),
                c = window.innerHeight - s.bottom,
                u = "above" === a || "below" !== a && c < n && s.top > n,
                h = window.pageYOffset + s.top + (u ? -n - 2 : e.offsetHeight + 2);
            if (Ul(i.calendarContainer, "arrowTop", !u), Ul(i.calendarContainer, "arrowBottom", u), i.config.inline) return;
            let d = window.pageXOffset + s.left,
                f = !1,
                p = !1;
            "center" === o ? (d -= (l - s.width) / 2, f = !0) : "right" === o && (d -= l - s.width, p = !0), Ul(i.calendarContainer, "arrowLeft", !f && !p), Ul(i.calendarContainer, "arrowCenter", f), Ul(i.calendarContainer, "arrowRight", p);
            const g = window.document.body.offsetWidth - (window.pageXOffset + s.right),
                m = d + l > window.document.body.offsetWidth,
                v = g + l > window.document.body.offsetWidth;
            if (Ul(i.calendarContainer, "rightMost", m), !i.config.static)
                if (i.calendarContainer.style.top = `${h}px`, m)
                    if (v) {
                        const t = function () {
                            let t = null;
                            for (let e = 0; e < document.styleSheets.length; e++) {
                                const i = document.styleSheets[e];
                                try {
                                    i.cssRules
                                } catch (t) {
                                    continue
                                }
                                t = i;
                                break
                            }
                            return null != t ? t : function () {
                                const t = document.createElement("style");
                                return document.head.appendChild(t), t.sheet
                            }()
                        }();
                        if (void 0 === t) return;
                        const e = window.document.body.offsetWidth,
                            n = Math.max(0, e / 2 - l / 2),
                            r = ".flatpickr-calendar.centerMost:before",
                            a = ".flatpickr-calendar.centerMost:after",
                            o = t.cssRules.length,
                            c = `{left:${s.left}px;right:auto;}`;
                        Ul(i.calendarContainer, "rightMost", !1), Ul(i.calendarContainer, "centerMost", !0), t.insertRule(`${r},${a}${c}`, o), i.calendarContainer.style.left = `${n}px`, i.calendarContainer.style.right = "auto"
                    } else i.calendarContainer.style.left = "auto", i.calendarContainer.style.right = `${g}px`;
            else i.calendarContainer.style.left = `${d}px`, i.calendarContainer.style.right = "auto"
        }

        function H() {
            i.config.noCalendar || i.isMobile || (w(), U(), x())
        }

        function B() {
            i._input.focus(), -1 !== window.navigator.userAgent.indexOf("MSIE") || void 0 !== navigator.msMaxTouchPoints ? setTimeout(i.close, 0) : i.close()
        }

        function Y(t) {
            t.preventDefault(), t.stopPropagation();
            const e = Ql(tr(t), (t => t.classList && t.classList.contains("flatpickr-day") && !t.classList.contains("flatpickr-disabled") && !t.classList.contains("notAllowed")));
            if (void 0 === e) return;
            const n = e,
                l = i.latestSelectedDateObj = new Date(n.dateObj.getTime()),
                r = (l.getMonth() < i.currentMonth || l.getMonth() > i.currentMonth + i.config.showMonths - 1) && "range" !== i.config.mode;
            if (i.selectedDateElem = n, "single" === i.config.mode) i.selectedDates = [l];
            else if ("multiple" === i.config.mode) {
                const t = G(l);
                t ? i.selectedDates.splice(parseInt(t), 1) : i.selectedDates.push(l)
            } else "range" === i.config.mode && (2 === i.selectedDates.length && i.clear(!1, !1), i.latestSelectedDateObj = l, i.selectedDates.push(l), 0 !== sr(l, i.selectedDates[0], !0) && i.selectedDates.sort(((t, e) => t.getTime() - e.getTime())));
            if (a(), r) {
                const t = i.currentYear !== l.getFullYear();
                i.currentYear = l.getFullYear(), i.currentMonth = l.getMonth(), t && (q("onYearChange"), w()), q("onMonthChange")
            }
            if (U(), x(), $(), r || "range" === i.config.mode || 1 !== i.config.showMonths ? void 0 !== i.selectedDateElem && void 0 === i.hourElement && i.selectedDateElem && i.selectedDateElem.focus() : m(n), void 0 !== i.hourElement && void 0 !== i.hourElement && i.hourElement.focus(), i.config.closeOnSelect) {
                const t = "single" === i.config.mode && !i.config.enableTime,
                    e = "range" === i.config.mode && 2 === i.selectedDates.length && !i.config.enableTime;
                (t || e) && B()
            }
            h()
        }
        i.parseDate = or({
            config: i.config,
            l10n: i.l10n
        }), i._handlers = [], i.pluginElements = [], i.loadedPlugins = [], i._bind = u, i._setHoursFromDate = o, i._positionCalendar = z, i.changeMonth = M, i.changeYear = O, i.clear = function (t = !0, e = !0) {
            i.input.value = "", void 0 !== i.altInput && (i.altInput.value = "");
            void 0 !== i.mobileInput && (i.mobileInput.value = "");
            i.selectedDates = [], i.latestSelectedDateObj = void 0, !0 === e && (i.currentYear = i._initialDate.getFullYear(), i.currentMonth = i._initialDate.getMonth());
            if (!0 === i.config.enableTime) {
                const {
                    hours: t,
                    minutes: e,
                    seconds: n
                } = ur(i.config);
                s(t, e, n)
            }
            i.redraw(), t && q("onChange")
        }, i.close = function () {
            i.isOpen = !1, i.isMobile || (void 0 !== i.calendarContainer && i.calendarContainer.classList.remove("open"), void 0 !== i._input && i._input.classList.remove("active"));
            q("onClose")
        }, i._createElement = Kl, i.destroy = function () {
            void 0 !== i.config && q("onDestroy");
            for (let t = i._handlers.length; t--;) i._handlers[t].remove();
            if (i._handlers = [], i.mobileInput) i.mobileInput.parentNode && i.mobileInput.parentNode.removeChild(i.mobileInput), i.mobileInput = void 0;
            else if (i.calendarContainer && i.calendarContainer.parentNode)
                if (i.config.static && i.calendarContainer.parentNode) {
                    const t = i.calendarContainer.parentNode;
                    if (t.lastChild && t.removeChild(t.lastChild), t.parentNode) {
                        for (; t.firstChild;) t.parentNode.insertBefore(t.firstChild, t);
                        t.parentNode.removeChild(t)
                    }
                } else i.calendarContainer.parentNode.removeChild(i.calendarContainer);
            i.altInput && (i.input.type = "text", i.altInput.parentNode && i.altInput.parentNode.removeChild(i.altInput), delete i.altInput);
            i.input && (i.input.type = i.input._type, i.input.classList.remove("flatpickr-input"), i.input.removeAttribute("readonly"));
            ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "monthsDropdownContainer", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach((t => {
                try {
                    delete i[t]
                } catch (t) {}
            }))
        }, i.isEnabled = T, i.jumpToDate = d, i.open = function (t, e = i._positionElement) {
            if (!0 === i.isMobile) {
                if (t) {
                    t.preventDefault();
                    const e = tr(t);
                    e && e.blur()
                }
                return void 0 !== i.mobileInput && (i.mobileInput.focus(), i.mobileInput.click()), void q("onOpen")
            }
            if (i._input.disabled || i.config.inline) return;
            const n = i.isOpen;
            i.isOpen = !0, n || (i.calendarContainer.classList.add("open"), i._input.classList.add("active"), q("onOpen"), z(e));
            !0 === i.config.enableTime && !0 === i.config.noCalendar && (!1 !== i.config.allowInput || void 0 !== t && i.timeContainer.contains(t.relatedTarget) || setTimeout((() => i.hourElement.select()), 50))
        }, i.redraw = H, i.set = function (t, e) {
            if (null !== t && "object" == typeof t) {
                Object.assign(i.config, t);
                for (const e in t) void 0 !== W[e] && W[e].forEach((t => t()))
            } else i.config[t] = e, void 0 !== W[t] ? W[t].forEach((t => t())) : Bl.indexOf(t) > -1 && (i.config[t] = Gl(e));
            i.redraw(), $(!0)
        }, i.setDate = function (t, e = !1, n = i.config.dateFormat) {
            if (0 !== t && !t || t instanceof Array && 0 === t.length) return i.clear(e);
            V(t, n), i.latestSelectedDateObj = i.selectedDates[i.selectedDates.length - 1], i.redraw(), d(void 0, e), o(), 0 === i.selectedDates.length && i.clear(!1);
            $(e), e && q("onChange")
        }, i.toggle = function (t) {
            if (!0 === i.isOpen) return i.close();
            i.open(t)
        };
        const W = {
            locale: [F, A],
            showMonths: [k, l, S],
            minDate: [d],
            maxDate: [d],
            clickOpens: [() => {
                !0 === i.config.clickOpens ? (u(i._input, "focus", i.open), u(i._input, "click", i.open)) : (i._input.removeEventListener("focus", i.open), i._input.removeEventListener("click", i.open))
            }]
        };

        function V(t, e) {
            let n = [];
            if (t instanceof Array) n = t.map((t => i.parseDate(t, e)));
            else if (t instanceof Date || "number" == typeof t) n = [i.parseDate(t, e)];
            else if ("string" == typeof t) switch (i.config.mode) {
                case "single":
                case "time":
                    n = [i.parseDate(t, e)];
                    break;
                case "multiple":
                    n = t.split(i.config.conjunction).map((t => i.parseDate(t, e)));
                    break;
                case "range":
                    n = t.split(i.l10n.rangeSeparator).map((t => i.parseDate(t, e)))
            } else i.config.errorHandler(new Error(`Invalid date supplied: ${JSON.stringify(t)}`));
            i.selectedDates = i.config.allowInvalidPreload ? n : n.filter((t => t instanceof Date && T(t, !1))), "range" === i.config.mode && i.selectedDates.sort(((t, e) => t.getTime() - e.getTime()))
        }

        function X(t) {
            return t.slice().map((t => "string" == typeof t || "number" == typeof t || t instanceof Date ? i.parseDate(t, void 0, !0) : t && "object" == typeof t && t.from && t.to ? {
                from: i.parseDate(t.from, void 0),
                to: i.parseDate(t.to, void 0)
            } : t)).filter((t => t))
        }

        function q(t, e) {
            if (void 0 === i.config) return;
            const n = i.config[t];
            if (void 0 !== n && n.length > 0)
                for (let t = 0; n[t] && t < n.length; t++) n[t](i.selectedDates, i.input.value, i, e);
            "onChange" === t && (i.input.dispatchEvent(Z("change")), i.input.dispatchEvent(Z("input")))
        }

        function Z(t) {
            const e = document.createEvent("Event");
            return e.initEvent(t, !0, !0), e
        }

        function G(t) {
            for (let e = 0; e < i.selectedDates.length; e++)
                if (0 === sr(i.selectedDates[e], t)) return "" + e;
            return !1
        }

        function U() {
            i.config.noCalendar || i.isMobile || !i.monthNav || (i.yearElements.forEach(((t, e) => {
                const n = new Date(i.currentYear, i.currentMonth, 1);
                n.setMonth(i.currentMonth + e), i.config.showMonths > 1 || "static" === i.config.monthSelectorType ? i.monthElements[e].textContent = ir(n.getMonth(), i.config.shorthandCurrentMonth, i.l10n) + " " : i.monthsDropdownContainer.value = n.getMonth().toString(), t.value = n.getFullYear().toString()
            })), i._hidePrevMonthArrow = void 0 !== i.config.minDate && (i.currentYear === i.config.minDate.getFullYear() ? i.currentMonth <= i.config.minDate.getMonth() : i.currentYear < i.config.minDate.getFullYear()), i._hideNextMonthArrow = void 0 !== i.config.maxDate && (i.currentYear === i.config.maxDate.getFullYear() ? i.currentMonth + 1 > i.config.maxDate.getMonth() : i.currentYear > i.config.maxDate.getFullYear()))
        }

        function K(t) {
            return i.selectedDates.map((e => i.formatDate(e, t))).filter(((t, e, n) => "range" !== i.config.mode || i.config.enableTime || n.indexOf(t) === e)).join("range" !== i.config.mode ? i.config.conjunction : i.l10n.rangeSeparator)
        }

        function $(t = !0) {
            void 0 !== i.mobileInput && i.mobileFormatStr && (i.mobileInput.value = void 0 !== i.latestSelectedDateObj ? i.formatDate(i.latestSelectedDateObj, i.mobileFormatStr) : ""), i.input.value = K(i.config.dateFormat), void 0 !== i.altInput && (i.altInput.value = K(i.config.altFormat)), !1 !== t && q("onValueUpdate")
        }

        function Q(t) {
            const e = tr(t),
                n = i.prevMonthNav.contains(e),
                l = i.nextMonthNav.contains(e);
            n || l ? M(n ? -1 : 1) : i.yearElements.indexOf(e) >= 0 ? e.select() : e.classList.contains("arrowUp") ? i.changeYear(i.currentYear + 1) : e.classList.contains("arrowDown") && i.changeYear(i.currentYear - 1)
        }
        return function () {
            i.element = i.input = t, i.isOpen = !1,
                function () {
                    const l = ["wrap", "weekNumbers", "allowInput", "allowInvalidPreload", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"],
                        r = Object.assign(Object.assign({}, JSON.parse(JSON.stringify(t.dataset || {}))), e),
                        a = {};
                    i.config.parseDate = r.parseDate, i.config.formatDate = r.formatDate, Object.defineProperty(i.config, "enable", {
                        get: () => i.config._enable,
                        set: t => {
                            i.config._enable = X(t)
                        }
                    }), Object.defineProperty(i.config, "disable", {
                        get: () => i.config._disable,
                        set: t => {
                            i.config._disable = X(t)
                        }
                    });
                    const o = "time" === r.mode;
                    if (!r.dateFormat && (r.enableTime || o)) {
                        const t = fr.defaultConfig.dateFormat || Yl.dateFormat;
                        a.dateFormat = r.noCalendar || o ? "H:i" + (r.enableSeconds ? ":S" : "") : t + " H:i" + (r.enableSeconds ? ":S" : "")
                    }
                    if (r.altInput && (r.enableTime || o) && !r.altFormat) {
                        const t = fr.defaultConfig.altFormat || Yl.altFormat;
                        a.altFormat = r.noCalendar || o ? "h:i" + (r.enableSeconds ? ":S K" : " K") : t + ` h:i${r.enableSeconds?":S":""} K`
                    }
                    Object.defineProperty(i.config, "minDate", {
                        get: () => i.config._minDate,
                        set: N("min")
                    }), Object.defineProperty(i.config, "maxDate", {
                        get: () => i.config._maxDate,
                        set: N("max")
                    });
                    const s = t => e => {
                        i.config["min" === t ? "_minTime" : "_maxTime"] = i.parseDate(e, "H:i:S")
                    };
                    Object.defineProperty(i.config, "minTime", {
                        get: () => i.config._minTime,
                        set: s("min")
                    }), Object.defineProperty(i.config, "maxTime", {
                        get: () => i.config._maxTime,
                        set: s("max")
                    }), "time" === r.mode && (i.config.noCalendar = !0, i.config.enableTime = !0);
                    Object.assign(i.config, a, r);
                    for (let t = 0; t < l.length; t++) i.config[l[t]] = !0 === i.config[l[t]] || "true" === i.config[l[t]];
                    Bl.filter((t => void 0 !== i.config[t])).forEach((t => {
                        i.config[t] = Gl(i.config[t] || []).map(n)
                    })), i.isMobile = !i.config.disableMobile && !i.config.inline && "single" === i.config.mode && !i.config.disable.length && !i.config.enable && !i.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    for (let t = 0; t < i.config.plugins.length; t++) {
                        const e = i.config.plugins[t](i) || {};
                        for (const t in e) Bl.indexOf(t) > -1 ? i.config[t] = Gl(e[t]).map(n).concat(i.config[t]) : void 0 === r[t] && (i.config[t] = e[t])
                    }
                    r.altInputClass || (i.config.altInputClass = R().className + " " + i.config.altInputClass);
                    q("onParseConfig")
                }(), F(),
                function () {
                    if (i.input = R(), !i.input) return void i.config.errorHandler(new Error("Invalid input element specified"));
                    i.input._type = i.input.type, i.input.type = "text", i.input.classList.add("flatpickr-input"), i._input = i.input, i.config.altInput && (i.altInput = Kl(i.input.nodeName, i.config.altInputClass), i._input = i.altInput, i.altInput.placeholder = i.input.placeholder, i.altInput.disabled = i.input.disabled, i.altInput.required = i.input.required, i.altInput.tabIndex = i.input.tabIndex, i.altInput.type = "text", i.input.setAttribute("type", "hidden"), !i.config.static && i.input.parentNode && i.input.parentNode.insertBefore(i.altInput, i.input.nextSibling));
                    i.config.allowInput || i._input.setAttribute("readonly", "readonly");
                    i._positionElement = i.config.positionElement || i._input
                }(),
                function () {
                    i.selectedDates = [], i.now = i.parseDate(i.config.now) || new Date;
                    const t = i.config.defaultDate || ("INPUT" !== i.input.nodeName && "TEXTAREA" !== i.input.nodeName || !i.input.placeholder || i.input.value !== i.input.placeholder ? i.input.value : null);
                    t && V(t, i.config.dateFormat);
                    i._initialDate = i.selectedDates.length > 0 ? i.selectedDates[0] : i.config.minDate && i.config.minDate.getTime() > i.now.getTime() ? i.config.minDate : i.config.maxDate && i.config.maxDate.getTime() < i.now.getTime() ? i.config.maxDate : i.now, i.currentYear = i._initialDate.getFullYear(), i.currentMonth = i._initialDate.getMonth(), i.selectedDates.length > 0 && (i.latestSelectedDateObj = i.selectedDates[0]);
                    void 0 !== i.config.minTime && (i.config.minTime = i.parseDate(i.config.minTime, "H:i"));
                    void 0 !== i.config.maxTime && (i.config.maxTime = i.parseDate(i.config.maxTime, "H:i"));
                    i.minDateHasTime = !!i.config.minDate && (i.config.minDate.getHours() > 0 || i.config.minDate.getMinutes() > 0 || i.config.minDate.getSeconds() > 0), i.maxDateHasTime = !!i.config.maxDate && (i.config.maxDate.getHours() > 0 || i.config.maxDate.getMinutes() > 0 || i.config.maxDate.getSeconds() > 0)
                }(), i.utils = {
                    getDaysInMonth: (t = i.currentMonth, e = i.currentYear) => 1 === t && (e % 4 == 0 && e % 100 != 0 || e % 400 == 0) ? 29 : i.l10n.daysInMonth[t]
                }, i.isMobile || function () {
                    const t = window.document.createDocumentFragment();
                    if (i.calendarContainer = Kl("div", "flatpickr-calendar"), i.calendarContainer.tabIndex = -1, !i.config.noCalendar) {
                        if (t.appendChild((i.monthNav = Kl("div", "flatpickr-months"), i.yearElements = [], i.monthElements = [], i.prevMonthNav = Kl("span", "flatpickr-prev-month"), i.prevMonthNav.innerHTML = i.config.prevArrow, i.nextMonthNav = Kl("span", "flatpickr-next-month"), i.nextMonthNav.innerHTML = i.config.nextArrow, k(), Object.defineProperty(i, "_hidePrevMonthArrow", {
                                get: () => i.__hidePrevMonthArrow,
                                set(t) {
                                    i.__hidePrevMonthArrow !== t && (Ul(i.prevMonthNav, "flatpickr-disabled", t), i.__hidePrevMonthArrow = t)
                                }
                            }), Object.defineProperty(i, "_hideNextMonthArrow", {
                                get: () => i.__hideNextMonthArrow,
                                set(t) {
                                    i.__hideNextMonthArrow !== t && (Ul(i.nextMonthNav, "flatpickr-disabled", t), i.__hideNextMonthArrow = t)
                                }
                            }), i.currentYearElement = i.yearElements[0], U(), i.monthNav)), i.innerContainer = Kl("div", "flatpickr-innerContainer"), i.config.weekNumbers) {
                            const {
                                weekWrapper: t,
                                weekNumbers: e
                            } = function () {
                                i.calendarContainer.classList.add("hasWeeks");
                                const t = Kl("div", "flatpickr-weekwrapper");
                                t.appendChild(Kl("span", "flatpickr-weekday", i.l10n.weekAbbreviation));
                                const e = Kl("div", "flatpickr-weeks");
                                return t.appendChild(e), {
                                    weekWrapper: t,
                                    weekNumbers: e
                                }
                            }();
                            i.innerContainer.appendChild(t), i.weekNumbers = e, i.weekWrapper = t
                        }
                        i.rContainer = Kl("div", "flatpickr-rContainer"), i.rContainer.appendChild(S()), i.daysContainer || (i.daysContainer = Kl("div", "flatpickr-days"), i.daysContainer.tabIndex = -1), x(), i.rContainer.appendChild(i.daysContainer), i.innerContainer.appendChild(i.rContainer), t.appendChild(i.innerContainer)
                    }
                    i.config.enableTime && t.appendChild(function () {
                        i.calendarContainer.classList.add("hasTime"), i.config.noCalendar && i.calendarContainer.classList.add("noCalendar");
                        const t = ur(i.config);
                        i.timeContainer = Kl("div", "flatpickr-time"), i.timeContainer.tabIndex = -1;
                        const e = Kl("span", "flatpickr-time-separator", ":"),
                            n = Jl("flatpickr-hour", {
                                "aria-label": i.l10n.hourAriaLabel
                            });
                        i.hourElement = n.getElementsByTagName("input")[0];
                        const l = Jl("flatpickr-minute", {
                            "aria-label": i.l10n.minuteAriaLabel
                        });
                        i.minuteElement = l.getElementsByTagName("input")[0], i.hourElement.tabIndex = i.minuteElement.tabIndex = -1, i.hourElement.value = Xl(i.latestSelectedDateObj ? i.latestSelectedDateObj.getHours() : i.config.time_24hr ? t.hours : function (t) {
                            switch (t % 24) {
                                case 0:
                                case 12:
                                    return 12;
                                default:
                                    return t % 12
                            }
                        }(t.hours)), i.minuteElement.value = Xl(i.latestSelectedDateObj ? i.latestSelectedDateObj.getMinutes() : t.minutes), i.hourElement.setAttribute("step", i.config.hourIncrement.toString()), i.minuteElement.setAttribute("step", i.config.minuteIncrement.toString()), i.hourElement.setAttribute("min", i.config.time_24hr ? "0" : "1"), i.hourElement.setAttribute("max", i.config.time_24hr ? "23" : "12"), i.hourElement.setAttribute("maxlength", "2"), i.minuteElement.setAttribute("min", "0"), i.minuteElement.setAttribute("max", "59"), i.minuteElement.setAttribute("maxlength", "2"), i.timeContainer.appendChild(n), i.timeContainer.appendChild(e), i.timeContainer.appendChild(l), i.config.time_24hr && i.timeContainer.classList.add("time24hr");
                        if (i.config.enableSeconds) {
                            i.timeContainer.classList.add("hasSeconds");
                            const e = Jl("flatpickr-second");
                            i.secondElement = e.getElementsByTagName("input")[0], i.secondElement.value = Xl(i.latestSelectedDateObj ? i.latestSelectedDateObj.getSeconds() : t.seconds), i.secondElement.setAttribute("step", i.minuteElement.getAttribute("step")), i.secondElement.setAttribute("min", "0"), i.secondElement.setAttribute("max", "59"), i.secondElement.setAttribute("maxlength", "2"), i.timeContainer.appendChild(Kl("span", "flatpickr-time-separator", ":")), i.timeContainer.appendChild(e)
                        }
                        i.config.time_24hr || (i.amPM = Kl("span", "flatpickr-am-pm", i.l10n.amPM[ql((i.latestSelectedDateObj ? i.hourElement.value : i.config.defaultHour) > 11)]), i.amPM.title = i.l10n.toggleTitle, i.amPM.tabIndex = -1, i.timeContainer.appendChild(i.amPM));
                        return i.timeContainer
                    }());
                    Ul(i.calendarContainer, "rangeMode", "range" === i.config.mode), Ul(i.calendarContainer, "animate", !0 === i.config.animate), Ul(i.calendarContainer, "multiMonth", i.config.showMonths > 1), i.calendarContainer.appendChild(t);
                    const e = void 0 !== i.config.appendTo && void 0 !== i.config.appendTo.nodeType;
                    if ((i.config.inline || i.config.static) && (i.calendarContainer.classList.add(i.config.inline ? "inline" : "static"), i.config.inline && (!e && i.element.parentNode ? i.element.parentNode.insertBefore(i.calendarContainer, i._input.nextSibling) : void 0 !== i.config.appendTo && i.config.appendTo.appendChild(i.calendarContainer)), i.config.static)) {
                        const t = Kl("div", "flatpickr-wrapper");
                        i.element.parentNode && i.element.parentNode.insertBefore(t, i.element), t.appendChild(i.element), i.altInput && t.appendChild(i.altInput), t.appendChild(i.calendarContainer)
                    }
                    i.config.static || i.config.inline || (void 0 !== i.config.appendTo ? i.config.appendTo : window.document.body).appendChild(i.calendarContainer)
                }(),
                function () {
                    i.config.wrap && ["open", "close", "toggle", "clear"].forEach((t => {
                        Array.prototype.forEach.call(i.element.querySelectorAll(`[data-${t}]`), (e => u(e, "click", i[t])))
                    }));
                    if (i.isMobile) return void

                    function () {
                        const t = i.config.enableTime ? i.config.noCalendar ? "time" : "datetime-local" : "date";
                        i.mobileInput = Kl("input", i.input.className + " flatpickr-mobile"), i.mobileInput.tabIndex = 1, i.mobileInput.type = t, i.mobileInput.disabled = i.input.disabled, i.mobileInput.required = i.input.required, i.mobileInput.placeholder = i.input.placeholder, i.mobileFormatStr = "datetime-local" === t ? "Y-m-d\\TH:i:S" : "date" === t ? "Y-m-d" : "H:i:S", i.selectedDates.length > 0 && (i.mobileInput.defaultValue = i.mobileInput.value = i.formatDate(i.selectedDates[0], i.mobileFormatStr));
                        i.config.minDate && (i.mobileInput.min = i.formatDate(i.config.minDate, "Y-m-d"));
                        i.config.maxDate && (i.mobileInput.max = i.formatDate(i.config.maxDate, "Y-m-d"));
                        i.input.getAttribute("step") && (i.mobileInput.step = String(i.input.getAttribute("step")));
                        i.input.type = "hidden", void 0 !== i.altInput && (i.altInput.type = "hidden");
                        try {
                            i.input.parentNode && i.input.parentNode.insertBefore(i.mobileInput, i.input.nextSibling)
                        } catch (t) {}
                        u(i.mobileInput, "change", (t => {
                            i.setDate(tr(t).value, !1, i.mobileFormatStr), q("onChange"), q("onClose")
                        }))
                    }();
                    const t = Zl(j, 50);
                    i._debouncedChange = Zl(h, 300), i.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && u(i.daysContainer, "mouseover", (t => {
                        "range" === i.config.mode && I(tr(t))
                    }));
                    u(window.document.body, "keydown", D), i.config.inline || i.config.static || u(window, "resize", t);
                    void 0 !== window.ontouchstart ? u(window.document, "touchstart", E) : u(window.document, "mousedown", E);
                    u(window.document, "focus", E, {
                        capture: !0
                    }), !0 === i.config.clickOpens && (u(i._input, "focus", i.open), u(i._input, "click", i.open));
                    void 0 !== i.daysContainer && (u(i.monthNav, "click", Q), u(i.monthNav, ["keyup", "increment"], c), u(i.daysContainer, "click", Y));
                    if (void 0 !== i.timeContainer && void 0 !== i.minuteElement && void 0 !== i.hourElement) {
                        const t = t => tr(t).select();
                        u(i.timeContainer, ["increment"], r), u(i.timeContainer, "blur", r, {
                            capture: !0
                        }), u(i.timeContainer, "click", f), u([i.hourElement, i.minuteElement], ["focus", "click"], t), void 0 !== i.secondElement && u(i.secondElement, "focus", (() => i.secondElement && i.secondElement.select())), void 0 !== i.amPM && u(i.amPM, "click", (t => {
                            r(t), h()
                        }))
                    }
                    i.config.allowInput && u(i._input, "blur", L)
                }(), (i.selectedDates.length || i.config.noCalendar) && (i.config.enableTime && o(i.config.noCalendar ? i.latestSelectedDateObj : void 0), $(!1)), l();
            const a = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            !i.isMobile && a && z(), q("onReady")
        }(), i
    }

    function dr(t, e) {
        const i = Array.prototype.slice.call(t).filter((t => t instanceof HTMLElement)),
            n = [];
        for (let t = 0; t < i.length; t++) {
            const l = i[t];
            try {
                if (null !== l.getAttribute("data-fp-omit")) continue;
                void 0 !== l._flatpickr && (l._flatpickr.destroy(), l._flatpickr = void 0), l._flatpickr = hr(l, e || {}), n.push(l._flatpickr)
            } catch (t) {
                console.error(t)
            }
        }
        return 1 === n.length ? n[0] : n
    }
    "undefined" != typeof HTMLElement && "undefined" != typeof HTMLCollection && "undefined" != typeof NodeList && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (t) {
        return dr(this, t)
    }, HTMLElement.prototype.flatpickr = function (t) {
        return dr([this], t)
    });
    var fr = function (t, e) {
        return "string" == typeof t ? dr(window.document.querySelectorAll(t), e) : t instanceof Node ? dr([t], e) : dr(t, e)
    };
    fr.defaultConfig = {}, fr.l10ns = {
        en: Object.assign({}, Vl),
        default: Object.assign({}, Vl)
    }, fr.localize = t => {
        fr.l10ns.default = Object.assign(Object.assign({}, fr.l10ns.default), t)
    }, fr.setDefaults = t => {
        fr.defaultConfig = Object.assign(Object.assign({}, fr.defaultConfig), t)
    }, fr.parseDate = or({}), fr.formatDate = ar({}), fr.compareDates = sr, "undefined" != typeof jQuery && void 0 !== jQuery.fn && (jQuery.fn.flatpickr = function (t) {
        return dr(this, t)
    }), Date.prototype.fp_incr = function (t) {
        return new Date(this.getFullYear(), this.getMonth(), this.getDate() + ("string" == typeof t ? parseInt(t, 10) : t))
    }, "undefined" != typeof window && (window.flatpickr = fr);
    var pr = fr;
    window.flatpickr = pr;
    var gr = i(94),
        mr = i.n(gr);
    window.Inputmask = mr.a, mr()().mask(document.querySelectorAll("input"));
    i(211), i(213), i(214), i(215)
}]);
//# sourceMappingURL=app.js.map
